export const airports = [
  {
    id: "1",
    name: "Goroka",
    city: "Goroka",
    country: "Papua New Guinea",
    iata: "GKA",
    icao: "AYGA",
    latitude: "-6.081689",
    longitude: "145.391881",
    altitude: "5282",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "2",
    name: "Madang",
    city: "Madang",
    country: "Papua New Guinea",
    iata: "MAG",
    icao: "AYMD",
    latitude: "-5.207083",
    longitude: "145.7887",
    altitude: "20",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "3",
    name: "Mount Hagen",
    city: "Mount Hagen",
    country: "Papua New Guinea",
    iata: "HGU",
    icao: "AYMH",
    latitude: "-5.826789",
    longitude: "144.295861",
    altitude: "5388",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "4",
    name: "Nadzab",
    city: "Nadzab",
    country: "Papua New Guinea",
    iata: "LAE",
    icao: "AYNZ",
    latitude: "-6.569828",
    longitude: "146.726242",
    altitude: "239",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5",
    name: "Port Moresby Jacksons Intl",
    city: "Port Moresby",
    country: "Papua New Guinea",
    iata: "POM",
    icao: "AYPY",
    latitude: "-9.443383",
    longitude: "147.22005",
    altitude: "146",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6",
    name: "Wewak Intl",
    city: "Wewak",
    country: "Papua New Guinea",
    iata: "WWK",
    icao: "AYWK",
    latitude: "-3.583828",
    longitude: "143.669186",
    altitude: "19",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "7",
    name: "Narsarsuaq",
    city: "Narssarssuaq",
    country: "Greenland",
    iata: "UAK",
    icao: "BGBW",
    latitude: "61.160517",
    longitude: "-45.425978",
    altitude: "112",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "8",
    name: "Nuuk",
    city: "Godthaab",
    country: "Greenland",
    iata: "GOH",
    icao: "BGGH",
    latitude: "64.190922",
    longitude: "-51.678064",
    altitude: "283",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "9",
    name: "Sondre Stromfjord",
    city: "Sondrestrom",
    country: "Greenland",
    iata: "SFJ",
    icao: "BGSF",
    latitude: "67.016969",
    longitude: "-50.689325",
    altitude: "165",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "10",
    name: "Thule Air Base",
    city: "Thule",
    country: "Greenland",
    iata: "THU",
    icao: "BGTL",
    latitude: "76.531203",
    longitude: "-68.703161",
    altitude: "251",
    timezone: "-4",
    dst: "E",
    tz: "America/Thule",
  },
  {
    id: "11",
    name: "Akureyri",
    city: "Akureyri",
    country: "Iceland",
    iata: "AEY",
    icao: "BIAR",
    latitude: "65.659994",
    longitude: "-18.072703",
    altitude: "6",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "12",
    name: "Egilsstadir",
    city: "Egilsstadir",
    country: "Iceland",
    iata: "EGS",
    icao: "BIEG",
    latitude: "65.283333",
    longitude: "-14.401389",
    altitude: "76",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "13",
    name: "Hornafjordur",
    city: "Hofn",
    country: "Iceland",
    iata: "HFN",
    icao: "BIHN",
    latitude: "64.295556",
    longitude: "-15.227222",
    altitude: "24",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "14",
    name: "Husavik",
    city: "Husavik",
    country: "Iceland",
    iata: "HZK",
    icao: "BIHU",
    latitude: "65.952328",
    longitude: "-17.425978",
    altitude: "48",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "15",
    name: "Isafjordur",
    city: "Isafjordur",
    country: "Iceland",
    iata: "IFJ",
    icao: "BIIS",
    latitude: "66.058056",
    longitude: "-23.135278",
    altitude: "8",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "16",
    name: "Keflavik International Airport",
    city: "Keflavik",
    country: "Iceland",
    iata: "KEF",
    icao: "BIKF",
    latitude: "63.985",
    longitude: "-22.605556",
    altitude: "171",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "17",
    name: "Patreksfjordur",
    city: "Patreksfjordur",
    country: "Iceland",
    iata: "PFJ",
    icao: "BIPA",
    latitude: "65.555833",
    longitude: "-23.965",
    altitude: "11",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "18",
    name: "Reykjavik",
    city: "Reykjavik",
    country: "Iceland",
    iata: "RKV",
    icao: "BIRK",
    latitude: "64.13",
    longitude: "-21.940556",
    altitude: "48",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "19",
    name: "Siglufjordur",
    city: "Siglufjordur",
    country: "Iceland",
    iata: "SIJ",
    icao: "BISI",
    latitude: "66.133333",
    longitude: "-18.916667",
    altitude: "10",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "20",
    name: "Vestmannaeyjar",
    city: "Vestmannaeyjar",
    country: "Iceland",
    iata: "VEY",
    icao: "BIVM",
    latitude: "63.424303",
    longitude: "-20.278875",
    altitude: "326",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "21",
    name: "Sault Ste Marie",
    city: "Sault Sainte Marie",
    country: "Canada",
    iata: "YAM",
    icao: "CYAM",
    latitude: "46.485001",
    longitude: "-84.509445",
    altitude: "630",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "22",
    name: "Winnipeg St Andrews",
    city: "Winnipeg",
    country: "Canada",
    iata: "YAV",
    icao: "CYAV",
    latitude: "50.056389",
    longitude: "-97.0325",
    altitude: "760",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "23",
    name: "Shearwater",
    city: "Halifax",
    country: "Canada",
    iata: "YAW",
    icao: "CYAW",
    latitude: "44.639721",
    longitude: "-63.499444",
    altitude: "167",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "24",
    name: "St Anthony",
    city: "St. Anthony",
    country: "Canada",
    iata: "YAY",
    icao: "CYAY",
    latitude: "51.391944",
    longitude: "-56.083056",
    altitude: "108",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "25",
    name: "Tofino",
    city: "Tofino",
    country: "Canada",
    iata: "YAZ",
    icao: "CYAZ",
    latitude: "49.082222",
    longitude: "-125.7725",
    altitude: "80",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "26",
    name: "Kugaaruk",
    city: "Pelly Bay",
    country: "Canada",
    iata: "YBB",
    icao: "CYBB",
    latitude: "68.534444",
    longitude: "-89.808056",
    altitude: "56",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "27",
    name: "Baie Comeau",
    city: "Baie Comeau",
    country: "Canada",
    iata: "YBC",
    icao: "CYBC",
    latitude: "49.1325",
    longitude: "-68.204444",
    altitude: "71",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "28",
    name: "Bagotville",
    city: "Bagotville",
    country: "Canada",
    iata: "YBG",
    icao: "CYBG",
    latitude: "48.330555",
    longitude: "-70.996391",
    altitude: "522",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "29",
    name: "Baker Lake",
    city: "Baker Lake",
    country: "Canada",
    iata: "YBK",
    icao: "CYBK",
    latitude: "64.298889",
    longitude: "-96.077778",
    altitude: "59",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "30",
    name: "Campbell River",
    city: "Campbell River",
    country: "Canada",
    iata: "YBL",
    icao: "CYBL",
    latitude: "49.950832",
    longitude: "-125.270833",
    altitude: "346",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "31",
    name: "Brandon Muni",
    city: "Brandon",
    country: "Canada",
    iata: "YBR",
    icao: "CYBR",
    latitude: "49.91",
    longitude: "-99.951944",
    altitude: "1343",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "32",
    name: "Cambridge Bay",
    city: "Cambridge Bay",
    country: "Canada",
    iata: "YCB",
    icao: "CYCB",
    latitude: "69.108055",
    longitude: "-105.138333",
    altitude: "90",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "33",
    name: "Nanaimo",
    city: "Nanaimo",
    country: "Canada",
    iata: "YCD",
    icao: "CYCD",
    latitude: "49.052333",
    longitude: "-123.870167",
    altitude: "93",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "34",
    name: "Castlegar",
    city: "Castlegar",
    country: "Canada",
    iata: "YCG",
    icao: "CYCG",
    latitude: "49.296389",
    longitude: "-117.6325",
    altitude: "1624",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "35",
    name: "Miramichi",
    city: "Chatham",
    country: "Canada",
    iata: "YCH",
    icao: "CYCH",
    latitude: "47.007778",
    longitude: "-65.449167",
    altitude: "108",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "36",
    name: "Charlo",
    city: "Charlo",
    country: "Canada",
    iata: "YCL",
    icao: "CYCL",
    latitude: "47.990833",
    longitude: "-66.330278",
    altitude: "132",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "37",
    name: "Kugluktuk",
    city: "Coppermine",
    country: "Canada",
    iata: "YCO",
    icao: "CYCO",
    latitude: "67.816667",
    longitude: "-115.143889",
    altitude: "74",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "38",
    name: "Coronation",
    city: "Coronation",
    country: "Canada",
    iata: "YCT",
    icao: "CYCT",
    latitude: "52.075001",
    longitude: "-111.445278",
    altitude: "2595",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "39",
    name: "Chilliwack",
    city: "Chilliwack",
    country: "Canada",
    iata: "YCW",
    icao: "CYCW",
    latitude: "49.152779",
    longitude: "-121.93889",
    altitude: "32",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "40",
    name: "Clyde River",
    city: "Clyde River",
    country: "Canada",
    iata: "YCY",
    icao: "CYCY",
    latitude: "70.486111",
    longitude: "-68.516667",
    altitude: "87",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "41",
    name: "Fairmont Hot Springs",
    city: "Coral Harbour",
    country: "Canada",
    iata: "YZS",
    icao: "CYCZ",
    latitude: "64.193333",
    longitude: "-83.359444",
    altitude: "2661",
    timezone: "-5",
    dst: "A",
    tz: "America/Coral_Harbour",
  },
  {
    id: "42",
    name: "Dawson City",
    city: "Dawson",
    country: "Canada",
    iata: "YDA",
    icao: "CYDA",
    latitude: "64.043056",
    longitude: "-139.127778",
    altitude: "1215",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "43",
    name: "Burwash",
    city: "Burwash",
    country: "Canada",
    iata: "YDB",
    icao: "CYDB",
    latitude: "61.371111",
    longitude: "-139.040556",
    altitude: "2647",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "44",
    name: "Princeton",
    city: "Princeton",
    country: "Canada",
    iata: "YDC",
    icao: "CYDC",
    latitude: "49.468056",
    longitude: "-120.511389",
    altitude: "2298",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "45",
    name: "Deer Lake",
    city: "Deer Lake",
    country: "Canada",
    iata: "YDF",
    icao: "CYDF",
    latitude: "49.210833",
    longitude: "-57.391388",
    altitude: "72",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "46",
    name: "Dease Lake",
    city: "Dease Lake",
    country: "Canada",
    iata: "YDL",
    icao: "CYDL",
    latitude: "58.422222",
    longitude: "-130.032222",
    altitude: "2600",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "47",
    name: "Dauphin Barker",
    city: "Dauphin",
    country: "Canada",
    iata: "YDN",
    icao: "CYDN",
    latitude: "51.100834",
    longitude: "-100.0525",
    altitude: "999",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "48",
    name: "Dawson Creek",
    city: "Dawson Creek",
    country: "Canada",
    iata: "YDQ",
    icao: "CYDQ",
    latitude: "55.742333",
    longitude: "-120.183",
    altitude: "2148",
    timezone: "-7",
    dst: "A",
    tz: "America/Dawson_Creek",
  },
  {
    id: "49",
    name: "Edmonton Intl",
    city: "Edmonton",
    country: "Canada",
    iata: "YEG",
    icao: "CYEG",
    latitude: "53.309723",
    longitude: "-113.579722",
    altitude: "2373",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "50",
    name: "Arviat",
    city: "Eskimo Point",
    country: "Canada",
    iata: "YEK",
    icao: "CYEK",
    latitude: "61.094166",
    longitude: "-94.070833",
    altitude: "32",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "51",
    name: "Estevan",
    city: "Estevan",
    country: "Canada",
    iata: "YEN",
    icao: "CYEN",
    latitude: "49.210278",
    longitude: "-102.965833",
    altitude: "1905",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "52",
    name: "Edson",
    city: "Edson",
    country: "Canada",
    iata: "YET",
    icao: "CYET",
    latitude: "53.578888",
    longitude: "-116.465",
    altitude: "3041",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "53",
    name: "Eureka",
    city: "Eureka",
    country: "Canada",
    iata: "YEU",
    icao: "CYEU",
    latitude: "79.994722",
    longitude: "-85.814167",
    altitude: "256",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "54",
    name: "Inuvik Mike Zubko",
    city: "Inuvik",
    country: "Canada",
    iata: "YEV",
    icao: "CYEV",
    latitude: "68.304167",
    longitude: "-133.482778",
    altitude: "224",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "55",
    name: "Iqaluit",
    city: "Iqaluit",
    country: "Canada",
    iata: "YFB",
    icao: "CYFB",
    latitude: "63.75639",
    longitude: "-68.555832",
    altitude: "110",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "56",
    name: "Fredericton",
    city: "Fredericton",
    country: "Canada",
    iata: "YFC",
    icao: "CYFC",
    latitude: "45.868889",
    longitude: "-66.537222",
    altitude: "68",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "57",
    name: "Forestville",
    city: "Forestville",
    country: "Canada",
    iata: "",
    icao: "CYFE",
    latitude: "48.746111",
    longitude: "-69.097222",
    altitude: "293",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "58",
    name: "Flin Flon",
    city: "Flin Flon",
    country: "Canada",
    iata: "YFO",
    icao: "CYFO",
    latitude: "54.678055",
    longitude: "-101.681667",
    altitude: "997",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "59",
    name: "Fort Resolution",
    city: "Fort Resolution",
    country: "Canada",
    iata: "YFR",
    icao: "CYFR",
    latitude: "61.180832",
    longitude: "-113.689722",
    altitude: "526",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "60",
    name: "Fort Simpson",
    city: "Fort Simpson",
    country: "Canada",
    iata: "YFS",
    icao: "CYFS",
    latitude: "61.760153",
    longitude: "-121.236525",
    altitude: "555",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "61",
    name: "Kingston",
    city: "Kingston",
    country: "Canada",
    iata: "YGK",
    icao: "CYGK",
    latitude: "44.225277",
    longitude: "-76.596944",
    altitude: "305",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "62",
    name: "La Grande Riviere",
    city: "La Grande Riviere",
    country: "Canada",
    iata: "YGL",
    icao: "CYGL",
    latitude: "53.625278",
    longitude: "-77.704167",
    altitude: "639",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "63",
    name: "Gaspe",
    city: "Gaspe",
    country: "Canada",
    iata: "YGP",
    icao: "CYGP",
    latitude: "48.775278",
    longitude: "-64.478611",
    altitude: "108",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "64",
    name: "Geraldton Greenstone Regional",
    city: "Geraldton",
    country: "Canada",
    iata: "YGQ",
    icao: "CYGQ",
    latitude: "49.778332",
    longitude: "-86.939445",
    altitude: "1144",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "65",
    name: "Iles De La Madeleine",
    city: "Iles De La Madeleine",
    country: "Canada",
    iata: "YGR",
    icao: "CYGR",
    latitude: "47.424721",
    longitude: "-61.778056",
    altitude: "35",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "66",
    name: "Hudson Bay",
    city: "Hudson Bay",
    country: "Canada",
    iata: "YHB",
    icao: "CYHB",
    latitude: "52.816666",
    longitude: "-102.31139",
    altitude: "1175",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "67",
    name: "Dryden Rgnl",
    city: "Dryden",
    country: "Canada",
    iata: "YHD",
    icao: "CYHD",
    latitude: "49.831667",
    longitude: "-92.744167",
    altitude: "1354",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "68",
    name: "Ulukhaktok Holman",
    city: "Holman Island",
    country: "Canada",
    iata: "YHI",
    icao: "CYHI",
    latitude: "70.762778",
    longitude: "-117.806111",
    altitude: "117",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "69",
    name: "Gjoa Haven",
    city: "Gjoa Haven",
    country: "Canada",
    iata: "YHK",
    icao: "CYHK",
    latitude: "68.635556",
    longitude: "-95.849722",
    altitude: "152",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "70",
    name: "Hamilton",
    city: "Hamilton",
    country: "Canada",
    iata: "YHM",
    icao: "CYHM",
    latitude: "43.173611",
    longitude: "-79.935",
    altitude: "780",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "71",
    name: "St Hubert",
    city: "Montreal",
    country: "Canada",
    iata: "YHU",
    icao: "CYHU",
    latitude: "45.5175",
    longitude: "-73.416944",
    altitude: "90",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "72",
    name: "Hay River",
    city: "Hay River",
    country: "Canada",
    iata: "YHY",
    icao: "CYHY",
    latitude: "60.839722",
    longitude: "-115.782778",
    altitude: "543",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "73",
    name: "Halifax Intl",
    city: "Halifax",
    country: "Canada",
    iata: "YHZ",
    icao: "CYHZ",
    latitude: "44.880833",
    longitude: "-63.50861",
    altitude: "477",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "74",
    name: "Atikokan Muni",
    city: "Atikokan",
    country: "Canada",
    iata: "YIB",
    icao: "CYIB",
    latitude: "48.773888",
    longitude: "-91.638611",
    altitude: "1408",
    timezone: "-5",
    dst: "A",
    tz: "America/Coral_Harbour",
  },
  {
    id: "75",
    name: "Pond Inlet",
    city: "Pond Inlet",
    country: "Canada",
    iata: "YIO",
    icao: "CYIO",
    latitude: "72.683334",
    longitude: "-77.966667",
    altitude: "181",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "76",
    name: "St Jean",
    city: "St. Jean",
    country: "Canada",
    iata: "YJN",
    icao: "CYJN",
    latitude: "45.294445",
    longitude: "-73.281111",
    altitude: "136",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "77",
    name: "Stephenville",
    city: "Stephenville",
    country: "Canada",
    iata: "YJT",
    icao: "CYJT",
    latitude: "48.544167",
    longitude: "-58.549999",
    altitude: "80",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "78",
    name: "Kamloops",
    city: "Kamloops",
    country: "Canada",
    iata: "YKA",
    icao: "CYKA",
    latitude: "50.702222",
    longitude: "-120.444444",
    altitude: "1133",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "79",
    name: "Waterloo",
    city: "Waterloo",
    country: "Canada",
    iata: "YKF",
    icao: "CYKF",
    latitude: "43.460833",
    longitude: "-80.378611",
    altitude: "1054",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "80",
    name: "Schefferville",
    city: "Schefferville",
    country: "Canada",
    iata: "YKL",
    icao: "CYKL",
    latitude: "54.805278",
    longitude: "-66.805278",
    altitude: "1709",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "81",
    name: "Kindersley",
    city: "Kindersley",
    country: "Canada",
    iata: "YKY",
    icao: "CYKY",
    latitude: "51.5175",
    longitude: "-109.180833",
    altitude: "2277",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "82",
    name: "Buttonville Muni",
    city: "Toronto",
    country: "Canada",
    iata: "YKZ",
    icao: "CYKZ",
    latitude: "43.862221",
    longitude: "-79.37",
    altitude: "650",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "83",
    name: "Chapleau",
    city: "Chapleau",
    country: "Canada",
    iata: "YLD",
    icao: "CYLD",
    latitude: "47.82",
    longitude: "-83.346667",
    altitude: "1470",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "84",
    name: "Meadow Lake",
    city: "Meadow Lake",
    country: "Canada",
    iata: "YLJ",
    icao: "CYLJ",
    latitude: "54.125278",
    longitude: "-108.522778",
    altitude: "1576",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "85",
    name: "Lloydminster",
    city: "Lloydminster",
    country: "Canada",
    iata: "YLL",
    icao: "CYLL",
    latitude: "53.309166",
    longitude: "-110.0725",
    altitude: "2193",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "86",
    name: "Alert",
    city: "Alert",
    country: "Canada",
    iata: "YLT",
    icao: "CYLT",
    latitude: "82.517778",
    longitude: "-62.280556",
    altitude: "100",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "87",
    name: "Kelowna",
    city: "Kelowna",
    country: "Canada",
    iata: "YLW",
    icao: "CYLW",
    latitude: "49.956112",
    longitude: "-119.377778",
    altitude: "1409",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "88",
    name: "Mayo",
    city: "Mayo",
    country: "Canada",
    iata: "YMA",
    icao: "CYMA",
    latitude: "63.616389",
    longitude: "-135.868333",
    altitude: "1653",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "89",
    name: "Moose Jaw Air Vice Marshal C M Mcewen",
    city: "Moose Jaw",
    country: "Canada",
    iata: "YMJ",
    icao: "CYMJ",
    latitude: "50.330278",
    longitude: "-105.559167",
    altitude: "1892",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "90",
    name: "Fort Mcmurray",
    city: "Fort Mcmurray",
    country: "Canada",
    iata: "YMM",
    icao: "CYMM",
    latitude: "56.653333",
    longitude: "-111.221944",
    altitude: "1211",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "91",
    name: "Moosonee",
    city: "Moosonee",
    country: "Canada",
    iata: "YMO",
    icao: "CYMO",
    latitude: "51.291111",
    longitude: "-80.607778",
    altitude: "30",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "92",
    name: "Maniwaki",
    city: "Maniwaki",
    country: "Canada",
    iata: "YMW",
    icao: "CYMW",
    latitude: "46.272778",
    longitude: "-75.990556",
    altitude: "656",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "93",
    name: "Montreal Intl Mirabel",
    city: "Montreal",
    country: "Canada",
    iata: "YMX",
    icao: "CYMX",
    latitude: "45.681944",
    longitude: "-74.005278",
    altitude: "270",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "94",
    name: "Natashquan",
    city: "Natashquan",
    country: "Canada",
    iata: "YNA",
    icao: "CYNA",
    latitude: "50.19",
    longitude: "-61.789167",
    altitude: "39",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "95",
    name: "Gatineau",
    city: "Gatineau",
    country: "Canada",
    iata: "YND",
    icao: "CYND",
    latitude: "45.521694",
    longitude: "-75.563589",
    altitude: "211",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "96",
    name: "Matagami",
    city: "Matagami",
    country: "Canada",
    iata: "YNM",
    icao: "CYNM",
    latitude: "49.761667",
    longitude: "-77.802778",
    altitude: "918",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "97",
    name: "Old Crow",
    city: "Old Crow",
    country: "Canada",
    iata: "YOC",
    icao: "CYOC",
    latitude: "67.570556",
    longitude: "-139.839167",
    altitude: "824",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "98",
    name: "Cold Lake",
    city: "Cold Lake",
    country: "Canada",
    iata: "YOD",
    icao: "CYOD",
    latitude: "54.404999",
    longitude: "-110.279444",
    altitude: "1775",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "99",
    name: "High Level",
    city: "High Level",
    country: "Canada",
    iata: "YOJ",
    icao: "CYOJ",
    latitude: "58.621389",
    longitude: "-117.164722",
    altitude: "1110",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "100",
    name: "Ottawa Macdonald Cartier Intl",
    city: "Ottawa",
    country: "Canada",
    iata: "YOW",
    icao: "CYOW",
    latitude: "45.3225",
    longitude: "-75.669167",
    altitude: "374",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "101",
    name: "Prince Albert Glass Field",
    city: "Prince Albert",
    country: "Canada",
    iata: "YPA",
    icao: "CYPA",
    latitude: "53.214167",
    longitude: "-105.672778",
    altitude: "1405",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "102",
    name: "Peace River",
    city: "Peace River",
    country: "Canada",
    iata: "YPE",
    icao: "CYPE",
    latitude: "56.226944",
    longitude: "-117.447222",
    altitude: "1873",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "103",
    name: "Southport",
    city: "Portage-la-prairie",
    country: "Canada",
    iata: "YPG",
    icao: "CYPG",
    latitude: "49.903056",
    longitude: "-98.273889",
    altitude: "885",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "104",
    name: "Pitt Meadows",
    city: "Pitt Meadows",
    country: "Canada",
    iata: "",
    icao: "CYPK",
    latitude: "49.21611",
    longitude: "-122.71",
    altitude: "11",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "105",
    name: "Pickle Lake",
    city: "Pickle Lake",
    country: "Canada",
    iata: "YPL",
    icao: "CYPL",
    latitude: "51.446388",
    longitude: "-90.214167",
    altitude: "1267",
    timezone: "-5",
    dst: "A",
    tz: "America/Coral_Harbour",
  },
  {
    id: "106",
    name: "Port Menier",
    city: "Port Menier",
    country: "Canada",
    iata: "YPN",
    icao: "CYPN",
    latitude: "49.836389",
    longitude: "-64.288611",
    altitude: "167",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "107",
    name: "Peterborough",
    city: "Peterborough",
    country: "Canada",
    iata: "YPQ",
    icao: "CYPQ",
    latitude: "44.23",
    longitude: "-78.363333",
    altitude: "628",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "108",
    name: "Prince Rupert",
    city: "Prince Pupert",
    country: "Canada",
    iata: "YPR",
    icao: "CYPR",
    latitude: "54.28611",
    longitude: "-130.444722",
    altitude: "116",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "109",
    name: "Fort Chipewyan",
    city: "Fort Chipewyan",
    country: "Canada",
    iata: "YPY",
    icao: "CYPY",
    latitude: "58.767223",
    longitude: "-111.117222",
    altitude: "761",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "110",
    name: "Muskoka",
    city: "Muskoka",
    country: "Canada",
    iata: "YQA",
    icao: "CYQA",
    latitude: "44.974722",
    longitude: "-79.303333",
    altitude: "925",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "111",
    name: "Quebec Jean Lesage Intl",
    city: "Quebec",
    country: "Canada",
    iata: "YQB",
    icao: "CYQB",
    latitude: "46.791111",
    longitude: "-71.393333",
    altitude: "244",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "112",
    name: "Red Deer Regional",
    city: "Red Deer Industrial",
    country: "Canada",
    iata: "YQF",
    icao: "CYQF",
    latitude: "52.182222",
    longitude: "-113.894444",
    altitude: "2968",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "113",
    name: "Windsor",
    city: "Windsor",
    country: "Canada",
    iata: "YQG",
    icao: "CYQG",
    latitude: "42.275556",
    longitude: "-82.955556",
    altitude: "622",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "114",
    name: "Watson Lake",
    city: "Watson Lake",
    country: "Canada",
    iata: "YQH",
    icao: "CYQH",
    latitude: "60.116389",
    longitude: "-128.8225",
    altitude: "2255",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "115",
    name: "Kenora",
    city: "Kenora",
    country: "Canada",
    iata: "YQK",
    icao: "CYQK",
    latitude: "49.788334",
    longitude: "-94.363056",
    altitude: "1332",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "116",
    name: "Lethbridge",
    city: "Lethbridge",
    country: "Canada",
    iata: "YQL",
    icao: "CYQL",
    latitude: "49.630278",
    longitude: "-112.799722",
    altitude: "3047",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "117",
    name: "Greater Moncton Intl",
    city: "Moncton",
    country: "Canada",
    iata: "YQM",
    icao: "CYQM",
    latitude: "46.112221",
    longitude: "-64.678611",
    altitude: "232",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "119",
    name: "Comox",
    city: "Comox",
    country: "Canada",
    iata: "YQQ",
    icao: "CYQQ",
    latitude: "49.710833",
    longitude: "-124.886667",
    altitude: "84",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "120",
    name: "Regina Intl",
    city: "Regina",
    country: "Canada",
    iata: "YQR",
    icao: "CYQR",
    latitude: "50.431944",
    longitude: "-104.665833",
    altitude: "1894",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "121",
    name: "Thunder Bay",
    city: "Thunder Bay",
    country: "Canada",
    iata: "YQT",
    icao: "CYQT",
    latitude: "48.371944",
    longitude: "-89.323889",
    altitude: "653",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "122",
    name: "Grande Prairie",
    city: "Grande Prairie",
    country: "Canada",
    iata: "YQU",
    icao: "CYQU",
    latitude: "55.179722",
    longitude: "-118.885",
    altitude: "2195",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "123",
    name: "Yorkton Muni",
    city: "Yorkton",
    country: "Canada",
    iata: "YQV",
    icao: "CYQV",
    latitude: "51.264721",
    longitude: "-102.461667",
    altitude: "1635",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "124",
    name: "North Battleford",
    city: "North Battleford",
    country: "Canada",
    iata: "YQW",
    icao: "CYQW",
    latitude: "52.769167",
    longitude: "-108.24361",
    altitude: "1799",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "125",
    name: "Gander Intl",
    city: "Gander",
    country: "Canada",
    iata: "YQX",
    icao: "CYQX",
    latitude: "48.936944",
    longitude: "-54.568056",
    altitude: "496",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "126",
    name: "Sydney",
    city: "Sydney",
    country: "Canada",
    iata: "YQY",
    icao: "CYQY",
    latitude: "46.161388",
    longitude: "-60.047779",
    altitude: "203",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "127",
    name: "Quesnel",
    city: "Quesnel",
    country: "Canada",
    iata: "YQZ",
    icao: "CYQZ",
    latitude: "53.026112",
    longitude: "-122.510278",
    altitude: "1789",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "128",
    name: "Resolute Bay",
    city: "Resolute",
    country: "Canada",
    iata: "YRB",
    icao: "CYRB",
    latitude: "74.716944",
    longitude: "-94.969444",
    altitude: "215",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "129",
    name: "Riviere Du Loup",
    city: "Riviere Du Loup",
    country: "Canada",
    iata: "YRI",
    icao: "CYRI",
    latitude: "47.764444",
    longitude: "-69.584722",
    altitude: "427",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "130",
    name: "Roberval",
    city: "Roberval",
    country: "Canada",
    iata: "YRJ",
    icao: "CYRJ",
    latitude: "48.52",
    longitude: "-72.265556",
    altitude: "586",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "131",
    name: "Rocky Mountain House",
    city: "Rocky Mountain House",
    country: "Canada",
    iata: "YRM",
    icao: "CYRM",
    latitude: "52.429722",
    longitude: "-114.904167",
    altitude: "3244",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "132",
    name: "Rankin Inlet",
    city: "Rankin Inlet",
    country: "Canada",
    iata: "YRT",
    icao: "CYRT",
    latitude: "62.81139",
    longitude: "-92.115833",
    altitude: "94",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "133",
    name: "Sudbury",
    city: "Sudbury",
    country: "Canada",
    iata: "YSB",
    icao: "CYSB",
    latitude: "46.625",
    longitude: "-80.798889",
    altitude: "1141",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "134",
    name: "Sherbrooke",
    city: "Sherbrooke",
    country: "Canada",
    iata: "YSC",
    icao: "CYSC",
    latitude: "45.438611",
    longitude: "-71.691389",
    altitude: "792",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "135",
    name: "Saint John",
    city: "St. John",
    country: "Canada",
    iata: "YSJ",
    icao: "CYSJ",
    latitude: "45.316111",
    longitude: "-65.890278",
    altitude: "357",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "136",
    name: "Fort Smith",
    city: "Fort Smith",
    country: "Canada",
    iata: "YSM",
    icao: "CYSM",
    latitude: "60.020278",
    longitude: "-111.961944",
    altitude: "671",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "137",
    name: "Nanisivik",
    city: "Nanisivik",
    country: "Canada",
    iata: "YSR",
    icao: "CYSR",
    latitude: "72.982222",
    longitude: "-84.613611",
    altitude: "2106",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "138",
    name: "Summerside",
    city: "Summerside",
    country: "Canada",
    iata: "YSU",
    icao: "CYSU",
    latitude: "46.440556",
    longitude: "-63.833611",
    altitude: "56",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "139",
    name: "Sachs Harbour",
    city: "Sachs Harbour",
    country: "Canada",
    iata: "YSY",
    icao: "CYSY",
    latitude: "71.993889",
    longitude: "-125.2425",
    altitude: "282",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "140",
    name: "Cape Dorset",
    city: "Cape Dorset",
    country: "Canada",
    iata: "YTE",
    icao: "CYTE",
    latitude: "64.23",
    longitude: "-76.526667",
    altitude: "164",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "141",
    name: "Thompson",
    city: "Thompson",
    country: "Canada",
    iata: "YTH",
    icao: "CYTH",
    latitude: "55.801111",
    longitude: "-97.864166",
    altitude: "729",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "142",
    name: "Trenton",
    city: "Trenton",
    country: "Canada",
    iata: "YTR",
    icao: "CYTR",
    latitude: "44.118889",
    longitude: "-77.528056",
    altitude: "283",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "143",
    name: "Timmins",
    city: "Timmins",
    country: "Canada",
    iata: "YTS",
    icao: "CYTS",
    latitude: "48.569721",
    longitude: "-81.376667",
    altitude: "967",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "144",
    name: "City Centre",
    city: "Toronto",
    country: "Canada",
    iata: "YTZ",
    icao: "CYTZ",
    latitude: "43.627499",
    longitude: "-79.396167",
    altitude: "251",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "145",
    name: "Tuktoyaktuk",
    city: "Tuktoyaktuk",
    country: "Canada",
    iata: "YUB",
    icao: "CYUB",
    latitude: "69.433334",
    longitude: "-133.026389",
    altitude: "15",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "146",
    name: "Pierre Elliott Trudeau Intl",
    city: "Montreal",
    country: "Canada",
    iata: "YUL",
    icao: "CYUL",
    latitude: "45.470556",
    longitude: "-73.740833",
    altitude: "118",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "147",
    name: "Repulse Bay",
    city: "Repulse Bay",
    country: "Canada",
    iata: "YUT",
    icao: "CYUT",
    latitude: "66.521389",
    longitude: "-86.224722",
    altitude: "80",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "148",
    name: "Hall Beach",
    city: "Hall Beach",
    country: "Canada",
    iata: "YUX",
    icao: "CYUX",
    latitude: "68.776111",
    longitude: "-81.243611",
    altitude: "27",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "149",
    name: "Rouyn Noranda",
    city: "Rouyn",
    country: "Canada",
    iata: "YUY",
    icao: "CYUY",
    latitude: "48.206111",
    longitude: "-78.835556",
    altitude: "988",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "150",
    name: "La Ronge",
    city: "La Ronge",
    country: "Canada",
    iata: "YVC",
    icao: "CYVC",
    latitude: "55.15139",
    longitude: "-105.261944",
    altitude: "1242",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "151",
    name: "Vermilion",
    city: "Vermillion",
    country: "Canada",
    iata: "YVG",
    icao: "CYVG",
    latitude: "53.355833",
    longitude: "-110.82389",
    altitude: "2025",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "152",
    name: "Qikiqtarjuaq",
    city: "Broughton Island",
    country: "Canada",
    iata: "YVM",
    icao: "CYVM",
    latitude: "67.545833",
    longitude: "-64.031389",
    altitude: "21",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "153",
    name: "Val D Or",
    city: "Val D'or",
    country: "Canada",
    iata: "YVO",
    icao: "CYVO",
    latitude: "48.053333",
    longitude: "-77.782778",
    altitude: "1107",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "154",
    name: "Kuujjuaq",
    city: "Quujjuaq",
    country: "Canada",
    iata: "YVP",
    icao: "CYVP",
    latitude: "58.096111",
    longitude: "-68.426944",
    altitude: "129",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "155",
    name: "Norman Wells",
    city: "Norman Wells",
    country: "Canada",
    iata: "YVQ",
    icao: "CYVQ",
    latitude: "65.281617",
    longitude: "-126.798219",
    altitude: "238",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "156",
    name: "Vancouver Intl",
    city: "Vancouver",
    country: "Canada",
    iata: "YVR",
    icao: "CYVR",
    latitude: "49.193889",
    longitude: "-123.184444",
    altitude: "14",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "157",
    name: "Buffalo Narrows",
    city: "Buffalo Narrows",
    country: "Canada",
    iata: "YVT",
    icao: "CYVT",
    latitude: "55.841944",
    longitude: "-108.4175",
    altitude: "1444",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "158",
    name: "Wiarton",
    city: "Wiarton",
    country: "Canada",
    iata: "YVV",
    icao: "CYVV",
    latitude: "44.745834",
    longitude: "-81.107222",
    altitude: "729",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "159",
    name: "Petawawa",
    city: "Petawawa",
    country: "Canada",
    iata: "YWA",
    icao: "CYWA",
    latitude: "45.952221",
    longitude: "-77.319168",
    altitude: "427",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "160",
    name: "Winnipeg Intl",
    city: "Winnipeg",
    country: "Canada",
    iata: "YWG",
    icao: "CYWG",
    latitude: "49.910036",
    longitude: "-97.239886",
    altitude: "783",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "161",
    name: "Wabush",
    city: "Wabush",
    country: "Canada",
    iata: "YWK",
    icao: "CYWK",
    latitude: "52.921944",
    longitude: "-66.864444",
    altitude: "1808",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "162",
    name: "Williams Lake",
    city: "Williams Lake",
    country: "Canada",
    iata: "YWL",
    icao: "CYWL",
    latitude: "52.183056",
    longitude: "-122.054167",
    altitude: "3085",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "163",
    name: "Wrigley",
    city: "Wrigley",
    country: "Canada",
    iata: "YWY",
    icao: "CYWY",
    latitude: "63.209444",
    longitude: "-123.436667",
    altitude: "489",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "164",
    name: "Canadian Rockies Intl",
    city: "Cranbrook",
    country: "Canada",
    iata: "YXC",
    icao: "CYXC",
    latitude: "49.612222",
    longitude: "-115.781944",
    altitude: "3084",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "165",
    name: "Edmonton City Centre",
    city: "Edmonton",
    country: "Canada",
    iata: "YXD",
    icao: "CYXD",
    latitude: "53.5725",
    longitude: "-113.520556",
    altitude: "2200",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "166",
    name: "Saskatoon J G Diefenbaker Intl",
    city: "Saskatoon",
    country: "Canada",
    iata: "YXE",
    icao: "CYXE",
    latitude: "52.170834",
    longitude: "-106.699722",
    altitude: "1653",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "167",
    name: "Medicine Hat",
    city: "Medicine Hat",
    country: "Canada",
    iata: "YXH",
    icao: "CYXH",
    latitude: "50.01889",
    longitude: "-110.720833",
    altitude: "2352",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "168",
    name: "Fort St John",
    city: "Fort Saint John",
    country: "Canada",
    iata: "YXJ",
    icao: "CYXJ",
    latitude: "56.238056",
    longitude: "-120.740278",
    altitude: "2280",
    timezone: "-7",
    dst: "A",
    tz: "America/Dawson_Creek",
  },
  {
    id: "169",
    name: "Sioux Lookout",
    city: "Sioux Lookout",
    country: "Canada",
    iata: "YXL",
    icao: "CYXL",
    latitude: "50.113889",
    longitude: "-91.905278",
    altitude: "1258",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "170",
    name: "Pangnirtung",
    city: "Pangnirtung",
    country: "Canada",
    iata: "YXP",
    icao: "CYXP",
    latitude: "66.145",
    longitude: "-65.713611",
    altitude: "75",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "171",
    name: "Timiskaming Rgnl",
    city: "Earlton",
    country: "Canada",
    iata: "YXR",
    icao: "CYXR",
    latitude: "47.695",
    longitude: "-79.848889",
    altitude: "798",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "172",
    name: "Prince George",
    city: "Prince George",
    country: "Canada",
    iata: "YXS",
    icao: "CYXS",
    latitude: "53.889444",
    longitude: "-122.678889",
    altitude: "2267",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "173",
    name: "Terrace",
    city: "Terrace",
    country: "Canada",
    iata: "YXT",
    icao: "CYXT",
    latitude: "54.468508",
    longitude: "-128.576219",
    altitude: "713",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "174",
    name: "London",
    city: "London",
    country: "Canada",
    iata: "YXU",
    icao: "CYXU",
    latitude: "43.033056",
    longitude: "-81.151111",
    altitude: "912",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "175",
    name: "Abbotsford",
    city: "Abbotsford",
    country: "Canada",
    iata: "YXX",
    icao: "CYXX",
    latitude: "49.025278",
    longitude: "-122.360556",
    altitude: "195",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "176",
    name: "Whitehorse Intl",
    city: "Whitehorse",
    country: "Canada",
    iata: "YXY",
    icao: "CYXY",
    latitude: "60.709553",
    longitude: "-135.067269",
    altitude: "2317",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "177",
    name: "North Bay",
    city: "North Bay",
    country: "Canada",
    iata: "YYB",
    icao: "CYYB",
    latitude: "46.363611",
    longitude: "-79.422778",
    altitude: "1215",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "178",
    name: "Calgary Intl",
    city: "Calgary",
    country: "Canada",
    iata: "YYC",
    icao: "CYYC",
    latitude: "51.113888",
    longitude: "-114.020278",
    altitude: "3557",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "179",
    name: "Smithers",
    city: "Smithers",
    country: "Canada",
    iata: "YYD",
    icao: "CYYD",
    latitude: "54.824722",
    longitude: "-127.182778",
    altitude: "1712",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "180",
    name: "Fort Nelson",
    city: "Fort Nelson",
    country: "Canada",
    iata: "YYE",
    icao: "CYYE",
    latitude: "58.836389",
    longitude: "-122.596944",
    altitude: "1253",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "181",
    name: "Penticton",
    city: "Penticton",
    country: "Canada",
    iata: "YYF",
    icao: "CYYF",
    latitude: "49.463056",
    longitude: "-119.602222",
    altitude: "1129",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "182",
    name: "Charlottetown",
    city: "Charlottetown",
    country: "Canada",
    iata: "YYG",
    icao: "CYYG",
    latitude: "46.290001",
    longitude: "-63.121111",
    altitude: "160",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "183",
    name: "Taloyoak",
    city: "Spence Bay",
    country: "Canada",
    iata: "YYH",
    icao: "CYYH",
    latitude: "69.546667",
    longitude: "-93.576667",
    altitude: "92",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "184",
    name: "Victoria Intl",
    city: "Victoria",
    country: "Canada",
    iata: "YYJ",
    icao: "CYYJ",
    latitude: "48.646944",
    longitude: "-123.425833",
    altitude: "63",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "185",
    name: "Lynn Lake",
    city: "Lynn Lake",
    country: "Canada",
    iata: "YYL",
    icao: "CYYL",
    latitude: "56.863888",
    longitude: "-101.07611",
    altitude: "1170",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "186",
    name: "Swift Current",
    city: "Swift Current",
    country: "Canada",
    iata: "YYN",
    icao: "CYYN",
    latitude: "50.291944",
    longitude: "-107.690556",
    altitude: "2680",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "187",
    name: "Churchill",
    city: "Churchill",
    country: "Canada",
    iata: "YYQ",
    icao: "CYYQ",
    latitude: "58.739167",
    longitude: "-94.065",
    altitude: "94",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "188",
    name: "Goose Bay",
    city: "Goose Bay",
    country: "Canada",
    iata: "YYR",
    icao: "CYYR",
    latitude: "53.319168",
    longitude: "-60.425833",
    altitude: "160",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "189",
    name: "St Johns Intl",
    city: "St. John's",
    country: "Canada",
    iata: "YYT",
    icao: "CYYT",
    latitude: "47.61861",
    longitude: "-52.751945",
    altitude: "461",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "190",
    name: "Kapuskasing",
    city: "Kapuskasing",
    country: "Canada",
    iata: "YYU",
    icao: "CYYU",
    latitude: "49.413889",
    longitude: "-82.4675",
    altitude: "743",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "191",
    name: "Armstrong",
    city: "Armstrong",
    country: "Canada",
    iata: "YYW",
    icao: "CYYW",
    latitude: "50.290279",
    longitude: "-88.909721",
    altitude: "1058",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "192",
    name: "Mont Joli",
    city: "Mont Joli",
    country: "Canada",
    iata: "YYY",
    icao: "CYYY",
    latitude: "48.608612",
    longitude: "-68.208056",
    altitude: "172",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "193",
    name: "Lester B Pearson Intl",
    city: "Toronto",
    country: "Canada",
    iata: "YYZ",
    icao: "CYYZ",
    latitude: "43.677223",
    longitude: "-79.630556",
    altitude: "569",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "194",
    name: "Downsview",
    city: "Toronto",
    country: "Canada",
    iata: "YZD",
    icao: "CYZD",
    latitude: "43.7425",
    longitude: "-79.465556",
    altitude: "652",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "195",
    name: "Gore Bay Manitoulin",
    city: "Gore Bay",
    country: "Canada",
    iata: "YZE",
    icao: "CYZE",
    latitude: "45.885277",
    longitude: "-82.567778",
    altitude: "635",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "196",
    name: "Yellowknife",
    city: "Yellowknife",
    country: "Canada",
    iata: "YZF",
    icao: "CYZF",
    latitude: "62.462778",
    longitude: "-114.440278",
    altitude: "675",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "197",
    name: "Slave Lake",
    city: "Slave Lake",
    country: "Canada",
    iata: "YZH",
    icao: "CYZH",
    latitude: "55.293056",
    longitude: "-114.777222",
    altitude: "1912",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "198",
    name: "Sandspit",
    city: "Sandspit",
    country: "Canada",
    iata: "YZP",
    icao: "CYZP",
    latitude: "53.254333",
    longitude: "-131.813833",
    altitude: "21",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "199",
    name: "Chris Hadfield",
    city: "Sarnia",
    country: "Canada",
    iata: "YZR",
    icao: "CYZR",
    latitude: "42.999444",
    longitude: "-82.308889",
    altitude: "594",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "200",
    name: "Port Hardy",
    city: "Port Hardy",
    country: "Canada",
    iata: "YZT",
    icao: "CYZT",
    latitude: "50.680556",
    longitude: "-127.366667",
    altitude: "71",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "201",
    name: "Whitecourt",
    city: "Whitecourt",
    country: "Canada",
    iata: "YZU",
    icao: "CYZU",
    latitude: "54.14389",
    longitude: "-115.786667",
    altitude: "2567",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "202",
    name: "Sept Iles",
    city: "Sept-iles",
    country: "Canada",
    iata: "YZV",
    icao: "CYZV",
    latitude: "50.223333",
    longitude: "-66.265556",
    altitude: "180",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "203",
    name: "Teslin",
    city: "Teslin",
    country: "Canada",
    iata: "YZW",
    icao: "CYZW",
    latitude: "60.172779",
    longitude: "-132.742778",
    altitude: "2313",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "204",
    name: "Greenwood",
    city: "Greenwood",
    country: "Canada",
    iata: "YZX",
    icao: "CYZX",
    latitude: "44.984444",
    longitude: "-64.916944",
    altitude: "92",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "205",
    name: "Faro",
    city: "Faro",
    country: "Canada",
    iata: "ZFA",
    icao: "CZFA",
    latitude: "62.2075",
    longitude: "-133.375833",
    altitude: "2351",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "206",
    name: "Fort Mcpherson",
    city: "Fort Mcpherson",
    country: "Canada",
    iata: "ZFM",
    icao: "CZFM",
    latitude: "67.4075",
    longitude: "-134.860556",
    altitude: "116",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "207",
    name: "Blida",
    city: "Blida",
    country: "Algeria",
    iata: "",
    icao: "DAAB",
    latitude: "36.503613",
    longitude: "2.814167",
    altitude: "535",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "208",
    name: "Bou Saada",
    city: "Bou Saada",
    country: "Algeria",
    iata: "",
    icao: "DAAD",
    latitude: "35.3325",
    longitude: "4.206389",
    altitude: "1506",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "209",
    name: "Soummam",
    city: "Bejaja",
    country: "Algeria",
    iata: "BJA",
    icao: "DAAE",
    latitude: "36.711997",
    longitude: "5.069922",
    altitude: "20",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "210",
    name: "Houari Boumediene",
    city: "Algier",
    country: "Algeria",
    iata: "ALG",
    icao: "DAAG",
    latitude: "36.691014",
    longitude: "3.215408",
    altitude: "82",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "211",
    name: "Tiska",
    city: "Djanet",
    country: "Algeria",
    iata: "DJG",
    icao: "DAAJ",
    latitude: "24.292767",
    longitude: "9.452444",
    altitude: "3176",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "212",
    name: "Boufarik",
    city: "Boufarik",
    country: "Algeria",
    iata: "QFD",
    icao: "DAAK",
    latitude: "36.545834",
    longitude: "2.876111",
    altitude: "335",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "213",
    name: "Reggane",
    city: "Reggan",
    country: "Algeria",
    iata: "",
    icao: "DAAN",
    latitude: "26.710103",
    longitude: "0.285647",
    altitude: "955",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "214",
    name: "Illizi Takhamalt",
    city: "Illizi",
    country: "Algeria",
    iata: "VVZ",
    icao: "DAAP",
    latitude: "26.723536",
    longitude: "8.622653",
    altitude: "1778",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "215",
    name: "Ain Oussera",
    city: "Ain Oussera",
    country: "Algeria",
    iata: "",
    icao: "DAAQ",
    latitude: "35.525414",
    longitude: "2.878714",
    altitude: "2132",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "216",
    name: "Tamanrasset",
    city: "Tamanrasset",
    country: "Algeria",
    iata: "TMR",
    icao: "DAAT",
    latitude: "22.811461",
    longitude: "5.451075",
    altitude: "4518",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "217",
    name: "Jijel",
    city: "Jijel",
    country: "Algeria",
    iata: "GJL",
    icao: "DAAV",
    latitude: "36.795136",
    longitude: "5.873608",
    altitude: "36",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "218",
    name: "Mecheria",
    city: "Mecheria",
    country: "Algeria",
    iata: "",
    icao: "DAAY",
    latitude: "33.535853",
    longitude: "-0.242353",
    altitude: "3855",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "219",
    name: "Relizane",
    city: "Relizane",
    country: "Algeria",
    iata: "",
    icao: "DAAZ",
    latitude: "35.752239",
    longitude: "0.626272",
    altitude: "282",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "220",
    name: "Annaba",
    city: "Annaba",
    country: "Algeria",
    iata: "AAE",
    icao: "DABB",
    latitude: "36.822225",
    longitude: "7.809167",
    altitude: "16",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "221",
    name: "Mohamed Boudiaf Intl",
    city: "Constantine",
    country: "Algeria",
    iata: "CZL",
    icao: "DABC",
    latitude: "36.276028",
    longitude: "6.620386",
    altitude: "2265",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "222",
    name: "Cheikh Larbi Tebessi",
    city: "Tebessa",
    country: "Algeria",
    iata: "TEE",
    icao: "DABS",
    latitude: "35.431611",
    longitude: "8.120717",
    altitude: "2661",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "224",
    name: "Hassi R Mel",
    city: "Tilrempt",
    country: "Algeria",
    iata: "HRM",
    icao: "DAFH",
    latitude: "32.930431",
    longitude: "3.311542",
    altitude: "2540",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "225",
    name: "Bou Chekif",
    city: "Tiaret",
    country: "Algeria",
    iata: "TID",
    icao: "DAOB",
    latitude: "35.341136",
    longitude: "1.463147",
    altitude: "3245",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "226",
    name: "Bou Sfer",
    city: "Bou Sfer",
    country: "Algeria",
    iata: "",
    icao: "DAOE",
    latitude: "35.735389",
    longitude: "-0.805389",
    altitude: "187",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "227",
    name: "Tindouf",
    city: "Tindouf",
    country: "Algeria",
    iata: "TIN",
    icao: "DAOF",
    latitude: "27.700372",
    longitude: "-8.167103",
    altitude: "1453",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "228",
    name: "Ech Cheliff",
    city: "Ech-cheliff",
    country: "Algeria",
    iata: "QAS",
    icao: "DAOI",
    latitude: "36.212658",
    longitude: "1.331775",
    altitude: "463",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "229",
    name: "Tafaraoui",
    city: "Oran",
    country: "Algeria",
    iata: "TAF",
    icao: "DAOL",
    latitude: "35.542444",
    longitude: "-0.532278",
    altitude: "367",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "230",
    name: "Zenata",
    city: "Tlemcen",
    country: "Algeria",
    iata: "TLM",
    icao: "DAON",
    latitude: "35.016667",
    longitude: "-1.45",
    altitude: "814",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "231",
    name: "Es Senia",
    city: "Oran",
    country: "Algeria",
    iata: "ORN",
    icao: "DAOO",
    latitude: "35.623858",
    longitude: "-0.621183",
    altitude: "295",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "232",
    name: "Sidi Bel Abbes",
    city: "Sidi Bel Abbes",
    country: "Algeria",
    iata: "",
    icao: "DAOS",
    latitude: "35.171775",
    longitude: "-0.593275",
    altitude: "1614",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "233",
    name: "Ghriss",
    city: "Ghriss",
    country: "Algeria",
    iata: "MUW",
    icao: "DAOV",
    latitude: "35.207725",
    longitude: "0.147142",
    altitude: "1686",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "234",
    name: "Touat Cheikh Sidi Mohamed Belkebir",
    city: "Adrar",
    country: "Algeria",
    iata: "AZR",
    icao: "DAUA",
    latitude: "27.837589",
    longitude: "-0.186414",
    altitude: "919",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "235",
    name: "Biskra",
    city: "Biskra",
    country: "Algeria",
    iata: "BSK",
    icao: "DAUB",
    latitude: "34.793289",
    longitude: "5.738231",
    altitude: "289",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "236",
    name: "El Golea",
    city: "El Golea",
    country: "Algeria",
    iata: "ELG",
    icao: "DAUE",
    latitude: "30.571294",
    longitude: "2.859586",
    altitude: "1306",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "237",
    name: "Noumerat",
    city: "Ghardaia",
    country: "Algeria",
    iata: "GHA",
    icao: "DAUG",
    latitude: "32.384106",
    longitude: "3.794114",
    altitude: "1512",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "238",
    name: "Oued Irara",
    city: "Hassi Messaoud",
    country: "Algeria",
    iata: "HME",
    icao: "DAUH",
    latitude: "31.672972",
    longitude: "6.140444",
    altitude: "463",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "239",
    name: "In Salah",
    city: "In Salah",
    country: "Algeria",
    iata: "INZ",
    icao: "DAUI",
    latitude: "27.251022",
    longitude: "2.512017",
    altitude: "896",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "240",
    name: "Sidi Mahdi",
    city: "Touggourt",
    country: "Algeria",
    iata: "TGR",
    icao: "DAUK",
    latitude: "33.067803",
    longitude: "6.088672",
    altitude: "279",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "241",
    name: "Laghouat",
    city: "Laghouat",
    country: "Algeria",
    iata: "LOO",
    icao: "DAUL",
    latitude: "33.764383",
    longitude: "2.928344",
    altitude: "2510",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "242",
    name: "Timimoun",
    city: "Timimoun",
    country: "Algeria",
    iata: "TMX",
    icao: "DAUT",
    latitude: "29.237119",
    longitude: "0.276033",
    altitude: "1027",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "243",
    name: "Ouargla",
    city: "Ouargla",
    country: "Algeria",
    iata: "OGX",
    icao: "DAUU",
    latitude: "31.917223",
    longitude: "5.412778",
    altitude: "492",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "244",
    name: "In Amenas",
    city: "Zarzaitine",
    country: "Algeria",
    iata: "IAM",
    icao: "DAUZ",
    latitude: "28.05155",
    longitude: "9.642911",
    altitude: "1847",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "245",
    name: "Cadjehoun",
    city: "Cotonou",
    country: "Benin",
    iata: "COO",
    icao: "DBBB",
    latitude: "6.357228",
    longitude: "2.384353",
    altitude: "19",
    timezone: "1",
    dst: "N",
    tz: "Africa/Porto-Novo",
  },
  {
    id: "246",
    name: "Ouagadougou",
    city: "Ouagadougou",
    country: "Burkina Faso",
    iata: "OUA",
    icao: "DFFD",
    latitude: "12.353194",
    longitude: "-1.512417",
    altitude: "1037",
    timezone: "0",
    dst: "N",
    tz: "Africa/Ouagadougou",
  },
  {
    id: "247",
    name: "Bobo Dioulasso",
    city: "Bobo-dioulasso",
    country: "Burkina Faso",
    iata: "BOY",
    icao: "DFOO",
    latitude: "11.160056",
    longitude: "-4.330969",
    altitude: "1511",
    timezone: "0",
    dst: "N",
    tz: "Africa/Ouagadougou",
  },
  {
    id: "248",
    name: "Kotoka Intl",
    city: "Accra",
    country: "Ghana",
    iata: "ACC",
    icao: "DGAA",
    latitude: "5.605186",
    longitude: "-0.166786",
    altitude: "205",
    timezone: "0",
    dst: "N",
    tz: "Africa/Accra",
  },
  {
    id: "249",
    name: "Tamale",
    city: "Tamale",
    country: "Ghana",
    iata: "TML",
    icao: "DGLE",
    latitude: "9.557192",
    longitude: "-0.863214",
    altitude: "553",
    timezone: "0",
    dst: "N",
    tz: "Africa/Accra",
  },
  {
    id: "250",
    name: "Wa",
    city: "Wa",
    country: "Ghana",
    iata: "",
    icao: "DGLW",
    latitude: "10.082664",
    longitude: "-2.507694",
    altitude: "1060",
    timezone: "0",
    dst: "N",
    tz: "Africa/Accra",
  },
  {
    id: "251",
    name: "Sunyani",
    city: "Sunyani",
    country: "Ghana",
    iata: "NYI",
    icao: "DGSN",
    latitude: "7.361828",
    longitude: "-2.328756",
    altitude: "1014",
    timezone: "0",
    dst: "N",
    tz: "Africa/Accra",
  },
  {
    id: "252",
    name: "Takoradi",
    city: "Takoradi",
    country: "Ghana",
    iata: "TKD",
    icao: "DGTK",
    latitude: "4.896056",
    longitude: "-1.774756",
    altitude: "21",
    timezone: "0",
    dst: "N",
    tz: "Africa/Accra",
  },
  {
    id: "253",
    name: "Abidjan Felix Houphouet Boigny Intl",
    city: "Abidjan",
    country: "Cote d'Ivoire",
    iata: "ABJ",
    icao: "DIAP",
    latitude: "5.261386",
    longitude: "-3.926294",
    altitude: "21",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "254",
    name: "Bouake",
    city: "Bouake",
    country: "Cote d'Ivoire",
    iata: "BYK",
    icao: "DIBK",
    latitude: "7.7388",
    longitude: "-5.073667",
    altitude: "1230",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "255",
    name: "Daloa",
    city: "Daloa",
    country: "Cote d'Ivoire",
    iata: "DJO",
    icao: "DIDL",
    latitude: "6.792808",
    longitude: "-6.473189",
    altitude: "823",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "256",
    name: "Korhogo",
    city: "Korhogo",
    country: "Cote d'Ivoire",
    iata: "HGO",
    icao: "DIKO",
    latitude: "9.387183",
    longitude: "-5.556664",
    altitude: "1214",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "257",
    name: "Man",
    city: "Man",
    country: "Cote d'Ivoire",
    iata: "MJC",
    icao: "DIMN",
    latitude: "7.272069",
    longitude: "-7.587364",
    altitude: "1089",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "258",
    name: "San Pedro",
    city: "San Pedro",
    country: "Cote d'Ivoire",
    iata: "SPY",
    icao: "DISP",
    latitude: "4.746717",
    longitude: "-6.660817",
    altitude: "26",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "259",
    name: "Yamoussoukro",
    city: "Yamoussoukro",
    country: "Cote d'Ivoire",
    iata: "ASK",
    icao: "DIYO",
    latitude: "6.903167",
    longitude: "-5.365581",
    altitude: "699",
    timezone: "0",
    dst: "N",
    tz: "Africa/Abidjan",
  },
  {
    id: "260",
    name: "Nnamdi Azikiwe Intl",
    city: "Abuja",
    country: "Nigeria",
    iata: "ABV",
    icao: "DNAA",
    latitude: "9.006792",
    longitude: "7.263172",
    altitude: "1123",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "261",
    name: "Akure",
    city: "Akure",
    country: "Nigeria",
    iata: "AKR",
    icao: "DNAK",
    latitude: "7.246739",
    longitude: "5.301008",
    altitude: "1100",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "262",
    name: "Benin",
    city: "Benin",
    country: "Nigeria",
    iata: "BNI",
    icao: "DNBE",
    latitude: "6.316981",
    longitude: "5.599503",
    altitude: "258",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "263",
    name: "Calabar",
    city: "Calabar",
    country: "Nigeria",
    iata: "CBQ",
    icao: "DNCA",
    latitude: "4.976019",
    longitude: "8.347197",
    altitude: "210",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "264",
    name: "Enugu",
    city: "Enugu",
    country: "Nigeria",
    iata: "ENU",
    icao: "DNEN",
    latitude: "6.474272",
    longitude: "7.561961",
    altitude: "466",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "265",
    name: "Gusau",
    city: "Gusau",
    country: "Nigeria",
    iata: "QUS",
    icao: "DNGU",
    latitude: "12.171667",
    longitude: "6.696111",
    altitude: "1520",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "266",
    name: "Ibadan",
    city: "Ibadan",
    country: "Nigeria",
    iata: "IBA",
    icao: "DNIB",
    latitude: "7.362458",
    longitude: "3.978333",
    altitude: "725",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "267",
    name: "Ilorin",
    city: "Ilorin",
    country: "Nigeria",
    iata: "ILR",
    icao: "DNIL",
    latitude: "8.440211",
    longitude: "4.493919",
    altitude: "1126",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "268",
    name: "Yakubu Gowon",
    city: "Jos",
    country: "Nigeria",
    iata: "JOS",
    icao: "DNJO",
    latitude: "9.639828",
    longitude: "8.86905",
    altitude: "4232",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "269",
    name: "Kaduna",
    city: "Kaduna",
    country: "Nigeria",
    iata: "KAD",
    icao: "DNKA",
    latitude: "10.696025",
    longitude: "7.320114",
    altitude: "2073",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "270",
    name: "Mallam Aminu Intl",
    city: "Kano",
    country: "Nigeria",
    iata: "KAN",
    icao: "DNKN",
    latitude: "12.047589",
    longitude: "8.524622",
    altitude: "1562",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "271",
    name: "Maiduguri",
    city: "Maiduguri",
    country: "Nigeria",
    iata: "MIU",
    icao: "DNMA",
    latitude: "11.855347",
    longitude: "13.08095",
    altitude: "1099",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "272",
    name: "Makurdi",
    city: "Makurdi",
    country: "Nigeria",
    iata: "MDI",
    icao: "DNMK",
    latitude: "7.703883",
    longitude: "8.613939",
    altitude: "371",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "273",
    name: "Murtala Muhammed",
    city: "Lagos",
    country: "Nigeria",
    iata: "LOS",
    icao: "DNMM",
    latitude: "6.577369",
    longitude: "3.321156",
    altitude: "135",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "274",
    name: "Minna New",
    city: "Minna",
    country: "Nigeria",
    iata: "MXJ",
    icao: "DNMN",
    latitude: "9.652172",
    longitude: "6.462256",
    altitude: "834",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "275",
    name: "Port Harcourt Intl",
    city: "Port Hartcourt",
    country: "Nigeria",
    iata: "PHC",
    icao: "DNPO",
    latitude: "5.015494",
    longitude: "6.949594",
    altitude: "87",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "276",
    name: "Sadiq Abubakar Iii Intl",
    city: "Sokoto",
    country: "Nigeria",
    iata: "SKO",
    icao: "DNSO",
    latitude: "12.916322",
    longitude: "5.207189",
    altitude: "1010",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "277",
    name: "Yola",
    city: "Yola",
    country: "Nigeria",
    iata: "YOL",
    icao: "DNYO",
    latitude: "9.257553",
    longitude: "12.430422",
    altitude: "599",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "278",
    name: "Zaria",
    city: "Zaria",
    country: "Nigeria",
    iata: "ZAR",
    icao: "DNZA",
    latitude: "11.130192",
    longitude: "7.685806",
    altitude: "2170",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "279",
    name: "Maradi",
    city: "Maradi",
    country: "Niger",
    iata: "MFQ",
    icao: "DRRM",
    latitude: "13.502531",
    longitude: "7.126753",
    altitude: "1240",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "280",
    name: "Diori Hamani",
    city: "Niamey",
    country: "Niger",
    iata: "NIM",
    icao: "DRRN",
    latitude: "13.481547",
    longitude: "2.183614",
    altitude: "732",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "281",
    name: "Tahoua",
    city: "Tahoua",
    country: "Niger",
    iata: "THZ",
    icao: "DRRT",
    latitude: "14.875658",
    longitude: "5.265358",
    altitude: "1266",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "282",
    name: "Manu Dayak",
    city: "Agadez",
    country: "Niger",
    iata: "AJY",
    icao: "DRZA",
    latitude: "16.965997",
    longitude: "8.000114",
    altitude: "1657",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "283",
    name: "Dirkou",
    city: "Dirkou",
    country: "Niger",
    iata: "",
    icao: "DRZD",
    latitude: "18.968703",
    longitude: "12.86865",
    altitude: "1273",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "284",
    name: "Diffa",
    city: "Diffa",
    country: "Niger",
    iata: "",
    icao: "DRZF",
    latitude: "13.372894",
    longitude: "12.626686",
    altitude: "994",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "285",
    name: "Zinder",
    city: "Zinder",
    country: "Niger",
    iata: "ZND",
    icao: "DRZR",
    latitude: "13.778997",
    longitude: "8.983761",
    altitude: "1516",
    timezone: "1",
    dst: "N",
    tz: "Africa/Niamey",
  },
  {
    id: "286",
    name: "Habib Bourguiba Intl",
    city: "Monastir",
    country: "Tunisia",
    iata: "MIR",
    icao: "DTMB",
    latitude: "35.758056",
    longitude: "10.754722",
    altitude: "9",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "287",
    name: "Carthage",
    city: "Tunis",
    country: "Tunisia",
    iata: "TUN",
    icao: "DTTA",
    latitude: "36.851033",
    longitude: "10.227217",
    altitude: "22",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "288",
    name: "Sidi Ahmed Air Base",
    city: "Bizerte",
    country: "Tunisia",
    iata: "",
    icao: "DTTB",
    latitude: "37.245447",
    longitude: "9.791453",
    altitude: "20",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "289",
    name: "Remada",
    city: "Remada",
    country: "Tunisia",
    iata: "",
    icao: "DTTD",
    latitude: "32.306156",
    longitude: "10.382108",
    altitude: "1004",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "290",
    name: "Gafsa",
    city: "Gafsa",
    country: "Tunisia",
    iata: "GAF",
    icao: "DTTF",
    latitude: "34.422022",
    longitude: "8.822503",
    altitude: "1060",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "291",
    name: "Gabes",
    city: "Gabes",
    country: "Tunisia",
    iata: "GAE",
    icao: "DTTG",
    latitude: "33.876919",
    longitude: "10.103333",
    altitude: "26",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "292",
    name: "Borj El Amri",
    city: "Bordj El Amri",
    country: "Tunisia",
    iata: "",
    icao: "DTTI",
    latitude: "36.721339",
    longitude: "9.943147",
    altitude: "108",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "293",
    name: "Zarzis",
    city: "Djerba",
    country: "Tunisia",
    iata: "DJE",
    icao: "DTTJ",
    latitude: "33.875031",
    longitude: "10.775461",
    altitude: "19",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "294",
    name: "El Borma",
    city: "El Borma",
    country: "Tunisia",
    iata: "EBM",
    icao: "DTTR",
    latitude: "31.704281",
    longitude: "9.254619",
    altitude: "827",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "295",
    name: "Thyna",
    city: "Sfax",
    country: "Tunisia",
    iata: "SFA",
    icao: "DTTX",
    latitude: "34.717953",
    longitude: "10.690972",
    altitude: "85",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "296",
    name: "Nefta",
    city: "Tozeur",
    country: "Tunisia",
    iata: "TOE",
    icao: "DTTZ",
    latitude: "33.939722",
    longitude: "8.110556",
    altitude: "287",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "297",
    name: "Niamtougou International",
    city: "Niatougou",
    country: "Togo",
    iata: "LRL",
    icao: "DXNG",
    latitude: "9.767333",
    longitude: "1.09125",
    altitude: "1515",
    timezone: "0",
    dst: "N",
    tz: "Africa/Lome",
  },
  {
    id: "298",
    name: "Gnassingbe Eyadema Intl",
    city: "Lome",
    country: "Togo",
    iata: "LFW",
    icao: "DXXX",
    latitude: "6.165611",
    longitude: "1.254511",
    altitude: "72",
    timezone: "0",
    dst: "N",
    tz: "Africa/Lome",
  },
  {
    id: "299",
    name: "Deurne",
    city: "Antwerp",
    country: "Belgium",
    iata: "ANR",
    icao: "EBAW",
    latitude: "51.189444",
    longitude: "4.460278",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "300",
    name: "Beauvechain",
    city: "Beauvechain",
    country: "Belgium",
    iata: "",
    icao: "EBBE",
    latitude: "50.75861",
    longitude: "4.768333",
    altitude: "370",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "301",
    name: "Kleine Brogel",
    city: "Kleine Brogel",
    country: "Belgium",
    iata: "",
    icao: "EBBL",
    latitude: "51.168333",
    longitude: "5.47",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "302",
    name: "Brussels Natl",
    city: "Brussels",
    country: "Belgium",
    iata: "BRU",
    icao: "EBBR",
    latitude: "50.901389",
    longitude: "4.484444",
    altitude: "184",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "303",
    name: "Bertrix",
    city: "Bertrix",
    country: "Belgium",
    iata: "",
    icao: "EBBX",
    latitude: "49.891667",
    longitude: "5.223889",
    altitude: "1514",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "304",
    name: "Brussels South",
    city: "Charleroi",
    country: "Belgium",
    iata: "CRL",
    icao: "EBCI",
    latitude: "50.459197",
    longitude: "4.453817",
    altitude: "614",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "305",
    name: "Chievres Ab",
    city: "Chievres",
    country: "Belgium",
    iata: "",
    icao: "EBCV",
    latitude: "50.575833",
    longitude: "3.831",
    altitude: "193",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "306",
    name: "Koksijde",
    city: "Koksijde",
    country: "Belgium",
    iata: "",
    icao: "EBFN",
    latitude: "51.090278",
    longitude: "2.652778",
    altitude: "20",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "307",
    name: "Florennes",
    city: "Florennes",
    country: "Belgium",
    iata: "",
    icao: "EBFS",
    latitude: "50.243333",
    longitude: "4.645833",
    altitude: "935",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "308",
    name: "Wevelgem",
    city: "Kortrijk-vevelgem",
    country: "Belgium",
    iata: "QKT",
    icao: "EBKT",
    latitude: "50.817222",
    longitude: "3.204722",
    altitude: "64",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "309",
    name: "Liege",
    city: "Liege",
    country: "Belgium",
    iata: "LGG",
    icao: "EBLG",
    latitude: "50.637417",
    longitude: "5.443222",
    altitude: "659",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "310",
    name: "Oostende",
    city: "Ostend",
    country: "Belgium",
    iata: "OST",
    icao: "EBOS",
    latitude: "51.198889",
    longitude: "2.862222",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "311",
    name: "Zutendaal",
    city: "Zutendaal",
    country: "Belgium",
    iata: "",
    icao: "EBSL",
    latitude: "50.9475",
    longitude: "5.590556",
    altitude: "312",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "312",
    name: "Sint Truiden",
    city: "Sint-truiden",
    country: "Belgium",
    iata: "",
    icao: "EBST",
    latitude: "50.791944",
    longitude: "5.201667",
    altitude: "246",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "313",
    name: "Saint Hubert Mil",
    city: "St.-hubert",
    country: "Belgium",
    iata: "",
    icao: "EBSU",
    latitude: "50.035833",
    longitude: "5.404167",
    altitude: "1930",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "314",
    name: "Ursel",
    city: "Ursel",
    country: "Belgium",
    iata: "",
    icao: "EBUL",
    latitude: "51.144133",
    longitude: "3.474361",
    altitude: "95",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "315",
    name: "Weelde",
    city: "Weelde",
    country: "Belgium",
    iata: "",
    icao: "EBWE",
    latitude: "51.394783",
    longitude: "4.960194",
    altitude: "105",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "316",
    name: "Zoersel",
    city: "Zoersel",
    country: "Belgium",
    iata: "",
    icao: "EBZR",
    latitude: "51.264722",
    longitude: "4.753333",
    altitude: "53",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "317",
    name: "Bautzen",
    city: "Bautzen",
    country: "Germany",
    iata: "BBJ",
    icao: "EDAB",
    latitude: "51.193531",
    longitude: "14.519747",
    altitude: "568",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "318",
    name: "Altenburg Nobitz",
    city: "Altenburg",
    country: "Germany",
    iata: "AOC",
    icao: "EDAC",
    latitude: "50.981817",
    longitude: "12.506361",
    altitude: "640",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "319",
    name: "Dessau",
    city: "Dessau",
    country: "Germany",
    iata: "",
    icao: "EDAD",
    latitude: "51.831828",
    longitude: "12.184033",
    altitude: "187",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "320",
    name: "Eisenhuttenstadt",
    city: "Eisenhuettenstadt",
    country: "Germany",
    iata: "",
    icao: "EDAE",
    latitude: "52.197333",
    longitude: "14.585667",
    altitude: "149",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6891",
    name: "Putnam County Airport",
    city: "Greencastle",
    country: "United States",
    iata: "4I7",
    icao: "\\N",
    latitude: "39.6335556",
    longitude: "-86.8138056",
    altitude: "842",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "322",
    name: "Grossenhain",
    city: "Suhl",
    country: "Germany",
    iata: "",
    icao: "EDAK",
    latitude: "51.308111",
    longitude: "13.554973",
    altitude: "417",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "323",
    name: "Merseburg",
    city: "Muehlhausen",
    country: "Germany",
    iata: "",
    icao: "EDAM",
    latitude: "51.363",
    longitude: "11.940833",
    altitude: "340",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "324",
    name: "Halle Oppin",
    city: "Halle",
    country: "Germany",
    iata: "",
    icao: "EDAQ",
    latitude: "51.552",
    longitude: "12.052667",
    altitude: "347",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "325",
    name: "Riesa Gohlis",
    city: "Riesa",
    country: "Germany",
    iata: "",
    icao: "EDAU",
    latitude: "51.2935",
    longitude: "13.356",
    altitude: "322",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "326",
    name: "Rechlin Larz",
    city: "Rechlin-laerz",
    country: "Germany",
    iata: "",
    icao: "EDAX",
    latitude: "53.306417",
    longitude: "12.753139",
    altitude: "220",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "327",
    name: "Strausberg",
    city: "Strausberg",
    country: "Germany",
    iata: "",
    icao: "EDAY",
    latitude: "52.579978",
    longitude: "13.915683",
    altitude: "263",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "328",
    name: "Schonhagen",
    city: "Schoenhagen",
    country: "Germany",
    iata: "",
    icao: "EDAZ",
    latitude: "52.203258",
    longitude: "13.158408",
    altitude: "131",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "329",
    name: "Barth",
    city: "Barth",
    country: "Germany",
    iata: "BBH",
    icao: "EDBH",
    latitude: "54.33754",
    longitude: "12.699705",
    altitude: "23",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "330",
    name: "Jena Schongleina",
    city: "Jena",
    country: "Germany",
    iata: "",
    icao: "EDBJ",
    latitude: "50.915161",
    longitude: "11.714519",
    altitude: "1228",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "331",
    name: "Kyritz",
    city: "Kyritz",
    country: "Germany",
    iata: "",
    icao: "EDBK",
    latitude: "52.918833",
    longitude: "12.425333",
    altitude: "130",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "332",
    name: "Magdeburg",
    city: "Magdeburg",
    country: "Germany",
    iata: "",
    icao: "EDBM",
    latitude: "52.073658",
    longitude: "11.626467",
    altitude: "268",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "333",
    name: "Rothenburg Gorlitz",
    city: "Rothenburg/ol",
    country: "Germany",
    iata: "",
    icao: "EDBR",
    latitude: "51.363167",
    longitude: "14.95",
    altitude: "517",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "334",
    name: "Anklam",
    city: "Anklam",
    country: "Germany",
    iata: "",
    icao: "EDCA",
    latitude: "53.8327",
    longitude: "13.669131",
    altitude: "18",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "335",
    name: "Cottbus Drewitz",
    city: "Cottbus",
    country: "Germany",
    iata: "",
    icao: "EDCD",
    latitude: "51.889475",
    longitude: "14.531986",
    altitude: "274",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "336",
    name: "Kamenz",
    city: "Kamenz",
    country: "Germany",
    iata: "",
    icao: "EDCM",
    latitude: "51.29625",
    longitude: "14.129",
    altitude: "495",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "337",
    name: "Schonefeld",
    city: "Berlin",
    country: "Germany",
    iata: "SXF",
    icao: "EDDB",
    latitude: "52.380001",
    longitude: "13.5225",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "338",
    name: "Dresden",
    city: "Dresden",
    country: "Germany",
    iata: "DRS",
    icao: "EDDC",
    latitude: "51.132767",
    longitude: "13.767161",
    altitude: "755",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "339",
    name: "Erfurt",
    city: "Erfurt",
    country: "Germany",
    iata: "ERF",
    icao: "EDDE",
    latitude: "50.979811",
    longitude: "10.958106",
    altitude: "1036",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "340",
    name: "Frankfurt Main",
    city: "Frankfurt",
    country: "Germany",
    iata: "FRA",
    icao: "EDDF",
    latitude: "50.026421",
    longitude: "8.543125",
    altitude: "364",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "341",
    name: "Munster Osnabruck",
    city: "Munster",
    country: "Germany",
    iata: "FMO",
    icao: "EDDG",
    latitude: "52.134642",
    longitude: "7.684831",
    altitude: "160",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "342",
    name: "Hamburg",
    city: "Hamburg",
    country: "Germany",
    iata: "HAM",
    icao: "EDDH",
    latitude: "53.630389",
    longitude: "9.988228",
    altitude: "53",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "343",
    name: "Tempelhof",
    city: "Berlin",
    country: "Germany",
    iata: "THF",
    icao: "EDDI",
    latitude: "52.473025",
    longitude: "13.403944",
    altitude: "167",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "344",
    name: "Koln Bonn",
    city: "Cologne",
    country: "Germany",
    iata: "CGN",
    icao: "EDDK",
    latitude: "50.865917",
    longitude: "7.142744",
    altitude: "302",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "345",
    name: "Dusseldorf",
    city: "Duesseldorf",
    country: "Germany",
    iata: "DUS",
    icao: "EDDL",
    latitude: "51.289453",
    longitude: "6.766775",
    altitude: "147",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "346",
    name: "Franz Josef Strauss",
    city: "Munich",
    country: "Germany",
    iata: "MUC",
    icao: "EDDM",
    latitude: "48.353783",
    longitude: "11.786086",
    altitude: "1487",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "347",
    name: "Nurnberg",
    city: "Nuernberg",
    country: "Germany",
    iata: "NUE",
    icao: "EDDN",
    latitude: "49.4987",
    longitude: "11.066897",
    altitude: "1046",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "348",
    name: "Leipzig Halle",
    city: "Leipzig",
    country: "Germany",
    iata: "LEJ",
    icao: "EDDP",
    latitude: "51.432447",
    longitude: "12.241633",
    altitude: "465",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "349",
    name: "Saarbrucken",
    city: "Saarbruecken",
    country: "Germany",
    iata: "SCN",
    icao: "EDDR",
    latitude: "49.214553",
    longitude: "7.109508",
    altitude: "1058",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "350",
    name: "Stuttgart",
    city: "Stuttgart",
    country: "Germany",
    iata: "STR",
    icao: "EDDS",
    latitude: "48.689878",
    longitude: "9.221964",
    altitude: "1276",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "351",
    name: "Tegel",
    city: "Berlin",
    country: "Germany",
    iata: "TXL",
    icao: "EDDT",
    latitude: "52.559686",
    longitude: "13.287711",
    altitude: "122",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "352",
    name: "Hannover",
    city: "Hannover",
    country: "Germany",
    iata: "HAJ",
    icao: "EDDV",
    latitude: "52.461056",
    longitude: "9.685078",
    altitude: "183",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "353",
    name: "Neuenland",
    city: "Bremen",
    country: "Germany",
    iata: "BRE",
    icao: "EDDW",
    latitude: "53.0475",
    longitude: "8.786667",
    altitude: "14",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "354",
    name: "Egelsbach",
    city: "Egelsbach",
    country: "Germany",
    iata: "",
    icao: "EDFE",
    latitude: "49.960833",
    longitude: "8.6415",
    altitude: "385",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "355",
    name: "Frankfurt Hahn",
    city: "Hahn",
    country: "Germany",
    iata: "HHN",
    icao: "EDFH",
    latitude: "49.948672",
    longitude: "7.263892",
    altitude: "1649",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "356",
    name: "Mannheim City",
    city: "Mannheim",
    country: "Germany",
    iata: "MHG",
    icao: "EDFM",
    latitude: "49.472706",
    longitude: "8.514264",
    altitude: "309",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "357",
    name: "Allendorf Eder",
    city: "Allendorf",
    country: "Germany",
    iata: "",
    icao: "EDFQ",
    latitude: "51.034878",
    longitude: "8.680839",
    altitude: "1164",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "358",
    name: "Worms",
    city: "Worms",
    country: "Germany",
    iata: "",
    icao: "EDFV",
    latitude: "49.606511",
    longitude: "8.3684",
    altitude: "295",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "359",
    name: "Mainz Finthen",
    city: "Mainz",
    country: "Germany",
    iata: "",
    icao: "EDFZ",
    latitude: "49.968931",
    longitude: "8.148336",
    altitude: "760",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "360",
    name: "Eisenach Kindel",
    city: "Eisenach",
    country: "Germany",
    iata: "",
    icao: "EDGE",
    latitude: "50.992797",
    longitude: "10.472711",
    altitude: "1101",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "361",
    name: "Siegerland",
    city: "Siegerland",
    country: "Germany",
    iata: "",
    icao: "EDGS",
    latitude: "50.707658",
    longitude: "8.082969",
    altitude: "1966",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "362",
    name: "Hamburg Finkenwerder",
    city: "Hamburg",
    country: "Germany",
    iata: "XFW",
    icao: "EDHI",
    latitude: "53.535886",
    longitude: "9.837025",
    altitude: "22",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "363",
    name: "Kiel Holtenau",
    city: "Kiel",
    country: "Germany",
    iata: "KEL",
    icao: "EDHK",
    latitude: "54.3795",
    longitude: "10.145167",
    altitude: "101",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "364",
    name: "Lubeck Blankensee",
    city: "Luebeck",
    country: "Germany",
    iata: "LBC",
    icao: "EDHL",
    latitude: "53.805367",
    longitude: "10.719222",
    altitude: "53",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "365",
    name: "Dahlemer Binz",
    city: "Dahlemer Binz",
    country: "Germany",
    iata: "",
    icao: "EDKV",
    latitude: "50.405888",
    longitude: "6.528083",
    altitude: "1896",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "366",
    name: "Meinerzhagen",
    city: "Meinerzhagen",
    country: "Germany",
    iata: "",
    icao: "EDKZ",
    latitude: "51.099445",
    longitude: "7.601944",
    altitude: "1548",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "367",
    name: "Arnsberg Menden",
    city: "Arnsberg",
    country: "Germany",
    iata: "ZCA",
    icao: "EDLA",
    latitude: "51.483333",
    longitude: "7.899333",
    altitude: "794",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "368",
    name: "Essen Mulheim",
    city: "Essen",
    country: "Germany",
    iata: "ESS",
    icao: "EDLE",
    latitude: "51.402333",
    longitude: "6.937333",
    altitude: "424",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "369",
    name: "Bielefeld",
    city: "Bielefeld",
    country: "Germany",
    iata: "",
    icao: "EDLI",
    latitude: "51.964833",
    longitude: "8.544833",
    altitude: "454",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "370",
    name: "Monchengladbach",
    city: "Moenchengladbach",
    country: "Germany",
    iata: "MGL",
    icao: "EDLN",
    latitude: "51.230356",
    longitude: "6.504494",
    altitude: "125",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "371",
    name: "Paderborn Lippstadt",
    city: "Paderborn",
    country: "Germany",
    iata: "PAD",
    icao: "EDLP",
    latitude: "51.614089",
    longitude: "8.616317",
    altitude: "699",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "372",
    name: "Stadtlohn Vreden",
    city: "Stadtlohn",
    country: "Germany",
    iata: "",
    icao: "EDLS",
    latitude: "51.995844",
    longitude: "6.840667",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "373",
    name: "Dortmund",
    city: "Dortmund",
    country: "Germany",
    iata: "DTM",
    icao: "EDLW",
    latitude: "51.518314",
    longitude: "7.612242",
    altitude: "425",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "374",
    name: "Augsburg",
    city: "Augsburg",
    country: "Germany",
    iata: "AGB",
    icao: "EDMA",
    latitude: "48.425158",
    longitude: "10.931764",
    altitude: "1515",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "375",
    name: "Biberach An Der Riss",
    city: "Biberach",
    country: "Germany",
    iata: "",
    icao: "EDMB",
    latitude: "48.111",
    longitude: "9.762833",
    altitude: "1903",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "376",
    name: "Eggenfelden",
    city: "Eggenfelden",
    country: "Germany",
    iata: "",
    icao: "EDME",
    latitude: "48.396167",
    longitude: "12.723667",
    altitude: "1342",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "377",
    name: "Mindelheim Mattsies",
    city: "Mindelheim",
    country: "Germany",
    iata: "",
    icao: "EDMN",
    latitude: "48.108833",
    longitude: "10.524333",
    altitude: "1857",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "378",
    name: "Oberpfaffenhofen",
    city: "Oberpfaffenhofen",
    country: "Germany",
    iata: "OBF",
    icao: "EDMO",
    latitude: "48.081364",
    longitude: "11.283067",
    altitude: "1947",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "379",
    name: "Straubing",
    city: "Straubing",
    country: "Germany",
    iata: "",
    icao: "EDMS",
    latitude: "48.90095",
    longitude: "12.518186",
    altitude: "1054",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "380",
    name: "Vilshofen",
    city: "Vilshofen",
    country: "Germany",
    iata: "",
    icao: "EDMV",
    latitude: "48.635167",
    longitude: "13.195667",
    altitude: "991",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "381",
    name: "Leutkirch Unterzeil",
    city: "Leutkirch",
    country: "Germany",
    iata: "",
    icao: "EDNL",
    latitude: "47.859117",
    longitude: "10.014572",
    altitude: "2099",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "382",
    name: "Friedrichshafen",
    city: "Friedrichshafen",
    country: "Germany",
    iata: "FDH",
    icao: "EDNY",
    latitude: "47.671317",
    longitude: "9.511486",
    altitude: "1367",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "383",
    name: "Schwerin Parchim",
    city: "Parchim",
    country: "Germany",
    iata: "SZW",
    icao: "EDOP",
    latitude: "53.426997",
    longitude: "11.783436",
    altitude: "166",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "384",
    name: "Stendal Borstel",
    city: "Stendal",
    country: "Germany",
    iata: "ZSN",
    icao: "EDOV",
    latitude: "52.627778",
    longitude: "11.818333",
    altitude: "184",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "385",
    name: "Aalen Heidenheim Elchingen",
    city: "Aalen-heidenheim",
    country: "Germany",
    iata: "",
    icao: "EDPA",
    latitude: "48.777833",
    longitude: "10.264667",
    altitude: "1916",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "386",
    name: "Bayreuth",
    city: "Bayreuth",
    country: "Germany",
    iata: "BYU",
    icao: "EDQD",
    latitude: "49.984428",
    longitude: "11.638569",
    altitude: "1601",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "387",
    name: "Burg Feuerstein",
    city: "Burg Feuerstein",
    country: "Germany",
    iata: "",
    icao: "EDQE",
    latitude: "49.793833",
    longitude: "11.133167",
    altitude: "1674",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "388",
    name: "Hof Plauen",
    city: "Hof",
    country: "Germany",
    iata: "HOQ",
    icao: "EDQM",
    latitude: "50.288836",
    longitude: "11.854919",
    altitude: "1960",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "389",
    name: "Hassfurt Schweinfurt",
    city: "Hassfurt",
    country: "Germany",
    iata: "",
    icao: "EDQT",
    latitude: "50.018",
    longitude: "10.5295",
    altitude: "718",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "390",
    name: "Koblenz Winningen",
    city: "Koblenz",
    country: "Germany",
    iata: "ZNV",
    icao: "EDRK",
    latitude: "50.3255",
    longitude: "7.528667",
    altitude: "640",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "391",
    name: "Trier Fohren",
    city: "Trier",
    country: "Germany",
    iata: "ZQF",
    icao: "EDRT",
    latitude: "49.8635",
    longitude: "6.788167",
    altitude: "665",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "392",
    name: "Speyer",
    city: "Speyer",
    country: "Germany",
    iata: "ZQC",
    icao: "EDRY",
    latitude: "49.302776",
    longitude: "8.451195",
    altitude: "312",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "393",
    name: "Zweibrucken",
    city: "Zweibruecken",
    country: "Germany",
    iata: "",
    icao: "EDRZ",
    latitude: "49.209525",
    longitude: "7.400647",
    altitude: "1133",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "394",
    name: "Donaueschingen Villingen",
    city: "Donaueschingen",
    country: "Germany",
    iata: "ZQL",
    icao: "EDTD",
    latitude: "47.973331",
    longitude: "8.522223",
    altitude: "2231",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "395",
    name: "Freiburg",
    city: "Freiburg",
    country: "Germany",
    iata: "",
    icao: "EDTF",
    latitude: "48.022653",
    longitude: "7.832583",
    altitude: "799",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "396",
    name: "Mengen Hohentengen",
    city: "Mengen",
    country: "Germany",
    iata: "",
    icao: "EDTM",
    latitude: "48.053833",
    longitude: "9.372833",
    altitude: "1820",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "397",
    name: "Schwabisch Hall",
    city: "Schwaebisch Hall",
    country: "Germany",
    iata: "",
    icao: "EDTY",
    latitude: "49.118317",
    longitude: "9.783956",
    altitude: "1311",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "398",
    name: "Finsterwalde Schacksdorf",
    city: "Soest",
    country: "Germany",
    iata: "",
    icao: "EDUS",
    latitude: "51.6075",
    longitude: "13.738",
    altitude: "399",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "399",
    name: "Braunschweig Wolfsburg",
    city: "Braunschweig",
    country: "Germany",
    iata: "BWE",
    icao: "EDVE",
    latitude: "52.319167",
    longitude: "10.556111",
    altitude: "295",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "400",
    name: "Kassel Calden",
    city: "Kassel",
    country: "Germany",
    iata: "KSF",
    icao: "EDVK",
    latitude: "51.408394",
    longitude: "9.377631",
    altitude: "908",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "401",
    name: "Hildesheim",
    city: "Hildesheim",
    country: "Germany",
    iata: "",
    icao: "EDVM",
    latitude: "52.179833",
    longitude: "9.945667",
    altitude: "293",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "402",
    name: "Bremerhaven",
    city: "Bremerhaven",
    country: "Germany",
    iata: "BRV",
    icao: "EDWB",
    latitude: "53.507081",
    longitude: "8.572878",
    altitude: "11",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "403",
    name: "Emden",
    city: "Emden",
    country: "Germany",
    iata: "EME",
    icao: "EDWE",
    latitude: "53.391186",
    longitude: "7.227408",
    altitude: "2",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "404",
    name: "Leer Papenburg",
    city: "Leer",
    country: "Germany",
    iata: "",
    icao: "EDWF",
    latitude: "53.271592",
    longitude: "7.442344",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "405",
    name: "Wilhelmshaven Mariensiel",
    city: "Wilhelmshaven",
    country: "Germany",
    iata: "WVN",
    icao: "EDWI",
    latitude: "53.504833",
    longitude: "8.053333",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "406",
    name: "Borkum",
    city: "Borkum",
    country: "Germany",
    iata: "BMK",
    icao: "EDWR",
    latitude: "53.5955",
    longitude: "6.709167",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "407",
    name: "Norderney",
    city: "Norderney",
    country: "Germany",
    iata: "NRD",
    icao: "EDWY",
    latitude: "53.706822",
    longitude: "7.230247",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "408",
    name: "Flensburg Schaferhaus",
    city: "Flensburg",
    country: "Germany",
    iata: "FLF",
    icao: "EDXF",
    latitude: "54.771772",
    longitude: "9.378214",
    altitude: "130",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "409",
    name: "Rendsburg Schachtholm",
    city: "Rendsburg",
    country: "Germany",
    iata: "",
    icao: "EDXR",
    latitude: "54.220928",
    longitude: "9.600803",
    altitude: "23",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "410",
    name: "Westerland Sylt",
    city: "Westerland",
    country: "Germany",
    iata: "GWT",
    icao: "EDXW",
    latitude: "54.91325",
    longitude: "8.340472",
    altitude: "51",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "411",
    name: "Amari",
    city: "Armari Air Force Base",
    country: "Estonia",
    iata: "",
    icao: "EEEI",
    latitude: "59.260286",
    longitude: "24.208467",
    altitude: "65",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "412",
    name: "Kardla",
    city: "Kardla",
    country: "Estonia",
    iata: "KDL",
    icao: "EEKA",
    latitude: "58.990756",
    longitude: "22.830733",
    altitude: "18",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "413",
    name: "Kuressaare",
    city: "Kuressaare",
    country: "Estonia",
    iata: "URE",
    icao: "EEKE",
    latitude: "58.229883",
    longitude: "22.509494",
    altitude: "14",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "414",
    name: "Parnu",
    city: "Parnu",
    country: "Estonia",
    iata: "EPU",
    icao: "EEPU",
    latitude: "58.419044",
    longitude: "24.472819",
    altitude: "47",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "415",
    name: "Tallinn",
    city: "Tallinn-ulemiste International",
    country: "Estonia",
    iata: "TLL",
    icao: "EETN",
    latitude: "59.413317",
    longitude: "24.832844",
    altitude: "131",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "416",
    name: "Tartu",
    city: "Tartu",
    country: "Estonia",
    iata: "TAY",
    icao: "EETU",
    latitude: "58.307461",
    longitude: "26.690428",
    altitude: "219",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "417",
    name: "Enontekio",
    city: "Enontekio",
    country: "Finland",
    iata: "ENF",
    icao: "EFET",
    latitude: "68.362586",
    longitude: "23.424322",
    altitude: "1005",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "418",
    name: "Eura",
    city: "Eura",
    country: "Finland",
    iata: "",
    icao: "EFEU",
    latitude: "61.116112",
    longitude: "22.201389",
    altitude: "259",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "419",
    name: "Halli",
    city: "Halli",
    country: "Finland",
    iata: "KEV",
    icao: "EFHA",
    latitude: "61.85605",
    longitude: "24.7866",
    altitude: "479",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "420",
    name: "Helsinki Malmi",
    city: "Helsinki",
    country: "Finland",
    iata: "HEM",
    icao: "EFHF",
    latitude: "60.254558",
    longitude: "25.042828",
    altitude: "57",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "421",
    name: "Helsinki Vantaa",
    city: "Helsinki",
    country: "Finland",
    iata: "HEL",
    icao: "EFHK",
    latitude: "60.317222",
    longitude: "24.963333",
    altitude: "179",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "422",
    name: "Hameenkyro",
    city: "Hameenkyro",
    country: "Finland",
    iata: "",
    icao: "EFHM",
    latitude: "61.689656",
    longitude: "23.073744",
    altitude: "449",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "423",
    name: "Hanko",
    city: "Hanko",
    country: "Finland",
    iata: "",
    icao: "EFHN",
    latitude: "59.848864",
    longitude: "23.083583",
    altitude: "20",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "424",
    name: "Hyvinkaa",
    city: "Hyvinkaa",
    country: "Finland",
    iata: "HYV",
    icao: "EFHV",
    latitude: "60.654444",
    longitude: "24.881111",
    altitude: "430",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "425",
    name: "Kiikala",
    city: "Kikala",
    country: "Finland",
    iata: "",
    icao: "EFIK",
    latitude: "60.462502",
    longitude: "23.6525",
    altitude: "381",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "426",
    name: "Immola",
    city: "Immola",
    country: "Finland",
    iata: "",
    icao: "EFIM",
    latitude: "61.249172",
    longitude: "28.903711",
    altitude: "338",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "427",
    name: "Kitee",
    city: "Kitee",
    country: "Finland",
    iata: "",
    icao: "EFIT",
    latitude: "62.166111",
    longitude: "30.073611",
    altitude: "364",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "428",
    name: "Ivalo",
    city: "Ivalo",
    country: "Finland",
    iata: "IVL",
    icao: "EFIV",
    latitude: "68.607269",
    longitude: "27.405328",
    altitude: "481",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "429",
    name: "Joensuu",
    city: "Joensuu",
    country: "Finland",
    iata: "JOE",
    icao: "EFJO",
    latitude: "62.662906",
    longitude: "29.60755",
    altitude: "398",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "430",
    name: "Jyvaskyla",
    city: "Jyvaskyla",
    country: "Finland",
    iata: "JYV",
    icao: "EFJY",
    latitude: "62.399453",
    longitude: "25.678253",
    altitude: "459",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "431",
    name: "Kauhava",
    city: "Kauhava",
    country: "Finland",
    iata: "KAU",
    icao: "EFKA",
    latitude: "63.127078",
    longitude: "23.051442",
    altitude: "151",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "432",
    name: "Kemi Tornio",
    city: "Kemi",
    country: "Finland",
    iata: "KEM",
    icao: "EFKE",
    latitude: "65.781889",
    longitude: "24.5991",
    altitude: "61",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "433",
    name: "Kajaani",
    city: "Kajaani",
    country: "Finland",
    iata: "KAJ",
    icao: "EFKI",
    latitude: "64.285472",
    longitude: "27.692414",
    altitude: "483",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "434",
    name: "Kauhajoki",
    city: "Kauhajoki",
    country: "Finland",
    iata: "",
    icao: "EFKJ",
    latitude: "62.462502",
    longitude: "22.393055",
    altitude: "407",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "435",
    name: "Kruunupyy",
    city: "Kruunupyy",
    country: "Finland",
    iata: "KOK",
    icao: "EFKK",
    latitude: "63.721172",
    longitude: "23.143131",
    altitude: "84",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "436",
    name: "Kemijarvi",
    city: "Kemijarvi",
    country: "Finland",
    iata: "",
    icao: "EFKM",
    latitude: "66.712883",
    longitude: "27.156786",
    altitude: "692",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "437",
    name: "Kuusamo",
    city: "Kuusamo",
    country: "Finland",
    iata: "KAO",
    icao: "EFKS",
    latitude: "65.987575",
    longitude: "29.239381",
    altitude: "866",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "438",
    name: "Kittila",
    city: "Kittila",
    country: "Finland",
    iata: "KTT",
    icao: "EFKT",
    latitude: "67.701022",
    longitude: "24.84685",
    altitude: "644",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "439",
    name: "Kuopio",
    city: "Kuopio",
    country: "Finland",
    iata: "KUO",
    icao: "EFKU",
    latitude: "63.00715",
    longitude: "27.797756",
    altitude: "323",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "440",
    name: "Lahti Vesivehmaa",
    city: "Vesivehmaa",
    country: "Finland",
    iata: "",
    icao: "EFLA",
    latitude: "61.144158",
    longitude: "25.693508",
    altitude: "502",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "441",
    name: "Lappeenranta",
    city: "Lappeenranta",
    country: "Finland",
    iata: "LPP",
    icao: "EFLP",
    latitude: "61.044553",
    longitude: "28.144397",
    altitude: "349",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "442",
    name: "Mariehamn",
    city: "Mariehamn",
    country: "Finland",
    iata: "MHQ",
    icao: "EFMA",
    latitude: "60.122203",
    longitude: "19.898156",
    altitude: "17",
    timezone: "2",
    dst: "E",
    tz: "Europe/Mariehamn",
  },
  {
    id: "443",
    name: "Menkijarvi",
    city: "Menkijarvi",
    country: "Finland",
    iata: "",
    icao: "EFME",
    latitude: "62.946667",
    longitude: "23.518889",
    altitude: "331",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "444",
    name: "Mikkeli",
    city: "Mikkeli",
    country: "Finland",
    iata: "MIK",
    icao: "EFMI",
    latitude: "61.6866",
    longitude: "27.201794",
    altitude: "329",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "445",
    name: "Nummela",
    city: "Nummela",
    country: "Finland",
    iata: "",
    icao: "EFNU",
    latitude: "60.333889",
    longitude: "24.296389",
    altitude: "367",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "446",
    name: "Oulu",
    city: "Oulu",
    country: "Finland",
    iata: "OUL",
    icao: "EFOU",
    latitude: "64.930061",
    longitude: "25.354564",
    altitude: "47",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "447",
    name: "Piikajarvi",
    city: "Piikajarvi",
    country: "Finland",
    iata: "",
    icao: "EFPI",
    latitude: "61.245558",
    longitude: "22.193356",
    altitude: "148",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "448",
    name: "Pori",
    city: "Pori",
    country: "Finland",
    iata: "POR",
    icao: "EFPO",
    latitude: "61.461686",
    longitude: "21.799983",
    altitude: "44",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "449",
    name: "Pudasjarvi",
    city: "Pudasjarvi",
    country: "Finland",
    iata: "",
    icao: "EFPU",
    latitude: "65.402222",
    longitude: "26.946944",
    altitude: "397",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "450",
    name: "Pyhasalmi",
    city: "Pyhasalmi",
    country: "Finland",
    iata: "",
    icao: "EFPY",
    latitude: "63.731917",
    longitude: "25.926306",
    altitude: "528",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "451",
    name: "Raahe Pattijoki",
    city: "Pattijoki",
    country: "Finland",
    iata: "",
    icao: "EFRH",
    latitude: "64.688056",
    longitude: "24.695833",
    altitude: "118",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "452",
    name: "Rantasalmi",
    city: "Rantasalmi",
    country: "Finland",
    iata: "",
    icao: "EFRN",
    latitude: "62.065481",
    longitude: "28.356494",
    altitude: "292",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "453",
    name: "Rovaniemi",
    city: "Rovaniemi",
    country: "Finland",
    iata: "RVN",
    icao: "EFRO",
    latitude: "66.564822",
    longitude: "25.830411",
    altitude: "642",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "454",
    name: "Rayskala",
    city: "Rayskala",
    country: "Finland",
    iata: "",
    icao: "EFRY",
    latitude: "60.744722",
    longitude: "24.107778",
    altitude: "407",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "455",
    name: "Savonlinna",
    city: "Savonlinna",
    country: "Finland",
    iata: "SVL",
    icao: "EFSA",
    latitude: "61.943064",
    longitude: "28.945136",
    altitude: "311",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "456",
    name: "Selanpaa",
    city: "Selanpaa",
    country: "Finland",
    iata: "",
    icao: "EFSE",
    latitude: "61.062389",
    longitude: "26.798861",
    altitude: "417",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "457",
    name: "Sodankyla",
    city: "Sodankyla",
    country: "Finland",
    iata: "SOT",
    icao: "EFSO",
    latitude: "67.395033",
    longitude: "26.619133",
    altitude: "602",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "458",
    name: "Tampere Pirkkala",
    city: "Tampere",
    country: "Finland",
    iata: "TMP",
    icao: "EFTP",
    latitude: "61.414147",
    longitude: "23.604392",
    altitude: "390",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "459",
    name: "Teisko",
    city: "Teisko",
    country: "Finland",
    iata: "",
    icao: "EFTS",
    latitude: "61.77335",
    longitude: "24.027006",
    altitude: "515",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "460",
    name: "Turku",
    city: "Turku",
    country: "Finland",
    iata: "TKU",
    icao: "EFTU",
    latitude: "60.514142",
    longitude: "22.262808",
    altitude: "161",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "461",
    name: "Utti",
    city: "Utti",
    country: "Finland",
    iata: "QVY",
    icao: "EFUT",
    latitude: "60.896394",
    longitude: "26.938353",
    altitude: "339",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "462",
    name: "Vaasa",
    city: "Vaasa",
    country: "Finland",
    iata: "VAA",
    icao: "EFVA",
    latitude: "63.05065",
    longitude: "21.762175",
    altitude: "19",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "463",
    name: "Varkaus",
    city: "Varkaus",
    country: "Finland",
    iata: "VRK",
    icao: "EFVR",
    latitude: "62.171111",
    longitude: "27.868611",
    altitude: "286",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "464",
    name: "Ylivieska",
    city: "Ylivieska-raudaskyla",
    country: "Finland",
    iata: "",
    icao: "EFYL",
    latitude: "64.060547",
    longitude: "24.715953",
    altitude: "252",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "465",
    name: "Belfast Intl",
    city: "Belfast",
    country: "United Kingdom",
    iata: "BFS",
    icao: "EGAA",
    latitude: "54.6575",
    longitude: "-6.215833",
    altitude: "268",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "466",
    name: "St Angelo",
    city: "Enniskillen",
    country: "United Kingdom",
    iata: "ENK",
    icao: "EGAB",
    latitude: "54.398889",
    longitude: "-7.651667",
    altitude: "155",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "467",
    name: "Belfast City",
    city: "Belfast",
    country: "United Kingdom",
    iata: "BHD",
    icao: "EGAC",
    latitude: "54.618056",
    longitude: "-5.8725",
    altitude: "15",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "468",
    name: "City of Derry",
    city: "Londonderry",
    country: "United Kingdom",
    iata: "LDY",
    icao: "EGAE",
    latitude: "55.042778",
    longitude: "-7.161111",
    altitude: "22",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "469",
    name: "Birmingham",
    city: "Birmingham",
    country: "United Kingdom",
    iata: "BHX",
    icao: "EGBB",
    latitude: "52.453856",
    longitude: "-1.748028",
    altitude: "327",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "470",
    name: "Coventry",
    city: "Coventry",
    country: "United Kingdom",
    iata: "CVT",
    icao: "EGBE",
    latitude: "52.369722",
    longitude: "-1.479722",
    altitude: "267",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "471",
    name: "Leicester",
    city: "Leicester",
    country: "United Kingdom",
    iata: "",
    icao: "EGBG",
    latitude: "52.607778",
    longitude: "-1.031944",
    altitude: "469",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "472",
    name: "Gloucestershire",
    city: "Golouchestershire",
    country: "United Kingdom",
    iata: "GLO",
    icao: "EGBJ",
    latitude: "51.894167",
    longitude: "-2.167222",
    altitude: "101",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "474",
    name: "Wolverhampton",
    city: "Halfpenny Green",
    country: "United Kingdom",
    iata: "",
    icao: "EGBO",
    latitude: "52.5175",
    longitude: "-2.259444",
    altitude: "283",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "475",
    name: "Kemble",
    city: "Pailton",
    country: "United Kingdom",
    iata: "",
    icao: "EGBP",
    latitude: "51.668056",
    longitude: "-2.056944",
    altitude: "433",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "476",
    name: "Turweston",
    city: "Turweston",
    country: "United Kingdom",
    iata: "",
    icao: "EGBT",
    latitude: "52.040833",
    longitude: "-1.095556",
    altitude: "448",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "477",
    name: "Wellesbourne Mountford",
    city: "Wellesbourne",
    country: "United Kingdom",
    iata: "",
    icao: "EGBW",
    latitude: "52.192222",
    longitude: "-1.614444",
    altitude: "159",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "478",
    name: "Manchester",
    city: "Manchester",
    country: "United Kingdom",
    iata: "MAN",
    icao: "EGCC",
    latitude: "53.353744",
    longitude: "-2.27495",
    altitude: "257",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "479",
    name: "Manchester Woodford",
    city: "Woodfort",
    country: "United Kingdom",
    iata: "",
    icao: "EGCD",
    latitude: "53.338056",
    longitude: "-2.148889",
    altitude: "295",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "480",
    name: "Chivenor",
    city: "Chivenor",
    country: "United Kingdom",
    iata: "",
    icao: "EGDC",
    latitude: "51.087167",
    longitude: "-4.150339",
    altitude: "27",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "481",
    name: "St Mawgan",
    city: "Newquai",
    country: "United Kingdom",
    iata: "NQY",
    icao: "EGDG",
    latitude: "50.440558",
    longitude: "-4.995408",
    altitude: "390",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "482",
    name: "Lyneham",
    city: "Lyneham",
    country: "United Kingdom",
    iata: "LYE",
    icao: "EGDL",
    latitude: "51.505144",
    longitude: "-1.993428",
    altitude: "513",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "483",
    name: "Boscombe Down",
    city: "Boscombe Down",
    country: "United Kingdom",
    iata: "",
    icao: "EGDM",
    latitude: "51.152189",
    longitude: "-1.747414",
    altitude: "407",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "484",
    name: "Culdrose",
    city: "Culdrose",
    country: "United Kingdom",
    iata: "",
    icao: "EGDR",
    latitude: "50.086092",
    longitude: "-5.255711",
    altitude: "267",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "485",
    name: "St Athan",
    city: "St. Athan",
    country: "United Kingdom",
    iata: "",
    icao: "EGDX",
    latitude: "51.404811",
    longitude: "-3.43575",
    altitude: "163",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "486",
    name: "Yeovilton",
    city: "Yeovilton",
    country: "United Kingdom",
    iata: "YEO",
    icao: "EGDY",
    latitude: "51.009358",
    longitude: "-2.638819",
    altitude: "75",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "487",
    name: "Haverfordwest",
    city: "Haverfordwest",
    country: "United Kingdom",
    iata: "",
    icao: "EGFE",
    latitude: "51.833056",
    longitude: "-4.961111",
    altitude: "159",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "488",
    name: "Cardiff",
    city: "Cardiff",
    country: "United Kingdom",
    iata: "CWL",
    icao: "EGFF",
    latitude: "51.396667",
    longitude: "-3.343333",
    altitude: "220",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "489",
    name: "Swansea",
    city: "Swansea",
    country: "United Kingdom",
    iata: "SWS",
    icao: "EGFH",
    latitude: "51.605333",
    longitude: "-4.067833",
    altitude: "299",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "490",
    name: "Bristol",
    city: "Bristol",
    country: "United Kingdom",
    iata: "BRS",
    icao: "EGGD",
    latitude: "51.382669",
    longitude: "-2.719089",
    altitude: "622",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "491",
    name: "Liverpool",
    city: "Liverpool",
    country: "United Kingdom",
    iata: "LPL",
    icao: "EGGP",
    latitude: "53.333611",
    longitude: "-2.849722",
    altitude: "80",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "492",
    name: "Luton",
    city: "London",
    country: "United Kingdom",
    iata: "LTN",
    icao: "EGGW",
    latitude: "51.874722",
    longitude: "-0.368333",
    altitude: "526",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "493",
    name: "Plymouth",
    city: "Plymouth",
    country: "United Kingdom",
    iata: "PLH",
    icao: "EGHD",
    latitude: "50.422778",
    longitude: "-4.105833",
    altitude: "476",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "494",
    name: "Bournemouth",
    city: "Bournemouth",
    country: "United Kingdom",
    iata: "BOH",
    icao: "EGHH",
    latitude: "50.78",
    longitude: "-1.8425",
    altitude: "38",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "495",
    name: "Southampton",
    city: "Southampton",
    country: "United Kingdom",
    iata: "SOU",
    icao: "EGHI",
    latitude: "50.950261",
    longitude: "-1.356803",
    altitude: "44",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "496",
    name: "Lasham",
    city: "Lasham",
    country: "United Kingdom",
    iata: "QLA",
    icao: "EGHL",
    latitude: "51.187167",
    longitude: "-1.0335",
    altitude: "618",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "497",
    name: "Alderney",
    city: "Alderney",
    country: "Guernsey",
    iata: "ACI",
    icao: "EGJA",
    latitude: "49.706111",
    longitude: "-2.214722",
    altitude: "290",
    timezone: "0",
    dst: "E",
    tz: "Europe/Guernsey",
  },
  {
    id: "498",
    name: "Guernsey",
    city: "Guernsey",
    country: "Guernsey",
    iata: "GCI",
    icao: "EGJB",
    latitude: "49.434956",
    longitude: "-2.601969",
    altitude: "336",
    timezone: "0",
    dst: "E",
    tz: "Europe/Guernsey",
  },
  {
    id: "499",
    name: "Jersey",
    city: "Jersey",
    country: "Jersey",
    iata: "JER",
    icao: "EGJJ",
    latitude: "49.207947",
    longitude: "-2.195508",
    altitude: "277",
    timezone: "0",
    dst: "E",
    tz: "Europe/Jersey",
  },
  {
    id: "500",
    name: "Shoreham",
    city: "Shoreham By Sea",
    country: "United Kingdom",
    iata: "ESH",
    icao: "EGKA",
    latitude: "50.835556",
    longitude: "-0.297222",
    altitude: "7",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "501",
    name: "Biggin Hill",
    city: "Biggin Hill",
    country: "United Kingdom",
    iata: "BQH",
    icao: "EGKB",
    latitude: "51.330833",
    longitude: "0.0325",
    altitude: "598",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "502",
    name: "Gatwick",
    city: "London",
    country: "United Kingdom",
    iata: "LGW",
    icao: "EGKK",
    latitude: "51.148056",
    longitude: "-0.190278",
    altitude: "202",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "503",
    name: "City",
    city: "London",
    country: "United Kingdom",
    iata: "LCY",
    icao: "EGLC",
    latitude: "51.505278",
    longitude: "0.055278",
    altitude: "19",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "504",
    name: "Farnborough",
    city: "Farnborough",
    country: "United Kingdom",
    iata: "FAB",
    icao: "EGLF",
    latitude: "51.275833",
    longitude: "-0.776333",
    altitude: "238",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "505",
    name: "Chalgrove",
    city: "Chalsgrove",
    country: "United Kingdom",
    iata: "",
    icao: "EGLJ",
    latitude: "51.676111",
    longitude: "-1.080833",
    altitude: "240",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "506",
    name: "Blackbushe",
    city: "Blackbushe",
    country: "United Kingdom",
    iata: "BBS",
    icao: "EGLK",
    latitude: "51.323889",
    longitude: "-0.8475",
    altitude: "325",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "507",
    name: "Heathrow",
    city: "London",
    country: "United Kingdom",
    iata: "LHR",
    icao: "EGLL",
    latitude: "51.4775",
    longitude: "-0.461389",
    altitude: "83",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "508",
    name: "Southend",
    city: "Southend",
    country: "United Kingdom",
    iata: "SEN",
    icao: "EGMC",
    latitude: "51.571389",
    longitude: "0.695556",
    altitude: "49",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "509",
    name: "Lydd",
    city: "Lydd",
    country: "United Kingdom",
    iata: "LYX",
    icao: "EGMD",
    latitude: "50.956111",
    longitude: "0.939167",
    altitude: "13",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "510",
    name: "Manston",
    city: "Manston",
    country: "United Kingdom",
    iata: "MSE",
    icao: "EGMH",
    latitude: "51.342222",
    longitude: "1.346111",
    altitude: "178",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "511",
    name: "Brough",
    city: "Brough",
    country: "United Kingdom",
    iata: "",
    icao: "EGNB",
    latitude: "53.719667",
    longitude: "-0.566333",
    altitude: "12",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "512",
    name: "Carlisle",
    city: "Carlisle",
    country: "United Kingdom",
    iata: "CAX",
    icao: "EGNC",
    latitude: "54.9375",
    longitude: "-2.809167",
    altitude: "190",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "513",
    name: "Gamston",
    city: "Repton",
    country: "United Kingdom",
    iata: "",
    icao: "EGNE",
    latitude: "53.280556",
    longitude: "-0.951389",
    altitude: "91",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "514",
    name: "Blackpool",
    city: "Blackpool",
    country: "United Kingdom",
    iata: "BLK",
    icao: "EGNH",
    latitude: "53.771667",
    longitude: "-3.028611",
    altitude: "34",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "515",
    name: "Humberside",
    city: "Humberside",
    country: "United Kingdom",
    iata: "HUY",
    icao: "EGNJ",
    latitude: "53.574444",
    longitude: "-0.350833",
    altitude: "121",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "516",
    name: "Walney Island",
    city: "Barrow Island",
    country: "United Kingdom",
    iata: "BWF",
    icao: "EGNL",
    latitude: "54.131167",
    longitude: "-3.263667",
    altitude: "173",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "517",
    name: "Leeds Bradford",
    city: "Leeds",
    country: "United Kingdom",
    iata: "LBA",
    icao: "EGNM",
    latitude: "53.865897",
    longitude: "-1.660569",
    altitude: "681",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "518",
    name: "Warton",
    city: "Warton",
    country: "United Kingdom",
    iata: "",
    icao: "EGNO",
    latitude: "53.745097",
    longitude: "-2.883061",
    altitude: "55",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "519",
    name: "Hawarden",
    city: "Hawarden",
    country: "United Kingdom",
    iata: "CEG",
    icao: "EGNR",
    latitude: "53.178056",
    longitude: "-2.977778",
    altitude: "45",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "520",
    name: "Isle Of Man",
    city: "Isle Of Man",
    country: "Isle of Man",
    iata: "IOM",
    icao: "EGNS",
    latitude: "54.083333",
    longitude: "-4.623889",
    altitude: "52",
    timezone: "0",
    dst: "E",
    tz: "Europe/Isle_of_Man",
  },
  {
    id: "521",
    name: "Newcastle",
    city: "Newcastle",
    country: "United Kingdom",
    iata: "NCL",
    icao: "EGNT",
    latitude: "55.0375",
    longitude: "-1.691667",
    altitude: "266",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "522",
    name: "Durham Tees Valley Airport",
    city: "Teesside",
    country: "United Kingdom",
    iata: "MME",
    icao: "EGNV",
    latitude: "54.509189",
    longitude: "-1.429406",
    altitude: "120",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "523",
    name: "Nottingham East Midlands",
    city: "East Midlands",
    country: "United Kingdom",
    iata: "EMA",
    icao: "EGNX",
    latitude: "52.831111",
    longitude: "-1.328056",
    altitude: "306",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "524",
    name: "Llanbedr",
    city: "Llanbedr",
    country: "United Kingdom",
    iata: "",
    icao: "EGOD",
    latitude: "52.811744",
    longitude: "-4.123575",
    altitude: "30",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "525",
    name: "Ternhill",
    city: "Ternhill",
    country: "United Kingdom",
    iata: "",
    icao: "EGOE",
    latitude: "52.871164",
    longitude: "-2.533561",
    altitude: "272",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "526",
    name: "Shawbury",
    city: "Shawbury",
    country: "United Kingdom",
    iata: "",
    icao: "EGOS",
    latitude: "52.798169",
    longitude: "-2.668042",
    altitude: "249",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "528",
    name: "Woodvale",
    city: "Woodvale",
    country: "United Kingdom",
    iata: "",
    icao: "EGOW",
    latitude: "53.581575",
    longitude: "-3.055522",
    altitude: "37",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "529",
    name: "Kirkwall",
    city: "Kirkwall",
    country: "United Kingdom",
    iata: "KOI",
    icao: "EGPA",
    latitude: "58.957778",
    longitude: "-2.905",
    altitude: "50",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "530",
    name: "Sumburgh",
    city: "Sumburgh",
    country: "United Kingdom",
    iata: "LSI",
    icao: "EGPB",
    latitude: "59.878889",
    longitude: "-1.295556",
    altitude: "20",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "531",
    name: "Wick",
    city: "Wick",
    country: "United Kingdom",
    iata: "WIC",
    icao: "EGPC",
    latitude: "58.458889",
    longitude: "-3.093056",
    altitude: "126",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "532",
    name: "Dyce",
    city: "Aberdeen",
    country: "United Kingdom",
    iata: "ABZ",
    icao: "EGPD",
    latitude: "57.201944",
    longitude: "-2.197778",
    altitude: "215",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "533",
    name: "Inverness",
    city: "Inverness",
    country: "United Kingdom",
    iata: "INV",
    icao: "EGPE",
    latitude: "57.5425",
    longitude: "-4.0475",
    altitude: "31",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "534",
    name: "Glasgow",
    city: "Glasgow",
    country: "United Kingdom",
    iata: "GLA",
    icao: "EGPF",
    latitude: "55.871944",
    longitude: "-4.433056",
    altitude: "26",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "535",
    name: "Edinburgh",
    city: "Edinburgh",
    country: "United Kingdom",
    iata: "EDI",
    icao: "EGPH",
    latitude: "55.95",
    longitude: "-3.3725",
    altitude: "135",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "536",
    name: "Islay",
    city: "Islay",
    country: "United Kingdom",
    iata: "ILY",
    icao: "EGPI",
    latitude: "55.681944",
    longitude: "-6.256667",
    altitude: "56",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "537",
    name: "Prestwick",
    city: "Prestwick",
    country: "United Kingdom",
    iata: "PIK",
    icao: "EGPK",
    latitude: "55.509444",
    longitude: "-4.586667",
    altitude: "65",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "538",
    name: "Benbecula",
    city: "Benbecula",
    country: "United Kingdom",
    iata: "BEB",
    icao: "EGPL",
    latitude: "57.481111",
    longitude: "-7.362778",
    altitude: "19",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "539",
    name: "Scatsta",
    city: "Scatsta",
    country: "United Kingdom",
    iata: "SDZ",
    icao: "EGPM",
    latitude: "60.432778",
    longitude: "-1.296111",
    altitude: "81",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "540",
    name: "Dundee",
    city: "Dundee",
    country: "United Kingdom",
    iata: "DND",
    icao: "EGPN",
    latitude: "56.452499",
    longitude: "-3.025833",
    altitude: "17",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "541",
    name: "Stornoway",
    city: "Stornoway",
    country: "United Kingdom",
    iata: "SYY",
    icao: "EGPO",
    latitude: "58.215556",
    longitude: "-6.331111",
    altitude: "26",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "542",
    name: "Tiree",
    city: "Tiree",
    country: "United Kingdom",
    iata: "TRE",
    icao: "EGPU",
    latitude: "56.499167",
    longitude: "-6.869167",
    altitude: "38",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "543",
    name: "Leuchars",
    city: "Leuchars",
    country: "United Kingdom",
    iata: "ADX",
    icao: "EGQL",
    latitude: "56.372889",
    longitude: "-2.868444",
    altitude: "38",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "544",
    name: "Lossiemouth",
    city: "Lossiemouth",
    country: "United Kingdom",
    iata: "LMO",
    icao: "EGQS",
    latitude: "57.705214",
    longitude: "-3.339169",
    altitude: "42",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "545",
    name: "Cambridge",
    city: "Cambridge",
    country: "United Kingdom",
    iata: "CBG",
    icao: "EGSC",
    latitude: "52.205",
    longitude: "0.175",
    altitude: "47",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "546",
    name: "Conington",
    city: "Peterborough",
    country: "United Kingdom",
    iata: "",
    icao: "EGSF",
    latitude: "52.468056",
    longitude: "-0.251111",
    altitude: "26",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "547",
    name: "Norwich",
    city: "Norwich",
    country: "United Kingdom",
    iata: "NWI",
    icao: "EGSH",
    latitude: "52.675833",
    longitude: "1.282778",
    altitude: "117",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "548",
    name: "Stansted",
    city: "London",
    country: "United Kingdom",
    iata: "STN",
    icao: "EGSS",
    latitude: "51.885",
    longitude: "0.235",
    altitude: "348",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "549",
    name: "North Weald",
    city: "North Weald",
    country: "United Kingdom",
    iata: "",
    icao: "EGSX",
    latitude: "51.721667",
    longitude: "0.154167",
    altitude: "321",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "550",
    name: "Sheffield City",
    city: "Fowlmere",
    country: "United Kingdom",
    iata: "",
    icao: "EGSY",
    latitude: "53.394256",
    longitude: "-1.388486",
    altitude: "231",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "551",
    name: "Cranfield",
    city: "Cranfield",
    country: "United Kingdom",
    iata: "",
    icao: "EGTC",
    latitude: "52.072222",
    longitude: "-0.616667",
    altitude: "358",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "552",
    name: "Exeter",
    city: "Exeter",
    country: "United Kingdom",
    iata: "EXT",
    icao: "EGTE",
    latitude: "50.734444",
    longitude: "-3.413889",
    altitude: "102",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "553",
    name: "Bristol Filton",
    city: "Bristol",
    country: "United Kingdom",
    iata: "FZO",
    icao: "EGTG",
    latitude: "51.519444",
    longitude: "-2.590833",
    altitude: "226",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "554",
    name: "Kidlington",
    city: "Oxford",
    country: "United Kingdom",
    iata: "OXF",
    icao: "EGTK",
    latitude: "51.836944",
    longitude: "-1.32",
    altitude: "270",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "555",
    name: "Benson",
    city: "Benson",
    country: "United Kingdom",
    iata: "",
    icao: "EGUB",
    latitude: "51.616389",
    longitude: "-1.095833",
    altitude: "226",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "556",
    name: "Lakenheath",
    city: "Lakenheath",
    country: "United Kingdom",
    iata: "",
    icao: "EGUL",
    latitude: "52.409333",
    longitude: "0.561",
    altitude: "32",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "557",
    name: "Mildenhall",
    city: "Mildenhall",
    country: "United Kingdom",
    iata: "MHZ",
    icao: "EGUN",
    latitude: "52.361933",
    longitude: "0.486406",
    altitude: "33",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "558",
    name: "Wattisham",
    city: "Wattisham",
    country: "United Kingdom",
    iata: "",
    icao: "EGUW",
    latitude: "52.127283",
    longitude: "0.956264",
    altitude: "284",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "559",
    name: "Wyton",
    city: "Wyton",
    country: "United Kingdom",
    iata: "",
    icao: "EGUY",
    latitude: "52.357167",
    longitude: "-0.107833",
    altitude: "135",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "560",
    name: "Fairford",
    city: "Fairford",
    country: "United Kingdom",
    iata: "FFD",
    icao: "EGVA",
    latitude: "51.682167",
    longitude: "-1.790028",
    altitude: "286",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "561",
    name: "Brize Norton",
    city: "Brize Norton",
    country: "United Kingdom",
    iata: "BZZ",
    icao: "EGVN",
    latitude: "51.749964",
    longitude: "-1.583617",
    altitude: "288",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "562",
    name: "Odiham",
    city: "Odiham",
    country: "United Kingdom",
    iata: "ODH",
    icao: "EGVO",
    latitude: "51.234139",
    longitude: "-0.942825",
    altitude: "405",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "563",
    name: "Cosford",
    city: "Cosford",
    country: "United Kingdom",
    iata: "",
    icao: "EGWC",
    latitude: "52.640028",
    longitude: "-2.305578",
    altitude: "272",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "564",
    name: "Northolt",
    city: "Northolt",
    country: "United Kingdom",
    iata: "NHT",
    icao: "EGWU",
    latitude: "51.553",
    longitude: "-0.418167",
    altitude: "124",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "565",
    name: "Coningsby",
    city: "Coningsby",
    country: "United Kingdom",
    iata: "QCY",
    icao: "EGXC",
    latitude: "53.093014",
    longitude: "-0.166014",
    altitude: "25",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "566",
    name: "Dishforth",
    city: "Dishforth",
    country: "United Kingdom",
    iata: "",
    icao: "EGXD",
    latitude: "54.137186",
    longitude: "-1.420253",
    altitude: "117",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "567",
    name: "Leeming",
    city: "Leeming",
    country: "United Kingdom",
    iata: "",
    icao: "EGXE",
    latitude: "54.292383",
    longitude: "-1.5354",
    altitude: "132",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "568",
    name: "Church Fenton",
    city: "Church Fenton",
    country: "United Kingdom",
    iata: "",
    icao: "EGXG",
    latitude: "53.834333",
    longitude: "-1.1955",
    altitude: "29",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "569",
    name: "Honington",
    city: "Honington",
    country: "United Kingdom",
    iata: "BEQ",
    icao: "EGXH",
    latitude: "52.342611",
    longitude: "0.772939",
    altitude: "174",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "570",
    name: "Cottesmore",
    city: "Cottesmore",
    country: "United Kingdom",
    iata: "",
    icao: "EGXJ",
    latitude: "52.735711",
    longitude: "-0.648769",
    altitude: "461",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "571",
    name: "Scampton",
    city: "Scampton",
    country: "United Kingdom",
    iata: "",
    icao: "EGXP",
    latitude: "53.307778",
    longitude: "-0.550833",
    altitude: "202",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "572",
    name: "Wittering",
    city: "Wittering",
    country: "United Kingdom",
    iata: "",
    icao: "EGXT",
    latitude: "52.612558",
    longitude: "-0.476453",
    altitude: "273",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "573",
    name: "Linton On Ouse",
    city: "Linton-on-ouse",
    country: "United Kingdom",
    iata: "",
    icao: "EGXU",
    latitude: "54.048911",
    longitude: "-1.252747",
    altitude: "53",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "574",
    name: "Waddington",
    city: "Waddington",
    country: "United Kingdom",
    iata: "WTN",
    icao: "EGXW",
    latitude: "53.166167",
    longitude: "-0.523811",
    altitude: "231",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "575",
    name: "Topcliffe",
    city: "Topcliffe",
    country: "United Kingdom",
    iata: "",
    icao: "EGXZ",
    latitude: "54.205522",
    longitude: "-1.382094",
    altitude: "92",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "576",
    name: "Cranwell",
    city: "Cranwell",
    country: "United Kingdom",
    iata: "",
    icao: "EGYD",
    latitude: "53.03035",
    longitude: "-0.483242",
    altitude: "218",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "577",
    name: "Barkston Heath",
    city: "Barkston Heath",
    country: "United Kingdom",
    iata: "",
    icao: "EGYE",
    latitude: "52.962225",
    longitude: "-0.561625",
    altitude: "367",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "578",
    name: "Marham",
    city: "Marham",
    country: "United Kingdom",
    iata: "KNF",
    icao: "EGYM",
    latitude: "52.648353",
    longitude: "0.550692",
    altitude: "75",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "579",
    name: "Mount Pleasant",
    city: "Mount Pleasant",
    country: "Falkland Islands",
    iata: "MPN",
    icao: "EGYP",
    latitude: "-51.822777",
    longitude: "-58.447222",
    altitude: "244",
    timezone: "-3",
    dst: "U",
    tz: "Atlantic/Stanley",
  },
  {
    id: "580",
    name: "Schiphol",
    city: "Amsterdam",
    country: "Netherlands",
    iata: "AMS",
    icao: "EHAM",
    latitude: "52.308613",
    longitude: "4.763889",
    altitude: "-11",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "581",
    name: "Budel",
    city: "Weert",
    country: "Netherlands",
    iata: "",
    icao: "EHBD",
    latitude: "51.25528",
    longitude: "5.601389",
    altitude: "114",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "582",
    name: "Maastricht",
    city: "Maastricht",
    country: "Netherlands",
    iata: "MST",
    icao: "EHBK",
    latitude: "50.911658",
    longitude: "5.770144",
    altitude: "375",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "583",
    name: "Deelen",
    city: "Deelen",
    country: "Netherlands",
    iata: "",
    icao: "EHDL",
    latitude: "52.060556",
    longitude: "5.873056",
    altitude: "158",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "584",
    name: "Drachten",
    city: "Drachten",
    country: "Netherlands",
    iata: "",
    icao: "EHDR",
    latitude: "53.119167",
    longitude: "6.129722",
    altitude: "14",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "585",
    name: "Eindhoven",
    city: "Eindhoven",
    country: "Netherlands",
    iata: "EIN",
    icao: "EHEH",
    latitude: "51.450139",
    longitude: "5.374528",
    altitude: "74",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "586",
    name: "Eelde",
    city: "Groningen",
    country: "Netherlands",
    iata: "GRQ",
    icao: "EHGG",
    latitude: "53.11972",
    longitude: "6.579444",
    altitude: "17",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "587",
    name: "Gilze Rijen",
    city: "Gilze-rijen",
    country: "Netherlands",
    iata: "",
    icao: "EHGR",
    latitude: "51.567389",
    longitude: "4.931833",
    altitude: "49",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "588",
    name: "De Kooy",
    city: "De Kooy",
    country: "Netherlands",
    iata: "DHR",
    icao: "EHKD",
    latitude: "52.923353",
    longitude: "4.780625",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "589",
    name: "Lelystad",
    city: "Lelystad",
    country: "Netherlands",
    iata: "",
    icao: "EHLE",
    latitude: "52.460278",
    longitude: "5.527222",
    altitude: "-13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "590",
    name: "Leeuwarden",
    city: "Leeuwarden",
    country: "Netherlands",
    iata: "LWR",
    icao: "EHLW",
    latitude: "53.228611",
    longitude: "5.760556",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "591",
    name: "Rotterdam",
    city: "Rotterdam",
    country: "Netherlands",
    iata: "RTM",
    icao: "EHRD",
    latitude: "51.956944",
    longitude: "4.437222",
    altitude: "-15",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "592",
    name: "Soesterberg",
    city: "Soesterberg",
    country: "Netherlands",
    iata: "UTC",
    icao: "EHSB",
    latitude: "52.1273",
    longitude: "5.27619",
    altitude: "66",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "593",
    name: "Twenthe",
    city: "Enschede",
    country: "Netherlands",
    iata: "ENS",
    icao: "EHTW",
    latitude: "52.27",
    longitude: "6.874167",
    altitude: "114",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "594",
    name: "Valkenburg",
    city: "Valkenburg",
    country: "Netherlands",
    iata: "LID",
    icao: "EHVB",
    latitude: "52.166139",
    longitude: "4.417944",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "595",
    name: "Woensdrecht",
    city: "Woensdrecht",
    country: "Netherlands",
    iata: "WOE",
    icao: "EHWO",
    latitude: "51.449092",
    longitude: "4.342031",
    altitude: "63",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "596",
    name: "Cork",
    city: "Cork",
    country: "Ireland",
    iata: "ORK",
    icao: "EICK",
    latitude: "51.841269",
    longitude: "-8.491111",
    altitude: "502",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "597",
    name: "Galway",
    city: "Galway",
    country: "Ireland",
    iata: "GWY",
    icao: "EICM",
    latitude: "53.300175",
    longitude: "-8.941592",
    altitude: "81",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "599",
    name: "Dublin",
    city: "Dublin",
    country: "Ireland",
    iata: "DUB",
    icao: "EIDW",
    latitude: "53.421333",
    longitude: "-6.270075",
    altitude: "242",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "600",
    name: "Ireland West Knock",
    city: "Connaught",
    country: "Ireland",
    iata: "NOC",
    icao: "EIKN",
    latitude: "53.910297",
    longitude: "-8.818492",
    altitude: "665",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "601",
    name: "Kerry",
    city: "Kerry",
    country: "Ireland",
    iata: "KIR",
    icao: "EIKY",
    latitude: "52.180878",
    longitude: "-9.523783",
    altitude: "112",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "602",
    name: "Casement",
    city: "Casement",
    country: "Ireland",
    iata: "",
    icao: "EIME",
    latitude: "53.301667",
    longitude: "-6.451333",
    altitude: "319",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "603",
    name: "Shannon",
    city: "Shannon",
    country: "Ireland",
    iata: "SNN",
    icao: "EINN",
    latitude: "52.701978",
    longitude: "-8.924817",
    altitude: "46",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "604",
    name: "Sligo",
    city: "Sligo",
    country: "Ireland",
    iata: "SXL",
    icao: "EISG",
    latitude: "54.280214",
    longitude: "-8.599206",
    altitude: "11",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "605",
    name: "Waterford",
    city: "Waterford",
    country: "Ireland",
    iata: "WAT",
    icao: "EIWF",
    latitude: "52.1872",
    longitude: "-7.086964",
    altitude: "119",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "607",
    name: "Aarhus",
    city: "Aarhus",
    country: "Denmark",
    iata: "AAR",
    icao: "EKAH",
    latitude: "56.300017",
    longitude: "10.619008",
    altitude: "82",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "608",
    name: "Billund",
    city: "Billund",
    country: "Denmark",
    iata: "BLL",
    icao: "EKBI",
    latitude: "55.740322",
    longitude: "9.151778",
    altitude: "247",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "609",
    name: "Kastrup",
    city: "Copenhagen",
    country: "Denmark",
    iata: "CPH",
    icao: "EKCH",
    latitude: "55.617917",
    longitude: "12.655972",
    altitude: "17",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "610",
    name: "Esbjerg",
    city: "Esbjerg",
    country: "Denmark",
    iata: "EBJ",
    icao: "EKEB",
    latitude: "55.525942",
    longitude: "8.553403",
    altitude: "97",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "611",
    name: "Gronholt Hillerod",
    city: "Gronholt",
    country: "Denmark",
    iata: "",
    icao: "EKGH",
    latitude: "55.941387",
    longitude: "12.382222",
    altitude: "97",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "612",
    name: "Karup",
    city: "Karup",
    country: "Denmark",
    iata: "KRP",
    icao: "EKKA",
    latitude: "56.297458",
    longitude: "9.124628",
    altitude: "170",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "613",
    name: "Laeso",
    city: "Laeso",
    country: "Denmark",
    iata: "",
    icao: "EKLS",
    latitude: "57.277228",
    longitude: "11.000083",
    altitude: "25",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "614",
    name: "Lolland Falster Maribo",
    city: "Maribo",
    country: "Denmark",
    iata: "",
    icao: "EKMB",
    latitude: "54.699344",
    longitude: "11.440117",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "615",
    name: "Odense",
    city: "Odense",
    country: "Denmark",
    iata: "ODE",
    icao: "EKOD",
    latitude: "55.476664",
    longitude: "10.330933",
    altitude: "56",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "616",
    name: "Krusa Padborg",
    city: "Krusa-padborg",
    country: "Denmark",
    iata: "",
    icao: "EKPB",
    latitude: "54.870306",
    longitude: "9.279014",
    altitude: "88",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "617",
    name: "Roskilde",
    city: "Copenhagen",
    country: "Denmark",
    iata: "RKE",
    icao: "EKRK",
    latitude: "55.585567",
    longitude: "12.131428",
    altitude: "146",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "618",
    name: "Bornholm Ronne",
    city: "Ronne",
    country: "Denmark",
    iata: "RNN",
    icao: "EKRN",
    latitude: "55.063267",
    longitude: "14.759558",
    altitude: "52",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "619",
    name: "Sonderborg",
    city: "Soenderborg",
    country: "Denmark",
    iata: "SGD",
    icao: "EKSB",
    latitude: "54.964367",
    longitude: "9.791731",
    altitude: "24",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "621",
    name: "Skrydstrup",
    city: "Skrydstrup",
    country: "Denmark",
    iata: "SKS",
    icao: "EKSP",
    latitude: "55.225553",
    longitude: "9.263931",
    altitude: "141",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "622",
    name: "Skive",
    city: "Skive",
    country: "Denmark",
    iata: "",
    icao: "EKSV",
    latitude: "56.550208",
    longitude: "9.172983",
    altitude: "74",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "623",
    name: "Thisted",
    city: "Thisted",
    country: "Denmark",
    iata: "TED",
    icao: "EKTS",
    latitude: "57.0688",
    longitude: "8.705225",
    altitude: "23",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "624",
    name: "Kolding Vamdrup",
    city: "Kolding",
    country: "Denmark",
    iata: "",
    icao: "EKVD",
    latitude: "55.436283",
    longitude: "9.330925",
    altitude: "143",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "625",
    name: "Vagar",
    city: "Vagar",
    country: "Faroe Islands",
    iata: "FAE",
    icao: "EKVG",
    latitude: "62.063628",
    longitude: "-7.277219",
    altitude: "280",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Faeroe",
  },
  {
    id: "626",
    name: "Aars",
    city: "Vesthimmerland",
    country: "Denmark",
    iata: "",
    icao: "EKVH",
    latitude: "56.846944",
    longitude: "9.458611",
    altitude: "119",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "627",
    name: "Stauning",
    city: "Stauning",
    country: "Denmark",
    iata: "STA",
    icao: "EKVJ",
    latitude: "55.990122",
    longitude: "8.353906",
    altitude: "17",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "628",
    name: "Aalborg",
    city: "Aalborg",
    country: "Denmark",
    iata: "AAL",
    icao: "EKYT",
    latitude: "57.092789",
    longitude: "9.849164",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "629",
    name: "Luxembourg",
    city: "Luxemburg",
    country: "Luxembourg",
    iata: "LUX",
    icao: "ELLX",
    latitude: "49.626575",
    longitude: "6.211517",
    altitude: "1234",
    timezone: "1",
    dst: "E",
    tz: "Europe/Luxembourg",
  },
  {
    id: "630",
    name: "Vigra",
    city: "Alesund",
    country: "Norway",
    iata: "AES",
    icao: "ENAL",
    latitude: "62.560372",
    longitude: "6.110164",
    altitude: "69",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "631",
    name: "Andenes",
    city: "Andoya",
    country: "Norway",
    iata: "ANX",
    icao: "ENAN",
    latitude: "69.2925",
    longitude: "16.144167",
    altitude: "43",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "632",
    name: "Alta",
    city: "Alta",
    country: "Norway",
    iata: "ALF",
    icao: "ENAT",
    latitude: "69.976111",
    longitude: "23.371667",
    altitude: "9",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "633",
    name: "Bomoen",
    city: "Voss",
    country: "Norway",
    iata: "",
    icao: "ENBM",
    latitude: "60.63885",
    longitude: "6.501497",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "634",
    name: "Bronnoy",
    city: "Bronnoysund",
    country: "Norway",
    iata: "BNN",
    icao: "ENBN",
    latitude: "65.461111",
    longitude: "12.2175",
    altitude: "25",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "635",
    name: "Bodo",
    city: "Bodo",
    country: "Norway",
    iata: "BOO",
    icao: "ENBO",
    latitude: "67.269167",
    longitude: "14.365278",
    altitude: "42",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "636",
    name: "Flesland",
    city: "Bergen",
    country: "Norway",
    iata: "BGO",
    icao: "ENBR",
    latitude: "60.293386",
    longitude: "5.218142",
    altitude: "170",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "637",
    name: "Batsfjord",
    city: "Batsfjord",
    country: "Norway",
    iata: "BJF",
    icao: "ENBS",
    latitude: "70.600278",
    longitude: "29.6925",
    altitude: "490",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "638",
    name: "Kjevik",
    city: "Kristiansand",
    country: "Norway",
    iata: "KRS",
    icao: "ENCN",
    latitude: "58.204214",
    longitude: "8.085369",
    altitude: "57",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "639",
    name: "Dagali",
    city: "Geilo",
    country: "Norway",
    iata: "",
    icao: "ENDI",
    latitude: "60.416667",
    longitude: "8.512778",
    altitude: "2618",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "640",
    name: "Bardufoss",
    city: "Bardufoss",
    country: "Norway",
    iata: "BDU",
    icao: "ENDU",
    latitude: "69.055758",
    longitude: "18.540356",
    altitude: "252",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "641",
    name: "Evenes",
    city: "Harstad/Narvik",
    country: "Norway",
    iata: "EVE",
    icao: "ENEV",
    latitude: "68.4913",
    longitude: "16.678108",
    altitude: "84",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "642",
    name: "Leirin",
    city: "Fagernes",
    country: "Norway",
    iata: "VDB",
    icao: "ENFG",
    latitude: "61.015556",
    longitude: "9.288056",
    altitude: "2697",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "643",
    name: "Floro",
    city: "Floro",
    country: "Norway",
    iata: "FRO",
    icao: "ENFL",
    latitude: "61.583611",
    longitude: "5.024722",
    altitude: "37",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "644",
    name: "Gardermoen",
    city: "Oslo",
    country: "Norway",
    iata: "OSL",
    icao: "ENGM",
    latitude: "60.193917",
    longitude: "11.100361",
    altitude: "681",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "645",
    name: "Karmoy",
    city: "Haugesund",
    country: "Norway",
    iata: "HAU",
    icao: "ENHD",
    latitude: "59.345267",
    longitude: "5.208364",
    altitude: "86",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "646",
    name: "Hasvik",
    city: "Hasvik",
    country: "Norway",
    iata: "HAA",
    icao: "ENHK",
    latitude: "70.486675",
    longitude: "22.139744",
    altitude: "21",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "647",
    name: "Kvernberget",
    city: "Kristiansund",
    country: "Norway",
    iata: "KSU",
    icao: "ENKB",
    latitude: "63.111781",
    longitude: "7.824522",
    altitude: "204",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "648",
    name: "Kjeller",
    city: "Kjeller",
    country: "Norway",
    iata: "",
    icao: "ENKJ",
    latitude: "59.969336",
    longitude: "11.036089",
    altitude: "354",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "649",
    name: "Hoybuktmoen",
    city: "Kirkenes",
    country: "Norway",
    iata: "KKN",
    icao: "ENKR",
    latitude: "69.725781",
    longitude: "29.891295",
    altitude: "283",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "650",
    name: "Lista",
    city: "Farsund",
    country: "Norway",
    iata: "FAN",
    icao: "ENLI",
    latitude: "58.099486",
    longitude: "6.62605",
    altitude: "29",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "651",
    name: "Aro",
    city: "Molde",
    country: "Norway",
    iata: "MOL",
    icao: "ENML",
    latitude: "62.744722",
    longitude: "7.2625",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "652",
    name: "Kjaerstad",
    city: "Mosjoen",
    country: "Norway",
    iata: "MJF",
    icao: "ENMS",
    latitude: "65.783997",
    longitude: "13.214914",
    altitude: "237",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "653",
    name: "Banak",
    city: "Lakselv",
    country: "Norway",
    iata: "LKL",
    icao: "ENNA",
    latitude: "70.068814",
    longitude: "24.973489",
    altitude: "25",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "654",
    name: "Notodden",
    city: "Notodden",
    country: "Norway",
    iata: "NTB",
    icao: "ENNO",
    latitude: "59.565683",
    longitude: "9.212222",
    altitude: "63",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "655",
    name: "Orland",
    city: "Orland",
    country: "Norway",
    iata: "OLA",
    icao: "ENOL",
    latitude: "63.698908",
    longitude: "9.604003",
    altitude: "28",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "656",
    name: "Roros",
    city: "Roros",
    country: "Norway",
    iata: "RRS",
    icao: "ENRO",
    latitude: "62.578411",
    longitude: "11.342347",
    altitude: "2054",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "657",
    name: "Moss",
    city: "Rygge",
    country: "Norway",
    iata: "RYG",
    icao: "ENRY",
    latitude: "59.378933",
    longitude: "10.785389",
    altitude: "174",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "658",
    name: "Longyear",
    city: "Svalbard",
    country: "Norway",
    iata: "LYR",
    icao: "ENSB",
    latitude: "78.246111",
    longitude: "15.465556",
    altitude: "88",
    timezone: "1",
    dst: "E",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "659",
    name: "Geiteryggen",
    city: "Skien",
    country: "Norway",
    iata: "SKE",
    icao: "ENSN",
    latitude: "59.185",
    longitude: "9.566944",
    altitude: "463",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "660",
    name: "Sorstokken",
    city: "Stord",
    country: "Norway",
    iata: "SRP",
    icao: "ENSO",
    latitude: "59.791925",
    longitude: "5.34085",
    altitude: "160",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "662",
    name: "Stokka",
    city: "Sandnessjoen",
    country: "Norway",
    iata: "SSJ",
    icao: "ENST",
    latitude: "65.956828",
    longitude: "12.468944",
    altitude: "56",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "663",
    name: "Langnes",
    city: "Tromso",
    country: "Norway",
    iata: "TOS",
    icao: "ENTC",
    latitude: "69.683333",
    longitude: "18.918919",
    altitude: "31",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "664",
    name: "Torp",
    city: "Sandefjord",
    country: "Norway",
    iata: "TRF",
    icao: "ENTO",
    latitude: "59.186703",
    longitude: "10.258628",
    altitude: "286",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "665",
    name: "Vaernes",
    city: "Trondheim",
    country: "Norway",
    iata: "TRD",
    icao: "ENVA",
    latitude: "63.457556",
    longitude: "10.92425",
    altitude: "56",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "666",
    name: "Sola",
    city: "Stavanger",
    country: "Norway",
    iata: "SVG",
    icao: "ENZV",
    latitude: "58.876778",
    longitude: "5.637856",
    altitude: "29",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "667",
    name: "Babice",
    city: "Warsaw",
    country: "Poland",
    iata: "",
    icao: "EPBC",
    latitude: "52.268494",
    longitude: "20.911047",
    altitude: "352",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "668",
    name: "Lech Walesa",
    city: "Gdansk",
    country: "Poland",
    iata: "GDN",
    icao: "EPGD",
    latitude: "54.377569",
    longitude: "18.466222",
    altitude: "489",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "669",
    name: "Balice",
    city: "Krakow",
    country: "Poland",
    iata: "KRK",
    icao: "EPKK",
    latitude: "50.077731",
    longitude: "19.784836",
    altitude: "791",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "670",
    name: "Muchowiec",
    city: "Katowice",
    country: "Poland",
    iata: "",
    icao: "EPKM",
    latitude: "50.238147",
    longitude: "19.034181",
    altitude: "909",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "671",
    name: "Pyrzowice",
    city: "Katowice",
    country: "Poland",
    iata: "KTW",
    icao: "EPKT",
    latitude: "50.474253",
    longitude: "19.080019",
    altitude: "995",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "673",
    name: "Mielec",
    city: "Mielec",
    country: "Poland",
    iata: "",
    icao: "EPML",
    latitude: "50.322275",
    longitude: "21.462131",
    altitude: "548",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "674",
    name: "Lawica",
    city: "Poznan",
    country: "Poland",
    iata: "POZ",
    icao: "EPPO",
    latitude: "52.421031",
    longitude: "16.826325",
    altitude: "308",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "675",
    name: "Jasionka",
    city: "Rzeszow",
    country: "Poland",
    iata: "RZE",
    icao: "EPRZ",
    latitude: "50.109958",
    longitude: "22.019",
    altitude: "675",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "676",
    name: "Goleniow",
    city: "Szczecin",
    country: "Poland",
    iata: "SZZ",
    icao: "EPSC",
    latitude: "53.584731",
    longitude: "14.902206",
    altitude: "154",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "677",
    name: "Redzikowo",
    city: "Slupsk",
    country: "Poland",
    iata: "OSP",
    icao: "EPSK",
    latitude: "54.478889",
    longitude: "17.1075",
    altitude: "217",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "678",
    name: "Swidwin",
    city: "Shapaja",
    country: "Poland",
    iata: "",
    icao: "EPSN",
    latitude: "53.790639",
    longitude: "15.82625",
    altitude: "385",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "679",
    name: "Okecie",
    city: "Warsaw",
    country: "Poland",
    iata: "WAW",
    icao: "EPWA",
    latitude: "52.16575",
    longitude: "20.967122",
    altitude: "362",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "680",
    name: "Strachowice",
    city: "Wroclaw",
    country: "Poland",
    iata: "WRO",
    icao: "EPWR",
    latitude: "51.102683",
    longitude: "16.885836",
    altitude: "404",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "681",
    name: "Babimost",
    city: "Zielona Gora",
    country: "Poland",
    iata: "IEG",
    icao: "EPZG",
    latitude: "52.138517",
    longitude: "15.798556",
    altitude: "194",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "682",
    name: "Malmen",
    city: "Linkoeping",
    country: "Sweden",
    iata: "",
    icao: "ESCF",
    latitude: "58.402278",
    longitude: "15.525683",
    altitude: "308",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "683",
    name: "Bravalla",
    city: "Norrkoeping",
    country: "Sweden",
    iata: "",
    icao: "ESCK",
    latitude: "58.610867",
    longitude: "16.103592",
    altitude: "90",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "684",
    name: "Uppsala",
    city: "Uppsala",
    country: "Sweden",
    iata: "",
    icao: "ESCM",
    latitude: "59.897328",
    longitude: "17.588581",
    altitude: "68",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "685",
    name: "Ronneby",
    city: "Ronneby",
    country: "Sweden",
    iata: "RNB",
    icao: "ESDF",
    latitude: "56.266667",
    longitude: "15.265",
    altitude: "191",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "686",
    name: "Rada",
    city: "Rada",
    country: "Sweden",
    iata: "",
    icao: "ESFR",
    latitude: "58.498136",
    longitude: "13.053231",
    altitude: "230",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "687",
    name: "Landvetter",
    city: "Gothenborg",
    country: "Sweden",
    iata: "GOT",
    icao: "ESGG",
    latitude: "57.662836",
    longitude: "12.279819",
    altitude: "506",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "688",
    name: "Jonkoping",
    city: "Joenkoeping",
    country: "Sweden",
    iata: "JKG",
    icao: "ESGJ",
    latitude: "57.757594",
    longitude: "14.068731",
    altitude: "741",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "689",
    name: "Falkoping",
    city: "Falkoping",
    country: "Sweden",
    iata: "",
    icao: "ESGK",
    latitude: "58.169794",
    longitude: "13.587847",
    altitude: "785",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "690",
    name: "Lidkoping",
    city: "Lidkoping",
    country: "Sweden",
    iata: "LDK",
    icao: "ESGL",
    latitude: "58.465522",
    longitude: "13.174414",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "691",
    name: "Save",
    city: "Gothenborg",
    country: "Sweden",
    iata: "GSE",
    icao: "ESGP",
    latitude: "57.774722",
    longitude: "11.870372",
    altitude: "59",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "692",
    name: "Skovde",
    city: "Skovde",
    country: "Sweden",
    iata: "KVB",
    icao: "ESGR",
    latitude: "58.4564",
    longitude: "13.972672",
    altitude: "324",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "693",
    name: "Trollhattan Vanersborg",
    city: "Trollhattan",
    country: "Sweden",
    iata: "THN",
    icao: "ESGT",
    latitude: "58.318056",
    longitude: "12.345",
    altitude: "137",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "694",
    name: "Karlsborg",
    city: "Karlsborg",
    country: "Sweden",
    iata: "",
    icao: "ESIA",
    latitude: "58.513842",
    longitude: "14.507119",
    altitude: "308",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "695",
    name: "Satenas",
    city: "Satenas",
    country: "Sweden",
    iata: "",
    icao: "ESIB",
    latitude: "58.426445",
    longitude: "12.714389",
    altitude: "181",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "696",
    name: "Barkarby",
    city: "Stockholm",
    country: "Sweden",
    iata: "",
    icao: "ESKB",
    latitude: "59.418694",
    longitude: "17.890694",
    altitude: "50",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "697",
    name: "Karlskoga",
    city: "Karlskoga",
    country: "Sweden",
    iata: "KSK",
    icao: "ESKK",
    latitude: "59.345867",
    longitude: "14.495922",
    altitude: "400",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "698",
    name: "Mora",
    city: "Mora",
    country: "Sweden",
    iata: "MXX",
    icao: "ESKM",
    latitude: "60.957908",
    longitude: "14.511383",
    altitude: "634",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "699",
    name: "Skavsta",
    city: "Stockholm",
    country: "Sweden",
    iata: "NYO",
    icao: "ESKN",
    latitude: "58.788636",
    longitude: "16.912189",
    altitude: "140",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "700",
    name: "Arvika",
    city: "Arvika",
    country: "Sweden",
    iata: "",
    icao: "ESKV",
    latitude: "59.675856",
    longitude: "12.639442",
    altitude: "237",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "701",
    name: "Emmaboda",
    city: "Emmaboda",
    country: "Sweden",
    iata: "",
    icao: "ESMA",
    latitude: "56.610761",
    longitude: "15.604761",
    altitude: "442",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "702",
    name: "Feringe",
    city: "Ljungby",
    country: "Sweden",
    iata: "",
    icao: "ESMG",
    latitude: "56.950278",
    longitude: "13.921667",
    altitude: "538",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "703",
    name: "Kristianstad",
    city: "Kristianstad",
    country: "Sweden",
    iata: "KID",
    icao: "ESMK",
    latitude: "55.921686",
    longitude: "14.085536",
    altitude: "76",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "704",
    name: "Landskrona",
    city: "Landskrona",
    country: "Sweden",
    iata: "JLD",
    icao: "ESML",
    latitude: "55.944444",
    longitude: "12.869444",
    altitude: "194",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "705",
    name: "Oskarshamn",
    city: "Oskarshamn",
    country: "Sweden",
    iata: "OSK",
    icao: "ESMO",
    latitude: "57.350453",
    longitude: "16.497972",
    altitude: "96",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "706",
    name: "Anderstorp",
    city: "Anderstorp",
    country: "Sweden",
    iata: "",
    icao: "ESMP",
    latitude: "57.264167",
    longitude: "13.599439",
    altitude: "507",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "707",
    name: "Kalmar",
    city: "Kalkmar",
    country: "Sweden",
    iata: "KLR",
    icao: "ESMQ",
    latitude: "56.685531",
    longitude: "16.287578",
    altitude: "17",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "708",
    name: "Sturup",
    city: "Malmoe",
    country: "Sweden",
    iata: "MMX",
    icao: "ESMS",
    latitude: "55.530193",
    longitude: "13.371639",
    altitude: "236",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "709",
    name: "Halmstad",
    city: "Halmstad",
    country: "Sweden",
    iata: "HAD",
    icao: "ESMT",
    latitude: "56.691128",
    longitude: "12.820211",
    altitude: "101",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "710",
    name: "Hagshult",
    city: "Hagshult",
    country: "Sweden",
    iata: "",
    icao: "ESMV",
    latitude: "57.292222",
    longitude: "14.137222",
    altitude: "556",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "711",
    name: "Kronoberg",
    city: "Vaxjo",
    country: "Sweden",
    iata: "VXO",
    icao: "ESMX",
    latitude: "56.929144",
    longitude: "14.727994",
    altitude: "610",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "712",
    name: "Hallviken",
    city: "Hallviken",
    country: "Sweden",
    iata: "",
    icao: "ESNA",
    latitude: "63.738333",
    longitude: "15.458333",
    altitude: "1119",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "713",
    name: "Hedlanda",
    city: "Hede",
    country: "Sweden",
    iata: "",
    icao: "ESNC",
    latitude: "62.408889",
    longitude: "13.747222",
    altitude: "1460",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "714",
    name: "Sveg",
    city: "Sveg",
    country: "Sweden",
    iata: "EVG",
    icao: "ESND",
    latitude: "62.047811",
    longitude: "14.42295",
    altitude: "1178",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "715",
    name: "Gallivare",
    city: "Gallivare",
    country: "Sweden",
    iata: "GEV",
    icao: "ESNG",
    latitude: "67.132408",
    longitude: "20.814636",
    altitude: "1027",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "716",
    name: "Hudiksvall",
    city: "Hudiksvall",
    country: "Sweden",
    iata: "HUV",
    icao: "ESNH",
    latitude: "61.768092",
    longitude: "17.080719",
    altitude: "95",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "717",
    name: "Jokkmokk",
    city: "Jokkmokk",
    country: "Sweden",
    iata: "",
    icao: "ESNJ",
    latitude: "66.496236",
    longitude: "20.147181",
    altitude: "904",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "718",
    name: "Kramfors Solleftea",
    city: "Kramfors",
    country: "Sweden",
    iata: "KRF",
    icao: "ESNK",
    latitude: "63.048597",
    longitude: "17.768856",
    altitude: "34",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "719",
    name: "Lycksele",
    city: "Lycksele",
    country: "Sweden",
    iata: "LYC",
    icao: "ESNL",
    latitude: "64.548322",
    longitude: "18.716219",
    altitude: "705",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "720",
    name: "Optand",
    city: "Optand",
    country: "Sweden",
    iata: "",
    icao: "ESNM",
    latitude: "63.128611",
    longitude: "14.802778",
    altitude: "1236",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "721",
    name: "Sundsvall Harnosand",
    city: "Sundsvall",
    country: "Sweden",
    iata: "SDL",
    icao: "ESNN",
    latitude: "62.528125",
    longitude: "17.443928",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "722",
    name: "Ornskoldsvik",
    city: "Ornskoldsvik",
    country: "Sweden",
    iata: "OER",
    icao: "ESNO",
    latitude: "63.408339",
    longitude: "18.990039",
    altitude: "354",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "723",
    name: "Pitea",
    city: "Pitea",
    country: "Sweden",
    iata: "",
    icao: "ESNP",
    latitude: "65.398333",
    longitude: "21.260833",
    altitude: "43",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "724",
    name: "Kiruna",
    city: "Kiruna",
    country: "Sweden",
    iata: "KRN",
    icao: "ESNQ",
    latitude: "67.821986",
    longitude: "20.336764",
    altitude: "1508",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "725",
    name: "Orsa",
    city: "Orsa",
    country: "Sweden",
    iata: "",
    icao: "ESNR",
    latitude: "61.190033",
    longitude: "14.712567",
    altitude: "683",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "726",
    name: "Skelleftea",
    city: "Skelleftea",
    country: "Sweden",
    iata: "SFT",
    icao: "ESNS",
    latitude: "64.624772",
    longitude: "21.076892",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "727",
    name: "Sattna",
    city: "Sattna",
    country: "Sweden",
    iata: "",
    icao: "ESNT",
    latitude: "62.481369",
    longitude: "17.002917",
    altitude: "886",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "728",
    name: "Umea",
    city: "Umea",
    country: "Sweden",
    iata: "UME",
    icao: "ESNU",
    latitude: "63.791828",
    longitude: "20.282758",
    altitude: "24",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "729",
    name: "Vilhelmina",
    city: "Vilhelmina",
    country: "Sweden",
    iata: "VHM",
    icao: "ESNV",
    latitude: "64.579083",
    longitude: "16.833575",
    altitude: "1140",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "730",
    name: "Arvidsjaur",
    city: "Arvidsjaur",
    country: "Sweden",
    iata: "AJR",
    icao: "ESNX",
    latitude: "65.590278",
    longitude: "19.281944",
    altitude: "1245",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "731",
    name: "Orebro",
    city: "Orebro",
    country: "Sweden",
    iata: "ORB",
    icao: "ESOE",
    latitude: "59.223733",
    longitude: "15.037956",
    altitude: "188",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "733",
    name: "Vasteras",
    city: "Vasteras",
    country: "Sweden",
    iata: "VST",
    icao: "ESOW",
    latitude: "59.589444",
    longitude: "16.633611",
    altitude: "21",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "734",
    name: "Kallax",
    city: "Lulea",
    country: "Sweden",
    iata: "LLA",
    icao: "ESPA",
    latitude: "65.543758",
    longitude: "22.121989",
    altitude: "65",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "735",
    name: "Vidsel",
    city: "Vidsel",
    country: "Sweden",
    iata: "",
    icao: "ESPE",
    latitude: "65.875325",
    longitude: "20.149917",
    altitude: "597",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "736",
    name: "Arboga",
    city: "Arboga",
    country: "Sweden",
    iata: "",
    icao: "ESQO",
    latitude: "59.386585",
    longitude: "15.924055",
    altitude: "33",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "737",
    name: "Arlanda",
    city: "Stockholm",
    country: "Sweden",
    iata: "ARN",
    icao: "ESSA",
    latitude: "59.651944",
    longitude: "17.918611",
    altitude: "137",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "738",
    name: "Bromma",
    city: "Stockholm",
    country: "Sweden",
    iata: "BMA",
    icao: "ESSB",
    latitude: "59.354372",
    longitude: "17.94165",
    altitude: "47",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "739",
    name: "Borlange",
    city: "Borlange",
    country: "Sweden",
    iata: "BLE",
    icao: "ESSD",
    latitude: "60.422017",
    longitude: "15.515211",
    altitude: "503",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "740",
    name: "Hultsfred",
    city: "Hultsfred",
    country: "Sweden",
    iata: "HLF",
    icao: "ESSF",
    latitude: "57.525833",
    longitude: "15.823333",
    altitude: "366",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "741",
    name: "Gavle",
    city: "Gavle",
    country: "Sweden",
    iata: "GVX",
    icao: "ESSK",
    latitude: "60.593333",
    longitude: "16.951389",
    altitude: "224",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "742",
    name: "Saab",
    city: "Linkoeping",
    country: "Sweden",
    iata: "LPI",
    icao: "ESSL",
    latitude: "58.40615",
    longitude: "15.680508",
    altitude: "172",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "743",
    name: "Kungsangen",
    city: "Norrkoeping",
    country: "Sweden",
    iata: "NRK",
    icao: "ESSP",
    latitude: "58.586253",
    longitude: "16.250622",
    altitude: "32",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "745",
    name: "Eskilstuna",
    city: "Eskilstuna",
    country: "Sweden",
    iata: "",
    icao: "ESSU",
    latitude: "59.351078",
    longitude: "16.7084",
    altitude: "139",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "746",
    name: "Visby",
    city: "Visby",
    country: "Sweden",
    iata: "VBY",
    icao: "ESSV",
    latitude: "57.662797",
    longitude: "18.346211",
    altitude: "164",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "748",
    name: "Kalixfors",
    city: "Kalixfors",
    country: "Sweden",
    iata: "",
    icao: "ESUK",
    latitude: "67.764789",
    longitude: "20.257228",
    altitude: "1549",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "750",
    name: "Spangdahlem Ab",
    city: "Spangdahlem",
    country: "Germany",
    iata: "SPM",
    icao: "ETAD",
    latitude: "49.972667",
    longitude: "6.6925",
    altitude: "1197",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "751",
    name: "Ramstein Ab",
    city: "Ramstein",
    country: "Germany",
    iata: "RMS",
    icao: "ETAR",
    latitude: "49.436911",
    longitude: "7.600283",
    altitude: "776",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "752",
    name: "Bamberg Aaf",
    city: "Bamberg",
    country: "Germany",
    iata: "",
    icao: "ETEJ",
    latitude: "49.920433",
    longitude: "10.914233",
    altitude: "823",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "753",
    name: "Giebelstadt Aaf",
    city: "Giebelstadt",
    country: "Germany",
    iata: "GHF",
    icao: "ETEU",
    latitude: "49.648131",
    longitude: "9.966494",
    altitude: "980",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "754",
    name: "Buckeburg",
    city: "Brueckeburg",
    country: "Germany",
    iata: "",
    icao: "ETHB",
    latitude: "52.2785",
    longitude: "9.082167",
    altitude: "230",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "755",
    name: "Celle",
    city: "Celle",
    country: "Germany",
    iata: "ZCN",
    icao: "ETHC",
    latitude: "52.5912",
    longitude: "10.022133",
    altitude: "129",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "756",
    name: "Rheine Bentlage",
    city: "Rheine-brentlange",
    country: "Germany",
    iata: "",
    icao: "ETHE",
    latitude: "52.291167",
    longitude: "7.387",
    altitude: "129",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "757",
    name: "Fritzlar",
    city: "Fritzlar",
    country: "Germany",
    iata: "",
    icao: "ETHF",
    latitude: "51.1145",
    longitude: "9.285833",
    altitude: "566",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "758",
    name: "Laupheim",
    city: "Laupheim",
    country: "Germany",
    iata: "",
    icao: "ETHL",
    latitude: "48.220297",
    longitude: "9.910019",
    altitude: "1766",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "759",
    name: "Mendig",
    city: "Mendig",
    country: "Germany",
    iata: "",
    icao: "ETHM",
    latitude: "50.366",
    longitude: "7.315333",
    altitude: "597",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "760",
    name: "Niederstetten",
    city: "Niederstetten",
    country: "Germany",
    iata: "",
    icao: "ETHN",
    latitude: "49.391833",
    longitude: "9.958167",
    altitude: "1536",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "761",
    name: "Roth",
    city: "Roth",
    country: "Germany",
    iata: "",
    icao: "ETHR",
    latitude: "49.2175",
    longitude: "11.100167",
    altitude: "1268",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "762",
    name: "Fassberg",
    city: "Fassberg",
    country: "Germany",
    iata: "",
    icao: "ETHS",
    latitude: "52.919406",
    longitude: "10.197528",
    altitude: "245",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "763",
    name: "Grafenwohr Aaf",
    city: "Grafenwoehr",
    country: "Germany",
    iata: "",
    icao: "ETIC",
    latitude: "49.698686",
    longitude: "11.940175",
    altitude: "1363",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "764",
    name: "Hanau Aaf",
    city: "Hanau",
    country: "Germany",
    iata: "ZNF",
    icao: "ETID",
    latitude: "50.169189",
    longitude: "8.961586",
    altitude: "368",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "765",
    name: "Hohenfels Aaf",
    city: "Hohenfels",
    country: "Germany",
    iata: "",
    icao: "ETIH",
    latitude: "49.218056",
    longitude: "11.836111",
    altitude: "1455",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "766",
    name: "Kitzingen Aaf",
    city: "Kitzingen",
    country: "Germany",
    iata: "",
    icao: "ETIN",
    latitude: "49.743057",
    longitude: "10.200556",
    altitude: "689",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "767",
    name: "Nordholz",
    city: "Nordholz",
    country: "Germany",
    iata: "",
    icao: "ETMN",
    latitude: "53.767667",
    longitude: "8.6585",
    altitude: "74",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "768",
    name: "Diepholz",
    city: "Diepholz",
    country: "Germany",
    iata: "",
    icao: "ETND",
    latitude: "52.585514",
    longitude: "8.341014",
    altitude: "127",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "769",
    name: "Geilenkirchen",
    city: "Geilenkirchen",
    country: "Germany",
    iata: "GKE",
    icao: "ETNG",
    latitude: "50.960817",
    longitude: "6.042422",
    altitude: "296",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "770",
    name: "Hohn",
    city: "Hohn",
    country: "Germany",
    iata: "",
    icao: "ETNH",
    latitude: "54.312167",
    longitude: "9.538167",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "771",
    name: "Jever",
    city: "Jever",
    country: "Germany",
    iata: "",
    icao: "ETNJ",
    latitude: "53.5335",
    longitude: "7.888667",
    altitude: "24",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "772",
    name: "Laage",
    city: "Laage",
    country: "Germany",
    iata: "RLG",
    icao: "ETNL",
    latitude: "53.918167",
    longitude: "12.278333",
    altitude: "138",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "773",
    name: "Norvenich",
    city: "Noervenich",
    country: "Germany",
    iata: "",
    icao: "ETNN",
    latitude: "50.831167",
    longitude: "6.658167",
    altitude: "386",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "774",
    name: "Schleswig",
    city: "Schleswig",
    country: "Germany",
    iata: "",
    icao: "ETNS",
    latitude: "54.459333",
    longitude: "9.516333",
    altitude: "70",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "775",
    name: "Wittmundhafen",
    city: "Wittmundhafen",
    country: "Germany",
    iata: "",
    icao: "ETNT",
    latitude: "53.547833",
    longitude: "7.667333",
    altitude: "26",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "776",
    name: "Neubrandenburg",
    city: "Neubrandenburg",
    country: "Germany",
    iata: "",
    icao: "ETNU",
    latitude: "53.602167",
    longitude: "13.306",
    altitude: "228",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "777",
    name: "Wunstorf",
    city: "Wunstorf",
    country: "Germany",
    iata: "",
    icao: "ETNW",
    latitude: "52.457333",
    longitude: "9.427167",
    altitude: "187",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "778",
    name: "Vilseck Aaf",
    city: "Vilseck",
    country: "Germany",
    iata: "",
    icao: "ETOI",
    latitude: "49.63361",
    longitude: "11.767222",
    altitude: "1353",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "779",
    name: "Coleman Aaf",
    city: "Coleman",
    country: "Germany",
    iata: "",
    icao: "ETOR",
    latitude: "49.563569",
    longitude: "8.463392",
    altitude: "309",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "780",
    name: "Wiesbaden Aaf",
    city: "Wiesbaden",
    country: "Germany",
    iata: "",
    icao: "ETOU",
    latitude: "50.049819",
    longitude: "8.325397",
    altitude: "461",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "781",
    name: "Landsberg Lech",
    city: "Landsberg",
    country: "Germany",
    iata: "",
    icao: "ETSA",
    latitude: "48.0705",
    longitude: "10.906",
    altitude: "2044",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "782",
    name: "Buchel",
    city: "Buechel",
    country: "Germany",
    iata: "",
    icao: "ETSB",
    latitude: "50.173833",
    longitude: "7.063333",
    altitude: "1568",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "783",
    name: "Erding",
    city: "Erding",
    country: "Germany",
    iata: "",
    icao: "ETSE",
    latitude: "48.322333",
    longitude: "11.948667",
    altitude: "1515",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "784",
    name: "Furstenfeldbruck",
    city: "Fuerstenfeldbruck",
    country: "Germany",
    iata: "FEL",
    icao: "ETSF",
    latitude: "48.205667",
    longitude: "11.267",
    altitude: "1703",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "785",
    name: "Holzdorf",
    city: "Holzdorf",
    country: "Germany",
    iata: "",
    icao: "ETSH",
    latitude: "51.767833",
    longitude: "13.167667",
    altitude: "265",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "786",
    name: "Ingolstadt Manching",
    city: "Ingolstadt",
    country: "Germany",
    iata: "",
    icao: "ETSI",
    latitude: "48.715667",
    longitude: "11.534",
    altitude: "1202",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "787",
    name: "Lechfeld",
    city: "Lechfeld",
    country: "Germany",
    iata: "",
    icao: "ETSL",
    latitude: "48.1855",
    longitude: "10.861167",
    altitude: "1822",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "788",
    name: "Neuburg",
    city: "Neuburg",
    country: "Germany",
    iata: "",
    icao: "ETSN",
    latitude: "48.711",
    longitude: "11.2115",
    altitude: "1249",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "789",
    name: "Gutersloh",
    city: "Guetersloh",
    country: "Germany",
    iata: "GUT",
    icao: "ETUO",
    latitude: "51.922833",
    longitude: "8.306333",
    altitude: "236",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "790",
    name: "Alexander Bay",
    city: "Alexander Bay",
    country: "South Africa",
    iata: "ALJ",
    icao: "FAAB",
    latitude: "-28.575001",
    longitude: "16.533333",
    altitude: "98",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "791",
    name: "Aggeneys",
    city: "Aggeneys",
    country: "South Africa",
    iata: "AGZ",
    icao: "FAAG",
    latitude: "-29.281767",
    longitude: "18.813869",
    altitude: "2648",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "792",
    name: "Brakpan",
    city: "Brakpan",
    country: "South Africa",
    iata: "",
    icao: "FABB",
    latitude: "-26.23865",
    longitude: "28.301769",
    altitude: "5300",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "793",
    name: "Bhisho",
    city: "Bisho",
    country: "South Africa",
    iata: "BIY",
    icao: "FABE",
    latitude: "-32.89715",
    longitude: "27.279111",
    altitude: "1950",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "794",
    name: "Bloemfontein Intl",
    city: "Bloemfontein",
    country: "South Africa",
    iata: "BFN",
    icao: "FABL",
    latitude: "-29.092722",
    longitude: "26.302444",
    altitude: "4458",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "795",
    name: "Bethlehem",
    city: "Bethlehem",
    country: "South Africa",
    iata: "",
    icao: "FABM",
    latitude: "-28.248392",
    longitude: "28.336125",
    altitude: "5561",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "796",
    name: "Bothaville",
    city: "Bothaville",
    country: "South Africa",
    iata: "",
    icao: "FABO",
    latitude: "-27.366769",
    longitude: "26.629194",
    altitude: "4236",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "797",
    name: "Cape Town Intl",
    city: "Cape Town",
    country: "South Africa",
    iata: "CPT",
    icao: "FACT",
    latitude: "-33.964806",
    longitude: "18.601667",
    altitude: "151",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "798",
    name: "Calvinia",
    city: "Calvinia",
    country: "South Africa",
    iata: "",
    icao: "FACV",
    latitude: "-31.500278",
    longitude: "19.725897",
    altitude: "3250",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "799",
    name: "Durban Intl",
    city: "Durban",
    country: "South Africa",
    iata: "DUR",
    icao: "FADN",
    latitude: "-29.970089",
    longitude: "30.950519",
    altitude: "33",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "800",
    name: "East London",
    city: "East London",
    country: "South Africa",
    iata: "ELS",
    icao: "FAEL",
    latitude: "-33.035569",
    longitude: "27.825939",
    altitude: "435",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "801",
    name: "Ermelo",
    city: "Ermelo",
    country: "South Africa",
    iata: "",
    icao: "FAEO",
    latitude: "-26.495644",
    longitude: "29.979764",
    altitude: "5700",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "802",
    name: "Ficksburg Sentraoes",
    city: "Ficksburg",
    country: "South Africa",
    iata: "",
    icao: "FAFB",
    latitude: "-28.823119",
    longitude: "27.9089",
    altitude: "5315",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "803",
    name: "Grand Central",
    city: "Johannesburg",
    country: "South Africa",
    iata: "GCJ",
    icao: "FAGC",
    latitude: "-25.986267",
    longitude: "28.140061",
    altitude: "5325",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "804",
    name: "George",
    city: "George",
    country: "South Africa",
    iata: "GRJ",
    icao: "FAGG",
    latitude: "-34.005553",
    longitude: "22.378889",
    altitude: "648",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "806",
    name: "Graaff Reinet",
    city: "Graaff Reinet",
    country: "South Africa",
    iata: "",
    icao: "FAGR",
    latitude: "-32.193611",
    longitude: "24.541389",
    altitude: "2604",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "807",
    name: "Grahamstown",
    city: "Grahamstown",
    country: "South Africa",
    iata: "",
    icao: "FAGT",
    latitude: "-33.284721",
    longitude: "26.498083",
    altitude: "2135",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "808",
    name: "Greytown",
    city: "Greytown",
    country: "South Africa",
    iata: "",
    icao: "FAGY",
    latitude: "-29.122011",
    longitude: "30.586706",
    altitude: "3531",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "809",
    name: "Harmony",
    city: "Harmony",
    country: "South Africa",
    iata: "",
    icao: "FAHA",
    latitude: "-28.078694",
    longitude: "26.861178",
    altitude: "4399",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "810",
    name: "Harrismith",
    city: "Harrismith",
    country: "South Africa",
    iata: "",
    icao: "FAHR",
    latitude: "-28.235072",
    longitude: "29.106206",
    altitude: "5585",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "811",
    name: "Hoedspruit Afb",
    city: "Hoedspruit",
    country: "South Africa",
    iata: "HDS",
    icao: "FAHS",
    latitude: "-24.368642",
    longitude: "31.048744",
    altitude: "1743",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "812",
    name: "Gariep Dam",
    city: "Hendrik Verwoerddam",
    country: "South Africa",
    iata: "",
    icao: "FAHV",
    latitude: "-30.562164",
    longitude: "25.528286",
    altitude: "4176",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "813",
    name: "Johannesburg Intl",
    city: "Johannesburg",
    country: "South Africa",
    iata: "JNB",
    icao: "FAJS",
    latitude: "-26.139166",
    longitude: "28.246",
    altitude: "5558",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "814",
    name: "P C Pelser",
    city: "Klerksdorp",
    country: "South Africa",
    iata: "",
    icao: "FAKD",
    latitude: "-26.871064",
    longitude: "26.718003",
    altitude: "4444",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "815",
    name: "Kimberley",
    city: "Kimberley",
    country: "South Africa",
    iata: "KIM",
    icao: "FAKM",
    latitude: "-28.802834",
    longitude: "24.765167",
    altitude: "3950",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "816",
    name: "Krugersdorp",
    city: "Krugersdorp",
    country: "South Africa",
    iata: "",
    icao: "FAKR",
    latitude: "-26.080978",
    longitude: "27.725667",
    altitude: "5499",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "817",
    name: "Kroonstad",
    city: "Kroonstad",
    country: "South Africa",
    iata: "",
    icao: "FAKS",
    latitude: "-27.660617",
    longitude: "27.315761",
    altitude: "4700",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "818",
    name: "Johan Pienaar",
    city: "Kuruman",
    country: "South Africa",
    iata: "",
    icao: "FAKU",
    latitude: "-27.456667",
    longitude: "23.411388",
    altitude: "4382",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "819",
    name: "Kleinsee",
    city: "Kleinsee",
    country: "South Africa",
    iata: "KLZ",
    icao: "FAKZ",
    latitude: "-29.688403",
    longitude: "17.094006",
    altitude: "270",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "820",
    name: "Lanseria",
    city: "Johannesburg",
    country: "South Africa",
    iata: "HLA",
    icao: "FALA",
    latitude: "-25.938514",
    longitude: "27.926133",
    altitude: "4517",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "821",
    name: "Lichtenburg",
    city: "Lichtenburg",
    country: "South Africa",
    iata: "",
    icao: "FALI",
    latitude: "-26.175672",
    longitude: "26.184575",
    altitude: "4875",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "822",
    name: "Makhado Afb",
    city: "Lambertsbaai",
    country: "South Africa",
    iata: "",
    icao: "FALM",
    latitude: "-23.159911",
    longitude: "29.696544",
    altitude: "3069",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "823",
    name: "Langebaanweg",
    city: "Langebaanweg",
    country: "South Africa",
    iata: "",
    icao: "FALW",
    latitude: "-32.968889",
    longitude: "18.160278",
    altitude: "108",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "824",
    name: "Ladysmith",
    city: "Ladysmith",
    country: "South Africa",
    iata: "LAY",
    icao: "FALY",
    latitude: "-28.581667",
    longitude: "29.749722",
    altitude: "3548",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "825",
    name: "Middelburg",
    city: "Middelburg",
    country: "South Africa",
    iata: "",
    icao: "FAMB",
    latitude: "-25.684775",
    longitude: "29.440158",
    altitude: "4886",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "827",
    name: "Margate",
    city: "Margate",
    country: "South Africa",
    iata: "MGH",
    icao: "FAMG",
    latitude: "-30.857408",
    longitude: "30.343019",
    altitude: "495",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "828",
    name: "Marble Hall",
    city: "Marble Hall",
    country: "South Africa",
    iata: "",
    icao: "FAMI",
    latitude: "-24.989114",
    longitude: "29.283122",
    altitude: "2980",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "829",
    name: "Majuba Power Station",
    city: "Majuba Power Station",
    country: "South Africa",
    iata: "",
    icao: "FAMJ",
    latitude: "-27.079253",
    longitude: "29.778528",
    altitude: "5600",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "6813",
    name: "Susse",
    city: "Kangia",
    country: "Greenland",
    iata: "",
    icao: "\\N",
    latitude: "69.2225",
    longitude: "-49.9383",
    altitude: "100",
    timezone: "-3",
    dst: "U",
    tz: "America/Godthab",
  },
  {
    id: "831",
    name: "Malelane",
    city: "Malalane",
    country: "South Africa",
    iata: "",
    icao: "FAMN",
    latitude: "-25.473603",
    longitude: "31.565828",
    altitude: "1153",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "832",
    name: "Messina",
    city: "Musina",
    country: "South Africa",
    iata: "MEZ",
    icao: "FAMS",
    latitude: "-25.704458",
    longitude: "26.908978",
    altitude: "4251",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "833",
    name: "Mkuzi",
    city: "Mkuze",
    country: "South Africa",
    iata: "",
    icao: "FAMU",
    latitude: "-27.626086",
    longitude: "32.044275",
    altitude: "400",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "834",
    name: "Newcastle",
    city: "Newcastle",
    country: "South Africa",
    iata: "NCS",
    icao: "FANC",
    latitude: "-27.770586",
    longitude: "29.976894",
    altitude: "4074",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "835",
    name: "Nylstroom",
    city: "Nylstroom",
    country: "South Africa",
    iata: "",
    icao: "FANY",
    latitude: "-24.686056",
    longitude: "28.434944",
    altitude: "3900",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "836",
    name: "Overberg",
    city: "Overberg",
    country: "South Africa",
    iata: "",
    icao: "FAOB",
    latitude: "-34.554861",
    longitude: "20.250681",
    altitude: "52",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "837",
    name: "Oudtshoorn",
    city: "Oudtshoorn",
    country: "South Africa",
    iata: "DUH",
    icao: "FAOH",
    latitude: "-33.606967",
    longitude: "22.188978",
    altitude: "1063",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "838",
    name: "Port Elizabeth Intl",
    city: "Port Elizabeth",
    country: "South Africa",
    iata: "PLZ",
    icao: "FAPE",
    latitude: "-33.984919",
    longitude: "25.617275",
    altitude: "226",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "839",
    name: "Plettenberg Bay",
    city: "Plettenberg Bay",
    country: "South Africa",
    iata: "",
    icao: "FAPG",
    latitude: "-34.090279",
    longitude: "23.327778",
    altitude: "465",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "840",
    name: "Phalaborwa",
    city: "Phalaborwa",
    country: "South Africa",
    iata: "PHW",
    icao: "FAPH",
    latitude: "-23.937166",
    longitude: "31.15539",
    altitude: "1432",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "841",
    name: "Polokwane International",
    city: "Polokwane",
    country: "South Africa",
    iata: "PTG",
    icao: "FAPI",
    latitude: "-23.926089",
    longitude: "29.484422",
    altitude: "4354",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "842",
    name: "Port St Johns",
    city: "Port Saint Johns",
    country: "South Africa",
    iata: "",
    icao: "FAPJ",
    latitude: "-31.605886",
    longitude: "29.519786",
    altitude: "1227",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "843",
    name: "Pietermaritzburg",
    city: "Pietermaritzburg",
    country: "South Africa",
    iata: "PZB",
    icao: "FAPM",
    latitude: "-29.648975",
    longitude: "30.398667",
    altitude: "2423",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "844",
    name: "Pilanesberg Intl",
    city: "Pilanesberg",
    country: "South Africa",
    iata: "NTY",
    icao: "FAPN",
    latitude: "-25.333822",
    longitude: "27.173358",
    altitude: "3412",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "845",
    name: "Polokwane Intl",
    city: "Potgietersrus",
    country: "South Africa",
    iata: "",
    icao: "FAPP",
    latitude: "-23.845306",
    longitude: "29.458611",
    altitude: "4076",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "846",
    name: "Potchefstroom",
    city: "Potchefstroom",
    country: "South Africa",
    iata: "",
    icao: "FAPS",
    latitude: "-26.670994",
    longitude: "27.0819",
    altitude: "4520",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "847",
    name: "Parys",
    city: "Parys",
    country: "South Africa",
    iata: "",
    icao: "FAPY",
    latitude: "-26.889344",
    longitude: "27.503417",
    altitude: "4740",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "848",
    name: "Queenstown",
    city: "Queenstown",
    country: "South Africa",
    iata: "UTW",
    icao: "FAQT",
    latitude: "-31.920197",
    longitude: "26.882206",
    altitude: "3637",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "849",
    name: "Richards Bay",
    city: "Richard's Bay",
    country: "South Africa",
    iata: "RCB",
    icao: "FARB",
    latitude: "-28.741039",
    longitude: "32.092111",
    altitude: "109",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "850",
    name: "Rustenburg",
    city: "Rustenburg",
    country: "South Africa",
    iata: "",
    icao: "FARG",
    latitude: "-25.6443",
    longitude: "27.271119",
    altitude: "3700",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "851",
    name: "Robertson",
    city: "Robertson",
    country: "South Africa",
    iata: "",
    icao: "FARS",
    latitude: "-33.812181",
    longitude: "19.902828",
    altitude: "640",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "852",
    name: "Springbok",
    city: "Springbok",
    country: "South Africa",
    iata: "SBU",
    icao: "FASB",
    latitude: "-29.689333",
    longitude: "17.939611",
    altitude: "2690",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "853",
    name: "Secunda",
    city: "Secunda",
    country: "South Africa",
    iata: "",
    icao: "FASC",
    latitude: "-26.524083",
    longitude: "29.170144",
    altitude: "5250",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "854",
    name: "Saldanha Vredenburg",
    city: "Saldanha",
    country: "South Africa",
    iata: "",
    icao: "FASD",
    latitude: "-32.964067",
    longitude: "17.969331",
    altitude: "50",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "855",
    name: "Springs",
    city: "Springs",
    country: "South Africa",
    iata: "",
    icao: "FASI",
    latitude: "-26.248411",
    longitude: "28.397508",
    altitude: "5340",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "856",
    name: "Swartkop",
    city: "Swartkop",
    country: "South Africa",
    iata: "",
    icao: "FASK",
    latitude: "-25.809717",
    longitude: "28.164631",
    altitude: "4780",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "857",
    name: "Sishen",
    city: "Sishen",
    country: "South Africa",
    iata: "SIS",
    icao: "FASS",
    latitude: "-27.648606",
    longitude: "22.999278",
    altitude: "3848",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "858",
    name: "Hendrik Swellengrebel",
    city: "Swellendam",
    country: "South Africa",
    iata: "",
    icao: "FASX",
    latitude: "-34.048222",
    longitude: "20.474611",
    altitude: "407",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "859",
    name: "Skukuza",
    city: "Skukuza",
    country: "South Africa",
    iata: "SZK",
    icao: "FASZ",
    latitude: "-24.960944",
    longitude: "31.588731",
    altitude: "1020",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "860",
    name: "Tommys Fld",
    city: "Tommy's Field",
    country: "South Africa",
    iata: "",
    icao: "FATF",
    latitude: "-28.260028",
    longitude: "22.993178",
    altitude: "4360",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "861",
    name: "New Tempe",
    city: "Bloemfontein",
    country: "South Africa",
    iata: "",
    icao: "FATP",
    latitude: "-29.032928",
    longitude: "26.157564",
    altitude: "4547",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "862",
    name: "Tutuka Power Station",
    city: "Tutuka",
    country: "South Africa",
    iata: "",
    icao: "FATT",
    latitude: "-26.776556",
    longitude: "29.338778",
    altitude: "5313",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "863",
    name: "Tzaneen",
    city: "Tzaneen",
    country: "South Africa",
    iata: "LTA",
    icao: "FATZ",
    latitude: "-23.824417",
    longitude: "30.329306",
    altitude: "1914",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "864",
    name: "Prince Mangosuthu Buthelezi",
    city: "Ulundi",
    country: "South Africa",
    iata: "ULD",
    icao: "FAUL",
    latitude: "-28.320586",
    longitude: "31.416519",
    altitude: "1720",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "865",
    name: "Upington",
    city: "Upington",
    country: "South Africa",
    iata: "UTN",
    icao: "FAUP",
    latitude: "-28.399097",
    longitude: "21.260239",
    altitude: "2782",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "866",
    name: "Mthatha",
    city: "Umtata",
    country: "South Africa",
    iata: "UTT",
    icao: "FAUT",
    latitude: "-31.547903",
    longitude: "28.674289",
    altitude: "2400",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "867",
    name: "Vryburg",
    city: "Vryburg",
    country: "South Africa",
    iata: "VRU",
    icao: "FAVB",
    latitude: "-26.982408",
    longitude: "24.728756",
    altitude: "3920",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "868",
    name: "Virginia",
    city: "Durban",
    country: "South Africa",
    iata: "VIR",
    icao: "FAVG",
    latitude: "-29.770606",
    longitude: "31.058406",
    altitude: "20",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "869",
    name: "Vredendal",
    city: "Vredendal",
    country: "South Africa",
    iata: "",
    icao: "FAVR",
    latitude: "-31.640961",
    longitude: "18.544789",
    altitude: "330",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "870",
    name: "Vereeniging",
    city: "Vereeniging",
    country: "South Africa",
    iata: "",
    icao: "FAVV",
    latitude: "-26.566372",
    longitude: "27.960756",
    altitude: "4846",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "871",
    name: "Wonderboom",
    city: "Pretoria",
    country: "South Africa",
    iata: "PRY",
    icao: "FAWB",
    latitude: "-25.653858",
    longitude: "28.224231",
    altitude: "4095",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "872",
    name: "Witbank",
    city: "Witbank",
    country: "South Africa",
    iata: "",
    icao: "FAWI",
    latitude: "-25.832294",
    longitude: "29.192019",
    altitude: "5078",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "873",
    name: "Waterkloof Afb",
    city: "Waterkloof",
    country: "South Africa",
    iata: "",
    icao: "FAWK",
    latitude: "-25.83",
    longitude: "28.2225",
    altitude: "4940",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "874",
    name: "Welkom",
    city: "Welkom",
    country: "South Africa",
    iata: "WEL",
    icao: "FAWM",
    latitude: "-27.998",
    longitude: "26.669586",
    altitude: "4399",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "875",
    name: "Ysterplaat",
    city: "Ysterplaat",
    country: "South Africa",
    iata: "",
    icao: "FAYP",
    latitude: "-33.900244",
    longitude: "18.498297",
    altitude: "52",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "876",
    name: "Zeerust",
    city: "Zeerust",
    country: "South Africa",
    iata: "",
    icao: "FAZR",
    latitude: "-25.598972",
    longitude: "26.042333",
    altitude: "4258",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "877",
    name: "Francistown",
    city: "Francistown",
    country: "Botswana",
    iata: "FRW",
    icao: "FBFT",
    latitude: "-21.159597",
    longitude: "27.474525",
    altitude: "3283",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "878",
    name: "Jwaneng",
    city: "Jwaneng",
    country: "Botswana",
    iata: "JWA",
    icao: "FBJW",
    latitude: "-24.602333",
    longitude: "24.690971",
    altitude: "3900",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "879",
    name: "Kasane",
    city: "Kasane",
    country: "Botswana",
    iata: "BBK",
    icao: "FBKE",
    latitude: "-17.832875",
    longitude: "25.1624",
    altitude: "3289",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "880",
    name: "Maun",
    city: "Maun",
    country: "Botswana",
    iata: "MUB",
    icao: "FBMN",
    latitude: "-19.972564",
    longitude: "23.431086",
    altitude: "3093",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "881",
    name: "Sir Seretse Khama Intl",
    city: "Gaberone",
    country: "Botswana",
    iata: "GBE",
    icao: "FBSK",
    latitude: "-24.555225",
    longitude: "25.918208",
    altitude: "3299",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "882",
    name: "Selebi Phikwe",
    city: "Selebi-phikwe",
    country: "Botswana",
    iata: "PKW",
    icao: "FBSP",
    latitude: "-22.05835",
    longitude: "27.828767",
    altitude: "2925",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "883",
    name: "Maya Maya",
    city: "Brazzaville",
    country: "Congo (Brazzaville)",
    iata: "BZV",
    icao: "FCBB",
    latitude: "-4.2517",
    longitude: "15.253031",
    altitude: "1048",
    timezone: "1",
    dst: "N",
    tz: "Africa/Brazzaville",
  },
  {
    id: "884",
    name: "Owando",
    city: "Owando",
    country: "Congo (Kinshasa)",
    iata: "FTX",
    icao: "FCOO",
    latitude: "-0.53135",
    longitude: "15.950094",
    altitude: "1214",
    timezone: "1",
    dst: "N",
    tz: "Africa/Brazzaville",
  },
  {
    id: "885",
    name: "Ouesso",
    city: "Ouesso",
    country: "Congo (Kinshasa)",
    iata: "OUE",
    icao: "FCOU",
    latitude: "1.615994",
    longitude: "16.037917",
    altitude: "1158",
    timezone: "1",
    dst: "N",
    tz: "Africa/Brazzaville",
  },
  {
    id: "886",
    name: "Pointe Noire",
    city: "Pointe-noire",
    country: "Congo (Brazzaville)",
    iata: "PNR",
    icao: "FCPP",
    latitude: "-4.816028",
    longitude: "11.886597",
    altitude: "55",
    timezone: "1",
    dst: "N",
    tz: "Africa/Brazzaville",
  },
  {
    id: "887",
    name: "Matsapha",
    city: "Manzini",
    country: "Swaziland",
    iata: "MTS",
    icao: "FDMS",
    latitude: "-26.529022",
    longitude: "31.307519",
    altitude: "2075",
    timezone: "2",
    dst: "U",
    tz: "Africa/Mbabane",
  },
  {
    id: "888",
    name: "Bangui M Poko",
    city: "Bangui",
    country: "Central African Republic",
    iata: "BGF",
    icao: "FEFF",
    latitude: "4.398475",
    longitude: "18.518786",
    altitude: "1208",
    timezone: "1",
    dst: "N",
    tz: "Africa/Bangui",
  },
  {
    id: "889",
    name: "Berberati",
    city: "Berberati",
    country: "Central African Republic",
    iata: "BBT",
    icao: "FEFT",
    latitude: "4.221583",
    longitude: "15.786369",
    altitude: "1929",
    timezone: "1",
    dst: "N",
    tz: "Africa/Bangui",
  },
  {
    id: "890",
    name: "Bata",
    city: "Bata",
    country: "Equatorial Guinea",
    iata: "BSG",
    icao: "FGBT",
    latitude: "1.905469",
    longitude: "9.805681",
    altitude: "13",
    timezone: "1",
    dst: "N",
    tz: "Africa/Malabo",
  },
  {
    id: "891",
    name: "Malabo",
    city: "Malabo",
    country: "Equatorial Guinea",
    iata: "SSG",
    icao: "FGSL",
    latitude: "3.755267",
    longitude: "8.708717",
    altitude: "76",
    timezone: "1",
    dst: "N",
    tz: "Africa/Malabo",
  },
  {
    id: "892",
    name: "Ascension Aux Af",
    city: "Wide Awake",
    country: "Saint Helena",
    iata: "",
    icao: "FHAW",
    latitude: "-7.969597",
    longitude: "-14.393664",
    altitude: "278",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/St_Helena",
  },
  {
    id: "893",
    name: "Sir Seewoosagur Ramgoolam Intl",
    city: "Plaisance",
    country: "Mauritius",
    iata: "MRU",
    icao: "FIMP",
    latitude: "-20.430235",
    longitude: "57.6836",
    altitude: "186",
    timezone: "4",
    dst: "N",
    tz: "Indian/Mauritius",
  },
  {
    id: "894",
    name: "Plaine Corail",
    city: "Rodriguez Island",
    country: "Mauritius",
    iata: "RRG",
    icao: "FIMR",
    latitude: "-19.757658",
    longitude: "63.360983",
    altitude: "95",
    timezone: "4",
    dst: "N",
    tz: "Indian/Mauritius",
  },
  {
    id: "895",
    name: "Diego Garcia Nsf",
    city: "Diego Garcia Island",
    country: "British Indian Ocean Territory",
    iata: "",
    icao: "FJDG",
    latitude: "-7.313267",
    longitude: "72.411089",
    altitude: "9",
    timezone: "6",
    dst: "U",
    tz: "Indian/Chagos",
  },
  {
    id: "896",
    name: "Tiko",
    city: "Tiko",
    country: "Cameroon",
    iata: "TKC",
    icao: "FKKC",
    latitude: "4.089192",
    longitude: "9.360528",
    altitude: "151",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "897",
    name: "Douala",
    city: "Douala",
    country: "Cameroon",
    iata: "DLA",
    icao: "FKKD",
    latitude: "4.006081",
    longitude: "9.719481",
    altitude: "33",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "898",
    name: "Salak",
    city: "Maroua",
    country: "Cameroon",
    iata: "MVR",
    icao: "FKKL",
    latitude: "10.451392",
    longitude: "14.257361",
    altitude: "1390",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "899",
    name: "Foumban Nkounja",
    city: "Foumban",
    country: "Cameroon",
    iata: "FOM",
    icao: "FKKM",
    latitude: "5.636919",
    longitude: "10.750817",
    altitude: "3963",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "900",
    name: "Ngaoundere",
    city: "N'gaoundere",
    country: "Cameroon",
    iata: "NGE",
    icao: "FKKN",
    latitude: "7.357011",
    longitude: "13.559242",
    altitude: "3655",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "901",
    name: "Garoua",
    city: "Garoua",
    country: "Cameroon",
    iata: "GOU",
    icao: "FKKR",
    latitude: "9.335892",
    longitude: "13.370103",
    altitude: "794",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "902",
    name: "Bafoussam",
    city: "Bafoussam",
    country: "Cameroon",
    iata: "BFX",
    icao: "FKKU",
    latitude: "5.536919",
    longitude: "10.354583",
    altitude: "4347",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "903",
    name: "Bamenda",
    city: "Bamenda",
    country: "Cameroon",
    iata: "BPC",
    icao: "FKKV",
    latitude: "6.039239",
    longitude: "10.122639",
    altitude: "4065",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "904",
    name: "Yaounde Ville",
    city: "Yaounde",
    country: "Cameroon",
    iata: "YAO",
    icao: "FKKY",
    latitude: "3.836039",
    longitude: "11.523461",
    altitude: "2464",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "905",
    name: "Kasompe",
    city: "Kasompe",
    country: "Zambia",
    iata: "",
    icao: "FLKE",
    latitude: "-12.572778",
    longitude: "27.89395",
    altitude: "4636",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "906",
    name: "Livingstone",
    city: "Livingstone",
    country: "Zambia",
    iata: "LVI",
    icao: "FLLI",
    latitude: "-17.821756",
    longitude: "25.822692",
    altitude: "3302",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "907",
    name: "Lusaka Intl",
    city: "Lusaka",
    country: "Zambia",
    iata: "LUN",
    icao: "FLLS",
    latitude: "-15.330817",
    longitude: "28.452628",
    altitude: "3779",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "908",
    name: "Mfuwe",
    city: "Mfuwe",
    country: "Zambia",
    iata: "MFU",
    icao: "FLMF",
    latitude: "-13.258878",
    longitude: "31.936581",
    altitude: "1853",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "909",
    name: "Mongu",
    city: "Mongu",
    country: "Zambia",
    iata: "",
    icao: "FLMG",
    latitude: "-15.254542",
    longitude: "23.162306",
    altitude: "3488",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "910",
    name: "Ndola",
    city: "Ndola",
    country: "Zambia",
    iata: "NLA",
    icao: "FLND",
    latitude: "-12.998139",
    longitude: "28.664944",
    altitude: "4167",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "911",
    name: "Southdowns",
    city: "Southdowns",
    country: "Zambia",
    iata: "KIW",
    icao: "FLSO",
    latitude: "-12.900469",
    longitude: "28.149858",
    altitude: "4145",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "912",
    name: "Prince Said Ibrahim",
    city: "Moroni",
    country: "Comoros",
    iata: "HAH",
    icao: "FMCH",
    latitude: "-11.533661",
    longitude: "43.27185",
    altitude: "93",
    timezone: "3",
    dst: "U",
    tz: "Indian/Comoro",
  },
  {
    id: "913",
    name: "Bandaressalam",
    city: "Moheli",
    country: "Comoros",
    iata: "NWA",
    icao: "FMCI",
    latitude: "-12.298108",
    longitude: "43.7664",
    altitude: "46",
    timezone: "3",
    dst: "U",
    tz: "Indian/Comoro",
  },
  {
    id: "914",
    name: "Ouani",
    city: "Anjouan",
    country: "Comoros",
    iata: "AJN",
    icao: "FMCV",
    latitude: "-12.131667",
    longitude: "44.430279",
    altitude: "62",
    timezone: "3",
    dst: "U",
    tz: "Indian/Comoro",
  },
  {
    id: "915",
    name: "Dzaoudzi Pamandzi",
    city: "Dzaoudzi",
    country: "Mayotte",
    iata: "DZA",
    icao: "FMCZ",
    latitude: "-12.804722",
    longitude: "45.281113",
    altitude: "23",
    timezone: "3",
    dst: "U",
    tz: "Indian/Mayotte",
  },
  {
    id: "916",
    name: "St Denis Gillot",
    city: "St.-denis",
    country: "Reunion",
    iata: "RUN",
    icao: "FMEE",
    latitude: "-20.8871",
    longitude: "55.510308",
    altitude: "66",
    timezone: "4",
    dst: "U",
    tz: "Indian/Reunion",
  },
  {
    id: "917",
    name: "St Pierre Pierrefonds",
    city: "St.-pierre",
    country: "Reunion",
    iata: "ZSE",
    icao: "FMEP",
    latitude: "-21.320039",
    longitude: "55.423581",
    altitude: "56",
    timezone: "4",
    dst: "U",
    tz: "Indian/Reunion",
  },
  {
    id: "918",
    name: "Ivato",
    city: "Antananarivo",
    country: "Madagascar",
    iata: "TNR",
    icao: "FMMI",
    latitude: "-18.79695",
    longitude: "47.478806",
    altitude: "4198",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "919",
    name: "Miandrivazo",
    city: "Miandrivazo",
    country: "Madagascar",
    iata: "ZVA",
    icao: "FMMN",
    latitude: "-19.562778",
    longitude: "45.450832",
    altitude: "203",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "920",
    name: "Sainte Marie",
    city: "Sainte Marie",
    country: "Madagascar",
    iata: "SMS",
    icao: "FMMS",
    latitude: "-17.093889",
    longitude: "49.815834",
    altitude: "7",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "921",
    name: "Toamasina",
    city: "Toamasina",
    country: "Madagascar",
    iata: "TMM",
    icao: "FMMT",
    latitude: "-18.109517",
    longitude: "49.392536",
    altitude: "22",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "922",
    name: "Morondava",
    city: "Morondava",
    country: "Madagascar",
    iata: "MOQ",
    icao: "FMMV",
    latitude: "-20.28475",
    longitude: "44.317614",
    altitude: "30",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "923",
    name: "Arrachart",
    city: "Antsiranana",
    country: "Madagascar",
    iata: "DIE",
    icao: "FMNA",
    latitude: "-12.3494",
    longitude: "49.291747",
    altitude: "374",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "924",
    name: "Avaratra",
    city: "Mananara",
    country: "Madagascar",
    iata: "WMR",
    icao: "FMNC",
    latitude: "-16.1639",
    longitude: "49.773753",
    altitude: "9",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "925",
    name: "Andapa",
    city: "Andapa",
    country: "Madagascar",
    iata: "ZWA",
    icao: "FMND",
    latitude: "-14.651667",
    longitude: "49.620556",
    altitude: "1552",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "926",
    name: "Ambilobe",
    city: "Ambilobe",
    country: "Madagascar",
    iata: "AMB",
    icao: "FMNE",
    latitude: "-13.188431",
    longitude: "48.987978",
    altitude: "72",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "927",
    name: "Antsirabato",
    city: "Antalaha",
    country: "Madagascar",
    iata: "ANM",
    icao: "FMNH",
    latitude: "-14.999411",
    longitude: "50.320233",
    altitude: "20",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "928",
    name: "Analalava",
    city: "Analalava",
    country: "Madagascar",
    iata: "HVA",
    icao: "FMNL",
    latitude: "-14.629694",
    longitude: "47.763783",
    altitude: "345",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "929",
    name: "Philibert Tsiranana",
    city: "Mahajanga",
    country: "Madagascar",
    iata: "MJN",
    icao: "FMNM",
    latitude: "-15.667144",
    longitude: "46.351828",
    altitude: "87",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "930",
    name: "Fascene",
    city: "Nosy-be",
    country: "Madagascar",
    iata: "NOS",
    icao: "FMNN",
    latitude: "-13.312067",
    longitude: "48.314822",
    altitude: "36",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "931",
    name: "Besalampy",
    city: "Besalampy",
    country: "Madagascar",
    iata: "BPY",
    icao: "FMNQ",
    latitude: "-16.741945",
    longitude: "44.481388",
    altitude: "125",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "932",
    name: "Maroantsetra",
    city: "Maroantsetra",
    country: "Madagascar",
    iata: "WMN",
    icao: "FMNR",
    latitude: "-15.436666",
    longitude: "49.688332",
    altitude: "13",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "933",
    name: "Sambava",
    city: "Sambava",
    country: "Madagascar",
    iata: "SVB",
    icao: "FMNS",
    latitude: "-14.278611",
    longitude: "50.174721",
    altitude: "20",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "934",
    name: "Vohimarina",
    city: "Vohemar",
    country: "Madagascar",
    iata: "VOH",
    icao: "FMNV",
    latitude: "-13.375834",
    longitude: "50.002777",
    altitude: "19",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "935",
    name: "Ambalabe",
    city: "Antsohihy",
    country: "Madagascar",
    iata: "WAI",
    icao: "FMNW",
    latitude: "-14.89875",
    longitude: "47.993894",
    altitude: "92",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "936",
    name: "Ampampamena",
    city: "Ampampamena",
    country: "Madagascar",
    iata: "",
    icao: "FMNZ",
    latitude: "-13.484814",
    longitude: "48.632739",
    altitude: "49",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "937",
    name: "Tolagnaro",
    city: "Tolagnaro",
    country: "Madagascar",
    iata: "FTU",
    icao: "FMSD",
    latitude: "-25.038056",
    longitude: "46.956111",
    altitude: "29",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "938",
    name: "Fianarantsoa",
    city: "Fianarantsoa",
    country: "Madagascar",
    iata: "WFI",
    icao: "FMSF",
    latitude: "-21.441558",
    longitude: "47.111736",
    altitude: "3658",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "939",
    name: "Farafangana",
    city: "Farafangana",
    country: "Madagascar",
    iata: "RVA",
    icao: "FMSG",
    latitude: "-22.805286",
    longitude: "47.820614",
    altitude: "26",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "940",
    name: "Manakara",
    city: "Manakara",
    country: "Madagascar",
    iata: "WVK",
    icao: "FMSK",
    latitude: "-22.119722",
    longitude: "48.021667",
    altitude: "33",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "941",
    name: "Mananjary",
    city: "Mananjary",
    country: "Madagascar",
    iata: "MNJ",
    icao: "FMSM",
    latitude: "-21.201772",
    longitude: "48.358317",
    altitude: "20",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "942",
    name: "Morombe",
    city: "Morombe",
    country: "Madagascar",
    iata: "MXM",
    icao: "FMSR",
    latitude: "-21.753867",
    longitude: "43.375533",
    altitude: "16",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "943",
    name: "Toliara",
    city: "Toliara",
    country: "Madagascar",
    iata: "TLE",
    icao: "FMST",
    latitude: "-23.383369",
    longitude: "43.728453",
    altitude: "29",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "944",
    name: "Mbanza Congo",
    city: "M'banza-congo",
    country: "Angola",
    iata: "SSY",
    icao: "FNBC",
    latitude: "-6.269897",
    longitude: "14.247025",
    altitude: "1860",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "945",
    name: "Benguela",
    city: "Benguela",
    country: "Angola",
    iata: "BUG",
    icao: "FNBG",
    latitude: "-12.609025",
    longitude: "13.403711",
    altitude: "118",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "946",
    name: "Cabinda",
    city: "Cabinda",
    country: "Angola",
    iata: "CAB",
    icao: "FNCA",
    latitude: "-5.596992",
    longitude: "12.188353",
    altitude: "66",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "6814",
    name: "Culebra Airport",
    city: "Culebra Island",
    country: "Puerto Rico",
    iata: "CPX",
    icao: "TJCP",
    latitude: "18.3127",
    longitude: "-65.3034",
    altitude: "12",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "948",
    name: "Huambo",
    city: "Huambo",
    country: "Angola",
    iata: "NOV",
    icao: "FNHU",
    latitude: "-12.808878",
    longitude: "15.760547",
    altitude: "5587",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "949",
    name: "Kuito",
    city: "Kuito",
    country: "Angola",
    iata: "SVP",
    icao: "FNKU",
    latitude: "-12.404633",
    longitude: "16.947414",
    altitude: "5618",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "950",
    name: "Lobito",
    city: "Lobito",
    country: "Angola",
    iata: "",
    icao: "FNLB",
    latitude: "-12.371233",
    longitude: "13.536625",
    altitude: "10",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "951",
    name: "Luanda 4 De Fevereiro",
    city: "Luanda",
    country: "Angola",
    iata: "LAD",
    icao: "FNLU",
    latitude: "-8.858375",
    longitude: "13.231178",
    altitude: "243",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "952",
    name: "Malanje",
    city: "Malanje",
    country: "Angola",
    iata: "MEG",
    icao: "FNMA",
    latitude: "-9.525086",
    longitude: "16.312406",
    altitude: "3868",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "953",
    name: "Menongue",
    city: "Menongue",
    country: "Angola",
    iata: "SPP",
    icao: "FNME",
    latitude: "-14.657583",
    longitude: "17.719833",
    altitude: "4469",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "955",
    name: "Negage",
    city: "Negage",
    country: "Angola",
    iata: "GXG",
    icao: "FNNG",
    latitude: "-7.754506",
    longitude: "15.287728",
    altitude: "4105",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "956",
    name: "Porto Amboim",
    city: "Porto Amboim",
    country: "Angola",
    iata: "PBN",
    icao: "FNPA",
    latitude: "-10.721956",
    longitude: "13.765528",
    altitude: "16",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "957",
    name: "Saurimo",
    city: "Saurimo",
    country: "Angola",
    iata: "VHC",
    icao: "FNSA",
    latitude: "-9.689067",
    longitude: "20.431875",
    altitude: "3584",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "958",
    name: "Soyo",
    city: "Soyo",
    country: "Angola",
    iata: "SZA",
    icao: "FNSO",
    latitude: "-6.141086",
    longitude: "12.371764",
    altitude: "15",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "959",
    name: "Lubango",
    city: "Lubango",
    country: "Angola",
    iata: "SDD",
    icao: "FNUB",
    latitude: "-14.924733",
    longitude: "13.575022",
    altitude: "5778",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "960",
    name: "Luena",
    city: "Luena",
    country: "Angola",
    iata: "LUO",
    icao: "FNUE",
    latitude: "-11.768086",
    longitude: "19.897672",
    altitude: "4360",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "961",
    name: "Uige",
    city: "Uige",
    country: "Angola",
    iata: "UGO",
    icao: "FNUG",
    latitude: "-7.603067",
    longitude: "15.027822",
    altitude: "2720",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "962",
    name: "Xangongo",
    city: "Xangongo",
    country: "Angola",
    iata: "XGN",
    icao: "FNXA",
    latitude: "-16.755417",
    longitude: "14.965344",
    altitude: "3635",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "963",
    name: "Oyem",
    city: "Oyem",
    country: "Gabon",
    iata: "OYE",
    icao: "FOGO",
    latitude: "1.543108",
    longitude: "11.581361",
    altitude: "2158",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "964",
    name: "Okondja",
    city: "Okondja",
    country: "Gabon",
    iata: "OKN",
    icao: "FOGQ",
    latitude: "-0.665214",
    longitude: "13.673133",
    altitude: "1325",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "965",
    name: "Lambarene",
    city: "Lambarene",
    country: "Gabon",
    iata: "LBQ",
    icao: "FOGR",
    latitude: "-0.704389",
    longitude: "10.245722",
    altitude: "82",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "966",
    name: "Bitam",
    city: "Bitam",
    country: "Gabon",
    iata: "BMM",
    icao: "FOOB",
    latitude: "2.075639",
    longitude: "11.493195",
    altitude: "1969",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "967",
    name: "Port Gentil",
    city: "Port Gentil",
    country: "Gabon",
    iata: "POG",
    icao: "FOOG",
    latitude: "-0.711739",
    longitude: "8.754383",
    altitude: "13",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "968",
    name: "Omboue Hopital",
    city: "Omboue Hospial",
    country: "Gabon",
    iata: "OMB",
    icao: "FOOH",
    latitude: "-1.574733",
    longitude: "9.262694",
    altitude: "33",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "969",
    name: "Makokou",
    city: "Makokou",
    country: "Gabon",
    iata: "MKU",
    icao: "FOOK",
    latitude: "0.579211",
    longitude: "12.890908",
    altitude: "1726",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "970",
    name: "Leon M Ba",
    city: "Libreville",
    country: "Gabon",
    iata: "LBV",
    icao: "FOOL",
    latitude: "0.4586",
    longitude: "9.412283",
    altitude: "39",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "971",
    name: "Mvengue",
    city: "Franceville",
    country: "Gabon",
    iata: "MVB",
    icao: "FOON",
    latitude: "-1.656156",
    longitude: "13.438036",
    altitude: "1450",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "972",
    name: "Principe",
    city: "Principe",
    country: "Sao Tome and Principe",
    iata: "PCP",
    icao: "FPPR",
    latitude: "1.662936",
    longitude: "7.411742",
    altitude: "591",
    timezone: "0",
    dst: "N",
    tz: "Africa/Sao_Tome",
  },
  {
    id: "973",
    name: "Sao Tome Intl",
    city: "Sao Tome",
    country: "Sao Tome and Principe",
    iata: "TMS",
    icao: "FPST",
    latitude: "0.378175",
    longitude: "6.712153",
    altitude: "33",
    timezone: "0",
    dst: "N",
    tz: "Africa/Sao_Tome",
  },
  {
    id: "974",
    name: "Beira",
    city: "Beira",
    country: "Mozambique",
    iata: "BEW",
    icao: "FQBR",
    latitude: "-19.796419",
    longitude: "34.907556",
    altitude: "33",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "976",
    name: "Inhambane",
    city: "Inhambane",
    country: "Mozambique",
    iata: "INH",
    icao: "FQIN",
    latitude: "-23.876431",
    longitude: "35.408544",
    altitude: "30",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "977",
    name: "Lichinga",
    city: "Lichinga",
    country: "Mozambique",
    iata: "VXC",
    icao: "FQLC",
    latitude: "-13.273986",
    longitude: "35.266262",
    altitude: "4505",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "978",
    name: "Lumbo",
    city: "Lumbo",
    country: "Mozambique",
    iata: "",
    icao: "FQLU",
    latitude: "-15.033058",
    longitude: "40.671728",
    altitude: "33",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "979",
    name: "Maputo",
    city: "Maputo",
    country: "Mozambique",
    iata: "MPM",
    icao: "FQMA",
    latitude: "-25.920836",
    longitude: "32.572606",
    altitude: "145",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "980",
    name: "Mueda",
    city: "Mueda",
    country: "Mozambique",
    iata: "",
    icao: "FQMD",
    latitude: "-11.672922",
    longitude: "39.563142",
    altitude: "2789",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "981",
    name: "Mocimboa Da Praia",
    city: "Mocimboa Da Praia",
    country: "Mozambique",
    iata: "MZB",
    icao: "FQMP",
    latitude: "-11.361789",
    longitude: "40.354875",
    altitude: "89",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "982",
    name: "Marrupa",
    city: "Marrupa",
    country: "Mozambique",
    iata: "",
    icao: "FQMR",
    latitude: "-13.225053",
    longitude: "37.552067",
    altitude: "2480",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "983",
    name: "Nacala",
    city: "Nacala",
    country: "Mozambique",
    iata: "MNC",
    icao: "FQNC",
    latitude: "-14.488233",
    longitude: "40.71225",
    altitude: "410",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "984",
    name: "Nampula",
    city: "Nampula",
    country: "Mozambique",
    iata: "APL",
    icao: "FQNP",
    latitude: "-15.105611",
    longitude: "39.2818",
    altitude: "1444",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "985",
    name: "Pemba",
    city: "Pemba",
    country: "Mozambique",
    iata: "POL",
    icao: "FQPB",
    latitude: "-12.986753",
    longitude: "40.522492",
    altitude: "331",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "986",
    name: "Quelimane",
    city: "Quelimane",
    country: "Mozambique",
    iata: "UEL",
    icao: "FQQL",
    latitude: "-17.8555",
    longitude: "36.869106",
    altitude: "36",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "987",
    name: "Songo",
    city: "Songo",
    country: "Mozambique",
    iata: "",
    icao: "FQSG",
    latitude: "-15.602694",
    longitude: "32.773189",
    altitude: "2904",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "988",
    name: "Tete Chingodzi",
    city: "Tete",
    country: "Mozambique",
    iata: "TET",
    icao: "FQTT",
    latitude: "-16.104817",
    longitude: "33.640181",
    altitude: "525",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "989",
    name: "Ulongwe",
    city: "Ulongwe",
    country: "Mozambique",
    iata: "",
    icao: "FQUG",
    latitude: "-14.704617",
    longitude: "34.352369",
    altitude: "4265",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "990",
    name: "Vilankulo",
    city: "Vilankulu",
    country: "Mozambique",
    iata: "VNX",
    icao: "FQVL",
    latitude: "-22.018431",
    longitude: "35.313297",
    altitude: "46",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "991",
    name: "Alphonse",
    city: "Alphonse",
    country: "Seychelles",
    iata: "",
    icao: "FSAL",
    latitude: "-7.004783",
    longitude: "52.726247",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "992",
    name: "Desroches",
    city: "Desroches",
    country: "Seychelles",
    iata: "DES",
    icao: "FSDR",
    latitude: "-5.696697",
    longitude: "53.655844",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "993",
    name: "Farquhar",
    city: "Farquhar",
    country: "Seychelles",
    iata: "",
    icao: "FSFA",
    latitude: "-10.109611",
    longitude: "51.176119",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "994",
    name: "Seychelles Intl",
    city: "Mahe",
    country: "Seychelles",
    iata: "SEZ",
    icao: "FSIA",
    latitude: "-4.674342",
    longitude: "55.521839",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "995",
    name: "Praslin",
    city: "Praslin",
    country: "Seychelles",
    iata: "PRI",
    icao: "FSPP",
    latitude: "-4.319292",
    longitude: "55.691417",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "996",
    name: "Coetivy",
    city: "Coetivy",
    country: "Seychelles",
    iata: "",
    icao: "FSSC",
    latitude: "-7.134567",
    longitude: "56.278239",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "997",
    name: "Abeche",
    city: "Abeche",
    country: "Chad",
    iata: "AEH",
    icao: "FTTC",
    latitude: "13.847",
    longitude: "20.844333",
    altitude: "1788",
    timezone: "1",
    dst: "N",
    tz: "Africa/Ndjamena",
  },
  {
    id: "998",
    name: "Moundou",
    city: "Moundou",
    country: "Chad",
    iata: "MQQ",
    icao: "FTTD",
    latitude: "8.624406",
    longitude: "16.071419",
    altitude: "1407",
    timezone: "1",
    dst: "N",
    tz: "Africa/Ndjamena",
  },
  {
    id: "999",
    name: "Ndjamena Hassan Djamous",
    city: "N'djamena",
    country: "Chad",
    iata: "NDJ",
    icao: "FTTJ",
    latitude: "12.133689",
    longitude: "15.034019",
    altitude: "968",
    timezone: "1",
    dst: "N",
    tz: "Africa/Ndjamena",
  },
  {
    id: "1000",
    name: "Faya Largeau",
    city: "Faya-largeau",
    country: "Chad",
    iata: "FYT",
    icao: "FTTY",
    latitude: "17.917053",
    longitude: "19.111078",
    altitude: "771",
    timezone: "1",
    dst: "N",
    tz: "Africa/Ndjamena",
  },
  {
    id: "1001",
    name: "J M Nkomo Intl",
    city: "Bulawayo",
    country: "Zimbabwe",
    iata: "BUQ",
    icao: "FVBU",
    latitude: "-20.017431",
    longitude: "28.617869",
    altitude: "4359",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1002",
    name: "Charles Prince",
    city: "Harare",
    country: "Zimbabwe",
    iata: "",
    icao: "FVCP",
    latitude: "-17.751561",
    longitude: "30.924706",
    altitude: "4845",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1003",
    name: "Buffalo Range",
    city: "Chiredzi",
    country: "Zimbabwe",
    iata: "BFO",
    icao: "FVCZ",
    latitude: "-21.008083",
    longitude: "31.57855",
    altitude: "1421",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1004",
    name: "Victoria Falls Intl",
    city: "Victoria Falls",
    country: "Zimbabwe",
    iata: "VFA",
    icao: "FVFA",
    latitude: "-18.095881",
    longitude: "25.839006",
    altitude: "3490",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1005",
    name: "Harare Intl",
    city: "Harare",
    country: "Zimbabwe",
    iata: "HRE",
    icao: "FVHA",
    latitude: "-17.931806",
    longitude: "31.092847",
    altitude: "4887",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1006",
    name: "Kariba Intl",
    city: "Kariba",
    country: "Zimbabwe",
    iata: "KAB",
    icao: "FVKB",
    latitude: "-16.519761",
    longitude: "28.884981",
    altitude: "1706",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1007",
    name: "Mutoko",
    city: "Mutoko",
    country: "Zimbabwe",
    iata: "",
    icao: "FVMT",
    latitude: "-17.431917",
    longitude: "32.184502",
    altitude: "3950",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1008",
    name: "Mutare",
    city: "Mutare",
    country: "Zimbabwe",
    iata: "",
    icao: "FVMU",
    latitude: "-18.997499",
    longitude: "32.627224",
    altitude: "3410",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1009",
    name: "Masvingo Intl",
    city: "Masvingo",
    country: "Zimbabwe",
    iata: "MVZ",
    icao: "FVMV",
    latitude: "-20.055333",
    longitude: "30.859111",
    altitude: "3595",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1010",
    name: "Zvishavane",
    city: "Zvishavane",
    country: "Zimbabwe",
    iata: "",
    icao: "FVSH",
    latitude: "-20.289497",
    longitude: "30.088228",
    altitude: "3012",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1011",
    name: "Gweru Thornhill",
    city: "Gwert",
    country: "Zimbabwe",
    iata: "GWE",
    icao: "FVTL",
    latitude: "-19.436394",
    longitude: "29.861911",
    altitude: "4680",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1012",
    name: "Hwange National Park",
    city: "Hwange National Park",
    country: "Zimbabwe",
    iata: "WKM",
    icao: "FVWN",
    latitude: "-18.629872",
    longitude: "27.021042",
    altitude: "3543",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "1013",
    name: "Chileka Intl",
    city: "Blantyre",
    country: "Malawi",
    iata: "BLZ",
    icao: "FWCL",
    latitude: "-15.679053",
    longitude: "34.974014",
    altitude: "2555",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "1014",
    name: "Karonga",
    city: "Karonga",
    country: "Malawi",
    iata: "KGJ",
    icao: "FWKA",
    latitude: "-9.953569",
    longitude: "33.893022",
    altitude: "1765",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "1015",
    name: "Kasungu",
    city: "Kasungu",
    country: "Malawi",
    iata: "",
    icao: "FWKG",
    latitude: "-13.014631",
    longitude: "33.468597",
    altitude: "3470",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "1016",
    name: "Kamuzu Intl",
    city: "Lilongwe",
    country: "Malawi",
    iata: "LLW",
    icao: "FWKI",
    latitude: "-13.789378",
    longitude: "33.781",
    altitude: "4035",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "1017",
    name: "Mzuzu",
    city: "Mzuzu",
    country: "Malawi",
    iata: "ZZU",
    icao: "FWUU",
    latitude: "-11.44475",
    longitude: "34.011776",
    altitude: "4115",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "1018",
    name: "Moshoeshoe I Intl",
    city: "Maseru",
    country: "Lesotho",
    iata: "MSU",
    icao: "FXMM",
    latitude: "-29.462256",
    longitude: "27.552503",
    altitude: "5348",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maseru",
  },
  {
    id: "1019",
    name: "Mejametalana",
    city: "Maseru",
    country: "Lesotho",
    iata: "",
    icao: "FXMU",
    latitude: "-29.304053",
    longitude: "27.503458",
    altitude: "5105",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maseru",
  },
  {
    id: "1020",
    name: "Ndjili Intl",
    city: "Kinshasa",
    country: "Congo (Kinshasa)",
    iata: "FIH",
    icao: "FZAA",
    latitude: "-4.38575",
    longitude: "15.444569",
    altitude: "1027",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1021",
    name: "Ndolo",
    city: "Kinshasa",
    country: "Congo (Kinshasa)",
    iata: "NLO",
    icao: "FZAB",
    latitude: "-4.326689",
    longitude: "15.327342",
    altitude: "915",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1022",
    name: "Muanda",
    city: "Muanda",
    country: "Congo (Kinshasa)",
    iata: "MNB",
    icao: "FZAG",
    latitude: "-5.930858",
    longitude: "12.351789",
    altitude: "89",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1023",
    name: "Kitona Base",
    city: "Kitona Base",
    country: "Congo (Kinshasa)",
    iata: "",
    icao: "FZAI",
    latitude: "-5.918056",
    longitude: "12.447694",
    altitude: "394",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1024",
    name: "Bandundu",
    city: "Bandoundu",
    country: "Congo (Kinshasa)",
    iata: "FDU",
    icao: "FZBO",
    latitude: "-3.311319",
    longitude: "17.381683",
    altitude: "1053",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1025",
    name: "Kikwit",
    city: "Kikwit",
    country: "Congo (Kinshasa)",
    iata: "KKW",
    icao: "FZCA",
    latitude: "-5.035767",
    longitude: "18.785631",
    altitude: "1572",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1026",
    name: "Mbandaka",
    city: "Mbandaka",
    country: "Congo (Kinshasa)",
    iata: "MDK",
    icao: "FZEA",
    latitude: "0.0226",
    longitude: "18.288744",
    altitude: "1040",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1027",
    name: "Gbadolite",
    city: "Gbadolite",
    country: "Congo (Kinshasa)",
    iata: "BDT",
    icao: "FZFD",
    latitude: "4.253206",
    longitude: "20.975283",
    altitude: "1509",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1028",
    name: "Gemena",
    city: "Gemena",
    country: "Congo (Kinshasa)",
    iata: "GMA",
    icao: "FZFK",
    latitude: "3.235369",
    longitude: "19.771258",
    altitude: "1378",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1029",
    name: "Kotakoli",
    city: "Kotakoli",
    country: "Congo (Kinshasa)",
    iata: "",
    icao: "FZFP",
    latitude: "4.157639",
    longitude: "21.650917",
    altitude: "1801",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1030",
    name: "Lisala",
    city: "Lisala",
    country: "Congo (Kinshasa)",
    iata: "LIQ",
    icao: "FZGA",
    latitude: "2.170658",
    longitude: "21.496906",
    altitude: "1509",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "1031",
    name: "Kisangani Simisini",
    city: "Kisangani",
    country: "Congo (Kinshasa)",
    iata: "FKI",
    icao: "FZIA",
    latitude: "0.5175",
    longitude: "25.155014",
    altitude: "1289",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1032",
    name: "Matari",
    city: "Isiro",
    country: "Congo (Kinshasa)",
    iata: "IRP",
    icao: "FZJH",
    latitude: "2.827606",
    longitude: "27.588253",
    altitude: "2438",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1033",
    name: "Bunia",
    city: "Bunia",
    country: "Congo (Kinshasa)",
    iata: "BUX",
    icao: "FZKA",
    latitude: "1.565719",
    longitude: "30.220833",
    altitude: "4045",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1034",
    name: "Buta Zega",
    city: "Buta Zega",
    country: "Congo (Kinshasa)",
    iata: "",
    icao: "FZKJ",
    latitude: "2.818347",
    longitude: "24.793706",
    altitude: "1378",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1035",
    name: "Bukavu Kavumu",
    city: "Bukavu/kavumu",
    country: "Congo (Kinshasa)",
    iata: "BKY",
    icao: "FZMA",
    latitude: "-2.308978",
    longitude: "28.808803",
    altitude: "5643",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1036",
    name: "Goma",
    city: "Goma",
    country: "Congo (Kinshasa)",
    iata: "GOM",
    icao: "FZNA",
    latitude: "-1.670814",
    longitude: "29.238464",
    altitude: "5089",
    timezone: "2",
    dst: "U",
    tz: "Africa/Kigali",
  },
  {
    id: "1037",
    name: "Kindu",
    city: "Kindu",
    country: "Congo (Kinshasa)",
    iata: "KND",
    icao: "FZOA",
    latitude: "-2.919178",
    longitude: "25.915361",
    altitude: "1630",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1038",
    name: "Lubumbashi Intl",
    city: "Lubumashi",
    country: "Congo (Kinshasa)",
    iata: "FBM",
    icao: "FZQA",
    latitude: "-11.591333",
    longitude: "27.530889",
    altitude: "4295",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1039",
    name: "Kolwezi",
    city: "Kolwezi",
    country: "Congo (Kinshasa)",
    iata: "KWZ",
    icao: "FZQM",
    latitude: "-10.765886",
    longitude: "25.505714",
    altitude: "5007",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1040",
    name: "Kalemie",
    city: "Kalemie",
    country: "Congo (Kinshasa)",
    iata: "FMI",
    icao: "FZRF",
    latitude: "-5.875556",
    longitude: "29.25",
    altitude: "2569",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1041",
    name: "Kamina Base",
    city: "Kamina Base",
    country: "Congo (Kinshasa)",
    iata: "KMN",
    icao: "FZSA",
    latitude: "-8.642025",
    longitude: "25.252897",
    altitude: "3543",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1042",
    name: "Kananga",
    city: "Kananga",
    country: "Congo (Kinshasa)",
    iata: "KGA",
    icao: "FZUA",
    latitude: "-5.900055",
    longitude: "22.469166",
    altitude: "2139",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1043",
    name: "Mbuji Mayi",
    city: "Mbuji-mayi",
    country: "Congo (Kinshasa)",
    iata: "MJM",
    icao: "FZWA",
    latitude: "-6.121236",
    longitude: "23.569008",
    altitude: "2221",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "1044",
    name: "Senou",
    city: "Bamako",
    country: "Mali",
    iata: "BKO",
    icao: "GABS",
    latitude: "12.533544",
    longitude: "-7.949944",
    altitude: "1247",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "1045",
    name: "Gao",
    city: "Gao",
    country: "Mali",
    iata: "GAQ",
    icao: "GAGO",
    latitude: "16.248433",
    longitude: "-0.005456",
    altitude: "870",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "1046",
    name: "Kayes Dag Dag",
    city: "Kayes",
    country: "Mali",
    iata: "KYS",
    icao: "GAKY",
    latitude: "14.481233",
    longitude: "-11.404397",
    altitude: "164",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "1047",
    name: "Ambodedjo",
    city: "Mopti",
    country: "Mali",
    iata: "MZI",
    icao: "GAMB",
    latitude: "14.512803",
    longitude: "-4.079561",
    altitude: "906",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "1048",
    name: "Tombouctou",
    city: "Tombouctou",
    country: "Mali",
    iata: "TOM",
    icao: "GATB",
    latitude: "16.730458",
    longitude: "-3.007583",
    altitude: "863",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "1049",
    name: "Tessalit",
    city: "Tessalit",
    country: "Mali",
    iata: "",
    icao: "GATS",
    latitude: "20.242983",
    longitude: "0.977308",
    altitude: "1621",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "1050",
    name: "Banjul Intl",
    city: "Banjul",
    country: "Gambia",
    iata: "BJL",
    icao: "GBYD",
    latitude: "13.337961",
    longitude: "-16.652206",
    altitude: "95",
    timezone: "0",
    dst: "N",
    tz: "Africa/Banjul",
  },
  {
    id: "1051",
    name: "Fuerteventura",
    city: "Fuerteventura",
    country: "Spain",
    iata: "FUE",
    icao: "GCFV",
    latitude: "28.452717",
    longitude: "-13.863761",
    altitude: "83",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1052",
    name: "Hierro",
    city: "Hierro",
    country: "Spain",
    iata: "VDE",
    icao: "GCHI",
    latitude: "27.814847",
    longitude: "-17.887056",
    altitude: "103",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1053",
    name: "La Palma",
    city: "Santa Cruz De La Palma",
    country: "Spain",
    iata: "SPC",
    icao: "GCLA",
    latitude: "28.626478",
    longitude: "-17.755611",
    altitude: "107",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1054",
    name: "Gran Canaria",
    city: "Gran Canaria",
    country: "Spain",
    iata: "LPA",
    icao: "GCLP",
    latitude: "27.931886",
    longitude: "-15.386586",
    altitude: "78",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1055",
    name: "Lanzarote",
    city: "Las Palmas",
    country: "Spain",
    iata: "ACE",
    icao: "GCRR",
    latitude: "28.945464",
    longitude: "-13.605225",
    altitude: "47",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1056",
    name: "Tenerife Sur",
    city: "Tenerife",
    country: "Spain",
    iata: "TFS",
    icao: "GCTS",
    latitude: "28.044475",
    longitude: "-16.572489",
    altitude: "209",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1057",
    name: "Tenerife Norte",
    city: "Tenerife",
    country: "Spain",
    iata: "TFN",
    icao: "GCXO",
    latitude: "28.482653",
    longitude: "-16.341536",
    altitude: "2073",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "1058",
    name: "Melilla",
    city: "Melilla",
    country: "Spain",
    iata: "MLN",
    icao: "GEML",
    latitude: "35.279817",
    longitude: "-2.956256",
    altitude: "156",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1059",
    name: "Freetown Lungi",
    city: "Freetown",
    country: "Sierra Leone",
    iata: "FNA",
    icao: "GFLL",
    latitude: "8.616444",
    longitude: "-13.195489",
    altitude: "84",
    timezone: "0",
    dst: "N",
    tz: "Africa/Freetown",
  },
  {
    id: "1060",
    name: "Cufar",
    city: "Cufar",
    country: "Guinea-Bissau",
    iata: "",
    icao: "GGCF",
    latitude: "11.287917",
    longitude: "-15.1805",
    altitude: "65",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bissau",
  },
  {
    id: "1062",
    name: "Monrovia Spriggs Payne",
    city: "Monrovia",
    country: "Liberia",
    iata: "MLW",
    icao: "GLMR",
    latitude: "6.289061",
    longitude: "-10.758722",
    altitude: "25",
    timezone: "0",
    dst: "N",
    tz: "Africa/Monrovia",
  },
  {
    id: "1063",
    name: "Monrovia Roberts Intl",
    city: "Monrovia",
    country: "Liberia",
    iata: "ROB",
    icao: "GLRB",
    latitude: "6.233789",
    longitude: "-10.362311",
    altitude: "31",
    timezone: "0",
    dst: "N",
    tz: "Africa/Monrovia",
  },
  {
    id: "1064",
    name: "Inezgane",
    city: "Agadir",
    country: "Morocco",
    iata: "AGA",
    icao: "GMAA",
    latitude: "30.381353",
    longitude: "-9.546311",
    altitude: "89",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1065",
    name: "Plage Blanche",
    city: "Tan Tan",
    country: "Morocco",
    iata: "TTA",
    icao: "GMAT",
    latitude: "28.448194",
    longitude: "-11.161347",
    altitude: "653",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1066",
    name: "Saiss",
    city: "Fes",
    country: "Morocco",
    iata: "FEZ",
    icao: "GMFF",
    latitude: "33.927261",
    longitude: "-4.977958",
    altitude: "1900",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1067",
    name: "Ifrane",
    city: "Ifrane",
    country: "Morocco",
    iata: "",
    icao: "GMFI",
    latitude: "33.505319",
    longitude: "-5.152903",
    altitude: "5459",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1068",
    name: "Moulay Ali Cherif",
    city: "Er-rachidia",
    country: "Morocco",
    iata: "ERH",
    icao: "GMFK",
    latitude: "31.9475",
    longitude: "-4.398333",
    altitude: "3428",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1069",
    name: "Bassatine",
    city: "Meknes",
    country: "Morocco",
    iata: "MEK",
    icao: "GMFM",
    latitude: "33.879067",
    longitude: "-5.515125",
    altitude: "1890",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1070",
    name: "Angads",
    city: "Oujda",
    country: "Morocco",
    iata: "OUD",
    icao: "GMFO",
    latitude: "34.78715",
    longitude: "-1.923986",
    altitude: "1535",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1071",
    name: "Ben Slimane",
    city: "Ben Slimane",
    country: "Morocco",
    iata: "",
    icao: "GMMB",
    latitude: "33.655422",
    longitude: "-7.22145",
    altitude: "627",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1072",
    name: "Sale",
    city: "Rabat",
    country: "Morocco",
    iata: "RBA",
    icao: "GMME",
    latitude: "34.051467",
    longitude: "-6.751519",
    altitude: "276",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1074",
    name: "Mohammed V Intl",
    city: "Casablanca",
    country: "Morocco",
    iata: "CMN",
    icao: "GMMN",
    latitude: "33.367467",
    longitude: "-7.589967",
    altitude: "656",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1075",
    name: "Menara",
    city: "Marrakech",
    country: "Morocco",
    iata: "RAK",
    icao: "GMMX",
    latitude: "31.606886",
    longitude: "-8.0363",
    altitude: "1545",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1076",
    name: "Kenitra",
    city: "Kentira",
    country: "Morocco",
    iata: "NNA",
    icao: "GMMY",
    latitude: "34.298864",
    longitude: "-6.595878",
    altitude: "16",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1077",
    name: "Ouarzazate",
    city: "Ouarzazate",
    country: "Morocco",
    iata: "OZZ",
    icao: "GMMZ",
    latitude: "30.939053",
    longitude: "-6.909431",
    altitude: "3782",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1078",
    name: "Cherif El Idrissi",
    city: "Al Hociema",
    country: "Morocco",
    iata: "AHU",
    icao: "GMTA",
    latitude: "35.177103",
    longitude: "-3.839525",
    altitude: "95",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1079",
    name: "Saniat Rmel",
    city: "Tetouan",
    country: "Morocco",
    iata: "TTU",
    icao: "GMTN",
    latitude: "35.594333",
    longitude: "-5.320019",
    altitude: "10",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1080",
    name: "Ibn Batouta",
    city: "Tanger",
    country: "Morocco",
    iata: "TNG",
    icao: "GMTT",
    latitude: "35.726917",
    longitude: "-5.916889",
    altitude: "62",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "1081",
    name: "Ziguinchor",
    city: "Ziguinchor",
    country: "Senegal",
    iata: "ZIG",
    icao: "GOGG",
    latitude: "12.555617",
    longitude: "-16.281783",
    altitude: "75",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1082",
    name: "Cap Skiring",
    city: "Cap Skiring",
    country: "Senegal",
    iata: "CSK",
    icao: "GOGS",
    latitude: "12.4102",
    longitude: "-16.746125",
    altitude: "52",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1083",
    name: "Kaolack",
    city: "Kaolack",
    country: "Senegal",
    iata: "KLC",
    icao: "GOOK",
    latitude: "14.146881",
    longitude: "-16.051297",
    altitude: "26",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1084",
    name: "Leopold Sedar Senghor Intl",
    city: "Dakar",
    country: "Senegal",
    iata: "DKR",
    icao: "GOOY",
    latitude: "14.739708",
    longitude: "-17.490225",
    altitude: "85",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1085",
    name: "Saint Louis",
    city: "St. Louis",
    country: "Senegal",
    iata: "XLS",
    icao: "GOSS",
    latitude: "16.050761",
    longitude: "-16.463172",
    altitude: "9",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1086",
    name: "Bakel",
    city: "Bakel",
    country: "Senegal",
    iata: "BXE",
    icao: "GOTB",
    latitude: "14.847256",
    longitude: "-12.468264",
    altitude: "98",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1087",
    name: "Kedougou",
    city: "Kedougou",
    country: "Senegal",
    iata: "KGG",
    icao: "GOTK",
    latitude: "12.572292",
    longitude: "-12.220333",
    altitude: "584",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1088",
    name: "Tambacounda",
    city: "Tambacounda",
    country: "Senegal",
    iata: "TUD",
    icao: "GOTT",
    latitude: "13.736817",
    longitude: "-13.653122",
    altitude: "161",
    timezone: "0",
    dst: "N",
    tz: "Africa/Dakar",
  },
  {
    id: "1089",
    name: "Aioun El Atrouss",
    city: "Aioun El Atrouss",
    country: "Mauritania",
    iata: "IEO",
    icao: "GQNA",
    latitude: "16.711294",
    longitude: "-9.637883",
    altitude: "951",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1090",
    name: "Tidjikja",
    city: "Tidjikja",
    country: "Mauritania",
    iata: "TIY",
    icao: "GQND",
    latitude: "18.570103",
    longitude: "-11.423547",
    altitude: "1316",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1091",
    name: "Kiffa",
    city: "Kiffa",
    country: "Mauritania",
    iata: "KFA",
    icao: "GQNF",
    latitude: "16.589983",
    longitude: "-11.406208",
    altitude: "423",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1092",
    name: "Nema",
    city: "Nema",
    country: "Mauritania",
    iata: "EMN",
    icao: "GQNI",
    latitude: "16.622",
    longitude: "-7.316567",
    altitude: "758",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1093",
    name: "Kaedi",
    city: "Kaedi",
    country: "Mauritania",
    iata: "KED",
    icao: "GQNK",
    latitude: "16.159547",
    longitude: "-13.507617",
    altitude: "75",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1094",
    name: "Nouakchott",
    city: "Nouakschott",
    country: "Mauritania",
    iata: "NKC",
    icao: "GQNN",
    latitude: "18.097856",
    longitude: "-15.947956",
    altitude: "7",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1095",
    name: "Selibady",
    city: "Selibabi",
    country: "Mauritania",
    iata: "SEY",
    icao: "GQNS",
    latitude: "15.179692",
    longitude: "-12.207272",
    altitude: "262",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1096",
    name: "Atar",
    city: "Atar",
    country: "Mauritania",
    iata: "ATR",
    icao: "GQPA",
    latitude: "20.506828",
    longitude: "-13.043194",
    altitude: "758",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1097",
    name: "Nouadhibou",
    city: "Nouadhibou",
    country: "Mauritania",
    iata: "NDB",
    icao: "GQPP",
    latitude: "20.933067",
    longitude: "-17.029956",
    altitude: "16",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1098",
    name: "Bir Moghrein",
    city: "Bir Moghrein",
    country: "Mauritania",
    iata: "",
    icao: "GQPT",
    latitude: "25.236697",
    longitude: "-11.588697",
    altitude: "1194",
    timezone: "0",
    dst: "N",
    tz: "Africa/Nouakchott",
  },
  {
    id: "1099",
    name: "Fria",
    city: "Fira",
    country: "Guinea",
    iata: "FIG",
    icao: "GUFA",
    latitude: "10.350556",
    longitude: "-13.569167",
    altitude: "499",
    timezone: "0",
    dst: "N",
    tz: "Africa/Conakry",
  },
  {
    id: "1100",
    name: "Faranah",
    city: "Faranah",
    country: "Guinea",
    iata: "FAA",
    icao: "GUFH",
    latitude: "10.035467",
    longitude: "-10.769825",
    altitude: "1476",
    timezone: "0",
    dst: "N",
    tz: "Africa/Conakry",
  },
  {
    id: "1101",
    name: "Labe",
    city: "Labe",
    country: "Guinea",
    iata: "LEK",
    icao: "GULB",
    latitude: "11.326058",
    longitude: "-12.28685",
    altitude: "3396",
    timezone: "0",
    dst: "N",
    tz: "Africa/Conakry",
  },
  {
    id: "1102",
    name: "Amilcar Cabral Intl",
    city: "Amilcar Cabral",
    country: "Cape Verde",
    iata: "SID",
    icao: "GVAC",
    latitude: "16.741389",
    longitude: "-22.949444",
    altitude: "177",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "1103",
    name: "Rabil",
    city: "Boa Vista",
    country: "Cape Verde",
    iata: "BVC",
    icao: "GVBA",
    latitude: "16.136531",
    longitude: "-22.888897",
    altitude: "69",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "1104",
    name: "Maio",
    city: "Maio",
    country: "Cape Verde",
    iata: "MMO",
    icao: "GVMA",
    latitude: "15.155928",
    longitude: "-23.213703",
    altitude: "36",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "1105",
    name: "Preguica",
    city: "Sao Nocolau Island",
    country: "Cape Verde",
    iata: "SNE",
    icao: "GVSN",
    latitude: "16.588356",
    longitude: "-24.284656",
    altitude: "669",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "1106",
    name: "Sao Pedro",
    city: "Sao Vicente Island",
    country: "Cape Verde",
    iata: "VXE",
    icao: "GVSV",
    latitude: "16.833689",
    longitude: "-25.054661",
    altitude: "66",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "1107",
    name: "Bole Intl",
    city: "Addis Ababa",
    country: "Ethiopia",
    iata: "ADD",
    icao: "HAAB",
    latitude: "8.977889",
    longitude: "38.799319",
    altitude: "7656",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1108",
    name: "Lideta",
    city: "Addis Ababa",
    country: "Ethiopia",
    iata: "",
    icao: "HAAL",
    latitude: "9.003681",
    longitude: "38.726019",
    altitude: "7749",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1109",
    name: "Arba Minch",
    city: "Arba Minch",
    country: "Ethiopia",
    iata: "AMH",
    icao: "HAAM",
    latitude: "6.039389",
    longitude: "37.590453",
    altitude: "3895",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1110",
    name: "Axum",
    city: "Axum",
    country: "Ethiopia",
    iata: "AXU",
    icao: "HAAX",
    latitude: "14.14675",
    longitude: "38.772833",
    altitude: "6915",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1111",
    name: "Bahir Dar",
    city: "Bahar Dar",
    country: "Ethiopia",
    iata: "BJR",
    icao: "HABD",
    latitude: "11.608075",
    longitude: "37.321644",
    altitude: "5976",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1112",
    name: "Dire Dawa Intl",
    city: "Dire Dawa",
    country: "Ethiopia",
    iata: "DIR",
    icao: "HADR",
    latitude: "9.6247",
    longitude: "41.854203",
    altitude: "3829",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1113",
    name: "Gambella",
    city: "Gambella",
    country: "Ethiopia",
    iata: "GMB",
    icao: "HAGM",
    latitude: "8.128764",
    longitude: "34.563131",
    altitude: "1771",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1114",
    name: "Gondar",
    city: "Gondar",
    country: "Ethiopia",
    iata: "GDQ",
    icao: "HAGN",
    latitude: "12.5199",
    longitude: "37.434047",
    altitude: "6541",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "6811",
    name: "South Ari Atoll",
    city: "Paradies Island",
    country: "Maldives",
    iata: "",
    icao: "ARIA",
    latitude: "3.4833",
    longitude: "72.8369",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "1116",
    name: "Jimma",
    city: "Jimma",
    country: "Ethiopia",
    iata: "JIM",
    icao: "HAJM",
    latitude: "7.666094",
    longitude: "36.816639",
    altitude: "5587",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1117",
    name: "Lalibella",
    city: "Lalibella",
    country: "Ethiopia",
    iata: "LLI",
    icao: "HALL",
    latitude: "11.975014",
    longitude: "38.979969",
    altitude: "6423",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1118",
    name: "Makale",
    city: "Makale",
    country: "Ethiopia",
    iata: "MQX",
    icao: "HAMK",
    latitude: "13.467367",
    longitude: "39.533464",
    altitude: "7406",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1119",
    name: "Asosa",
    city: "Asosa",
    country: "Ethiopia",
    iata: "ASO",
    icao: "HASO",
    latitude: "10.01855",
    longitude: "34.586253",
    altitude: "5120",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "1120",
    name: "Bujumbura Intl",
    city: "Bujumbura",
    country: "Burundi",
    iata: "BJM",
    icao: "HBBA",
    latitude: "-3.324019",
    longitude: "29.318519",
    altitude: "2582",
    timezone: "2",
    dst: "U",
    tz: "Africa/Bujumbura",
  },
  {
    id: "1121",
    name: "Egal Intl",
    city: "Hargeisa",
    country: "Somalia",
    iata: "HGA",
    icao: "HCMH",
    latitude: "9.518167",
    longitude: "44.088758",
    altitude: "4423",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "1122",
    name: "Berbera",
    city: "Berbera",
    country: "Somalia",
    iata: "BBO",
    icao: "HCMI",
    latitude: "10.389167",
    longitude: "44.941106",
    altitude: "30",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "1123",
    name: "Kisimayu",
    city: "Kismayu",
    country: "Somalia",
    iata: "KMU",
    icao: "HCMK",
    latitude: "-0.377353",
    longitude: "42.459233",
    altitude: "49",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "6890",
    name: "Dowagiac Municipal Airport",
    city: "Dowagiac",
    country: "United States",
    iata: "C91",
    icao: "\\N",
    latitude: "41.9929342",
    longitude: "-86.1280125",
    altitude: "748",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "1126",
    name: "Alexandria Intl",
    city: "Alexandria",
    country: "Egypt",
    iata: "ALY",
    icao: "HEAX",
    latitude: "31.183903",
    longitude: "29.948889",
    altitude: "-6",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1127",
    name: "Abu Simbel",
    city: "Abu Simbel",
    country: "Egypt",
    iata: "ABS",
    icao: "HEBL",
    latitude: "22.375953",
    longitude: "31.611722",
    altitude: "616",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1128",
    name: "Cairo Intl",
    city: "Cairo",
    country: "Egypt",
    iata: "CAI",
    icao: "HECA",
    latitude: "30.121944",
    longitude: "31.405556",
    altitude: "382",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1129",
    name: "Cairo West",
    city: "Cairo",
    country: "Egypt",
    iata: "",
    icao: "HECW",
    latitude: "30.116362",
    longitude: "30.915445",
    altitude: "550",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1130",
    name: "Hurghada Intl",
    city: "Hurghada",
    country: "Egypt",
    iata: "HRG",
    icao: "HEGN",
    latitude: "27.178317",
    longitude: "33.799436",
    altitude: "52",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1131",
    name: "El Gora",
    city: "El Gorah",
    country: "Egypt",
    iata: "EGR",
    icao: "HEGR",
    latitude: "31.068975",
    longitude: "34.129194",
    altitude: "324",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1132",
    name: "Luxor Intl",
    city: "Luxor",
    country: "Egypt",
    iata: "LXR",
    icao: "HELX",
    latitude: "25.671028",
    longitude: "32.706583",
    altitude: "294",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1133",
    name: "Mersa Matruh",
    city: "Mersa-matruh",
    country: "Egypt",
    iata: "MUH",
    icao: "HEMM",
    latitude: "31.325356",
    longitude: "27.221689",
    altitude: "94",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1134",
    name: "Port Said",
    city: "Port Said",
    country: "Egypt",
    iata: "PSD",
    icao: "HEPS",
    latitude: "31.279444",
    longitude: "32.24",
    altitude: "8",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1135",
    name: "St Catherine Intl",
    city: "St. Catherine",
    country: "Egypt",
    iata: "SKV",
    icao: "HESC",
    latitude: "28.685278",
    longitude: "34.0625",
    altitude: "4368",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1136",
    name: "Aswan Intl",
    city: "Aswan",
    country: "Egypt",
    iata: "ASW",
    icao: "HESN",
    latitude: "23.964356",
    longitude: "32.819975",
    altitude: "662",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1137",
    name: "El Tor",
    city: "El-tor",
    country: "Egypt",
    iata: "ELT",
    icao: "HETR",
    latitude: "28.209028",
    longitude: "33.645517",
    altitude: "115",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "1138",
    name: "Eldoret Intl",
    city: "Eldoret",
    country: "Kenya",
    iata: "EDL",
    icao: "HKEL",
    latitude: "0.404458",
    longitude: "35.238928",
    altitude: "6941",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1139",
    name: "Kakamega",
    city: "Kakamega",
    country: "Kenya",
    iata: "",
    icao: "HKKG",
    latitude: "0.271342",
    longitude: "34.787297",
    altitude: "5020",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1140",
    name: "Kisumu",
    city: "Kisumu",
    country: "Kenya",
    iata: "KIS",
    icao: "HKKI",
    latitude: "-0.086139",
    longitude: "34.728892",
    altitude: "3796",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1141",
    name: "Kitale",
    city: "Kitale",
    country: "Kenya",
    iata: "KTL",
    icao: "HKKT",
    latitude: "0.971989",
    longitude: "34.958556",
    altitude: "6070",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "6889",
    name: "Cambridge Municipal Airport",
    city: "Cambridge",
    country: "United States",
    iata: "CDI",
    icao: "\\N",
    latitude: "39.9750278",
    longitude: "-81.5775833",
    altitude: "799",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "1143",
    name: "Lodwar",
    city: "Lodwar",
    country: "Kenya",
    iata: "LOK",
    icao: "HKLO",
    latitude: "3.121967",
    longitude: "35.608692",
    altitude: "1715",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1144",
    name: "Lamu Manda",
    city: "Lamu",
    country: "Kenya",
    iata: "LAU",
    icao: "HKLU",
    latitude: "-2.252417",
    longitude: "40.913097",
    altitude: "20",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1145",
    name: "Mombasa Moi Intl",
    city: "Mombasa",
    country: "Kenya",
    iata: "MBA",
    icao: "HKMO",
    latitude: "-4.034833",
    longitude: "39.59425",
    altitude: "200",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1146",
    name: "Naivasha",
    city: "Naivasha",
    country: "Kenya",
    iata: "",
    icao: "HKNV",
    latitude: "-0.787953",
    longitude: "36.433528",
    altitude: "6380",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1147",
    name: "Nairobi Wilson",
    city: "Nairobi",
    country: "Kenya",
    iata: "WIL",
    icao: "HKNW",
    latitude: "-1.321719",
    longitude: "36.814833",
    altitude: "5546",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1148",
    name: "Eastleigh",
    city: "Nairobi",
    country: "Kenya",
    iata: "",
    icao: "HKRE",
    latitude: "-1.277267",
    longitude: "36.862339",
    altitude: "5380",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1149",
    name: "Wajir",
    city: "Wajir",
    country: "Kenya",
    iata: "WJR",
    icao: "HKWJ",
    latitude: "1.733239",
    longitude: "40.091606",
    altitude: "770",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "1150",
    name: "Bu Attifel",
    city: "Buattifel",
    country: "Libya",
    iata: "",
    icao: "HLFL",
    latitude: "28.795372",
    longitude: "22.080939",
    altitude: "161",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1151",
    name: "Warehouse 59e",
    city: "Giallo",
    country: "Libya",
    iata: "",
    icao: "HLGL",
    latitude: "28.638458",
    longitude: "21.438042",
    altitude: "325",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1152",
    name: "Ghat",
    city: "Ghat",
    country: "Libya",
    iata: "GHT",
    icao: "HLGT",
    latitude: "25.145564",
    longitude: "10.142647",
    altitude: "2296",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1153",
    name: "Kufra",
    city: "Kufra",
    country: "Libya",
    iata: "AKF",
    icao: "HLKF",
    latitude: "24.178728",
    longitude: "23.313958",
    altitude: "1367",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1154",
    name: "Benina",
    city: "Benghazi",
    country: "Libya",
    iata: "BEN",
    icao: "HLLB",
    latitude: "32.096786",
    longitude: "20.269472",
    altitude: "433",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1156",
    name: "Sebha",
    city: "Sebha",
    country: "Libya",
    iata: "SEB",
    icao: "HLLS",
    latitude: "26.986964",
    longitude: "14.472525",
    altitude: "1427",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1157",
    name: "Tripoli Intl",
    city: "Tripoli",
    country: "Libya",
    iata: "TIP",
    icao: "HLLT",
    latitude: "32.663544",
    longitude: "13.159011",
    altitude: "263",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1158",
    name: "Marsa Brega",
    city: "Marsa Brega",
    country: "Libya",
    iata: "",
    icao: "HLMB",
    latitude: "30.378139",
    longitude: "19.576444",
    altitude: "50",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1159",
    name: "Ras Lanuf Oil",
    city: "Ras Lanouf V 40",
    country: "Libya",
    iata: "",
    icao: "HLNF",
    latitude: "30.500013",
    longitude: "18.527161",
    altitude: "42",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1160",
    name: "Hon",
    city: "Hon",
    country: "Libya",
    iata: "",
    icao: "HLON",
    latitude: "29.110106",
    longitude: "15.965567",
    altitude: "919",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1161",
    name: "Dahra",
    city: "Dahra",
    country: "Libya",
    iata: "",
    icao: "HLRA",
    latitude: "29.472567",
    longitude: "17.934936",
    altitude: "1050",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1162",
    name: "Ghadames East",
    city: "Ghadames",
    country: "Libya",
    iata: "LTD",
    icao: "HLTD",
    latitude: "30.151695",
    longitude: "9.715305",
    altitude: "1122",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1163",
    name: "Zella 74",
    city: "Zella 74",
    country: "Libya",
    iata: "",
    icao: "HLZA",
    latitude: "28.589878",
    longitude: "17.293858",
    altitude: "1085",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "1164",
    name: "Gisenyi",
    city: "Gisenyi",
    country: "Rwanda",
    iata: "GYI",
    icao: "HRYG",
    latitude: "-1.677203",
    longitude: "29.258875",
    altitude: "5082",
    timezone: "2",
    dst: "U",
    tz: "Africa/Kigali",
  },
  {
    id: "1165",
    name: "Kigali Intl",
    city: "Kigali",
    country: "Rwanda",
    iata: "KGL",
    icao: "HRYR",
    latitude: "-1.968628",
    longitude: "30.13945",
    altitude: "4859",
    timezone: "2",
    dst: "U",
    tz: "Africa/Kigali",
  },
  {
    id: "1166",
    name: "Kamembe",
    city: "Kamembe",
    country: "Rwanda",
    iata: "KME",
    icao: "HRZA",
    latitude: "-2.462242",
    longitude: "28.90795",
    altitude: "5192",
    timezone: "2",
    dst: "U",
    tz: "Africa/Kigali",
  },
  {
    id: "1167",
    name: "Dongola",
    city: "Dongola",
    country: "Sudan",
    iata: "DOG",
    icao: "HSDN",
    latitude: "19.153867",
    longitude: "30.430094",
    altitude: "773",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1168",
    name: "Damazin",
    city: "Damazin",
    country: "Sudan",
    iata: "",
    icao: "HSDZ",
    latitude: "11.785889",
    longitude: "34.336656",
    altitude: "1582",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1169",
    name: "El Fashir",
    city: "El Fasher",
    country: "Sudan",
    iata: "ELF",
    icao: "HSFS",
    latitude: "13.614892",
    longitude: "25.32465",
    altitude: "2393",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1170",
    name: "Kassala",
    city: "Kassala",
    country: "Sudan",
    iata: "KSL",
    icao: "HSKA",
    latitude: "15.387494",
    longitude: "36.328842",
    altitude: "1671",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1171",
    name: "Kadugli",
    city: "Kadugli",
    country: "Sudan",
    iata: "",
    icao: "HSLI",
    latitude: "11.138028",
    longitude: "29.701122",
    altitude: "1848",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1172",
    name: "El Obeid",
    city: "El Obeid",
    country: "Sudan",
    iata: "EBD",
    icao: "HSOB",
    latitude: "13.153219",
    longitude: "30.232675",
    altitude: "1927",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1173",
    name: "Juba",
    city: "Juba",
    country: "South Sudan",
    iata: "JUB",
    icao: "HSSJ",
    latitude: "4.872006",
    longitude: "31.601117",
    altitude: "1513",
    timezone: "3",
    dst: "U",
    tz: "Africa/Juba",
  },
  {
    id: "1174",
    name: "Malakal",
    city: "Malakal",
    country: "Sudan",
    iata: "MAK",
    icao: "HSSM",
    latitude: "9.558969",
    longitude: "31.652242",
    altitude: "1291",
    timezone: "3",
    dst: "U",
    tz: "Africa/Juba",
  },
  {
    id: "1175",
    name: "Khartoum",
    city: "Khartoum",
    country: "Sudan",
    iata: "KRT",
    icao: "HSSS",
    latitude: "15.589497",
    longitude: "32.553161",
    altitude: "1265",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "1176",
    name: "Arusha",
    city: "Arusha",
    country: "Tanzania",
    iata: "ARK",
    icao: "HTAR",
    latitude: "-3.367794",
    longitude: "36.633333",
    altitude: "4550",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1177",
    name: "Mwalimu Julius K Nyerere Intl",
    city: "Dar Es Salaam",
    country: "Tanzania",
    iata: "DAR",
    icao: "HTDA",
    latitude: "-6.878111",
    longitude: "39.202625",
    altitude: "182",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1178",
    name: "Dodoma",
    city: "Dodoma",
    country: "Tanzania",
    iata: "DOD",
    icao: "HTDO",
    latitude: "-6.170436",
    longitude: "35.752578",
    altitude: "3637",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1179",
    name: "Iringa",
    city: "Iringa",
    country: "Tanzania",
    iata: "IRI",
    icao: "HTIR",
    latitude: "-7.668633",
    longitude: "35.752114",
    altitude: "4678",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1180",
    name: "Kilimanjaro Intl",
    city: "Kilimanjaro",
    country: "Tanzania",
    iata: "JRO",
    icao: "HTKJ",
    latitude: "-3.429406",
    longitude: "37.074461",
    altitude: "2932",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1181",
    name: "Lake Manyara",
    city: "Lake Manyara",
    country: "Tanzania",
    iata: "LKY",
    icao: "HTLM",
    latitude: "-3.376306",
    longitude: "35.818278",
    altitude: "4150",
    timezone: "3",
    dst: "N",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1182",
    name: "Mtwara",
    city: "Mtwara",
    country: "Tanzania",
    iata: "MYW",
    icao: "HTMT",
    latitude: "-10.339058",
    longitude: "40.181781",
    altitude: "371",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1183",
    name: "Mwanza",
    city: "Mwanza",
    country: "Tanzania",
    iata: "MWZ",
    icao: "HTMW",
    latitude: "-2.444486",
    longitude: "32.932667",
    altitude: "3763",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1184",
    name: "Pemba",
    city: "Pemba",
    country: "Tanzania",
    iata: "PMA",
    icao: "HTPE",
    latitude: "-5.257264",
    longitude: "39.811417",
    altitude: "80",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1185",
    name: "Tanga",
    city: "Tanga",
    country: "Tanzania",
    iata: "TGT",
    icao: "HTTG",
    latitude: "-5.092358",
    longitude: "39.071158",
    altitude: "129",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1186",
    name: "Zanzibar",
    city: "Zanzibar",
    country: "Tanzania",
    iata: "ZNZ",
    icao: "HTZA",
    latitude: "-6.222025",
    longitude: "39.224886",
    altitude: "54",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "1187",
    name: "Entebbe Intl",
    city: "Entebbe",
    country: "Uganda",
    iata: "EBB",
    icao: "HUEN",
    latitude: "0.042386",
    longitude: "32.443503",
    altitude: "3782",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "6888",
    name: "Dusseldorf Hauptbahnhof",
    city: "Dusseldorf",
    country: "Germany",
    iata: "QDU",
    icao: "\\N",
    latitude: "51.220278",
    longitude: "6.792778",
    altitude: "125",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "1189",
    name: "Soroti",
    city: "Soroti",
    country: "Uganda",
    iata: "SRT",
    icao: "HUSO",
    latitude: "1.727578",
    longitude: "33.622861",
    altitude: "3641",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "1190",
    name: "Tirana Rinas",
    city: "Tirana",
    country: "Albania",
    iata: "TIA",
    icao: "LATI",
    latitude: "41.414742",
    longitude: "19.720561",
    altitude: "126",
    timezone: "1",
    dst: "E",
    tz: "Europe/Tirane",
  },
  {
    id: "1191",
    name: "Burgas",
    city: "Bourgas",
    country: "Bulgaria",
    iata: "BOJ",
    icao: "LBBG",
    latitude: "42.569583",
    longitude: "27.515236",
    altitude: "135",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "1192",
    name: "Gorna Oryahovitsa",
    city: "Gorna Orechovica",
    country: "Bulgaria",
    iata: "GOZ",
    icao: "LBGO",
    latitude: "43.151444",
    longitude: "25.712889",
    altitude: "285",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "1193",
    name: "Plovdiv",
    city: "Plovdiv",
    country: "Bulgaria",
    iata: "PDV",
    icao: "LBPD",
    latitude: "42.067806",
    longitude: "24.850833",
    altitude: "597",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "1194",
    name: "Sofia",
    city: "Sofia",
    country: "Bulgaria",
    iata: "SOF",
    icao: "LBSF",
    latitude: "42.695194",
    longitude: "23.406167",
    altitude: "1742",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "1195",
    name: "Stara Zagora",
    city: "Stara Zagora",
    country: "Bulgaria",
    iata: "",
    icao: "LBSZ",
    latitude: "42.376667",
    longitude: "25.655195",
    altitude: "558",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "1196",
    name: "Varna",
    city: "Varna",
    country: "Bulgaria",
    iata: "VAR",
    icao: "LBWN",
    latitude: "43.232072",
    longitude: "27.825106",
    altitude: "230",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "1197",
    name: "Larnaca",
    city: "Larnaca",
    country: "Cyprus",
    iata: "LCA",
    icao: "LCLK",
    latitude: "34.875117",
    longitude: "33.62485",
    altitude: "8",
    timezone: "2",
    dst: "E",
    tz: "Asia/Nicosia",
  },
  {
    id: "1198",
    name: "Pafos Intl",
    city: "Paphos",
    country: "Cyprus",
    iata: "PFO",
    icao: "LCPH",
    latitude: "34.718039",
    longitude: "32.485731",
    altitude: "41",
    timezone: "2",
    dst: "E",
    tz: "Asia/Nicosia",
  },
  {
    id: "1199",
    name: "Akrotiri",
    city: "Akrotiri",
    country: "Cyprus",
    iata: "AKT",
    icao: "LCRA",
    latitude: "34.590416",
    longitude: "32.987861",
    altitude: "76",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "1200",
    name: "Dubrovnik",
    city: "Dubrovnik",
    country: "Croatia",
    iata: "DBV",
    icao: "LDDU",
    latitude: "42.561353",
    longitude: "18.268244",
    altitude: "527",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1201",
    name: "Cepin",
    city: "Cepin",
    country: "Croatia",
    iata: "",
    icao: "LDOC",
    latitude: "45.542169",
    longitude: "18.636233",
    altitude: "299",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1202",
    name: "Osijek",
    city: "Osijek",
    country: "Croatia",
    iata: "OSI",
    icao: "LDOS",
    latitude: "45.462667",
    longitude: "18.810156",
    altitude: "290",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1203",
    name: "Pula",
    city: "Pula",
    country: "Croatia",
    iata: "PUY",
    icao: "LDPL",
    latitude: "44.893533",
    longitude: "13.922192",
    altitude: "274",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1204",
    name: "Grobnicko Polje",
    city: "Grobnik",
    country: "Croatia",
    iata: "",
    icao: "LDRG",
    latitude: "45.379483",
    longitude: "14.503756",
    altitude: "951",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1205",
    name: "Rijeka",
    city: "Rijeka",
    country: "Croatia",
    iata: "RJK",
    icao: "LDRI",
    latitude: "45.216889",
    longitude: "14.570267",
    altitude: "278",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1206",
    name: "Split",
    city: "Split",
    country: "Croatia",
    iata: "SPU",
    icao: "LDSP",
    latitude: "43.538944",
    longitude: "16.297964",
    altitude: "79",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1207",
    name: "Varazdin",
    city: "Varazdin",
    country: "Croatia",
    iata: "",
    icao: "LDVA",
    latitude: "46.294724",
    longitude: "16.38125",
    altitude: "548",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1208",
    name: "Zagreb",
    city: "Zagreb",
    country: "Croatia",
    iata: "ZAG",
    icao: "LDZA",
    latitude: "45.742931",
    longitude: "16.068778",
    altitude: "353",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1209",
    name: "Zadar",
    city: "Zadar",
    country: "Croatia",
    iata: "ZAD",
    icao: "LDZD",
    latitude: "44.108269",
    longitude: "15.346697",
    altitude: "289",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1210",
    name: "Udbina",
    city: "Udbina",
    country: "Croatia",
    iata: "",
    icao: "LDZU",
    latitude: "44.55761",
    longitude: "15.774361",
    altitude: "2462",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "1211",
    name: "Albacete",
    city: "Albacete",
    country: "Spain",
    iata: "",
    icao: "LEAB",
    latitude: "38.948528",
    longitude: "-1.863517",
    altitude: "2302",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1212",
    name: "Alicante",
    city: "Alicante",
    country: "Spain",
    iata: "ALC",
    icao: "LEAL",
    latitude: "38.282169",
    longitude: "-0.558156",
    altitude: "142",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1213",
    name: "Almeria",
    city: "Almeria",
    country: "Spain",
    iata: "LEI",
    icao: "LEAM",
    latitude: "36.843936",
    longitude: "-2.370097",
    altitude: "70",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1214",
    name: "Asturias",
    city: "Aviles",
    country: "Spain",
    iata: "OVD",
    icao: "LEAS",
    latitude: "43.563567",
    longitude: "-6.034622",
    altitude: "416",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1215",
    name: "Cordoba",
    city: "Cordoba",
    country: "Spain",
    iata: "ODB",
    icao: "LEBA",
    latitude: "37.842006",
    longitude: "-4.848878",
    altitude: "297",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1216",
    name: "Bilbao",
    city: "Bilbao",
    country: "Spain",
    iata: "BIO",
    icao: "LEBB",
    latitude: "43.301097",
    longitude: "-2.910608",
    altitude: "138",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1218",
    name: "Barcelona",
    city: "Barcelona",
    country: "Spain",
    iata: "BCN",
    icao: "LEBL",
    latitude: "41.297078",
    longitude: "2.078464",
    altitude: "12",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1219",
    name: "Talavera La Real",
    city: "Badajoz",
    country: "Spain",
    iata: "BJZ",
    icao: "LEBZ",
    latitude: "38.89125",
    longitude: "-6.821333",
    altitude: "609",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1220",
    name: "A Coruna",
    city: "La Coruna",
    country: "Spain",
    iata: "LCG",
    icao: "LECO",
    latitude: "43.302061",
    longitude: "-8.377256",
    altitude: "326",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1221",
    name: "Armilla",
    city: "Granada",
    country: "Spain",
    iata: "",
    icao: "LEGA",
    latitude: "37.133222",
    longitude: "-3.635694",
    altitude: "2297",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1222",
    name: "Girona",
    city: "Gerona",
    country: "Spain",
    iata: "GRO",
    icao: "LEGE",
    latitude: "41.900969",
    longitude: "2.760547",
    altitude: "468",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1223",
    name: "Granada",
    city: "Granada",
    country: "Spain",
    iata: "GRX",
    icao: "LEGR",
    latitude: "37.188731",
    longitude: "-3.777356",
    altitude: "1860",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1224",
    name: "Getafe",
    city: "Madrid",
    country: "Spain",
    iata: "",
    icao: "LEGT",
    latitude: "40.294139",
    longitude: "-3.723833",
    altitude: "2029",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1225",
    name: "Ibiza",
    city: "Ibiza",
    country: "Spain",
    iata: "IBZ",
    icao: "LEIB",
    latitude: "38.872858",
    longitude: "1.373117",
    altitude: "20",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1226",
    name: "Jerez",
    city: "Jerez",
    country: "Spain",
    iata: "XRY",
    icao: "LEJR",
    latitude: "36.744622",
    longitude: "-6.060111",
    altitude: "93",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1227",
    name: "Murcia San Javier",
    city: "Murcia",
    country: "Spain",
    iata: "MJV",
    icao: "LELC",
    latitude: "37.774972",
    longitude: "-0.812389",
    altitude: "11",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "6887",
    name: "Alexion",
    city: "Porto Heli",
    country: "Greece",
    iata: "PKH",
    icao: "LGHL",
    latitude: "37.298792",
    longitude: "23.148986",
    altitude: "2224",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1229",
    name: "Barajas",
    city: "Madrid",
    country: "Spain",
    iata: "MAD",
    icao: "LEMD",
    latitude: "40.493556",
    longitude: "-3.566764",
    altitude: "2000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1230",
    name: "Malaga",
    city: "Malaga",
    country: "Spain",
    iata: "AGP",
    icao: "LEMG",
    latitude: "36.6749",
    longitude: "-4.499106",
    altitude: "52",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1231",
    name: "Menorca",
    city: "Menorca",
    country: "Spain",
    iata: "MAH",
    icao: "LEMH",
    latitude: "39.862597",
    longitude: "4.218647",
    altitude: "298",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1232",
    name: "Moron Ab",
    city: "Sevilla",
    country: "Spain",
    iata: "OZP",
    icao: "LEMO",
    latitude: "37.174917",
    longitude: "-5.615944",
    altitude: "285",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1233",
    name: "Ocana",
    city: "Ocana",
    country: "Spain",
    iata: "",
    icao: "LEOC",
    latitude: "39.9375",
    longitude: "-3.503333",
    altitude: "2405",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1234",
    name: "Pamplona",
    city: "Pamplona",
    country: "Spain",
    iata: "PNA",
    icao: "LEPP",
    latitude: "42.770039",
    longitude: "-1.646331",
    altitude: "1504",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1235",
    name: "Alcantarilla",
    city: "Murcia",
    country: "Spain",
    iata: "",
    icao: "LERI",
    latitude: "37.951111",
    longitude: "-1.230319",
    altitude: "250",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1236",
    name: "Reus",
    city: "Reus",
    country: "Spain",
    iata: "REU",
    icao: "LERS",
    latitude: "41.147392",
    longitude: "1.167172",
    altitude: "234",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1237",
    name: "Rota Ns",
    city: "Rota",
    country: "Spain",
    iata: "",
    icao: "LERT",
    latitude: "36.645211",
    longitude: "-6.349458",
    altitude: "86",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1238",
    name: "Salamanca",
    city: "Salamanca",
    country: "Spain",
    iata: "SLM",
    icao: "LESA",
    latitude: "40.952117",
    longitude: "-5.501986",
    altitude: "2595",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1239",
    name: "Son Bonet",
    city: "Son Bonet",
    country: "Spain",
    iata: "",
    icao: "LESB",
    latitude: "39.598889",
    longitude: "2.702778",
    altitude: "135",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1240",
    name: "Palma De Mallorca",
    city: "Palma De Mallorca",
    country: "Spain",
    iata: "",
    icao: "LESJ",
    latitude: "39.551675",
    longitude: "2.738808",
    altitude: "27",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1241",
    name: "San Luis",
    city: "San Luis",
    country: "Spain",
    iata: "",
    icao: "LESL",
    latitude: "39.862222",
    longitude: "4.258333",
    altitude: "197",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1242",
    name: "San Sebastian",
    city: "San Sebastian",
    country: "Spain",
    iata: "EAS",
    icao: "LESO",
    latitude: "43.356519",
    longitude: "-1.790611",
    altitude: "15",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1243",
    name: "Santiago",
    city: "Santiago",
    country: "Spain",
    iata: "SCQ",
    icao: "LEST",
    latitude: "42.896333",
    longitude: "-8.415144",
    altitude: "1213",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1244",
    name: "Seo De Urgel",
    city: "Seo De Urgel",
    country: "Spain",
    iata: "LEU",
    icao: "LESU",
    latitude: "42.338611",
    longitude: "1.409167",
    altitude: "2625",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1245",
    name: "Torrejon",
    city: "Madrid",
    country: "Spain",
    iata: "TOJ",
    icao: "LETO",
    latitude: "40.496747",
    longitude: "-3.445872",
    altitude: "2026",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1246",
    name: "Valencia",
    city: "Valencia",
    country: "Spain",
    iata: "VLC",
    icao: "LEVC",
    latitude: "39.489314",
    longitude: "-0.481625",
    altitude: "225",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1247",
    name: "Valladolid",
    city: "Valladolid",
    country: "Spain",
    iata: "VLL",
    icao: "LEVD",
    latitude: "41.706111",
    longitude: "-4.851944",
    altitude: "2775",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1248",
    name: "Cuatro Vientos",
    city: "Madrid",
    country: "Spain",
    iata: "",
    icao: "LEVS",
    latitude: "40.370678",
    longitude: "-3.785144",
    altitude: "2267",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1249",
    name: "Vitoria",
    city: "Vitoria",
    country: "Spain",
    iata: "VIT",
    icao: "LEVT",
    latitude: "42.882836",
    longitude: "-2.724469",
    altitude: "1682",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1250",
    name: "Vigo",
    city: "Vigo",
    country: "Spain",
    iata: "VGO",
    icao: "LEVX",
    latitude: "42.2318",
    longitude: "-8.626775",
    altitude: "855",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1251",
    name: "Santander",
    city: "Santander",
    country: "Spain",
    iata: "SDR",
    icao: "LEXJ",
    latitude: "43.427064",
    longitude: "-3.820006",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1252",
    name: "Zaragoza Ab",
    city: "Zaragoza",
    country: "Spain",
    iata: "ZAZ",
    icao: "LEZG",
    latitude: "41.666242",
    longitude: "-1.041553",
    altitude: "863",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1253",
    name: "Sevilla",
    city: "Sevilla",
    country: "Spain",
    iata: "SVQ",
    icao: "LEZL",
    latitude: "37.418",
    longitude: "-5.893106",
    altitude: "111",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "1254",
    name: "Calais Dunkerque",
    city: "Calais",
    country: "France",
    iata: "CQF",
    icao: "LFAC",
    latitude: "50.962097",
    longitude: "1.954764",
    altitude: "12",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1255",
    name: "Peronne St Quentin",
    city: "Peronne",
    country: "France",
    iata: "",
    icao: "LFAG",
    latitude: "49.868547",
    longitude: "3.029578",
    altitude: "295",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1256",
    name: "Les Loges",
    city: "Nangis",
    country: "France",
    iata: "",
    icao: "LFAI",
    latitude: "48.596219",
    longitude: "3.006786",
    altitude: "428",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1257",
    name: "Couterne",
    city: "Bagnole-de-l'orne",
    country: "France",
    iata: "",
    icao: "LFAO",
    latitude: "48.545836",
    longitude: "-0.387444",
    altitude: "718",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1258",
    name: "Bray",
    city: "Albert",
    country: "France",
    iata: "",
    icao: "LFAQ",
    latitude: "49.971531",
    longitude: "2.697661",
    altitude: "364",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1259",
    name: "Le Touquet Paris Plage",
    city: "Le Tourquet",
    country: "France",
    iata: "LTQ",
    icao: "LFAT",
    latitude: "50.517385",
    longitude: "1.620587",
    altitude: "36",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1260",
    name: "Denain",
    city: "Valenciennes",
    country: "France",
    iata: "",
    icao: "LFAV",
    latitude: "50.325808",
    longitude: "3.461264",
    altitude: "177",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1261",
    name: "Glisy",
    city: "Amiens",
    country: "France",
    iata: "",
    icao: "LFAY",
    latitude: "49.873019",
    longitude: "2.387075",
    altitude: "208",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1262",
    name: "La Garenne",
    city: "Agen",
    country: "France",
    iata: "AGF",
    icao: "LFBA",
    latitude: "44.174721",
    longitude: "0.590556",
    altitude: "204",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1263",
    name: "Cazaux",
    city: "Cazaux",
    country: "France",
    iata: "",
    icao: "LFBC",
    latitude: "44.533333",
    longitude: "-1.125",
    altitude: "84",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1264",
    name: "Merignac",
    city: "Bordeaux",
    country: "France",
    iata: "BOD",
    icao: "LFBD",
    latitude: "44.828335",
    longitude: "-0.715556",
    altitude: "162",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1265",
    name: "Roumaniere",
    city: "Bergerac",
    country: "France",
    iata: "EGC",
    icao: "LFBE",
    latitude: "44.825279",
    longitude: "0.518611",
    altitude: "171",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1266",
    name: "Francazal",
    city: "Toulouse",
    country: "France",
    iata: "",
    icao: "LFBF",
    latitude: "43.545555",
    longitude: "1.3675",
    altitude: "535",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1267",
    name: "Chateaubernard",
    city: "Cognac",
    country: "France",
    iata: "CNG",
    icao: "LFBG",
    latitude: "45.658333",
    longitude: "-0.3175",
    altitude: "102",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1268",
    name: "Biard",
    city: "Poitiers",
    country: "France",
    iata: "PIS",
    icao: "LFBI",
    latitude: "46.587745",
    longitude: "0.306666",
    altitude: "423",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1269",
    name: "Montlucon Gueret",
    city: "Montlucon-gueret",
    country: "France",
    iata: "",
    icao: "LFBK",
    latitude: "46.222644",
    longitude: "2.363964",
    altitude: "1497",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1270",
    name: "Bellegarde",
    city: "Limoges",
    country: "France",
    iata: "LIG",
    icao: "LFBL",
    latitude: "45.862778",
    longitude: "1.179444",
    altitude: "1300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1271",
    name: "Mont De Marsan",
    city: "Mont-de-marsan",
    country: "France",
    iata: "",
    icao: "LFBM",
    latitude: "43.911667",
    longitude: "-0.5075",
    altitude: "203",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1272",
    name: "Souche",
    city: "Niort",
    country: "France",
    iata: "NIT",
    icao: "LFBN",
    latitude: "46.311303",
    longitude: "-0.401503",
    altitude: "203",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1273",
    name: "Blagnac",
    city: "Toulouse",
    country: "France",
    iata: "TLS",
    icao: "LFBO",
    latitude: "43.629075",
    longitude: "1.363819",
    altitude: "499",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1274",
    name: "Pau Pyrenees",
    city: "Pau",
    country: "France",
    iata: "PUF",
    icao: "LFBP",
    latitude: "43.38",
    longitude: "-0.418611",
    altitude: "616",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1275",
    name: "Lherm",
    city: "La Rochelle",
    country: "France",
    iata: "",
    icao: "LFBR",
    latitude: "43.448891",
    longitude: "1.263333",
    altitude: "622",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1276",
    name: "Lourdes",
    city: "Tarbes",
    country: "France",
    iata: "LDE",
    icao: "LFBT",
    latitude: "43.178675",
    longitude: "-0.006439",
    altitude: "1260",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1277",
    name: "Brie Champniers",
    city: "Angouleme",
    country: "France",
    iata: "ANG",
    icao: "LFBU",
    latitude: "45.729247",
    longitude: "0.221456",
    altitude: "436",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1278",
    name: "La Roche",
    city: "Brive",
    country: "France",
    iata: "BVE",
    icao: "LFSL",
    latitude: "45.150833",
    longitude: "1.469167",
    altitude: "379",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1279",
    name: "Bassillac",
    city: "Perigueux",
    country: "France",
    iata: "PGX",
    icao: "LFBX",
    latitude: "45.198055",
    longitude: "0.815556",
    altitude: "328",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1280",
    name: "Anglet",
    city: "Biarritz-bayonne",
    country: "France",
    iata: "BIQ",
    icao: "LFBZ",
    latitude: "43.468419",
    longitude: "-1.523325",
    altitude: "245",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1281",
    name: "Lalbenque",
    city: "Cahors",
    country: "France",
    iata: "",
    icao: "LFCC",
    latitude: "44.351387",
    longitude: "1.475278",
    altitude: "912",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1282",
    name: "Antichan",
    city: "St.-girons",
    country: "France",
    iata: "",
    icao: "LFCG",
    latitude: "43.007764",
    longitude: "1.10315",
    altitude: "1368",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1283",
    name: "La Teste De Buch",
    city: "Arcachon",
    country: "France",
    iata: "XAC",
    icao: "LFCH",
    latitude: "44.59639",
    longitude: "-1.110833",
    altitude: "49",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1284",
    name: "Le Sequestre",
    city: "Albi",
    country: "France",
    iata: "LBI",
    icao: "LFCI",
    latitude: "43.913887",
    longitude: "2.113056",
    altitude: "564",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1285",
    name: "Mazamet",
    city: "Castres",
    country: "France",
    iata: "DCM",
    icao: "LFCK",
    latitude: "43.55625",
    longitude: "2.289183",
    altitude: "788",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1286",
    name: "Lasbordes",
    city: "Toulouse",
    country: "France",
    iata: "",
    icao: "LFCL",
    latitude: "43.586113",
    longitude: "1.499167",
    altitude: "459",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1287",
    name: "Larzac",
    city: "Millau",
    country: "France",
    iata: "",
    icao: "LFCM",
    latitude: "43.989342",
    longitude: "3.183",
    altitude: "2606",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1288",
    name: "Montdragon",
    city: "Graulhet",
    country: "France",
    iata: "",
    icao: "LFCQ",
    latitude: "43.771111",
    longitude: "2.010833",
    altitude: "581",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1289",
    name: "Marcillac",
    city: "Rodez",
    country: "France",
    iata: "RDZ",
    icao: "LFCR",
    latitude: "44.407869",
    longitude: "2.482672",
    altitude: "1910",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1290",
    name: "Thalamy",
    city: "Ussel",
    country: "France",
    iata: "",
    icao: "LFCU",
    latitude: "45.534721",
    longitude: "2.423889",
    altitude: "2428",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1291",
    name: "Villeneuve Sur Lot",
    city: "Villeneuve-sur-lot",
    country: "France",
    iata: "",
    icao: "LFCW",
    latitude: "44.396946",
    longitude: "0.758889",
    altitude: "190",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1292",
    name: "Medis",
    city: "Royan",
    country: "France",
    iata: "RYN",
    icao: "LFCY",
    latitude: "45.628056",
    longitude: "-0.9725",
    altitude: "72",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1293",
    name: "Mimizan",
    city: "Mimizan",
    country: "France",
    iata: "",
    icao: "LFCZ",
    latitude: "44.146111",
    longitude: "-1.174444",
    altitude: "164",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1294",
    name: "Aire Sur L Adour",
    city: "Aire-sur-l'adour",
    country: "France",
    iata: "",
    icao: "LFDA",
    latitude: "43.709444",
    longitude: "-0.245278",
    altitude: "259",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1295",
    name: "Montauban",
    city: "Montauban",
    country: "France",
    iata: "",
    icao: "LFDB",
    latitude: "44.025694",
    longitude: "1.378042",
    altitude: "351",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1296",
    name: "Lamothe",
    city: "Auch",
    country: "France",
    iata: "",
    icao: "LFDH",
    latitude: "43.687778",
    longitude: "0.601667",
    altitude: "411",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1297",
    name: "Artigues De Lussac",
    city: "Libourne",
    country: "France",
    iata: "",
    icao: "LFDI",
    latitude: "44.982498",
    longitude: "-0.134722",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1298",
    name: "Les Pujols",
    city: "Pamiers",
    country: "France",
    iata: "",
    icao: "LFDJ",
    latitude: "43.090556",
    longitude: "1.695833",
    altitude: "1115",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1299",
    name: "Virazeil",
    city: "Marmande",
    country: "France",
    iata: "",
    icao: "LFDM",
    latitude: "44.498919",
    longitude: "0.200514",
    altitude: "105",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1300",
    name: "St Agnant",
    city: "Rochefort",
    country: "France",
    iata: "RCO",
    icao: "LFDN",
    latitude: "45.887779",
    longitude: "-0.983056",
    altitude: "60",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1301",
    name: "Pontivy",
    city: "Pontivy",
    country: "France",
    iata: "",
    icao: "LFED",
    latitude: "48.056789",
    longitude: "-2.921244",
    altitude: "407",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1302",
    name: "Aubigny Sur Nere",
    city: "Aubigny-sur-nere",
    country: "France",
    iata: "",
    icao: "LFEH",
    latitude: "47.474167",
    longitude: "2.393055",
    altitude: "630",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1303",
    name: "Scaer",
    city: "Guiscriff-scaer",
    country: "France",
    iata: "",
    icao: "LFES",
    latitude: "48.052508",
    longitude: "-3.664717",
    altitude: "574",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1305",
    name: "Ancenis",
    city: "Ancenis",
    country: "France",
    iata: "",
    icao: "LFFI",
    latitude: "47.408056",
    longitude: "-1.1775",
    altitude: "111",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1306",
    name: "Brienne Le Chateau",
    city: "Brienne-le Chateau",
    country: "France",
    iata: "",
    icao: "LFFN",
    latitude: "48.429764",
    longitude: "4.482222",
    altitude: "381",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1307",
    name: "Houssen",
    city: "Colmar",
    country: "France",
    iata: "CMR",
    icao: "LFGA",
    latitude: "48.109853",
    longitude: "7.359011",
    altitude: "628",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1308",
    name: "Challanges",
    city: "Beaune",
    country: "France",
    iata: "",
    icao: "LFGF",
    latitude: "47.005886",
    longitude: "4.893425",
    altitude: "656",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1309",
    name: "Tavaux",
    city: "Dole",
    country: "France",
    iata: "DLE",
    icao: "LFGJ",
    latitude: "47.039014",
    longitude: "5.42725",
    altitude: "645",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1310",
    name: "Joigny",
    city: "Joigny",
    country: "France",
    iata: "",
    icao: "LFGK",
    latitude: "47.992222",
    longitude: "3.392222",
    altitude: "732",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1311",
    name: "Le Rozelier",
    city: "Verdun",
    country: "France",
    iata: "",
    icao: "LFGW",
    latitude: "49.122383",
    longitude: "5.469047",
    altitude: "1230",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1312",
    name: "Ardeche Meridionale",
    city: "Aubenas-vals-lanas",
    country: "France",
    iata: "OBS",
    icao: "LFHO",
    latitude: "44.544236",
    longitude: "4.372192",
    altitude: "923",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1313",
    name: "Loudes",
    city: "Le Puy",
    country: "France",
    iata: "LPY",
    icao: "LFHP",
    latitude: "45.080689",
    longitude: "3.762889",
    altitude: "2731",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1314",
    name: "Coltines",
    city: "St.-flour",
    country: "France",
    iata: "",
    icao: "LFHQ",
    latitude: "45.076389",
    longitude: "2.993611",
    altitude: "3218",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1315",
    name: "Ceyzeriat",
    city: "Bourg",
    country: "France",
    iata: "XBK",
    icao: "LFHS",
    latitude: "46.20089",
    longitude: "5.292028",
    altitude: "857",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1316",
    name: "Tarare",
    city: "Vilefrance",
    country: "France",
    iata: "XVF",
    icao: "LFHV",
    latitude: "45.901947",
    longitude: "4.634906",
    altitude: "1076",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1317",
    name: "Montbeugny",
    city: "Moulins",
    country: "France",
    iata: "XMU",
    icao: "LFHY",
    latitude: "46.534581",
    longitude: "3.423725",
    altitude: "915",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1318",
    name: "Belmont",
    city: "St.-afrique-belmont",
    country: "France",
    iata: "",
    icao: "LFIF",
    latitude: "43.823334",
    longitude: "2.745278",
    altitude: "1686",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1319",
    name: "Cassagnes Begonhes",
    city: "Cassagnes-beghones",
    country: "France",
    iata: "",
    icao: "LFIG",
    latitude: "44.177776",
    longitude: "2.515",
    altitude: "2024",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1320",
    name: "Metz Nancy Lorraine",
    city: "Metz",
    country: "France",
    iata: "ETZ",
    icao: "LFJL",
    latitude: "48.982142",
    longitude: "6.251319",
    altitude: "870",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1321",
    name: "Poretta",
    city: "Bastia",
    country: "France",
    iata: "BIA",
    icao: "LFKB",
    latitude: "42.552664",
    longitude: "9.483731",
    altitude: "26",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1322",
    name: "Saint Catherine",
    city: "Calvi",
    country: "France",
    iata: "CLY",
    icao: "LFKC",
    latitude: "42.530753",
    longitude: "8.793189",
    altitude: "209",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1323",
    name: "Sud Corse",
    city: "Figari",
    country: "France",
    iata: "FSC",
    icao: "LFKF",
    latitude: "41.500557",
    longitude: "9.097777",
    altitude: "87",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1324",
    name: "Campo Dell Oro",
    city: "Ajaccio",
    country: "France",
    iata: "AJA",
    icao: "LFKJ",
    latitude: "41.923637",
    longitude: "8.802917",
    altitude: "18",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1325",
    name: "Propriano",
    city: "Propriano",
    country: "France",
    iata: "",
    icao: "LFKO",
    latitude: "41.660558",
    longitude: "8.889747",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1326",
    name: "Solenzara",
    city: "Solenzara",
    country: "France",
    iata: "SOZ",
    icao: "LFKS",
    latitude: "41.924416",
    longitude: "9.406",
    altitude: "28",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1327",
    name: "Corte",
    city: "Corte",
    country: "France",
    iata: "",
    icao: "LFKT",
    latitude: "42.29361",
    longitude: "9.193055",
    altitude: "1132",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1328",
    name: "Branches",
    city: "Auxerre",
    country: "France",
    iata: "AUF",
    icao: "LFLA",
    latitude: "47.850193",
    longitude: "3.497111",
    altitude: "523",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1329",
    name: "Aix Les Bains",
    city: "Chambery",
    country: "France",
    iata: "CMF",
    icao: "LFLB",
    latitude: "45.63805",
    longitude: "5.880225",
    altitude: "779",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1330",
    name: "Auvergne",
    city: "Clermont-Ferrand",
    country: "France",
    iata: "CFE",
    icao: "LFLC",
    latitude: "45.786661",
    longitude: "3.169169",
    altitude: "1090",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1331",
    name: "Bourges",
    city: "Bourges",
    country: "France",
    iata: "BOU",
    icao: "LFLD",
    latitude: "47.058056",
    longitude: "2.370278",
    altitude: "529",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1332",
    name: "Challes Les Eaux",
    city: "Chambery",
    country: "France",
    iata: "",
    icao: "LFLE",
    latitude: "45.56105",
    longitude: "5.975761",
    altitude: "973",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1333",
    name: "Champforgeuil",
    city: "Chalon",
    country: "France",
    iata: "XCD",
    icao: "LFLH",
    latitude: "46.826108",
    longitude: "4.817633",
    altitude: "623",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1334",
    name: "Annemasse",
    city: "Annemasse",
    country: "France",
    iata: "QNJ",
    icao: "LFLI",
    latitude: "46.191972",
    longitude: "6.268386",
    altitude: "1620",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1335",
    name: "Saint Exupery",
    city: "Lyon",
    country: "France",
    iata: "LYS",
    icao: "LFLL",
    latitude: "45.726387",
    longitude: "5.090833",
    altitude: "821",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1336",
    name: "Charnay",
    city: "Macon",
    country: "France",
    iata: "QNX",
    icao: "LFLM",
    latitude: "46.295103",
    longitude: "4.795767",
    altitude: "728",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1337",
    name: "Saint Yan",
    city: "St.-yan",
    country: "France",
    iata: "",
    icao: "LFLN",
    latitude: "46.412536",
    longitude: "4.013264",
    altitude: "796",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1338",
    name: "Renaison",
    city: "Roanne",
    country: "France",
    iata: "RNE",
    icao: "LFLO",
    latitude: "46.058334",
    longitude: "4.001389",
    altitude: "1106",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1339",
    name: "Meythet",
    city: "Annecy",
    country: "France",
    iata: "NCY",
    icao: "LFLP",
    latitude: "45.929233",
    longitude: "6.098764",
    altitude: "1521",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1340",
    name: "Saint Geoirs",
    city: "Grenoble",
    country: "France",
    iata: "GNB",
    icao: "LFLS",
    latitude: "45.362944",
    longitude: "5.329375",
    altitude: "1302",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1341",
    name: "Domerat",
    city: "Montlucon",
    country: "France",
    iata: "MCU",
    icao: "LFLT",
    latitude: "46.352525",
    longitude: "2.570486",
    altitude: "771",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1342",
    name: "Chabeuil",
    city: "Valence",
    country: "France",
    iata: "VAF",
    icao: "LFLU",
    latitude: "44.921594",
    longitude: "4.9699",
    altitude: "525",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1343",
    name: "Charmeil",
    city: "Vichy",
    country: "France",
    iata: "VHY",
    icao: "LFLV",
    latitude: "46.169689",
    longitude: "3.403736",
    altitude: "817",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1344",
    name: "Aurillac",
    city: "Aurillac",
    country: "France",
    iata: "AUR",
    icao: "LFLW",
    latitude: "44.891388",
    longitude: "2.421944",
    altitude: "2096",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1345",
    name: "Deols",
    city: "Chateauroux",
    country: "France",
    iata: "CHR",
    icao: "LFLX",
    latitude: "46.862194",
    longitude: "1.730667",
    altitude: "529",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1346",
    name: "Bron",
    city: "Lyon",
    country: "France",
    iata: "LYN",
    icao: "LFLY",
    latitude: "45.727172",
    longitude: "4.944275",
    altitude: "659",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1347",
    name: "Aix Les Milles",
    city: "Aix-les-milles",
    country: "France",
    iata: "QXB",
    icao: "LFMA",
    latitude: "43.505554",
    longitude: "5.367778",
    altitude: "367",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1348",
    name: "Le Cannet",
    city: "Le Luc",
    country: "France",
    iata: "",
    icao: "LFMC",
    latitude: "43.384672",
    longitude: "6.387139",
    altitude: "265",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1349",
    name: "Mandelieu",
    city: "Cannes",
    country: "France",
    iata: "CEQ",
    icao: "LFMD",
    latitude: "43.54205",
    longitude: "6.953478",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1350",
    name: "Boutheon",
    city: "St-Etienne",
    country: "France",
    iata: "EBU",
    icao: "LFMH",
    latitude: "45.540554",
    longitude: "4.296389",
    altitude: "1325",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1351",
    name: "Le Tube",
    city: "Istres",
    country: "France",
    iata: "",
    icao: "LFMI",
    latitude: "43.522736",
    longitude: "4.923844",
    altitude: "82",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1352",
    name: "Salvaza",
    city: "Carcassonne",
    country: "France",
    iata: "CCF",
    icao: "LFMK",
    latitude: "43.215978",
    longitude: "2.306317",
    altitude: "433",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1353",
    name: "Provence",
    city: "Marseille",
    country: "France",
    iata: "MRS",
    icao: "LFML",
    latitude: "43.435555",
    longitude: "5.213611",
    altitude: "74",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1354",
    name: "Cote D\\\\'Azur",
    city: "Nice",
    country: "France",
    iata: "NCE",
    icao: "LFMN",
    latitude: "43.658411",
    longitude: "7.215872",
    altitude: "12",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1355",
    name: "Caritat",
    city: "Orange",
    country: "France",
    iata: "",
    icao: "LFMO",
    latitude: "44.140481",
    longitude: "4.866717",
    altitude: "197",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1356",
    name: "Rivesaltes",
    city: "Perpignan",
    country: "France",
    iata: "PGF",
    icao: "LFMP",
    latitude: "42.740442",
    longitude: "2.870667",
    altitude: "144",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1357",
    name: "Le Castellet",
    city: "Le Castellet",
    country: "France",
    iata: "CTT",
    icao: "LFMQ",
    latitude: "43.252506",
    longitude: "5.785189",
    altitude: "1391",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1358",
    name: "Deaux",
    city: "Ales",
    country: "France",
    iata: "",
    icao: "LFMS",
    latitude: "44.069656",
    longitude: "4.142122",
    altitude: "668",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1359",
    name: "Mediterranee",
    city: "Montpellier",
    country: "France",
    iata: "MPL",
    icao: "LFMT",
    latitude: "43.576194",
    longitude: "3.963014",
    altitude: "17",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1360",
    name: "Vias",
    city: "Beziers",
    country: "France",
    iata: "BZR",
    icao: "LFMU",
    latitude: "43.323522",
    longitude: "3.353903",
    altitude: "56",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1361",
    name: "Caumont",
    city: "Avignon",
    country: "France",
    iata: "AVN",
    icao: "LFMV",
    latitude: "43.9073",
    longitude: "4.901831",
    altitude: "124",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1362",
    name: "Salon",
    city: "Salon",
    country: "France",
    iata: "",
    icao: "LFMY",
    latitude: "43.606415",
    longitude: "5.10925",
    altitude: "195",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1363",
    name: "Lezignan Corbieres",
    city: "Lezignan-corbieres",
    country: "France",
    iata: "",
    icao: "LFMZ",
    latitude: "43.175835",
    longitude: "2.734167",
    altitude: "207",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1364",
    name: "Brenoux",
    city: "Mende",
    country: "France",
    iata: "MEN",
    icao: "LFNB",
    latitude: "44.502108",
    longitude: "3.532819",
    altitude: "3362",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1365",
    name: "Carpentras",
    city: "Carpentras",
    country: "France",
    iata: "",
    icao: "LFNH",
    latitude: "44.029847",
    longitude: "5.078058",
    altitude: "394",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1366",
    name: "Avord",
    city: "Avord",
    country: "France",
    iata: "",
    icao: "LFOA",
    latitude: "47.053333",
    longitude: "2.6325",
    altitude: "580",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1367",
    name: "Tille",
    city: "Beauvais",
    country: "France",
    iata: "BVA",
    icao: "LFOB",
    latitude: "49.454444",
    longitude: "2.112778",
    altitude: "359",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1368",
    name: "Chateaudun",
    city: "Chateaudun",
    country: "France",
    iata: "",
    icao: "LFOC",
    latitude: "48.058142",
    longitude: "1.376625",
    altitude: "433",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1369",
    name: "St Florent",
    city: "Saumur",
    country: "France",
    iata: "",
    icao: "LFOD",
    latitude: "47.256839",
    longitude: "-0.115142",
    altitude: "269",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1370",
    name: "Fauville",
    city: "Evreux",
    country: "France",
    iata: "",
    icao: "LFOE",
    latitude: "49.028669",
    longitude: "1.219864",
    altitude: "464",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1371",
    name: "Octeville",
    city: "Le Havre",
    country: "France",
    iata: "LEH",
    icao: "LFOH",
    latitude: "49.533889",
    longitude: "0.088056",
    altitude: "312",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1372",
    name: "Abbeville",
    city: "Abbeville",
    country: "France",
    iata: "",
    icao: "LFOI",
    latitude: "50.143492",
    longitude: "1.831892",
    altitude: "220",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1373",
    name: "Bricy",
    city: "Orleans",
    country: "France",
    iata: "ORE",
    icao: "LFOJ",
    latitude: "47.987778",
    longitude: "1.760556",
    altitude: "412",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1374",
    name: "Vatry",
    city: "Chalons",
    country: "France",
    iata: "XCR",
    icao: "LFOK",
    latitude: "48.776072",
    longitude: "4.184492",
    altitude: "587",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1375",
    name: "Vallee De Seine",
    city: "Rouen",
    country: "France",
    iata: "URO",
    icao: "LFOP",
    latitude: "49.384172",
    longitude: "1.1748",
    altitude: "512",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1376",
    name: "Val De Loire",
    city: "Tours",
    country: "France",
    iata: "TUF",
    icao: "LFOT",
    latitude: "47.432222",
    longitude: "0.727606",
    altitude: "357",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1377",
    name: "Le Pontreau",
    city: "Cholet",
    country: "France",
    iata: "CET",
    icao: "LFOU",
    latitude: "47.082136",
    longitude: "-0.877064",
    altitude: "443",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1378",
    name: "Entrammes",
    city: "Laval",
    country: "France",
    iata: "LVA",
    icao: "LFOV",
    latitude: "48.031361",
    longitude: "-0.742986",
    altitude: "330",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1379",
    name: "St Denis De L Hotel",
    city: "Orleans",
    country: "France",
    iata: "",
    icao: "LFOZ",
    latitude: "47.896946",
    longitude: "2.163333",
    altitude: "396",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1380",
    name: "Le Bourget",
    city: "Paris",
    country: "France",
    iata: "LBG",
    icao: "LFPB",
    latitude: "48.969444",
    longitude: "2.441389",
    altitude: "218",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1381",
    name: "Creil",
    city: "Creil",
    country: "France",
    iata: "CSF",
    icao: "LFPC",
    latitude: "49.253547",
    longitude: "2.519139",
    altitude: "291",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1382",
    name: "Charles De Gaulle",
    city: "Paris",
    country: "France",
    iata: "CDG",
    icao: "LFPG",
    latitude: "49.012779",
    longitude: "2.55",
    altitude: "392",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1383",
    name: "Voisins",
    city: "Coulommiers",
    country: "France",
    iata: "",
    icao: "LFPK",
    latitude: "48.837653",
    longitude: "3.016117",
    altitude: "470",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1384",
    name: "Villaroche",
    city: "Melun",
    country: "France",
    iata: "",
    icao: "LFPM",
    latitude: "48.604725",
    longitude: "2.671119",
    altitude: "302",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1385",
    name: "Toussus Le Noble",
    city: "Toussous-le-noble",
    country: "France",
    iata: "TNF",
    icao: "LFPN",
    latitude: "48.751922",
    longitude: "2.106189",
    altitude: "538",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1386",
    name: "Orly",
    city: "Paris",
    country: "France",
    iata: "ORY",
    icao: "LFPO",
    latitude: "48.725278",
    longitude: "2.359444",
    altitude: "291",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1387",
    name: "Cormeilles En Vexin",
    city: "Pontoise",
    country: "France",
    iata: "POX",
    icao: "LFPT",
    latitude: "49.096647",
    longitude: "2.040833",
    altitude: "325",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1388",
    name: "Velizy",
    city: "Villacoublay",
    country: "France",
    iata: "",
    icao: "LFPV",
    latitude: "48.774406",
    longitude: "2.201536",
    altitude: "584",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1389",
    name: "Prunay",
    city: "Reims",
    country: "France",
    iata: "",
    icao: "LFQA",
    latitude: "49.208689",
    longitude: "4.156581",
    altitude: "313",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1390",
    name: "Barberey",
    city: "Troyes",
    country: "France",
    iata: "QYR",
    icao: "LFQB",
    latitude: "48.322136",
    longitude: "4.016703",
    altitude: "388",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1391",
    name: "Croismare",
    city: "Luneville",
    country: "France",
    iata: "",
    icao: "LFQC",
    latitude: "48.593275",
    longitude: "6.543456",
    altitude: "790",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1392",
    name: "Rouvres",
    city: "Etain",
    country: "France",
    iata: "",
    icao: "LFQE",
    latitude: "49.226917",
    longitude: "5.672219",
    altitude: "770",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1393",
    name: "Bellevue",
    city: "Autun",
    country: "France",
    iata: "",
    icao: "LFQF",
    latitude: "46.967283",
    longitude: "4.260572",
    altitude: "997",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1394",
    name: "Fourchambault",
    city: "Nevers",
    country: "France",
    iata: "NVS",
    icao: "LFQG",
    latitude: "47.002625",
    longitude: "3.113333",
    altitude: "602",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1395",
    name: "Epinoy",
    city: "Cambrai",
    country: "France",
    iata: "",
    icao: "LFQI",
    latitude: "50.221814",
    longitude: "3.154236",
    altitude: "257",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1396",
    name: "Elesmes",
    city: "Maubeuge",
    country: "France",
    iata: "",
    icao: "LFQJ",
    latitude: "50.310467",
    longitude: "4.033119",
    altitude: "452",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1397",
    name: "La Veze",
    city: "Besancon-la-veze",
    country: "France",
    iata: "",
    icao: "LFQM",
    latitude: "47.206567",
    longitude: "6.083681",
    altitude: "1271",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1398",
    name: "Bourscheid",
    city: "Phalsbourg",
    country: "France",
    iata: "",
    icao: "LFQP",
    latitude: "48.76625",
    longitude: "7.200519",
    altitude: "1017",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1399",
    name: "Lesquin",
    city: "Lille",
    country: "France",
    iata: "LIL",
    icao: "LFQQ",
    latitude: "50.561942",
    longitude: "3.089444",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1400",
    name: "Calonne",
    city: "Merville",
    country: "France",
    iata: "",
    icao: "LFQT",
    latitude: "50.618394",
    longitude: "2.642242",
    altitude: "61",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1401",
    name: "Charleville Mezieres",
    city: "Charleville",
    country: "France",
    iata: "",
    icao: "LFQV",
    latitude: "49.783942",
    longitude: "4.647078",
    altitude: "492",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1402",
    name: "Frotey",
    city: "Vesoul-frotey",
    country: "France",
    iata: "",
    icao: "LFQW",
    latitude: "47.637611",
    longitude: "6.203922",
    altitude: "1249",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1403",
    name: "Guipavas",
    city: "Brest",
    country: "France",
    iata: "BES",
    icao: "LFRB",
    latitude: "48.447911",
    longitude: "-4.418539",
    altitude: "325",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1404",
    name: "Maupertus",
    city: "Cherbourg",
    country: "France",
    iata: "CER",
    icao: "LFRC",
    latitude: "49.650106",
    longitude: "-1.470281",
    altitude: "459",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1405",
    name: "Pleurtuit",
    city: "Dinard",
    country: "France",
    iata: "DNR",
    icao: "LFRD",
    latitude: "48.587683",
    longitude: "-2.079958",
    altitude: "219",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1406",
    name: "Escoublac",
    city: "La Baule",
    country: "France",
    iata: "",
    icao: "LFRE",
    latitude: "47.289444",
    longitude: "-2.346389",
    altitude: "105",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1407",
    name: "Granville",
    city: "Granville",
    country: "France",
    iata: "GFR",
    icao: "LFRF",
    latitude: "48.883057",
    longitude: "-1.564167",
    altitude: "45",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1408",
    name: "St Gatien",
    city: "Deauville",
    country: "France",
    iata: "DOL",
    icao: "LFRG",
    latitude: "49.365339",
    longitude: "0.154306",
    altitude: "479",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1409",
    name: "Lann Bihoue",
    city: "Lorient",
    country: "France",
    iata: "LRT",
    icao: "LFRH",
    latitude: "47.760555",
    longitude: "-3.44",
    altitude: "160",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1410",
    name: "Les Ajoncs",
    city: "La Roche-sur-yon",
    country: "France",
    iata: "EDM",
    icao: "LFRI",
    latitude: "46.701944",
    longitude: "-1.378625",
    altitude: "299",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1411",
    name: "Landivisiau",
    city: "Landivisiau",
    country: "France",
    iata: "",
    icao: "LFRJ",
    latitude: "48.530258",
    longitude: "-4.151642",
    altitude: "348",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1412",
    name: "Carpiquet",
    city: "Caen",
    country: "France",
    iata: "CFR",
    icao: "LFRK",
    latitude: "49.173333",
    longitude: "-0.45",
    altitude: "256",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1413",
    name: "Poulmic",
    city: "Lanvedoc",
    country: "France",
    iata: "",
    icao: "LFRL",
    latitude: "48.281703",
    longitude: "-4.445017",
    altitude: "287",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1414",
    name: "Arnage",
    city: "Le Mans",
    country: "France",
    iata: "LME",
    icao: "LFRM",
    latitude: "47.948611",
    longitude: "0.201667",
    altitude: "194",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1415",
    name: "St Jacques",
    city: "Rennes",
    country: "France",
    iata: "RNS",
    icao: "LFRN",
    latitude: "48.069508",
    longitude: "-1.734794",
    altitude: "124",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1416",
    name: "Lannion",
    city: "Lannion",
    country: "France",
    iata: "LAI",
    icao: "LFRO",
    latitude: "48.754378",
    longitude: "-3.471656",
    altitude: "290",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1417",
    name: "Pluguffan",
    city: "Quimper",
    country: "France",
    iata: "UIP",
    icao: "LFRQ",
    latitude: "47.974981",
    longitude: "-4.167786",
    altitude: "297",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1418",
    name: "Nantes Atlantique",
    city: "Nantes",
    country: "France",
    iata: "NTE",
    icao: "LFRS",
    latitude: "47.153189",
    longitude: "-1.610725",
    altitude: "90",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1419",
    name: "Armor",
    city: "St.-brieuc Armor",
    country: "France",
    iata: "SBK",
    icao: "LFRT",
    latitude: "48.537777",
    longitude: "-2.854445",
    altitude: "453",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1420",
    name: "Ploujean",
    city: "Morlaix",
    country: "France",
    iata: "MXN",
    icao: "LFRU",
    latitude: "48.603222",
    longitude: "-3.815783",
    altitude: "272",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1421",
    name: "Meucon",
    city: "Vannes",
    country: "France",
    iata: "VNE",
    icao: "LFRV",
    latitude: "47.723303",
    longitude: "-2.718561",
    altitude: "440",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1422",
    name: "Montoir",
    city: "St.-nazaire",
    country: "France",
    iata: "SNR",
    icao: "LFRZ",
    latitude: "47.312189",
    longitude: "-2.149181",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1423",
    name: "Bale Mulhouse",
    city: "Mulhouse",
    country: "France",
    iata: "MLH",
    icao: "LFSB",
    latitude: "47.589583",
    longitude: "7.529914",
    altitude: "885",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1424",
    name: "Meyenheim",
    city: "Colmar",
    country: "France",
    iata: "",
    icao: "LFSC",
    latitude: "47.921978",
    longitude: "7.399669",
    altitude: "693",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1425",
    name: "Longvic",
    city: "Dijon",
    country: "France",
    iata: "DIJ",
    icao: "LFSD",
    latitude: "47.26889",
    longitude: "5.09",
    altitude: "726",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1426",
    name: "Frescaty",
    city: "Metz",
    country: "France",
    iata: "MZM",
    icao: "LFSF",
    latitude: "49.071667",
    longitude: "6.131667",
    altitude: "629",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1427",
    name: "Mirecourt",
    city: "Epinal",
    country: "France",
    iata: "EPL",
    icao: "LFSG",
    latitude: "48.324961",
    longitude: "6.069983",
    altitude: "1084",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1428",
    name: "Haguenau",
    city: "Haguenau",
    country: "France",
    iata: "",
    icao: "LFSH",
    latitude: "48.794331",
    longitude: "7.817613",
    altitude: "491",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1429",
    name: "Robinson",
    city: "St.-dizier",
    country: "France",
    iata: "",
    icao: "LFSI",
    latitude: "48.636008",
    longitude: "4.899417",
    altitude: "458",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1430",
    name: "Courcelles",
    city: "Montbeliard",
    country: "France",
    iata: "",
    icao: "LFSM",
    latitude: "47.487",
    longitude: "6.790536",
    altitude: "1041",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1431",
    name: "Essey",
    city: "Nancy",
    country: "France",
    iata: "ENC",
    icao: "LFSN",
    latitude: "48.692069",
    longitude: "6.230458",
    altitude: "751",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1432",
    name: "Ochey",
    city: "Nancy",
    country: "France",
    iata: "",
    icao: "LFSO",
    latitude: "48.583056",
    longitude: "5.955",
    altitude: "1106",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1433",
    name: "Pontarlier",
    city: "Pontarlier",
    country: "France",
    iata: "",
    icao: "LFSP",
    latitude: "46.903958",
    longitude: "6.327367",
    altitude: "2683",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1434",
    name: "Champagne",
    city: "Reims",
    country: "France",
    iata: "RHE",
    icao: "LFSR",
    latitude: "49.31",
    longitude: "4.05",
    altitude: "312",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1435",
    name: "Entzheim",
    city: "Strasbourg",
    country: "France",
    iata: "SXB",
    icao: "LFST",
    latitude: "48.538319",
    longitude: "7.628233",
    altitude: "505",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1436",
    name: "Saint Sauveur",
    city: "Luxeuil",
    country: "France",
    iata: "",
    icao: "LFSX",
    latitude: "47.783131",
    longitude: "6.364056",
    altitude: "913",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1437",
    name: "Pierrefeu",
    city: "Cuers",
    country: "France",
    iata: "",
    icao: "LFTF",
    latitude: "43.247803",
    longitude: "6.126697",
    altitude: "266",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1438",
    name: "Le Palyvestre",
    city: "Hyeres",
    country: "France",
    iata: "TLN",
    icao: "LFTH",
    latitude: "43.0973",
    longitude: "6.14603",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1439",
    name: "Garons",
    city: "Nimes",
    country: "France",
    iata: "FNI",
    icao: "LFTW",
    latitude: "43.757444",
    longitude: "4.416347",
    altitude: "309",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1440",
    name: "Miquelon",
    city: "Miquelon",
    country: "Saint Pierre and Miquelon",
    iata: "MQC",
    icao: "LFVM",
    latitude: "47.095472",
    longitude: "-56.380278",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Miquelon",
  },
  {
    id: "1441",
    name: "St Pierre",
    city: "St.-pierre",
    country: "Saint Pierre and Miquelon",
    iata: "FSP",
    icao: "LFVP",
    latitude: "46.762904",
    longitude: "-56.173088",
    altitude: "27",
    timezone: "-3",
    dst: "U",
    tz: "America/Miquelon",
  },
  {
    id: "1442",
    name: "Amberieu",
    city: "Amberieu",
    country: "France",
    iata: "",
    icao: "LFXA",
    latitude: "45.987335",
    longitude: "5.328445",
    altitude: "823",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1443",
    name: "Damblain",
    city: "Damblain",
    country: "France",
    iata: "",
    icao: "LFYD",
    latitude: "48.086325",
    longitude: "5.664058",
    altitude: "1280",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1444",
    name: "Andravida",
    city: "Andravida",
    country: "Greece",
    iata: "PYR",
    icao: "LGAD",
    latitude: "37.920708",
    longitude: "21.292583",
    altitude: "55",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1445",
    name: "Agrinion",
    city: "Agrinion",
    country: "Greece",
    iata: "AGQ",
    icao: "LGAG",
    latitude: "38.602022",
    longitude: "21.351208",
    altitude: "154",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1446",
    name: "Dimokritos",
    city: "Alexandroupolis",
    country: "Greece",
    iata: "AXD",
    icao: "LGAL",
    latitude: "40.855869",
    longitude: "25.956264",
    altitude: "24",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1447",
    name: "Alexandria",
    city: "Alexandria",
    country: "Greece",
    iata: "",
    icao: "LGAX",
    latitude: "40.651128",
    longitude: "22.488739",
    altitude: "27",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1448",
    name: "Nea Anchialos",
    city: "Nea Anghialos",
    country: "Greece",
    iata: "VOL",
    icao: "LGBL",
    latitude: "39.219619",
    longitude: "22.794339",
    altitude: "83",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1449",
    name: "Elefsis",
    city: "Elefsis",
    country: "Greece",
    iata: "",
    icao: "LGEL",
    latitude: "38.063831",
    longitude: "23.556011",
    altitude: "143",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1450",
    name: "Chios",
    city: "Chios",
    country: "Greece",
    iata: "JKH",
    icao: "LGHI",
    latitude: "38.343175",
    longitude: "26.140572",
    altitude: "15",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1451",
    name: "Ioannina",
    city: "Ioannina",
    country: "Greece",
    iata: "IOA",
    icao: "LGIO",
    latitude: "39.696388",
    longitude: "20.8225",
    altitude: "1558",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1452",
    name: "Nikos Kazantzakis",
    city: "Heraklion",
    country: "Greece",
    iata: "HER",
    icao: "LGIR",
    latitude: "35.339719",
    longitude: "25.180297",
    altitude: "115",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1453",
    name: "Aristotelis",
    city: "Kastoria",
    country: "Greece",
    iata: "KSO",
    icao: "LGKA",
    latitude: "40.446294",
    longitude: "21.282186",
    altitude: "2167",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1454",
    name: "Kithira",
    city: "Kithira",
    country: "Greece",
    iata: "KIT",
    icao: "LGKC",
    latitude: "36.274258",
    longitude: "23.016978",
    altitude: "1045",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1455",
    name: "Kefallinia",
    city: "Keffallinia",
    country: "Greece",
    iata: "EFL",
    icao: "LGKF",
    latitude: "38.120069",
    longitude: "20.500481",
    altitude: "59",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1456",
    name: "Kalamata",
    city: "Kalamata",
    country: "Greece",
    iata: "KLX",
    icao: "LGKL",
    latitude: "37.068319",
    longitude: "22.025525",
    altitude: "26",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1457",
    name: "Amigdhaleon",
    city: "Kavala",
    country: "Greece",
    iata: "",
    icao: "LGKM",
    latitude: "40.972775",
    longitude: "24.341417",
    altitude: "203",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1458",
    name: "Kos",
    city: "Kos",
    country: "Greece",
    iata: "KGS",
    icao: "LGKO",
    latitude: "36.793335",
    longitude: "27.091667",
    altitude: "412",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1459",
    name: "Karpathos",
    city: "Karpathos",
    country: "Greece",
    iata: "AOK",
    icao: "LGKP",
    latitude: "35.421408",
    longitude: "27.146008",
    altitude: "66",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1460",
    name: "Ioannis Kapodistrias Intl",
    city: "Kerkyra/corfu",
    country: "Greece",
    iata: "CFU",
    icao: "LGKR",
    latitude: "39.601944",
    longitude: "19.911667",
    altitude: "6",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1461",
    name: "Kasos",
    city: "Kasos",
    country: "Greece",
    iata: "KSJ",
    icao: "LGKS",
    latitude: "35.421358",
    longitude: "26.910047",
    altitude: "35",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1462",
    name: "Megas Alexandros Intl",
    city: "Kavala",
    country: "Greece",
    iata: "KVA",
    icao: "LGKV",
    latitude: "40.913306",
    longitude: "24.619223",
    altitude: "18",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1463",
    name: "Filippos",
    city: "Kozani",
    country: "Greece",
    iata: "KZI",
    icao: "LGKZ",
    latitude: "40.28611",
    longitude: "21.840834",
    altitude: "2059",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1464",
    name: "Leros",
    city: "Leros",
    country: "Greece",
    iata: "LRS",
    icao: "LGLE",
    latitude: "37.184903",
    longitude: "26.800289",
    altitude: "39",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1465",
    name: "Limnos",
    city: "Limnos",
    country: "Greece",
    iata: "LXS",
    icao: "LGLM",
    latitude: "39.917072",
    longitude: "25.236308",
    altitude: "14",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1466",
    name: "Larisa",
    city: "Larissa",
    country: "Greece",
    iata: "LRA",
    icao: "LGLR",
    latitude: "39.650253",
    longitude: "22.4655",
    altitude: "241",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1467",
    name: "Megara",
    city: "Megara",
    country: "Greece",
    iata: "",
    icao: "LGMG",
    latitude: "37.981114",
    longitude: "23.365422",
    altitude: "12",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1468",
    name: "Mikonos",
    city: "Mykonos",
    country: "Greece",
    iata: "JMK",
    icao: "LGMK",
    latitude: "37.435128",
    longitude: "25.348103",
    altitude: "405",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1469",
    name: "Mitilini",
    city: "Mytilini",
    country: "Greece",
    iata: "MJT",
    icao: "LGMT",
    latitude: "39.056667",
    longitude: "26.598333",
    altitude: "60",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1470",
    name: "Aktio",
    city: "Preveza",
    country: "Greece",
    iata: "PVK",
    icao: "LGPZ",
    latitude: "38.925467",
    longitude: "20.765311",
    altitude: "11",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1471",
    name: "Maritsa",
    city: "Rhodos",
    country: "Greece",
    iata: "",
    icao: "LGRD",
    latitude: "36.383056",
    longitude: "28.108889",
    altitude: "204",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1472",
    name: "Rhodes Diagoras",
    city: "Rhodos",
    country: "Greece",
    iata: "RHO",
    icao: "LGRP",
    latitude: "36.405419",
    longitude: "28.086192",
    altitude: "17",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1473",
    name: "Araxos",
    city: "Patras",
    country: "Greece",
    iata: "GPA",
    icao: "LGRX",
    latitude: "38.151111",
    longitude: "21.425556",
    altitude: "46",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1474",
    name: "Souda",
    city: "Chania",
    country: "Greece",
    iata: "CHQ",
    icao: "LGSA",
    latitude: "35.531747",
    longitude: "24.149678",
    altitude: "490",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1475",
    name: "Alexandros Papadiamantis",
    city: "Skiathos",
    country: "Greece",
    iata: "JSI",
    icao: "LGSK",
    latitude: "39.1771",
    longitude: "23.503675",
    altitude: "54",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1476",
    name: "Samos",
    city: "Samos",
    country: "Greece",
    iata: "SMI",
    icao: "LGSM",
    latitude: "37.689999",
    longitude: "26.911667",
    altitude: "19",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "6886",
    name: "Ashford",
    city: "Lympne",
    country: "United Kingdom",
    iata: "LYM",
    icao: "EGMK",
    latitude: "51.083333",
    longitude: "1.016667",
    altitude: "351",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "1478",
    name: "Sparti",
    city: "Sparti",
    country: "Greece",
    iata: "",
    icao: "LGSP",
    latitude: "36.973892",
    longitude: "22.526292",
    altitude: "500",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1479",
    name: "Santorini",
    city: "Thira",
    country: "Greece",
    iata: "JTR",
    icao: "LGSR",
    latitude: "36.399169",
    longitude: "25.479333",
    altitude: "127",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1480",
    name: "Sitia",
    city: "Sitia",
    country: "Greece",
    iata: "JSH",
    icao: "LGST",
    latitude: "35.216108",
    longitude: "26.101325",
    altitude: "376",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1481",
    name: "Stefanovikion",
    city: "Stefanovikion",
    country: "Greece",
    iata: "",
    icao: "LGSV",
    latitude: "39.48",
    longitude: "22.767222",
    altitude: "146",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1482",
    name: "Skiros",
    city: "Skiros",
    country: "Greece",
    iata: "SKU",
    icao: "LGSY",
    latitude: "38.967553",
    longitude: "24.487228",
    altitude: "44",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1483",
    name: "Tanagra",
    city: "Tanagra",
    country: "Greece",
    iata: "",
    icao: "LGTG",
    latitude: "38.339847",
    longitude: "23.564958",
    altitude: "485",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1484",
    name: "Kasteli",
    city: "Kasteli",
    country: "Greece",
    iata: "",
    icao: "LGTL",
    latitude: "35.192019",
    longitude: "25.327",
    altitude: "1180",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1485",
    name: "Tripolis",
    city: "Tripolis",
    country: "Greece",
    iata: "",
    icao: "LGTP",
    latitude: "37.530567",
    longitude: "22.403633",
    altitude: "2113",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1486",
    name: "Makedonia",
    city: "Thessaloniki",
    country: "Greece",
    iata: "SKG",
    icao: "LGTS",
    latitude: "40.519725",
    longitude: "22.97095",
    altitude: "22",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1487",
    name: "Tatoi",
    city: "Dekelia",
    country: "Greece",
    iata: "",
    icao: "LGTT",
    latitude: "38.108928",
    longitude: "23.783836",
    altitude: "785",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1488",
    name: "Dionysios Solomos",
    city: "Zakynthos",
    country: "Greece",
    iata: "ZTH",
    icao: "LGZA",
    latitude: "37.750853",
    longitude: "20.88425",
    altitude: "15",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "1489",
    name: "Ferihegy",
    city: "Budapest",
    country: "Hungary",
    iata: "BUD",
    icao: "LHBP",
    latitude: "47.436933",
    longitude: "19.255592",
    altitude: "495",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "1490",
    name: "Debrecen",
    city: "Debrecen",
    country: "Hungary",
    iata: "DEB",
    icao: "LHDC",
    latitude: "47.488917",
    longitude: "21.615333",
    altitude: "359",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "1491",
    name: "Kecskemet",
    city: "Kecskemet",
    country: "Hungary",
    iata: "",
    icao: "LHKE",
    latitude: "46.9175",
    longitude: "19.749222",
    altitude: "376",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "1492",
    name: "Nyiregyhaza",
    city: "Nyirregyhaza",
    country: "Hungary",
    iata: "",
    icao: "LHNY",
    latitude: "47.983892",
    longitude: "21.692317",
    altitude: "338",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "1493",
    name: "Ocseny",
    city: "Ocseny",
    country: "Hungary",
    iata: "",
    icao: "LHOY",
    latitude: "46.303889",
    longitude: "18.769167",
    altitude: "295",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "6885",
    name: "Door County Cherryland Airport",
    city: "Sturgeon Bay",
    country: "United States",
    iata: "SUE",
    icao: "\\N",
    latitude: "44.8436667",
    longitude: "-87.4215556",
    altitude: "725",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "1496",
    name: "Szentkiralyszabadja",
    city: "Azentkilyszabadja",
    country: "Hungary",
    iata: "",
    icao: "LHSA",
    latitude: "47.077861",
    longitude: "17.968444",
    altitude: "919",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "1498",
    name: "Szolnok",
    city: "Szolnok",
    country: "Hungary",
    iata: "",
    icao: "LHSN",
    latitude: "47.122861",
    longitude: "20.2355",
    altitude: "322",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "1499",
    name: "Amendola",
    city: "Amendola",
    country: "Italy",
    iata: "",
    icao: "LIBA",
    latitude: "41.541392",
    longitude: "15.718083",
    altitude: "183",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1500",
    name: "Crotone",
    city: "Crotone",
    country: "Italy",
    iata: "CRV",
    icao: "LIBC",
    latitude: "38.997225",
    longitude: "17.080169",
    altitude: "521",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1501",
    name: "Bari",
    city: "Bari",
    country: "Italy",
    iata: "BRI",
    icao: "LIBD",
    latitude: "41.138856",
    longitude: "16.760594",
    altitude: "177",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1502",
    name: "Gino Lisa",
    city: "Foggia",
    country: "Italy",
    iata: "FOG",
    icao: "LIBF",
    latitude: "41.432917",
    longitude: "15.535028",
    altitude: "266",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1503",
    name: "Grottaglie",
    city: "Grottaglie",
    country: "Italy",
    iata: "TAR",
    icao: "LIBG",
    latitude: "40.517514",
    longitude: "17.403212",
    altitude: "215",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1504",
    name: "Lecce",
    city: "Lecce",
    country: "Italy",
    iata: "LCC",
    icao: "LIBN",
    latitude: "40.239228",
    longitude: "18.133325",
    altitude: "156",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1505",
    name: "Pescara",
    city: "Pescara",
    country: "Italy",
    iata: "PSR",
    icao: "LIBP",
    latitude: "42.431656",
    longitude: "14.181067",
    altitude: "48",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1506",
    name: "Casale",
    city: "Brindisi",
    country: "Italy",
    iata: "BDS",
    icao: "LIBR",
    latitude: "40.657633",
    longitude: "17.947033",
    altitude: "47",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1507",
    name: "Gioia Del Colle",
    city: "Gioia Del Colle",
    country: "Italy",
    iata: "",
    icao: "LIBV",
    latitude: "40.767833",
    longitude: "16.933333",
    altitude: "1187",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1508",
    name: "Lamezia Terme",
    city: "Lamezia",
    country: "Italy",
    iata: "SUF",
    icao: "LICA",
    latitude: "38.905394",
    longitude: "16.242269",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1509",
    name: "Catania Fontanarossa",
    city: "Catania",
    country: "Italy",
    iata: "CTA",
    icao: "LICC",
    latitude: "37.466781",
    longitude: "15.0664",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1510",
    name: "Lampedusa",
    city: "Lampedusa",
    country: "Italy",
    iata: "LMP",
    icao: "LICD",
    latitude: "35.497914",
    longitude: "12.618083",
    altitude: "70",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1511",
    name: "Pantelleria",
    city: "Pantelleria",
    country: "Italy",
    iata: "PNL",
    icao: "LICG",
    latitude: "36.816519",
    longitude: "11.968864",
    altitude: "635",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1512",
    name: "Palermo",
    city: "Palermo",
    country: "Italy",
    iata: "PMO",
    icao: "LICJ",
    latitude: "38.175958",
    longitude: "13.091019",
    altitude: "65",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1513",
    name: "Boccadifalco",
    city: "Palermo",
    country: "Italy",
    iata: "",
    icao: "LICP",
    latitude: "38.110833",
    longitude: "13.313333",
    altitude: "345",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1514",
    name: "Reggio Calabria",
    city: "Reggio Calabria",
    country: "Italy",
    iata: "REG",
    icao: "LICR",
    latitude: "38.071206",
    longitude: "15.651556",
    altitude: "96",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1515",
    name: "Trapani Birgi",
    city: "Trapani",
    country: "Italy",
    iata: "TPS",
    icao: "LICT",
    latitude: "37.911403",
    longitude: "12.487961",
    altitude: "24",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1516",
    name: "Sigonella",
    city: "Sigonella",
    country: "Italy",
    iata: "NSY",
    icao: "LICZ",
    latitude: "37.401664",
    longitude: "14.922358",
    altitude: "79",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1517",
    name: "Alghero",
    city: "Alghero",
    country: "Italy",
    iata: "AHO",
    icao: "LIEA",
    latitude: "40.632133",
    longitude: "8.290772",
    altitude: "87",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1518",
    name: "Decimomannu",
    city: "Decimomannu",
    country: "Italy",
    iata: "DCI",
    icao: "LIED",
    latitude: "39.354222",
    longitude: "8.972481",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1519",
    name: "Elmas",
    city: "Cagliari",
    country: "Italy",
    iata: "CAG",
    icao: "LIEE",
    latitude: "39.251469",
    longitude: "9.054283",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1520",
    name: "Olbia Costa Smeralda",
    city: "Olbia",
    country: "Italy",
    iata: "OLB",
    icao: "LIEO",
    latitude: "40.898661",
    longitude: "9.517628",
    altitude: "37",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1521",
    name: "Tortoli",
    city: "Tortoli",
    country: "Italy",
    iata: "TTB",
    icao: "LIET",
    latitude: "39.918761",
    longitude: "9.682981",
    altitude: "23",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1522",
    name: "Aeritalia",
    city: "Turin",
    country: "Italy",
    iata: "",
    icao: "LIMA",
    latitude: "45.086353",
    longitude: "7.603375",
    altitude: "943",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1523",
    name: "Bresso",
    city: "Milano",
    country: "Italy",
    iata: "",
    icao: "LIMB",
    latitude: "45.542222",
    longitude: "9.203333",
    altitude: "484",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1524",
    name: "Malpensa",
    city: "Milano",
    country: "Italy",
    iata: "MXP",
    icao: "LIMC",
    latitude: "45.630606",
    longitude: "8.728111",
    altitude: "767",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1525",
    name: "Bergamo Orio Al Serio",
    city: "Bergamo",
    country: "Italy",
    iata: "BGY",
    icao: "LIME",
    latitude: "45.673889",
    longitude: "9.704166",
    altitude: "782",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1526",
    name: "Torino",
    city: "Torino",
    country: "Italy",
    iata: "TRN",
    icao: "LIMF",
    latitude: "45.200761",
    longitude: "7.649631",
    altitude: "989",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1527",
    name: "Albenga",
    city: "Albenga",
    country: "Italy",
    iata: "ALL",
    icao: "LIMG",
    latitude: "44.050608",
    longitude: "8.127428",
    altitude: "148",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1528",
    name: "Genova Sestri",
    city: "Genoa",
    country: "Italy",
    iata: "GOA",
    icao: "LIMJ",
    latitude: "44.413333",
    longitude: "8.8375",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1529",
    name: "Linate",
    city: "Milan",
    country: "Italy",
    iata: "LIN",
    icao: "LIML",
    latitude: "45.445103",
    longitude: "9.276739",
    altitude: "353",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1530",
    name: "Cameri",
    city: "Cameri",
    country: "Italy",
    iata: "",
    icao: "LIMN",
    latitude: "45.529592",
    longitude: "8.669225",
    altitude: "586",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1531",
    name: "Parma",
    city: "Parma",
    country: "Italy",
    iata: "PMF",
    icao: "LIMP",
    latitude: "44.824483",
    longitude: "10.296367",
    altitude: "161",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1532",
    name: "Piacenza",
    city: "Piacenza",
    country: "Italy",
    iata: "QPZ",
    icao: "LIMS",
    latitude: "44.913055",
    longitude: "9.723333",
    altitude: "456",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "6884",
    name: "Shoestring Aviation Airfield",
    city: "Stewartstown",
    country: "United States",
    iata: "0P2",
    icao: "\\N",
    latitude: "39.7948244",
    longitude: "-76.6471914",
    altitude: "1000",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "1534",
    name: "Levaldigi",
    city: "Cuneo",
    country: "Italy",
    iata: "CUF",
    icao: "LIMZ",
    latitude: "44.547019",
    longitude: "7.623217",
    altitude: "1267",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1535",
    name: "Aviano Ab",
    city: "Aviano",
    country: "Italy",
    iata: "AVB",
    icao: "LIPA",
    latitude: "46.031889",
    longitude: "12.596472",
    altitude: "410",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1536",
    name: "Bolzano",
    city: "Bolzano",
    country: "Italy",
    iata: "BZO",
    icao: "LIPB",
    latitude: "46.460194",
    longitude: "11.326383",
    altitude: "789",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1537",
    name: "Cervia",
    city: "Cervia",
    country: "Italy",
    iata: "",
    icao: "LIPC",
    latitude: "44.224175",
    longitude: "12.307203",
    altitude: "18",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1538",
    name: "Bologna",
    city: "Bologna",
    country: "Italy",
    iata: "BLQ",
    icao: "LIPE",
    latitude: "44.535444",
    longitude: "11.288667",
    altitude: "123",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1539",
    name: "Treviso",
    city: "Treviso",
    country: "Italy",
    iata: "TSF",
    icao: "LIPH",
    latitude: "45.6484",
    longitude: "12.194422",
    altitude: "59",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1540",
    name: "Rivolto",
    city: "Rivolto",
    country: "Italy",
    iata: "",
    icao: "LIPI",
    latitude: "45.97875",
    longitude: "13.049331",
    altitude: "179",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1541",
    name: "Forli",
    city: "Forli",
    country: "Italy",
    iata: "FRL",
    icao: "LIPK",
    latitude: "44.194753",
    longitude: "12.070094",
    altitude: "97",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1542",
    name: "Ghedi",
    city: "Ghedi",
    country: "Italy",
    iata: "",
    icao: "LIPL",
    latitude: "45.432167",
    longitude: "10.267667",
    altitude: "333",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1543",
    name: "Verona Boscomantico",
    city: "Verona",
    country: "Italy",
    iata: "",
    icao: "LIPN",
    latitude: "45.472017",
    longitude: "10.927919",
    altitude: "286",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1544",
    name: "Montichiari",
    city: "Brescia",
    country: "Italy",
    iata: "VBS",
    icao: "LIPO",
    latitude: "45.428889",
    longitude: "10.330556",
    altitude: "356",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1545",
    name: "Ronchi Dei Legionari",
    city: "Ronchi De Legionari",
    country: "Italy",
    iata: "TRS",
    icao: "LIPQ",
    latitude: "45.8275",
    longitude: "13.472222",
    altitude: "37",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1546",
    name: "Rimini",
    city: "Rimini",
    country: "Italy",
    iata: "RMI",
    icao: "LIPR",
    latitude: "44.020292",
    longitude: "12.611747",
    altitude: "41",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1547",
    name: "Istrana",
    city: "Treviso",
    country: "Italy",
    iata: "",
    icao: "LIPS",
    latitude: "45.684867",
    longitude: "12.082881",
    altitude: "137",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1548",
    name: "Vicenza",
    city: "Vicenza",
    country: "Italy",
    iata: "VIC",
    icao: "LIPT",
    latitude: "45.573411",
    longitude: "11.52955",
    altitude: "128",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1549",
    name: "Padova",
    city: "Padova",
    country: "Italy",
    iata: "QPA",
    icao: "LIPU",
    latitude: "45.395767",
    longitude: "11.847903",
    altitude: "44",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1550",
    name: "Villafranca",
    city: "Villafranca",
    country: "Italy",
    iata: "VRN",
    icao: "LIPX",
    latitude: "45.395706",
    longitude: "10.888533",
    altitude: "239",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1551",
    name: "Venezia Tessera",
    city: "Venice",
    country: "Italy",
    iata: "VCE",
    icao: "LIPZ",
    latitude: "45.505278",
    longitude: "12.351944",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1552",
    name: "Ampugnano",
    city: "Siena",
    country: "Italy",
    iata: "SAY",
    icao: "LIQS",
    latitude: "43.256286",
    longitude: "11.255036",
    altitude: "634",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1553",
    name: "Ciampino",
    city: "Rome",
    country: "Italy",
    iata: "CIA",
    icao: "LIRA",
    latitude: "41.799361",
    longitude: "12.594936",
    altitude: "427",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1554",
    name: "Pratica Di Mare",
    city: "Pratica Di Mare",
    country: "Italy",
    iata: "",
    icao: "LIRE",
    latitude: "41.654522",
    longitude: "12.445183",
    altitude: "41",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1555",
    name: "Fiumicino",
    city: "Rome",
    country: "Italy",
    iata: "FCO",
    icao: "LIRF",
    latitude: "41.804475",
    longitude: "12.250797",
    altitude: "15",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1556",
    name: "Guidonia",
    city: "Guidonia",
    country: "Italy",
    iata: "",
    icao: "LIRG",
    latitude: "41.990278",
    longitude: "12.740833",
    altitude: "289",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1558",
    name: "Marina Di Campo",
    city: "Marina Di Campo",
    country: "Italy",
    iata: "EBA",
    icao: "LIRJ",
    latitude: "42.760277",
    longitude: "10.239445",
    altitude: "31",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1559",
    name: "Latina",
    city: "Latina",
    country: "Italy",
    iata: "QLT",
    icao: "LIRL",
    latitude: "41.542436",
    longitude: "12.909019",
    altitude: "93",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1560",
    name: "Grazzanise",
    city: "Grazzanise",
    country: "Italy",
    iata: "",
    icao: "LIRM",
    latitude: "41.060833",
    longitude: "14.081944",
    altitude: "29",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1561",
    name: "Capodichino",
    city: "Naples",
    country: "Italy",
    iata: "NAP",
    icao: "LIRN",
    latitude: "40.886033",
    longitude: "14.290781",
    altitude: "294",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1562",
    name: "Pisa",
    city: "Pisa",
    country: "Italy",
    iata: "PSA",
    icao: "LIRP",
    latitude: "43.683917",
    longitude: "10.39275",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1563",
    name: "Firenze",
    city: "Florence",
    country: "Italy",
    iata: "FLR",
    icao: "LIRQ",
    latitude: "43.809953",
    longitude: "11.2051",
    altitude: "142",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1564",
    name: "Grosseto",
    city: "Grosseto",
    country: "Italy",
    iata: "GRS",
    icao: "LIRS",
    latitude: "42.759747",
    longitude: "11.071897",
    altitude: "15",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1565",
    name: "Urbe",
    city: "Rome",
    country: "Italy",
    iata: "",
    icao: "LIRU",
    latitude: "41.951946",
    longitude: "12.498889",
    altitude: "55",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1566",
    name: "Viterbo",
    city: "Viterbo",
    country: "Italy",
    iata: "",
    icao: "LIRV",
    latitude: "42.430183",
    longitude: "12.064156",
    altitude: "990",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1567",
    name: "Perugia",
    city: "Perugia",
    country: "Italy",
    iata: "PEG",
    icao: "LIRZ",
    latitude: "43.095906",
    longitude: "12.513222",
    altitude: "693",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "1568",
    name: "Cerklje",
    city: "Cerklje",
    country: "Slovenia",
    iata: "",
    icao: "LJCE",
    latitude: "45.899971",
    longitude: "15.530194",
    altitude: "510",
    timezone: "1",
    dst: "E",
    tz: "Europe/Ljubljana",
  },
  {
    id: "1569",
    name: "Ljubljana",
    city: "Ljubljana",
    country: "Slovenia",
    iata: "LJU",
    icao: "LJLJ",
    latitude: "46.223686",
    longitude: "14.457611",
    altitude: "1273",
    timezone: "1",
    dst: "E",
    tz: "Europe/Ljubljana",
  },
  {
    id: "1570",
    name: "Maribor",
    city: "Maribor",
    country: "Slovenia",
    iata: "MBX",
    icao: "LJMB",
    latitude: "46.479861",
    longitude: "15.686131",
    altitude: "876",
    timezone: "1",
    dst: "E",
    tz: "Europe/Ljubljana",
  },
  {
    id: "1571",
    name: "Portoroz",
    city: "Portoroz",
    country: "Slovenia",
    iata: "POW",
    icao: "LJPZ",
    latitude: "45.473353",
    longitude: "13.614978",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Ljubljana",
  },
  {
    id: "1572",
    name: "Slovenj Gradec",
    city: "Slovenj Gradec",
    country: "Slovenia",
    iata: "",
    icao: "LJSG",
    latitude: "46.471975",
    longitude: "15.116997",
    altitude: "1645",
    timezone: "1",
    dst: "E",
    tz: "Europe/Ljubljana",
  },
  {
    id: "1573",
    name: "Ceske Budejovice",
    city: "Ceske Budejovice",
    country: "Czech Republic",
    iata: "",
    icao: "LKCS",
    latitude: "48.946381",
    longitude: "14.427464",
    altitude: "1417",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1574",
    name: "Caslav",
    city: "Caslav",
    country: "Czech Republic",
    iata: "",
    icao: "LKCV",
    latitude: "49.939653",
    longitude: "15.381808",
    altitude: "794",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1575",
    name: "Hradec Kralove",
    city: "Hradec Kralove",
    country: "Czech Republic",
    iata: "",
    icao: "LKHK",
    latitude: "50.2532",
    longitude: "15.845228",
    altitude: "791",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1576",
    name: "Horovice",
    city: "Horovice",
    country: "Czech Republic",
    iata: "",
    icao: "LKHV",
    latitude: "49.848111",
    longitude: "13.893506",
    altitude: "1214",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1577",
    name: "Kbely",
    city: "Praha",
    country: "Czech Republic",
    iata: "",
    icao: "LKKB",
    latitude: "50.121367",
    longitude: "14.543642",
    altitude: "939",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1578",
    name: "Kunovice",
    city: "Kunovice",
    country: "Czech Republic",
    iata: "",
    icao: "LKKU",
    latitude: "49.029444",
    longitude: "17.439722",
    altitude: "581",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1579",
    name: "Karlovy Vary",
    city: "Karlovy Vary",
    country: "Czech Republic",
    iata: "KLV",
    icao: "LKKV",
    latitude: "50.202978",
    longitude: "12.914983",
    altitude: "1989",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1580",
    name: "Plzen Line",
    city: "Line",
    country: "Czech Republic",
    iata: "",
    icao: "LKLN",
    latitude: "49.675172",
    longitude: "13.274617",
    altitude: "1188",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1581",
    name: "Mnichovo Hradiste",
    city: "Mnichovo Hradiste",
    country: "Czech Republic",
    iata: "",
    icao: "LKMH",
    latitude: "50.540211",
    longitude: "15.006592",
    altitude: "800",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1582",
    name: "Mosnov",
    city: "Ostrava",
    country: "Czech Republic",
    iata: "OSR",
    icao: "LKMT",
    latitude: "49.696292",
    longitude: "18.111053",
    altitude: "844",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1583",
    name: "Namest",
    city: "Namest",
    country: "Czech Republic",
    iata: "",
    icao: "LKNA",
    latitude: "49.165833",
    longitude: "16.124925",
    altitude: "1548",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1584",
    name: "Pardubice",
    city: "Pardubice",
    country: "Czech Republic",
    iata: "PED",
    icao: "LKPD",
    latitude: "50.013419",
    longitude: "15.738647",
    altitude: "741",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1585",
    name: "Pribram",
    city: "Pribram",
    country: "Czech Republic",
    iata: "",
    icao: "LKPM",
    latitude: "49.720078",
    longitude: "14.100567",
    altitude: "1529",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1586",
    name: "Prerov",
    city: "Prerov",
    country: "Czech Republic",
    iata: "PRV",
    icao: "LKPO",
    latitude: "49.425833",
    longitude: "17.404722",
    altitude: "676",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1587",
    name: "Ruzyne",
    city: "Prague",
    country: "Czech Republic",
    iata: "PRG",
    icao: "LKPR",
    latitude: "50.100833",
    longitude: "14.26",
    altitude: "1247",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1588",
    name: "Turany",
    city: "Brno",
    country: "Czech Republic",
    iata: "BRQ",
    icao: "LKTB",
    latitude: "49.151269",
    longitude: "16.694433",
    altitude: "778",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1589",
    name: "Vodochody",
    city: "Vodochody",
    country: "Czech Republic",
    iata: "",
    icao: "LKVO",
    latitude: "50.216581",
    longitude: "14.395806",
    altitude: "919",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "1590",
    name: "Ben Gurion",
    city: "Tel-aviv",
    country: "Israel",
    iata: "TLV",
    icao: "LLBG",
    latitude: "32.011389",
    longitude: "34.886667",
    altitude: "135",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1591",
    name: "Teyman",
    city: "Beer-sheba",
    country: "Israel",
    iata: "BEV",
    icao: "LLBS",
    latitude: "31.287003",
    longitude: "34.722953",
    altitude: "656",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1592",
    name: "Tel Nov",
    city: "Tel-nof",
    country: "Israel",
    iata: "",
    icao: "LLEK",
    latitude: "31.839472",
    longitude: "34.821844",
    altitude: "193",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1593",
    name: "Eyn Shemer",
    city: "Eyn-shemer",
    country: "Israel",
    iata: "",
    icao: "LLES",
    latitude: "32.440814",
    longitude: "35.007661",
    altitude: "95",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1594",
    name: "Eilat",
    city: "Elat",
    country: "Israel",
    iata: "ETH",
    icao: "LLET",
    latitude: "29.561281",
    longitude: "34.960081",
    altitude: "42",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1595",
    name: "En Yahav",
    city: "Eyn-yahav",
    country: "Israel",
    iata: "",
    icao: "LLEY",
    latitude: "30.621656",
    longitude: "35.203325",
    altitude: "-164",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1596",
    name: "Haifa",
    city: "Haifa",
    country: "Israel",
    iata: "HFA",
    icao: "LLHA",
    latitude: "32.809444",
    longitude: "35.043056",
    altitude: "28",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1597",
    name: "Hatzor",
    city: "Haztor",
    country: "Israel",
    iata: "",
    icao: "LLHS",
    latitude: "31.7625",
    longitude: "34.727222",
    altitude: "148",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1598",
    name: "Mahanaim I Ben Yaakov",
    city: "Rosh Pina",
    country: "Israel",
    iata: "RPN",
    icao: "LLIB",
    latitude: "32.981047",
    longitude: "35.571908",
    altitude: "922",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1599",
    name: "Megiddo",
    city: "Megido Airstrip",
    country: "Israel",
    iata: "",
    icao: "LLMG",
    latitude: "32.597139",
    longitude: "35.228803",
    altitude: "200",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1600",
    name: "I Bar Yehuda",
    city: "Metzada",
    country: "Israel",
    iata: "",
    icao: "LLMZ",
    latitude: "31.328169",
    longitude: "35.388608",
    altitude: "-1266",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1601",
    name: "Nevatim Ab",
    city: "Nevatim",
    country: "Israel",
    iata: "",
    icao: "LLNV",
    latitude: "31.208347",
    longitude: "35.0123",
    altitude: "1330",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1602",
    name: "Ovda",
    city: "Ovda",
    country: "Israel",
    iata: "VDA",
    icao: "LLOV",
    latitude: "29.94025",
    longitude: "34.93585",
    altitude: "1492",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1603",
    name: "Ramat David",
    city: "Ramat David",
    country: "Israel",
    iata: "",
    icao: "LLRD",
    latitude: "32.665142",
    longitude: "35.179458",
    altitude: "185",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1604",
    name: "Ramon",
    city: "Ramon",
    country: "Israel",
    iata: "",
    icao: "LLRM",
    latitude: "30.776061",
    longitude: "34.666769",
    altitude: "2126",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1605",
    name: "Sde Dov",
    city: "Tel-aviv",
    country: "Israel",
    iata: "SDV",
    icao: "LLSD",
    latitude: "32.114661",
    longitude: "34.782239",
    altitude: "43",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "1606",
    name: "Luqa",
    city: "Malta",
    country: "Malta",
    iata: "MLA",
    icao: "LMML",
    latitude: "35.857497",
    longitude: "14.4775",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "1607",
    name: "Wiener Neustadt East",
    city: "Wiener Neustadt Ost",
    country: "Austria",
    iata: "",
    icao: "LOAN",
    latitude: "47.843333",
    longitude: "16.260139",
    altitude: "896",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1608",
    name: "Wels",
    city: "Wels",
    country: "Austria",
    iata: "",
    icao: "LOLW",
    latitude: "48.183304",
    longitude: "14.040861",
    altitude: "1043",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1609",
    name: "Graz",
    city: "Graz",
    country: "Austria",
    iata: "GRZ",
    icao: "LOWG",
    latitude: "46.991067",
    longitude: "15.439628",
    altitude: "1115",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1610",
    name: "Innsbruck",
    city: "Innsbruck",
    country: "Austria",
    iata: "INN",
    icao: "LOWI",
    latitude: "47.260219",
    longitude: "11.343964",
    altitude: "1906",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1611",
    name: "Linz",
    city: "Linz",
    country: "Austria",
    iata: "LNZ",
    icao: "LOWL",
    latitude: "48.233219",
    longitude: "14.187511",
    altitude: "978",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1612",
    name: "Salzburg",
    city: "Salzburg",
    country: "Austria",
    iata: "SZG",
    icao: "LOWS",
    latitude: "47.793304",
    longitude: "13.004333",
    altitude: "1411",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1613",
    name: "Schwechat",
    city: "Vienna",
    country: "Austria",
    iata: "VIE",
    icao: "LOWW",
    latitude: "48.110278",
    longitude: "16.569722",
    altitude: "600",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1614",
    name: "Klagenfurt",
    city: "Klagenfurt",
    country: "Austria",
    iata: "",
    icao: "LOXK",
    latitude: "46.642514",
    longitude: "14.337739",
    altitude: "1470",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1615",
    name: "Zeltweg",
    city: "Zeltweg",
    country: "Austria",
    iata: "",
    icao: "LOXZ",
    latitude: "47.202751",
    longitude: "14.744223",
    altitude: "2220",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "1616",
    name: "Alverca",
    city: "Alverca",
    country: "Portugal",
    iata: "",
    icao: "LPAR",
    latitude: "38.883278",
    longitude: "-9.030097",
    altitude: "11",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1617",
    name: "Santa Maria",
    city: "Santa Maria (island)",
    country: "Portugal",
    iata: "SMA",
    icao: "LPAZ",
    latitude: "36.97139",
    longitude: "-25.170639",
    altitude: "308",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1618",
    name: "Braganca",
    city: "Braganca",
    country: "Portugal",
    iata: "BGC",
    icao: "LPBG",
    latitude: "41.8578",
    longitude: "-6.707125",
    altitude: "2241",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1619",
    name: "Beja",
    city: "Beja (madeira)",
    country: "Portugal",
    iata: "",
    icao: "LPBJ",
    latitude: "38.078903",
    longitude: "-7.932397",
    altitude: "636",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1620",
    name: "Braga",
    city: "Braga",
    country: "Portugal",
    iata: "",
    icao: "LPBR",
    latitude: "41.587058",
    longitude: "-8.445139",
    altitude: "247",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1621",
    name: "Coimbra",
    city: "Coimba",
    country: "Portugal",
    iata: "",
    icao: "LPCO",
    latitude: "40.157223",
    longitude: "-8.47",
    altitude: "587",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1622",
    name: "Cascais",
    city: "Cascais",
    country: "Portugal",
    iata: "",
    icao: "LPCS",
    latitude: "38.725025",
    longitude: "-9.355231",
    altitude: "326",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1623",
    name: "Covilha",
    city: "Covilha",
    country: "Portugal",
    iata: "",
    icao: "LPCV",
    latitude: "40.264772",
    longitude: "-7.479958",
    altitude: "1572",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1624",
    name: "Evora",
    city: "Evora",
    country: "Portugal",
    iata: "",
    icao: "LPEV",
    latitude: "38.533472",
    longitude: "-7.889639",
    altitude: "807",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1625",
    name: "Flores",
    city: "Flores",
    country: "Portugal",
    iata: "FLW",
    icao: "LPFL",
    latitude: "39.455272",
    longitude: "-31.131361",
    altitude: "112",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1626",
    name: "Faro",
    city: "Faro",
    country: "Portugal",
    iata: "FAO",
    icao: "LPFR",
    latitude: "37.014425",
    longitude: "-7.965911",
    altitude: "24",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1627",
    name: "Graciosa",
    city: "Graciosa Island",
    country: "Portugal",
    iata: "GRW",
    icao: "LPGR",
    latitude: "39.092169",
    longitude: "-28.029847",
    altitude: "86",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1628",
    name: "Horta",
    city: "Horta",
    country: "Portugal",
    iata: "HOR",
    icao: "LPHR",
    latitude: "38.519894",
    longitude: "-28.715872",
    altitude: "118",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1629",
    name: "Lajes",
    city: "Lajes (terceira Island)",
    country: "Portugal",
    iata: "TER",
    icao: "LPLA",
    latitude: "38.761842",
    longitude: "-27.090797",
    altitude: "180",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1630",
    name: "Monte Real",
    city: "Monte Real",
    country: "Portugal",
    iata: "",
    icao: "LPMR",
    latitude: "39.831244",
    longitude: "-8.887261",
    altitude: "187",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1631",
    name: "Montijo",
    city: "Montijo",
    country: "Portugal",
    iata: "",
    icao: "LPMT",
    latitude: "38.703861",
    longitude: "-9.035916",
    altitude: "46",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1632",
    name: "Ovar",
    city: "Ovar",
    country: "Portugal",
    iata: "",
    icao: "LPOV",
    latitude: "40.915867",
    longitude: "-8.645919",
    altitude: "56",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1633",
    name: "Ponta Delgada",
    city: "Ponta Delgada",
    country: "Portugal",
    iata: "PDL",
    icao: "LPPD",
    latitude: "37.741184",
    longitude: "-25.69787",
    altitude: "259",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1634",
    name: "Pico",
    city: "Pico",
    country: "Portugal",
    iata: "PIX",
    icao: "LPPI",
    latitude: "38.554333",
    longitude: "-28.441333",
    altitude: "109",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1635",
    name: "Portimao",
    city: "Portimao",
    country: "Portugal",
    iata: "",
    icao: "LPPM",
    latitude: "37.149331",
    longitude: "-8.583961",
    altitude: "5",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1636",
    name: "Porto",
    city: "Porto",
    country: "Portugal",
    iata: "OPO",
    icao: "LPPR",
    latitude: "41.248055",
    longitude: "-8.681389",
    altitude: "228",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1637",
    name: "Porto Santo",
    city: "Porto Santo",
    country: "Portugal",
    iata: "PXO",
    icao: "LPPS",
    latitude: "33.073386",
    longitude: "-16.349975",
    altitude: "341",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1638",
    name: "Lisboa",
    city: "Lisbon",
    country: "Portugal",
    iata: "LIS",
    icao: "LPPT",
    latitude: "38.781311",
    longitude: "-9.135919",
    altitude: "374",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1639",
    name: "Sao Jorge",
    city: "Sao Jorge Island",
    country: "Portugal",
    iata: "SJZ",
    icao: "LPSJ",
    latitude: "38.6655",
    longitude: "-28.175817",
    altitude: "311",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "1640",
    name: "Sintra",
    city: "Sintra",
    country: "Portugal",
    iata: "",
    icao: "LPST",
    latitude: "38.831053",
    longitude: "-9.339553",
    altitude: "440",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1641",
    name: "Tancos",
    city: "Tancos",
    country: "Portugal",
    iata: "",
    icao: "LPTN",
    latitude: "39.47514",
    longitude: "-8.364583",
    altitude: "266",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1642",
    name: "Vila Real",
    city: "Vila Real",
    country: "Portugal",
    iata: "VRL",
    icao: "LPVR",
    latitude: "41.274334",
    longitude: "-7.720472",
    altitude: "1805",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "1643",
    name: "Viseu",
    city: "Viseu",
    country: "Portugal",
    iata: "",
    icao: "LPVZ",
    latitude: "40.725539",
    longitude: "-7.888992",
    altitude: "2060",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "6883",
    name: "Eastern Oregon Regional Airport",
    city: "Pendleton",
    country: "United States",
    iata: "PDT",
    icao: "KPDT",
    latitude: "45.695",
    longitude: "-118.841389",
    altitude: "1497",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "1645",
    name: "Mostar",
    city: "Mostar",
    country: "Bosnia and Herzegovina",
    iata: "OMO",
    icao: "LQMO",
    latitude: "43.2829",
    longitude: "17.845878",
    altitude: "156",
    timezone: "1",
    dst: "E",
    tz: "Europe/Sarajevo",
  },
  {
    id: "1646",
    name: "Sarajevo",
    city: "Sarajevo",
    country: "Bosnia and Herzegovina",
    iata: "SJJ",
    icao: "LQSA",
    latitude: "43.824583",
    longitude: "18.331467",
    altitude: "1708",
    timezone: "1",
    dst: "E",
    tz: "Europe/Sarajevo",
  },
  {
    id: "1647",
    name: "Arad",
    city: "Arad",
    country: "Romania",
    iata: "ARW",
    icao: "LRAR",
    latitude: "46.17655",
    longitude: "21.262022",
    altitude: "352",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1648",
    name: "Bacau",
    city: "Bacau",
    country: "Romania",
    iata: "BCM",
    icao: "LRBC",
    latitude: "46.521946",
    longitude: "26.910278",
    altitude: "607",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1649",
    name: "Tautii Magheraus",
    city: "Baia Mare",
    country: "Romania",
    iata: "BAY",
    icao: "LRBM",
    latitude: "47.658389",
    longitude: "23.470022",
    altitude: "605",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1650",
    name: "Aurel Vlaicu",
    city: "Bucharest",
    country: "Romania",
    iata: "BBU",
    icao: "LRBS",
    latitude: "44.503194",
    longitude: "26.102111",
    altitude: "297",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1651",
    name: "Mihail Kogalniceanu",
    city: "Constanta",
    country: "Romania",
    iata: "CND",
    icao: "LRCK",
    latitude: "44.362222",
    longitude: "28.488333",
    altitude: "353",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1652",
    name: "Cluj Napoca",
    city: "Cluj-napoca",
    country: "Romania",
    iata: "CLJ",
    icao: "LRCL",
    latitude: "46.785167",
    longitude: "23.686167",
    altitude: "1036",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1653",
    name: "Caransebes",
    city: "Caransebes",
    country: "Romania",
    iata: "CSB",
    icao: "LRCS",
    latitude: "45.42",
    longitude: "22.253333",
    altitude: "866",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1654",
    name: "Craiova",
    city: "Craiova",
    country: "Romania",
    iata: "CRA",
    icao: "LRCV",
    latitude: "44.318139",
    longitude: "23.888611",
    altitude: "626",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1655",
    name: "Iasi",
    city: "Iasi",
    country: "Romania",
    iata: "IAS",
    icao: "LRIA",
    latitude: "47.178492",
    longitude: "27.620631",
    altitude: "397",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1656",
    name: "Oradea",
    city: "Oradea",
    country: "Romania",
    iata: "OMR",
    icao: "LROD",
    latitude: "47.025278",
    longitude: "21.9025",
    altitude: "465",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1657",
    name: "Henri Coanda",
    city: "Bucharest",
    country: "Romania",
    iata: "OTP",
    icao: "LROP",
    latitude: "44.572161",
    longitude: "26.102178",
    altitude: "314",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1658",
    name: "Sibiu",
    city: "Sibiu",
    country: "Romania",
    iata: "SBZ",
    icao: "LRSB",
    latitude: "45.785597",
    longitude: "24.091342",
    altitude: "1496",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1659",
    name: "Satu Mare",
    city: "Satu Mare",
    country: "Romania",
    iata: "SUJ",
    icao: "LRSM",
    latitude: "47.703275",
    longitude: "22.8857",
    altitude: "405",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1660",
    name: "Stefan Cel Mare",
    city: "Suceava",
    country: "Romania",
    iata: "SCV",
    icao: "LRSV",
    latitude: "47.6875",
    longitude: "26.354056",
    altitude: "1375",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1661",
    name: "Cataloi",
    city: "Tulcea",
    country: "Romania",
    iata: "TCE",
    icao: "LRTC",
    latitude: "45.062486",
    longitude: "28.714311",
    altitude: "200",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1662",
    name: "Transilvania Targu Mures",
    city: "Tirgu Mures",
    country: "Romania",
    iata: "TGM",
    icao: "LRTM",
    latitude: "46.467714",
    longitude: "24.412525",
    altitude: "963",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1663",
    name: "Traian Vuia",
    city: "Timisoara",
    country: "Romania",
    iata: "TSR",
    icao: "LRTR",
    latitude: "45.809861",
    longitude: "21.337861",
    altitude: "348",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "1664",
    name: "Les Eplatures",
    city: "Les Eplatures",
    country: "Switzerland",
    iata: "",
    icao: "LSGC",
    latitude: "47.08385",
    longitude: "6.792836",
    altitude: "3368",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1665",
    name: "Geneve Cointrin",
    city: "Geneva",
    country: "Switzerland",
    iata: "GVA",
    icao: "LSGG",
    latitude: "46.238064",
    longitude: "6.10895",
    altitude: "1411",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "1666",
    name: "Saanen",
    city: "Saanen",
    country: "Switzerland",
    iata: "",
    icao: "LSGK",
    latitude: "46.487499",
    longitude: "7.250834",
    altitude: "3307",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1667",
    name: "Sion",
    city: "Sion",
    country: "Switzerland",
    iata: "SIR",
    icao: "LSGS",
    latitude: "46.219592",
    longitude: "7.326764",
    altitude: "1585",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1668",
    name: "Alpnach",
    city: "Alpnach",
    country: "Switzerland",
    iata: "",
    icao: "LSMA",
    latitude: "46.943889",
    longitude: "8.284167",
    altitude: "1460",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1669",
    name: "Dubendorf",
    city: "Dubendorf",
    country: "Switzerland",
    iata: "",
    icao: "LSMD",
    latitude: "47.398644",
    longitude: "8.648231",
    altitude: "1470",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1670",
    name: "Emmen",
    city: "Emmen",
    country: "Switzerland",
    iata: "",
    icao: "LSME",
    latitude: "47.092369",
    longitude: "8.305117",
    altitude: "1400",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1671",
    name: "Mollis",
    city: "Mollis",
    country: "Switzerland",
    iata: "",
    icao: "LSMF",
    latitude: "47.078872",
    longitude: "9.064831",
    altitude: "1485",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1672",
    name: "Meiringen",
    city: "Meiringen",
    country: "Switzerland",
    iata: "",
    icao: "LSMM",
    latitude: "46.743333",
    longitude: "8.11",
    altitude: "1895",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1673",
    name: "Payerne",
    city: "Payerne",
    country: "Switzerland",
    iata: "",
    icao: "LSMP",
    latitude: "46.843208",
    longitude: "6.915058",
    altitude: "1465",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1674",
    name: "Buochs",
    city: "Buochs",
    country: "Switzerland",
    iata: "",
    icao: "LSMU",
    latitude: "46.974914",
    longitude: "8.39915",
    altitude: "1475",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1675",
    name: "Lugano",
    city: "Lugano",
    country: "Switzerland",
    iata: "LUG",
    icao: "LSZA",
    latitude: "46.004275",
    longitude: "8.910578",
    altitude: "915",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1676",
    name: "Bern Belp",
    city: "Bern",
    country: "Switzerland",
    iata: "BRN",
    icao: "LSZB",
    latitude: "46.9141",
    longitude: "7.497153",
    altitude: "1674",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1677",
    name: "Grenchen",
    city: "Grenchen",
    country: "Switzerland",
    iata: "",
    icao: "LSZG",
    latitude: "47.181628",
    longitude: "7.417189",
    altitude: "1411",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1678",
    name: "Zurich",
    city: "Zurich",
    country: "Switzerland",
    iata: "ZRH",
    icao: "LSZH",
    latitude: "47.464722",
    longitude: "8.549167",
    altitude: "1416",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1679",
    name: "St Gallen Altenrhein",
    city: "Altenrhein",
    country: "Switzerland",
    iata: "ACH",
    icao: "LSZR",
    latitude: "47.485033",
    longitude: "9.560775",
    altitude: "1306",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1680",
    name: "Samedan",
    city: "Samedan",
    country: "Switzerland",
    iata: "SMV",
    icao: "LSZS",
    latitude: "46.534075",
    longitude: "9.884106",
    altitude: "5600",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "1681",
    name: "Guvercinlik",
    city: "Ankara",
    country: "Turkey",
    iata: "",
    icao: "LTAB",
    latitude: "39.93495",
    longitude: "32.740775",
    altitude: "2694",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1682",
    name: "Esenboga",
    city: "Ankara",
    country: "Turkey",
    iata: "ESB",
    icao: "LTAC",
    latitude: "40.128082",
    longitude: "32.995083",
    altitude: "3125",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1683",
    name: "Etimesgut",
    city: "Ankara",
    country: "Turkey",
    iata: "ANK",
    icao: "LTAD",
    latitude: "39.949831",
    longitude: "32.688622",
    altitude: "2653",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1684",
    name: "Akinci",
    city: "Ankara",
    country: "Turkey",
    iata: "",
    icao: "LTAE",
    latitude: "40.078919",
    longitude: "32.565625",
    altitude: "2767",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1685",
    name: "Adana",
    city: "Adana",
    country: "Turkey",
    iata: "ADA",
    icao: "LTAF",
    latitude: "36.982166",
    longitude: "35.280388",
    altitude: "65",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1686",
    name: "Incirlik Ab",
    city: "Adana",
    country: "Turkey",
    iata: "",
    icao: "LTAG",
    latitude: "37.0021",
    longitude: "35.425894",
    altitude: "238",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1687",
    name: "Afyon",
    city: "Afyon",
    country: "Turkey",
    iata: "AFY",
    icao: "LTAH",
    latitude: "38.726425",
    longitude: "30.601114",
    altitude: "3310",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1688",
    name: "Antalya",
    city: "Antalya",
    country: "Turkey",
    iata: "AYT",
    icao: "LTAI",
    latitude: "36.898731",
    longitude: "30.800461",
    altitude: "177",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1689",
    name: "Oguzeli",
    city: "Gaziantep",
    country: "Turkey",
    iata: "GZT",
    icao: "LTAJ",
    latitude: "36.947183",
    longitude: "37.478683",
    altitude: "2315",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1690",
    name: "Iskenderun",
    city: "Iskenderun",
    country: "Turkey",
    iata: "",
    icao: "LTAK",
    latitude: "36.573472",
    longitude: "36.154",
    altitude: "25",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1691",
    name: "Konya",
    city: "Konya",
    country: "Turkey",
    iata: "KYA",
    icao: "LTAN",
    latitude: "37.979",
    longitude: "32.561861",
    altitude: "3381",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1692",
    name: "Tulga",
    city: "Malatya",
    country: "Turkey",
    iata: "",
    icao: "LTAO",
    latitude: "38.35375",
    longitude: "38.253944",
    altitude: "3016",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1693",
    name: "Merzifon",
    city: "Merzifon",
    country: "Turkey",
    iata: "MZH",
    icao: "LTAP",
    latitude: "40.829375",
    longitude: "35.521992",
    altitude: "1758",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1694",
    name: "Sivas",
    city: "Sivas",
    country: "Turkey",
    iata: "VAS",
    icao: "LTAR",
    latitude: "39.813828",
    longitude: "36.903497",
    altitude: "5236",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1695",
    name: "Erhac",
    city: "Malatya",
    country: "Turkey",
    iata: "MLX",
    icao: "LTAT",
    latitude: "38.435347",
    longitude: "38.091006",
    altitude: "2828",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1696",
    name: "Erkilet",
    city: "Kayseri",
    country: "Turkey",
    iata: "ASR",
    icao: "LTAU",
    latitude: "38.770386",
    longitude: "35.495428",
    altitude: "3463",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1697",
    name: "Sivrihisar",
    city: "Sivrihisar",
    country: "Turkey",
    iata: "",
    icao: "LTAV",
    latitude: "39.451469",
    longitude: "31.365308",
    altitude: "3185",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1698",
    name: "Tokat",
    city: "Tokat",
    country: "Turkey",
    iata: "",
    icao: "LTAW",
    latitude: "40.306281",
    longitude: "36.371089",
    altitude: "1831",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1699",
    name: "Cardak",
    city: "Denizli",
    country: "Turkey",
    iata: "DNZ",
    icao: "LTAY",
    latitude: "37.785567",
    longitude: "29.701297",
    altitude: "2795",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1701",
    name: "Ataturk",
    city: "Istanbul",
    country: "Turkey",
    iata: "IST",
    icao: "LTBA",
    latitude: "40.976922",
    longitude: "28.814606",
    altitude: "163",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1702",
    name: "Balikesir",
    city: "Balikesir",
    country: "Turkey",
    iata: "BZI",
    icao: "LTBF",
    latitude: "39.619258",
    longitude: "27.925958",
    altitude: "340",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1703",
    name: "Bandirma",
    city: "Bandirma",
    country: "Turkey",
    iata: "BDM",
    icao: "LTBG",
    latitude: "40.317972",
    longitude: "27.977694",
    altitude: "170",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6882",
    name: "Tyonek Airport",
    city: "Tyonek",
    country: "United States",
    iata: "TYE",
    icao: "\\N",
    latitude: "61.076667",
    longitude: "-151.138056",
    altitude: "110",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "1705",
    name: "Eskisehir",
    city: "Eskisehir",
    country: "Turkey",
    iata: "ESK",
    icao: "LTBI",
    latitude: "39.784138",
    longitude: "30.582111",
    altitude: "2581",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1706",
    name: "Adnan Menderes",
    city: "Izmir",
    country: "Turkey",
    iata: "ADB",
    icao: "LTBJ",
    latitude: "38.292392",
    longitude: "27.156953",
    altitude: "412",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1707",
    name: "Gaziemir",
    city: "Izmir",
    country: "Turkey",
    iata: "",
    icao: "LTBK",
    latitude: "38.319106",
    longitude: "27.159353",
    altitude: "433",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1708",
    name: "Cigli",
    city: "Izmir",
    country: "Turkey",
    iata: "IGL",
    icao: "LTBL",
    latitude: "38.513022",
    longitude: "27.010053",
    altitude: "16",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1709",
    name: "Isparta",
    city: "Isparta",
    country: "Turkey",
    iata: "",
    icao: "LTBM",
    latitude: "37.785369",
    longitude: "30.581817",
    altitude: "3250",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1710",
    name: "Kutahya",
    city: "Kutahya",
    country: "Turkey",
    iata: "",
    icao: "LTBN",
    latitude: "39.426708",
    longitude: "30.016872",
    altitude: "3026",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1712",
    name: "Yalova",
    city: "Yalova",
    country: "Turkey",
    iata: "",
    icao: "LTBP",
    latitude: "40.684353",
    longitude: "29.375728",
    altitude: "6",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1713",
    name: "Topel",
    city: "Topel",
    country: "Turkey",
    iata: "",
    icao: "LTBQ",
    latitude: "40.735028",
    longitude: "30.083336",
    altitude: "182",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1715",
    name: "Dalaman",
    city: "Dalaman",
    country: "Turkey",
    iata: "DLM",
    icao: "LTBS",
    latitude: "36.713056",
    longitude: "28.7925",
    altitude: "20",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1716",
    name: "Akhisar",
    city: "Akhisar",
    country: "Turkey",
    iata: "",
    icao: "LTBT",
    latitude: "38.808887",
    longitude: "27.83386",
    altitude: "263",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6881",
    name: "Riverton Regional",
    city: "Riverton WY",
    country: "United States",
    iata: "RIW",
    icao: "KRIW",
    latitude: "43.064167",
    longitude: "-108.459722",
    altitude: "5525",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "1718",
    name: "Imsik",
    city: "Bodrum",
    country: "Turkey",
    iata: "BXN",
    icao: "LTBV",
    latitude: "37.140144",
    longitude: "27.669717",
    altitude: "202",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1719",
    name: "Samandira",
    city: "Istanbul",
    country: "Turkey",
    iata: "",
    icao: "LTBX",
    latitude: "40.992975",
    longitude: "29.216539",
    altitude: "400",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1721",
    name: "Elazig",
    city: "Elazig",
    country: "Turkey",
    iata: "EZS",
    icao: "LTCA",
    latitude: "38.606925",
    longitude: "39.291417",
    altitude: "2927",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1722",
    name: "Diyarbakir",
    city: "Diyabakir",
    country: "Turkey",
    iata: "DIY",
    icao: "LTCC",
    latitude: "37.893897",
    longitude: "40.201019",
    altitude: "2251",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1723",
    name: "Erzincan",
    city: "Erzincan",
    country: "Turkey",
    iata: "ERC",
    icao: "LTCD",
    latitude: "39.710203",
    longitude: "39.527003",
    altitude: "3783",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1724",
    name: "Erzurum",
    city: "Erzurum",
    country: "Turkey",
    iata: "ERZ",
    icao: "LTCE",
    latitude: "39.956501",
    longitude: "41.170166",
    altitude: "5763",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1726",
    name: "Trabzon",
    city: "Trabzon",
    country: "Turkey",
    iata: "TZX",
    icao: "LTCG",
    latitude: "40.995108",
    longitude: "39.789728",
    altitude: "104",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6880",
    name: "Montrose Regional Airport",
    city: "Montrose CO",
    country: "United States",
    iata: "MTJ",
    icao: "KMTJ",
    latitude: "38.509794",
    longitude: "-107.894242",
    altitude: "5759",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "1728",
    name: "Van",
    city: "Van",
    country: "Turkey",
    iata: "VAN",
    icao: "LTCI",
    latitude: "38.468219",
    longitude: "43.3323",
    altitude: "5480",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1729",
    name: "Batman",
    city: "Batman",
    country: "Turkey",
    iata: "BAL",
    icao: "LTCJ",
    latitude: "37.928969",
    longitude: "41.116583",
    altitude: "1822",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1731",
    name: "Siirt",
    city: "Siirt",
    country: "Turkey",
    iata: "",
    icao: "LTCL",
    latitude: "37.978886",
    longitude: "41.840436",
    altitude: "2001",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1732",
    name: "Kaklic",
    city: "Izmir",
    country: "Turkey",
    iata: "",
    icao: "LTFA",
    latitude: "38.517608",
    longitude: "26.977406",
    altitude: "13",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1733",
    name: "Efes",
    city: "Izmir",
    country: "Turkey",
    iata: "",
    icao: "LTFB",
    latitude: "37.950747",
    longitude: "27.329014",
    altitude: "10",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "1734",
    name: "Balti Intl",
    city: "Saltsy",
    country: "Moldova",
    iata: "",
    icao: "LUBL",
    latitude: "47.838114",
    longitude: "27.781475",
    altitude: "758",
    timezone: "2",
    dst: "E",
    tz: "Europe/Chisinau",
  },
  {
    id: "1735",
    name: "Chisinau Intl",
    city: "Chisinau",
    country: "Moldova",
    iata: "KIV",
    icao: "LUKK",
    latitude: "46.927744",
    longitude: "28.930978",
    altitude: "399",
    timezone: "2",
    dst: "E",
    tz: "Europe/Chisinau",
  },
  {
    id: "1736",
    name: "Ohrid",
    city: "Ohrid",
    country: "Macedonia",
    iata: "OHD",
    icao: "LWOH",
    latitude: "41.179956",
    longitude: "20.742325",
    altitude: "2313",
    timezone: "1",
    dst: "E",
    tz: "Europe/Skopje",
  },
  {
    id: "1737",
    name: "Skopje",
    city: "Skopje",
    country: "Macedonia",
    iata: "SKP",
    icao: "LWSK",
    latitude: "41.961622",
    longitude: "21.621381",
    altitude: "781",
    timezone: "1",
    dst: "E",
    tz: "Europe/Skopje",
  },
  {
    id: "1738",
    name: "Gibraltar",
    city: "Gibraltar",
    country: "Gibraltar",
    iata: "GIB",
    icao: "LXGB",
    latitude: "36.151219",
    longitude: "-5.349664",
    altitude: "15",
    timezone: "1",
    dst: "N",
    tz: "Europe/Gibraltar",
  },
  {
    id: "1739",
    name: "Beograd",
    city: "Belgrade",
    country: "Serbia",
    iata: "BEG",
    icao: "LYBE",
    latitude: "44.818444",
    longitude: "20.309139",
    altitude: "335",
    timezone: "1",
    dst: "E",
    tz: "Europe/Belgrade",
  },
  {
    id: "1740",
    name: "Nis",
    city: "Nis",
    country: "Serbia",
    iata: "INI",
    icao: "LYNI",
    latitude: "43.337289",
    longitude: "21.853722",
    altitude: "648",
    timezone: "1",
    dst: "E",
    tz: "Europe/Belgrade",
  },
  {
    id: "1741",
    name: "Podgorica",
    city: "Podgorica",
    country: "Montenegro",
    iata: "TGD",
    icao: "LYPG",
    latitude: "42.359392",
    longitude: "19.251894",
    altitude: "141",
    timezone: "1",
    dst: "E",
    tz: "Europe/Podgorica",
  },
  {
    id: "1742",
    name: "Pristina",
    city: "Pristina",
    country: "Serbia",
    iata: "PRN",
    icao: "LYPR",
    latitude: "42.572778",
    longitude: "21.035833",
    altitude: "1789",
    timezone: "1",
    dst: "E",
    tz: "Europe/Belgrade",
  },
  {
    id: "1743",
    name: "Tivat",
    city: "Tivat",
    country: "Montenegro",
    iata: "TIV",
    icao: "LYTV",
    latitude: "42.404664",
    longitude: "18.723286",
    altitude: "20",
    timezone: "1",
    dst: "E",
    tz: "Europe/Podgorica",
  },
  {
    id: "1744",
    name: "Vrsac",
    city: "Vrsac",
    country: "Serbia",
    iata: "",
    icao: "LYVR",
    latitude: "45.146889",
    longitude: "21.309889",
    altitude: "276",
    timezone: "1",
    dst: "E",
    tz: "Europe/Belgrade",
  },
  {
    id: "1745",
    name: "M R Stefanik",
    city: "Bratislava",
    country: "Slovakia",
    iata: "BTS",
    icao: "LZIB",
    latitude: "48.170167",
    longitude: "17.212667",
    altitude: "436",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "1746",
    name: "Kosice",
    city: "Kosice",
    country: "Slovakia",
    iata: "KSC",
    icao: "LZKZ",
    latitude: "48.663055",
    longitude: "21.241112",
    altitude: "755",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "1747",
    name: "Malacky",
    city: "Malacky",
    country: "Slovakia",
    iata: "",
    icao: "LZMC",
    latitude: "48.402028",
    longitude: "17.118389",
    altitude: "679",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "1748",
    name: "Piestany",
    city: "Piestany",
    country: "Slovakia",
    iata: "PZY",
    icao: "LZPP",
    latitude: "48.625247",
    longitude: "17.828444",
    altitude: "545",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "1749",
    name: "Sliac",
    city: "Sliac",
    country: "Slovakia",
    iata: "SLD",
    icao: "LZSL",
    latitude: "48.637839",
    longitude: "19.134108",
    altitude: "1043",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "1750",
    name: "Trencin",
    city: "Trencin",
    country: "Slovakia",
    iata: "",
    icao: "LZTN",
    latitude: "48.865003",
    longitude: "17.99225",
    altitude: "676",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "1751",
    name: "Tatry",
    city: "Poprad",
    country: "Slovakia",
    iata: "TAT",
    icao: "LZTT",
    latitude: "49.073594",
    longitude: "20.241142",
    altitude: "2356",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "6879",
    name: "Clow International Airport",
    city: "Bolingbrook",
    country: "United States",
    iata: "1CS",
    icao: "\\N",
    latitude: "41.6959744",
    longitude: "-88.1292306",
    altitude: "670",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "1753",
    name: "North Caicos",
    city: "North Caicos",
    country: "Turks and Caicos Islands",
    iata: "NCA",
    icao: "MBNC",
    latitude: "21.917475",
    longitude: "-71.939561",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Grand_Turk",
  },
  {
    id: "1754",
    name: "Providenciales",
    city: "Providenciales",
    country: "Turks and Caicos Islands",
    iata: "PLS",
    icao: "MBPV",
    latitude: "21.773625",
    longitude: "-72.265886",
    altitude: "15",
    timezone: "-5",
    dst: "U",
    tz: "America/Grand_Turk",
  },
  {
    id: "1755",
    name: "South Caicos",
    city: "South Caicos",
    country: "Turks and Caicos Islands",
    iata: "XSC",
    icao: "MBSC",
    latitude: "21.515739",
    longitude: "-71.528528",
    altitude: "6",
    timezone: "-5",
    dst: "U",
    tz: "America/Grand_Turk",
  },
  {
    id: "1756",
    name: "Arroyo Barril Intl",
    city: "Samana",
    country: "Dominican Republic",
    iata: "EPS",
    icao: "MDAB",
    latitude: "19.198586",
    longitude: "-69.429772",
    altitude: "57",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1757",
    name: "Maria Montez Intl",
    city: "Barahona",
    country: "Dominican Republic",
    iata: "BRX",
    icao: "MDBH",
    latitude: "18.251464",
    longitude: "-71.1204",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1758",
    name: "Cabo Rojo",
    city: "Cabo Rojo",
    country: "Dominican Republic",
    iata: "",
    icao: "MDCR",
    latitude: "17.928981",
    longitude: "-71.644769",
    altitude: "262",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1759",
    name: "Casa De Campo Intl",
    city: "La Romana",
    country: "Dominican Republic",
    iata: "LRM",
    icao: "MDLR",
    latitude: "18.450711",
    longitude: "-68.911833",
    altitude: "240",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1760",
    name: "Punta Cana Intl",
    city: "Punta Cana",
    country: "Dominican Republic",
    iata: "PUJ",
    icao: "MDPC",
    latitude: "18.567367",
    longitude: "-68.363431",
    altitude: "47",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1761",
    name: "Gregorio Luperon Intl",
    city: "Puerto Plata",
    country: "Dominican Republic",
    iata: "POP",
    icao: "MDPP",
    latitude: "19.7579",
    longitude: "-70.570033",
    altitude: "15",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1762",
    name: "Las Americas Intl",
    city: "Santo Domingo",
    country: "Dominican Republic",
    iata: "SDQ",
    icao: "MDSD",
    latitude: "18.429664",
    longitude: "-69.668925",
    altitude: "59",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1763",
    name: "San Isidro Ab",
    city: "San Isidoro",
    country: "Dominican Republic",
    iata: "",
    icao: "MDSI",
    latitude: "18.503706",
    longitude: "-69.761706",
    altitude: "111",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1764",
    name: "Cibao Intl",
    city: "Santiago",
    country: "Dominican Republic",
    iata: "STI",
    icao: "MDST",
    latitude: "19.406092",
    longitude: "-70.604689",
    altitude: "565",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "1765",
    name: "Bananera",
    city: "Bananera",
    country: "Guatemala",
    iata: "",
    icao: "MGBN",
    latitude: "15.473528",
    longitude: "-88.837222",
    altitude: "130",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "1766",
    name: "Coban",
    city: "Coban",
    country: "Guatemala",
    iata: "CBV",
    icao: "MGCB",
    latitude: "15.468958",
    longitude: "-90.406742",
    altitude: "4339",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "1767",
    name: "La Aurora",
    city: "Guatemala City",
    country: "Guatemala",
    iata: "GUA",
    icao: "MGGT",
    latitude: "14.583272",
    longitude: "-90.527475",
    altitude: "4952",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "1769",
    name: "Retalhuleu",
    city: "Retalhuleu",
    country: "Guatemala",
    iata: "",
    icao: "MGRT",
    latitude: "14.521017",
    longitude: "-91.697256",
    altitude: "656",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "1770",
    name: "San Jose",
    city: "San Jose",
    country: "Guatemala",
    iata: "",
    icao: "MGSJ",
    latitude: "13.936192",
    longitude: "-90.835833",
    altitude: "29",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "1771",
    name: "Goloson Intl",
    city: "La Ceiba",
    country: "Honduras",
    iata: "LCE",
    icao: "MHLC",
    latitude: "15.742481",
    longitude: "-86.853036",
    altitude: "49",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1772",
    name: "La Mesa Intl",
    city: "San Pedro Sula",
    country: "Honduras",
    iata: "SAP",
    icao: "MHLM",
    latitude: "15.452639",
    longitude: "-87.923556",
    altitude: "91",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1773",
    name: "Guanaja",
    city: "Guanaja",
    country: "Honduras",
    iata: "GJA",
    icao: "MHNJ",
    latitude: "16.445367",
    longitude: "-85.906611",
    altitude: "49",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1774",
    name: "Juan Manuel Galvez Intl",
    city: "Roatan",
    country: "Honduras",
    iata: "RTB",
    icao: "MHRO",
    latitude: "16.316814",
    longitude: "-86.522961",
    altitude: "18",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1775",
    name: "Tela",
    city: "Tela",
    country: "Honduras",
    iata: "TEA",
    icao: "MHTE",
    latitude: "15.775864",
    longitude: "-87.475847",
    altitude: "7",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1776",
    name: "Toncontin Intl",
    city: "Tegucigalpa",
    country: "Honduras",
    iata: "TGU",
    icao: "MHTG",
    latitude: "14.060883",
    longitude: "-87.217197",
    altitude: "3294",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1777",
    name: "Trujillo",
    city: "Trujillo",
    country: "Honduras",
    iata: "",
    icao: "MHTJ",
    latitude: "15.926847",
    longitude: "-85.93825",
    altitude: "3",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "1778",
    name: "Boscobel",
    city: "Ocho Rios",
    country: "Jamaica",
    iata: "OCJ",
    icao: "MKBS",
    latitude: "18.404247",
    longitude: "-76.969017",
    altitude: "90",
    timezone: "-5",
    dst: "U",
    tz: "America/Jamaica",
  },
  {
    id: "1779",
    name: "Norman Manley Intl",
    city: "Kingston",
    country: "Jamaica",
    iata: "KIN",
    icao: "MKJP",
    latitude: "17.935667",
    longitude: "-76.7875",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Jamaica",
  },
  {
    id: "1780",
    name: "Sangster Intl",
    city: "Montego Bay",
    country: "Jamaica",
    iata: "MBJ",
    icao: "MKJS",
    latitude: "18.503717",
    longitude: "-77.913358",
    altitude: "4",
    timezone: "-5",
    dst: "U",
    tz: "America/Jamaica",
  },
  {
    id: "1781",
    name: "Ken Jones",
    city: "Port Antonio",
    country: "Jamaica",
    iata: "POT",
    icao: "MKKJ",
    latitude: "18.198806",
    longitude: "-76.534528",
    altitude: "20",
    timezone: "-5",
    dst: "U",
    tz: "America/Jamaica",
  },
  {
    id: "1782",
    name: "Tinson Pen",
    city: "Kingston",
    country: "Jamaica",
    iata: "KTP",
    icao: "MKTP",
    latitude: "17.988558",
    longitude: "-76.823761",
    altitude: "16",
    timezone: "-5",
    dst: "U",
    tz: "America/Jamaica",
  },
  {
    id: "1783",
    name: "General Juan N Alvarez Intl",
    city: "Acapulco",
    country: "Mexico",
    iata: "ACA",
    icao: "MMAA",
    latitude: "16.757061",
    longitude: "-99.753953",
    altitude: "16",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1784",
    name: "Del Norte Intl",
    city: "Monterrey",
    country: "Mexico",
    iata: "NTR",
    icao: "MMAN",
    latitude: "25.865572",
    longitude: "-100.237239",
    altitude: "1476",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1785",
    name: "Jesus Teran Intl",
    city: "Aguascalientes",
    country: "Mexico",
    iata: "AGU",
    icao: "MMAS",
    latitude: "21.705558",
    longitude: "-102.317858",
    altitude: "6112",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1786",
    name: "Bahias De Huatulco Intl",
    city: "Huatulco",
    country: "Mexico",
    iata: "HUX",
    icao: "MMBT",
    latitude: "15.775317",
    longitude: "-96.262572",
    altitude: "464",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1787",
    name: "General Mariano Matamoros",
    city: "Cuernavaca",
    country: "Mexico",
    iata: "CVJ",
    icao: "MMCB",
    latitude: "18.834764",
    longitude: "-99.2613",
    altitude: "4277",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1788",
    name: "Ciudad Acuna Intl New",
    city: "Ciudad Acuna",
    country: "Mexico",
    iata: "",
    icao: "MMCC",
    latitude: "29.333917",
    longitude: "-101.100892",
    altitude: "1410",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1789",
    name: "Ciudad Del Carmen Intl",
    city: "Ciudad Del Carmen",
    country: "Mexico",
    iata: "CME",
    icao: "MMCE",
    latitude: "18.653739",
    longitude: "-91.799017",
    altitude: "10",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1790",
    name: "Nuevo Casas Grandes",
    city: "Nuevo Casas Grandes",
    country: "Mexico",
    iata: "",
    icao: "MMCG",
    latitude: "30.397439",
    longitude: "-107.874969",
    altitude: "4850",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1791",
    name: "Chilpancingo",
    city: "Chilpancingo",
    country: "Mexico",
    iata: "",
    icao: "MMCH",
    latitude: "17.573767",
    longitude: "-99.514339",
    altitude: "4199",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1792",
    name: "Culiacan Intl",
    city: "Culiacan",
    country: "Mexico",
    iata: "CUL",
    icao: "MMCL",
    latitude: "24.764547",
    longitude: "-107.474717",
    altitude: "108",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1793",
    name: "Chetumal Intl",
    city: "Chetumal",
    country: "Mexico",
    iata: "CTM",
    icao: "MMCM",
    latitude: "18.504667",
    longitude: "-88.326847",
    altitude: "39",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1794",
    name: "Ciudad Obregon Intl",
    city: "Ciudad Obregon",
    country: "Mexico",
    iata: "CEN",
    icao: "MMCN",
    latitude: "27.392639",
    longitude: "-109.833111",
    altitude: "205",
    timezone: "-7",
    dst: "S",
    tz: "America/Hermosillo",
  },
  {
    id: "1795",
    name: "Ingeniero Alberto Acuna Ongay Intl",
    city: "Campeche",
    country: "Mexico",
    iata: "CPE",
    icao: "MMCP",
    latitude: "19.816794",
    longitude: "-90.500314",
    altitude: "34",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1796",
    name: "Abraham Gonzalez Intl",
    city: "Ciudad Juarez",
    country: "Mexico",
    iata: "CJS",
    icao: "MMCS",
    latitude: "31.636133",
    longitude: "-106.428667",
    altitude: "3904",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1797",
    name: "General R Fierro Villalobos Intl",
    city: "Chihuahua",
    country: "Mexico",
    iata: "CUU",
    icao: "MMCU",
    latitude: "28.702875",
    longitude: "-105.964567",
    altitude: "4462",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1798",
    name: "General Pedro Jose Mendez Intl",
    city: "Ciudad Victoria",
    country: "Mexico",
    iata: "CVM",
    icao: "MMCV",
    latitude: "23.703336",
    longitude: "-98.956486",
    altitude: "761",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "6878",
    name: "Kenosha Regional Airport",
    city: "Kenosha",
    country: "United States",
    iata: "ENW",
    icao: "\\N",
    latitude: "42.5956944",
    longitude: "-87.9278056",
    altitude: "742",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "1800",
    name: "Cozumel Intl",
    city: "Cozumel",
    country: "Mexico",
    iata: "CZM",
    icao: "MMCZ",
    latitude: "20.522403",
    longitude: "-86.925644",
    altitude: "15",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1801",
    name: "Durango Intl",
    city: "Durango",
    country: "Mexico",
    iata: "DGO",
    icao: "MMDO",
    latitude: "24.124194",
    longitude: "-104.528014",
    altitude: "6104",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1802",
    name: "Tepic",
    city: "Tepic",
    country: "Mexico",
    iata: "TPQ",
    icao: "MMEP",
    latitude: "21.419453",
    longitude: "-104.842581",
    altitude: "3020",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1803",
    name: "Ensenada",
    city: "Ensenada",
    country: "Mexico",
    iata: "ESE",
    icao: "MMES",
    latitude: "31.795281",
    longitude: "-116.602772",
    altitude: "66",
    timezone: "-8",
    dst: "S",
    tz: "America/Tijuana",
  },
  {
    id: "1804",
    name: "Don Miguel Hidalgo Y Costilla Intl",
    city: "Guadalajara",
    country: "Mexico",
    iata: "GDL",
    icao: "MMGL",
    latitude: "20.5218",
    longitude: "-103.311167",
    altitude: "5016",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1805",
    name: "General Jose Maria Yanez Intl",
    city: "Guaymas",
    country: "Mexico",
    iata: "GYM",
    icao: "MMGM",
    latitude: "27.968983",
    longitude: "-110.925169",
    altitude: "59",
    timezone: "-7",
    dst: "S",
    tz: "America/Hermosillo",
  },
  {
    id: "1806",
    name: "Tehuacan",
    city: "Tehuacan",
    country: "Mexico",
    iata: "TCN",
    icao: "MMHC",
    latitude: "18.497189",
    longitude: "-97.419942",
    altitude: "5509",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1807",
    name: "General Ignacio P Garcia Intl",
    city: "Hermosillo",
    country: "Mexico",
    iata: "HMO",
    icao: "MMHO",
    latitude: "29.095858",
    longitude: "-111.047858",
    altitude: "627",
    timezone: "-7",
    dst: "S",
    tz: "America/Hermosillo",
  },
  {
    id: "1808",
    name: "Colima",
    city: "Colima",
    country: "Mexico",
    iata: "CLQ",
    icao: "MMIA",
    latitude: "19.277011",
    longitude: "-103.577397",
    altitude: "2467",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1809",
    name: "Isla Mujeres",
    city: "Isla Mujeres",
    country: "Mexico",
    iata: "ISJ",
    icao: "MMIM",
    latitude: "21.245033",
    longitude: "-86.739967",
    altitude: "7",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1810",
    name: "Plan De Guadalupe Intl",
    city: "Saltillo",
    country: "Mexico",
    iata: "SLW",
    icao: "MMIO",
    latitude: "25.549497",
    longitude: "-100.928669",
    altitude: "4778",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1811",
    name: "Ixtepec",
    city: "Iztepec",
    country: "Mexico",
    iata: "",
    icao: "MMIT",
    latitude: "16.449336",
    longitude: "-95.093697",
    altitude: "164",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1813",
    name: "Lazaro Cardenas",
    city: "Lazard Cardenas",
    country: "Mexico",
    iata: "LZC",
    icao: "MMLC",
    latitude: "18.001731",
    longitude: "-102.220525",
    altitude: "39",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1814",
    name: "Valle Del Fuerte Intl",
    city: "Los Mochis",
    country: "Mexico",
    iata: "LMM",
    icao: "MMLM",
    latitude: "25.685194",
    longitude: "-109.080806",
    altitude: "16",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1815",
    name: "Guanajuato Intl",
    city: "Del Bajio",
    country: "Mexico",
    iata: "BJX",
    icao: "MMLO",
    latitude: "20.993464",
    longitude: "-101.480847",
    altitude: "5956",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1816",
    name: "General Manuel Marquez De Leon Intl",
    city: "La Paz",
    country: "Mexico",
    iata: "LAP",
    icao: "MMLP",
    latitude: "24.072694",
    longitude: "-110.362475",
    altitude: "69",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1817",
    name: "Loreto Intl",
    city: "Loreto",
    country: "Mexico",
    iata: "LTO",
    icao: "MMLT",
    latitude: "25.989194",
    longitude: "-111.348361",
    altitude: "34",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1818",
    name: "General Servando Canales Intl",
    city: "Matamoros",
    country: "Mexico",
    iata: "MAM",
    icao: "MMMA",
    latitude: "25.769894",
    longitude: "-97.525311",
    altitude: "25",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1819",
    name: "Licenciado Manuel Crescencio Rejon Int",
    city: "Merida",
    country: "Mexico",
    iata: "MID",
    icao: "MMMD",
    latitude: "20.936981",
    longitude: "-89.657672",
    altitude: "38",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1820",
    name: "General Rodolfo Sanchez Taboada Intl",
    city: "Mexicali",
    country: "Mexico",
    iata: "MXL",
    icao: "MMML",
    latitude: "32.630634",
    longitude: "-115.241637",
    altitude: "74",
    timezone: "-8",
    dst: "S",
    tz: "America/Tijuana",
  },
  {
    id: "1821",
    name: "General Francisco J Mujica Intl",
    city: "Morelia",
    country: "Mexico",
    iata: "MLM",
    icao: "MMMM",
    latitude: "19.849944",
    longitude: "-101.0255",
    altitude: "6033",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1822",
    name: "Minatitlan",
    city: "Minatitlan",
    country: "Mexico",
    iata: "MTT",
    icao: "MMMT",
    latitude: "18.103419",
    longitude: "-94.580681",
    altitude: "36",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1823",
    name: "Monclova Intl",
    city: "Monclova",
    country: "Mexico",
    iata: "LOV",
    icao: "MMMV",
    latitude: "26.955733",
    longitude: "-101.470136",
    altitude: "1864",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1824",
    name: "Licenciado Benito Juarez Intl",
    city: "Mexico City",
    country: "Mexico",
    iata: "MEX",
    icao: "MMMX",
    latitude: "19.436303",
    longitude: "-99.072097",
    altitude: "7316",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1825",
    name: "General Mariano Escobedo Intl",
    city: "Monterrey",
    country: "Mexico",
    iata: "MTY",
    icao: "MMMY",
    latitude: "25.778489",
    longitude: "-100.106878",
    altitude: "1278",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1826",
    name: "General Rafael Buelna Intl",
    city: "Mazatlan",
    country: "Mexico",
    iata: "MZT",
    icao: "MMMZ",
    latitude: "23.161356",
    longitude: "-106.266072",
    altitude: "38",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1827",
    name: "Nogales Intl",
    city: "Nogales",
    country: "Mexico",
    iata: "NOG",
    icao: "MMNG",
    latitude: "31.226083",
    longitude: "-110.975831",
    altitude: "3990",
    timezone: "-7",
    dst: "S",
    tz: "America/Hermosillo",
  },
  {
    id: "1828",
    name: "Quetzalcoatl Intl",
    city: "Nuevo Laredo",
    country: "Mexico",
    iata: "NLD",
    icao: "MMNL",
    latitude: "27.443918",
    longitude: "-99.57046",
    altitude: "484",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1829",
    name: "Xoxocotlan Intl",
    city: "Oaxaca",
    country: "Mexico",
    iata: "OAX",
    icao: "MMOX",
    latitude: "16.999906",
    longitude: "-96.726639",
    altitude: "4989",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1830",
    name: "Tajin",
    city: "Poza Rico",
    country: "Mexico",
    iata: "PAZ",
    icao: "MMPA",
    latitude: "20.602671",
    longitude: "-97.460839",
    altitude: "497",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1831",
    name: "Hermanos Serdan Intl",
    city: "Puebla",
    country: "Mexico",
    iata: "PBC",
    icao: "MMPB",
    latitude: "19.158144",
    longitude: "-98.371447",
    altitude: "7361",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1832",
    name: "Ingeniero Juan Guillermo Villasana",
    city: "Pachuca",
    country: "Mexico",
    iata: "PCA",
    icao: "MMPC",
    latitude: "20.0772",
    longitude: "-98.782814",
    altitude: "7600",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1833",
    name: "Puerto Penasco",
    city: "Punta Penasco",
    country: "Mexico",
    iata: "PPE",
    icao: "MMPE",
    latitude: "31.351878",
    longitude: "-113.525728",
    altitude: "30",
    timezone: "-7",
    dst: "S",
    tz: "America/Hermosillo",
  },
  {
    id: "1834",
    name: "Piedras Negras Intl",
    city: "Piedras Negras",
    country: "Mexico",
    iata: "PDS",
    icao: "MMPG",
    latitude: "28.627394",
    longitude: "-100.535211",
    altitude: "901",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1835",
    name: "Licenciado Y Gen Ignacio Lopez Rayon",
    city: "Uruapan",
    country: "Mexico",
    iata: "UPN",
    icao: "MMPN",
    latitude: "19.396692",
    longitude: "-102.039056",
    altitude: "5258",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1836",
    name: "Licenciado Gustavo Diaz Ordaz Intl",
    city: "Puerto Vallarta",
    country: "Mexico",
    iata: "PVR",
    icao: "MMPR",
    latitude: "20.680083",
    longitude: "-105.254167",
    altitude: "23",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1837",
    name: "Puerto Escondido Intl",
    city: "Puerto Escondido",
    country: "Mexico",
    iata: "PXM",
    icao: "MMPS",
    latitude: "15.876861",
    longitude: "-97.089117",
    altitude: "294",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1838",
    name: "Queretaro Intercontinental",
    city: "Queretaro",
    country: "Mexico",
    iata: "QRO",
    icao: "MMQT",
    latitude: "20.617289",
    longitude: "-100.185658",
    altitude: "6296",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1839",
    name: "General Lucio Blanco Intl",
    city: "Reynosa",
    country: "Mexico",
    iata: "REX",
    icao: "MMRX",
    latitude: "26.008908",
    longitude: "-98.228513",
    altitude: "139",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1840",
    name: "Los Cabos Intl",
    city: "San Jose Del Cabo",
    country: "Mexico",
    iata: "SJD",
    icao: "MMSD",
    latitude: "23.15185",
    longitude: "-109.721044",
    altitude: "374",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "1841",
    name: "San Felipe Intl",
    city: "San Filipe",
    country: "Mexico",
    iata: "",
    icao: "MMSF",
    latitude: "30.930222",
    longitude: "-114.808639",
    altitude: "148",
    timezone: "-8",
    dst: "S",
    tz: "America/Tijuana",
  },
  {
    id: "1842",
    name: "Ponciano Arriaga Intl",
    city: "San Luis Potosi",
    country: "Mexico",
    iata: "SLP",
    icao: "MMSP",
    latitude: "22.254303",
    longitude: "-100.930806",
    altitude: "6035",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1843",
    name: "Tlaxcala",
    city: "Tlaxcala",
    country: "Mexico",
    iata: "TXA",
    icao: "MMTA",
    latitude: "19.537964",
    longitude: "-98.173467",
    altitude: "8229",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1844",
    name: "General Div P A Angel H Corzo Molina",
    city: "Tuxtla Gutierrez",
    country: "Mexico",
    iata: "",
    icao: "MMTB",
    latitude: "16.739919",
    longitude: "-93.173297",
    altitude: "1909",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1845",
    name: "Torreon Intl",
    city: "Torreon",
    country: "Mexico",
    iata: "TRC",
    icao: "MMTC",
    latitude: "25.568278",
    longitude: "-103.410583",
    altitude: "3688",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1846",
    name: "Angel Albino Corzo",
    city: "Tuxtla Gutierrez",
    country: "Mexico",
    iata: "TGZ",
    icao: "MMTG",
    latitude: "16.561822",
    longitude: "-93.026081",
    altitude: "1491",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1847",
    name: "General Abelardo L Rodriguez Intl",
    city: "Tijuana",
    country: "Mexico",
    iata: "TIJ",
    icao: "MMTJ",
    latitude: "32.541064",
    longitude: "-116.970158",
    altitude: "489",
    timezone: "-8",
    dst: "S",
    tz: "America/Tijuana",
  },
  {
    id: "1848",
    name: "General Francisco Javier Mina Intl",
    city: "Tampico",
    country: "Mexico",
    iata: "TAM",
    icao: "MMTM",
    latitude: "22.29645",
    longitude: "-97.865931",
    altitude: "80",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1849",
    name: "Tamuin",
    city: "Tamuin",
    country: "Mexico",
    iata: "TSL",
    icao: "MMTN",
    latitude: "22.038292",
    longitude: "-98.806503",
    altitude: "164",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1850",
    name: "Licenciado Adolfo Lopez Mateos Intl",
    city: "Toluca",
    country: "Mexico",
    iata: "TLC",
    icao: "MMTO",
    latitude: "19.337072",
    longitude: "-99.566008",
    altitude: "8466",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1851",
    name: "Tapachula Intl",
    city: "Tapachula",
    country: "Mexico",
    iata: "TAP",
    icao: "MMTP",
    latitude: "14.794339",
    longitude: "-92.370025",
    altitude: "97",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1852",
    name: "Cancun Intl",
    city: "Cancun",
    country: "Mexico",
    iata: "CUN",
    icao: "MMUN",
    latitude: "21.036528",
    longitude: "-86.877083",
    altitude: "20",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1853",
    name: "C P A Carlos Rovirosa Intl",
    city: "Villahermosa",
    country: "Mexico",
    iata: "VSA",
    icao: "MMVA",
    latitude: "17.997",
    longitude: "-92.817361",
    altitude: "46",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1854",
    name: "General Heriberto Jara Intl",
    city: "Vera Cruz",
    country: "Mexico",
    iata: "VER",
    icao: "MMVR",
    latitude: "19.145931",
    longitude: "-96.187267",
    altitude: "90",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1855",
    name: "General Leobardo C Ruiz Intl",
    city: "Zacatecas",
    country: "Mexico",
    iata: "ZCL",
    icao: "MMZC",
    latitude: "22.897112",
    longitude: "-102.68689",
    altitude: "7141",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1856",
    name: "Ixtapa Zihuatanejo Intl",
    city: "Zihuatanejo",
    country: "Mexico",
    iata: "ZIH",
    icao: "MMZH",
    latitude: "17.601569",
    longitude: "-101.460536",
    altitude: "26",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1857",
    name: "Zamora",
    city: "Zamora",
    country: "Mexico",
    iata: "ZMM",
    icao: "MMZM",
    latitude: "20.045036",
    longitude: "-102.275955",
    altitude: "5141",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1858",
    name: "Playa De Oro Intl",
    city: "Manzanillo",
    country: "Mexico",
    iata: "ZLO",
    icao: "MMZO",
    latitude: "19.144778",
    longitude: "-104.558631",
    altitude: "30",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1859",
    name: "Zapopan",
    city: "Zapopan",
    country: "Mexico",
    iata: "",
    icao: "MMZP",
    latitude: "20.755833",
    longitude: "-103.465278",
    altitude: "5333",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "1860",
    name: "Bluefields",
    city: "Bluefields",
    country: "Nicaragua",
    iata: "BEF",
    icao: "MNBL",
    latitude: "11.990961",
    longitude: "-83.774086",
    altitude: "41",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "1861",
    name: "Los Brasiles",
    city: "Los Brasiles",
    country: "Nicaragua",
    iata: "",
    icao: "MNBR",
    latitude: "12.190044",
    longitude: "-86.353872",
    altitude: "262",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "1862",
    name: "Leon",
    city: "Leon",
    country: "Nicaragua",
    iata: "",
    icao: "MNLN",
    latitude: "12.428028",
    longitude: "-86.902361",
    altitude: "328",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "1863",
    name: "Managua Intl",
    city: "Managua",
    country: "Nicaragua",
    iata: "MGA",
    icao: "MNMG",
    latitude: "12.141494",
    longitude: "-86.168178",
    altitude: "194",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "1864",
    name: "Puerto Cabezas",
    city: "Puerto Cabezas",
    country: "Nicaragua",
    iata: "PUZ",
    icao: "MNPC",
    latitude: "14.047194",
    longitude: "-83.386722",
    altitude: "69",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "1865",
    name: "Bocas Del Toro Intl",
    city: "Bocas Del Toro",
    country: "Panama",
    iata: "BOC",
    icao: "MPBO",
    latitude: "9.340853",
    longitude: "-82.250842",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1866",
    name: "Cap Manuel Nino Intl",
    city: "Changuinola",
    country: "Panama",
    iata: "CHX",
    icao: "MPCH",
    latitude: "9.458636",
    longitude: "-82.516806",
    altitude: "19",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1867",
    name: "Enrique Malek Intl",
    city: "David",
    country: "Panama",
    iata: "DAV",
    icao: "MPDA",
    latitude: "8.391003",
    longitude: "-82.434992",
    altitude: "89",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1868",
    name: "Howard",
    city: "Howard",
    country: "Panama",
    iata: "HOW",
    icao: "MPHO",
    latitude: "8.914794",
    longitude: "-79.599633",
    altitude: "52",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1869",
    name: "Marcos A Gelabert Intl",
    city: "Panama",
    country: "Panama",
    iata: "PAC",
    icao: "MPMG",
    latitude: "8.973339",
    longitude: "-79.555583",
    altitude: "31",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1870",
    name: "Ruben Cantu",
    city: "Santiago",
    country: "Panama",
    iata: "",
    icao: "MPSA",
    latitude: "8.085597",
    longitude: "-80.945253",
    altitude: "272",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1871",
    name: "Tocumen Intl",
    city: "Panama City",
    country: "Panama",
    iata: "PTY",
    icao: "MPTO",
    latitude: "9.071364",
    longitude: "-79.383453",
    altitude: "135",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "1872",
    name: "Buenos Aires",
    city: "Buenos Aires",
    country: "Costa Rica",
    iata: "",
    icao: "MRBA",
    latitude: "9.163606",
    longitude: "-83.329872",
    altitude: "1214",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "6877",
    name: "North Las Vegas Airport",
    city: "Las Vegas",
    country: "United States",
    iata: "VGT",
    icao: "\\N",
    latitude: "36.2106944",
    longitude: "-115.1944444",
    altitude: "2205",
    timezone: "-8",
    dst: "U",
    tz: "America/Los_Angeles",
  },
  {
    id: "1874",
    name: "Coto 47",
    city: "Coto 47",
    country: "Costa Rica",
    iata: "OTR",
    icao: "MRCC",
    latitude: "8.601556",
    longitude: "-82.968614",
    altitude: "26",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1875",
    name: "Chacarita",
    city: "Chacarita",
    country: "Costa Rica",
    iata: "",
    icao: "MRCH",
    latitude: "9.981408",
    longitude: "-84.772736",
    altitude: "7",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "6876",
    name: "Brown County Airport",
    city: "Georgetown",
    country: "United States",
    iata: "",
    icao: "KGEO",
    latitude: "38.8819456",
    longitude: "-83.8827367",
    altitude: "958",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "1877",
    name: "El Carmen De Siquirres",
    city: "El Carmen",
    country: "Costa Rica",
    iata: "",
    icao: "MREC",
    latitude: "10.202033",
    longitude: "-83.472167",
    altitude: "56",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1878",
    name: "Nuevo Palmar Sur",
    city: "Finca 10",
    country: "Costa Rica",
    iata: "",
    icao: "MRFI",
    latitude: "8.916347",
    longitude: "-83.507267",
    altitude: "49",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1879",
    name: "Golfito",
    city: "Golfito",
    country: "Costa Rica",
    iata: "GLF",
    icao: "MRGF",
    latitude: "8.653775",
    longitude: "-83.180544",
    altitude: "49",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1880",
    name: "Guapiles",
    city: "Guapiles",
    country: "Costa Rica",
    iata: "",
    icao: "MRGP",
    latitude: "10.217194",
    longitude: "-83.797003",
    altitude: "883",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1881",
    name: "Daniel Oduber Quiros Intl",
    city: "Liberia",
    country: "Costa Rica",
    iata: "LIR",
    icao: "MRLB",
    latitude: "10.593289",
    longitude: "-85.544408",
    altitude: "270",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1882",
    name: "Los Chiles",
    city: "Los Chiles",
    country: "Costa Rica",
    iata: "",
    icao: "MRLC",
    latitude: "11.035277",
    longitude: "-84.706108",
    altitude: "131",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1883",
    name: "Limon Intl",
    city: "Limon",
    country: "Costa Rica",
    iata: "LIO",
    icao: "MRLM",
    latitude: "9.957961",
    longitude: "-83.022006",
    altitude: "7",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1884",
    name: "Nosara",
    city: "Nosara Beach",
    country: "Costa Rica",
    iata: "NOB",
    icao: "MRNS",
    latitude: "9.97649",
    longitude: "-85.653",
    altitude: "33",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1885",
    name: "Juan Santamaria Intl",
    city: "San Jose",
    country: "Costa Rica",
    iata: "SJO",
    icao: "MROC",
    latitude: "9.993861",
    longitude: "-84.208806",
    altitude: "3021",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1886",
    name: "Pandora",
    city: "Pandora",
    country: "Costa Rica",
    iata: "",
    icao: "MRPD",
    latitude: "9.732169",
    longitude: "-82.983214",
    altitude: "98",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1887",
    name: "Palmar Sur",
    city: "Palmar Sur",
    country: "Costa Rica",
    iata: "PMZ",
    icao: "MRPM",
    latitude: "8.951025",
    longitude: "-83.468583",
    altitude: "49",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1889",
    name: "La Managua",
    city: "Quepos",
    country: "Costa Rica",
    iata: "XQP",
    icao: "MRQP",
    latitude: "9.443164",
    longitude: "-84.129772",
    altitude: "85",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1890",
    name: "Santa Clara De Guapiles",
    city: "Santa Clara",
    country: "Costa Rica",
    iata: "",
    icao: "MRSG",
    latitude: "10.288278",
    longitude: "-83.713519",
    altitude: "262",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1891",
    name: "San Vito De Java",
    city: "San Vito De Jaba",
    country: "Costa Rica",
    iata: "",
    icao: "MRSV",
    latitude: "8.826111",
    longitude: "-82.958885",
    altitude: "3228",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "1892",
    name: "El Salvador Intl",
    city: "San Salvador",
    country: "El Salvador",
    iata: "SAL",
    icao: "MSLP",
    latitude: "13.440947",
    longitude: "-89.055728",
    altitude: "101",
    timezone: "-6",
    dst: "U",
    tz: "America/El_Salvador",
  },
  {
    id: "1893",
    name: "Ilopango Intl",
    city: "San Salvador",
    country: "El Salvador",
    iata: "",
    icao: "MSSS",
    latitude: "13.699492",
    longitude: "-89.119861",
    altitude: "2021",
    timezone: "-6",
    dst: "U",
    tz: "America/El_Salvador",
  },
  {
    id: "1894",
    name: "Cayes",
    city: "Cayes",
    country: "Haiti",
    iata: "",
    icao: "MTCA",
    latitude: "18.271103",
    longitude: "-73.788289",
    altitude: "203",
    timezone: "-5",
    dst: "U",
    tz: "America/Port-au-Prince",
  },
  {
    id: "1895",
    name: "Cap Haitien Intl",
    city: "Cap Haitien",
    country: "Haiti",
    iata: "CAP",
    icao: "MTCH",
    latitude: "19.732989",
    longitude: "-72.194739",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Port-au-Prince",
  },
  {
    id: "1896",
    name: "Jacmel",
    city: "Jacmel",
    country: "Haiti",
    iata: "",
    icao: "MTJA",
    latitude: "18.241083",
    longitude: "-72.5185",
    altitude: "167",
    timezone: "-5",
    dst: "U",
    tz: "America/Port-au-Prince",
  },
  {
    id: "1897",
    name: "Toussaint Louverture Intl",
    city: "Port-au-prince",
    country: "Haiti",
    iata: "PAP",
    icao: "MTPP",
    latitude: "18.58005",
    longitude: "-72.292542",
    altitude: "122",
    timezone: "-5",
    dst: "U",
    tz: "America/Port-au-Prince",
  },
  {
    id: "1898",
    name: "Gustavo Rizo",
    city: "Baracoa Playa",
    country: "Cuba",
    iata: "BCA",
    icao: "MUBA",
    latitude: "20.365317",
    longitude: "-74.506206",
    altitude: "26",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1899",
    name: "Carlos Manuel De Cespedes",
    city: "Bayamo",
    country: "Cuba",
    iata: "BYM",
    icao: "MUBY",
    latitude: "20.396331",
    longitude: "-76.621494",
    altitude: "203",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1900",
    name: "Maximo Gomez",
    city: "Ciego De Avila",
    country: "Cuba",
    iata: "AVI",
    icao: "MUCA",
    latitude: "22.027053",
    longitude: "-78.789617",
    altitude: "335",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1901",
    name: "Jardines Del Rey",
    city: "Cunagua",
    country: "Cuba",
    iata: "",
    icao: "MUCC",
    latitude: "22.460986",
    longitude: "-78.328422",
    altitude: "13",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1902",
    name: "Jaime Gonzalez",
    city: "Cienfuegos",
    country: "Cuba",
    iata: "CFG",
    icao: "MUCF",
    latitude: "22.15",
    longitude: "-80.414167",
    altitude: "102",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1903",
    name: "Vilo Acuna Intl",
    city: "Cayo Largo del Sur",
    country: "Cuba",
    iata: "CYO",
    icao: "MUCL",
    latitude: "21.616453",
    longitude: "-81.545989",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1904",
    name: "Ignacio Agramonte Intl",
    city: "Camaguey",
    country: "Cuba",
    iata: "CMW",
    icao: "MUCM",
    latitude: "21.420428",
    longitude: "-77.847433",
    altitude: "413",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1905",
    name: "Antonio Maceo Intl",
    city: "Santiago De Cuba",
    country: "Cuba",
    iata: "SCU",
    icao: "MUCU",
    latitude: "19.969769",
    longitude: "-75.835414",
    altitude: "249",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1906",
    name: "Florida",
    city: "Florida",
    country: "Cuba",
    iata: "",
    icao: "MUFL",
    latitude: "21.499722",
    longitude: "-78.202778",
    altitude: "197",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1907",
    name: "Guantanamo Bay Ns",
    city: "Guantanamo",
    country: "Cuba",
    iata: "",
    icao: "MUGM",
    latitude: "19.906458",
    longitude: "-75.207056",
    altitude: "56",
    timezone: "-5",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "1908",
    name: "Mariana Grajales",
    city: "Guantanamo",
    country: "Cuba",
    iata: "GAO",
    icao: "MUGT",
    latitude: "20.085419",
    longitude: "-75.158328",
    altitude: "56",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1909",
    name: "Jose Marti Intl",
    city: "Havana",
    country: "Cuba",
    iata: "HAV",
    icao: "MUHA",
    latitude: "22.989153",
    longitude: "-82.409086",
    altitude: "210",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1910",
    name: "Frank Pais Intl",
    city: "Holguin",
    country: "Cuba",
    iata: "HOG",
    icao: "MUHG",
    latitude: "20.785589",
    longitude: "-76.315108",
    altitude: "361",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1911",
    name: "La Coloma",
    city: "La Coloma",
    country: "Cuba",
    iata: "LCL",
    icao: "MULM",
    latitude: "22.336261",
    longitude: "-83.642111",
    altitude: "131",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1912",
    name: "Orestes Acosta",
    city: "Moa",
    country: "Cuba",
    iata: "MOA",
    icao: "MUMO",
    latitude: "20.654114",
    longitude: "-74.922114",
    altitude: "16",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1913",
    name: "Sierra Maestra",
    city: "Manzanillo",
    country: "Cuba",
    iata: "MZO",
    icao: "MUMZ",
    latitude: "20.288172",
    longitude: "-77.0893",
    altitude: "112",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1914",
    name: "Rafael Cabrera",
    city: "Nueva Gerona",
    country: "Cuba",
    iata: "GER",
    icao: "MUNG",
    latitude: "21.834689",
    longitude: "-82.783819",
    altitude: "79",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1915",
    name: "Playa Baracoa",
    city: "Baracoa Playa",
    country: "Cuba",
    iata: "",
    icao: "MUPB",
    latitude: "23.032778",
    longitude: "-82.579444",
    altitude: "102",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1916",
    name: "Pinar Del Rio",
    city: "Pinar Del Rio Norte",
    country: "Cuba",
    iata: "",
    icao: "MUPR",
    latitude: "22.421356",
    longitude: "-83.678428",
    altitude: "131",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1917",
    name: "San Antonio De Los Banos",
    city: "San Antonio De Banos",
    country: "Cuba",
    iata: "",
    icao: "MUSA",
    latitude: "22.871529",
    longitude: "-82.509308",
    altitude: "164",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1918",
    name: "Abel Santamaria",
    city: "Santa Clara",
    country: "Cuba",
    iata: "SNU",
    icao: "MUSC",
    latitude: "22.492192",
    longitude: "-79.943611",
    altitude: "338",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1919",
    name: "Santa Lucia",
    city: "Santa Lucia",
    country: "Cuba",
    iata: "",
    icao: "MUSL",
    latitude: "21.509453",
    longitude: "-77.020375",
    altitude: "13",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1920",
    name: "Siguanea",
    city: "Siguanea",
    country: "Cuba",
    iata: "",
    icao: "MUSN",
    latitude: "21.642525",
    longitude: "-82.955114",
    altitude: "39",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1921",
    name: "Sancti Spiritus",
    city: "Sancti Spiritus",
    country: "Cuba",
    iata: "",
    icao: "MUSS",
    latitude: "21.969969",
    longitude: "-79.442692",
    altitude: "295",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "6875",
    name: "Grand Geneva Resort Airport",
    city: "Lake Geneva",
    country: "United States",
    iata: "C02",
    icao: "\\N",
    latitude: "42.6149167",
    longitude: "-88.3895833",
    altitude: "835",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "1923",
    name: "Juan Gualberto Gomez Intl",
    city: "Varadero",
    country: "Cuba",
    iata: "VRA",
    icao: "MUVR",
    latitude: "23.034445",
    longitude: "-81.435278",
    altitude: "210",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1924",
    name: "Hermanos Ameijeiras",
    city: "Las Tunas",
    country: "Cuba",
    iata: "VTU",
    icao: "MUVT",
    latitude: "20.987642",
    longitude: "-76.9358",
    altitude: "328",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "1925",
    name: "Gerrard Smith Intl",
    city: "Cayman Barac",
    country: "Cayman Islands",
    iata: "CYB",
    icao: "MWCB",
    latitude: "19.686981",
    longitude: "-79.882789",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Cayman",
  },
  {
    id: "1926",
    name: "Owen Roberts Intl",
    city: "Georgetown",
    country: "Cayman Islands",
    iata: "GCM",
    icao: "MWCR",
    latitude: "19.292778",
    longitude: "-81.35775",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Cayman",
  },
  {
    id: "1927",
    name: "Clarence A Bain",
    city: "Clarence Bain",
    country: "Bahamas",
    iata: "",
    icao: "MYAB",
    latitude: "24.287664",
    longitude: "-77.684614",
    altitude: "19",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1928",
    name: "Fresh Creek",
    city: "Andros Town",
    country: "Bahamas",
    iata: "ASD",
    icao: "MYAF",
    latitude: "24.698283",
    longitude: "-77.795611",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1930",
    name: "Marsh Harbour",
    city: "Marsh Harbor",
    country: "Bahamas",
    iata: "MHH",
    icao: "MYAM",
    latitude: "26.511406",
    longitude: "-77.083472",
    altitude: "6",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1931",
    name: "San Andros",
    city: "San Andros",
    country: "Bahamas",
    iata: "SAQ",
    icao: "MYAN",
    latitude: "25.053814",
    longitude: "-78.048997",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1932",
    name: "Spring Point",
    city: "Spring Point",
    country: "Bahamas",
    iata: "AXP",
    icao: "MYAP",
    latitude: "22.441828",
    longitude: "-73.970858",
    altitude: "11",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1933",
    name: "Sandy Point",
    city: "Sandy Point",
    country: "Bahamas",
    iata: "",
    icao: "MYAS",
    latitude: "26.004639",
    longitude: "-77.395483",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1934",
    name: "Treasure Cay",
    city: "Treasure Cay",
    country: "Bahamas",
    iata: "TCB",
    icao: "MYAT",
    latitude: "26.745336",
    longitude: "-77.391269",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1935",
    name: "Chub Cay",
    city: "Chub Cay",
    country: "Bahamas",
    iata: "CCZ",
    icao: "MYBC",
    latitude: "25.417108",
    longitude: "-77.88085",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1936",
    name: "Great Harbour Cay",
    city: "Bullocks Harbour",
    country: "Bahamas",
    iata: "",
    icao: "MYBG",
    latitude: "25.738331",
    longitude: "-77.840114",
    altitude: "18",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1937",
    name: "South Bimini",
    city: "Alice Town",
    country: "Bahamas",
    iata: "BIM",
    icao: "MYBS",
    latitude: "25.699881",
    longitude: "-79.264656",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "6874",
    name: "De Kalb Taylor Municipal Airport",
    city: "De Kalb",
    country: "United States",
    iata: "DKB",
    icao: "\\N",
    latitude: "41.9338342",
    longitude: "-88.7056864",
    altitude: "914",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "1941",
    name: "Exuma Intl",
    city: "Great Exuma",
    country: "Bahamas",
    iata: "GGT",
    icao: "MYEF",
    latitude: "23.562631",
    longitude: "-75.877958",
    altitude: "9",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1942",
    name: "George Town",
    city: "George Town",
    country: "Bahamas",
    iata: "",
    icao: "MYEG",
    latitude: "23.466667",
    longitude: "-75.78167",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1943",
    name: "North Eleuthera",
    city: "North Eleuthera",
    country: "Bahamas",
    iata: "ELH",
    icao: "MYEH",
    latitude: "25.474861",
    longitude: "-76.683489",
    altitude: "13",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1944",
    name: "Governors Harbour",
    city: "Governor's Harbor",
    country: "Bahamas",
    iata: "GHB",
    icao: "MYEM",
    latitude: "25.284706",
    longitude: "-76.331011",
    altitude: "26",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1945",
    name: "Normans Cay",
    city: "Norman's Cay",
    country: "Bahamas",
    iata: "",
    icao: "MYEN",
    latitude: "24.594258",
    longitude: "-76.820214",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1946",
    name: "Rock Sound",
    city: "Rock Sound",
    country: "Bahamas",
    iata: "RSD",
    icao: "MYER",
    latitude: "24.8917",
    longitude: "-76.177739",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1947",
    name: "Staniel Cay",
    city: "Staniel Cay",
    country: "Bahamas",
    iata: "",
    icao: "MYES",
    latitude: "24.169083",
    longitude: "-76.439056",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1948",
    name: "Grand Bahama Intl",
    city: "Freeport",
    country: "Bahamas",
    iata: "FPO",
    icao: "MYGF",
    latitude: "26.558686",
    longitude: "-78.695553",
    altitude: "7",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1949",
    name: "Matthew Town",
    city: "Matthew Town",
    country: "Bahamas",
    iata: "IGA",
    icao: "MYIG",
    latitude: "20.975",
    longitude: "-73.666862",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1950",
    name: "Deadmans Cay",
    city: "Dead Man's Cay",
    country: "Bahamas",
    iata: "LGI",
    icao: "MYLD",
    latitude: "23.179014",
    longitude: "-75.093597",
    altitude: "9",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1951",
    name: "Stella Maris",
    city: "Stella Maris",
    country: "Bahamas",
    iata: "SML",
    icao: "MYLS",
    latitude: "23.581444",
    longitude: "-75.270475",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1952",
    name: "Mayaguana",
    city: "Mayaguana",
    country: "Bahamas",
    iata: "MYG",
    icao: "MYMM",
    latitude: "22.379528",
    longitude: "-73.0135",
    altitude: "11",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1953",
    name: "Lynden Pindling Intl",
    city: "Nassau",
    country: "Bahamas",
    iata: "NAS",
    icao: "MYNN",
    latitude: "25.038958",
    longitude: "-77.466231",
    altitude: "16",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1954",
    name: "Duncan Town",
    city: "Duncan Town",
    country: "Bahamas",
    iata: "",
    icao: "MYRD",
    latitude: "22.181803",
    longitude: "-75.729456",
    altitude: "6",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1955",
    name: "New Port Nelson",
    city: "Port Nelson",
    country: "Bahamas",
    iata: "",
    icao: "MYRP",
    latitude: "23.684378",
    longitude: "-74.836186",
    altitude: "15",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1956",
    name: "San Salvador",
    city: "Cockburn Town",
    country: "Bahamas",
    iata: "ZSA",
    icao: "MYSM",
    latitude: "24.063275",
    longitude: "-74.523967",
    altitude: "24",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "1957",
    name: "Philip S W Goldson Intl",
    city: "Belize City",
    country: "Belize",
    iata: "BZE",
    icao: "MZBZ",
    latitude: "17.539144",
    longitude: "-88.308203",
    altitude: "15",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "1958",
    name: "Aitutaki",
    city: "Aitutaki",
    country: "Cook Islands",
    iata: "AIT",
    icao: "NCAI",
    latitude: "-18.830922",
    longitude: "-159.764233",
    altitude: "14",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "1959",
    name: "Rarotonga Intl",
    city: "Avarua",
    country: "Cook Islands",
    iata: "RAR",
    icao: "NCRG",
    latitude: "-21.202739",
    longitude: "-159.805556",
    altitude: "19",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "1960",
    name: "Nadi Intl",
    city: "Nandi",
    country: "Fiji",
    iata: "NAN",
    icao: "NFFN",
    latitude: "-17.755392",
    longitude: "177.443378",
    altitude: "59",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "1961",
    name: "Nausori Intl",
    city: "Nausori",
    country: "Fiji",
    iata: "SUV",
    icao: "NFNA",
    latitude: "-18.043267",
    longitude: "178.559228",
    altitude: "17",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "1963",
    name: "Fua Amotu Intl",
    city: "Tongatapu",
    country: "Tonga",
    iata: "TBU",
    icao: "NFTF",
    latitude: "-21.241214",
    longitude: "-175.149644",
    altitude: "126",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Tongatapu",
  },
  {
    id: "1964",
    name: "Vavau Intl",
    city: "Vava'u",
    country: "Tonga",
    iata: "VAV",
    icao: "NFTV",
    latitude: "-18.585336",
    longitude: "-173.961717",
    altitude: "236",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Tongatapu",
  },
  {
    id: "1965",
    name: "Bonriki Intl",
    city: "Tarawa",
    country: "Kiribati",
    iata: "TRW",
    icao: "NGTA",
    latitude: "1.381636",
    longitude: "173.147036",
    altitude: "9",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "1966",
    name: "Tabiteuea North",
    city: "Tabiteuea North",
    country: "Kiribati",
    iata: "TBF",
    icao: "NGTE",
    latitude: "-1.224469",
    longitude: "174.775614",
    altitude: "7",
    timezone: "12",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "6809",
    name: "Maitland Airport",
    city: "Maitland",
    country: "Australia",
    iata: "MTL",
    icao: "YMND",
    latitude: "-32.7033",
    longitude: "151.488",
    altitude: "75",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "1968",
    name: "Wallis",
    city: "Wallis",
    country: "Wallis and Futuna",
    iata: "WLS",
    icao: "NLWW",
    latitude: "-13.238281",
    longitude: "-176.199228",
    altitude: "79",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Wallis",
  },
  {
    id: "1969",
    name: "Faleolo Intl",
    city: "Faleolo",
    country: "Samoa",
    iata: "APW",
    icao: "NSFA",
    latitude: "-13.829969",
    longitude: "-172.008336",
    altitude: "58",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Apia",
  },
  {
    id: "1970",
    name: "Pago Pago Intl",
    city: "Pago Pago",
    country: "American Samoa",
    iata: "PPG",
    icao: "NSTU",
    latitude: "-14.331",
    longitude: "-170.7105",
    altitude: "32",
    timezone: "-11",
    dst: "U",
    tz: "Pacific/Pago_Pago",
  },
  {
    id: "1971",
    name: "Rurutu",
    city: "Rurutu",
    country: "French Polynesia",
    iata: "RUR",
    icao: "NTAR",
    latitude: "-22.434069",
    longitude: "-151.360614",
    altitude: "18",
    timezone: "-10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "1972",
    name: "Tubuai",
    city: "Tubuai",
    country: "French Polynesia",
    iata: "TUB",
    icao: "NTAT",
    latitude: "-23.365353",
    longitude: "-149.524072",
    altitude: "7",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1973",
    name: "Anaa",
    city: "Anaa",
    country: "French Polynesia",
    iata: "AAA",
    icao: "NTGA",
    latitude: "-17.352606",
    longitude: "-145.509956",
    altitude: "10",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1974",
    name: "Fangatau",
    city: "Fangatau",
    country: "French Polynesia",
    iata: "",
    icao: "NTGB",
    latitude: "-15.819928",
    longitude: "-140.88715",
    altitude: "9",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1975",
    name: "Tikehau",
    city: "Tikehau",
    country: "French Polynesia",
    iata: "TIH",
    icao: "NTGC",
    latitude: "-15.119617",
    longitude: "-148.230697",
    altitude: "6",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1976",
    name: "Reao",
    city: "Reao",
    country: "French Polynesia",
    iata: "REA",
    icao: "NTGE",
    latitude: "-18.465861",
    longitude: "-136.439706",
    altitude: "12",
    timezone: "-10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "1977",
    name: "Fakarava",
    city: "Fakarava",
    country: "French Polynesia",
    iata: "FAV",
    icao: "NTGF",
    latitude: "-16.05415",
    longitude: "-145.656994",
    altitude: "13",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1978",
    name: "Manihi",
    city: "Manihi",
    country: "French Polynesia",
    iata: "XMH",
    icao: "NTGI",
    latitude: "-14.436764",
    longitude: "-146.070056",
    altitude: "14",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1979",
    name: "Totegegie",
    city: "Totegegie",
    country: "French Polynesia",
    iata: "GMR",
    icao: "NTGJ",
    latitude: "-23.079861",
    longitude: "-134.890333",
    altitude: "7",
    timezone: "-9",
    dst: "U",
    tz: "Pacific/Gambier",
  },
  {
    id: "1980",
    name: "Kaukura",
    city: "Kaukura Atoll",
    country: "French Polynesia",
    iata: "KKR",
    icao: "NTGK",
    latitude: "-15.663333",
    longitude: "-146.884769",
    altitude: "11",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1981",
    name: "Makemo",
    city: "Makemo",
    country: "French Polynesia",
    iata: "MKP",
    icao: "NTGM",
    latitude: "-16.583919",
    longitude: "-143.658369",
    altitude: "3",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1982",
    name: "Puka Puka",
    city: "Puka Puka",
    country: "French Polynesia",
    iata: "PKP",
    icao: "NTGP",
    latitude: "-14.809458",
    longitude: "-138.812811",
    altitude: "5",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1983",
    name: "Takapoto",
    city: "Takapoto",
    country: "French Polynesia",
    iata: "TKP",
    icao: "NTGT",
    latitude: "-14.709544",
    longitude: "-145.245814",
    altitude: "12",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1984",
    name: "Arutua",
    city: "Arutua",
    country: "French Polynesia",
    iata: "AXR",
    icao: "NTGU",
    latitude: "-15.248289",
    longitude: "-146.616708",
    altitude: "9",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1985",
    name: "Mataiva",
    city: "Mataiva",
    country: "French Polynesia",
    iata: "MVT",
    icao: "NTGV",
    latitude: "-14.868055",
    longitude: "-148.717225",
    altitude: "11",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1986",
    name: "Takaroa",
    city: "Takaroa",
    country: "French Polynesia",
    iata: "TKX",
    icao: "NTKR",
    latitude: "-14.455781",
    longitude: "-145.024542",
    altitude: "13",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1987",
    name: "Nuku Hiva",
    city: "Nuku Hiva",
    country: "French Polynesia",
    iata: "NHV",
    icao: "NTMD",
    latitude: "-8.795603",
    longitude: "-140.228789",
    altitude: "220",
    timezone: "-9.5",
    dst: "U",
    tz: "Pacific/Marquesas",
  },
  {
    id: "6873",
    name: "Purude University Airport",
    city: "Lafayette",
    country: "United States",
    iata: "LAF",
    icao: "\\N",
    latitude: "40.4123056",
    longitude: "-86.9368889",
    altitude: "606",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "1989",
    name: "Bora Bora",
    city: "Bora Bora",
    country: "French Polynesia",
    iata: "BOB",
    icao: "NTTB",
    latitude: "-16.444378",
    longitude: "-151.751286",
    altitude: "10",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1990",
    name: "Rangiroa",
    city: "Rangiroa",
    country: "French Polynesia",
    iata: "RGI",
    icao: "NTTG",
    latitude: "-14.954283",
    longitude: "-147.6608",
    altitude: "10",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1991",
    name: "Huahine",
    city: "Huahine Island",
    country: "French Polynesia",
    iata: "HUH",
    icao: "NTTH",
    latitude: "-16.687242",
    longitude: "-151.021667",
    altitude: "7",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1992",
    name: "Moorea",
    city: "Moorea",
    country: "French Polynesia",
    iata: "MOZ",
    icao: "NTTM",
    latitude: "-17.489972",
    longitude: "-149.761869",
    altitude: "9",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1993",
    name: "Hao",
    city: "Hao Island",
    country: "French Polynesia",
    iata: "HOI",
    icao: "NTTO",
    latitude: "-18.074814",
    longitude: "-140.945886",
    altitude: "10",
    timezone: "-10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "1994",
    name: "Maupiti",
    city: "Maupiti",
    country: "French Polynesia",
    iata: "MAU",
    icao: "NTTP",
    latitude: "-16.426486",
    longitude: "-152.243669",
    altitude: "15",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1995",
    name: "Raiatea",
    city: "Raiatea Island",
    country: "French Polynesia",
    iata: "RFP",
    icao: "NTTR",
    latitude: "-16.722861",
    longitude: "-151.465856",
    altitude: "3",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "1997",
    name: "Port Vila Bauerfield",
    city: "Port-vila",
    country: "Vanuatu",
    iata: "VLI",
    icao: "NVVV",
    latitude: "-17.699325",
    longitude: "168.319794",
    altitude: "70",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "1998",
    name: "Kone",
    city: "Kone",
    country: "New Caledonia",
    iata: "KNQ",
    icao: "NWWD",
    latitude: "-21.053428",
    longitude: "164.837806",
    altitude: "23",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "1999",
    name: "Koumac",
    city: "Koumac",
    country: "New Caledonia",
    iata: "KOC",
    icao: "NWWK",
    latitude: "-20.546314",
    longitude: "164.255625",
    altitude: "42",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2000",
    name: "Lifou",
    city: "Lifou",
    country: "New Caledonia",
    iata: "LIF",
    icao: "NWWL",
    latitude: "-20.7748",
    longitude: "167.239864",
    altitude: "92",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2001",
    name: "Magenta",
    city: "Noumea",
    country: "New Caledonia",
    iata: "GEA",
    icao: "NWWM",
    latitude: "-22.258278",
    longitude: "166.472806",
    altitude: "10",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2002",
    name: "Mare",
    city: "Mare",
    country: "New Caledonia",
    iata: "MEE",
    icao: "NWWR",
    latitude: "-21.481678",
    longitude: "168.037508",
    altitude: "141",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2003",
    name: "Touho",
    city: "Touho",
    country: "New Caledonia",
    iata: "TOU",
    icao: "NWWU",
    latitude: "-20.790028",
    longitude: "165.259486",
    altitude: "10",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2004",
    name: "Ouvea",
    city: "Ouvea",
    country: "New Caledonia",
    iata: "UVE",
    icao: "NWWV",
    latitude: "-20.640556",
    longitude: "166.572778",
    altitude: "23",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2005",
    name: "La Tontouta",
    city: "Noumea",
    country: "New Caledonia",
    iata: "NOU",
    icao: "NWWW",
    latitude: "-22.014553",
    longitude: "166.212972",
    altitude: "52",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "2006",
    name: "Auckland Intl",
    city: "Auckland",
    country: "New Zealand",
    iata: "AKL",
    icao: "NZAA",
    latitude: "-37.008056",
    longitude: "174.791667",
    altitude: "23",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2007",
    name: "Taupo",
    city: "Taupo",
    country: "New Zealand",
    iata: "TUO",
    icao: "NZAP",
    latitude: "-38.739723",
    longitude: "176.084444",
    altitude: "1335",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2008",
    name: "Ardmore",
    city: "Ardmore",
    country: "New Zealand",
    iata: "AMZ",
    icao: "NZAR",
    latitude: "-37.029722",
    longitude: "174.973333",
    altitude: "111",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2009",
    name: "Christchurch Intl",
    city: "Christchurch",
    country: "New Zealand",
    iata: "CHC",
    icao: "NZCH",
    latitude: "-43.489358",
    longitude: "172.532225",
    altitude: "123",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2010",
    name: "Chatham Islands",
    city: "Chatham Island",
    country: "New Zealand",
    iata: "CHT",
    icao: "NZCI",
    latitude: "-43.81",
    longitude: "-176.457222",
    altitude: "43",
    timezone: "12.75",
    dst: "Z",
    tz: "Pacific/Chatham",
  },
  {
    id: "2011",
    name: "Dunedin",
    city: "Dunedin",
    country: "New Zealand",
    iata: "DUD",
    icao: "NZDN",
    latitude: "-45.928055",
    longitude: "170.198333",
    altitude: "4",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2012",
    name: "Gisborne",
    city: "Gisborne",
    country: "New Zealand",
    iata: "GIS",
    icao: "NZGS",
    latitude: "-38.663333",
    longitude: "177.978333",
    altitude: "15",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2013",
    name: "Glentanner",
    city: "Glentanner",
    country: "New Zealand",
    iata: "MON",
    icao: "NZGT",
    latitude: "-43.906666",
    longitude: "170.128333",
    altitude: "1824",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2014",
    name: "Hokitika",
    city: "Hokitika",
    country: "New Zealand",
    iata: "HKK",
    icao: "NZHK",
    latitude: "-42.713611",
    longitude: "170.985278",
    altitude: "146",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2015",
    name: "Hamilton",
    city: "Hamilton",
    country: "New Zealand",
    iata: "HLZ",
    icao: "NZHN",
    latitude: "-37.866661",
    longitude: "175.332056",
    altitude: "172",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2016",
    name: "Hastings",
    city: "Hastings",
    country: "New Zealand",
    iata: "",
    icao: "NZHS",
    latitude: "-39.646667",
    longitude: "176.766944",
    altitude: "72",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2017",
    name: "Kerikeri",
    city: "Kerikeri",
    country: "New Zealand",
    iata: "KKE",
    icao: "NZKK",
    latitude: "-35.262779",
    longitude: "173.911944",
    altitude: "492",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2018",
    name: "Kaitaia",
    city: "Kaitaia",
    country: "New Zealand",
    iata: "KAT",
    icao: "NZKT",
    latitude: "-35.07",
    longitude: "173.285278",
    altitude: "270",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2019",
    name: "Alexandra",
    city: "Alexandra",
    country: "New Zealand",
    iata: "ALR",
    icao: "NZLX",
    latitude: "-45.211666",
    longitude: "169.373333",
    altitude: "752",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2020",
    name: "Mount Cook",
    city: "Mount Cook",
    country: "New Zealand",
    iata: "GTN",
    icao: "NZMC",
    latitude: "-43.764999",
    longitude: "170.133333",
    altitude: "2153",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2021",
    name: "Manapouri",
    city: "Manapouri",
    country: "New Zealand",
    iata: "TEU",
    icao: "NZMO",
    latitude: "-45.533056",
    longitude: "167.65",
    altitude: "687",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2022",
    name: "Masterton",
    city: "Masterton",
    country: "New Zealand",
    iata: "MRO",
    icao: "NZMS",
    latitude: "-40.973333",
    longitude: "175.633611",
    altitude: "364",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2023",
    name: "New Plymouth",
    city: "New Plymouth",
    country: "New Zealand",
    iata: "NPL",
    icao: "NZNP",
    latitude: "-39.008611",
    longitude: "174.179167",
    altitude: "97",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2024",
    name: "Nelson",
    city: "Nelson",
    country: "New Zealand",
    iata: "NSN",
    icao: "NZNS",
    latitude: "-41.298333",
    longitude: "173.221111",
    altitude: "17",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2025",
    name: "Invercargill",
    city: "Invercargill",
    country: "New Zealand",
    iata: "IVC",
    icao: "NZNV",
    latitude: "-46.412408",
    longitude: "168.312992",
    altitude: "5",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2026",
    name: "Ohakea",
    city: "Ohakea",
    country: "New Zealand",
    iata: "",
    icao: "NZOH",
    latitude: "-40.206039",
    longitude: "175.387808",
    altitude: "164",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2027",
    name: "Oamaru",
    city: "Oamaru",
    country: "New Zealand",
    iata: "OAM",
    icao: "NZOU",
    latitude: "-44.97",
    longitude: "171.081667",
    altitude: "99",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2028",
    name: "Palmerston North",
    city: "Palmerston North",
    country: "New Zealand",
    iata: "PMR",
    icao: "NZPM",
    latitude: "-40.320556",
    longitude: "175.616944",
    altitude: "151",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2029",
    name: "Paraparaumu",
    city: "Paraparaumu",
    country: "New Zealand",
    iata: "PPQ",
    icao: "NZPP",
    latitude: "-40.904722",
    longitude: "174.989167",
    altitude: "22",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2030",
    name: "Queenstown",
    city: "Queenstown International",
    country: "New Zealand",
    iata: "ZQN",
    icao: "NZQN",
    latitude: "-45.021111",
    longitude: "168.739167",
    altitude: "1171",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2031",
    name: "Rotorua",
    city: "Rotorua",
    country: "New Zealand",
    iata: "ROT",
    icao: "NZRO",
    latitude: "-38.109167",
    longitude: "176.317222",
    altitude: "935",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2032",
    name: "Waiouru",
    city: "Waiouru",
    country: "New Zealand",
    iata: "",
    icao: "NZRU",
    latitude: "-39.446389",
    longitude: "175.658333",
    altitude: "2686",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2033",
    name: "South Pole Station",
    city: "Stephen's Island",
    country: "Antarctica",
    iata: "",
    icao: "NZSP",
    latitude: "-89.999997",
    longitude: "0",
    altitude: "9300",
    timezone: "12",
    dst: "U",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "2034",
    name: "Tauranga",
    city: "Tauranga",
    country: "New Zealand",
    iata: "TRG",
    icao: "NZTG",
    latitude: "-37.671944",
    longitude: "176.19611",
    altitude: "13",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2035",
    name: "Timaru",
    city: "Timaru",
    country: "New Zealand",
    iata: "TIU",
    icao: "NZTU",
    latitude: "-44.302778",
    longitude: "171.225278",
    altitude: "89",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2036",
    name: "Pukaki",
    city: "Pukaki",
    country: "New Zealand",
    iata: "",
    icao: "NZUK",
    latitude: "-44.235",
    longitude: "170.118333",
    altitude: "1575",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2037",
    name: "Woodbourne",
    city: "Woodbourne",
    country: "New Zealand",
    iata: "BHE",
    icao: "NZWB",
    latitude: "-41.518333",
    longitude: "173.870278",
    altitude: "109",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2038",
    name: "Mcmurdo Station",
    city: "Weydon",
    country: "Antarctica",
    iata: "",
    icao: "NZWD",
    latitude: "-77.867358",
    longitude: "167.056572",
    altitude: "68",
    timezone: "12",
    dst: "N",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "2039",
    name: "Wanaka",
    city: "Wanaka",
    country: "New Zealand",
    iata: "WKA",
    icao: "NZWF",
    latitude: "-44.722222",
    longitude: "169.245556",
    altitude: "1142",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2040",
    name: "Wigram",
    city: "Wigram",
    country: "New Zealand",
    iata: "",
    icao: "NZWG",
    latitude: "-43.551111",
    longitude: "172.552778",
    altitude: "74",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2041",
    name: "Whakatane",
    city: "Whakatane",
    country: "New Zealand",
    iata: "WHK",
    icao: "NZWK",
    latitude: "-37.920556",
    longitude: "176.914167",
    altitude: "20",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2042",
    name: "Wellington Intl",
    city: "Wellington",
    country: "New Zealand",
    iata: "WLG",
    icao: "NZWN",
    latitude: "-41.327221",
    longitude: "174.805278",
    altitude: "41",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2043",
    name: "Wairoa",
    city: "Wairoa",
    country: "New Zealand",
    iata: "",
    icao: "NZWO",
    latitude: "-39.006944",
    longitude: "177.406667",
    altitude: "42",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2044",
    name: "Whenuapai",
    city: "Whenuapai",
    country: "New Zealand",
    iata: "",
    icao: "NZWP",
    latitude: "-36.787777",
    longitude: "174.630278",
    altitude: "100",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2045",
    name: "Whangarei",
    city: "Whangarei",
    country: "New Zealand",
    iata: "WRE",
    icao: "NZWR",
    latitude: "-35.768333",
    longitude: "174.365",
    altitude: "133",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2046",
    name: "Westport",
    city: "Westport",
    country: "New Zealand",
    iata: "WSZ",
    icao: "NZWS",
    latitude: "-41.738056",
    longitude: "171.580833",
    altitude: "13",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2047",
    name: "Wanganui",
    city: "Wanganui",
    country: "New Zealand",
    iata: "WAG",
    icao: "NZWU",
    latitude: "-39.962222",
    longitude: "175.025278",
    altitude: "27",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2048",
    name: "Herat",
    city: "Herat",
    country: "Afghanistan",
    iata: "HEA",
    icao: "OAHR",
    latitude: "34.210017",
    longitude: "62.2283",
    altitude: "3206",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2049",
    name: "Jalalabad",
    city: "Jalalabad",
    country: "Afghanistan",
    iata: "JAA",
    icao: "OAJL",
    latitude: "34.399842",
    longitude: "70.498625",
    altitude: "1814",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2050",
    name: "Kabul Intl",
    city: "Kabul",
    country: "Afghanistan",
    iata: "KBL",
    icao: "OAKB",
    latitude: "34.565853",
    longitude: "69.212328",
    altitude: "5877",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2051",
    name: "Kandahar",
    city: "Kandahar",
    country: "Afghanistan",
    iata: "KDH",
    icao: "OAKN",
    latitude: "31.505756",
    longitude: "65.847822",
    altitude: "3337",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2052",
    name: "Maimana",
    city: "Maimama",
    country: "Afghanistan",
    iata: "MMZ",
    icao: "OAMN",
    latitude: "35.930789",
    longitude: "64.760917",
    altitude: "2743",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2053",
    name: "Mazar I Sharif",
    city: "Mazar-i-sharif",
    country: "Afghanistan",
    iata: "MZR",
    icao: "OAMS",
    latitude: "36.706914",
    longitude: "67.209678",
    altitude: "1284",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2054",
    name: "Shindand",
    city: "Shindand",
    country: "Afghanistan",
    iata: "",
    icao: "OASD",
    latitude: "33.391331",
    longitude: "62.260975",
    altitude: "3773",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2055",
    name: "Sheberghan",
    city: "Sheberghan",
    country: "Afghanistan",
    iata: "",
    icao: "OASG",
    latitude: "36.750783",
    longitude: "65.913164",
    altitude: "1053",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2056",
    name: "Konduz",
    city: "Kunduz",
    country: "Afghanistan",
    iata: "UND",
    icao: "OAUZ",
    latitude: "36.665111",
    longitude: "68.910833",
    altitude: "1457",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "2057",
    name: "Bahrain Intl",
    city: "Bahrain",
    country: "Bahrain",
    iata: "BAH",
    icao: "OBBI",
    latitude: "26.270834",
    longitude: "50.63361",
    altitude: "6",
    timezone: "3",
    dst: "U",
    tz: "Asia/Bahrain",
  },
  {
    id: "2058",
    name: "Shaikh Isa",
    city: "Bahrain",
    country: "Bahrain",
    iata: "",
    icao: "OBBS",
    latitude: "25.918362",
    longitude: "50.590557",
    altitude: "136",
    timezone: "3",
    dst: "U",
    tz: "Asia/Bahrain",
  },
  {
    id: "2059",
    name: "Abha",
    city: "Abha",
    country: "Saudi Arabia",
    iata: "AHB",
    icao: "OEAB",
    latitude: "18.240367",
    longitude: "42.656625",
    altitude: "6858",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2060",
    name: "Al Ahsa",
    city: "Al-ahsa",
    country: "Saudi Arabia",
    iata: "HOF",
    icao: "OEAH",
    latitude: "25.285306",
    longitude: "49.485189",
    altitude: "588",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2061",
    name: "Al Baha",
    city: "El-baha",
    country: "Saudi Arabia",
    iata: "ABT",
    icao: "OEBA",
    latitude: "20.296139",
    longitude: "41.634277",
    altitude: "5486",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2062",
    name: "Bisha",
    city: "Bisha",
    country: "Saudi Arabia",
    iata: "BHH",
    icao: "OEBH",
    latitude: "19.98435",
    longitude: "42.620881",
    altitude: "3887",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2063",
    name: "Abqaiq",
    city: "Abqaiq",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEBQ",
    latitude: "25.911281",
    longitude: "49.591231",
    altitude: "229",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2064",
    name: "King Fahd Intl",
    city: "Dammam",
    country: "Saudi Arabia",
    iata: "DMM",
    icao: "OEDF",
    latitude: "26.471161",
    longitude: "49.79789",
    altitude: "72",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2065",
    name: "King Abdulaziz Ab",
    city: "Dhahran",
    country: "Saudi Arabia",
    iata: "DHA",
    icao: "OEDR",
    latitude: "26.265417",
    longitude: "50.152027",
    altitude: "84",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2066",
    name: "King Abdullah Bin Abdulaziz",
    city: "Gizan",
    country: "Saudi Arabia",
    iata: "GIZ",
    icao: "OEGN",
    latitude: "16.901111",
    longitude: "42.585833",
    altitude: "20",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2067",
    name: "Gassim",
    city: "Gassim",
    country: "Saudi Arabia",
    iata: "ELQ",
    icao: "OEGS",
    latitude: "26.302822",
    longitude: "43.773911",
    altitude: "2126",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2068",
    name: "Guriat",
    city: "Guriat",
    country: "Saudi Arabia",
    iata: "URY",
    icao: "OEGT",
    latitude: "31.411942",
    longitude: "37.279469",
    altitude: "1672",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2069",
    name: "Hail",
    city: "Hail",
    country: "Saudi Arabia",
    iata: "HAS",
    icao: "OEHL",
    latitude: "27.437917",
    longitude: "41.686292",
    altitude: "3331",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2070",
    name: "Jubail",
    city: "Jubail",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEJB",
    latitude: "27.039028",
    longitude: "49.405083",
    altitude: "26",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2071",
    name: "King Faisal Naval Base",
    city: "Jeddah",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEJF",
    latitude: "21.3481",
    longitude: "39.173033",
    altitude: "7",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2072",
    name: "King Abdulaziz Intl",
    city: "Jeddah",
    country: "Saudi Arabia",
    iata: "JED",
    icao: "OEJN",
    latitude: "21.679564",
    longitude: "39.156536",
    altitude: "48",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2073",
    name: "King Khaled Military City",
    city: "King Khalid Mil.city",
    country: "Saudi Arabia",
    iata: "HBT",
    icao: "OEKK",
    latitude: "27.900917",
    longitude: "45.528194",
    altitude: "1352",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2074",
    name: "Prince Mohammad Bin Abdulaziz",
    city: "Madinah",
    country: "Saudi Arabia",
    iata: "MED",
    icao: "OEMA",
    latitude: "24.553422",
    longitude: "39.705061",
    altitude: "2151",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2075",
    name: "Nejran",
    city: "Nejran",
    country: "Saudi Arabia",
    iata: "EAM",
    icao: "OENG",
    latitude: "17.611436",
    longitude: "44.419169",
    altitude: "3982",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2076",
    name: "Qaisumah",
    city: "Hafr Al-batin",
    country: "Saudi Arabia",
    iata: "AQI",
    icao: "OEPA",
    latitude: "28.335192",
    longitude: "46.125069",
    altitude: "1174",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2077",
    name: "Pump Station 3",
    city: "Petroline 3",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEPC",
    latitude: "25.174547",
    longitude: "47.488431",
    altitude: "1740",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2078",
    name: "Pump Station 6",
    city: "Petroline 6",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEPF",
    latitude: "24.710333",
    longitude: "44.964527",
    altitude: "2530",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2079",
    name: "Pump Station 10",
    city: "Petroline 10",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEPJ",
    latitude: "24.107339",
    longitude: "41.036047",
    altitude: "2840",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2080",
    name: "Rabigh",
    city: "Rabigh",
    country: "Saudi Arabia",
    iata: "",
    icao: "OERB",
    latitude: "22.702608",
    longitude: "39.069842",
    altitude: "22",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2081",
    name: "Rafha",
    city: "Rafha",
    country: "Saudi Arabia",
    iata: "RAH",
    icao: "OERF",
    latitude: "29.626419",
    longitude: "43.490614",
    altitude: "1474",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2082",
    name: "King Khaled Intl",
    city: "Riyadh",
    country: "Saudi Arabia",
    iata: "RUH",
    icao: "OERK",
    latitude: "24.95764",
    longitude: "46.698776",
    altitude: "2049",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2083",
    name: "Ras Mishab",
    city: "Rash Mishab",
    country: "Saudi Arabia",
    iata: "",
    icao: "OERM",
    latitude: "28.079584",
    longitude: "48.610973",
    altitude: "13",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2084",
    name: "Arar",
    city: "Arar",
    country: "Saudi Arabia",
    iata: "RAE",
    icao: "OERR",
    latitude: "30.906589",
    longitude: "41.138217",
    altitude: "1813",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2085",
    name: "Ras Tanura",
    city: "Ras Tanura",
    country: "Saudi Arabia",
    iata: "",
    icao: "OERT",
    latitude: "26.723108",
    longitude: "50.030814",
    altitude: "6",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2086",
    name: "Sharurah",
    city: "Sharurah",
    country: "Saudi Arabia",
    iata: "SHW",
    icao: "OESH",
    latitude: "17.466875",
    longitude: "47.121431",
    altitude: "2363",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "6808",
    name: "Mudgee Airport",
    city: "Mudgee",
    country: "Australia",
    iata: "DGE",
    icao: "YMDG",
    latitude: "-32.5625",
    longitude: "149.611",
    altitude: "1545",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "2088",
    name: "Sulayel",
    city: "Sulayel",
    country: "Saudi Arabia",
    iata: "SLF",
    icao: "OESL",
    latitude: "20.464744",
    longitude: "45.619644",
    altitude: "2021",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2089",
    name: "Tabuk",
    city: "Tabuk",
    country: "Saudi Arabia",
    iata: "TUU",
    icao: "OETB",
    latitude: "28.365417",
    longitude: "36.618889",
    altitude: "2551",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2090",
    name: "Taif",
    city: "Taif",
    country: "Saudi Arabia",
    iata: "TIF",
    icao: "OETF",
    latitude: "21.483418",
    longitude: "40.544334",
    altitude: "4848",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2091",
    name: "Thumamah",
    city: "Thumamah",
    country: "Saudi Arabia",
    iata: "",
    icao: "OETH",
    latitude: "25.212986",
    longitude: "46.640978",
    altitude: "1870",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2092",
    name: "Ras Tanajib",
    city: "Ras Tanajib",
    country: "Saudi Arabia",
    iata: "",
    icao: "OETN",
    latitude: "27.867844",
    longitude: "48.76915",
    altitude: "30",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2093",
    name: "Turaif",
    city: "Turaif",
    country: "Saudi Arabia",
    iata: "TUI",
    icao: "OETR",
    latitude: "31.692683",
    longitude: "38.7312",
    altitude: "2803",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "6872",
    name: "Miami University Airport",
    city: "Oxford",
    country: "United States",
    iata: "OXD",
    icao: "\\N",
    latitude: "39.5022607",
    longitude: "-84.7843814",
    altitude: "1040",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "2095",
    name: "Wejh",
    city: "Wejh",
    country: "Saudi Arabia",
    iata: "EJH",
    icao: "OEWJ",
    latitude: "26.198553",
    longitude: "36.476381",
    altitude: "66",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2096",
    name: "Yenbo",
    city: "Yenbo",
    country: "Saudi Arabia",
    iata: "YNB",
    icao: "OEYN",
    latitude: "24.144244",
    longitude: "38.06335",
    altitude: "26",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "2097",
    name: "Abadan",
    city: "Abadan",
    country: "Iran",
    iata: "ABD",
    icao: "OIAA",
    latitude: "30.371111",
    longitude: "48.228333",
    altitude: "19",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2098",
    name: "Dezful",
    city: "Dezful",
    country: "Iran",
    iata: "",
    icao: "OIAD",
    latitude: "32.434444",
    longitude: "48.39764",
    altitude: "474",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2099",
    name: "Aghajari",
    city: "Aghajari",
    country: "Iran",
    iata: "",
    icao: "OIAG",
    latitude: "30.74445",
    longitude: "49.677183",
    altitude: "88",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2100",
    name: "Gachsaran",
    city: "Gachsaran",
    country: "Iran",
    iata: "",
    icao: "OIAH",
    latitude: "30.337567",
    longitude: "50.827964",
    altitude: "2414",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2101",
    name: "Shahid Asyaee",
    city: "Masjed Soleiman",
    country: "Iran",
    iata: "QMJ",
    icao: "OIAI",
    latitude: "32.002372",
    longitude: "49.270364",
    altitude: "1206",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2102",
    name: "Omidiyeh",
    city: "Omidyeh",
    country: "Iran",
    iata: "",
    icao: "OIAJ",
    latitude: "30.835167",
    longitude: "49.534916",
    altitude: "85",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2103",
    name: "Mahshahr",
    city: "Bandar Mahshahr",
    country: "Iran",
    iata: "MRX",
    icao: "OIAM",
    latitude: "30.556192",
    longitude: "49.151879",
    altitude: "8",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2104",
    name: "Ahwaz",
    city: "Ahwaz",
    country: "Iran",
    iata: "AWZ",
    icao: "OIAW",
    latitude: "31.337431",
    longitude: "48.76195",
    altitude: "66",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2105",
    name: "Abumusa Island",
    city: "Abumusa I.",
    country: "Iran",
    iata: "",
    icao: "OIBA",
    latitude: "25.875742",
    longitude: "55.032994",
    altitude: "23",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2106",
    name: "Bushehr",
    city: "Bushehr",
    country: "Iran",
    iata: "BUZ",
    icao: "OIBB",
    latitude: "28.944811",
    longitude: "50.834637",
    altitude: "68",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2107",
    name: "Bastak",
    city: "Bastak",
    country: "Iran",
    iata: "",
    icao: "OIBH",
    latitude: "27.212678",
    longitude: "54.318592",
    altitude: "1350",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2108",
    name: "Asaloyeh",
    city: "Golbandi",
    country: "Iran",
    iata: "",
    icao: "OIBI",
    latitude: "27.481425",
    longitude: "52.615483",
    altitude: "15",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2109",
    name: "Kish Island",
    city: "Kish Island",
    country: "Iran",
    iata: "KIH",
    icao: "OIBK",
    latitude: "26.526156",
    longitude: "53.980211",
    altitude: "101",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2110",
    name: "Bandar Lengeh",
    city: "Bandar Lengeh",
    country: "Iran",
    iata: "BDH",
    icao: "OIBL",
    latitude: "26.532",
    longitude: "54.824847",
    altitude: "67",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2111",
    name: "Khark Island",
    city: "Khark Island",
    country: "Iran",
    iata: "",
    icao: "OIBQ",
    latitude: "29.260278",
    longitude: "50.323889",
    altitude: "17",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2112",
    name: "Sirri Island",
    city: "Siri Island",
    country: "Iran",
    iata: "",
    icao: "OIBS",
    latitude: "25.908869",
    longitude: "54.5394",
    altitude: "43",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2113",
    name: "Lavan Island",
    city: "Lavan Island",
    country: "Iran",
    iata: "",
    icao: "OIBV",
    latitude: "26.8103",
    longitude: "53.356289",
    altitude: "76",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2114",
    name: "Shahid Ashrafi Esfahani",
    city: "Bakhtaran",
    country: "Iran",
    iata: "KSH",
    icao: "OICC",
    latitude: "34.345853",
    longitude: "47.158128",
    altitude: "4301",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2117",
    name: "Sanandaj",
    city: "Sanandaj",
    country: "Iran",
    iata: "SDG",
    icao: "OICS",
    latitude: "35.245856",
    longitude: "47.009247",
    altitude: "4522",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2118",
    name: "Hesa",
    city: "Daran",
    country: "Iran",
    iata: "",
    icao: "OIFE",
    latitude: "32.928889",
    longitude: "51.561111",
    altitude: "5256",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2119",
    name: "Shahid Vatan Pour Air Base",
    city: "Esfahan",
    country: "Iran",
    iata: "",
    icao: "OIFH",
    latitude: "32.567039",
    longitude: "51.691594",
    altitude: "5310",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2120",
    name: "Kashan",
    city: "Kashan",
    country: "Iran",
    iata: "",
    icao: "OIFK",
    latitude: "33.895333",
    longitude: "51.577044",
    altitude: "3465",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2121",
    name: "Esfahan Shahid Beheshti Intl",
    city: "Esfahan",
    country: "Iran",
    iata: "",
    icao: "OIFM",
    latitude: "32.750836",
    longitude: "51.861267",
    altitude: "5059",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2122",
    name: "Badr Air Base",
    city: "Sepah",
    country: "Iran",
    iata: "",
    icao: "OIFP",
    latitude: "32.621108",
    longitude: "51.697017",
    altitude: "5242",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2123",
    name: "Rasht",
    city: "Rasht",
    country: "Iran",
    iata: "RAS",
    icao: "OIGG",
    latitude: "37.325314",
    longitude: "49.605817",
    altitude: "-40",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6871",
    name: "Delaware County Airport",
    city: "Muncie",
    country: "United States",
    iata: "MIE",
    icao: "\\N",
    latitude: "40.2424722",
    longitude: "-85.39575",
    altitude: "937",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "2125",
    name: "Arak",
    city: "Arak",
    country: "Iran",
    iata: "",
    icao: "OIHR",
    latitude: "34.138147",
    longitude: "49.847292",
    altitude: "5440",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2126",
    name: "Ghazvin Azadi",
    city: "Abe-ali",
    country: "Iran",
    iata: "",
    icao: "OIIA",
    latitude: "35.952097",
    longitude: "50.450778",
    altitude: "3769",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2127",
    name: "Kushke Nosrat",
    city: "Kushke Nosrat",
    country: "Iran",
    iata: "",
    icao: "OIIC",
    latitude: "34.98395",
    longitude: "50.806219",
    altitude: "3008",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2128",
    name: "Doshan Tappeh",
    city: "Teheran",
    country: "Iran",
    iata: "",
    icao: "OIID",
    latitude: "35.702983",
    longitude: "51.475131",
    altitude: "4046",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2129",
    name: "Imam Khomeini Intl",
    city: "Abyek",
    country: "Iran",
    iata: "",
    icao: "OIIE",
    latitude: "35.416111",
    longitude: "51.152222",
    altitude: "3305",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2130",
    name: "Ghale Morghi",
    city: "Teheran",
    country: "Iran",
    iata: "",
    icao: "OIIG",
    latitude: "35.644806",
    longitude: "51.380695",
    altitude: "3627",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2131",
    name: "Mehrabad Intl",
    city: "Teheran",
    country: "Iran",
    iata: "THR",
    icao: "OIII",
    latitude: "35.689167",
    longitude: "51.313416",
    altitude: "3962",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2132",
    name: "Ghazvin",
    city: "Ghazvin",
    country: "Iran",
    iata: "",
    icao: "OIIK",
    latitude: "36.240061",
    longitude: "50.047153",
    altitude: "4184",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2133",
    name: "Naja",
    city: "Khoram Dareh",
    country: "Iran",
    iata: "",
    icao: "OIIM",
    latitude: "35.776286",
    longitude: "50.881014",
    altitude: "4040",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2134",
    name: "Bandar Abbass Intl",
    city: "Bandar Abbas",
    country: "Iran",
    iata: "BND",
    icao: "OIKB",
    latitude: "27.218317",
    longitude: "56.37785",
    altitude: "22",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2135",
    name: "Jiroft",
    city: "Jiroft",
    country: "Iran",
    iata: "",
    icao: "OIKJ",
    latitude: "28.726925",
    longitude: "57.670269",
    altitude: "2663",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2136",
    name: "Kerman",
    city: "Kerman",
    country: "Iran",
    iata: "KER",
    icao: "OIKK",
    latitude: "30.274444",
    longitude: "56.951111",
    altitude: "5741",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2138",
    name: "Havadarya",
    city: "Bandar Abbas",
    country: "Iran",
    iata: "",
    icao: "OIKP",
    latitude: "27.158251",
    longitude: "56.172461",
    altitude: "19",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2139",
    name: "Dayrestan",
    city: "Gheshm I.",
    country: "Iran",
    iata: "",
    icao: "OIKQ",
    latitude: "26.754639",
    longitude: "55.902353",
    altitude: "45",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2141",
    name: "Sirjan",
    city: "Sirjan",
    country: "Iran",
    iata: "",
    icao: "OIKY",
    latitude: "29.550933",
    longitude: "55.672708",
    altitude: "5846",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2142",
    name: "Birjand",
    city: "Birjand",
    country: "Iran",
    iata: "XBJ",
    icao: "OIMB",
    latitude: "32.898056",
    longitude: "59.266111",
    altitude: "4952",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2143",
    name: "Sarakhs",
    city: "Sarakhs",
    country: "Iran",
    iata: "",
    icao: "OIMC",
    latitude: "36.501178",
    longitude: "61.064903",
    altitude: "945",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2144",
    name: "Shahroud",
    city: "Emam Shahr",
    country: "Iran",
    iata: "",
    icao: "OIMJ",
    latitude: "36.425094",
    longitude: "55.104833",
    altitude: "4197",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6870",
    name: "Whitsunday Airstrip",
    city: "Airlie Beach",
    country: "Australia",
    iata: "WSY",
    icao: "YWHI",
    latitude: "-20.276",
    longitude: "148.755",
    altitude: "60",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "2147",
    name: "Tabas",
    city: "Tabas",
    country: "Iran",
    iata: "",
    icao: "OIMT",
    latitude: "33.66775",
    longitude: "56.892675",
    altitude: "2312",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2148",
    name: "Kalaleh",
    city: "Kalaleh",
    country: "Iran",
    iata: "",
    icao: "OINE",
    latitude: "37.383272",
    longitude: "55.452008",
    altitude: "425",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2151",
    name: "Ramsar",
    city: "Ramsar",
    country: "Iran",
    iata: "RZR",
    icao: "OINR",
    latitude: "36.909908",
    longitude: "50.679589",
    altitude: "-70",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6869",
    name: "Aeropuerto de Rafaela",
    city: "Rafaela",
    country: "Argentina",
    iata: "RAF",
    icao: "\\N",
    latitude: "-31.282072",
    longitude: "-61.501594",
    altitude: "100",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2153",
    name: "Fasa",
    city: "Fasa",
    country: "Iran",
    iata: "",
    icao: "OISF",
    latitude: "28.891756",
    longitude: "53.723339",
    altitude: "4261",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2154",
    name: "Jahrom",
    city: "Jahrom",
    country: "Iran",
    iata: "",
    icao: "OISJ",
    latitude: "28.586675",
    longitude: "53.579144",
    altitude: "3358",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2156",
    name: "Lamerd",
    city: "Lamerd",
    country: "Iran",
    iata: "",
    icao: "OISR",
    latitude: "27.372744",
    longitude: "53.188794",
    altitude: "1337",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2157",
    name: "Shiraz Shahid Dastghaib Intl",
    city: "Shiraz",
    country: "Iran",
    iata: "SYZ",
    icao: "OISS",
    latitude: "29.539242",
    longitude: "52.589786",
    altitude: "4920",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2158",
    name: "Khoy",
    city: "Khoy",
    country: "Iran",
    iata: "",
    icao: "OITK",
    latitude: "38.427453",
    longitude: "44.973575",
    altitude: "3981",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6868",
    name: "Sabadell Airport",
    city: "Sabadell",
    country: "Spain",
    iata: "QSA",
    icao: "LELL",
    latitude: "41.5209",
    longitude: "2.10508",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "2162",
    name: "Tabriz Intl",
    city: "Tabriz",
    country: "Iran",
    iata: "TBZ",
    icao: "OITT",
    latitude: "38.133889",
    longitude: "46.235",
    altitude: "4459",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2163",
    name: "Zanjan",
    city: "Zanjan",
    country: "Iran",
    iata: "",
    icao: "OITZ",
    latitude: "36.77365",
    longitude: "48.359422",
    altitude: "5382",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2164",
    name: "Yazd Shahid Sadooghi",
    city: "Yazd",
    country: "Iran",
    iata: "AZD",
    icao: "OIYY",
    latitude: "31.904908",
    longitude: "54.276503",
    altitude: "4054",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2165",
    name: "Zabol",
    city: "Zabol",
    country: "Iran",
    iata: "",
    icao: "OIZB",
    latitude: "31.098333",
    longitude: "61.543889",
    altitude: "1628",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2166",
    name: "Chah Bahar",
    city: "Chah Bahar",
    country: "Iran",
    iata: "ZBR",
    icao: "OIZC",
    latitude: "25.44335",
    longitude: "60.382114",
    altitude: "43",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2167",
    name: "Zahedan Intl",
    city: "Zahedan",
    country: "Iran",
    iata: "ZAH",
    icao: "OIZH",
    latitude: "29.475686",
    longitude: "60.906189",
    altitude: "4564",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2168",
    name: "Iran Shahr",
    city: "Iran Shahr",
    country: "Iran",
    iata: "",
    icao: "OIZI",
    latitude: "27.236117",
    longitude: "60.720039",
    altitude: "2040",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2169",
    name: "Saravan",
    city: "Saravan",
    country: "Iran",
    iata: "",
    icao: "OIZS",
    latitude: "27.419261",
    longitude: "62.315789",
    altitude: "3930",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "2170",
    name: "Queen Alia Intl",
    city: "Amman",
    country: "Jordan",
    iata: "AMM",
    icao: "OJAI",
    latitude: "31.722556",
    longitude: "35.993214",
    altitude: "2395",
    timezone: "2",
    dst: "E",
    tz: "Asia/Amman",
  },
  {
    id: "2171",
    name: "Marka Intl",
    city: "Amman",
    country: "Jordan",
    iata: "ADJ",
    icao: "OJAM",
    latitude: "31.972703",
    longitude: "35.991569",
    altitude: "2555",
    timezone: "2",
    dst: "E",
    tz: "Asia/Amman",
  },
  {
    id: "2172",
    name: "Aqaba King Hussein Intl",
    city: "Aqaba",
    country: "Jordan",
    iata: "AQJ",
    icao: "OJAQ",
    latitude: "29.611619",
    longitude: "35.018067",
    altitude: "175",
    timezone: "2",
    dst: "E",
    tz: "Asia/Amman",
  },
  {
    id: "2173",
    name: "Prince Hasan",
    city: "Hotel Four",
    country: "Jordan",
    iata: "",
    icao: "OJHF",
    latitude: "32.160747",
    longitude: "37.149383",
    altitude: "2220",
    timezone: "2",
    dst: "E",
    tz: "Asia/Amman",
  },
  {
    id: "2174",
    name: "Jerusalem",
    city: "Jerusalem",
    country: "West Bank",
    iata: "",
    icao: "OJJR",
    latitude: "31.864722",
    longitude: "35.219167",
    altitude: "2485",
    timezone: "2",
    dst: "U",
    tz: "Asia/Gaza",
  },
  {
    id: "2175",
    name: "King Hussein",
    city: "Mafraq",
    country: "Jordan",
    iata: "OMF",
    icao: "OJMF",
    latitude: "32.356353",
    longitude: "36.259181",
    altitude: "2240",
    timezone: "2",
    dst: "E",
    tz: "Asia/Amman",
  },
  {
    id: "2176",
    name: "Kuwait Intl",
    city: "Kuwait",
    country: "Kuwait",
    iata: "KWI",
    icao: "OKBK",
    latitude: "29.226567",
    longitude: "47.968928",
    altitude: "206",
    timezone: "3",
    dst: "U",
    tz: "Asia/Kuwait",
  },
  {
    id: "2177",
    name: "Rafic Hariri Intl",
    city: "Beirut",
    country: "Lebanon",
    iata: "BEY",
    icao: "OLBA",
    latitude: "33.820931",
    longitude: "35.488389",
    altitude: "87",
    timezone: "2",
    dst: "E",
    tz: "Asia/Beirut",
  },
  {
    id: "2178",
    name: "Rene Mouawad",
    city: "Kleiat",
    country: "Lebanon",
    iata: "",
    icao: "OLKA",
    latitude: "34.589333",
    longitude: "36.011322",
    altitude: "75",
    timezone: "2",
    dst: "E",
    tz: "Asia/Beirut",
  },
  {
    id: "2179",
    name: "Abu Dhabi Intl",
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    iata: "AUH",
    icao: "OMAA",
    latitude: "24.432972",
    longitude: "54.651138",
    altitude: "88",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2180",
    name: "Bateen",
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    iata: "AZI",
    icao: "OMAD",
    latitude: "24.428333",
    longitude: "54.458084",
    altitude: "16",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2181",
    name: "Al Hamra Aux",
    city: "Al Hamra",
    country: "United Arab Emirates",
    iata: "",
    icao: "OMAH",
    latitude: "24.073981",
    longitude: "52.463644",
    altitude: "50",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2182",
    name: "Jebel Dhana",
    city: "Jebel Dhana",
    country: "United Arab Emirates",
    iata: "",
    icao: "OMAJ",
    latitude: "24.187428",
    longitude: "52.614",
    altitude: "43",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "6867",
    name: "Reykjahlid Airport",
    city: "Myvatn",
    country: "Iceland",
    iata: "MVA",
    icao: "BIRL",
    latitude: "65.6558",
    longitude: "-16.9181",
    altitude: "1030",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "2184",
    name: "Al Dhafra",
    city: "Abu Dhabi",
    country: "United Arab Emirates",
    iata: "",
    icao: "OMAM",
    latitude: "24.248249",
    longitude: "54.547722",
    altitude: "77",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2185",
    name: "Arzanah",
    city: "Arzana",
    country: "United Arab Emirates",
    iata: "",
    icao: "OMAR",
    latitude: "24.780528",
    longitude: "52.559944",
    altitude: "15",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2186",
    name: "Das Island",
    city: "Das Island",
    country: "United Arab Emirates",
    iata: "",
    icao: "OMAS",
    latitude: "25.146219",
    longitude: "52.873711",
    altitude: "12",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2187",
    name: "Zirku",
    city: "Zirku",
    country: "United Arab Emirates",
    iata: "",
    icao: "OMAZ",
    latitude: "24.861542",
    longitude: "53.077833",
    altitude: "14",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2188",
    name: "Dubai Intl",
    city: "Dubai",
    country: "United Arab Emirates",
    iata: "DXB",
    icao: "OMDB",
    latitude: "25.252778",
    longitude: "55.364444",
    altitude: "62",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2189",
    name: "Fujairah Intl",
    city: "Fujeirah",
    country: "United Arab Emirates",
    iata: "FJR",
    icao: "OMFJ",
    latitude: "25.112225",
    longitude: "56.323964",
    altitude: "152",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2190",
    name: "Ras Al Khaimah Intl",
    city: "Ras Al Khaimah",
    country: "United Arab Emirates",
    iata: "RKT",
    icao: "OMRK",
    latitude: "25.613483",
    longitude: "55.938817",
    altitude: "102",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2191",
    name: "Sharjah Intl",
    city: "Sharjah",
    country: "United Arab Emirates",
    iata: "SHJ",
    icao: "OMSJ",
    latitude: "25.328575",
    longitude: "55.51715",
    altitude: "111",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "2192",
    name: "Khasab",
    city: "Khasab",
    country: "Oman",
    iata: "KHS",
    icao: "OOKB",
    latitude: "26.170986",
    longitude: "56.240569",
    altitude: "100",
    timezone: "4",
    dst: "U",
    tz: "Asia/Muscat",
  },
  {
    id: "2193",
    name: "Masirah",
    city: "Masirah",
    country: "Oman",
    iata: "MSH",
    icao: "OOMA",
    latitude: "20.675434",
    longitude: "58.890467",
    altitude: "64",
    timezone: "4",
    dst: "U",
    tz: "Asia/Muscat",
  },
  {
    id: "2194",
    name: "Seeb Intl",
    city: "Muscat",
    country: "Oman",
    iata: "MCT",
    icao: "OOMS",
    latitude: "23.593278",
    longitude: "58.284444",
    altitude: "48",
    timezone: "4",
    dst: "U",
    tz: "Asia/Muscat",
  },
  {
    id: "2195",
    name: "Salalah",
    city: "Salalah",
    country: "Oman",
    iata: "SLL",
    icao: "OOSA",
    latitude: "17.038719",
    longitude: "54.091297",
    altitude: "73",
    timezone: "4",
    dst: "U",
    tz: "Asia/Muscat",
  },
  {
    id: "2196",
    name: "Thumrait",
    city: "Thumrait",
    country: "Oman",
    iata: "TTH",
    icao: "OOTH",
    latitude: "17.666",
    longitude: "54.024612",
    altitude: "1570",
    timezone: "4",
    dst: "U",
    tz: "Asia/Muscat",
  },
  {
    id: "2197",
    name: "Bhagatanwala",
    city: "Bhagtanwala",
    country: "Pakistan",
    iata: "",
    icao: "OPBG",
    latitude: "32.056108",
    longitude: "72.9484",
    altitude: "600",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "6866",
    name: "Spray View Airport",
    city: "Spray View",
    country: "Zimbabwe",
    iata: "",
    icao: "FVSV",
    latitude: "-17.917",
    longitude: "25.817",
    altitude: "3210",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "6865",
    name: "Lyon Part-Dieu Railway",
    city: "Lyon",
    country: "France",
    iata: "XYD",
    icao: "\\N",
    latitude: "46",
    longitude: "5",
    altitude: "821",
    timezone: "1",
    dst: "U",
    tz: "Europe/Paris",
  },
  {
    id: "2202",
    name: "Faisalabad Intl",
    city: "Faisalabad",
    country: "Pakistan",
    iata: "LYP",
    icao: "OPFA",
    latitude: "31.365014",
    longitude: "72.994842",
    altitude: "591",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2203",
    name: "Gwadar",
    city: "Gwadar",
    country: "Pakistan",
    iata: "GWD",
    icao: "OPGD",
    latitude: "25.233308",
    longitude: "62.329494",
    altitude: "36",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2204",
    name: "Gilgit",
    city: "Gilgit",
    country: "Pakistan",
    iata: "GIL",
    icao: "OPGT",
    latitude: "35.918786",
    longitude: "74.333644",
    altitude: "4796",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2205",
    name: "Shahbaz Ab",
    city: "Jacobsbad",
    country: "Pakistan",
    iata: "",
    icao: "OPJA",
    latitude: "28.284167",
    longitude: "68.449711",
    altitude: "185",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2206",
    name: "Jinnah Intl",
    city: "Karachi",
    country: "Pakistan",
    iata: "KHI",
    icao: "OPKC",
    latitude: "24.906547",
    longitude: "67.160797",
    altitude: "100",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2207",
    name: "Allama Iqbal Intl",
    city: "Lahore",
    country: "Pakistan",
    iata: "LHE",
    icao: "OPLA",
    latitude: "31.521564",
    longitude: "74.403594",
    altitude: "712",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2208",
    name: "Walton",
    city: "Lahore",
    country: "Pakistan",
    iata: "",
    icao: "OPLH",
    latitude: "31.494794",
    longitude: "74.346239",
    altitude: "679",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2209",
    name: "Mangla",
    city: "Mangla",
    country: "Pakistan",
    iata: "",
    icao: "OPMA",
    latitude: "33.050086",
    longitude: "73.638381",
    altitude: "902",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2210",
    name: "Muzaffarabad",
    city: "Muzaffarabad",
    country: "Pakistan",
    iata: "MFG",
    icao: "OPMF",
    latitude: "34.339022",
    longitude: "73.508639",
    altitude: "2691",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2211",
    name: "Mianwali",
    city: "Mianwali",
    country: "Pakistan",
    iata: "",
    icao: "OPMI",
    latitude: "32.563089",
    longitude: "71.570681",
    altitude: "690",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2212",
    name: "Moenjodaro",
    city: "Moenjodaro",
    country: "Pakistan",
    iata: "MJD",
    icao: "OPMJ",
    latitude: "27.335156",
    longitude: "68.143053",
    altitude: "154",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2213",
    name: "Masroor",
    city: "Karachi",
    country: "Pakistan",
    iata: "",
    icao: "OPMR",
    latitude: "24.893564",
    longitude: "66.938753",
    altitude: "35",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2214",
    name: "Multan Intl",
    city: "Multan",
    country: "Pakistan",
    iata: "MUX",
    icao: "OPMT",
    latitude: "30.203222",
    longitude: "71.419111",
    altitude: "403",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2215",
    name: "Nawabshah",
    city: "Nawabshah",
    country: "Pakistan",
    iata: "WNS",
    icao: "OPNH",
    latitude: "26.219442",
    longitude: "68.390053",
    altitude: "95",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2216",
    name: "Okara",
    city: "Okara",
    country: "Pakistan",
    iata: "",
    icao: "OPOK",
    latitude: "30.741025",
    longitude: "73.357736",
    altitude: "568",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2217",
    name: "Panjgur",
    city: "Panjgur",
    country: "Pakistan",
    iata: "PJG",
    icao: "OPPG",
    latitude: "26.954547",
    longitude: "64.132517",
    altitude: "3289",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2218",
    name: "Pasni",
    city: "Pasni",
    country: "Pakistan",
    iata: "PSI",
    icao: "OPPI",
    latitude: "25.290487",
    longitude: "63.345083",
    altitude: "33",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2219",
    name: "Peshawar Intl",
    city: "Peshawar",
    country: "Pakistan",
    iata: "PEW",
    icao: "OPPS",
    latitude: "33.993911",
    longitude: "71.514581",
    altitude: "1158",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2220",
    name: "Qasim",
    city: "Qasim",
    country: "Pakistan",
    iata: "",
    icao: "OPQS",
    latitude: "33.560153",
    longitude: "73.033217",
    altitude: "1581",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2221",
    name: "Quetta",
    city: "Quetta",
    country: "Pakistan",
    iata: "UET",
    icao: "OPQT",
    latitude: "30.251369",
    longitude: "66.937764",
    altitude: "5267",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2222",
    name: "Sheikh Zayed",
    city: "Rahim Yar Khan",
    country: "Pakistan",
    iata: "RYK",
    icao: "OPRK",
    latitude: "28.3839",
    longitude: "70.279572",
    altitude: "271",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2223",
    name: "Chaklala",
    city: "Islamabad",
    country: "Pakistan",
    iata: "ISB",
    icao: "OPRN",
    latitude: "33.616653",
    longitude: "73.099233",
    altitude: "1668",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2224",
    name: "Risalpur",
    city: "Risalpur",
    country: "Pakistan",
    iata: "",
    icao: "OPRS",
    latitude: "34.081112",
    longitude: "71.972583",
    altitude: "1050",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2225",
    name: "Rawalakot",
    city: "Rawala Kot",
    country: "Pakistan",
    iata: "RAZ",
    icao: "OPRT",
    latitude: "33.849658",
    longitude: "73.798147",
    altitude: "5479",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "6864",
    name: "Point Roberts Airpark",
    city: "Point Roberts",
    country: "United States",
    iata: "1RL",
    icao: "K1RL",
    latitude: "48.9797222",
    longitude: "-123.0788889",
    altitude: "10",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "2227",
    name: "Sukkur",
    city: "Sukkur",
    country: "Pakistan",
    iata: "SKZ",
    icao: "OPSK",
    latitude: "27.721989",
    longitude: "68.791683",
    altitude: "196",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2228",
    name: "Saidu Sharif",
    city: "Saidu Sharif",
    country: "Pakistan",
    iata: "SDT",
    icao: "OPSS",
    latitude: "34.813556",
    longitude: "72.352814",
    altitude: "3183",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2229",
    name: "Sui",
    city: "Sui",
    country: "Pakistan",
    iata: "SUL",
    icao: "OPSU",
    latitude: "28.645142",
    longitude: "69.176917",
    altitude: "763",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2230",
    name: "Talhar",
    city: "Talhar",
    country: "Pakistan",
    iata: "BDN",
    icao: "OPTH",
    latitude: "24.841519",
    longitude: "68.838408",
    altitude: "28",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2232",
    name: "Wana",
    city: "Wana",
    country: "Pakistan",
    iata: "",
    icao: "OPWN",
    latitude: "32.304664",
    longitude: "69.570433",
    altitude: "4550",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2233",
    name: "Zhob",
    city: "Zhob",
    country: "Pakistan",
    iata: "PZH",
    icao: "OPZB",
    latitude: "31.358381",
    longitude: "69.463606",
    altitude: "4728",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "2234",
    name: "Basrah Intl",
    city: "Basrah",
    country: "Iraq",
    iata: "BSR",
    icao: "ORMM",
    latitude: "30.549069",
    longitude: "47.662142",
    altitude: "11",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "2235",
    name: "Aleppo Intl",
    city: "Aleppo",
    country: "Syria",
    iata: "ALP",
    icao: "OSAP",
    latitude: "36.180675",
    longitude: "37.224358",
    altitude: "1276",
    timezone: "2",
    dst: "E",
    tz: "Asia/Damascus",
  },
  {
    id: "2236",
    name: "Damascus Intl",
    city: "Damascus",
    country: "Syria",
    iata: "DAM",
    icao: "OSDI",
    latitude: "33.410636",
    longitude: "36.514267",
    altitude: "2020",
    timezone: "2",
    dst: "E",
    tz: "Asia/Damascus",
  },
  {
    id: "2237",
    name: "Deir Zzor",
    city: "Deire Zor",
    country: "Syria",
    iata: "DEZ",
    icao: "OSDZ",
    latitude: "35.285374",
    longitude: "40.175961",
    altitude: "700",
    timezone: "2",
    dst: "E",
    tz: "Asia/Damascus",
  },
  {
    id: "2239",
    name: "Bassel Al Assad Intl",
    city: "Latakia",
    country: "Syria",
    iata: "LTK",
    icao: "OSLK",
    latitude: "35.401094",
    longitude: "35.948681",
    altitude: "157",
    timezone: "2",
    dst: "E",
    tz: "Asia/Damascus",
  },
  {
    id: "2240",
    name: "Palmyra",
    city: "Palmyra",
    country: "Syria",
    iata: "PMS",
    icao: "OSPR",
    latitude: "34.557361",
    longitude: "38.316889",
    altitude: "1322",
    timezone: "2",
    dst: "E",
    tz: "Asia/Damascus",
  },
  {
    id: "2241",
    name: "Doha Intl",
    city: "Doha",
    country: "Qatar",
    iata: "DOH",
    icao: "OTBD",
    latitude: "25.261125",
    longitude: "51.565056",
    altitude: "35",
    timezone: "3",
    dst: "U",
    tz: "Asia/Qatar",
  },
  {
    id: "2242",
    name: "Canton",
    city: "Canton Island",
    country: "Kiribati",
    iata: "CIS",
    icao: "PCIS",
    latitude: "-2.768122",
    longitude: "-171.710394",
    altitude: "9",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Enderbury",
  },
  {
    id: "2243",
    name: "Rota Intl",
    city: "Rota",
    country: "Northern Mariana Islands",
    iata: "ROP",
    icao: "PGRO",
    latitude: "14.174308",
    longitude: "145.242536",
    altitude: "607",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Saipan",
  },
  {
    id: "2244",
    name: "Francisco C Ada Saipan Intl",
    city: "Saipan",
    country: "Northern Mariana Islands",
    iata: "SPN",
    icao: "PGSN",
    latitude: "15.119003",
    longitude: "145.729356",
    altitude: "215",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Saipan",
  },
  {
    id: "2245",
    name: "Andersen Afb",
    city: "Andersen",
    country: "Guam",
    iata: "UAM",
    icao: "PGUA",
    latitude: "13.583953",
    longitude: "144.930025",
    altitude: "627",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Guam",
  },
  {
    id: "2246",
    name: "Guam Intl",
    city: "Agana",
    country: "Guam",
    iata: "GUM",
    icao: "PGUM",
    latitude: "13.48345",
    longitude: "144.795983",
    altitude: "298",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Guam",
  },
  {
    id: "2247",
    name: "Tinian Intl",
    city: "West Tinian",
    country: "Northern Mariana Islands",
    iata: "TIQ",
    icao: "PGWT",
    latitude: "14.999203",
    longitude: "145.61935",
    altitude: "271",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Saipan",
  },
  {
    id: "6807",
    name: "Scone Airport",
    city: "Scone",
    country: "Australia",
    iata: "NSO",
    icao: "YSCO",
    latitude: "-32.0372",
    longitude: "150.832",
    altitude: "745",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "2249",
    name: "Marshall Islands Intl",
    city: "Majuro",
    country: "Marshall Islands",
    iata: "MAJ",
    icao: "PKMJ",
    latitude: "7.064758",
    longitude: "171.272022",
    altitude: "6",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "2250",
    name: "Dyess Aaf",
    city: "Kwajalein",
    country: "Marshall Islands",
    iata: "",
    icao: "PKRO",
    latitude: "9.396886",
    longitude: "167.470869",
    altitude: "9",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "2251",
    name: "Bucholz Aaf",
    city: "Kwajalein",
    country: "Marshall Islands",
    iata: "KWA",
    icao: "PKWA",
    latitude: "8.720122",
    longitude: "167.731661",
    altitude: "9",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "2252",
    name: "Cassidy Intl",
    city: "Kiritimati",
    country: "Kiribati",
    iata: "CXI",
    icao: "PLCH",
    latitude: "1.986161",
    longitude: "-157.349778",
    altitude: "5",
    timezone: "-12",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "2253",
    name: "Midway Atoll",
    city: "Midway",
    country: "Midway Islands",
    iata: "MDY",
    icao: "PMDY",
    latitude: "28.201725",
    longitude: "-177.380636",
    altitude: "13",
    timezone: "-11",
    dst: "U",
    tz: "Pacific/Midway",
  },
  {
    id: "2254",
    name: "Chuuk Intl",
    city: "Chuuk",
    country: "Micronesia",
    iata: "TKK",
    icao: "PTKK",
    latitude: "7.461869",
    longitude: "151.843006",
    altitude: "11",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Truk",
  },
  {
    id: "2255",
    name: "Pohnpei Intl",
    city: "Pohnpei",
    country: "Micronesia",
    iata: "PNI",
    icao: "PTPN",
    latitude: "6.9851",
    longitude: "158.208989",
    altitude: "10",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Ponape",
  },
  {
    id: "2256",
    name: "Babelthuap",
    city: "Babelthuap",
    country: "Palau",
    iata: "ROR",
    icao: "PTRO",
    latitude: "7.367303",
    longitude: "134.544278",
    altitude: "176",
    timezone: "9",
    dst: "U",
    tz: "Pacific/Palau",
  },
  {
    id: "2257",
    name: "Kosrae",
    city: "Kosrae",
    country: "Micronesia",
    iata: "KSA",
    icao: "PTSA",
    latitude: "5.356975",
    longitude: "162.958386",
    altitude: "11",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Kosrae",
  },
  {
    id: "2258",
    name: "Yap Intl",
    city: "Yap",
    country: "Micronesia",
    iata: "YAP",
    icao: "PTYA",
    latitude: "9.498911",
    longitude: "138.082497",
    altitude: "91",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Truk",
  },
  {
    id: "2259",
    name: "Shang Yi",
    city: "Kinmen",
    country: "Taiwan",
    iata: "KNH",
    icao: "RCBS",
    latitude: "24.427892",
    longitude: "118.359197",
    altitude: "93",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2260",
    name: "Pingtung South",
    city: "Pingtung",
    country: "Taiwan",
    iata: "PIF",
    icao: "RCDC",
    latitude: "22.672367",
    longitude: "120.461728",
    altitude: "78",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2261",
    name: "Longtan",
    city: "Longtang",
    country: "Taiwan",
    iata: "",
    icao: "RCDI",
    latitude: "24.855136",
    longitude: "121.237636",
    altitude: "790",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2262",
    name: "Fengnin",
    city: "Fengnin",
    country: "Taiwan",
    iata: "TTT",
    icao: "RCFN",
    latitude: "22.754986",
    longitude: "121.101681",
    altitude: "143",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2263",
    name: "Lyudao",
    city: "Green Island",
    country: "Taiwan",
    iata: "GNI",
    icao: "RCGI",
    latitude: "22.673853",
    longitude: "121.466481",
    altitude: "28",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2264",
    name: "Kaohsiung Intl",
    city: "Kaohsiung",
    country: "Taiwan",
    iata: "KHH",
    icao: "RCKH",
    latitude: "22.577094",
    longitude: "120.350006",
    altitude: "31",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2265",
    name: "Chiayi",
    city: "Chiayi",
    country: "Taiwan",
    iata: "CYI",
    icao: "RCKU",
    latitude: "23.461779",
    longitude: "120.39283",
    altitude: "85",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2267",
    name: "Lanyu",
    city: "Lanyu",
    country: "Taiwan",
    iata: "KYD",
    icao: "RCLY",
    latitude: "22.028842",
    longitude: "121.533642",
    altitude: "44",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2268",
    name: "Ching Chuang Kang",
    city: "Taichung",
    country: "Taiwan",
    iata: "RMQ",
    icao: "RCMQ",
    latitude: "24.264668",
    longitude: "120.62058",
    altitude: "663",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "6806",
    name: "Cessnock Airport",
    city: "Cessnock",
    country: "Australia",
    iata: "CES",
    icao: "YCNK",
    latitude: "-32.7875",
    longitude: "151.342",
    altitude: "211",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "2270",
    name: "Tainan",
    city: "Tainan",
    country: "Taiwan",
    iata: "TNN",
    icao: "RCNN",
    latitude: "22.950361",
    longitude: "120.205778",
    altitude: "63",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2271",
    name: "Hsinchu",
    city: "Hsinchu",
    country: "Taiwan",
    iata: "",
    icao: "RCPO",
    latitude: "24.818033",
    longitude: "120.939394",
    altitude: "26",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2272",
    name: "Magong",
    city: "Makung",
    country: "Taiwan",
    iata: "MZG",
    icao: "RCQC",
    latitude: "23.568669",
    longitude: "119.628311",
    altitude: "103",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2273",
    name: "Jhihhang",
    city: "Taitung",
    country: "Taiwan",
    iata: "",
    icao: "RCQS",
    latitude: "22.793117",
    longitude: "121.181975",
    altitude: "128",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2274",
    name: "Pingtung North",
    city: "Pingtung",
    country: "Taiwan",
    iata: "",
    icao: "RCSQ",
    latitude: "22.700239",
    longitude: "120.482",
    altitude: "97",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2275",
    name: "Sungshan",
    city: "Taipei",
    country: "Taiwan",
    iata: "TSA",
    icao: "RCSS",
    latitude: "25.069722",
    longitude: "121.5525",
    altitude: "18",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2276",
    name: "Taoyuan Intl",
    city: "Taipei",
    country: "Taiwan",
    iata: "TPE",
    icao: "RCTP",
    latitude: "25.077731",
    longitude: "121.232822",
    altitude: "106",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2277",
    name: "Wang An",
    city: "Wang An",
    country: "Taiwan",
    iata: "WOT",
    icao: "RCWA",
    latitude: "23.370833",
    longitude: "119.494444",
    altitude: "115",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2278",
    name: "Hualien",
    city: "Hualien",
    country: "Taiwan",
    iata: "HUN",
    icao: "RCYU",
    latitude: "24.023725",
    longitude: "121.616906",
    altitude: "52",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "2279",
    name: "Narita Intl",
    city: "Tokyo",
    country: "Japan",
    iata: "NRT",
    icao: "RJAA",
    latitude: "35.764722",
    longitude: "140.386389",
    altitude: "141",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2280",
    name: "Matsumoto",
    city: "Matsumoto",
    country: "Japan",
    iata: "MMJ",
    icao: "RJAF",
    latitude: "36.166758",
    longitude: "137.922669",
    altitude: "2182",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2281",
    name: "Hyakuri",
    city: "Ibaraki",
    country: "Japan",
    iata: "IBR",
    icao: "RJAH",
    latitude: "36.181083",
    longitude: "140.415444",
    altitude: "105",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2282",
    name: "Minami Torishima",
    city: "Minami Tori Shima",
    country: "Japan",
    iata: "",
    icao: "RJAM",
    latitude: "24.289697",
    longitude: "153.979119",
    altitude: "22",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2283",
    name: "Iwo Jima",
    city: "Iwojima",
    country: "Japan",
    iata: "IWO",
    icao: "RJAW",
    latitude: "24.784",
    longitude: "141.322722",
    altitude: "384",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2284",
    name: "Nanki Shirahama",
    city: "Nanki-shirahama",
    country: "Japan",
    iata: "SHM",
    icao: "RJBD",
    latitude: "33.662222",
    longitude: "135.364444",
    altitude: "298",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2285",
    name: "Kohnan",
    city: "Kohnan",
    country: "Japan",
    iata: "",
    icao: "RJBK",
    latitude: "34.590836",
    longitude: "133.933225",
    altitude: "3",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2286",
    name: "Obihiro",
    city: "Obihiro",
    country: "Japan",
    iata: "OBO",
    icao: "RJCB",
    latitude: "42.733333",
    longitude: "143.217222",
    altitude: "505",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2287",
    name: "New Chitose",
    city: "Sapporo",
    country: "Japan",
    iata: "CTS",
    icao: "RJCC",
    latitude: "42.7752",
    longitude: "141.692283",
    altitude: "82",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2288",
    name: "Hakodate",
    city: "Hakodate",
    country: "Japan",
    iata: "HKD",
    icao: "RJCH",
    latitude: "41.77",
    longitude: "140.821944",
    altitude: "151",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2289",
    name: "Chitose",
    city: "Chitose",
    country: "Japan",
    iata: "SPK",
    icao: "RJCJ",
    latitude: "42.794475",
    longitude: "141.666447",
    altitude: "87",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2290",
    name: "Memanbetsu",
    city: "Memanbetsu",
    country: "Japan",
    iata: "MMB",
    icao: "RJCM",
    latitude: "43.880606",
    longitude: "144.164053",
    altitude: "135",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2291",
    name: "Nakashibetsu",
    city: "Nakashibetsu",
    country: "Japan",
    iata: "SHB",
    icao: "RJCN",
    latitude: "43.5775",
    longitude: "144.96",
    altitude: "234",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2293",
    name: "Tokachi",
    city: "Tokachi",
    country: "Japan",
    iata: "",
    icao: "RJCT",
    latitude: "42.890544",
    longitude: "143.158475",
    altitude: "281",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2294",
    name: "Wakkanai",
    city: "Wakkanai",
    country: "Japan",
    iata: "WKJ",
    icao: "RJCW",
    latitude: "45.404167",
    longitude: "141.800833",
    altitude: "30",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2295",
    name: "Iki",
    city: "Iki",
    country: "Japan",
    iata: "IKI",
    icao: "RJDB",
    latitude: "33.749027",
    longitude: "129.785417",
    altitude: "41",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2296",
    name: "Yamaguchi Ube",
    city: "Yamaguchi",
    country: "Japan",
    iata: "UBJ",
    icao: "RJDC",
    latitude: "33.93",
    longitude: "131.278611",
    altitude: "23",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2297",
    name: "Tsushima",
    city: "Tsushima",
    country: "Japan",
    iata: "TSJ",
    icao: "RJDT",
    latitude: "34.284889",
    longitude: "129.33055",
    altitude: "213",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2298",
    name: "Monbetsu",
    city: "Monbetsu",
    country: "Japan",
    iata: "MBE",
    icao: "RJEB",
    latitude: "44.303914",
    longitude: "143.404028",
    altitude: "80",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2299",
    name: "Asahikawa",
    city: "Asahikawa",
    country: "Japan",
    iata: "AKJ",
    icao: "RJEC",
    latitude: "43.670833",
    longitude: "142.4475",
    altitude: "721",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2300",
    name: "Okushiri",
    city: "Okushiri",
    country: "Japan",
    iata: "OIR",
    icao: "RJEO",
    latitude: "42.071667",
    longitude: "139.432911",
    altitude: "161",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2301",
    name: "Rishiri",
    city: "Rishiri Island",
    country: "Japan",
    iata: "RIS",
    icao: "RJER",
    latitude: "45.242006",
    longitude: "141.186431",
    altitude: "112",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2302",
    name: "Ashiya",
    city: "Ashiya",
    country: "Japan",
    iata: "",
    icao: "RJFA",
    latitude: "33.883083",
    longitude: "130.653",
    altitude: "98",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2303",
    name: "Yakushima",
    city: "Yakushima",
    country: "Japan",
    iata: "KUM",
    icao: "RJFC",
    latitude: "30.385569",
    longitude: "130.659017",
    altitude: "124",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2304",
    name: "Fukue",
    city: "Fukue",
    country: "Japan",
    iata: "FUJ",
    icao: "RJFE",
    latitude: "32.666269",
    longitude: "128.832808",
    altitude: "273",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2305",
    name: "Fukuoka",
    city: "Fukuoka",
    country: "Japan",
    iata: "FUK",
    icao: "RJFF",
    latitude: "33.585942",
    longitude: "130.450686",
    altitude: "32",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2306",
    name: "New Tanegashima",
    city: "Tanegashima",
    country: "Japan",
    iata: "TNE",
    icao: "RJFG",
    latitude: "30.605067",
    longitude: "130.991231",
    altitude: "768",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2307",
    name: "Kagoshima",
    city: "Kagoshima",
    country: "Japan",
    iata: "KOJ",
    icao: "RJFK",
    latitude: "31.803397",
    longitude: "130.719408",
    altitude: "906",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2308",
    name: "Miyazaki",
    city: "Miyazaki",
    country: "Japan",
    iata: "KMI",
    icao: "RJFM",
    latitude: "31.877222",
    longitude: "131.448611",
    altitude: "20",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2309",
    name: "Nyutabaru",
    city: "Nyutabaru",
    country: "Japan",
    iata: "",
    icao: "RJFN",
    latitude: "32.083611",
    longitude: "131.451389",
    altitude: "259",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2310",
    name: "Oita",
    city: "Oita",
    country: "Japan",
    iata: "OIT",
    icao: "RJFO",
    latitude: "33.479444",
    longitude: "131.737222",
    altitude: "19",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2311",
    name: "New Kitakyushu",
    city: "Kitakyushu",
    country: "Japan",
    iata: "KKJ",
    icao: "RJFR",
    latitude: "33.845942",
    longitude: "131.034689",
    altitude: "21",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2312",
    name: "Kumamoto",
    city: "Kumamoto",
    country: "Japan",
    iata: "KMJ",
    icao: "RJFT",
    latitude: "32.837319",
    longitude: "130.85505",
    altitude: "642",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2313",
    name: "Nagasaki",
    city: "Nagasaki",
    country: "Japan",
    iata: "NGS",
    icao: "RJFU",
    latitude: "32.916944",
    longitude: "129.913611",
    altitude: "15",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2314",
    name: "Kanoya",
    city: "Kanoya",
    country: "Japan",
    iata: "",
    icao: "RJFY",
    latitude: "31.367608",
    longitude: "130.845456",
    altitude: "214",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2315",
    name: "Tsuiki",
    city: "Tsuiki",
    country: "Japan",
    iata: "",
    icao: "RJFZ",
    latitude: "33.685",
    longitude: "131.040278",
    altitude: "55",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2316",
    name: "Amami",
    city: "Amami",
    country: "Japan",
    iata: "ASJ",
    icao: "RJKA",
    latitude: "28.430633",
    longitude: "129.712542",
    altitude: "27",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2317",
    name: "Okierabu",
    city: "Okierabu",
    country: "Japan",
    iata: "",
    icao: "RJKB",
    latitude: "27.425522",
    longitude: "128.700903",
    altitude: "101",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2318",
    name: "Tokunoshima",
    city: "Tokunoshima",
    country: "Japan",
    iata: "TKN",
    icao: "RJKN",
    latitude: "27.836381",
    longitude: "128.881253",
    altitude: "17",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2319",
    name: "Fukui",
    city: "Fukui",
    country: "Japan",
    iata: "",
    icao: "RJNF",
    latitude: "36.142847",
    longitude: "136.223922",
    altitude: "19",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2320",
    name: "Gifu",
    city: "Gifu",
    country: "Japan",
    iata: "",
    icao: "RJNG",
    latitude: "35.394078",
    longitude: "136.869667",
    altitude: "128",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2321",
    name: "Hamamatsu",
    city: "Hamamatsu",
    country: "Japan",
    iata: "",
    icao: "RJNH",
    latitude: "34.750239",
    longitude: "137.703083",
    altitude: "150",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2322",
    name: "Komatsu",
    city: "Kanazawa",
    country: "Japan",
    iata: "KMQ",
    icao: "RJNK",
    latitude: "36.394611",
    longitude: "136.406544",
    altitude: "36",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2323",
    name: "Oki",
    city: "Oki Island",
    country: "Japan",
    iata: "OKI",
    icao: "RJNO",
    latitude: "36.181125",
    longitude: "133.324844",
    altitude: "311",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2324",
    name: "Toyama",
    city: "Toyama",
    country: "Japan",
    iata: "TOY",
    icao: "RJNT",
    latitude: "36.648333",
    longitude: "137.1875",
    altitude: "95",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2325",
    name: "Shizuhama",
    city: "Yaizu",
    country: "Japan",
    iata: "",
    icao: "RJNY",
    latitude: "34.812778",
    longitude: "138.298056",
    altitude: "23",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2326",
    name: "Hiroshima",
    city: "Hiroshima",
    country: "Japan",
    iata: "HIJ",
    icao: "RJOA",
    latitude: "34.436111",
    longitude: "132.919444",
    altitude: "1088",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2327",
    name: "Okayama",
    city: "Okayama",
    country: "Japan",
    iata: "OKJ",
    icao: "RJOB",
    latitude: "34.756944",
    longitude: "133.855278",
    altitude: "806",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2328",
    name: "Izumo",
    city: "Izumo",
    country: "Japan",
    iata: "IZO",
    icao: "RJOC",
    latitude: "35.413611",
    longitude: "132.89",
    altitude: "15",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2329",
    name: "Hofu",
    city: "Hofu",
    country: "Japan",
    iata: "",
    icao: "RJOF",
    latitude: "34.034667",
    longitude: "131.549194",
    altitude: "7",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2330",
    name: "Yonago Kitaro",
    city: "Miho",
    country: "Japan",
    iata: "YGJ",
    icao: "RJOH",
    latitude: "35.492222",
    longitude: "133.236389",
    altitude: "20",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2331",
    name: "Iwakuni Mcas",
    city: "Iwakuni",
    country: "Japan",
    iata: "",
    icao: "RJOI",
    latitude: "34.14386",
    longitude: "132.23575",
    altitude: "7",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2332",
    name: "Kochi",
    city: "Kochi",
    country: "Japan",
    iata: "KCZ",
    icao: "RJOK",
    latitude: "33.546111",
    longitude: "133.669444",
    altitude: "42",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2333",
    name: "Matsuyama",
    city: "Matsuyama",
    country: "Japan",
    iata: "MYJ",
    icao: "RJOM",
    latitude: "33.827222",
    longitude: "132.699722",
    altitude: "25",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2334",
    name: "Osaka Intl",
    city: "Osaka",
    country: "Japan",
    iata: "ITM",
    icao: "RJOO",
    latitude: "34.785528",
    longitude: "135.438222",
    altitude: "50",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2335",
    name: "Tottori",
    city: "Tottori",
    country: "Japan",
    iata: "TTJ",
    icao: "RJOR",
    latitude: "35.530069",
    longitude: "134.166553",
    altitude: "65",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2336",
    name: "Tokushima",
    city: "Tokushima",
    country: "Japan",
    iata: "TKS",
    icao: "RJOS",
    latitude: "34.132808",
    longitude: "134.606639",
    altitude: "26",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2337",
    name: "Takamatsu",
    city: "Takamatsu",
    country: "Japan",
    iata: "TAK",
    icao: "RJOT",
    latitude: "34.214167",
    longitude: "134.015556",
    altitude: "607",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2338",
    name: "Yao",
    city: "Osaka",
    country: "Japan",
    iata: "",
    icao: "RJOY",
    latitude: "34.596311",
    longitude: "135.602944",
    altitude: "39",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2339",
    name: "Ozuki",
    city: "Ozuki",
    country: "Japan",
    iata: "",
    icao: "RJOZ",
    latitude: "34.045322",
    longitude: "131.052144",
    altitude: "13",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2340",
    name: "Aomori",
    city: "Aomori",
    country: "Japan",
    iata: "AOJ",
    icao: "RJSA",
    latitude: "40.734722",
    longitude: "140.690833",
    altitude: "664",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2341",
    name: "Yamagata",
    city: "Yamagata",
    country: "Japan",
    iata: "GAJ",
    icao: "RJSC",
    latitude: "38.411894",
    longitude: "140.371331",
    altitude: "353",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2342",
    name: "Sado",
    city: "Sado",
    country: "Japan",
    iata: "",
    icao: "RJSD",
    latitude: "38.060181",
    longitude: "138.413928",
    altitude: "88",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2343",
    name: "Hachinohe",
    city: "Hachinoe",
    country: "Japan",
    iata: "",
    icao: "RJSH",
    latitude: "40.556447",
    longitude: "141.466325",
    altitude: "152",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2344",
    name: "Hanamaki",
    city: "Hanamaki",
    country: "Japan",
    iata: "HNA",
    icao: "RJSI",
    latitude: "39.428611",
    longitude: "141.135278",
    altitude: "297",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2345",
    name: "Akita",
    city: "Akita",
    country: "Japan",
    iata: "AXT",
    icao: "RJSK",
    latitude: "39.615556",
    longitude: "140.218611",
    altitude: "313",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2346",
    name: "Misawa Ab",
    city: "Misawa",
    country: "Japan",
    iata: "MSJ",
    icao: "RJSM",
    latitude: "40.703222",
    longitude: "141.368364",
    altitude: "119",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2347",
    name: "Sendai",
    city: "Sendai",
    country: "Japan",
    iata: "SDJ",
    icao: "RJSS",
    latitude: "38.139722",
    longitude: "140.916944",
    altitude: "15",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2348",
    name: "Matsushima",
    city: "Matsushima",
    country: "Japan",
    iata: "",
    icao: "RJST",
    latitude: "38.404919",
    longitude: "141.219572",
    altitude: "7",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "6862",
    name: "Sazena",
    city: "Sazena",
    country: "Czech Republic",
    iata: "LKS",
    icao: "LKSZ",
    latitude: "50.1929",
    longitude: "14.1532",
    altitude: "233",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "2350",
    name: "Atsugi Naf",
    city: "Atsugi",
    country: "Japan",
    iata: "",
    icao: "RJTA",
    latitude: "35.454611",
    longitude: "139.450167",
    altitude: "205",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2351",
    name: "Tateyama",
    city: "Tateyama",
    country: "Japan",
    iata: "",
    icao: "RJTE",
    latitude: "34.987053",
    longitude: "139.829208",
    altitude: "10",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2352",
    name: "Hachijojima",
    city: "Hachijojima",
    country: "Japan",
    iata: "HAC",
    icao: "RJTH",
    latitude: "33.115",
    longitude: "139.785833",
    altitude: "303",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2353",
    name: "Iruma",
    city: "Iruma",
    country: "Japan",
    iata: "",
    icao: "RJTJ",
    latitude: "35.841944",
    longitude: "139.410556",
    altitude: "295",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2354",
    name: "Kisarazu",
    city: "Kisarazu",
    country: "Japan",
    iata: "",
    icao: "RJTK",
    latitude: "35.398272",
    longitude: "139.909936",
    altitude: "10",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2355",
    name: "Shimofusa",
    city: "Shimofusa",
    country: "Japan",
    iata: "",
    icao: "RJTL",
    latitude: "35.798944",
    longitude: "140.011111",
    altitude: "98",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2356",
    name: "Oshima",
    city: "Oshima",
    country: "Japan",
    iata: "OIM",
    icao: "RJTO",
    latitude: "34.782033",
    longitude: "139.360306",
    altitude: "130",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2358",
    name: "Kastner Aaf",
    city: "Zama",
    country: "Japan",
    iata: "",
    icao: "RJTR",
    latitude: "35.513769",
    longitude: "139.393675",
    altitude: "360",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2359",
    name: "Tokyo Intl",
    city: "Tokyo",
    country: "Japan",
    iata: "HND",
    icao: "RJTT",
    latitude: "35.552258",
    longitude: "139.779694",
    altitude: "35",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2360",
    name: "Yokota Ab",
    city: "Yokota",
    country: "Japan",
    iata: "OKO",
    icao: "RJTY",
    latitude: "35.748492",
    longitude: "139.348483",
    altitude: "463",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2361",
    name: "Gwangju",
    city: "Kwangju",
    country: "South Korea",
    iata: "KWJ",
    icao: "RKJJ",
    latitude: "35.126389",
    longitude: "126.808889",
    altitude: "39",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2364",
    name: "Jeon Ju",
    city: "Jhunju",
    country: "South Korea",
    iata: "",
    icao: "RKJU",
    latitude: "35.878436",
    longitude: "127.11955",
    altitude: "96",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2365",
    name: "Yeosu",
    city: "Yeosu",
    country: "South Korea",
    iata: "RSU",
    icao: "RKJY",
    latitude: "34.842328",
    longitude: "127.61685",
    altitude: "53",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2366",
    name: "Sokcho",
    city: "Sokch'o",
    country: "South Korea",
    iata: "SHO",
    icao: "RKND",
    latitude: "38.142614",
    longitude: "128.598556",
    altitude: "92",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2367",
    name: "Gangneung",
    city: "Kangnung",
    country: "South Korea",
    iata: "KAG",
    icao: "RKNN",
    latitude: "37.753561",
    longitude: "128.943625",
    altitude: "35",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6861",
    name: "Macomb Municipal Airport",
    city: "Macomb",
    country: "United States",
    iata: "MQB",
    icao: "\\N",
    latitude: "40.5200833",
    longitude: "-90.6523889",
    altitude: "707",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "2370",
    name: "Jeju Intl",
    city: "Cheju",
    country: "South Korea",
    iata: "CJU",
    icao: "RKPC",
    latitude: "33.511306",
    longitude: "126.493028",
    altitude: "118",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2371",
    name: "Jinhae",
    city: "Chinhae",
    country: "South Korea",
    iata: "",
    icao: "RKPE",
    latitude: "35.141175",
    longitude: "128.695792",
    altitude: "8",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2372",
    name: "Gimhae Intl",
    city: "Busan",
    country: "South Korea",
    iata: "PUS",
    icao: "RKPK",
    latitude: "35.179528",
    longitude: "128.938222",
    altitude: "6",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6860",
    name: "Bungle Bungle Airport",
    city: "Bungle Bungle",
    country: "Australia",
    iata: "",
    icao: "YBUU",
    latitude: "-17.5453",
    longitude: "128.307",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "2374",
    name: "Ulsan",
    city: "Ulsan",
    country: "South Korea",
    iata: "USN",
    icao: "RKPU",
    latitude: "35.593494",
    longitude: "129.351722",
    altitude: "45",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2375",
    name: "A 511",
    city: "Pyongtaek",
    country: "South Korea",
    iata: "",
    icao: "RKSG",
    latitude: "36.962214",
    longitude: "127.031072",
    altitude: "51",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2376",
    name: "Seoul Ab",
    city: "Seoul East",
    country: "South Korea",
    iata: "SSN",
    icao: "RKSM",
    latitude: "37.445833",
    longitude: "127.113889",
    altitude: "92",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2377",
    name: "Osan Ab",
    city: "Osan",
    country: "South Korea",
    iata: "OSN",
    icao: "RKSO",
    latitude: "37.090617",
    longitude: "127.029594",
    altitude: "40",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2378",
    name: "Gimpo",
    city: "Seoul",
    country: "South Korea",
    iata: "GMP",
    icao: "RKSS",
    latitude: "37.558311",
    longitude: "126.790586",
    altitude: "58",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2379",
    name: "Suwon",
    city: "Suwon",
    country: "South Korea",
    iata: "",
    icao: "RKSW",
    latitude: "37.239406",
    longitude: "127.007053",
    altitude: "88",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2380",
    name: "Pohang",
    city: "Pohang",
    country: "South Korea",
    iata: "KPO",
    icao: "RKTH",
    latitude: "35.987858",
    longitude: "129.420486",
    altitude: "70",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2381",
    name: "Daegu Ab",
    city: "Taegu",
    country: "South Korea",
    iata: "TAE",
    icao: "RKTN",
    latitude: "35.894108",
    longitude: "128.658856",
    altitude: "116",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2383",
    name: "Yecheon",
    city: "Yechon",
    country: "South Korea",
    iata: "YEC",
    icao: "RKTY",
    latitude: "36.631933",
    longitude: "128.35485",
    altitude: "354",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "2384",
    name: "Naha",
    city: "Okinawa",
    country: "Japan",
    iata: "OKA",
    icao: "ROAH",
    latitude: "26.195814",
    longitude: "127.645869",
    altitude: "12",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "2385",
    name: "Ie Shima Aux Ab",
    city: "Iejima",
    country: "Japan",
    iata: "",
    icao: "RODE",
    latitude: "26.728775",
    longitude: "127.761775",
    altitude: "184",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2386",
    name: "Kadena Ab",
    city: "Kadena",
    country: "Japan",
    iata: "DNA",
    icao: "RODN",
    latitude: "26.355612",
    longitude: "127.767633",
    altitude: "143",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2387",
    name: "Ishigaki",
    city: "Ishigaki",
    country: "Japan",
    iata: "ISG",
    icao: "ROIG",
    latitude: "24.344525",
    longitude: "124.186983",
    altitude: "93",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2388",
    name: "Kumejima",
    city: "Kumejima",
    country: "Japan",
    iata: "UEO",
    icao: "ROKJ",
    latitude: "26.363506",
    longitude: "126.713806",
    altitude: "23",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2389",
    name: "Minami Daito",
    city: "Minami Daito",
    country: "Japan",
    iata: "MMD",
    icao: "ROMD",
    latitude: "25.846533",
    longitude: "131.263494",
    altitude: "167",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2390",
    name: "Miyako",
    city: "Miyako",
    country: "Japan",
    iata: "MMY",
    icao: "ROMY",
    latitude: "24.782833",
    longitude: "125.295111",
    altitude: "150",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2391",
    name: "Kitadaito",
    city: "Kitadaito",
    country: "Japan",
    iata: "KTD",
    icao: "RORK",
    latitude: "25.944722",
    longitude: "131.326944",
    altitude: "80",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2392",
    name: "Shimojishima",
    city: "Shimojishima",
    country: "Japan",
    iata: "SHI",
    icao: "RORS",
    latitude: "24.826667",
    longitude: "125.144722",
    altitude: "54",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2393",
    name: "Tarama",
    city: "Tarama",
    country: "Japan",
    iata: "",
    icao: "RORT",
    latitude: "24.653889",
    longitude: "124.675278",
    altitude: "36",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2394",
    name: "Yoron",
    city: "Yoron",
    country: "Japan",
    iata: "RNJ",
    icao: "RORY",
    latitude: "27.043964",
    longitude: "128.401517",
    altitude: "52",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2395",
    name: "Futenma Mcas",
    city: "Futema",
    country: "Japan",
    iata: "",
    icao: "ROTM",
    latitude: "26.274275",
    longitude: "127.756494",
    altitude: "247",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2396",
    name: "Yonaguni",
    city: "Yonaguni Jima",
    country: "Japan",
    iata: "OGN",
    icao: "ROYN",
    latitude: "24.466944",
    longitude: "122.977778",
    altitude: "70",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "2397",
    name: "Ninoy Aquino Intl",
    city: "Manila",
    country: "Philippines",
    iata: "MNL",
    icao: "RPLL",
    latitude: "14.508647",
    longitude: "121.019581",
    altitude: "75",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6859",
    name: "Mary Airport",
    city: "Mary",
    country: "Turkmenistan",
    iata: "MYP",
    icao: "UTAM",
    latitude: "37.6194",
    longitude: "61.8967",
    altitude: "728",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "2399",
    name: "Cotabato",
    city: "Cotabato",
    country: "Philippines",
    iata: "CBO",
    icao: "RPMC",
    latitude: "7.165242",
    longitude: "124.209619",
    altitude: "189",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2400",
    name: "Cagayan De Oro",
    city: "Ladag",
    country: "Philippines",
    iata: "CGY",
    icao: "RPML",
    latitude: "8.415619",
    longitude: "124.611219",
    altitude: "601",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2401",
    name: "Pagadian",
    city: "Pagadian",
    country: "Philippines",
    iata: "PAG",
    icao: "RPMP",
    latitude: "7.827197",
    longitude: "123.458294",
    altitude: "5",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2402",
    name: "Tambler",
    city: "Romblon",
    country: "Philippines",
    iata: "",
    icao: "RPMR",
    latitude: "6.058003",
    longitude: "125.096033",
    altitude: "505",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6858",
    name: "Crocodile Camp",
    city: "Tsavo East",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-3.070875",
    longitude: "39.2194305555556",
    altitude: "400",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "2404",
    name: "Zamboanga Intl",
    city: "Zamboanga",
    country: "Philippines",
    iata: "ZAM",
    icao: "RPMZ",
    latitude: "6.922419",
    longitude: "122.059633",
    altitude: "33",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2405",
    name: "Baguio",
    city: "Baguio",
    country: "Philippines",
    iata: "BAG",
    icao: "RPUB",
    latitude: "16.375103",
    longitude: "120.619636",
    altitude: "4251",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2406",
    name: "Daet",
    city: "Daet",
    country: "Philippines",
    iata: "",
    icao: "RPUD",
    latitude: "14.129167",
    longitude: "122.980181",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2407",
    name: "Basa Ab",
    city: "Floridablanca",
    country: "Philippines",
    iata: "",
    icao: "RPUF",
    latitude: "14.986527",
    longitude: "120.4925",
    altitude: "151",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2408",
    name: "Lingayen",
    city: "Lingayen",
    country: "Philippines",
    iata: "",
    icao: "RPUG",
    latitude: "16.034786",
    longitude: "120.241106",
    altitude: "7",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2409",
    name: "San Jose",
    city: "San Jose",
    country: "Philippines",
    iata: "",
    icao: "RPUH",
    latitude: "12.361517",
    longitude: "121.046639",
    altitude: "14",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2410",
    name: "Fernando Ab",
    city: "Lipa",
    country: "Philippines",
    iata: "",
    icao: "RPUL",
    latitude: "13.955017",
    longitude: "121.124925",
    altitude: "1220",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2411",
    name: "Mamburao",
    city: "Mamburao",
    country: "Philippines",
    iata: "",
    icao: "RPUM",
    latitude: "13.208092",
    longitude: "120.60535",
    altitude: "13",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2414",
    name: "Vigan",
    city: "Vigan",
    country: "Philippines",
    iata: "",
    icao: "RPUQ",
    latitude: "17.555331",
    longitude: "120.355797",
    altitude: "16",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2415",
    name: "Baler",
    city: "Baler",
    country: "Philippines",
    iata: "",
    icao: "RPUR",
    latitude: "15.729836",
    longitude: "121.500133",
    altitude: "108",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6857",
    name: "Kimana",
    city: "Kimana",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-2.8",
    longitude: "37.5333333333333",
    altitude: "3900",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "6856",
    name: "Solio Ranch Airport",
    city: "Solio",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-0.245167",
    longitude: "36.8849",
    altitude: "6300",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "6855",
    name: "Kalundborg Flyveplads",
    city: "Kalundborg",
    country: "Denmark",
    iata: "",
    icao: "EKKL",
    latitude: "55.7001",
    longitude: "11.2549",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "2421",
    name: "Bagabag",
    city: "Bagabag",
    country: "Philippines",
    iata: "",
    icao: "RPUZ",
    latitude: "16.619194",
    longitude: "121.252319",
    altitude: "820",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2422",
    name: "Daniel Z Romualdez",
    city: "Tacloban",
    country: "Philippines",
    iata: "TAC",
    icao: "RPVA",
    latitude: "11.227628",
    longitude: "125.027758",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2423",
    name: "Bacolod",
    city: "Bacolod",
    country: "Philippines",
    iata: "BCD",
    icao: "RPVB",
    latitude: "10.642511",
    longitude: "122.929617",
    altitude: "25",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6854",
    name: "Gardermoen Airport",
    city: "Oslo",
    country: "Norway",
    iata: "GEN",
    icao: "\\N",
    latitude: "60.1939",
    longitude: "11.1004",
    altitude: "681",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "2425",
    name: "Dumaguete",
    city: "Dumaguete",
    country: "Philippines",
    iata: "DGT",
    icao: "RPVD",
    latitude: "9.333714",
    longitude: "123.300472",
    altitude: "15",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2426",
    name: "Caticlan",
    city: "Caticlan",
    country: "Philippines",
    iata: "",
    icao: "RPVE",
    latitude: "11.924503",
    longitude: "121.95405",
    altitude: "7",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2428",
    name: "Guiuan",
    city: "Guiuan",
    country: "Philippines",
    iata: "",
    icao: "RPVG",
    latitude: "11.035544",
    longitude: "125.741594",
    altitude: "7",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2429",
    name: "Iloilo",
    city: "Iloilo",
    country: "Philippines",
    iata: "ILO",
    icao: "RPVI",
    latitude: "10.713044",
    longitude: "122.545297",
    altitude: "27",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2430",
    name: "Kalibo",
    city: "Kalibo",
    country: "Philippines",
    iata: "KLO",
    icao: "RPVK",
    latitude: "11.679431",
    longitude: "122.376294",
    altitude: "14",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2431",
    name: "Mactan Cebu Intl",
    city: "Masbate",
    country: "Philippines",
    iata: "",
    icao: "RPVM",
    latitude: "10.307542",
    longitude: "123.979439",
    altitude: "31",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6853",
    name: "Wausau Downtown Airport",
    city: "Wausau",
    country: "United States",
    iata: "AUW",
    icao: "\\N",
    latitude: "44.9262845",
    longitude: "-89.6270018",
    altitude: "1201",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "2433",
    name: "Puerto Princesa",
    city: "Puerto Princesa",
    country: "Philippines",
    iata: "PPS",
    icao: "RPVP",
    latitude: "9.742119",
    longitude: "118.758731",
    altitude: "71",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2435",
    name: "Antique",
    city: "San Jose",
    country: "Philippines",
    iata: "SJI",
    icao: "RPVS",
    latitude: "10.766044",
    longitude: "121.933439",
    altitude: "23",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "2436",
    name: "Comodoro Pierrestegui",
    city: "Concordia",
    country: "Argentina",
    iata: "COC",
    icao: "SAAC",
    latitude: "-31.296944",
    longitude: "-57.996631",
    altitude: "112",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2437",
    name: "Gualeguaychu",
    city: "Gualeguaychu",
    country: "Argentina",
    iata: "GHU",
    icao: "SAAG",
    latitude: "-33.010278",
    longitude: "-58.613056",
    altitude: "75",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2438",
    name: "Junin",
    city: "Junin",
    country: "Argentina",
    iata: "",
    icao: "SAAJ",
    latitude: "-34.545889",
    longitude: "-60.930556",
    altitude: "262",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2439",
    name: "General Urquiza",
    city: "Parana",
    country: "Argentina",
    iata: "PRA",
    icao: "SAAP",
    latitude: "-31.794778",
    longitude: "-60.480361",
    altitude: "243",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2440",
    name: "Rosario",
    city: "Rosario",
    country: "Argentina",
    iata: "ROS",
    icao: "SAAR",
    latitude: "-32.903611",
    longitude: "-60.785",
    altitude: "85",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2441",
    name: "Sauce Viejo",
    city: "Santa Fe",
    country: "Argentina",
    iata: "SFN",
    icao: "SAAV",
    latitude: "-31.711666",
    longitude: "-60.811668",
    altitude: "56",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2442",
    name: "Aeroparque Jorge Newbery",
    city: "Buenos Aires",
    country: "Argentina",
    iata: "AEP",
    icao: "SABE",
    latitude: "-34.559175",
    longitude: "-58.415606",
    altitude: "18",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2443",
    name: "Ambrosio L V Taravella",
    city: "Cordoba",
    country: "Argentina",
    iata: "COR",
    icao: "SACO",
    latitude: "-31.323619",
    longitude: "-64.207953",
    altitude: "1604",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2444",
    name: "Chamical",
    city: "Gobernador Gordillo",
    country: "Argentina",
    iata: "",
    icao: "SACT",
    latitude: "-30.345278",
    longitude: "-66.29361",
    altitude: "1503",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2445",
    name: "San Fernando",
    city: "San Fernando",
    country: "Argentina",
    iata: "",
    icao: "SADF",
    latitude: "-34.453189",
    longitude: "-58.589644",
    altitude: "10",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2446",
    name: "Mariano Moreno",
    city: "Jose C. Paz",
    country: "Argentina",
    iata: "",
    icao: "SADJ",
    latitude: "-34.56065",
    longitude: "-58.789564",
    altitude: "105",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2447",
    name: "La Plata",
    city: "La Plata",
    country: "Argentina",
    iata: "LPG",
    icao: "SADL",
    latitude: "-34.972222",
    longitude: "-57.894694",
    altitude: "72",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2448",
    name: "Moron",
    city: "Moron",
    country: "Argentina",
    iata: "",
    icao: "SADM",
    latitude: "-34.676317",
    longitude: "-58.642756",
    altitude: "95",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2449",
    name: "El Palomar",
    city: "El Palomar",
    country: "Argentina",
    iata: "",
    icao: "SADP",
    latitude: "-34.609939",
    longitude: "-58.612592",
    altitude: "59",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2450",
    name: "Chos Malal",
    city: "Chosmadal",
    country: "Argentina",
    iata: "",
    icao: "SAHC",
    latitude: "-37.444692",
    longitude: "-70.222469",
    altitude: "2788",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2451",
    name: "General Roca",
    city: "Fuerte Gral Roca",
    country: "Argentina",
    iata: "",
    icao: "SAHR",
    latitude: "-39.000672",
    longitude: "-67.620514",
    altitude: "853",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2452",
    name: "El Plumerillo",
    city: "Mendoza",
    country: "Argentina",
    iata: "MDZ",
    icao: "SAME",
    latitude: "-32.831717",
    longitude: "-68.792856",
    altitude: "2310",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2453",
    name: "Malargue",
    city: "Malargue",
    country: "Argentina",
    iata: "LGS",
    icao: "SAMM",
    latitude: "-35.493597",
    longitude: "-69.574267",
    altitude: "4683",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2454",
    name: "San Rafael",
    city: "San Rafael",
    country: "Argentina",
    iata: "AFA",
    icao: "SAMR",
    latitude: "-34.588314",
    longitude: "-68.403854",
    altitude: "2470",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2455",
    name: "Catamarca",
    city: "Catamarca",
    country: "Argentina",
    iata: "CTC",
    icao: "SANC",
    latitude: "-28.593214",
    longitude: "-65.750925",
    altitude: "1522",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2456",
    name: "Santiago Del Estero",
    city: "Santiago Del Estero",
    country: "Argentina",
    iata: "SDE",
    icao: "SANE",
    latitude: "-27.765617",
    longitude: "-64.310122",
    altitude: "656",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2457",
    name: "Tinogasta",
    city: "Tinogasta",
    country: "Argentina",
    iata: "",
    icao: "SANI",
    latitude: "-28.03775",
    longitude: "-67.580314",
    altitude: "3968",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2458",
    name: "La Rioja",
    city: "La Rioja",
    country: "Argentina",
    iata: "IRJ",
    icao: "SANL",
    latitude: "-29.381636",
    longitude: "-66.795839",
    altitude: "1436",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2459",
    name: "Chilecito",
    city: "Chilecito",
    country: "Argentina",
    iata: "",
    icao: "SANO",
    latitude: "-29.223888",
    longitude: "-67.438889",
    altitude: "3099",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2460",
    name: "Teniente Benjamin Matienzo",
    city: "Tucuman",
    country: "Argentina",
    iata: "TUC",
    icao: "SANT",
    latitude: "-26.840861",
    longitude: "-65.104944",
    altitude: "1495",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2461",
    name: "San Juan",
    city: "San Julian",
    country: "Argentina",
    iata: "UAQ",
    icao: "SANU",
    latitude: "-31.571472",
    longitude: "-68.418194",
    altitude: "1959",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2462",
    name: "Rio Cuarto Area De Material",
    city: "Rio Cuarto",
    country: "Argentina",
    iata: "RCU",
    icao: "SAOC",
    latitude: "-33.085128",
    longitude: "-64.261314",
    altitude: "1381",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2463",
    name: "Villa Dolores",
    city: "Villa Dolores",
    country: "Argentina",
    iata: "VDR",
    icao: "SAOD",
    latitude: "-31.945183",
    longitude: "-65.146283",
    altitude: "1915",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2464",
    name: "Laboulaye",
    city: "Laboulaye",
    country: "Argentina",
    iata: "",
    icao: "SAOL",
    latitude: "-34.135444",
    longitude: "-63.36225",
    altitude: "449",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2465",
    name: "Marcos Juarez",
    city: "Marcos Juarez",
    country: "Argentina",
    iata: "",
    icao: "SAOM",
    latitude: "-32.683639",
    longitude: "-62.157792",
    altitude: "361",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2466",
    name: "Villa Reynolds",
    city: "Villa Reynolds",
    country: "Argentina",
    iata: "",
    icao: "SAOR",
    latitude: "-33.725144",
    longitude: "-65.378086",
    altitude: "1591",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2467",
    name: "San Luis",
    city: "San Luis",
    country: "Argentina",
    iata: "LUQ",
    icao: "SAOU",
    latitude: "-33.273192",
    longitude: "-66.356422",
    altitude: "2329",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2468",
    name: "Corrientes",
    city: "Corrientes",
    country: "Argentina",
    iata: "CNQ",
    icao: "SARC",
    latitude: "-27.445503",
    longitude: "-58.761864",
    altitude: "203",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2469",
    name: "Resistencia",
    city: "Resistencia",
    country: "Argentina",
    iata: "RES",
    icao: "SARE",
    latitude: "-27.449986",
    longitude: "-59.056125",
    altitude: "173",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2470",
    name: "Formosa",
    city: "Formosa",
    country: "Argentina",
    iata: "FMA",
    icao: "SARF",
    latitude: "-26.212722",
    longitude: "-58.228111",
    altitude: "194",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2471",
    name: "Cataratas Del Iguazu",
    city: "Iguazu Falls",
    country: "Argentina",
    iata: "IGR",
    icao: "SARI",
    latitude: "-25.737281",
    longitude: "-54.473444",
    altitude: "916",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2472",
    name: "Paso De Los Libres",
    city: "Paso De Los Libres",
    country: "Argentina",
    iata: "AOL",
    icao: "SARL",
    latitude: "-29.689425",
    longitude: "-57.152078",
    altitude: "230",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2473",
    name: "Monte Caseros",
    city: "Monte Caseros",
    country: "Argentina",
    iata: "",
    icao: "SARM",
    latitude: "-30.271922",
    longitude: "-57.640231",
    altitude: "174",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2474",
    name: "Posadas",
    city: "Posadas",
    country: "Argentina",
    iata: "PSS",
    icao: "SARP",
    latitude: "-27.385839",
    longitude: "-55.970728",
    altitude: "430",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2475",
    name: "Termal",
    city: "Presidencia R.s.pena",
    country: "Argentina",
    iata: "",
    icao: "SARS",
    latitude: "-26.756519",
    longitude: "-60.493103",
    altitude: "307",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2476",
    name: "Salta",
    city: "Salta",
    country: "Argentina",
    iata: "SLA",
    icao: "SASA",
    latitude: "-24.855978",
    longitude: "-65.486169",
    altitude: "4088",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2477",
    name: "Jujuy",
    city: "Jujuy",
    country: "Argentina",
    iata: "JUJ",
    icao: "SASJ",
    latitude: "-24.392778",
    longitude: "-65.097778",
    altitude: "3019",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2478",
    name: "Oran",
    city: "Oran",
    country: "Argentina",
    iata: "ORA",
    icao: "SASO",
    latitude: "-23.152779",
    longitude: "-64.32917",
    altitude: "1168",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2479",
    name: "La Quiaca",
    city: "La Quiaca",
    country: "Argentina",
    iata: "",
    icao: "SASQ",
    latitude: "-22.150556",
    longitude: "-65.5775",
    altitude: "11414",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6852",
    name: "Portage Municipal Airport",
    city: "Portage",
    country: "United States",
    iata: "C47",
    icao: "\\N",
    latitude: "43.5603136",
    longitude: "-89.4828607",
    altitude: "825",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "2481",
    name: "Eldorado",
    city: "El Dorado",
    country: "Argentina",
    iata: "",
    icao: "SATD",
    latitude: "-26.397499",
    longitude: "-54.574722",
    altitude: "685",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2482",
    name: "Goya",
    city: "Goya",
    country: "Argentina",
    iata: "",
    icao: "SATG",
    latitude: "-29.099472",
    longitude: "-59.250583",
    altitude: "125",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2483",
    name: "Obera",
    city: "Obera",
    country: "Argentina",
    iata: "",
    icao: "SATO",
    latitude: "-27.518156",
    longitude: "-55.124156",
    altitude: "1125",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2484",
    name: "Reconquista",
    city: "Reconquista",
    country: "Argentina",
    iata: "",
    icao: "SATR",
    latitude: "-29.210278",
    longitude: "-59.68",
    altitude: "161",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2485",
    name: "Curuzu Cuatia",
    city: "Curuzu Cuatia",
    country: "Argentina",
    iata: "",
    icao: "SATU",
    latitude: "-29.770555",
    longitude: "-57.978889",
    altitude: "229",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2486",
    name: "El Bolson",
    city: "El Bolson",
    country: "Argentina",
    iata: "EHL",
    icao: "SAVB",
    latitude: "-41.943189",
    longitude: "-71.532289",
    altitude: "1131",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2487",
    name: "Comodoro Rivadavia",
    city: "Comodoro Rivadavia",
    country: "Argentina",
    iata: "CRD",
    icao: "SAVC",
    latitude: "-45.785347",
    longitude: "-67.465508",
    altitude: "190",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2488",
    name: "Esquel",
    city: "Esquel",
    country: "Argentina",
    iata: "EQS",
    icao: "SAVE",
    latitude: "-42.90795",
    longitude: "-71.139472",
    altitude: "2621",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2490",
    name: "Almirante Zar",
    city: "Trelew",
    country: "Argentina",
    iata: "REL",
    icao: "SAVT",
    latitude: "-43.2105",
    longitude: "-65.270319",
    altitude: "141",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2491",
    name: "Gobernador Castello",
    city: "Viedma",
    country: "Argentina",
    iata: "VDM",
    icao: "SAVV",
    latitude: "-40.869222",
    longitude: "-63.000389",
    altitude: "20",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2492",
    name: "El Tehuelche",
    city: "Puerto Madryn",
    country: "Argentina",
    iata: "PMY",
    icao: "SAVY",
    latitude: "-42.759161",
    longitude: "-65.102725",
    altitude: "426",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2493",
    name: "Base Marambio",
    city: "Marambio Base",
    country: "Antarctica",
    iata: "",
    icao: "SAWB",
    latitude: "-64.238335",
    longitude: "-56.630833",
    altitude: "760",
    timezone: "12",
    dst: "U",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "2494",
    name: "Puerto Deseado",
    city: "Puerto Deseado",
    country: "Argentina",
    iata: "PUD",
    icao: "SAWD",
    latitude: "-47.735292",
    longitude: "-65.904097",
    altitude: "266",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2495",
    name: "Rio Grande",
    city: "Rio Grande",
    country: "Argentina",
    iata: "RGA",
    icao: "SAWE",
    latitude: "-53.777667",
    longitude: "-67.749389",
    altitude: "65",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2496",
    name: "Rio Gallegos",
    city: "Rio Gallegos",
    country: "Argentina",
    iata: "RGL",
    icao: "SAWG",
    latitude: "-51.608875",
    longitude: "-69.312636",
    altitude: "61",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2497",
    name: "Ushuaia Malvinas Argentinas",
    city: "Ushuaia",
    country: "Argentina",
    iata: "USH",
    icao: "SAWH",
    latitude: "-54.843278",
    longitude: "-68.29575",
    altitude: "71",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2498",
    name: "San Julian",
    city: "San Julian",
    country: "Argentina",
    iata: "ULA",
    icao: "SAWJ",
    latitude: "-49.306775",
    longitude: "-67.802589",
    altitude: "190",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2499",
    name: "Perito Moreno",
    city: "Perito Moreno",
    country: "Argentina",
    iata: "PMQ",
    icao: "SAWP",
    latitude: "-46.537911",
    longitude: "-70.978689",
    altitude: "1410",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2500",
    name: "Santa Cruz",
    city: "Santa Cruz",
    country: "Argentina",
    iata: "RZA",
    icao: "SAWU",
    latitude: "-50.01655",
    longitude: "-68.579197",
    altitude: "364",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2501",
    name: "Comandante Espora",
    city: "Bahia Blanca",
    country: "Argentina",
    iata: "BHI",
    icao: "SAZB",
    latitude: "-38.724967",
    longitude: "-62.169317",
    altitude: "246",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2502",
    name: "Coronel Suarez",
    city: "Colonel Suarez",
    country: "Argentina",
    iata: "",
    icao: "SAZC",
    latitude: "-37.446111",
    longitude: "-61.889297",
    altitude: "768",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2503",
    name: "Olavarria",
    city: "Olavarria",
    country: "Argentina",
    iata: "",
    icao: "SAZF",
    latitude: "-36.890039",
    longitude: "-60.216619",
    altitude: "551",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2504",
    name: "General Pico",
    city: "General Pico",
    country: "Argentina",
    iata: "",
    icao: "SAZG",
    latitude: "-35.696183",
    longitude: "-63.758286",
    altitude: "459",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2505",
    name: "Tres Arroyos",
    city: "Tres Arroyos",
    country: "Argentina",
    iata: "",
    icao: "SAZH",
    latitude: "-38.386911",
    longitude: "-60.329711",
    altitude: "400",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2506",
    name: "Bolivar",
    city: "Bolivar",
    country: "Argentina",
    iata: "",
    icao: "SAZI",
    latitude: "-36.186594",
    longitude: "-61.076367",
    altitude: "308",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6851",
    name: "Gogebic Iron County Airport",
    city: "Ironwood",
    country: "United States",
    iata: "IWD",
    icao: "\\N",
    latitude: "46.5274747",
    longitude: "-90.1313967",
    altitude: "1230",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "2508",
    name: "Mar Del Plata",
    city: "Mar Del Plata",
    country: "Argentina",
    iata: "MDQ",
    icao: "SAZM",
    latitude: "-37.934167",
    longitude: "-57.573333",
    altitude: "71",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2509",
    name: "Presidente Peron",
    city: "Neuquen",
    country: "Argentina",
    iata: "NQN",
    icao: "SAZN",
    latitude: "-38.949",
    longitude: "-68.155711",
    altitude: "895",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6850",
    name: "Mackinac Island Airport",
    city: "Mackinac Island",
    country: "United States",
    iata: "MCD",
    icao: "\\N",
    latitude: "45.8649344",
    longitude: "-84.637344",
    altitude: "740",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "2511",
    name: "Comodoro P Zanni",
    city: "Pehuajo",
    country: "Argentina",
    iata: "",
    icao: "SAZP",
    latitude: "-35.844592",
    longitude: "-61.857553",
    altitude: "278",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2512",
    name: "Santa Rosa",
    city: "Santa Rosa",
    country: "Argentina",
    iata: "RSA",
    icao: "SAZR",
    latitude: "-36.588322",
    longitude: "-64.275694",
    altitude: "630",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2513",
    name: "San Carlos De Bariloche",
    city: "San Carlos De Bariloche",
    country: "Argentina",
    iata: "BRC",
    icao: "SAZS",
    latitude: "-41.151172",
    longitude: "-71.157542",
    altitude: "2776",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2514",
    name: "Tandil",
    city: "Tandil",
    country: "Argentina",
    iata: "TDL",
    icao: "SAZT",
    latitude: "-37.237392",
    longitude: "-59.227922",
    altitude: "574",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2515",
    name: "Villa Gesell",
    city: "Villa Gesell",
    country: "Argentina",
    iata: "VLG",
    icao: "SAZV",
    latitude: "-37.235408",
    longitude: "-57.029239",
    altitude: "32",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2516",
    name: "Cutralco",
    city: "Cutralco",
    country: "Argentina",
    iata: "",
    icao: "SAZW",
    latitude: "-38.939683",
    longitude: "-69.264642",
    altitude: "2133",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2517",
    name: "Aviador C Campos",
    city: "San Martin Des Andes",
    country: "Argentina",
    iata: "CPC",
    icao: "SAZY",
    latitude: "-40.075383",
    longitude: "-71.137294",
    altitude: "2569",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "2518",
    name: "Conceicao Do Araguaia",
    city: "Conceicao Do Araguaia",
    country: "Brazil",
    iata: "CDJ",
    icao: "SBAA",
    latitude: "-8.348347",
    longitude: "-49.301528",
    altitude: "653",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2519",
    name: "Campo Delio Jardim De Mattos",
    city: "Rio De Janeiro",
    country: "Brazil",
    iata: "",
    icao: "SBAF",
    latitude: "-22.875083",
    longitude: "-43.384708",
    altitude: "110",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2520",
    name: "Amapa",
    city: "Amapa",
    country: "Brazil",
    iata: "",
    icao: "SBAM",
    latitude: "2.077511",
    longitude: "-50.858236",
    altitude: "45",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2521",
    name: "Araraquara",
    city: "Araracuara",
    country: "Brazil",
    iata: "AQA",
    icao: "SBAQ",
    latitude: "-21.812",
    longitude: "-48.133028",
    altitude: "2334",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2522",
    name: "Santa Maria",
    city: "Aracaju",
    country: "Brazil",
    iata: "AJU",
    icao: "SBAR",
    latitude: "-10.984",
    longitude: "-37.070333",
    altitude: "23",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2523",
    name: "Assis",
    city: "Assis",
    country: "Brazil",
    iata: "",
    icao: "SBAS",
    latitude: "-22.638564",
    longitude: "-50.455914",
    altitude: "1850",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2524",
    name: "Alta Floresta",
    city: "Alta Floresta",
    country: "Brazil",
    iata: "AFL",
    icao: "SBAT",
    latitude: "-9.866092",
    longitude: "-56.106206",
    altitude: "947",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "2525",
    name: "Aracatuba",
    city: "Aracatuba",
    country: "Brazil",
    iata: "ARU",
    icao: "SBAU",
    latitude: "-21.141342",
    longitude: "-50.424722",
    altitude: "1361",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2526",
    name: "Val De Cans Intl",
    city: "Belem",
    country: "Brazil",
    iata: "BEL",
    icao: "SBBE",
    latitude: "-1.37925",
    longitude: "-48.476292",
    altitude: "54",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2527",
    name: "Comandante Gustavo Kraemer",
    city: "Bage",
    country: "Brazil",
    iata: "BGX",
    icao: "SBBG",
    latitude: "-31.390528",
    longitude: "-54.112244",
    altitude: "600",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2528",
    name: "Pampulha Carlos Drummond De Andrade",
    city: "Belo Horizonte",
    country: "Brazil",
    iata: "PLU",
    icao: "SBBH",
    latitude: "-19.851181",
    longitude: "-43.950628",
    altitude: "2589",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2529",
    name: "Bacacheri",
    city: "Curitiba",
    country: "Brazil",
    iata: "BFH",
    icao: "SBBI",
    latitude: "-25.405078",
    longitude: "-49.232036",
    altitude: "3057",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2530",
    name: "Major Brigadeiro Doorgal Borges",
    city: "Barbacena",
    country: "Brazil",
    iata: "",
    icao: "SBBQ",
    latitude: "-21.267167",
    longitude: "-43.761056",
    altitude: "3657",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2531",
    name: "Presidente Juscelino Kubitschek",
    city: "Brasilia",
    country: "Brazil",
    iata: "BSB",
    icao: "SBBR",
    latitude: "-15.8711",
    longitude: "-47.918625",
    altitude: "3479",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2532",
    name: "Bauru",
    city: "Bauru",
    country: "Brazil",
    iata: "BAU",
    icao: "SBBU",
    latitude: "-22.345042",
    longitude: "-49.0538",
    altitude: "2025",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2533",
    name: "Boa Vista",
    city: "Boa Vista",
    country: "Brazil",
    iata: "BVB",
    icao: "SBBV",
    latitude: "2.846311",
    longitude: "-60.690069",
    altitude: "276",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2534",
    name: "Barra Do Garcas",
    city: "Barra Do Garcas",
    country: "Brazil",
    iata: "",
    icao: "SBBW",
    latitude: "-15.861344",
    longitude: "-52.388894",
    altitude: "1147",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "2535",
    name: "Cascavel",
    city: "Cascavel",
    country: "Brazil",
    iata: "CAC",
    icao: "SBCA",
    latitude: "-25.000339",
    longitude: "-53.500764",
    altitude: "2473",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2536",
    name: "Cachimbo",
    city: "Itaituba",
    country: "Brazil",
    iata: "",
    icao: "SBCC",
    latitude: "-9.333936",
    longitude: "-54.965422",
    altitude: "1762",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2537",
    name: "Tancredo Neves Intl",
    city: "Belo Horizonte",
    country: "Brazil",
    iata: "CNF",
    icao: "SBCF",
    latitude: "-19.63375",
    longitude: "-43.968856",
    altitude: "2715",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2538",
    name: "Campo Grande",
    city: "Campo Grande",
    country: "Brazil",
    iata: "CGR",
    icao: "SBCG",
    latitude: "-20.468667",
    longitude: "-54.6725",
    altitude: "1833",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "2539",
    name: "Chapeco",
    city: "Chapeco",
    country: "Brazil",
    iata: "XAP",
    icao: "SBCH",
    latitude: "-27.134219",
    longitude: "-52.656553",
    altitude: "2146",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2540",
    name: "Carolina",
    city: "Carolina",
    country: "Brazil",
    iata: "CLN",
    icao: "SBCI",
    latitude: "-7.320444",
    longitude: "-47.458667",
    altitude: "565",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2541",
    name: "Forquilhinha",
    city: "Criciuma",
    country: "Brazil",
    iata: "CCM",
    icao: "SBCM",
    latitude: "-28.725817",
    longitude: "-49.424739",
    altitude: "93",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2542",
    name: "Canoas",
    city: "Porto Alegre",
    country: "Brazil",
    iata: "",
    icao: "SBCO",
    latitude: "-29.945944",
    longitude: "-51.144367",
    altitude: "26",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2543",
    name: "Bartolomeu Lisandro",
    city: "Campos",
    country: "Brazil",
    iata: "CAW",
    icao: "SBCP",
    latitude: "-21.698333",
    longitude: "-41.301669",
    altitude: "57",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2544",
    name: "Corumba Intl",
    city: "Corumba",
    country: "Brazil",
    iata: "CMG",
    icao: "SBCR",
    latitude: "-19.011931",
    longitude: "-57.673053",
    altitude: "461",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "2545",
    name: "Afonso Pena",
    city: "Curitiba",
    country: "Brazil",
    iata: "CWB",
    icao: "SBCT",
    latitude: "-25.528475",
    longitude: "-49.175775",
    altitude: "2988",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2546",
    name: "Caravelas",
    city: "Caravelas",
    country: "Brazil",
    iata: "CRQ",
    icao: "SBCV",
    latitude: "-17.652283",
    longitude: "-39.253069",
    altitude: "36",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2547",
    name: "Campo Dos Bugres",
    city: "Caxias Do Sul",
    country: "Brazil",
    iata: "CXJ",
    icao: "SBCX",
    latitude: "-29.197064",
    longitude: "-51.187536",
    altitude: "2472",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2548",
    name: "Marechal Rondon",
    city: "Cuiaba",
    country: "Brazil",
    iata: "CGB",
    icao: "SBCY",
    latitude: "-15.652931",
    longitude: "-56.116719",
    altitude: "617",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "2549",
    name: "Cruzeiro do Sul",
    city: "Cruzeiro do Sul",
    country: "Brazil",
    iata: "CZS",
    icao: "SBCZ",
    latitude: "-7.599906",
    longitude: "-72.769489",
    altitude: "637",
    timezone: "-5",
    dst: "S",
    tz: "America/Rio_Branco",
  },
  {
    id: "2550",
    name: "Presidente Prudente",
    city: "President Prudente",
    country: "Brazil",
    iata: "PPB",
    icao: "SBDN",
    latitude: "-22.175056",
    longitude: "-51.424639",
    altitude: "1477",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2551",
    name: "Eduardo Gomes Intl",
    city: "Manaus",
    country: "Brazil",
    iata: "MAO",
    icao: "SBEG",
    latitude: "-3.038611",
    longitude: "-60.049721",
    altitude: "264",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2552",
    name: "Jacareacanga",
    city: "Jacare-acanga",
    country: "Brazil",
    iata: "",
    icao: "SBEK",
    latitude: "-6.233156",
    longitude: "-57.776869",
    altitude: "324",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2553",
    name: "Sao Pedro Da Aldeia",
    city: "Sao Pedro Da Aldeia",
    country: "Brazil",
    iata: "",
    icao: "SBES",
    latitude: "-22.812872",
    longitude: "-42.092633",
    altitude: "61",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2554",
    name: "Cataratas Intl",
    city: "Foz Do Iguacu",
    country: "Brazil",
    iata: "IGU",
    icao: "SBFI",
    latitude: "-25.59615",
    longitude: "-54.487206",
    altitude: "787",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2555",
    name: "Hercilio Luz",
    city: "Florianopolis",
    country: "Brazil",
    iata: "FLN",
    icao: "SBFL",
    latitude: "-27.670489",
    longitude: "-48.547181",
    altitude: "20",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2556",
    name: "Fernando De Noronha",
    city: "Fernando Do Noronha",
    country: "Brazil",
    iata: "FEN",
    icao: "SBFN",
    latitude: "-3.854928",
    longitude: "-32.423336",
    altitude: "193",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2557",
    name: "Fronteira",
    city: "Fronteira",
    country: "Brazil",
    iata: "",
    icao: "SBFT",
    latitude: "-20.278483",
    longitude: "-49.187472",
    altitude: "1599",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2558",
    name: "Furnas",
    city: "Alpinopolis",
    country: "Brazil",
    iata: "",
    icao: "SBFU",
    latitude: "-20.702817",
    longitude: "-46.335264",
    altitude: "2413",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2559",
    name: "Pinto Martins Intl",
    city: "Fortaleza",
    country: "Brazil",
    iata: "FOR",
    icao: "SBFZ",
    latitude: "-3.776283",
    longitude: "-38.532556",
    altitude: "82",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2560",
    name: "Galeao Antonio Carlos Jobim",
    city: "Rio De Janeiro",
    country: "Brazil",
    iata: "GIG",
    icao: "SBGL",
    latitude: "-22.808903",
    longitude: "-43.243647",
    altitude: "28",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2561",
    name: "Guajara Mirim",
    city: "Guajara-mirim",
    country: "Brazil",
    iata: "",
    icao: "SBGM",
    latitude: "-10.786375",
    longitude: "-65.284792",
    altitude: "478",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2562",
    name: "Santa Genoveva",
    city: "Goiania",
    country: "Brazil",
    iata: "GYN",
    icao: "SBGO",
    latitude: "-16.632033",
    longitude: "-49.220686",
    altitude: "2450",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2563",
    name: "Embraer Unidade Gaviao Peixoto",
    city: "Macae",
    country: "Brazil",
    iata: "",
    icao: "SBGP",
    latitude: "-21.773683",
    longitude: "-48.405078",
    altitude: "1998",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2564",
    name: "Guarulhos Gov Andre Franco Montouro",
    city: "Sao Paulo",
    country: "Brazil",
    iata: "GRU",
    icao: "SBGR",
    latitude: "-23.432075",
    longitude: "-46.469511",
    altitude: "2459",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2565",
    name: "Guaratingueta",
    city: "Guaratingueta",
    country: "Brazil",
    iata: "",
    icao: "SBGW",
    latitude: "-22.791608",
    longitude: "-45.204778",
    altitude: "1761",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2566",
    name: "Altamira",
    city: "Altamira",
    country: "Brazil",
    iata: "ATM",
    icao: "SBHT",
    latitude: "-3.253906",
    longitude: "-52.253978",
    altitude: "368",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2567",
    name: "Itacoatiara",
    city: "Itaituba",
    country: "Brazil",
    iata: "",
    icao: "SBIC",
    latitude: "-3.127256",
    longitude: "-58.481186",
    altitude: "142",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2568",
    name: "Itaituba",
    city: "Itaituba",
    country: "Brazil",
    iata: "",
    icao: "SBIH",
    latitude: "-4.242342",
    longitude: "-56.000669",
    altitude: "110",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2569",
    name: "Ilheus",
    city: "Ilheus",
    country: "Brazil",
    iata: "IOS",
    icao: "SBIL",
    latitude: "-14.815964",
    longitude: "-39.033197",
    altitude: "15",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2570",
    name: "Usiminas",
    city: "Ipatinga",
    country: "Brazil",
    iata: "IPN",
    icao: "SBIP",
    latitude: "-19.470722",
    longitude: "-42.487583",
    altitude: "784",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2571",
    name: "Hidroeletrica",
    city: "Itumbiara",
    country: "Brazil",
    iata: "",
    icao: "SBIT",
    latitude: "-18.444661",
    longitude: "-49.213361",
    altitude: "1630",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2572",
    name: "Prefeito Renato Moreira",
    city: "Imperatriz",
    country: "Brazil",
    iata: "IMP",
    icao: "SBIZ",
    latitude: "-5.531292",
    longitude: "-47.46005",
    altitude: "431",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2573",
    name: "Julio Cesar",
    city: "Belem",
    country: "Brazil",
    iata: "",
    icao: "SBJC",
    latitude: "-1.414158",
    longitude: "-48.460739",
    altitude: "52",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2574",
    name: "Francisco De Assis",
    city: "Juiz De Fora",
    country: "Brazil",
    iata: "JDF",
    icao: "SBJF",
    latitude: "-21.7915",
    longitude: "-43.386778",
    altitude: "2989",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2575",
    name: "Presidente Castro Pinto",
    city: "Joao Pessoa",
    country: "Brazil",
    iata: "JPA",
    icao: "SBJP",
    latitude: "-7.148381",
    longitude: "-34.950681",
    altitude: "215",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2576",
    name: "Lauro Carneiro De Loyola",
    city: "Joinville",
    country: "Brazil",
    iata: "JOI",
    icao: "SBJV",
    latitude: "-26.224453",
    longitude: "-48.797364",
    altitude: "15",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2577",
    name: "Presidente Joao Suassuna",
    city: "Campina Grande",
    country: "Brazil",
    iata: "CPV",
    icao: "SBKG",
    latitude: "-7.269917",
    longitude: "-35.896364",
    altitude: "1646",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2578",
    name: "Viracopos",
    city: "Campinas",
    country: "Brazil",
    iata: "VCP",
    icao: "SBKP",
    latitude: "-23.0075",
    longitude: "-47.134444",
    altitude: "2170",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2579",
    name: "Lages",
    city: "Lajes",
    country: "Brazil",
    iata: "",
    icao: "SBLJ",
    latitude: "-27.782142",
    longitude: "-50.281486",
    altitude: "3065",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2580",
    name: "Lins",
    city: "Lins",
    country: "Brazil",
    iata: "LIP",
    icao: "SBLN",
    latitude: "-21.664039",
    longitude: "-49.730519",
    altitude: "1575",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2581",
    name: "Londrina",
    city: "Londrina",
    country: "Brazil",
    iata: "LDB",
    icao: "SBLO",
    latitude: "-23.333625",
    longitude: "-51.130072",
    altitude: "1867",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2582",
    name: "Bom Jesus Da Lapa",
    city: "Bom Jesus Da Lapa",
    country: "Brazil",
    iata: "LAZ",
    icao: "SBLP",
    latitude: "-13.262086",
    longitude: "-43.408114",
    altitude: "1454",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2583",
    name: "Lagoa Santa",
    city: "Lagoa Santa",
    country: "Brazil",
    iata: "",
    icao: "SBLS",
    latitude: "-19.661611",
    longitude: "-43.896403",
    altitude: "2795",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2584",
    name: "Maraba",
    city: "Maraba",
    country: "Brazil",
    iata: "MAB",
    icao: "SBMA",
    latitude: "-5.368589",
    longitude: "-49.138025",
    altitude: "357",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2585",
    name: "Monte Dourado",
    city: "Almeirim",
    country: "Brazil",
    iata: "",
    icao: "SBMD",
    latitude: "-0.889839",
    longitude: "-52.60225",
    altitude: "677",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2586",
    name: "Regional De Maringa Silvio Name Junior",
    city: "Maringa",
    country: "Brazil",
    iata: "MGF",
    icao: "SBMG",
    latitude: "-23.476392",
    longitude: "-52.016406",
    altitude: "1788",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2587",
    name: "Mario Ribeiro",
    city: "Montes Claros",
    country: "Brazil",
    iata: "MOC",
    icao: "SBMK",
    latitude: "-16.706925",
    longitude: "-43.8189",
    altitude: "2191",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6849",
    name: "Grand Marais Cook County Airport",
    city: "Grand Marais",
    country: "United States",
    iata: "GRM",
    icao: "KCKC",
    latitude: "47.8383333",
    longitude: "-90.3829444",
    altitude: "1799",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "2589",
    name: "Ponta Pelada",
    city: "Manaus",
    country: "Brazil",
    iata: "",
    icao: "SBMN",
    latitude: "-3.146042",
    longitude: "-59.9863",
    altitude: "267",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2590",
    name: "Zumbi Dos Palmares",
    city: "Maceio",
    country: "Brazil",
    iata: "MCZ",
    icao: "SBMO",
    latitude: "-9.510808",
    longitude: "-35.791678",
    altitude: "387",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2591",
    name: "Macapa",
    city: "Macapa",
    country: "Brazil",
    iata: "MCP",
    icao: "SBMQ",
    latitude: "0.050664",
    longitude: "-51.072178",
    altitude: "56",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2592",
    name: "Dix Sept Rosado",
    city: "Mocord",
    country: "Brazil",
    iata: "",
    icao: "SBMS",
    latitude: "-5.201919",
    longitude: "-37.364347",
    altitude: "77",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2593",
    name: "Marte",
    city: "Sao Paulo",
    country: "Brazil",
    iata: "",
    icao: "SBMT",
    latitude: "-23.509119",
    longitude: "-46.637753",
    altitude: "2368",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2594",
    name: "Manicore",
    city: "Manicore",
    country: "Brazil",
    iata: "MNX",
    icao: "SBMY",
    latitude: "-5.811381",
    longitude: "-61.278319",
    altitude: "174",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2595",
    name: "Ministro Victor Konder Intl",
    city: "Navegantes",
    country: "Brazil",
    iata: "NVT",
    icao: "SBNF",
    latitude: "-26.879999",
    longitude: "-48.65139",
    altitude: "18",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2596",
    name: "Santo Angelo",
    city: "Santo Angelo",
    country: "Brazil",
    iata: "GEL",
    icao: "SBNM",
    latitude: "-28.281683",
    longitude: "-54.169139",
    altitude: "1056",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2597",
    name: "Augusto Severo",
    city: "Natal",
    country: "Brazil",
    iata: "NAT",
    icao: "SBNT",
    latitude: "-5.911417",
    longitude: "-35.247717",
    altitude: "169",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2598",
    name: "Oiapoque",
    city: "Oioiapoque",
    country: "Brazil",
    iata: "",
    icao: "SBOI",
    latitude: "3.855486",
    longitude: "-51.796867",
    altitude: "63",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2599",
    name: "Salgado Filho",
    city: "Porto Alegre",
    country: "Brazil",
    iata: "POA",
    icao: "SBPA",
    latitude: "-29.994428",
    longitude: "-51.171428",
    altitude: "11",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2600",
    name: "Prefeito Doutor Joao Silva Filho",
    city: "Parnaiba",
    country: "Brazil",
    iata: "",
    icao: "SBPB",
    latitude: "-2.893747",
    longitude: "-41.731961",
    altitude: "16",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2601",
    name: "Pocos De Caldas",
    city: "Pocos De Caldas",
    country: "Brazil",
    iata: "POO",
    icao: "SBPC",
    latitude: "-21.843014",
    longitude: "-46.567917",
    altitude: "4135",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2602",
    name: "Lauro Kurtz",
    city: "Passo Fundo",
    country: "Brazil",
    iata: "PFB",
    icao: "SBPF",
    latitude: "-28.243989",
    longitude: "-52.326558",
    altitude: "2376",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2603",
    name: "Pelotas",
    city: "Pelotas",
    country: "Brazil",
    iata: "PET",
    icao: "SBPK",
    latitude: "-31.718353",
    longitude: "-52.327689",
    altitude: "59",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2604",
    name: "Senador Nilo Coelho",
    city: "Petrolina",
    country: "Brazil",
    iata: "PNZ",
    icao: "SBPL",
    latitude: "-9.362411",
    longitude: "-40.569097",
    altitude: "1263",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2605",
    name: "Porto Nacional",
    city: "Porto Nacional",
    country: "Brazil",
    iata: "PNB",
    icao: "SBPN",
    latitude: "-10.719417",
    longitude: "-48.399736",
    altitude: "870",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2606",
    name: "Ponta Pora",
    city: "Ponta Pora",
    country: "Brazil",
    iata: "PMG",
    icao: "SBPP",
    latitude: "-22.549639",
    longitude: "-55.702614",
    altitude: "2156",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "2607",
    name: "Governador Jorge Teixeira De Oliveira",
    city: "Porto Velho",
    country: "Brazil",
    iata: "PVH",
    icao: "SBPV",
    latitude: "-8.709294",
    longitude: "-63.902281",
    altitude: "294",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "6848",
    name: "Porter County Municipal Airport",
    city: "Valparaiso",
    country: "United States",
    iata: "NPZ",
    icao: "\\N",
    latitude: "41.4539722",
    longitude: "-87.0070833",
    altitude: "770",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "2609",
    name: "PlÃ¡cido de Castro",
    city: "Rio Branco",
    country: "Brazil",
    iata: "RBR",
    icao: "SBRB",
    latitude: "-9.583",
    longitude: "-67.4836",
    altitude: "633",
    timezone: "-5",
    dst: "S",
    tz: "America/Rio_Branco",
  },
  {
    id: "2610",
    name: "Guararapes Gilberto Freyre Intl",
    city: "Recife",
    country: "Brazil",
    iata: "REC",
    icao: "SBRF",
    latitude: "-8.126794",
    longitude: "-34.923039",
    altitude: "33",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2611",
    name: "Rio Grande",
    city: "Rio Grande",
    country: "Brazil",
    iata: "RIG",
    icao: "SBRG",
    latitude: "-32.082617",
    longitude: "-52.166542",
    altitude: "27",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2612",
    name: "Santos Dumont",
    city: "Rio De Janeiro",
    country: "Brazil",
    iata: "SDU",
    icao: "SBRJ",
    latitude: "-22.910461",
    longitude: "-43.163133",
    altitude: "11",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2613",
    name: "Leite Lopes",
    city: "Ribeirao Preto",
    country: "Brazil",
    iata: "RAO",
    icao: "SBRP",
    latitude: "-21.134167",
    longitude: "-47.774189",
    altitude: "1802",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2614",
    name: "Santa Cruz",
    city: "Rio De Janeiro",
    country: "Brazil",
    iata: "STU",
    icao: "SBSC",
    latitude: "-22.93235",
    longitude: "-43.719092",
    altitude: "10",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2615",
    name: "Professor Urbano Ernesto Stumpf",
    city: "Sao Jose Dos Campos",
    country: "Brazil",
    iata: "SJK",
    icao: "SBSJ",
    latitude: "-23.228172",
    longitude: "-45.862739",
    altitude: "2120",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2616",
    name: "Marechal Cunha Machado Intl",
    city: "Sao Luis",
    country: "Brazil",
    iata: "SLZ",
    icao: "SBSL",
    latitude: "-2.585361",
    longitude: "-44.234139",
    altitude: "178",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2618",
    name: "Congonhas",
    city: "Sao Paulo",
    country: "Brazil",
    iata: "CGH",
    icao: "SBSP",
    latitude: "-23.626692",
    longitude: "-46.655375",
    altitude: "2631",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2619",
    name: "Sao Jose Do Rio Preto",
    city: "Sao Jose Do Rio Preto",
    country: "Brazil",
    iata: "SJP",
    icao: "SBSR",
    latitude: "-20.816567",
    longitude: "-49.406511",
    altitude: "1784",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2620",
    name: "Base Aerea De Santos",
    city: "Santos",
    country: "Brazil",
    iata: "SSZ",
    icao: "SBST",
    latitude: "-23.925206",
    longitude: "-46.2875",
    altitude: "10",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2621",
    name: "Deputado Luis Eduardo Magalhaes",
    city: "Salvador",
    country: "Brazil",
    iata: "SSA",
    icao: "SBSV",
    latitude: "-12.910994",
    longitude: "-38.331044",
    altitude: "64",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2622",
    name: "Trombetas",
    city: "Oriximina",
    country: "Brazil",
    iata: "TMT",
    icao: "SBTB",
    latitude: "-1.4896",
    longitude: "-56.396803",
    altitude: "287",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2623",
    name: "Senador Petronio Portella",
    city: "Teresina",
    country: "Brazil",
    iata: "THE",
    icao: "SBTE",
    latitude: "-5.059942",
    longitude: "-42.823478",
    altitude: "219",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2624",
    name: "Tefe",
    city: "Tefe",
    country: "Brazil",
    iata: "TFF",
    icao: "SBTF",
    latitude: "-3.382944",
    longitude: "-64.724056",
    altitude: "184",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2625",
    name: "Tarauaca",
    city: "Tarauaca",
    country: "Brazil",
    iata: "",
    icao: "SBTK",
    latitude: "-8.155256",
    longitude: "-70.783269",
    altitude: "646",
    timezone: "-5",
    dst: "S",
    tz: "America/Rio_Branco",
  },
  {
    id: "2626",
    name: "Telemaco Borba",
    city: "Telemaco Borba",
    country: "Brazil",
    iata: "",
    icao: "SBTL",
    latitude: "-24.317775",
    longitude: "-50.651592",
    altitude: "2610",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2627",
    name: "Tirios",
    city: "Obidos Tirios",
    country: "Brazil",
    iata: "",
    icao: "SBTS",
    latitude: "2.223472",
    longitude: "-55.946056",
    altitude: "1127",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2628",
    name: "Tabatinga",
    city: "Tabatinga",
    country: "Brazil",
    iata: "TBT",
    icao: "SBTT",
    latitude: "-4.255669",
    longitude: "-69.935828",
    altitude: "279",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2629",
    name: "Tucurui",
    city: "Tucurui",
    country: "Brazil",
    iata: "TUR",
    icao: "SBTU",
    latitude: "-3.786008",
    longitude: "-49.720267",
    altitude: "830",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2630",
    name: "Sao Gabriel Da Cachoeira",
    city: "Sao Gabriel",
    country: "Brazil",
    iata: "",
    icao: "SBUA",
    latitude: "-0.148419",
    longitude: "-66.985589",
    altitude: "249",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2631",
    name: "Paulo Afonso",
    city: "Paulo Alfonso",
    country: "Brazil",
    iata: "PAV",
    icao: "SBUF",
    latitude: "-9.400878",
    longitude: "-38.250575",
    altitude: "883",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "2632",
    name: "Rubem Berta",
    city: "Uruguaiana",
    country: "Brazil",
    iata: "URG",
    icao: "SBUG",
    latitude: "-29.782178",
    longitude: "-57.038189",
    altitude: "256",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2633",
    name: "Ten Cel Av Cesar Bombonato",
    city: "Uberlandia",
    country: "Brazil",
    iata: "UDI",
    icao: "SBUL",
    latitude: "-18.882844",
    longitude: "-48.225594",
    altitude: "3094",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2634",
    name: "Urubupunga",
    city: "Castilho",
    country: "Brazil",
    iata: "",
    icao: "SBUP",
    latitude: "-20.777067",
    longitude: "-51.564761",
    altitude: "1169",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2635",
    name: "Uberaba",
    city: "Uberaba",
    country: "Brazil",
    iata: "UBA",
    icao: "SBUR",
    latitude: "-19.765",
    longitude: "-47.964778",
    altitude: "2655",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2636",
    name: "Major Brigadeiro Trompowsky",
    city: "Varginha",
    country: "Brazil",
    iata: "VAG",
    icao: "SBVG",
    latitude: "-21.590067",
    longitude: "-45.473342",
    altitude: "3028",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2637",
    name: "Vilhena",
    city: "Vilhena",
    country: "Brazil",
    iata: "BVH",
    icao: "SBVH",
    latitude: "-12.694375",
    longitude: "-60.098269",
    altitude: "2018",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2638",
    name: "Goiabeiras",
    city: "Vitoria",
    country: "Brazil",
    iata: "VIX",
    icao: "SBVT",
    latitude: "-20.258056",
    longitude: "-40.286389",
    altitude: "11",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2639",
    name: "Iauarete",
    city: "Iauarete",
    country: "Brazil",
    iata: "",
    icao: "SBYA",
    latitude: "0.6075",
    longitude: "-69.185837",
    altitude: "345",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "2640",
    name: "Campo Fontenelle",
    city: "Piracununga",
    country: "Brazil",
    iata: "QPS",
    icao: "SBYS",
    latitude: "-21.984561",
    longitude: "-47.334764",
    altitude: "1968",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "2641",
    name: "Chacalluta",
    city: "Arica",
    country: "Chile",
    iata: "ARI",
    icao: "SCAR",
    latitude: "-18.348531",
    longitude: "-70.338742",
    altitude: "167",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2642",
    name: "Balmaceda",
    city: "Balmaceda",
    country: "Chile",
    iata: "BBA",
    icao: "SCBA",
    latitude: "-45.916058",
    longitude: "-71.689475",
    altitude: "1722",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2643",
    name: "El Bosque",
    city: "Santiago",
    country: "Chile",
    iata: "",
    icao: "SCBQ",
    latitude: "-33.5618",
    longitude: "-70.6884",
    altitude: "1844",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2644",
    name: "Chile Chico",
    city: "Chile Chico",
    country: "Chile",
    iata: "CCH",
    icao: "SCCC",
    latitude: "-46.583341",
    longitude: "-71.687405",
    altitude: "1070",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2645",
    name: "El Loa",
    city: "Calama",
    country: "Chile",
    iata: "CJC",
    icao: "SCCF",
    latitude: "-22.498175",
    longitude: "-68.903575",
    altitude: "7543",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2646",
    name: "General Bernardo O Higgins",
    city: "Chillan",
    country: "Chile",
    iata: "",
    icao: "SCCH",
    latitude: "-36.582497",
    longitude: "-72.031367",
    altitude: "495",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2647",
    name: "Carlos Ibanez Del Campo Intl",
    city: "Punta Arenas",
    country: "Chile",
    iata: "PUQ",
    icao: "SCCI",
    latitude: "-53.002642",
    longitude: "-70.854586",
    altitude: "139",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2648",
    name: "Teniente Vidal",
    city: "Coyhaique",
    country: "Chile",
    iata: "GXQ",
    icao: "SCCY",
    latitude: "-45.594211",
    longitude: "-72.106133",
    altitude: "1020",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2649",
    name: "Diego Aracena Intl",
    city: "Iquique",
    country: "Chile",
    iata: "IQQ",
    icao: "SCDA",
    latitude: "-20.535222",
    longitude: "-70.181275",
    altitude: "155",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2650",
    name: "Arturo Merino Benitez Intl",
    city: "Santiago",
    country: "Chile",
    iata: "SCL",
    icao: "SCEL",
    latitude: "-33.392975",
    longitude: "-70.785803",
    altitude: "1555",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2651",
    name: "Cerro Moreno Intl",
    city: "Antofagasta",
    country: "Chile",
    iata: "ANF",
    icao: "SCFA",
    latitude: "-23.444478",
    longitude: "-70.4451",
    altitude: "455",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2652",
    name: "Capitan Fuentes Martinez",
    city: "Porvenir",
    country: "Chile",
    iata: "",
    icao: "SCFM",
    latitude: "-53.2537",
    longitude: "-70.319228",
    altitude: "104",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2653",
    name: "Futaleufu",
    city: "Futaleufu",
    country: "Chile",
    iata: "",
    icao: "SCFT",
    latitude: "-43.189167",
    longitude: "-71.851112",
    altitude: "1148",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2654",
    name: "Maria Dolores",
    city: "Los Angeles",
    country: "Chile",
    iata: "LSQ",
    icao: "SCGE",
    latitude: "-37.401731",
    longitude: "-72.425444",
    altitude: "374",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2655",
    name: "Guardiamarina Zanartu",
    city: "Puerto Williams",
    country: "Chile",
    iata: "",
    icao: "SCGZ",
    latitude: "-54.931072",
    longitude: "-67.626261",
    altitude: "88",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2656",
    name: "Carriel Sur Intl",
    city: "Concepcion",
    country: "Chile",
    iata: "CCP",
    icao: "SCIE",
    latitude: "-36.77265",
    longitude: "-73.063106",
    altitude: "26",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2657",
    name: "Mataveri Intl",
    city: "Easter Island",
    country: "Chile",
    iata: "IPC",
    icao: "SCIP",
    latitude: "-27.164792",
    longitude: "-109.421831",
    altitude: "227",
    timezone: "-6",
    dst: "S",
    tz: "Pacific/Easter",
  },
  {
    id: "2658",
    name: "Canal Bajo Carlos Hott Siebert",
    city: "Osorno",
    country: "Chile",
    iata: "ZOS",
    icao: "SCJO",
    latitude: "-40.611208",
    longitude: "-73.061042",
    altitude: "187",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2659",
    name: "Vallenar",
    city: "Vallenar",
    country: "Chile",
    iata: "",
    icao: "SCLL",
    latitude: "-28.596403",
    longitude: "-70.755997",
    altitude: "1725",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2660",
    name: "De La Independencia",
    city: "Rancagua",
    country: "Chile",
    iata: "",
    icao: "SCRG",
    latitude: "-34.173694",
    longitude: "-70.775694",
    altitude: "1446",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2661",
    name: "Teniente Rodolfo Marsh Martin",
    city: "Isla Rey Jorge",
    country: "Antarctica",
    iata: "",
    icao: "SCRM",
    latitude: "-62.190833",
    longitude: "-58.986667",
    altitude: "147",
    timezone: "12",
    dst: "U",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "2662",
    name: "La Florida",
    city: "La Serena",
    country: "Chile",
    iata: "LSC",
    icao: "SCSE",
    latitude: "-29.916233",
    longitude: "-71.199522",
    altitude: "481",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2663",
    name: "Eulogio Sanchez",
    city: "Santiago",
    country: "Chile",
    iata: "",
    icao: "SCTB",
    latitude: "-33.456278",
    longitude: "-70.546667",
    altitude: "2129",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2664",
    name: "Maquehue",
    city: "Temuco",
    country: "Chile",
    iata: "ZCO",
    icao: "SCTC",
    latitude: "-38.766819",
    longitude: "-72.637097",
    altitude: "304",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2665",
    name: "El Tepual Intl",
    city: "Puerto Montt",
    country: "Chile",
    iata: "PMC",
    icao: "SCTE",
    latitude: "-41.438886",
    longitude: "-73.093953",
    altitude: "294",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2666",
    name: "Chaiten",
    city: "Chaiten",
    country: "Chile",
    iata: "WCH",
    icao: "SCTN",
    latitude: "-42.932808",
    longitude: "-72.699114",
    altitude: "13",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2667",
    name: "Pichoy",
    city: "Valdivia",
    country: "Chile",
    iata: "ZAL",
    icao: "SCVD",
    latitude: "-39.649956",
    longitude: "-73.086111",
    altitude: "59",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "2668",
    name: "Chachoan",
    city: "Ambato",
    country: "Ecuador",
    iata: "ATF",
    icao: "SEAM",
    latitude: "-1.212067",
    longitude: "-78.574636",
    altitude: "8502",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2669",
    name: "Hacienda Clementina",
    city: "Clementia",
    country: "Ecuador",
    iata: "",
    icao: "SECM",
    latitude: "-1.706275",
    longitude: "-79.378936",
    altitude: "328",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2670",
    name: "Francisco De Orellana",
    city: "Coca",
    country: "Ecuador",
    iata: "OCC",
    icao: "SECO",
    latitude: "-0.462886",
    longitude: "-76.986842",
    altitude: "834",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2671",
    name: "Mariscal Lamar",
    city: "Cuenca",
    country: "Ecuador",
    iata: "CUE",
    icao: "SECU",
    latitude: "-2.889467",
    longitude: "-78.984397",
    altitude: "8306",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2672",
    name: "Seymour",
    city: "Galapagos",
    country: "Ecuador",
    iata: "GPS",
    icao: "SEGS",
    latitude: "-0.453758",
    longitude: "-90.265914",
    altitude: "207",
    timezone: "-6",
    dst: "U",
    tz: "Pacific/Galapagos",
  },
  {
    id: "2673",
    name: "Jose Joaquin De Olmedo Intl",
    city: "Guayaquil",
    country: "Ecuador",
    iata: "GYE",
    icao: "SEGU",
    latitude: "-2.157419",
    longitude: "-79.883558",
    altitude: "19",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2674",
    name: "Gualaquiza",
    city: "Gualaquiza",
    country: "Ecuador",
    iata: "",
    icao: "SEGZ",
    latitude: "-3.423214",
    longitude: "-78.566994",
    altitude: "2640",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2675",
    name: "Atahualpa",
    city: "Ibarra",
    country: "Ecuador",
    iata: "",
    icao: "SEIB",
    latitude: "0.338419",
    longitude: "-78.136422",
    altitude: "7304",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2676",
    name: "Km 192",
    city: "Km-192",
    country: "Ecuador",
    iata: "",
    icao: "SEKK",
    latitude: "0.184203",
    longitude: "-79.391956",
    altitude: "1247",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2677",
    name: "Hacienda La Julia",
    city: "La Julia",
    country: "Ecuador",
    iata: "",
    icao: "SELJ",
    latitude: "-1.704381",
    longitude: "-79.552261",
    altitude: "50",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2678",
    name: "Cotopaxi Intl",
    city: "Latacunga",
    country: "Ecuador",
    iata: "",
    icao: "SELT",
    latitude: "-0.906833",
    longitude: "-78.615756",
    altitude: "9205",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2679",
    name: "Jose Maria Velasco Ibarra",
    city: "Macara",
    country: "Ecuador",
    iata: "",
    icao: "SEMA",
    latitude: "-4.378231",
    longitude: "-79.941022",
    altitude: "1508",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2680",
    name: "Coronel E Carvajal",
    city: "Macas",
    country: "Ecuador",
    iata: "XMS",
    icao: "SEMC",
    latitude: "-2.299167",
    longitude: "-78.12075",
    altitude: "3452",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2681",
    name: "General Manuel Serrano",
    city: "Machala",
    country: "Ecuador",
    iata: "MCH",
    icao: "SEMH",
    latitude: "-3.268903",
    longitude: "-79.961572",
    altitude: "11",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2682",
    name: "Montalvo",
    city: "Montalvo",
    country: "Ecuador",
    iata: "",
    icao: "SEMO",
    latitude: "-2.067014",
    longitude: "-76.975742",
    altitude: "960",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2683",
    name: "Eloy Alfaro Intl",
    city: "Manta",
    country: "Ecuador",
    iata: "MEC",
    icao: "SEMT",
    latitude: "-0.946078",
    longitude: "-80.678808",
    altitude: "48",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2684",
    name: "Maragrosa",
    city: "Maragrosa",
    country: "Ecuador",
    iata: "",
    icao: "SEMX",
    latitude: "-2.851097",
    longitude: "-79.803619",
    altitude: "18",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2685",
    name: "Amable Calle Gutierrez",
    city: "Pasaje",
    country: "Ecuador",
    iata: "",
    icao: "SEPS",
    latitude: "-3.319667",
    longitude: "-79.769165",
    altitude: "22",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2686",
    name: "Reales Tamarindos",
    city: "Portoviejo",
    country: "Ecuador",
    iata: "PVO",
    icao: "SEPV",
    latitude: "-1.041647",
    longitude: "-80.472206",
    altitude: "130",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2687",
    name: "Quevedo",
    city: "Quevedo",
    country: "Ecuador",
    iata: "",
    icao: "SEQE",
    latitude: "-0.9894",
    longitude: "-79.465114",
    altitude: "350",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2688",
    name: "Mariscal Sucre Intl",
    city: "Quito",
    country: "Ecuador",
    iata: "UIO",
    icao: "SEQU",
    latitude: "-0.141144",
    longitude: "-78.488214",
    altitude: "9228",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2689",
    name: "Chimborazo",
    city: "Riobamba",
    country: "Ecuador",
    iata: "",
    icao: "SERB",
    latitude: "-1.653433",
    longitude: "-78.656142",
    altitude: "9151",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2690",
    name: "Coronel Artilleria Victor Larrea",
    city: "Santa Rosa",
    country: "Ecuador",
    iata: "",
    icao: "SERO",
    latitude: "-3.435161",
    longitude: "-79.977817",
    altitude: "170",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2691",
    name: "General Ulpiano Paez",
    city: "Salinas",
    country: "Ecuador",
    iata: "SNC",
    icao: "SESA",
    latitude: "-2.204994",
    longitude: "-80.988878",
    altitude: "18",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2692",
    name: "Santo Domingo Los Colorados",
    city: "Santo Domingo",
    country: "Ecuador",
    iata: "",
    icao: "SESD",
    latitude: "-0.248222",
    longitude: "-79.214447",
    altitude: "1714",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2694",
    name: "Taura",
    city: "Taura",
    country: "Ecuador",
    iata: "",
    icao: "SETA",
    latitude: "-2.261036",
    longitude: "-79.680169",
    altitude: "56",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2695",
    name: "Mayor Galo Torres",
    city: "Tena",
    country: "Ecuador",
    iata: "",
    icao: "SETE",
    latitude: "-0.986767",
    longitude: "-77.819447",
    altitude: "1708",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2696",
    name: "Tarapoa",
    city: "Tarapoa",
    country: "Ecuador",
    iata: "TPC",
    icao: "SETR",
    latitude: "-0.122956",
    longitude: "-76.33775",
    altitude: "814",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "2697",
    name: "Teniente Coronel Luis A Mantilla",
    city: "Tulcan",
    country: "Ecuador",
    iata: "TUA",
    icao: "SETU",
    latitude: "0.809506",
    longitude: "-77.708056",
    altitude: "9649",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "6847",
    name: "Silverton",
    city: "Silverton",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.812545",
    longitude: "-107.662994",
    altitude: "9308",
    timezone: "-7",
    dst: "U",
    tz: "America/Denver",
  },
  {
    id: "2699",
    name: "Silvio Pettirossi Intl",
    city: "Asuncion",
    country: "Paraguay",
    iata: "ASU",
    icao: "SGAS",
    latitude: "-25.23985",
    longitude: "-57.519133",
    altitude: "292",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "2700",
    name: "Juan De Ayolas",
    city: "Ayolas",
    country: "Paraguay",
    iata: "",
    icao: "SGAY",
    latitude: "-27.37065",
    longitude: "-56.853944",
    altitude: "223",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "2701",
    name: "Teniente Col Carmelo Peralta",
    city: "Conception",
    country: "Paraguay",
    iata: "",
    icao: "SGCO",
    latitude: "-23.44175",
    longitude: "-57.427122",
    altitude: "253",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "2702",
    name: "Itaipu",
    city: "Itaipu",
    country: "Paraguay",
    iata: "",
    icao: "SGIB",
    latitude: "-25.407853",
    longitude: "-54.619417",
    altitude: "762",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "2703",
    name: "Dr Luis Maria Argana Intl",
    city: "Mariscal Estigarribia",
    country: "Paraguay",
    iata: "",
    icao: "SGME",
    latitude: "-22.044986",
    longitude: "-60.621694",
    altitude: "553",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "2704",
    name: "Carlos Miguel Gimenez",
    city: "Pilar",
    country: "Paraguay",
    iata: "",
    icao: "SGPI",
    latitude: "-26.881467",
    longitude: "-58.318036",
    altitude: "249",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "2705",
    name: "El Eden",
    city: "Armenia",
    country: "Colombia",
    iata: "AXM",
    icao: "SKAR",
    latitude: "4.452775",
    longitude: "-75.766447",
    altitude: "3990",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2706",
    name: "Tres De Mayo",
    city: "Puerto Asis",
    country: "Colombia",
    iata: "PUU",
    icao: "SKAS",
    latitude: "0.505228",
    longitude: "-76.500836",
    altitude: "815",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2707",
    name: "Las Flores",
    city: "El Banco",
    country: "Colombia",
    iata: "",
    icao: "SKBC",
    latitude: "9.045542",
    longitude: "-73.974931",
    altitude: "111",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2708",
    name: "Palonegro",
    city: "Bucaramanga",
    country: "Colombia",
    iata: "BGA",
    icao: "SKBG",
    latitude: "7.1265",
    longitude: "-73.184778",
    altitude: "3897",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2709",
    name: "Eldorado Intl",
    city: "Bogota",
    country: "Colombia",
    iata: "BOG",
    icao: "SKBO",
    latitude: "4.701594",
    longitude: "-74.146947",
    altitude: "8361",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2710",
    name: "Ernesto Cortissoz",
    city: "Barranquilla",
    country: "Colombia",
    iata: "BAQ",
    icao: "SKBQ",
    latitude: "10.889589",
    longitude: "-74.780819",
    altitude: "98",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2711",
    name: "Jose Celestino Mutis",
    city: "Bahia Solano",
    country: "Colombia",
    iata: "BSC",
    icao: "SKBS",
    latitude: "6.202917",
    longitude: "-77.394675",
    altitude: "80",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2712",
    name: "Gerardo Tobar Lopez",
    city: "Buenaventura",
    country: "Colombia",
    iata: "BUN",
    icao: "SKBU",
    latitude: "3.819628",
    longitude: "-76.989767",
    altitude: "48",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2713",
    name: "Camilo Daza",
    city: "Cucuta",
    country: "Colombia",
    iata: "CUC",
    icao: "SKCC",
    latitude: "7.927567",
    longitude: "-72.511547",
    altitude: "1096",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2714",
    name: "Rafael Nunez",
    city: "Cartagena",
    country: "Colombia",
    iata: "CTG",
    icao: "SKCG",
    latitude: "10.442381",
    longitude: "-75.512961",
    altitude: "4",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2715",
    name: "Alfonso Bonilla Aragon Intl",
    city: "Cali",
    country: "Colombia",
    iata: "CLO",
    icao: "SKCL",
    latitude: "3.543222",
    longitude: "-76.381583",
    altitude: "3162",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2716",
    name: "La Florida",
    city: "Tumaco",
    country: "Colombia",
    iata: "TCO",
    icao: "SKCO",
    latitude: "1.814417",
    longitude: "-78.749228",
    altitude: "8",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2717",
    name: "Las Brujas",
    city: "Corozal",
    country: "Colombia",
    iata: "CZU",
    icao: "SKCZ",
    latitude: "9.332742",
    longitude: "-75.285594",
    altitude: "528",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2718",
    name: "Yariguies",
    city: "Barrancabermeja",
    country: "Colombia",
    iata: "EJA",
    icao: "SKEJ",
    latitude: "7.024331",
    longitude: "-73.8068",
    altitude: "412",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2719",
    name: "Gustavo Artunduaga Paredes",
    city: "Florencia",
    country: "Colombia",
    iata: "FLA",
    icao: "SKFL",
    latitude: "1.589189",
    longitude: "-75.564372",
    altitude: "803",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2720",
    name: "Santiago Vila",
    city: "Girardot",
    country: "Colombia",
    iata: "",
    icao: "SKGI",
    latitude: "4.276242",
    longitude: "-74.796692",
    altitude: "900",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6846",
    name: "McCarthy Airport",
    city: "McCarthy",
    country: "United States",
    iata: "MXY",
    icao: "\\N",
    latitude: "61.4370608",
    longitude: "-142.90307372",
    altitude: "1531",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "2722",
    name: "Juan Casiano",
    city: "Guapi",
    country: "Colombia",
    iata: "GPI",
    icao: "SKGP",
    latitude: "2.570133",
    longitude: "-77.8986",
    altitude: "164",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2723",
    name: "Guaymaral",
    city: "Guaymaral",
    country: "Colombia",
    iata: "",
    icao: "SKGY",
    latitude: "4.812333",
    longitude: "-74.064919",
    altitude: "8390",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2724",
    name: "Perales",
    city: "Ibague",
    country: "Colombia",
    iata: "IBE",
    icao: "SKIB",
    latitude: "4.421608",
    longitude: "-75.1333",
    altitude: "2999",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2725",
    name: "San Luis",
    city: "Ipiales",
    country: "Colombia",
    iata: "IPI",
    icao: "SKIP",
    latitude: "0.861925",
    longitude: "-77.671764",
    altitude: "9765",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2726",
    name: "Antonio Roldan Betancourt",
    city: "Carepa",
    country: "Colombia",
    iata: "",
    icao: "SKLC",
    latitude: "7.811956",
    longitude: "-76.716428",
    altitude: "46",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2727",
    name: "La Mina",
    city: "La Mina",
    country: "Colombia",
    iata: "",
    icao: "SKLM",
    latitude: "11.232528",
    longitude: "-72.490139",
    altitude: "276",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2728",
    name: "Alfredo Vasquez Cobo",
    city: "Leticia",
    country: "Colombia",
    iata: "LET",
    icao: "SKLT",
    latitude: "-4.193549",
    longitude: "-69.943163",
    altitude: "277",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2729",
    name: "Olaya Herrera",
    city: "Medellin",
    country: "Colombia",
    iata: "EOH",
    icao: "SKMD",
    latitude: "6.219958",
    longitude: "-75.590519",
    altitude: "4940",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2730",
    name: "Baracoa",
    city: "Magangue",
    country: "Colombia",
    iata: "MGN",
    icao: "SKMG",
    latitude: "9.284739",
    longitude: "-74.846092",
    altitude: "178",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2731",
    name: "Los Garzones",
    city: "Monteria",
    country: "Colombia",
    iata: "MTR",
    icao: "SKMR",
    latitude: "8.823744",
    longitude: "-75.825831",
    altitude: "36",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2732",
    name: "Fabio Alberto Leon Bentley",
    city: "Mitu",
    country: "Colombia",
    iata: "MVP",
    icao: "SKMU",
    latitude: "1.253664",
    longitude: "-70.233878",
    altitude: "680",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2733",
    name: "La Nubia",
    city: "Manizales",
    country: "Colombia",
    iata: "MZL",
    icao: "SKMZ",
    latitude: "5.029597",
    longitude: "-75.464708",
    altitude: "6871",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2734",
    name: "Benito Salas",
    city: "Neiva",
    country: "Colombia",
    iata: "NVA",
    icao: "SKNV",
    latitude: "2.95015",
    longitude: "-75.294",
    altitude: "1464",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2735",
    name: "Aguas Claras",
    city: "Ocana",
    country: "Colombia",
    iata: "OCV",
    icao: "SKOC",
    latitude: "8.315061",
    longitude: "-73.358331",
    altitude: "3850",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2736",
    name: "Otu",
    city: "Otu",
    country: "Colombia",
    iata: "OTU",
    icao: "SKOT",
    latitude: "7.010369",
    longitude: "-74.715497",
    altitude: "2060",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2737",
    name: "Puerto Bolivar",
    city: "Puerto Bolivar",
    country: "Colombia",
    iata: "",
    icao: "SKPB",
    latitude: "12.221483",
    longitude: "-71.984817",
    altitude: "90",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2738",
    name: "Puerto Carreno",
    city: "Puerto Carreno",
    country: "Colombia",
    iata: "PCR",
    icao: "SKPC",
    latitude: "6.184717",
    longitude: "-67.493164",
    altitude: "177",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2739",
    name: "Matecana",
    city: "Pereira",
    country: "Colombia",
    iata: "PEI",
    icao: "SKPE",
    latitude: "4.812675",
    longitude: "-75.739519",
    altitude: "4416",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2740",
    name: "Pitalito",
    city: "Pitalito",
    country: "Colombia",
    iata: "",
    icao: "SKPI",
    latitude: "1.857769",
    longitude: "-76.085719",
    altitude: "4212",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2741",
    name: "Guillermo Leon Valencia",
    city: "Popayan",
    country: "Colombia",
    iata: "PPN",
    icao: "SKPP",
    latitude: "2.4544",
    longitude: "-76.609319",
    altitude: "5687",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2742",
    name: "Antonio Narino",
    city: "Pasto",
    country: "Colombia",
    iata: "PSO",
    icao: "SKPS",
    latitude: "1.396247",
    longitude: "-77.291478",
    altitude: "5951",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2743",
    name: "El Embrujo",
    city: "Providencia",
    country: "Colombia",
    iata: "PVA",
    icao: "SKPV",
    latitude: "13.356944",
    longitude: "-81.35833",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2744",
    name: "Mariquita",
    city: "Mariquita",
    country: "Colombia",
    iata: "",
    icao: "SKQU",
    latitude: "5.212556",
    longitude: "-74.883647",
    altitude: "1531",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2745",
    name: "Jose Maria Cordova",
    city: "Rio Negro",
    country: "Colombia",
    iata: "MDE",
    icao: "SKRG",
    latitude: "6.164536",
    longitude: "-75.423119",
    altitude: "6955",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2746",
    name: "Almirante Padilla",
    city: "Rio Hacha",
    country: "Colombia",
    iata: "RCH",
    icao: "SKRH",
    latitude: "11.526222",
    longitude: "-72.925958",
    altitude: "43",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2747",
    name: "Jorge E Gonzalez Torres",
    city: "San Jose Del Guaviare",
    country: "Colombia",
    iata: "SJE",
    icao: "SKSJ",
    latitude: "2.579694",
    longitude: "-72.639358",
    altitude: "605",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2748",
    name: "Simon Bolivar",
    city: "Santa Marta",
    country: "Colombia",
    iata: "SMR",
    icao: "SKSM",
    latitude: "11.11965",
    longitude: "-74.230647",
    altitude: "22",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2749",
    name: "Gustavo Rojas Pinilla",
    city: "San Andres Island",
    country: "Colombia",
    iata: "ADZ",
    icao: "SKSP",
    latitude: "12.583594",
    longitude: "-81.711192",
    altitude: "19",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2750",
    name: "Eduardo Falla Solano",
    city: "San Vincente De Caguan",
    country: "Colombia",
    iata: "SVI",
    icao: "SKSV",
    latitude: "2.152175",
    longitude: "-74.76635",
    altitude: "920",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2751",
    name: "Tame",
    city: "Tame",
    country: "Colombia",
    iata: "TME",
    icao: "SKTM",
    latitude: "6.451081",
    longitude: "-71.760261",
    altitude: "1050",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2752",
    name: "Santiago Perez",
    city: "Arauca",
    country: "Colombia",
    iata: "AUC",
    icao: "SKUC",
    latitude: "7.068881",
    longitude: "-70.736925",
    altitude: "420",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2753",
    name: "El Carano",
    city: "Quibdo",
    country: "Colombia",
    iata: "UIB",
    icao: "SKUI",
    latitude: "5.690758",
    longitude: "-76.641181",
    altitude: "204",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2754",
    name: "Farfan",
    city: "Tulua",
    country: "Colombia",
    iata: "ULQ",
    icao: "SKUL",
    latitude: "4.088358",
    longitude: "-76.235133",
    altitude: "3132",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2755",
    name: "Alfonso Lopez Pumarejo",
    city: "Valledupar",
    country: "Colombia",
    iata: "VUP",
    icao: "SKVP",
    latitude: "10.435042",
    longitude: "-73.249506",
    altitude: "456",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2756",
    name: "Vanguardia",
    city: "Villavicencio",
    country: "Colombia",
    iata: "VVC",
    icao: "SKVV",
    latitude: "4.167875",
    longitude: "-73.613761",
    altitude: "1394",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "2758",
    name: "Bermejo",
    city: "Bermejo",
    country: "Bolivia",
    iata: "BJO",
    icao: "SLBJ",
    latitude: "-22.773336",
    longitude: "-64.312881",
    altitude: "1250",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2759",
    name: "Jorge Wilsterman",
    city: "Cochabamba",
    country: "Bolivia",
    iata: "CBB",
    icao: "SLCB",
    latitude: "-17.421058",
    longitude: "-66.177114",
    altitude: "8360",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2760",
    name: "Chimore",
    city: "Chapacura",
    country: "Bolivia",
    iata: "",
    icao: "SLCH",
    latitude: "-16.990019",
    longitude: "-65.141533",
    altitude: "1000",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2761",
    name: "Heroes Del Acre",
    city: "Cobija",
    country: "Bolivia",
    iata: "CIJ",
    icao: "SLCO",
    latitude: "-11.040436",
    longitude: "-68.782972",
    altitude: "892",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2762",
    name: "El Alto Intl",
    city: "La Paz",
    country: "Bolivia",
    iata: "LPB",
    icao: "SLLP",
    latitude: "-16.513339",
    longitude: "-68.192256",
    altitude: "13325",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2763",
    name: "Juan Mendoza",
    city: "Oruro",
    country: "Bolivia",
    iata: "",
    icao: "SLOR",
    latitude: "-17.962589",
    longitude: "-67.076236",
    altitude: "12146",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2764",
    name: "Capitan Nicolas Rojas",
    city: "Potosi",
    country: "Bolivia",
    iata: "POI",
    icao: "SLPO",
    latitude: "-19.543069",
    longitude: "-65.723706",
    altitude: "12913",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2765",
    name: "Tte De Av Salvador Ogaya G",
    city: "Puerto Suarez",
    country: "Bolivia",
    iata: "PSZ",
    icao: "SLPS",
    latitude: "-18.975281",
    longitude: "-57.820586",
    altitude: "439",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2766",
    name: "Santa Ana Del Yacuma",
    city: "Santa Ana",
    country: "Bolivia",
    iata: "",
    icao: "SLSA",
    latitude: "-13.762208",
    longitude: "-65.435158",
    altitude: "472",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2767",
    name: "Juana Azurduy De Padilla",
    city: "Sucre",
    country: "Bolivia",
    iata: "SRE",
    icao: "SLSU",
    latitude: "-19.007083",
    longitude: "-65.288747",
    altitude: "9527",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2768",
    name: "Capitan Oriel Lea Plaza",
    city: "Tarija",
    country: "Bolivia",
    iata: "TJA",
    icao: "SLTJ",
    latitude: "-21.555736",
    longitude: "-64.701325",
    altitude: "6084",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2769",
    name: "Tte Av Jorge Henrich Arauz",
    city: "Trinidad",
    country: "Bolivia",
    iata: "TDD",
    icao: "SLTR",
    latitude: "-14.818739",
    longitude: "-64.918019",
    altitude: "509",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2770",
    name: "Tcnl Rafael Pabon",
    city: "Villa Montes",
    country: "Bolivia",
    iata: "",
    icao: "SLVM",
    latitude: "-21.255231",
    longitude: "-63.405611",
    altitude: "1306",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2771",
    name: "Viru Viru Intl",
    city: "Santa Cruz",
    country: "Bolivia",
    iata: "VVI",
    icao: "SLVR",
    latitude: "-17.644756",
    longitude: "-63.135364",
    altitude: "1225",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2772",
    name: "Yacuiba",
    city: "Yacuiba",
    country: "Bolivia",
    iata: "BYC",
    icao: "SLYA",
    latitude: "-21.960925",
    longitude: "-63.651669",
    altitude: "2116",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "2773",
    name: "Johan A Pengel Intl",
    city: "Zandery",
    country: "Suriname",
    iata: "PBM",
    icao: "SMJP",
    latitude: "5.452831",
    longitude: "-55.187783",
    altitude: "59",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "2774",
    name: "Rochambeau",
    city: "Cayenne",
    country: "French Guiana",
    iata: "CAY",
    icao: "SOCA",
    latitude: "4.819808",
    longitude: "-52.360447",
    altitude: "26",
    timezone: "-3",
    dst: "U",
    tz: "America/Cayenne",
  },
  {
    id: "2775",
    name: "St Georges De L Oyapock",
    city: "St.-georges Oyapock",
    country: "French Guiana",
    iata: "",
    icao: "SOOG",
    latitude: "3.8976",
    longitude: "-51.804083",
    altitude: "46",
    timezone: "-3",
    dst: "U",
    tz: "America/Cayenne",
  },
  {
    id: "2776",
    name: "Huancabamba",
    city: "Huancabamba",
    country: "Peru",
    iata: "",
    icao: "SPAB",
    latitude: "-5.256767",
    longitude: "-79.442856",
    altitude: "6312",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2777",
    name: "Alferez Vladimir Sara Bauer",
    city: "Andoas",
    country: "Peru",
    iata: "",
    icao: "SPAS",
    latitude: "-2.796128",
    longitude: "-76.466617",
    altitude: "728",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2778",
    name: "Atalaya",
    city: "Atalaya",
    country: "Peru",
    iata: "",
    icao: "SPAY",
    latitude: "-10.729117",
    longitude: "-73.766503",
    altitude: "751",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6845",
    name: "Seward Airport",
    city: "Seward",
    country: "United States",
    iata: "SWD",
    icao: "\\N",
    latitude: "60.1269383",
    longitude: "-149.4188122",
    altitude: "22",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "2780",
    name: "Iberia",
    city: "Iberia",
    country: "Peru",
    iata: "",
    icao: "SPBR",
    latitude: "-11.411578",
    longitude: "-69.488711",
    altitude: "750",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2781",
    name: "Cap Fap David Abenzur Rengifo Intl",
    city: "Pucallpa",
    country: "Peru",
    iata: "PCL",
    icao: "SPCL",
    latitude: "-8.377939",
    longitude: "-74.574297",
    altitude: "513",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2782",
    name: "Teniente Jaime A De Montreuil Morales",
    city: "Chimbote",
    country: "Peru",
    iata: "CHM",
    icao: "SPEO",
    latitude: "-9.149614",
    longitude: "-78.52385",
    altitude: "69",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2783",
    name: "Puerto Esperanza",
    city: "Puerto Esperanza",
    country: "Peru",
    iata: "",
    icao: "SPEP",
    latitude: "-9.768131",
    longitude: "-70.706456",
    altitude: "725",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2784",
    name: "Cesar Torke Podesta",
    city: "Moquegua",
    country: "Peru",
    iata: "",
    icao: "SPEQ",
    latitude: "-17.178961",
    longitude: "-70.930803",
    altitude: "4480",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2785",
    name: "Capt Jose A Quinones Gonzales Intl",
    city: "Chiclayo",
    country: "Peru",
    iata: "CIX",
    icao: "SPHI",
    latitude: "-6.787475",
    longitude: "-79.828097",
    altitude: "97",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2786",
    name: "Coronel Fap Alfredo Mendivil Duarte",
    city: "Ayacucho",
    country: "Peru",
    iata: "AYP",
    icao: "SPHO",
    latitude: "-13.154819",
    longitude: "-74.204417",
    altitude: "8917",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2787",
    name: "Andahuaylas",
    city: "Andahuaylas",
    country: "Peru",
    iata: "ANS",
    icao: "SPHY",
    latitude: "-13.706408",
    longitude: "-73.350378",
    altitude: "11300",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2788",
    name: "Comandante Fap German Arias Graziani",
    city: "Anta",
    country: "Peru",
    iata: "ATA",
    icao: "SPHZ",
    latitude: "-9.347444",
    longitude: "-77.598392",
    altitude: "9097",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2789",
    name: "Jorge Chavez Intl",
    city: "Lima",
    country: "Peru",
    iata: "LIM",
    icao: "SPIM",
    latitude: "-12.021889",
    longitude: "-77.114319",
    altitude: "113",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2790",
    name: "Juanjui",
    city: "Juanjui",
    country: "Peru",
    iata: "JJI",
    icao: "SPJI",
    latitude: "-7.1691",
    longitude: "-76.728561",
    altitude: "1148",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2791",
    name: "Francisco Carle",
    city: "Jauja",
    country: "Peru",
    iata: "",
    icao: "SPJJ",
    latitude: "-11.783144",
    longitude: "-75.473394",
    altitude: "11034",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2792",
    name: "Juliaca",
    city: "Juliaca",
    country: "Peru",
    iata: "JUL",
    icao: "SPJL",
    latitude: "-15.467103",
    longitude: "-70.158169",
    altitude: "12552",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6844",
    name: "Michigan City Municipal Airport",
    city: "Michigan City",
    country: "United States",
    iata: "MGC",
    icao: "KMGC",
    latitude: "41.7033",
    longitude: "-86.8211",
    altitude: "500",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "2794",
    name: "Ilo",
    city: "Ilo",
    country: "Peru",
    iata: "",
    icao: "SPLO",
    latitude: "-17.695036",
    longitude: "-71.343964",
    altitude: "72",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2795",
    name: "Las Palmas",
    city: "Las Palmas",
    country: "Peru",
    iata: "",
    icao: "SPLP",
    latitude: "-12.160708",
    longitude: "-76.998942",
    altitude: "250",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2796",
    name: "Pedro Canga",
    city: "Tumbes",
    country: "Peru",
    iata: "TBP",
    icao: "SPME",
    latitude: "-3.552528",
    longitude: "-80.381356",
    altitude: "115",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2797",
    name: "Moises Benzaquen Rengifo",
    city: "Yurimaguas",
    country: "Peru",
    iata: "YMS",
    icao: "SPMS",
    latitude: "-5.893772",
    longitude: "-76.118211",
    altitude: "587",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2799",
    name: "Collique",
    city: "Collique",
    country: "Peru",
    iata: "",
    icao: "SPOL",
    latitude: "-11.9287",
    longitude: "-77.061139",
    altitude: "410",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2800",
    name: "Chachapoyas",
    city: "Chachapoyas",
    country: "Peru",
    iata: "CHH",
    icao: "SPPY",
    latitude: "-6.201806",
    longitude: "-77.856064",
    altitude: "8333",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2801",
    name: "Coronel Francisco Secada Vignetta Intl",
    city: "Iquitos",
    country: "Peru",
    iata: "IQT",
    icao: "SPQT",
    latitude: "-3.784739",
    longitude: "-73.308806",
    altitude: "306",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2802",
    name: "Rodriguez Ballon",
    city: "Arequipa",
    country: "Peru",
    iata: "AQP",
    icao: "SPQU",
    latitude: "-16.341072",
    longitude: "-71.583083",
    altitude: "8405",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2803",
    name: "San Ramon",
    city: "San Ramon",
    country: "Peru",
    iata: "",
    icao: "SPRM",
    latitude: "-11.128639",
    longitude: "-75.3505",
    altitude: "2600",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2804",
    name: "Capitan Carlos Martinez De Pinillos",
    city: "Trujillo",
    country: "Peru",
    iata: "TRU",
    icao: "SPRU",
    latitude: "-8.081411",
    longitude: "-79.108761",
    altitude: "106",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2805",
    name: "Pisco Intl",
    city: "Pisco",
    country: "Peru",
    iata: "PIO",
    icao: "SPSO",
    latitude: "-13.744864",
    longitude: "-76.220284",
    altitude: "39",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2806",
    name: "Cadete Guillermo Del Castillo Paredes",
    city: "Tarapoto",
    country: "Peru",
    iata: "TPP",
    icao: "SPST",
    latitude: "-6.508742",
    longitude: "-76.373247",
    altitude: "869",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2807",
    name: "Coronel Carlos Ciriani Santa Rosa Intl",
    city: "Tacna",
    country: "Peru",
    iata: "TCQ",
    icao: "SPTN",
    latitude: "-18.053333",
    longitude: "-70.275833",
    altitude: "1538",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2808",
    name: "Padre Aldamiz",
    city: "Puerto Maldonado",
    country: "Peru",
    iata: "PEM",
    icao: "SPTU",
    latitude: "-12.613611",
    longitude: "-69.228611",
    altitude: "659",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2809",
    name: "Capitan Fap Guillermo Concha Iberico",
    city: "Piura",
    country: "Peru",
    iata: "PIU",
    icao: "SPUR",
    latitude: "-5.20575",
    longitude: "-80.616444",
    altitude: "120",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2810",
    name: "Capitan Montes",
    city: "Talara",
    country: "Peru",
    iata: "TYL",
    icao: "SPYL",
    latitude: "-4.576639",
    longitude: "-81.254139",
    altitude: "282",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6843",
    name: "Niijima Airport",
    city: "Niijima",
    country: "Japan",
    iata: "",
    icao: "RJAN",
    latitude: "34.366944",
    longitude: "139.268611",
    altitude: "133",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "2812",
    name: "Teniente Alejandro Velasco Astete Intl",
    city: "Cuzco",
    country: "Peru",
    iata: "CUZ",
    icao: "SPZO",
    latitude: "-13.535722",
    longitude: "-71.938781",
    altitude: "10860",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "2813",
    name: "Angel S Adami",
    city: "Montevideo",
    country: "Uruguay",
    iata: "",
    icao: "SUAA",
    latitude: "-34.789208",
    longitude: "-56.264703",
    altitude: "174",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "2814",
    name: "Santa Bernardina Intl",
    city: "Durazno",
    country: "Uruguay",
    iata: "",
    icao: "SUDU",
    latitude: "-33.358867",
    longitude: "-56.499172",
    altitude: "305",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "6842",
    name: "East Glacier Park Amtrak Station",
    city: "East Glacier",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "48.443965",
    longitude: "-113.218556",
    altitude: "5171",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "2816",
    name: "Carrasco Intl",
    city: "Montevideo",
    country: "Uruguay",
    iata: "MVD",
    icao: "SUMU",
    latitude: "-34.838417",
    longitude: "-56.030806",
    altitude: "105",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "2817",
    name: "Nueva Hesperides Intl",
    city: "Salto",
    country: "Uruguay",
    iata: "STY",
    icao: "SUSO",
    latitude: "-31.438481",
    longitude: "-57.985294",
    altitude: "187",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "2818",
    name: "Oswaldo Guevara Mujica",
    city: "Acarigua",
    country: "Venezuela",
    iata: "AGV",
    icao: "SVAC",
    latitude: "9.553422",
    longitude: "-69.237536",
    altitude: "741",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2819",
    name: "Anaco",
    city: "Anaco",
    country: "Venezuela",
    iata: "AAO",
    icao: "SVAN",
    latitude: "9.430225",
    longitude: "-64.470725",
    altitude: "721",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2820",
    name: "San Fernando De Atabapo",
    city: "San Fernando Deatabapo",
    country: "Venezuela",
    iata: "",
    icao: "SVAT",
    latitude: "4.051819",
    longitude: "-67.701072",
    altitude: "298",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2821",
    name: "General Jose Antonio Anzoategui Intl",
    city: "Barcelona",
    country: "Venezuela",
    iata: "BLA",
    icao: "SVBC",
    latitude: "10.107139",
    longitude: "-64.689161",
    altitude: "26",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2822",
    name: "Barinas",
    city: "Barinas",
    country: "Venezuela",
    iata: "BNS",
    icao: "SVBI",
    latitude: "8.619575",
    longitude: "-70.220825",
    altitude: "666",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2823",
    name: "El Libertador Ab",
    city: "Maracaibo",
    country: "Venezuela",
    iata: "",
    icao: "SVBL",
    latitude: "10.183375",
    longitude: "-67.557319",
    altitude: "1450",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2824",
    name: "Barquisimeto Intl",
    city: "Barquisimeto",
    country: "Venezuela",
    iata: "BRM",
    icao: "SVBM",
    latitude: "10.042747",
    longitude: "-69.358619",
    altitude: "2042",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2826",
    name: "Ciudad Bolivar",
    city: "Ciudad Bolivar",
    country: "Venezuela",
    iata: "CBL",
    icao: "SVCB",
    latitude: "8.121898",
    longitude: "-63.537353",
    altitude: "197",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2827",
    name: "Caicara Del Orinoco",
    city: "Caicara De Orinoco",
    country: "Venezuela",
    iata: "",
    icao: "SVCD",
    latitude: "7.626078",
    longitude: "-66.164917",
    altitude: "141",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2828",
    name: "San Carlos",
    city: "San Carlos",
    country: "Venezuela",
    iata: "",
    icao: "SVCJ",
    latitude: "9.647722",
    longitude: "-68.574656",
    altitude: "512",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2829",
    name: "Calabozo",
    city: "Calabozo",
    country: "Venezuela",
    iata: "",
    icao: "SVCL",
    latitude: "8.924656",
    longitude: "-67.417094",
    altitude: "328",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2830",
    name: "Canaima",
    city: "Canaima",
    country: "Venezuela",
    iata: "CAJ",
    icao: "SVCN",
    latitude: "6.231989",
    longitude: "-62.854433",
    altitude: "1450",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2831",
    name: "Carora",
    city: "Carora",
    country: "Venezuela",
    iata: "",
    icao: "SVCO",
    latitude: "10.175603",
    longitude: "-70.065214",
    altitude: "1437",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2832",
    name: "General Jose Francisco Bermudez",
    city: "Carupano",
    country: "Venezuela",
    iata: "CUP",
    icao: "SVCP",
    latitude: "10.660014",
    longitude: "-63.261681",
    altitude: "33",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2833",
    name: "Jose Leonardo Chirinos",
    city: "Coro",
    country: "Venezuela",
    iata: "CZE",
    icao: "SVCR",
    latitude: "11.414867",
    longitude: "-69.681656",
    altitude: "52",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2834",
    name: "Oscar Machado Zuloaga",
    city: "Caracas",
    country: "Venezuela",
    iata: "",
    icao: "SVCS",
    latitude: "10.286589",
    longitude: "-66.816219",
    altitude: "2145",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2835",
    name: "Antonio Jose De Sucre",
    city: "Cumana",
    country: "Venezuela",
    iata: "CUM",
    icao: "SVCU",
    latitude: "10.450333",
    longitude: "-64.130472",
    altitude: "25",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2836",
    name: "Capitan Manuel Rios Guarico Airbase",
    city: "Carrizal",
    country: "Venezuela",
    iata: "",
    icao: "SVCZ",
    latitude: "9.372167",
    longitude: "-66.922989",
    altitude: "525",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2837",
    name: "El Dorado",
    city: "El Dorado",
    country: "Venezuela",
    iata: "",
    icao: "SVED",
    latitude: "6.715438",
    longitude: "-61.639219",
    altitude: "318",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2838",
    name: "Elorza",
    city: "Elorza",
    country: "Venezuela",
    iata: "",
    icao: "SVEZ",
    latitude: "7.059722",
    longitude: "-69.496694",
    altitude: "295",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2839",
    name: "Guasdualito",
    city: "Guasdualito",
    country: "Venezuela",
    iata: "",
    icao: "SVGD",
    latitude: "7.211081",
    longitude: "-70.75645",
    altitude: "426",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2840",
    name: "Guiria",
    city: "Guiria",
    country: "Venezuela",
    iata: "GUI",
    icao: "SVGI",
    latitude: "10.574078",
    longitude: "-62.312667",
    altitude: "42",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2841",
    name: "Guanare",
    city: "Guanare",
    country: "Venezuela",
    iata: "GUQ",
    icao: "SVGU",
    latitude: "9.026944",
    longitude: "-69.75515",
    altitude: "606",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2842",
    name: "Higuerote",
    city: "Higuerote",
    country: "Venezuela",
    iata: "",
    icao: "SVHG",
    latitude: "10.462453",
    longitude: "-66.092758",
    altitude: "10",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2843",
    name: "Andres Miguel Salazar Marcano",
    city: "Isla De Coche",
    country: "Venezuela",
    iata: "",
    icao: "SVIE",
    latitude: "10.794406",
    longitude: "-63.981589",
    altitude: "10",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2844",
    name: "Josefa Camejo",
    city: "Paraguana",
    country: "Venezuela",
    iata: "LSP",
    icao: "SVJC",
    latitude: "11.780775",
    longitude: "-70.151497",
    altitude: "75",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2845",
    name: "San Juan De Los Morros",
    city: "San Juan De Los Morros",
    country: "Venezuela",
    iata: "",
    icao: "SVJM",
    latitude: "9.906953",
    longitude: "-67.379639",
    altitude: "1404",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2846",
    name: "La Fria",
    city: "La Fria",
    country: "Venezuela",
    iata: "LFR",
    icao: "SVLF",
    latitude: "8.239167",
    longitude: "-72.271028",
    altitude: "323",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2847",
    name: "La Orchila",
    city: "La Orchila",
    country: "Venezuela",
    iata: "",
    icao: "SVLO",
    latitude: "11.808822",
    longitude: "-66.179214",
    altitude: "5",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2848",
    name: "La Chinita Intl",
    city: "Maracaibo",
    country: "Venezuela",
    iata: "MAR",
    icao: "SVMC",
    latitude: "10.558208",
    longitude: "-71.727856",
    altitude: "235",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2849",
    name: "Alberto Carnevalli",
    city: "Merida",
    country: "Venezuela",
    iata: "MRD",
    icao: "SVMD",
    latitude: "8.582294",
    longitude: "-71.161186",
    altitude: "5007",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2850",
    name: "Del Caribe Intl Gen Santiago Marino",
    city: "Porlamar",
    country: "Venezuela",
    iata: "PMV",
    icao: "SVMG",
    latitude: "10.912926",
    longitude: "-63.967581",
    altitude: "74",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2851",
    name: "Simon Bolivar Intl",
    city: "Caracas",
    country: "Venezuela",
    iata: "CCS",
    icao: "SVMI",
    latitude: "10.603117",
    longitude: "-66.990583",
    altitude: "235",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2852",
    name: "Maturin",
    city: "Maturin",
    country: "Venezuela",
    iata: "MUN",
    icao: "SVMT",
    latitude: "9.749067",
    longitude: "-63.1534",
    altitude: "224",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2853",
    name: "Casique Aramare",
    city: "Puerto Ayacucho",
    country: "Venezuela",
    iata: "PYH",
    icao: "SVPA",
    latitude: "5.619992",
    longitude: "-67.606103",
    altitude: "245",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2854",
    name: "General Bartolome Salom Intl",
    city: "Puerto Cabello",
    country: "Venezuela",
    iata: "PBL",
    icao: "SVPC",
    latitude: "10.4805",
    longitude: "-68.073025",
    altitude: "32",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2855",
    name: "Paramillo",
    city: "San Cristobal",
    country: "Venezuela",
    iata: "",
    icao: "SVPM",
    latitude: "7.801317",
    longitude: "-72.202847",
    altitude: "3314",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2856",
    name: "General Manuel Carlos Piar",
    city: "Guayana",
    country: "Venezuela",
    iata: "PZO",
    icao: "SVPR",
    latitude: "8.288528",
    longitude: "-62.760361",
    altitude: "472",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2857",
    name: "Palmarito",
    city: "Palmarito",
    country: "Venezuela",
    iata: "",
    icao: "SVPT",
    latitude: "7.575706",
    longitude: "-70.174328",
    altitude: "347",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2858",
    name: "San Antonio Del Tachira",
    city: "San Antonio",
    country: "Venezuela",
    iata: "SVZ",
    icao: "SVSA",
    latitude: "7.840831",
    longitude: "-72.439742",
    altitude: "1312",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2859",
    name: "Santa Barbara De Barinas",
    city: "Santa Barbara",
    country: "Venezuela",
    iata: "",
    icao: "SVSB",
    latitude: "7.803514",
    longitude: "-71.165717",
    altitude: "590",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2860",
    name: "Santa Elena De Uairen",
    city: "Santa Ana De Uairen",
    country: "Venezuela",
    iata: "",
    icao: "SVSE",
    latitude: "4.554722",
    longitude: "-61.144922",
    altitude: "2939",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2861",
    name: "Mayor Buenaventura Vivas",
    city: "Santo Domingo",
    country: "Venezuela",
    iata: "STD",
    icao: "SVSO",
    latitude: "7.565111",
    longitude: "-72.035125",
    altitude: "1083",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2862",
    name: "Sub Teniente Nestor Arias",
    city: "San Felipe",
    country: "Venezuela",
    iata: "SFH",
    icao: "SVSP",
    latitude: "10.278728",
    longitude: "-68.755211",
    altitude: "761",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2863",
    name: "San Fernando De Apure",
    city: "San Fernando De Apure",
    country: "Venezuela",
    iata: "SFD",
    icao: "SVSR",
    latitude: "7.883317",
    longitude: "-67.444025",
    altitude: "154",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2864",
    name: "San Tome",
    city: "San Tome",
    country: "Venezuela",
    iata: "SOM",
    icao: "SVST",
    latitude: "8.945147",
    longitude: "-64.151083",
    altitude: "837",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2865",
    name: "Santa Barbara Del Zulia",
    city: "Santa Barbara",
    country: "Venezuela",
    iata: "STB",
    icao: "SVSZ",
    latitude: "8.974425",
    longitude: "-71.943014",
    altitude: "32",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2866",
    name: "Tucupita",
    city: "Tucupita",
    country: "Venezuela",
    iata: "TUV",
    icao: "SVTC",
    latitude: "9.088994",
    longitude: "-62.094175",
    altitude: "105",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2867",
    name: "Tumeremo",
    city: "Tumeremo",
    country: "Venezuela",
    iata: "",
    icao: "SVTM",
    latitude: "7.249381",
    longitude: "-61.528933",
    altitude: "344",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2868",
    name: "Arturo Michelena Intl",
    city: "Valencia",
    country: "Venezuela",
    iata: "VLN",
    icao: "SVVA",
    latitude: "10.149733",
    longitude: "-67.9284",
    altitude: "1417",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "6841",
    name: "Flugplatz Hoexter Holzminden",
    city: "Hoexter Holzminden",
    country: "Germany",
    iata: "",
    icao: "EDVI",
    latitude: "51.4838",
    longitude: "9.2259",
    altitude: "855",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "2870",
    name: "Dr Antonio Nicolas Briceno",
    city: "Valera",
    country: "Venezuela",
    iata: "VLV",
    icao: "SVVL",
    latitude: "9.340797",
    longitude: "-70.584089",
    altitude: "1893",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2871",
    name: "Valle De La Pascua",
    city: "Valle De La Pascua",
    country: "Venezuela",
    iata: "VDP",
    icao: "SVVP",
    latitude: "9.222028",
    longitude: "-65.993583",
    altitude: "410",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "2872",
    name: "Linden",
    city: "Linden",
    country: "Guyana",
    iata: "",
    icao: "SYLD",
    latitude: "5.965922",
    longitude: "-58.270336",
    altitude: "180",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "2873",
    name: "Lethem",
    city: "Lethem",
    country: "Guyana",
    iata: "LTM",
    icao: "SYLT",
    latitude: "3.372761",
    longitude: "-59.789439",
    altitude: "351",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "2874",
    name: "V C Bird Intl",
    city: "Antigua",
    country: "Antigua and Barbuda",
    iata: "ANU",
    icao: "TAPA",
    latitude: "17.136749",
    longitude: "-61.792667",
    altitude: "62",
    timezone: "-4",
    dst: "U",
    tz: "America/Antigua",
  },
  {
    id: "2875",
    name: "Grantley Adams Intl",
    city: "Bridgetown",
    country: "Barbados",
    iata: "BGI",
    icao: "TBPB",
    latitude: "13.074603",
    longitude: "-59.492456",
    altitude: "169",
    timezone: "-4",
    dst: "U",
    tz: "America/Barbados",
  },
  {
    id: "2876",
    name: "Canefield",
    city: "Canefield",
    country: "Dominica",
    iata: "DCF",
    icao: "TDCF",
    latitude: "15.336719",
    longitude: "-61.392211",
    altitude: "13",
    timezone: "-4",
    dst: "U",
    tz: "America/Dominica",
  },
  {
    id: "2877",
    name: "Melville Hall",
    city: "Dominica",
    country: "Dominica",
    iata: "DOM",
    icao: "TDPD",
    latitude: "15.547028",
    longitude: "-61.3",
    altitude: "73",
    timezone: "-4",
    dst: "U",
    tz: "America/Dominica",
  },
  {
    id: "2878",
    name: "Le Lamentin",
    city: "Fort-de-france",
    country: "Martinique",
    iata: "FDF",
    icao: "TFFF",
    latitude: "14.591033",
    longitude: "-61.003175",
    altitude: "16",
    timezone: "-4",
    dst: "U",
    tz: "America/Martinique",
  },
  {
    id: "2879",
    name: "Grand Case",
    city: "St. Martin",
    country: "Guadeloupe",
    iata: "SFG",
    icao: "TFFG",
    latitude: "18.099914",
    longitude: "-63.047197",
    altitude: "7",
    timezone: "-4",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "2881",
    name: "Le Raizet",
    city: "Pointe-a-pitre",
    country: "Guadeloupe",
    iata: "PTP",
    icao: "TFFR",
    latitude: "16.265306",
    longitude: "-61.531806",
    altitude: "36",
    timezone: "-4",
    dst: "U",
    tz: "America/Guadeloupe",
  },
  {
    id: "2882",
    name: "Point Salines Intl",
    city: "Point Salines",
    country: "Grenada",
    iata: "GND",
    icao: "TGPY",
    latitude: "12.004247",
    longitude: "-61.786192",
    altitude: "41",
    timezone: "-4",
    dst: "U",
    tz: "America/Grenada",
  },
  {
    id: "2883",
    name: "Cyril E King",
    city: "St. Thomas",
    country: "Virgin Islands",
    iata: "STT",
    icao: "TIST",
    latitude: "18.337306",
    longitude: "-64.973361",
    altitude: "23",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Thomas",
  },
  {
    id: "2884",
    name: "Henry E Rohlsen",
    city: "St. Croix Island",
    country: "Virgin Islands",
    iata: "STX",
    icao: "TISX",
    latitude: "17.701889",
    longitude: "-64.798556",
    altitude: "74",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Thomas",
  },
  {
    id: "2885",
    name: "Rafael Hernandez",
    city: "Aguadilla",
    country: "Puerto Rico",
    iata: "BQN",
    icao: "TJBQ",
    latitude: "18.494861",
    longitude: "-67.129444",
    altitude: "237",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "2886",
    name: "Diego Jimenez Torres",
    city: "Fajardo",
    country: "Puerto Rico",
    iata: "FAJ",
    icao: "TJFA",
    latitude: "18.308889",
    longitude: "-65.661861",
    altitude: "64",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "2887",
    name: "Fernando Luis Ribas Dominicci",
    city: "San Juan",
    country: "Puerto Rico",
    iata: "SIG",
    icao: "TJIG",
    latitude: "18.456828",
    longitude: "-66.098139",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "2888",
    name: "Eugenio Maria De Hostos",
    city: "Mayaguez",
    country: "Puerto Rico",
    iata: "MAZ",
    icao: "TJMZ",
    latitude: "18.255694",
    longitude: "-67.148472",
    altitude: "28",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "2889",
    name: "Mercedita",
    city: "Ponce",
    country: "Puerto Rico",
    iata: "PSE",
    icao: "TJPS",
    latitude: "18.008306",
    longitude: "-66.563028",
    altitude: "29",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "2890",
    name: "Luis Munoz Marin Intl",
    city: "San Juan",
    country: "Puerto Rico",
    iata: "SJU",
    icao: "TJSJ",
    latitude: "18.439417",
    longitude: "-66.001833",
    altitude: "9",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "2891",
    name: "Robert L Bradshaw",
    city: "Basse Terre",
    country: "Saint Kitts and Nevis",
    iata: "SKB",
    icao: "TKPK",
    latitude: "17.311194",
    longitude: "-62.718667",
    altitude: "170",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Kitts",
  },
  {
    id: "6840",
    name: "Dinslaken Schwarze-Heide",
    city: "Dinslaken",
    country: "Germany",
    iata: "",
    icao: "EDLD",
    latitude: "51.3659",
    longitude: "6.5155",
    altitude: "198",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "2893",
    name: "George F L Charles",
    city: "Castries",
    country: "Saint Lucia",
    iata: "SLU",
    icao: "TLPC",
    latitude: "14.020228",
    longitude: "-60.992936",
    altitude: "22",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Lucia",
  },
  {
    id: "2894",
    name: "Hewanorra Intl",
    city: "Hewandorra",
    country: "Saint Lucia",
    iata: "UVF",
    icao: "TLPL",
    latitude: "13.733194",
    longitude: "-60.952597",
    altitude: "14",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Lucia",
  },
  {
    id: "2895",
    name: "Reina Beatrix Intl",
    city: "Oranjestad",
    country: "Aruba",
    iata: "AUA",
    icao: "TNCA",
    latitude: "12.501389",
    longitude: "-70.015221",
    altitude: "60",
    timezone: "-4",
    dst: "U",
    tz: "America/Aruba",
  },
  {
    id: "2896",
    name: "Flamingo",
    city: "Kralendijk",
    country: "Netherlands Antilles",
    iata: "BON",
    icao: "TNCB",
    latitude: "12.131044",
    longitude: "-68.268511",
    altitude: "20",
    timezone: "-4",
    dst: "U",
    tz: "America/Curacao",
  },
  {
    id: "2897",
    name: "Hato",
    city: "Willemstad",
    country: "Netherlands Antilles",
    iata: "CUR",
    icao: "TNCC",
    latitude: "12.188853",
    longitude: "-68.959803",
    altitude: "29",
    timezone: "-4",
    dst: "U",
    tz: "America/Curacao",
  },
  {
    id: "2898",
    name: "F D Roosevelt",
    city: "Oranjestad",
    country: "Netherlands Antilles",
    iata: "EUX",
    icao: "TNCE",
    latitude: "17.496492",
    longitude: "-62.979439",
    altitude: "129",
    timezone: "-4",
    dst: "U",
    tz: "America/Curacao",
  },
  {
    id: "2899",
    name: "Princess Juliana Intl",
    city: "Philipsburg",
    country: "Netherlands Antilles",
    iata: "SXM",
    icao: "TNCM",
    latitude: "18.040953",
    longitude: "-63.1089",
    altitude: "14",
    timezone: "-4",
    dst: "U",
    tz: "America/Curacao",
  },
  {
    id: "2900",
    name: "Wallblake",
    city: "The Valley",
    country: "Anguilla",
    iata: "AXA",
    icao: "TQPF",
    latitude: "18.204834",
    longitude: "-63.055084",
    altitude: "127",
    timezone: "-4",
    dst: "U",
    tz: "America/Anguilla",
  },
  {
    id: "2901",
    name: "Crown Point",
    city: "Scarborough",
    country: "Trinidad and Tobago",
    iata: "TAB",
    icao: "TTCP",
    latitude: "11.149658",
    longitude: "-60.832194",
    altitude: "38",
    timezone: "-4",
    dst: "U",
    tz: "America/Port_of_Spain",
  },
  {
    id: "2902",
    name: "Piarco",
    city: "Port-of-spain",
    country: "Trinidad and Tobago",
    iata: "POS",
    icao: "TTPP",
    latitude: "10.595369",
    longitude: "-61.337242",
    altitude: "58",
    timezone: "-4",
    dst: "U",
    tz: "America/Port_of_Spain",
  },
  {
    id: "2903",
    name: "Terrance B Lettsome Intl",
    city: "Tortola",
    country: "British Virgin Islands",
    iata: "EIS",
    icao: "TUPJ",
    latitude: "18.444834",
    longitude: "-64.542975",
    altitude: "15",
    timezone: "-4",
    dst: "U",
    tz: "America/Tortola",
  },
  {
    id: "6839",
    name: "Allakaket Airport",
    city: "Allakaket",
    country: "United States",
    iata: "AET",
    icao: "PFAL",
    latitude: "66.5519",
    longitude: "-152.6222",
    altitude: "441",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "2905",
    name: "Canouan",
    city: "Canouan Island",
    country: "Saint Vincent and the Grenadines",
    iata: "CIW",
    icao: "TVSC",
    latitude: "12.699042",
    longitude: "-61.342431",
    altitude: "11",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Vincent",
  },
  {
    id: "2906",
    name: "Mustique",
    city: "Mustique",
    country: "Saint Vincent and the Grenadines",
    iata: "MQS",
    icao: "TVSM",
    latitude: "12.887947",
    longitude: "-61.180161",
    altitude: "8",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Vincent",
  },
  {
    id: "2907",
    name: "E T Joshua",
    city: "Kingstown",
    country: "Saint Vincent and the Grenadines",
    iata: "SVD",
    icao: "TVSV",
    latitude: "13.144306",
    longitude: "-61.210861",
    altitude: "66",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Vincent",
  },
  {
    id: "2908",
    name: "Almaty",
    city: "Alma-ata",
    country: "Kazakhstan",
    iata: "ALA",
    icao: "UAAA",
    latitude: "43.352072",
    longitude: "77.040508",
    altitude: "2234",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "2909",
    name: "Balkhash",
    city: "Balkhash",
    country: "Kazakhstan",
    iata: "",
    icao: "UAAH",
    latitude: "46.893333",
    longitude: "75.005",
    altitude: "1446",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "2910",
    name: "Astana Intl",
    city: "Tselinograd",
    country: "Kazakhstan",
    iata: "TSE",
    icao: "UACC",
    latitude: "51.022222",
    longitude: "71.466944",
    altitude: "1165",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "2911",
    name: "Taraz",
    city: "Dzhambul",
    country: "Kazakhstan",
    iata: "DMB",
    icao: "UADD",
    latitude: "42.853611",
    longitude: "71.303611",
    altitude: "2184",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "2912",
    name: "Manas",
    city: "Bishkek",
    country: "Kyrgyzstan",
    iata: "FRU",
    icao: "UAFM",
    latitude: "43.061306",
    longitude: "74.477556",
    altitude: "2058",
    timezone: "6",
    dst: "U",
    tz: "Asia/Bishkek",
  },
  {
    id: "2913",
    name: "Osh",
    city: "Osh",
    country: "Kyrgyzstan",
    iata: "OSS",
    icao: "UAFO",
    latitude: "40.608989",
    longitude: "72.793269",
    altitude: "2927",
    timezone: "6",
    dst: "U",
    tz: "Asia/Bishkek",
  },
  {
    id: "2914",
    name: "Shymkent",
    city: "Chimkent",
    country: "Kazakhstan",
    iata: "CIT",
    icao: "UAII",
    latitude: "42.364167",
    longitude: "69.478889",
    altitude: "1385",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "6803",
    name: "Yakutat",
    city: "Yakutat",
    country: "United States",
    iata: "YAK",
    icao: "PAYA",
    latitude: "59.3012",
    longitude: "-139.3937",
    altitude: "33",
    timezone: "-9",
    dst: "A",
    tz: "\\N",
  },
  {
    id: "2916",
    name: "Uralsk",
    city: "Uralsk",
    country: "Kazakhstan",
    iata: "URA",
    icao: "UARR",
    latitude: "51.150833",
    longitude: "51.543056",
    altitude: "125",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "2917",
    name: "Pavlodar",
    city: "Pavlodar",
    country: "Kazakhstan",
    iata: "PWQ",
    icao: "UASP",
    latitude: "52.195",
    longitude: "77.073889",
    altitude: "410",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "2918",
    name: "Semipalatinsk",
    city: "Semiplatinsk",
    country: "Kazakhstan",
    iata: "PLX",
    icao: "UASS",
    latitude: "50.3513",
    longitude: "80.2344",
    altitude: "761",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "2919",
    name: "Aktau",
    city: "Shevchenko",
    country: "Kazakhstan",
    iata: "",
    icao: "UATE",
    latitude: "43.86005",
    longitude: "51.091978",
    altitude: "73",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "2920",
    name: "Aktyubinsk",
    city: "Aktyubinsk",
    country: "Kazakhstan",
    iata: "AKX",
    icao: "UATT",
    latitude: "50.245833",
    longitude: "57.206667",
    altitude: "738",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "2922",
    name: "Heydar Aliyev",
    city: "Baku",
    country: "Azerbaijan",
    iata: "GYD",
    icao: "UBBB",
    latitude: "40.4675",
    longitude: "50.046667",
    altitude: "10",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "2923",
    name: "Yakutsk",
    city: "Yakutsk",
    country: "Russia",
    iata: "YKS",
    icao: "UEEE",
    latitude: "62.09325",
    longitude: "129.770672",
    altitude: "325",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "2925",
    name: "Mirny",
    city: "Mirnyj",
    country: "Russia",
    iata: "MJZ",
    icao: "UERR",
    latitude: "62.534689",
    longitude: "114.038928",
    altitude: "1156",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "2926",
    name: "Ignatyevo",
    city: "Blagoveschensk",
    country: "Russia",
    iata: "BQS",
    icao: "UHBB",
    latitude: "50.425394",
    longitude: "127.412478",
    altitude: "638",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "2927",
    name: "Novy",
    city: "Khabarovsk",
    country: "Russia",
    iata: "KHV",
    icao: "UHHH",
    latitude: "48.528044",
    longitude: "135.188361",
    altitude: "244",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "6838",
    name: "Sawyer International Airport",
    city: "Marquette",
    country: "United States",
    iata: "MQT",
    icao: "KMQT",
    latitude: "46.353611",
    longitude: "-87.395278",
    altitude: "1221",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "2929",
    name: "Provideniya Bay",
    city: "Provideniya Bay",
    country: "Russia",
    iata: "PVS",
    icao: "UHMD",
    latitude: "64.378139",
    longitude: "-173.243306",
    altitude: "71",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "2930",
    name: "Sokol",
    city: "Magadan",
    country: "Russia",
    iata: "GDX",
    icao: "UHMM",
    latitude: "59.910989",
    longitude: "150.720439",
    altitude: "574",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "2931",
    name: "Pevek",
    city: "Pevek",
    country: "Russia",
    iata: "PWE",
    icao: "UHMP",
    latitude: "69.783283",
    longitude: "170.597006",
    altitude: "11",
    timezone: "12",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "2932",
    name: "Yelizovo",
    city: "Petropavlovsk",
    country: "Russia",
    iata: "PKC",
    icao: "UHPP",
    latitude: "53.167889",
    longitude: "158.453669",
    altitude: "131",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "2933",
    name: "Khomutovo",
    city: "Yuzhno-sakhalinsk",
    country: "Russia",
    iata: "UUS",
    icao: "UHSS",
    latitude: "46.888672",
    longitude: "142.717531",
    altitude: "59",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "2934",
    name: "Knevichi",
    city: "Vladivostok",
    country: "Russia",
    iata: "VVO",
    icao: "UHWW",
    latitude: "43.398953",
    longitude: "132.148017",
    altitude: "46",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "2935",
    name: "Kadala",
    city: "Chita",
    country: "Russia",
    iata: "HTA",
    icao: "UIAA",
    latitude: "52.026317",
    longitude: "113.305556",
    altitude: "2272",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "2936",
    name: "Bratsk",
    city: "Bratsk",
    country: "Russia",
    iata: "BTK",
    icao: "UIBB",
    latitude: "56.370556",
    longitude: "101.698331",
    altitude: "1610",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "2937",
    name: "Irkutsk",
    city: "Irkutsk",
    country: "Russia",
    iata: "IKT",
    icao: "UIII",
    latitude: "52.268028",
    longitude: "104.388975",
    altitude: "1675",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "2938",
    name: "Mukhino",
    city: "Ulan-ude",
    country: "Russia",
    iata: "UUD",
    icao: "UIUU",
    latitude: "51.807764",
    longitude: "107.437644",
    altitude: "1690",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "2939",
    name: "Boryspil Intl",
    city: "Kiev",
    country: "Ukraine",
    iata: "KBP",
    icao: "UKBB",
    latitude: "50.345",
    longitude: "30.894722",
    altitude: "427",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "2940",
    name: "Donetsk Intl",
    city: "Donetsk",
    country: "Ukraine",
    iata: "DOK",
    icao: "UKCC",
    latitude: "48.073611",
    longitude: "37.739722",
    altitude: "791",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "2941",
    name: "Dnipropetrovsk Intl",
    city: "Dnepropetrovsk",
    country: "Ukraine",
    iata: "DNK",
    icao: "UKDD",
    latitude: "48.357222",
    longitude: "35.100556",
    altitude: "481",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "2942",
    name: "Simferopol Intl",
    city: "Simferopol",
    country: "Ukraine",
    iata: "SIP",
    icao: "UKFF",
    latitude: "45.052222",
    longitude: "33.975139",
    altitude: "639",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "2944",
    name: "Zhuliany Intl",
    city: "Kiev",
    country: "Ukraine",
    iata: "IEV",
    icao: "UKKK",
    latitude: "50.401694",
    longitude: "30.449697",
    altitude: "586",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "2945",
    name: "Lviv Intl",
    city: "Lvov",
    country: "Ukraine",
    iata: "LWO",
    icao: "UKLL",
    latitude: "49.8125",
    longitude: "23.956111",
    altitude: "1071",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6837",
    name: "Ford Airport",
    city: "Iron Mountain",
    country: "United States",
    iata: "IMT",
    icao: "KIMT",
    latitude: "45.8183611",
    longitude: "-88.1145556",
    altitude: "1182",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "2947",
    name: "Odesa Intl",
    city: "Odessa",
    country: "Ukraine",
    iata: "ODS",
    icao: "UKOO",
    latitude: "46.426767",
    longitude: "30.676464",
    altitude: "172",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "2948",
    name: "Pulkovo",
    city: "St. Petersburg",
    country: "Russia",
    iata: "LED",
    icao: "ULLI",
    latitude: "59.800292",
    longitude: "30.262503",
    altitude: "78",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2949",
    name: "Murmansk",
    city: "Murmansk",
    country: "Russia",
    iata: "MMK",
    icao: "ULMM",
    latitude: "68.781672",
    longitude: "32.750822",
    altitude: "266",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2950",
    name: "Gomel",
    city: "Gomel",
    country: "Belarus",
    iata: "GME",
    icao: "UMGG",
    latitude: "52.527022",
    longitude: "31.016692",
    altitude: "471",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "2951",
    name: "Vitebsk",
    city: "Vitebsk",
    country: "Belarus",
    iata: "VTB",
    icao: "UMII",
    latitude: "55.1265",
    longitude: "30.349639",
    altitude: "683",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "2952",
    name: "Khrabrovo",
    city: "Kaliningrad",
    country: "Russia",
    iata: "KGD",
    icao: "UMKK",
    latitude: "54.89005",
    longitude: "20.592633",
    altitude: "42",
    timezone: "3",
    dst: "N",
    tz: "Europe/Kaliningrad",
  },
  {
    id: "2953",
    name: "Minsk 1",
    city: "Minsk",
    country: "Belarus",
    iata: "MHP",
    icao: "UMMM",
    latitude: "53.864472",
    longitude: "27.539683",
    altitude: "748",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "2954",
    name: "Minsk 2",
    city: "Minsk 2",
    country: "Belarus",
    iata: "MSQ",
    icao: "UMMS",
    latitude: "53.882469",
    longitude: "28.030731",
    altitude: "670",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "2955",
    name: "Abakan",
    city: "Abakan",
    country: "Russia",
    iata: "ABA",
    icao: "UNAA",
    latitude: "53.74",
    longitude: "91.385",
    altitude: "831",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "2956",
    name: "Barnaul",
    city: "Barnaul",
    country: "Russia",
    iata: "BAX",
    icao: "UNBB",
    latitude: "53.363775",
    longitude: "83.538533",
    altitude: "838",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "2957",
    name: "Kemerovo",
    city: "Kemorovo",
    country: "Russia",
    iata: "KEJ",
    icao: "UNEE",
    latitude: "55.270094",
    longitude: "86.107208",
    altitude: "863",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "2958",
    name: "Omsk",
    city: "Omsk",
    country: "Russia",
    iata: "OMS",
    icao: "UNOO",
    latitude: "54.967042",
    longitude: "73.310514",
    altitude: "311",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "2960",
    name: "Pashkovskiy",
    city: "Krasnodar",
    country: "Russia",
    iata: "KRR",
    icao: "URKK",
    latitude: "45.034689",
    longitude: "39.170539",
    altitude: "118",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2961",
    name: "Uytash",
    city: "Makhachkala",
    country: "Russia",
    iata: "MCX",
    icao: "URML",
    latitude: "42.816822",
    longitude: "47.652294",
    altitude: "12",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2962",
    name: "Mineralnyye Vody",
    city: "Mineralnye Vody",
    country: "Russia",
    iata: "MRV",
    icao: "URMM",
    latitude: "44.225072",
    longitude: "43.081889",
    altitude: "1054",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2963",
    name: "Shpakovskoye",
    city: "Stavropol",
    country: "Russia",
    iata: "STW",
    icao: "URMT",
    latitude: "45.109165",
    longitude: "42.112778",
    altitude: "1486",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2964",
    name: "Rostov Na Donu",
    city: "Rostov",
    country: "Russia",
    iata: "ROV",
    icao: "URRR",
    latitude: "47.258208",
    longitude: "39.818089",
    altitude: "280",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2965",
    name: "Sochi",
    city: "Sochi",
    country: "Russia",
    iata: "AER",
    icao: "URSS",
    latitude: "43.449928",
    longitude: "39.956589",
    altitude: "89",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2966",
    name: "Astrakhan",
    city: "Astrakhan",
    country: "Russia",
    iata: "ASF",
    icao: "URWA",
    latitude: "46.283333",
    longitude: "48.006278",
    altitude: "-65",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2967",
    name: "Gumrak",
    city: "Volgograd",
    country: "Russia",
    iata: "VOG",
    icao: "URWW",
    latitude: "48.782528",
    longitude: "44.345544",
    altitude: "482",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2968",
    name: "Balandino",
    city: "Chelyabinsk",
    country: "Russia",
    iata: "CEK",
    icao: "USCC",
    latitude: "55.305836",
    longitude: "61.503333",
    altitude: "769",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2969",
    name: "Magnitogorsk",
    city: "Magnetiogorsk",
    country: "Russia",
    iata: "MQF",
    icao: "USCM",
    latitude: "53.393131",
    longitude: "58.755661",
    altitude: "1431",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6834",
    name: "Great Barrier Island",
    city: "Claris",
    country: "New Zealand",
    iata: "GBZ",
    icao: "NZGB",
    latitude: "-36.1429",
    longitude: "175.2819",
    altitude: "10",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "2972",
    name: "Nizhnevartovsk",
    city: "Nizhnevartovsk",
    country: "Russia",
    iata: "NJC",
    icao: "USNN",
    latitude: "60.949272",
    longitude: "76.483617",
    altitude: "177",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2973",
    name: "Bolshoye Savino",
    city: "Perm",
    country: "Russia",
    iata: "PEE",
    icao: "USPP",
    latitude: "57.914517",
    longitude: "56.021214",
    altitude: "404",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2974",
    name: "Surgut",
    city: "Surgut",
    country: "Russia",
    iata: "SGC",
    icao: "USRR",
    latitude: "61.343694",
    longitude: "73.401842",
    altitude: "200",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2975",
    name: "Koltsovo",
    city: "Yekaterinburg",
    country: "Russia",
    iata: "SVX",
    icao: "USSS",
    latitude: "56.743108",
    longitude: "60.802728",
    altitude: "764",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2976",
    name: "Ashgabat",
    city: "Ashkhabad",
    country: "Turkmenistan",
    iata: "ASB",
    icao: "UTAA",
    latitude: "37.986814",
    longitude: "58.360967",
    altitude: "692",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "2977",
    name: "Turkmenbashi",
    city: "Krasnovodsk",
    country: "Turkmenistan",
    iata: "KRW",
    icao: "UTAK",
    latitude: "40.063333",
    longitude: "53.007222",
    altitude: "279",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "2978",
    name: "Turkmenabat",
    city: "Chardzhou",
    country: "Turkmenistan",
    iata: "",
    icao: "UTAV",
    latitude: "39.083333",
    longitude: "63.613333",
    altitude: "630",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "2979",
    name: "Dushanbe",
    city: "Dushanbe",
    country: "Tajikistan",
    iata: "DYU",
    icao: "UTDD",
    latitude: "38.543333",
    longitude: "68.825",
    altitude: "2575",
    timezone: "5",
    dst: "U",
    tz: "Asia/Dushanbe",
  },
  {
    id: "2980",
    name: "Bukhara",
    city: "Bukhara",
    country: "Uzbekistan",
    iata: "BHK",
    icao: "UTSB",
    latitude: "39.775",
    longitude: "64.483333",
    altitude: "751",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "2981",
    name: "Samarkand",
    city: "Samarkand",
    country: "Uzbekistan",
    iata: "SKD",
    icao: "UTSS",
    latitude: "39.700547",
    longitude: "66.983829",
    altitude: "2224",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6833",
    name: "Al Udeid AB",
    city: "Doha",
    country: "Qatar",
    iata: "IUD",
    icao: "OTBH",
    latitude: "25.1174",
    longitude: "51.3228",
    altitude: "130",
    timezone: "3",
    dst: "N",
    tz: "Asia/Qatar",
  },
  {
    id: "2983",
    name: "Yuzhny",
    city: "Tashkent",
    country: "Uzbekistan",
    iata: "TAS",
    icao: "UTTT",
    latitude: "41.257861",
    longitude: "69.281186",
    altitude: "1417",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "2984",
    name: "Bryansk",
    city: "Bryansk",
    country: "Russia",
    iata: "BZK",
    icao: "UUBP",
    latitude: "53.214194",
    longitude: "34.176447",
    altitude: "663",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2985",
    name: "Sheremetyevo",
    city: "Moscow",
    country: "Russia",
    iata: "SVO",
    icao: "UUEE",
    latitude: "55.972642",
    longitude: "37.414589",
    altitude: "622",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2986",
    name: "Migalovo",
    city: "Tver",
    country: "Russia",
    iata: "KLD",
    icao: "UUEM",
    latitude: "56.824736",
    longitude: "35.757678",
    altitude: "469",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2987",
    name: "Chertovitskoye",
    city: "Voronezh",
    country: "Russia",
    iata: "VOZ",
    icao: "UUOO",
    latitude: "51.814211",
    longitude: "39.229589",
    altitude: "514",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2988",
    name: "Vnukovo",
    city: "Moscow",
    country: "Russia",
    iata: "VKO",
    icao: "UUWW",
    latitude: "55.591531",
    longitude: "37.261486",
    altitude: "685",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2989",
    name: "Syktyvkar",
    city: "Syktyvkar",
    country: "Russia",
    iata: "SCW",
    icao: "UUYY",
    latitude: "61.64705",
    longitude: "50.84505",
    altitude: "342",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2990",
    name: "Kazan",
    city: "Kazan",
    country: "Russia",
    iata: "KZN",
    icao: "UWKD",
    latitude: "55.606186",
    longitude: "49.278728",
    altitude: "411",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2991",
    name: "Orenburg",
    city: "Orenburg",
    country: "Russia",
    iata: "REN",
    icao: "UWOO",
    latitude: "51.795786",
    longitude: "55.456744",
    altitude: "387",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2992",
    name: "Ufa",
    city: "Ufa",
    country: "Russia",
    iata: "UFA",
    icao: "UWUU",
    latitude: "54.557511",
    longitude: "55.874417",
    altitude: "449",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "2993",
    name: "Kurumoch",
    city: "Samara",
    country: "Russia",
    iata: "KBY",
    icao: "UWWW",
    latitude: "53.504858",
    longitude: "50.164336",
    altitude: "477",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "2994",
    name: "Ahmedabad",
    city: "Ahmedabad",
    country: "India",
    iata: "AMD",
    icao: "VAAH",
    latitude: "23.077242",
    longitude: "72.63465",
    altitude: "189",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "2995",
    name: "Akola",
    city: "Akola",
    country: "India",
    iata: "AKD",
    icao: "VAAK",
    latitude: "20.699006",
    longitude: "77.058628",
    altitude: "999",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "2996",
    name: "Aurangabad",
    city: "Aurangabad",
    country: "India",
    iata: "IXU",
    icao: "VAAU",
    latitude: "19.862728",
    longitude: "75.398114",
    altitude: "1911",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "2997",
    name: "Chhatrapati Shivaji Intl",
    city: "Mumbai",
    country: "India",
    iata: "BOM",
    icao: "VABB",
    latitude: "19.088686",
    longitude: "72.867919",
    altitude: "37",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "2998",
    name: "Bilaspur",
    city: "Bilaspur",
    country: "India",
    iata: "PAB",
    icao: "VABI",
    latitude: "21.9884",
    longitude: "82.110983",
    altitude: "899",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "2999",
    name: "Bhuj",
    city: "Bhuj",
    country: "India",
    iata: "BHJ",
    icao: "VABJ",
    latitude: "23.287828",
    longitude: "69.670147",
    altitude: "268",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3000",
    name: "Belgaum",
    city: "Belgaum",
    country: "India",
    iata: "IXG",
    icao: "VABM",
    latitude: "15.859286",
    longitude: "74.618292",
    altitude: "2487",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3001",
    name: "Vadodara",
    city: "Baroda",
    country: "India",
    iata: "BDQ",
    icao: "VABO",
    latitude: "22.336164",
    longitude: "73.226289",
    altitude: "129",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3002",
    name: "Bhopal",
    city: "Bhopal",
    country: "India",
    iata: "BHO",
    icao: "VABP",
    latitude: "23.287467",
    longitude: "77.337375",
    altitude: "1719",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3003",
    name: "Bhavnagar",
    city: "Bhaunagar",
    country: "India",
    iata: "BHU",
    icao: "VABV",
    latitude: "21.752206",
    longitude: "72.185181",
    altitude: "44",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3004",
    name: "Daman",
    city: "Daman",
    country: "India",
    iata: "NMB",
    icao: "VADN",
    latitude: "20.434364",
    longitude: "72.843206",
    altitude: "33",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3005",
    name: "Deesa",
    city: "Deesa",
    country: "India",
    iata: "",
    icao: "VADS",
    latitude: "24.267936",
    longitude: "72.204433",
    altitude: "485",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3006",
    name: "Guna",
    city: "Guna",
    country: "India",
    iata: "",
    icao: "VAGN",
    latitude: "24.654681",
    longitude: "77.347347",
    altitude: "1600",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3007",
    name: "Goa",
    city: "Goa",
    country: "India",
    iata: "GOI",
    icao: "VAGO",
    latitude: "15.380833",
    longitude: "73.831422",
    altitude: "184",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3008",
    name: "Devi Ahilyabai Holkar",
    city: "Indore",
    country: "India",
    iata: "IDR",
    icao: "VAID",
    latitude: "22.721786",
    longitude: "75.801086",
    altitude: "1850",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3009",
    name: "Jabalpur",
    city: "Jabalpur",
    country: "India",
    iata: "JLR",
    icao: "VAJB",
    latitude: "23.177817",
    longitude: "80.052047",
    altitude: "1624",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3010",
    name: "Jamnagar",
    city: "Jamnagar",
    country: "India",
    iata: "JGA",
    icao: "VAJM",
    latitude: "22.465522",
    longitude: "70.012556",
    altitude: "69",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3011",
    name: "Kandla",
    city: "Kandla",
    country: "India",
    iata: "IXY",
    icao: "VAKE",
    latitude: "23.112719",
    longitude: "70.100289",
    altitude: "96",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3012",
    name: "Khajuraho",
    city: "Khajuraho",
    country: "India",
    iata: "HJR",
    icao: "VAKJ",
    latitude: "24.817197",
    longitude: "79.918597",
    altitude: "728",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3013",
    name: "Kolhapur",
    city: "Kolhapur",
    country: "India",
    iata: "KLH",
    icao: "VAKP",
    latitude: "16.664658",
    longitude: "74.289353",
    altitude: "1996",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3014",
    name: "Keshod",
    city: "Keshod",
    country: "India",
    iata: "IXK",
    icao: "VAKS",
    latitude: "21.317069",
    longitude: "70.270403",
    altitude: "167",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3015",
    name: "Dr Ambedkar Intl",
    city: "Nagpur",
    country: "India",
    iata: "NAG",
    icao: "VANP",
    latitude: "21.092192",
    longitude: "79.047183",
    altitude: "1033",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3016",
    name: "Nasik Road",
    city: "Nasik Road",
    country: "India",
    iata: "ISK",
    icao: "VANR",
    latitude: "19.963739",
    longitude: "73.807644",
    altitude: "1959",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3017",
    name: "Pune",
    city: "Pune",
    country: "India",
    iata: "PNQ",
    icao: "VAPO",
    latitude: "18.582111",
    longitude: "73.919697",
    altitude: "1942",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3018",
    name: "Porbandar",
    city: "Porbandar",
    country: "India",
    iata: "PBD",
    icao: "VAPR",
    latitude: "21.648675",
    longitude: "69.657219",
    altitude: "23",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3019",
    name: "Rajkot",
    city: "Rajkot",
    country: "India",
    iata: "RAJ",
    icao: "VARK",
    latitude: "22.309183",
    longitude: "70.779525",
    altitude: "441",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3020",
    name: "Raipur",
    city: "Raipur",
    country: "India",
    iata: "RPR",
    icao: "VARP",
    latitude: "21.180406",
    longitude: "81.738753",
    altitude: "1041",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3021",
    name: "Sholapur",
    city: "Sholapur",
    country: "India",
    iata: "SSE",
    icao: "VASL",
    latitude: "17.627958",
    longitude: "75.934842",
    altitude: "1584",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3022",
    name: "Surat",
    city: "Surat",
    country: "India",
    iata: "STV",
    icao: "VASU",
    latitude: "21.114061",
    longitude: "72.741792",
    altitude: "16",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3023",
    name: "Udaipur",
    city: "Udaipur",
    country: "India",
    iata: "UDR",
    icao: "VAUD",
    latitude: "24.617697",
    longitude: "73.8961",
    altitude: "1684",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3024",
    name: "Bandaranaike Intl Colombo",
    city: "Colombo",
    country: "Sri Lanka",
    iata: "CMB",
    icao: "VCBI",
    latitude: "7.180756",
    longitude: "79.884117",
    altitude: "30",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "3025",
    name: "Anuradhapura",
    city: "Anuradhapura",
    country: "Sri Lanka",
    iata: "",
    icao: "VCCA",
    latitude: "8.301486",
    longitude: "80.4279",
    altitude: "324",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "3026",
    name: "Batticaloa",
    city: "Batticaloa",
    country: "Sri Lanka",
    iata: "",
    icao: "VCCB",
    latitude: "7.705756",
    longitude: "81.678783",
    altitude: "20",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "3027",
    name: "Colombo Ratmalana",
    city: "Colombo",
    country: "Sri Lanka",
    iata: "RML",
    icao: "VCCC",
    latitude: "6.821994",
    longitude: "79.886208",
    altitude: "22",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "3028",
    name: "Amparai",
    city: "Galoya",
    country: "Sri Lanka",
    iata: "GOY",
    icao: "VCCG",
    latitude: "7.337081",
    longitude: "81.625881",
    altitude: "150",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "3029",
    name: "Kankesanturai",
    city: "Jaffna",
    country: "Sri Lanka",
    iata: "JAF",
    icao: "VCCJ",
    latitude: "9.792331",
    longitude: "80.070089",
    altitude: "33",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "3030",
    name: "China Bay",
    city: "Trinciomalee",
    country: "Sri Lanka",
    iata: "TRR",
    icao: "VCCT",
    latitude: "8.538514",
    longitude: "81.181853",
    altitude: "6",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "6832",
    name: "Kirkuk AB",
    city: "Kirkuk",
    country: "Iraq",
    iata: "KIK",
    icao: "ORKK",
    latitude: "35.17",
    longitude: "44.3483",
    altitude: "1061",
    timezone: "3",
    dst: "N",
    tz: "Asia/Baghdad",
  },
  {
    id: "3033",
    name: "Kampong Chhnang",
    city: "Kompong Chnang",
    country: "Cambodia",
    iata: "",
    icao: "VDKH",
    latitude: "12.255236",
    longitude: "104.563875",
    altitude: "56",
    timezone: "7",
    dst: "U",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "3034",
    name: "Phnom Penh Intl",
    city: "Phnom-penh",
    country: "Cambodia",
    iata: "PNH",
    icao: "VDPP",
    latitude: "11.546556",
    longitude: "104.844139",
    altitude: "40",
    timezone: "7",
    dst: "U",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "3035",
    name: "Siem Reap",
    city: "Siem-reap",
    country: "Cambodia",
    iata: "REP",
    icao: "VDSR",
    latitude: "13.410666",
    longitude: "103.81284",
    altitude: "60",
    timezone: "7",
    dst: "U",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "3036",
    name: "Stung Treng",
    city: "Stung Treng",
    country: "Cambodia",
    iata: "",
    icao: "VDST",
    latitude: "13.531897",
    longitude: "106.014531",
    altitude: "203",
    timezone: "7",
    dst: "U",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "3037",
    name: "Along",
    city: "Along",
    country: "India",
    iata: "",
    icao: "VEAN",
    latitude: "28.175317",
    longitude: "94.802036",
    altitude: "900",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3038",
    name: "Agartala",
    city: "Agartala",
    country: "India",
    iata: "IXA",
    icao: "VEAT",
    latitude: "23.886978",
    longitude: "91.24045",
    altitude: "46",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3039",
    name: "Aizawl",
    city: "Aizwal",
    country: "India",
    iata: "AJL",
    icao: "VEAZ",
    latitude: "23.746603",
    longitude: "92.802767",
    altitude: "1001",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3040",
    name: "Bagdogra",
    city: "Baghdogra",
    country: "India",
    iata: "IXB",
    icao: "VEBD",
    latitude: "26.681206",
    longitude: "88.328567",
    altitude: "412",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3041",
    name: "Bokaro",
    city: "Bokaro",
    country: "India",
    iata: "",
    icao: "VEBK",
    latitude: "23.643489",
    longitude: "86.148886",
    altitude: "715",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3042",
    name: "Bhubaneshwar",
    city: "Bhubaneswar",
    country: "India",
    iata: "BBI",
    icao: "VEBS",
    latitude: "20.244364",
    longitude: "85.817781",
    altitude: "138",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3043",
    name: "Netaji Subhash Chandra Bose Intl",
    city: "Kolkata",
    country: "India",
    iata: "CCU",
    icao: "VECC",
    latitude: "22.654739",
    longitude: "88.446722",
    altitude: "16",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3044",
    name: "Cooch Behar",
    city: "Cooch-behar",
    country: "India",
    iata: "COH",
    icao: "VECO",
    latitude: "26.330508",
    longitude: "89.467203",
    altitude: "138",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3045",
    name: "Dhanbad",
    city: "Dhanbad",
    country: "India",
    iata: "DBD",
    icao: "VEDB",
    latitude: "23.834044",
    longitude: "86.425261",
    altitude: "847",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6800",
    name: "Delta County Airport",
    city: "Escanaba",
    country: "United States",
    iata: "ESC",
    icao: "KESC",
    latitude: "45.722778",
    longitude: "-87.093611",
    altitude: "609",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6801",
    name: "Lauf-Lillinghof",
    city: "Lillinghof",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.6543",
    longitude: "11.6539",
    altitude: "954",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "3048",
    name: "Gaya",
    city: "Gaya",
    country: "India",
    iata: "GAY",
    icao: "VEGY",
    latitude: "24.744308",
    longitude: "84.951175",
    altitude: "380",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3049",
    name: "Hirakud",
    city: "Hirakud",
    country: "India",
    iata: "",
    icao: "VEHK",
    latitude: "21.580231",
    longitude: "84.005728",
    altitude: "658",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3050",
    name: "Imphal",
    city: "Imphal",
    country: "India",
    iata: "IMF",
    icao: "VEIM",
    latitude: "24.75995",
    longitude: "93.896697",
    altitude: "2540",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3051",
    name: "Jharsuguda",
    city: "Jharsuguda",
    country: "India",
    iata: "",
    icao: "VEJH",
    latitude: "21.913536",
    longitude: "84.050383",
    altitude: "751",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3052",
    name: "Jamshedpur",
    city: "Jamshedpur",
    country: "India",
    iata: "IXW",
    icao: "VEJS",
    latitude: "22.813211",
    longitude: "86.168844",
    altitude: "505",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3053",
    name: "Jorhat",
    city: "Jorhat",
    country: "India",
    iata: "JRH",
    icao: "VEJT",
    latitude: "26.731528",
    longitude: "94.175536",
    altitude: "311",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3054",
    name: "Kailashahar",
    city: "Kailashahar",
    country: "India",
    iata: "IXH",
    icao: "VEKR",
    latitude: "24.308192",
    longitude: "92.007156",
    altitude: "79",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3055",
    name: "Silchar",
    city: "Silchar",
    country: "India",
    iata: "IXS",
    icao: "VEKU",
    latitude: "24.912928",
    longitude: "92.978742",
    altitude: "352",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3056",
    name: "Lilabari",
    city: "Lilabari",
    country: "India",
    iata: "IXI",
    icao: "VELR",
    latitude: "27.295494",
    longitude: "94.09765",
    altitude: "330",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3057",
    name: "Dibrugarh",
    city: "Mohanbari",
    country: "India",
    iata: "MOH",
    icao: "VEMN",
    latitude: "27.483853",
    longitude: "95.016922",
    altitude: "362",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3058",
    name: "Muzaffarpur",
    city: "Mazuffarpur",
    country: "India",
    iata: "",
    icao: "VEMZ",
    latitude: "26.119089",
    longitude: "85.313664",
    altitude: "174",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3059",
    name: "Nawapara",
    city: "Nawapara",
    country: "India",
    iata: "",
    icao: "VENP",
    latitude: "20.870036",
    longitude: "82.519553",
    altitude: "1058",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3060",
    name: "Panagarh",
    city: "Panagarh",
    country: "India",
    iata: "",
    icao: "VEPH",
    latitude: "23.474336",
    longitude: "87.427508",
    altitude: "240",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3061",
    name: "Patna",
    city: "Patina",
    country: "India",
    iata: "PAT",
    icao: "VEPT",
    latitude: "25.591317",
    longitude: "85.087992",
    altitude: "170",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3062",
    name: "Purnea",
    city: "Purnea",
    country: "India",
    iata: "",
    icao: "VEPU",
    latitude: "25.759594",
    longitude: "87.410011",
    altitude: "129",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3063",
    name: "Birsa Munda",
    city: "Ranchi",
    country: "India",
    iata: "IXR",
    icao: "VERC",
    latitude: "23.31425",
    longitude: "85.321675",
    altitude: "2148",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3064",
    name: "Rourkela",
    city: "Rourkela",
    country: "India",
    iata: "RRK",
    icao: "VERK",
    latitude: "22.25665",
    longitude: "84.814567",
    altitude: "659",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3065",
    name: "Utkela",
    city: "Utkela",
    country: "India",
    iata: "",
    icao: "VEUK",
    latitude: "20.097411",
    longitude: "83.183797",
    altitude: "680",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3066",
    name: "Vishakhapatnam",
    city: "Vishakhapatnam",
    country: "India",
    iata: "VTZ",
    icao: "VEVZ",
    latitude: "17.721167",
    longitude: "83.224483",
    altitude: "15",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3067",
    name: "Zero",
    city: "Zero",
    country: "India",
    iata: "",
    icao: "VEZO",
    latitude: "27.588283",
    longitude: "93.828061",
    altitude: "5403",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3068",
    name: "Coxs Bazar",
    city: "Cox's Bazar",
    country: "Bangladesh",
    iata: "CXB",
    icao: "VGCB",
    latitude: "21.452194",
    longitude: "91.963889",
    altitude: "12",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3069",
    name: "Shah Amanat Intl",
    city: "Chittagong",
    country: "Bangladesh",
    iata: "CGP",
    icao: "VGEG",
    latitude: "22.249611",
    longitude: "91.813286",
    altitude: "12",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3070",
    name: "Ishurdi",
    city: "Ishurdi",
    country: "Bangladesh",
    iata: "IRD",
    icao: "VGIS",
    latitude: "24.1525",
    longitude: "89.049446",
    altitude: "45",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3071",
    name: "Jessore",
    city: "Jessore",
    country: "Bangladesh",
    iata: "JSR",
    icao: "VGJR",
    latitude: "23.1838",
    longitude: "89.160833",
    altitude: "20",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3072",
    name: "Shah Mokhdum",
    city: "Rajshahi",
    country: "Bangladesh",
    iata: "RJH",
    icao: "VGRJ",
    latitude: "24.437219",
    longitude: "88.616511",
    altitude: "64",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3073",
    name: "Saidpur",
    city: "Saidpur",
    country: "Bangladesh",
    iata: "SPD",
    icao: "VGSD",
    latitude: "25.759228",
    longitude: "88.908869",
    altitude: "125",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3074",
    name: "Osmany Intl",
    city: "Sylhet Osmani",
    country: "Bangladesh",
    iata: "ZYL",
    icao: "VGSY",
    latitude: "24.963242",
    longitude: "91.866783",
    altitude: "50",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3075",
    name: "Tejgaon",
    city: "Dhaka",
    country: "Bangladesh",
    iata: "",
    icao: "VGTJ",
    latitude: "23.778783",
    longitude: "90.382689",
    altitude: "24",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3076",
    name: "Zia Intl",
    city: "Dhaka",
    country: "Bangladesh",
    iata: "DAC",
    icao: "VGZR",
    latitude: "23.843333",
    longitude: "90.397781",
    altitude: "30",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "3077",
    name: "Hong Kong Intl",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "HKG",
    icao: "VHHH",
    latitude: "22.308919",
    longitude: "113.914603",
    altitude: "28",
    timezone: "8",
    dst: "U",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "3078",
    name: "Sek Kong",
    city: "Sek Kong",
    country: "Hong Kong",
    iata: "",
    icao: "VHSK",
    latitude: "22.436592",
    longitude: "114.080397",
    altitude: "50",
    timezone: "8",
    dst: "U",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "3079",
    name: "Agra",
    city: "Agra",
    country: "India",
    iata: "AGR",
    icao: "VIAG",
    latitude: "27.155831",
    longitude: "77.960892",
    altitude: "551",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3080",
    name: "Allahabad",
    city: "Allahabad",
    country: "India",
    iata: "IXD",
    icao: "VIAL",
    latitude: "25.440064",
    longitude: "81.733872",
    altitude: "322",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3081",
    name: "Amritsar",
    city: "Amritsar",
    country: "India",
    iata: "ATQ",
    icao: "VIAR",
    latitude: "31.709594",
    longitude: "74.797264",
    altitude: "756",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3082",
    name: "Nal",
    city: "Bikaner",
    country: "India",
    iata: "",
    icao: "VIBK",
    latitude: "28.070606",
    longitude: "73.207161",
    altitude: "750",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3083",
    name: "Bakshi Ka Talab",
    city: "Bakshi Ka Talab",
    country: "India",
    iata: "",
    icao: "VIBL",
    latitude: "26.988339",
    longitude: "80.893117",
    altitude: "385",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3084",
    name: "Varanasi",
    city: "Varanasi",
    country: "India",
    iata: "VNS",
    icao: "VIBN",
    latitude: "25.452358",
    longitude: "82.859342",
    altitude: "266",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3085",
    name: "Kullu Manali",
    city: "Kulu",
    country: "India",
    iata: "KUU",
    icao: "VIBR",
    latitude: "31.876706",
    longitude: "77.154367",
    altitude: "3573",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3086",
    name: "Bhatinda",
    city: "Bhatinda",
    country: "India",
    iata: "",
    icao: "VIBT",
    latitude: "30.270139",
    longitude: "74.755772",
    altitude: "662",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3087",
    name: "Bhiwani",
    city: "Bhiwani",
    country: "India",
    iata: "",
    icao: "VIBW",
    latitude: "28.837039",
    longitude: "76.179094",
    altitude: "720",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3088",
    name: "Bareilly",
    city: "Bareilly",
    country: "India",
    iata: "",
    icao: "VIBY",
    latitude: "28.422061",
    longitude: "79.450842",
    altitude: "580",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3089",
    name: "Chandigarh",
    city: "Chandigarh",
    country: "India",
    iata: "IXC",
    icao: "VICG",
    latitude: "30.673469",
    longitude: "76.788542",
    altitude: "1012",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3090",
    name: "Kanpur Chakeri",
    city: "Kanpur",
    country: "India",
    iata: "",
    icao: "VICX",
    latitude: "26.4043",
    longitude: "80.410119",
    altitude: "405",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3091",
    name: "Safdarjung",
    city: "Delhi",
    country: "India",
    iata: "",
    icao: "VIDD",
    latitude: "28.584511",
    longitude: "77.205783",
    altitude: "705",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3092",
    name: "Dehradun",
    city: "Dehra Dun",
    country: "India",
    iata: "DED",
    icao: "VIDN",
    latitude: "30.189689",
    longitude: "78.180256",
    altitude: "1831",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3093",
    name: "Indira Gandhi Intl",
    city: "Delhi",
    country: "India",
    iata: "DEL",
    icao: "VIDP",
    latitude: "28.5665",
    longitude: "77.103088",
    altitude: "777",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3094",
    name: "Gwalior",
    city: "Gwalior",
    country: "India",
    iata: "GWL",
    icao: "VIGR",
    latitude: "26.293336",
    longitude: "78.227753",
    altitude: "617",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3095",
    name: "Hissar",
    city: "Hissar",
    country: "India",
    iata: "",
    icao: "VIHR",
    latitude: "29.179444",
    longitude: "75.755336",
    altitude: "700",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3096",
    name: "Jhansi",
    city: "Jhansi",
    country: "India",
    iata: "",
    icao: "VIJN",
    latitude: "25.491172",
    longitude: "78.558422",
    altitude: "801",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3097",
    name: "Jodhpur",
    city: "Jodhpur",
    country: "India",
    iata: "JDH",
    icao: "VIJO",
    latitude: "26.251092",
    longitude: "73.048869",
    altitude: "717",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3098",
    name: "Jaipur",
    city: "Jaipur",
    country: "India",
    iata: "JAI",
    icao: "VIJP",
    latitude: "26.824192",
    longitude: "75.812161",
    altitude: "1263",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3099",
    name: "Jaisalmer",
    city: "Jaisalmer",
    country: "India",
    iata: "JSA",
    icao: "VIJR",
    latitude: "26.888653",
    longitude: "70.864967",
    altitude: "751",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3100",
    name: "Jammu",
    city: "Jammu",
    country: "India",
    iata: "IXJ",
    icao: "VIJU",
    latitude: "32.689142",
    longitude: "74.837389",
    altitude: "1029",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3101",
    name: "Kanpur",
    city: "Kanpur",
    country: "India",
    iata: "KNU",
    icao: "VIKA",
    latitude: "26.441444",
    longitude: "80.364864",
    altitude: "411",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3102",
    name: "Kota",
    city: "Kota",
    country: "India",
    iata: "KTU",
    icao: "VIKO",
    latitude: "25.160219",
    longitude: "75.845631",
    altitude: "896",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3103",
    name: "Ludhiana",
    city: "Ludhiaha",
    country: "India",
    iata: "LUH",
    icao: "VILD",
    latitude: "30.854681",
    longitude: "75.952592",
    altitude: "834",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3104",
    name: "Leh",
    city: "Leh",
    country: "India",
    iata: "IXL",
    icao: "VILH",
    latitude: "34.135872",
    longitude: "77.546514",
    altitude: "10682",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3105",
    name: "Lucknow",
    city: "Lucknow",
    country: "India",
    iata: "LKO",
    icao: "VILK",
    latitude: "26.760594",
    longitude: "80.889339",
    altitude: "410",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3106",
    name: "Pathankot",
    city: "Pathankot",
    country: "India",
    iata: "IXP",
    icao: "VIPK",
    latitude: "32.233778",
    longitude: "75.634628",
    altitude: "1017",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3107",
    name: "Patiala",
    city: "Patiala",
    country: "India",
    iata: "",
    icao: "VIPL",
    latitude: "30.314847",
    longitude: "76.364469",
    altitude: "820",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3108",
    name: "Pantnagar",
    city: "Nainital",
    country: "India",
    iata: "PGH",
    icao: "VIPT",
    latitude: "29.033408",
    longitude: "79.473744",
    altitude: "769",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3109",
    name: "Fursatganj",
    city: "Raibarelli",
    country: "India",
    iata: "",
    icao: "VIRB",
    latitude: "26.248489",
    longitude: "81.380506",
    altitude: "360",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3111",
    name: "Sarsawa",
    city: "Saharanpur",
    country: "India",
    iata: "",
    icao: "VISP",
    latitude: "29.993919",
    longitude: "77.425311",
    altitude: "891",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3112",
    name: "Srinagar",
    city: "Srinagar",
    country: "India",
    iata: "SXR",
    icao: "VISR",
    latitude: "33.987139",
    longitude: "74.77425",
    altitude: "5429",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3113",
    name: "Satna",
    city: "Satna",
    country: "India",
    iata: "TNI",
    icao: "VIST",
    latitude: "24.562319",
    longitude: "80.854933",
    altitude: "1060",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6495",
    name: "Balkhash Airport",
    city: "Balkhash",
    country: "Kazakhstan",
    iata: "BXH",
    icao: "\\N",
    latitude: "46.8933",
    longitude: "75.005",
    altitude: "1446",
    timezone: "6",
    dst: "E",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "3115",
    name: "Luang Phabang Intl",
    city: "Luang Prabang",
    country: "Laos",
    iata: "LPQ",
    icao: "VLLB",
    latitude: "19.897914",
    longitude: "102.160764",
    altitude: "955",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "3116",
    name: "Pakse",
    city: "Pakse",
    country: "Laos",
    iata: "PKZ",
    icao: "VLPS",
    latitude: "15.132053",
    longitude: "105.781417",
    altitude: "351",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "3117",
    name: "Phonesavanh",
    city: "Phong Savanh",
    country: "Laos",
    iata: "",
    icao: "VLPV",
    latitude: "19.454864",
    longitude: "103.218208",
    altitude: "3628",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "3118",
    name: "Savannakhet",
    city: "Savannakhet",
    country: "Laos",
    iata: "ZVK",
    icao: "VLSK",
    latitude: "16.556594",
    longitude: "104.759531",
    altitude: "509",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "3119",
    name: "Sam Neua",
    city: "Sam Neua",
    country: "Laos",
    iata: "",
    icao: "VLSN",
    latitude: "20.418358",
    longitude: "104.066583",
    altitude: "3281",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "3120",
    name: "Wattay Intl",
    city: "Vientiane",
    country: "Laos",
    iata: "VTE",
    icao: "VLVT",
    latitude: "17.988322",
    longitude: "102.563256",
    altitude: "564",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "3121",
    name: "Macau Intl",
    city: "Macau",
    country: "Macau",
    iata: "MFM",
    icao: "VMMC",
    latitude: "22.149556",
    longitude: "113.591558",
    altitude: "20",
    timezone: "8",
    dst: "U",
    tz: "Asia/Macau",
  },
  {
    id: "3122",
    name: "Bhairahawa",
    city: "Bhairawa",
    country: "Nepal",
    iata: "BWA",
    icao: "VNBW",
    latitude: "27.505703",
    longitude: "83.41625",
    altitude: "358",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "6831",
    name: "Nastaetten",
    city: "Nastaetten",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.1972",
    longitude: "7.8916",
    altitude: "600",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "3124",
    name: "Janakpur",
    city: "Janakpur",
    country: "Nepal",
    iata: "",
    icao: "VNJP",
    latitude: "26.708806",
    longitude: "85.922394",
    altitude: "256",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "3125",
    name: "Tribhuvan Intl",
    city: "Kathmandu",
    country: "Nepal",
    iata: "KTM",
    icao: "VNKT",
    latitude: "27.696583",
    longitude: "85.3591",
    altitude: "4390",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "3127",
    name: "Pokhara",
    city: "Pokhara",
    country: "Nepal",
    iata: "PKR",
    icao: "VNPK",
    latitude: "28.200881",
    longitude: "83.982056",
    altitude: "2712",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "3128",
    name: "Simara",
    city: "Simara",
    country: "Nepal",
    iata: "SIF",
    icao: "VNSI",
    latitude: "27.159456",
    longitude: "84.980122",
    altitude: "450",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "3129",
    name: "Biratnagar",
    city: "Biratnagar",
    country: "Nepal",
    iata: "BIR",
    icao: "VNVT",
    latitude: "26.481453",
    longitude: "87.264036",
    altitude: "236",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "3130",
    name: "Agatti",
    city: "Agatti Island",
    country: "India",
    iata: "AGX",
    icao: "VOAT",
    latitude: "10.823656",
    longitude: "72.176042",
    altitude: "14",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3131",
    name: "Bangalore",
    city: "Bangalore",
    country: "India",
    iata: "BLR",
    icao: "VOBL",
    latitude: "12.949986",
    longitude: "77.668206",
    altitude: "2912",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3132",
    name: "Bellary",
    city: "Bellary",
    country: "India",
    iata: "BEP",
    icao: "VOBI",
    latitude: "15.162783",
    longitude: "76.882775",
    altitude: "30",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3133",
    name: "Bidar",
    city: "Bidar",
    country: "India",
    iata: "",
    icao: "VOBR",
    latitude: "17.908081",
    longitude: "77.487142",
    altitude: "2178",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3134",
    name: "Vijayawada",
    city: "Vijayawada",
    country: "India",
    iata: "VGA",
    icao: "VOBZ",
    latitude: "16.530433",
    longitude: "80.796847",
    altitude: "82",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3135",
    name: "Coimbatore",
    city: "Coimbatore",
    country: "India",
    iata: "CJB",
    icao: "VOCB",
    latitude: "11.030031",
    longitude: "77.043383",
    altitude: "1324",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3136",
    name: "Cochin",
    city: "Kochi",
    country: "India",
    iata: "COK",
    icao: "VOCI",
    latitude: "10.155556",
    longitude: "76.391389",
    altitude: "8",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3137",
    name: "Calicut",
    city: "Calicut",
    country: "India",
    iata: "CCJ",
    icao: "VOCL",
    latitude: "11.136839",
    longitude: "75.9553",
    altitude: "342",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3138",
    name: "Cuddapah",
    city: "Cuddapah",
    country: "India",
    iata: "CDP",
    icao: "VOCP",
    latitude: "14.509961",
    longitude: "78.772833",
    altitude: "430",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3139",
    name: "Carnicobar",
    city: "Carnicobar",
    country: "India",
    iata: "",
    icao: "VOCX",
    latitude: "9.152508",
    longitude: "92.819628",
    altitude: "5",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3140",
    name: "Dundigul",
    city: "Dundigul",
    country: "India",
    iata: "",
    icao: "VODG",
    latitude: "17.627178",
    longitude: "78.403361",
    altitude: "2013",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3141",
    name: "Hyderabad",
    city: "Hyderabad",
    country: "India",
    iata: "HYD",
    icao: "VOHY",
    latitude: "17.453117",
    longitude: "78.467586",
    altitude: "1742",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3142",
    name: "Madurai",
    city: "Madurai",
    country: "India",
    iata: "IXM",
    icao: "VOMD",
    latitude: "9.834508",
    longitude: "78.093378",
    altitude: "459",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3143",
    name: "Mangalore",
    city: "Mangalore",
    country: "India",
    iata: "IXE",
    icao: "VOML",
    latitude: "12.961267",
    longitude: "74.890069",
    altitude: "337",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3144",
    name: "Chennai Intl",
    city: "Madras",
    country: "India",
    iata: "MAA",
    icao: "VOMM",
    latitude: "12.994414",
    longitude: "80.180517",
    altitude: "52",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3145",
    name: "Nagarjuna Sagar",
    city: "Nagarjunsagar",
    country: "India",
    iata: "",
    icao: "VONS",
    latitude: "16.542653",
    longitude: "79.318714",
    altitude: "658",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3146",
    name: "Port Blair",
    city: "Port Blair",
    country: "India",
    iata: "IXZ",
    icao: "VOPB",
    latitude: "11.641161",
    longitude: "92.729744",
    altitude: "14",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3147",
    name: "Pondicherry",
    city: "Pendicherry",
    country: "India",
    iata: "PNY",
    icao: "VOPC",
    latitude: "11.968722",
    longitude: "79.810058",
    altitude: "118",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3148",
    name: "Rajahmundry",
    city: "Rajahmundry",
    country: "India",
    iata: "RJA",
    icao: "VORY",
    latitude: "17.110361",
    longitude: "81.818208",
    altitude: "151",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3149",
    name: "Salem",
    city: "Salem",
    country: "India",
    iata: "",
    icao: "VOSM",
    latitude: "11.783314",
    longitude: "78.065606",
    altitude: "1008",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3150",
    name: "Tanjore",
    city: "Tanjore",
    country: "India",
    iata: "",
    icao: "VOTJ",
    latitude: "10.722428",
    longitude: "79.101567",
    altitude: "253",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3151",
    name: "Tirupati",
    city: "Tirupeti",
    country: "India",
    iata: "TIR",
    icao: "VOTP",
    latitude: "13.632492",
    longitude: "79.543256",
    altitude: "350",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3152",
    name: "Trichy",
    city: "Tiruchirappalli",
    country: "India",
    iata: "TRZ",
    icao: "VOTR",
    latitude: "10.765364",
    longitude: "78.709722",
    altitude: "288",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3153",
    name: "Thiruvananthapuram Intl",
    city: "Trivandrum",
    country: "India",
    iata: "TRV",
    icao: "VOTV",
    latitude: "8.482122",
    longitude: "76.920114",
    altitude: "15",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3154",
    name: "Tambaram",
    city: "Tambaram",
    country: "India",
    iata: "",
    icao: "VOTX",
    latitude: "12.907214",
    longitude: "80.121861",
    altitude: "90",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "3155",
    name: "Paro",
    city: "Thimphu",
    country: "Bhutan",
    iata: "PBH",
    icao: "VQPR",
    latitude: "27.403192",
    longitude: "89.424606",
    altitude: "7332",
    timezone: "6",
    dst: "N",
    tz: "Asia/Thimphu",
  },
  {
    id: "3156",
    name: "Male Intl",
    city: "Male",
    country: "Maldives",
    iata: "MLE",
    icao: "VRMM",
    latitude: "4.191833",
    longitude: "73.529128",
    altitude: "6",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "3157",
    name: "Don Muang Intl",
    city: "Bangkok",
    country: "Thailand",
    iata: "DMK",
    icao: "VTBD",
    latitude: "13.912583",
    longitude: "100.60675",
    altitude: "9",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3158",
    name: "Kamphaeng Saen",
    city: "Nakhon Pathom",
    country: "Thailand",
    iata: "",
    icao: "VTBK",
    latitude: "14.101975",
    longitude: "99.917219",
    altitude: "30",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3159",
    name: "Khok Kathiam",
    city: "Lop Buri",
    country: "Thailand",
    iata: "",
    icao: "VTBL",
    latitude: "14.874561",
    longitude: "100.663367",
    altitude: "123",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3886",
    name: "Naha",
    city: "Naha",
    country: "Indonesia",
    iata: "NAH",
    icao: "WAMH",
    latitude: "3.683214",
    longitude: "125.528019",
    altitude: "16",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3161",
    name: "U Taphao Intl",
    city: "Pattaya",
    country: "Thailand",
    iata: "UTP",
    icao: "VTBU",
    latitude: "12.679944",
    longitude: "101.005028",
    altitude: "42",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3162",
    name: "Watthana Nakhon",
    city: "Prachin Buri",
    country: "Thailand",
    iata: "",
    icao: "VTBW",
    latitude: "13.7688",
    longitude: "102.315492",
    altitude: "200",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3163",
    name: "Lampang",
    city: "Lampang",
    country: "Thailand",
    iata: "LPT",
    icao: "VTCL",
    latitude: "18.270933",
    longitude: "99.504167",
    altitude: "811",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3164",
    name: "Phrae",
    city: "Phrae",
    country: "Thailand",
    iata: "PRH",
    icao: "VTCP",
    latitude: "18.132169",
    longitude: "100.164664",
    altitude: "538",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3165",
    name: "Hua Hin",
    city: "Prachuap Khiri Khan",
    country: "Thailand",
    iata: "HHQ",
    icao: "VTPH",
    latitude: "12.636225",
    longitude: "99.951533",
    altitude: "62",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3166",
    name: "Takhli",
    city: "Nakhon Sawan",
    country: "Thailand",
    iata: "",
    icao: "VTPI",
    latitude: "15.277306",
    longitude: "100.295861",
    altitude: "107",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3167",
    name: "Sak Long",
    city: "Phetchabun",
    country: "Thailand",
    iata: "",
    icao: "VTPL",
    latitude: "16.824322",
    longitude: "101.251389",
    altitude: "500",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3169",
    name: "Nakhon Sawan",
    city: "Nakhon Sawan",
    country: "Thailand",
    iata: "",
    icao: "VTPN",
    latitude: "15.672997",
    longitude: "100.136794",
    altitude: "113",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3170",
    name: "Phitsanulok",
    city: "Phitsanulok",
    country: "Thailand",
    iata: "PHS",
    icao: "VTPP",
    latitude: "16.782939",
    longitude: "100.279122",
    altitude: "154",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3171",
    name: "Khunan Phumipol",
    city: "Tak",
    country: "Thailand",
    iata: "",
    icao: "VTPY",
    latitude: "17.234211",
    longitude: "99.057911",
    altitude: "492",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3172",
    name: "Khoun Khan",
    city: "Satun",
    country: "Thailand",
    iata: "",
    icao: "VTSA",
    latitude: "6.661403",
    longitude: "100.080317",
    altitude: "18",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3173",
    name: "Narathiwat",
    city: "Narathiwat",
    country: "Thailand",
    iata: "NAW",
    icao: "VTSC",
    latitude: "6.519922",
    longitude: "101.7434",
    altitude: "16",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3174",
    name: "Krabi",
    city: "Krabi",
    country: "Thailand",
    iata: "KBV",
    icao: "VTSG",
    latitude: "8.095969",
    longitude: "98.988764",
    altitude: "93",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3175",
    name: "Songkhla",
    city: "Songkhla",
    country: "Thailand",
    iata: "",
    icao: "VTSH",
    latitude: "7.186564",
    longitude: "100.608031",
    altitude: "12",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3176",
    name: "Pattani",
    city: "Pattani",
    country: "Thailand",
    iata: "PAN",
    icao: "VTSK",
    latitude: "6.785458",
    longitude: "101.153569",
    altitude: "8",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3177",
    name: "Samui",
    city: "Ko Samui",
    country: "Thailand",
    iata: "USM",
    icao: "VTSM",
    latitude: "9.547794",
    longitude: "100.062272",
    altitude: "64",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3178",
    name: "Cha Ian",
    city: "Nakhon Si Thammarat",
    country: "Thailand",
    iata: "",
    icao: "VTSN",
    latitude: "8.471147",
    longitude: "99.955625",
    altitude: "44",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3179",
    name: "Phuket Intl",
    city: "Phuket",
    country: "Thailand",
    iata: "HKT",
    icao: "VTSP",
    latitude: "8.1132",
    longitude: "98.316872",
    altitude: "82",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3180",
    name: "Ranong",
    city: "Ranong",
    country: "Thailand",
    iata: "",
    icao: "VTSR",
    latitude: "9.777622",
    longitude: "98.585483",
    altitude: "57",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3181",
    name: "Hat Yai Intl",
    city: "Hat Yai",
    country: "Thailand",
    iata: "HDY",
    icao: "VTSS",
    latitude: "6.933206",
    longitude: "100.392975",
    altitude: "90",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3182",
    name: "Trang",
    city: "Trang",
    country: "Thailand",
    iata: "TST",
    icao: "VTST",
    latitude: "7.508744",
    longitude: "99.616578",
    altitude: "67",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3183",
    name: "Udon Thani",
    city: "Udon Thani",
    country: "Thailand",
    iata: "UTH",
    icao: "VTUD",
    latitude: "17.386436",
    longitude: "102.788247",
    altitude: "579",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3184",
    name: "Sakon Nakhon",
    city: "Sakon Nakhon",
    country: "Thailand",
    iata: "SNO",
    icao: "VTUI",
    latitude: "17.195142",
    longitude: "104.118625",
    altitude: "529",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3185",
    name: "Surin",
    city: "Surin",
    country: "Thailand",
    iata: "",
    icao: "VTUJ",
    latitude: "14.868264",
    longitude: "103.498256",
    altitude: "478",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3186",
    name: "Loei",
    city: "Loei",
    country: "Thailand",
    iata: "LOE",
    icao: "VTUL",
    latitude: "17.439133",
    longitude: "101.722064",
    altitude: "860",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3187",
    name: "Khorat",
    city: "Nakhon Ratchasima",
    country: "Thailand",
    iata: "",
    icao: "VTUN",
    latitude: "14.934514",
    longitude: "102.078639",
    altitude: "729",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3188",
    name: "Rob Muang",
    city: "Roi Et",
    country: "Thailand",
    iata: "",
    icao: "VTUR",
    latitude: "16.07035",
    longitude: "103.6459",
    altitude: "459",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "6830",
    name: "Finsterwalde-Heinrichsruh",
    city: "Finsterwalde",
    country: "Germany",
    iata: "",
    icao: "EDAS",
    latitude: "51.6377",
    longitude: "13.2419",
    altitude: "384",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6829",
    name: "Orchid Beach",
    city: "Fraser Island",
    country: "Australia",
    iata: "OKB",
    icao: "KOKB",
    latitude: "-24.95841",
    longitude: "153.3145",
    altitude: "6",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6828",
    name: "Mara Lodges",
    city: "Mara Lodges",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.183581",
    longitude: "35.099931",
    altitude: "5600",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "3196",
    name: "Danang Intl",
    city: "Danang",
    country: "Vietnam",
    iata: "DAD",
    icao: "VVDN",
    latitude: "16.043917",
    longitude: "108.19937",
    altitude: "33",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3197",
    name: "Hanoi Gia Lam",
    city: "Hanoi",
    country: "Vietnam",
    iata: "",
    icao: "VVGL",
    latitude: "21.040975",
    longitude: "105.886011",
    altitude: "50",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3198",
    name: "Kep",
    city: "Kep",
    country: "Vietnam",
    iata: "",
    icao: "VVKP",
    latitude: "21.394639",
    longitude: "106.261083",
    altitude: "55",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3199",
    name: "Noibai Intl",
    city: "Hanoi",
    country: "Vietnam",
    iata: "HAN",
    icao: "VVNB",
    latitude: "21.221192",
    longitude: "105.807178",
    altitude: "39",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3200",
    name: "Nhatrang",
    city: "Nhatrang",
    country: "Vietnam",
    iata: "NHA",
    icao: "VVNT",
    latitude: "12.227467",
    longitude: "109.192322",
    altitude: "20",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3201",
    name: "Phubai",
    city: "Hue",
    country: "Vietnam",
    iata: "",
    icao: "VVPB",
    latitude: "16.4015",
    longitude: "107.702614",
    altitude: "48",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6827",
    name: "Namanga",
    city: "Namanga",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-2.55",
    longitude: "36.7833333",
    altitude: "4445",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "3204",
    name: "Phu Quoc",
    city: "Phuquoc",
    country: "Vietnam",
    iata: "",
    icao: "VVPQ",
    latitude: "10.227025",
    longitude: "103.967169",
    altitude: "23",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3205",
    name: "Tansonnhat Intl",
    city: "Ho Chi Minh City",
    country: "Vietnam",
    iata: "SGN",
    icao: "VVTS",
    latitude: "10.818797",
    longitude: "106.651856",
    altitude: "33",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "3207",
    name: "Ann",
    city: "Ann",
    country: "Burma",
    iata: "",
    icao: "VYAN",
    latitude: "19.769156",
    longitude: "94.026133",
    altitude: "74",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3208",
    name: "Anisakan",
    city: "Anisakan",
    country: "Burma",
    iata: "",
    icao: "VYAS",
    latitude: "21.955433",
    longitude: "96.40605",
    altitude: "3000",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3209",
    name: "Bagan",
    city: "Bagan",
    country: "Burma",
    iata: "",
    icao: "VYBG",
    latitude: "21.178756",
    longitude: "94.930169",
    altitude: "312",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6826",
    name: "Bamburi",
    city: "Bamburi",
    country: "Kenya",
    iata: "BMQ",
    icao: "KBMQ",
    latitude: "-3.98268888888889",
    longitude: "39.7308972222222",
    altitude: "50",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "3211",
    name: "Coco Island",
    city: "Coco Island",
    country: "Burma",
    iata: "",
    icao: "VYCI",
    latitude: "14.141517",
    longitude: "93.368531",
    altitude: "20",
    timezone: "6",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "3213",
    name: "Heho",
    city: "Heho",
    country: "Burma",
    iata: "HEH",
    icao: "VYHH",
    latitude: "20.747036",
    longitude: "96.792044",
    altitude: "3858",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3214",
    name: "Hommalinn",
    city: "Hommalin",
    country: "Burma",
    iata: "",
    icao: "VYHL",
    latitude: "24.899597",
    longitude: "94.914033",
    altitude: "534",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3215",
    name: "Kengtung",
    city: "Kengtung",
    country: "Burma",
    iata: "KET",
    icao: "VYKG",
    latitude: "21.301611",
    longitude: "99.635997",
    altitude: "2798",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6825",
    name: "Williamson Country Regional Airport",
    city: "Marion",
    country: "United States",
    iata: "MWA",
    icao: "KMWA",
    latitude: "37.7549569",
    longitude: "-89.0110936",
    altitude: "472",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3217",
    name: "Kyaukpyu",
    city: "Kyaukpyu",
    country: "Burma",
    iata: "KYP",
    icao: "VYKP",
    latitude: "19.426447",
    longitude: "93.534836",
    altitude: "20",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6824",
    name: "Lommis Airport",
    city: "Lommis",
    country: "Switzerland",
    iata: "",
    icao: "LSZT",
    latitude: "47.5244",
    longitude: "9.00306",
    altitude: "1539",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "3220",
    name: "Lashio",
    city: "Lashio",
    country: "Burma",
    iata: "LSH",
    icao: "VYLS",
    latitude: "22.977881",
    longitude: "97.752183",
    altitude: "2450",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3221",
    name: "Lanywa",
    city: "Lanywa",
    country: "Burma",
    iata: "",
    icao: "VYLY",
    latitude: "20.940361",
    longitude: "94.822617",
    altitude: "175",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3222",
    name: "Mandalay Intl",
    city: "Mandalay",
    country: "Burma",
    iata: "MDL",
    icao: "VYMD",
    latitude: "21.702156",
    longitude: "95.977928",
    altitude: "300",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3223",
    name: "Myeik",
    city: "Myeik",
    country: "Burma",
    iata: "MGZ",
    icao: "VYME",
    latitude: "12.439797",
    longitude: "98.621478",
    altitude: "75",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3224",
    name: "Myitkyina",
    city: "Myitkyina",
    country: "Burma",
    iata: "MYT",
    icao: "VYMK",
    latitude: "25.383636",
    longitude: "97.351919",
    altitude: "475",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3226",
    name: "Momeik",
    city: "Momeik",
    country: "Burma",
    iata: "",
    icao: "VYMO",
    latitude: "23.092525",
    longitude: "96.645272",
    altitude: "600",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3227",
    name: "Mong Hsat",
    city: "Mong Hsat",
    country: "Burma",
    iata: "MOG",
    icao: "VYMS",
    latitude: "20.516758",
    longitude: "99.256825",
    altitude: "1875",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3228",
    name: "Nampong",
    city: "Nampong",
    country: "Burma",
    iata: "",
    icao: "VYNP",
    latitude: "25.354375",
    longitude: "97.29515",
    altitude: "459",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3229",
    name: "Namsang",
    city: "Namsang",
    country: "Burma",
    iata: "",
    icao: "VYNS",
    latitude: "20.890492",
    longitude: "97.735922",
    altitude: "3100",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3230",
    name: "Hpa An",
    city: "Hpa-an",
    country: "Burma",
    iata: "",
    icao: "VYPA",
    latitude: "16.893714",
    longitude: "97.674581",
    altitude: "150",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6823",
    name: "Amlikon Glider Airport",
    city: "Amlikon",
    country: "Switzerland",
    iata: "",
    icao: "LSPA",
    latitude: "47.5742",
    longitude: "9.0475",
    altitude: "1371",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "3232",
    name: "Putao",
    city: "Putao",
    country: "Burma",
    iata: "PBU",
    icao: "VYPT",
    latitude: "27.329922",
    longitude: "97.426269",
    altitude: "1500",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3233",
    name: "Pyay",
    city: "Pyay",
    country: "Burma",
    iata: "",
    icao: "VYPY",
    latitude: "18.824478",
    longitude: "95.266003",
    altitude: "120",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3234",
    name: "Shante",
    city: "Shante",
    country: "Burma",
    iata: "",
    icao: "VYST",
    latitude: "20.941668",
    longitude: "95.914497",
    altitude: "630",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3235",
    name: "Sittwe",
    city: "Sittwe",
    country: "Burma",
    iata: "AKY",
    icao: "VYSW",
    latitude: "20.132708",
    longitude: "92.872628",
    altitude: "27",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3236",
    name: "Thandwe",
    city: "Thandwe",
    country: "Burma",
    iata: "SNW",
    icao: "VYTD",
    latitude: "18.460731",
    longitude: "94.300119",
    altitude: "20",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3237",
    name: "Tachileik",
    city: "Tachilek",
    country: "Burma",
    iata: "THL",
    icao: "VYTL",
    latitude: "20.483831",
    longitude: "99.935353",
    altitude: "1280",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3238",
    name: "Taungoo",
    city: "Taungoo",
    country: "Burma",
    iata: "",
    icao: "VYTO",
    latitude: "19.031275",
    longitude: "96.401239",
    altitude: "160",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3239",
    name: "Yangon Intl",
    city: "Yangon",
    country: "Burma",
    iata: "RGN",
    icao: "VYYY",
    latitude: "16.907305",
    longitude: "96.133222",
    altitude: "109",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "3240",
    name: "Hasanuddin",
    city: "Ujung Pandang",
    country: "Indonesia",
    iata: "UPG",
    icao: "WAAA",
    latitude: "-5.061631",
    longitude: "119.554042",
    altitude: "47",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3241",
    name: "Frans Kaisiepo",
    city: "Biak",
    country: "Indonesia",
    iata: "BIK",
    icao: "WABB",
    latitude: "-1.190017",
    longitude: "136.107997",
    altitude: "46",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3242",
    name: "Nabire",
    city: "Nabire",
    country: "Indonesia",
    iata: "NBX",
    icao: "WABI",
    latitude: "-3.368183",
    longitude: "135.496406",
    altitude: "20",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3243",
    name: "Moses Kilangin",
    city: "Timika",
    country: "Indonesia",
    iata: "TIM",
    icao: "WABP",
    latitude: "-4.528275",
    longitude: "136.887375",
    altitude: "103",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3244",
    name: "Sentani",
    city: "Jayapura",
    country: "Indonesia",
    iata: "DJJ",
    icao: "WAJJ",
    latitude: "-2.576953",
    longitude: "140.516372",
    altitude: "289",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3245",
    name: "Wamena",
    city: "Wamena",
    country: "Indonesia",
    iata: "WMX",
    icao: "WAJW",
    latitude: "-4.102511",
    longitude: "138.957372",
    altitude: "5085",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3246",
    name: "Mopah",
    city: "Merauke",
    country: "Indonesia",
    iata: "MKQ",
    icao: "WAKK",
    latitude: "-8.520294",
    longitude: "140.418453",
    altitude: "10",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3247",
    name: "Jalaluddin",
    city: "Gorontalo",
    country: "Indonesia",
    iata: "GTO",
    icao: "WAMG",
    latitude: "0.637119",
    longitude: "122.849858",
    altitude: "105",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3930",
    name: "Incheon Intl",
    city: "Seoul",
    country: "South Korea",
    iata: "ICN",
    icao: "RKSI",
    latitude: "37.469075",
    longitude: "126.450517",
    altitude: "23",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "3249",
    name: "Mutiara",
    city: "Palu",
    country: "Indonesia",
    iata: "PLW",
    icao: "WAML",
    latitude: "-0.918542",
    longitude: "119.909642",
    altitude: "284",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3250",
    name: "Sam Ratulangi",
    city: "Manado",
    country: "Indonesia",
    iata: "MDC",
    icao: "WAMM",
    latitude: "1.549447",
    longitude: "124.925878",
    altitude: "264",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3251",
    name: "Kasiguncu",
    city: "Poso",
    country: "Indonesia",
    iata: "PSJ",
    icao: "WAMP",
    latitude: "-1.416753",
    longitude: "120.657669",
    altitude: "174",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3252",
    name: "Pitu",
    city: "Morotai Island",
    country: "Indonesia",
    iata: "OTI",
    icao: "WAMR",
    latitude: "2.045992",
    longitude: "128.324708",
    altitude: "49",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3253",
    name: "Sultan Babullah",
    city: "Ternate",
    country: "Indonesia",
    iata: "TTE",
    icao: "WAMT",
    latitude: "0.831414",
    longitude: "127.381486",
    altitude: "49",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3254",
    name: "Bubung",
    city: "Luwuk",
    country: "Indonesia",
    iata: "LUW",
    icao: "WAMW",
    latitude: "-1.038919",
    longitude: "122.771906",
    altitude: "56",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6821",
    name: "Mukachevo Air Base",
    city: "Mukacheve",
    country: "Ukraine",
    iata: "",
    icao: "\\N",
    latitude: "48.4",
    longitude: "22.6833",
    altitude: "390",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "3256",
    name: "Pattimura",
    city: "Ambon",
    country: "Indonesia",
    iata: "AMQ",
    icao: "WAPP",
    latitude: "-3.710264",
    longitude: "128.089136",
    altitude: "33",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3257",
    name: "Fak Fak",
    city: "Fak Fak",
    country: "Indonesia",
    iata: "FKQ",
    icao: "WASF",
    latitude: "-2.920192",
    longitude: "132.267031",
    altitude: "462",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3258",
    name: "Kaimana",
    city: "Kaimana",
    country: "Indonesia",
    iata: "KNG",
    icao: "WASK",
    latitude: "-3.644517",
    longitude: "133.695553",
    altitude: "19",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3259",
    name: "Babo",
    city: "Babo",
    country: "Indonesia",
    iata: "BXB",
    icao: "WASO",
    latitude: "-2.532242",
    longitude: "133.438894",
    altitude: "10",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3260",
    name: "Rendani",
    city: "Manokwari",
    country: "Indonesia",
    iata: "MKW",
    icao: "WASR",
    latitude: "-0.891833",
    longitude: "134.049183",
    altitude: "23",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3261",
    name: "Jefman",
    city: "Sorong",
    country: "Indonesia",
    iata: "SOQ",
    icao: "WASS",
    latitude: "-0.926358",
    longitude: "131.121194",
    altitude: "10",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "3262",
    name: "Bintulu",
    city: "Bintulu",
    country: "Malaysia",
    iata: "BTU",
    icao: "WBGB",
    latitude: "3.12385",
    longitude: "113.020472",
    altitude: "74",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3263",
    name: "Kuching Intl",
    city: "Kuching",
    country: "Malaysia",
    iata: "KCH",
    icao: "WBGG",
    latitude: "1.484697",
    longitude: "110.346933",
    altitude: "89",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3264",
    name: "Limbang",
    city: "Limbang",
    country: "Malaysia",
    iata: "LMN",
    icao: "WBGJ",
    latitude: "4.808303",
    longitude: "115.010439",
    altitude: "14",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3265",
    name: "Marudi",
    city: "Marudi",
    country: "Malaysia",
    iata: "MUR",
    icao: "WBGM",
    latitude: "4.1775",
    longitude: "114.321944",
    altitude: "103",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3266",
    name: "Miri",
    city: "Miri",
    country: "Malaysia",
    iata: "MYY",
    icao: "WBGR",
    latitude: "4.322014",
    longitude: "113.986806",
    altitude: "59",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3267",
    name: "Sibu",
    city: "Sibu",
    country: "Malaysia",
    iata: "SBW",
    icao: "WBGS",
    latitude: "2.261603",
    longitude: "111.985322",
    altitude: "122",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3268",
    name: "Lahad Datu",
    city: "Lahad Datu",
    country: "Malaysia",
    iata: "LDU",
    icao: "WBKD",
    latitude: "5.032247",
    longitude: "118.324036",
    altitude: "45",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3269",
    name: "Kota Kinabalu Intl",
    city: "Kota Kinabalu",
    country: "Malaysia",
    iata: "BKI",
    icao: "WBKK",
    latitude: "5.937208",
    longitude: "116.051181",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3270",
    name: "Labuan",
    city: "Labuan",
    country: "Malaysia",
    iata: "LBU",
    icao: "WBKL",
    latitude: "5.300683",
    longitude: "115.250181",
    altitude: "101",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3271",
    name: "Tawau",
    city: "Tawau",
    country: "Malaysia",
    iata: "TWU",
    icao: "WBKW",
    latitude: "4.313369",
    longitude: "118.121953",
    altitude: "57",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3272",
    name: "Brunei Intl",
    city: "Bandar Seri Begawan",
    country: "Brunei",
    iata: "BWN",
    icao: "WBSB",
    latitude: "4.9442",
    longitude: "114.928353",
    altitude: "73",
    timezone: "8",
    dst: "U",
    tz: "Asia/Brunei",
  },
  {
    id: "3273",
    name: "Sultan Syarif Kasim Ii",
    city: "Pekanbaru",
    country: "Indonesia",
    iata: "PKU",
    icao: "WIBB",
    latitude: "0.460786",
    longitude: "101.444539",
    altitude: "102",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3274",
    name: "Pinang Kampai",
    city: "Dumai",
    country: "Indonesia",
    iata: "DUM",
    icao: "WIBD",
    latitude: "1.609194",
    longitude: "101.433558",
    altitude: "55",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3275",
    name: "Soekarno Hatta Intl",
    city: "Jakarta",
    country: "Indonesia",
    iata: "CGK",
    icao: "WIII",
    latitude: "-6.125567",
    longitude: "106.655897",
    altitude: "34",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3276",
    name: "Binaka",
    city: "Gunung Sitoli",
    country: "Indonesia",
    iata: "GNS",
    icao: "WIMB",
    latitude: "1.166381",
    longitude: "97.704681",
    altitude: "20",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3277",
    name: "Aek Godang",
    city: "Padang Sidempuan",
    country: "Indonesia",
    iata: "",
    icao: "WIME",
    latitude: "1.400103",
    longitude: "99.430453",
    altitude: "922",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3278",
    name: "Minangkabau",
    city: "Padang",
    country: "Indonesia",
    iata: "PDG",
    icao: "WIPT",
    latitude: "-0.874989",
    longitude: "100.351881",
    altitude: "9",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3279",
    name: "Polonia",
    city: "Medan",
    country: "Indonesia",
    iata: "MES",
    icao: "WIMM",
    latitude: "3.558056",
    longitude: "98.671722",
    altitude: "114",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3280",
    name: "Dr Ferdinand Lumban Tobing",
    city: "Sibolga",
    country: "Indonesia",
    iata: "",
    icao: "WIMS",
    latitude: "1.555944",
    longitude: "98.888908",
    altitude: "43",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3281",
    name: "Nanga Pinoh I",
    city: "Nangapinoh",
    country: "Indonesia",
    iata: "",
    icao: "WIOG",
    latitude: "-0.348869",
    longitude: "111.747606",
    altitude: "123",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3282",
    name: "Rahadi Usman",
    city: "Ketapang",
    country: "Indonesia",
    iata: "KTG",
    icao: "WIOK",
    latitude: "-1.816639",
    longitude: "109.963483",
    altitude: "46",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6820",
    name: "Mukachevo",
    city: "Mukacheve",
    country: "Ukraine",
    iata: "",
    icao: "\\N",
    latitude: "48.4",
    longitude: "22.683",
    altitude: "390",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "3284",
    name: "Supadio",
    city: "Pontianak",
    country: "Indonesia",
    iata: "PNK",
    icao: "WIOO",
    latitude: "-0.150711",
    longitude: "109.403892",
    altitude: "10",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6819",
    name: "Borovaya Airfield",
    city: "Minsk",
    country: "Belarus",
    iata: "",
    icao: "UMMB",
    latitude: "53.57",
    longitude: "27.39",
    altitude: "0",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "6798",
    name: "Weser-Wuemme",
    city: "Hellwege",
    country: "Germany",
    iata: "",
    icao: "EDWM",
    latitude: "53.054",
    longitude: "9.208667",
    altitude: "59",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "3287",
    name: "Sultan Thaha",
    city: "Jambi",
    country: "Indonesia",
    iata: "DJB",
    icao: "WIPA",
    latitude: "-1.638017",
    longitude: "103.644378",
    altitude: "82",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3288",
    name: "Fatmawati Soekarno",
    city: "Bengkulu",
    country: "Indonesia",
    iata: "BKS",
    icao: "WIPL",
    latitude: "-3.8637",
    longitude: "102.339036",
    altitude: "50",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3289",
    name: "Sultan Mahmud Badaruddin Ii",
    city: "Palembang",
    country: "Indonesia",
    iata: "PLM",
    icao: "WIPP",
    latitude: "-2.89825",
    longitude: "104.699903",
    altitude: "49",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3291",
    name: "Japura",
    city: "Rengat",
    country: "Indonesia",
    iata: "RGT",
    icao: "WIPR",
    latitude: "-0.352808",
    longitude: "102.334917",
    altitude: "62",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3292",
    name: "Lhok Sukon",
    city: "Lhok Sukon",
    country: "Indonesia",
    iata: "",
    icao: "WITL",
    latitude: "5.069506",
    longitude: "97.259192",
    altitude: "28",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6818",
    name: "Balti International Airport",
    city: "Strymba",
    country: "Moldova",
    iata: "BZY",
    icao: "\\N",
    latitude: "47.8381",
    longitude: "27.7815",
    altitude: "758",
    timezone: "2",
    dst: "U",
    tz: "Europe/Chisinau",
  },
  {
    id: "3294",
    name: "Sultan Iskandarmuda",
    city: "Banda Aceh",
    country: "Indonesia",
    iata: "BTJ",
    icao: "WITT",
    latitude: "5.523522",
    longitude: "95.420372",
    altitude: "65",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3295",
    name: "Kluang",
    city: "Kluang",
    country: "Malaysia",
    iata: "",
    icao: "WMAP",
    latitude: "2.041394",
    longitude: "103.307394",
    altitude: "150",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3296",
    name: "Sultan Abdul Halim",
    city: "Alor Setar",
    country: "Malaysia",
    iata: "AOR",
    icao: "WMKA",
    latitude: "6.189667",
    longitude: "100.398183",
    altitude: "15",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3297",
    name: "Butterworth",
    city: "Butterworth",
    country: "Malaysia",
    iata: "",
    icao: "WMKB",
    latitude: "5.465917",
    longitude: "100.391167",
    altitude: "11",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3298",
    name: "Sultan Ismail Petra",
    city: "Kota Bahru",
    country: "Malaysia",
    iata: "KBR",
    icao: "WMKC",
    latitude: "6.16685",
    longitude: "102.293014",
    altitude: "16",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3299",
    name: "Kuantan",
    city: "Kuantan",
    country: "Malaysia",
    iata: "KUA",
    icao: "WMKD",
    latitude: "3.775389",
    longitude: "103.209056",
    altitude: "58",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3300",
    name: "Kerteh",
    city: "Kerteh",
    country: "Malaysia",
    iata: "KTE",
    icao: "WMKE",
    latitude: "4.537222",
    longitude: "103.426756",
    altitude: "18",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3301",
    name: "Simpang",
    city: "Simpang",
    country: "Malaysia",
    iata: "",
    icao: "WMKF",
    latitude: "3.11225",
    longitude: "101.70275",
    altitude: "111",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3302",
    name: "Sultan Azlan Shah",
    city: "Ipoh",
    country: "Malaysia",
    iata: "IPH",
    icao: "WMKI",
    latitude: "4.567972",
    longitude: "101.092194",
    altitude: "130",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3303",
    name: "Sultan Ismail",
    city: "Johor Bahru",
    country: "Malaysia",
    iata: "JHB",
    icao: "WMKJ",
    latitude: "1.641308",
    longitude: "103.669619",
    altitude: "135",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3304",
    name: "Kuala Lumpur Intl",
    city: "Kuala Lumpur",
    country: "Malaysia",
    iata: "KUL",
    icao: "WMKK",
    latitude: "2.745578",
    longitude: "101.709917",
    altitude: "69",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3305",
    name: "Langkawi Intl",
    city: "Pulau",
    country: "Malaysia",
    iata: "LGK",
    icao: "WMKL",
    latitude: "6.329728",
    longitude: "99.728667",
    altitude: "29",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3306",
    name: "Malacca",
    city: "Malacca",
    country: "Malaysia",
    iata: "MKZ",
    icao: "WMKM",
    latitude: "2.263361",
    longitude: "102.251553",
    altitude: "35",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3307",
    name: "Sultan Mahmud",
    city: "Kuala Terengganu",
    country: "Malaysia",
    iata: "TGG",
    icao: "WMKN",
    latitude: "5.382639",
    longitude: "103.10336",
    altitude: "21",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3308",
    name: "Penang Intl",
    city: "Penang",
    country: "Malaysia",
    iata: "PEN",
    icao: "WMKP",
    latitude: "5.297139",
    longitude: "100.276864",
    altitude: "11",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3309",
    name: "Suai",
    city: "Suai",
    country: "East Timor",
    iata: "",
    icao: "WPDB",
    latitude: "-9.303306",
    longitude: "125.286753",
    altitude: "96",
    timezone: "9",
    dst: "U",
    tz: "Asia/Dili",
  },
  {
    id: "3310",
    name: "Presidente Nicolau Lobato Intl",
    city: "Dili",
    country: "East Timor",
    iata: "DIL",
    icao: "WPDL",
    latitude: "-8.546553",
    longitude: "125.524719",
    altitude: "25",
    timezone: "9",
    dst: "U",
    tz: "Asia/Dili",
  },
  {
    id: "3311",
    name: "Cakung",
    city: "Baucau",
    country: "East Timor",
    iata: "",
    icao: "WPEC",
    latitude: "-8.485547",
    longitude: "126.399389",
    altitude: "1777",
    timezone: "9",
    dst: "U",
    tz: "Asia/Dili",
  },
  {
    id: "3312",
    name: "Sembawang",
    city: "Sembawang",
    country: "Singapore",
    iata: "",
    icao: "WSAG",
    latitude: "1.425264",
    longitude: "103.812806",
    altitude: "86",
    timezone: "8",
    dst: "N",
    tz: "Asia/Singapore",
  },
  {
    id: "3313",
    name: "Paya Lebar",
    city: "Paya Lebar",
    country: "Singapore",
    iata: "QPG",
    icao: "WSAP",
    latitude: "1.360417",
    longitude: "103.90953",
    altitude: "65",
    timezone: "8",
    dst: "N",
    tz: "Asia/Singapore",
  },
  {
    id: "3314",
    name: "Tengah",
    city: "Tengah",
    country: "Singapore",
    iata: "",
    icao: "WSAT",
    latitude: "1.387258",
    longitude: "103.708719",
    altitude: "50",
    timezone: "8",
    dst: "N",
    tz: "Asia/Singapore",
  },
  {
    id: "3315",
    name: "Seletar",
    city: "Singapore",
    country: "Singapore",
    iata: "XSP",
    icao: "WSSL",
    latitude: "1.41695",
    longitude: "103.867653",
    altitude: "36",
    timezone: "8",
    dst: "N",
    tz: "Asia/Singapore",
  },
  {
    id: "3316",
    name: "Changi Intl",
    city: "Singapore",
    country: "Singapore",
    iata: "SIN",
    icao: "WSSS",
    latitude: "1.350189",
    longitude: "103.994433",
    altitude: "22",
    timezone: "8",
    dst: "N",
    tz: "Asia/Singapore",
  },
  {
    id: "3317",
    name: "Brisbane Archerfield",
    city: "Brisbane",
    country: "Australia",
    iata: "",
    icao: "YBAF",
    latitude: "-27.570278",
    longitude: "153.008056",
    altitude: "63",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3318",
    name: "Bamaga Injinoo",
    city: "Amberley",
    country: "Australia",
    iata: "ABM",
    icao: "YBAM",
    latitude: "-10.950833",
    longitude: "142.459444",
    altitude: "34",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3319",
    name: "Alice Springs",
    city: "Alice Springs",
    country: "Australia",
    iata: "ASP",
    icao: "YBAS",
    latitude: "-23.806667",
    longitude: "133.902222",
    altitude: "1789",
    timezone: "9.5",
    dst: "N",
    tz: "Australia/Darwin",
  },
  {
    id: "3320",
    name: "Brisbane Intl",
    city: "Brisbane",
    country: "Australia",
    iata: "BNE",
    icao: "YBBN",
    latitude: "-27.384167",
    longitude: "153.1175",
    altitude: "13",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "3321",
    name: "Gold Coast",
    city: "Coolangatta",
    country: "Australia",
    iata: "OOL",
    icao: "YBCG",
    latitude: "-28.164444",
    longitude: "153.504722",
    altitude: "21",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "3322",
    name: "Cairns Intl",
    city: "Cairns",
    country: "Australia",
    iata: "CNS",
    icao: "YBCS",
    latitude: "-16.885833",
    longitude: "145.755278",
    altitude: "10",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "3323",
    name: "Charleville",
    city: "Charlieville",
    country: "Australia",
    iata: "CTL",
    icao: "YBCV",
    latitude: "-26.413334",
    longitude: "146.2625",
    altitude: "1003",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3324",
    name: "Mount Isa",
    city: "Mount Isa",
    country: "Australia",
    iata: "ISA",
    icao: "YBMA",
    latitude: "-20.663889",
    longitude: "139.488611",
    altitude: "1121",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3325",
    name: "Sunshine Coast",
    city: "Maroochydore",
    country: "Australia",
    iata: "MCY",
    icao: "YBMC",
    latitude: "-26.603333",
    longitude: "153.091111",
    altitude: "15",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3326",
    name: "Mackay",
    city: "Mackay",
    country: "Australia",
    iata: "MKY",
    icao: "YBMK",
    latitude: "-21.171667",
    longitude: "149.179722",
    altitude: "19",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3328",
    name: "Proserpine Whitsunday Coast",
    city: "Prosserpine",
    country: "Australia",
    iata: "PPP",
    icao: "YBPN",
    latitude: "-20.495",
    longitude: "148.552222",
    altitude: "82",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3329",
    name: "Rockhampton",
    city: "Rockhampton",
    country: "Australia",
    iata: "ROK",
    icao: "YBRK",
    latitude: "-23.381944",
    longitude: "150.475278",
    altitude: "34",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3330",
    name: "Townsville",
    city: "Townsville",
    country: "Australia",
    iata: "TSV",
    icao: "YBTL",
    latitude: "-19.2525",
    longitude: "146.765278",
    altitude: "18",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "3331",
    name: "Weipa",
    city: "Weipa",
    country: "Australia",
    iata: "WEI",
    icao: "YBWP",
    latitude: "-12.678611",
    longitude: "141.925278",
    altitude: "63",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3332",
    name: "Avalon",
    city: "Avalon",
    country: "Australia",
    iata: "AVV",
    icao: "YMAV",
    latitude: "-38.039444",
    longitude: "144.469444",
    altitude: "35",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "3333",
    name: "Albury",
    city: "Albury",
    country: "Australia",
    iata: "ABX",
    icao: "YMAY",
    latitude: "-36.067778",
    longitude: "146.958056",
    altitude: "539",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3334",
    name: "Melbourne Essendon",
    city: "Melbourne",
    country: "Australia",
    iata: "MEB",
    icao: "YMEN",
    latitude: "-37.728056",
    longitude: "144.901944",
    altitude: "282",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "3335",
    name: "East Sale",
    city: "East Sale",
    country: "Australia",
    iata: "",
    icao: "YMES",
    latitude: "-38.098889",
    longitude: "147.149444",
    altitude: "23",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "3336",
    name: "Hobart",
    city: "Hobart",
    country: "Australia",
    iata: "HBA",
    icao: "YMHB",
    latitude: "-42.836111",
    longitude: "147.510278",
    altitude: "13",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "3337",
    name: "Launceston",
    city: "Launceston",
    country: "Australia",
    iata: "LST",
    icao: "YMLT",
    latitude: "-41.545278",
    longitude: "147.214167",
    altitude: "562",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "3338",
    name: "Melbourne Moorabbin",
    city: "Melbourne",
    country: "Australia",
    iata: "MBW",
    icao: "YMMB",
    latitude: "-37.975833",
    longitude: "145.102222",
    altitude: "50",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "3339",
    name: "Melbourne Intl",
    city: "Melbourne",
    country: "Australia",
    iata: "MEL",
    icao: "YMML",
    latitude: "-37.673333",
    longitude: "144.843333",
    altitude: "434",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "3340",
    name: "Point Cook",
    city: "Point Cook",
    country: "Australia",
    iata: "",
    icao: "YMPC",
    latitude: "-37.932222",
    longitude: "144.753333",
    altitude: "14",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "3341",
    name: "Adelaide Intl",
    city: "Adelaide",
    country: "Australia",
    iata: "ADL",
    icao: "YPAD",
    latitude: "-34.945",
    longitude: "138.530556",
    altitude: "20",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "3343",
    name: "Edinburgh",
    city: "Edinburgh",
    country: "Australia",
    iata: "",
    icao: "YPED",
    latitude: "-34.7025",
    longitude: "138.620833",
    altitude: "67",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "3344",
    name: "Perth Jandakot",
    city: "Perth",
    country: "Australia",
    iata: "JAD",
    icao: "YPJT",
    latitude: "-32.0975",
    longitude: "115.881111",
    altitude: "99",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "3345",
    name: "Karratha",
    city: "Karratha",
    country: "Australia",
    iata: "KTA",
    icao: "YPKA",
    latitude: "-20.712222",
    longitude: "116.773333",
    altitude: "29",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "3346",
    name: "Kalgoorlie Boulder",
    city: "Kalgoorlie",
    country: "Australia",
    iata: "KGI",
    icao: "YPKG",
    latitude: "-30.789444",
    longitude: "121.461667",
    altitude: "1203",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "3347",
    name: "Kununurra",
    city: "Kununurra",
    country: "Australia",
    iata: "KNX",
    icao: "YPKU",
    latitude: "-15.778056",
    longitude: "128.7075",
    altitude: "145",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "3348",
    name: "Learmonth",
    city: "Learmonth",
    country: "Australia",
    iata: "LEA",
    icao: "YPLM",
    latitude: "-22.235556",
    longitude: "114.088611",
    altitude: "19",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "3349",
    name: "Port Hedland Intl",
    city: "Port Hedland",
    country: "Australia",
    iata: "PHE",
    icao: "YPPD",
    latitude: "-20.377778",
    longitude: "118.626389",
    altitude: "33",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "3350",
    name: "Adelaide Parafield",
    city: "Adelaide",
    country: "Australia",
    iata: "",
    icao: "YPPF",
    latitude: "-34.793333",
    longitude: "138.633056",
    altitude: "57",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "3351",
    name: "Perth Intl",
    city: "Perth",
    country: "Australia",
    iata: "PER",
    icao: "YPPH",
    latitude: "-31.940278",
    longitude: "115.966944",
    altitude: "67",
    timezone: "8",
    dst: "N",
    tz: "Australia/Perth",
  },
  {
    id: "3352",
    name: "Woomera",
    city: "Woomera",
    country: "Australia",
    iata: "UMR",
    icao: "YPWR",
    latitude: "-31.144167",
    longitude: "136.816944",
    altitude: "548",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "3353",
    name: "Christmas Island",
    city: "Christmas Island",
    country: "Christmas Island",
    iata: "XCH",
    icao: "YPXM",
    latitude: "-10.450556",
    longitude: "105.690278",
    altitude: "916",
    timezone: "7",
    dst: "U",
    tz: "Indian/Christmas",
  },
  {
    id: "3354",
    name: "Sydney Bankstown",
    city: "Sydney",
    country: "Australia",
    iata: "BWU",
    icao: "YSBK",
    latitude: "-33.924444",
    longitude: "150.988333",
    altitude: "29",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3355",
    name: "Canberra",
    city: "Canberra",
    country: "Australia",
    iata: "CBR",
    icao: "YSCB",
    latitude: "-35.306944",
    longitude: "149.195",
    altitude: "1886",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3356",
    name: "Coffs Harbour",
    city: "Coff's Harbour",
    country: "Australia",
    iata: "CFS",
    icao: "YSCH",
    latitude: "-30.320556",
    longitude: "153.116389",
    altitude: "18",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3357",
    name: "Camden",
    city: "Camden",
    country: "Australia",
    iata: "CDU",
    icao: "YSCN",
    latitude: "-34.040278",
    longitude: "150.687222",
    altitude: "230",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3358",
    name: "Dubbo",
    city: "Dubbo",
    country: "Australia",
    iata: "DBO",
    icao: "YSDU",
    latitude: "-32.216667",
    longitude: "148.574722",
    altitude: "935",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3359",
    name: "Norfolk Island Intl",
    city: "Norfolk Island",
    country: "Norfolk Island",
    iata: "NLK",
    icao: "YSNF",
    latitude: "-29.041625",
    longitude: "167.938742",
    altitude: "371",
    timezone: "11.5",
    dst: "U",
    tz: "Pacific/Norfolk",
  },
  {
    id: "3360",
    name: "Richmond",
    city: "Richmond",
    country: "Australia",
    iata: "RCM",
    icao: "YSRI",
    latitude: "-33.600556",
    longitude: "150.780833",
    altitude: "67",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3361",
    name: "Sydney Intl",
    city: "Sydney",
    country: "Australia",
    iata: "SYD",
    icao: "YSSY",
    latitude: "-33.946111",
    longitude: "151.177222",
    altitude: "21",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3362",
    name: "Tamworth",
    city: "Tamworth",
    country: "Australia",
    iata: "TMW",
    icao: "YSTW",
    latitude: "-31.083889",
    longitude: "150.846667",
    altitude: "1334",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3363",
    name: "Wagga Wagga",
    city: "Wagga Wagga",
    country: "Australia",
    iata: "WGA",
    icao: "YSWG",
    latitude: "-35.165278",
    longitude: "147.466389",
    altitude: "724",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "3364",
    name: "Capital Intl",
    city: "Beijing",
    country: "China",
    iata: "PEK",
    icao: "ZBAA",
    latitude: "40.080111",
    longitude: "116.584556",
    altitude: "116",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6817",
    name: "Hongyuan Airfield",
    city: "Hongyuan",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "32.800428",
    longitude: "102.534785",
    altitude: "11500",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "3366",
    name: "Dongshan",
    city: "Hailar",
    country: "China",
    iata: "HLD",
    icao: "ZBLA",
    latitude: "49.204997",
    longitude: "119.825",
    altitude: "2169",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3368",
    name: "Binhai",
    city: "Tianjin",
    country: "China",
    iata: "TSN",
    icao: "ZBTJ",
    latitude: "39.124353",
    longitude: "117.346183",
    altitude: "10",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3369",
    name: "Wusu",
    city: "Taiyuan",
    country: "China",
    iata: "TYN",
    icao: "ZBYN",
    latitude: "37.746897",
    longitude: "112.628428",
    altitude: "2575",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3370",
    name: "Baiyun Intl",
    city: "Guangzhou",
    country: "China",
    iata: "CAN",
    icao: "ZGGG",
    latitude: "23.392436",
    longitude: "113.298786",
    altitude: "50",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3371",
    name: "Huanghua",
    city: "Changcha",
    country: "China",
    iata: "CSX",
    icao: "ZGHA",
    latitude: "28.189158",
    longitude: "113.219633",
    altitude: "217",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3372",
    name: "Liangjiang",
    city: "Guilin",
    country: "China",
    iata: "KWL",
    icao: "ZGKL",
    latitude: "25.218106",
    longitude: "110.039197",
    altitude: "570",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3373",
    name: "Wuxu",
    city: "Nanning",
    country: "China",
    iata: "NNG",
    icao: "ZGNN",
    latitude: "22.608267",
    longitude: "108.172442",
    altitude: "421",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3374",
    name: "Baoan Intl",
    city: "Shenzhen",
    country: "China",
    iata: "SZX",
    icao: "ZGSZ",
    latitude: "22.639258",
    longitude: "113.810664",
    altitude: "13",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3375",
    name: "Xinzheng",
    city: "Zhengzhou",
    country: "China",
    iata: "CGO",
    icao: "ZHCC",
    latitude: "34.519672",
    longitude: "113.840889",
    altitude: "495",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3376",
    name: "Tianhe",
    city: "Wuhan",
    country: "China",
    iata: "WUH",
    icao: "ZHHH",
    latitude: "30.783758",
    longitude: "114.2081",
    altitude: "113",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3377",
    name: "Pyongyang Intl",
    city: "Pyongyang",
    country: "Korea",
    iata: "FNJ",
    icao: "ZKPY",
    latitude: "39.224061",
    longitude: "125.67015",
    altitude: "117",
    timezone: "9",
    dst: "U",
    tz: "Asia/Pyongyang",
  },
  {
    id: "3378",
    name: "Zhongchuan",
    city: "Lanzhou",
    country: "China",
    iata: "ZGC",
    icao: "ZLLL",
    latitude: "36.515242",
    longitude: "103.620775",
    altitude: "6388",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3379",
    name: "Xianyang",
    city: "Xi'an",
    country: "China",
    iata: "XIY",
    icao: "ZLXY",
    latitude: "34.447119",
    longitude: "108.751592",
    altitude: "1572",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3380",
    name: "Chinggis Khaan Intl",
    city: "Ulan Bator",
    country: "Mongolia",
    iata: "ULN",
    icao: "ZMUB",
    latitude: "47.843056",
    longitude: "106.766639",
    altitude: "4364",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "3381",
    name: "Gasa",
    city: "Jinghonggasa",
    country: "China",
    iata: "",
    icao: "ZPJH",
    latitude: "21.973914",
    longitude: "100.759611",
    altitude: "1815",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3382",
    name: "Wujiaba",
    city: "Kunming",
    country: "China",
    iata: "KMG",
    icao: "ZPPP",
    latitude: "24.992364",
    longitude: "102.743536",
    altitude: "6217",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3383",
    name: "Gaoqi",
    city: "Xiamen",
    country: "China",
    iata: "XMN",
    icao: "ZSAM",
    latitude: "24.544036",
    longitude: "118.127739",
    altitude: "59",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3384",
    name: "Changbei Intl",
    city: "Nanchang",
    country: "China",
    iata: "KHN",
    icao: "ZSCN",
    latitude: "28.865",
    longitude: "115.9",
    altitude: "143",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3385",
    name: "Changle",
    city: "Fuzhou",
    country: "China",
    iata: "FOC",
    icao: "ZSFZ",
    latitude: "25.935064",
    longitude: "119.663272",
    altitude: "46",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3386",
    name: "Xiaoshan",
    city: "Hangzhou",
    country: "China",
    iata: "HGH",
    icao: "ZSHC",
    latitude: "30.229503",
    longitude: "120.434453",
    altitude: "23",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3387",
    name: "Lishe",
    city: "Ninbo",
    country: "China",
    iata: "NGB",
    icao: "ZSNB",
    latitude: "29.826683",
    longitude: "121.461906",
    altitude: "13",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3388",
    name: "Lukou",
    city: "Nanjing",
    country: "China",
    iata: "NKG",
    icao: "ZSNJ",
    latitude: "31.742042",
    longitude: "118.862025",
    altitude: "49",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3389",
    name: "Luogang",
    city: "Hefei",
    country: "China",
    iata: "HFE",
    icao: "ZSOF",
    latitude: "31.780019",
    longitude: "117.298436",
    altitude: "108",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3390",
    name: "Liuting",
    city: "Qingdao",
    country: "China",
    iata: "TAO",
    icao: "ZSQD",
    latitude: "36.266108",
    longitude: "120.374436",
    altitude: "33",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3391",
    name: "Hongqiao Intl",
    city: "Shanghai",
    country: "China",
    iata: "SHA",
    icao: "ZSSS",
    latitude: "31.197875",
    longitude: "121.336319",
    altitude: "10",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3392",
    name: "Laishan",
    city: "Yantai",
    country: "China",
    iata: "YNT",
    icao: "ZSYT",
    latitude: "37.401667",
    longitude: "121.371667",
    altitude: "59",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3393",
    name: "Jiangbei",
    city: "Chongqing",
    country: "China",
    iata: "CKG",
    icao: "ZUCK",
    latitude: "29.719217",
    longitude: "106.641678",
    altitude: "1365",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3394",
    name: "Longdongbao",
    city: "Guiyang",
    country: "China",
    iata: "KWE",
    icao: "ZUGY",
    latitude: "26.538522",
    longitude: "106.800703",
    altitude: "3736",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3395",
    name: "Shuangliu",
    city: "Chengdu",
    country: "China",
    iata: "CTU",
    icao: "ZUUU",
    latitude: "30.578528",
    longitude: "103.947086",
    altitude: "1625",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3396",
    name: "Qingshan",
    city: "Xichang",
    country: "China",
    iata: "XIC",
    icao: "ZUXC",
    latitude: "27.989083",
    longitude: "102.184361",
    altitude: "5112",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3397",
    name: "Kashi",
    city: "Kashi",
    country: "China",
    iata: "KHG",
    icao: "ZWSH",
    latitude: "39.542922",
    longitude: "76.019956",
    altitude: "4529",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3398",
    name: "Hotan",
    city: "Hotan",
    country: "China",
    iata: "HTN",
    icao: "ZWTN",
    latitude: "37.038522",
    longitude: "79.864933",
    altitude: "4672",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3399",
    name: "Diwopu",
    city: "Urumqi",
    country: "China",
    iata: "URC",
    icao: "ZWWW",
    latitude: "43.907106",
    longitude: "87.474244",
    altitude: "2125",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3400",
    name: "Taiping",
    city: "Harbin",
    country: "China",
    iata: "HRB",
    icao: "ZYHB",
    latitude: "45.623403",
    longitude: "126.250328",
    altitude: "457",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6797",
    name: "Hohenems",
    city: "Hohenems",
    country: "Austria",
    iata: "HOJ",
    icao: "LOIH",
    latitude: "47.385",
    longitude: "9.7",
    altitude: "412",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "3402",
    name: "Hailang",
    city: "Mudanjiang",
    country: "China",
    iata: "",
    icao: "ZYMD",
    latitude: "44.524072",
    longitude: "129.568972",
    altitude: "883",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3404",
    name: "Zhoushuizi",
    city: "Dalian",
    country: "China",
    iata: "DLC",
    icao: "ZYTL",
    latitude: "38.965667",
    longitude: "121.5386",
    altitude: "107",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3406",
    name: "Pudong",
    city: "Shanghai",
    country: "China",
    iata: "PVG",
    icao: "ZSPD",
    latitude: "31.143378",
    longitude: "121.805214",
    altitude: "13",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "3407",
    name: "Pulau Tioman",
    city: "Tioman",
    country: "Malaysia",
    iata: "TOD",
    icao: "WMBT",
    latitude: "2.818183",
    longitude: "104.160019",
    altitude: "15",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3408",
    name: "Subang-Sultan Abdul Aziz Shah Intl",
    city: "Kuala Lumpur",
    country: "Malaysia",
    iata: "SZB",
    icao: "WMSA",
    latitude: "3.130583",
    longitude: "101.549333",
    altitude: "90",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "3409",
    name: "Noto",
    city: "Wajima",
    country: "Japan",
    iata: "NTQ",
    icao: "RJNW",
    latitude: "37.293097",
    longitude: "136.961853",
    altitude: "718",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "3410",
    name: "Borg El Arab Intl",
    city: "Alexandria",
    country: "Egypt",
    iata: "HBE",
    icao: "HEBA",
    latitude: "30.917669",
    longitude: "29.696408",
    altitude: "177",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "3411",
    name: "Barter Island Lrrs",
    city: "Barter Island",
    country: "United States",
    iata: "BTI",
    icao: "PABA",
    latitude: "70.133989",
    longitude: "-143.581867",
    altitude: "2",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3412",
    name: "Wainwright As",
    city: "Fort Wainwright",
    country: "United States",
    iata: "K03",
    icao: "PAWT",
    latitude: "70.613378",
    longitude: "-159.86035",
    altitude: "35",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3413",
    name: "Cape Lisburne Lrrs",
    city: "Cape Lisburne",
    country: "United States",
    iata: "LUR",
    icao: "PALU",
    latitude: "68.875133",
    longitude: "-166.110022",
    altitude: "12",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3414",
    name: "Point Lay Lrrs",
    city: "Point Lay",
    country: "United States",
    iata: "PIZ",
    icao: "PPIZ",
    latitude: "69.732875",
    longitude: "-163.005342",
    altitude: "25",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3415",
    name: "Hilo Intl",
    city: "Hilo",
    country: "United States",
    iata: "ITO",
    icao: "PHTO",
    latitude: "19.721375",
    longitude: "-155.048469",
    altitude: "38",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3416",
    name: "Executive",
    city: "Orlando",
    country: "United States",
    iata: "ORL",
    icao: "KORL",
    latitude: "28.545464",
    longitude: "-81.332936",
    altitude: "113",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3417",
    name: "Bettles",
    city: "Bettles",
    country: "United States",
    iata: "BTT",
    icao: "PABT",
    latitude: "66.913944",
    longitude: "-151.529056",
    altitude: "644",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3418",
    name: "Clear",
    city: "Clear Mews",
    country: "United States",
    iata: "Z84",
    icao: "PACL",
    latitude: "64.301203",
    longitude: "-149.120144",
    altitude: "552",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3419",
    name: "Indian Mountain Lrrs",
    city: "Indian Mountains",
    country: "United States",
    iata: "UTO",
    icao: "PAIM",
    latitude: "65.992794",
    longitude: "-153.704289",
    altitude: "1220",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3420",
    name: "Fort Yukon",
    city: "Fort Yukon",
    country: "United States",
    iata: "FYU",
    icao: "PFYU",
    latitude: "66.571492",
    longitude: "-145.250417",
    altitude: "433",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3421",
    name: "Sparrevohn Lrrs",
    city: "Sparrevohn",
    country: "United States",
    iata: "SVW",
    icao: "PASV",
    latitude: "61.097369",
    longitude: "-155.574228",
    altitude: "1583",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3422",
    name: "Bryant Ahp",
    city: "Fort Richardson",
    country: "United States",
    iata: "FRN",
    icao: "PAFR",
    latitude: "61.266381",
    longitude: "-149.653119",
    altitude: "378",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3423",
    name: "Tatalina Lrrs",
    city: "Tatalina",
    country: "United States",
    iata: "TLJ",
    icao: "PATL",
    latitude: "62.894369",
    longitude: "-155.976525",
    altitude: "964",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3424",
    name: "Cape Romanzof Lrrs",
    city: "Cape Romanzof",
    country: "United States",
    iata: "CZF",
    icao: "PACZ",
    latitude: "61.780297",
    longitude: "-166.038747",
    altitude: "457",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3425",
    name: "Laurence G Hanscom Fld",
    city: "Bedford",
    country: "United States",
    iata: "BED",
    icao: "KBED",
    latitude: "42.469953",
    longitude: "-71.289031",
    altitude: "133",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3426",
    name: "St Paul Island",
    city: "St. Paul Island",
    country: "United States",
    iata: "SNP",
    icao: "PASN",
    latitude: "57.167333",
    longitude: "-170.220444",
    altitude: "63",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3427",
    name: "Cape Newenham Lrrs",
    city: "Cape Newenham",
    country: "United States",
    iata: "EHM",
    icao: "PAEH",
    latitude: "58.646428",
    longitude: "-162.062778",
    altitude: "541",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3428",
    name: "St George",
    city: "Point Barrow",
    country: "United States",
    iata: "PBV",
    icao: "PAPB",
    latitude: "56.578344",
    longitude: "-169.661611",
    altitude: "125",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3429",
    name: "Iliamna",
    city: "Iliamna",
    country: "United States",
    iata: "ILI",
    icao: "PAIL",
    latitude: "59.754356",
    longitude: "-154.910961",
    altitude: "186",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3430",
    name: "Platinum",
    city: "Port Moller",
    country: "United States",
    iata: "PTU",
    icao: "PAPM",
    latitude: "59.011356",
    longitude: "-161.819664",
    altitude: "15",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3431",
    name: "Big Mountain Afs",
    city: "Big Mountain",
    country: "United States",
    iata: "BMX",
    icao: "PABM",
    latitude: "59.361247",
    longitude: "-155.258822",
    altitude: "663",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3432",
    name: "Oscoda Wurtsmith",
    city: "Oscoda",
    country: "United States",
    iata: "OSC",
    icao: "KOSC",
    latitude: "44.451558",
    longitude: "-83.394053",
    altitude: "634",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3433",
    name: "Marina Muni",
    city: "Fort Ord",
    country: "United States",
    iata: "OAR",
    icao: "KOAR",
    latitude: "36.681878",
    longitude: "-121.762347",
    altitude: "134",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3434",
    name: "Sacramento Mather",
    city: "Sacramento",
    country: "United States",
    iata: "MHR",
    icao: "KMHR",
    latitude: "38.553897",
    longitude: "-121.297592",
    altitude: "96",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3435",
    name: "Bicycle Lake Aaf",
    city: "Fort Irwin",
    country: "United States",
    iata: "BYS",
    icao: "KBYS",
    latitude: "35.280531",
    longitude: "-116.630031",
    altitude: "2350",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3436",
    name: "Twentynine Palms Eaf",
    city: "Twenty Nine Palms",
    country: "United States",
    iata: "NXP",
    icao: "KNXP",
    latitude: "34.296161",
    longitude: "-116.162203",
    altitude: "2051",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3437",
    name: "Fort Smith Rgnl",
    city: "Fort Smith",
    country: "United States",
    iata: "FSM",
    icao: "KFSM",
    latitude: "35.336583",
    longitude: "-94.367444",
    altitude: "469",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3438",
    name: "Merrill Fld",
    city: "Anchorage",
    country: "United States",
    iata: "MRI",
    icao: "PAMR",
    latitude: "61.213544",
    longitude: "-149.844447",
    altitude: "137",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3439",
    name: "Grants Milan Muni",
    city: "Grants",
    country: "United States",
    iata: "GNT",
    icao: "KGNT",
    latitude: "35.167286",
    longitude: "-107.901989",
    altitude: "6537",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3440",
    name: "Ponca City Rgnl",
    city: "Ponca City",
    country: "United States",
    iata: "PNC",
    icao: "KPNC",
    latitude: "36.731958",
    longitude: "-97.099781",
    altitude: "1007",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3441",
    name: "Hunter Aaf",
    city: "Hunter Aaf",
    country: "United States",
    iata: "SVN",
    icao: "KSVN",
    latitude: "32.01",
    longitude: "-81.145683",
    altitude: "42",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3442",
    name: "Grand Forks Intl",
    city: "Grand Forks",
    country: "United States",
    iata: "GFK",
    icao: "KGFK",
    latitude: "47.949256",
    longitude: "-97.176111",
    altitude: "845",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3443",
    name: "Grider Fld",
    city: "Pine Bluff",
    country: "United States",
    iata: "PBF",
    icao: "KPBF",
    latitude: "34.173142",
    longitude: "-91.935597",
    altitude: "206",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3444",
    name: "Whiting Fld Nas North",
    city: "Milton",
    country: "United States",
    iata: "NSE",
    icao: "KNSE",
    latitude: "30.724167",
    longitude: "-87.021944",
    altitude: "199",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3445",
    name: "Hana",
    city: "Hana",
    country: "United States",
    iata: "HNM",
    icao: "PHHN",
    latitude: "20.795636",
    longitude: "-156.014439",
    altitude: "78",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3446",
    name: "Ernest A Love Fld",
    city: "Prescott",
    country: "United States",
    iata: "PRC",
    icao: "KPRC",
    latitude: "34.654472",
    longitude: "-112.419583",
    altitude: "5045",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3447",
    name: "Trenton Mercer",
    city: "Trenton",
    country: "United States",
    iata: "TTN",
    icao: "KTTN",
    latitude: "40.276692",
    longitude: "-74.813469",
    altitude: "213",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3448",
    name: "General Edward Lawrence Logan Intl",
    city: "Boston",
    country: "United States",
    iata: "BOS",
    icao: "KBOS",
    latitude: "42.364347",
    longitude: "-71.005181",
    altitude: "19",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3449",
    name: "Travis Afb",
    city: "Fairfield",
    country: "United States",
    iata: "SUU",
    icao: "KSUU",
    latitude: "38.262692",
    longitude: "-121.927464",
    altitude: "62",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3450",
    name: "Griffiss Afld",
    city: "Rome",
    country: "United States",
    iata: "RME",
    icao: "KRME",
    latitude: "43.2338",
    longitude: "-75.407033",
    altitude: "504",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3451",
    name: "Wendover",
    city: "Wendover",
    country: "United States",
    iata: "ENV",
    icao: "KENV",
    latitude: "40.718694",
    longitude: "-114.030889",
    altitude: "4237",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3452",
    name: "Mobile Downtown",
    city: "Mobile",
    country: "United States",
    iata: "BFM",
    icao: "KBFM",
    latitude: "30.626783",
    longitude: "-88.068092",
    altitude: "26",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3453",
    name: "Metropolitan Oakland Intl",
    city: "Oakland",
    country: "United States",
    iata: "OAK",
    icao: "KOAK",
    latitude: "37.721278",
    longitude: "-122.220722",
    altitude: "9",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3454",
    name: "Eppley Afld",
    city: "Omaha",
    country: "United States",
    iata: "OMA",
    icao: "KOMA",
    latitude: "41.303167",
    longitude: "-95.894069",
    altitude: "984",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3455",
    name: "Port Angeles Cgas",
    city: "Port Angeles",
    country: "United States",
    iata: "NOW",
    icao: "KNOW",
    latitude: "48.141481",
    longitude: "-123.414075",
    altitude: "13",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3456",
    name: "Kahului",
    city: "Kahului",
    country: "United States",
    iata: "OGG",
    icao: "PHOG",
    latitude: "20.89865",
    longitude: "-156.430458",
    altitude: "54",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3457",
    name: "Wichita Mid Continent",
    city: "Wichita",
    country: "United States",
    iata: "ICT",
    icao: "KICT",
    latitude: "37.649944",
    longitude: "-97.433056",
    altitude: "1333",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3458",
    name: "Kansas City Intl",
    city: "Kansas City",
    country: "United States",
    iata: "MCI",
    icao: "KMCI",
    latitude: "39.297606",
    longitude: "-94.713905",
    altitude: "1026",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3459",
    name: "Dane Co Rgnl Truax Fld",
    city: "Madison",
    country: "United States",
    iata: "MSN",
    icao: "KMSN",
    latitude: "43.139858",
    longitude: "-89.337514",
    altitude: "887",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3460",
    name: "Dillingham",
    city: "Dillingham",
    country: "United States",
    iata: "DLG",
    icao: "PADL",
    latitude: "59.044667",
    longitude: "-158.5055",
    altitude: "74",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3461",
    name: "Boone Co",
    city: "Harrison",
    country: "United States",
    iata: "HRO",
    icao: "KHRO",
    latitude: "36.261519",
    longitude: "-93.154728",
    altitude: "1365",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3462",
    name: "Phoenix Sky Harbor Intl",
    city: "Phoenix",
    country: "United States",
    iata: "PHX",
    icao: "KPHX",
    latitude: "33.434278",
    longitude: "-112.011583",
    altitude: "1135",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "3463",
    name: "Bangor Intl",
    city: "Bangor",
    country: "United States",
    iata: "BGR",
    icao: "KBGR",
    latitude: "44.807444",
    longitude: "-68.828139",
    altitude: "192",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3464",
    name: "Fort Lauderdale Executive",
    city: "Fort Lauderdale",
    country: "United States",
    iata: "FXE",
    icao: "KFXE",
    latitude: "26.197281",
    longitude: "-80.170706",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3465",
    name: "East Texas Rgnl",
    city: "Longview",
    country: "United States",
    iata: "GGG",
    icao: "KGGG",
    latitude: "32.384014",
    longitude: "-94.711486",
    altitude: "365",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3466",
    name: "Anderson Rgnl",
    city: "Andersen",
    country: "United States",
    iata: "AND",
    icao: "KAND",
    latitude: "34.494583",
    longitude: "-82.709389",
    altitude: "782",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3467",
    name: "Spokane Intl",
    city: "Spokane",
    country: "United States",
    iata: "GEG",
    icao: "KGEG",
    latitude: "47.619861",
    longitude: "-117.533833",
    altitude: "2376",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3468",
    name: "North Perry",
    city: "Hollywood",
    country: "United States",
    iata: "HWO",
    icao: "KHWO",
    latitude: "26.001222",
    longitude: "-80.240722",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3469",
    name: "San Francisco Intl",
    city: "San Francisco",
    country: "United States",
    iata: "SFO",
    icao: "KSFO",
    latitude: "37.618972",
    longitude: "-122.374889",
    altitude: "13",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3470",
    name: "Cut Bank Muni",
    city: "Cutbank",
    country: "United States",
    iata: "CTB",
    icao: "KCTB",
    latitude: "48.608353",
    longitude: "-112.376144",
    altitude: "3854",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3471",
    name: "Acadiana Rgnl",
    city: "Louisiana",
    country: "United States",
    iata: "ARA",
    icao: "KARA",
    latitude: "30.037758",
    longitude: "-91.883896",
    altitude: "24",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3472",
    name: "Gainesville Rgnl",
    city: "Gainesville",
    country: "United States",
    iata: "GNV",
    icao: "KGNV",
    latitude: "29.690056",
    longitude: "-82.271778",
    altitude: "152",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3473",
    name: "Memphis Intl",
    city: "Memphis",
    country: "United States",
    iata: "MEM",
    icao: "KMEM",
    latitude: "35.042417",
    longitude: "-89.976667",
    altitude: "341",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3474",
    name: "Bisbee Douglas Intl",
    city: "Douglas",
    country: "United States",
    iata: "DUG",
    icao: "KDUG",
    latitude: "31.469028",
    longitude: "-109.603667",
    altitude: "4154",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3475",
    name: "Allen Aaf",
    city: "Delta Junction",
    country: "United States",
    iata: "BIG",
    icao: "PABI",
    latitude: "63.994547",
    longitude: "-145.721642",
    altitude: "1291",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3476",
    name: "Tstc Waco",
    city: "Waco",
    country: "United States",
    iata: "CNW",
    icao: "KCNW",
    latitude: "31.637831",
    longitude: "-97.074139",
    altitude: "470",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3477",
    name: "Annette Island",
    city: "Annette Island",
    country: "United States",
    iata: "ANN",
    icao: "PANT",
    latitude: "55.042436",
    longitude: "-131.572233",
    altitude: "119",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3478",
    name: "Caribou Muni",
    city: "Caribou",
    country: "United States",
    iata: "CAR",
    icao: "KCAR",
    latitude: "46.8715",
    longitude: "-68.017917",
    altitude: "626",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3479",
    name: "Little Rock Afb",
    city: "Jacksonville",
    country: "United States",
    iata: "LRF",
    icao: "KLRF",
    latitude: "34.916944",
    longitude: "-92.149722",
    altitude: "311",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3480",
    name: "Redstone Aaf",
    city: "Redstone",
    country: "United States",
    iata: "HUA",
    icao: "KHUA",
    latitude: "34.678653",
    longitude: "-86.684781",
    altitude: "685",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3481",
    name: "Pope Field",
    city: "Fort Bragg",
    country: "United States",
    iata: "POB",
    icao: "KPOB",
    latitude: "35.170883",
    longitude: "-79.014472",
    altitude: "217",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3482",
    name: "Dalhart Muni",
    city: "Dalhart",
    country: "United States",
    iata: "DHT",
    icao: "KDHT",
    latitude: "36.022586",
    longitude: "-102.547278",
    altitude: "3991",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3483",
    name: "Laughlin Afb",
    city: "Del Rio",
    country: "United States",
    iata: "DLF",
    icao: "KDLF",
    latitude: "29.359486",
    longitude: "-100.777975",
    altitude: "1082",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3484",
    name: "Los Angeles Intl",
    city: "Los Angeles",
    country: "United States",
    iata: "LAX",
    icao: "KLAX",
    latitude: "33.942536",
    longitude: "-118.408075",
    altitude: "126",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3485",
    name: "Anniston Metro",
    city: "Anniston",
    country: "United States",
    iata: "ANB",
    icao: "KANB",
    latitude: "33.588167",
    longitude: "-85.858111",
    altitude: "612",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3486",
    name: "Cleveland Hopkins Intl",
    city: "Cleveland",
    country: "United States",
    iata: "CLE",
    icao: "KCLE",
    latitude: "41.411689",
    longitude: "-81.849794",
    altitude: "791",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3487",
    name: "Dover Afb",
    city: "Dover",
    country: "United States",
    iata: "DOV",
    icao: "KDOV",
    latitude: "39.129539",
    longitude: "-75.465958",
    altitude: "28",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3488",
    name: "Cincinnati Northern Kentucky Intl",
    city: "Cincinnati",
    country: "United States",
    iata: "CVG",
    icao: "KCVG",
    latitude: "39.048836",
    longitude: "-84.667822",
    altitude: "896",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3489",
    name: "Tipton",
    city: "Fort Meade",
    country: "United States",
    iata: "FME",
    icao: "KFME",
    latitude: "39.085386",
    longitude: "-76.759414",
    altitude: "150",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3490",
    name: "China Lake Naws",
    city: "China",
    country: "United States",
    iata: "NID",
    icao: "KNID",
    latitude: "35.685422",
    longitude: "-117.692039",
    altitude: "2283",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3491",
    name: "Huron Rgnl",
    city: "Huron",
    country: "United States",
    iata: "HON",
    icao: "KHON",
    latitude: "44.3852",
    longitude: "-98.228542",
    altitude: "1289",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3492",
    name: "Juneau Intl",
    city: "Juneau",
    country: "United States",
    iata: "JNU",
    icao: "PAJN",
    latitude: "58.354972",
    longitude: "-134.576278",
    altitude: "21",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3493",
    name: "Lafayette Rgnl",
    city: "Lafayette",
    country: "United States",
    iata: "LFT",
    icao: "KLFT",
    latitude: "30.205278",
    longitude: "-91.987611",
    altitude: "43",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3494",
    name: "Newark Liberty Intl",
    city: "Newark",
    country: "United States",
    iata: "EWR",
    icao: "KEWR",
    latitude: "40.6925",
    longitude: "-74.168667",
    altitude: "18",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3495",
    name: "Boise Air Terminal",
    city: "Boise",
    country: "United States",
    iata: "BOI",
    icao: "KBOI",
    latitude: "43.564361",
    longitude: "-116.222861",
    altitude: "2871",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3496",
    name: "Creech Afb",
    city: "Indian Springs",
    country: "United States",
    iata: "INS",
    icao: "KINS",
    latitude: "36.587183",
    longitude: "-115.673353",
    altitude: "3133",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3497",
    name: "Garden City Rgnl",
    city: "Garden City",
    country: "United States",
    iata: "GCK",
    icao: "KGCK",
    latitude: "37.927528",
    longitude: "-100.724417",
    altitude: "2891",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3498",
    name: "Minot Intl",
    city: "Minot",
    country: "United States",
    iata: "MOT",
    icao: "KMOT",
    latitude: "48.259378",
    longitude: "-101.280333",
    altitude: "1716",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3499",
    name: "Wheeler Aaf",
    city: "Wahiawa",
    country: "United States",
    iata: "HHI",
    icao: "PHHI",
    latitude: "21.4835",
    longitude: "-158.039667",
    altitude: "837",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3500",
    name: "Maxwell Afb",
    city: "Montgomery",
    country: "United States",
    iata: "MXF",
    icao: "KMXF",
    latitude: "32.382944",
    longitude: "-86.365778",
    altitude: "171",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3501",
    name: "Robinson Aaf",
    city: "Robinson",
    country: "United States",
    iata: "RBM",
    icao: "KRBM",
    latitude: "34.850089",
    longitude: "-92.300153",
    altitude: "587",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3502",
    name: "Dallas Love Fld",
    city: "Dallas",
    country: "United States",
    iata: "DAL",
    icao: "KDAL",
    latitude: "32.847111",
    longitude: "-96.851778",
    altitude: "487",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3503",
    name: "Butts Aaf",
    city: "Fort Carson",
    country: "United States",
    iata: "FCS",
    icao: "KFCS",
    latitude: "38.678394",
    longitude: "-104.756581",
    altitude: "5838",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3504",
    name: "Helena Rgnl",
    city: "Helena",
    country: "United States",
    iata: "HLN",
    icao: "KHLN",
    latitude: "46.606806",
    longitude: "-111.98275",
    altitude: "3877",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3505",
    name: "Miramar Mcas",
    city: "Miramar",
    country: "United States",
    iata: "NKX",
    icao: "KNKX",
    latitude: "32.867694",
    longitude: "-117.14175",
    altitude: "478",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3506",
    name: "Luke Afb",
    city: "Phoenix",
    country: "United States",
    iata: "LUF",
    icao: "KLUF",
    latitude: "33.535",
    longitude: "-112.38306",
    altitude: "1085",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3507",
    name: "Hurlburt Fld",
    city: "Mary Esther",
    country: "United States",
    iata: "HRT",
    icao: "KHRT",
    latitude: "30.427803",
    longitude: "-86.689278",
    altitude: "38",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3508",
    name: "Jack Northrop Fld Hawthorne Muni",
    city: "Hawthorne",
    country: "United States",
    iata: "HHR",
    icao: "KHHR",
    latitude: "33.922839",
    longitude: "-118.335186",
    altitude: "66",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3509",
    name: "Houlton Intl",
    city: "Houlton",
    country: "United States",
    iata: "HUL",
    icao: "KHUL",
    latitude: "46.123083",
    longitude: "-67.792056",
    altitude: "489",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3510",
    name: "Vance Afb",
    city: "Enid",
    country: "United States",
    iata: "END",
    icao: "KEND",
    latitude: "36.339167",
    longitude: "-97.9165",
    altitude: "1307",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3511",
    name: "Point Mugu Nas",
    city: "Point Mugu",
    country: "United States",
    iata: "NTD",
    icao: "KNTD",
    latitude: "34.120285",
    longitude: "-119.12094",
    altitude: "13",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3512",
    name: "Edwards Afb",
    city: "Edwards Afb",
    country: "United States",
    iata: "EDW",
    icao: "KEDW",
    latitude: "34.905417",
    longitude: "-117.883739",
    altitude: "2302",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3513",
    name: "Lake Charles Rgnl",
    city: "Lake Charles",
    country: "United States",
    iata: "LCH",
    icao: "KLCH",
    latitude: "30.126112",
    longitude: "-93.223335",
    altitude: "15",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3514",
    name: "Kona Intl At Keahole",
    city: "Kona",
    country: "United States",
    iata: "KOA",
    icao: "PHKO",
    latitude: "19.738767",
    longitude: "-156.045631",
    altitude: "47",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3515",
    name: "Myrtle Beach Intl",
    city: "Myrtle Beach",
    country: "United States",
    iata: "MYR",
    icao: "KMYR",
    latitude: "33.67975",
    longitude: "-78.928333",
    altitude: "25",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3516",
    name: "Lemoore Nas",
    city: "Lemoore",
    country: "United States",
    iata: "NLC",
    icao: "KNLC",
    latitude: "36.333012",
    longitude: "-119.95208",
    altitude: "234",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3517",
    name: "Nantucket Mem",
    city: "Nantucket",
    country: "United States",
    iata: "ACK",
    icao: "KACK",
    latitude: "41.253053",
    longitude: "-70.060181",
    altitude: "48",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3518",
    name: "Felker Aaf",
    city: "Fort Eustis",
    country: "United States",
    iata: "FAF",
    icao: "KFAF",
    latitude: "37.1325",
    longitude: "-76.608841",
    altitude: "12",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3519",
    name: "Campbell Aaf",
    city: "Hopkinsville",
    country: "United States",
    iata: "HOP",
    icao: "KHOP",
    latitude: "36.668567",
    longitude: "-87.496183",
    altitude: "573",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3520",
    name: "Ronald Reagan Washington Natl",
    city: "Washington",
    country: "United States",
    iata: "DCA",
    icao: "KDCA",
    latitude: "38.852083",
    longitude: "-77.037722",
    altitude: "15",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3521",
    name: "Patuxent River Nas",
    city: "Patuxent River",
    country: "United States",
    iata: "NHK",
    icao: "KNHK",
    latitude: "38.285981",
    longitude: "-76.411781",
    altitude: "39",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3522",
    name: "Palacios Muni",
    city: "Palacios",
    country: "United States",
    iata: "PSX",
    icao: "KPSX",
    latitude: "28.727508",
    longitude: "-96.250958",
    altitude: "14",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3523",
    name: "Arkansas Intl",
    city: "Blytheville",
    country: "United States",
    iata: "BYH",
    icao: "KBYH",
    latitude: "35.964347",
    longitude: "-89.943956",
    altitude: "254",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3524",
    name: "Atlantic City Intl",
    city: "Atlantic City",
    country: "United States",
    iata: "ACY",
    icao: "KACY",
    latitude: "39.457583",
    longitude: "-74.577167",
    altitude: "75",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3525",
    name: "Tinker Afb",
    city: "Oklahoma City",
    country: "United States",
    iata: "TIK",
    icao: "KTIK",
    latitude: "35.414739",
    longitude: "-97.386633",
    altitude: "1291",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3526",
    name: "Elizabeth City Cgas Rgnl",
    city: "Elizabeth City",
    country: "United States",
    iata: "ECG",
    icao: "KECG",
    latitude: "36.260581",
    longitude: "-76.174572",
    altitude: "12",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3527",
    name: "Pueblo Memorial",
    city: "Pueblo",
    country: "United States",
    iata: "PUB",
    icao: "KPUB",
    latitude: "38.289085",
    longitude: "-104.496572",
    altitude: "4726",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3528",
    name: "Northern Maine Rgnl At Presque Isle",
    city: "Presque Isle",
    country: "United States",
    iata: "PQI",
    icao: "KPQI",
    latitude: "46.688958",
    longitude: "-68.044797",
    altitude: "534",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3529",
    name: "Kirtland Air Force Base",
    city: "Kirtland A.f.b.",
    country: "United States",
    iata: "IKR",
    icao: "KIKR",
    latitude: "35.040222",
    longitude: "-106.609194",
    altitude: "5355",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3530",
    name: "Gray Aaf",
    city: "Fort Lewis",
    country: "United States",
    iata: "GRF",
    icao: "KGRF",
    latitude: "47.079217",
    longitude: "-122.580783",
    altitude: "302",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3531",
    name: "Kodiak",
    city: "Kodiak",
    country: "United States",
    iata: "ADQ",
    icao: "PADQ",
    latitude: "57.749967",
    longitude: "-152.493856",
    altitude: "78",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3532",
    name: "Upolu",
    city: "Opolu",
    country: "United States",
    iata: "UPP",
    icao: "PHUP",
    latitude: "20.265256",
    longitude: "-155.859989",
    altitude: "96",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3533",
    name: "Fort Lauderdale Hollywood Intl",
    city: "Fort Lauderdale",
    country: "United States",
    iata: "FLL",
    icao: "KFLL",
    latitude: "26.072583",
    longitude: "-80.15275",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3534",
    name: "Davis Fld",
    city: "Muskogee",
    country: "United States",
    iata: "MKO",
    icao: "KMKO",
    latitude: "35.656489",
    longitude: "-95.366656",
    altitude: "612",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3535",
    name: "Falls Intl",
    city: "International Falls",
    country: "United States",
    iata: "INL",
    icao: "KINL",
    latitude: "48.566186",
    longitude: "-93.403067",
    altitude: "1185",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3536",
    name: "Salt Lake City Intl",
    city: "Salt Lake City",
    country: "United States",
    iata: "SLC",
    icao: "KSLC",
    latitude: "40.788389",
    longitude: "-111.977772",
    altitude: "4227",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3537",
    name: "Childress Muni",
    city: "Childress",
    country: "United States",
    iata: "CDS",
    icao: "KCDS",
    latitude: "34.433781",
    longitude: "-100.287992",
    altitude: "1954",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3538",
    name: "Keesler Afb",
    city: "Biloxi",
    country: "United States",
    iata: "BIX",
    icao: "KBIX",
    latitude: "30.410425",
    longitude: "-88.924433",
    altitude: "33",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3539",
    name: "Lawson Aaf",
    city: "Fort Benning",
    country: "United States",
    iata: "LSF",
    icao: "KLSF",
    latitude: "32.337322",
    longitude: "-84.991283",
    altitude: "232",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3540",
    name: "Kingsville Nas",
    city: "Kingsville",
    country: "United States",
    iata: "NQI",
    icao: "KNQI",
    latitude: "27.507223",
    longitude: "-97.809723",
    altitude: "50",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3541",
    name: "Marshall Aaf",
    city: "Fort Riley",
    country: "United States",
    iata: "FRI",
    icao: "KFRI",
    latitude: "39.055275",
    longitude: "-96.764453",
    altitude: "1063",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3542",
    name: "Harrisburg Intl",
    city: "Harrisburg",
    country: "United States",
    iata: "MDT",
    icao: "KMDT",
    latitude: "40.193494",
    longitude: "-76.763403",
    altitude: "310",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3543",
    name: "Lincoln",
    city: "Lincoln",
    country: "United States",
    iata: "LNK",
    icao: "KLNK",
    latitude: "40.850971",
    longitude: "-96.75925",
    altitude: "1219",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3544",
    name: "Capital City",
    city: "Lansing",
    country: "United States",
    iata: "LAN",
    icao: "KLAN",
    latitude: "42.7787",
    longitude: "-84.587357",
    altitude: "861",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3545",
    name: "Waimea Kohala",
    city: "Kamuela",
    country: "United States",
    iata: "MUE",
    icao: "PHMU",
    latitude: "20.001328",
    longitude: "-155.668108",
    altitude: "2671",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3546",
    name: "Massena Intl Richards Fld",
    city: "Massena",
    country: "United States",
    iata: "MSS",
    icao: "KMSS",
    latitude: "44.935833",
    longitude: "-74.845547",
    altitude: "215",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3547",
    name: "Hickory Rgnl",
    city: "Hickory",
    country: "United States",
    iata: "HKY",
    icao: "KHKY",
    latitude: "35.741147",
    longitude: "-81.38955",
    altitude: "1189",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3548",
    name: "Albert Whitted",
    city: "St. Petersburg",
    country: "United States",
    iata: "SPG",
    icao: "KSPG",
    latitude: "27.765111",
    longitude: "-82.626972",
    altitude: "7",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3549",
    name: "Page Fld",
    city: "Fort Myers",
    country: "United States",
    iata: "FMY",
    icao: "KFMY",
    latitude: "26.586611",
    longitude: "-81.86325",
    altitude: "17",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3550",
    name: "George Bush Intercontinental",
    city: "Houston",
    country: "United States",
    iata: "IAH",
    icao: "KIAH",
    latitude: "29.984433",
    longitude: "-95.341442",
    altitude: "97",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3551",
    name: "Millinocket Muni",
    city: "Millinocket",
    country: "United States",
    iata: "MLT",
    icao: "KMLT",
    latitude: "45.647836",
    longitude: "-68.685561",
    altitude: "408",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3552",
    name: "Andrews Afb",
    city: "Camp Springs",
    country: "United States",
    iata: "ADW",
    icao: "KADW",
    latitude: "38.810806",
    longitude: "-76.867028",
    altitude: "280",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3553",
    name: "Smith Reynolds",
    city: "Winston-salem",
    country: "United States",
    iata: "INT",
    icao: "KINT",
    latitude: "36.133722",
    longitude: "-80.222",
    altitude: "969",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3554",
    name: "Southern California Logistics",
    city: "Victorville",
    country: "United States",
    iata: "VCV",
    icao: "KVCV",
    latitude: "34.597453",
    longitude: "-117.382997",
    altitude: "2885",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3555",
    name: "Bob Sikes",
    city: "Crestview",
    country: "United States",
    iata: "CEW",
    icao: "KCEW",
    latitude: "30.778833",
    longitude: "-86.522111",
    altitude: "213",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3556",
    name: "Wheeler Sack Aaf",
    city: "Fort Drum",
    country: "United States",
    iata: "GTB",
    icao: "KGTB",
    latitude: "44.055619",
    longitude: "-75.719458",
    altitude: "690",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3557",
    name: "St Clair Co Intl",
    city: "Port Huron",
    country: "United States",
    iata: "PHN",
    icao: "KPHN",
    latitude: "42.910957",
    longitude: "-82.528862",
    altitude: "650",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3558",
    name: "Meadows Fld",
    city: "Bakersfield",
    country: "United States",
    iata: "BFL",
    icao: "KBFL",
    latitude: "35.433598",
    longitude: "-119.05677",
    altitude: "507",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3559",
    name: "El Paso Intl",
    city: "El Paso",
    country: "United States",
    iata: "ELP",
    icao: "KELP",
    latitude: "31.80725",
    longitude: "-106.377583",
    altitude: "3958",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3560",
    name: "Valley Intl",
    city: "Harlingen",
    country: "United States",
    iata: "HRL",
    icao: "KHRL",
    latitude: "26.2285",
    longitude: "-97.654389",
    altitude: "36",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3561",
    name: "Columbia Metropolitan",
    city: "Columbia",
    country: "United States",
    iata: "CAE",
    icao: "KCAE",
    latitude: "33.938833",
    longitude: "-81.119528",
    altitude: "236",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3562",
    name: "Davis Monthan Afb",
    city: "Tucson",
    country: "United States",
    iata: "DMA",
    icao: "KDMA",
    latitude: "32.166467",
    longitude: "-110.883144",
    altitude: "2704",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3563",
    name: "Pensacola Nas",
    city: "Pensacola",
    country: "United States",
    iata: "NPA",
    icao: "KNPA",
    latitude: "30.352656",
    longitude: "-87.318647",
    altitude: "28",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3564",
    name: "Pensacola Rgnl",
    city: "Pensacola",
    country: "United States",
    iata: "PNS",
    icao: "KPNS",
    latitude: "30.473425",
    longitude: "-87.186611",
    altitude: "121",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3565",
    name: "Grand Forks Afb",
    city: "Red River",
    country: "United States",
    iata: "RDR",
    icao: "KRDR",
    latitude: "47.961098",
    longitude: "-97.401194",
    altitude: "913",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3566",
    name: "William P Hobby",
    city: "Houston",
    country: "United States",
    iata: "HOU",
    icao: "KHOU",
    latitude: "29.645419",
    longitude: "-95.278889",
    altitude: "46",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3567",
    name: "Buckley Afb",
    city: "Buckley",
    country: "United States",
    iata: "BKF",
    icao: "KBKF",
    latitude: "39.701668",
    longitude: "-104.75166",
    altitude: "5662",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3568",
    name: "Northway",
    city: "Northway",
    country: "United States",
    iata: "ORT",
    icao: "PAOR",
    latitude: "62.961334",
    longitude: "-141.929136",
    altitude: "1716",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3569",
    name: "Palmer Muni",
    city: "Palmer",
    country: "United States",
    iata: "PAQ",
    icao: "PAAQ",
    latitude: "61.594914",
    longitude: "-149.088711",
    altitude: "242",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3570",
    name: "Pittsburgh Intl",
    city: "Pittsburgh",
    country: "United States",
    iata: "PIT",
    icao: "KPIT",
    latitude: "40.491467",
    longitude: "-80.232872",
    altitude: "1204",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3571",
    name: "Wiley Post Will Rogers Mem",
    city: "Barrow",
    country: "United States",
    iata: "BRW",
    icao: "PABR",
    latitude: "71.285446",
    longitude: "-156.766003",
    altitude: "44",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3572",
    name: "Ellington Fld",
    city: "Houston",
    country: "United States",
    iata: "EFD",
    icao: "KEFD",
    latitude: "29.607333",
    longitude: "-95.15875",
    altitude: "32",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3573",
    name: "Whidbey Island Nas",
    city: "Whidbey Island",
    country: "United States",
    iata: "NUW",
    icao: "KNUW",
    latitude: "48.351803",
    longitude: "-122.655906",
    altitude: "47",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3574",
    name: "Alice Intl",
    city: "Alice",
    country: "United States",
    iata: "ALI",
    icao: "KALI",
    latitude: "27.740889",
    longitude: "-98.026944",
    altitude: "178",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3575",
    name: "Moody Afb",
    city: "Valdosta",
    country: "United States",
    iata: "VAD",
    icao: "KVAD",
    latitude: "30.967833",
    longitude: "-83.193",
    altitude: "233",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3576",
    name: "Miami Intl",
    city: "Miami",
    country: "United States",
    iata: "MIA",
    icao: "KMIA",
    latitude: "25.79325",
    longitude: "-80.290556",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3577",
    name: "Seattle Tacoma Intl",
    city: "Seattle",
    country: "United States",
    iata: "SEA",
    icao: "KSEA",
    latitude: "47.449",
    longitude: "-122.309306",
    altitude: "433",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3578",
    name: "Lovell Fld",
    city: "Chattanooga",
    country: "United States",
    iata: "CHA",
    icao: "KCHA",
    latitude: "35.035278",
    longitude: "-85.203808",
    altitude: "683",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3579",
    name: "Igor I Sikorsky Mem",
    city: "Stratford",
    country: "United States",
    iata: "BDR",
    icao: "KBDR",
    latitude: "41.163472",
    longitude: "-73.126167",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3580",
    name: "Jackson Evers Intl",
    city: "Jackson",
    country: "United States",
    iata: "JAN",
    icao: "KJAN",
    latitude: "32.311167",
    longitude: "-90.075889",
    altitude: "346",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3581",
    name: "Scholes Intl At Galveston",
    city: "Galveston",
    country: "United States",
    iata: "GLS",
    icao: "KGLS",
    latitude: "29.265322",
    longitude: "-94.860406",
    altitude: "6",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3582",
    name: "Long Beach",
    city: "Long Beach",
    country: "United States",
    iata: "LGB",
    icao: "KLGB",
    latitude: "33.817722",
    longitude: "-118.151611",
    altitude: "60",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3583",
    name: "Dillingham",
    city: "Dillingham",
    country: "United States",
    iata: "HDH",
    icao: "PHDH",
    latitude: "21.579475",
    longitude: "-158.197281",
    altitude: "14",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3584",
    name: "Williamsport Rgnl",
    city: "Williamsport",
    country: "United States",
    iata: "IPT",
    icao: "KIPT",
    latitude: "41.241836",
    longitude: "-76.921094",
    altitude: "529",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3585",
    name: "Indianapolis Intl",
    city: "Indianapolis",
    country: "United States",
    iata: "IND",
    icao: "KIND",
    latitude: "39.717331",
    longitude: "-86.294383",
    altitude: "797",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3586",
    name: "Whiteman Afb",
    city: "Knobnoster",
    country: "United States",
    iata: "SZL",
    icao: "KSZL",
    latitude: "38.730306",
    longitude: "-93.547864",
    altitude: "870",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3587",
    name: "Akron Fulton Intl",
    city: "Akron",
    country: "United States",
    iata: "AKC",
    icao: "KAKR",
    latitude: "41.0375",
    longitude: "-81.466917",
    altitude: "1067",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3588",
    name: "Greenwood Leflore",
    city: "Greenwood",
    country: "United States",
    iata: "GWO",
    icao: "KGWO",
    latitude: "33.494328",
    longitude: "-90.084706",
    altitude: "162",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3589",
    name: "Westchester Co",
    city: "White Plains",
    country: "United States",
    iata: "HPN",
    icao: "KHPN",
    latitude: "41.066959",
    longitude: "-73.707575",
    altitude: "439",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3590",
    name: "Francis S Gabreski",
    city: "West Hampton Beach",
    country: "United States",
    iata: "FOK",
    icao: "KFOK",
    latitude: "40.843656",
    longitude: "-72.631789",
    altitude: "67",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3591",
    name: "Jonesboro Muni",
    city: "Jonesboro",
    country: "United States",
    iata: "JBR",
    icao: "KJBR",
    latitude: "35.831708",
    longitude: "-90.646417",
    altitude: "262",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3592",
    name: "Tonopah Test Range",
    city: "Tonopah",
    country: "United States",
    iata: "TNX",
    icao: "KTNX",
    latitude: "37.798836",
    longitude: "-116.78075",
    altitude: "5549",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3593",
    name: "Palm Beach Co Park",
    city: "West Palm Beach",
    country: "United States",
    iata: "LNA",
    icao: "KLNA",
    latitude: "26.593",
    longitude: "-80.085056",
    altitude: "14",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3594",
    name: "North Island Nas",
    city: "San Diego",
    country: "United States",
    iata: "NZY",
    icao: "KNZY",
    latitude: "32.699219",
    longitude: "-117.21531",
    altitude: "26",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3595",
    name: "Biggs Aaf",
    city: "El Paso",
    country: "United States",
    iata: "BIF",
    icao: "KBIF",
    latitude: "31.849528",
    longitude: "-106.380039",
    altitude: "3948",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3596",
    name: "Yuma Mcas Yuma Intl",
    city: "Yuma",
    country: "United States",
    iata: "YUM",
    icao: "KYUM",
    latitude: "32.656578",
    longitude: "-114.60598",
    altitude: "216",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "3597",
    name: "Cavern City Air Terminal",
    city: "Carlsbad",
    country: "United States",
    iata: "CNM",
    icao: "KCNM",
    latitude: "32.337472",
    longitude: "-104.263278",
    altitude: "3295",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3598",
    name: "Duluth Intl",
    city: "Duluth",
    country: "United States",
    iata: "DLH",
    icao: "KDLH",
    latitude: "46.842091",
    longitude: "-92.193649",
    altitude: "1428",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3599",
    name: "Bethel",
    city: "Bethel",
    country: "United States",
    iata: "BET",
    icao: "PABE",
    latitude: "60.779778",
    longitude: "-161.838",
    altitude: "121",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3600",
    name: "Bowman Fld",
    city: "Louisville",
    country: "United States",
    iata: "LOU",
    icao: "KLOU",
    latitude: "38.228",
    longitude: "-85.663722",
    altitude: "546",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3601",
    name: "Sierra Vista Muni Libby Aaf",
    city: "Fort Huachuca",
    country: "United States",
    iata: "FHU",
    icao: "KFHU",
    latitude: "31.588472",
    longitude: "-110.344389",
    altitude: "4719",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3602",
    name: "Lihue",
    city: "Lihue",
    country: "United States",
    iata: "LIH",
    icao: "PHLI",
    latitude: "21.975983",
    longitude: "-159.338958",
    altitude: "153",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3603",
    name: "Terre Haute Intl Hulman Fld",
    city: "Terre Haute",
    country: "United States",
    iata: "HUF",
    icao: "KHUF",
    latitude: "39.451464",
    longitude: "-87.307561",
    altitude: "589",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3604",
    name: "Havre City Co",
    city: "Havre",
    country: "United States",
    iata: "HVR",
    icao: "KHVR",
    latitude: "48.542983",
    longitude: "-109.762342",
    altitude: "2590",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3605",
    name: "Grant Co Intl",
    city: "Grant County Airport",
    country: "United States",
    iata: "MWH",
    icao: "KMWH",
    latitude: "47.207708",
    longitude: "-119.32019",
    altitude: "1185",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3606",
    name: "Edward F Knapp State",
    city: "Montpelier",
    country: "United States",
    iata: "MPV",
    icao: "KMPV",
    latitude: "44.203503",
    longitude: "-72.562328",
    altitude: "1165",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3607",
    name: "San Nicolas Island Nolf",
    city: "San Nicolas Island",
    country: "United States",
    iata: "",
    icao: "KNSI",
    latitude: "33.239765",
    longitude: "-119.45816",
    altitude: "506",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3608",
    name: "Richmond Intl",
    city: "Richmond",
    country: "United States",
    iata: "RIC",
    icao: "KRIC",
    latitude: "37.505167",
    longitude: "-77.319667",
    altitude: "167",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3609",
    name: "Shreveport Rgnl",
    city: "Shreveport",
    country: "United States",
    iata: "SHV",
    icao: "KSHV",
    latitude: "32.446629",
    longitude: "-93.8256",
    altitude: "258",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3610",
    name: "Merle K Mudhole Smith",
    city: "Cordova",
    country: "United States",
    iata: "CDV",
    icao: "PACV",
    latitude: "60.491778",
    longitude: "-145.477556",
    altitude: "48",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3611",
    name: "Norfolk Intl",
    city: "Norfolk",
    country: "United States",
    iata: "ORF",
    icao: "KORF",
    latitude: "36.894611",
    longitude: "-76.201222",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3612",
    name: "Southeast Texas Rgnl",
    city: "Beaumont",
    country: "United States",
    iata: "BPT",
    icao: "KBPT",
    latitude: "29.950833",
    longitude: "-94.020694",
    altitude: "15",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3613",
    name: "Savannah Hilton Head Intl",
    city: "Savannah",
    country: "United States",
    iata: "SAV",
    icao: "KSAV",
    latitude: "32.127583",
    longitude: "-81.202139",
    altitude: "51",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3614",
    name: "Hill Afb",
    city: "Ogden",
    country: "United States",
    iata: "HIF",
    icao: "KHIF",
    latitude: "41.123939",
    longitude: "-111.973039",
    altitude: "4789",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3615",
    name: "Nome",
    city: "Nome",
    country: "United States",
    iata: "OME",
    icao: "PAOM",
    latitude: "64.512203",
    longitude: "-165.445247",
    altitude: "37",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3616",
    name: "Scappoose Industrial Airpark",
    city: "San Luis",
    country: "United States",
    iata: "SPB",
    icao: "KSPB",
    latitude: "45.771028",
    longitude: "-122.861833",
    altitude: "58",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3617",
    name: "St Petersburg Clearwater Intl",
    city: "St. Petersburg",
    country: "United States",
    iata: "PIE",
    icao: "KPIE",
    latitude: "27.910167",
    longitude: "-82.687389",
    altitude: "10",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3618",
    name: "Menominee Marinette Twin Co",
    city: "Macon",
    country: "United States",
    iata: "MNM",
    icao: "KMNM",
    latitude: "45.12665",
    longitude: "-87.638443",
    altitude: "625",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3619",
    name: "Lone Star Executive",
    city: "Conroe",
    country: "United States",
    iata: "CXO",
    icao: "KCXO",
    latitude: "30.351833",
    longitude: "-95.414467",
    altitude: "245",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3620",
    name: "Deadhorse",
    city: "Deadhorse",
    country: "United States",
    iata: "SCC",
    icao: "PASC",
    latitude: "70.19475",
    longitude: "-148.465167",
    altitude: "64",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3621",
    name: "San Antonio Intl",
    city: "San Antonio",
    country: "United States",
    iata: "SAT",
    icao: "KSAT",
    latitude: "29.533694",
    longitude: "-98.469778",
    altitude: "809",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3622",
    name: "Greater Rochester Intl",
    city: "Rochester",
    country: "United States",
    iata: "ROC",
    icao: "KROC",
    latitude: "43.118866",
    longitude: "-77.672389",
    altitude: "559",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3623",
    name: "Patrick Afb",
    city: "Coco Beach",
    country: "United States",
    iata: "COF",
    icao: "KCOF",
    latitude: "28.234922",
    longitude: "-80.610125",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3624",
    name: "Teterboro",
    city: "Teterboro",
    country: "United States",
    iata: "TEB",
    icao: "KTEB",
    latitude: "40.850103",
    longitude: "-74.060837",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3625",
    name: "Ellsworth Afb",
    city: "Rapid City",
    country: "United States",
    iata: "RCA",
    icao: "KRCA",
    latitude: "44.145042",
    longitude: "-103.103567",
    altitude: "3279",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3626",
    name: "Raleigh Durham Intl",
    city: "Raleigh-durham",
    country: "United States",
    iata: "RDU",
    icao: "KRDU",
    latitude: "35.877639",
    longitude: "-78.787472",
    altitude: "435",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3627",
    name: "James M Cox Dayton Intl",
    city: "Dayton",
    country: "United States",
    iata: "DAY",
    icao: "KDAY",
    latitude: "39.902375",
    longitude: "-84.219375",
    altitude: "1009",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3628",
    name: "Kenai Muni",
    city: "Kenai",
    country: "United States",
    iata: "ENA",
    icao: "PAEN",
    latitude: "60.573111",
    longitude: "-151.245",
    altitude: "99",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3629",
    name: "Mc Alester Rgnl",
    city: "Mcalester",
    country: "United States",
    iata: "MLC",
    icao: "KMLC",
    latitude: "34.882403",
    longitude: "-95.783463",
    altitude: "770",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3630",
    name: "Niagara Falls Intl",
    city: "Niagara Falls",
    country: "United States",
    iata: "IAG",
    icao: "KIAG",
    latitude: "43.107333",
    longitude: "-78.946194",
    altitude: "589",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3631",
    name: "Coulter Fld",
    city: "Bryan",
    country: "United States",
    iata: "CFD",
    icao: "KCFD",
    latitude: "30.715694",
    longitude: "-96.331361",
    altitude: "367",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3632",
    name: "Wright Aaf",
    city: "Wright",
    country: "United States",
    iata: "",
    icao: "KLHW",
    latitude: "31.889097",
    longitude: "-81.562333",
    altitude: "45",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3633",
    name: "Newport News Williamsburg Intl",
    city: "Newport News",
    country: "United States",
    iata: "PHF",
    icao: "KPHF",
    latitude: "37.131894",
    longitude: "-76.492989",
    altitude: "43",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3634",
    name: "Esler Rgnl",
    city: "Alexandria",
    country: "United States",
    iata: "ESF",
    icao: "KESF",
    latitude: "31.394903",
    longitude: "-92.295772",
    altitude: "112",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3635",
    name: "Altus Afb",
    city: "Altus",
    country: "United States",
    iata: "LTS",
    icao: "KLTS",
    latitude: "34.667067",
    longitude: "-99.266681",
    altitude: "1382",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3636",
    name: "Tucson Intl",
    city: "Tucson",
    country: "United States",
    iata: "TUS",
    icao: "KTUS",
    latitude: "32.116083",
    longitude: "-110.941028",
    altitude: "2643",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "3637",
    name: "Minot Afb",
    city: "Minot",
    country: "United States",
    iata: "MIB",
    icao: "KMIB",
    latitude: "48.415572",
    longitude: "-101.357661",
    altitude: "1668",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3638",
    name: "Beale Afb",
    city: "Marysville",
    country: "United States",
    iata: "BAB",
    icao: "KBAB",
    latitude: "39.136089",
    longitude: "-121.436567",
    altitude: "113",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3639",
    name: "Greater Kankakee",
    city: "Kankakee",
    country: "United States",
    iata: "IKK",
    icao: "KIKK",
    latitude: "41.071389",
    longitude: "-87.846278",
    altitude: "630",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3640",
    name: "Seymour Johnson Afb",
    city: "Goldsboro",
    country: "United States",
    iata: "GSB",
    icao: "KGSB",
    latitude: "35.339383",
    longitude: "-77.960589",
    altitude: "110",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3641",
    name: "Theodore Francis Green State",
    city: "Providence",
    country: "United States",
    iata: "PVD",
    icao: "KPVD",
    latitude: "41.732581",
    longitude: "-71.420383",
    altitude: "55",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3642",
    name: "Salisbury Ocean City Wicomico Rgnl",
    city: "Salisbury",
    country: "United States",
    iata: "SBY",
    icao: "KSBY",
    latitude: "38.340525",
    longitude: "-75.510289",
    altitude: "52",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3643",
    name: "Rancho Murieta",
    city: "Rancho Murieta",
    country: "United States",
    iata: "RIU",
    icao: "KRIU",
    latitude: "38.486778",
    longitude: "-121.102778",
    altitude: "141",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3644",
    name: "Bob Hope",
    city: "Burbank",
    country: "United States",
    iata: "BUR",
    icao: "KBUR",
    latitude: "34.200667",
    longitude: "-118.358667",
    altitude: "778",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3645",
    name: "Detroit Metro Wayne Co",
    city: "Detroit",
    country: "United States",
    iata: "DTW",
    icao: "KDTW",
    latitude: "42.212444",
    longitude: "-83.353389",
    altitude: "645",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3646",
    name: "Tampa Intl",
    city: "Tampa",
    country: "United States",
    iata: "TPA",
    icao: "KTPA",
    latitude: "27.975472",
    longitude: "-82.53325",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3647",
    name: "Pembina Muni",
    city: "Pembina",
    country: "United States",
    iata: "PMB",
    icao: "KPMB",
    latitude: "48.942501",
    longitude: "-97.240833",
    altitude: "795",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3648",
    name: "Polk Aaf",
    city: "Fort Polk",
    country: "United States",
    iata: "POE",
    icao: "KPOE",
    latitude: "31.044833",
    longitude: "-93.191667",
    altitude: "330",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3649",
    name: "Eielson Afb",
    city: "Fairbanks",
    country: "United States",
    iata: "EIL",
    icao: "PAEI",
    latitude: "64.665667",
    longitude: "-147.1015",
    altitude: "548",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3650",
    name: "Chisholm Hibbing",
    city: "Hibbing",
    country: "United States",
    iata: "HIB",
    icao: "KHIB",
    latitude: "47.3866",
    longitude: "-92.838994",
    altitude: "1353",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3651",
    name: "Angelina Co",
    city: "Lufkin",
    country: "United States",
    iata: "LFK",
    icao: "KLFK",
    latitude: "31.234014",
    longitude: "-94.75",
    altitude: "296",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3652",
    name: "Midland Intl",
    city: "Midland",
    country: "United States",
    iata: "MAF",
    icao: "KMAF",
    latitude: "31.942528",
    longitude: "-102.201914",
    altitude: "2871",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3653",
    name: "Austin Straubel Intl",
    city: "Green Bay",
    country: "United States",
    iata: "GRB",
    icao: "KGRB",
    latitude: "44.485072",
    longitude: "-88.129589",
    altitude: "695",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3654",
    name: "Ardmore Muni",
    city: "Ardmore",
    country: "United States",
    iata: "ADM",
    icao: "KADM",
    latitude: "34.300833",
    longitude: "-97.008889",
    altitude: "762",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3655",
    name: "Mc Guire Afb",
    city: "Wrightstown",
    country: "United States",
    iata: "WRI",
    icao: "KWRI",
    latitude: "40.015556",
    longitude: "-74.591667",
    altitude: "131",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3656",
    name: "Cherry Point Mcas",
    city: "Cherry Point",
    country: "United States",
    iata: "NKT",
    icao: "KNKT",
    latitude: "34.900872",
    longitude: "-76.880733",
    altitude: "29",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3657",
    name: "Emanuel Co",
    city: "Santa Barbara",
    country: "United States",
    iata: "SBO",
    icao: "KSBO",
    latitude: "32.609139",
    longitude: "-82.369944",
    altitude: "327",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3658",
    name: "Augusta Rgnl At Bush Fld",
    city: "Bush Field",
    country: "United States",
    iata: "AGS",
    icao: "KAGS",
    latitude: "33.369944",
    longitude: "-81.9645",
    altitude: "144",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3659",
    name: "Sloulin Fld Intl",
    city: "Williston",
    country: "United States",
    iata: "ISN",
    icao: "KISN",
    latitude: "48.177939",
    longitude: "-103.642347",
    altitude: "1982",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3660",
    name: "Adams Fld",
    city: "Little Rock",
    country: "United States",
    iata: "LIT",
    icao: "KLIT",
    latitude: "34.729444",
    longitude: "-92.224306",
    altitude: "262",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3661",
    name: "Stewart Intl",
    city: "Newburgh",
    country: "United States",
    iata: "SWF",
    icao: "KSWF",
    latitude: "41.504094",
    longitude: "-74.104839",
    altitude: "491",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3662",
    name: "Baudette Intl",
    city: "Baudette",
    country: "United States",
    iata: "BDE",
    icao: "KBDE",
    latitude: "48.728444",
    longitude: "-94.612222",
    altitude: "1086",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3663",
    name: "Sacramento Executive",
    city: "Sacramento",
    country: "United States",
    iata: "SAC",
    icao: "KSAC",
    latitude: "38.512524",
    longitude: "-121.49347",
    altitude: "24",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3664",
    name: "Homer",
    city: "Homer",
    country: "United States",
    iata: "HOM",
    icao: "PAHO",
    latitude: "59.645556",
    longitude: "-151.476583",
    altitude: "84",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3665",
    name: "Waynesville Rgnl Arpt At Forney Fld",
    city: "Fort Leonardwood",
    country: "United States",
    iata: "TBN",
    icao: "KTBN",
    latitude: "37.741631",
    longitude: "-92.140736",
    altitude: "1159",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3666",
    name: "Dobbins Arb",
    city: "Marietta",
    country: "United States",
    iata: "MGE",
    icao: "KMGE",
    latitude: "33.915382",
    longitude: "-84.516319",
    altitude: "1068",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3667",
    name: "Fairchild Afb",
    city: "Spokane",
    country: "United States",
    iata: "SKA",
    icao: "KSKA",
    latitude: "47.615058",
    longitude: "-117.655772",
    altitude: "2461",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3668",
    name: "Roscommon Co",
    city: "Houghton Lake",
    country: "United States",
    iata: "HTL",
    icao: "KHTL",
    latitude: "44.359806",
    longitude: "-84.671112",
    altitude: "1150",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3669",
    name: "Tyndall Afb",
    city: "Panama City",
    country: "United States",
    iata: "PAM",
    icao: "KPAM",
    latitude: "30.069567",
    longitude: "-85.575417",
    altitude: "17",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3670",
    name: "Dallas Fort Worth Intl",
    city: "Dallas-Fort Worth",
    country: "United States",
    iata: "DFW",
    icao: "KDFW",
    latitude: "32.896828",
    longitude: "-97.037997",
    altitude: "607",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3671",
    name: "Melbourne Intl",
    city: "Melbourne",
    country: "United States",
    iata: "MLB",
    icao: "KMLB",
    latitude: "28.102753",
    longitude: "-80.645258",
    altitude: "33",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3672",
    name: "Mc Chord Afb",
    city: "Tacoma",
    country: "United States",
    iata: "TCM",
    icao: "KTCM",
    latitude: "47.137678",
    longitude: "-122.476475",
    altitude: "322",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3673",
    name: "Austin Bergstrom Intl",
    city: "Austin",
    country: "United States",
    iata: "AUS",
    icao: "KAUS",
    latitude: "30.194528",
    longitude: "-97.669889",
    altitude: "542",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3674",
    name: "Rickenbacker Intl",
    city: "Columbus",
    country: "United States",
    iata: "LCK",
    icao: "KLCK",
    latitude: "39.813786",
    longitude: "-82.927822",
    altitude: "744",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3675",
    name: "Sawyer Intl",
    city: "Gwinn",
    country: "United States",
    iata: "",
    icao: "KSAW",
    latitude: "46.353625",
    longitude: "-87.395353",
    altitude: "1221",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3676",
    name: "Mc Ghee Tyson",
    city: "Knoxville",
    country: "United States",
    iata: "TYS",
    icao: "KTYS",
    latitude: "35.810972",
    longitude: "-83.994028",
    altitude: "981",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3677",
    name: "Hood Aaf",
    city: "Fort Hood",
    country: "United States",
    iata: "HLR",
    icao: "KHLR",
    latitude: "31.138731",
    longitude: "-97.714469",
    altitude: "924",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3678",
    name: "Lambert St Louis Intl",
    city: "St. Louis",
    country: "United States",
    iata: "STL",
    icao: "KSTL",
    latitude: "38.748697",
    longitude: "-90.370028",
    altitude: "618",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3679",
    name: "Millville Muni",
    city: "Millville",
    country: "United States",
    iata: "MIV",
    icao: "KMIV",
    latitude: "39.367806",
    longitude: "-75.072222",
    altitude: "85",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3680",
    name: "Sheppard Afb Wichita Falls Muni",
    city: "Wichita Falls",
    country: "United States",
    iata: "SPS",
    icao: "KSPS",
    latitude: "33.988797",
    longitude: "-98.491894",
    altitude: "1019",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3681",
    name: "Cincinnati Muni Lunken Fld",
    city: "Cincinnati",
    country: "United States",
    iata: "LUK",
    icao: "KLUK",
    latitude: "39.103333",
    longitude: "-84.418611",
    altitude: "483",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3682",
    name: "Hartsfield Jackson Atlanta Intl",
    city: "Atlanta",
    country: "United States",
    iata: "ATL",
    icao: "KATL",
    latitude: "33.636719",
    longitude: "-84.428067",
    altitude: "1026",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3683",
    name: "Castle",
    city: "Merced",
    country: "United States",
    iata: "MER",
    icao: "KMER",
    latitude: "37.380481",
    longitude: "-120.568189",
    altitude: "189",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3684",
    name: "Mc Clellan Afld",
    city: "Sacramento",
    country: "United States",
    iata: "MCC",
    icao: "KMCC",
    latitude: "38.667639",
    longitude: "-121.400611",
    altitude: "75",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3685",
    name: "Gerald R Ford Intl",
    city: "Grand Rapids",
    country: "United States",
    iata: "GRR",
    icao: "KGRR",
    latitude: "42.880833",
    longitude: "-85.522806",
    altitude: "794",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3686",
    name: "Winkler Co",
    city: "Wink",
    country: "United States",
    iata: "INK",
    icao: "KINK",
    latitude: "31.779628",
    longitude: "-103.201361",
    altitude: "2822",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3687",
    name: "Fresno Yosemite Intl",
    city: "Fresno",
    country: "United States",
    iata: "FAT",
    icao: "KFAT",
    latitude: "36.776194",
    longitude: "-119.71814",
    altitude: "336",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3688",
    name: "Vero Beach Muni",
    city: "Vero Beach",
    country: "United States",
    iata: "VRB",
    icao: "KVRB",
    latitude: "27.655556",
    longitude: "-80.417944",
    altitude: "24",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3689",
    name: "Imperial Co",
    city: "Imperial",
    country: "United States",
    iata: "IPL",
    icao: "KIPL",
    latitude: "32.834219",
    longitude: "-115.578744",
    altitude: "-54",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3690",
    name: "Nashville Intl",
    city: "Nashville",
    country: "United States",
    iata: "BNA",
    icao: "KBNA",
    latitude: "36.124472",
    longitude: "-86.678194",
    altitude: "599",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3691",
    name: "Laredo Intl",
    city: "Laredo",
    country: "United States",
    iata: "LRD",
    icao: "KLRD",
    latitude: "27.54375",
    longitude: "-99.461556",
    altitude: "508",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3692",
    name: "Elmendorf Afb",
    city: "Anchorage",
    country: "United States",
    iata: "EDF",
    icao: "PAED",
    latitude: "61.250986",
    longitude: "-149.806503",
    altitude: "212",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3693",
    name: "Ralph Wien Mem",
    city: "Kotzebue",
    country: "United States",
    iata: "OTZ",
    icao: "PAOT",
    latitude: "66.884678",
    longitude: "-162.59855",
    altitude: "11",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3694",
    name: "Altoona Blair Co",
    city: "Altoona",
    country: "United States",
    iata: "AOO",
    icao: "KAOO",
    latitude: "40.296372",
    longitude: "-78.320022",
    altitude: "1504",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3695",
    name: "Dyess Afb",
    city: "Abilene",
    country: "United States",
    iata: "DYS",
    icao: "KDYS",
    latitude: "32.420756",
    longitude: "-99.8546",
    altitude: "1789",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3696",
    name: "South Arkansas Rgnl At Goodwin Fld",
    city: "El Dorado",
    country: "United States",
    iata: "ELD",
    icao: "KELD",
    latitude: "33.220972",
    longitude: "-92.813278",
    altitude: "277",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3697",
    name: "La Guardia",
    city: "New York",
    country: "United States",
    iata: "LGA",
    icao: "KLGA",
    latitude: "40.777245",
    longitude: "-73.872608",
    altitude: "22",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3698",
    name: "Tallahassee Rgnl",
    city: "Tallahassee",
    country: "United States",
    iata: "TLH",
    icao: "KTLH",
    latitude: "30.396528",
    longitude: "-84.350333",
    altitude: "81",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3699",
    name: "Dupage",
    city: "West Chicago",
    country: "United States",
    iata: "DPA",
    icao: "KDPA",
    latitude: "41.907778",
    longitude: "-88.248611",
    altitude: "758",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3700",
    name: "Waco Rgnl",
    city: "Waco",
    country: "United States",
    iata: "ACT",
    icao: "KACT",
    latitude: "31.611289",
    longitude: "-97.230519",
    altitude: "516",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3701",
    name: "Augusta State",
    city: "Augusta",
    country: "United States",
    iata: "AUG",
    icao: "KAUG",
    latitude: "44.320647",
    longitude: "-69.797317",
    altitude: "352",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3702",
    name: "Hillsboro Muni",
    city: "Hillsboro",
    country: "United States",
    iata: "INJ",
    icao: "KINJ",
    latitude: "32.083486",
    longitude: "-97.097228",
    altitude: "685",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3703",
    name: "Jacksonville Nas",
    city: "Jacksonville",
    country: "United States",
    iata: "NIP",
    icao: "KNIP",
    latitude: "30.235834",
    longitude: "-81.680556",
    altitude: "22",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3704",
    name: "Mc Kellar Sipes Rgnl",
    city: "Jackson",
    country: "United States",
    iata: "MKL",
    icao: "KMKL",
    latitude: "35.599889",
    longitude: "-88.915611",
    altitude: "434",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3705",
    name: "Molokai",
    city: "Molokai",
    country: "United States",
    iata: "MKK",
    icao: "PHMK",
    latitude: "21.152886",
    longitude: "-157.096256",
    altitude: "454",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3706",
    name: "Godman Aaf",
    city: "Fort Knox",
    country: "United States",
    iata: "FTK",
    icao: "KFTK",
    latitude: "37.907058",
    longitude: "-85.972106",
    altitude: "756",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3707",
    name: "New River Mcas",
    city: "Jacksonville",
    country: "United States",
    iata: "",
    icao: "KNCA",
    latitude: "34.708417",
    longitude: "-77.439667",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3708",
    name: "San Angelo Rgnl Mathis Fld",
    city: "San Angelo",
    country: "United States",
    iata: "SJT",
    icao: "KSJT",
    latitude: "31.35775",
    longitude: "-100.496306",
    altitude: "1919",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3709",
    name: "Calexico Intl",
    city: "Calexico",
    country: "United States",
    iata: "CXL",
    icao: "KCXL",
    latitude: "32.669502",
    longitude: "-115.51333",
    altitude: "4",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3710",
    name: "Chico Muni",
    city: "Chico",
    country: "United States",
    iata: "CIC",
    icao: "KCIC",
    latitude: "39.795383",
    longitude: "-121.858422",
    altitude: "238",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3711",
    name: "Burlington Intl",
    city: "Burlington",
    country: "United States",
    iata: "BTV",
    icao: "KBTV",
    latitude: "44.471861",
    longitude: "-73.153278",
    altitude: "335",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3712",
    name: "Jacksonville Intl",
    city: "Jacksonville",
    country: "United States",
    iata: "JAX",
    icao: "KJAX",
    latitude: "30.494056",
    longitude: "-81.687861",
    altitude: "30",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3713",
    name: "Durango La Plata Co",
    city: "Durango",
    country: "United States",
    iata: "DRO",
    icao: "KDRO",
    latitude: "37.151516",
    longitude: "-107.75377",
    altitude: "6685",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3714",
    name: "Washington Dulles Intl",
    city: "Washington",
    country: "United States",
    iata: "IAD",
    icao: "KIAD",
    latitude: "38.944533",
    longitude: "-77.455811",
    altitude: "313",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3715",
    name: "Easterwood Fld",
    city: "College Station",
    country: "United States",
    iata: "CLL",
    icao: "KCLL",
    latitude: "30.588583",
    longitude: "-96.363833",
    altitude: "321",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3716",
    name: "Felts Fld",
    city: "Spokane",
    country: "United States",
    iata: "SFF",
    icao: "KSFF",
    latitude: "47.682819",
    longitude: "-117.322558",
    altitude: "1953",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3717",
    name: "General Mitchell Intl",
    city: "Milwaukee",
    country: "United States",
    iata: "MKE",
    icao: "KMKE",
    latitude: "42.947222",
    longitude: "-87.896583",
    altitude: "723",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3718",
    name: "Abilene Rgnl",
    city: "Abilene",
    country: "United States",
    iata: "ABI",
    icao: "KABI",
    latitude: "32.411319",
    longitude: "-99.681897",
    altitude: "1791",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3719",
    name: "Columbia Rgnl",
    city: "Columbia",
    country: "United States",
    iata: "COU",
    icao: "KCOU",
    latitude: "38.818094",
    longitude: "-92.219631",
    altitude: "889",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3720",
    name: "Portland Intl",
    city: "Portland",
    country: "United States",
    iata: "PDX",
    icao: "KPDX",
    latitude: "45.588722",
    longitude: "-122.5975",
    altitude: "30",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3721",
    name: "Dade Collier Training And Transition",
    city: "Miami",
    country: "United States",
    iata: "TNT",
    icao: "KTNT",
    latitude: "25.861806",
    longitude: "-80.897",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3722",
    name: "Palm Beach Intl",
    city: "West Palm Beach",
    country: "United States",
    iata: "PBI",
    icao: "KPBI",
    latitude: "26.683161",
    longitude: "-80.095589",
    altitude: "19",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3723",
    name: "Fort Worth Meacham Intl",
    city: "Fort Worth",
    country: "United States",
    iata: "FTW",
    icao: "KFTW",
    latitude: "32.819778",
    longitude: "-97.362444",
    altitude: "710",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3724",
    name: "Ogdensburg Intl",
    city: "Ogdensburg",
    country: "United States",
    iata: "OGS",
    icao: "KOGS",
    latitude: "44.681854",
    longitude: "-75.4655",
    altitude: "297",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3725",
    name: "Otis Angb",
    city: "Falmouth",
    country: "United States",
    iata: "FMH",
    icao: "KFMH",
    latitude: "41.658439",
    longitude: "-70.521417",
    altitude: "131",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3726",
    name: "Boeing Fld King Co Intl",
    city: "Seattle",
    country: "United States",
    iata: "BFI",
    icao: "KBFI",
    latitude: "47.53",
    longitude: "-122.301947",
    altitude: "21",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3727",
    name: "Lackland Afb Kelly Fld Annex",
    city: "San Antonio",
    country: "United States",
    iata: "SKF",
    icao: "KSKF",
    latitude: "29.384228",
    longitude: "-98.581108",
    altitude: "691",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3728",
    name: "Honolulu Intl",
    city: "Honolulu",
    country: "United States",
    iata: "HNL",
    icao: "PHNL",
    latitude: "21.318681",
    longitude: "-157.922428",
    altitude: "13",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3729",
    name: "Des Moines Intl",
    city: "Des Moines",
    country: "United States",
    iata: "DSM",
    icao: "KDSM",
    latitude: "41.533972",
    longitude: "-93.663083",
    altitude: "958",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3730",
    name: "Craven Co Rgnl",
    city: "New Bern",
    country: "United States",
    iata: "EWN",
    icao: "KEWN",
    latitude: "35.072972",
    longitude: "-77.042944",
    altitude: "18",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3731",
    name: "San Diego Intl",
    city: "San Diego",
    country: "United States",
    iata: "SAN",
    icao: "KSAN",
    latitude: "32.733556",
    longitude: "-117.189667",
    altitude: "17",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3732",
    name: "Monroe Rgnl",
    city: "Monroe",
    country: "United States",
    iata: "MLU",
    icao: "KMLU",
    latitude: "32.510864",
    longitude: "-92.037689",
    altitude: "79",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3733",
    name: "Shaw Afb",
    city: "Sumter",
    country: "United States",
    iata: "SSC",
    icao: "KSSC",
    latitude: "33.972719",
    longitude: "-80.470564",
    altitude: "242",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3734",
    name: "Ontario Intl",
    city: "Ontario",
    country: "United States",
    iata: "ONT",
    icao: "KONT",
    latitude: "34.056",
    longitude: "-117.601194",
    altitude: "944",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3735",
    name: "Majors",
    city: "Greenvile",
    country: "United States",
    iata: "GVT",
    icao: "KGVT",
    latitude: "33.067839",
    longitude: "-96.065333",
    altitude: "535",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3736",
    name: "Roswell Intl Air Center",
    city: "Roswell",
    country: "United States",
    iata: "ROW",
    icao: "KROW",
    latitude: "33.301556",
    longitude: "-104.530556",
    altitude: "3671",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3737",
    name: "Coleman A Young Muni",
    city: "Detroit",
    country: "United States",
    iata: "DET",
    icao: "KDET",
    latitude: "42.409195",
    longitude: "-83.009861",
    altitude: "626",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3738",
    name: "Brownsville South Padre Island Intl",
    city: "Brownsville",
    country: "United States",
    iata: "BRO",
    icao: "KBRO",
    latitude: "25.906833",
    longitude: "-97.425861",
    altitude: "22",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3739",
    name: "Dothan Rgnl",
    city: "Dothan",
    country: "United States",
    iata: "DHN",
    icao: "KDHN",
    latitude: "31.321339",
    longitude: "-85.449628",
    altitude: "401",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3740",
    name: "Cape May Co",
    city: "Wildwood",
    country: "United States",
    iata: "WWD",
    icao: "KWWD",
    latitude: "39.008507",
    longitude: "-74.908275",
    altitude: "23",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3741",
    name: "Fallon Nas",
    city: "Fallon",
    country: "United States",
    iata: "NFL",
    icao: "KNFL",
    latitude: "39.416584",
    longitude: "-118.70098",
    altitude: "3934",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3742",
    name: "Selfridge Angb",
    city: "Mount Clemens",
    country: "United States",
    iata: "MTC",
    icao: "KMTC",
    latitude: "42.608333",
    longitude: "-82.8355",
    altitude: "580",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3743",
    name: "Four Corners Rgnl",
    city: "Farmington",
    country: "United States",
    iata: "FMN",
    icao: "KFMN",
    latitude: "36.74125",
    longitude: "-108.229944",
    altitude: "5506",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3744",
    name: "Corpus Christi Intl",
    city: "Corpus Christi",
    country: "United States",
    iata: "CRP",
    icao: "KCRP",
    latitude: "27.770361",
    longitude: "-97.501222",
    altitude: "44",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3745",
    name: "Syracuse Hancock Intl",
    city: "Syracuse",
    country: "United States",
    iata: "SYR",
    icao: "KSYR",
    latitude: "43.111187",
    longitude: "-76.106311",
    altitude: "421",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3746",
    name: "Key West Nas",
    city: "Key West",
    country: "United States",
    iata: "NQX",
    icao: "KNQX",
    latitude: "24.575834",
    longitude: "-81.688889",
    altitude: "6",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3747",
    name: "Chicago Midway Intl",
    city: "Chicago",
    country: "United States",
    iata: "MDW",
    icao: "KMDW",
    latitude: "41.785972",
    longitude: "-87.752417",
    altitude: "620",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3748",
    name: "Norman Y Mineta San Jose Intl",
    city: "San Jose",
    country: "United States",
    iata: "SJC",
    icao: "KSJC",
    latitude: "37.3626",
    longitude: "-121.929022",
    altitude: "62",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3749",
    name: "Lea Co Rgnl",
    city: "Hobbs",
    country: "United States",
    iata: "HOB",
    icao: "KHOB",
    latitude: "32.687528",
    longitude: "-103.217028",
    altitude: "3661",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3750",
    name: "Northeast Philadelphia",
    city: "Philadelphia",
    country: "United States",
    iata: "PNE",
    icao: "KPNE",
    latitude: "40.081944",
    longitude: "-75.010586",
    altitude: "121",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3751",
    name: "Denver Intl",
    city: "Denver",
    country: "United States",
    iata: "DEN",
    icao: "KDEN",
    latitude: "39.861656",
    longitude: "-104.673178",
    altitude: "5431",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3752",
    name: "Philadelphia Intl",
    city: "Philadelphia",
    country: "United States",
    iata: "PHL",
    icao: "KPHL",
    latitude: "39.871944",
    longitude: "-75.241139",
    altitude: "36",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3753",
    name: "Sioux Gateway Col Bud Day Fld",
    city: "Sioux City",
    country: "United States",
    iata: "SUX",
    icao: "KSUX",
    latitude: "42.402603",
    longitude: "-96.384367",
    altitude: "1098",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3754",
    name: "Middle Georgia Rgnl",
    city: "Macon",
    country: "United States",
    iata: "MCN",
    icao: "KMCN",
    latitude: "32.69285",
    longitude: "-83.649211",
    altitude: "354",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3755",
    name: "Truth Or Consequences Muni",
    city: "Truth Or Consequences",
    country: "United States",
    iata: "TCS",
    icao: "KTCS",
    latitude: "33.236944",
    longitude: "-107.27175",
    altitude: "4853",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3756",
    name: "Palmdale Rgnl Usaf Plt 42",
    city: "Palmdale",
    country: "United States",
    iata: "PMD",
    icao: "KPMD",
    latitude: "34.629391",
    longitude: "-118.08456",
    altitude: "2543",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3757",
    name: "Randolph Afb",
    city: "San Antonio",
    country: "United States",
    iata: "RND",
    icao: "KRND",
    latitude: "29.529675",
    longitude: "-98.2789",
    altitude: "762",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3758",
    name: "El Centro Naf",
    city: "El Centro",
    country: "United States",
    iata: "NJK",
    icao: "KNJK",
    latitude: "32.829222",
    longitude: "-115.671667",
    altitude: "-42",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3759",
    name: "Port Columbus Intl",
    city: "Columbus",
    country: "United States",
    iata: "CMH",
    icao: "KCMH",
    latitude: "39.997972",
    longitude: "-82.891889",
    altitude: "815",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3760",
    name: "Drake Fld",
    city: "Fayetteville",
    country: "United States",
    iata: "FYV",
    icao: "KFYV",
    latitude: "36.005094",
    longitude: "-94.170059",
    altitude: "1251",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3761",
    name: "Henry Post Aaf",
    city: "Fort Sill",
    country: "United States",
    iata: "FSI",
    icao: "KFSI",
    latitude: "34.649833",
    longitude: "-98.402167",
    altitude: "1189",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3762",
    name: "Princeton Muni",
    city: "Princeton",
    country: "United States",
    iata: "PNM",
    icao: "KPNM",
    latitude: "45.559868",
    longitude: "-93.608217",
    altitude: "979",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3763",
    name: "Wright Patterson Afb",
    city: "Dayton",
    country: "United States",
    iata: "FFO",
    icao: "KFFO",
    latitude: "39.826111",
    longitude: "-84.048332",
    altitude: "823",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3764",
    name: "Edward G Pitka Sr",
    city: "Galena",
    country: "United States",
    iata: "GAL",
    icao: "PAGA",
    latitude: "64.736178",
    longitude: "-156.937417",
    altitude: "152",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3765",
    name: "Chandler Muni",
    city: "Chandler",
    country: "United States",
    iata: "",
    icao: "KCHD",
    latitude: "33.269111",
    longitude: "-111.811111",
    altitude: "1243",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3766",
    name: "Mineral Wells",
    city: "Mineral Wells",
    country: "United States",
    iata: "MWL",
    icao: "KMWL",
    latitude: "32.781606",
    longitude: "-98.060175",
    altitude: "974",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3767",
    name: "Mc Connell Afb",
    city: "Wichita",
    country: "United States",
    iata: "IAB",
    icao: "KIAB",
    latitude: "37.621853",
    longitude: "-97.268192",
    altitude: "1371",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3768",
    name: "New Orleans Nas Jrb",
    city: "New Orleans",
    country: "United States",
    iata: "NBG",
    icao: "KNBG",
    latitude: "29.825333",
    longitude: "-90.035",
    altitude: "3",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3769",
    name: "Beaufort",
    city: "Beaufort",
    country: "United States",
    iata: "BFT",
    icao: "KNBC",
    latitude: "32.477411",
    longitude: "-80.723161",
    altitude: "37",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3770",
    name: "Texarkana Rgnl Webb Fld",
    city: "Texarkana",
    country: "United States",
    iata: "TXK",
    icao: "KTXK",
    latitude: "33.453722",
    longitude: "-93.991028",
    altitude: "390",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3771",
    name: "Plattsburgh Intl",
    city: "Plattsburgh",
    country: "United States",
    iata: "PBG",
    icao: "KPBG",
    latitude: "44.650944",
    longitude: "-73.468139",
    altitude: "234",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3772",
    name: "Phillips Aaf",
    city: "Aberdeen",
    country: "United States",
    iata: "APG",
    icao: "KAPG",
    latitude: "39.466219",
    longitude: "-76.168808",
    altitude: "57",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3773",
    name: "Tucumcari Muni",
    city: "Tucumcari",
    country: "United States",
    iata: "TCC",
    icao: "KTCC",
    latitude: "35.182777",
    longitude: "-103.603186",
    altitude: "4065",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3774",
    name: "Ted Stevens Anchorage Intl",
    city: "Anchorage",
    country: "United States",
    iata: "ANC",
    icao: "PANC",
    latitude: "61.174361",
    longitude: "-149.996361",
    altitude: "152",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3775",
    name: "Robert Gray Aaf",
    city: "Killeen",
    country: "United States",
    iata: "GRK",
    icao: "KGRK",
    latitude: "31.06725",
    longitude: "-97.828917",
    altitude: "1015",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3776",
    name: "Black Rock",
    city: "Zuni Pueblo",
    country: "United States",
    iata: "ZUN",
    icao: "KZUN",
    latitude: "35.083228",
    longitude: "-108.791778",
    altitude: "6454",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3777",
    name: "Bellingham Intl",
    city: "Bellingham",
    country: "United States",
    iata: "BLI",
    icao: "KBLI",
    latitude: "48.792694",
    longitude: "-122.537528",
    altitude: "170",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3778",
    name: "Millington Rgnl Jetport",
    city: "Millington",
    country: "United States",
    iata: "NQA",
    icao: "KNQA",
    latitude: "35.356667",
    longitude: "-89.870278",
    altitude: "320",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3779",
    name: "Elkins Randolph Co Jennings Randolph",
    city: "Elkins",
    country: "United States",
    iata: "EKN",
    icao: "KEKN",
    latitude: "38.889444",
    longitude: "-79.857139",
    altitude: "1987",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3780",
    name: "Hartford Brainard",
    city: "Hartford",
    country: "United States",
    iata: "HFD",
    icao: "KHFD",
    latitude: "41.736722",
    longitude: "-72.649444",
    altitude: "18",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3781",
    name: "North Central State",
    city: "Smithfield",
    country: "United States",
    iata: "SFZ",
    icao: "KSFZ",
    latitude: "41.920764",
    longitude: "-71.491381",
    altitude: "441",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3782",
    name: "Mobile Rgnl",
    city: "Mobile",
    country: "United States",
    iata: "MOB",
    icao: "KMOB",
    latitude: "30.691231",
    longitude: "-88.242814",
    altitude: "219",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3783",
    name: "Moffett Federal Afld",
    city: "Mountain View",
    country: "United States",
    iata: "NUQ",
    icao: "KNUQ",
    latitude: "37.416142",
    longitude: "-122.049139",
    altitude: "32",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3784",
    name: "Santa Fe Muni",
    city: "Santa Fe",
    country: "United States",
    iata: "SAF",
    icao: "KSAF",
    latitude: "35.617108",
    longitude: "-106.089422",
    altitude: "6348",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3785",
    name: "Barking Sands Pmrf",
    city: "Barking Sands",
    country: "United States",
    iata: "BKH",
    icao: "PHBK",
    latitude: "22.022833",
    longitude: "-159.785",
    altitude: "23",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3786",
    name: "Beauregard Rgnl",
    city: "Deridder",
    country: "United States",
    iata: "DRI",
    icao: "KDRI",
    latitude: "30.831722",
    longitude: "-93.339917",
    altitude: "202",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3787",
    name: "Bradshaw Aaf",
    city: "Bradshaw Field",
    country: "United States",
    iata: "BSF",
    icao: "PHSF",
    latitude: "19.760056",
    longitude: "-155.553717",
    altitude: "6190",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3788",
    name: "Nogales Intl",
    city: "Nogales",
    country: "United States",
    iata: "OLS",
    icao: "KOLS",
    latitude: "31.417722",
    longitude: "-110.84789",
    altitude: "3955",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "3789",
    name: "Macdill Afb",
    city: "Tampa",
    country: "United States",
    iata: "MCF",
    icao: "KMCF",
    latitude: "27.849339",
    longitude: "-82.521214",
    altitude: "14",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3790",
    name: "Scott Afb Midamerica",
    city: "Belleville",
    country: "United States",
    iata: "BLV",
    icao: "KBLV",
    latitude: "38.545178",
    longitude: "-89.835183",
    altitude: "459",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3791",
    name: "Opa Locka",
    city: "Miami",
    country: "United States",
    iata: "OPF",
    icao: "KOPF",
    latitude: "25.907",
    longitude: "-80.278389",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3792",
    name: "Del Rio Intl",
    city: "Del Rio",
    country: "United States",
    iata: "DRT",
    icao: "KDRT",
    latitude: "29.374208",
    longitude: "-100.927158",
    altitude: "1002",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3793",
    name: "Southwest Florida Intl",
    city: "Fort Myers",
    country: "United States",
    iata: "RSW",
    icao: "KRSW",
    latitude: "26.536167",
    longitude: "-81.755167",
    altitude: "30",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3794",
    name: "King Salmon",
    city: "King Salmon",
    country: "United States",
    iata: "AKN",
    icao: "PAKN",
    latitude: "58.676778",
    longitude: "-156.649278",
    altitude: "68",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3795",
    name: "Muir Aaf",
    city: "Muir",
    country: "United States",
    iata: "MUI",
    icao: "KMUI",
    latitude: "40.434811",
    longitude: "-76.569411",
    altitude: "489",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3796",
    name: "Kapalua",
    city: "Lahania-kapalua",
    country: "United States",
    iata: "JHM",
    icao: "PHJH",
    latitude: "20.962936",
    longitude: "-156.673031",
    altitude: "256",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3797",
    name: "John F Kennedy Intl",
    city: "New York",
    country: "United States",
    iata: "JFK",
    icao: "KJFK",
    latitude: "40.639751",
    longitude: "-73.778925",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3798",
    name: "Homestead Arb",
    city: "Homestead",
    country: "United States",
    iata: "HST",
    icao: "KHST",
    latitude: "25.48855",
    longitude: "-80.383567",
    altitude: "6",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3799",
    name: "Riverside Muni",
    city: "Riverside",
    country: "United States",
    iata: "RAL",
    icao: "KRAL",
    latitude: "33.951875",
    longitude: "-117.445103",
    altitude: "818",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3800",
    name: "Sherman Aaf",
    city: "Fort Leavenworth",
    country: "United States",
    iata: "FLV",
    icao: "KFLV",
    latitude: "39.368332",
    longitude: "-94.914686",
    altitude: "772",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3801",
    name: "Wallops Flight Facility",
    city: "Wallops Island",
    country: "United States",
    iata: "WAL",
    icao: "KWAL",
    latitude: "37.940194",
    longitude: "-75.466389",
    altitude: "40",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3802",
    name: "Holloman Afb",
    city: "Alamogordo",
    country: "United States",
    iata: "HMN",
    icao: "KHMN",
    latitude: "32.852519",
    longitude: "-106.106525",
    altitude: "4093",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3803",
    name: "Willow Grove Nas Jrb",
    city: "Willow Grove",
    country: "United States",
    iata: "NXX",
    icao: "KNXX",
    latitude: "40.199833",
    longitude: "-75.148167",
    altitude: "358",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3804",
    name: "Cheyenne Rgnl Jerry Olson Fld",
    city: "Cheyenne",
    country: "United States",
    iata: "CYS",
    icao: "KCYS",
    latitude: "41.155722",
    longitude: "-104.811839",
    altitude: "6156",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3805",
    name: "Stockton Metropolitan",
    city: "Stockton",
    country: "United States",
    iata: "SCK",
    icao: "KSCK",
    latitude: "37.894167",
    longitude: "-121.238306",
    altitude: "33",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3806",
    name: "Charleston Afb Intl",
    city: "Charleston",
    country: "United States",
    iata: "CHS",
    icao: "KCHS",
    latitude: "32.898647",
    longitude: "-80.040528",
    altitude: "45",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3807",
    name: "Reno Tahoe Intl",
    city: "Reno",
    country: "United States",
    iata: "RNO",
    icao: "KRNO",
    latitude: "39.499108",
    longitude: "-119.768108",
    altitude: "4415",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3808",
    name: "Ketchikan Intl",
    city: "Ketchikan",
    country: "United States",
    iata: "KTN",
    icao: "PAKT",
    latitude: "55.355556",
    longitude: "-131.71375",
    altitude: "88",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3809",
    name: "Willow Run",
    city: "Detroit",
    country: "United States",
    iata: "YIP",
    icao: "KYIP",
    latitude: "42.237928",
    longitude: "-83.530408",
    altitude: "716",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3810",
    name: "Vandenberg Afb",
    city: "Lompoc",
    country: "United States",
    iata: "VBG",
    icao: "KVBG",
    latitude: "34.737333",
    longitude: "-120.584306",
    altitude: "369",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3811",
    name: "Birmingham Intl",
    city: "Birmingham",
    country: "United States",
    iata: "BHM",
    icao: "KBHM",
    latitude: "33.562942",
    longitude: "-86.75355",
    altitude: "644",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3812",
    name: "Lakehurst Naes",
    city: "Lakehurst",
    country: "United States",
    iata: "NEL",
    icao: "KNEL",
    latitude: "40.033333",
    longitude: "-74.353333",
    altitude: "103",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3813",
    name: "Eareckson As",
    city: "Shemya",
    country: "United States",
    iata: "SYA",
    icao: "PASY",
    latitude: "52.712275",
    longitude: "174.11362",
    altitude: "98",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3814",
    name: "Nellis Afb",
    city: "Las Vegas",
    country: "United States",
    iata: "LSV",
    icao: "KLSV",
    latitude: "36.236197",
    longitude: "-115.034253",
    altitude: "1870",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3815",
    name: "March Arb",
    city: "Riverside",
    country: "United States",
    iata: "RIV",
    icao: "KRIV",
    latitude: "33.880711",
    longitude: "-117.259453",
    altitude: "1535",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3816",
    name: "Modesto City Co Harry Sham",
    city: "Modesto",
    country: "United States",
    iata: "MOD",
    icao: "KMOD",
    latitude: "37.625817",
    longitude: "-120.954422",
    altitude: "97",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3817",
    name: "Sacramento Intl",
    city: "Sacramento",
    country: "United States",
    iata: "SMF",
    icao: "KSMF",
    latitude: "38.695417",
    longitude: "-121.590778",
    altitude: "27",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3818",
    name: "Waukegan Rgnl",
    city: "Chicago",
    country: "United States",
    iata: "UGN",
    icao: "KUGN",
    latitude: "42.422161",
    longitude: "-87.867908",
    altitude: "727",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3819",
    name: "City Of Colorado Springs Muni",
    city: "Colorado Springs",
    country: "United States",
    iata: "COS",
    icao: "KCOS",
    latitude: "38.805805",
    longitude: "-104.700778",
    altitude: "6187",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3820",
    name: "Buffalo Niagara Intl",
    city: "Buffalo",
    country: "United States",
    iata: "BUF",
    icao: "KBUF",
    latitude: "42.940525",
    longitude: "-78.732167",
    altitude: "724",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3821",
    name: "Griffing Sandusky",
    city: "Sandusky",
    country: "United States",
    iata: "SKY",
    icao: "KSKY",
    latitude: "41.433361",
    longitude: "-82.652333",
    altitude: "580",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3822",
    name: "Snohomish Co",
    city: "Everett",
    country: "United States",
    iata: "PAE",
    icao: "KPAE",
    latitude: "47.906342",
    longitude: "-122.281564",
    altitude: "606",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3823",
    name: "Mountain Home Afb",
    city: "Mountain Home",
    country: "United States",
    iata: "MUO",
    icao: "KMUO",
    latitude: "43.043603",
    longitude: "-115.872431",
    altitude: "2996",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3824",
    name: "Cedar City Rgnl",
    city: "Cedar City",
    country: "United States",
    iata: "CDC",
    icao: "KCDC",
    latitude: "37.700967",
    longitude: "-113.098847",
    altitude: "5622",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3825",
    name: "Bradley Intl",
    city: "Windsor Locks",
    country: "United States",
    iata: "BDL",
    icao: "KBDL",
    latitude: "41.938889",
    longitude: "-72.683222",
    altitude: "173",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3826",
    name: "Mc Allen Miller Intl",
    city: "Mcallen",
    country: "United States",
    iata: "MFE",
    icao: "KMFE",
    latitude: "26.175833",
    longitude: "-98.238611",
    altitude: "107",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3827",
    name: "Norfolk Ns",
    city: "Norfolk",
    country: "United States",
    iata: "NGU",
    icao: "KNGU",
    latitude: "36.937644",
    longitude: "-76.289289",
    altitude: "15",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3828",
    name: "Westover Arb Metropolitan",
    city: "Chicopee Falls",
    country: "United States",
    iata: "CEF",
    icao: "KCEF",
    latitude: "42.194014",
    longitude: "-72.534783",
    altitude: "241",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3829",
    name: "Lubbock Preston Smith Intl",
    city: "Lubbock",
    country: "United States",
    iata: "LBB",
    icao: "KLBB",
    latitude: "33.663639",
    longitude: "-101.822778",
    altitude: "3282",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3830",
    name: "Chicago Ohare Intl",
    city: "Chicago",
    country: "United States",
    iata: "ORD",
    icao: "KORD",
    latitude: "41.978603",
    longitude: "-87.904842",
    altitude: "668",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3831",
    name: "Boca Raton",
    city: "Boca Raton",
    country: "United States",
    iata: "BCT",
    icao: "KBCT",
    latitude: "26.3785",
    longitude: "-80.107694",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3832",
    name: "Fairbanks Intl",
    city: "Fairbanks",
    country: "United States",
    iata: "FAI",
    icao: "PAFA",
    latitude: "64.815114",
    longitude: "-147.856267",
    altitude: "434",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3833",
    name: "Quantico Mcaf",
    city: "Quantico",
    country: "United States",
    iata: "NYG",
    icao: "KNYG",
    latitude: "38.501683",
    longitude: "-77.305333",
    altitude: "11",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3834",
    name: "Cannon Afb",
    city: "Clovis",
    country: "United States",
    iata: "CVS",
    icao: "KCVS",
    latitude: "34.382775",
    longitude: "-103.322147",
    altitude: "4295",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3835",
    name: "Kaneohe Bay Mcaf",
    city: "Kaneohe Bay",
    country: "United States",
    iata: "NGF",
    icao: "PHNG",
    latitude: "21.450453",
    longitude: "-157.768",
    altitude: "24",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3836",
    name: "Offutt Afb",
    city: "Omaha",
    country: "United States",
    iata: "OFF",
    icao: "KOFF",
    latitude: "41.118332",
    longitude: "-95.912511",
    altitude: "1052",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3837",
    name: "Gulkana",
    city: "Gulkana",
    country: "United States",
    iata: "GKN",
    icao: "PAGK",
    latitude: "62.154888",
    longitude: "-145.456639",
    altitude: "1580",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3838",
    name: "Watertown Intl",
    city: "Watertown",
    country: "United States",
    iata: "ART",
    icao: "KART",
    latitude: "43.991922",
    longitude: "-76.021739",
    altitude: "325",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3839",
    name: "Palm Springs Intl",
    city: "Palm Springs",
    country: "United States",
    iata: "PSP",
    icao: "KPSP",
    latitude: "33.829667",
    longitude: "-116.506694",
    altitude: "477",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3840",
    name: "Rick Husband Amarillo Intl",
    city: "Amarillo",
    country: "United States",
    iata: "AMA",
    icao: "KAMA",
    latitude: "35.219369",
    longitude: "-101.705931",
    altitude: "3607",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3841",
    name: "Fort Dodge Rgnl",
    city: "Fort Dodge",
    country: "United States",
    iata: "FOD",
    icao: "KFOD",
    latitude: "42.5512",
    longitude: "-94.191842",
    altitude: "1157",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3842",
    name: "Barksdale Afb",
    city: "Shreveport",
    country: "United States",
    iata: "BAD",
    icao: "KBAD",
    latitude: "32.50182",
    longitude: "-93.662674",
    altitude: "166",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3843",
    name: "Forbes Fld",
    city: "Topeka",
    country: "United States",
    iata: "FOE",
    icao: "KFOE",
    latitude: "38.950944",
    longitude: "-95.663611",
    altitude: "1078",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3844",
    name: "Cotulla Lasalle Co",
    city: "Cotulla",
    country: "United States",
    iata: "COT",
    icao: "KCOT",
    latitude: "28.456694",
    longitude: "-99.220294",
    altitude: "474",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3845",
    name: "Wilmington Intl",
    city: "Wilmington",
    country: "United States",
    iata: "ILM",
    icao: "KILM",
    latitude: "34.270615",
    longitude: "-77.902569",
    altitude: "32",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3846",
    name: "Baton Rouge Metro Ryan Fld",
    city: "Baton Rouge",
    country: "United States",
    iata: "BTR",
    icao: "KBTR",
    latitude: "30.533167",
    longitude: "-91.149639",
    altitude: "70",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3847",
    name: "Meridian Nas",
    city: "Meridian",
    country: "United States",
    iata: "NMM",
    icao: "KNMM",
    latitude: "32.552083",
    longitude: "-88.555557",
    altitude: "317",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3848",
    name: "Tyler Pounds Rgnl",
    city: "Tyler",
    country: "United States",
    iata: "TYR",
    icao: "KTYR",
    latitude: "32.354139",
    longitude: "-95.402386",
    altitude: "544",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3849",
    name: "Baltimore Washington Intl",
    city: "Baltimore",
    country: "United States",
    iata: "BWI",
    icao: "KBWI",
    latitude: "39.175361",
    longitude: "-76.668333",
    altitude: "146",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3850",
    name: "Hobart Muni",
    city: "Hobart",
    country: "United States",
    iata: "HBR",
    icao: "KHBR",
    latitude: "34.991308",
    longitude: "-99.051353",
    altitude: "1564",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3851",
    name: "Lanai",
    city: "Lanai",
    country: "United States",
    iata: "LNY",
    icao: "PHNY",
    latitude: "20.785611",
    longitude: "-156.951419",
    altitude: "1308",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "3852",
    name: "Alexandria Intl",
    city: "Alexandria",
    country: "United States",
    iata: "AEX",
    icao: "KAEX",
    latitude: "31.3274",
    longitude: "-92.549833",
    altitude: "89",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3853",
    name: "Condron Aaf",
    city: "White Sands",
    country: "United States",
    iata: "WSD",
    icao: "KWSD",
    latitude: "32.341484",
    longitude: "-106.40277",
    altitude: "3934",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3854",
    name: "Cold Bay",
    city: "Cold Bay",
    country: "United States",
    iata: "CDB",
    icao: "PACD",
    latitude: "55.206061",
    longitude: "-162.725436",
    altitude: "96",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3855",
    name: "Tulsa Intl",
    city: "Tulsa",
    country: "United States",
    iata: "TUL",
    icao: "KTUL",
    latitude: "36.198389",
    longitude: "-95.888111",
    altitude: "677",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3856",
    name: "Sitka Rocky Gutierrez",
    city: "Sitka",
    country: "United States",
    iata: "SIT",
    icao: "PASI",
    latitude: "57.047138",
    longitude: "-135.361611",
    altitude: "21",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3857",
    name: "Long Island Mac Arthur",
    city: "Islip",
    country: "United States",
    iata: "ISP",
    icao: "KISP",
    latitude: "40.79525",
    longitude: "-73.100222",
    altitude: "99",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3858",
    name: "Minneapolis St Paul Intl",
    city: "Minneapolis",
    country: "United States",
    iata: "MSP",
    icao: "KMSP",
    latitude: "44.881956",
    longitude: "-93.221767",
    altitude: "841",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3859",
    name: "New Castle",
    city: "Wilmington",
    country: "United States",
    iata: "ILG",
    icao: "KILG",
    latitude: "39.678722",
    longitude: "-75.606528",
    altitude: "79",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3860",
    name: "Unalaska",
    city: "Unalaska",
    country: "United States",
    iata: "DUT",
    icao: "PADU",
    latitude: "53.900139",
    longitude: "-166.5435",
    altitude: "22",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3861",
    name: "Louis Armstrong New Orleans Intl",
    city: "New Orleans",
    country: "United States",
    iata: "MSY",
    icao: "KMSY",
    latitude: "29.993389",
    longitude: "-90.258028",
    altitude: "4",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3862",
    name: "Portland Intl Jetport",
    city: "Portland",
    country: "United States",
    iata: "PWM",
    icao: "KPWM",
    latitude: "43.646161",
    longitude: "-70.309281",
    altitude: "77",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3863",
    name: "Will Rogers World",
    city: "Oklahoma City",
    country: "United States",
    iata: "OKC",
    icao: "KOKC",
    latitude: "35.393089",
    longitude: "-97.600733",
    altitude: "1295",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3864",
    name: "Albany Intl",
    city: "Albany",
    country: "United States",
    iata: "ALB",
    icao: "KALB",
    latitude: "42.748267",
    longitude: "-73.801692",
    altitude: "285",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3865",
    name: "Valdez Pioneer Fld",
    city: "Valdez",
    country: "United States",
    iata: "VDZ",
    icao: "PAVD",
    latitude: "61.133949",
    longitude: "-146.248342",
    altitude: "118",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3866",
    name: "Langley Afb",
    city: "Hampton",
    country: "United States",
    iata: "LFI",
    icao: "KLFI",
    latitude: "37.082881",
    longitude: "-76.360547",
    altitude: "11",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3867",
    name: "John Wayne Arpt Orange Co",
    city: "Santa Ana",
    country: "United States",
    iata: "SNA",
    icao: "KSNA",
    latitude: "33.675667",
    longitude: "-117.868222",
    altitude: "56",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3868",
    name: "Columbus Afb",
    city: "Colombus",
    country: "United States",
    iata: "CBM",
    icao: "KCBM",
    latitude: "33.643833",
    longitude: "-88.443833",
    altitude: "219",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3869",
    name: "Kendall Tamiami Executive",
    city: "Kendall-tamiami",
    country: "United States",
    iata: "TMB",
    icao: "KTMB",
    latitude: "25.647889",
    longitude: "-80.432777",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3870",
    name: "Oceana Nas",
    city: "Oceana",
    country: "United States",
    iata: "NTU",
    icao: "KNTU",
    latitude: "36.820703",
    longitude: "-76.033542",
    altitude: "22",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3871",
    name: "Grissom Arb",
    city: "Peru",
    country: "United States",
    iata: "GUS",
    icao: "KGUS",
    latitude: "40.648094",
    longitude: "-86.152119",
    altitude: "812",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3872",
    name: "Natrona Co Intl",
    city: "Casper",
    country: "United States",
    iata: "CPR",
    icao: "KCPR",
    latitude: "42.908",
    longitude: "-106.464417",
    altitude: "5347",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3873",
    name: "Eglin Afb",
    city: "Valparaiso",
    country: "United States",
    iata: "VPS",
    icao: "KVPS",
    latitude: "30.48325",
    longitude: "-86.5254",
    altitude: "87",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3874",
    name: "Craig Fld",
    city: "Selma",
    country: "United States",
    iata: "SEM",
    icao: "KSEM",
    latitude: "32.343947",
    longitude: "-86.987803",
    altitude: "166",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "3875",
    name: "Key West Intl",
    city: "Key West",
    country: "United States",
    iata: "EYW",
    icao: "KEYW",
    latitude: "24.556111",
    longitude: "-81.759556",
    altitude: "3",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3876",
    name: "Charlotte Douglas Intl",
    city: "Charlotte",
    country: "United States",
    iata: "CLT",
    icao: "KCLT",
    latitude: "35.214",
    longitude: "-80.943139",
    altitude: "748",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3877",
    name: "Mc Carran Intl",
    city: "Las Vegas",
    country: "United States",
    iata: "LAS",
    icao: "KLAS",
    latitude: "36.080056",
    longitude: "-115.15225",
    altitude: "2141",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3878",
    name: "Orlando Intl",
    city: "Orlando",
    country: "United States",
    iata: "MCO",
    icao: "KMCO",
    latitude: "28.429394",
    longitude: "-81.308994",
    altitude: "96",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3879",
    name: "Florence Rgnl",
    city: "Florence",
    country: "United States",
    iata: "FLO",
    icao: "KFLO",
    latitude: "34.185361",
    longitude: "-79.723889",
    altitude: "146",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3880",
    name: "Great Falls Intl",
    city: "Great Falls",
    country: "United States",
    iata: "GTF",
    icao: "KGTF",
    latitude: "47.482",
    longitude: "-111.370689",
    altitude: "3677",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "3881",
    name: "Youngstown Warren Rgnl",
    city: "Youngstown",
    country: "United States",
    iata: "YNG",
    icao: "KYNG",
    latitude: "41.260736",
    longitude: "-80.679097",
    altitude: "1196",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3882",
    name: "Ladd Aaf",
    city: "Fort Wainwright",
    country: "United States",
    iata: "FBK",
    icao: "PAFB",
    latitude: "64.8375",
    longitude: "-147.614444",
    altitude: "454",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "3883",
    name: "Mc Minnville Muni",
    city: "Mackminnville",
    country: "United States",
    iata: "MMV",
    icao: "KMMV",
    latitude: "45.194444",
    longitude: "-123.135944",
    altitude: "163",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3884",
    name: "Robins Afb",
    city: "Macon",
    country: "United States",
    iata: "WRB",
    icao: "KWRB",
    latitude: "32.640144",
    longitude: "-83.59185",
    altitude: "294",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3885",
    name: "Suvarnabhumi Intl",
    city: "Bangkok",
    country: "Thailand",
    iata: "BKK",
    icao: "VTBS",
    latitude: "13.681108",
    longitude: "100.747283",
    altitude: "5",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3887",
    name: "Andi Jemma",
    city: "Masamba",
    country: "Indonesia",
    iata: "",
    icao: "WAWM",
    latitude: "-2.558044",
    longitude: "120.324383",
    altitude: "164",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3888",
    name: "Soroako",
    city: "Soroako",
    country: "Indonesia",
    iata: "",
    icao: "WAWS",
    latitude: "-2.531203",
    longitude: "121.357639",
    altitude: "1388",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3889",
    name: "Pongtiku",
    city: "Makale",
    country: "Indonesia",
    iata: "",
    icao: "WAWT",
    latitude: "-3.044736",
    longitude: "119.821536",
    altitude: "2884",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3890",
    name: "Wolter Monginsidi",
    city: "Kendari",
    country: "Indonesia",
    iata: "KDI",
    icao: "WAWW",
    latitude: "-4.081608",
    longitude: "122.418231",
    altitude: "538",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3891",
    name: "Maimun Saleh",
    city: "Sabang",
    country: "Indonesia",
    iata: "SBG",
    icao: "WITB",
    latitude: "5.874131",
    longitude: "95.339672",
    altitude: "393",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3892",
    name: "Cibeureum",
    city: "Tasikmalaya",
    country: "Indonesia",
    iata: "",
    icao: "WICM",
    latitude: "-7.346603",
    longitude: "108.246092",
    altitude: "1148",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3893",
    name: "Iswahyudi",
    city: "Madiun",
    country: "Indonesia",
    iata: "",
    icao: "WARI",
    latitude: "-7.615767",
    longitude: "111.434117",
    altitude: "361",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3894",
    name: "Abdul Rachman Saleh",
    city: "Malang",
    country: "Indonesia",
    iata: "MLG",
    icao: "WARA",
    latitude: "-7.926556",
    longitude: "112.714514",
    altitude: "1726",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3895",
    name: "Budiarto",
    city: "Tangerang",
    country: "Indonesia",
    iata: "",
    icao: "WICB",
    latitude: "-6.293169",
    longitude: "106.5699",
    altitude: "151",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3896",
    name: "Husein Sastranegara",
    city: "Bandung",
    country: "Indonesia",
    iata: "BDO",
    icao: "WICC",
    latitude: "-6.900625",
    longitude: "107.576294",
    altitude: "2436",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3897",
    name: "Penggung",
    city: "Cirebon",
    country: "Indonesia",
    iata: "CBN",
    icao: "WICD",
    latitude: "-6.756144",
    longitude: "108.539672",
    altitude: "89",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3898",
    name: "Adi Sutjipto",
    city: "Yogyakarta",
    country: "Indonesia",
    iata: "JOG",
    icao: "WARJ",
    latitude: "-7.788181",
    longitude: "110.431758",
    altitude: "350",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3899",
    name: "Tunggul Wulung",
    city: "Cilacap",
    country: "Indonesia",
    iata: "CXP",
    icao: "WIHL",
    latitude: "-7.645056",
    longitude: "109.033911",
    altitude: "69",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3900",
    name: "Pondok Cabe",
    city: "Jakarta",
    country: "Indonesia",
    iata: "PCB",
    icao: "WIHP",
    latitude: "-6.336964",
    longitude: "106.764561",
    altitude: "200",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3901",
    name: "Achmad Yani",
    city: "Semarang",
    country: "Indonesia",
    iata: "SRG",
    icao: "WARS",
    latitude: "-6.971447",
    longitude: "110.374122",
    altitude: "13",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3903",
    name: "Hang Nadim",
    city: "Batam",
    country: "Indonesia",
    iata: "BTH",
    icao: "WIDD",
    latitude: "1.121028",
    longitude: "104.118753",
    altitude: "126",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3904",
    name: "H As Hanandjoeddin",
    city: "Tanjung Pandan",
    country: "Indonesia",
    iata: "TJQ",
    icao: "WIOD",
    latitude: "-2.745722",
    longitude: "107.754917",
    altitude: "164",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3905",
    name: "Depati Amir",
    city: "Pangkal Pinang",
    country: "Indonesia",
    iata: "PGK",
    icao: "WIPK",
    latitude: "-2.1622",
    longitude: "106.139064",
    altitude: "109",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3906",
    name: "Kijang",
    city: "Tanjung Pinang",
    country: "Indonesia",
    iata: "TNJ",
    icao: "WIDN",
    latitude: "0.922683",
    longitude: "104.532311",
    altitude: "52",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3907",
    name: "Dabo",
    city: "Singkep",
    country: "Indonesia",
    iata: "SIQ",
    icao: "WIDS",
    latitude: "-0.479189",
    longitude: "104.579283",
    altitude: "95",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3908",
    name: "Syamsudin Noor",
    city: "Banjarmasin",
    country: "Indonesia",
    iata: "BDJ",
    icao: "WAOO",
    latitude: "-3.442356",
    longitude: "114.762553",
    altitude: "66",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3909",
    name: "Batu Licin",
    city: "Batu Licin",
    country: "Indonesia",
    iata: "",
    icao: "WAOC",
    latitude: "-3.412408",
    longitude: "115.995136",
    altitude: "3",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3910",
    name: "Iskandar",
    city: "Pangkalan Bun",
    country: "Indonesia",
    iata: "PKN",
    icao: "WAOI",
    latitude: "-2.705197",
    longitude: "111.673208",
    altitude: "75",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3911",
    name: "Tjilik Riwut",
    city: "Palangkaraya",
    country: "Indonesia",
    iata: "PKY",
    icao: "WAOP",
    latitude: "-2.225128",
    longitude: "113.942661",
    altitude: "82",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6822",
    name: "Militaerlager",
    city: "S-Chanf",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.6166",
    longitude: "9.9833",
    altitude: "5100",
    timezone: "1",
    dst: "U",
    tz: "Europe/Zurich",
  },
  {
    id: "3913",
    name: "Wai Oti",
    city: "Maumere",
    country: "Indonesia",
    iata: "MOF",
    icao: "WATC",
    latitude: "-8.640647",
    longitude: "122.236889",
    altitude: "115",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3914",
    name: "H Hasan Aroeboesman",
    city: "Ende",
    country: "Indonesia",
    iata: "ENE",
    icao: "WATE",
    latitude: "-8.849294",
    longitude: "121.660644",
    altitude: "49",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3915",
    name: "Satar Tacik",
    city: "Ruteng",
    country: "Indonesia",
    iata: "RTG",
    icao: "WATG",
    latitude: "-8.597011",
    longitude: "120.477061",
    altitude: "3510",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3916",
    name: "El Tari",
    city: "Kupang",
    country: "Indonesia",
    iata: "KOE",
    icao: "WATT",
    latitude: "-10.171583",
    longitude: "123.671136",
    altitude: "335",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3917",
    name: "Mutiara Ii",
    city: "Labuhan Bajo",
    country: "Indonesia",
    iata: "LBJ",
    icao: "WATO",
    latitude: "-8.486656",
    longitude: "119.88905",
    altitude: "66",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3919",
    name: "Sepinggan",
    city: "Balikpapan",
    country: "Indonesia",
    iata: "BPN",
    icao: "WALL",
    latitude: "-1.268272",
    longitude: "116.894478",
    altitude: "12",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3920",
    name: "Juwata",
    city: "Taraken",
    country: "Indonesia",
    iata: "TRK",
    icao: "WALR",
    latitude: "3.326694",
    longitude: "117.565569",
    altitude: "20",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3921",
    name: "Temindung",
    city: "Samarinda",
    country: "Indonesia",
    iata: "SRI",
    icao: "WALS",
    latitude: "-0.484531",
    longitude: "117.157111",
    altitude: "33",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3922",
    name: "Tanjung Santan",
    city: "Tanjung Santan",
    country: "Indonesia",
    iata: "",
    icao: "WALT",
    latitude: "-0.093215",
    longitude: "117.439292",
    altitude: "121",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3923",
    name: "Selaparang",
    city: "Mataram",
    country: "Indonesia",
    iata: "AMI",
    icao: "WADA",
    latitude: "-8.560708",
    longitude: "116.094656",
    altitude: "52",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3924",
    name: "Muhammad Salahuddin",
    city: "Bima",
    country: "Indonesia",
    iata: "BMU",
    icao: "WADB",
    latitude: "-8.539647",
    longitude: "118.687322",
    altitude: "3",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6799",
    name: "Krems Langenlois",
    city: "Krems",
    country: "Austria",
    iata: "",
    icao: "LOAG",
    latitude: "48.446075",
    longitude: "15.631243",
    altitude: "1022",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "3927",
    name: "Mau Hau",
    city: "Waingapu",
    country: "Indonesia",
    iata: "WGP",
    icao: "WADW",
    latitude: "-9.669217",
    longitude: "120.302006",
    altitude: "33",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3928",
    name: "Juanda",
    city: "Surabaya",
    country: "Indonesia",
    iata: "SUB",
    icao: "WARR",
    latitude: "-7.379831",
    longitude: "112.786858",
    altitude: "9",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3929",
    name: "Adi Sumarmo Wiryokusumo",
    city: "Solo City",
    country: "Indonesia",
    iata: "SOC",
    icao: "WARQ",
    latitude: "-7.516089",
    longitude: "110.756892",
    altitude: "421",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "3931",
    name: "Chiang Mai Intl",
    city: "Chiang Mai",
    country: "Thailand",
    iata: "CNX",
    icao: "VTCC",
    latitude: "18.766847",
    longitude: "98.962644",
    altitude: "1036",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3932",
    name: "Chiang Rai Intl",
    city: "Chiang Rai",
    country: "Thailand",
    iata: "CEI",
    icao: "VTCT",
    latitude: "19.952342",
    longitude: "99.882928",
    altitude: "1280",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3933",
    name: "Nakhon Si Thammarat",
    city: "Nakhon Si Thammarat",
    country: "Thailand",
    iata: "NST",
    icao: "VTSF",
    latitude: "8.539617",
    longitude: "99.944725",
    altitude: "13",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3940",
    name: "Bali Ngurah Rai",
    city: "Denpasar",
    country: "Indonesia",
    iata: "DPS",
    icao: "WADD",
    latitude: "-8.748169",
    longitude: "115.167172",
    altitude: "14",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "3935",
    name: "Nakhon Ratchasima",
    city: "Nakhon Ratchasima",
    country: "Thailand",
    iata: "NAK",
    icao: "VTUQ",
    latitude: "14.949497",
    longitude: "102.312736",
    altitude: "765",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3936",
    name: "Nakhon Phanom",
    city: "Nakhon Phanom",
    country: "Thailand",
    iata: "KOP",
    icao: "VTUW",
    latitude: "17.383794",
    longitude: "104.643022",
    altitude: "587",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3937",
    name: "Ubon Ratchathani",
    city: "Ubon Ratchathani",
    country: "Thailand",
    iata: "UBP",
    icao: "VTUU",
    latitude: "15.251278",
    longitude: "104.870231",
    altitude: "406",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3938",
    name: "Khon Kaen",
    city: "Khon Kaen",
    country: "Thailand",
    iata: "KKC",
    icao: "VTUK",
    latitude: "16.466628",
    longitude: "102.783661",
    altitude: "670",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3939",
    name: "Sukhothai",
    city: "Sukhothai",
    country: "Thailand",
    iata: "THS",
    icao: "VTPO",
    latitude: "17.237992",
    longitude: "99.818183",
    altitude: "179",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "3941",
    name: "Eleftherios Venizelos Intl",
    city: "Athens",
    country: "Greece",
    iata: "ATH",
    icao: "LGAV",
    latitude: "37.936358",
    longitude: "23.944467",
    altitude: "308",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "3942",
    name: "Chubu Centrair Intl",
    city: "Nagoya",
    country: "Japan",
    iata: "NGO",
    icao: "RJGG",
    latitude: "34.858414",
    longitude: "136.805408",
    altitude: "15",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "3943",
    name: "Kobe",
    city: "Kobe",
    country: "Japan",
    iata: "UKB",
    icao: "RJBE",
    latitude: "34.632778",
    longitude: "135.223889",
    altitude: "22",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "3944",
    name: "Pullman-Moscow Rgnl",
    city: "Pullman",
    country: "United States",
    iata: "PUW",
    icao: "KPUW",
    latitude: "46.743861",
    longitude: "-117.109583",
    altitude: "2556",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3945",
    name: "Lewiston Nez Perce Co",
    city: "Lewiston",
    country: "United States",
    iata: "LWS",
    icao: "KLWS",
    latitude: "46.3745",
    longitude: "-117.015389",
    altitude: "1442",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3946",
    name: "Elmira Corning Rgnl",
    city: "Elmira",
    country: "United States",
    iata: "ELM",
    icao: "KELM",
    latitude: "42.159889",
    longitude: "-76.891611",
    altitude: "954",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3947",
    name: "Ithaca Tompkins Rgnl",
    city: "Ithaca",
    country: "United States",
    iata: "ITH",
    icao: "KITH",
    latitude: "42.491028",
    longitude: "-76.458444",
    altitude: "1099",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3948",
    name: "Monterey Peninsula",
    city: "Monterey",
    country: "United States",
    iata: "MRY",
    icao: "KMRY",
    latitude: "36.587",
    longitude: "-121.842944",
    altitude: "257",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3949",
    name: "Santa Barbara Muni",
    city: "Santa Barbara",
    country: "United States",
    iata: "SBA",
    icao: "KSBA",
    latitude: "34.426211",
    longitude: "-119.840372",
    altitude: "10",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "3950",
    name: "Daytona Beach Intl",
    city: "Daytona Beach",
    country: "United States",
    iata: "DAB",
    icao: "KDAB",
    latitude: "29.179917",
    longitude: "-81.058056",
    altitude: "34",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8421",
    name: "Taoyuan Station",
    city: "Zhongli",
    country: "Taiwan",
    iata: "",
    icao: "\\N",
    latitude: "25.013092",
    longitude: "121.215216",
    altitude: "250",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "3952",
    name: "Liepaja Intl",
    city: "Liepaja",
    country: "Latvia",
    iata: "LPX",
    icao: "EVLA",
    latitude: "56.5175",
    longitude: "21.096944",
    altitude: "16",
    timezone: "2",
    dst: "E",
    tz: "Europe/Riga",
  },
  {
    id: "3953",
    name: "Riga Intl",
    city: "Riga",
    country: "Latvia",
    iata: "RIX",
    icao: "EVRA",
    latitude: "56.923611",
    longitude: "23.971111",
    altitude: "34",
    timezone: "2",
    dst: "E",
    tz: "Europe/Riga",
  },
  {
    id: "3954",
    name: "Siauliai Intl",
    city: "Siauliai",
    country: "Lithuania",
    iata: "SQQ",
    icao: "EYSA",
    latitude: "55.893886",
    longitude: "23.394975",
    altitude: "443",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3955",
    name: "Barysiai",
    city: "Barysiai",
    country: "Lithuania",
    iata: "HLJ",
    icao: "EYSB",
    latitude: "56.070556",
    longitude: "23.558056",
    altitude: "270",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3956",
    name: "Kaunas Intl",
    city: "Kaunas",
    country: "Lithuania",
    iata: "KUN",
    icao: "EYKA",
    latitude: "54.963919",
    longitude: "24.084778",
    altitude: "256",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3957",
    name: "S. Darius",
    city: "Kaunas",
    country: "Lithuania",
    iata: "",
    icao: "EYKS",
    latitude: "54.879792",
    longitude: "23.881511",
    altitude: "246",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3958",
    name: "Palanga Intl",
    city: "Palanga",
    country: "Lithuania",
    iata: "PLQ",
    icao: "EYPA",
    latitude: "55.973228",
    longitude: "21.093856",
    altitude: "33",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3959",
    name: "Vilnius Intl",
    city: "Vilnius",
    country: "Lithuania",
    iata: "VNO",
    icao: "EYVI",
    latitude: "54.634133",
    longitude: "25.285767",
    altitude: "646",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3960",
    name: "Pajuostis",
    city: "Panevezys",
    country: "Lithuania",
    iata: "PNV",
    icao: "EYPP",
    latitude: "55.729444",
    longitude: "24.460833",
    altitude: "197",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "3962",
    name: "Erebuni",
    city: "Yerevan",
    country: "Armenia",
    iata: "",
    icao: "UDYE",
    latitude: "40.122114",
    longitude: "44.464992",
    altitude: "2948",
    timezone: "4",
    dst: "E",
    tz: "Asia/Yerevan",
  },
  {
    id: "3963",
    name: "Stepanavan",
    city: "Stepanavan",
    country: "Armenia",
    iata: "",
    icao: "UDLS",
    latitude: "41.04845",
    longitude: "44.337172",
    altitude: "4836",
    timezone: "4",
    dst: "E",
    tz: "Asia/Yerevan",
  },
  {
    id: "3964",
    name: "Zvartnots",
    city: "Yerevan",
    country: "Armenia",
    iata: "EVN",
    icao: "UDYZ",
    latitude: "40.147275",
    longitude: "44.395881",
    altitude: "2838",
    timezone: "4",
    dst: "E",
    tz: "Asia/Yerevan",
  },
  {
    id: "3965",
    name: "Gyumri",
    city: "Gyumri",
    country: "Armenia",
    iata: "LWN",
    icao: "UDSG",
    latitude: "40.750369",
    longitude: "43.859342",
    altitude: "5000",
    timezone: "4",
    dst: "E",
    tz: "Asia/Yerevan",
  },
  {
    id: "3966",
    name: "Assab Intl",
    city: "Assab",
    country: "Eritrea",
    iata: "ASA",
    icao: "HHSB",
    latitude: "13.071783",
    longitude: "42.645006",
    altitude: "46",
    timezone: "3",
    dst: "U",
    tz: "Africa/Asmera",
  },
  {
    id: "3967",
    name: "Asmara Intl",
    city: "Asmara",
    country: "Eritrea",
    iata: "ASM",
    icao: "HHAS",
    latitude: "15.291853",
    longitude: "38.910667",
    altitude: "7661",
    timezone: "3",
    dst: "U",
    tz: "Africa/Asmera",
  },
  {
    id: "3968",
    name: "Massawa Intl",
    city: "Massawa",
    country: "Eritrea",
    iata: "MSW",
    icao: "HHMS",
    latitude: "15.669989",
    longitude: "39.370103",
    altitude: "194",
    timezone: "3",
    dst: "U",
    tz: "Africa/Asmera",
  },
  {
    id: "3969",
    name: "Yasser Arafat Intl",
    city: "Gaza",
    country: "Palestine",
    iata: "GZA",
    icao: "LVGZ",
    latitude: "31.246389",
    longitude: "34.276111",
    altitude: "320",
    timezone: "2",
    dst: "U",
    tz: "Asia/Gaza",
  },
  {
    id: "3974",
    name: "Riyan",
    city: "Mukalla",
    country: "Yemen",
    iata: "RIY",
    icao: "OYRN",
    latitude: "14.662639",
    longitude: "49.375028",
    altitude: "54",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3971",
    name: "Batumi",
    city: "Batumi",
    country: "Georgia",
    iata: "BUS",
    icao: "UGSB",
    latitude: "41.610278",
    longitude: "41.599694",
    altitude: "105",
    timezone: "4",
    dst: "N",
    tz: "Asia/Tbilisi",
  },
  {
    id: "3972",
    name: "Kopitnari",
    city: "Kutaisi",
    country: "Georgia",
    iata: "KUT",
    icao: "UGKO",
    latitude: "42.176653",
    longitude: "42.482583",
    altitude: "223",
    timezone: "4",
    dst: "N",
    tz: "Asia/Tbilisi",
  },
  {
    id: "3973",
    name: "Tbilisi",
    city: "Tbilisi",
    country: "Georgia",
    iata: "TBS",
    icao: "UGTB",
    latitude: "41.669167",
    longitude: "44.954722",
    altitude: "1624",
    timezone: "4",
    dst: "N",
    tz: "Asia/Tbilisi",
  },
  {
    id: "3975",
    name: "Taiz Intl",
    city: "Taiz",
    country: "Yemen",
    iata: "TAI",
    icao: "OYTZ",
    latitude: "13.685964",
    longitude: "44.139056",
    altitude: "4838",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3976",
    name: "Hodeidah Intl",
    city: "Hodeidah",
    country: "Yemen",
    iata: "HOD",
    icao: "OYHD",
    latitude: "14.753",
    longitude: "42.976336",
    altitude: "41",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3977",
    name: "Aden Intl",
    city: "Aden",
    country: "Yemen",
    iata: "ADE",
    icao: "OYAA",
    latitude: "12.829542",
    longitude: "45.028792",
    altitude: "7",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3978",
    name: "Ataq",
    city: "Ataq",
    country: "Yemen",
    iata: "AXK",
    icao: "OYAT",
    latitude: "14.551322",
    longitude: "46.826183",
    altitude: "3735",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3979",
    name: "Al Ghaidah Intl",
    city: "Al Ghaidah Intl",
    country: "Yemen",
    iata: "AAY",
    icao: "OYGD",
    latitude: "16.191667",
    longitude: "52.175",
    altitude: "134",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3980",
    name: "Sanaa Intl",
    city: "Sanaa",
    country: "Yemen",
    iata: "SAH",
    icao: "OYSN",
    latitude: "15.476258",
    longitude: "44.219739",
    altitude: "7216",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3986",
    name: "Allgau",
    city: "Memmingen",
    country: "Germany",
    iata: "FMM",
    icao: "EDJA",
    latitude: "47.988758",
    longitude: "10.2395",
    altitude: "2077",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "3982",
    name: "Beihan",
    city: "Beihan",
    country: "Yemen",
    iata: "BHN",
    icao: "OYBN",
    latitude: "14.781972",
    longitude: "45.720083",
    altitude: "3800",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "6863",
    name: "RK Heliplex",
    city: "Panorama",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "50.2735",
    longitude: "-116.14",
    altitude: "358",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "3984",
    name: "Socotra Intl",
    city: "Socotra",
    country: "Yemen",
    iata: "SCT",
    icao: "OYSQ",
    latitude: "12.630672",
    longitude: "53.905778",
    altitude: "146",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3985",
    name: "Al Badie",
    city: "Al Badie",
    country: "Yemen",
    iata: "",
    icao: "OYBA",
    latitude: "18.719311",
    longitude: "50.836911",
    altitude: "908",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "3987",
    name: "Kapadokya",
    city: "Nevsehir",
    country: "Turkey",
    iata: "NAV",
    icao: "LTAZ",
    latitude: "38.771867",
    longitude: "34.53455",
    altitude: "3100",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "3988",
    name: "Ministro Pistarini",
    city: "Buenos Aires",
    country: "Argentina",
    iata: "EZE",
    icao: "SAEZ",
    latitude: "-34.822222",
    longitude: "-58.535833",
    altitude: "67",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "3989",
    name: "Erbil Intl",
    city: "Erbil",
    country: "Iraq",
    iata: "EBL",
    icao: "ORER",
    latitude: "36.237611",
    longitude: "43.963158",
    altitude: "1341",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "3990",
    name: "Emerald",
    city: "Emerald",
    country: "Australia",
    iata: "EMD",
    icao: "YEML",
    latitude: "-23.5675",
    longitude: "148.179167",
    altitude: "624",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "3991",
    name: "Ellinikon International Airport",
    city: "Athens",
    country: "Greece",
    iata: "",
    icao: "LGAT",
    latitude: "37.5354",
    longitude: "23.4346",
    altitude: "68",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "3992",
    name: "Kansai",
    city: "Osaka",
    country: "Japan",
    iata: "KIX",
    icao: "RJBB",
    latitude: "34.4347222",
    longitude: "135.244167",
    altitude: "49",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "3993",
    name: "Wall Street Heliport",
    city: "New York",
    country: "United States",
    iata: "JRB",
    icao: "KJRB",
    latitude: "40.701214",
    longitude: "-74.009028",
    altitude: "7",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "3994",
    name: "Tagbilaran",
    city: "Tagbilaran",
    country: "Philippines",
    iata: "TAG",
    icao: "RPVT",
    latitude: "9.66408056",
    longitude: "123.853247",
    altitude: "38",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "3995",
    name: "Ilulissat",
    city: "Ilulissat",
    country: "Greenland",
    iata: "JAV",
    icao: "BGJN",
    latitude: "69.23444",
    longitude: "-51.05111",
    altitude: "2",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "3996",
    name: "Qasigiannguit",
    city: "Qasigiannguit",
    country: "Greenland",
    iata: "JCH",
    icao: "BGCH",
    latitude: "68.833336",
    longitude: "-51",
    altitude: "2",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "3997",
    name: "Aasiaat",
    city: "Aasiaat",
    country: "Greenland",
    iata: "JEG",
    icao: "BGEM",
    latitude: "68.7",
    longitude: "-52.75",
    altitude: "2",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "3998",
    name: "Son Sant Joan",
    city: "Palma de Mallorca",
    country: "Spain",
    iata: "PMI",
    icao: "LEPA",
    latitude: "39.55361",
    longitude: "2.727778",
    altitude: "24",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "3999",
    name: "Darwin Intl",
    city: "Darwin",
    country: "Australia",
    iata: "DRW",
    icao: "YPDN",
    latitude: "-12.4083333",
    longitude: "130.87266",
    altitude: "103",
    timezone: "9.5",
    dst: "N",
    tz: "Australia/Darwin",
  },
  {
    id: "4000",
    name: "Surat Thani",
    city: "Surat Thani",
    country: "Thailand",
    iata: "URT",
    icao: "VTSB",
    latitude: "9.1325",
    longitude: "99.135556",
    altitude: "286",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4001",
    name: "Bagan Intl",
    city: "Nyuang U",
    country: "Burma",
    iata: "NYU",
    icao: "VYBR",
    latitude: "21.173833266",
    longitude: "94.9246666",
    altitude: "290",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "4002",
    name: "Godofredo P",
    city: "Caticlan",
    country: "Philippines",
    iata: "MPH",
    icao: "RPXE",
    latitude: "11.9214999",
    longitude: "121.953",
    altitude: "20",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4003",
    name: "Bimini North Seaplane Base",
    city: "Bimini",
    country: "Bahamas",
    iata: "NSB",
    icao: "\\N",
    latitude: "25.767",
    longitude: "-79.25",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "4004",
    name: "Talkeetna",
    city: "Talkeetna",
    country: "United States",
    iata: "TKA",
    icao: "PATK",
    latitude: "62.3205",
    longitude: "-150.093694",
    altitude: "358",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "4005",
    name: "Xewkija Heliport",
    city: "Gozo",
    country: "Malta",
    iata: "GZM",
    icao: "LMMG",
    latitude: "36.027222",
    longitude: "14.272778",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "4006",
    name: "Tweed-New Haven Airport",
    city: "New Haven",
    country: "United States",
    iata: "HVN",
    icao: "KHVN",
    latitude: "41.26375",
    longitude: "-72.886806",
    altitude: "14",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4007",
    name: "Asheville Regional Airport",
    city: "Asheville",
    country: "United States",
    iata: "AVL",
    icao: "KAVL",
    latitude: "35.436194",
    longitude: "-82.541806",
    altitude: "2165",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4008",
    name: "Piedmont Triad",
    city: "Greensboro",
    country: "United States",
    iata: "GSO",
    icao: "KGSO",
    latitude: "36.09775",
    longitude: "-79.937306",
    altitude: "925",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4009",
    name: "Sioux Falls",
    city: "Sioux Falls",
    country: "United States",
    iata: "FSD",
    icao: "KFSD",
    latitude: "43.582014",
    longitude: "-96.741914",
    altitude: "1429",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4010",
    name: "Ayers Rock",
    city: "Uluru",
    country: "Australia",
    iata: "AYQ",
    icao: "YAYE",
    latitude: "-25.186111",
    longitude: "130.975556",
    altitude: "1626",
    timezone: "9.5",
    dst: "N",
    tz: "Australia/Darwin",
  },
  {
    id: "4011",
    name: "Manchester Regional Airport",
    city: "Manchester NH",
    country: "United States",
    iata: "MHT",
    icao: "KMHT",
    latitude: "42.932556",
    longitude: "-71.435667",
    altitude: "266",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4012",
    name: "Naples Muni",
    city: "Naples",
    country: "United States",
    iata: "APF",
    icao: "KAPF",
    latitude: "26.152619",
    longitude: "-81.775294",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4013",
    name: "Redang",
    city: "Redang",
    country: "Malaysia",
    iata: "RDN",
    icao: "WMPR",
    latitude: "5.76528",
    longitude: "103.007",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "4014",
    name: "Louisville International Airport",
    city: "Louisville",
    country: "United States",
    iata: "SDF",
    icao: "KSDF",
    latitude: "38.1740858",
    longitude: "-85.7364989",
    altitude: "501",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4015",
    name: "Charlottesville-Albemarle",
    city: "Charlottesville VA",
    country: "United States",
    iata: "CHO",
    icao: "KCHO",
    latitude: "38.138639",
    longitude: "-78.452861",
    altitude: "639",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4016",
    name: "Roanoke Regional",
    city: "Roanoke VA",
    country: "United States",
    iata: "ROA",
    icao: "KROA",
    latitude: "37.325472",
    longitude: "-79.975417",
    altitude: "1175",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4017",
    name: "Blue Grass",
    city: "Lexington KY",
    country: "United States",
    iata: "LEX",
    icao: "KLEX",
    latitude: "38.0365",
    longitude: "-84.605889",
    altitude: "979",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4018",
    name: "Evansville Regional",
    city: "Evansville",
    country: "United States",
    iata: "EVV",
    icao: "KEVV",
    latitude: "38.036997",
    longitude: "-87.532364",
    altitude: "418",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4019",
    name: "Albuquerque International Sunport",
    city: "Albuquerque",
    country: "United States",
    iata: "ABQ",
    icao: "KABQ",
    latitude: "35.0402222",
    longitude: "-106.6091944",
    altitude: "5355",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4020",
    name: "Gallatin Field",
    city: "Bozeman",
    country: "United States",
    iata: "BZN",
    icao: "KBZN",
    latitude: "45.777643",
    longitude: "-111.160151",
    altitude: "4500",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4021",
    name: "Billings Logan International Airport",
    city: "Billings",
    country: "United States",
    iata: "BIL",
    icao: "KBIL",
    latitude: "45.80921",
    longitude: "-108.537654",
    altitude: "3652",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4022",
    name: "Bert Mooney Airport",
    city: "Butte",
    country: "United States",
    iata: "BTM",
    icao: "KBTM",
    latitude: "45.954806",
    longitude: "-112.497472",
    altitude: "5550",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4023",
    name: "Cherry Capital Airport",
    city: "Traverse City",
    country: "United States",
    iata: "TVC",
    icao: "KTVC",
    latitude: "44.741445",
    longitude: "-85.582235",
    altitude: "624",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4024",
    name: "Mundo Maya International",
    city: "Flores",
    country: "Guatemala",
    iata: "FRS",
    icao: "MGTK",
    latitude: "16.913819",
    longitude: "-89.866383",
    altitude: "427",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "4025",
    name: "Hancock County - Bar Harbor",
    city: "Bar Harbor",
    country: "United States",
    iata: "BHB",
    icao: "KBHB",
    latitude: "44.4497689",
    longitude: "-68.3615653",
    altitude: "83",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4026",
    name: "Knox County Regional Airport",
    city: "Rockland",
    country: "United States",
    iata: "RKD",
    icao: "KRKD",
    latitude: "44.0601111",
    longitude: "-69.0992303",
    altitude: "56",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4027",
    name: "Jackson Hole Airport",
    city: "Jacksn Hole",
    country: "United States",
    iata: "JAC",
    icao: "KJAC",
    latitude: "43.607333333",
    longitude: "-110.73775",
    altitude: "6451",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4028",
    name: "Chicago Rockford International Airport ",
    city: "Rockford",
    country: "United States",
    iata: "RFD",
    icao: "KRFD",
    latitude: "42.1953611",
    longitude: "-89.0972222",
    altitude: "742",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4029",
    name: "Domododevo",
    city: "Moscow",
    country: "Russia",
    iata: "DME",
    icao: "UUDD",
    latitude: "55.408611",
    longitude: "37.906111",
    altitude: "588",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4030",
    name: "Phoenix International",
    city: "Sanya",
    country: "China",
    iata: "SYX",
    icao: "ZJSY",
    latitude: "18.302897",
    longitude: "109.412272",
    altitude: "92",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4031",
    name: "Milford Sound Airport",
    city: "Milford Sound",
    country: "New Zealand",
    iata: "MFN",
    icao: "NZMF",
    latitude: "-44.67333",
    longitude: "167.92333",
    altitude: "10",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "4032",
    name: "East 34th Street Heliport",
    city: "New York",
    country: "United States",
    iata: "TSS",
    icao: "NONE",
    latitude: "40.7425",
    longitude: "-73.971944",
    altitude: "10",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4033",
    name: "Lijiang Airport",
    city: "Lijiang",
    country: "China",
    iata: "LJG",
    icao: "ZPLJ",
    latitude: "26.883333",
    longitude: "100.23333",
    altitude: "7923",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4034",
    name: "Greenville-Spartanburg International",
    city: "Greenville",
    country: "United States",
    iata: "GSP",
    icao: "KGSP",
    latitude: "34.895556",
    longitude: "-82.218889",
    altitude: "964",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4035",
    name: "Cologne Railway",
    city: "Cologne",
    country: "Germany",
    iata: "QKL",
    icao: "\\N",
    latitude: "50.9425",
    longitude: "6.958056",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4036",
    name: "Stuttgart Railway Station",
    city: "Stuttgart",
    country: "Germany",
    iata: "ZWS",
    icao: "\\N",
    latitude: "48.783611",
    longitude: "9.181667",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4037",
    name: "Central Illinois Rgnl",
    city: "Bloomington",
    country: "United States",
    iata: "BMI",
    icao: "KBMI",
    latitude: "40.477111",
    longitude: "-88.915917",
    altitude: "871",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4038",
    name: "Gulfport-Biloxi",
    city: "Gulfport",
    country: "United States",
    iata: "GPT",
    icao: "KGPT",
    latitude: "30.407278",
    longitude: "-89.070111",
    altitude: "28",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4039",
    name: "Kalamazoo",
    city: "Kalamazoo",
    country: "United States",
    iata: "AZO",
    icao: "KAZO",
    latitude: "42.234875",
    longitude: "-85.552058",
    altitude: "874",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4040",
    name: "Toledo",
    city: "Toledo",
    country: "United States",
    iata: "TOL",
    icao: "KTOL",
    latitude: "41.586806",
    longitude: "-83.807833",
    altitude: "684",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4041",
    name: "Fort Wayne",
    city: "Fort Wayne",
    country: "United States",
    iata: "FWA",
    icao: "KFWA",
    latitude: "40.978472",
    longitude: "-85.195139",
    altitude: "815",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4042",
    name: "Decatur",
    city: "Decatur",
    country: "United States",
    iata: "DEC",
    icao: "KDEC",
    latitude: "39.834564",
    longitude: "-88.865689",
    altitude: "682",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4043",
    name: "Cedar Rapids",
    city: "Cedar Rapids",
    country: "United States",
    iata: "CID",
    icao: "KCID",
    latitude: "41.884694",
    longitude: "-91.710806",
    altitude: "869",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4044",
    name: "La Crosse Municipal",
    city: "La Crosse",
    country: "United States",
    iata: "LSE",
    icao: "KLSE",
    latitude: "43.878986",
    longitude: "-91.256711",
    altitude: "654",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4045",
    name: "Central Wisconsin",
    city: "Wassau",
    country: "United States",
    iata: "CWA",
    icao: "KCWA",
    latitude: "44.772726",
    longitude: "-89.646635",
    altitude: "840",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4046",
    name: "Peoria Regional",
    city: "Peoria",
    country: "United States",
    iata: "PIA",
    icao: "KPIA",
    latitude: "40.664203",
    longitude: "-89.693258",
    altitude: "660",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4047",
    name: "Appleton",
    city: "Appleton",
    country: "United States",
    iata: "ATW",
    icao: "KATW",
    latitude: "44.257526",
    longitude: "-88.507576",
    altitude: "680",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4048",
    name: "Rochester",
    city: "Rochester",
    country: "United States",
    iata: "RST",
    icao: "KRST",
    latitude: "43.908283",
    longitude: "-92.500014",
    altitude: "1317",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4049",
    name: "Champaign",
    city: "Champaign",
    country: "United States",
    iata: "CMI",
    icao: "KCMI",
    latitude: "40.03925",
    longitude: "-88.278056",
    altitude: "754",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4050",
    name: "Manhattan Reigonal",
    city: "Manhattan",
    country: "United States",
    iata: "MHK",
    icao: "KMHK",
    latitude: "39.140972",
    longitude: "-96.670833",
    altitude: "1057",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4051",
    name: "Kingscote Airport",
    city: "Kingscote",
    country: "Australia",
    iata: "KGC",
    icao: "YKSC",
    latitude: "-35.713889",
    longitude: "137.521389",
    altitude: "24",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "4052",
    name: "Hervey Bay Airport",
    city: "Hervey Bay",
    country: "Australia",
    iata: "HVB",
    icao: "YHBA",
    latitude: "-25.318889",
    longitude: "152.880278",
    altitude: "60",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "4053",
    name: "EuroAirport Basel-Mulhouse-Freiburg",
    city: "Basel",
    country: "Switzerland",
    iata: "BSL",
    icao: "\\N",
    latitude: "47.59",
    longitude: "7.529167",
    altitude: "885",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "4054",
    name: "Dali",
    city: "Dali",
    country: "China",
    iata: "DLU",
    icao: "ZPDL",
    latitude: "25.649444",
    longitude: "100.319444",
    altitude: "6978",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4055",
    name: "Jinghong",
    city: "Jinghong",
    country: "China",
    iata: "JHG",
    icao: "\\N",
    latitude: "21.973914",
    longitude: "100.759611",
    altitude: "1815",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4056",
    name: "Mulu",
    city: "Mulu",
    country: "Malaysia",
    iata: "MZV",
    icao: "\\N",
    latitude: "4.048333",
    longitude: "114.805",
    altitude: "80",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "4057",
    name: "Sharm El Sheikh Intl",
    city: "Sharm El Sheikh",
    country: "Egypt",
    iata: "SSH",
    icao: "HESH",
    latitude: "27.977222",
    longitude: "34.394722",
    altitude: "143",
    timezone: "2",
    dst: "N",
    tz: "Africa/Cairo",
  },
  {
    id: "4058",
    name: "Franklin",
    city: "Franklin",
    country: "United States",
    iata: "FKL",
    icao: "KFKL",
    latitude: "41.377874",
    longitude: "-79.860362",
    altitude: "1540",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4059",
    name: "Jomo Kenyatta International",
    city: "Nairobi",
    country: "Kenya",
    iata: "NBO",
    icao: "HKJK",
    latitude: "-1.319167",
    longitude: "36.9275",
    altitude: "5327",
    timezone: "3",
    dst: "N",
    tz: "Africa/Nairobi",
  },
  {
    id: "4060",
    name: "Seronera",
    city: "Seronera",
    country: "Tanzania",
    iata: "SEU",
    icao: "HTSN",
    latitude: "-2.458056",
    longitude: "34.8225",
    altitude: "5080",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "4061",
    name: "El Calafate",
    city: "El Calafate",
    country: "Argentina",
    iata: "FTE",
    icao: "SAWC",
    latitude: "-50.280322",
    longitude: "-72.053103",
    altitude: "669",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "4062",
    name: "Armidale",
    city: "Armidale",
    country: "Australia",
    iata: "ARM",
    icao: "YARM",
    latitude: "-30.528056",
    longitude: "151.617222",
    altitude: "3556",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "4063",
    name: "Grand Junction Regional",
    city: "Grand Junction",
    country: "United States",
    iata: "GJT",
    icao: "KGJT",
    latitude: "39.122413",
    longitude: "-108.526735",
    altitude: "4858",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4064",
    name: "St George Muni",
    city: "Saint George",
    country: "United States",
    iata: "SGU",
    icao: "KSGU",
    latitude: "37.090583",
    longitude: "-113.593056",
    altitude: "2941",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4065",
    name: "David Wayne Hooks Field",
    city: "Houston",
    country: "United States",
    iata: "DWH",
    icao: "KDWH",
    latitude: "30.063746",
    longitude: "-95.554276",
    altitude: "152",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4066",
    name: "Port O\\\\'Connor Airfield",
    city: "Port O\\\\'Connor",
    country: "United States",
    iata: "S46",
    icao: "XS46",
    latitude: "28.429977",
    longitude: "-96.442859",
    altitude: "10",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4067",
    name: "Sarasota Bradenton Intl",
    city: "Sarasota",
    country: "United States",
    iata: "SRQ",
    icao: "KSRQ",
    latitude: "27.395444",
    longitude: "-82.554389",
    altitude: "30",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4071",
    name: "Van Nuys",
    city: "Van Nuys",
    country: "United States",
    iata: "VNY",
    icao: "KVNY",
    latitude: "34.209811",
    longitude: "-118.489972",
    altitude: "802",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4069",
    name: "Bermuda Intl",
    city: "Bermuda",
    country: "Bermuda",
    iata: "BDA",
    icao: "TXKF",
    latitude: "32.364042",
    longitude: "-64.678703",
    altitude: "12",
    timezone: "-4",
    dst: "A",
    tz: "Atlantic/Bermuda",
  },
  {
    id: "4070",
    name: "Arthur Dunn Airpark",
    city: "Titusville",
    country: "United States",
    iata: "X21",
    icao: "\\N",
    latitude: "28.622552",
    longitude: "-80.83541",
    altitude: "30",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4072",
    name: "Quad City Intl",
    city: "Moline",
    country: "United States",
    iata: "MLI",
    icao: "KMLI",
    latitude: "41.448528",
    longitude: "-90.507539",
    altitude: "590",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4073",
    name: "Panama City Bay Co Intl",
    city: "Panama City",
    country: "United States",
    iata: "PFN",
    icao: "KPFN",
    latitude: "30.212083",
    longitude: "-85.682806",
    altitude: "20",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4074",
    name: "Honiara International",
    city: "Honiara",
    country: "Solomon Islands",
    iata: "HIR",
    icao: "AGGH",
    latitude: "-9.428",
    longitude: "160.054789",
    altitude: "28",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "4075",
    name: "Faa\\\\'a International",
    city: "Papeete",
    country: "French Polynesia",
    iata: "PPT",
    icao: "NTAA",
    latitude: "-17.556667",
    longitude: "-149.611389",
    altitude: "7",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "4076",
    name: "Nauru Intl",
    city: "Nauru",
    country: "Nauru",
    iata: "INU",
    icao: "ANYN",
    latitude: "-0.547458",
    longitude: "166.9191",
    altitude: "22",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Nauru",
  },
  {
    id: "4077",
    name: "Funafuti International",
    city: "Funafuti",
    country: "Tuvalu",
    iata: "FUN",
    icao: "NGFU",
    latitude: "-8.525",
    longitude: "179.196389",
    altitude: "9",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Funafuti",
  },
  {
    id: "4078",
    name: "Tolmachevo",
    city: "Novosibirsk",
    country: "Russia",
    iata: "OVB",
    icao: "UNNT",
    latitude: "55.012622",
    longitude: "82.650656",
    altitude: "365",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "4079",
    name: "Orlando",
    city: "Orlando",
    country: "United States",
    iata: "DWS",
    icao: "\\N",
    latitude: "28.398",
    longitude: "-81.57",
    altitude: "340",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4080",
    name: "Stavns",
    city: "Samsoe",
    country: "Denmark",
    iata: "",
    icao: "EKSS",
    latitude: "55.89",
    longitude: "10.62",
    altitude: "1",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "4081",
    name: "Xieng Khouang",
    city: "Phon Savan",
    country: "Laos",
    iata: "XKH",
    icao: "VLXK",
    latitude: "19.449997",
    longitude: "103.158333",
    altitude: "3445",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "4082",
    name: "Phu Bai",
    city: "Hue",
    country: "Vietnam",
    iata: "HUI",
    icao: "\\N",
    latitude: "16.401499",
    longitude: "107.702614",
    altitude: "48",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4083",
    name: "Bismarck Municipal Airport",
    city: "Bismarck",
    country: "United States",
    iata: "BIS",
    icao: "KBIS",
    latitude: "46.775842",
    longitude: "-100.757931",
    altitude: "1661",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4084",
    name: "Telluride",
    city: "Telluride",
    country: "United States",
    iata: "TEX",
    icao: "KTEX",
    latitude: "37.953759",
    longitude: "-107.90848",
    altitude: "9078",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4085",
    name: "Yinchuan",
    city: "Yinchuan",
    country: "China",
    iata: "INC",
    icao: "ZLIC",
    latitude: "38.481944",
    longitude: "106.009167",
    altitude: "3600",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4086",
    name: "Mae Hong Son",
    city: "Mae Hong Son",
    country: "Thailand",
    iata: "HGN",
    icao: "VTCH",
    latitude: "19.301667",
    longitude: "97.975",
    altitude: "929",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4087",
    name: "Rapid City Regional Airport",
    city: "Rapid City",
    country: "United States",
    iata: "RAP",
    icao: "KRAP",
    latitude: "44.045278",
    longitude: "-103.057222",
    altitude: "3204",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4088",
    name: "McClellan-Palomar Airport",
    city: "Carlsbad",
    country: "United States",
    iata: "CLD",
    icao: "KCRQ",
    latitude: "33.0742",
    longitude: "-117.1648",
    altitude: "328",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4089",
    name: "Bishop International",
    city: "Flint",
    country: "United States",
    iata: "FNT",
    icao: "KFNT",
    latitude: "42.965424",
    longitude: "-83.743629",
    altitude: "782",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4090",
    name: "Francisco Bangoy International",
    city: "Davao",
    country: "Philippines",
    iata: "DVO",
    icao: "RPMD",
    latitude: "7.125522",
    longitude: "125.645778",
    altitude: "59",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4091",
    name: "Madeira",
    city: "Funchal",
    country: "Portugal",
    iata: "FNC",
    icao: "LPMA",
    latitude: "32.697889",
    longitude: "-16.774453",
    altitude: "192",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "4092",
    name: "Santarem",
    city: "Santarem",
    country: "Brazil",
    iata: "STM",
    icao: "SBSN",
    latitude: "-2.422431",
    longitude: "-54.792789",
    altitude: "198",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "4093",
    name: "Sihanoukville",
    city: "Sihanoukville",
    country: "Cambodia",
    iata: "KOS",
    icao: "VDSV",
    latitude: "10.579686",
    longitude: "103.636828",
    altitude: "33",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "4094",
    name: "Ekati",
    city: "Ekati",
    country: "Canada",
    iata: "YOA",
    icao: "CYOA",
    latitude: "64.698889",
    longitude: "-110.614722",
    altitude: "1540",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4095",
    name: "Napier",
    city: "NAPIER",
    country: "New Zealand",
    iata: "NPE",
    icao: "NZNR",
    latitude: "-39.465833",
    longitude: "176.87",
    altitude: "6",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "4096",
    name: "Levuka Airfield",
    city: "Levuka",
    country: "Fiji",
    iata: "LEV",
    icao: "NFNB",
    latitude: "-17.68333",
    longitude: "178.83333",
    altitude: "11",
    timezone: "12",
    dst: "N",
    tz: "Pacific/Fiji",
  },
  {
    id: "4097",
    name: "Lhasa-Gonggar",
    city: "Lhasa",
    country: "China",
    iata: "LXA",
    icao: "ZULS",
    latitude: "29.297778",
    longitude: "90.911944",
    altitude: "13136",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4098",
    name: "Redding Muni",
    city: "Redding",
    country: "United States",
    iata: "RDD",
    icao: "KRDD",
    latitude: "40.509",
    longitude: "-122.293389",
    altitude: "504",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4099",
    name: "Mahlon Sweet Fld",
    city: "Eugene",
    country: "United States",
    iata: "EUG",
    icao: "KEUG",
    latitude: "44.124583",
    longitude: "-123.211972",
    altitude: "374",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4100",
    name: "Idaho Falls Rgnl",
    city: "Idaho Falls",
    country: "United States",
    iata: "IDA",
    icao: "KIDA",
    latitude: "43.514556",
    longitude: "-112.07075",
    altitude: "4744",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4101",
    name: "Rogue Valley Intl Medford",
    city: "Medford",
    country: "United States",
    iata: "MFR",
    icao: "KMFR",
    latitude: "42.374228",
    longitude: "-122.8735",
    altitude: "1335",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4102",
    name: "Kaikoura",
    city: "Kaikoura",
    country: "New Zealand",
    iata: "KBZ",
    icao: "NZKI",
    latitude: "-42.416668",
    longitude: "173.68333",
    altitude: "19",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "4103",
    name: "Roberts Fld",
    city: "Redmond-Bend",
    country: "United States",
    iata: "RDM",
    icao: "KRDM",
    latitude: "44.254066",
    longitude: "-121.149964",
    altitude: "3077",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4104",
    name: "Koromiko",
    city: "Picton",
    country: "New Zealand",
    iata: "PCN",
    icao: "NZPN",
    latitude: "-41.348333",
    longitude: "173.955278",
    altitude: "60",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "4105",
    name: "Windhoek Hosea Kutako International Airport ",
    city: "Windhoek",
    country: "Namibia",
    iata: "WDH",
    icao: "FYWV",
    latitude: "-22.486667",
    longitude: "17.4625",
    altitude: "5640",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "4106",
    name: "Victoria Inner Harbour Airport",
    city: "Victoria",
    country: "Canada",
    iata: "YWH",
    icao: "CYWH",
    latitude: "48.422778",
    longitude: "-123.3875",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "4107",
    name: "Vancouver Coal Harbour",
    city: "Vancouver",
    country: "Canada",
    iata: "CXH",
    icao: "CAQ3",
    latitude: "49.289722",
    longitude: "-123.115833",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "4108",
    name: "Jinan",
    city: "Jinan",
    country: "China",
    iata: "TNA",
    icao: "ZSJN",
    latitude: "36.857214",
    longitude: "117.215992",
    altitude: "76",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4109",
    name: "Changzhou",
    city: "Changzhou",
    country: "China",
    iata: "CZX",
    icao: "ZSCG",
    latitude: "31.941667",
    longitude: "119.711667",
    altitude: "39",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4110",
    name: "Yibin",
    city: "Yibin",
    country: "China",
    iata: "YBP",
    icao: "ZUYB",
    latitude: "28.800278",
    longitude: "104.544444",
    altitude: "1000",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4111",
    name: "Roschino",
    city: "Tyumen",
    country: "Russia",
    iata: "TJM",
    icao: "USTR",
    latitude: "57.189567",
    longitude: "65.3243",
    altitude: "378",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "4112",
    name: "Akron Canton Regional Airport",
    city: "Akron",
    country: "United States",
    iata: "CAK",
    icao: "KCAK",
    latitude: "40.9160833",
    longitude: "-81.4421944",
    altitude: "1228",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4113",
    name: "Huntsville International Airport-Carl T Jones Field",
    city: "Huntsville",
    country: "United States",
    iata: "HSV",
    icao: "KHSV",
    latitude: "34.6371944",
    longitude: "-86.7750556",
    altitude: "629",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4114",
    name: "Mid-Ohio Valley Regional Airport",
    city: "PARKERSBURG",
    country: "United States",
    iata: "PKB",
    icao: "KPKB",
    latitude: "39.3451039",
    longitude: "-81.4392031",
    altitude: "858",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4115",
    name: "Montgomery Regional Airport ",
    city: "MONTGOMERY",
    country: "United States",
    iata: "MGM",
    icao: "KMGM",
    latitude: "32.3006389",
    longitude: "-86.3939722",
    altitude: "221",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4116",
    name: "Tri-Cities Regional Airport",
    city: "BRISTOL",
    country: "United States",
    iata: "TRI",
    icao: "KTRI",
    latitude: "36.4752222",
    longitude: "-82.4074167",
    altitude: "1519",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4117",
    name: "Barkley Regional Airport",
    city: "PADUCAH",
    country: "United States",
    iata: "PAH",
    icao: "KPAH",
    latitude: "37.0602875",
    longitude: "-88.7729583",
    altitude: "410",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4118",
    name: "Kurumoch",
    city: "Samara",
    country: "Russia",
    iata: "KUF",
    icao: "\\N",
    latitude: "53.5",
    longitude: "50.15",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4119",
    name: "Ambouli International Airport",
    city: "Djibouti",
    country: "Djibouti",
    iata: "JIB",
    icao: "HDAM",
    latitude: "11.5472",
    longitude: "43.1594",
    altitude: "49",
    timezone: "3",
    dst: "U",
    tz: "Africa/Djibouti",
  },
  {
    id: "4120",
    name: "Meilan",
    city: "Haikou",
    country: "China",
    iata: "HAK",
    icao: "ZJHK",
    latitude: "19.934856",
    longitude: "110.458961",
    altitude: "75",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4121",
    name: "Mafia",
    city: "Mafia Island",
    country: "Tanzania",
    iata: "MFA",
    icao: "HTMA",
    latitude: "-7.913889",
    longitude: "39.665",
    altitude: "60",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "4127",
    name: "Glacier Park Intl",
    city: "Kalispell",
    country: "United States",
    iata: "FCA",
    icao: "KFCA",
    latitude: "48.310472",
    longitude: "-114.256",
    altitude: "2977",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4123",
    name: "Mtemere Airstrip",
    city: "Selous",
    country: "Tanzania",
    iata: "",
    icao: "",
    latitude: "-7.75093364715576",
    longitude: "38.2032814025878",
    altitude: "60",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "4124",
    name: "Page Municipal Airport",
    city: "Page",
    country: "United States",
    iata: "PGA",
    icao: "KPGA",
    latitude: "36.9261",
    longitude: "-111.4483",
    altitude: "4316",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "4125",
    name: "Utila Airport",
    city: "Utila",
    country: "Honduras",
    iata: "UII",
    icao: "MHUT",
    latitude: "16.091667",
    longitude: "-86.8875",
    altitude: "10",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "4126",
    name: "Santa Elena Airport",
    city: "Santa Elena de Uairen",
    country: "Venezuela",
    iata: "SNV",
    icao: "\\N",
    latitude: "4.554722",
    longitude: "-61.144922",
    altitude: "3585",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "4128",
    name: "Mbs Intl",
    city: "Saginaw",
    country: "United States",
    iata: "MBS",
    icao: "KMBS",
    latitude: "43.532913",
    longitude: "-84.079647",
    altitude: "668",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4129",
    name: "Greater Binghamton Edwin A Link Fld",
    city: "Binghamton",
    country: "United States",
    iata: "BGM",
    icao: "KBGM",
    latitude: "42.208689",
    longitude: "-75.979839",
    altitude: "1636",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4130",
    name: "Baghdad International Airport",
    city: "Baghdad",
    country: "Iraq",
    iata: "BGW",
    icao: "ORBI",
    latitude: "33.262539",
    longitude: "44.234578",
    altitude: "114",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "4131",
    name: "Nan",
    city: "Nan",
    country: "Thailand",
    iata: "NNT",
    icao: "VTCN",
    latitude: "18.807914",
    longitude: "100.783419",
    altitude: "685",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4132",
    name: "Roi Et",
    city: "Roi Et",
    country: "Thailand",
    iata: "ROI",
    icao: "VTUV",
    latitude: "16.116761",
    longitude: "103.773797",
    altitude: "451",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4133",
    name: "Buri Ram",
    city: "Buri Ram",
    country: "Thailand",
    iata: "BFV",
    icao: "VTUO",
    latitude: "15.229539",
    longitude: "103.253231",
    altitude: "590",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4134",
    name: "Ranong",
    city: "Ranong",
    country: "Thailand",
    iata: "UNN",
    icao: "\\N",
    latitude: "9.777622",
    longitude: "98.585483",
    altitude: "57",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4135",
    name: "Trat",
    city: "Trat",
    country: "Thailand",
    iata: "TDX",
    icao: "VTBO",
    latitude: "12.274572",
    longitude: "102.318958",
    altitude: "105",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4136",
    name: "Blythe Airport",
    city: "Blythe",
    country: "United States",
    iata: "BLH",
    icao: "KBLH",
    latitude: "33.619167",
    longitude: "-114.716889",
    altitude: "399",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4137",
    name: "Al Asad Airbase",
    city: "Al Asad",
    country: "Iraq",
    iata: "",
    icao: "ORAA",
    latitude: "33.785608",
    longitude: "42.4412",
    altitude: "618",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "4138",
    name: "Al Taqaddum Airbase",
    city: "Al Taqaddum",
    country: "Iraq",
    iata: "",
    icao: "ORAT",
    latitude: "33.338053",
    longitude: "43.597072",
    altitude: "275",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "4139",
    name: "Balad Southeast Airport",
    city: "Al Bakr",
    country: "Iraq",
    iata: "",
    icao: "ORBD",
    latitude: "33.940194",
    longitude: "44.361583",
    altitude: "161",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "4140",
    name: "Diosdado Macapagal International",
    city: "Angeles City",
    country: "Philippines",
    iata: "CRK",
    icao: "RPLC",
    latitude: "15.185833",
    longitude: "120.560278",
    altitude: "484",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4141",
    name: "Sandakan",
    city: "Sandakan",
    country: "Malaysia",
    iata: "SDK",
    icao: "WBKS",
    latitude: "5.900897",
    longitude: "118.059486",
    altitude: "46",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "4142",
    name: "Luang Namtha",
    city: "Luang Namtha",
    country: "Laos",
    iata: "LXG",
    icao: "VLLN",
    latitude: "20.960556",
    longitude: "101.4025",
    altitude: "1968",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "4143",
    name: "Oudomxay",
    city: "Muang Xay",
    country: "Laos",
    iata: "ODY",
    icao: "VLOS",
    latitude: "20.6827",
    longitude: "101.994",
    altitude: "1380",
    timezone: "7",
    dst: "N",
    tz: "Asia/Vientiane",
  },
  {
    id: "4144",
    name: "Shenyang Taoxian International Airport",
    city: "Shenyang",
    country: "China",
    iata: "SHE",
    icao: "ZYTX",
    latitude: "41.3824",
    longitude: "123.2901",
    altitude: "198",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4145",
    name: "Dongying Airport",
    city: "Dongying",
    country: "China",
    iata: "DOY",
    icao: "ZSDY",
    latitude: "37.2716",
    longitude: "118.2819",
    altitude: "86",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4146",
    name: "John A. Osborne Airport",
    city: "Geralds",
    country: "Montserrat",
    iata: "MNI",
    icao: "TRPG",
    latitude: "16.791389",
    longitude: "-62.193333",
    altitude: "40",
    timezone: "-4",
    dst: "N",
    tz: "America/Montserrat",
  },
  {
    id: "4147",
    name: "Petersburg James A. Johnson",
    city: "Petersburg",
    country: "United States",
    iata: "PSG",
    icao: "PAPG",
    latitude: "56.801667",
    longitude: "-132.945278",
    altitude: "105",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "4148",
    name: "Luoyang Airport",
    city: "Luoyang",
    country: "China",
    iata: "LYA",
    icao: "ZHLY",
    latitude: "34.41",
    longitude: "112.28",
    altitude: "210",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4149",
    name: "Xuzhou Guanyin Airport",
    city: "Xuzhou",
    country: "China",
    iata: "XUZ",
    icao: "ZSXZ",
    latitude: "34.16",
    longitude: "117.11",
    altitude: "140",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4150",
    name: "Esfahan Shahid Beheshti Intl",
    city: "Isfahan",
    country: "Iran",
    iata: "IFN",
    icao: "\\N",
    latitude: "32.750836",
    longitude: "51.861267",
    altitude: "5059",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "4151",
    name: "Magwe",
    city: "Magwe",
    country: "Burma",
    iata: "MWQ",
    icao: "VYMW",
    latitude: "20.165453",
    longitude: "94.941185",
    altitude: "275",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "4152",
    name: "Khamti",
    city: "Khamti",
    country: "Burma",
    iata: "KHM",
    icao: "VYKI",
    latitude: "25.988333",
    longitude: "95.674444",
    altitude: "6000",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "4153",
    name: "Dalat",
    city: "Dalat",
    country: "Vietnam",
    iata: "DLI",
    icao: "VVDL",
    latitude: "11.75",
    longitude: "108.367",
    altitude: "3156",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4154",
    name: "Dong Hoi",
    city: "Dong Hoi",
    country: "Vietnam",
    iata: "VDH",
    icao: "\\N",
    latitude: "17.515",
    longitude: "106.590556",
    altitude: "50",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4155",
    name: "Rach Gia",
    city: "Rach Gia",
    country: "Vietnam",
    iata: "VKG",
    icao: "VVRG",
    latitude: "9.949676",
    longitude: "105.133659",
    altitude: "7",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4156",
    name: "Ca Mau",
    city: "Ca Mau",
    country: "Vietnam",
    iata: "CAH",
    icao: "VVCM",
    latitude: "9.188049",
    longitude: "105.174721",
    altitude: "50",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4157",
    name: "Chu Lai",
    city: "Chu Lai",
    country: "Vietnam",
    iata: "VCL",
    icao: "VVCA",
    latitude: "15.405944",
    longitude: "108.705889",
    altitude: "10",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4158",
    name: "Dong Tac",
    city: "Tuy Hoa",
    country: "Vietnam",
    iata: "TBB",
    icao: "VVTH",
    latitude: "13.04955",
    longitude: "109.333706",
    altitude: "20",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4159",
    name: "Pai",
    city: "Pai",
    country: "Thailand",
    iata: "PYY",
    icao: "VTCI",
    latitude: "19.372",
    longitude: "98.437",
    altitude: "1271",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4160",
    name: "Brac",
    city: "Brac",
    country: "Croatia",
    iata: "BWK",
    icao: "LDSB",
    latitude: "43.285719",
    longitude: "16.679719",
    altitude: "1776",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "4161",
    name: "Yaounde Nsimalen",
    city: "Yaounde",
    country: "Cameroon",
    iata: "NSI",
    icao: "FKYS",
    latitude: "3.722556",
    longitude: "11.553269",
    altitude: "2278",
    timezone: "1",
    dst: "N",
    tz: "Africa/Douala",
  },
  {
    id: "4162",
    name: "Conakry",
    city: "Conakry",
    country: "Guinea",
    iata: "CKY",
    icao: "GUCY",
    latitude: "9.576889",
    longitude: "-13.611961",
    altitude: "72",
    timezone: "0",
    dst: "N",
    tz: "Africa/Conakry",
  },
  {
    id: "4163",
    name: "Bergrestaurant",
    city: "Trogen",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.992094",
    longitude: "8.390315",
    altitude: "1800",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "4164",
    name: "Uetliberg",
    city: "Zuerich",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "47.36029",
    longitude: "8.47805",
    altitude: "1800",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "4165",
    name: "Flugplatz Merzbrueck",
    city: "Aachen",
    country: "Germany",
    iata: "AAH",
    icao: "EDKA",
    latitude: "50.823194",
    longitude: "6.186389",
    altitude: "570",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4166",
    name: "Baden Airpark",
    city: "Karlsruhe/Baden-Baden",
    country: "Germany",
    iata: "FKB",
    icao: "EDSB",
    latitude: "48.7793",
    longitude: "8.08048",
    altitude: "407",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4167",
    name: "Orlando Sanford Intl",
    city: "Sanford",
    country: "United States",
    iata: "SFB",
    icao: "KSFB",
    latitude: "28.777639",
    longitude: "-81.237489",
    altitude: "55",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4168",
    name: "Duong Dong Airport",
    city: "Phu Quoc",
    country: "Vietnam",
    iata: "PQC",
    icao: "\\N",
    latitude: "10.227025",
    longitude: "103.967169",
    altitude: "23",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "4169",
    name: "John Murtha Johnstown-Cambria County Airport",
    city: "Johnstown",
    country: "United States",
    iata: "JST",
    icao: "KJST",
    latitude: "40.316111",
    longitude: "-78.833889",
    altitude: "2284",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4170",
    name: "Lukla",
    city: "Lukla",
    country: "Nepal",
    iata: "LUA",
    icao: "VNLK",
    latitude: "27.687778",
    longitude: "86.731389",
    altitude: "9100",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4171",
    name: "Bhojpur",
    city: "Bhojpur",
    country: "Nepal",
    iata: "BHP",
    icao: "VNBJ",
    latitude: "27.14743",
    longitude: "87.050819",
    altitude: "4000",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4172",
    name: "Lamidanda",
    city: "Lamidanda",
    country: "Nepal",
    iata: "LDN",
    icao: "VNLD",
    latitude: "27.253117",
    longitude: "86.670044",
    altitude: "4100",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4173",
    name: "Jomsom",
    city: "Jomsom",
    country: "Nepal",
    iata: "JMO",
    icao: "VNJS",
    latitude: "28.782222",
    longitude: "83.7225",
    altitude: "8800",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4174",
    name: "Manang",
    city: "Manang",
    country: "Nepal",
    iata: "NGX",
    icao: "VNMA",
    latitude: "28.633",
    longitude: "84",
    altitude: "11000",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4175",
    name: "Phaplu",
    city: "Phaplu",
    country: "Nepal",
    iata: "PPL",
    icao: "VNPL",
    latitude: "27.517",
    longitude: "86.6",
    altitude: "7918",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4176",
    name: "Thamkharka",
    city: "Thamkharka",
    country: "Nepal",
    iata: "TMK",
    icao: "\\N",
    latitude: "27.052222",
    longitude: "86.861944",
    altitude: "6000",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4177",
    name: "Rumjatar",
    city: "Rumjatar",
    country: "Nepal",
    iata: "RUM",
    icao: "VNRT",
    latitude: "27.303509",
    longitude: "86.55043",
    altitude: "4500",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4178",
    name: "Tulsipur",
    city: "Dang",
    country: "Nepal",
    iata: "DNP",
    icao: "VNDG",
    latitude: "28.111111",
    longitude: "82.294167",
    altitude: "2100",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4179",
    name: "Rukumkot",
    city: "Rukumkot",
    country: "Nepal",
    iata: "RUK",
    icao: "VNRK",
    latitude: "28.627",
    longitude: "82.195",
    altitude: "2500",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4180",
    name: "Jumla",
    city: "Jumla",
    country: "Nepal",
    iata: "JUM",
    icao: "VNJL",
    latitude: "29.274167",
    longitude: "82.193333",
    altitude: "7700",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4181",
    name: "Chaurjhari",
    city: "Chaurjhari",
    country: "Nepal",
    iata: "HRJ",
    icao: "VNCJ",
    latitude: "28",
    longitude: "83.833",
    altitude: "4000",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4182",
    name: "Taplejung",
    city: "Taplejung",
    country: "Nepal",
    iata: "TPJ",
    icao: "VNTJ",
    latitude: "27.35",
    longitude: "84.667",
    altitude: "4000",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4183",
    name: "Tumling Tar",
    city: "Tumling Tar",
    country: "Nepal",
    iata: "TMI",
    icao: "VNTR",
    latitude: "27.315",
    longitude: "87.193333",
    altitude: "1700",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4184",
    name: "Surkhet",
    city: "Surkhet",
    country: "Nepal",
    iata: "SKH",
    icao: "VNSK",
    latitude: "28.586",
    longitude: "81.636",
    altitude: "2400",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4185",
    name: "Simikot",
    city: "Simikot",
    country: "Nepal",
    iata: "IMK",
    icao: "VNST",
    latitude: "29.971064",
    longitude: "81.818932",
    altitude: "9246",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4186",
    name: "Dolpa",
    city: "Dolpa",
    country: "Nepal",
    iata: "DOP",
    icao: "VNDP",
    latitude: "28.985718",
    longitude: "82.819145",
    altitude: "8200",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4187",
    name: "Bajhang",
    city: "Bajhang",
    country: "Nepal",
    iata: "BJH",
    icao: "VNBG",
    latitude: "29.53896",
    longitude: "81.185364",
    altitude: "4100",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4188",
    name: "Dhangarhi",
    city: "Dhangarhi",
    country: "Nepal",
    iata: "DHI",
    icao: "VNDH",
    latitude: "28.753333",
    longitude: "80.581944",
    altitude: "690",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "4189",
    name: "Muan",
    city: "Muan",
    country: "South Korea",
    iata: "MWX",
    icao: "RKJB",
    latitude: "34.991389",
    longitude: "126.382778",
    altitude: "51",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "4190",
    name: "Astypalaia",
    city: "Astypalaia",
    country: "Greece",
    iata: "JTY",
    icao: "LGPL",
    latitude: "36.579886",
    longitude: "26.375822",
    altitude: "165",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4191",
    name: "Ikaria",
    city: "Ikaria",
    country: "Greece",
    iata: "JIK",
    icao: "LGIK",
    latitude: "37.682717",
    longitude: "26.347061",
    altitude: "79",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4192",
    name: "Kalymnos Island",
    city: "Kalymnos",
    country: "Greece",
    iata: "JKL",
    icao: "LGKY",
    latitude: "36.963333",
    longitude: "26.940556",
    altitude: "771",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4193",
    name: "Milos",
    city: "Milos",
    country: "Greece",
    iata: "MLO",
    icao: "LGML",
    latitude: "36.696111",
    longitude: "24.4775",
    altitude: "12",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4194",
    name: "Naxos",
    city: "Cyclades Islands",
    country: "Greece",
    iata: "JNX",
    icao: "LGNX",
    latitude: "37.080556",
    longitude: "25.368056",
    altitude: "10",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4195",
    name: "Paros",
    city: "Paros",
    country: "Greece",
    iata: "PAS",
    icao: "LGPA",
    latitude: "37.010278",
    longitude: "25.127778",
    altitude: "121",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4196",
    name: "Kastelorizo",
    city: "Kastelorizo",
    country: "Greece",
    iata: "KZS",
    icao: "LGKJ",
    latitude: "36.127777",
    longitude: "29.566656",
    altitude: "474",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4197",
    name: "Marsa Alam Intl",
    city: "Marsa Alam",
    country: "Egypt",
    iata: "RMF",
    icao: "HEMA",
    latitude: "25.557111",
    longitude: "34.583711",
    altitude: "251",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "4198",
    name: "Niederrhein",
    city: "Weeze",
    country: "Germany",
    iata: "NRN",
    icao: "EDLV",
    latitude: "51.602222",
    longitude: "6.141944",
    altitude: "106",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4199",
    name: "Busuanga",
    city: "Busuanga",
    country: "Philippines",
    iata: "USU",
    icao: "RPVV",
    latitude: "12.121458",
    longitude: "120.100031",
    altitude: "148",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4200",
    name: "Butuan",
    city: "Butuan",
    country: "Philippines",
    iata: "BXU",
    icao: "RPME",
    latitude: "8.951322",
    longitude: "125.477972",
    altitude: "141",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4201",
    name: "Dipolog",
    city: "Dipolog",
    country: "Philippines",
    iata: "DPL",
    icao: "RPMG",
    latitude: "8.601261",
    longitude: "123.334481",
    altitude: "12",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4202",
    name: "Laoag Intl",
    city: "Laoag",
    country: "Philippines",
    iata: "LAO",
    icao: "RPLI",
    latitude: "18.178092",
    longitude: "120.531522",
    altitude: "25",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4203",
    name: "Legazpi",
    city: "Legazpi",
    country: "Philippines",
    iata: "LGP",
    icao: "RPLP",
    latitude: "13.157064",
    longitude: "123.746247",
    altitude: "66",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4204",
    name: "Ozamis",
    city: "Ozamis",
    country: "Philippines",
    iata: "OZC",
    icao: "RPMO",
    latitude: "8.178508",
    longitude: "123.841731",
    altitude: "75",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6510",
    name: "Zweibruecken",
    city: "Zweibruecken",
    country: "Germany",
    iata: "ZQW",
    icao: "\\N",
    latitude: "49.209445",
    longitude: "7.401323",
    altitude: "1132",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4206",
    name: "Mactan Cebu Intl",
    city: "Cebu",
    country: "Philippines",
    iata: "CEB",
    icao: "RPVM",
    latitude: "10.307542",
    longitude: "123.979439",
    altitude: "31",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "4207",
    name: "Sonderlandeplatz Norden-Norddeich",
    city: "Norden",
    country: "Germany",
    iata: "NOE",
    icao: "EDWS",
    latitude: "53.632221",
    longitude: "7.191389",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4208",
    name: "Verkehrslandeplatz Juist",
    city: "Juist",
    country: "Germany",
    iata: "JUI",
    icao: "EDWJ",
    latitude: "53.681572",
    longitude: "7.055731",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4209",
    name: "Aeroporto de Porto Seguro",
    city: "Porto Seguro",
    country: "Brazil",
    iata: "BPS",
    icao: "SBPS",
    latitude: "-16.438611",
    longitude: "-39.080833",
    altitude: "167",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "4210",
    name: "Gounda Airport",
    city: "Gounda",
    country: "Central African Republic",
    iata: "GDA",
    icao: "\\N",
    latitude: "9.272222",
    longitude: "21.197222",
    altitude: "1509",
    timezone: "1",
    dst: "N",
    tz: "Africa/Bangui",
  },
  {
    id: "4211",
    name: "Heliport Hotel das Cataratas",
    city: "Cataratas National Park",
    country: "Brazil",
    iata: "",
    icao: "\\N",
    latitude: "-25.684",
    longitude: "-54.44024",
    altitude: "1000",
    timezone: "-3",
    dst: "S",
    tz: "America/Cordoba",
  },
  {
    id: "4213",
    name: "Iguatu",
    city: "Iguatu",
    country: "Brazil",
    iata: "",
    icao: "SNIG",
    latitude: "-6.346639",
    longitude: "-39.293777",
    altitude: "699",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "4214",
    name: "Palmas",
    city: "Palmas",
    country: "Brazil",
    iata: "PMW",
    icao: "SBPJ",
    latitude: "-10.241667",
    longitude: "-48.35278",
    altitude: "774",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "4215",
    name: "Caldas Novas",
    city: "Caldas Novas",
    country: "Brazil",
    iata: "CLV",
    icao: "SBCN",
    latitude: "-17.7267",
    longitude: "-48.6114",
    altitude: "2247",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "4216",
    name: "Missoula Intl",
    city: "Missoula",
    country: "United States",
    iata: "MSO",
    icao: "KMSO",
    latitude: "46.916306",
    longitude: "-114.090556",
    altitude: "3205",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4217",
    name: "Blackall",
    city: "Blackall",
    country: "Australia",
    iata: "BKQ",
    icao: "YBCK",
    latitude: "-24.427778",
    longitude: "145.428611",
    altitude: "928",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "4218",
    name: "Bundaberg",
    city: "Bundaberg",
    country: "Australia",
    iata: "BDB",
    icao: "YBUD",
    latitude: "-24.903889",
    longitude: "152.318611",
    altitude: "107",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "4219",
    name: "Grand Canyon National Park Airport",
    city: "Grand Canyon",
    country: "United States",
    iata: "GCN",
    icao: "KGCN",
    latitude: "35.9523611",
    longitude: "-112.1469722",
    altitude: "6609",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "4220",
    name: "Sugar Land Regional Airport",
    city: "Sugar Land",
    country: "United States",
    iata: "SGR",
    icao: "KSGR",
    latitude: "29.62225",
    longitude: "-95.6565278",
    altitude: "82",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4221",
    name: "Hayman Island Airport",
    city: "Hayman Island",
    country: "Australia",
    iata: "HIS",
    icao: "YHYN",
    latitude: "-20.066668",
    longitude: "148.86667",
    altitude: "10",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "4222",
    name: "Centennial",
    city: "Denver",
    country: "United States",
    iata: "APA",
    icao: "KAPA",
    latitude: "39.570129",
    longitude: "-104.849294",
    altitude: "5883",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4223",
    name: "Clovis Muni",
    city: "Clovis",
    country: "United States",
    iata: "CVN",
    icao: "KCVN",
    latitude: "34.425139",
    longitude: "-103.079278",
    altitude: "4216",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4224",
    name: "Fort Stockton Pecos Co",
    city: "Fort Stockton",
    country: "United States",
    iata: "FST",
    icao: "KFST",
    latitude: "30.915667",
    longitude: "-102.916139",
    altitude: "3011",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4225",
    name: "Las Vegas Muni",
    city: "Las Vegas",
    country: "United States",
    iata: "LVS",
    icao: "KLVS",
    latitude: "35.654222",
    longitude: "-105.142389",
    altitude: "6877",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4226",
    name: "West Houston",
    city: "Houston",
    country: "United States",
    iata: "IWS",
    icao: "KIWS",
    latitude: "29.818194",
    longitude: "-95.672611",
    altitude: "111",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4227",
    name: "La Junta Muni",
    city: "La Junta",
    country: "United States",
    iata: "LHX",
    icao: "KLHX",
    latitude: "38.049719",
    longitude: "-103.509431",
    altitude: "4238",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4228",
    name: "Las Cruces Intl",
    city: "Las Cruces",
    country: "United States",
    iata: "LRU",
    icao: "KLRU",
    latitude: "32.289417",
    longitude: "-106.921972",
    altitude: "4456",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4229",
    name: "Stephens Co",
    city: "Breckenridge",
    country: "United States",
    iata: "BKD",
    icao: "KBKD",
    latitude: "32.719047",
    longitude: "-98.891",
    altitude: "1284",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4230",
    name: "Draughon Miller Central Texas Rgnl",
    city: "Temple",
    country: "United States",
    iata: "TPL",
    icao: "KTPL",
    latitude: "31.1525",
    longitude: "-97.407778",
    altitude: "682",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4231",
    name: "Ozona Muni",
    city: "Ozona",
    country: "United States",
    iata: "OZA",
    icao: "KOZA",
    latitude: "30.735281",
    longitude: "-101.202972",
    altitude: "2381",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4232",
    name: "Hong Kong Kai Tak",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "VHXX",
    latitude: "22.315365",
    longitude: "114.195349",
    altitude: "1",
    timezone: "8",
    dst: "U",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "6416",
    name: "Athen Helenikon Airport",
    city: "Athens",
    country: "Greece",
    iata: "HEW",
    icao: "\\N",
    latitude: "37.8933",
    longitude: "23.7261",
    altitude: "69",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "6415",
    name: "Waikoloa Heliport",
    city: "Waikoloa Village",
    country: "United States",
    iata: "WKL",
    icao: "HI07",
    latitude: "19.9136",
    longitude: "-155.864",
    altitude: "109",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "4235",
    name: "Kaadedhdhoo",
    city: "Kaadedhdhoo",
    country: "Maldives",
    iata: "KDM",
    icao: "\\N",
    latitude: "0.4880555",
    longitude: "72.995556",
    altitude: "3",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "4236",
    name: "Aklavik",
    city: "Aklavik",
    country: "Canada",
    iata: "LAK",
    icao: "CYKD",
    latitude: "68.223333",
    longitude: "-135.005833",
    altitude: "23",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4237",
    name: "Deline",
    city: "Deline",
    country: "Canada",
    iata: "YWJ",
    icao: "CYWJ",
    latitude: "65.1833333",
    longitude: "-125.41666667",
    altitude: "550",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4238",
    name: "Tulita",
    city: "Tulita",
    country: "Canada",
    iata: "ZFN",
    icao: "CZFN",
    latitude: "64.0833333",
    longitude: "-125.5833333",
    altitude: "320",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4239",
    name: "Fort Good Hope",
    city: "Fort Good Hope",
    country: "Canada",
    iata: "YGH",
    icao: "CYGH",
    latitude: "66.26666667",
    longitude: "-128.65",
    altitude: "215",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4240",
    name: "Inuvik Town",
    city: "Inuvik",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "66.3676",
    longitude: "-133.7594",
    altitude: "200",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4241",
    name: "INAWR",
    city: "Inuvik",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "68.3676",
    longitude: "-133.7594",
    altitude: "200",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4242",
    name: "Tanna island",
    city: "Tanna",
    country: "Vanuatu",
    iata: "TAH",
    icao: "\\N",
    latitude: "-19.455198",
    longitude: "169.22394",
    altitude: "3",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "6509",
    name: "Sun Island",
    city: "Sun Island",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.48596289680953",
    longitude: "72.8060746192932",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "4244",
    name: "Paulatuk",
    city: "Paulatuk",
    country: "Canada",
    iata: "YPC",
    icao: "CYPC",
    latitude: "62.35",
    longitude: "-124.3333",
    altitude: "50",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4246",
    name: "Nicholson Peninsula",
    city: "Nicholson Peninsula",
    country: "Canada",
    iata: "",
    icao: "YUCX",
    latitude: "69.917",
    longitude: "-128.95",
    altitude: "1",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "4247",
    name: "Santa Cruz",
    city: "Santa Cruz",
    country: "Bolivia",
    iata: "SRZ",
    icao: "\\N",
    latitude: "-17.8",
    longitude: "-63.166667",
    altitude: "1224",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "4248",
    name: "Kulusuk",
    city: "Kulusuk",
    country: "Greenland",
    iata: "KUS",
    icao: "\\N",
    latitude: "65.566667",
    longitude: "-37.1166667",
    altitude: "112",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "4249",
    name: "Juancho E. Yrausquin",
    city: "Saba",
    country: "Netherlands Antilles",
    iata: "SAB",
    icao: "TNCS",
    latitude: "17.645278",
    longitude: "-63.220556",
    altitude: "60",
    timezone: "-4",
    dst: "U",
    tz: "America/Curacao",
  },
  {
    id: "4250",
    name: "Eagle Co Rgnl",
    city: "Vail",
    country: "United States",
    iata: "EGE",
    icao: "KEGE",
    latitude: "39.642556",
    longitude: "-106.917694",
    altitude: "6540",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4251",
    name: "Stapleton",
    city: "Denver",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.779255",
    longitude: "-104.88184",
    altitude: "5333",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4252",
    name: "Skagen",
    city: "Stokmarknes",
    country: "Norway",
    iata: "SKN",
    icao: "ENSK",
    latitude: "68.580833",
    longitude: "15.026111",
    altitude: "11",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4253",
    name: "Cuyahoga County",
    city: "Richmond Heights",
    country: "United States",
    iata: "CGF",
    icao: "KCGF",
    latitude: "41.565124",
    longitude: "-81.4863555",
    altitude: "879",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4254",
    name: "Mansfield Lahm Regional",
    city: "Mansfield",
    country: "United States",
    iata: "MFD",
    icao: "KMFD",
    latitude: "40.8214167",
    longitude: "-82.5166389",
    altitude: "1297",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4255",
    name: "Columbus Metropolitan Airport",
    city: "Columbus",
    country: "United States",
    iata: "CSG",
    icao: "KCSG",
    latitude: "32.5163333",
    longitude: "-84.9388611",
    altitude: "397",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4256",
    name: "Lawton-Fort Sill Regional Airport",
    city: "Lawton",
    country: "United States",
    iata: "LAW",
    icao: "KLAW",
    latitude: "34.5677144",
    longitude: "-98.4166367",
    altitude: "1110",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4257",
    name: "Fort Collins Loveland Muni",
    city: "Fort Collins",
    country: "United States",
    iata: "FNL",
    icao: "KFNL",
    latitude: "40.451828",
    longitude: "-105.011336",
    altitude: "5016",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "6835",
    name: "Gouvia Marina",
    city: "Gouvia",
    country: "Greece",
    iata: "",
    icao: "\\N",
    latitude: "39.648682",
    longitude: "19.855771",
    altitude: "0",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "6836",
    name: "Paxos Marina",
    city: "Paxos",
    country: "Greece",
    iata: "",
    icao: "\\N",
    latitude: "39.202676",
    longitude: "20.187968",
    altitude: "0",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "4261",
    name: "Flagstaff Pulliam Airport",
    city: "Flagstaff",
    country: "United States",
    iata: "FLG",
    icao: "KFLG",
    latitude: "35.140318",
    longitude: "-111.6692392",
    altitude: "7015",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "4262",
    name: "Lake Tahoe Airport",
    city: "South Lake Tahoe",
    country: "United States",
    iata: "TVL",
    icao: "KTVL",
    latitude: "38.893889",
    longitude: "-119.995278",
    altitude: "8544",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4263",
    name: "Magic Valley Regional Airport",
    city: "Twin Falls",
    country: "United States",
    iata: "TWF",
    icao: "KTWF",
    latitude: "42.481803",
    longitude: "-114.487733",
    altitude: "4151",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4264",
    name: "Monaco",
    city: "Monaco",
    country: "Monaco",
    iata: "MCM",
    icao: "\\N",
    latitude: "43.73333333",
    longitude: "7.41666666",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Monaco",
  },
  {
    id: "4265",
    name: "Martha\\\\'s Vineyard",
    city: "Vineyard Haven MA",
    country: "United States",
    iata: "MVY",
    icao: "KMVY",
    latitude: "41.391667",
    longitude: "-70.615278",
    altitude: "67",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4266",
    name: "Newport State",
    city: "Newport RI",
    country: "United States",
    iata: "UUU",
    icao: "\\N",
    latitude: "41.533056",
    longitude: "-71.282222",
    altitude: "172",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4267",
    name: "Hartness State",
    city: "Springfield VT",
    country: "United States",
    iata: "VSF",
    icao: "\\N",
    latitude: "43.343333",
    longitude: "-72.517222",
    altitude: "577",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4268",
    name: "Concord Municipal",
    city: "Concord NH",
    country: "United States",
    iata: "CON",
    icao: "\\N",
    latitude: "43.20267",
    longitude: "-71.50233",
    altitude: "342",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4269",
    name: "Sanford Regional",
    city: "Sanford ME",
    country: "United States",
    iata: "SFM",
    icao: "\\N",
    latitude: "43.39383",
    longitude: "-70.708",
    altitude: "244",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4270",
    name: "Groton New London",
    city: "Groton CT",
    country: "United States",
    iata: "GON",
    icao: "KGON",
    latitude: "41.330056",
    longitude: "-72.045139",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4271",
    name: "Saint Cloud Regional Airport",
    city: "Saint Cloud",
    country: "United States",
    iata: "STC",
    icao: "KSTC",
    latitude: "45.546556",
    longitude: "-94.059889",
    altitude: "1031",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4272",
    name: "Bagan",
    city: "Bagan",
    country: "Burma",
    iata: "BPE",
    icao: "\\N",
    latitude: "21.17383327",
    longitude: "94.9246666",
    altitude: "0",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "4273",
    name: "Golden Triangle Regional Airport",
    city: "Columbus Mississippi",
    country: "United States",
    iata: "GTR",
    icao: "KGTR",
    latitude: "33.450333",
    longitude: "-88.591361",
    altitude: "264",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4274",
    name: "Nizhny Novgorod",
    city: "Nizhniy Novgorod",
    country: "Russia",
    iata: "GOJ",
    icao: "UWGG",
    latitude: "56.230119",
    longitude: "43.784042",
    altitude: "256",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4275",
    name: "Bowerman Field",
    city: "Hoquiam",
    country: "United States",
    iata: "HQM",
    icao: "\\N",
    latitude: "46.9711944",
    longitude: "-123.9365556",
    altitude: "18",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4276",
    name: "Erie Intl Tom Ridge Fld",
    city: "Erie",
    country: "United States",
    iata: "ERI",
    icao: "KERI",
    latitude: "42.082022",
    longitude: "-80.176217",
    altitude: "733",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4277",
    name: "Conrad Maldives Resort",
    city: "Rangali Island",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.5833",
    longitude: "72.7167",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "4278",
    name: "Barnstable Muni Boardman Polando Fld",
    city: "Barnstable",
    country: "United States",
    iata: "HYA",
    icao: "KHYA",
    latitude: "41.669336",
    longitude: "-70.280356",
    altitude: "55",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4279",
    name: "San Pedro",
    city: "San Pedro",
    country: "Belize",
    iata: "SPR",
    icao: "MZ10",
    latitude: "17.913936",
    longitude: "-87.971075",
    altitude: "4",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "4280",
    name: "Sedona",
    city: "Sedona",
    country: "United States",
    iata: "SDX",
    icao: "KSEZ",
    latitude: "34.848628",
    longitude: "-111.788472",
    altitude: "4830",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "4281",
    name: "Dry Tortugas",
    city: "Dry Tortugas",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "24.62",
    longitude: "-82.87",
    altitude: "5",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4282",
    name: "Dry Tortugas",
    city: "Dry Tortugas",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "24.62",
    longitude: "24.62",
    altitude: "5",
    timezone: "2",
    dst: "A",
    tz: "Africa/Tripoli",
  },
  {
    id: "4283",
    name: "Dry Tortugas",
    city: "Dry Tortugas",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "24.628",
    longitude: "82.873",
    altitude: "5",
    timezone: "5.5",
    dst: "A",
    tz: "Asia/Calcutta",
  },
  {
    id: "4284",
    name: "Morgantown Muni Walter L Bill Hart Fld",
    city: "Morgantown",
    country: "United States",
    iata: "MGW",
    icao: "KMGW",
    latitude: "39.642908",
    longitude: "-79.916314",
    altitude: "1248",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4285",
    name: "Yeager",
    city: "Charleston",
    country: "United States",
    iata: "CRW",
    icao: "KCRW",
    latitude: "38.373147",
    longitude: "-81.593189",
    altitude: "981",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4286",
    name: "Wilkes Barre Scranton Intl",
    city: "Scranton",
    country: "United States",
    iata: "AVP",
    icao: "KAVP",
    latitude: "41.338478",
    longitude: "-75.723403",
    altitude: "962",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4287",
    name: "Bemidji Regional Airport",
    city: "Bemidji",
    country: "United States",
    iata: "BJI",
    icao: "KBJI",
    latitude: "47.510722",
    longitude: "-94.934722",
    altitude: "1391",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4288",
    name: "Heydar Aliyev",
    city: "Baku",
    country: "Azerbaijan",
    iata: "BAK",
    icao: "\\N",
    latitude: "40.4675",
    longitude: "50.046667",
    altitude: "10",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "4289",
    name: "Thangool",
    city: "Biloela",
    country: "Australia",
    iata: "THG",
    icao: "YTNG",
    latitude: "-24.493889",
    longitude: "150.576111",
    altitude: "644",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "4290",
    name: "Fagali\\\\'i",
    city: "Apia",
    country: "Samoa",
    iata: "FGI",
    icao: "NSFI",
    latitude: "-13.84861111",
    longitude: "-171.74083333",
    altitude: "25",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Apia",
  },
  {
    id: "4291",
    name: "Ballina Byron Gateway",
    city: "Ballina Byron Bay",
    country: "Australia",
    iata: "BNK",
    icao: "YBNA",
    latitude: "-28.833889",
    longitude: "153.5625",
    altitude: "7",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "4292",
    name: "Hector International Airport",
    city: "Fargo",
    country: "United States",
    iata: "FAR",
    icao: "KFAR",
    latitude: "46.92065",
    longitude: "-96.8157639",
    altitude: "902",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4293",
    name: "Downtown",
    city: "Kansas City",
    country: "United States",
    iata: "MKC",
    icao: "KMKC",
    latitude: "39.1275",
    longitude: "-94.598889",
    altitude: "759",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6505",
    name: "Phoenix-Mesa Gateway",
    city: "Mesa",
    country: "United States",
    iata: "AZA",
    icao: "KIWA",
    latitude: "33.307833",
    longitude: "-111.655",
    altitude: "1382",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "4295",
    name: "Ratanakiri",
    city: "Ratanakiri",
    country: "Cambodia",
    iata: "RBE",
    icao: "\\N",
    latitude: "13.73",
    longitude: "106.987",
    altitude: "0",
    timezone: "7",
    dst: "U",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "4296",
    name: "Gillette-Campbell County Airport",
    city: "Gillette",
    country: "United States",
    iata: "GCC",
    icao: "KGCC",
    latitude: "44.3489167",
    longitude: "-105.5393611",
    altitude: "4365",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4297",
    name: "Tomsk Bogashevo Airport",
    city: "Tomsk",
    country: "Russia",
    iata: "TOF",
    icao: "UNTT",
    latitude: "56.380278",
    longitude: "85.208333",
    altitude: "597",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "4298",
    name: "El Toro",
    city: "Santa Ana",
    country: "United States",
    iata: "NZJ",
    icao: "KNZJ",
    latitude: "33.676132",
    longitude: "-117.731164",
    altitude: "383",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4299",
    name: "Phetchabun",
    city: "Phetchabun",
    country: "Thailand",
    iata: "PHY",
    icao: "VTPB",
    latitude: "16.676028",
    longitude: "101.195108",
    altitude: "450",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4300",
    name: "Chumphon",
    city: "Chumphon",
    country: "Thailand",
    iata: "CJM",
    icao: "VTSE",
    latitude: "10.7112",
    longitude: "99.361706",
    altitude: "18",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "4301",
    name: "Jiuzhaigou Huanglong",
    city: "Jiuzhaigou",
    country: "China",
    iata: "JZH",
    icao: "ZUJZ",
    latitude: "32.857",
    longitude: "103.683",
    altitude: "11311",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4302",
    name: "Wai Sha Airport",
    city: "Shantou",
    country: "China",
    iata: "SWA",
    icao: "ZGOW",
    latitude: "23.4",
    longitude: "116.683",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4303",
    name: "Les Ailerons",
    city: "Enghien-moisselles",
    country: "France",
    iata: "",
    icao: "LFFE",
    latitude: "0",
    longitude: "0",
    altitude: "302",
    timezone: "0",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "4304",
    name: "Cheddi Jagan Intl",
    city: "Georgetown",
    country: "Guyana",
    iata: "GEO",
    icao: "SYCJ",
    latitude: "6.498553",
    longitude: "-58.254119",
    altitude: "95",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "4305",
    name: "Ciudad del Este",
    city: "Ciudad del Este",
    country: "Paraguay",
    iata: "AGT",
    icao: "SGES",
    latitude: "-25.4555",
    longitude: "-54.843592",
    altitude: "846",
    timezone: "-4",
    dst: "S",
    tz: "America/Asuncion",
  },
  {
    id: "4306",
    name: "Ogle",
    city: "Georgetown",
    country: "Guyana",
    iata: "OGL",
    icao: "SYGO",
    latitude: "6.806944",
    longitude: "-58.104444",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "4307",
    name: "Kaieteur",
    city: "Kaieteur",
    country: "Guyana",
    iata: "KAI",
    icao: "SYKA",
    latitude: "5.167",
    longitude: "-59.483",
    altitude: "750",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "4308",
    name: "Dunhuang Airport",
    city: "Dunhuang",
    country: "China",
    iata: "DNH",
    icao: "ZLDH",
    latitude: "40.094",
    longitude: "94.4818",
    altitude: "3688",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4309",
    name: "Falconara",
    city: "Ancona",
    country: "Italy",
    iata: "AOI",
    icao: "LIPY",
    latitude: "43.616389",
    longitude: "13.362222",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "4310",
    name: "Samjiyon",
    city: "Samjiyon",
    country: "South Korea",
    iata: "",
    icao: "ZZ04",
    latitude: "41.542301",
    longitude: "128.243571",
    altitude: "4410",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8833",
    name: "Iosco County",
    city: "East Tawas",
    country: "United States",
    iata: "ECA",
    icao: "K6D9",
    latitude: "44.311",
    longitude: "-83.422",
    altitude: "606",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4312",
    name: "Copiapo",
    city: "Copiapo",
    country: "Chile",
    iata: "CPO",
    icao: "SCHA",
    latitude: "-27",
    longitude: "-70",
    altitude: "1000",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "4313",
    name: "Taba Intl",
    city: "Taba",
    country: "Egypt",
    iata: "TCP",
    icao: "HETB",
    latitude: "29.587778",
    longitude: "34.778056",
    altitude: "2415",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "4314",
    name: "Edward Bodden Airfield",
    city: "Little Cayman",
    country: "Cayman Islands",
    iata: "LYB",
    icao: "MWCL",
    latitude: "19.6591666667",
    longitude: "-80.09083333",
    altitude: "1",
    timezone: "-5",
    dst: "U",
    tz: "America/Cayman",
  },
  {
    id: "4315",
    name: "Bodrum - Milas",
    city: "Bodrum",
    country: "Turkey",
    iata: "BJV",
    icao: "LTFE",
    latitude: "37.249",
    longitude: "27.667",
    altitude: "19",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "4316",
    name: "7 Novembre",
    city: "Tabarka",
    country: "Tunisia",
    iata: "TBJ",
    icao: "DTKA",
    latitude: "36.978333",
    longitude: "8.876389",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Africa/Tunis",
  },
  {
    id: "4317",
    name: "Sabiha Gokcen",
    city: "Istanbul",
    country: "Turkey",
    iata: "SAW",
    icao: "LTFJ",
    latitude: "40.898553",
    longitude: "29.309219",
    altitude: "312",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "4318",
    name: "University Park Airport",
    city: "State College Pennsylvania",
    country: "United States",
    iata: "SCE",
    icao: "KUNV",
    latitude: "40.849278",
    longitude: "-77.848694",
    altitude: "1239",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4319",
    name: "Broome",
    city: "Broome",
    country: "Australia",
    iata: "BME",
    icao: "YPBR",
    latitude: "-17.8",
    longitude: "122.2",
    altitude: "56",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "4320",
    name: "Newcastle Airport",
    city: "Newcastle",
    country: "Australia",
    iata: "NTL",
    icao: "YWLM",
    latitude: "-32.78",
    longitude: "151.83",
    altitude: "31",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "4321",
    name: "Bakki Airport",
    city: "Bakki",
    country: "Iceland",
    iata: "",
    icao: "BIBA",
    latitude: "63.55805",
    longitude: "-20.14833",
    altitude: "45",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "4322",
    name: "Woerthersee International Airport",
    city: "Klagenfurt",
    country: "Austria",
    iata: "KLU",
    icao: "LOWK",
    latitude: "46.642514",
    longitude: "14.337739",
    altitude: "452",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "4323",
    name: "General Manuel Carlos Piar",
    city: "Ciudad Guayana",
    country: "Venezuela",
    iata: "CGU",
    icao: "\\N",
    latitude: "8.288527",
    longitude: "-62.760361",
    altitude: "472",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "4324",
    name: "Flugplatz Hoepen",
    city: "Schneverdingen",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "53.1167",
    longitude: "9.8",
    altitude: "267",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4325",
    name: "Hammerfest Airport",
    city: "Hammerfest",
    country: "Norway",
    iata: "HFT",
    icao: "ENHF",
    latitude: "70.679722",
    longitude: "23.668889",
    altitude: "799",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4326",
    name: "Valan",
    city: "Honningsvag",
    country: "Norway",
    iata: "HVG",
    icao: "ENHV",
    latitude: "70.99",
    longitude: "25.83",
    altitude: "46",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4327",
    name: "Mehamn",
    city: "Mehamn",
    country: "Norway",
    iata: "MEH",
    icao: "ENMR",
    latitude: "71.029722",
    longitude: "27.826667",
    altitude: "41",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4328",
    name: "Airport",
    city: "Vadso",
    country: "Norway",
    iata: "VDS",
    icao: "ENVD",
    latitude: "70.065",
    longitude: "29.844",
    altitude: "127",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4329",
    name: "Riem",
    city: "Munich",
    country: "Germany",
    iata: "",
    icao: "MUCX",
    latitude: "48.137778",
    longitude: "11.690278",
    altitude: "1487",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4330",
    name: "Imam Khomeini",
    city: "Tehran",
    country: "Iran",
    iata: "IKA",
    icao: "OIIE",
    latitude: "35.416111",
    longitude: "51.152222",
    altitude: "3305",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "4331",
    name: "Mashhad",
    city: "Mashhad",
    country: "Iran",
    iata: "MHD",
    icao: "OIMM",
    latitude: "36.234",
    longitude: "59.643",
    altitude: "3263",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "4332",
    name: "Egelsbach",
    city: "Egelsbach",
    country: "Germany",
    iata: "QEF",
    icao: "\\N",
    latitude: "49.9608",
    longitude: "8.64361",
    altitude: "384",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "4333",
    name: "Ust-Ilimsk",
    city: "Ust Ilimsk",
    country: "Russia",
    iata: "UIK",
    icao: "UIBS",
    latitude: "58.135",
    longitude: "102.566",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "4334",
    name: "Mudanjiang",
    city: "Mudanjiang",
    country: "China",
    iata: "MDG",
    icao: "\\N",
    latitude: "44.523889",
    longitude: "129.568889",
    altitude: "883",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4335",
    name: "Key Field",
    city: "Meridian",
    country: "United States",
    iata: "MEI",
    icao: "KMEI",
    latitude: "32.332624",
    longitude: "-88.751868",
    altitude: "297",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4336",
    name: "Abraham Lincoln Capital",
    city: "Springfield",
    country: "United States",
    iata: "SPI",
    icao: "KSPI",
    latitude: "39.8441",
    longitude: "-89.677889",
    altitude: "597",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4337",
    name: "Uzundzhovo",
    city: "Haskovo",
    country: "Bulgaria",
    iata: "HKV",
    icao: "LB14",
    latitude: "41.976375",
    longitude: "25.589817",
    altitude: "160",
    timezone: "2",
    dst: "E",
    tz: "Europe/Sofia",
  },
  {
    id: "4338",
    name: "Cortez Muni",
    city: "Cortez",
    country: "United States",
    iata: "CEZ",
    icao: "KCEZ",
    latitude: "37.303",
    longitude: "-108.628056",
    altitude: "5918",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4339",
    name: "Yampa Valley",
    city: "Hayden",
    country: "United States",
    iata: "HDN",
    icao: "KHDN",
    latitude: "40.481181",
    longitude: "-107.21766",
    altitude: "6602",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4340",
    name: "Gallup Muni",
    city: "Gallup",
    country: "United States",
    iata: "GUP",
    icao: "KGUP",
    latitude: "35.511058",
    longitude: "-108.789308",
    altitude: "6472",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4341",
    name: "Liberal Muni",
    city: "Liberal",
    country: "United States",
    iata: "LBL",
    icao: "KLBL",
    latitude: "37.044222",
    longitude: "-100.95986",
    altitude: "2885",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4342",
    name: "Lamar Muni",
    city: "Lamar",
    country: "United States",
    iata: "LAA",
    icao: "KLAA",
    latitude: "38.069694",
    longitude: "-102.6885",
    altitude: "3706",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4343",
    name: "Renner Fld",
    city: "Goodland",
    country: "United States",
    iata: "GLD",
    icao: "KGLD",
    latitude: "39.370621",
    longitude: "-101.698992",
    altitude: "3656",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4344",
    name: "Yellowstone Rgnl",
    city: "Cody",
    country: "United States",
    iata: "COD",
    icao: "KCOD",
    latitude: "44.520194",
    longitude: "-109.023806",
    altitude: "5102",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "4345",
    name: "Hovden",
    city: "Orsta-Volda",
    country: "Norway",
    iata: "HOV",
    icao: "ENOV",
    latitude: "62.18",
    longitude: "6.0742",
    altitude: "242",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4346",
    name: "RNAS WATTON",
    city: "WATTON",
    country: "United Kingdom",
    iata: "",
    icao: "EGYR",
    latitude: "52.33",
    longitude: "0.51",
    altitude: "173",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "4347",
    name: "ISLES OF SCILLY",
    city: "ST MARY\\\\'S",
    country: "United Kingdom",
    iata: "ISC",
    icao: "\\N",
    latitude: "49.919",
    longitude: "-6.3075",
    altitude: "70",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "4348",
    name: "Springfield Branson Natl",
    city: "Springfield",
    country: "United States",
    iata: "SGF",
    icao: "KSGF",
    latitude: "37.245667",
    longitude: "-93.388639",
    altitude: "1268",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4349",
    name: "Framnes",
    city: "Narvik",
    country: "Norway",
    iata: "NVK",
    icao: "ENNK",
    latitude: "68.435833",
    longitude: "17.388056",
    altitude: "97",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4350",
    name: "Berlevag",
    city: "Berlevag",
    country: "Norway",
    iata: "BVG",
    icao: "ENBV",
    latitude: "70.866667",
    longitude: "29",
    altitude: "43",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4351",
    name: "Fornebu",
    city: "Oslo",
    country: "Norway",
    iata: "FBU",
    icao: "ENFB",
    latitude: "59.883333",
    longitude: "10.616667",
    altitude: "56",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4352",
    name: "Alykel",
    city: "Norilsk",
    country: "Russia",
    iata: "NSK",
    icao: "UOOO",
    latitude: "69.311053",
    longitude: "87.332183",
    altitude: "595",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "4353",
    name: "Vityazevo",
    city: "Anapa",
    country: "Russia",
    iata: "AAQ",
    icao: "URKA",
    latitude: "45.002097",
    longitude: "37.347272",
    altitude: "174",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4354",
    name: "Joplin Rgnl",
    city: "Joplin",
    country: "United States",
    iata: "JLN",
    icao: "KJLN",
    latitude: "37.151814",
    longitude: "-94.498269",
    altitude: "981",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4355",
    name: "Lehigh Valley Intl",
    city: "Allentown",
    country: "United States",
    iata: "ABE",
    icao: "KABE",
    latitude: "40.652083",
    longitude: "-75.440806",
    altitude: "393",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4356",
    name: "NW Arkansas Regional",
    city: "Bentonville",
    country: "United States",
    iata: "XNA",
    icao: "KXNA",
    latitude: "36.2818694",
    longitude: "-94.3068111",
    altitude: "1287",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4357",
    name: "Atyrau",
    city: "Atyrau",
    country: "Kazakhstan",
    iata: "GUW",
    icao: "UATG",
    latitude: "47.121944",
    longitude: "51.821389",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "4358",
    name: "Kzyl-Orda",
    city: "Kzyl-Orda",
    country: "Kazakhstan",
    iata: "KZO",
    icao: "UAOO",
    latitude: "44.709",
    longitude: "65.591",
    altitude: "0",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "4359",
    name: "South Bend Rgnl",
    city: "South Bend",
    country: "United States",
    iata: "SBN",
    icao: "KSBN",
    latitude: "41.708661",
    longitude: "-86.31725",
    altitude: "799",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4360",
    name: "Bykovo",
    city: "Moscow",
    country: "Russia",
    iata: "BKA",
    icao: "UUBB",
    latitude: "55.617222",
    longitude: "38.059999",
    altitude: "427",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4361",
    name: "Chintheche",
    city: "Chintheche",
    country: "Malawi",
    iata: "",
    icao: "FWCC",
    latitude: "-11.8333",
    longitude: "34.1667",
    altitude: "0",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "4362",
    name: "Talagi",
    city: "Arkhangelsk",
    country: "Russia",
    iata: "ARH",
    icao: "ULAA",
    latitude: "64.360281",
    longitude: "40.430167",
    altitude: "19",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4363",
    name: "Central",
    city: "Saratov",
    country: "Russia",
    iata: "RTW",
    icao: "UWSS",
    latitude: "51.334366",
    longitude: "46.022952",
    altitude: "152",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4364",
    name: "Novyi Urengoy",
    city: "Novy Urengoy",
    country: "Russia",
    iata: "NUX",
    icao: "USMU",
    latitude: "66.041811",
    longitude: "76.313938",
    altitude: "20",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "4365",
    name: "Noyabrsk",
    city: "Noyabrsk",
    country: "Russia",
    iata: "NOJ",
    icao: "USRO",
    latitude: "63.110079",
    longitude: "75.162243",
    altitude: "20",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6508",
    name: "Washington Union Station",
    city: "Washington",
    country: "United States",
    iata: "ZWU",
    icao: "\\N",
    latitude: "38.89746",
    longitude: "-77.00643",
    altitude: "76",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4367",
    name: "Aktau",
    city: "Aktau",
    country: "Kazakhstan",
    iata: "SCO",
    icao: "UATE",
    latitude: "43.86005",
    longitude: "51.091978",
    altitude: "21",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "4368",
    name: "Ukhta",
    city: "Ukhta",
    country: "Russia",
    iata: "UCT",
    icao: "\\N",
    latitude: "63.340297",
    longitude: "53.482592",
    altitude: "100",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4369",
    name: "Usinsk",
    city: "Usinsk",
    country: "Russia",
    iata: "USK",
    icao: "\\N",
    latitude: "66.00077",
    longitude: "57.221113",
    altitude: "20",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4370",
    name: "Pechora",
    city: "Pechora",
    country: "Russia",
    iata: "PEX",
    icao: "\\N",
    latitude: "65.070387",
    longitude: "57.082045",
    altitude: "20",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4371",
    name: "Naryan-Mar",
    city: "Naryan-Mar",
    country: "Russia",
    iata: "NNM",
    icao: "ULAM",
    latitude: "67.380537",
    longitude: "53.051016",
    altitude: "20",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4372",
    name: "Kresty",
    city: "Pskov",
    country: "Russia",
    iata: "PKV",
    icao: "ULOO",
    latitude: "57.783917",
    longitude: "28.395614",
    altitude: "154",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4373",
    name: "Kogalym International",
    city: "Kogalym",
    country: "Russia",
    iata: "KGP",
    icao: "USRK",
    latitude: "62.18",
    longitude: "74.53",
    altitude: "220",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "4374",
    name: "Emelyanovo",
    city: "Krasnoyarsk",
    country: "Russia",
    iata: "KJA",
    icao: "UNKL",
    latitude: "56.18",
    longitude: "92.475",
    altitude: "940",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "4375",
    name: "Sary-Arka",
    city: "Karaganda",
    country: "Kazakhstan",
    iata: "KGF",
    icao: "UAKK",
    latitude: "49.670833",
    longitude: "73.334444",
    altitude: "1765",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "4376",
    name: "Severny",
    city: "Novosibirsk",
    country: "Russia",
    iata: "",
    icao: "UNCC",
    latitude: "55.1",
    longitude: "82.9",
    altitude: "560",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "4377",
    name: "Uraj",
    city: "Uraj",
    country: "Russia",
    iata: "URJ",
    icao: "USHU",
    latitude: "60.1",
    longitude: "64.83",
    altitude: "186",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "4378",
    name: "Turkmenabat",
    city: "Turkmenabat",
    country: "Turkmenistan",
    iata: "CRZ",
    icao: "\\N",
    latitude: "39.083333",
    longitude: "63.602222",
    altitude: "630",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "4379",
    name: "Yuzhny",
    city: "Ivanovo",
    country: "Russia",
    iata: "IWA",
    icao: "UUBI",
    latitude: "56.939444",
    longitude: "40.940833",
    altitude: "410",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "4380",
    name: "Changchun",
    city: "Changchun",
    country: "China",
    iata: "CGQ",
    icao: "ZYCC",
    latitude: "43.5412",
    longitude: "125.1201",
    altitude: "227",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "4381",
    name: "Niigata",
    city: "Niigata",
    country: "Japan",
    iata: "KIJ",
    icao: "RJSN",
    latitude: "37.5711",
    longitude: "139.0646",
    altitude: "1",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "4382",
    name: "Johnston Atoll",
    city: "Johnston Island",
    country: "Johnston Atoll",
    iata: "JON",
    icao: "PJON",
    latitude: "16.7286",
    longitude: "-169.534",
    altitude: "7",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Johnston",
  },
  {
    id: "4383",
    name: "Smith Fld",
    city: "Fort Wayne IN",
    country: "United States",
    iata: "SMD",
    icao: "KSMD",
    latitude: "41.143353",
    longitude: "-85.152778",
    altitude: "834",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4384",
    name: "Arcata",
    city: "Arcata CA",
    country: "United States",
    iata: "ACV",
    icao: "KACV",
    latitude: "40.978111",
    longitude: "-124.108611",
    altitude: "221",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "4385",
    name: "Camp Mabry Austin City",
    city: "Austin TX",
    country: "United States",
    iata: "ATT",
    icao: "KATT",
    latitude: "30.31666",
    longitude: "-97.7666",
    altitude: "0",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4386",
    name: "Albert J Ellis",
    city: "Jacksonville NC",
    country: "United States",
    iata: "OAJ",
    icao: "KOAJ",
    latitude: "34.829164",
    longitude: "-77.612139",
    altitude: "94",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "4387",
    name: "Tuscaloosa Rgnl",
    city: "Tuscaloosa AL",
    country: "United States",
    iata: "TCL",
    icao: "KTCL",
    latitude: "33.220627",
    longitude: "-87.611403",
    altitude: "170",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4388",
    name: "Dubuque Rgnl",
    city: "Dubuque IA",
    country: "United States",
    iata: "DBQ",
    icao: "KDBQ",
    latitude: "42.402",
    longitude: "-90.709472",
    altitude: "1076",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "4389",
    name: "Forde Bringeland",
    city: "Forde",
    country: "Norway",
    iata: "FDE",
    icao: "\\N",
    latitude: "61.392",
    longitude: "5.763",
    altitude: "1034",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "4390",
    name: "Shun Tak Heliport",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "VHST",
    latitude: "22.289372",
    longitude: "114.152153",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "6092",
    name: "Poliarny Airport",
    city: "Yakutia",
    country: "Russia",
    iata: "PYJ",
    icao: "UERP",
    latitude: "66.400431",
    longitude: "112.030325",
    altitude: "1660",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "6090",
    name: "Nakhchivan Airport",
    city: "Nakhchivan",
    country: "Azerbaijan",
    iata: "NAJ",
    icao: "UBBN",
    latitude: "39.1888",
    longitude: "45.4584",
    altitude: "2863",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "6089",
    name: "Ganja Airport",
    city: "Ganja",
    country: "Azerbaijan",
    iata: "KVD",
    icao: "UBBG",
    latitude: "40.7377",
    longitude: "46.3176",
    altitude: "1083",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "6804",
    name: "Torp",
    city: "Sandefjord",
    country: "Norway",
    iata: "",
    icao: "\\N",
    latitude: "59.186703",
    longitude: "10.258628",
    altitude: "286",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "6086",
    name: "Ust Kamenogorsk Airport",
    city: "Ust Kamenogorsk",
    country: "Kazakhstan",
    iata: "UKK",
    icao: "UASK",
    latitude: "50.0366",
    longitude: "82.4942",
    altitude: "939",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "6084",
    name: "Petropavlosk South Airport",
    city: "Petropavlosk",
    country: "Kazakhstan",
    iata: "PPK",
    icao: "UACP",
    latitude: "54.7747",
    longitude: "69.1839",
    altitude: "453",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "6078",
    name: "Les Bases Airport",
    city: "Grand Bourg",
    country: "Guadeloupe",
    iata: "GBJ",
    icao: "TFFM",
    latitude: "15.86875",
    longitude: "-61.270022",
    altitude: "16",
    timezone: "-4",
    dst: "U",
    tz: "America/Guadeloupe",
  },
  {
    id: "6077",
    name: "St-François Airport",
    city: "St-François",
    country: "Guadeloupe",
    iata: "SFC",
    icao: "TFFC",
    latitude: "16.2578",
    longitude: "-61.2625",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guadeloupe",
  },
  {
    id: "6074",
    name: "Codrington Airport",
    city: "Codrington",
    country: "Antigua and Barbuda",
    iata: "BBQ",
    icao: "TAPH",
    latitude: "17.6358",
    longitude: "-61.8286",
    altitude: "15",
    timezone: "-4",
    dst: "U",
    tz: "America/Antigua",
  },
  {
    id: "6073",
    name: "Ji-Paraná Airport",
    city: "Ji-Paraná",
    country: "Brazil",
    iata: "JPR",
    icao: "SWJI",
    latitude: "-10.8708",
    longitude: "-61.8465",
    altitude: "598",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "6071",
    name: "Escuela Mariscal Sucre Airport",
    city: "Maracay",
    country: "Venezuela",
    iata: "MYC",
    icao: "SVBS",
    latitude: "10.249978",
    longitude: "-67.649419",
    altitude: "1338",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "6068",
    name: "Maria Reiche Neuman Airport",
    city: "Nazca",
    country: "Peru",
    iata: "NZA",
    icao: "SPZA",
    latitude: "-14.854192",
    longitude: "-74.961811",
    altitude: "1860",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6066",
    name: "Mayor General FAP Armando Revoredo Iglesias Airport",
    city: "Cajamarca",
    country: "Peru",
    iata: "CJA",
    icao: "SPJR",
    latitude: "-7.139183",
    longitude: "-78.4894",
    altitude: "8781",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6064",
    name: "Gatokae Airport",
    city: "Gatokae",
    country: "Solomon Islands",
    iata: "GTA",
    icao: "",
    latitude: "-8.75",
    longitude: "158.2",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "6063",
    name: "Boorama Airport",
    city: "Boorama",
    country: "Somalia",
    iata: "BXX",
    icao: "",
    latitude: "9.933",
    longitude: "43.15",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "6062",
    name: "Mucuri Airport",
    city: "Mucuri",
    country: "Brazil",
    iata: "MVS",
    icao: "SNMU",
    latitude: "-18.0489",
    longitude: "-39.8642",
    altitude: "276",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "6061",
    name: "Zorg en Hoop Airport",
    city: "Paramaribo",
    country: "Suriname",
    iata: "ORG",
    icao: "SMZO",
    latitude: "5.81108",
    longitude: "-55.1907",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "6059",
    name: "Reyes Airport",
    city: "Reyes",
    country: "Bolivia",
    iata: "REY",
    icao: "SLRY",
    latitude: "-14.3044",
    longitude: "-67.3534",
    altitude: "935",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "6057",
    name: "Puerto Rico Airport",
    city: "Puerto Rico/Manuripi",
    country: "Bolivia",
    iata: "PUR",
    icao: "SLPR",
    latitude: "-11.1077",
    longitude: "-67.5512",
    altitude: "597",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "6055",
    name: "El Alcaraván Airport",
    city: "Yopal",
    country: "Colombia",
    iata: "EYP",
    icao: "SKYP",
    latitude: "5.319114",
    longitude: "-72.383975",
    altitude: "1028",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6047",
    name: "General Rivadeneira Airport",
    city: "Esmeraldas",
    country: "Ecuador",
    iata: "ESM",
    icao: "SETN",
    latitude: "0.978519",
    longitude: "-79.6266",
    altitude: "32",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "6043",
    name: "Pucón Airport",
    city: "Pucon",
    country: "Chile",
    iata: "ZPC",
    icao: "SCPC",
    latitude: "-39.2928",
    longitude: "-71.9159",
    altitude: "853",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "6041",
    name: "Toledo Airport",
    city: "Toledo",
    country: "Brazil",
    iata: "TOW",
    icao: "SBTD",
    latitude: "-24.6863",
    longitude: "-53.6975",
    altitude: "1843",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6040",
    name: "Santa Maria Airport",
    city: "Santa Maria",
    country: "Brazil",
    iata: "RIA",
    icao: "SBSM",
    latitude: "-29.711358",
    longitude: "-53.688153",
    altitude: "287",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6036",
    name: "Chapada Diamantina Airport",
    city: "Lençóis",
    country: "Brazil",
    iata: "LEC",
    icao: "SBLE",
    latitude: "-12.4823",
    longitude: "-41.277",
    altitude: "1676",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "6805",
    name: "Goulburn Airport",
    city: "Goulburn",
    country: "Australia",
    iata: "GUL",
    icao: "YGLB",
    latitude: "-34.8103",
    longitude: "149.726",
    altitude: "2141",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6034",
    name: "Orlando Bezerra de Menezes Airport",
    city: "Juazeiro Do Norte",
    country: "Brazil",
    iata: "JDO",
    icao: "SBJU",
    latitude: "-7.218958",
    longitude: "-39.2701",
    altitude: "1392",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "6032",
    name: "Santa Teresita Airport",
    city: "Santa Teresita",
    country: "Argentina",
    iata: "SST",
    icao: "SAZL",
    latitude: "-36.542317",
    longitude: "-56.721756",
    altitude: "9",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6031",
    name: "Gobernador Gregores Airport",
    city: "Gobernador Gregores",
    country: "Argentina",
    iata: "GGS",
    icao: "SAWR",
    latitude: "-48.7831",
    longitude: "-70.15",
    altitude: "356",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6029",
    name: "Antoine De St Exupery Airport",
    city: "San Antonio Oeste",
    country: "Argentina",
    iata: "OES",
    icao: "SAVN",
    latitude: "-40.7512",
    longitude: "-65.0343",
    altitude: "85",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6028",
    name: "Las Heras Airport",
    city: "Las Heras",
    country: "Argentina",
    iata: "LHS",
    icao: "SAVH",
    latitude: "-46.533056",
    longitude: "-68.951111",
    altitude: "1082",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6027",
    name: "General Enrique Mosconi Airport",
    city: "Tartagal",
    country: "Argentina",
    iata: "TTG",
    icao: "SAST",
    latitude: "-22.619167",
    longitude: "-63.793189",
    altitude: "1472",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6025",
    name: "Masbate Airport",
    city: "Masbate",
    country: "Philippines",
    iata: "MBT",
    icao: "RPVJ",
    latitude: "12.3694",
    longitude: "123.629",
    altitude: "26",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6024",
    name: "Catarman National Airport",
    city: "Catarman",
    country: "Philippines",
    iata: "CRM",
    icao: "RPVF",
    latitude: "12.502417",
    longitude: "124.635778",
    altitude: "6",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6013",
    name: "Jolo Airport",
    city: "Jolo",
    country: "Philippines",
    iata: "JOL",
    icao: "RPMJ",
    latitude: "6.05367",
    longitude: "121.011",
    altitude: "118",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6012",
    name: "Camiguin Airport",
    city: "Camiguin",
    country: "Philippines",
    iata: "CGM",
    icao: "RPMH",
    latitude: "9.25352",
    longitude: "124.707",
    altitude: "53",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6010",
    name: "Cuyo Airport",
    city: "Cuyo",
    country: "Philippines",
    iata: "CYU",
    icao: "RPLO",
    latitude: "10.8581",
    longitude: "121.069",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6008",
    name: "Cheongju International Airport",
    city: "Chongju",
    country: "South Korea",
    iata: "CJJ",
    icao: "RKTU",
    latitude: "36.7166",
    longitude: "127.499119",
    altitude: "191",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6007",
    name: "Sacheon Air Base",
    city: "Sacheon",
    country: "South Korea",
    iata: "HIN",
    icao: "RKPS",
    latitude: "35.088543",
    longitude: "128.07037",
    altitude: "25",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6005",
    name: "Wonju Airport",
    city: "Wonju",
    country: "South Korea",
    iata: "WJU",
    icao: "RKNW",
    latitude: "37.438081",
    longitude: "127.960383",
    altitude: "329",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6004",
    name: "Mokpo Airport",
    city: "Mokpo",
    country: "South Korea",
    iata: "MPK",
    icao: "RKJM",
    latitude: "34.758906",
    longitude: "126.379872",
    altitude: "23",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6003",
    name: "Kunsan Air Base",
    city: "Kunsan",
    country: "South Korea",
    iata: "KUV",
    icao: "RKJK",
    latitude: "35.903756",
    longitude: "126.615906",
    altitude: "29",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6002",
    name: "Miyakejima Airport",
    city: "Miyakejima",
    country: "Japan",
    iata: "MYE",
    icao: "RJTQ",
    latitude: "34.0736",
    longitude: "139.56",
    altitude: "67",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "6001",
    name: "Shonai Airport",
    city: "Shonai",
    country: "Japan",
    iata: "SYO",
    icao: "RJSY",
    latitude: "38.812222",
    longitude: "139.787222",
    altitude: "86",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "6000",
    name: "Odate Noshiro Airport",
    city: "Odate Noshiro",
    country: "Japan",
    iata: "ONJ",
    icao: "RJSR",
    latitude: "40.1919",
    longitude: "140.371",
    altitude: "292",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "5999",
    name: "Fukushima Airport",
    city: "Fukushima",
    country: "Japan",
    iata: "FKS",
    icao: "RJSF",
    latitude: "37.2274",
    longitude: "140.431",
    altitude: "1221",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "5998",
    name: "Iwami Airport",
    city: "Iwami",
    country: "Japan",
    iata: "IWJ",
    icao: "RJOW",
    latitude: "34.6764",
    longitude: "131.79",
    altitude: "184",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "5997",
    name: "Nagoya Airport",
    city: "Nagoya",
    country: "Japan",
    iata: "NKM",
    icao: "RJNA",
    latitude: "35.255",
    longitude: "136.924",
    altitude: "52",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "5996",
    name: "Saga Airport",
    city: "Saga",
    country: "Japan",
    iata: "HSG",
    icao: "RJFS",
    latitude: "33.1497",
    longitude: "130.302",
    altitude: "6",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "5995",
    name: "Okadama Airport",
    city: "Sapporo",
    country: "Japan",
    iata: "OKD",
    icao: "RJCO",
    latitude: "43.1161",
    longitude: "141.38",
    altitude: "25",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "5994",
    name: "Kushiro Airport",
    city: "Kushiro",
    country: "Japan",
    iata: "KUH",
    icao: "RJCK",
    latitude: "43.041",
    longitude: "144.193",
    altitude: "327",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "5993",
    name: "Matsu Beigan Airport",
    city: "Matsu Islands",
    country: "Taiwan",
    iata: "MFK",
    icao: "RCMT",
    latitude: "26.224153",
    longitude: "120.00275",
    altitude: "41",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "5992",
    name: "Hengchun Airport",
    city: "Hengchun",
    country: "Taiwan",
    iata: "HCN",
    icao: "RCKW",
    latitude: "22.041075",
    longitude: "120.730208",
    altitude: "46",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "5991",
    name: "Matsu Nangan Airport",
    city: "Matsu Islands",
    country: "Taiwan",
    iata: "LZN",
    icao: "RCFG",
    latitude: "26.1598",
    longitude: "119.958",
    altitude: "232",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "5990",
    name: "Eniwetok Airport",
    city: "Eniwetok Atoll",
    country: "Marshall Islands",
    iata: "ENT",
    icao: "PKMA",
    latitude: "11.34075",
    longitude: "162.327861",
    altitude: "13",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5989",
    name: "Kalaupapa Airport",
    city: "Molokai",
    country: "United States",
    iata: "LUP",
    icao: "PHLU",
    latitude: "21.211",
    longitude: "-156.974",
    altitude: "24",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "5988",
    name: "El Nido Airport",
    city: "El Nido",
    country: "Philippines",
    iata: "ENI",
    icao: "",
    latitude: "11.202",
    longitude: "119.417",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "5987",
    name: "Wipim Airport",
    city: "Wipim",
    country: "Papua New Guinea",
    iata: "WPM",
    icao: "",
    latitude: "-8.78822",
    longitude: "142.882",
    altitude: "173",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5986",
    name: "Baimuru Airport",
    city: "Baimuru",
    country: "Papua New Guinea",
    iata: "VMU",
    icao: "",
    latitude: "-7.49686",
    longitude: "144.82",
    altitude: "27",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5985",
    name: "Nuku Airport",
    city: "Nuku",
    country: "Papua New Guinea",
    iata: "UKU",
    icao: "",
    latitude: "-3.667",
    longitude: "142.483",
    altitude: "750",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5984",
    name: "Tufi Airport",
    city: "Tufi",
    country: "Papua New Guinea",
    iata: "TFI",
    icao: "",
    latitude: "-9.07595",
    longitude: "149.32",
    altitude: "85",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5983",
    name: "Suki Airport",
    city: "Suki",
    country: "Papua New Guinea",
    iata: "SKC",
    icao: "",
    latitude: "-8.033",
    longitude: "141.717",
    altitude: "24",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5982",
    name: "Balimo Airport",
    city: "Balimo",
    country: "Papua New Guinea",
    iata: "OPU",
    icao: "",
    latitude: "-8.05",
    longitude: "142.933",
    altitude: "51",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5981",
    name: "Obo Airport",
    city: "Obo",
    country: "Papua New Guinea",
    iata: "OBX",
    icao: "",
    latitude: "-7.583",
    longitude: "141.317",
    altitude: "29",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5980",
    name: "Losuia Airport",
    city: "Losuia",
    country: "Papua New Guinea",
    iata: "LSA",
    icao: "",
    latitude: "-8.50582",
    longitude: "151.081",
    altitude: "27",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5979",
    name: "Londolovit Airport",
    city: "Londolovit",
    country: "Papua New Guinea",
    iata: "LNV",
    icao: "",
    latitude: "-3.04361",
    longitude: "152.629",
    altitude: "167",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5978",
    name: "Lake Murray Airport",
    city: "Lake Murray",
    country: "Papua New Guinea",
    iata: "LMY",
    icao: "",
    latitude: "-7.00992",
    longitude: "141.494",
    altitude: "52",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5977",
    name: "Kamusi Airport",
    city: "Kamusi",
    country: "Papua New Guinea",
    iata: "KUY",
    icao: "",
    latitude: "-7.42035",
    longitude: "143.122",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5976",
    name: "Kokoda Airport",
    city: "Kokoda",
    country: "Papua New Guinea",
    iata: "KKD",
    icao: "",
    latitude: "-8.88468",
    longitude: "147.731",
    altitude: "1240",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5975",
    name: "Kandrian Airport",
    city: "Kandrian",
    country: "Papua New Guinea",
    iata: "KDR",
    icao: "",
    latitude: "-6.183",
    longitude: "149.533",
    altitude: "280",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5974",
    name: "Jacquinot Bay Airport",
    city: "Jacquinot Bay",
    country: "Papua New Guinea",
    iata: "JAQ",
    icao: "",
    latitude: "-5.6525",
    longitude: "151.507",
    altitude: "136",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5973",
    name: "Nissan Island Airport",
    city: "Nissan Island",
    country: "Papua New Guinea",
    iata: "IIS",
    icao: "",
    latitude: "-4.49972",
    longitude: "154.226",
    altitude: "52",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5972",
    name: "Ihu Airport",
    city: "Ihu",
    country: "Papua New Guinea",
    iata: "IHU",
    icao: "",
    latitude: "-7.89756",
    longitude: "145.396",
    altitude: "47",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5971",
    name: "Gasmata Island Airport",
    city: "Gasmata Island",
    country: "Papua New Guinea",
    iata: "GMI",
    icao: "",
    latitude: "-6.27111",
    longitude: "150.331",
    altitude: "23",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5970",
    name: "Tadji Airport",
    city: "Aitape",
    country: "Papua New Guinea",
    iata: "ATP",
    icao: "",
    latitude: "-3.18985",
    longitude: "142.43",
    altitude: "48",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5969",
    name: "Wrangell Airport",
    city: "Wrangell",
    country: "United States",
    iata: "WRG",
    icao: "PAWG",
    latitude: "56.4843",
    longitude: "-132.37",
    altitude: "44",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5968",
    name: "Chevak Airport",
    city: "Chevak",
    country: "United States",
    iata: "VAK",
    icao: "PAVA",
    latitude: "61.5338",
    longitude: "-165.584",
    altitude: "75",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5967",
    name: "Aniak Airport",
    city: "Aniak",
    country: "United States",
    iata: "ANI",
    icao: "PANI",
    latitude: "61.5816",
    longitude: "-159.543",
    altitude: "88",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5966",
    name: "Mountain Village Airport",
    city: "Mountain Village",
    country: "United States",
    iata: "MOU",
    icao: "PAMO",
    latitude: "62.0954",
    longitude: "-163.682",
    altitude: "337",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5965",
    name: "McGrath Airport",
    city: "Mcgrath",
    country: "United States",
    iata: "MCG",
    icao: "PAMC",
    latitude: "62.9529",
    longitude: "-155.606",
    altitude: "338",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5964",
    name: "Kalskag Airport",
    city: "Kalskag",
    country: "United States",
    iata: "KLG",
    icao: "PALG",
    latitude: "61.5363",
    longitude: "-160.341",
    altitude: "55",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5963",
    name: "Haines Airport",
    city: "Haines",
    country: "United States",
    iata: "HNS",
    icao: "PAHN",
    latitude: "59.2438",
    longitude: "-135.524",
    altitude: "15",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5962",
    name: "Holy Cross Airport",
    city: "Holy Cross",
    country: "United States",
    iata: "HCR",
    icao: "PAHC",
    latitude: "62.1883",
    longitude: "-159.775",
    altitude: "70",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5961",
    name: "Skagway Airport",
    city: "Skagway",
    country: "United States",
    iata: "SGY",
    icao: "PAGY",
    latitude: "59.4601",
    longitude: "-135.316",
    altitude: "44",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5960",
    name: "Gustavus Airport",
    city: "Gustavus",
    country: "United States",
    iata: "GST",
    icao: "PAGS",
    latitude: "58.4253",
    longitude: "-135.707",
    altitude: "34",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5959",
    name: "Adak Airport",
    city: "Adak Island",
    country: "United States",
    iata: "ADK",
    icao: "PADK",
    latitude: "51.878",
    longitude: "-176.646",
    altitude: "18",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "5958",
    name: "Sambu Airport",
    city: "Boca de Sábalo",
    country: "Panama",
    iata: "SAX",
    icao: "",
    latitude: "8.017",
    longitude: "-78.2",
    altitude: "32",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5957",
    name: "Contadora Airport",
    city: "Contadora Island",
    country: "Panama",
    iata: "OTD",
    icao: "",
    latitude: "8.62876",
    longitude: "-79.0347",
    altitude: "14",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5956",
    name: "EL Real Airport",
    city: "El Real",
    country: "Panama",
    iata: "ELE",
    icao: "",
    latitude: "8.133",
    longitude: "-77.7",
    altitude: "57",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5955",
    name: "Bahia Piña Airport",
    city: "Bahia Piña",
    country: "Panama",
    iata: "BFQ",
    icao: "",
    latitude: "7.583",
    longitude: "-78.2",
    altitude: "14",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5954",
    name: "Sayun International Airport",
    city: "Sayun Intl",
    country: "Yemen",
    iata: "GXF",
    icao: "OYSY",
    latitude: "15.966111",
    longitude: "48.7883",
    altitude: "2097",
    timezone: "3",
    dst: "U",
    tz: "Asia/Aden",
  },
  {
    id: "5953",
    name: "Kamishly Airport",
    city: "Kamishly",
    country: "Syria",
    iata: "KAC",
    icao: "OSKL",
    latitude: "37.020625",
    longitude: "41.191394",
    altitude: "1480",
    timezone: "2",
    dst: "E",
    tz: "Asia/Damascus",
  },
  {
    id: "5952",
    name: "Sulaymaniyah International Airport",
    city: "Sulaymaniyah",
    country: "Iraq",
    iata: "ISU",
    icao: "ORSU",
    latitude: "35.5608",
    longitude: "45.3147",
    altitude: "2494",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "5951",
    name: "Turbat International Airport",
    city: "Turbat",
    country: "Pakistan",
    iata: "TUK",
    icao: "OPTU",
    latitude: "25.986369",
    longitude: "63.030167",
    altitude: "498",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5950",
    name: "Sehwan Sharif Airport",
    city: "Sehwan Sharif",
    country: "Pakistan",
    iata: "SYW",
    icao: "OPSN",
    latitude: "26.4731",
    longitude: "67.7172",
    altitude: "121",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5949",
    name: "Skardu Airport",
    city: "Skardu",
    country: "Pakistan",
    iata: "KDU",
    icao: "OPSD",
    latitude: "35.335508",
    longitude: "75.536047",
    altitude: "7316",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5948",
    name: "Parachinar Airport",
    city: "Parachinar",
    country: "Pakistan",
    iata: "PAJ",
    icao: "OPPC",
    latitude: "33.9021",
    longitude: "70.0716",
    altitude: "5800",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5947",
    name: "Ormara Airport",
    city: "Ormara Raik",
    country: "Pakistan",
    iata: "ORW",
    icao: "OPOR",
    latitude: "25.2747",
    longitude: "64.586",
    altitude: "10",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5946",
    name: "Khuzdar Airport",
    city: "Khuzdar",
    country: "Pakistan",
    iata: "KDD",
    icao: "OPKH",
    latitude: "27.7906",
    longitude: "66.6473",
    altitude: "4012",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5945",
    name: "Hyderabad Airport",
    city: "Hyderabad",
    country: "Pakistan",
    iata: "HDD",
    icao: "OPKD",
    latitude: "25.3181",
    longitude: "68.3661",
    altitude: "130",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5944",
    name: "Jiwani Airport",
    city: "Jiwani",
    country: "Pakistan",
    iata: "JIW",
    icao: "OPJI",
    latitude: "25.0678",
    longitude: "61.8054",
    altitude: "186",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5943",
    name: "Dera Ismael Khan Airport",
    city: "Dera Ismael Khan",
    country: "Pakistan",
    iata: "DSK",
    icao: "OPDI",
    latitude: "31.909422",
    longitude: "70.896639",
    altitude: "594",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5942",
    name: "Dera Ghazi Khan Airport",
    city: "Dera Ghazi Khan",
    country: "Pakistan",
    iata: "DEA",
    icao: "OPDG",
    latitude: "29.961011",
    longitude: "70.485925",
    altitude: "492",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5941",
    name: "Dalbandin Airport",
    city: "Dalbandin",
    country: "Pakistan",
    iata: "DBA",
    icao: "OPDB",
    latitude: "28.8783",
    longitude: "64.3998",
    altitude: "2800",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5940",
    name: "Chitral Airport",
    city: "Chitral",
    country: "Pakistan",
    iata: "CJL",
    icao: "OPCH",
    latitude: "35.886592",
    longitude: "71.800578",
    altitude: "4920",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5939",
    name: "Bahawalpur Airport",
    city: "Bahawalpur",
    country: "Pakistan",
    iata: "BHV",
    icao: "OPBW",
    latitude: "29.3481",
    longitude: "71.717981",
    altitude: "392",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5938",
    name: "Bannu Airport",
    city: "Bannu",
    country: "Pakistan",
    iata: "BNP",
    icao: "OPBN",
    latitude: "32.9729",
    longitude: "70.5279",
    altitude: "1325",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "5937",
    name: "Al Ain International Airport",
    city: "Al Ain",
    country: "United Arab Emirates",
    iata: "AAN",
    icao: "OMAL",
    latitude: "24.261667",
    longitude: "55.609167",
    altitude: "869",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "5936",
    name: "Uromiyeh Airport",
    city: "Uromiyeh",
    country: "Iran",
    iata: "OMH",
    icao: "OITR",
    latitude: "37.6681",
    longitude: "45.0687",
    altitude: "4343",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5935",
    name: "Ardabil Airport",
    city: "Ardabil",
    country: "Iran",
    iata: "ADU",
    icao: "OITL",
    latitude: "38.325678",
    longitude: "48.424356",
    altitude: "4315",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5934",
    name: "Lar Airport",
    city: "Lar",
    country: "Iran",
    iata: "LRR",
    icao: "OISL",
    latitude: "27.674725",
    longitude: "54.383278",
    altitude: "2641",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5933",
    name: "Sari Dasht E Naz Airport",
    city: "Dasht-e-naz",
    country: "Iran",
    iata: "SRY",
    icao: "OINZ",
    latitude: "36.635833",
    longitude: "53.193611",
    altitude: "35",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5932",
    name: "Noshahr Airport",
    city: "Noshahr",
    country: "Iran",
    iata: "NSH",
    icao: "OINN",
    latitude: "36.663333",
    longitude: "51.464722",
    altitude: "-61",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5931",
    name: "Sabzevar National Airport",
    city: "Sabzevar",
    country: "Iran",
    iata: "AFZ",
    icao: "OIMS",
    latitude: "36.168083",
    longitude: "57.595183",
    altitude: "3010",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5930",
    name: "Bojnourd Airport",
    city: "Bojnourd",
    country: "Iran",
    iata: "BJB",
    icao: "OIMN",
    latitude: "37.492958",
    longitude: "57.308219",
    altitude: "3499",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5929",
    name: "Rafsanjan Airport",
    city: "Rafsanjan",
    country: "Iran",
    iata: "RJN",
    icao: "OIKR",
    latitude: "30.297714",
    longitude: "56.051139",
    altitude: "5298",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5928",
    name: "Bam Airport",
    city: "Bam",
    country: "Iran",
    iata: "BXR",
    icao: "OIKM",
    latitude: "29.084169",
    longitude: "58.450042",
    altitude: "3231",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5927",
    name: "Khoram Abad Airport",
    city: "Khorram Abad",
    country: "Iran",
    iata: "KHD",
    icao: "OICK",
    latitude: "33.435378",
    longitude: "48.282889",
    altitude: "3782",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5926",
    name: "Wadi Al Dawasir Airport",
    city: "Wadi-al-dawasir",
    country: "Saudi Arabia",
    iata: "EWD",
    icao: "OEWD",
    latitude: "20.504275",
    longitude: "45.199556",
    altitude: "2062",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "5925",
    name: "Al-Jawf Domestic Airport",
    city: "Al-Jawf",
    country: "Saudi Arabia",
    iata: "AJF",
    icao: "OESK",
    latitude: "29.785133",
    longitude: "40.100006",
    altitude: "2261",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "5924",
    name: "Dawadmi Domestic Airport",
    city: "Dawadmi",
    country: "Saudi Arabia",
    iata: "DWD",
    icao: "OEDW",
    latitude: "24.5",
    longitude: "44.4",
    altitude: "3429",
    timezone: "3",
    dst: "U",
    tz: "Asia/Riyadh",
  },
  {
    id: "6506",
    name: "Saul Airport",
    city: "Saul",
    country: "French Guiana",
    iata: "XAU",
    icao: "SOOS",
    latitude: "3.61361",
    longitude: "-53.2042",
    altitude: "656",
    timezone: "-3",
    dst: "U",
    tz: "America/Cayenne",
  },
  {
    id: "5922",
    name: "Faizabad Airport",
    city: "Faizabad",
    country: "Afghanistan",
    iata: "FBD",
    icao: "OAFZ",
    latitude: "37.1211",
    longitude: "70.5181",
    altitude: "3872",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "5921",
    name: "Île des Pins Airport",
    city: "Île des Pins",
    country: "New Caledonia",
    iata: "ILP",
    icao: "NWWE",
    latitude: "-22.5889",
    longitude: "167.456",
    altitude: "315",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "5920",
    name: "Belep Islands Airport",
    city: "Waala",
    country: "New Caledonia",
    iata: "BMY",
    icao: "NWWC",
    latitude: "-19.7206",
    longitude: "163.661",
    altitude: "306",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "5919",
    name: "Tiga Airport",
    city: "Tiga",
    country: "New Caledonia",
    iata: "TGJ",
    icao: "NWWA",
    latitude: "-21.0961",
    longitude: "167.804",
    altitude: "128",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Noumea",
  },
  {
    id: "5918",
    name: "Ipota Airport",
    city: "Ipota",
    country: "Vanuatu",
    iata: "IPA",
    icao: "NVVI",
    latitude: "-18.8783",
    longitude: "169.308",
    altitude: "23",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5917",
    name: "Futuna Airport",
    city: "Futuna Island",
    country: "Vanuatu",
    iata: "FTA",
    icao: "NVVF",
    latitude: "-19.5164",
    longitude: "170.232",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5916",
    name: "Dillon's Bay Airport",
    city: "Dillon's Bay",
    country: "Vanuatu",
    iata: "DLY",
    icao: "NVVD",
    latitude: "-18.7694",
    longitude: "169.001",
    altitude: "538",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5915",
    name: "Aniwa Airport",
    city: "Aniwa",
    country: "Vanuatu",
    iata: "AWD",
    icao: "NVVB",
    latitude: "-19.24",
    longitude: "169.605",
    altitude: "69",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5914",
    name: "Anelghowhat Airport",
    city: "Anelghowhat",
    country: "Vanuatu",
    iata: "AUY",
    icao: "NVVA",
    latitude: "-20.2492",
    longitude: "169.771",
    altitude: "7",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5913",
    name: "North West Santo Airport",
    city: "Olpoi",
    country: "Vanuatu",
    iata: "OLZ",
    icao: "NVSZ",
    latitude: "-14.8817",
    longitude: "166.558",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5912",
    name: "Southwest Bay Airport",
    city: "Malekula Island",
    country: "Vanuatu",
    iata: "SWJ",
    icao: "NVSX",
    latitude: "-16.495",
    longitude: "167.438",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5911",
    name: "Valesdir Airport",
    city: "Valesdir",
    country: "Vanuatu",
    iata: "VLS",
    icao: "NVSV",
    latitude: "-16.7961",
    longitude: "168.177",
    altitude: "10",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5910",
    name: "Uléi Airport",
    city: "Ambryn Island",
    country: "Vanuatu",
    iata: "ULB",
    icao: "NVSU",
    latitude: "-16.333",
    longitude: "168.283",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5909",
    name: "Tongoa Island Airport",
    city: "Tongoa Island",
    country: "Vanuatu",
    iata: "TGH",
    icao: "NVST",
    latitude: "-16.8911",
    longitude: "168.551",
    altitude: "443",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5908",
    name: "Santo Pekoa International Airport",
    city: "Santo",
    country: "Vanuatu",
    iata: "SON",
    icao: "NVSS",
    latitude: "-15.505033",
    longitude: "167.219742",
    altitude: "184",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5907",
    name: "Redcliffe Airport",
    city: "Redcliffe",
    country: "Vanuatu",
    iata: "RCL",
    icao: "NVSR",
    latitude: "-15.472",
    longitude: "167.835",
    altitude: "36",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5906",
    name: "Gaua Island Airport",
    city: "Gaua Island",
    country: "Vanuatu",
    iata: "ZGU",
    icao: "NVSQ",
    latitude: "-14.2181",
    longitude: "167.587",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5905",
    name: "Norsup Airport",
    city: "Norsup",
    country: "Vanuatu",
    iata: "NUS",
    icao: "NVSP",
    latitude: "-16.0797",
    longitude: "167.401",
    altitude: "23",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5904",
    name: "Lonorore Airport",
    city: "Lonorore",
    country: "Vanuatu",
    iata: "LNE",
    icao: "NVSO",
    latitude: "-15.8656",
    longitude: "168.172",
    altitude: "43",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5903",
    name: "Naone Airport",
    city: "Maewo Island",
    country: "Vanuatu",
    iata: "MWF",
    icao: "NVSN",
    latitude: "-15",
    longitude: "168.083",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5902",
    name: "Lamen Bay Airport",
    city: "Lamen Bay",
    country: "Vanuatu",
    iata: "LNB",
    icao: "NVSM",
    latitude: "-16.5842",
    longitude: "168.159",
    altitude: "7",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5901",
    name: "Lamap Airport",
    city: "Lamap",
    country: "Vanuatu",
    iata: "LPM",
    icao: "NVSL",
    latitude: "-16.454",
    longitude: "167.823",
    altitude: "7",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5900",
    name: "Tavie Airport",
    city: "Paama Island",
    country: "Vanuatu",
    iata: "PBJ",
    icao: "NVSI",
    latitude: "-16.439",
    longitude: "168.257",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5899",
    name: "Sara Airport",
    city: "Pentecost Island",
    country: "Vanuatu",
    iata: "SSR",
    icao: "NVSH",
    latitude: "-15.4708",
    longitude: "168.152",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5898",
    name: "Longana Airport",
    city: "Longana",
    country: "Vanuatu",
    iata: "LOD",
    icao: "NVSG",
    latitude: "-15.3067",
    longitude: "167.967",
    altitude: "167",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5897",
    name: "Craig Cove Airport",
    city: "Craig Cove",
    country: "Vanuatu",
    iata: "CCV",
    icao: "NVSF",
    latitude: "-16.265",
    longitude: "167.924",
    altitude: "69",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5896",
    name: "Sangafa Airport",
    city: "Sangafa",
    country: "Vanuatu",
    iata: "EAE",
    icao: "NVSE",
    latitude: "-17.0903",
    longitude: "168.343",
    altitude: "7",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5895",
    name: "Torres Airstrip",
    city: "Loh/Linua",
    country: "Vanuatu",
    iata: "TOH",
    icao: "NVSD",
    latitude: "-13.328",
    longitude: "166.638",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5894",
    name: "Sola Airport",
    city: "Sola",
    country: "Vanuatu",
    iata: "SLH",
    icao: "NVSC",
    latitude: "-13.8517",
    longitude: "167.537",
    altitude: "7",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5893",
    name: "Mota Lava Airport",
    city: "Ablow",
    country: "Vanuatu",
    iata: "MTV",
    icao: "NVSA",
    latitude: "-13.666",
    longitude: "167.712",
    altitude: "63",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "5892",
    name: "Ua Huka Airport",
    city: "Ua Huka",
    country: "French Polynesia",
    iata: "UAH",
    icao: "NTMU",
    latitude: "-8.93611",
    longitude: "-139.552",
    altitude: "160",
    timezone: "-9.5",
    dst: "U",
    tz: "Pacific/Marquesas",
  },
  {
    id: "5891",
    name: "Ua Pou Airport",
    city: "Ua Pou",
    country: "French Polynesia",
    iata: "UAP",
    icao: "NTMP",
    latitude: "-9.35167",
    longitude: "-140.078",
    altitude: "16",
    timezone: "-9.5",
    dst: "U",
    tz: "Pacific/Marquesas",
  },
  {
    id: "5890",
    name: "Hiva Oa-Atuona Airport",
    city: "Hiva-oa",
    country: "French Polynesia",
    iata: "AUQ",
    icao: "NTMN",
    latitude: "-9.768794",
    longitude: "-139.011256",
    altitude: "1481",
    timezone: "-9.5",
    dst: "U",
    tz: "Pacific/Marquesas",
  },
  {
    id: "5889",
    name: "Ahe Airport",
    city: "Ahe",
    country: "French Polynesia",
    iata: "AHE",
    icao: "NTHE",
    latitude: "-14.4281",
    longitude: "-146.257",
    altitude: "11",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "5888",
    name: "Apataki Airport",
    city: "Apataki",
    country: "French Polynesia",
    iata: "APK",
    icao: "NTGD",
    latitude: "-15.5736",
    longitude: "-146.415",
    altitude: "8",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "5887",
    name: "Maota Airport",
    city: "Savaii Island",
    country: "Samoa",
    iata: "MXS",
    icao: "NSMA",
    latitude: "-13.733",
    longitude: "-172.3",
    altitude: "0",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Apia",
  },
  {
    id: "5886",
    name: "Mountain Airport",
    city: "Mountain",
    country: "Nepal",
    iata: "MWP",
    icao: "",
    latitude: "28",
    longitude: "85.333",
    altitude: "0",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "5885",
    name: "Pointe Vele Airport",
    city: "Futuna Island",
    country: "Wallis and Futuna",
    iata: "FUT",
    icao: "NLWF",
    latitude: "-14.3114",
    longitude: "-178.066",
    altitude: "20",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Wallis",
  },
  {
    id: "5884",
    name: "Niue International Airport",
    city: "Alofi",
    country: "Niue",
    iata: "IUE",
    icao: "NIUE",
    latitude: "-19.080028",
    longitude: "-169.925639",
    altitude: "209",
    timezone: "-11",
    dst: "U",
    tz: "Pacific/Niue",
  },
  {
    id: "5883",
    name: "Vanua Balavu Airport",
    city: "Vanua Balavu",
    country: "Fiji",
    iata: "VBV",
    icao: "NFVB",
    latitude: "-17.269",
    longitude: "-178.976",
    altitude: "76",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5882",
    name: "Kuini Lavenia Airport",
    city: "Niuatoputapu",
    country: "Tonga",
    iata: "NTT",
    icao: "NFTP",
    latitude: "-15.9767",
    longitude: "-173.755",
    altitude: "0",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Tongatapu",
  },
  {
    id: "5881",
    name: "Mata'aho Airport",
    city: "Angaha, Niuafo'ou Island",
    country: "Tonga",
    iata: "NFO",
    icao: "NFTO",
    latitude: "-15.5708",
    longitude: "-175.633",
    altitude: "160",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Tongatapu",
  },
  {
    id: "5880",
    name: "Lifuka Island Airport",
    city: "Lifuka",
    country: "Tonga",
    iata: "HPA",
    icao: "NFTL",
    latitude: "-19.777",
    longitude: "-174.341",
    altitude: "31",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Tongatapu",
  },
  {
    id: "5879",
    name: "Kaufana Airport",
    city: "Eua Island",
    country: "Tonga",
    iata: "EUA",
    icao: "NFTE",
    latitude: "-21.3783",
    longitude: "-174.958",
    altitude: "325",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Tongatapu",
  },
  {
    id: "5878",
    name: "Savusavu Airport",
    city: "Savusavu",
    country: "Fiji",
    iata: "SVU",
    icao: "NFNS",
    latitude: "-16.8028",
    longitude: "179.341",
    altitude: "17",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5877",
    name: "Rotuma Airport",
    city: "Rotuma",
    country: "Fiji",
    iata: "RTA",
    icao: "NFNR",
    latitude: "-12.4825",
    longitude: "177.071",
    altitude: "22",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5876",
    name: "Koro Island Airport",
    city: "Koro Island",
    country: "Fiji",
    iata: "KXF",
    icao: "NFNO",
    latitude: "-17.3458",
    longitude: "179.422",
    altitude: "358",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5875",
    name: "Matei Airport",
    city: "Matei",
    country: "Fiji",
    iata: "TVU",
    icao: "NFNM",
    latitude: "-16.6906",
    longitude: "-179.877",
    altitude: "60",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5874",
    name: "Labasa Airport",
    city: "Lambasa",
    country: "Fiji",
    iata: "LBS",
    icao: "NFNL",
    latitude: "-16.466749",
    longitude: "179.33986",
    altitude: "44",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5873",
    name: "Lakeba Island Airport",
    city: "Lakeba Island",
    country: "Fiji",
    iata: "LKB",
    icao: "NFNK",
    latitude: "-18.1992",
    longitude: "-178.817",
    altitude: "280",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5872",
    name: "Ngau Airport",
    city: "Ngau",
    country: "Fiji",
    iata: "NGI",
    icao: "NFNG",
    latitude: "-18.1156",
    longitude: "179.34",
    altitude: "50",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5871",
    name: "Moala Airport",
    city: "Moala",
    country: "Fiji",
    iata: "MFJ",
    icao: "NFMO",
    latitude: "-18.5667",
    longitude: "179.951",
    altitude: "13",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5870",
    name: "Mana Island Airport",
    city: "Mana Island",
    country: "Fiji",
    iata: "MNF",
    icao: "NFMA",
    latitude: "-17.6731",
    longitude: "177.098",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5869",
    name: "Vunisea Airport",
    city: "Vunisea",
    country: "Fiji",
    iata: "KDV",
    icao: "NFKD",
    latitude: "-19.0581",
    longitude: "178.157",
    altitude: "6",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5868",
    name: "Malolo Lailai Island Airport",
    city: "Malolo Lailai Island",
    country: "Fiji",
    iata: "PTF",
    icao: "NFFO",
    latitude: "-17.7779",
    longitude: "177.197",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5867",
    name: "Cicia Airport",
    city: "Cicia",
    country: "Fiji",
    iata: "ICI",
    icao: "NFCI",
    latitude: "-17.7433",
    longitude: "-179.342",
    altitude: "13",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "5866",
    name: "Penrhyn Island Airport",
    city: "Penrhyn Island",
    country: "Cook Islands",
    iata: "PYE",
    icao: "NCPY",
    latitude: "-9.00667",
    longitude: "-158.037",
    altitude: "8",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "5865",
    name: "Mitiaro Island Airport",
    city: "Mitiaro Island",
    country: "Cook Islands",
    iata: "MOI",
    icao: "NCMR",
    latitude: "-19.8425",
    longitude: "-157.703",
    altitude: "25",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "5864",
    name: "Mauke Airport",
    city: "Mauke Island",
    country: "Cook Islands",
    iata: "MUK",
    icao: "NCMK",
    latitude: "-20.1361",
    longitude: "-157.345",
    altitude: "26",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "5863",
    name: "Manihiki Island Airport",
    city: "Manihiki Island",
    country: "Cook Islands",
    iata: "MHX",
    icao: "NCMH",
    latitude: "-10.3767",
    longitude: "-161.002",
    altitude: "0",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "5862",
    name: "Mangaia Island Airport",
    city: "Mangaia Island",
    country: "Cook Islands",
    iata: "MGS",
    icao: "NCMG",
    latitude: "-21.8956",
    longitude: "-157.905",
    altitude: "45",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "5861",
    name: "Atiu Island Airport",
    city: "Atiu Island",
    country: "Cook Islands",
    iata: "AIU",
    icao: "NCAT",
    latitude: "-19.9678",
    longitude: "-158.119",
    altitude: "36",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Rarotonga",
  },
  {
    id: "5860",
    name: "Nassau Paradise Island Airport",
    city: "Nassau",
    country: "Bahamas",
    iata: "PID",
    icao: "MYPI",
    latitude: "25.083",
    longitude: "-77.3",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "5859",
    name: "Colonel Hill Airport",
    city: "Colonel Hill",
    country: "Bahamas",
    iata: "CRI",
    icao: "MYCI",
    latitude: "22.745561",
    longitude: "-74.182353",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "5858",
    name: "New Bight Airport",
    city: "Cat Island",
    country: "Bahamas",
    iata: "CAT",
    icao: "MYCB",
    latitude: "24.315292",
    longitude: "-75.452331",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "5857",
    name: "Arthurs Town Airport",
    city: "Arthur's Town",
    country: "Bahamas",
    iata: "ATC",
    icao: "MYCA",
    latitude: "24.629417",
    longitude: "-75.673775",
    altitude: "18",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "5856",
    name: "Congo Town Airport",
    city: "Andros",
    country: "Bahamas",
    iata: "COX",
    icao: "MYAK",
    latitude: "24.158933",
    longitude: "-77.589758",
    altitude: "15",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "5855",
    name: "Long Banga Airport",
    city: "Long Banga",
    country: "Malaysia",
    iata: "LBP",
    icao: "",
    latitude: "3.18495",
    longitude: "115.454",
    altitude: "750",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "5854",
    name: "Salina Cruz Naval Air Station",
    city: "Salina Cruz",
    country: "Mexico",
    iata: "SCX",
    icao: "MM57",
    latitude: "16.2126",
    longitude: "-95.2016",
    altitude: "75",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "5853",
    name: "Alberto Delgado Airport",
    city: "Trinidad",
    country: "Cuba",
    iata: "TND",
    icao: "MUTD",
    latitude: "21.788461",
    longitude: "-79.997203",
    altitude: "125",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "5852",
    name: "Cayo Coco Airport",
    city: "Cayo Coco",
    country: "Cuba",
    iata: "CCC",
    icao: "MUOC",
    latitude: "22.5132",
    longitude: "-78.511",
    altitude: "6",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "5851",
    name: "Port-de-Paix Airport",
    city: "Port-de-Paix",
    country: "Haiti",
    iata: "PAX",
    icao: "MTPX",
    latitude: "19.9336",
    longitude: "-72.8486",
    altitude: "9",
    timezone: "-5",
    dst: "U",
    tz: "America/Port-au-Prince",
  },
  {
    id: "5850",
    name: "Jeremie Airport",
    city: "Jeremie",
    country: "Haiti",
    iata: "JEE",
    icao: "MTJE",
    latitude: "18.6631",
    longitude: "-74.1703",
    altitude: "147",
    timezone: "-5",
    dst: "U",
    tz: "America/Port-au-Prince",
  },
  {
    id: "5849",
    name: "Playa Samara Airport",
    city: "Playa Samara",
    country: "Costa Rica",
    iata: "PLD",
    icao: "MRSR",
    latitude: "10.25",
    longitude: "-85.417",
    altitude: "10",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5848",
    name: "Tobias Bolanos International Airport",
    city: "San Jose",
    country: "Costa Rica",
    iata: "SYQ",
    icao: "MRPV",
    latitude: "9.957053",
    longitude: "-84.139797",
    altitude: "3287",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5847",
    name: "Puerto Jimenez Airport",
    city: "Puerto Jimenez",
    country: "Costa Rica",
    iata: "PJM",
    icao: "MRPJ",
    latitude: "8.53333",
    longitude: "-83.3",
    altitude: "7",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5845",
    name: "Islita Airport",
    city: "Nandayure",
    country: "Costa Rica",
    iata: "PBP",
    icao: "MRIA",
    latitude: "9.85611",
    longitude: "-85.3708",
    altitude: "7",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5844",
    name: "Cabo Velas Airport",
    city: "Nicoya",
    country: "Costa Rica",
    iata: "TNO",
    icao: "MRCV",
    latitude: "10.3557",
    longitude: "-85.852892",
    altitude: "33",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5843",
    name: "Barra del Colorado Airport",
    city: "Pococi",
    country: "Costa Rica",
    iata: "BCL",
    icao: "MRBC",
    latitude: "10.768736",
    longitude: "-83.585614",
    altitude: "3",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5842",
    name: "Aerotortuguero Airport",
    city: "Roxana",
    country: "Costa Rica",
    iata: "TTQ",
    icao: "MRAO",
    latitude: "10.569",
    longitude: "-83.5148",
    altitude: "82",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "5841",
    name: "Captain Ramon Xatruch Airport",
    city: "La Palma",
    country: "Panama",
    iata: "PLP",
    icao: "MPLP",
    latitude: "8.40667",
    longitude: "-78.1417",
    altitude: "30",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5840",
    name: "Jaqué Airport",
    city: "Jaqué",
    country: "Panama",
    iata: "JQE",
    icao: "MPJE",
    latitude: "7.51778",
    longitude: "-78.1572",
    altitude: "29",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5839",
    name: "Enrique Adolfo Jimenez Airport",
    city: "Colón",
    country: "Panama",
    iata: "ONX",
    icao: "MPEJ",
    latitude: "9.35664",
    longitude: "-79.8674",
    altitude: "25",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5838",
    name: "Alonso Valderrama Airport",
    city: "Chitré",
    country: "Panama",
    iata: "CTD",
    icao: "MPCE",
    latitude: "7.98784",
    longitude: "-80.4097",
    altitude: "33",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "5837",
    name: "Lencero Airport",
    city: "Jalapa",
    country: "Mexico",
    iata: "JAL",
    icao: "MMJA",
    latitude: "19.475083",
    longitude: "-96.797506",
    altitude: "3127",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "5836",
    name: "Guerrero Negro Airport",
    city: "Guerrero Negro",
    country: "Mexico",
    iata: "GUB",
    icao: "MMGR",
    latitude: "28.0261",
    longitude: "-114.024",
    altitude: "59",
    timezone: "-8",
    dst: "S",
    tz: "America/Tijuana",
  },
  {
    id: "5835",
    name: "Ciudad Constitución Airport",
    city: "Ciudad Constitución",
    country: "Mexico",
    iata: "CUA",
    icao: "MMDA",
    latitude: "25.0538",
    longitude: "-111.615",
    altitude: "213",
    timezone: "-7",
    dst: "S",
    tz: "America/Mazatlan",
  },
  {
    id: "5834",
    name: "Captain Rogelio Castillo National Airport",
    city: "Celaya",
    country: "Mexico",
    iata: "CYW",
    icao: "MMCY",
    latitude: "20.545994",
    longitude: "-100.88655",
    altitude: "5709",
    timezone: "-6",
    dst: "S",
    tz: "America/Mexico_City",
  },
  {
    id: "5833",
    name: "Mili Island Airport",
    city: "Mili Island",
    country: "Marshall Islands",
    iata: "MIJ",
    icao: "MLIP",
    latitude: "6.08333",
    longitude: "171.733",
    altitude: "4",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5832",
    name: "Puerto Lempira Airport",
    city: "Puerto Lempira",
    country: "Honduras",
    iata: "PEU",
    icao: "MHPL",
    latitude: "15.2622",
    longitude: "-83.7812",
    altitude: "25",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "5831",
    name: "Ahuas Airport",
    city: "Ahuas",
    country: "Honduras",
    iata: "AHS",
    icao: "MHAH",
    latitude: "15.4722",
    longitude: "-84.3522",
    altitude: "98",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "5830",
    name: "Wotho Island Airport",
    city: "Wotho Island",
    country: "Marshall Islands",
    iata: "WTO",
    icao: "",
    latitude: "10.1733",
    longitude: "166.003",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5829",
    name: "Wotje Atoll Airport",
    city: "Wotje Atoll",
    country: "Marshall Islands",
    iata: "WTE",
    icao: "N36",
    latitude: "9.46667",
    longitude: "170.233",
    altitude: "4",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5828",
    name: "Woja Airport",
    city: "Majuro Atoll",
    country: "Marshall Islands",
    iata: "WJA",
    icao: "",
    latitude: "7.083",
    longitude: "171.133",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5827",
    name: "Jaluit Airport",
    city: "Jabor Jaluit Atoll",
    country: "Marshall Islands",
    iata: "UIT",
    icao: "N55",
    latitude: "5.90924",
    longitude: "169.637",
    altitude: "4",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5826",
    name: "Rongelap Island Airport",
    city: "Rongelap Island",
    country: "Marshall Islands",
    iata: "RNP",
    icao: "",
    latitude: "11.1572",
    longitude: "166.887",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5825",
    name: "Namorik Atoll Airport",
    city: "Namorik Atoll",
    country: "Marshall Islands",
    iata: "NDK",
    icao: "3N0",
    latitude: "5.63167",
    longitude: "168.125",
    altitude: "15",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5824",
    name: "Majkin Airport",
    city: "Majkin",
    country: "Marshall Islands",
    iata: "MJE",
    icao: "",
    latitude: "7.833",
    longitude: "168.167",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5823",
    name: "Mejit Atoll Airport",
    city: "Mejit Atoll",
    country: "Marshall Islands",
    iata: "MJB",
    icao: "Q30",
    latitude: "10.2833",
    longitude: "170.883",
    altitude: "5",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5822",
    name: "Maloelap Island Airport",
    city: "Maloelap Island",
    country: "Marshall Islands",
    iata: "MAV",
    icao: "",
    latitude: "8.70444",
    longitude: "171.23",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5821",
    name: "Likiep Airport",
    city: "Likiep Island",
    country: "Marshall Islands",
    iata: "LIK",
    icao: "",
    latitude: "9.82316",
    longitude: "169.308",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5820",
    name: "Kaben Airport",
    city: "Kaben",
    country: "Marshall Islands",
    iata: "KBT",
    icao: "",
    latitude: "8.90056",
    longitude: "170.844",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5819",
    name: "Jeh Airport",
    city: "Ailinglapalap Atoll",
    country: "Marshall Islands",
    iata: "JEJ",
    icao: "",
    latitude: "7.56535",
    longitude: "168.962",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5818",
    name: "Jabot Airport",
    city: "Ailinglapalap Atoll",
    country: "Marshall Islands",
    iata: "JAT",
    icao: "",
    latitude: "7.45235",
    longitude: "168.552",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5817",
    name: "Enyu Airfield",
    city: "Bikini Atoll",
    country: "Marshall Islands",
    iata: "BII",
    icao: "",
    latitude: "11.5225",
    longitude: "165.565",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5816",
    name: "Aur Island Airport",
    city: "Aur Atoll",
    country: "Marshall Islands",
    iata: "AUL",
    icao: "",
    latitude: "8.14528",
    longitude: "171.173",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5815",
    name: "Ailuk Airport",
    city: "Ailuk Island",
    country: "Marshall Islands",
    iata: "AIM",
    icao: "",
    latitude: "10.2168",
    longitude: "169.983",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5814",
    name: "Utirik Airport",
    city: "Utirik Island",
    country: "Marshall Islands",
    iata: "UTK",
    icao: "03N",
    latitude: "11.222",
    longitude: "169.852",
    altitude: "4",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5813",
    name: "Quezaltenango Airport",
    city: "Quezaltenango",
    country: "Guatemala",
    iata: "AAZ",
    icao: "MGQZ",
    latitude: "14.8656",
    longitude: "-91.502",
    altitude: "7779",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "5812",
    name: "Puerto Barrios Airport",
    city: "Puerto Barrios",
    country: "Guatemala",
    iata: "PBR",
    icao: "MGPB",
    latitude: "15.730878",
    longitude: "-88.583767",
    altitude: "33",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "5811",
    name: "Dr Joaquin Balaguer International Airport",
    city: "La Isabela",
    country: "Dominican Republic",
    iata: "JBQ",
    icao: "MDJB",
    latitude: "18.5725",
    longitude: "-69.9856",
    altitude: "98",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "5810",
    name: "Samaná El Catey International Airport",
    city: "Samana",
    country: "Dominican Republic",
    iata: "AZS",
    icao: "MDCY",
    latitude: "19.267",
    longitude: "-69.742",
    altitude: "30",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "5809",
    name: "Salt Cay Airport",
    city: "Salt Cay",
    country: "Turks and Caicos Islands",
    iata: "SLX",
    icao: "MBSY",
    latitude: "21.333",
    longitude: "-71.2",
    altitude: "3",
    timezone: "-5",
    dst: "U",
    tz: "America/Grand_Turk",
  },
  {
    id: "5808",
    name: "Middle Caicos Airport",
    city: "Middle Caicos",
    country: "Turks and Caicos Islands",
    iata: "MDS",
    icao: "MBMC",
    latitude: "21.833",
    longitude: "-71.817",
    altitude: "9",
    timezone: "-5",
    dst: "U",
    tz: "America/Grand_Turk",
  },
  {
    id: "5807",
    name: "JAGS McCartney International Airport",
    city: "Cockburn Town",
    country: "Turks and Caicos Islands",
    iata: "GDT",
    icao: "MBGT",
    latitude: "21.4445",
    longitude: "-71.1423",
    altitude: "13",
    timezone: "-5",
    dst: "U",
    tz: "America/Grand_Turk",
  },
  {
    id: "5806",
    name: "Žilina Airport",
    city: "Žilina",
    country: "Slovakia",
    iata: "ILZ",
    icao: "LZZI",
    latitude: "49.231528",
    longitude: "18.6135",
    altitude: "1020",
    timezone: "1",
    dst: "E",
    tz: "Europe/Bratislava",
  },
  {
    id: "5805",
    name: "Ubari Airport",
    city: "Ubari",
    country: "Libya",
    iata: "QUB",
    icao: "",
    latitude: "26.5675",
    longitude: "12.8231",
    altitude: "1387",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "5804",
    name: "Misratah Airport",
    city: "Misratah",
    country: "Libya",
    iata: "MRA",
    icao: "",
    latitude: "32.325",
    longitude: "15.061",
    altitude: "60",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "5803",
    name: "Samsun-Çarşamba Airport",
    city: "Samsun",
    country: "Turkey",
    iata: "SZF",
    icao: "LTFH",
    latitude: "41.2545",
    longitude: "36.5671",
    altitude: "18",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5802",
    name: "Balikesir Korfez Airport",
    city: "Balikesir Korfez",
    country: "Turkey",
    iata: "EDO",
    icao: "LTFD",
    latitude: "39.5546",
    longitude: "27.0138",
    altitude: "50",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5801",
    name: "Isparta Süleyman Demirel Airport",
    city: "Isparta",
    country: "Turkey",
    iata: "ISE",
    icao: "LTFC",
    latitude: "37.8554",
    longitude: "30.3684",
    altitude: "2835",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5800",
    name: "Adiyaman Airport",
    city: "Adiyaman",
    country: "Turkey",
    iata: "ADF",
    icao: "LTCP",
    latitude: "37.7314",
    longitude: "38.4689",
    altitude: "2216",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5799",
    name: "Agri Airport",
    city: "Agri",
    country: "Turkey",
    iata: "AJI",
    icao: "LTCO",
    latitude: "39.6546",
    longitude: "43.0271",
    altitude: "5462",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5798",
    name: "Kahramanmaras Airport",
    city: "Kahramanmaras",
    country: "Turkey",
    iata: "KCM",
    icao: "LTCN",
    latitude: "37.539",
    longitude: "36.9534",
    altitude: "1723",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5797",
    name: "Sanliurfa Airport",
    city: "Sanliurfa",
    country: "Turkey",
    iata: "SFQ",
    icao: "LTCH",
    latitude: "37.094261",
    longitude: "38.847103",
    altitude: "1483",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5796",
    name: "Kars Airport",
    city: "Kars",
    country: "Turkey",
    iata: "KSY",
    icao: "LTCF",
    latitude: "40.562222",
    longitude: "43.115002",
    altitude: "5889",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5795",
    name: "Usak Airport",
    city: "Usak",
    country: "Turkey",
    iata: "USQ",
    icao: "LTBO",
    latitude: "38.681478",
    longitude: "29.471675",
    altitude: "2897",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "5794",
    name: "Banja Luka International Airport",
    city: "Banja Luka",
    country: "Bosnia and Herzegovina",
    iata: "BNX",
    icao: "LQBK",
    latitude: "44.941444",
    longitude: "17.297501",
    altitude: "400",
    timezone: "1",
    dst: "E",
    tz: "Europe/Sarajevo",
  },
  {
    id: "5793",
    name: "Corvo Airport",
    city: "Corvo",
    country: "Portugal",
    iata: "CVU",
    icao: "LPCR",
    latitude: "39.6715",
    longitude: "-31.1136",
    altitude: "0",
    timezone: "-1",
    dst: "E",
    tz: "Atlantic/Azores",
  },
  {
    id: "5792",
    name: "Salerno Pontecagnano Airport",
    city: "Salerno",
    country: "Italy",
    iata: "QSR",
    icao: "LIRI",
    latitude: "40.6204",
    longitude: "14.911294",
    altitude: "123",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "5791",
    name: "Aosta Airport",
    city: "Aosta",
    country: "Italy",
    iata: "AOT",
    icao: "LIMW",
    latitude: "45.738456",
    longitude: "7.368719",
    altitude: "1791",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "5790",
    name: "Sármellék International Airport",
    city: "Sármellék",
    country: "Hungary",
    iata: "SOB",
    icao: "LHSM",
    latitude: "46.686389",
    longitude: "17.159056",
    altitude: "408",
    timezone: "1",
    dst: "N",
    tz: "Europe/Budapest",
  },
  {
    id: "5789",
    name: "Győr-Pér International Airport",
    city: "Győr",
    country: "Hungary",
    iata: "QGY",
    icao: "LHPR",
    latitude: "47.627097",
    longitude: "17.808347",
    altitude: "424",
    timezone: "1",
    dst: "N",
    tz: "Europe/Budapest",
  },
  {
    id: "5788",
    name: "Pécs-Pogány Airport",
    city: "Pécs-Pogány",
    country: "Hungary",
    iata: "PEV",
    icao: "LHPP",
    latitude: "45.990928",
    longitude: "18.240983",
    altitude: "1000",
    timezone: "1",
    dst: "N",
    tz: "Europe/Budapest",
  },
  {
    id: "5787",
    name: "Syros Airport",
    city: "Syros Island",
    country: "Greece",
    iata: "JSY",
    icao: "LGSO",
    latitude: "37.422792",
    longitude: "24.950936",
    altitude: "236",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "5786",
    name: "La Môle Airport",
    city: "La Môle",
    country: "France",
    iata: "LTT",
    icao: "LFTZ",
    latitude: "43.2054",
    longitude: "6.482",
    altitude: "59",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "6810",
    name: "EuroAirport",
    city: "Mulhouse",
    country: "France",
    iata: "EAP",
    icao: "\\N",
    latitude: "47.589583",
    longitude: "7.529914",
    altitude: "885",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "6511",
    name: "Tekapo",
    city: "Lake Tekapo",
    country: "New Zealand",
    iata: "",
    icao: "NZTL",
    latitude: "-44",
    longitude: "170.28",
    altitude: "2",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "5783",
    name: "Angers-Loire Airport",
    city: "Angers/Marcé",
    country: "France",
    iata: "ANE",
    icao: "LFJR",
    latitude: "47.5603",
    longitude: "-0.312222",
    altitude: "194",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "5782",
    name: "Île d'Yeu Airport",
    city: "Île d'Yeu",
    country: "France",
    iata: "IDY",
    icao: "LFEY",
    latitude: "46.718611",
    longitude: "-2.391111",
    altitude: "79",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "5781",
    name: "Logroño-Agoncillo Airport",
    city: "Logroño-Agoncillo",
    country: "Spain",
    iata: "RJL",
    icao: "LELO",
    latitude: "42.4542",
    longitude: "-2.32083",
    altitude: "1161",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "5780",
    name: "Ercan International Airport",
    city: "Nicosia",
    country: "Cyprus",
    iata: "ECN",
    icao: "LCEN",
    latitude: "35.1547",
    longitude: "33.4961",
    altitude: "404",
    timezone: "2",
    dst: "E",
    tz: "Asia/Nicosia",
  },
  {
    id: "5779",
    name: "Yakima Air Terminal McAllister Field",
    city: "Yakima",
    country: "United States",
    iata: "YKM",
    icao: "KYKM",
    latitude: "46.5682",
    longitude: "-120.544",
    altitude: "1095",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5778",
    name: "Kiwayu (Mkononi) Airport",
    city: "Kiwayu",
    country: "Kenya",
    iata: "KWY",
    icao: "",
    latitude: "-1.96056",
    longitude: "41.2975",
    altitude: "21",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "5777",
    name: "Worland Municipal Airport",
    city: "Worland",
    country: "United States",
    iata: "WRL",
    icao: "KWRL",
    latitude: "43.9657",
    longitude: "-107.951",
    altitude: "4227",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5776",
    name: "Valdosta Regional Airport",
    city: "Valdosta",
    country: "United States",
    iata: "VLD",
    icao: "KVLD",
    latitude: "30.7825",
    longitude: "-83.2767",
    altitude: "203",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5775",
    name: "Victoria Regional Airport",
    city: "Victoria",
    country: "United States",
    iata: "VCT",
    icao: "KVCT",
    latitude: "28.8526",
    longitude: "-96.9185",
    altitude: "115",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5774",
    name: "Quincy Regional Baldwin Field",
    city: "Quincy",
    country: "United States",
    iata: "UIN",
    icao: "KUIN",
    latitude: "39.9427",
    longitude: "-91.1946",
    altitude: "769",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5773",
    name: "Tupelo Regional Airport",
    city: "Tupelo",
    country: "United States",
    iata: "TUP",
    icao: "KTUP",
    latitude: "34.2681",
    longitude: "-88.7699",
    altitude: "346",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5772",
    name: "Santa Maria Pub Cpt G Allan Hancock Airport",
    city: "Santa Maria",
    country: "United States",
    iata: "SMX",
    icao: "KSMX",
    latitude: "34.8989",
    longitude: "-120.457",
    altitude: "261",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5771",
    name: "Salina Municipal Airport",
    city: "Salina",
    country: "United States",
    iata: "SLN",
    icao: "KSLN",
    latitude: "38.791",
    longitude: "-97.6522",
    altitude: "1288",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5770",
    name: "Adirondack Regional Airport",
    city: "Saranac Lake",
    country: "United States",
    iata: "SLK",
    icao: "KSLK",
    latitude: "44.3853",
    longitude: "-74.2062",
    altitude: "1663",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5769",
    name: "Sheridan County Airport",
    city: "Sheridan",
    country: "United States",
    iata: "SHR",
    icao: "KSHR",
    latitude: "44.7692",
    longitude: "-106.98",
    altitude: "4021",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5768",
    name: "San Luis County Regional Airport",
    city: "San Luis Obispo",
    country: "United States",
    iata: "SBP",
    icao: "KSBP",
    latitude: "35.2368",
    longitude: "-120.642",
    altitude: "212",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5767",
    name: "Rutland State Airport",
    city: "Rutland",
    country: "United States",
    iata: "RUT",
    icao: "KRUT",
    latitude: "43.5294",
    longitude: "-72.9496",
    altitude: "787",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5766",
    name: "Rock Springs Sweetwater County Airport",
    city: "Rock Springs",
    country: "United States",
    iata: "RKS",
    icao: "KRKS",
    latitude: "41.5942",
    longitude: "-109.065",
    altitude: "6760",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5765",
    name: "Rhinelander Oneida County Airport",
    city: "Rhinelander",
    country: "United States",
    iata: "RHI",
    icao: "KRHI",
    latitude: "45.6312",
    longitude: "-89.4675",
    altitude: "1624",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5764",
    name: "Reading Regional Carl A Spaatz Field",
    city: "Reading",
    country: "United States",
    iata: "RDG",
    icao: "KRDG",
    latitude: "40.3785",
    longitude: "-75.9652",
    altitude: "344",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5763",
    name: "Pease International Tradeport",
    city: "Portsmouth",
    country: "United States",
    iata: "PSM",
    icao: "KPSM",
    latitude: "43.0779",
    longitude: "-70.8233",
    altitude: "100",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5762",
    name: "Pellston Regional Airport of Emmet County Airport",
    city: "Pellston",
    country: "United States",
    iata: "PLN",
    icao: "KPLN",
    latitude: "45.5709",
    longitude: "-84.7967",
    altitude: "720",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5761",
    name: "Pierre Regional Airport",
    city: "Pierre",
    country: "United States",
    iata: "PIR",
    icao: "KPIR",
    latitude: "44.3827",
    longitude: "-100.286",
    altitude: "1742",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5760",
    name: "Pocatello Regional Airport",
    city: "Pocatello",
    country: "United States",
    iata: "PIH",
    icao: "KPIH",
    latitude: "42.9098",
    longitude: "-112.596",
    altitude: "4452",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5759",
    name: "Hattiesburg Laurel Regional Airport",
    city: "Hattiesburg/Laurel",
    country: "United States",
    iata: "PIB",
    icao: "KPIB",
    latitude: "31.4671",
    longitude: "-89.3371",
    altitude: "298",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5758",
    name: "Owensboro Daviess County Airport",
    city: "Owensboro",
    country: "United States",
    iata: "OWB",
    icao: "KOWB",
    latitude: "37.7401",
    longitude: "-87.1668",
    altitude: "406",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5757",
    name: "Southwest Oregon Regional Airport",
    city: "North Bend",
    country: "United States",
    iata: "OTH",
    icao: "KOTH",
    latitude: "43.4171",
    longitude: "-124.246",
    altitude: "17",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5756",
    name: "Northwest Alabama Regional Airport",
    city: "Muscle Shoals",
    country: "United States",
    iata: "MSL",
    icao: "KMSL",
    latitude: "34.7453",
    longitude: "-87.6102",
    altitude: "550",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5755",
    name: "Frank Wiley Field",
    city: "Miles City",
    country: "United States",
    iata: "MLS",
    icao: "KMLS",
    latitude: "46.428",
    longitude: "-105.886",
    altitude: "2630",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5754",
    name: "Muskegon County Airport",
    city: "Muskegon",
    country: "United States",
    iata: "MKG",
    icao: "KMKG",
    latitude: "43.1695",
    longitude: "-86.2382",
    altitude: "628",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5753",
    name: "Lynchburg Regional Preston Glenn Field",
    city: "Lynchburg",
    country: "United States",
    iata: "LYH",
    icao: "KLYH",
    latitude: "37.3267",
    longitude: "-79.2004",
    altitude: "938",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5752",
    name: "Lewistown Municipal Airport",
    city: "Lewistown",
    country: "United States",
    iata: "LWT",
    icao: "KLWT",
    latitude: "47.0493",
    longitude: "-109.467",
    altitude: "4170",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5751",
    name: "Lancaster Airport",
    city: "Lancaster",
    country: "United States",
    iata: "LNS",
    icao: "KLNS",
    latitude: "40.1217",
    longitude: "-76.2961",
    altitude: "403",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5750",
    name: "Klamath Falls Airport",
    city: "Klamath Falls",
    country: "United States",
    iata: "LMT",
    icao: "KLMT",
    latitude: "42.1561",
    longitude: "-121.733",
    altitude: "4095",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5749",
    name: "Lebanon Municipal Airport",
    city: "Lebanon",
    country: "United States",
    iata: "LEB",
    icao: "KLEB",
    latitude: "43.6261",
    longitude: "-72.3042",
    altitude: "603",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5748",
    name: "North Platte Regional Airport Lee Bird Field",
    city: "North Platte",
    country: "United States",
    iata: "LBF",
    icao: "KLBF",
    latitude: "41.1262",
    longitude: "-100.684",
    altitude: "2776",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5747",
    name: "Arnold Palmer Regional Airport",
    city: "Latrobe",
    country: "United States",
    iata: "LBE",
    icao: "KLBE",
    latitude: "40.2759",
    longitude: "-79.4048",
    altitude: "1185",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5746",
    name: "Laramie Regional Airport",
    city: "Laramie",
    country: "United States",
    iata: "LAR",
    icao: "KLAR",
    latitude: "41.3121",
    longitude: "-105.675",
    altitude: "7284",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5745",
    name: "Jamestown Regional Airport",
    city: "Jamestown",
    country: "United States",
    iata: "JMS",
    icao: "KJMS",
    latitude: "46.9297",
    longitude: "-98.6782",
    altitude: "1498",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5744",
    name: "Kirksville Regional Airport",
    city: "Kirksville",
    country: "United States",
    iata: "IRK",
    icao: "KIRK",
    latitude: "40.0935",
    longitude: "-92.5449",
    altitude: "966",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5743",
    name: "Kili Airport",
    city: "Kili Island",
    country: "Marshall Islands",
    iata: "KIO",
    icao: "Q51",
    latitude: "5.64452",
    longitude: "169.12",
    altitude: "5",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "5742",
    name: "Tri State Milton J Ferguson Field",
    city: "Huntington",
    country: "United States",
    iata: "HTS",
    icao: "KHTS",
    latitude: "38.3667",
    longitude: "-82.558",
    altitude: "828",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5741",
    name: "Memorial Field",
    city: "Hot Springs",
    country: "United States",
    iata: "HOT",
    icao: "KHOT",
    latitude: "34.478",
    longitude: "-93.0962",
    altitude: "540",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5740",
    name: "Central Nebraska Regional Airport",
    city: "Grand Island",
    country: "United States",
    iata: "GRI",
    icao: "KGRI",
    latitude: "40.9675",
    longitude: "-98.3096",
    altitude: "1847",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5739",
    name: "Wokal Field Glasgow International Airport",
    city: "Glasgow",
    country: "United States",
    iata: "GGW",
    icao: "KGGW",
    latitude: "48.2125",
    longitude: "-106.615",
    altitude: "2296",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5738",
    name: "Fayetteville Regional Grannis Field",
    city: "Fayetteville",
    country: "United States",
    iata: "FAY",
    icao: "KFAY",
    latitude: "34.9912",
    longitude: "-78.8803",
    altitude: "189",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5737",
    name: "New Bedford Regional Airport",
    city: "New Bedford",
    country: "United States",
    iata: "EWB",
    icao: "KEWB",
    latitude: "41.6761",
    longitude: "-70.9569",
    altitude: "80",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5736",
    name: "Elko Regional Airport",
    city: "Elko",
    country: "United States",
    iata: "EKO",
    icao: "KEKO",
    latitude: "40.8249",
    longitude: "-115.792",
    altitude: "5140",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5735",
    name: "Chippewa Valley Regional Airport",
    city: "Eau Claire",
    country: "United States",
    iata: "EAU",
    icao: "KEAU",
    latitude: "44.8658",
    longitude: "-91.4843",
    altitude: "913",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5734",
    name: "DuBois Regional Airport",
    city: "Du Bois",
    country: "United States",
    iata: "DUJ",
    icao: "KDUJ",
    latitude: "41.1783",
    longitude: "-78.8987",
    altitude: "1817",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5733",
    name: "Dodge City Regional Airport",
    city: "Dodge City",
    country: "United States",
    iata: "DDC",
    icao: "KDDC",
    latitude: "37.7634",
    longitude: "-99.9656",
    altitude: "2594",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5732",
    name: "Houghton County Memorial Airport",
    city: "Hancock",
    country: "United States",
    iata: "CMX",
    icao: "KCMX",
    latitude: "47.1684",
    longitude: "-88.4891",
    altitude: "1095",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5731",
    name: "William R Fairchild International Airport",
    city: "Port Angeles",
    country: "United States",
    iata: "CLM",
    icao: "KCLM",
    latitude: "48.1202",
    longitude: "-123.5",
    altitude: "291",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5730",
    name: "Harrison Marion Regional Airport",
    city: "Clarksburg",
    country: "United States",
    iata: "CKB",
    icao: "KCKB",
    latitude: "39.2966",
    longitude: "-80.2281",
    altitude: "1217",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5729",
    name: "Chippewa County International Airport",
    city: "Sault Ste Marie",
    country: "United States",
    iata: "CIU",
    icao: "KCIU",
    latitude: "46.2508",
    longitude: "-84.4724",
    altitude: "800",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5728",
    name: "Cape Girardeau Regional Airport",
    city: "Cape Girardeau",
    country: "United States",
    iata: "CGI",
    icao: "KCGI",
    latitude: "37.2253",
    longitude: "-89.5708",
    altitude: "342",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5727",
    name: "Del Norte County Airport",
    city: "Crescent City",
    country: "United States",
    iata: "CEC",
    icao: "KCEC",
    latitude: "41.7802",
    longitude: "-124.237",
    altitude: "57",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5726",
    name: "Southeast Iowa Regional Airport",
    city: "Burlington",
    country: "United States",
    iata: "BRL",
    icao: "KBRL",
    latitude: "40.7832",
    longitude: "-91.1255",
    altitude: "698",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5725",
    name: "Brunswick Golden Isles Airport",
    city: "Brunswick",
    country: "United States",
    iata: "BQK",
    icao: "KBQK",
    latitude: "31.2588",
    longitude: "-81.4665",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5724",
    name: "Raleigh County Memorial Airport",
    city: "Beckley",
    country: "United States",
    iata: "BKW",
    icao: "KBKW",
    latitude: "37.7873",
    longitude: "-81.1242",
    altitude: "2504",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5723",
    name: "Western Nebraska Regional Airport",
    city: "Scottsbluff",
    country: "United States",
    iata: "BFF",
    icao: "KBFF",
    latitude: "41.874",
    longitude: "-103.596",
    altitude: "3967",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5722",
    name: "Bradford Regional Airport",
    city: "Bradford",
    country: "United States",
    iata: "BFD",
    icao: "KBFD",
    latitude: "41.8031",
    longitude: "-78.6401",
    altitude: "2143",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5721",
    name: "Watertown Regional Airport",
    city: "Watertown",
    country: "United States",
    iata: "ATY",
    icao: "KATY",
    latitude: "44.914",
    longitude: "-97.1547",
    altitude: "1748",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5720",
    name: "Alpena County Regional Airport",
    city: "Alpena",
    country: "United States",
    iata: "APN",
    icao: "KAPN",
    latitude: "45.0781",
    longitude: "-83.5603",
    altitude: "689",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5719",
    name: "Walla Walla Regional Airport",
    city: "Walla Walla",
    country: "United States",
    iata: "ALW",
    icao: "KALW",
    latitude: "46.0949",
    longitude: "-118.288",
    altitude: "1191",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "5718",
    name: "Waterloo Regional Airport",
    city: "Waterloo",
    country: "United States",
    iata: "ALO",
    icao: "KALO",
    latitude: "42.5571",
    longitude: "-92.4003",
    altitude: "873",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5717",
    name: "Alamogordo White Sands Regional Airport",
    city: "Alamogordo",
    country: "United States",
    iata: "ALM",
    icao: "KALM",
    latitude: "32.8399",
    longitude: "-105.991",
    altitude: "4200",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "5716",
    name: "Athens Ben Epps Airport",
    city: "Athens",
    country: "United States",
    iata: "AHN",
    icao: "KAHN",
    latitude: "33.9486",
    longitude: "-83.3263",
    altitude: "808",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5715",
    name: "Southwest Georgia Regional Airport",
    city: "Albany",
    country: "United States",
    iata: "ABY",
    icao: "KABY",
    latitude: "31.5355",
    longitude: "-84.1945",
    altitude: "197",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "5714",
    name: "Aberdeen Regional Airport",
    city: "Aberdeen",
    country: "United States",
    iata: "ABR",
    icao: "KABR",
    latitude: "45.4491",
    longitude: "-98.4218",
    altitude: "1302",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "5713",
    name: "San Domino Island Heliport",
    city: "Tremiti Islands",
    country: "Italy",
    iata: "TQR",
    icao: "",
    latitude: "42.1025",
    longitude: "15.488",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "5712",
    name: "Gheshm Airport",
    city: "Gheshm",
    country: "Iran",
    iata: "GSM",
    icao: "",
    latitude: "26.9487",
    longitude: "56.2688",
    altitude: "100",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "5711",
    name: "Diu Airport",
    city: "Diu",
    country: "India",
    iata: "DIU",
    icao: "VA1P",
    latitude: "20.7131",
    longitude: "70.9211",
    altitude: "31",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "5710",
    name: "Gulu Airport",
    city: "Gulu",
    country: "Uganda",
    iata: "ULU",
    icao: "HUGU",
    latitude: "2.805556",
    longitude: "32.271792",
    altitude: "3510",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "5709",
    name: "Arua Airport",
    city: "Arua",
    country: "Uganda",
    iata: "RUA",
    icao: "HUAR",
    latitude: "3.05",
    longitude: "30.917",
    altitude: "3951",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "5708",
    name: "Tabora Airport",
    city: "Tabora",
    country: "Tanzania",
    iata: "TBO",
    icao: "HTTB",
    latitude: "-5.07639",
    longitude: "32.8333",
    altitude: "3868",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "5707",
    name: "Shinyanga Airport",
    city: "Shinyanga",
    country: "Tanzania",
    iata: "SHY",
    icao: "HTSY",
    latitude: "-3.667",
    longitude: "33.417",
    altitude: "3800",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "5706",
    name: "Musoma Airport",
    city: "Musoma",
    country: "Tanzania",
    iata: "MUZ",
    icao: "HTMU",
    latitude: "-1.483",
    longitude: "33.8",
    altitude: "3806",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "5705",
    name: "Kikwetu Airport",
    city: "Lindi",
    country: "Tanzania",
    iata: "LDI",
    icao: "HTLI",
    latitude: "-9.85111",
    longitude: "39.7578",
    altitude: "100",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "5704",
    name: "Kigoma Airport",
    city: "Kigoma",
    country: "Tanzania",
    iata: "TKQ",
    icao: "HTKA",
    latitude: "-4.883",
    longitude: "29.633",
    altitude: "2700",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "5703",
    name: "Bukoba Airport",
    city: "Bukoba",
    country: "Tanzania",
    iata: "BKZ",
    icao: "HTBU",
    latitude: "-1.3",
    longitude: "31.8",
    altitude: "3745",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "5702",
    name: "Port Sudan New International Airport",
    city: "Port Sudan",
    country: "Sudan",
    iata: "PZU",
    icao: "HSPN",
    latitude: "19.4336",
    longitude: "37.2341",
    altitude: "135",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "5701",
    name: "Nyala Airport",
    city: "Nyala",
    country: "Sudan",
    iata: "UYL",
    icao: "HSNN",
    latitude: "12.0535",
    longitude: "24.9562",
    altitude: "2106",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "5700",
    name: "Atbara Airport",
    city: "Atbara",
    country: "Sudan",
    iata: "ATB",
    icao: "HSAT",
    latitude: "17.7",
    longitude: "33.967",
    altitude: "1181",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "5699",
    name: "La Abraq Airport",
    city: "Al Bayda'",
    country: "Libya",
    iata: "LAQ",
    icao: "HLLQ",
    latitude: "32.788673",
    longitude: "21.964333",
    altitude: "2157",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "5698",
    name: "Mitiga Airport",
    city: "Tripoli",
    country: "Libya",
    iata: "MJI",
    icao: "HLLM",
    latitude: "32.8941",
    longitude: "13.276",
    altitude: "36",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "5697",
    name: "Gamal Abdel Nasser Airport",
    city: "Tobruk",
    country: "Libya",
    iata: "TOB",
    icao: "HLGN",
    latitude: "31.861",
    longitude: "23.907",
    altitude: "519",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "5696",
    name: "Gardabya Airport",
    city: "Sirt",
    country: "Libya",
    iata: "SRX",
    icao: "HLGD",
    latitude: "31.0635",
    longitude: "16.595",
    altitude: "267",
    timezone: "2",
    dst: "N",
    tz: "Africa/Tripoli",
  },
  {
    id: "5695",
    name: "Nanyuki Civil Airport",
    city: "Nanyuki",
    country: "Kenya",
    iata: "NYK",
    icao: "HKNY",
    latitude: "-0.067",
    longitude: "37.033",
    altitude: "6250",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "5694",
    name: "Malindi Airport",
    city: "Malindi",
    country: "Kenya",
    iata: "MYD",
    icao: "HKML",
    latitude: "-3.22931",
    longitude: "40.1017",
    altitude: "80",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "5693",
    name: "Lokichoggio Airport",
    city: "Lokichoggio",
    country: "Kenya",
    iata: "LKG",
    icao: "HKLK",
    latitude: "4.204117",
    longitude: "34.348186",
    altitude: "2074",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "5692",
    name: "Amboseli Airport",
    city: "Amboseli National Park",
    country: "Kenya",
    iata: "ASV",
    icao: "HKAM",
    latitude: "-2.64505",
    longitude: "37.2531",
    altitude: "3755",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "5691",
    name: "Asyut International Airport",
    city: "Asyut",
    country: "Egypt",
    iata: "ATZ",
    icao: "HEAT",
    latitude: "27.046508",
    longitude: "31.011983",
    altitude: "772",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "5690",
    name: "El Arish International Airport",
    city: "El Arish",
    country: "Egypt",
    iata: "AAC",
    icao: "HEAR",
    latitude: "31.073333",
    longitude: "33.835833",
    altitude: "121",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "5689",
    name: "Burao Airport",
    city: "Burao",
    country: "Somalia",
    iata: "BUO",
    icao: "HCMV",
    latitude: "9.517",
    longitude: "45.567",
    altitude: "3400",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "5688",
    name: "Galcaio Airport",
    city: "Galcaio",
    country: "Somalia",
    iata: "GLK",
    icao: "HCMR",
    latitude: "6.78083",
    longitude: "47.4547",
    altitude: "975",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "5687",
    name: "Aden Adde International Airport",
    city: "Mogadishu",
    country: "Somalia",
    iata: "MGQ",
    icao: "HCMM",
    latitude: "2.01444",
    longitude: "45.3047",
    altitude: "29",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "5686",
    name: "Bosaso Airport",
    city: "Bosaso",
    country: "Somalia",
    iata: "BSA",
    icao: "HCMF",
    latitude: "11.2753",
    longitude: "49.1494",
    altitude: "3",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "5685",
    name: "Alula Airport",
    city: "Alula",
    country: "Somalia",
    iata: "ALU",
    icao: "HCMA",
    latitude: "11.95",
    longitude: "50.733",
    altitude: "6",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "5684",
    name: "Tippi Airport",
    city: "Tippi",
    country: "Ethiopia",
    iata: "TIE",
    icao: "HATP",
    latitude: "7.117",
    longitude: "35.383",
    altitude: "1100",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5683",
    name: "Mizan Teferi Airport",
    city: "Mizan Teferi",
    country: "Ethiopia",
    iata: "MTF",
    icao: "HAMT",
    latitude: "6.967",
    longitude: "35.533",
    altitude: "4396",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5682",
    name: "Kabri Dehar Airport",
    city: "Kabri Dehar",
    country: "Ethiopia",
    iata: "ABK",
    icao: "HAKD",
    latitude: "6.734",
    longitude: "44.253",
    altitude: "1800",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5681",
    name: "Gore Airport",
    city: "Gore",
    country: "Ethiopia",
    iata: "GOR",
    icao: "HAGR",
    latitude: "8.167",
    longitude: "35.55",
    altitude: "6580",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5680",
    name: "Gode Airport",
    city: "Gode",
    country: "Ethiopia",
    iata: "GDE",
    icao: "HAGO",
    latitude: "5.935128",
    longitude: "43.578567",
    altitude: "834",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5679",
    name: "Dembidollo Airport",
    city: "Dembidollo",
    country: "Ethiopia",
    iata: "DEM",
    icao: "HADD",
    latitude: "8.554",
    longitude: "34.858",
    altitude: "5200",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5678",
    name: "Combolcha Airport",
    city: "Dessie",
    country: "Ethiopia",
    iata: "DSE",
    icao: "HADC",
    latitude: "11.0825",
    longitude: "39.7114",
    altitude: "6117",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5677",
    name: "Beica Airport",
    city: "Beica",
    country: "Ethiopia",
    iata: "BEI",
    icao: "HABE",
    latitude: "9.38639",
    longitude: "34.5219",
    altitude: "5410",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5676",
    name: "Baco Airport",
    city: "Baco",
    country: "Ethiopia",
    iata: "BCO",
    icao: "HABC",
    latitude: "5.78287",
    longitude: "36.562",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5675",
    name: "Sao Filipe Airport",
    city: "Sao Filipe, Fogo Island",
    country: "Cape Verde",
    iata: "SFL",
    icao: "GVSF",
    latitude: "14.885",
    longitude: "-24.48",
    altitude: "617",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "5674",
    name: "Praia International Airport",
    city: "Praia, Santiago Island",
    country: "Cape Verde",
    iata: "RAI",
    icao: "GVNP",
    latitude: "14.9245",
    longitude: "-23.4935",
    altitude: "230",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Cape_Verde",
  },
  {
    id: "5673",
    name: "El Aroui Airport",
    city: "El Aroui",
    country: "Morocco",
    iata: "NDR",
    icao: "GMMW",
    latitude: "34.9888",
    longitude: "-3.02821",
    altitude: "574",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "5672",
    name: "Hassan I Airport",
    city: "El Aaiún",
    country: "Western Sahara",
    iata: "EUN",
    icao: "GMML",
    latitude: "27.1517",
    longitude: "-13.2192",
    altitude: "207",
    timezone: "0",
    dst: "N",
    tz: "Africa/El_Aaiun",
  },
  {
    id: "5671",
    name: "Mogador Airport",
    city: "Essadouira",
    country: "Morocco",
    iata: "ESU",
    icao: "GMMI",
    latitude: "31.3975",
    longitude: "-9.681667",
    altitude: "384",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "5670",
    name: "Dakhla Airport",
    city: "Dakhla",
    country: "Western Sahara",
    iata: "VIL",
    icao: "GMMH",
    latitude: "23.7183",
    longitude: "-15.932",
    altitude: "36",
    timezone: "0",
    dst: "N",
    tz: "Africa/El_Aaiun",
  },
  {
    id: "5669",
    name: "Smara Airport",
    city: "Smara",
    country: "Western Sahara",
    iata: "SMW",
    icao: "GMMA",
    latitude: "26.7318",
    longitude: "-11.6847",
    altitude: "350",
    timezone: "0",
    dst: "N",
    tz: "Africa/El_Aaiun",
  },
  {
    id: "5668",
    name: "Iginniarfik Heliport",
    city: "Iginniarfik",
    country: "Greenland",
    iata: "QFI",
    icao: "",
    latitude: "68.7",
    longitude: "-52.9667",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5667",
    name: "Akunnaaq Heliport",
    city: "Akunnaaq",
    country: "Greenland",
    iata: "QCU",
    icao: "",
    latitude: "68.75",
    longitude: "-52.3333",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5666",
    name: "Groennedal Heliport",
    city: "Groennedal",
    country: "Greenland",
    iata: "JGR",
    icao: "",
    latitude: "61.2333",
    longitude: "-48.1",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5665",
    name: "Osvaldo Vieira International Airport",
    city: "Bissau",
    country: "Guinea-Bissau",
    iata: "OXB",
    icao: "GGOV",
    latitude: "11.89485",
    longitude: "-15.653681",
    altitude: "129",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bissau",
  },
  {
    id: "5664",
    name: "Kenema Airport",
    city: "Kenema",
    country: "Sierra Leone",
    iata: "KEN",
    icao: "GFKE",
    latitude: "7.89129",
    longitude: "-11.1766",
    altitude: "485",
    timezone: "0",
    dst: "N",
    tz: "Africa/Freetown",
  },
  {
    id: "5663",
    name: "Bo Airport",
    city: "Bo",
    country: "Sierra Leone",
    iata: "KBS",
    icao: "GFBO",
    latitude: "7.9444",
    longitude: "-11.761",
    altitude: "328",
    timezone: "0",
    dst: "N",
    tz: "Africa/Freetown",
  },
  {
    id: "5662",
    name: "Sherbro International Airport",
    city: "Bonthe",
    country: "Sierra Leone",
    iata: "BTE",
    icao: "GFBN",
    latitude: "7.53242",
    longitude: "-12.5189",
    altitude: "14",
    timezone: "0",
    dst: "N",
    tz: "Africa/Freetown",
  },
  {
    id: "5661",
    name: "Ceuta Heliport",
    city: "Ceuta",
    country: "Spain",
    iata: "JCU",
    icao: "GECT",
    latitude: "35.8969",
    longitude: "-5.29908",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "5660",
    name: "Lauriston Airport",
    city: "Carriacou Island",
    country: "Grenada",
    iata: "CRU",
    icao: "",
    latitude: "12.4761",
    longitude: "-61.4728",
    altitude: "0",
    timezone: "-4",
    dst: "U",
    tz: "America/Grenada",
  },
  {
    id: "5659",
    name: "La Gomera Airport",
    city: "La Gomera",
    country: "Spain",
    iata: "GMZ",
    icao: "GCGM",
    latitude: "28.0296",
    longitude: "-17.2146",
    altitude: "718",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "5658",
    name: "Papa Stour Airport",
    city: "Papa Stour",
    country: "United Kingdom",
    iata: "PSV",
    icao: "",
    latitude: "60.3217",
    longitude: "-1.69306",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5657",
    name: "Outer Skerries Airport",
    city: "Outer Skerries",
    country: "United Kingdom",
    iata: "OUK",
    icao: "",
    latitude: "60.417",
    longitude: "-0.75",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5656",
    name: "Foula Airport",
    city: "Foula",
    country: "United Kingdom",
    iata: "FOA",
    icao: "",
    latitude: "60.121",
    longitude: "-2.052",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5655",
    name: "Gamba",
    city: "Gamba",
    country: "Gabon",
    iata: "GAX",
    icao: "",
    latitude: "-2.71016",
    longitude: "9.96062",
    altitude: "73",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "5654",
    name: "Ilebo Airport",
    city: "Ilebo",
    country: "Congo (Kinshasa)",
    iata: "PFR",
    icao: "FZVS",
    latitude: "-4.333",
    longitude: "20.583",
    altitude: "1450",
    timezone: "2",
    dst: "N",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "5653",
    name: "Lodja Airport",
    city: "Lodja",
    country: "Congo (Kinshasa)",
    iata: "LJA",
    icao: "FZVA",
    latitude: "-3.417",
    longitude: "23.45",
    altitude: "1647",
    timezone: "2",
    dst: "N",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "5652",
    name: "Tshikapa Airport",
    city: "Tshikapa",
    country: "Congo (Kinshasa)",
    iata: "TSH",
    icao: "FZUK",
    latitude: "-6.43833",
    longitude: "20.7947",
    altitude: "1595",
    timezone: "2",
    dst: "N",
    tz: "Africa/Lubumbashi",
  },
  {
    id: "5651",
    name: "Basankusu Airport",
    city: "Basankusu",
    country: "Congo (Kinshasa)",
    iata: "BSU",
    icao: "FZEN",
    latitude: "1.22472",
    longitude: "19.7889",
    altitude: "1217",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "5650",
    name: "Basango Mboliasa Airport",
    city: "Kiri",
    country: "Congo (Kinshasa)",
    iata: "KRZ",
    icao: "FZBT",
    latitude: "-1.435",
    longitude: "19.024",
    altitude: "1013",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "5649",
    name: "Nioki Airport",
    city: "Nioki",
    country: "Congo (Kinshasa)",
    iata: "NIO",
    icao: "FZBI",
    latitude: "-2.7175",
    longitude: "17.6847",
    altitude: "1043",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "5648",
    name: "Inongo Airport",
    city: "Inongo",
    country: "Congo (Kinshasa)",
    iata: "INO",
    icao: "FZBA",
    latitude: "-1.94722",
    longitude: "18.2858",
    altitude: "1040",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "5647",
    name: "Tshimpi Airport",
    city: "Matadi",
    country: "Congo (Kinshasa)",
    iata: "MAT",
    icao: "FZAM",
    latitude: "-5.79961",
    longitude: "13.4404",
    altitude: "1115",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "5646",
    name: "Boma Airport",
    city: "Boma",
    country: "Congo (Kinshasa)",
    iata: "BOA",
    icao: "FZAJ",
    latitude: "-5.854",
    longitude: "13.064",
    altitude: "26",
    timezone: "1",
    dst: "N",
    tz: "Africa/Kinshasa",
  },
  {
    id: "5645",
    name: "Eros Airport",
    city: "Windhoek",
    country: "Namibia",
    iata: "ERS",
    icao: "FYWE",
    latitude: "-22.6122",
    longitude: "17.0804",
    altitude: "5575",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "5644",
    name: "Swakopmund Airport",
    city: "Swakopmund",
    country: "Namibia",
    iata: "SWP",
    icao: "FYSM",
    latitude: "-22.6619",
    longitude: "14.5681",
    altitude: "207",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "5643",
    name: "Oranjemund Airport",
    city: "Oranjemund",
    country: "Namibia",
    iata: "OMD",
    icao: "FYOG",
    latitude: "-28.5847",
    longitude: "16.4467",
    altitude: "14",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "5642",
    name: "Ondangwa Airport",
    city: "Ondangwa",
    country: "Namibia",
    iata: "OND",
    icao: "FYOA",
    latitude: "-17.8782",
    longitude: "15.9526",
    altitude: "3599",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "5641",
    name: "Luderitz Airport",
    city: "Luderitz",
    country: "Namibia",
    iata: "LUD",
    icao: "FYLZ",
    latitude: "-26.6874",
    longitude: "15.2429",
    altitude: "457",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "5640",
    name: "Club Makokola Airport",
    city: "Club Makokola",
    country: "Malawi",
    iata: "CMK",
    icao: "FWCM",
    latitude: "-14.3069",
    longitude: "35.1325",
    altitude: "1587",
    timezone: "2",
    dst: "U",
    tz: "Africa/Blantyre",
  },
  {
    id: "5639",
    name: "Sarh Airport",
    city: "Sarh",
    country: "Chad",
    iata: "SRH",
    icao: "FTTA",
    latitude: "9.14444",
    longitude: "18.3744",
    altitude: "1198",
    timezone: "1",
    dst: "N",
    tz: "Africa/Ndjamena",
  },
  {
    id: "5638",
    name: "Croisette Heliport",
    city: "Cannes",
    country: "France",
    iata: "JCA",
    icao: "",
    latitude: "43.536",
    longitude: "7.03736",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "5637",
    name: "Chimoio Airport",
    city: "Chimoio",
    country: "Mozambique",
    iata: "VPY",
    icao: "FQCH",
    latitude: "-19.151267",
    longitude: "33.428958",
    altitude: "2287",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "5636",
    name: "Tchibanga Airport",
    city: "Tchibanga",
    country: "Gabon",
    iata: "TCH",
    icao: "FOOT",
    latitude: "-2.85",
    longitude: "11.017",
    altitude: "269",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "5635",
    name: "Mouilla Ville Airport",
    city: "Mouila",
    country: "Gabon",
    iata: "MJL",
    icao: "FOGM",
    latitude: "-1.84514",
    longitude: "11.0567",
    altitude: "295",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "5634",
    name: "Koulamoutou Airport",
    city: "Koulamoutou",
    country: "Gabon",
    iata: "KOU",
    icao: "FOGK",
    latitude: "-1.18461",
    longitude: "12.4413",
    altitude: "1070",
    timezone: "1",
    dst: "N",
    tz: "Africa/Libreville",
  },
  {
    id: "5633",
    name: "Namibe Airport",
    city: "Mocamedes",
    country: "Angola",
    iata: "MSZ",
    icao: "FNMO",
    latitude: "-15.261222",
    longitude: "12.146756",
    altitude: "210",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "5632",
    name: "Ondjiva Pereira Airport",
    city: "Ondjiva",
    country: "Angola",
    iata: "VPE",
    icao: "FNGI",
    latitude: "-17.043464",
    longitude: "15.683822",
    altitude: "3566",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "5631",
    name: "Dundo Airport",
    city: "Dundo",
    country: "Angola",
    iata: "DUE",
    icao: "FNDU",
    latitude: "-7.40089",
    longitude: "20.8185",
    altitude: "2451",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "5630",
    name: "Catumbela Airport",
    city: "Catumbela",
    country: "Angola",
    iata: "CBT",
    icao: "FNCT",
    latitude: "-12.4792",
    longitude: "13.4869",
    altitude: "0",
    timezone: "1",
    dst: "N",
    tz: "Africa/Luanda",
  },
  {
    id: "5629",
    name: "Manja Airport",
    city: "Manja",
    country: "Madagascar",
    iata: "MJA",
    icao: "FMSJ",
    latitude: "-21.417",
    longitude: "44.317",
    altitude: "787",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5628",
    name: "Mandritsara Airport",
    city: "Mandritsara",
    country: "Madagascar",
    iata: "WMA",
    icao: "FMNX",
    latitude: "-15.817",
    longitude: "48.833",
    altitude: "1007",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5627",
    name: "Tsaratanana Airport",
    city: "Tsaratanana",
    country: "Madagascar",
    iata: "TTS",
    icao: "FMNT",
    latitude: "-16.75",
    longitude: "47.617",
    altitude: "1073",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5626",
    name: "Mampikony Airport",
    city: "Mampikony",
    country: "Madagascar",
    iata: "WMP",
    icao: "FMNP",
    latitude: "-16.049",
    longitude: "47.622",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5625",
    name: "Soalala Airport",
    city: "Soalala",
    country: "Madagascar",
    iata: "DWB",
    icao: "FMNO",
    latitude: "-16.083",
    longitude: "45.367",
    altitude: "141",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5624",
    name: "Ambanja Airport",
    city: "Ambanja",
    country: "Madagascar",
    iata: "IVA",
    icao: "FMNJ",
    latitude: "-13.65",
    longitude: "48.467",
    altitude: "36",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5623",
    name: "Port Bergé Airport",
    city: "Port Bergé",
    country: "Madagascar",
    iata: "WPB",
    icao: "FMNG",
    latitude: "-15.583",
    longitude: "47.617",
    altitude: "213",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5622",
    name: "Ambatondrazaka Airport",
    city: "Ambatondrazaka",
    country: "Madagascar",
    iata: "WAM",
    icao: "FMMZ",
    latitude: "-17.8",
    longitude: "48.433",
    altitude: "2513",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5621",
    name: "Tsiroanomandidy Airport",
    city: "Tsiroanomandidy",
    country: "Madagascar",
    iata: "WTS",
    icao: "FMMX",
    latitude: "-18.75",
    longitude: "46.05",
    altitude: "2776",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5620",
    name: "Tambohorano Airport",
    city: "Tambohorano",
    country: "Madagascar",
    iata: "WTA",
    icao: "FMMU",
    latitude: "-17.4761",
    longitude: "43.9728",
    altitude: "23",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5619",
    name: "Morafenobe Airport",
    city: "Morafenobe",
    country: "Madagascar",
    iata: "TVA",
    icao: "FMMR",
    latitude: "-17.85",
    longitude: "44.917",
    altitude: "748",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5618",
    name: "Maintirano Airport",
    city: "Maintirano",
    country: "Madagascar",
    iata: "MXT",
    icao: "FMMO",
    latitude: "-18.05",
    longitude: "44.033",
    altitude: "95",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5617",
    name: "Belo sur Tsiribihina Airport",
    city: "Belo sur Tsiribihina",
    country: "Madagascar",
    iata: "BMD",
    icao: "FMML",
    latitude: "-19.6867",
    longitude: "44.5419",
    altitude: "154",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5616",
    name: "Ankavandra Airport",
    city: "Ankavandra",
    country: "Madagascar",
    iata: "JVA",
    icao: "FMMK",
    latitude: "-18.8",
    longitude: "45.283",
    altitude: "427",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5615",
    name: "Antsalova Airport",
    city: "Antsalova",
    country: "Madagascar",
    iata: "WAQ",
    icao: "FMMG",
    latitude: "-18.7",
    longitude: "44.617",
    altitude: "551",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "5614",
    name: "Iconi Airport",
    city: "Moroni",
    country: "Comoros",
    iata: "YVA",
    icao: "FMCN",
    latitude: "-11.7108",
    longitude: "43.2439",
    altitude: "33",
    timezone: "3",
    dst: "U",
    tz: "Indian/Comoro",
  },
  {
    id: "5613",
    name: "Solwesi Airport",
    city: "Solwesi",
    country: "Zambia",
    iata: "SLI",
    icao: "FLSW",
    latitude: "-12.1737",
    longitude: "26.3651",
    altitude: "4551",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "5612",
    name: "Chipata Airport",
    city: "Chipata",
    country: "Zambia",
    iata: "CIP",
    icao: "FLCP",
    latitude: "-13.5583",
    longitude: "32.5872",
    altitude: "3360",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "5611",
    name: "Loubomo Airport",
    city: "Loubomo",
    country: "Congo (Brazzaville)",
    iata: "DIS",
    icao: "FCPL",
    latitude: "-4.2",
    longitude: "12.7",
    altitude: "1079",
    timezone: "1",
    dst: "N",
    tz: "Africa/Brazzaville",
  },
  {
    id: "5610",
    name: "Limpopo Valley Airport",
    city: "Tuli Lodge",
    country: "Botswana",
    iata: "TLD",
    icao: "FBTL",
    latitude: "-22.1892",
    longitude: "29.1269",
    altitude: "1772",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "5609",
    name: "Shakawe Airport",
    city: "Shakawe",
    country: "Botswana",
    iata: "SWX",
    icao: "FBSW",
    latitude: "-18.3739",
    longitude: "21.8326",
    altitude: "3379",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "5608",
    name: "Orapa Airport",
    city: "Orapa",
    country: "Botswana",
    iata: "ORP",
    icao: "FBOR",
    latitude: "-21.2667",
    longitude: "25.3167",
    altitude: "3100",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "5607",
    name: "Ghanzi Airport",
    city: "Ghanzi",
    country: "Botswana",
    iata: "GNZ",
    icao: "FBGZ",
    latitude: "-21.6925",
    longitude: "21.6581",
    altitude: "3730",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "5606",
    name: "Mmabatho International Airport",
    city: "Mafeking",
    country: "South Africa",
    iata: "MBD",
    icao: "FAMM",
    latitude: "-25.798444",
    longitude: "25.548028",
    altitude: "4181",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "5605",
    name: "Malamala Airport",
    city: "Malamala",
    country: "South Africa",
    iata: "AAM",
    icao: "FAMD",
    latitude: "-24.818111",
    longitude: "31.544584",
    altitude: "1124",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "5604",
    name: "Kruger Mpumalanga International Airport",
    city: "Mpumalanga",
    country: "South Africa",
    iata: "MQP",
    icao: "FAKN",
    latitude: "-25.3832",
    longitude: "31.1056",
    altitude: "2829",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "5603",
    name: "Rand Airport",
    city: "Johannesburg",
    country: "South Africa",
    iata: "QRA",
    icao: "FAGM",
    latitude: "-26.242506",
    longitude: "28.151169",
    altitude: "5483",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "5602",
    name: "Ventspils International Airport",
    city: "Ventspils",
    country: "Latvia",
    iata: "VTS",
    icao: "EVVA",
    latitude: "57.357778",
    longitude: "21.544167",
    altitude: "19",
    timezone: "2",
    dst: "E",
    tz: "Europe/Riga",
  },
  {
    id: "5601",
    name: "Shire Inda Selassie Airport",
    city: "Shire Indasilase",
    country: "Ethiopia",
    iata: "SHC",
    icao: "",
    latitude: "14.0781",
    longitude: "38.2725",
    altitude: "6207",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5600",
    name: "Shilavo Airport",
    city: "Shilavo",
    country: "Ethiopia",
    iata: "HIL",
    icao: "",
    latitude: "6.08333",
    longitude: "44.7667",
    altitude: "1296",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "5599",
    name: "Hemavan Airport",
    city: "Hemavan",
    country: "Sweden",
    iata: "HMV",
    icao: "ESUT",
    latitude: "65.806111",
    longitude: "15.082778",
    altitude: "1503",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5598",
    name: "Storuman Airport",
    city: "Mohed",
    country: "Sweden",
    iata: "SQO",
    icao: "ESUD",
    latitude: "64.960894",
    longitude: "17.696583",
    altitude: "915",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5597",
    name: "Ängelholm-Helsingborg Airport",
    city: "Ängelholm",
    country: "Sweden",
    iata: "AGH",
    icao: "ESTA",
    latitude: "56.2961",
    longitude: "12.8471",
    altitude: "68",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5596",
    name: "Torsby Airport",
    city: "Torsby",
    country: "Sweden",
    iata: "TYF",
    icao: "ESST",
    latitude: "60.157622",
    longitude: "12.991269",
    altitude: "393",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5595",
    name: "Karlstad Airport",
    city: "Karlstad",
    country: "Sweden",
    iata: "KSD",
    icao: "ESOK",
    latitude: "59.4447",
    longitude: "13.3374",
    altitude: "352",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5594",
    name: "Hagfors Airport",
    city: "Hagfors",
    country: "Sweden",
    iata: "HFS",
    icao: "ESOH",
    latitude: "60.020064",
    longitude: "13.578908",
    altitude: "474",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5593",
    name: "Östersund Airport",
    city: "Östersund",
    country: "Sweden",
    iata: "OSD",
    icao: "ESNZ",
    latitude: "63.1944",
    longitude: "14.5003",
    altitude: "1233",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "5592",
    name: "Łódź Władysław Reymont Airport",
    city: "Lodz",
    country: "Poland",
    iata: "LCJ",
    icao: "EPLL",
    latitude: "51.721881",
    longitude: "19.398133",
    altitude: "604",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "5591",
    name: "Bydgoszcz Ignacy Jan Paderewski Airport",
    city: "Bydgoszcz",
    country: "Poland",
    iata: "BZG",
    icao: "EPBY",
    latitude: "53.0968",
    longitude: "17.9777",
    altitude: "235",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "5590",
    name: "Værøy Heliport",
    city: "Værøy",
    country: "Norway",
    iata: "VRY",
    icao: "ENVR",
    latitude: "67.6667",
    longitude: "12.6833",
    altitude: "36",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5589",
    name: "Svartnes Airport",
    city: "Vardø",
    country: "Norway",
    iata: "VAW",
    icao: "ENSS",
    latitude: "70.355392",
    longitude: "31.044889",
    altitude: "42",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5588",
    name: "Sorkjosen Airport",
    city: "Sorkjosen",
    country: "Norway",
    iata: "SOJ",
    icao: "ENSR",
    latitude: "69.7868",
    longitude: "20.9594",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5587",
    name: "Svolvær Helle Airport",
    city: "Svolvær",
    country: "Norway",
    iata: "SVJ",
    icao: "ENSH",
    latitude: "68.2433",
    longitude: "14.6692",
    altitude: "27",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5586",
    name: "Sogndal Airport",
    city: "Sogndal",
    country: "Norway",
    iata: "SOG",
    icao: "ENSG",
    latitude: "61.1561",
    longitude: "7.13778",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5585",
    name: "Anda Airport",
    city: "Sandane",
    country: "Norway",
    iata: "SDN",
    icao: "ENSD",
    latitude: "61.83",
    longitude: "6.10583",
    altitude: "196",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5584",
    name: "Røst Airport",
    city: "Røst",
    country: "Norway",
    iata: "RET",
    icao: "ENRS",
    latitude: "67.5278",
    longitude: "12.1033",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5583",
    name: "Ryum Airport",
    city: "Rørvik",
    country: "Norway",
    iata: "RVK",
    icao: "ENRM",
    latitude: "64.8383",
    longitude: "11.1461",
    altitude: "14",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5582",
    name: "Røssvoll Airport",
    city: "Mo i Rana",
    country: "Norway",
    iata: "MQN",
    icao: "ENRA",
    latitude: "66.3639",
    longitude: "14.3014",
    altitude: "229",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5581",
    name: "Namsos Høknesøra Airport",
    city: "Namsos",
    country: "Norway",
    iata: "OSY",
    icao: "ENNM",
    latitude: "64.4722",
    longitude: "11.5786",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5580",
    name: "Leknes Airport",
    city: "Leknes",
    country: "Norway",
    iata: "LKN",
    icao: "ENLK",
    latitude: "68.1525",
    longitude: "13.6094",
    altitude: "78",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "5579",
    name: "Sindal Airport",
    city: "Sindal",
    country: "Denmark",
    iata: "CNL",
    icao: "EKSN",
    latitude: "57.503525",
    longitude: "10.229372",
    altitude: "92",
    timezone: "1",
    dst: "N",
    tz: "Europe/Copenhagen",
  },
  {
    id: "5578",
    name: "Weston Airport",
    city: "Leixlip",
    country: "Ireland",
    iata: "",
    icao: "EIWT",
    latitude: "53.351333",
    longitude: "-6.4875",
    altitude: "150",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "5577",
    name: "Donegal Airport",
    city: "Dongloe",
    country: "Ireland",
    iata: "CFN",
    icao: "EIDL",
    latitude: "55.044192",
    longitude: "-8.341",
    altitude: "30",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "6816",
    name: "Raron Airport",
    city: "Raron",
    country: "Switzerland",
    iata: "",
    icao: "LSTA",
    latitude: "46.3036",
    longitude: "7.82333",
    altitude: "2029",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "5575",
    name: "Barra Airport",
    city: "Barra",
    country: "United Kingdom",
    iata: "BRR",
    icao: "EGPR",
    latitude: "57.0228",
    longitude: "-7.44306",
    altitude: "5",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5574",
    name: "Anglesey Airport",
    city: "Angelsey",
    country: "United Kingdom",
    iata: "HLY",
    icao: "EGOV",
    latitude: "53.248097",
    longitude: "-4.535339",
    altitude: "37",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5573",
    name: "Penzance Heliport",
    city: "Penzance",
    country: "United Kingdom",
    iata: "PZE",
    icao: "EGHK",
    latitude: "50.1281",
    longitude: "-5.51845",
    altitude: "14",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5572",
    name: "Land's End / St. Just Airport",
    city: "Land's End",
    country: "United Kingdom",
    iata: "LEQ",
    icao: "EGHC",
    latitude: "50.1028",
    longitude: "-5.67056",
    altitude: "401",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5571",
    name: "Westray Airport",
    city: "Westray",
    country: "United Kingdom",
    iata: "WRY",
    icao: "EGEW",
    latitude: "59.3503",
    longitude: "-2.95",
    altitude: "29",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5570",
    name: "Lerwick / Tingwall Airport",
    city: "Lerwick",
    country: "United Kingdom",
    iata: "LWK",
    icao: "EGET",
    latitude: "60.1922",
    longitude: "-1.24361",
    altitude: "43",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5569",
    name: "Sanday Airport",
    city: "Sanday",
    country: "United Kingdom",
    iata: "NDY",
    icao: "EGES",
    latitude: "59.2503",
    longitude: "-2.57667",
    altitude: "68",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5568",
    name: "Stronsay Airport",
    city: "Stronsay",
    country: "United Kingdom",
    iata: "SOY",
    icao: "EGER",
    latitude: "59.1553",
    longitude: "-2.64139",
    altitude: "39",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5567",
    name: "Papa Westray Airport",
    city: "Papa Westray",
    country: "United Kingdom",
    iata: "PPW",
    icao: "EGEP",
    latitude: "59.3517",
    longitude: "-2.90028",
    altitude: "91",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5566",
    name: "North Ronaldsay Airport",
    city: "North Ronaldsay",
    country: "United Kingdom",
    iata: "NRL",
    icao: "EGEN",
    latitude: "59.3675",
    longitude: "-2.43444",
    altitude: "40",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5565",
    name: "Fair Isle Airport",
    city: "Fair Isle",
    country: "United Kingdom",
    iata: "FIE",
    icao: "EGEF",
    latitude: "59.5358",
    longitude: "-1.62806",
    altitude: "223",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5564",
    name: "Eday Airport",
    city: "Eday",
    country: "United Kingdom",
    iata: "EOI",
    icao: "EGED",
    latitude: "59.1906",
    longitude: "-2.77222",
    altitude: "10",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5563",
    name: "Campbeltown Airport",
    city: "Campbeltown",
    country: "United Kingdom",
    iata: "CAL",
    icao: "EGEC",
    latitude: "55.4372",
    longitude: "-5.68639",
    altitude: "42",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5562",
    name: "Robin Hood Doncaster Sheffield Airport",
    city: "Doncaster, Sheffield",
    country: "United Kingdom",
    iata: "DSA",
    icao: "EGCN",
    latitude: "53.474722",
    longitude: "-1.004444",
    altitude: "55",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5561",
    name: "Nottingham Airport",
    city: "Nottingham",
    country: "United Kingdom",
    iata: "NQT",
    icao: "EGBN",
    latitude: "52.92",
    longitude: "-1.079167",
    altitude: "138",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "5560",
    name: "Seinäjoki Airport",
    city: "Seinäjoki / Ilmajoki",
    country: "Finland",
    iata: "SJY",
    icao: "EFSI",
    latitude: "62.6921",
    longitude: "22.8323",
    altitude: "302",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "5559",
    name: "Helgoland-Düne Airport",
    city: "Helgoland",
    country: "Germany",
    iata: "HGL",
    icao: "EDXH",
    latitude: "54.1853",
    longitude: "7.91583",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "5558",
    name: "Heide-Büsum Airport",
    city: "Büsum",
    country: "Germany",
    iata: "HEI",
    icao: "EDXB",
    latitude: "54.1533",
    longitude: "8.90167",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "5557",
    name: "Heringsdorf Airport",
    city: "Heringsdorf",
    country: "Germany",
    iata: "HDF",
    icao: "EDAH",
    latitude: "53.878706",
    longitude: "14.152347",
    altitude: "93",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "5556",
    name: "Kumasi Airport",
    city: "Kumasi",
    country: "Ghana",
    iata: "KMS",
    icao: "DGSI",
    latitude: "6.71456",
    longitude: "-1.59082",
    altitude: "942",
    timezone: "0",
    dst: "N",
    tz: "Africa/Accra",
  },
  {
    id: "5555",
    name: "Guemar Airport",
    city: "Guemar",
    country: "Algeria",
    iata: "ELU",
    icao: "DAUO",
    latitude: "33.5114",
    longitude: "6.77679",
    altitude: "203",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "5554",
    name: "Bordj Badji Mokhtar Airport",
    city: "Bordj Badji Mokhtar",
    country: "Algeria",
    iata: "BMW",
    icao: "DATM",
    latitude: "21.375",
    longitude: "0.923889",
    altitude: "1303",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "5553",
    name: "Béchar Boudghene Ben Ali Lotfi Airport",
    city: "Béchar",
    country: "Algeria",
    iata: "CBH",
    icao: "DAOR",
    latitude: "31.6457",
    longitude: "-2.26986",
    altitude: "2661",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "5552",
    name: "Batna Airport",
    city: "Batna",
    country: "Algeria",
    iata: "BLJ",
    icao: "DABT",
    latitude: "35.752106",
    longitude: "6.308589",
    altitude: "2697",
    timezone: "1",
    dst: "N",
    tz: "Africa/Algiers",
  },
  {
    id: "5551",
    name: "Wollaston Lake Airport",
    city: "Wollaston Lake",
    country: "Canada",
    iata: "ZWL",
    icao: "CZWL",
    latitude: "58.1069",
    longitude: "-103.172",
    altitude: "1360",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "5550",
    name: "Churchill Falls Airport",
    city: "Churchill Falls",
    country: "Canada",
    iata: "ZUM",
    icao: "CZUM",
    latitude: "53.5619",
    longitude: "-64.1064",
    altitude: "1442",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5549",
    name: "Shamattawa Airport",
    city: "Shamattawa",
    country: "Canada",
    iata: "ZTM",
    icao: "CZTM",
    latitude: "55.8656",
    longitude: "-92.0814",
    altitude: "289",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5548",
    name: "Sandy Lake Airport",
    city: "Sandy Lake",
    country: "Canada",
    iata: "ZSJ",
    icao: "CZSJ",
    latitude: "53.0642",
    longitude: "-93.3444",
    altitude: "951",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5547",
    name: "Round Lake (Weagamow Lake) Airport",
    city: "Round Lake",
    country: "Canada",
    iata: "ZRJ",
    icao: "CZRJ",
    latitude: "52.9436",
    longitude: "-91.3128",
    altitude: "974",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5546",
    name: "Sachigo Lake Airport",
    city: "Sachigo Lake",
    country: "Canada",
    iata: "ZPB",
    icao: "CZPB",
    latitude: "53.8911",
    longitude: "-92.1964",
    altitude: "876",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5545",
    name: "Masset Airport",
    city: "Masset",
    country: "Canada",
    iata: "ZMT",
    icao: "CZMT",
    latitude: "54.0275",
    longitude: "-132.125",
    altitude: "25",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "5544",
    name: "Muskrat Dam Airport",
    city: "Muskrat Dam",
    country: "Canada",
    iata: "MSA",
    icao: "CZMD",
    latitude: "53.4414",
    longitude: "-91.7628",
    altitude: "911",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5543",
    name: "Kashechewan Airport",
    city: "Kashechewan",
    country: "Canada",
    iata: "ZKE",
    icao: "CZKE",
    latitude: "52.2825",
    longitude: "-81.6778",
    altitude: "35",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5542",
    name: "Swan River Airport",
    city: "Swan River",
    country: "Canada",
    iata: "ZJN",
    icao: "CZJN",
    latitude: "52.1206",
    longitude: "-101.236",
    altitude: "1100",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5541",
    name: "Gods River Airport",
    city: "Gods River",
    country: "Canada",
    iata: "ZGI",
    icao: "CZGI",
    latitude: "54.8397",
    longitude: "-94.0786",
    altitude: "627",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5540",
    name: "Fond-Du-Lac Airport",
    city: "Fond-Du-Lac",
    country: "Canada",
    iata: "ZFD",
    icao: "CZFD",
    latitude: "59.3344",
    longitude: "-107.182",
    altitude: "814",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "5539",
    name: "Eastmain River Airport",
    city: "Eastmain River",
    country: "Canada",
    iata: "ZEM",
    icao: "CZEM",
    latitude: "52.2264",
    longitude: "-78.5225",
    altitude: "24",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5538",
    name: "Bathurst Airport",
    city: "Bathurst",
    country: "Canada",
    iata: "ZBF",
    icao: "CZBF",
    latitude: "47.6297",
    longitude: "-65.7389",
    altitude: "193",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5537",
    name: "Ilford Airport",
    city: "Ilford",
    country: "Canada",
    iata: "ILF",
    icao: "CZBD",
    latitude: "56.0614",
    longitude: "-95.6139",
    altitude: "642",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5536",
    name: "York Landing Airport",
    city: "York Landing",
    country: "Canada",
    iata: "ZAC",
    icao: "CZAC",
    latitude: "56.0894",
    longitude: "-96.0892",
    altitude: "621",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5535",
    name: "Salluit Airport",
    city: "Salluit",
    country: "Canada",
    iata: "YZG",
    icao: "CYZG",
    latitude: "62.1794",
    longitude: "-75.6672",
    altitude: "743",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5534",
    name: "Whale Cove Airport",
    city: "Whale Cove",
    country: "Canada",
    iata: "YXN",
    icao: "CYXN",
    latitude: "62.24",
    longitude: "-92.5981",
    altitude: "40",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5533",
    name: "Webequie Airport",
    city: "Webequie",
    country: "Canada",
    iata: "YWP",
    icao: "CYWP",
    latitude: "52.9597",
    longitude: "-87.3689",
    altitude: "685",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5532",
    name: "Deer Lake Airport",
    city: "Deer Lake",
    country: "Canada",
    iata: "YVZ",
    icao: "CYVZ",
    latitude: "52.6558",
    longitude: "-94.0614",
    altitude: "1092",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5531",
    name: "Big Trout Lake Airport",
    city: "Big Trout Lake",
    country: "Canada",
    iata: "YTL",
    icao: "CYTL",
    latitude: "53.8178",
    longitude: "-89.8969",
    altitude: "729",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5530",
    name: "St. Theresa Point Airport",
    city: "St. Theresa Point",
    country: "Canada",
    iata: "YST",
    icao: "CYST",
    latitude: "53.8456",
    longitude: "-94.8519",
    altitude: "773",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5529",
    name: "Sanikiluaq Airport",
    city: "Sanikiluaq",
    country: "Canada",
    iata: "YSK",
    icao: "CYSK",
    latitude: "56.5378",
    longitude: "-79.2467",
    altitude: "104",
    timezone: "-5",
    dst: "A",
    tz: "\\N",
  },
  {
    id: "5528",
    name: "Stony Rapids Airport",
    city: "Stony Rapids",
    country: "Canada",
    iata: "YSF",
    icao: "CYSF",
    latitude: "59.2503",
    longitude: "-105.841",
    altitude: "805",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "5527",
    name: "Red Lake Airport",
    city: "Red Lake",
    country: "Canada",
    iata: "YRL",
    icao: "CYRL",
    latitude: "51.0669",
    longitude: "-93.7931",
    altitude: "1265",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5526",
    name: "Rae Lakes Airport",
    city: "Gamètì",
    country: "Canada",
    iata: "YRA",
    icao: "CYRA",
    latitude: "64.1161",
    longitude: "-117.31",
    altitude: "723",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "5525",
    name: "Nakina Airport",
    city: "Nakina",
    country: "Canada",
    iata: "YQN",
    icao: "CYQN",
    latitude: "50.182777",
    longitude: "-86.696388",
    altitude: "1057",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5524",
    name: "The Pas Airport",
    city: "The Pas",
    country: "Canada",
    iata: "YQD",
    icao: "CYQD",
    latitude: "53.9714",
    longitude: "-101.091",
    altitude: "887",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5523",
    name: "Powell River Airport",
    city: "Powell River",
    country: "Canada",
    iata: "YPW",
    icao: "CYPW",
    latitude: "49.8342",
    longitude: "-124.5",
    altitude: "425",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "5522",
    name: "Peawanuck Airport",
    city: "Peawanuck",
    country: "Canada",
    iata: "YPO",
    icao: "CYPO",
    latitude: "54.9881",
    longitude: "-85.4433",
    altitude: "173",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5521",
    name: "Pikangikum Airport",
    city: "Pikangikum",
    country: "Canada",
    iata: "YPM",
    icao: "CYPM",
    latitude: "51.8197",
    longitude: "-93.9733",
    altitude: "1114",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5520",
    name: "Inukjuak Airport",
    city: "Inukjuak",
    country: "Canada",
    iata: "YPH",
    icao: "CYPH",
    latitude: "58.4719",
    longitude: "-78.0769",
    altitude: "83",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5519",
    name: "Oxford House Airport",
    city: "Oxford House",
    country: "Canada",
    iata: "YOH",
    icao: "CYOH",
    latitude: "54.9333",
    longitude: "-95.2789",
    altitude: "663",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5518",
    name: "Points North Landing Airport",
    city: "Points North Landing",
    country: "Canada",
    iata: "YNL",
    icao: "CYNL",
    latitude: "58.2767",
    longitude: "-104.082",
    altitude: "1605",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "5517",
    name: "Norway House Airport",
    city: "Norway House",
    country: "Canada",
    iata: "YNE",
    icao: "CYNE",
    latitude: "53.9583",
    longitude: "-97.8442",
    altitude: "734",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5516",
    name: "Wemindji Airport",
    city: "Wemindji",
    country: "Canada",
    iata: "YNC",
    icao: "CYNC",
    latitude: "53.0106",
    longitude: "-78.8311",
    altitude: "66",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5515",
    name: "Umiujaq Airport",
    city: "Umiujaq",
    country: "Canada",
    iata: "YUD",
    icao: "CYMU",
    latitude: "56.5361",
    longitude: "-76.5183",
    altitude: "250",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5514",
    name: "Chapais Airport",
    city: "Chibougamau",
    country: "Canada",
    iata: "YMT",
    icao: "CYMT",
    latitude: "49.7719",
    longitude: "-74.5281",
    altitude: "1270",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5513",
    name: "Mary's Harbour Airport",
    city: "Mary's Harbour",
    country: "Canada",
    iata: "YMH",
    icao: "CYMH",
    latitude: "52.3028",
    longitude: "-55.8472",
    altitude: "38",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "5512",
    name: "Kangiqsualujjuaq (Georges River) Airport",
    city: "Kangiqsualujjuaq",
    country: "Canada",
    iata: "XGR",
    icao: "CYLU",
    latitude: "58.7114",
    longitude: "-65.9928",
    altitude: "215",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5511",
    name: "Lutselk'e Airport",
    city: "Lutselk'e",
    country: "Canada",
    iata: "YSG",
    icao: "CYLK",
    latitude: "62.4183",
    longitude: "-110.682",
    altitude: "596",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "5510",
    name: "Lansdowne House Airport",
    city: "Lansdowne House",
    country: "Canada",
    iata: "YLH",
    icao: "CYLH",
    latitude: "52.1956",
    longitude: "-87.9342",
    altitude: "834",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5509",
    name: "Kimmirut Airport",
    city: "Kimmirut",
    country: "Canada",
    iata: "YLC",
    icao: "CYLC",
    latitude: "62.85",
    longitude: "-69.8833",
    altitude: "175",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5508",
    name: "Aupaluk Airport",
    city: "Aupaluk",
    country: "Canada",
    iata: "YPJ",
    icao: "CYLA",
    latitude: "59.2967",
    longitude: "-69.5997",
    altitude: "119",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5507",
    name: "Waskaganish Airport",
    city: "Waskaganish",
    country: "Canada",
    iata: "YKQ",
    icao: "CYKQ",
    latitude: "51.4733",
    longitude: "-78.7583",
    altitude: "80",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5506",
    name: "Akulivik Airport",
    city: "Akulivik",
    country: "Canada",
    iata: "AKV",
    icao: "CYKO",
    latitude: "60.8186",
    longitude: "-78.1486",
    altitude: "75",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5505",
    name: "Island Lake Airport",
    city: "Island Lake",
    country: "Canada",
    iata: "YIV",
    icao: "CYIV",
    latitude: "53.8572",
    longitude: "-94.6536",
    altitude: "770",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5504",
    name: "Ivujivik Airport",
    city: "Ivujivik",
    country: "Canada",
    iata: "YIK",
    icao: "CYIK",
    latitude: "62.4173",
    longitude: "-77.9253",
    altitude: "126",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5503",
    name: "Chevery Airport",
    city: "Chevery",
    country: "Canada",
    iata: "YHR",
    icao: "CYHR",
    latitude: "50.4689",
    longitude: "-59.6367",
    altitude: "39",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "5502",
    name: "Hopedale Airport",
    city: "Hopedale",
    country: "Canada",
    iata: "YHO",
    icao: "CYHO",
    latitude: "55.4483",
    longitude: "-60.2286",
    altitude: "39",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5501",
    name: "Nemiscau Airport",
    city: "Nemiscau",
    country: "Canada",
    iata: "YNS",
    icao: "CYHH",
    latitude: "51.6911",
    longitude: "-76.1356",
    altitude: "802",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5500",
    name: "Vancouver Harbour Water Airport",
    city: "Vancouver",
    country: "Canada",
    iata: "YHC",
    icao: "CYHC",
    latitude: "49.2944",
    longitude: "-123.111",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "5499",
    name: "Quaqtaq Airport",
    city: "Quaqtaq",
    country: "Canada",
    iata: "YQC",
    icao: "CYHA",
    latitude: "61.0464",
    longitude: "-69.6178",
    altitude: "103",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5498",
    name: "Grise Fiord Airport",
    city: "Grise Fiord",
    country: "Canada",
    iata: "YGZ",
    icao: "CYGZ",
    latitude: "76.4261",
    longitude: "-82.9092",
    altitude: "146",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5497",
    name: "Gillam Airport",
    city: "Gillam",
    country: "Canada",
    iata: "YGX",
    icao: "CYGX",
    latitude: "56.3575",
    longitude: "-94.7106",
    altitude: "476",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5496",
    name: "Kuujjuarapik Airport",
    city: "Kuujjuarapik",
    country: "Canada",
    iata: "YGW",
    icao: "CYGW",
    latitude: "55.2819",
    longitude: "-77.7653",
    altitude: "34",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5495",
    name: "Igloolik Airport",
    city: "Igloolik",
    country: "Canada",
    iata: "YGT",
    icao: "CYGT",
    latitude: "69.3647",
    longitude: "-81.8161",
    altitude: "174",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5494",
    name: "Gods Lake Narrows Airport",
    city: "Gods Lake Narrows",
    country: "Canada",
    iata: "YGO",
    icao: "CYGO",
    latitude: "54.5589",
    longitude: "-94.4914",
    altitude: "617",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5493",
    name: "Texada Gillies Bay Airport",
    city: "Texada",
    country: "Canada",
    iata: "YGB",
    icao: "CYGB",
    latitude: "49.6942",
    longitude: "-124.518",
    altitude: "326",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "5492",
    name: "Makkovik Airport",
    city: "Makkovik",
    country: "Canada",
    iata: "YMN",
    icao: "CYFT",
    latitude: "55.0769",
    longitude: "-59.1864",
    altitude: "234",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5491",
    name: "Fort Hope Airport",
    city: "Fort Hope",
    country: "Canada",
    iata: "YFH",
    icao: "CYFH",
    latitude: "51.5619",
    longitude: "-87.9078",
    altitude: "899",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5490",
    name: "Fort Albany Airport",
    city: "Fort Albany",
    country: "Canada",
    iata: "YFA",
    icao: "CYFA",
    latitude: "52.2014",
    longitude: "-81.6969",
    altitude: "48",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5489",
    name: "Fort Severn Airport",
    city: "Fort Severn",
    country: "Canada",
    iata: "YER",
    icao: "CYER",
    latitude: "56.0189",
    longitude: "-87.6761",
    altitude: "48",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5488",
    name: "Nain Airport",
    city: "Nain",
    country: "Canada",
    iata: "YDP",
    icao: "CYDP",
    latitude: "56.5492",
    longitude: "-61.6803",
    altitude: "22",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5487",
    name: "Chesterfield Inlet Airport",
    city: "Chesterfield Inlet",
    country: "Canada",
    iata: "YCS",
    icao: "CYCS",
    latitude: "63.3469",
    longitude: "-90.7311",
    altitude: "32",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5486",
    name: "Cartwright Airport",
    city: "Cartwright",
    country: "Canada",
    iata: "YRF",
    icao: "CYCA",
    latitude: "53.6828",
    longitude: "-57.0419",
    altitude: "40",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5485",
    name: "Lourdes De Blanc Sablon Airport",
    city: "Lourdes-De-Blanc-Sablon",
    country: "Canada",
    iata: "YBX",
    icao: "CYBX",
    latitude: "51.4436",
    longitude: "-57.1853",
    altitude: "121",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "5484",
    name: "Uranium City Airport",
    city: "Uranium City",
    country: "Canada",
    iata: "YBE",
    icao: "CYBE",
    latitude: "59.5614",
    longitude: "-108.481",
    altitude: "1044",
    timezone: "-6",
    dst: "N",
    tz: "America/Regina",
  },
  {
    id: "5483",
    name: "Lac Du Bonnet Airport",
    city: "Lac Du Bonnet",
    country: "Canada",
    iata: "",
    icao: "CYAX",
    latitude: "50.2944",
    longitude: "-96.01",
    altitude: "850",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5482",
    name: "Attawapiskat Airport",
    city: "Attawapiskat",
    country: "Canada",
    iata: "YAT",
    icao: "CYAT",
    latitude: "52.9275",
    longitude: "-82.4319",
    altitude: "31",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5481",
    name: "Kangirsuk Airport",
    city: "Kangirsuk",
    country: "Canada",
    iata: "YKG",
    icao: "CYAS",
    latitude: "60.0272",
    longitude: "-69.9992",
    altitude: "403",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5480",
    name: "Kasabonika Airport",
    city: "Kasabonika",
    country: "Canada",
    iata: "XKS",
    icao: "CYAQ",
    latitude: "53.5247",
    longitude: "-88.6428",
    altitude: "672",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5479",
    name: "Fort Frances Municipal Airport",
    city: "Fort Frances",
    country: "Canada",
    iata: "YAG",
    icao: "CYAG",
    latitude: "48.6542",
    longitude: "-93.4397",
    altitude: "1125",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5478",
    name: "Cat Lake Airport",
    city: "Cat Lake",
    country: "Canada",
    iata: "YAC",
    icao: "CYAC",
    latitude: "51.7272",
    longitude: "-91.8244",
    altitude: "1344",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5477",
    name: "Tarapacá Airport",
    city: "Tarapacá",
    country: "Colombia",
    iata: "TCD",
    icao: "",
    latitude: "-2.867",
    longitude: "-69.733",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "5476",
    name: "Apartadó Airport",
    city: "Apartadó",
    country: "Colombia",
    iata: "APO",
    icao: "",
    latitude: "7.033",
    longitude: "-77.2",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "5475",
    name: "Nantong Airport",
    city: "Nantong",
    country: "China",
    iata: "NTG",
    icao: "",
    latitude: "32.0708",
    longitude: "120.976",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "5474",
    name: "La Tabatière Airport",
    city: "La Tabatière",
    country: "Canada",
    iata: "ZLT",
    icao: "CTU5",
    latitude: "50.8308",
    longitude: "-58.9756",
    altitude: "102",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "5473",
    name: "Tête-à-la-Baleine Airport",
    city: "Tête-à-la-Baleine",
    country: "Canada",
    iata: "ZTB",
    icao: "CTB6",
    latitude: "50.6744",
    longitude: "-59.3836",
    altitude: "107",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "5472",
    name: "Chisasibi Airport",
    city: "Chisasibi",
    country: "Canada",
    iata: "YKU",
    icao: "CSU2",
    latitude: "53.8056",
    longitude: "-78.9169",
    altitude: "43",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5471",
    name: "Poplar Hill Airport",
    city: "Poplar Hill",
    country: "Canada",
    iata: "YHP",
    icao: "CPV7",
    latitude: "52.1133",
    longitude: "-94.2556",
    altitude: "1095",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5470",
    name: "Ogoki Post Airport",
    city: "Ogoki Post",
    country: "Canada",
    iata: "YOG",
    icao: "CNT3",
    latitude: "51.6586",
    longitude: "-85.9017",
    altitude: "594",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5469",
    name: "Kingfisher Lake Airport",
    city: "Kingfisher Lake",
    country: "Canada",
    iata: "KIF",
    icao: "CNM5",
    latitude: "53.0125",
    longitude: "-89.8553",
    altitude: "866",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5468",
    name: "Bearskin Lake Airport",
    city: "Bearskin Lake",
    country: "Canada",
    iata: "XBE",
    icao: "CNE3",
    latitude: "53.9656",
    longitude: "-91.0272",
    altitude: "800",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5467",
    name: "North Spirit Lake Airport",
    city: "North Spirit Lake",
    country: "Canada",
    iata: "YNO",
    icao: "CKQ3",
    latitude: "52.49",
    longitude: "-92.9711",
    altitude: "1082",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5466",
    name: "Wunnumin Lake Airport",
    city: "Wunnumin Lake",
    country: "Canada",
    iata: "WNN",
    icao: "CKL3",
    latitude: "52.8939",
    longitude: "-89.2892",
    altitude: "819",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5465",
    name: "Wapekeka Airport",
    city: "Angling Lake",
    country: "Canada",
    iata: "YAX",
    icao: "CKB6",
    latitude: "53.8492",
    longitude: "-89.5794",
    altitude: "712",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "5464",
    name: "Summer Beaver Airport",
    city: "Summer Beaver",
    country: "Canada",
    iata: "SUR",
    icao: "CJV7",
    latitude: "52.7086",
    longitude: "-88.5419",
    altitude: "832",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "5463",
    name: "Whatì Airport",
    city: "Whatì",
    country: "Canada",
    iata: "YLE",
    icao: "CEM3",
    latitude: "63.1317",
    longitude: "-117.246",
    altitude: "882",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "5462",
    name: "Colville Lake Airport",
    city: "Colville Lake",
    country: "Canada",
    iata: "YCK",
    icao: "CEB3",
    latitude: "67.0333",
    longitude: "-126.083",
    altitude: "850",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "5461",
    name: "Rigolet Airport",
    city: "Rigolet",
    country: "Canada",
    iata: "YRG",
    icao: "CCZ2",
    latitude: "54.1797",
    longitude: "-58.4575",
    altitude: "180",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "5460",
    name: "Port Hope Simpson Airport",
    city: "Port Hope Simpson",
    country: "Canada",
    iata: "YHA",
    icao: "CCP4",
    latitude: "52.5281",
    longitude: "-56.2861",
    altitude: "347",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "5459",
    name: "St. Lewis (Fox Harbour) Airport",
    city: "St. Lewis",
    country: "Canada",
    iata: "YFX",
    icao: "CCK4",
    latitude: "52.3728",
    longitude: "-55.6739",
    altitude: "74",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "5458",
    name: "Williams Harbour Airport",
    city: "Williams Harbour",
    country: "Canada",
    iata: "YWM",
    icao: "CCA6",
    latitude: "52.5669",
    longitude: "-55.7847",
    altitude: "70",
    timezone: "-3.5",
    dst: "A",
    tz: "America/St_Johns",
  },
  {
    id: "5457",
    name: "Anahim Lake Airport",
    city: "Anahim Lake",
    country: "Canada",
    iata: "YAA",
    icao: "CAJ4",
    latitude: "52.4525",
    longitude: "-125.303",
    altitude: "3635",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "5456",
    name: "Whistler/Green Lake Water Aerodrome",
    city: "Whistler",
    country: "Canada",
    iata: "YWS",
    icao: "CAE5",
    latitude: "50.1436",
    longitude: "-122.949",
    altitude: "2100",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "5455",
    name: "Punta Gorda Airport",
    city: "Punta Gorda",
    country: "Belize",
    iata: "PND",
    icao: "",
    latitude: "16.1024",
    longitude: "-88.8083",
    altitude: "7",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "5454",
    name: "Caye Caulker Airport",
    city: "Caye Caulker",
    country: "Belize",
    iata: "CUK",
    icao: "",
    latitude: "17.7347",
    longitude: "-88.0325",
    altitude: "1",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "5453",
    name: "Vopnafjörður Airport",
    city: "Vopnafjörður",
    country: "Iceland",
    iata: "VPN",
    icao: "BIVO",
    latitude: "65.7206",
    longitude: "-14.8506",
    altitude: "0",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "5452",
    name: "Thorshofn Airport",
    city: "Thorshofn",
    country: "Iceland",
    iata: "THO",
    icao: "BITN",
    latitude: "66.2185",
    longitude: "-15.3356",
    altitude: "65",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "6945",
    name: "Drake Bay Airport",
    city: "Puntarenas",
    country: "Costa Rica",
    iata: "DRK",
    icao: "MRDK",
    latitude: "8.71889",
    longitude: "-83.6417",
    altitude: "12",
    timezone: "-6",
    dst: "N",
    tz: "America/Costa_Rica",
  },
  {
    id: "5450",
    name: "Grímsey Airport",
    city: "Grímsey",
    country: "Iceland",
    iata: "GRY",
    icao: "BIGR",
    latitude: "66.5547",
    longitude: "-18.0175",
    altitude: "66",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "5449",
    name: "Qaarsut Airport",
    city: "Uummannaq",
    country: "Greenland",
    iata: "JQA",
    icao: "BGUQ",
    latitude: "70.7342",
    longitude: "-52.6962",
    altitude: "289",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5448",
    name: "Upernavik Airport",
    city: "Upernavik",
    country: "Greenland",
    iata: "JUV",
    icao: "BGUK",
    latitude: "72.7902",
    longitude: "-56.1306",
    altitude: "414",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5447",
    name: "Sisimiut Airport",
    city: "Sisimiut",
    country: "Greenland",
    iata: "JHS",
    icao: "BGSS",
    latitude: "66.9513",
    longitude: "-53.7293",
    altitude: "33",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5446",
    name: "Qaanaaq Airport",
    city: "Qaanaaq",
    country: "Greenland",
    iata: "NAQ",
    icao: "BGQQ",
    latitude: "77.4886",
    longitude: "-69.3887",
    altitude: "51",
    timezone: "-4",
    dst: "E",
    tz: "America/Thule",
  },
  {
    id: "5445",
    name: "Narsaq Heliport",
    city: "Narsaq",
    country: "Greenland",
    iata: "JNS",
    icao: "BGNS",
    latitude: "60.9167",
    longitude: "-46.0586",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5444",
    name: "Nanortalik Heliport",
    city: "Nanortalik",
    country: "Greenland",
    iata: "JNN",
    icao: "BGNN",
    latitude: "60.14",
    longitude: "-45.2317",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5443",
    name: "Maniitsoq Airport",
    city: "Maniitsoq",
    country: "Greenland",
    iata: "JSU",
    icao: "BGMQ",
    latitude: "65.4125",
    longitude: "-52.9394",
    altitude: "91",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5442",
    name: "Qaqortoq Heliport",
    city: "Qaqortoq",
    country: "Greenland",
    iata: "JJU",
    icao: "BGJH",
    latitude: "60.7158",
    longitude: "-46.0294",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5441",
    name: "Qeqertarsuaq Heliport",
    city: "Qeqertarsuaq Airport",
    country: "Greenland",
    iata: "JGO",
    icao: "BGGN",
    latitude: "69.2511",
    longitude: "-53.5381",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5440",
    name: "Paamiut Heliport",
    city: "Paamiut",
    country: "Greenland",
    iata: "JFR",
    icao: "BGFH",
    latitude: "61.9922",
    longitude: "-49.6625",
    altitude: "0",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5439",
    name: "Neerlerit Inaat Airport",
    city: "Neerlerit Inaat",
    country: "Greenland",
    iata: "CNP",
    icao: "BGCO",
    latitude: "70.7433",
    longitude: "-22.6606",
    altitude: "45",
    timezone: "-1",
    dst: "E",
    tz: "America/Scoresbysund",
  },
  {
    id: "5438",
    name: "Alluitsup Paa Heliport",
    city: "Alluitsup Paa",
    country: "Greenland",
    iata: "LLU",
    icao: "BGAP",
    latitude: "60.4644",
    longitude: "-45.5778",
    altitude: "89",
    timezone: "-3",
    dst: "E",
    tz: "America/Godthab",
  },
  {
    id: "5437",
    name: "Wapenamanda Airport",
    city: "Wapenamanda",
    country: "Papua New Guinea",
    iata: "WBM",
    icao: "AYWD",
    latitude: "-5.6433",
    longitude: "143.895",
    altitude: "5889",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5436",
    name: "Vanimo Airport",
    city: "Vanimo",
    country: "Papua New Guinea",
    iata: "VAI",
    icao: "AYVN",
    latitude: "-2.69717",
    longitude: "141.302",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5435",
    name: "Tokua Airport",
    city: "Tokua",
    country: "Papua New Guinea",
    iata: "RAB",
    icao: "AYTK",
    latitude: "-4.34046",
    longitude: "152.38",
    altitude: "32",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5434",
    name: "Tabubil Airport",
    city: "Tabubil",
    country: "Papua New Guinea",
    iata: "TBG",
    icao: "AYTB",
    latitude: "-5.27861",
    longitude: "141.226",
    altitude: "1570",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5433",
    name: "Tari Airport",
    city: "Tari",
    country: "Papua New Guinea",
    iata: "TIZ",
    icao: "AYTA",
    latitude: "-5.845",
    longitude: "142.948",
    altitude: "5500",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5432",
    name: "Misima Island Airport",
    city: "Misima Island",
    country: "Papua New Guinea",
    iata: "MIS",
    icao: "AYMS",
    latitude: "-10.6892",
    longitude: "152.838",
    altitude: "26",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5431",
    name: "Moro Airport",
    city: "Moro",
    country: "Papua New Guinea",
    iata: "MXH",
    icao: "AYMR",
    latitude: "-6.36333",
    longitude: "143.238",
    altitude: "2740",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5430",
    name: "Momote Airport",
    city: "Momote",
    country: "Papua New Guinea",
    iata: "MAS",
    icao: "AYMO",
    latitude: "-2.06189",
    longitude: "147.424",
    altitude: "12",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5429",
    name: "Mendi Airport",
    city: "Mendi",
    country: "Papua New Guinea",
    iata: "MDU",
    icao: "AYMN",
    latitude: "-6.14774",
    longitude: "143.657",
    altitude: "5680",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5428",
    name: "Kavieng Airport",
    city: "Kavieng",
    country: "Papua New Guinea",
    iata: "KVG",
    icao: "AYKV",
    latitude: "-2.5794",
    longitude: "150.808",
    altitude: "7",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5427",
    name: "Kerema Airport",
    city: "Kerema",
    country: "Papua New Guinea",
    iata: "KMA",
    icao: "AYKM",
    latitude: "-7.96361",
    longitude: "145.771",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5426",
    name: "Kikori Airport",
    city: "Kikori",
    country: "Papua New Guinea",
    iata: "KRI",
    icao: "AYKK",
    latitude: "-7.42438",
    longitude: "144.25",
    altitude: "50",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5425",
    name: "Kiunga Airport",
    city: "Kiunga",
    country: "Papua New Guinea",
    iata: "UNG",
    icao: "AYKI",
    latitude: "-6.12571",
    longitude: "141.282",
    altitude: "88",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5424",
    name: "Kimbe Airport",
    city: "Hoskins",
    country: "Papua New Guinea",
    iata: "HKN",
    icao: "AYHK",
    latitude: "-5.46217",
    longitude: "150.405",
    altitude: "66",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5423",
    name: "Girua Airport",
    city: "Girua",
    country: "Papua New Guinea",
    iata: "PNP",
    icao: "AYGR",
    latitude: "-8.80454",
    longitude: "148.309",
    altitude: "311",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5422",
    name: "Gurney Airport",
    city: "Gurney",
    country: "Papua New Guinea",
    iata: "GUR",
    icao: "AYGN",
    latitude: "-10.3115",
    longitude: "150.334",
    altitude: "88",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5421",
    name: "Daru Airport",
    city: "Daru",
    country: "Papua New Guinea",
    iata: "DAU",
    icao: "AYDU",
    latitude: "-9.08676",
    longitude: "143.208",
    altitude: "20",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5420",
    name: "Chimbu Airport",
    city: "Kundiawa",
    country: "Papua New Guinea",
    iata: "CMU",
    icao: "AYCH",
    latitude: "-6.02429",
    longitude: "144.971",
    altitude: "4974",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5419",
    name: "Buka Airport",
    city: "Buka Island",
    country: "Papua New Guinea",
    iata: "BUA",
    icao: "AYBK",
    latitude: "-5.42232",
    longitude: "154.673",
    altitude: "11",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "5418",
    name: "Ramata Airport",
    city: "Ramata",
    country: "Solomon Islands",
    iata: "RBV",
    icao: "AGRM",
    latitude: "-8.16806",
    longitude: "157.643",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5417",
    name: "Kagau Island Airport",
    city: "Kagau Island",
    country: "Solomon Islands",
    iata: "KGE",
    icao: "AGKG",
    latitude: "-7.333",
    longitude: "157.583",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5416",
    name: "Suavanao Airport",
    city: "Suavanao",
    country: "Solomon Islands",
    iata: "VAO",
    icao: "AGGV",
    latitude: "-7.58556",
    longitude: "158.731",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5415",
    name: "Marau Airport",
    city: "Marau",
    country: "Solomon Islands",
    iata: "RUS",
    icao: "AGGU",
    latitude: "-9.86167",
    longitude: "160.825",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5414",
    name: "Rennell/Tingoa Airport",
    city: "Rennell Island",
    country: "Solomon Islands",
    iata: "RNL",
    icao: "AGGR",
    latitude: "-11.5339",
    longitude: "160.063",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5413",
    name: "Mono Airport",
    city: "Stirling Island",
    country: "Solomon Islands",
    iata: "MNY",
    icao: "AGGO",
    latitude: "-7.41694",
    longitude: "155.565",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5412",
    name: "Nusatupe Airport",
    city: "Gizo",
    country: "Solomon Islands",
    iata: "GZO",
    icao: "AGGN",
    latitude: "-8.09778",
    longitude: "156.864",
    altitude: "13",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5411",
    name: "Munda Airport",
    city: "Munda",
    country: "Solomon Islands",
    iata: "MUA",
    icao: "AGGM",
    latitude: "-8.32797",
    longitude: "157.263",
    altitude: "10",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5410",
    name: "Santa Cruz/Graciosa Bay/Luova Airport",
    city: "Santa Cruz/Graciosa Bay/Luova",
    country: "Solomon Islands",
    iata: "SCZ",
    icao: "AGGL",
    latitude: "-10.7203",
    longitude: "165.795",
    altitude: "18",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5409",
    name: "Ngorangora Airport",
    city: "Kirakira",
    country: "Solomon Islands",
    iata: "IRA",
    icao: "AGGK",
    latitude: "-10.4497",
    longitude: "161.898",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5408",
    name: "Babanakira Airport",
    city: "Mbambanakira",
    country: "Solomon Islands",
    iata: "MBU",
    icao: "AGGI",
    latitude: "-9.7475",
    longitude: "159.839",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5407",
    name: "Fera/Maringe Airport",
    city: "Fera Island",
    country: "Solomon Islands",
    iata: "FRE",
    icao: "AGGF",
    latitude: "-8.1075",
    longitude: "159.577",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5406",
    name: "Ballalae Airport",
    city: "Ballalae",
    country: "Solomon Islands",
    iata: "BAS",
    icao: "AGGE",
    latitude: "-6.967",
    longitude: "155.883",
    altitude: "5",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5405",
    name: "Auki Airport",
    city: "Auki",
    country: "Solomon Islands",
    iata: "AKS",
    icao: "AGGA",
    latitude: "-8.70257",
    longitude: "160.682",
    altitude: "5",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "5404",
    name: "Uru Harbour Airport",
    city: "Atoifi",
    country: "Solomon Islands",
    iata: "ATD",
    icao: "AGAT",
    latitude: "-8.87333",
    longitude: "161.011",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "6097",
    name: "Komsomolsk-on-Amur Airport",
    city: "Komsomolsk-on-Amur",
    country: "Russia",
    iata: "KXK",
    icao: "UHKK",
    latitude: "50.4094",
    longitude: "136.934",
    altitude: "92",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "6096",
    name: "Moyo Airport",
    city: "Moyo",
    country: "Uganda",
    iata: "OYG",
    icao: "",
    latitude: "3.633",
    longitude: "31.75",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "6095",
    name: "Tiksi Airport",
    city: "Tiksi",
    country: "Russia",
    iata: "IKS",
    icao: "UEST",
    latitude: "71.6977",
    longitude: "128.903",
    altitude: "26",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "6094",
    name: "Cherskiy Airport",
    city: "Cherskiy",
    country: "Russia",
    iata: "CYX",
    icao: "UESS",
    latitude: "68.7406",
    longitude: "161.338",
    altitude: "20",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "6093",
    name: "Chokurdakh Airport",
    city: "Chokurdah",
    country: "Russia",
    iata: "CKH",
    icao: "UESO",
    latitude: "70.6231",
    longitude: "147.902",
    altitude: "151",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "6091",
    name: "Chulman",
    city: "Neryungri",
    country: "Russia",
    iata: "CNN",
    icao: "UELL",
    latitude: "56.9139",
    longitude: "124.914",
    altitude: "2812",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "6088",
    name: "Kostanay West Airport",
    city: "Kostanay",
    country: "Kazakhstan",
    iata: "KSN",
    icao: "UAUU",
    latitude: "53.206944",
    longitude: "63.550278",
    altitude: "595",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "6085",
    name: "Zhezkazgan Airport",
    city: "Zhezkazgan",
    country: "Kazakhstan",
    iata: "DZN",
    icao: "UAKD",
    latitude: "47.708333",
    longitude: "67.733333",
    altitude: "1250",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "6083",
    name: "Kokshetau Airport",
    city: "Kokshetau",
    country: "Kazakhstan",
    iata: "KOV",
    icao: "UACK",
    latitude: "53.3291",
    longitude: "69.5946",
    altitude: "900",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "6082",
    name: "Union Island International Airport",
    city: "Union Island",
    country: "Saint Vincent and the Grenadines",
    iata: "UNI",
    icao: "TVSU",
    latitude: "12.583",
    longitude: "-61.417",
    altitude: "16",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Vincent",
  },
  {
    id: "6081",
    name: "J F Mitchell Airport",
    city: "Bequia",
    country: "Saint Vincent and the Grenadines",
    iata: "BQU",
    icao: "TVSB",
    latitude: "12.988444",
    longitude: "-61.262033",
    altitude: "15",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Vincent",
  },
  {
    id: "6080",
    name: "Virgin Gorda Airport",
    city: "Spanish Town",
    country: "British Virgin Islands",
    iata: "VIJ",
    icao: "TUPW",
    latitude: "18.4464",
    longitude: "-64.4275",
    altitude: "9",
    timezone: "-4",
    dst: "U",
    tz: "America/Tortola",
  },
  {
    id: "6079",
    name: "Vance Winkworth Amory International Airport",
    city: "Charlestown",
    country: "Saint Kitts and Nevis",
    iata: "NEV",
    icao: "TKPN",
    latitude: "17.205678",
    longitude: "-62.589869",
    altitude: "14",
    timezone: "-4",
    dst: "U",
    tz: "America/St_Kitts",
  },
  {
    id: "6076",
    name: "Baillif Airport",
    city: "Basse Terre",
    country: "Guadeloupe",
    iata: "BBR",
    icao: "TFFB",
    latitude: "16.0133",
    longitude: "-61.7422",
    altitude: "59",
    timezone: "-4",
    dst: "U",
    tz: "America/Guadeloupe",
  },
  {
    id: "6075",
    name: "La Désirade Airport",
    city: "Grande Anse",
    country: "Guadeloupe",
    iata: "DSD",
    icao: "TFFA",
    latitude: "16.2969",
    longitude: "-61.0844",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guadeloupe",
  },
  {
    id: "6072",
    name: "Juan Pablo Pérez Alfonso Airport",
    city: "El Vigía",
    country: "Venezuela",
    iata: "VIG",
    icao: "SVVG",
    latitude: "8.6241",
    longitude: "-71.672819",
    altitude: "250",
    timezone: "-4.5",
    dst: "U",
    tz: "America/Caracas",
  },
  {
    id: "6070",
    name: "El Jaguel / Punta del Este Airport",
    city: "Maldonado",
    country: "Uruguay",
    iata: "MDO",
    icao: "SUPE",
    latitude: "-34.917",
    longitude: "-54.917",
    altitude: "66",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "6069",
    name: "Santa Rosa Airport",
    city: "Santa Rosa",
    country: "Brazil",
    iata: "SRA",
    icao: "SSZR",
    latitude: "-27.9067",
    longitude: "-54.5204",
    altitude: "984",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6067",
    name: "Alferez Fap David Figueroa Fernandini Airport",
    city: "Huánuco",
    country: "Peru",
    iata: "HUU",
    icao: "SPNC",
    latitude: "-9.878811",
    longitude: "-76.204797",
    altitude: "6070",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6065",
    name: "Caballococha Airport",
    city: "Caballococha",
    country: "Peru",
    iata: "LHC",
    icao: "SPBC",
    latitude: "-3.916858",
    longitude: "-70.508225",
    altitude: "328",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6060",
    name: "Capitán Av. German Quiroga G. Airport",
    city: "San Borja",
    country: "Bolivia",
    iata: "SRJ",
    icao: "SLSB",
    latitude: "-14.8592",
    longitude: "-66.7375",
    altitude: "633",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "6058",
    name: "Capitán Av. Selin Zeitun Lopez Airport",
    city: "Riberalta",
    country: "Bolivia",
    iata: "RIB",
    icao: "SLRI",
    latitude: "-11",
    longitude: "-66",
    altitude: "462",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "6056",
    name: "Capitán de Av. Emilio Beltrán Airport",
    city: "Guayaramerín",
    country: "Bolivia",
    iata: "GYA",
    icao: "SLGY",
    latitude: "-10.8206",
    longitude: "-65.3456",
    altitude: "557",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "6054",
    name: "Obando Airport",
    city: "Puerto Inírida",
    country: "Colombia",
    iata: "PDA",
    icao: "SKPD",
    latitude: "3.85",
    longitude: "-67.91",
    altitude: "460",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6053",
    name: "Reyes Murillo Airport",
    city: "Nuquí",
    country: "Colombia",
    iata: "NQU",
    icao: "SKNQ",
    latitude: "5.7",
    longitude: "-77.28",
    altitude: "12",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6052",
    name: "La Pedrera Airport",
    city: "La Pedrera",
    country: "Colombia",
    iata: "LPD",
    icao: "SKLP",
    latitude: "-1.33",
    longitude: "-69.58",
    altitude: "590",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6051",
    name: "Caucaya Airport",
    city: "Puerto Leguízamo",
    country: "Colombia",
    iata: "LQM",
    icao: "SKLG",
    latitude: "-0.18",
    longitude: "-74.77",
    altitude: "573",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6050",
    name: "La Jagua Airport",
    city: "Garzón",
    country: "Colombia",
    iata: "GLJ",
    icao: "SKGZ",
    latitude: "2.17",
    longitude: "-75.67",
    altitude: "2620",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6049",
    name: "Santa Ana Airport",
    city: "Cartago",
    country: "Colombia",
    iata: "CRC",
    icao: "SKGO",
    latitude: "4.758181",
    longitude: "-75.955753",
    altitude: "2979",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6048",
    name: "Stanley Airport",
    city: "Stanley",
    country: "Falkland Islands",
    iata: "PSY",
    icao: "SFAL",
    latitude: "-51.685672",
    longitude: "-57.777644",
    altitude: "75",
    timezone: "-3",
    dst: "U",
    tz: "Atlantic/Stanley",
  },
  {
    id: "6046",
    name: "Camilo Ponce Enriquez Airport",
    city: "La Toma (Catamayo)",
    country: "Ecuador",
    iata: "LOH",
    icao: "SETM",
    latitude: "-3.99589",
    longitude: "-79.3719",
    altitude: "4056",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "6045",
    name: "San Cristóbal Airport",
    city: "San Cristóbal",
    country: "Ecuador",
    iata: "SCY",
    icao: "SEST",
    latitude: "-0.910206",
    longitude: "-89.61745",
    altitude: "62",
    timezone: "-6",
    dst: "U",
    tz: "Pacific/Galapagos",
  },
  {
    id: "6044",
    name: "Sorocaba Airport",
    city: "Sorocaba",
    country: "Brazil",
    iata: "SOD",
    icao: "SDCO",
    latitude: "-23.478",
    longitude: "-47.49",
    altitude: "2077",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6042",
    name: "Ricardo García Posada Airport",
    city: "El Salvador",
    country: "Chile",
    iata: "ESR",
    icao: "SCES",
    latitude: "-26.3111",
    longitude: "-69.7652",
    altitude: "5240",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "6039",
    name: "Vitória da Conquista Airport",
    city: "Vitória Da Conquista",
    country: "Brazil",
    iata: "VDC",
    icao: "SBQV",
    latitude: "-14.862761",
    longitude: "-40.863106",
    altitude: "2998",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "6038",
    name: "Marília Airport",
    city: "Marília",
    country: "Brazil",
    iata: "MII",
    icao: "SBML",
    latitude: "-22.196892",
    longitude: "-49.9264",
    altitude: "2122",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6037",
    name: "Macaé Airport",
    city: "Macaé",
    country: "Brazil",
    iata: "MEA",
    icao: "SBME",
    latitude: "-22.343",
    longitude: "-41.766",
    altitude: "8",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6033",
    name: "Necochea Airport",
    city: "Necochea",
    country: "Argentina",
    iata: "NEC",
    icao: "SAZO",
    latitude: "-38.483056",
    longitude: "-58.817222",
    altitude: "72",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6030",
    name: "Lago Argentino Airport",
    city: "El Calafate",
    country: "Argentina",
    iata: "ING",
    icao: "SAWA",
    latitude: "-50.3361",
    longitude: "-72.2486",
    altitude: "732",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "6026",
    name: "Roxas Airport",
    city: "Roxas City",
    country: "Philippines",
    iata: "RXS",
    icao: "RPVR",
    latitude: "11.597669",
    longitude: "122.751669",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6023",
    name: "Calbayog Airport",
    city: "Calbayog City",
    country: "Philippines",
    iata: "CYP",
    icao: "RPVC",
    latitude: "12.072706",
    longitude: "124.545092",
    altitude: "12",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6022",
    name: "Virac Airport",
    city: "Virac",
    country: "Philippines",
    iata: "VRC",
    icao: "RPUV",
    latitude: "13.576439",
    longitude: "124.205672",
    altitude: "121",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6021",
    name: "Tuguegarao Airport",
    city: "Tuguegarao",
    country: "Philippines",
    iata: "TUG",
    icao: "RPUT",
    latitude: "17.638311",
    longitude: "121.730614",
    altitude: "70",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6020",
    name: "San Fernando Airport",
    city: "San Fernando",
    country: "Philippines",
    iata: "SFE",
    icao: "RPUS",
    latitude: "16.595589",
    longitude: "120.303219",
    altitude: "13",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6019",
    name: "Basco Airport",
    city: "Basco",
    country: "Philippines",
    iata: "BSO",
    icao: "RPUO",
    latitude: "20.451322",
    longitude: "121.979883",
    altitude: "291",
    timezone: "8",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "6018",
    name: "Naga Airport",
    city: "Naga",
    country: "Philippines",
    iata: "WNP",
    icao: "RPUN",
    latitude: "13.584886",
    longitude: "123.270239",
    altitude: "142",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6017",
    name: "Tandag Airport",
    city: "Tandag",
    country: "Philippines",
    iata: "TDG",
    icao: "RPMW",
    latitude: "9.07211",
    longitude: "126.171",
    altitude: "16",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6016",
    name: "Surigao Airport",
    city: "Sangley Point",
    country: "Philippines",
    iata: "SUG",
    icao: "RPMS",
    latitude: "9.757567",
    longitude: "125.479328",
    altitude: "20",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6507",
    name: "Fremont Airport",
    city: "Fremont",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.3331",
    longitude: "-83.1612",
    altitude: "663",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6014",
    name: "Sanga Sanga Airport",
    city: "Sanga Sanga",
    country: "Philippines",
    iata: "SGS",
    icao: "RPMN",
    latitude: "5.04699",
    longitude: "119.743",
    altitude: "15",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6011",
    name: "General Santos International Airport",
    city: "General Santos City",
    country: "Philippines",
    iata: "GES",
    icao: "RPMB",
    latitude: "6.106439",
    longitude: "125.2353",
    altitude: "28",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6009",
    name: "Subic Bay International Airport",
    city: "Olongapo City",
    country: "Philippines",
    iata: "SFS",
    icao: "RPLB",
    latitude: "14.7944",
    longitude: "120.271",
    altitude: "64",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6006",
    name: "Yangyang International Airport",
    city: "Sokcho / Gangneung",
    country: "South Korea",
    iata: "YNY",
    icao: "RKNY",
    latitude: "38.061311",
    longitude: "128.669164",
    altitude: "241",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "6098",
    name: "Ugolny Airport",
    city: "Anadyr",
    country: "Russia",
    iata: "DYR",
    icao: "UHMA",
    latitude: "64.73495",
    longitude: "177.741483",
    altitude: "194",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "6099",
    name: "Okhotsk Airport",
    city: "Okhotsk",
    country: "Russia",
    iata: "OHO",
    icao: "UHOO",
    latitude: "59.4101",
    longitude: "143.057",
    altitude: "0",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "6100",
    name: "Ujae Atoll Airport",
    city: "Ujae Atoll",
    country: "Marshall Islands",
    iata: "UJE",
    icao: "UJAP",
    latitude: "8.92806",
    longitude: "165.762",
    altitude: "0",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "6101",
    name: "Mariupol International Airport",
    city: "Mariupol International",
    country: "Ukraine",
    iata: "MPW",
    icao: "UKCM",
    latitude: "47.0761",
    longitude: "37.4496",
    altitude: "251",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6102",
    name: "Luhansk International Airport",
    city: "Lugansk",
    country: "Ukraine",
    iata: "VSG",
    icao: "UKCW",
    latitude: "48.4174",
    longitude: "39.3741",
    altitude: "636",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6103",
    name: "Zaporizhzhia International Airport",
    city: "Zaporozhye",
    country: "Ukraine",
    iata: "OZH",
    icao: "UKDE",
    latitude: "47.867",
    longitude: "35.3157",
    altitude: "373",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6104",
    name: "Lozuvatka International Airport",
    city: "Krivoy Rog",
    country: "Ukraine",
    iata: "KWG",
    icao: "UKDR",
    latitude: "48.0433",
    longitude: "33.21",
    altitude: "408",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6105",
    name: "Osnova International Airport",
    city: "Kharkov",
    country: "Ukraine",
    iata: "HRK",
    icao: "UKHH",
    latitude: "49.924786",
    longitude: "36.289986",
    altitude: "508",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6106",
    name: "Ivano Frankivsk International Airport",
    city: "Ivano-Frankivsk",
    country: "Ukraine",
    iata: "IFO",
    icao: "UKLI",
    latitude: "48.884167",
    longitude: "24.686111",
    altitude: "919",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6107",
    name: "Chernivtsi International Airport",
    city: "Chernovtsk",
    country: "Ukraine",
    iata: "CWC",
    icao: "UKLN",
    latitude: "48.259322",
    longitude: "25.980831",
    altitude: "826",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6108",
    name: "Rivne International Airport",
    city: "Rivne",
    country: "Ukraine",
    iata: "RWN",
    icao: "UKLR",
    latitude: "50.6071",
    longitude: "26.1416",
    altitude: "755",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6109",
    name: "Uzhhorod International Airport",
    city: "Uzhgorod",
    country: "Ukraine",
    iata: "UDJ",
    icao: "UKLU",
    latitude: "48.634278",
    longitude: "22.263356",
    altitude: "383",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6110",
    name: "Solovki Airport",
    city: "Solovetsky Islands",
    country: "Russia",
    iata: "CSH",
    icao: "ULAS",
    latitude: "65.03",
    longitude: "35.7333",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6111",
    name: "Cherepovets Airport",
    city: "Cherepovets",
    country: "Russia",
    iata: "CEE",
    icao: "ULBC",
    latitude: "59.2736",
    longitude: "38.0158",
    altitude: "377",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6112",
    name: "Amderma Airport",
    city: "Amderma",
    country: "Russia",
    iata: "AMV",
    icao: "ULDD",
    latitude: "69.7633",
    longitude: "61.5564",
    altitude: "13",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6113",
    name: "Kotlas Airport",
    city: "Kotlas",
    country: "Russia",
    iata: "KSZ",
    icao: "ULKK",
    latitude: "61.2358",
    longitude: "46.6975",
    altitude: "184",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6114",
    name: "Petrozavodsk Airport",
    city: "Petrozavodsk",
    country: "Russia",
    iata: "PES",
    icao: "ULPB",
    latitude: "61.8852",
    longitude: "34.1547",
    altitude: "151",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6115",
    name: "Hrodno Airport",
    city: "Hrodna",
    country: "Belarus",
    iata: "GNA",
    icao: "UMMG",
    latitude: "53.602",
    longitude: "24.0538",
    altitude: "443",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "6116",
    name: "Mogilev Airport",
    city: "Mogilev",
    country: "Belarus",
    iata: "MVQ",
    icao: "UMOO",
    latitude: "53.9549",
    longitude: "30.0951",
    altitude: "637",
    timezone: "3",
    dst: "E",
    tz: "Europe/Minsk",
  },
  {
    id: "6117",
    name: "Yeniseysk Airport",
    city: "Yeniseysk",
    country: "Russia",
    iata: "EIE",
    icao: "UNII",
    latitude: "58.4742",
    longitude: "92.1125",
    altitude: "253",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "6118",
    name: "Kyzyl Airport",
    city: "Kyzyl",
    country: "Russia",
    iata: "KYZ",
    icao: "UNKY",
    latitude: "51.6694",
    longitude: "94.4006",
    altitude: "2123",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "6119",
    name: "Spichenkovo Airport",
    city: "Novokuznetsk",
    country: "Russia",
    iata: "NOZ",
    icao: "UNWW",
    latitude: "53.8114",
    longitude: "86.8772",
    altitude: "1024",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "6120",
    name: "Khatanga Airport",
    city: "Khatanga",
    country: "Russia",
    iata: "HTG",
    icao: "UOHH",
    latitude: "71.978058",
    longitude: "102.490514",
    altitude: "95",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "6121",
    name: "Igarka Airport",
    city: "Igarka",
    country: "Russia",
    iata: "IAA",
    icao: "UOII",
    latitude: "67.4372",
    longitude: "86.6219",
    altitude: "82",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "6122",
    name: "Grozny Airport",
    city: "Grozny",
    country: "Russia",
    iata: "GRV",
    icao: "URMG",
    latitude: "43.2981",
    longitude: "45.7841",
    altitude: "548",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6123",
    name: "Nalchik Airport",
    city: "Nalchik",
    country: "Russia",
    iata: "NAL",
    icao: "URMN",
    latitude: "43.5129",
    longitude: "43.6366",
    altitude: "1461",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6124",
    name: "Beslan Airport",
    city: "Beslan",
    country: "Russia",
    iata: "OGZ",
    icao: "URMO",
    latitude: "43.2051",
    longitude: "44.6066",
    altitude: "1673",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6125",
    name: "Elista Airport",
    city: "Elista",
    country: "Russia",
    iata: "ESL",
    icao: "URWI",
    latitude: "46.3739",
    longitude: "44.3309",
    altitude: "501",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6126",
    name: "Aleknagik Airport",
    city: "Aleknagik",
    country: "United States",
    iata: "WKK",
    icao: "5A8",
    latitude: "59.2826",
    longitude: "-158.618",
    altitude: "66",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6127",
    name: "Brookings Regional Airport",
    city: "Brookings",
    country: "United States",
    iata: "BKX",
    icao: "BKX",
    latitude: "44.3048",
    longitude: "-96.8169",
    altitude: "1648",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6128",
    name: "Mercer County Airport",
    city: "Bluefield",
    country: "United States",
    iata: "BLF",
    icao: "BLF",
    latitude: "37.2958",
    longitude: "-81.2077",
    altitude: "2857",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6129",
    name: "Kearney Municipal Airport",
    city: "Kearney",
    country: "United States",
    iata: "EAR",
    icao: "EAR",
    latitude: "40.727",
    longitude: "-99.0068",
    altitude: "2131",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6130",
    name: "Mid Delta Regional Airport",
    city: "Greenville",
    country: "United States",
    iata: "GLH",
    icao: "GLH",
    latitude: "33.4829",
    longitude: "-90.9856",
    altitude: "131",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6131",
    name: "Laughlin-Bullhead Intl",
    city: "Bullhead",
    country: "United States",
    iata: "IFP",
    icao: "IFP",
    latitude: "35.1574",
    longitude: "-114.56",
    altitude: "695",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "6132",
    name: "Kingman Airport",
    city: "Kingman",
    country: "United States",
    iata: "IGM",
    icao: "IGM",
    latitude: "35.2595",
    longitude: "-113.938",
    altitude: "3449",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "6133",
    name: "Tri Cities Airport",
    city: "Pasco",
    country: "United States",
    iata: "PSC",
    icao: "PSC",
    latitude: "46.2647",
    longitude: "-119.119",
    altitude: "410",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6134",
    name: "Akutan Seaplane Base",
    city: "Akutan",
    country: "United States",
    iata: "KQA",
    icao: "KQA",
    latitude: "54.1325",
    longitude: "-165.785",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6135",
    name: "Grant County Airport",
    city: "Silver City",
    country: "United States",
    iata: "SVC",
    icao: "SVC",
    latitude: "32.6365",
    longitude: "-108.156",
    altitude: "5446",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "6136",
    name: "Lopez Island Airport",
    city: "Lopez",
    country: "United States",
    iata: "LPS",
    icao: "S31",
    latitude: "48.4839",
    longitude: "-122.938",
    altitude: "209",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6137",
    name: "Salekhard Airport",
    city: "Salekhard",
    country: "Russia",
    iata: "SLY",
    icao: "USDD",
    latitude: "66.590753",
    longitude: "66.611042",
    altitude: "218",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6138",
    name: "Khanty Mansiysk Airport",
    city: "Khanty-Mansiysk",
    country: "Russia",
    iata: "HMA",
    icao: "USHH",
    latitude: "61.028479",
    longitude: "69.086067",
    altitude: "76",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6139",
    name: "Nyagan Airport",
    city: "Nyagan",
    country: "Russia",
    iata: "NYA",
    icao: "USHN",
    latitude: "62.11",
    longitude: "65.615",
    altitude: "361",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6140",
    name: "Sovetsky Tyumenskaya Airport",
    city: "Sovetskiy",
    country: "Russia",
    iata: "OVS",
    icao: "USHS",
    latitude: "61.32",
    longitude: "63.6044",
    altitude: "351",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6141",
    name: "Izhevsk Airport",
    city: "Izhevsk",
    country: "Russia",
    iata: "IJK",
    icao: "USII",
    latitude: "56.8281",
    longitude: "53.4575",
    altitude: "531",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6142",
    name: "Pobedilovo Airport",
    city: "Kirov",
    country: "Russia",
    iata: "KVX",
    icao: "USKK",
    latitude: "58.5033",
    longitude: "49.3483",
    altitude: "479",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6143",
    name: "Nadym Airport",
    city: "Nadym",
    country: "Russia",
    iata: "NYM",
    icao: "USMM",
    latitude: "65.4809",
    longitude: "72.6989",
    altitude: "49",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6144",
    name: "Raduzhny Airport",
    city: "Raduzhnyi",
    country: "Russia",
    iata: "RAT",
    icao: "USNR",
    latitude: "62.1586",
    longitude: "77.3289",
    altitude: "250",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6145",
    name: "Nefteyugansk Airport",
    city: "Nefteyugansk",
    country: "Russia",
    iata: "NFG",
    icao: "USRN",
    latitude: "61.1083",
    longitude: "72.65",
    altitude: "115",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6146",
    name: "Kurgan Airport",
    city: "Kurgan",
    country: "Russia",
    iata: "KRO",
    icao: "USUU",
    latitude: "55.4753",
    longitude: "65.4156",
    altitude: "240",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6147",
    name: "Khudzhand Airport",
    city: "Khudzhand",
    country: "Tajikistan",
    iata: "LBD",
    icao: "UTDL",
    latitude: "40.2154",
    longitude: "69.6947",
    altitude: "1450",
    timezone: "5",
    dst: "U",
    tz: "Asia/Dushanbe",
  },
  {
    id: "6148",
    name: "Andizhan Airport",
    city: "Andizhan",
    country: "Uzbekistan",
    iata: "AZN",
    icao: "UTKA",
    latitude: "40.7277",
    longitude: "72.294",
    altitude: "1515",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6149",
    name: "Fergana Airport",
    city: "Fergana",
    country: "Uzbekistan",
    iata: "FEG",
    icao: "UTKF",
    latitude: "40.3588",
    longitude: "71.745",
    altitude: "1980",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6150",
    name: "Namangan Airport",
    city: "Namangan",
    country: "Uzbekistan",
    iata: "NMA",
    icao: "UTKN",
    latitude: "40.9846",
    longitude: "71.5567",
    altitude: "1555",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6151",
    name: "Nukus Airport",
    city: "Nukus",
    country: "Uzbekistan",
    iata: "NCU",
    icao: "UTNN",
    latitude: "42.4884",
    longitude: "59.6233",
    altitude: "246",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6152",
    name: "Urgench Airport",
    city: "Urgench",
    country: "Uzbekistan",
    iata: "UGC",
    icao: "UTNU",
    latitude: "41.5843",
    longitude: "60.6417",
    altitude: "320",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6153",
    name: "Karshi Khanabad Airport",
    city: "Khanabad",
    country: "Uzbekistan",
    iata: "KSQ",
    icao: "UTSL",
    latitude: "38.8336",
    longitude: "65.9215",
    altitude: "1365",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6154",
    name: "Termez Airport",
    city: "Termez",
    country: "Uzbekistan",
    iata: "TMJ",
    icao: "UTST",
    latitude: "37.286667",
    longitude: "67.31",
    altitude: "1027",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6155",
    name: "Staroselye Airport",
    city: "Rybinsk",
    country: "Russia",
    iata: "RYB",
    icao: "UUBK",
    latitude: "58.1042",
    longitude: "38.9294",
    altitude: "423",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6156",
    name: "Belgorod International Airport",
    city: "Belgorod",
    country: "Russia",
    iata: "EGO",
    icao: "UUOB",
    latitude: "50.6438",
    longitude: "36.5901",
    altitude: "735",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6157",
    name: "Kursk East Airport",
    city: "Kursk",
    country: "Russia",
    iata: "URS",
    icao: "UUOK",
    latitude: "51.7506",
    longitude: "36.2956",
    altitude: "686",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6158",
    name: "Lipetsk Airport",
    city: "Lipetsk",
    country: "Russia",
    iata: "LPK",
    icao: "UUOL",
    latitude: "52.7028",
    longitude: "39.5378",
    altitude: "584",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6159",
    name: "Vorkuta Airport",
    city: "Vorkuta",
    country: "Russia",
    iata: "VKT",
    icao: "UUYW",
    latitude: "67.4886",
    longitude: "63.9931",
    altitude: "604",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6160",
    name: "Bugulma Airport",
    city: "Bugulma",
    country: "Russia",
    iata: "UUA",
    icao: "UWKB",
    latitude: "54.64",
    longitude: "52.8017",
    altitude: "991",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6161",
    name: "Yoshkar-Ola Airport",
    city: "Yoshkar-Ola",
    country: "Russia",
    iata: "JOK",
    icao: "UWKJ",
    latitude: "56.7006",
    longitude: "47.9047",
    altitude: "348",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6162",
    name: "Cheboksary Airport",
    city: "Cheboksary",
    country: "Russia",
    iata: "CSY",
    icao: "UWKS",
    latitude: "56.0903",
    longitude: "47.3473",
    altitude: "558",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6163",
    name: "Ulyanovsk East Airport",
    city: "Ulyanovsk",
    country: "Russia",
    iata: "ULY",
    icao: "UWLW",
    latitude: "54.401",
    longitude: "48.8027",
    altitude: "252",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6164",
    name: "Orsk Airport",
    city: "Orsk",
    country: "Russia",
    iata: "OSW",
    icao: "UWOR",
    latitude: "51.0725",
    longitude: "58.5956",
    altitude: "909",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6165",
    name: "Penza Airport",
    city: "Penza",
    country: "Russia",
    iata: "PEZ",
    icao: "UWPP",
    latitude: "53.1106",
    longitude: "45.0211",
    altitude: "614",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6166",
    name: "Saransk Airport",
    city: "Saransk",
    country: "Russia",
    iata: "SKX",
    icao: "UWPS",
    latitude: "54.1251",
    longitude: "45.2123",
    altitude: "676",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6167",
    name: "Balakovo Airport",
    city: "Balakovo",
    country: "Russia",
    iata: "BWO",
    icao: "UWSB",
    latitude: "51.8583",
    longitude: "47.7456",
    altitude: "95",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6168",
    name: "Hubli Airport",
    city: "Hubli",
    country: "India",
    iata: "HBX",
    icao: "VAHB",
    latitude: "15.3617",
    longitude: "75.0849",
    altitude: "2171",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6169",
    name: "Koggala Airport",
    city: "Koggala",
    country: "Sri Lanka",
    iata: "KCT",
    icao: "VCCK",
    latitude: "5.99368",
    longitude: "80.3203",
    altitude: "10",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "6170",
    name: "Wirawila Airport",
    city: "Wirawila",
    country: "Sri Lanka",
    iata: "WRZ",
    icao: "VCCW",
    latitude: "6.254494",
    longitude: "81.235189",
    altitude: "50",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "6171",
    name: "Battambang Airport",
    city: "Battambang",
    country: "Cambodia",
    iata: "BBM",
    icao: "VDBG",
    latitude: "13.0956",
    longitude: "103.224",
    altitude: "59",
    timezone: "7",
    dst: "U",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "6172",
    name: "Shillong Airport",
    city: "Shillong",
    country: "India",
    iata: "SHL",
    icao: "VEBI",
    latitude: "25.7036",
    longitude: "91.9787",
    altitude: "2910",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6173",
    name: "Lokpriya Gopinath Bordoloi International Airport",
    city: "Guwahati",
    country: "India",
    iata: "GAU",
    icao: "VEGT",
    latitude: "26.106092",
    longitude: "91.585939",
    altitude: "162",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6174",
    name: "Dimapur Airport",
    city: "Dimapur",
    country: "India",
    iata: "DMU",
    icao: "VEMR",
    latitude: "25.8839",
    longitude: "93.7711",
    altitude: "487",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6175",
    name: "Tezpur Airport",
    city: "Tezpur",
    country: "India",
    iata: "TEZ",
    icao: "VETZ",
    latitude: "26.7091",
    longitude: "92.7847",
    altitude: "240",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6176",
    name: "Barisal Airport",
    city: "Barisal",
    country: "Bangladesh",
    iata: "BZL",
    icao: "VGBR",
    latitude: "22.801",
    longitude: "90.3012",
    altitude: "23",
    timezone: "6",
    dst: "U",
    tz: "Asia/Dhaka",
  },
  {
    id: "6177",
    name: "Ban Huoeisay Airport",
    city: "Huay Xai",
    country: "Laos",
    iata: "OUI",
    icao: "VLHS",
    latitude: "20.2573",
    longitude: "100.437",
    altitude: "1380",
    timezone: "7",
    dst: "N",
    tz: "Asia/Vientiane",
  },
  {
    id: "6178",
    name: "Kontum Airport",
    city: "Kontum",
    country: "Vietnam",
    iata: "KON",
    icao: "",
    latitude: "14.35",
    longitude: "108.017",
    altitude: "1804",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6179",
    name: "Bharatpur Airport",
    city: "Bharatpur",
    country: "Nepal",
    iata: "BHR",
    icao: "VNBP",
    latitude: "27.6781",
    longitude: "84.4294",
    altitude: "600",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "6180",
    name: "Chandragadhi Airport",
    city: "Chandragarhi",
    country: "Nepal",
    iata: "BDP",
    icao: "VNCG",
    latitude: "26.570822",
    longitude: "88.079578",
    altitude: "300",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "6181",
    name: "Meghauli Airport",
    city: "Meghauli",
    country: "Nepal",
    iata: "MEY",
    icao: "VNMG",
    latitude: "27.583",
    longitude: "84.233",
    altitude: "600",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "6182",
    name: "Nepalgunj Airport",
    city: "Nepalgunj",
    country: "Nepal",
    iata: "KEP",
    icao: "VNNG",
    latitude: "28.103633",
    longitude: "81.667006",
    altitude: "540",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "6183",
    name: "Gan Island Airport",
    city: "Gan Island",
    country: "Maldives",
    iata: "GAN",
    icao: "VRMG",
    latitude: "-0.693342",
    longitude: "73.1556",
    altitude: "6",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "6184",
    name: "Hanimaadhoo Airport",
    city: "Haa Dhaalu Atoll",
    country: "Maldives",
    iata: "HAQ",
    icao: "VRMH",
    latitude: "6.74423",
    longitude: "73.1705",
    altitude: "4",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "6185",
    name: "Kadhdhoo Airport",
    city: "Laamu Atoll",
    country: "Maldives",
    iata: "KDO",
    icao: "VRMK",
    latitude: "1.85917",
    longitude: "73.5219",
    altitude: "4",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "6186",
    name: "Mae Sot Airport",
    city: "Tak",
    country: "Thailand",
    iata: "MAQ",
    icao: "VTPM",
    latitude: "16.699856",
    longitude: "98.545056",
    altitude: "690",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "6187",
    name: "Buon Ma Thuot Airport",
    city: "Buonmethuot",
    country: "Vietnam",
    iata: "BMV",
    icao: "VVBM",
    latitude: "12.668311",
    longitude: "108.120272",
    altitude: "1729",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6188",
    name: "Cat Bi International Airport",
    city: "Haiphong",
    country: "Vietnam",
    iata: "HPH",
    icao: "VVCI",
    latitude: "20.819386",
    longitude: "106.724989",
    altitude: "6",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6189",
    name: "Cam Ranh Airport",
    city: "Nha Trang",
    country: "Vietnam",
    iata: "CXR",
    icao: "VVCR",
    latitude: "11.998153",
    longitude: "109.219372",
    altitude: "40",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6190",
    name: "Co Ong Airport",
    city: "Conson",
    country: "Vietnam",
    iata: "VCS",
    icao: "VVCS",
    latitude: "8.731831",
    longitude: "106.632589",
    altitude: "20",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6191",
    name: "Trà Nóc Airport",
    city: "Can Tho",
    country: "Vietnam",
    iata: "VCA",
    icao: "VVCT",
    latitude: "10.085119",
    longitude: "105.711922",
    altitude: "9",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6192",
    name: "Dien Bien Phu Airport",
    city: "Dienbienphu",
    country: "Vietnam",
    iata: "DIN",
    icao: "VVDB",
    latitude: "21.397481",
    longitude: "103.007831",
    altitude: "1611",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6193",
    name: "Phu Cat Airport",
    city: "Phucat",
    country: "Vietnam",
    iata: "UIH",
    icao: "VVPC",
    latitude: "13.954986",
    longitude: "109.042267",
    altitude: "80",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6194",
    name: "Pleiku Airport",
    city: "Pleiku",
    country: "Vietnam",
    iata: "PXU",
    icao: "VVPK",
    latitude: "14.004522",
    longitude: "108.017158",
    altitude: "2434",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6195",
    name: "Vinh Airport",
    city: "Vinh",
    country: "Vietnam",
    iata: "VII",
    icao: "VVVH",
    latitude: "18.737569",
    longitude: "105.670764",
    altitude: "23",
    timezone: "7",
    dst: "U",
    tz: "Asia/Saigon",
  },
  {
    id: "6196",
    name: "Banmaw Airport",
    city: "Banmaw",
    country: "Burma",
    iata: "BMO",
    icao: "VYBM",
    latitude: "24.269033",
    longitude: "97.246153",
    altitude: "370",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6197",
    name: "Dawei Airport",
    city: "Dawei",
    country: "Burma",
    iata: "TVY",
    icao: "VYDW",
    latitude: "14.103886",
    longitude: "98.203636",
    altitude: "84",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6198",
    name: "Kawthoung Airport",
    city: "Kawthoung",
    country: "Burma",
    iata: "KAW",
    icao: "VYKT",
    latitude: "10.049258",
    longitude: "98.538006",
    altitude: "180",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6199",
    name: "Loikaw Airport",
    city: "Loikaw",
    country: "Burma",
    iata: "LIW",
    icao: "VYLK",
    latitude: "19.691494",
    longitude: "97.214825",
    altitude: "2940",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6200",
    name: "Mawlamyine Airport",
    city: "Mawlamyine",
    country: "Burma",
    iata: "MNU",
    icao: "VYMM",
    latitude: "16.444747",
    longitude: "97.660669",
    altitude: "52",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6201",
    name: "Pathein Airport",
    city: "Pathein",
    country: "Burma",
    iata: "BSX",
    icao: "VYPN",
    latitude: "16.815233",
    longitude: "94.779911",
    altitude: "20",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6202",
    name: "Pakhokku Airport",
    city: "Pakhokku",
    country: "Burma",
    iata: "PKK",
    icao: "VYPU",
    latitude: "21.3333",
    longitude: "95.1",
    altitude: "151",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6203",
    name: "Sumbawa Besar Airport",
    city: "Sumbawa Island",
    country: "Indonesia",
    iata: "SWQ",
    icao: "WADS",
    latitude: "-8.489039",
    longitude: "117.412119",
    altitude: "16",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6204",
    name: "Tambolaka Airport",
    city: "Waikabubak-Sumba Island",
    country: "Indonesia",
    iata: "TMC",
    icao: "WADT",
    latitude: "-9.409717",
    longitude: "119.244494",
    altitude: "161",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6205",
    name: "Bokondini Airport",
    city: "Bokondini-Papua Island",
    country: "Indonesia",
    iata: "BUI",
    icao: "WAJB",
    latitude: "-3.58365",
    longitude: "138.533",
    altitude: "9104",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "6206",
    name: "Senggeh Airport",
    city: "Senggeh-Papua Island",
    country: "Indonesia",
    iata: "SEH",
    icao: "WAJS",
    latitude: "-3.43333",
    longitude: "140.817",
    altitude: "914",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "6207",
    name: "Tanjung Harapan Airport",
    city: "Tanjung Selor-Borneo Island",
    country: "Indonesia",
    iata: "TJS",
    icao: "WALG",
    latitude: "2.83641",
    longitude: "117.374",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6208",
    name: "Datadawai Airport",
    city: "Datadawai-Borneo Island",
    country: "Indonesia",
    iata: "DTD",
    icao: "WALJ",
    latitude: "0.717",
    longitude: "116.483",
    altitude: "229",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6209",
    name: "Barau(Kalimaru) Airport",
    city: "Tanjung Redep-Borneo Island",
    country: "Indonesia",
    iata: "BEJ",
    icao: "WALK",
    latitude: "2.155497",
    longitude: "117.432256",
    altitude: "59",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6210",
    name: "Warukin Airport",
    city: "Tanjung-Borneo Island",
    country: "Indonesia",
    iata: "TJG",
    icao: "WAON",
    latitude: "-2.21656",
    longitude: "115.436",
    altitude: "197",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6211",
    name: "Sampit(Hasan) Airport",
    city: "Sampit-Borneo Island",
    country: "Indonesia",
    iata: "SMQ",
    icao: "WAOS",
    latitude: "-2.499194",
    longitude: "112.974992",
    altitude: "50",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6212",
    name: "Dumatubun Airport",
    city: "Langgur-Kei Islands",
    country: "Indonesia",
    iata: "LUV",
    icao: "WAPL",
    latitude: "-5.661619",
    longitude: "132.731431",
    altitude: "10",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "6213",
    name: "Mali Airport",
    city: "Alor Island",
    country: "Indonesia",
    iata: "ARD",
    icao: "WATM",
    latitude: "-8.13234",
    longitude: "124.597",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6214",
    name: "Belaga Airport",
    city: "Belaga",
    country: "Malaysia",
    iata: "BLG",
    icao: "WBGC",
    latitude: "2.65",
    longitude: "113.767",
    altitude: "200",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6215",
    name: "Long Lellang Airport",
    city: "Long Datih",
    country: "Malaysia",
    iata: "LGL",
    icao: "WBGF",
    latitude: "3.421",
    longitude: "115.154",
    altitude: "1400",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6216",
    name: "Long Seridan Airport",
    city: "Long Seridan",
    country: "Malaysia",
    iata: "ODN",
    icao: "WBGI",
    latitude: "3.967",
    longitude: "115.05",
    altitude: "607",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6217",
    name: "Mukah Airport",
    city: "Mukah",
    country: "Malaysia",
    iata: "MKM",
    icao: "WBGK",
    latitude: "2.90639",
    longitude: "112.08",
    altitude: "13",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6218",
    name: "Bakalalan Airport",
    city: "Bakalalan",
    country: "Malaysia",
    iata: "BKM",
    icao: "WBGQ",
    latitude: "3.974",
    longitude: "115.618",
    altitude: "2900",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6219",
    name: "Lawas Airport",
    city: "Lawas",
    country: "Malaysia",
    iata: "LWY",
    icao: "WBGW",
    latitude: "4.84917",
    longitude: "115.408",
    altitude: "5",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6220",
    name: "Bario Airport",
    city: "Bario",
    country: "Malaysia",
    iata: "BBN",
    icao: "WBGZ",
    latitude: "3.73389",
    longitude: "115.479",
    altitude: "3350",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6221",
    name: "Tomanggong Airport",
    city: "Tomanggong",
    country: "Malaysia",
    iata: "TMG",
    icao: "WBKM",
    latitude: "5.4",
    longitude: "118.65",
    altitude: "26",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6222",
    name: "Kudat Airport",
    city: "Kudat",
    country: "Malaysia",
    iata: "KUD",
    icao: "WBKT",
    latitude: "6.9225",
    longitude: "116.836",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6223",
    name: "Radin Inten II (Branti) Airport",
    city: "Bandar Lampung-Sumatra Island",
    country: "Indonesia",
    iata: "TKG",
    icao: "WICT",
    latitude: "-5.242339",
    longitude: "105.178939",
    altitude: "282",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6224",
    name: "Halim Perdanakusuma International Airport",
    city: "Jakarta",
    country: "Indonesia",
    iata: "HLP",
    icao: "WIHH",
    latitude: "-6.26661",
    longitude: "106.891",
    altitude: "84",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6225",
    name: "Ranai Airport",
    city: "Ranai-Natuna Besar Island",
    country: "Indonesia",
    iata: "NTX",
    icao: "WION",
    latitude: "3.908714",
    longitude: "108.387897",
    altitude: "7",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6226",
    name: "Pangsuma Airport",
    city: "Putussibau-Borneo Island",
    country: "Indonesia",
    iata: "PSU",
    icao: "WIOP",
    latitude: "0.835578",
    longitude: "112.937144",
    altitude: "297",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6227",
    name: "Susilo Airport",
    city: "Sintang-Borneo Island",
    country: "Indonesia",
    iata: "SQG",
    icao: "WIOS",
    latitude: "0.063619",
    longitude: "111.473428",
    altitude: "98",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6228",
    name: "Pendopo Airport",
    city: "Talang Gudang-Sumatra Island",
    country: "Indonesia",
    iata: "PDO",
    icao: "WIPQ",
    latitude: "-3.286069",
    longitude: "103.8796",
    altitude: "184",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6229",
    name: "Malikus Saleh Airport",
    city: "Lhok Seumawe-Sumatra Island",
    country: "Indonesia",
    iata: "LSW",
    icao: "WITM",
    latitude: "5.226681",
    longitude: "96.950342",
    altitude: "90",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6230",
    name: "Pulau Pangkor Airport",
    city: "Pangkor Island",
    country: "Malaysia",
    iata: "PKG",
    icao: "WMPA",
    latitude: "4.24472",
    longitude: "100.553",
    altitude: "19",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6231",
    name: "Stagen Airport",
    city: "Laut Island",
    country: "Indonesia",
    iata: "KBU",
    icao: "WRBK",
    latitude: "-3.29472",
    longitude: "116.165",
    altitude: "4",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6232",
    name: "Long Bawan Airport",
    city: "Long Bawan-Borneo Island",
    country: "Indonesia",
    iata: "LBW",
    icao: "WRLB",
    latitude: "3.867",
    longitude: "115.683",
    altitude: "3590",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6233",
    name: "Nunukan Airport",
    city: "Nunukan-Nunukan Island",
    country: "Indonesia",
    iata: "NNX",
    icao: "WRLF",
    latitude: "4.13653",
    longitude: "117.667",
    altitude: "52",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6234",
    name: "Long Apung Airport",
    city: "Long Apung-Borneo Island",
    country: "Indonesia",
    iata: "LPU",
    icao: "WRLP",
    latitude: "0.583",
    longitude: "115.6",
    altitude: "627",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "6235",
    name: "Albany Airport",
    city: "Albany",
    country: "Australia",
    iata: "ALH",
    icao: "YABA",
    latitude: "-34.9433",
    longitude: "117.809",
    altitude: "233",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6236",
    name: "Argyle Airport",
    city: "Argyle",
    country: "Australia",
    iata: "GYL",
    icao: "YARG",
    latitude: "-16.6369",
    longitude: "128.451",
    altitude: "522",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6237",
    name: "Aurukun Airport",
    city: "Aurukun",
    country: "Australia",
    iata: "AUU",
    icao: "YAUR",
    latitude: "-13.3539",
    longitude: "141.721",
    altitude: "31",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6238",
    name: "Barcaldine Airport",
    city: "Barcaldine",
    country: "Australia",
    iata: "BCI",
    icao: "YBAR",
    latitude: "-23.5653",
    longitude: "145.307",
    altitude: "878",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6239",
    name: "Badu Island Airport",
    city: "Badu Island",
    country: "Australia",
    iata: "BDD",
    icao: "YBAU",
    latitude: "-10.15",
    longitude: "141.175",
    altitude: "14",
    timezone: "9",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6240",
    name: "Birdsville Airport",
    city: "Birdsville",
    country: "Australia",
    iata: "BVI",
    icao: "YBDV",
    latitude: "-25.8975",
    longitude: "139.348",
    altitude: "159",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6241",
    name: "Broken Hill Airport",
    city: "Broken Hill",
    country: "Australia",
    iata: "BHQ",
    icao: "YBHI",
    latitude: "-32.0014",
    longitude: "141.472",
    altitude: "958",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6242",
    name: "Hamilton Island Airport",
    city: "Hamilton Island",
    country: "Australia",
    iata: "HTI",
    icao: "YBHM",
    latitude: "-20.3581",
    longitude: "148.952",
    altitude: "15",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6243",
    name: "Bedourie Airport",
    city: "Bedourie",
    country: "Australia",
    iata: "BEU",
    icao: "YBIE",
    latitude: "-24.3461",
    longitude: "139.46",
    altitude: "300",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6244",
    name: "Bourke Airport",
    city: "Bourke",
    country: "Australia",
    iata: "BRK",
    icao: "YBKE",
    latitude: "-30.0392",
    longitude: "145.952",
    altitude: "352",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6245",
    name: "Burketown Airport",
    city: "Burketown",
    country: "Australia",
    iata: "BUC",
    icao: "YBKT",
    latitude: "-17.7486",
    longitude: "139.534",
    altitude: "21",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6246",
    name: "Boigu Airport",
    city: "Boigu",
    country: "Australia",
    iata: "GIC",
    icao: "YBOI",
    latitude: "-9.23278",
    longitude: "142.218",
    altitude: "23",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6247",
    name: "Oakey Airport",
    city: "Oakey",
    country: "Australia",
    iata: "OKY",
    icao: "YBOK",
    latitude: "-27.411389",
    longitude: "151.735278",
    altitude: "1335",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6248",
    name: "Boulia Airport",
    city: "Boulia",
    country: "Australia",
    iata: "BQL",
    icao: "YBOU",
    latitude: "-22.9133",
    longitude: "139.9",
    altitude: "542",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6249",
    name: "Bathurst Airport",
    city: "Bathurst",
    country: "Australia",
    iata: "BHS",
    icao: "YBTH",
    latitude: "-33.4094",
    longitude: "149.652",
    altitude: "2435",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6250",
    name: "Blackwater Airport",
    city: "Blackwater",
    country: "Australia",
    iata: "BLT",
    icao: "YBTR",
    latitude: "-23.6031",
    longitude: "148.807",
    altitude: "657",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6251",
    name: "Carnarvon Airport",
    city: "Carnarvon",
    country: "Australia",
    iata: "CVQ",
    icao: "YCAR",
    latitude: "-24.8806",
    longitude: "113.672",
    altitude: "13",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6252",
    name: "Cobar Airport",
    city: "Cobar",
    country: "Australia",
    iata: "CAZ",
    icao: "YCBA",
    latitude: "-31.5383",
    longitude: "145.794",
    altitude: "724",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6253",
    name: "Coober Pedy Airport",
    city: "Coober Pedy",
    country: "Australia",
    iata: "CPD",
    icao: "YCBP",
    latitude: "-29.04",
    longitude: "134.721",
    altitude: "740",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6254",
    name: "Coconut Island Airport",
    city: "Coconut Island",
    country: "Australia",
    iata: "CNC",
    icao: "YCCT",
    latitude: "-10.05",
    longitude: "143.07",
    altitude: "3",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6255",
    name: "Cloncurry Airport",
    city: "Cloncurry",
    country: "Australia",
    iata: "CNJ",
    icao: "YCCY",
    latitude: "-20.6686",
    longitude: "140.504",
    altitude: "616",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6256",
    name: "Ceduna Airport",
    city: "Ceduna",
    country: "Australia",
    iata: "CED",
    icao: "YCDU",
    latitude: "-32.1306",
    longitude: "133.71",
    altitude: "77",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6257",
    name: "Cooktown Airport",
    city: "Cooktown",
    country: "Australia",
    iata: "CTN",
    icao: "YCKN",
    latitude: "-15.4447",
    longitude: "145.184",
    altitude: "26",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6258",
    name: "Cunnamulla Airport",
    city: "Cunnamulla",
    country: "Australia",
    iata: "CMA",
    icao: "YCMU",
    latitude: "-28.03",
    longitude: "145.622",
    altitude: "630",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6259",
    name: "Coonamble Airport",
    city: "Coonamble",
    country: "Australia",
    iata: "CNB",
    icao: "YCNM",
    latitude: "-30.9833",
    longitude: "148.376",
    altitude: "604",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6260",
    name: "Coen Airport",
    city: "Coen",
    country: "Australia",
    iata: "CUQ",
    icao: "YCOE",
    latitude: "-13.7608",
    longitude: "143.114",
    altitude: "532",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6261",
    name: "Cooma Snowy Mountains Airport",
    city: "Cooma",
    country: "Australia",
    iata: "OOM",
    icao: "YCOM",
    latitude: "-36.3006",
    longitude: "148.974",
    altitude: "3088",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6262",
    name: "Doomadgee Airport",
    city: "Doomadgee",
    country: "Australia",
    iata: "DMD",
    icao: "YDMG",
    latitude: "-17.9403",
    longitude: "138.822",
    altitude: "153",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6263",
    name: "Darnley Island Airport",
    city: "Darnley Island",
    country: "Australia",
    iata: "NLF",
    icao: "YDNI",
    latitude: "-9.58333",
    longitude: "143.767",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6264",
    name: "Devonport Airport",
    city: "Devonport",
    country: "Australia",
    iata: "DPO",
    icao: "YDPO",
    latitude: "-41.1697",
    longitude: "146.43",
    altitude: "33",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "6265",
    name: "Elcho Island Airport",
    city: "Elcho Island",
    country: "Australia",
    iata: "ELC",
    icao: "YELD",
    latitude: "-12.0194",
    longitude: "135.571",
    altitude: "101",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6266",
    name: "Esperance Airport",
    city: "Esperance",
    country: "Australia",
    iata: "EPR",
    icao: "YESP",
    latitude: "-33.6844",
    longitude: "121.823",
    altitude: "470",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6267",
    name: "Flinders Island Airport",
    city: "Flinders Island",
    country: "Australia",
    iata: "FLS",
    icao: "YFLI",
    latitude: "-40.0917",
    longitude: "147.993",
    altitude: "10",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "6268",
    name: "Geraldton Airport",
    city: "Geraldton",
    country: "Australia",
    iata: "GET",
    icao: "YGEL",
    latitude: "-28.7961",
    longitude: "114.707",
    altitude: "121",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6269",
    name: "Gladstone Airport",
    city: "Gladstone",
    country: "Australia",
    iata: "GLT",
    icao: "YGLA",
    latitude: "-23.8697",
    longitude: "151.223",
    altitude: "64",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6270",
    name: "Groote Eylandt Airport",
    city: "Groote Eylandt",
    country: "Australia",
    iata: "GTE",
    icao: "YGTE",
    latitude: "-13.975",
    longitude: "136.46",
    altitude: "53",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6271",
    name: "Griffith Airport",
    city: "Griffith",
    country: "Australia",
    iata: "GFF",
    icao: "YGTH",
    latitude: "-34.2508",
    longitude: "146.067",
    altitude: "439",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6272",
    name: "Horn Island Airport",
    city: "Horn Island",
    country: "Australia",
    iata: "HID",
    icao: "YHID",
    latitude: "-10.5864",
    longitude: "142.29",
    altitude: "43",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6273",
    name: "Hooker Creek Airport",
    city: "Hooker Creek",
    country: "Australia",
    iata: "HOK",
    icao: "YHOO",
    latitude: "-18.3367",
    longitude: "130.638",
    altitude: "320",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6274",
    name: "Mount Hotham Airport",
    city: "Mount Hotham",
    country: "Australia",
    iata: "MHU",
    icao: "YHOT",
    latitude: "-37.0475",
    longitude: "147.334",
    altitude: "4260",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "6275",
    name: "Hughenden Airport",
    city: "Hughenden",
    country: "Australia",
    iata: "HGD",
    icao: "YHUG",
    latitude: "-20.815",
    longitude: "144.225",
    altitude: "1043",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6276",
    name: "Julia Creek Airport",
    city: "Julia Creek",
    country: "Australia",
    iata: "JCK",
    icao: "YJLC",
    latitude: "-20.6683",
    longitude: "141.723",
    altitude: "404",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6277",
    name: "Kalbarri Airport",
    city: "Kalbarri",
    country: "Australia",
    iata: "KAX",
    icao: "YKBR",
    latitude: "-27.69",
    longitude: "114.262",
    altitude: "157",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6278",
    name: "King Island Airport",
    city: "King Island",
    country: "Australia",
    iata: "KNS",
    icao: "YKII",
    latitude: "-39.8775",
    longitude: "143.878",
    altitude: "132",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "6279",
    name: "Kalkgurung Airport",
    city: "Kalkgurung",
    country: "Australia",
    iata: "KFG",
    icao: "YKKG",
    latitude: "-17.4319",
    longitude: "130.808",
    altitude: "646",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6280",
    name: "Karumba Airport",
    city: "Karumba",
    country: "Australia",
    iata: "KRB",
    icao: "YKMB",
    latitude: "-17.4567",
    longitude: "140.83",
    altitude: "5",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6281",
    name: "Kowanyama Airport",
    city: "Kowanyama",
    country: "Australia",
    iata: "KWM",
    icao: "YKOW",
    latitude: "-15.4856",
    longitude: "141.751",
    altitude: "35",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6282",
    name: "Kubin Airport",
    city: "Kubin",
    country: "Australia",
    iata: "KUG",
    icao: "YKUB",
    latitude: "-10.225",
    longitude: "142.218",
    altitude: "15",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6283",
    name: "Leonora Airport",
    city: "Leonora",
    country: "Australia",
    iata: "LNO",
    icao: "YLEO",
    latitude: "-28.8781",
    longitude: "121.315",
    altitude: "1217",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6284",
    name: "Lake Evella Airport",
    city: "Lake Evella",
    country: "Australia",
    iata: "LEL",
    icao: "YLEV",
    latitude: "-12.4989",
    longitude: "135.806",
    altitude: "256",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6285",
    name: "Lord Howe Island Airport",
    city: "Lord Howe Island",
    country: "Australia",
    iata: "LDH",
    icao: "YLHI",
    latitude: "-31.5383",
    longitude: "159.077",
    altitude: "5",
    timezone: "10.5",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6286",
    name: "Lockhart River Airport",
    city: "Lockhart River",
    country: "Australia",
    iata: "IRG",
    icao: "YLHR",
    latitude: "-12.7869",
    longitude: "143.305",
    altitude: "77",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6287",
    name: "Lismore Airport",
    city: "Lismore",
    country: "Australia",
    iata: "LSY",
    icao: "YLIS",
    latitude: "-28.8303",
    longitude: "153.26",
    altitude: "35",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6288",
    name: "Lightning Ridge Airport",
    city: "Lightning Ridge",
    country: "Australia",
    iata: "LHG",
    icao: "YLRD",
    latitude: "-29.4567",
    longitude: "147.984",
    altitude: "540",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6289",
    name: "Longreach Airport",
    city: "Longreach",
    country: "Australia",
    iata: "LRE",
    icao: "YLRE",
    latitude: "-23.4342",
    longitude: "144.28",
    altitude: "627",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6290",
    name: "Leinster Airport",
    city: "Leinster",
    country: "Australia",
    iata: "LER",
    icao: "YLST",
    latitude: "-27.8433",
    longitude: "120.703",
    altitude: "1631",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6291",
    name: "Laverton Airport",
    city: "Laverton",
    country: "Australia",
    iata: "LVO",
    icao: "YLTN",
    latitude: "-28.6136",
    longitude: "122.424",
    altitude: "1530",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6292",
    name: "Mabuiag Island Airport",
    city: "Mabuiag Island",
    country: "Australia",
    iata: "UBB",
    icao: "YMAA",
    latitude: "-9.95",
    longitude: "142.183",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6293",
    name: "Meekatharra Airport",
    city: "Meekatharra",
    country: "Australia",
    iata: "MKR",
    icao: "YMEK",
    latitude: "-26.6117",
    longitude: "118.548",
    altitude: "1713",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6294",
    name: "Merimbula Airport",
    city: "Merimbula",
    country: "Australia",
    iata: "MIM",
    icao: "YMER",
    latitude: "-36.9086",
    longitude: "149.901",
    altitude: "7",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6295",
    name: "Milingimbi Airport",
    city: "Milingimbi",
    country: "Australia",
    iata: "MGT",
    icao: "YMGB",
    latitude: "-12.0944",
    longitude: "134.894",
    altitude: "53",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6296",
    name: "Maningrida Airport",
    city: "Maningrida",
    country: "Australia",
    iata: "MNG",
    icao: "YMGD",
    latitude: "-12.0561",
    longitude: "134.234",
    altitude: "123",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6297",
    name: "McArthur River Mine Airport",
    city: "McArthur River Mine",
    country: "Australia",
    iata: "MCV",
    icao: "YMHU",
    latitude: "-16.4425",
    longitude: "136.084",
    altitude: "131",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6298",
    name: "Mildura Airport",
    city: "Mildura",
    country: "Australia",
    iata: "MQL",
    icao: "YMIA",
    latitude: "-34.2292",
    longitude: "142.086",
    altitude: "167",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "6299",
    name: "Mount Magnet Airport",
    city: "Mount Magnet",
    country: "Australia",
    iata: "MMG",
    icao: "YMOG",
    latitude: "-28.1161",
    longitude: "117.842",
    altitude: "1354",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6300",
    name: "Moree Airport",
    city: "Moree",
    country: "Australia",
    iata: "MRZ",
    icao: "YMOR",
    latitude: "-29.4989",
    longitude: "149.845",
    altitude: "701",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6301",
    name: "Moranbah Airport",
    city: "Moranbah",
    country: "Australia",
    iata: "MOV",
    icao: "YMRB",
    latitude: "-22.0578",
    longitude: "148.077",
    altitude: "770",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6302",
    name: "Moruya Airport",
    city: "Moruya",
    country: "Australia",
    iata: "MYA",
    icao: "YMRY",
    latitude: "-35.8978",
    longitude: "150.144",
    altitude: "14",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6303",
    name: "Mount Gambier Airport",
    city: "Mount Gambier",
    country: "Australia",
    iata: "MGB",
    icao: "YMTG",
    latitude: "-37.7456",
    longitude: "140.785",
    altitude: "212",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6304",
    name: "Mornington Island Airport",
    city: "Mornington Island",
    country: "Australia",
    iata: "ONG",
    icao: "YMTI",
    latitude: "-16.6625",
    longitude: "139.178",
    altitude: "33",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6305",
    name: "Murray Island Airport",
    city: "Murray Island",
    country: "Australia",
    iata: "MYI",
    icao: "YMUI",
    latitude: "-9.91667",
    longitude: "144.055",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6306",
    name: "Maryborough Airport",
    city: "Maryborough",
    country: "Australia",
    iata: "MBH",
    icao: "YMYB",
    latitude: "-25.5133",
    longitude: "152.715",
    altitude: "38",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6307",
    name: "Narrandera Airport",
    city: "Narrandera",
    country: "Australia",
    iata: "NRA",
    icao: "YNAR",
    latitude: "-34.7022",
    longitude: "146.512",
    altitude: "474",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6308",
    name: "Narrabri Airport",
    city: "Narrabri",
    country: "Australia",
    iata: "NAA",
    icao: "YNBR",
    latitude: "-30.3192",
    longitude: "149.827",
    altitude: "788",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6309",
    name: "Normanton Airport",
    city: "Normanton",
    country: "Australia",
    iata: "NTN",
    icao: "YNTN",
    latitude: "-17.6836",
    longitude: "141.07",
    altitude: "73",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6310",
    name: "Newman Airport",
    city: "Newman",
    country: "Australia",
    iata: "ZNE",
    icao: "YNWN",
    latitude: "-23.4178",
    longitude: "119.803",
    altitude: "1724",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6311",
    name: "Olympic Dam Airport",
    city: "Olympic Dam",
    country: "Australia",
    iata: "OLP",
    icao: "YOLD",
    latitude: "-30.485",
    longitude: "136.877",
    altitude: "343",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6312",
    name: "Port Augusta Airport",
    city: "Argyle",
    country: "Australia",
    iata: "PUG",
    icao: "YPAG",
    latitude: "-32.506944",
    longitude: "137.716667",
    altitude: "56",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6313",
    name: "Palm Island Airport",
    city: "Palm Island",
    country: "Australia",
    iata: "PMK",
    icao: "YPAM",
    latitude: "-18.7553",
    longitude: "146.581",
    altitude: "28",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6314",
    name: "Paraburdoo Airport",
    city: "Paraburdoo",
    country: "Australia",
    iata: "PBO",
    icao: "YPBO",
    latitude: "-23.1711",
    longitude: "117.745",
    altitude: "1406",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6315",
    name: "Cocos Keeling Island Airport",
    city: "Cocos Keeling Island",
    country: "Cocos (Keeling) Islands",
    iata: "CCK",
    icao: "YPCC",
    latitude: "-12.1883",
    longitude: "96.8339",
    altitude: "10",
    timezone: "6.5",
    dst: "U",
    tz: "Indian/Cocos",
  },
  {
    id: "6316",
    name: "Gove Airport",
    city: "Gove",
    country: "Australia",
    iata: "GOV",
    icao: "YPGV",
    latitude: "-12.2694",
    longitude: "136.818",
    altitude: "192",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6317",
    name: "Parkes Airport",
    city: "Parkes",
    country: "Australia",
    iata: "PKE",
    icao: "YPKS",
    latitude: "-33.1314",
    longitude: "148.239",
    altitude: "1069",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6318",
    name: "Port Lincoln Airport",
    city: "Port Lincoln",
    country: "Australia",
    iata: "PLO",
    icao: "YPLC",
    latitude: "-34.6053",
    longitude: "135.88",
    altitude: "36",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6319",
    name: "Pormpuraaw Airport",
    city: "Pormpuraaw",
    country: "Australia",
    iata: "EDR",
    icao: "YPMP",
    latitude: "-14.8967",
    longitude: "141.609",
    altitude: "10",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6320",
    name: "Port Macquarie Airport",
    city: "Port Macquarie",
    country: "Australia",
    iata: "PQQ",
    icao: "YPMQ",
    latitude: "-31.4358",
    longitude: "152.863",
    altitude: "12",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6321",
    name: "Portland Airport",
    city: "Portland",
    country: "Australia",
    iata: "PTJ",
    icao: "YPOD",
    latitude: "-38.3181",
    longitude: "141.471",
    altitude: "265",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "6322",
    name: "Quilpie Airport",
    city: "Quilpie",
    country: "Australia",
    iata: "ULP",
    icao: "YQLP",
    latitude: "-26.6122",
    longitude: "144.253",
    altitude: "655",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6323",
    name: "Ramingining Airport",
    city: "Ramingining",
    country: "Australia",
    iata: "RAM",
    icao: "YRNG",
    latitude: "-12.3564",
    longitude: "134.898",
    altitude: "206",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6324",
    name: "Roma Airport",
    city: "Roma",
    country: "Australia",
    iata: "RMA",
    icao: "YROM",
    latitude: "-26.545",
    longitude: "148.775",
    altitude: "1032",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6325",
    name: "St George Airport",
    city: "St George",
    country: "Australia",
    iata: "SGO",
    icao: "YSGE",
    latitude: "-28.0497",
    longitude: "148.595",
    altitude: "656",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6326",
    name: "Shark Bay Airport",
    city: "Shark Bay",
    country: "Australia",
    iata: "MJK",
    icao: "YSHK",
    latitude: "-25.8939",
    longitude: "113.577",
    altitude: "111",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6327",
    name: "Saibai Island Airport",
    city: "Saibai Island",
    country: "Australia",
    iata: "SBR",
    icao: "YSII",
    latitude: "-9.37833",
    longitude: "142.625",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6328",
    name: "Strahan Airport",
    city: "Strahan",
    country: "Australia",
    iata: "SRN",
    icao: "YSRN",
    latitude: "-42.155",
    longitude: "145.292",
    altitude: "20",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "6329",
    name: "Thargomindah Airport",
    city: "Thargomindah",
    country: "Australia",
    iata: "XTG",
    icao: "YTGM",
    latitude: "-27.9864",
    longitude: "143.811",
    altitude: "433",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6330",
    name: "Tennant Creek Airport",
    city: "Tennant Creek",
    country: "Australia",
    iata: "TCA",
    icao: "YTNK",
    latitude: "-19.6344",
    longitude: "134.183",
    altitude: "1236",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6331",
    name: "Victoria River Downs Airport",
    city: "Victoria River Downs",
    country: "Australia",
    iata: "VCD",
    icao: "YVRD",
    latitude: "-16.4033",
    longitude: "131.002",
    altitude: "89",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6332",
    name: "Warraber Island Airport",
    city: "Sue Islet",
    country: "Australia",
    iata: "SYU",
    icao: "YWBS",
    latitude: "-10.2083",
    longitude: "142.825",
    altitude: "3",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6333",
    name: "Windorah Airport",
    city: "Windorah",
    country: "Australia",
    iata: "WNR",
    icao: "YWDH",
    latitude: "-25.4131",
    longitude: "142.667",
    altitude: "452",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6334",
    name: "Whyalla Airport",
    city: "Whyalla",
    country: "Australia",
    iata: "WYA",
    icao: "YWHA",
    latitude: "-33.0589",
    longitude: "137.514",
    altitude: "41",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "6335",
    name: "Wiluna Airport",
    city: "Wiluna",
    country: "Australia",
    iata: "WUN",
    icao: "YWLU",
    latitude: "-26.6292",
    longitude: "120.221",
    altitude: "1649",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6336",
    name: "Wollongong Airport",
    city: "Wollongong",
    country: "Australia",
    iata: "WOL",
    icao: "YWOL",
    latitude: "-34.5611",
    longitude: "150.789",
    altitude: "31",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6337",
    name: "Winton Airport",
    city: "Winton",
    country: "Australia",
    iata: "WIN",
    icao: "YWTN",
    latitude: "-22.3636",
    longitude: "143.086",
    altitude: "638",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6338",
    name: "Wynyard Airport",
    city: "Burnie",
    country: "Australia",
    iata: "BWT",
    icao: "YWYY",
    latitude: "-40.9989",
    longitude: "145.731",
    altitude: "62",
    timezone: "10",
    dst: "O",
    tz: "Australia/Melbourne",
  },
  {
    id: "6339",
    name: "Yorke Island Airport",
    city: "Yorke Island",
    country: "Australia",
    iata: "OKR",
    icao: "YYKI",
    latitude: "-9.75703",
    longitude: "143.411",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6340",
    name: "Yam Island Airport",
    city: "Yam Island",
    country: "Australia",
    iata: "XMY",
    icao: "YYMI",
    latitude: "-9.90111",
    longitude: "142.776",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "6341",
    name: "Beijing Nanyuan Airport",
    city: "Beijing",
    country: "China",
    iata: "NAY",
    icao: "ZBBB",
    latitude: "39.7825",
    longitude: "116.387778",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6342",
    name: "Chifeng Airport",
    city: "Chifeng",
    country: "China",
    iata: "CIF",
    icao: "ZBCF",
    latitude: "42.235",
    longitude: "118.908",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6343",
    name: "Changzhi Airport",
    city: "Changzhi",
    country: "China",
    iata: "CIH",
    icao: "ZBCZ",
    latitude: "36.2475",
    longitude: "113.126",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6344",
    name: "Datong Airport",
    city: "Datong",
    country: "China",
    iata: "DAT",
    icao: "ZBDT",
    latitude: "40.0603",
    longitude: "113.482",
    altitude: "3442",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6345",
    name: "Baita Airport",
    city: "Hohhot",
    country: "China",
    iata: "HET",
    icao: "ZBHH",
    latitude: "40.851422",
    longitude: "111.824103",
    altitude: "3556",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6346",
    name: "Baotou Airport",
    city: "Baotou",
    country: "China",
    iata: "BAV",
    icao: "ZBOW",
    latitude: "40.56",
    longitude: "109.997",
    altitude: "3321",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6347",
    name: "Shijiazhuang Daguocun International Airport",
    city: "Shijiazhuang",
    country: "China",
    iata: "SJW",
    icao: "ZBSJ",
    latitude: "38.280686",
    longitude: "114.6973",
    altitude: "233",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6348",
    name: "Tongliao Airport",
    city: "Tongliao",
    country: "China",
    iata: "TGO",
    icao: "ZBTL",
    latitude: "43.5567",
    longitude: "122.2",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6349",
    name: "Ulanhot Airport",
    city: "Ulanhot",
    country: "China",
    iata: "HLH",
    icao: "ZBUL",
    latitude: "46.083",
    longitude: "122.017",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6350",
    name: "Xilinhot Airport",
    city: "Xilinhot",
    country: "China",
    iata: "XIL",
    icao: "ZBXH",
    latitude: "43.9156",
    longitude: "115.964",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6351",
    name: "Beihai Airport",
    city: "Beihai",
    country: "China",
    iata: "BHY",
    icao: "ZGBH",
    latitude: "21.5394",
    longitude: "109.294",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6352",
    name: "Changde Airport",
    city: "Changde",
    country: "China",
    iata: "CGD",
    icao: "ZGCD",
    latitude: "28.9189",
    longitude: "111.64",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6353",
    name: "Dayong Airport",
    city: "Dayong",
    country: "China",
    iata: "DYG",
    icao: "ZGDY",
    latitude: "29.1028",
    longitude: "110.443",
    altitude: "692",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6354",
    name: "Meixian Airport",
    city: "Meixian",
    country: "China",
    iata: "MXZ",
    icao: "ZGMX",
    latitude: "24.35",
    longitude: "116.133",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6355",
    name: "Zhuhai Airport",
    city: "Zhuhai",
    country: "China",
    iata: "ZUH",
    icao: "ZGSD",
    latitude: "22.0064",
    longitude: "113.376",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6356",
    name: "Bailian Airport",
    city: "Liuzhou",
    country: "China",
    iata: "LZH",
    icao: "ZGZH",
    latitude: "24.2075",
    longitude: "109.391",
    altitude: "295",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6357",
    name: "Zhanjiang Airport",
    city: "Zhanjiang",
    country: "China",
    iata: "ZHA",
    icao: "ZGZJ",
    latitude: "21.2144",
    longitude: "110.358",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6358",
    name: "Enshi Airport",
    city: "Enshi",
    country: "China",
    iata: "ENH",
    icao: "ZHES",
    latitude: "30.3203",
    longitude: "109.485",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6359",
    name: "Nanyang Airport",
    city: "Nanyang",
    country: "China",
    iata: "NNY",
    icao: "ZHNY",
    latitude: "32.9808",
    longitude: "112.615",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6360",
    name: "Xiangfan Airport",
    city: "Xiangfan",
    country: "China",
    iata: "XFN",
    icao: "ZHXF",
    latitude: "32.1506",
    longitude: "112.291",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6361",
    name: "Yichang Airport",
    city: "Yichang",
    country: "China",
    iata: "YIH",
    icao: "ZHYC",
    latitude: "30.671",
    longitude: "111.441",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6362",
    name: "Ankang Airport",
    city: "Ankang",
    country: "China",
    iata: "AKA",
    icao: "ZLAK",
    latitude: "32.7081",
    longitude: "108.931",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6363",
    name: "Golmud Airport",
    city: "Golmud",
    country: "China",
    iata: "GOQ",
    icao: "ZLGM",
    latitude: "34.633",
    longitude: "98.867",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6364",
    name: "Hanzhong Airport",
    city: "Hanzhong",
    country: "China",
    iata: "HZG",
    icao: "ZLHZ",
    latitude: "33.0636",
    longitude: "107.008",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6365",
    name: "Qingyang Airport",
    city: "Qingyang",
    country: "China",
    iata: "IQN",
    icao: "ZLQY",
    latitude: "35.7997",
    longitude: "107.603",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6366",
    name: "Xining Caojiabu Airport",
    city: "Xining",
    country: "China",
    iata: "XNN",
    icao: "ZLXN",
    latitude: "36.5275",
    longitude: "102.043",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6367",
    name: "Yan'an Airport",
    city: "Yan'an",
    country: "China",
    iata: "ENY",
    icao: "ZLYA",
    latitude: "36.6369",
    longitude: "109.554",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6368",
    name: "Yulin Airport",
    city: "Yulin",
    country: "China",
    iata: "UYN",
    icao: "ZLYL",
    latitude: "38.2692",
    longitude: "109.731",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6369",
    name: "Arvaikheer Airport",
    city: "Arvaikheer",
    country: "Mongolia",
    iata: "AVK",
    icao: "ZMAH",
    latitude: "46.2503",
    longitude: "102.802",
    altitude: "5932",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "6370",
    name: "Altai Airport",
    city: "Altai",
    country: "Mongolia",
    iata: "LTI",
    icao: "ZMAT",
    latitude: "46.3764",
    longitude: "96.2211",
    altitude: "7260",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "6371",
    name: "Bayankhongor Airport",
    city: "Bayankhongor",
    country: "Mongolia",
    iata: "BYN",
    icao: "ZMBH",
    latitude: "46.1633",
    longitude: "100.704",
    altitude: "6085",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "6372",
    name: "Dalanzadgad Airport",
    city: "Dalanzadgad",
    country: "Mongolia",
    iata: "DLZ",
    icao: "ZMDZ",
    latitude: "43.5917",
    longitude: "104.43",
    altitude: "4787",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "6373",
    name: "Khovd Airport",
    city: "Khovd",
    country: "Mongolia",
    iata: "HVD",
    icao: "ZMKD",
    latitude: "47.9541",
    longitude: "91.6282",
    altitude: "4898",
    timezone: "7",
    dst: "U",
    tz: "Asia/Hovd",
  },
  {
    id: "6374",
    name: "Muren Airport",
    city: "Muren",
    country: "Mongolia",
    iata: "MXV",
    icao: "ZMMN",
    latitude: "49.6633",
    longitude: "100.099",
    altitude: "4272",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "6375",
    name: "Diqing Airport",
    city: "Shangri-La",
    country: "China",
    iata: "DIG",
    icao: "ZPDQ",
    latitude: "27.7936",
    longitude: "99.6772",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6376",
    name: "Mangshi Airport",
    city: "Luxi",
    country: "China",
    iata: "LUM",
    icao: "ZPLX",
    latitude: "24.4011",
    longitude: "98.5317",
    altitude: "2890",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6377",
    name: "Simao Airport",
    city: "Simao",
    country: "China",
    iata: "SYM",
    icao: "ZPSM",
    latitude: "22.7933",
    longitude: "100.959",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6378",
    name: "Zhaotong Airport",
    city: "Zhaotong",
    country: "China",
    iata: "ZAT",
    icao: "ZPZT",
    latitude: "27.3256",
    longitude: "103.755",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6379",
    name: "Ganzhou Airport",
    city: "Ganzhou",
    country: "China",
    iata: "KOW",
    icao: "ZSGZ",
    latitude: "25.8258",
    longitude: "114.912",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6380",
    name: "Jingdezhen Airport",
    city: "Jingdezhen",
    country: "China",
    iata: "JDZ",
    icao: "ZSJD",
    latitude: "29.3386",
    longitude: "117.176",
    altitude: "112",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6381",
    name: "Jiujiang Lushan Airport",
    city: "Jiujiang",
    country: "China",
    iata: "JIU",
    icao: "ZSJJ",
    latitude: "29.733",
    longitude: "115.983",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6382",
    name: "Quzhou Airport",
    city: "Quzhou",
    country: "China",
    iata: "JUZ",
    icao: "ZSJU",
    latitude: "28.9658",
    longitude: "118.899",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6383",
    name: "Lianyungang Airport",
    city: "Lianyungang",
    country: "China",
    iata: "LYG",
    icao: "ZSLG",
    latitude: "34.55",
    longitude: "119.25",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6384",
    name: "Huangyan Luqiao Airport",
    city: "Huangyan",
    country: "China",
    iata: "HYN",
    icao: "ZSLQ",
    latitude: "28.5622",
    longitude: "121.429",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6385",
    name: "Shubuling Airport",
    city: "Linyi",
    country: "China",
    iata: "LYI",
    icao: "ZSLY",
    latitude: "35.0461",
    longitude: "118.412",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6386",
    name: "Quanzhou Airport",
    city: "Quanzhou",
    country: "China",
    iata: "JJN",
    icao: "ZSQZ",
    latitude: "24.7964",
    longitude: "118.59",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6387",
    name: "Tunxi International Airport",
    city: "Huangshan",
    country: "China",
    iata: "TXN",
    icao: "ZSTX",
    latitude: "29.7333",
    longitude: "118.256",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6388",
    name: "Weifang Airport",
    city: "Weifang",
    country: "China",
    iata: "WEF",
    icao: "ZSWF",
    latitude: "36.6467",
    longitude: "119.119",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6389",
    name: "Weihai Airport",
    city: "Weihai",
    country: "China",
    iata: "WEH",
    icao: "ZSWH",
    latitude: "37.1871",
    longitude: "122.229",
    altitude: "145",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6390",
    name: "Wuxi Airport",
    city: "Wuxi",
    country: "China",
    iata: "WUX",
    icao: "ZSWX",
    latitude: "31.4944",
    longitude: "120.429",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6391",
    name: "Nanping Wuyishan Airport",
    city: "Wuyishan",
    country: "China",
    iata: "WUS",
    icao: "ZSWY",
    latitude: "27.7019",
    longitude: "118.001",
    altitude: "614",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6392",
    name: "Wenzhou Yongqiang Airport",
    city: "Wenzhou",
    country: "China",
    iata: "WNZ",
    icao: "ZSWZ",
    latitude: "27.9122",
    longitude: "120.852",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6393",
    name: "Yancheng Airport",
    city: "Yancheng",
    country: "China",
    iata: "YNZ",
    icao: "ZSYN",
    latitude: "33.3856",
    longitude: "120.125",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6394",
    name: "Yiwu Airport",
    city: "Yiwu",
    country: "China",
    iata: "YIW",
    icao: "ZSYW",
    latitude: "29.3447",
    longitude: "120.032",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6395",
    name: "Zhoushan Airport",
    city: "Zhoushan",
    country: "China",
    iata: "HSN",
    icao: "ZSZS",
    latitude: "29.9342",
    longitude: "122.362",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6396",
    name: "Qamdo Bangda Airport",
    city: "Bangda",
    country: "China",
    iata: "BPX",
    icao: "ZUBD",
    latitude: "30.5536",
    longitude: "97.1083",
    altitude: "14219",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6397",
    name: "Dachuan Airport",
    city: "Dazhou",
    country: "China",
    iata: "DAX",
    icao: "ZUDX",
    latitude: "31.3",
    longitude: "107.5",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6398",
    name: "Guangyuan Airport",
    city: "Guangyuan",
    country: "China",
    iata: "GYS",
    icao: "ZUGU",
    latitude: "32.3911",
    longitude: "105.702",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6399",
    name: "Luzhou Airport",
    city: "Luzhou",
    country: "China",
    iata: "LZO",
    icao: "ZULZ",
    latitude: "28.8522",
    longitude: "105.393",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6400",
    name: "Mianyang Airport",
    city: "Mianyang",
    country: "China",
    iata: "MIG",
    icao: "ZUMY",
    latitude: "31.4281",
    longitude: "104.741",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6401",
    name: "Nanchong Airport",
    city: "Nanchong",
    country: "China",
    iata: "NAO",
    icao: "ZUNC",
    latitude: "30.754",
    longitude: "106.062",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6402",
    name: "Nyingchi Airport",
    city: "Nyingchi",
    country: "China",
    iata: "LZY",
    icao: "ZUNZ",
    latitude: "29.3033",
    longitude: "94.3353",
    altitude: "9675",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6403",
    name: "Wanxian Airport",
    city: "Wanxian",
    country: "China",
    iata: "WXN",
    icao: "ZUWX",
    latitude: "30.8361",
    longitude: "108.406",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6404",
    name: "Aksu Airport",
    city: "Aksu",
    country: "China",
    iata: "AKU",
    icao: "ZWAK",
    latitude: "41.2625",
    longitude: "80.2917",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6405",
    name: "Qiemo Airport",
    city: "Qiemo",
    country: "China",
    iata: "IQM",
    icao: "ZWCM",
    latitude: "38.1494",
    longitude: "85.5328",
    altitude: "4108",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6406",
    name: "Kuqa Airport",
    city: "Kuqa",
    country: "China",
    iata: "KCA",
    icao: "ZWKC",
    latitude: "41.7181",
    longitude: "82.9869",
    altitude: "3524",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6407",
    name: "Korla Airport",
    city: "Korla",
    country: "China",
    iata: "KRL",
    icao: "ZWKL",
    latitude: "41.6978",
    longitude: "86.1289",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6408",
    name: "Karamay Airport",
    city: "Karamay",
    country: "China",
    iata: "KRY",
    icao: "ZWKM",
    latitude: "45.617",
    longitude: "84.883",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6409",
    name: "Yining Airport",
    city: "Yining",
    country: "China",
    iata: "YIN",
    icao: "ZWYN",
    latitude: "43.9558",
    longitude: "81.3303",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6410",
    name: "Heihe Airport",
    city: "Heihe",
    country: "China",
    iata: "HEK",
    icao: "ZYHE",
    latitude: "50.25",
    longitude: "127.3",
    altitude: "8530",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6411",
    name: "Jiamusi Airport",
    city: "Jiamusi",
    country: "China",
    iata: "JMU",
    icao: "ZYJM",
    latitude: "46.843394",
    longitude: "130.465389",
    altitude: "262",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6412",
    name: "Jinzhou Airport",
    city: "Jinzhou",
    country: "China",
    iata: "JNZ",
    icao: "ZYJZ",
    latitude: "41.1014",
    longitude: "121.062",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6413",
    name: "Qiqihar Sanjiazi Airport",
    city: "Qiqihar",
    country: "China",
    iata: "NDG",
    icao: "ZYQQ",
    latitude: "47.239628",
    longitude: "123.918131",
    altitude: "477",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6414",
    name: "Yanji Airport",
    city: "Yanji",
    country: "China",
    iata: "YNJ",
    icao: "ZYYJ",
    latitude: "42.8828",
    longitude: "129.451258",
    altitude: "624",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6417",
    name: "Valletta Sea Plane Terminal",
    city: "Valletta",
    country: "Malta",
    iata: "",
    icao: "\\N",
    latitude: "35.888863",
    longitude: "14.508417",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "6418",
    name: "Gozo Sea Plane Terminal",
    city: "Mgarr",
    country: "Malta",
    iata: "",
    icao: "\\N",
    latitude: "36.026389",
    longitude: "14.298333",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "6419",
    name: "Mount Keith",
    city: "Mount Keith",
    country: "Australia",
    iata: "WME",
    icao: "YMNE",
    latitude: "-27.286389",
    longitude: "120.554722",
    altitude: "1792",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6420",
    name: "Gran Roque Airport",
    city: "Los Roques",
    country: "Venezuela",
    iata: "LRV",
    icao: "SVRS",
    latitude: "11.95",
    longitude: "-66.67",
    altitude: "17",
    timezone: "-4.5",
    dst: "S",
    tz: "America/Caracas",
  },
  {
    id: "6421",
    name: "Inishmore Airport",
    city: "Inis Mor",
    country: "Ireland",
    iata: "IOR",
    icao: "EIIM",
    latitude: "53.1067",
    longitude: "-9.65361",
    altitude: "24",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "6422",
    name: "Connemara Regional Airport",
    city: "Indreabhan",
    country: "Ireland",
    iata: "NNR",
    icao: "EICA",
    latitude: "53.2303",
    longitude: "-9.46778",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "6423",
    name: "Guettin MecklenburgVorpommern Germany",
    city: "Ruegen",
    country: "Germany",
    iata: "GTI",
    icao: "EDCG",
    latitude: "54.383333",
    longitude: "13.325278",
    altitude: "69",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "6424",
    name: "Berezovo",
    city: "Berezovo",
    country: "Russia",
    iata: "NBB",
    icao: "USHB",
    latitude: "63.9241",
    longitude: "65.0487",
    altitude: "98",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "6425",
    name: "Szczecin-Dabie",
    city: "Szczecin",
    country: "Poland",
    iata: "",
    icao: "EPSD",
    latitude: "53.471138",
    longitude: "14.63775",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "6426",
    name: "Worcester Regional Airport",
    city: "Worcester",
    country: "United States",
    iata: "ORH",
    icao: "KORH",
    latitude: "42.2673",
    longitude: "-71.8757",
    altitude: "1009",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6427",
    name: "Anqing Airport",
    city: "Anqing",
    country: "China",
    iata: "AQG",
    icao: "ZSAQ",
    latitude: "30.5822",
    longitude: "117.0502",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6428",
    name: "Jing Gang Shan Airport",
    city: "Ji An",
    country: "China",
    iata: "JGS",
    icao: "\\N",
    latitude: "26.8997",
    longitude: "114.7375",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6429",
    name: "Shanhaiguan Airport",
    city: "Qinhuangdao",
    country: "China",
    iata: "SHP",
    icao: "ZBSH",
    latitude: "39.9681",
    longitude: "119.731",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6430",
    name: "Zhangxiao",
    city: "Yuncheng",
    country: "China",
    iata: "YCU",
    icao: "ZBYC",
    latitude: "35.018",
    longitude: "110.993",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6431",
    name: "Lanzhou Airport",
    city: "Lanzhou",
    country: "China",
    iata: "LHW",
    icao: "ZLAN",
    latitude: "36.117",
    longitude: "103.617",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6432",
    name: "Jiayuguan Airport",
    city: "Jiayuguan",
    country: "China",
    iata: "JGN",
    icao: "ZLJQ",
    latitude: "39.8569",
    longitude: "98.3414",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6433",
    name: "Dandong",
    city: "Dandong",
    country: "China",
    iata: "DDG",
    icao: "ZYDD",
    latitude: "40.0255",
    longitude: "124.2866",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6434",
    name: "Ordos Ejin Horo",
    city: "Dongsheng",
    country: "China",
    iata: "DSN",
    icao: "ZBDS",
    latitude: "39.85",
    longitude: "110.033",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6435",
    name: "Panzhihua",
    city: "Panzhihua",
    country: "China",
    iata: "PZI",
    icao: "ZUZH",
    latitude: "26.54",
    longitude: "101.799",
    altitude: "9186",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "6436",
    name: "Grytviken",
    city: "Grytviken",
    country: "South Georgia and the Islands",
    iata: "",
    icao: "\\N",
    latitude: "-54.16534",
    longitude: "-36.30288",
    altitude: "0",
    timezone: "-2",
    dst: "N",
    tz: "Atlantic/South_Georgia",
  },
  {
    id: "6437",
    name: "South Shetland",
    city: "South Shetland",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-68",
    longitude: "-58",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "6438",
    name: "South Shetland",
    city: "South Shetland",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-63.37",
    longitude: "-62.83",
    altitude: "0",
    timezone: "12",
    dst: "N",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "6439",
    name: "New Rochelle Amtrak Station",
    city: "New Rochelle",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.913923",
    longitude: "-73.782008",
    altitude: "66",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8838",
    name: "Anoka County Blaine Airport",
    city: "Anoka",
    country: "United States",
    iata: "",
    icao: "KANE",
    latitude: "45.1448889",
    longitude: "-93.2101944",
    altitude: "912",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "6441",
    name: "New Haven Rail Station",
    city: "New Haven",
    country: "United States",
    iata: "ZVE",
    icao: "\\N",
    latitude: "41.298669",
    longitude: "-72.925992",
    altitude: "7",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6442",
    name: "Chicago Union Station",
    city: "Chicago",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.8791966",
    longitude: "-87.6388507",
    altitude: "581",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6443",
    name: "Dibrugarh Airport",
    city: "Dibrugarh",
    country: "India",
    iata: "DIB",
    icao: "\\N",
    latitude: "27.4839",
    longitude: "95.0169",
    altitude: "362",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6444",
    name: "Doha Free Zone Airport",
    city: "Doha",
    country: "Qatar",
    iata: "XOZ",
    icao: "\\N",
    latitude: "24.8333",
    longitude: "50.9166",
    altitude: "0",
    timezone: "3",
    dst: "N",
    tz: "Asia/Qatar",
  },
  {
    id: "6445",
    name: "Bremerton National",
    city: "Bremerton",
    country: "United States",
    iata: "PWT",
    icao: "KPWT",
    latitude: "47.490244",
    longitude: "-122.764814",
    altitude: "444",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6446",
    name: "Spencer Muni",
    city: "Spencer",
    country: "United States",
    iata: "SPW",
    icao: "KSPW",
    latitude: "43.165527",
    longitude: "-95.202805",
    altitude: "1339",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6447",
    name: "Jefferson City Memorial Airport",
    city: "Jefferson City",
    country: "United States",
    iata: "JEF",
    icao: "KJEF",
    latitude: "38.5912",
    longitude: "-92.1561",
    altitude: "549",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6448",
    name: "Grand Canyon West Airport",
    city: "Grand Canyon West",
    country: "United States",
    iata: "GCW",
    icao: "\\N",
    latitude: "35.5925",
    longitude: "-113.4859",
    altitude: "4825",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "6449",
    name: "Boulder City Municipal Airport",
    city: "Boulder City",
    country: "United States",
    iata: "BLD",
    icao: "KBVU",
    latitude: "35.5651",
    longitude: "-114.514",
    altitude: "2201",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "6450",
    name: "Tannheim",
    city: "Tannheim",
    country: "Germany",
    iata: "",
    icao: "EDMT",
    latitude: "48.011736",
    longitude: "10.100903",
    altitude: "1902",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6451",
    name: "Glenview Amtrak Station",
    city: "Glenview",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.074197",
    longitude: "-87.805346",
    altitude: "630",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6452",
    name: "Baltimore Penn Station",
    city: "Baltimore",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.307408",
    longitude: "-76.615552",
    altitude: "62",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6453",
    name: "Summit Camp",
    city: "Ice Cap",
    country: "Greenland",
    iata: "",
    icao: "\\N",
    latitude: "72.579187",
    longitude: "-38.4572",
    altitude: "11000",
    timezone: "0",
    dst: "U",
    tz: "America/Danmarkshavn",
  },
  {
    id: "6454",
    name: "Unst Airport",
    city: "Unst",
    country: "United Kingdom",
    iata: "UNT",
    icao: "EGPW",
    latitude: "60.7472",
    longitude: "-0.85385",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "6455",
    name: "Pagerungan",
    city: "Pagerungan",
    country: "Indonesia",
    iata: "",
    icao: "WA19",
    latitude: "-6.956608",
    longitude: "115.931239",
    altitude: "20",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "6456",
    name: "Provincetown Muni",
    city: "Provincetown",
    country: "United States",
    iata: "PVC",
    icao: "KPVC",
    latitude: "42.071945",
    longitude: "-70.22139",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6457",
    name: "Kenmore Air Harbor Seaplane Base",
    city: "Seattle",
    country: "United States",
    iata: "LKE",
    icao: "KW55",
    latitude: "47.629",
    longitude: "-122.339",
    altitude: "14",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6458",
    name: "Seria - Anduki",
    city: "Seria",
    country: "Brunei",
    iata: "",
    icao: "WBAK",
    latitude: "4.6333",
    longitude: "114.3833",
    altitude: "5",
    timezone: "8",
    dst: "N",
    tz: "Asia/Brunei",
  },
  {
    id: "6459",
    name: "Magas",
    city: "Nazran",
    country: "Russia",
    iata: "%u0",
    icao: "%u04",
    latitude: "43.323815",
    longitude: "45.017761",
    altitude: "1060",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6460",
    name: "Saint Barthelemy",
    city: "Gustavia",
    country: "France",
    iata: "SBH",
    icao: "TFFJ",
    latitude: "17.9023",
    longitude: "-62.8324",
    altitude: "50",
    timezone: "-4",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "6461",
    name: "Morro de Sao Paulo",
    city: "Morro de Sao Paulo",
    country: "Brazil",
    iata: "",
    icao: "\\N",
    latitude: "-13.2314",
    longitude: "-38.5432",
    altitude: "10",
    timezone: "3",
    dst: "S",
    tz: "\\N",
  },
  {
    id: "6462",
    name: "Morro de Sao Paulo",
    city: "Morro de Sao Paulo",
    country: "Brazil",
    iata: "",
    icao: "\\N",
    latitude: "-13.386571",
    longitude: "-38.909122",
    altitude: "10",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "6463",
    name: "Belize City Municipal Airport",
    city: "Belize",
    country: "Belize",
    iata: "TZA",
    icao: "\\N",
    latitude: "17.5344",
    longitude: "-88.298",
    altitude: "15",
    timezone: "-6",
    dst: "N",
    tz: "America/Belize",
  },
  {
    id: "6464",
    name: "Kostroma - Sokerkino",
    city: "Kostroma",
    country: "Russia",
    iata: "",
    icao: "UUBA",
    latitude: "57.47",
    longitude: "41.01",
    altitude: "453",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6465",
    name: "Sukhumi Dranda",
    city: "Sukhumi",
    country: "Georgia",
    iata: "SUI",
    icao: "UGSS",
    latitude: "42.87",
    longitude: "41.12",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Asia/Tbilisi",
  },
  {
    id: "6466",
    name: "Tambow",
    city: "Tambow",
    country: "Russia",
    iata: "TBW",
    icao: "UUOT",
    latitude: "52.81",
    longitude: "41.48",
    altitude: "126",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6467",
    name: "Oban Airport",
    city: "North Connel",
    country: "United Kingdom",
    iata: "OBN",
    icao: "EGEO",
    latitude: "56.464",
    longitude: "-5.4",
    altitude: "23",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "6468",
    name: "Vilamendhoo",
    city: "Vilamendhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "73.0191098670891",
    longitude: "3.60965475494316",
    altitude: "0",
    timezone: "1",
    dst: "U",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "6469",
    name: "Vilamendhoo",
    city: "Vilamendhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.60965475494316",
    longitude: "73.0191098670891",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "6470",
    name: "Vilamendhoo",
    city: "Vilamendhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.484",
    longitude: "73.802",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "6471",
    name: "Vilamendhoo",
    city: "Vilamendhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "73.801",
    longitude: "3.801",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "6472",
    name: "Aaa",
    city: "Aaa",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "73.9",
    longitude: "3.222",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "6473",
    name: "Vilamendhoo",
    city: "Vilamendhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "0",
    longitude: "0",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "6474",
    name: "Vilamendhoo",
    city: "Vilamendhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.8",
    longitude: "73.8",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "6475",
    name: "Sharya",
    city: "Sharya",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "58.2321",
    longitude: "45.3314",
    altitude: "453",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6476",
    name: "Mt. Fuji Shizuoka Airport",
    city: "Shizuoka",
    country: "Japan",
    iata: "FSZ",
    icao: "RJNS",
    latitude: "34.796111",
    longitude: "138.189444",
    altitude: "433",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "6477",
    name: "Erechim Airport",
    city: "Erechim",
    country: "Brazil",
    iata: "ERM",
    icao: "SSER",
    latitude: "-27.6619",
    longitude: "-52.2683",
    altitude: "2498",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6478",
    name: "La Cote",
    city: "Prangins",
    country: "Switzerland",
    iata: "",
    icao: "LSGP",
    latitude: "46.413056",
    longitude: "6.258611",
    altitude: "1350",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6479",
    name: "Courchevel Airport",
    city: "Courcheval",
    country: "France",
    iata: "CVF",
    icao: "LFLJ",
    latitude: "45.3967",
    longitude: "6.63472",
    altitude: "6588",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "6481",
    name: "Fullerton Municipal Airport",
    city: "Fullerton",
    country: "United States",
    iata: "FUL",
    icao: "KFUL",
    latitude: "33.521925",
    longitude: "-117.584722",
    altitude: "96",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6482",
    name: "Concord Rgnl",
    city: "Concord",
    country: "United States",
    iata: "",
    icao: "KJQF",
    latitude: "35.387775",
    longitude: "-80.709136",
    altitude: "705",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6483",
    name: "Sandown",
    city: "Isle Of Wight",
    country: "United Kingdom",
    iata: "",
    icao: "EGHN",
    latitude: "50.677776",
    longitude: "-1.317803",
    altitude: "18",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "6484",
    name: "Fort William Heliport",
    city: "Fort William",
    country: "United Kingdom",
    iata: "FWM",
    icao: "\\N",
    latitude: "56.816666",
    longitude: "-5.116667",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "6485",
    name: "Navoi Airport",
    city: "Navoi",
    country: "Uzbekistan",
    iata: "NVI",
    icao: "UTSA",
    latitude: "40.1172",
    longitude: "65.1708",
    altitude: "0",
    timezone: "5",
    dst: "E",
    tz: "Asia/Samarkand",
  },
  {
    id: "6486",
    name: "La Defense Heliport",
    city: "Paris",
    country: "France",
    iata: "JPU",
    icao: "\\N",
    latitude: "48.86667",
    longitude: "2.333333",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "6487",
    name: "Andernos-Les-Bains",
    city: "Andernos-Les-Bains",
    country: "France",
    iata: "",
    icao: "LFCD",
    latitude: "44.81111",
    longitude: "-1.186023",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "6488",
    name: "Ronda Airport",
    city: "Ronda",
    country: "Spain",
    iata: "RRA",
    icao: "\\N",
    latitude: "36.75",
    longitude: "-5.166667",
    altitude: "2500",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "6489",
    name: "Bienenfarm Airport",
    city: "Nauen",
    country: "Germany",
    iata: "",
    icao: "EDOI",
    latitude: "52.6617",
    longitude: "12.7458",
    altitude: "131",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8131",
    name: "Nguma Island Lodge Airstrip",
    city: "Etsha 13",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-18.9538",
    longitude: "22.3668",
    altitude: "0",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "6491",
    name: "Champion-7",
    city: "Champion-7",
    country: "Brunei",
    iata: "",
    icao: "\\N",
    latitude: "5.21",
    longitude: "114.7419",
    altitude: "12",
    timezone: "8",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "6492",
    name: "Ain Arnat Airport",
    city: "Setif",
    country: "Algeria",
    iata: "QSF",
    icao: "DAAS",
    latitude: "36.1781",
    longitude: "5.32449",
    altitude: "3360",
    timezone: "1",
    dst: "U",
    tz: "Africa/Algiers",
  },
  {
    id: "6493",
    name: "La Rochelle-Ile de Re",
    city: "La Rochelle",
    country: "France",
    iata: "LRH",
    icao: "LFBH",
    latitude: "46.1792",
    longitude: "-1.19528",
    altitude: "74",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "6494",
    name: "Friedman Mem",
    city: "Hailey",
    country: "United States",
    iata: "SUN",
    icao: "KSUN",
    latitude: "43.504444",
    longitude: "-114.296194",
    altitude: "5320",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "6497",
    name: "Yverdon-Les-Bains",
    city: "Yverdon-Les-Bains",
    country: "Switzerland",
    iata: "",
    icao: "LSGY",
    latitude: "46.86667",
    longitude: "6.7",
    altitude: "1427",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6498",
    name: "Portsmouth Airport",
    city: "Portsmouth",
    country: "United Kingdom",
    iata: "PME",
    icao: "\\N",
    latitude: "50.8",
    longitude: "-1.083333",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "6499",
    name: "Aleksandrowice",
    city: "Bielsko-Biala",
    country: "Poland",
    iata: "",
    icao: "EPBA",
    latitude: "49.84997",
    longitude: "19.020193",
    altitude: "860",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "6500",
    name: "Mason City Municipal",
    city: "Mason City",
    country: "United States",
    iata: "MCW",
    icao: "KMCW",
    latitude: "43.2247",
    longitude: "-93.4067",
    altitude: "1243",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6501",
    name: "Salar de Uyuni",
    city: "Salar de Uyuni",
    country: "Bolivia",
    iata: "",
    icao: "\\N",
    latitude: "-20.330706",
    longitude: "-67.046881",
    altitude: "12000",
    timezone: "-4",
    dst: "S",
    tz: "America/La_Paz",
  },
  {
    id: "6502",
    name: "Isla Pescado",
    city: "Isla Pescado",
    country: "Bolivia",
    iata: "",
    icao: "\\N",
    latitude: "-20.240932",
    longitude: "-67.62538",
    altitude: "12020",
    timezone: "-4",
    dst: "S",
    tz: "America/La_Paz",
  },
  {
    id: "6503",
    name: "Toro Toro",
    city: "Toro Toro",
    country: "Bolivia",
    iata: "",
    icao: "\\N",
    latitude: "-18.133114",
    longitude: "-65.768781",
    altitude: "9007",
    timezone: "-4",
    dst: "S",
    tz: "America/La_Paz",
  },
  {
    id: "6512",
    name: "QTHRL",
    city: "Queenstown",
    country: "New Zealand",
    iata: "",
    icao: "\\N",
    latitude: "-44.8898",
    longitude: "168.6762",
    altitude: "1",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "6513",
    name: "QTHRS",
    city: "Queenstown",
    country: "New Zealand",
    iata: "",
    icao: "\\N",
    latitude: "-44.9486",
    longitude: "168.7068",
    altitude: "1",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "6514",
    name: "Helirafting Start",
    city: "Queenstown",
    country: "New Zealand",
    iata: "",
    icao: "\\N",
    latitude: "-44.9486",
    longitude: "168.7068",
    altitude: "1300",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "6515",
    name: "Helirafting Landung",
    city: "Queenstown",
    country: "New Zealand",
    iata: "",
    icao: "\\N",
    latitude: "-44.8898",
    longitude: "168.6762",
    altitude: "1300",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "6517",
    name: "Jomo Kenyatta",
    city: "Nairobi",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.319242",
    longitude: "36.927775",
    altitude: "1625",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "6518",
    name: "DWEST",
    city: "DWEST",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.025",
    longitude: "7.1837",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6519",
    name: "Niederoeblarn",
    city: "Niederoeblarn",
    country: "Austria",
    iata: "",
    icao: "LOGO",
    latitude: "47.478",
    longitude: "14.008",
    altitude: "2142",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "6520",
    name: "Bad Voeslau",
    city: "Bad Voeslau",
    country: "Austria",
    iata: "",
    icao: "LOAV",
    latitude: "47.965",
    longitude: "16.259",
    altitude: "765",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "6521",
    name: "Arekuna Camp",
    city: "Arekuna",
    country: "Venezuela",
    iata: "",
    icao: "\\N",
    latitude: "6.290501",
    longitude: "-62.534499",
    altitude: "0",
    timezone: "-4.5",
    dst: "S",
    tz: "America/Caracas",
  },
  {
    id: "6522",
    name: "Uetersen",
    city: "Uetersen",
    country: "Germany",
    iata: "",
    icao: "EDHE",
    latitude: "53.646667",
    longitude: "9.704167",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6523",
    name: "HLP1 HS-16",
    city: "Salzwedel",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "52.8333",
    longitude: "11.2027",
    altitude: "111",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "6524",
    name: "HLP2 HS-16",
    city: "Nordhausen",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.4888",
    longitude: "10.7833",
    altitude: "278",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "6525",
    name: "HLP HQ GT",
    city: "Paetz",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "52.2361",
    longitude: "13.6667",
    altitude: "98",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "6944",
    name: "Jining Airport ",
    city: "Jining",
    country: "China",
    iata: "JNG",
    icao: "\\N",
    latitude: "35.417",
    longitude: "116.533",
    altitude: "1540",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6943",
    name: "Heilongjiang Mohe Airport",
    city: "Mohe County",
    country: "China",
    iata: "OHE",
    icao: "\\N",
    latitude: "52.915",
    longitude: "122.427",
    altitude: "1500",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6942",
    name: "Daqing Saertu Airport",
    city: "Daqing",
    country: "China",
    iata: "DAQ",
    icao: "\\N",
    latitude: "46.583333",
    longitude: "125",
    altitude: "1020",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6941",
    name: "Byron Airport",
    city: "Byron",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.8284",
    longitude: "-121.626",
    altitude: "79",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6940",
    name: "Tunoshna",
    city: "Yaroslavl",
    country: "Russia",
    iata: "IAR",
    icao: "UUDL",
    latitude: "57.560666676667",
    longitude: "40.157369454444",
    altitude: "270",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6939",
    name: "Belaya",
    city: "Sredniiy",
    country: "Russia",
    iata: "",
    icao: "UIIB",
    latitude: "52.91500001",
    longitude: "103.57500001",
    altitude: "1396",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "6938",
    name: "Borisoglebskoe",
    city: "Kazan",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.86067",
    longitude: "49.10099",
    altitude: "384",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6937",
    name: "Dzemgi",
    city: "Komsomolsk-on-Amur",
    country: "Russia",
    iata: "",
    icao: "UHKD",
    latitude: "50.605",
    longitude: "137.08167",
    altitude: "82",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "6936",
    name: "Khabarovsk-MVL",
    city: "Khabarovsk",
    country: "Russia",
    iata: "",
    icao: "UHHT",
    latitude: "48.528",
    longitude: "135.179",
    altitude: "213",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "6935",
    name: "Irkutsk-2",
    city: "Irkutsk",
    country: "Russia",
    iata: "",
    icao: "UIIR",
    latitude: "52.3678",
    longitude: "104.183",
    altitude: "13411",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "6934",
    name: "Zhukovski",
    city: "Ramenskoe",
    country: "Russia",
    iata: "",
    icao: "UUBW",
    latitude: "55.589",
    longitude: "38.154",
    altitude: "335",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6933",
    name: "Gelendzhik",
    city: "Gelendzhik",
    country: "Russia",
    iata: "",
    icao: "URKG",
    latitude: "44.55",
    longitude: "38.083",
    altitude: "100",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6932",
    name: "Taganrog-Juzhnyi",
    city: "Taganrog",
    country: "Russia",
    iata: "",
    icao: "URRT",
    latitude: "47.117",
    longitude: "38.513",
    altitude: "100",
    timezone: "4",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "6931",
    name: "Neuchatel Airport",
    city: "Neuchatel",
    country: "Switzerland",
    iata: "QNC",
    icao: "LSGN",
    latitude: "46.9575",
    longitude: "6.86472",
    altitude: "1427",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6930",
    name: "Locarno Airport",
    city: "Locarno",
    country: "Switzerland",
    iata: "ZJI",
    icao: "LSZL",
    latitude: "46.1608",
    longitude: "8.87861",
    altitude: "650",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6929",
    name: "Speck-Fehraltorf Airport",
    city: "Fehraltorf",
    country: "Switzerland",
    iata: "",
    icao: "LSZK",
    latitude: "47.3764",
    longitude: "8.7575",
    altitude: "1748",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6928",
    name: "Lausanne-la Blecherette Airport",
    city: "Lausanne",
    country: "Switzerland",
    iata: "",
    icao: "LSGL",
    latitude: "46.5453",
    longitude: "6.61667",
    altitude: "2041",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6927",
    name: "Triengen Airport",
    city: "Triengen",
    country: "Switzerland",
    iata: "",
    icao: "LSPN",
    latitude: "47.2267",
    longitude: "8.07806",
    altitude: "1594",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6926",
    name: "Rimatara",
    city: "Rimatara",
    country: "French Polynesia",
    iata: "RMT",
    icao: "NTAM",
    latitude: "-22.637253",
    longitude: "-152.805192",
    altitude: "56",
    timezone: "-10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "6925",
    name: "Ust-Ilimsk",
    city: "Ust-Ilimsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "58.116667",
    longitude: "102.4666667",
    altitude: "1244",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "6924",
    name: "Ust-Kut",
    city: "Ust-Kut",
    country: "Russia",
    iata: "UKX",
    icao: "UITT",
    latitude: "56.85",
    longitude: "105.7167",
    altitude: "2033",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "6923",
    name: "Kavalerovo",
    city: "Kavalerovo",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "44.270556",
    longitude: "135.054722",
    altitude: "675",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "6922",
    name: "Kirensk",
    city: "Kirensk",
    country: "Russia",
    iata: "",
    icao: "UIKK",
    latitude: "57.7667",
    longitude: "108.05",
    altitude: "780",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "6921",
    name: "Fortman Airport",
    city: "St. Marys",
    country: "United States",
    iata: "1OH",
    icao: "\\N",
    latitude: "40.5553253",
    longitude: "-84.3866186",
    altitude: "885",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "6920",
    name: "Bellona",
    city: "Bellona",
    country: "Solomon Islands",
    iata: "BN1",
    icao: "\\N",
    latitude: "15.981666666667",
    longitude: "-11.3",
    altitude: "3",
    timezone: "0",
    dst: "U",
    tz: "Africa/Nouakchott",
  },
  {
    id: "6919",
    name: "Bellona",
    city: "Bellona",
    country: "Solomon Islands",
    iata: "BNY",
    icao: "\\N",
    latitude: "-11.302",
    longitude: "159.8",
    altitude: "3",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "6918",
    name: "Ringi Cove Airport",
    city: "Ringi Cove",
    country: "Solomon Islands",
    iata: "RIN",
    icao: "AGRC",
    latitude: "-8.12639",
    longitude: "157.143",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "6917",
    name: "Antonio Juarbe Pol Airport",
    city: "Arecibo",
    country: "Puerto Rico",
    iata: "ARE",
    icao: "TJAB",
    latitude: "18.451111",
    longitude: "-66.675556",
    altitude: "23",
    timezone: "-4",
    dst: "N",
    tz: "America/Puerto_Rico",
  },
  {
    id: "6916",
    name: "Pangborn Field",
    city: "Wenatchee",
    country: "United States",
    iata: "EAT",
    icao: "KEAT",
    latitude: "47.398",
    longitude: "-120.206",
    altitude: "1249",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6915",
    name: "Bendigo Airport",
    city: "Bendigo",
    country: "Australia",
    iata: "",
    icao: "YBDG",
    latitude: "-36.7394",
    longitude: "144.33",
    altitude: "705",
    timezone: "10",
    dst: "U",
    tz: "Australia/Hobart",
  },
  {
    id: "6913",
    name: "Aeroporto Prefeito Octavio de Almeida Neves",
    city: "Sao Joao del Rei",
    country: "Brazil",
    iata: "JDR",
    icao: "\\N",
    latitude: "-21.0864",
    longitude: "-44.2258",
    altitude: "3120",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6914",
    name: "RAAF Pearce",
    city: "Perth",
    country: "Australia",
    iata: "",
    icao: "YPEA",
    latitude: "-31.66778",
    longitude: "116.015",
    altitude: "149",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "6911",
    name: "Wangerooge Airport",
    city: "Wangerooge",
    country: "Germany",
    iata: "AGE",
    icao: "EDWG",
    latitude: "53.7828",
    longitude: "7.91389",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6910",
    name: "Harle Airport",
    city: "Harlesiel",
    country: "Germany",
    iata: "",
    icao: "EDXP",
    latitude: "53.7067",
    longitude: "7.82028",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6909",
    name: "Wittman Regional Airport",
    city: "Oshkosh",
    country: "United States",
    iata: "OSH",
    icao: "KOSH",
    latitude: "44.024983",
    longitude: "-88.551336",
    altitude: "790",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6908",
    name: "Brest",
    city: "Brest",
    country: "Belarus",
    iata: "BQT",
    icao: "UMBB",
    latitude: "52.06",
    longitude: "23.53",
    altitude: "468",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "6907",
    name: "Ternopol",
    city: "Ternopol",
    country: "Ukraine",
    iata: "TNL",
    icao: "UKLT",
    latitude: "49.31",
    longitude: "25.42",
    altitude: "1073",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6906",
    name: "Chernigov",
    city: "Chernigov",
    country: "Ukraine",
    iata: "CEJ",
    icao: "UKRR",
    latitude: "51.24",
    longitude: "31.09",
    altitude: "446",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6905",
    name: "Lutsk",
    city: "Lutsk",
    country: "Ukraine",
    iata: "UKC",
    icao: "UKLC",
    latitude: "50.6833",
    longitude: "25.4833",
    altitude: "774",
    timezone: "2",
    dst: "U",
    tz: "Europe/Kiev",
  },
  {
    id: "6904",
    name: "Southwest Michigan Regional Airport",
    city: "Benton Harbor",
    country: "United States",
    iata: "BEH",
    icao: "\\N",
    latitude: "42.1285833",
    longitude: "-86.4285",
    altitude: "643",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6903",
    name: "Waukesha County Airport",
    city: "Waukesha",
    country: "United States",
    iata: "UES",
    icao: "\\N",
    latitude: "43.0410278",
    longitude: "-88.2370556",
    altitude: "911",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6902",
    name: "Ronda",
    city: "Ronda",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.73333",
    longitude: "-5.166667",
    altitude: "1000",
    timezone: "1",
    dst: "U",
    tz: "Europe/Madrid",
  },
  {
    id: "6901",
    name: "Thurles",
    city: "Thurles",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "52.67888",
    longitude: "-7.814369",
    altitude: "500",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "6900",
    name: "Limerick",
    city: "Limerick",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "52.659",
    longitude: "-8.624",
    altitude: "500",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "6899",
    name: "Nowra Airport",
    city: "Nowra",
    country: "Australia",
    iata: "NOA",
    icao: "YSNW",
    latitude: "-34.9489",
    longitude: "150.537",
    altitude: "400",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "6898",
    name: "RAAF Williams Laverton Base",
    city: "Laverton",
    country: "Australia",
    iata: "",
    icao: "YLVT",
    latitude: "-37.8636",
    longitude: "144.746",
    altitude: "18",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "6897",
    name: "Tindal Airport",
    city: "Katherine",
    country: "Australia",
    iata: "KTR",
    icao: "YPTN",
    latitude: "-14.5211",
    longitude: "132.378",
    altitude: "443",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "6896",
    name: "Amberley",
    city: "Amberley",
    country: "Australia",
    iata: "",
    icao: "YAMB",
    latitude: "-27.64",
    longitude: "152.712",
    altitude: "91",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "6895",
    name: "Geiranger",
    city: "Geiranger",
    country: "Norway",
    iata: "",
    icao: "GEIR",
    latitude: "62.1",
    longitude: "7.2",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "6894",
    name: "Zell am See",
    city: "Zell am See",
    country: "Austria",
    iata: "",
    icao: "LOWZ",
    latitude: "47.2933",
    longitude: "12.7883",
    altitude: "2470",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "6893",
    name: "Galt Field Airport",
    city: "Greenwood",
    country: "United States",
    iata: "10C",
    icao: "\\N",
    latitude: "42.4028889",
    longitude: "-88.3751111",
    altitude: "875",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "6892",
    name: "Everglades Airpark",
    city: "Everglades",
    country: "United States",
    iata: "X01",
    icao: "\\N",
    latitude: "25.8488611",
    longitude: "-81.3902778",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "6795",
    name: "Choibalsan Airport",
    city: "Choibalsan",
    country: "Mongolia",
    iata: "COQ",
    icao: "ZMCD",
    latitude: "48.1357",
    longitude: "114.646",
    altitude: "2457",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "6794",
    name: "Taree Airport",
    city: "Taree",
    country: "Australia",
    iata: "TRO",
    icao: "YTRE",
    latitude: "-31.8886",
    longitude: "152.514",
    altitude: "38",
    timezone: "10",
    dst: "U",
    tz: "Australia/Sydney",
  },
  {
    id: "6793",
    name: "Orange Airport",
    city: "Orange",
    country: "Australia",
    iata: "OAG",
    icao: "YORG",
    latitude: "-33.3817",
    longitude: "149.133",
    altitude: "3115",
    timezone: "10",
    dst: "U",
    tz: "Australia/Sydney",
  },
  {
    id: "6792",
    name: "Grafton Airport",
    city: "Grafton",
    country: "Australia",
    iata: "GFN",
    icao: "YGFN",
    latitude: "-29.7594",
    longitude: "153.03",
    altitude: "110",
    timezone: "10",
    dst: "U",
    tz: "Australia/Sydney",
  },
  {
    id: "6791",
    name: "Marinduque Airport",
    city: "Gasan",
    country: "Philippines",
    iata: "MRQ",
    icao: "RPUW",
    latitude: "13.360967",
    longitude: "121.825583",
    altitude: "32",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6790",
    name: "Hamadan Airport",
    city: "Hamadan",
    country: "Iran",
    iata: "HDM",
    icao: "OIHH",
    latitude: "34.869167",
    longitude: "48.5525",
    altitude: "5755",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6789",
    name: "St Augustin Airport",
    city: "St-Augustin",
    country: "Canada",
    iata: "YIF",
    icao: "CYIF",
    latitude: "51.2117",
    longitude: "-58.6583",
    altitude: "20",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "6788",
    name: "Vieques Airport",
    city: "Vieques Island",
    country: "Puerto Rico",
    iata: "VQS",
    icao: "TJCG",
    latitude: "18.1158",
    longitude: "-65.4227",
    altitude: "19",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "6787",
    name: "Kalay Airport",
    city: "Kalemyo",
    country: "Myanmar",
    iata: "KMV",
    icao: "VYKL",
    latitude: "23.188811",
    longitude: "94.051094",
    altitude: "499",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6786",
    name: "Terre-de-Haut Airport",
    city: "Les Saintes",
    country: "Guadeloupe",
    iata: "LSS",
    icao: "TFFS",
    latitude: "15.8644",
    longitude: "-61.5806",
    altitude: "46",
    timezone: "-4",
    dst: "U",
    tz: "America/Guadeloupe",
  },
  {
    id: "6785",
    name: "Yenisehir Airport",
    city: "Yenisehir",
    country: "Turkey",
    iata: "YEI",
    icao: "LTBR",
    latitude: "40.255208",
    longitude: "29.562569",
    altitude: "764",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6784",
    name: "Tekirdağ Çorlu Airport",
    city: "Çorlu",
    country: "Turkey",
    iata: "TEQ",
    icao: "LTBU",
    latitude: "41.13825",
    longitude: "27.919094",
    altitude: "574",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6783",
    name: "Sinop Airport",
    city: "Sinop",
    country: "Turkey",
    iata: "SIC",
    icao: "LTCM",
    latitude: "42.0158",
    longitude: "35.0664",
    altitude: "20",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6782",
    name: "Mus Airport",
    city: "Mus",
    country: "Turkey",
    iata: "MSR",
    icao: "LTCK",
    latitude: "38.747769",
    longitude: "41.661236",
    altitude: "4157",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6781",
    name: "Canakkale Airport",
    city: "Canakkale",
    country: "Turkey",
    iata: "CKZ",
    icao: "LTBH",
    latitude: "40.137722",
    longitude: "26.426777",
    altitude: "23",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6780",
    name: "Anadolu Airport",
    city: "Eskissehir",
    country: "Turkey",
    iata: "AOE",
    icao: "LTBY",
    latitude: "39.809858",
    longitude: "30.519378",
    altitude: "2588",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6779",
    name: "Katima Mulilo Airport",
    city: "Mpacha",
    country: "Namibia",
    iata: "MPA",
    icao: "FYKM",
    latitude: "-17.6344",
    longitude: "24.1767",
    altitude: "3144",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "6778",
    name: "Walvis Bay Airport",
    city: "Walvis Bay",
    country: "Namibia",
    iata: "WVB",
    icao: "FYWB",
    latitude: "-22.9799",
    longitude: "14.6453",
    altitude: "299",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "6777",
    name: "Capitan Corbeta C A Curbelo International Airport",
    city: "Punta del Este",
    country: "Uruguay",
    iata: "PDP",
    icao: "SULS",
    latitude: "-34.855139",
    longitude: "-55.094278",
    altitude: "95",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "6776",
    name: "Sialkot Airport",
    city: "Sialkot",
    country: "Pakistan",
    iata: "SKT",
    icao: "OPST",
    latitude: "32.5356",
    longitude: "74.3639",
    altitude: "810",
    timezone: "5",
    dst: "N",
    tz: "Asia/Karachi",
  },
  {
    id: "6775",
    name: "Bonaventure Airport",
    city: "Bonaventure",
    country: "Canada",
    iata: "YVB",
    icao: "CYVB",
    latitude: "48.0711",
    longitude: "-65.4603",
    altitude: "123",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "6774",
    name: "Brus Laguna Airport",
    city: "Brus Laguna",
    country: "Honduras",
    iata: "BHG",
    icao: "MHBL",
    latitude: "15.7631",
    longitude: "-84.5436",
    altitude: "2",
    timezone: "-6",
    dst: "U",
    tz: "America/Tegucigalpa",
  },
  {
    id: "6773",
    name: "Samburu South Airport",
    city: "Samburu South",
    country: "Kenya",
    iata: "UAS",
    icao: "HKSB",
    latitude: "0.530583",
    longitude: "37.5342",
    altitude: "3295",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "6772",
    name: "Chaoyang Airport",
    city: "Chaoyang",
    country: "China",
    iata: "CHG",
    icao: "ZYCY",
    latitude: "41.5381",
    longitude: "120.435",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6771",
    name: "Walaha Airport",
    city: "Walaha",
    country: "Vanuatu",
    iata: "WLH",
    icao: "NVSW",
    latitude: "-15.412",
    longitude: "167.691",
    altitude: "151",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Efate",
  },
  {
    id: "6770",
    name: "Tanjung Manis Airport",
    city: "Tanjung Manis",
    country: "Malaysia",
    iata: "TGC",
    icao: "WBTM",
    latitude: "2.17784",
    longitude: "111.202",
    altitude: "15",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6769",
    name: "Long Akah Airport",
    city: "Long Akah",
    country: "Malaysia",
    iata: "LKH",
    icao: "WBGL",
    latitude: "3.3",
    longitude: "114.783",
    altitude: "289",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "6768",
    name: "Geneina Airport",
    city: "Geneina",
    country: "Sudan",
    iata: "EGN",
    icao: "HSGN",
    latitude: "13.4817",
    longitude: "22.4672",
    altitude: "2650",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "6767",
    name: "Togiak Airport",
    city: "Togiak Village",
    country: "United States",
    iata: "TOG",
    icao: "PATG",
    latitude: "59.0528",
    longitude: "-160.397",
    altitude: "21",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6766",
    name: "Port Heiden Airport",
    city: "Port Heiden",
    country: "United States",
    iata: "PTH",
    icao: "PAPH",
    latitude: "56.9591",
    longitude: "-158.633",
    altitude: "95",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6765",
    name: "King Cove Airport",
    city: "King Cove",
    country: "United States",
    iata: "KVC",
    icao: "PAVC",
    latitude: "55.1163",
    longitude: "-162.266",
    altitude: "155",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6764",
    name: "New Stuyahok Airport",
    city: "New Stuyahok",
    country: "United States",
    iata: "KNW",
    icao: "PANW",
    latitude: "59.4499",
    longitude: "-157.328",
    altitude: "302",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6763",
    name: "Igiugig Airport",
    city: "Igiugig",
    country: "United States",
    iata: "IGG",
    icao: "PAIG",
    latitude: "59.324",
    longitude: "-155.902",
    altitude: "90",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6762",
    name: "Shimla Airport",
    city: "Shimla",
    country: "India",
    iata: "SLV",
    icao: "VISM",
    latitude: "31.081803",
    longitude: "77.067967",
    altitude: "5072",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6761",
    name: "Nanded Airport",
    city: "Nanded",
    country: "India",
    iata: "NDC",
    icao: "VAND",
    latitude: "19.1833",
    longitude: "77.3167",
    altitude: "1250",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6760",
    name: "Kangra Airport",
    city: "Kangra",
    country: "India",
    iata: "DHM",
    icao: "VIGG",
    latitude: "32.1651",
    longitude: "76.2634",
    altitude: "2525",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6759",
    name: "Shahre Kord Airport",
    city: "Shahre Kord",
    country: "Iran",
    iata: "CQD",
    icao: "OIFS",
    latitude: "32.2972",
    longitude: "50.8422",
    altitude: "6723",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6758",
    name: "Sege Airport",
    city: "Sege",
    country: "Solomon Islands",
    iata: "EGM",
    icao: "AGGS",
    latitude: "-8.57889",
    longitude: "157.876",
    altitude: "0",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "6757",
    name: "Burgos Airport",
    city: "Burgos",
    country: "Spain",
    iata: "RGS",
    icao: "LEBG",
    latitude: "42.357628",
    longitude: "-3.620764",
    altitude: "2945",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "6756",
    name: "Leon Airport",
    city: "Leon",
    country: "Spain",
    iata: "LEN",
    icao: "LELN",
    latitude: "42.589",
    longitude: "-5.655556",
    altitude: "3006",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "6755",
    name: "Deering Airport",
    city: "Deering",
    country: "United States",
    iata: "DRG",
    icao: "PADE",
    latitude: "66.0696",
    longitude: "-162.766",
    altitude: "21",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6754",
    name: "Sugraly Airport",
    city: "Zarafshan",
    country: "Uzbekistan",
    iata: "AFS",
    icao: "UTSN",
    latitude: "41.6139",
    longitude: "64.2332",
    altitude: "1396",
    timezone: "5",
    dst: "U",
    tz: "Asia/Samarkand",
  },
  {
    id: "6753",
    name: "Mardin Airport",
    city: "Mardin",
    country: "Turkey",
    iata: "MQM",
    icao: "LTCR",
    latitude: "37.2233",
    longitude: "40.6317",
    altitude: "1729",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "6752",
    name: "Tacheng Airport",
    city: "Tacheng",
    country: "China",
    iata: "TCG",
    icao: "ZWTC",
    latitude: "46.6725",
    longitude: "83.3408",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6751",
    name: "Tocache Airport",
    city: "Tocache",
    country: "Peru",
    iata: "",
    icao: "SPCH",
    latitude: "-8.183",
    longitude: "-76.517",
    altitude: "1500",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6750",
    name: "Nueva Loja Airport",
    city: "Lago Agrio",
    country: "Ecuador",
    iata: "LGQ",
    icao: "SELA",
    latitude: "0.093056",
    longitude: "-76.8675",
    altitude: "980",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "6749",
    name: "Parsabade Moghan Airport",
    city: "Parsabad",
    country: "Iran",
    iata: "PFQ",
    icao: "OITP",
    latitude: "39.603606",
    longitude: "47.8815",
    altitude: "251",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6748",
    name: "Ilam Airport",
    city: "Ilam",
    country: "Iran",
    iata: "IIL",
    icao: "OICI",
    latitude: "33.586606",
    longitude: "46.404842",
    altitude: "4404",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6747",
    name: "Gorgan Airport",
    city: "Gorgan",
    country: "Iran",
    iata: "GBT",
    icao: "OING",
    latitude: "36.909381",
    longitude: "54.401339",
    altitude: "-24",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6746",
    name: "Sahand Airport",
    city: "Maragheh",
    country: "Iran",
    iata: "ACP",
    icao: "OITM",
    latitude: "37.348017",
    longitude: "46.127903",
    altitude: "4396",
    timezone: "3.5",
    dst: "E",
    tz: "Asia/Tehran",
  },
  {
    id: "6745",
    name: "Romblon Airport",
    city: "Romblon",
    country: "Philippines",
    iata: "TBH",
    icao: "RPVU",
    latitude: "12.311",
    longitude: "122.085",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6744",
    name: "Changzhoudao Airport",
    city: "Wuzhou",
    country: "China",
    iata: "WUZ",
    icao: "ZGWZ",
    latitude: "23.4567",
    longitude: "111.248",
    altitude: "89",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6743",
    name: "Hami Airport",
    city: "Hami",
    country: "China",
    iata: "HMI",
    icao: "ZWHM",
    latitude: "42.8414",
    longitude: "93.6692",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6742",
    name: "Sand Point Airport",
    city: "Sand Point",
    country: "United States",
    iata: "SDP",
    icao: "PASD",
    latitude: "55.315",
    longitude: "-160.523",
    altitude: "21",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6741",
    name: "Gorakhpur Airport",
    city: "Gorakhpur",
    country: "India",
    iata: "GOP",
    icao: "VEGK",
    latitude: "26.739708",
    longitude: "83.449708",
    altitude: "259",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "6740",
    name: "Araracuara Airport",
    city: "Araracuara",
    country: "Colombia",
    iata: "ACR",
    icao: "SKAC",
    latitude: "-0.58",
    longitude: "-72.41",
    altitude: "1250",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "6739",
    name: "Hagerstown Regional Richard A Henson Field",
    city: "Hagerstown",
    country: "United States",
    iata: "HGR",
    icao: "KHGR",
    latitude: "39.7079",
    longitude: "-77.7295",
    altitude: "704",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6738",
    name: "Bella Coola Airport",
    city: "Bella Coola",
    country: "Canada",
    iata: "QBC",
    icao: "CYBD",
    latitude: "52.3875",
    longitude: "-126.596",
    altitude: "117",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "6737",
    name: "Pajala Airport",
    city: "Pajala",
    country: "Sweden",
    iata: "PJA",
    icao: "ESUP",
    latitude: "67.2456",
    longitude: "23.0689",
    altitude: "542",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "6736",
    name: "Port Clarence Coast Guard Station",
    city: "Port Clarence",
    country: "United States",
    iata: "KPC",
    icao: "PAPC",
    latitude: "65.2537",
    longitude: "-166.859",
    altitude: "10",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6735",
    name: "Governador Valadares Airport",
    city: "Governador Valadares",
    country: "Brazil",
    iata: "GVR",
    icao: "SBGV",
    latitude: "-18.8952",
    longitude: "-41.9822",
    altitude: "561",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "6734",
    name: "Kirovsk-Apatity Airport",
    city: "Apatity",
    country: "Russia",
    iata: "KVK",
    icao: "ULMK",
    latitude: "67.4633",
    longitude: "33.5883",
    altitude: "515",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6733",
    name: "Cauayan Airport",
    city: "Cauayan",
    country: "Philippines",
    iata: "CYZ",
    icao: "RPUY",
    latitude: "16.929861",
    longitude: "121.753036",
    altitude: "200",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6732",
    name: "Tambor Airport",
    city: "Nicoya",
    country: "Costa Rica",
    iata: "TMU",
    icao: "MRTR",
    latitude: "9.73852",
    longitude: "-85.0138",
    altitude: "33",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "6731",
    name: "Arenal Airport",
    city: "La Fortuna/San Carlos",
    country: "Costa Rica",
    iata: "FON",
    icao: "MRAN",
    latitude: "10.478",
    longitude: "-84.6345",
    altitude: "342",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "6730",
    name: "Imo Airport",
    city: "Imo",
    country: "Nigeria",
    iata: "QOW",
    icao: "DNIM",
    latitude: "5.42706",
    longitude: "7.20603",
    altitude: "373",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "6729",
    name: "Arctic Village Airport",
    city: "Arctic Village",
    country: "United States",
    iata: "ARC",
    icao: "PARC",
    latitude: "68.1147",
    longitude: "-145.579",
    altitude: "2092",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6728",
    name: "Tasiujaq Airport",
    city: "Tasiujaq",
    country: "Canada",
    iata: "YTQ",
    icao: "CYTQ",
    latitude: "58.6678",
    longitude: "-69.9558",
    altitude: "122",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "6727",
    name: "Puvirnituq Airport",
    city: "Puvirnituq",
    country: "Canada",
    iata: "YPX",
    icao: "CYPX",
    latitude: "60.0506",
    longitude: "-77.2869",
    altitude: "74",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "6726",
    name: "Ormoc Airport",
    city: "Ormoc City",
    country: "Philippines",
    iata: "OMC",
    icao: "RPVO",
    latitude: "11.057997",
    longitude: "124.565322",
    altitude: "83",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6725",
    name: "Noatak Airport",
    city: "Noatak",
    country: "United States",
    iata: "WTK",
    icao: "PAWN",
    latitude: "67.5661",
    longitude: "-162.975",
    altitude: "88",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6724",
    name: "Savoonga Airport",
    city: "Savoonga",
    country: "United States",
    iata: "SVA",
    icao: "PASA",
    latitude: "63.6864",
    longitude: "-170.493",
    altitude: "53",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6723",
    name: "Shishmaref Airport",
    city: "Shishmaref",
    country: "United States",
    iata: "SHH",
    icao: "PASH",
    latitude: "66.2496",
    longitude: "-166.089",
    altitude: "12",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6722",
    name: "Ruby Airport",
    city: "Ruby",
    country: "United States",
    iata: "RBY",
    icao: "PARY",
    latitude: "64.7272",
    longitude: "-155.47",
    altitude: "653",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6721",
    name: "Point Hope Airport",
    city: "Point Hope",
    country: "United States",
    iata: "PHO",
    icao: "PPHO",
    latitude: "68.3488",
    longitude: "-166.799",
    altitude: "12",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6720",
    name: "Mekoryuk Airport",
    city: "Mekoryuk",
    country: "United States",
    iata: "MYU",
    icao: "PAMY",
    latitude: "60.3714",
    longitude: "-166.271",
    altitude: "48",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6719",
    name: "Kivalina Airport",
    city: "Kivalina",
    country: "United States",
    iata: "KVL",
    icao: "PAVL",
    latitude: "67.7362",
    longitude: "-164.563",
    altitude: "13",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6718",
    name: "St Marys Airport",
    city: "St Mary's",
    country: "United States",
    iata: "KSM",
    icao: "PASM",
    latitude: "62.0605",
    longitude: "-163.302",
    altitude: "311",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6717",
    name: "Kaltag Airport",
    city: "Kaltag",
    country: "United States",
    iata: "KAL",
    icao: "PAKV",
    latitude: "64.3191",
    longitude: "-158.741",
    altitude: "187",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6716",
    name: "Hooper Bay Airport",
    city: "Hooper Bay",
    country: "United States",
    iata: "HPB",
    icao: "PAHP",
    latitude: "61.5239",
    longitude: "-166.147",
    altitude: "7",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6715",
    name: "Gambell Airport",
    city: "Gambell",
    country: "United States",
    iata: "GAM",
    icao: "PAGM",
    latitude: "63.7668",
    longitude: "-171.733",
    altitude: "27",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6714",
    name: "Atqasuk Edward Burnell Sr Memorial Airport",
    city: "Atqasuk",
    country: "United States",
    iata: "ATK",
    icao: "PATQ",
    latitude: "70.4673",
    longitude: "-157.436",
    altitude: "96",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6713",
    name: "Anvik Airport",
    city: "Anvik",
    country: "United States",
    iata: "ANV",
    icao: "PANV",
    latitude: "62.6467",
    longitude: "-160.191",
    altitude: "309",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6712",
    name: "Anaktuvuk Pass Airport",
    city: "Anaktuvuk Pass",
    country: "United States",
    iata: "AKP",
    icao: "PAKP",
    latitude: "68.1336",
    longitude: "-151.743",
    altitude: "2103",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6946",
    name: "Altay Airport",
    city: "Altay",
    country: "China",
    iata: "AAT",
    icao: "ZWAT",
    latitude: "47.866667",
    longitude: "88.116667",
    altitude: "2491",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6947",
    name: "Tuzla",
    city: "Null",
    country: "Bosnia and Herzegovina",
    iata: "",
    icao: "LQTZ",
    latitude: "44.458656",
    longitude: "18.724783",
    altitude: "784",
    timezone: "1",
    dst: "E",
    tz: "Europe/Sarajevo",
  },
  {
    id: "6948",
    name: "Fort Worth NAS",
    city: "Dallas",
    country: "United States",
    iata: "",
    icao: "KNFW",
    latitude: "32.769167",
    longitude: "-97.441528",
    altitude: "650",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6949",
    name: "Naypyidaw",
    city: "Naypyidaw",
    country: "Burma",
    iata: "ELA",
    icao: "VYEL",
    latitude: "19.6235",
    longitude: "96.201028",
    altitude: "302",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6950",
    name: "Kyauktu",
    city: "Kyauktu",
    country: "Burma",
    iata: "",
    icao: "VYXG",
    latitude: "21.406667",
    longitude: "94.130278",
    altitude: "1345",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6951",
    name: "Jan Mayensfield",
    city: "Jan Mayen",
    country: "Norway",
    iata: "ZXB",
    icao: "ENJA",
    latitude: "70.961111",
    longitude: "-8.575833",
    altitude: "33",
    timezone: "1",
    dst: "E",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "6952",
    name: "Bokepyin",
    city: "Bokepyin",
    country: "Burma",
    iata: "",
    icao: "VYBP",
    latitude: "11.267",
    longitude: "98.767",
    altitude: "100",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "6953",
    name: "Huanghua Intl",
    city: "Changsha",
    country: "China",
    iata: "HHA",
    icao: "\\N",
    latitude: "28.189158",
    longitude: "113.219633",
    altitude: "217",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6954",
    name: "Manzhouli",
    city: "Manzhouli",
    country: "China",
    iata: "NZH",
    icao: "\\N",
    latitude: "49.566667",
    longitude: "117.329444",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6955",
    name: "Wuhai",
    city: "Wuhai",
    country: "China",
    iata: "WUA",
    icao: "ZBUH",
    latitude: "39.794444",
    longitude: "106.799444",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6956",
    name: "Gary Chicago International Airport",
    city: "Gary",
    country: "United States",
    iata: "GYY",
    icao: "KGYY",
    latitude: "41.6163",
    longitude: "-87.4128",
    altitude: "591",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6957",
    name: "Brainerd Lakes Rgnl",
    city: "Brainerd",
    country: "United States",
    iata: "BRD",
    icao: "KBRD",
    latitude: "46.398308",
    longitude: "-94.138078",
    altitude: "1226",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "6958",
    name: "Greenbrier Valley Airport",
    city: "Lewisburg",
    country: "United States",
    iata: "LWB",
    icao: "KLWB",
    latitude: "37.858333",
    longitude: "-80.399444",
    altitude: "2302",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "6959",
    name: "Pitt-Greenville Airport",
    city: "Greenville",
    country: "United States",
    iata: "PGV",
    icao: "KPGV",
    latitude: "35.635278",
    longitude: "-77.385278",
    altitude: "27",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6960",
    name: "Chefornak Airport",
    city: "Chefornak",
    country: "United States",
    iata: "CYF",
    icao: "PACK",
    latitude: "60.149167",
    longitude: "-164.285556",
    altitude: "40",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "6961",
    name: "Oxnard - Ventura County",
    city: "Oxnard",
    country: "United States",
    iata: "OXR",
    icao: "KOXR",
    latitude: "34.200833",
    longitude: "-119.207222",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6962",
    name: "Branson LLC",
    city: "Branson",
    country: "United States",
    iata: "BKG",
    icao: "KBBG",
    latitude: "36.531994",
    longitude: "-93.200556",
    altitude: "1302",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "6963",
    name: "Tongren",
    city: "Tongren",
    country: "China",
    iata: "TEN",
    icao: "ZUTR",
    latitude: "27.884",
    longitude: "109.31",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6964",
    name: "Jinggangshan",
    city: "Jian",
    country: "China",
    iata: "KNC",
    icao: "ZSJA",
    latitude: "26.8575",
    longitude: "114.737222",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "6965",
    name: "Penn Station",
    city: "Baltimore",
    country: "United States",
    iata: "ZBP",
    icao: "\\N",
    latitude: "39.307222",
    longitude: "-76.615556",
    altitude: "66",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6966",
    name: "Penn Station",
    city: "New York",
    country: "United States",
    iata: "ZYP",
    icao: "\\N",
    latitude: "40.7505",
    longitude: "-73.9935",
    altitude: "35",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6967",
    name: "Niau",
    city: "Niau",
    country: "French Polynesia",
    iata: "NIU",
    icao: "NTKN",
    latitude: "-16.119037",
    longitude: "-146.368406",
    altitude: "49",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Tahiti",
  },
  {
    id: "6968",
    name: "Stratton ANGB - Schenectady County Airpor",
    city: "Scotia NY",
    country: "United States",
    iata: "SCH",
    icao: "KSCH",
    latitude: "42.85245555",
    longitude: "-73.928866666",
    altitude: "378",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6969",
    name: "Begishevo",
    city: "Nizhnekamsk",
    country: "Russia",
    iata: "NBC",
    icao: "UWKE",
    latitude: "55.34",
    longitude: "52.06",
    altitude: "50",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6970",
    name: "Bogovarovo",
    city: "Bogovarovo",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "58.8535",
    longitude: "47.0114",
    altitude: "100",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "6971",
    name: "Summit Camp",
    city: "Greenland Ice Cap",
    country: "Greenland",
    iata: "",
    icao: "GSUM",
    latitude: "72.5795841916667",
    longitude: "-38.4591850305556",
    altitude: "10552",
    timezone: "0",
    dst: "N",
    tz: "America/Danmarkshavn",
  },
  {
    id: "6972",
    name: "Warri Airport",
    city: "Osubi",
    country: "Nigeria",
    iata: "QRW",
    icao: "DNSU",
    latitude: "5.31",
    longitude: "5.45",
    altitude: "50",
    timezone: "1",
    dst: "U",
    tz: "Africa/Lagos",
  },
  {
    id: "6973",
    name: "Volkel",
    city: "Volkel",
    country: "Netherlands",
    iata: "",
    icao: "EHVK",
    latitude: "51.656389",
    longitude: "5.708611",
    altitude: "72",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "6974",
    name: "Sayak Airport",
    city: "Siargao",
    country: "Philippines",
    iata: "",
    icao: "RPNS",
    latitude: "9.859097",
    longitude: "126.014017",
    altitude: "10",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "6975",
    name: "Langeoog Airport",
    city: "Langeoog",
    country: "Germany",
    iata: "LGO",
    icao: "EDWL",
    latitude: "53.7425",
    longitude: "7.49778",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "6976",
    name: "Fane Airport",
    city: "Fane",
    country: "Papua New Guinea",
    iata: "FNE",
    icao: "\\N",
    latitude: "-8.55",
    longitude: "147.083",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6977",
    name: "Itokama Airport",
    city: "Itokama",
    country: "Papua New Guinea",
    iata: "ITK",
    icao: "\\N",
    latitude: "-9.2",
    longitude: "148.25",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6978",
    name: "Ononge Airport",
    city: "Ononge",
    country: "Papua New Guinea",
    iata: "ONB",
    icao: "\\N",
    latitude: "-8.583",
    longitude: "147.2",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6979",
    name: "Tapini Airport",
    city: "Tapini",
    country: "Papua New Guinea",
    iata: "TPI",
    icao: "\\N",
    latitude: "-8.35",
    longitude: "146.983",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6980",
    name: "Wanigela Airport",
    city: "Wanigela",
    country: "Papua New Guinea",
    iata: "AGL",
    icao: "\\N",
    latitude: "-9.333",
    longitude: "149.15",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6981",
    name: "Woitape Airport",
    city: "Woitape",
    country: "Papua New Guinea",
    iata: "WTP",
    icao: "\\N",
    latitude: "-8.533",
    longitude: "147.25",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6982",
    name: "Awaba Airport",
    city: "Awaba",
    country: "Papua New Guinea",
    iata: "AWB",
    icao: "\\N",
    latitude: "-8.014",
    longitude: "142.75",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6983",
    name: "Telefomin Airport",
    city: "Telefomin",
    country: "Papua New Guinea",
    iata: "TFM",
    icao: "\\N",
    latitude: "-5.117",
    longitude: "141.633",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "6984",
    name: "Kappelen",
    city: "Biel",
    country: "Switzerland",
    iata: "",
    icao: "LSZP",
    latitude: "47.089167",
    longitude: "7.29",
    altitude: "1437",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "6985",
    name: "Nelspruit Airport",
    city: "Nelspruit",
    country: "South Africa",
    iata: "NLP",
    icao: "FANS",
    latitude: "-25.5",
    longitude: "30.9138",
    altitude: "2875",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "6986",
    name: "Cherkassy",
    city: "Cherkassy",
    country: "Ukraine",
    iata: "CKC",
    icao: "UKKE",
    latitude: "49.416666",
    longitude: "32.1333",
    altitude: "114",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6987",
    name: "Gotska Sandon Heliport",
    city: "Gotland",
    country: "Sweden",
    iata: "",
    icao: "\\N",
    latitude: "58.392393",
    longitude: "19.193142",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "6988",
    name: "Lauterhorn",
    city: "Faro",
    country: "Sweden",
    iata: "",
    icao: "\\N",
    latitude: "57.9521",
    longitude: "19.0812",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "6989",
    name: "St. Augustine Airport",
    city: "St. Augustine Airport",
    country: "United States",
    iata: "UST",
    icao: "KSGJ",
    latitude: "29.959167",
    longitude: "-81.339722",
    altitude: "10",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6990",
    name: "Mykolaiv International Airport",
    city: "Nikolayev",
    country: "Ukraine",
    iata: "NLV",
    icao: "UKON",
    latitude: "47.0579",
    longitude: "31.9198",
    altitude: "184",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "6991",
    name: "Ramechhap",
    city: "Ramechhap",
    country: "Nepal",
    iata: "RHP",
    icao: "VNRC",
    latitude: "27.394005",
    longitude: "86.06144",
    altitude: "1555",
    timezone: "5.75",
    dst: "U",
    tz: "Asia/Katmandu",
  },
  {
    id: "6992",
    name: "Charles M Schulz Sonoma Co",
    city: "Santa Rosa",
    country: "United States",
    iata: "STS",
    icao: "KSTS",
    latitude: "38.508978",
    longitude: "-122.81288",
    altitude: "125",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "6993",
    name: "Kissimmee Gateway Airport",
    city: "Kissimmee",
    country: "United States",
    iata: "ISM",
    icao: "KISM",
    latitude: "28.289806",
    longitude: "-81.437083",
    altitude: "82",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6994",
    name: "Lake City Municipal Airport",
    city: "Lake City",
    country: "United States",
    iata: "LCQ",
    icao: "KLCQ",
    latitude: "30.181944",
    longitude: "-82.576944",
    altitude: "201",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6995",
    name: "DeLand Municipal Airport",
    city: "DeLand",
    country: "United States",
    iata: "",
    icao: "KDED",
    latitude: "29.066944",
    longitude: "-81.283889",
    altitude: "79",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6996",
    name: "Haller Airpark Airport",
    city: "Green Cove Springs",
    country: "United States",
    iata: "",
    icao: "7FL4",
    latitude: "29.903021",
    longitude: "-81.685923",
    altitude: "75",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "6997",
    name: "Santa Lucia PNP Airstrip",
    city: "Santa Lucia",
    country: "Peru",
    iata: "",
    icao: "SLPA",
    latitude: "-8.337041",
    longitude: "-76.385733",
    altitude: "50",
    timezone: "-5",
    dst: "U",
    tz: "America/Lima",
  },
  {
    id: "6998",
    name: "Logan-Cache",
    city: "Logan",
    country: "United States",
    iata: "LGU",
    icao: "KLGU",
    latitude: "41.791",
    longitude: "-111.852",
    altitude: "4457",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "6999",
    name: "Brigham City",
    city: "Brigham City",
    country: "United States",
    iata: "BMC",
    icao: "KBMC",
    latitude: "41.552",
    longitude: "-112.062",
    altitude: "4229",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7000",
    name: "Malad City",
    city: "Malad City",
    country: "United States",
    iata: "MLD",
    icao: "KMLD",
    latitude: "42.17",
    longitude: "-112.289",
    altitude: "4503",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7001",
    name: "Aspen Pitkin County Sardy Field",
    city: "Aspen",
    country: "United States",
    iata: "ASE",
    icao: "KASE",
    latitude: "39.2232",
    longitude: "-106.869",
    altitude: "7820",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7002",
    name: "Hilton Head",
    city: "Hilton Head",
    country: "United States",
    iata: "HHH",
    icao: "KHHH",
    latitude: "32.216",
    longitude: "-80.752",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7003",
    name: "Barataevka",
    city: "Ulyanovsk",
    country: "Russia",
    iata: "ULV",
    icao: "UWLL",
    latitude: "54.268299",
    longitude: "48.2267",
    altitude: "463",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7004",
    name: "Horog",
    city: "Horog",
    country: "Tajikistan",
    iata: "",
    icao: "UTOD",
    latitude: "37.5",
    longitude: "71.5",
    altitude: "2000",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "7005",
    name: "Sabi Sabi Airport",
    city: "Sabi Sabi",
    country: "South Africa",
    iata: "GSS",
    icao: "\\N",
    latitude: "-24.9415",
    longitude: "31.4446",
    altitude: "1276",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "7006",
    name: "Philadelphia 30th St Station",
    city: "Philadelphia",
    country: "United States",
    iata: "ZFV",
    icao: "\\N",
    latitude: "39.9557",
    longitude: "-75.182",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7007",
    name: "KBWD",
    city: "Brownwood",
    country: "United States",
    iata: "BWD",
    icao: "\\N",
    latitude: "31.7936111",
    longitude: "-98.9565",
    altitude: "1387",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7008",
    name: "Mexia - Limestone County Airport",
    city: "Mexia",
    country: "United States",
    iata: "LXY",
    icao: "\\N",
    latitude: "31.6411783",
    longitude: "-96.5144594",
    altitude: "544",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7009",
    name: "Kerrville Municipal Airport",
    city: "Kerrville",
    country: "United States",
    iata: "ERV",
    icao: "KERV",
    latitude: "29.9766667",
    longitude: "-99.0854722",
    altitude: "1617",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7010",
    name: "Birrfeld",
    city: "Birrfeld",
    country: "Switzerland",
    iata: "",
    icao: "LSZF",
    latitude: "47.4436",
    longitude: "8.23361",
    altitude: "1300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7011",
    name: "Sussex Co",
    city: "Georgetown",
    country: "United States",
    iata: "GED",
    icao: "KGED",
    latitude: "38.689194",
    longitude: "-75.358889",
    altitude: "50",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7012",
    name: "Seal Cove Seaplane Base",
    city: "Prince Rupert",
    country: "Canada",
    iata: "ZSW",
    icao: "CZSW",
    latitude: "54.3333",
    longitude: "-130.283",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7013",
    name: "Great Bend Municipal",
    city: "Great Bend",
    country: "United States",
    iata: "GBN",
    icao: "KGBD",
    latitude: "38.344167",
    longitude: "-98.859167",
    altitude: "1887",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7014",
    name: "Hays Regional Airport",
    city: "Hays",
    country: "United States",
    iata: "HYS",
    icao: "KHYS",
    latitude: "38.8422",
    longitude: "-99.2732",
    altitude: "1998",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7015",
    name: "Spirit Of St Louis",
    city: "Null",
    country: "United States",
    iata: "SUS",
    icao: "KSUS",
    latitude: "38.662119",
    longitude: "-90.652044",
    altitude: "463",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7016",
    name: "Ely Municipal",
    city: "Ely",
    country: "United States",
    iata: "LYU",
    icao: "KELO",
    latitude: "47.824444",
    longitude: "-91.830833",
    altitude: "1456",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7017",
    name: "Grand Rapids Itasca County",
    city: "Grand Rapids MN",
    country: "United States",
    iata: "GPZ",
    icao: "KGPZ",
    latitude: "47.211111",
    longitude: "-93.509722",
    altitude: "413",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7018",
    name: "Thief River Falls",
    city: "Thief River Falls",
    country: "United States",
    iata: "TVF",
    icao: "KTVF",
    latitude: "48.065556",
    longitude: "-96.185",
    altitude: "1116",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7019",
    name: "Eagle River",
    city: "Eagle River",
    country: "United States",
    iata: "EGV",
    icao: "KEGV",
    latitude: "45.932333",
    longitude: "-89.268283",
    altitude: "1642",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7020",
    name: "Lakeland",
    city: "Minocqua - Woodruff",
    country: "United States",
    iata: "ARV",
    icao: "KARV",
    latitude: "45.927778",
    longitude: "-89.730833",
    altitude: "1629",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7021",
    name: "Ankeny Regl Airport",
    city: "Ankeny",
    country: "United States",
    iata: "IKV",
    icao: "KIKV",
    latitude: "41.691389",
    longitude: "-93.566389",
    altitude: "910",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7022",
    name: "Berens River",
    city: "Berens River",
    country: "Canada",
    iata: "YBV",
    icao: "CYBV",
    latitude: "52.358889",
    longitude: "-97.018333",
    altitude: "728",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7023",
    name: "Corpus Christi NAS",
    city: "Corpus Christi",
    country: "United States",
    iata: "NGP",
    icao: "KNGP",
    latitude: "27.692701",
    longitude: "-97.290376",
    altitude: "18",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7024",
    name: "Seaplane Base",
    city: "Port Simpson",
    country: "Canada",
    iata: "YPI",
    icao: "CYPI",
    latitude: "54.566667",
    longitude: "-130.433333",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7025",
    name: "Avalon",
    city: "Catalina Island",
    country: "United States",
    iata: "AVX",
    icao: "KAVX",
    latitude: "33.405",
    longitude: "-118.415833",
    altitude: "1602",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7026",
    name: "Mojave",
    city: "Mojave",
    country: "United States",
    iata: "MHV",
    icao: "KMHV",
    latitude: "35.059364",
    longitude: "-118.151856",
    altitude: "2791",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7027",
    name: "Air Base",
    city: "Interlaken",
    country: "Switzerland",
    iata: "ZIN",
    icao: "LSMI",
    latitude: "46.6766",
    longitude: "7.87908",
    altitude: "1893",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7028",
    name: "Kenmore Air Harbor Inc Seaplane Base",
    city: "Kenmore",
    country: "United States",
    iata: "KEH",
    icao: "\\N",
    latitude: "47.7548",
    longitude: "-122.259",
    altitude: "14",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7029",
    name: "Municipal",
    city: "Corozal",
    country: "Belize",
    iata: "CZH",
    icao: "\\N",
    latitude: "18.3822",
    longitude: "-88.4119",
    altitude: "40",
    timezone: "-6",
    dst: "N",
    tz: "America/Belize",
  },
  {
    id: "7030",
    name: "Inisheer",
    city: "Inisheer",
    country: "Ireland",
    iata: "INQ",
    icao: "EIIR",
    latitude: "53.0647",
    longitude: "-9.5109",
    altitude: "40",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "7031",
    name: "Winterlandeplatz",
    city: "Maennlichen",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.610833",
    longitude: "7.9425",
    altitude: "7297",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7032",
    name: "Paketzentrum",
    city: "Ostermundigen",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.963",
    longitude: "7.482",
    altitude: "1854",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7033",
    name: "Strezhevoy",
    city: "Strezhevoy",
    country: "Russia",
    iata: "SWT",
    icao: "UNSS",
    latitude: "60.716667",
    longitude: "77.65",
    altitude: "164",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "7034",
    name: "Cashel",
    city: "Cashel",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "52.5158333",
    longitude: "-7.8855556",
    altitude: "440",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "7035",
    name: "Hutchinson Municipal Airport",
    city: "Hutchinson",
    country: "United States",
    iata: "HUT",
    icao: "KHUT",
    latitude: "38.0655",
    longitude: "-97.8606",
    altitude: "1543",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7036",
    name: "Bagram AFB",
    city: "Kabul",
    country: "Afghanistan",
    iata: "BPM",
    icao: "OAIX",
    latitude: "34.5646",
    longitude: "69.1554",
    altitude: "4895",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "7037",
    name: "Al Kharj AFB",
    city: "Al Kharj",
    country: "Saudi Arabia",
    iata: "",
    icao: "OEPS",
    latitude: "24.0346",
    longitude: "47.345",
    altitude: "1651",
    timezone: "3",
    dst: "N",
    tz: "Asia/Riyadh",
  },
  {
    id: "7038",
    name: "Eagle County Airport",
    city: "Eagle",
    country: "United States",
    iata: "EGA",
    icao: "\\N",
    latitude: "39.6427611",
    longitude: "-106.9159347",
    altitude: "6548",
    timezone: "-7",
    dst: "U",
    tz: "America/Denver",
  },
  {
    id: "7039",
    name: "Oak Lawn Train Station",
    city: "Oak Lawn",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.7198242969588",
    longitude: "-87.7488327026367",
    altitude: "500",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "7040",
    name: "Wrigleyville",
    city: "Chicago",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.948958067066",
    longitude: "-87.6587533950806",
    altitude: "500",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "7041",
    name: "Gelendzik",
    city: "Gelendzik",
    country: "Russia",
    iata: "GDZ",
    icao: "\\N",
    latitude: "44.566666666667",
    longitude: "38.016666666667",
    altitude: "50",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7042",
    name: "Rosecrans Mem",
    city: "Rosecrans",
    country: "United States",
    iata: "STJ",
    icao: "KSTJ",
    latitude: "39.771944",
    longitude: "-94.909706",
    altitude: "826",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7043",
    name: "Hartford Union Station",
    city: "Hartford",
    country: "United States",
    iata: "ZRT",
    icao: "\\N",
    latitude: "41.76888",
    longitude: "-72.6815",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7044",
    name: "Stamford Amtrak Station",
    city: "Stamford",
    country: "United States",
    iata: "ZTF",
    icao: "\\N",
    latitude: "41.046937",
    longitude: "-73.541493",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7045",
    name: "Newark Penn Station",
    city: "Newark",
    country: "United States",
    iata: "ZRP",
    icao: "\\N",
    latitude: "40.734722",
    longitude: "-74.164167",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7046",
    name: "Papa Airport",
    city: "Papa",
    country: "Hungary",
    iata: "",
    icao: "LHPA",
    latitude: "47.3636",
    longitude: "17.5008",
    altitude: "466",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "7047",
    name: "Cuxhaven Airport",
    city: "Cuxhaven",
    country: "Germany",
    iata: "NDZ",
    icao: "KNDZ",
    latitude: "53.768612",
    longitude: "8.644722",
    altitude: "75",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7048",
    name: "Volk Fld",
    city: "Camp Douglas",
    country: "United States",
    iata: "VOK",
    icao: "KVOK",
    latitude: "43.938956",
    longitude: "-90.253433",
    altitude: "912",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7049",
    name: "BFT County Airport",
    city: "Beauford",
    country: "United States",
    iata: "BFT",
    icao: "KBFT",
    latitude: "32.41083",
    longitude: "-80.635",
    altitude: "500",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7050",
    name: "Adana-Incirlik Airbase",
    city: "Adana",
    country: "Turkey",
    iata: "UAB",
    icao: "KUAB",
    latitude: "37.00028",
    longitude: "35.41833",
    altitude: "500",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "7051",
    name: "Gunnison - Crested Butte",
    city: "Gunnison",
    country: "United States",
    iata: "GUC",
    icao: "KGUC",
    latitude: "38.533889",
    longitude: "-106.933056",
    altitude: "7678",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7052",
    name: "Xi\\\\'An Xiguan",
    city: "Xi\\\\'AN",
    country: "China",
    iata: "SIA",
    icao: "ZLSN",
    latitude: "34.3767",
    longitude: "109.12",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7053",
    name: "Zamperini Field Airport",
    city: "Torrance",
    country: "United States",
    iata: "TOA",
    icao: "KTOA",
    latitude: "33.803392",
    longitude: "-118.339611",
    altitude: "101",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7054",
    name: "Manistee County-Blacker Airport",
    city: "Manistee",
    country: "United States",
    iata: "MBL",
    icao: "KMBL",
    latitude: "44.2725",
    longitude: "-86.246944",
    altitude: "621",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7055",
    name: "Hickam Air Force Base",
    city: "Honolulu",
    country: "United States",
    iata: "",
    icao: "PHIK",
    latitude: "21.318681",
    longitude: "-157.922427",
    altitude: "13",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Honolulu",
  },
  {
    id: "7056",
    name: "Charlotte County-Punta Gorda Airport",
    city: "Punta Gorda",
    country: "United States",
    iata: "PGD",
    icao: "KPGD",
    latitude: "26.919722",
    longitude: "-81.990556",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7057",
    name: "Grand Canyon Heliport",
    city: "Grand Canyon",
    country: "United States",
    iata: "JGC",
    icao: "\\N",
    latitude: "35.96666666",
    longitude: "-112.13333333",
    altitude: "2500",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "7058",
    name: "Northern Aroostook Regional Airport",
    city: "Frenchville",
    country: "United States",
    iata: "WFK",
    icao: "KFVE",
    latitude: "47.285556",
    longitude: "-68.312778",
    altitude: "988",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7059",
    name: "Chautauqua County-Jamestown",
    city: "Jamestown",
    country: "United States",
    iata: "JHW",
    icao: "KJHW",
    latitude: "42.153333",
    longitude: "-79.258056",
    altitude: "525",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7060",
    name: "Riviere Rouge - Mont-Tremblant International Inc. Airport",
    city: "Mont-Tremblant",
    country: "Canada",
    iata: "YTM",
    icao: "CYFJ",
    latitude: "46.409444",
    longitude: "-74.78",
    altitude: "827",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7061",
    name: "Lake Cumberland Regional Airport",
    city: "Somerset",
    country: "United States",
    iata: "SME",
    icao: "KSME",
    latitude: "37.053611",
    longitude: "-84.615556",
    altitude: "927",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7062",
    name: "Shenandoah Valley Regional Airport",
    city: "Weyers Cave",
    country: "United States",
    iata: "SHD",
    icao: "KSHD",
    latitude: "38.263889",
    longitude: "-78.896389",
    altitude: "1201",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7063",
    name: "Devils Lake Regional Airport",
    city: "Devils Lake",
    country: "United States",
    iata: "DVL",
    icao: "KDVL",
    latitude: "48.114444",
    longitude: "-98.908611",
    altitude: "1445",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7064",
    name: "Dickinson Theodore Roosevelt Regional Airport",
    city: "Dickinson",
    country: "United States",
    iata: "DIK",
    icao: "KDIK",
    latitude: "46.7975",
    longitude: "-102.801944",
    altitude: "2592",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7065",
    name: "Sidney-Richland Municipal Airport",
    city: "Sidney",
    country: "United States",
    iata: "SDY",
    icao: "KSDY",
    latitude: "47.706944",
    longitude: "-104.1925",
    altitude: "1984",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7066",
    name: "Chadron Municipal Airport",
    city: "Chadron",
    country: "United States",
    iata: "CDR",
    icao: "KCDR",
    latitude: "42.8375",
    longitude: "-103.095556",
    altitude: "3297",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7067",
    name: "Alliance Municipal Airport",
    city: "Alliance",
    country: "United States",
    iata: "AIA",
    icao: "KAIA",
    latitude: "42.053333",
    longitude: "-102.803889",
    altitude: "3931",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7068",
    name: "McCook Regional Airport",
    city: "McCook",
    country: "United States",
    iata: "MCK",
    icao: "KMCK",
    latitude: "40.206389",
    longitude: "-100.592222",
    altitude: "2583",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7069",
    name: "Florida Keys Marathon Airport",
    city: "Marathon",
    country: "United States",
    iata: "MTH",
    icao: "KMTH",
    latitude: "24.726111",
    longitude: "-81.051389",
    altitude: "7",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7070",
    name: "Dawson Community Airport",
    city: "Glendive",
    country: "United States",
    iata: "GDV",
    icao: "KGDV",
    latitude: "47.138611",
    longitude: "-104.807222",
    altitude: "749",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7071",
    name: "LM Clayton Airport",
    city: "Wolf Point",
    country: "United States",
    iata: "OLF",
    icao: "KOLF",
    latitude: "48.094444",
    longitude: "-105.575",
    altitude: "1986",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7072",
    name: "Yellowstone Airport",
    city: "West Yellowstone",
    country: "United States",
    iata: "WYS",
    icao: "KWYS",
    latitude: "44.688333",
    longitude: "-111.1175",
    altitude: "6644",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7073",
    name: "San Luis Valley Regional Airport",
    city: "Alamosa",
    country: "United States",
    iata: "ALS",
    icao: "KALS",
    latitude: "37.435",
    longitude: "-105.866667",
    altitude: "7539",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7074",
    name: "Canyonlands Field",
    city: "Moab",
    country: "United States",
    iata: "CNY",
    icao: "KCNY",
    latitude: "38.755",
    longitude: "-109.754722",
    altitude: "4555",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7075",
    name: "Ely Airport",
    city: "Ely",
    country: "United States",
    iata: "ELY",
    icao: "KELY",
    latitude: "39.299722",
    longitude: "-114.841944",
    altitude: "6259",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7076",
    name: "Vernal Regional Airport",
    city: "Vernal",
    country: "United States",
    iata: "VEL",
    icao: "KVEL",
    latitude: "40.440833",
    longitude: "-109.51",
    altitude: "5278",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7077",
    name: "Sierra Blanca Regional Airport",
    city: "Ruidoso",
    country: "United States",
    iata: "SRR",
    icao: "KSRR",
    latitude: "33.46285",
    longitude: "-105.534751",
    altitude: "6814",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7078",
    name: "Show Low Regional Airport",
    city: "Show Low",
    country: "United States",
    iata: "SOW",
    icao: "KSOW",
    latitude: "34.265556",
    longitude: "-110.005556",
    altitude: "6415",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "7079",
    name: "McCall Municipal Airport",
    city: "McCall",
    country: "United States",
    iata: "MYL",
    icao: "KMYL",
    latitude: "44.889722",
    longitude: "-116.101389",
    altitude: "5021",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7080",
    name: "Lemhi County Airport",
    city: "Salmon",
    country: "United States",
    iata: "SMN",
    icao: "KSMN",
    latitude: "45.123889",
    longitude: "-113.881389",
    altitude: "4043",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7081",
    name: "Mammoth Yosemite Airport",
    city: "Mammoth Lakes",
    country: "United States",
    iata: "MMH",
    icao: "KMMH",
    latitude: "37.624049",
    longitude: "-118.837772",
    altitude: "7128",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7082",
    name: "Friday Harbor Airport",
    city: "Friday Harbor",
    country: "United States",
    iata: "FRD",
    icao: "KFHR",
    latitude: "48.521944",
    longitude: "-123.024444",
    altitude: "113",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7083",
    name: "Orcas Island Airport",
    city: "Eastsound",
    country: "United States",
    iata: "ESD",
    icao: "KORS",
    latitude: "48.708056",
    longitude: "-122.910556",
    altitude: "31",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7084",
    name: "Anacortes Airport",
    city: "Anacortes",
    country: "United States",
    iata: "OTS",
    icao: "\\N",
    latitude: "48.498889",
    longitude: "-122.6625",
    altitude: "241",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7085",
    name: "Astoria Regional Airport",
    city: "Astoria",
    country: "United States",
    iata: "AST",
    icao: "KAST",
    latitude: "46.157972",
    longitude: "-123.878694",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7086",
    name: "Newport Municipal Airport",
    city: "Newport",
    country: "United States",
    iata: "ONP",
    icao: "KNOP",
    latitude: "44.580361",
    longitude: "-124.057917",
    altitude: "160",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7087",
    name: "Emmonak Airport",
    city: "Emmonak",
    country: "United States",
    iata: "EMK",
    icao: "PAEM",
    latitude: "62.786111",
    longitude: "-164.490833",
    altitude: "13",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7088",
    name: "Unalakleet Airport",
    city: "Unalakleet",
    country: "United States",
    iata: "UNK",
    icao: "PAUN",
    latitude: "63.888333",
    longitude: "-160.798889",
    altitude: "21",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7089",
    name: "Ugnu-Kuparuk Airport",
    city: "Kuparuk",
    country: "United States",
    iata: "UUK",
    icao: "PAKU",
    latitude: "70.330833",
    longitude: "-149.5975",
    altitude: "67",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7090",
    name: "Shageluk Airport",
    city: "Shageluk",
    country: "United States",
    iata: "SHX",
    icao: "PAHX",
    latitude: "62.692222",
    longitude: "-159.569167",
    altitude: "79",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7091",
    name: "Chuathbaluk Airport",
    city: "Chuathbaluk",
    country: "United States",
    iata: "CHU",
    icao: "PACH",
    latitude: "61.579167",
    longitude: "-159.215556",
    altitude: "243",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7092",
    name: "Nuiqsut Airport",
    city: "Nuiqsut",
    country: "United States",
    iata: "NUI",
    icao: "PAQT",
    latitude: "70.21",
    longitude: "-151.005556",
    altitude: "38",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7093",
    name: "Eek Airport",
    city: "Eek",
    country: "United States",
    iata: "EEK",
    icao: "PAEE",
    latitude: "60.213611",
    longitude: "-162.043889",
    altitude: "15",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7094",
    name: "Kasigluk Airport",
    city: "Kasigluk",
    country: "United States",
    iata: "KUK",
    icao: "PFKA",
    latitude: "60.873333",
    longitude: "-162.524444",
    altitude: "40",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7095",
    name: "Kwethluk Airport",
    city: "Kwethluk",
    country: "United States",
    iata: "KWT",
    icao: "PFKW",
    latitude: "60.790278",
    longitude: "-161.443611",
    altitude: "30",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7096",
    name: "Kwigillingok Airport",
    city: "Kwigillingok",
    country: "United States",
    iata: "KWK",
    icao: "PAGG",
    latitude: "59.876389",
    longitude: "-163.168611",
    altitude: "18",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7097",
    name: "Marshall Don Hunter Sr. Airport",
    city: "Marshall",
    country: "United States",
    iata: "MLL",
    icao: "PADM",
    latitude: "61.8646418",
    longitude: "-162.026111",
    altitude: "103",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7098",
    name: "Russian Mission Airport",
    city: "Russian Mission",
    country: "United States",
    iata: "RSH",
    icao: "PARS",
    latitude: "61.775",
    longitude: "-161.319444",
    altitude: "51",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7099",
    name: "Tuntutuliak Airport",
    city: "Tuntutuliak",
    country: "United States",
    iata: "WTL",
    icao: "\\N",
    latitude: "60.335278",
    longitude: "-162.666944",
    altitude: "16",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7100",
    name: "Ekwok Airport",
    city: "Ekwok",
    country: "United States",
    iata: "KEK",
    icao: "\\N",
    latitude: "59.356944",
    longitude: "-157.471111",
    altitude: "135",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7101",
    name: "Koliganek Airport",
    city: "Koliganek",
    country: "United States",
    iata: "KGK",
    icao: "PAJZ",
    latitude: "59.726667",
    longitude: "-157.259444",
    altitude: "269",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7102",
    name: "Levelock Airport",
    city: "Levelock",
    country: "United States",
    iata: "KLL",
    icao: "\\N",
    latitude: "59.128056",
    longitude: "-156.858611",
    altitude: "39",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7103",
    name: "Manokotak Airport",
    city: "Manokotak",
    country: "United States",
    iata: "KMO",
    icao: "PAMB",
    latitude: "58.990278",
    longitude: "-159.05",
    altitude: "51",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7104",
    name: "Twin Hills Airport",
    city: "Twin Hills",
    country: "United States",
    iata: "TWA",
    icao: "\\N",
    latitude: "59.074444",
    longitude: "-160.275",
    altitude: "82",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7105",
    name: "Chalkyitsik Airport",
    city: "Chalkyitsik",
    country: "United States",
    iata: "CIK",
    icao: "PACI",
    latitude: "66.645",
    longitude: "-143.74",
    altitude: "544",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7106",
    name: "Eagle Airport",
    city: "Eagle",
    country: "United States",
    iata: "EAA",
    icao: "PAEG",
    latitude: "64.778056",
    longitude: "-141.149722",
    altitude: "908",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7107",
    name: "Hughes Airport",
    city: "Hughes",
    country: "United States",
    iata: "HUS",
    icao: "PAHU",
    latitude: "66.039167",
    longitude: "-154.264722",
    altitude: "299",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7108",
    name: "Huslia Airport",
    city: "Huslia",
    country: "United States",
    iata: "HSL",
    icao: "PAHL",
    latitude: "65.697778",
    longitude: "-156.351389",
    altitude: "213",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7109",
    name: "Livingood Airport",
    city: "Livingood",
    country: "United States",
    iata: "LIV",
    icao: "\\N",
    latitude: "65.531111",
    longitude: "-148.541111",
    altitude: "696",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7110",
    name: "Minto Airport",
    city: "Minto",
    country: "United States",
    iata: "MNT",
    icao: "\\N",
    latitude: "65.143611",
    longitude: "-149.37",
    altitude: "460",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7111",
    name: "Nulato Airport",
    city: "Nulato",
    country: "United States",
    iata: "NUL",
    icao: "PANU",
    latitude: "64.729444",
    longitude: "-158.074167",
    altitude: "399",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7112",
    name: "Rampart Airport",
    city: "Rampart",
    country: "United States",
    iata: "RMP",
    icao: "\\N",
    latitude: "65.507778",
    longitude: "-150.140833",
    altitude: "302",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7113",
    name: "Tanana Airport",
    city: "Tanana",
    country: "United States",
    iata: "TAL",
    icao: "\\N",
    latitude: "65.179556",
    longitude: "-152.075833",
    altitude: "207",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7114",
    name: "Venetie Airport",
    city: "Venetie",
    country: "United States",
    iata: "VEE",
    icao: "PAVE",
    latitude: "67.008611",
    longitude: "-146.366389",
    altitude: "574",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7115",
    name: "Beaver Airport",
    city: "Beaver",
    country: "United States",
    iata: "WBQ",
    icao: "PAWB",
    latitude: "66.362222",
    longitude: "-147.406667",
    altitude: "359",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7116",
    name: "Central Airport",
    city: "Central",
    country: "United States",
    iata: "CEM",
    icao: "PACE",
    latitude: "65.573889",
    longitude: "-144.780833",
    altitude: "937",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7117",
    name: "Shungnak Airport",
    city: "Shungnak",
    country: "United States",
    iata: "SHG",
    icao: "PAGH",
    latitude: "66.888056",
    longitude: "-157.1625",
    altitude: "197",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7118",
    name: "Birch Creek Airport",
    city: "Brich Creek",
    country: "United States",
    iata: "KBC",
    icao: "\\N",
    latitude: "66.256708",
    longitude: "-145.815319",
    altitude: "450",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7119",
    name: "Coldfoot Airport",
    city: "Coldfoot",
    country: "United States",
    iata: "CXF",
    icao: "\\N",
    latitude: "67.251389",
    longitude: "-150.176111",
    altitude: "1014",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7120",
    name: "Inyokern Airport",
    city: "Inyokern",
    country: "United States",
    iata: "IYK",
    icao: "KIYK",
    latitude: "35.658889",
    longitude: "-117.829444",
    altitude: "2455",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7121",
    name: "Visalia Municipal Airport",
    city: "Visalia",
    country: "United States",
    iata: "VIS",
    icao: "KVIS",
    latitude: "36.318611",
    longitude: "-119.392778",
    altitude: "295",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7122",
    name: "Merced Municipal Airport",
    city: "Merced",
    country: "United States",
    iata: "MCE",
    icao: "KMCE",
    latitude: "37.284722",
    longitude: "-120.513889",
    altitude: "156",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7123",
    name: "Laguna de Los Patos International Airport",
    city: "Colonia",
    country: "Uruguay",
    iata: "CYR",
    icao: "SUCA",
    latitude: "-34.4564",
    longitude: "-57.7706",
    altitude: "66",
    timezone: "-3",
    dst: "U",
    tz: "America/Montevideo",
  },
  {
    id: "7124",
    name: "Camelo",
    city: "Camelo",
    country: "Uruguay",
    iata: "",
    icao: "SULO",
    latitude: "-33.963882",
    longitude: "-58.288612",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Montevideo",
  },
  {
    id: "7125",
    name: "Amarais Airport",
    city: "Campinas",
    country: "Brazil",
    iata: "CPQ",
    icao: "SDAM",
    latitude: "-22.8592",
    longitude: "-47.1082",
    altitude: "2008",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7126",
    name: "Phoenix Goodyear",
    city: "Goodyear",
    country: "United States",
    iata: "",
    icao: "KGYR",
    latitude: "33.423725",
    longitude: "-112.374456",
    altitude: "968",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "7127",
    name: "Park City",
    city: "Park City",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.659444",
    longitude: "-111.4997222",
    altitude: "7000",
    timezone: "-7",
    dst: "U",
    tz: "America/Denver",
  },
  {
    id: "7128",
    name: "Toowoomba",
    city: "Toowoomba",
    country: "Australia",
    iata: "TWB",
    icao: "YTWB",
    latitude: "-27.542778",
    longitude: "151.916389",
    altitude: "2086",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "7129",
    name: "Ballera",
    city: "Ballera",
    country: "Australia",
    iata: "",
    icao: "YLLE",
    latitude: "-27.408333",
    longitude: "141.808333",
    altitude: "385",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "7130",
    name: "Gatton",
    city: "Gatton",
    country: "Australia",
    iata: "",
    icao: "YGAT",
    latitude: "-27.5583000183105",
    longitude: "152.341995239258",
    altitude: "400",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "7131",
    name: "Arkalyk Airport",
    city: "Arkalyk",
    country: "Kazakhstan",
    iata: "AYK",
    icao: "UAUR",
    latitude: "50.2395",
    longitude: "66.941",
    altitude: "1152",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "7132",
    name: "Hamburger Hafen",
    city: "Hamburg",
    country: "Germany",
    iata: "",
    icao: "ZZ06",
    latitude: "53.542369",
    longitude: "9.981592",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7133",
    name: "Flugplatz Fehmarn-Neujellingsdorf",
    city: "Neujellingsdorf",
    country: "Germany",
    iata: "",
    icao: "ZZ05",
    latitude: "54.455802",
    longitude: "11.109273",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7134",
    name: "Nabern Teck",
    city: "Kirchheim-Teck",
    country: "Germany",
    iata: "",
    icao: "EDTN",
    latitude: "48.3676",
    longitude: "9.2863",
    altitude: "1215",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7135",
    name: "Angoon Seaplane Base",
    city: "Angoon",
    country: "United States",
    iata: "AGN",
    icao: "PAGN",
    latitude: "57.503611",
    longitude: "-134.585",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7136",
    name: "Elfin Cove Seaplane Base",
    city: "Elfin Cove",
    country: "United States",
    iata: "ELV",
    icao: "PAEL",
    latitude: "58.195278",
    longitude: "-136.3475",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7137",
    name: "Tenakee Seaplane Base",
    city: "Tenakee Springs",
    country: "United States",
    iata: "TKE",
    icao: "\\N",
    latitude: "57.779722",
    longitude: "-135.218333",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7138",
    name: "Pelican Seaplane Base",
    city: "Pelican",
    country: "United States",
    iata: "PEC",
    icao: "\\N",
    latitude: "57.955278",
    longitude: "-136.236389",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7139",
    name: "Chatham Seaplane Base",
    city: "Sitka",
    country: "United States",
    iata: "CYM",
    icao: "\\N",
    latitude: "57.515",
    longitude: "-134.946111",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7140",
    name: "Funter Bay Seaplane Base",
    city: "Funter Bay",
    country: "United States",
    iata: "FNR",
    icao: "PANR",
    latitude: "58.254444",
    longitude: "-134.897778",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7141",
    name: "Excursion Inlet Seaplane Base",
    city: "Excursion Inlet",
    country: "United States",
    iata: "EXI",
    icao: "\\N",
    latitude: "58.420556",
    longitude: "-135.449167",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7142",
    name: "Hoonah Airport",
    city: "Hoonah",
    country: "United States",
    iata: "HNH",
    icao: "PAOH",
    latitude: "58.096111",
    longitude: "-135.409722",
    altitude: "19",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7143",
    name: "Kake Airport",
    city: "Kake",
    country: "United States",
    iata: "AFE",
    icao: "PAFE",
    latitude: "56.961389",
    longitude: "-133.910278",
    altitude: "172",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7144",
    name: "Craig Seaplane Base",
    city: "Craig",
    country: "United States",
    iata: "CGA",
    icao: "\\N",
    latitude: "55.478889",
    longitude: "-133.147778",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7145",
    name: "Hollis Seaplane Base",
    city: "Hollis",
    country: "United States",
    iata: "HYL",
    icao: "\\N",
    latitude: "55.481667",
    longitude: "-132.646111",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7146",
    name: "Metlakatla Seaplane Base",
    city: "Metakatla",
    country: "United States",
    iata: "MTM",
    icao: "PAMM",
    latitude: "55.131111",
    longitude: "-131.578056",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7147",
    name: "Thorne Bay Seaplane Base",
    city: "Thorne Bay",
    country: "United States",
    iata: "KTB",
    icao: "\\N",
    latitude: "55.688056",
    longitude: "-132.536667",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7148",
    name: "Hydaburg Seaplane Base",
    city: "Hydaburg",
    country: "United States",
    iata: "HYG",
    icao: "PAHY",
    latitude: "55.206389",
    longitude: "-132.828333",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7149",
    name: "Hyder Seaplane Base",
    city: "Hyder",
    country: "United States",
    iata: "WHD",
    icao: "\\N",
    latitude: "55.903333",
    longitude: "-130.006667",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7150",
    name: "Point Baker Seaplane Base",
    city: "Point Baker",
    country: "United States",
    iata: "KPB",
    icao: "\\N",
    latitude: "56.351944",
    longitude: "-133.6225",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7151",
    name: "Port Protection Seaplane Base",
    city: "Port Protection",
    country: "United States",
    iata: "PPV",
    icao: "\\N",
    latitude: "56.328889",
    longitude: "-133.61",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7152",
    name: "North Whale Seaplane Base",
    city: "North Whale Pass",
    country: "United States",
    iata: "WWP",
    icao: "\\N",
    latitude: "56.116389",
    longitude: "-133.121667",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7153",
    name: "Chignik Lake Airport",
    city: "Chignik Lake",
    country: "United States",
    iata: "KCQ",
    icao: "\\N",
    latitude: "56.255",
    longitude: "-158.775278",
    altitude: "50",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7154",
    name: "Egegik Airport",
    city: "Egegik",
    country: "United States",
    iata: "EGX",
    icao: "PAII",
    latitude: "58.185556",
    longitude: "-157.375556",
    altitude: "92",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7155",
    name: "Chignik Lagoon Airport",
    city: "Chignik Lagoon",
    country: "United States",
    iata: "KCL",
    icao: "\\N",
    latitude: "56.311111",
    longitude: "-158.534167",
    altitude: "25",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7156",
    name: "Chignik Bay Seaplane Base",
    city: "Chignik",
    country: "United States",
    iata: "KBW",
    icao: "\\N",
    latitude: "56.295556",
    longitude: "-158.401398",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7157",
    name: "Perryville Airport",
    city: "Perryville",
    country: "United States",
    iata: "KPV",
    icao: "PAPE",
    latitude: "55.906667",
    longitude: "-159.160833",
    altitude: "29",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7158",
    name: "Pilot Point Airport",
    city: "Pilot Point",
    country: "United States",
    iata: "PIP",
    icao: "PAPN",
    latitude: "57.585393",
    longitude: "-157.571944",
    altitude: "57",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7159",
    name: "South Naknek Airport",
    city: "South Naknek",
    country: "United States",
    iata: "WSN",
    icao: "PFWS",
    latitude: "58.702222",
    longitude: "-157.0025",
    altitude: "162",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7160",
    name: "Akhiok Airport",
    city: "Akhiok",
    country: "United States",
    iata: "AKK",
    icao: "PAKH",
    latitude: "56.938611",
    longitude: "-154.1825",
    altitude: "44",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7161",
    name: "Karuluk Airport",
    city: "Karluk",
    country: "United States",
    iata: "KYK",
    icao: "PAKY",
    latitude: "57.566944",
    longitude: "-154.450278",
    altitude: "137",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7162",
    name: "Larsen Bay Airport",
    city: "Larsen Bay",
    country: "United States",
    iata: "KLN",
    icao: "PALB",
    latitude: "57.535",
    longitude: "-153.976667",
    altitude: "87",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7163",
    name: "Old Harbor Airport",
    city: "Old Harbor",
    country: "United States",
    iata: "OLH",
    icao: "\\N",
    latitude: "57.218056",
    longitude: "-153.269722",
    altitude: "55",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7164",
    name: "Ouzinkie Airport",
    city: "Ouzinkie",
    country: "United States",
    iata: "KOZ",
    icao: "\\N",
    latitude: "57.922876",
    longitude: "-152.500511",
    altitude: "55",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7165",
    name: "Port Lions Airport",
    city: "Port Lions",
    country: "United States",
    iata: "ORI",
    icao: "\\N",
    latitude: "57.885278",
    longitude: "-152.846111",
    altitude: "52",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7166",
    name: "Alitak Seaplane Base",
    city: "Lazy Bay",
    country: "United States",
    iata: "ALZ",
    icao: "\\N",
    latitude: "56.899444",
    longitude: "-154.247778",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7167",
    name: "Amook Bay Seaplane Base",
    city: "Amook Bay",
    country: "United States",
    iata: "AOS",
    icao: "\\N",
    latitude: "57.471389",
    longitude: "-153.815278",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7168",
    name: "Kitoi Bay Seaplane Base",
    city: "Kitoi Bay",
    country: "United States",
    iata: "KKB",
    icao: "\\N",
    latitude: "58.190833",
    longitude: "-152.370556",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7169",
    name: "Moser Bay Seaplane Base",
    city: "Moser Bay",
    country: "United States",
    iata: "KMY",
    icao: "\\N",
    latitude: "57.025556",
    longitude: "-154.145833",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7170",
    name: "Olga Bay Seaplane Base",
    city: "Olga Bay",
    country: "United States",
    iata: "KOY",
    icao: "\\N",
    latitude: "57.161389",
    longitude: "-154.229722",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7171",
    name: "Port Bailey Seaplane Base",
    city: "Port Bailey",
    country: "United States",
    iata: "KPY",
    icao: "\\N",
    latitude: "57.93",
    longitude: "-153.040556",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7172",
    name: "Port Williams Seaplane Base",
    city: "Port Williams",
    country: "United States",
    iata: "KPR",
    icao: "\\N",
    latitude: "58.49",
    longitude: "-152.582222",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7173",
    name: "Seal Bay Seaplane Base",
    city: "Seal Bay",
    country: "United States",
    iata: "SYB",
    icao: "\\N",
    latitude: "58.166667",
    longitude: "-152.5",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7174",
    name: "San Juan - Uganik Seaplane Base",
    city: "San Juan",
    country: "United States",
    iata: "WSJ",
    icao: "\\N",
    latitude: "57.730278",
    longitude: "-153.320556",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7175",
    name: "West Point Village Seaplane Base",
    city: "West Point",
    country: "United States",
    iata: "KWP",
    icao: "\\N",
    latitude: "57.77",
    longitude: "-153.548889",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7176",
    name: "Zachar Bay Seaplane Base",
    city: "Zachar Bay",
    country: "United States",
    iata: "KZB",
    icao: "\\N",
    latitude: "57.55",
    longitude: "-153.75",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7177",
    name: "Ambler Airport",
    city: "Ambler",
    country: "United States",
    iata: "ABL",
    icao: "PAFM",
    latitude: "67.106389",
    longitude: "-157.8575",
    altitude: "334",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7178",
    name: "Buckland Airport",
    city: "Buckland",
    country: "United States",
    iata: "BKC",
    icao: "PABL",
    latitude: "65.981667",
    longitude: "-161.149167",
    altitude: "31",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7179",
    name: "Bob Baker Memorial Airport",
    city: "Kiana",
    country: "United States",
    iata: "IAN",
    icao: "PAIK",
    latitude: "66.975833",
    longitude: "-160.436667",
    altitude: "166",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7180",
    name: "Kobuk Airport",
    city: "Kobuk",
    country: "United States",
    iata: "OBU",
    icao: "PAOB",
    latitude: "66.912222",
    longitude: "-156.897222",
    altitude: "137",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7181",
    name: "Robert Curtis Memorial Airport",
    city: "Noorvik",
    country: "United States",
    iata: "ORV",
    icao: "PFNO",
    latitude: "66.8175",
    longitude: "-161.022222",
    altitude: "55",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7182",
    name: "Selawik Airport",
    city: "Selawik",
    country: "United States",
    iata: "WLK",
    icao: "PASK",
    latitude: "66.6",
    longitude: "-159.985833",
    altitude: "17",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7183",
    name: "Brevig Mission Airport",
    city: "Brevig Mission",
    country: "United States",
    iata: "KTS",
    icao: "PFKT",
    latitude: "65.331389",
    longitude: "-166.465833",
    altitude: "35",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7184",
    name: "Elim Airport",
    city: "Elim",
    country: "United States",
    iata: "ELI",
    icao: "PFEL",
    latitude: "64.615",
    longitude: "-162.270556",
    altitude: "162",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7185",
    name: "Golovin Airport",
    city: "Golovin",
    country: "United States",
    iata: "GLV",
    icao: "PAGL",
    latitude: "64.550556",
    longitude: "-163.007222",
    altitude: "59",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7186",
    name: "Teller Airport",
    city: "Teller",
    country: "United States",
    iata: "TLA",
    icao: "PATE",
    latitude: "65.240278",
    longitude: "-166.339444",
    altitude: "294",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7187",
    name: "Wales Airport",
    city: "Wales",
    country: "United States",
    iata: "WAA",
    icao: "PAIW",
    latitude: "65.6225",
    longitude: "-168.095",
    altitude: "22",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7188",
    name: "White Mountain Airport",
    city: "White Mountain",
    country: "United States",
    iata: "WMO",
    icao: "PAWM",
    latitude: "64.689167",
    longitude: "-163.412778",
    altitude: "267",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7189",
    name: "Council Airport",
    city: "Council",
    country: "United States",
    iata: "CIL",
    icao: "\\N",
    latitude: "64.897778",
    longitude: "-163.703333",
    altitude: "85",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7190",
    name: "Koyuk Alfred Adams Airport",
    city: "Koyuk",
    country: "United States",
    iata: "KKA",
    icao: "PAKK",
    latitude: "64.939444",
    longitude: "-161.154167",
    altitude: "154",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7191",
    name: "St. Michael Airport",
    city: "St. Michael",
    country: "United States",
    iata: "SMK",
    icao: "PAMK",
    latitude: "63.49",
    longitude: "-162.110278",
    altitude: "98",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7192",
    name: "Shaktoolik Airport",
    city: "Shaktoolik",
    country: "United States",
    iata: "SKK",
    icao: "PFSH",
    latitude: "64.371111",
    longitude: "-161.223889",
    altitude: "24",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7193",
    name: "Stebbins Airport",
    city: "Stebbins",
    country: "United States",
    iata: "WBB",
    icao: "\\N",
    latitude: "63.515833",
    longitude: "-162.278056",
    altitude: "14",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7194",
    name: "Tin City LRRS Airport",
    city: "Tin City",
    country: "United States",
    iata: "TNC",
    icao: "PATC",
    latitude: "65.563056",
    longitude: "-167.921667",
    altitude: "269",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7195",
    name: "Atka Airport",
    city: "Atka",
    country: "United States",
    iata: "AKB",
    icao: "PAAK",
    latitude: "52.220278",
    longitude: "-174.206389",
    altitude: "56",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7196",
    name: "Nikolski Air Station",
    city: "Nikolski",
    country: "United States",
    iata: "IKO",
    icao: "PAKO",
    latitude: "52.941667",
    longitude: "-168.848889",
    altitude: "77",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7197",
    name: "Icy Bay Airport",
    city: "Icy Bay",
    country: "United States",
    iata: "ICY",
    icao: "\\N",
    latitude: "59.968889",
    longitude: "-141.661667",
    altitude: "50",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7198",
    name: "Yakataga Airport",
    city: "Yakataga",
    country: "United States",
    iata: "CYT",
    icao: "PACY",
    latitude: "60.081901",
    longitude: "-142.493611",
    altitude: "12",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7199",
    name: "Alakanuk Airport",
    city: "Alakanuk",
    country: "United States",
    iata: "AUK",
    icao: "PAUK",
    latitude: "62.68",
    longitude: "-164.66",
    altitude: "10",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7200",
    name: "Sheldon Point Airport",
    city: "Nunam Iqua",
    country: "United States",
    iata: "SXP",
    icao: "\\N",
    latitude: "62.520556",
    longitude: "-164.847778",
    altitude: "12",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7201",
    name: "Kipnuk Airport",
    city: "Kipnuk",
    country: "United States",
    iata: "KPN",
    icao: "PAKI",
    latitude: "59.933056",
    longitude: "-164.030556",
    altitude: "11",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7202",
    name: "False Pass Airport",
    city: "False Pass",
    country: "United States",
    iata: "KFP",
    icao: "PAKF",
    latitude: "54.8475",
    longitude: "-163.410278",
    altitude: "20",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7203",
    name: "Nelson Lagoon",
    city: "Nelson Lagoon",
    country: "United States",
    iata: "NLG",
    icao: "PAOU",
    latitude: "56.0075",
    longitude: "-161.160278",
    altitude: "14",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7204",
    name: "Port Moller Airport",
    city: "Cold Bay",
    country: "United States",
    iata: "PML",
    icao: "PAAL",
    latitude: "56.006111",
    longitude: "-160.560833",
    altitude: "20",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7205",
    name: "Klawock Airport",
    city: "Klawock",
    country: "United States",
    iata: "KLW",
    icao: "PAKW",
    latitude: "55.579167",
    longitude: "-133.076111",
    altitude: "80",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7206",
    name: "Quinhagak Airport",
    city: "Quinhagak",
    country: "United States",
    iata: "KWN",
    icao: "PAQH",
    latitude: "59.755",
    longitude: "-161.845278",
    altitude: "42",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7207",
    name: "Kotlik Airport",
    city: "Kotlik",
    country: "United States",
    iata: "KOT",
    icao: "PFKO",
    latitude: "63.030556",
    longitude: "-163.532778",
    altitude: "15",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7208",
    name: "Koyukuk Airport",
    city: "Koyukuk",
    country: "United States",
    iata: "KYU",
    icao: "PFKU",
    latitude: "64.875833",
    longitude: "-157.730556",
    altitude: "149",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7209",
    name: "Scammon Bay Airport",
    city: "Scammon Bay",
    country: "United States",
    iata: "SCM",
    icao: "PACM",
    latitude: "61.845278",
    longitude: "-165.571389",
    altitude: "14",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7210",
    name: "Nondalton Airport",
    city: "Nondalton",
    country: "United States",
    iata: "NNL",
    icao: "PANO",
    latitude: "59.966944",
    longitude: "-154.851667",
    altitude: "262",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7211",
    name: "Pedro Bay Airport",
    city: "Pedro Bay",
    country: "United States",
    iata: "PDB",
    icao: "\\N",
    latitude: "59.782222",
    longitude: "-154.1325",
    altitude: "45",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7212",
    name: "Nunapitchuk Airport",
    city: "Nunapitchuk",
    country: "United States",
    iata: "NUP",
    icao: "\\N",
    latitude: "60.905833",
    longitude: "-162.439167",
    altitude: "12",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7213",
    name: "Kongiganak Airport",
    city: "Kongiganak",
    country: "United States",
    iata: "KKH",
    icao: "PADY",
    latitude: "59.960833",
    longitude: "-162.881111",
    altitude: "30",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7214",
    name: "Nikolai Airport",
    city: "Nikolai",
    country: "United States",
    iata: "NIB",
    icao: "PAFS",
    latitude: "63.010833",
    longitude: "-154.383889",
    altitude: "427",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7215",
    name: "Takotna Airport",
    city: "Takotna",
    country: "United States",
    iata: "TCT",
    icao: "\\N",
    latitude: "62.971944",
    longitude: "-156.082778",
    altitude: "825",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7216",
    name: "Pilot Station Airport",
    city: "Pilot Station",
    country: "United States",
    iata: "PQS",
    icao: "\\N",
    latitude: "61.934444",
    longitude: "-162.899444",
    altitude: "305",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7217",
    name: "Akiak Airport",
    city: "Akiak",
    country: "United States",
    iata: "AKI",
    icao: "PFAK",
    latitude: "60.902778",
    longitude: "-161.230556",
    altitude: "30",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7218",
    name: "Tuluksak Airport",
    city: "Tuluksak",
    country: "United States",
    iata: "TLT",
    icao: "\\N",
    latitude: "61.096944",
    longitude: "-160.969444",
    altitude: "30",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7219",
    name: "Grayling Airport",
    city: "Grayling",
    country: "United States",
    iata: "KGX",
    icao: "\\N",
    latitude: "62.894444",
    longitude: "-160.065",
    altitude: "99",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7220",
    name: "Wainwright Airport",
    city: "Wainwright",
    country: "United States",
    iata: "AIN",
    icao: "PAWI",
    latitude: "70.638056",
    longitude: "-159.994722",
    altitude: "41",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7221",
    name: "ZAPALA",
    city: "ZAPALA",
    country: "Argentina",
    iata: "APZ",
    icao: "SAHZ",
    latitude: "-38.9755",
    longitude: "-70.113581",
    altitude: "3330",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7222",
    name: "Rincon de los Sauces",
    city: "Rincon de los Sauces",
    country: "Argentina",
    iata: "RDS",
    icao: "\\N",
    latitude: "-37.390617",
    longitude: "-68.904211",
    altitude: "1969",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7223",
    name: "Colonia Sarmiento",
    city: "Colonia Sarmiento",
    country: "Argentina",
    iata: "OLN",
    icao: "\\N",
    latitude: "-45.6",
    longitude: "-69.083333",
    altitude: "849",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7224",
    name: "Grytvyken",
    city: "Grytvyken",
    country: "South Georgia and the Islands",
    iata: "",
    icao: "\\N",
    latitude: "-54.276667",
    longitude: "-36.511667",
    altitude: "538",
    timezone: "-2",
    dst: "S",
    tz: "Atlantic/South_Georgia",
  },
  {
    id: "7225",
    name: "Rio Turbio",
    city: "Rio Turbio",
    country: "Argentina",
    iata: "RYO",
    icao: "\\N",
    latitude: "-51.533333",
    longitude: "-72.3",
    altitude: "1158",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7226",
    name: "Puerto Natales",
    city: "Puerto Natales",
    country: "Chile",
    iata: "PNT",
    icao: "SCNT",
    latitude: "-51.733333",
    longitude: "-72.516667",
    altitude: "9",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "7227",
    name: "Caleta Olivia",
    city: "Caleta Olivia",
    country: "Argentina",
    iata: "CVI",
    icao: "\\N",
    latitude: "-46.4333",
    longitude: "-67.5333",
    altitude: "124",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7228",
    name: "Fitz Roy",
    city: "El Chalten",
    country: "Argentina",
    iata: "",
    icao: "\\N",
    latitude: "-47.033333",
    longitude: "-67.25",
    altitude: "757",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7229",
    name: "Sierra Grande",
    city: "Sierra Grande",
    country: "Argentina",
    iata: "SGV",
    icao: "SAVS",
    latitude: "-41.592",
    longitude: "-65.341",
    altitude: "820",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7230",
    name: "Ingeniero Jacobacci",
    city: "Ingeniero Jacobacci",
    country: "Argentina",
    iata: "IGB",
    icao: "SAVJ",
    latitude: "-41.3",
    longitude: "-69.5833",
    altitude: "2936",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7231",
    name: "Lago Posadas",
    city: "Lago Posadas",
    country: "Argentina",
    iata: "",
    icao: "\\N",
    latitude: "-47.533333",
    longitude: "-71.75",
    altitude: "748",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7232",
    name: "El Chalten",
    city: "El Chalten",
    country: "Argentina",
    iata: "ELX",
    icao: "\\N",
    latitude: "-49.328889",
    longitude: "-72.93",
    altitude: "1279",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7233",
    name: "Chenega Bay Airport",
    city: "Chenega",
    country: "United States",
    iata: "NCN",
    icao: "PFCB",
    latitude: "60.077222",
    longitude: "-147.991944",
    altitude: "72",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7234",
    name: "Chisana Airport",
    city: "Chisana",
    country: "United States",
    iata: "CZN",
    icao: "\\N",
    latitude: "62.071111",
    longitude: "-142.048333",
    altitude: "1011",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7235",
    name: "Tok Junction Airport",
    city: "Tok",
    country: "United States",
    iata: "6K8",
    icao: "PFTO",
    latitude: "63.329444",
    longitude: "-142.953611",
    altitude: "1639",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7236",
    name: "Circle City Airport",
    city: "Circle",
    country: "United States",
    iata: "IRC",
    icao: "PACR",
    latitude: "65.827778",
    longitude: "-144.076111",
    altitude: "613",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7237",
    name: "Coffman Cove Seaplane Base",
    city: "Coffman Cove",
    country: "United States",
    iata: "KCC",
    icao: "\\N",
    latitude: "56.014722",
    longitude: "-132.833889",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7238",
    name: "Crooked Creek Airport",
    city: "Crooked Creek",
    country: "United States",
    iata: "CKD",
    icao: "\\N",
    latitude: "61.867778",
    longitude: "-158.135",
    altitude: "178",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7239",
    name: "Red Devil Airport",
    city: "Red Devil",
    country: "United States",
    iata: "RDV",
    icao: "\\N",
    latitude: "61.788056",
    longitude: "-157.350278",
    altitude: "174",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7240",
    name: "Sleetmute Airport",
    city: "Sleetmute",
    country: "United States",
    iata: "SLQ",
    icao: "PASL",
    latitude: "61.700566",
    longitude: "-157.165833",
    altitude: "190",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7241",
    name: "Stony River 2 Airport",
    city: "Stony River",
    country: "United States",
    iata: "SRV",
    icao: "\\N",
    latitude: "61.7875",
    longitude: "-156.591111",
    altitude: "230",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7242",
    name: "Healy River Airport",
    city: "Healy",
    country: "United States",
    iata: "HKB",
    icao: "PAHV",
    latitude: "63.8675",
    longitude: "-148.968889",
    altitude: "1263",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7243",
    name: "Kake Seaplane Base",
    city: "Kake",
    country: "United States",
    iata: "KAE",
    icao: "\\N",
    latitude: "56.973056",
    longitude: "-133.945556",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7244",
    name: "Klawock Seaplane Base",
    city: "Klawock",
    country: "United States",
    iata: "AQC",
    icao: "PAQC",
    latitude: "55.554658",
    longitude: "-133.101693",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7245",
    name: "Minchumina Airport",
    city: "Lake Minchumina",
    country: "United States",
    iata: "MHM",
    icao: "PAMH",
    latitude: "63.886111",
    longitude: "-152.301944",
    altitude: "678",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7246",
    name: "Manley Hot Springs Airport",
    city: "Manley Hot Springs",
    country: "United States",
    iata: "MLY",
    icao: "PAML",
    latitude: "64.9975",
    longitude: "-150.644167",
    altitude: "270",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7247",
    name: "St. George Airport",
    city: "St. George",
    country: "United States",
    iata: "STG",
    icao: "\\N",
    latitude: "56.577222",
    longitude: "-169.663611",
    altitude: "125",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7248",
    name: "Tatitlek Airport",
    city: "Tatitlek",
    country: "United States",
    iata: "TEK",
    icao: "\\N",
    latitude: "60.8725",
    longitude: "-146.691111",
    altitude: "62",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7249",
    name: "Ketchikan harbor Seaplane Base",
    city: "Ketchikan",
    country: "United States",
    iata: "WFB",
    icao: "\\N",
    latitude: "55.344444",
    longitude: "-131.663333",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7250",
    name: "Fox Harbour Airport",
    city: "Fox Harbour",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "45.87",
    longitude: "-63.461111",
    altitude: "62",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "7251",
    name: "Natuashish Airport",
    city: "Natuashish",
    country: "Canada",
    iata: "",
    icao: "CNH2",
    latitude: "55.913889",
    longitude: "-61.184444",
    altitude: "33",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "7252",
    name: "Postville Airport",
    city: "Postville",
    country: "Canada",
    iata: "YSO",
    icao: "CCD4",
    latitude: "54.910278",
    longitude: "-59.785278",
    altitude: "223",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "7253",
    name: "Kangiqsujuaq - Wakeham Bay Airport",
    city: "Kangiqsujuaq",
    country: "Canada",
    iata: "YWB",
    icao: "CYKG",
    latitude: "61.588611",
    longitude: "-71.929444",
    altitude: "501",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7254",
    name: "Alma Airport",
    city: "Alma",
    country: "Canada",
    iata: "YTF",
    icao: "CYTF",
    latitude: "48.508611",
    longitude: "-71.641389",
    altitude: "449",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7255",
    name: "Havre Saint-Pierre Airport",
    city: "Havre-Saint-Pierre",
    country: "Canada",
    iata: "YGV",
    icao: "CYGV",
    latitude: "50.281944",
    longitude: "-63.611389",
    altitude: "124",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7256",
    name: "Rimouski Airport",
    city: "Rimouski",
    country: "Canada",
    iata: "YXK",
    icao: "CYXK",
    latitude: "48.478056",
    longitude: "-68.496944",
    altitude: "82",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7257",
    name: "Vakarufahli Island",
    city: "Vakarufahli Island",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.578742",
    longitude: "72.902075",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "7258",
    name: "Vakarufalhi Island",
    city: "Vakarufalhi Island",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.578742",
    longitude: "72.902075",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "7259",
    name: "Tadoule Lake Airport",
    city: "Tadoule Lake",
    country: "Canada",
    iata: "XTL",
    icao: "CYBQ",
    latitude: "58.706111",
    longitude: "-98.512222",
    altitude: "923",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7260",
    name: "Lac Brochet Airport",
    city: "Lac Brochet",
    country: "Canada",
    iata: "XLB",
    icao: "CZWH",
    latitude: "58.614167",
    longitude: "-101.468889",
    altitude: "1212",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7261",
    name: "South Indian Lake Airport",
    city: "South Indian Lake",
    country: "Canada",
    iata: "XSI",
    icao: "CZSN",
    latitude: "56.792778",
    longitude: "-98.907222",
    altitude: "951",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7262",
    name: "Brochet Airport",
    city: "Brochet",
    country: "Canada",
    iata: "YBT",
    icao: "CYBT",
    latitude: "57.889444",
    longitude: "-101.679167",
    altitude: "1131",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7263",
    name: "Little Grand Rapids Airport",
    city: "Little Grand Rapids",
    country: "Canada",
    iata: "ZGR",
    icao: "CZGR",
    latitude: "52.045",
    longitude: "-95.466111",
    altitude: "1008",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7264",
    name: "Cross Lake - Charlie Sinclair Memorial Airport",
    city: "Cross Lake",
    country: "Canada",
    iata: "YCR",
    icao: "CYCR",
    latitude: "54.610833",
    longitude: "-97.760278",
    altitude: "707",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7265",
    name: "Red Sucker Lake Airport",
    city: "Red Sucker Lake",
    country: "Canada",
    iata: "YRS",
    icao: "CYRS",
    latitude: "54.167222",
    longitude: "-93.557222",
    altitude: "729",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7266",
    name: "Rainbow Lake Airport",
    city: "Rainbow Lake",
    country: "Canada",
    iata: "YOP",
    icao: "CYOP",
    latitude: "58.491389",
    longitude: "-119.407778",
    altitude: "1756",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "7267",
    name: "Bonnyville Airport",
    city: "Bonnyville",
    country: "Canada",
    iata: "YBY",
    icao: "CYBF",
    latitude: "54.304722",
    longitude: "-110.741111",
    altitude: "1839",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "7268",
    name: "Nanaimo Harbour Water Airport",
    city: "Nanaimo",
    country: "Canada",
    iata: "ZNA",
    icao: "CAC8",
    latitude: "49.183333",
    longitude: "-123.95",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7269",
    name: "Ganges Water Aerodrome",
    city: "Ganges",
    country: "Canada",
    iata: "",
    icao: "CAX6",
    latitude: "48.85",
    longitude: "-123.5",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7270",
    name: "Bedwell Harbour Water Aerdrome",
    city: "Bedwell Harbour",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "48.75",
    longitude: "-123.233333",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7271",
    name: "Qualicum Beach Airport",
    city: "Qualicum Beach",
    country: "Canada",
    iata: "XQU",
    icao: "\\N",
    latitude: "49.337222",
    longitude: "-124.393889",
    altitude: "191",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7272",
    name: "Fort St. James - Perison Airport",
    city: "Fort St. James",
    country: "Canada",
    iata: "YJM",
    icao: "CYJM",
    latitude: "54.397222",
    longitude: "-124.262778",
    altitude: "2364",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7273",
    name: "Boundary Bay Airport",
    city: "Boundary Bay",
    country: "Canada",
    iata: "YDT",
    icao: "CZBB",
    latitude: "49.073889",
    longitude: "-123.0075",
    altitude: "6",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7274",
    name: "Langley Regional Airport",
    city: "Langley Township",
    country: "Canada",
    iata: "",
    icao: "CYNJ",
    latitude: "49.101111",
    longitude: "-122.630556",
    altitude: "34",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7275",
    name: "Bella Bella Airport",
    city: "Bella Bella",
    country: "Canada",
    iata: "ZEL",
    icao: "CYJQ",
    latitude: "52.139722",
    longitude: "-128.063611",
    altitude: "162",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7276",
    name: "Sechelt Aerodrome",
    city: "Sechelt-Gibsons",
    country: "Canada",
    iata: "YHS",
    icao: "\\N",
    latitude: "49.460556",
    longitude: "-123.718611",
    altitude: "250",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7277",
    name: "Wekweeti Airport",
    city: "Wekweeti",
    country: "Canada",
    iata: "",
    icao: "CFJ2",
    latitude: "64.190833",
    longitude: "-114.076667",
    altitude: "1206",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "7278",
    name: "Campo Cuatro Milpas Airport",
    city: "Guasave",
    country: "Mexico",
    iata: "",
    icao: "MM52",
    latitude: "25.651944",
    longitude: "-108.538056",
    altitude: "72",
    timezone: "-7",
    dst: "A",
    tz: "America/Mazatlan",
  },
  {
    id: "7279",
    name: "Isla de Cedros Airport",
    city: "Cedros",
    country: "Mexico",
    iata: "",
    icao: "MMCD",
    latitude: "28.0375",
    longitude: "-115.189444",
    altitude: "98",
    timezone: "-6",
    dst: "A",
    tz: "America/Mexico_City",
  },
  {
    id: "7280",
    name: "Cabo San Lucas International Airport",
    city: "Cabo San Lucas",
    country: "Mexico",
    iata: "",
    icao: "MMSL",
    latitude: "22.9475",
    longitude: "-109.937081",
    altitude: "459",
    timezone: "-7",
    dst: "A",
    tz: "America/Mazatlan",
  },
  {
    id: "7281",
    name: "Bahia Tortugas Airfield",
    city: "Bahia Tortugas",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "27.705278",
    longitude: "-114.911111",
    altitude: "102",
    timezone: "-7",
    dst: "A",
    tz: "America/Mazatlan",
  },
  {
    id: "7282",
    name: "Palo Verde Airport",
    city: "San Bruno",
    country: "Mexico",
    iata: "PVP",
    icao: "\\N",
    latitude: "27.093056",
    longitude: "-112.098889",
    altitude: "55",
    timezone: "-7",
    dst: "A",
    tz: "America/Mazatlan",
  },
  {
    id: "7283",
    name: "Ziyaraifushi",
    city: "Ziyaraifushi",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "4.531313889",
    longitude: "73.373325",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "7284",
    name: "Brussels Gare du Midi",
    city: "Brussels",
    country: "Belgium",
    iata: "ZYR",
    icao: "\\N",
    latitude: "50.8",
    longitude: "4.4",
    altitude: "180",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "7285",
    name: "Caye Chapel Airport",
    city: "Caye Chapel",
    country: "Belize",
    iata: "CYC",
    icao: "\\N",
    latitude: "17.683611",
    longitude: "-88.045",
    altitude: "10",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "7286",
    name: "Big Creek Airport",
    city: "Big Creek",
    country: "Belize",
    iata: "BGK",
    icao: "\\N",
    latitude: "16.516667",
    longitude: "-88.416667",
    altitude: "16",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "7287",
    name: "Dangriga Airport",
    city: "Dangriga",
    country: "Belize",
    iata: "DGA",
    icao: "\\N",
    latitude: "16.966667",
    longitude: "-88.216667",
    altitude: "10",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "7288",
    name: "Placencia Airport",
    city: "Placencia",
    country: "Belize",
    iata: "PLJ",
    icao: "\\N",
    latitude: "16.536944",
    longitude: "-88.361667",
    altitude: "42",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "7289",
    name: "Sartaneja Airport",
    city: "Sarteneja",
    country: "Belize",
    iata: "SJX",
    icao: "\\N",
    latitude: "18.355556",
    longitude: "-88.130833",
    altitude: "10",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "7290",
    name: "Huehuetenango Airport",
    city: "Huehuetenango",
    country: "Guatemala",
    iata: "",
    icao: "\\N",
    latitude: "15.314722",
    longitude: "-91.476111",
    altitude: "1901",
    timezone: "-6",
    dst: "U",
    tz: "America/Guatemala",
  },
  {
    id: "7291",
    name: "Corn Island Airport",
    city: "Corn Island",
    country: "Nicaragua",
    iata: "RNI",
    icao: "MNCI",
    latitude: "12.168611",
    longitude: "-83.0675",
    altitude: "26",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "7292",
    name: "Bonanza Airport",
    city: "Bonanza",
    country: "Nicaragua",
    iata: "BZA",
    icao: "MNBZ",
    latitude: "14.041667",
    longitude: "-84.630556",
    altitude: "597",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "7293",
    name: "Rosita Airport",
    city: "Rosita",
    country: "Nicaragua",
    iata: "RFS",
    icao: "MNRT",
    latitude: "13.897222",
    longitude: "-84.404722",
    altitude: "207",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "7294",
    name: "Siuna Airport",
    city: "Siuna",
    country: "Nicaragua",
    iata: "SIU",
    icao: "MNSI",
    latitude: "13.716667",
    longitude: "-84.776944",
    altitude: "480",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "7295",
    name: "Waspam Airport",
    city: "Waspam",
    country: "Nicaragua",
    iata: "WSP",
    icao: "MNWP",
    latitude: "14.737778",
    longitude: "-83.975833",
    altitude: "115",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "7296",
    name: "San Carols Airport",
    city: "San Carlos",
    country: "Nicaragua",
    iata: "",
    icao: "MNSC",
    latitude: "11.133333",
    longitude: "-84.783333",
    altitude: "131",
    timezone: "-6",
    dst: "U",
    tz: "America/Managua",
  },
  {
    id: "7297",
    name: "Carrillo Airport",
    city: "Carrillo",
    country: "Costa Rica",
    iata: "RIK",
    icao: "MRCR",
    latitude: "9.866667",
    longitude: "-85.483333",
    altitude: "10",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "7298",
    name: "Fussen",
    city: "Fussen",
    country: "Germany",
    iata: "FUS",
    icao: "FUSS",
    latitude: "47.585",
    longitude: "10.6866",
    altitude: "800",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7299",
    name: "John A. Osborne Airport",
    city: "Montserrat",
    country: "Montserrat",
    iata: "",
    icao: "\\N",
    latitude: "16.791389",
    longitude: "-62.193333",
    altitude: "550",
    timezone: "-4",
    dst: "U",
    tz: "America/Montserrat",
  },
  {
    id: "7300",
    name: "Monte Plata Batley Juan Sanchez Field",
    city: "Monte Plata",
    country: "Dominican Republic",
    iata: "",
    icao: "MDJS",
    latitude: "18.81",
    longitude: "-69.79",
    altitude: "1424",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "7301",
    name: "Constanza Airport",
    city: "Constanza",
    country: "Dominican Republic",
    iata: "COZ",
    icao: "MDCZ",
    latitude: "18.907626",
    longitude: "-70.719852",
    altitude: "3931",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "7302",
    name: "Negril Aerodrome",
    city: "Negril",
    country: "Jamaica",
    iata: "NEG",
    icao: "MKNG",
    latitude: "18.34",
    longitude: "-78.335556",
    altitude: "9",
    timezone: "-5",
    dst: "U",
    tz: "America/Jamaica",
  },
  {
    id: "7303",
    name: "Bochum Railway",
    city: "Bochum",
    country: "Germany",
    iata: "EBO",
    icao: "\\N",
    latitude: "51.478506",
    longitude: "7.222781",
    altitude: "45",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7304",
    name: "Fliegerhost ",
    city: "Kaufbeuren",
    country: "Germany",
    iata: "KFB",
    icao: "\\N",
    latitude: "47.874",
    longitude: "10.6294",
    altitude: "680",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7305",
    name: "Munich Railway",
    city: "Munich",
    country: "Germany",
    iata: "ZMU",
    icao: "\\N",
    latitude: "48.1408",
    longitude: "11.555",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7306",
    name: "Nuernberg Railway",
    city: "Nuernberg",
    country: "Germany",
    iata: "ZAQ",
    icao: "\\N",
    latitude: "49.446389",
    longitude: "11.081944",
    altitude: "312",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7307",
    name: "Jose Aponte de la Torre Airport",
    city: "Ceiba",
    country: "Puerto Rico",
    iata: "RVR",
    icao: "TJRV",
    latitude: "18.245278",
    longitude: "-65.643333",
    altitude: "38",
    timezone: "-4",
    dst: "A",
    tz: "America/Puerto_Rico",
  },
  {
    id: "7308",
    name: "Aeropuerto Internacional Valle del Conlara",
    city: "Merlo",
    country: "Argentina",
    iata: "RLO",
    icao: "\\N",
    latitude: "-32.349803",
    longitude: "-65.179932",
    altitude: "100",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7309",
    name: "Charlotte Amalie Harbor",
    city: "Charlotte Amalie",
    country: "Virgin Islands",
    iata: "",
    icao: "VI22",
    latitude: "18.338611",
    longitude: "-64.940833",
    altitude: "0",
    timezone: "-4",
    dst: "A",
    tz: "America/St_Thomas",
  },
  {
    id: "7310",
    name: "Christiansted Harbor Seaplane Base",
    city: "Christiansted",
    country: "Virgin Islands",
    iata: "SSB",
    icao: "\\N",
    latitude: "17.747222",
    longitude: "-64.705",
    altitude: "0",
    timezone: "-4",
    dst: "A",
    tz: "America/St_Thomas",
  },
  {
    id: "7311",
    name: "Alto Rio Senguer Airport",
    city: "Alto Rio Senguer",
    country: "Argentina",
    iata: "ARR",
    icao: "SAVR",
    latitude: "-45.016667",
    longitude: "-70.816667",
    altitude: "2145",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7312",
    name: "Jose de San Martin Airport",
    city: "Jose de San Martin",
    country: "Argentina",
    iata: "JSM",
    icao: "SAWS",
    latitude: "-44.016667",
    longitude: "-70.466667",
    altitude: "4359",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7313",
    name: "Uyuni Airport",
    city: "Uyuni",
    country: "Bolivia",
    iata: "UYU",
    icao: "SLUY",
    latitude: "-20.466667",
    longitude: "-66.833333",
    altitude: "11990",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "7314",
    name: "Augsburg Railway",
    city: "Augsburg",
    country: "Germany",
    iata: "ZAU",
    icao: "\\N",
    latitude: "48.3655",
    longitude: "10.8863",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7315",
    name: "Mannheim Railway",
    city: "Mannheim",
    country: "Germany",
    iata: "ZMA",
    icao: "\\N",
    latitude: "49.479633",
    longitude: "8.469858",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7316",
    name: "Essen Railway",
    city: "Essen",
    country: "Germany",
    iata: "ZES",
    icao: "\\N",
    latitude: "51.451389",
    longitude: "7.013889",
    altitude: "200",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7317",
    name: "Rurrenabaque Airport",
    city: "Rerrenabaque",
    country: "Bolivia",
    iata: "RBQ",
    icao: "SLRQ",
    latitude: "-14.4275",
    longitude: "-67.498056",
    altitude: "898",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "7318",
    name: "Lancaster Amtrak Station",
    city: "Lancaster",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.05",
    longitude: "-76.31",
    altitude: "345",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7319",
    name: "Ardmore Amtrak Station",
    city: "Ardmore",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.01",
    longitude: "-75.29",
    altitude: "360",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7320",
    name: "Abaiang Atoll Airport",
    city: "Abaiang Atoll",
    country: "Kiribati",
    iata: "ABF",
    icao: "NGAB",
    latitude: "1.8",
    longitude: "173.04",
    altitude: "1",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7321",
    name: "Metropark Amtrak Station",
    city: "Iselin",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.568",
    longitude: "-74.3275",
    altitude: "1",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7322",
    name: "St. Louis Downtown Airport",
    city: "East St. Louis",
    country: "United States",
    iata: "CPS",
    icao: "\\N",
    latitude: "38.5707244",
    longitude: "-90.1562211",
    altitude: "413",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "7323",
    name: "Afobaka Airstrip",
    city: "Afobaka",
    country: "Suriname",
    iata: "",
    icao: "SMAF",
    latitude: "4.9982",
    longitude: "-54.9919",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7324",
    name: "Alalapadu Airstrip",
    city: "Alapadu",
    country: "Suriname",
    iata: "",
    icao: "SMDU",
    latitude: "2.5232",
    longitude: "-56.3241",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7325",
    name: "Albina Airstrip",
    city: "Albina",
    country: "Suriname",
    iata: "ABN",
    icao: "SMBN",
    latitude: "5.516667",
    longitude: "-54.05",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7326",
    name: "Lawa Anapaike Airstrip",
    city: "Anapaike",
    country: "Suriname",
    iata: "",
    icao: "SMLA",
    latitude: "3.416667",
    longitude: "-54.033333",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7327",
    name: "Apetina Airstrip",
    city: "Apetina",
    country: "Suriname",
    iata: "",
    icao: "SMPT",
    latitude: "3.5017",
    longitude: "-55.0614",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7328",
    name: "Botopassi Airstrip",
    city: "Botopasi",
    country: "Suriname",
    iata: "BTO",
    icao: "\\N",
    latitude: "4.233333",
    longitude: "-55.45",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7329",
    name: "Djoemoe Airstrip",
    city: "Djoemoe",
    country: "Suriname",
    iata: "DOE",
    icao: "\\N",
    latitude: "4.016667",
    longitude: "-55.483333",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7330",
    name: "Drietabbetje Airstrip",
    city: "Drietabbetje",
    country: "Suriname",
    iata: "DRJ",
    icao: "SMDA",
    latitude: "4.11667",
    longitude: "-54.66667",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7331",
    name: "Kabalebo Airstrip",
    city: "Kabalebo",
    country: "Suriname",
    iata: "",
    icao: "SMKA",
    latitude: "4.406",
    longitude: "-57.223",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7332",
    name: "Kayser Airstrip",
    city: "Kayser",
    country: "Suriname",
    iata: "",
    icao: "SMKE",
    latitude: "3.1",
    longitude: "-56.483",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7333",
    name: "Kwamelasemoetoe Airstrip",
    city: "Kwamelasemoetoe",
    country: "Suriname",
    iata: "",
    icao: "SMSM",
    latitude: "2.33333",
    longitude: "-56.783333",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7334",
    name: "Moengo Airstrip",
    city: "Moengo",
    country: "Suriname",
    iata: "",
    icao: "SMMO",
    latitude: "5.616667",
    longitude: "-54.4",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7335",
    name: "Majoor Henry Fernandes Airport",
    city: "Nieuw Nickerie",
    country: "Suriname",
    iata: "ICK",
    icao: "SMNI",
    latitude: "5.955556",
    longitude: "-57.039444",
    altitude: "9",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7336",
    name: "Vincent Fayks Airport",
    city: "Paloemeu",
    country: "Suriname",
    iata: "OEM",
    icao: "SMPA",
    latitude: "5.811111",
    longitude: "-55.190833",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7337",
    name: "Sarakreek Airstrip",
    city: "Sarakreek",
    country: "Suriname",
    iata: "",
    icao: "SMSK",
    latitude: "4.9",
    longitude: "-55.083333",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7338",
    name: "Sipaliwini Airstrip",
    city: "Sipaliwini",
    country: "Suriname",
    iata: "",
    icao: "SMSI",
    latitude: "1.96605",
    longitude: "-56.0035",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7339",
    name: "Stoelmans Eiland Airstrip",
    city: "Stoelmans Eiland",
    country: "Suriname",
    iata: "SMZ",
    icao: "SMST",
    latitude: "4.35",
    longitude: "-54.41667",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7340",
    name: "Totness Airstrip",
    city: "Totness",
    country: "Suriname",
    iata: "TOT",
    icao: "SMCO",
    latitude: "5.865833",
    longitude: "-56.3275",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7341",
    name: "Wageningen Airstrip",
    city: "Wageningen",
    country: "Suriname",
    iata: "AGI",
    icao: "SMWA",
    latitude: "5.76667",
    longitude: "-56.63333",
    altitude: "10",
    timezone: "-3",
    dst: "U",
    tz: "America/Paramaribo",
  },
  {
    id: "7342",
    name: "Kaieteur International Airport",
    city: "Kaieteur Falls",
    country: "Guyana",
    iata: "KIA",
    icao: "PSKA",
    latitude: "5.163333",
    longitude: "-59.483333",
    altitude: "95",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7343",
    name: "Codela Airport",
    city: "Guapiles",
    country: "Costa Rica",
    iata: "CSC",
    icao: "MRCA",
    latitude: "10.414",
    longitude: "-85.0917",
    altitude: "328",
    timezone: "-6",
    dst: "U",
    tz: "America/Costa_Rica",
  },
  {
    id: "7344",
    name: "Newport News Amtrak Station",
    city: "Newport News",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.0228",
    longitude: "-76.4519",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7345",
    name: "Portland Union Station",
    city: "Portland",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "45.529",
    longitude: "-122.6768",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7346",
    name: "Orinduik Airport",
    city: "Orinduik",
    country: "Guyana",
    iata: "ORJ",
    icao: "SYOR",
    latitude: "4.7",
    longitude: "-60.016667",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7347",
    name: "Annai Airport",
    city: "Annai",
    country: "Guyana",
    iata: "NAI",
    icao: "SYAN",
    latitude: "3.95",
    longitude: "-59.133333",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7348",
    name: "Apoteri Airport",
    city: "Apoteri",
    country: "Guyana",
    iata: "",
    icao: "SYAP",
    latitude: "4.033333",
    longitude: "-58.583333",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7349",
    name: "Imbaimadai Airport",
    city: "Imbaimadai",
    country: "Guyana",
    iata: "IMB",
    icao: "SYIB",
    latitude: "5.69252",
    longitude: "-60.28198",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7350",
    name: "Kamarang Airport",
    city: "Kamarang",
    country: "Guyana",
    iata: "KAR",
    icao: "SYKM",
    latitude: "5.865278",
    longitude: "-60.614167",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7351",
    name: "Mabaruma Airport",
    city: "Mabaruma",
    country: "Guyana",
    iata: "USI",
    icao: "SYMB",
    latitude: "8.2",
    longitude: "-59.783333",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7352",
    name: "Mahdia Airport",
    city: "Mahdia",
    country: "Guyana",
    iata: "MHA",
    icao: "SYMD",
    latitude: "5.266667",
    longitude: "-59.15",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Guyana",
  },
  {
    id: "7353",
    name: "Dr. Augusto Roberto Fuster International Airport",
    city: "Pedro Juan Caballero",
    country: "Paraguay",
    iata: "PJC",
    icao: "SGPJ",
    latitude: "-22.641389",
    longitude: "-55.829722",
    altitude: "1873",
    timezone: "-4",
    dst: "U",
    tz: "America/Asuncion",
  },
  {
    id: "7354",
    name: "Alcides Fernandez Airport",
    city: "Acandi",
    country: "Colombia",
    iata: "ACD",
    icao: "SKAD",
    latitude: "8.516667",
    longitude: "-77.3",
    altitude: "50",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7355",
    name: "Los Colonizadores Airport",
    city: "Saravena",
    country: "Colombia",
    iata: "RVE",
    icao: "SKSA",
    latitude: "6.916667",
    longitude: "-71.9",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7356",
    name: "La Chorrera Airport",
    city: "La Chorrera",
    country: "Colombia",
    iata: "LCR",
    icao: "\\N",
    latitude: "-0.733333",
    longitude: "-73.016667",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7357",
    name: "Batagay Airport",
    city: "Batagay",
    country: "Russia",
    iata: "",
    icao: "UEBB",
    latitude: "67.648",
    longitude: "134.695",
    altitude: "696",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "7358",
    name: "La Macarena",
    city: "La Macarena",
    country: "Colombia",
    iata: "LMC",
    icao: "\\N",
    latitude: "2.179167",
    longitude: "-73.7875",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7359",
    name: "Villa Garzon Airport",
    city: "Villa Garzon",
    country: "Colombia",
    iata: "VGZ",
    icao: "SKVG",
    latitude: "0.978889",
    longitude: "-76.605556",
    altitude: "1248",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7360",
    name: "El Bagre Airport",
    city: "El Bagre",
    country: "Colombia",
    iata: "EBG",
    icao: "SKEB",
    latitude: "7.596389",
    longitude: "-74.808889",
    altitude: "180",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7361",
    name: "Juan H. White",
    city: "Caucasia",
    country: "Colombia",
    iata: "CAQ",
    icao: "SKCU",
    latitude: "7.968333",
    longitude: "-75.198333",
    altitude: "174",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7362",
    name: "Mandinga Airport",
    city: "Condoto",
    country: "Colombia",
    iata: "COG",
    icao: "SKCD",
    latitude: "5.071667",
    longitude: "-76.676389",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7363",
    name: "Golfo de Morrosquillo Airport",
    city: "Tolu",
    country: "Colombia",
    iata: "TLU",
    icao: "SKTL",
    latitude: "9.511944",
    longitude: "-75.586389",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Bogota",
  },
  {
    id: "7364",
    name: "Cabo Frio International Airport",
    city: "Cabo Frio",
    country: "Brazil",
    iata: "CFB",
    icao: "SBCB",
    latitude: "-22.921667",
    longitude: "-42.074167",
    altitude: "14",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7365",
    name: "Westport Amtrak Station",
    city: "Westport",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "44.1871",
    longitude: "-73.4519",
    altitude: "1",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7366",
    name: "Trenton Amtrak Station",
    city: "Trenton",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.21889",
    longitude: "-74.75417",
    altitude: "1",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7367",
    name: "Sinop Airport",
    city: "Sinop",
    country: "Brazil",
    iata: "OPS",
    icao: "SWSI",
    latitude: "-11.885",
    longitude: "-55.586",
    altitude: "10",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "7368",
    name: "Gurupi Airport",
    city: "Gurupi",
    country: "Brazil",
    iata: "GRP",
    icao: "SWGI",
    latitude: "-11.728889",
    longitude: "-49.068889",
    altitude: "10",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7369",
    name: "Campo Alegre Airport",
    city: "Santana do Araguaia",
    country: "Brazil",
    iata: "CMP",
    icao: "SNKE",
    latitude: "-9.505",
    longitude: "-50.625",
    altitude: "525",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7370",
    name: "Breves Airport",
    city: "Breves",
    country: "Brazil",
    iata: "BVS",
    icao: "SNVS",
    latitude: "-1.681944",
    longitude: "-50.48",
    altitude: "131",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7371",
    name: "Soure Airport",
    city: "Soure",
    country: "Brazil",
    iata: "SFK",
    icao: "SNSW",
    latitude: "-0.716944",
    longitude: "-48.522778",
    altitude: "33",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7372",
    name: "Julio Belem Airport",
    city: "Parintins",
    country: "Brazil",
    iata: "PIN",
    icao: "SWPI",
    latitude: "-2.627778",
    longitude: "-56.735833",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7373",
    name: "Barreiras Airport",
    city: "Barreiras",
    country: "Brazil",
    iata: "BRA",
    icao: "SNBR",
    latitude: "-12.083333",
    longitude: "-45",
    altitude: "1356",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7374",
    name: "Confresa Airport",
    city: "Santa Terezinha",
    country: "Brazil",
    iata: "STZ",
    icao: "SWST",
    latitude: "-10.47",
    longitude: "-50.502778",
    altitude: "650",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "7375",
    name: "Minacu Airport",
    city: "Minacu",
    country: "Brazil",
    iata: "MQH",
    icao: "SBMC",
    latitude: "-13.526944",
    longitude: "-48.220556",
    altitude: "1053",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7376",
    name: "Araguaina Airport",
    city: "Araguaina",
    country: "Brazil",
    iata: "AUX",
    icao: "SWGN",
    latitude: "-7.228333",
    longitude: "-48.240833",
    altitude: "771",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7377",
    name: "Novo Aripuana Airport",
    city: "Novo Aripuana",
    country: "Brazil",
    iata: "NVP",
    icao: "SWNA",
    latitude: "-5.121389",
    longitude: "-60.380556",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7378",
    name: "Bom Futuro Airport",
    city: "Lucas do Rio Verde",
    country: "Brazil",
    iata: "LVR",
    icao: "SWFE",
    latitude: "-13.05",
    longitude: "-55.910833",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "7379",
    name: "Franca Airport",
    city: "Franca",
    country: "Brazil",
    iata: "FRC",
    icao: "SIMK",
    latitude: "-20.538611",
    longitude: "-47.400833",
    altitude: "1040",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7380",
    name: "Dourados Airport",
    city: "Dourados",
    country: "Brazil",
    iata: "DOU",
    icao: "SSDO",
    latitude: "-22.220833",
    longitude: "-54.805833",
    altitude: "1433",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "7381",
    name: "Labrea Airport",
    city: "Labrea",
    country: "Brazil",
    iata: "LBR",
    icao: "SWLB",
    latitude: "-7.258889",
    longitude: "-64.797778",
    altitude: "225",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7382",
    name: "Rondonopolis Airport",
    city: "Rondonopolis",
    country: "Brazil",
    iata: "ROO",
    icao: "SWRD",
    latitude: "-16.466667",
    longitude: "-54.633333",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "7383",
    name: "Tancredo Thomaz de Faria Airport",
    city: "Guarapuava",
    country: "Brazil",
    iata: "GPB",
    icao: "SBGU",
    latitude: "-25.383333",
    longitude: "-51.45",
    altitude: "200",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7384",
    name: "Joacaba Airport",
    city: "Joacaba",
    country: "Brazil",
    iata: "JCB",
    icao: "SSJA",
    latitude: "-27.172778",
    longitude: "-51.500833",
    altitude: "1713",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7385",
    name: "North Philadelphia Amtrak Station",
    city: "Philadelphia",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.9969556",
    longitude: "-75.1487722",
    altitude: "1",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7386",
    name: "Aberdeen Railway Station",
    city: "Aberdeen",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "57.1436",
    longitude: "-2.0985",
    altitude: "1",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7387",
    name: "Glasgow Railway Station",
    city: "Glasgow",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "55.8622",
    longitude: "-4.2512",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7388",
    name: "Edinburgh Waverly Station",
    city: "Edinburgh",
    country: "United Kingdom",
    iata: "ZXE",
    icao: "\\N",
    latitude: "55.952",
    longitude: "-3.189",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7389",
    name: "Newcastle Railway Station",
    city: "Newcastle Upon Tyne",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "54.9686",
    longitude: "-1.6171",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7390",
    name: "Leeds Railway Station",
    city: "Leeds",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "53.794",
    longitude: "-1.547",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7391",
    name: "Manchester Picadilly Station",
    city: "Manchester",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "53.477",
    longitude: "-2.23",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7392",
    name: "Liverpool Railway Station",
    city: "Liverpool",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "53.405",
    longitude: "-2.979",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7393",
    name: "London Euston Railway Station",
    city: "London",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.5284",
    longitude: "-0.1331",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7394",
    name: "General leite de Castro Airport",
    city: "Rio Verde",
    country: "Brazil",
    iata: "RVD",
    icao: "SWLC",
    latitude: "-17.790278",
    longitude: "-50.918333",
    altitude: "2244",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7395",
    name: "Araxa Airport",
    city: "Araxa",
    country: "Brazil",
    iata: "AAX",
    icao: "SBAX",
    latitude: "-19.563056",
    longitude: "-46.960278",
    altitude: "3276",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7396",
    name: "Maues Airport",
    city: "Maues",
    country: "Brazil",
    iata: "MBZ",
    icao: "SWMW",
    latitude: "-3.383611",
    longitude: "-57.718611",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7397",
    name: "Borba Airport",
    city: "Borba",
    country: "Brazil",
    iata: "RBB",
    icao: "SWBR",
    latitude: "-4.387778",
    longitude: "-59.593889",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7398",
    name: "Coari Airport",
    city: "Coari",
    country: "Brazil",
    iata: "CIZ",
    icao: "SWKO",
    latitude: "-4.085",
    longitude: "-63.140833",
    altitude: "33",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7399",
    name: "Barcelos Airport",
    city: "Barcelos",
    country: "Brazil",
    iata: "BAZ",
    icao: "SWBC",
    latitude: "-0.975",
    longitude: "-62.923889",
    altitude: "500",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7400",
    name: "Herbert Glacier",
    city: "Juneau",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "58.571385",
    longitude: "-134.607754",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7401",
    name: "Seattle Cruise Terminal",
    city: "Seattle",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.615884",
    longitude: "-122.330017",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7402",
    name: "Juneau Cruise Pier",
    city: "Juneau",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "58.335451",
    longitude: "-134.414978",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7403",
    name: "Skagway Cruise Pier",
    city: "Skagway",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "59.470896",
    longitude: "-135.31723",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7404",
    name: "Ketchikan Cruise Pier",
    city: "Ketchikan ",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "55.346327",
    longitude: "-131.644707",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7405",
    name: "Victoria Cruise Pier",
    city: "Victoria",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "48.429144",
    longitude: "-123.367023",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7406",
    name: "Diamantino Airport",
    city: "Diamantino",
    country: "Brazil",
    iata: "DMT",
    icao: "SWDM",
    latitude: "-14.408889",
    longitude: "-56.445833",
    altitude: "1837",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "7407",
    name: "Guanambi Airport",
    city: "Guanambi",
    country: "Brazil",
    iata: "GNM",
    icao: "SNGI",
    latitude: "-14.216667",
    longitude: "-42.783333",
    altitude: "500",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7408",
    name: "Tsletsi Airport",
    city: "Djelfa",
    country: "Algeria",
    iata: "QDJ",
    icao: "DAFI",
    latitude: "34.6657",
    longitude: "3.351",
    altitude: "10",
    timezone: "1",
    dst: "U",
    tz: "Africa/Algiers",
  },
  {
    id: "7409",
    name: "Nzagi Airport",
    city: "Nzagi",
    country: "Angola",
    iata: "",
    icao: "FNZG",
    latitude: "-7.716944",
    longitude: "21.358056",
    altitude: "2431",
    timezone: "1",
    dst: "U",
    tz: "Africa/Luanda",
  },
  {
    id: "7410",
    name: "Catoca Airport",
    city: "Catoca",
    country: "Angola",
    iata: "",
    icao: "\\N",
    latitude: "-9.433017",
    longitude: "20.311189",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Luanda",
  },
  {
    id: "7411",
    name: "Lucapa Airport",
    city: "Lucapa",
    country: "Angola",
    iata: "LBZ",
    icao: "FNLK",
    latitude: "-8.443056",
    longitude: "20.732222",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Luanda",
  },
  {
    id: "7412",
    name: "Kapanda Airport",
    city: "Kapanda",
    country: "Angola",
    iata: "KNP",
    icao: "FNCP",
    latitude: "-9.771944",
    longitude: "15.456111",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Luanda",
  },
  {
    id: "7413",
    name: "Am Timan Airport",
    city: "Am Timan",
    country: "Chad",
    iata: "AMC",
    icao: "FTTN",
    latitude: "11.034",
    longitude: "20.274",
    altitude: "1421",
    timezone: "1",
    dst: "U",
    tz: "Africa/Ndjamena",
  },
  {
    id: "7414",
    name: "Sharq Al-Owainat Airport",
    city: "Sharq Al-Owainat",
    country: "Egypt",
    iata: "GSQ",
    icao: "HEOW",
    latitude: "22.5806",
    longitude: "28.7207",
    altitude: "859",
    timezone: "2",
    dst: "U",
    tz: "Africa/Cairo",
  },
  {
    id: "7415",
    name: "Eastern WV Regional Airport",
    city: "Martinsburg",
    country: "United States",
    iata: "MRB",
    icao: "KMRB",
    latitude: "39.2407",
    longitude: "-77.591",
    altitude: "554",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7416",
    name: "Awasa Airport",
    city: "Awasa",
    country: "Ethiopia",
    iata: "AWA",
    icao: "HALA",
    latitude: "7.067",
    longitude: "38.5",
    altitude: "5149",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7417",
    name: "Jijiga Airport",
    city: "Jijiga",
    country: "Ethiopia",
    iata: "JIJ",
    icao: "HAJJ",
    latitude: "9.359722",
    longitude: "42.7875",
    altitude: "2000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7418",
    name: "Mekane Salam Airport",
    city: "Mekane Selam",
    country: "Ethiopia",
    iata: "MKS",
    icao: "HAMA",
    latitude: "10.633333",
    longitude: "38.783333",
    altitude: "3000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7419",
    name: "Debre Marqos",
    city: "Debre Marqos",
    country: "Ethiopia",
    iata: "DBM",
    icao: "HADM",
    latitude: "10.316667",
    longitude: "37.733333",
    altitude: "7440",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7420",
    name: "Debre Tabor Airport",
    city: "Debre Tabor",
    country: "Ethiopia",
    iata: "DBT",
    icao: "HADT",
    latitude: "11.966667",
    longitude: "38",
    altitude: "7740",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7421",
    name: "Harar Meda Airport",
    city: "Debre Zeyit",
    country: "Ethiopia",
    iata: "QHR",
    icao: "HAHM",
    latitude: "8.7163",
    longitude: "39.0059",
    altitude: "8850",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7422",
    name: "Robe Airport",
    city: "Goba",
    country: "Ethiopia",
    iata: "GOB",
    icao: "HAGB",
    latitude: "6.733333",
    longitude: "44.266667",
    altitude: "4000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "7423",
    name: "Mayumba Airport",
    city: "Mayumba",
    country: "Gabon",
    iata: "MYB",
    icao: "FOOY",
    latitude: "-3.416667",
    longitude: "10.65",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Libreville",
  },
  {
    id: "7424",
    name: "Mara Serena Airport",
    city: "Masai Mara",
    country: "Kenya",
    iata: "MRE",
    icao: "\\N",
    latitude: "-1.406111",
    longitude: "35.008056",
    altitude: "500",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "7425",
    name: "Lewa Airport",
    city: "Lewa",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "0.1955",
    longitude: "37.4699",
    altitude: "2000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "7426",
    name: "Mulika Lodge Airport",
    city: "Meru National Park",
    country: "Kenya",
    iata: "",
    icao: "HKMK",
    latitude: "0.230278",
    longitude: "38.170556",
    altitude: "2000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "7427",
    name: "Rumbek Airport",
    city: "Rumbek",
    country: "Sudan",
    iata: "RBX",
    icao: "HSMK",
    latitude: "6.825",
    longitude: "29.669",
    altitude: "2000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Juba",
  },
  {
    id: "7428",
    name: "Yei Airport",
    city: "Yei",
    country: "Sudan",
    iata: "",
    icao: "HSYE",
    latitude: "4.083",
    longitude: "30.65",
    altitude: "1000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Juba",
  },
  {
    id: "7429",
    name: "Cape Palmas Airport",
    city: "Greenville",
    country: "Liberia",
    iata: "CPA",
    icao: "GLCP",
    latitude: "4.37902",
    longitude: "-7.69695",
    altitude: "500",
    timezone: "0",
    dst: "U",
    tz: "Africa/Monrovia",
  },
  {
    id: "7430",
    name: "Ambatomainty Airport",
    city: "Ambatomainty",
    country: "Madagascar",
    iata: "AMY",
    icao: "\\N",
    latitude: "-17.1667",
    longitude: "47.1833",
    altitude: "500",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "7431",
    name: "Kyoto",
    city: "Kyoto",
    country: "Japan",
    iata: "UKY",
    icao: "\\N",
    latitude: "35.016667",
    longitude: "135.766667",
    altitude: "262",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "7432",
    name: "Ecuvillens Airport",
    city: "Ecuvillens",
    country: "Switzerland",
    iata: "",
    icao: "LSGE",
    latitude: "46.754997",
    longitude: "7.076111",
    altitude: "2293",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7433",
    name: "Andermatt",
    city: "Andermatt",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.63889",
    longitude: "8.58889",
    altitude: "4747",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7434",
    name: "Wohlen Airfield",
    city: "Wohlen bei Bern",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.96694",
    longitude: "7.35806",
    altitude: "1795",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7435",
    name: "Bazaruto Island Airport",
    city: "Bazaruto Island",
    country: "Mozambique",
    iata: "BZB",
    icao: "\\N",
    latitude: "-21.542778",
    longitude: "35.473056",
    altitude: "500",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "7436",
    name: "Benguera Island Airport",
    city: "Benguera Island",
    country: "Mozambique",
    iata: "BCW",
    icao: "\\N",
    latitude: "-21.849167",
    longitude: "35.436944",
    altitude: "50",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "7437",
    name: "Inhaca Airport",
    city: "Inhaca",
    country: "Mozambique",
    iata: "",
    icao: "FQIA",
    latitude: "-26",
    longitude: "32.916667",
    altitude: "500",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "7438",
    name: "Indigo Bay Lodge Airport",
    city: "Indigo Bay Lodge",
    country: "Mozambique",
    iata: "IBL",
    icao: "\\N",
    latitude: "-21.707222",
    longitude: "35.452222",
    altitude: "50",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maputo",
  },
  {
    id: "7439",
    name: "Gombe Lawanti International Airport",
    city: "Gombe",
    country: "Nigeria",
    iata: "",
    icao: "\\N",
    latitude: "9.2575",
    longitude: "12.430278",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Lagos",
  },
  {
    id: "7440",
    name: "Akwa Ibom International Airport",
    city: "Uyo",
    country: "Nigeria",
    iata: "",
    icao: "\\N",
    latitude: "5.05",
    longitude: "7.933333",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Lagos",
  },
  {
    id: "7441",
    name: "Katsina Airport",
    city: "Katsina",
    country: "Nigeria",
    iata: "",
    icao: "\\N",
    latitude: "13.007778",
    longitude: "7.660278",
    altitude: "50",
    timezone: "1",
    dst: "U",
    tz: "Africa/Lagos",
  },
  {
    id: "7442",
    name: "Ouro Sogui Airport",
    city: "Matam",
    country: "Senegal",
    iata: "MAX",
    icao: "GOSM",
    latitude: "15.593611",
    longitude: "-13.322778",
    altitude: "85",
    timezone: "0",
    dst: "U",
    tz: "Africa/Dakar",
  },
  {
    id: "7443",
    name: "Bird Island Airport",
    city: "Bird Island",
    country: "Seychelles",
    iata: "BDI",
    icao: "FSSB",
    latitude: "-3.721389",
    longitude: "55.208611",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7444",
    name: "K50 Airport",
    city: "Mogadishu",
    country: "Somalia",
    iata: "",
    icao: "\\N",
    latitude: "1.999167",
    longitude: "44.974167",
    altitude: "500",
    timezone: "3",
    dst: "U",
    tz: "Africa/Mogadishu",
  },
  {
    id: "7445",
    name: "El Daein",
    city: "El Daein",
    country: "Sudan",
    iata: "",
    icao: "\\N",
    latitude: "14",
    longitude: "32.316667",
    altitude: "1000",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "7446",
    name: "Wadi Halfa Airport",
    city: "Wadi Halfa",
    country: "Sudan",
    iata: "WHF",
    icao: "HSSW",
    latitude: "21.800278",
    longitude: "31.516389",
    altitude: "1500",
    timezone: "3",
    dst: "U",
    tz: "Africa/Khartoum",
  },
  {
    id: "7447",
    name: "Enfidha - Zine El Abidine Ben Ali International Airport",
    city: "Enfidha",
    country: "Tunisia",
    iata: "NBE",
    icao: "DTNZ",
    latitude: "36.075833",
    longitude: "10.438611",
    altitude: "500",
    timezone: "1",
    dst: "U",
    tz: "Africa/Tunis",
  },
  {
    id: "7448",
    name: "Kidepo Airport",
    city: "Kidepo",
    country: "Uganda",
    iata: "",
    icao: "HUKD",
    latitude: "3.719167",
    longitude: "33.754167",
    altitude: "3904",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "7449",
    name: "Kitgum Airport",
    city: "Kitgum",
    country: "Uganda",
    iata: "",
    icao: "HUKT",
    latitude: "3.278611",
    longitude: "32.89",
    altitude: "2493",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "7450",
    name: "Pakuba Airport",
    city: "Pakuba",
    country: "Uganda",
    iata: "PAF",
    icao: "HUPA",
    latitude: "2.3275",
    longitude: "31.5",
    altitude: "2297",
    timezone: "3",
    dst: "U",
    tz: "Africa/Kampala",
  },
  {
    id: "7451",
    name: "Svea Airport",
    city: "Sveagruva",
    country: "Svalbard",
    iata: "",
    icao: "ENSA",
    latitude: "77.9",
    longitude: "16.683333",
    altitude: "29",
    timezone: "1",
    dst: "U",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "7452",
    name: "Ny-Alesund Airport",
    city: "Ny-Alesund",
    country: "Svalbard",
    iata: "",
    icao: "ENAS",
    latitude: "78.9275",
    longitude: "11.874167",
    altitude: "50",
    timezone: "1",
    dst: "U",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "7453",
    name: "Hatay Airport",
    city: "Hatay",
    country: "Turkey",
    iata: "HTY",
    icao: "LTDA",
    latitude: "36.362778",
    longitude: "36.282222",
    altitude: "25",
    timezone: "2",
    dst: "U",
    tz: "Europe/Istanbul",
  },
  {
    id: "7454",
    name: "Kihnu Airfield",
    city: "Kihnu",
    country: "Estonia",
    iata: "",
    icao: "EEKU",
    latitude: "58.148",
    longitude: "24.003",
    altitude: "50",
    timezone: "2",
    dst: "U",
    tz: "Europe/Tallinn",
  },
  {
    id: "7455",
    name: "Ruhnu Airfield",
    city: "Ruhnu",
    country: "Estonia",
    iata: "",
    icao: "EERU",
    latitude: "57.784",
    longitude: "23.266",
    altitude: "50",
    timezone: "2",
    dst: "U",
    tz: "Europe/Tallinn",
  },
  {
    id: "7456",
    name: "Raivavae Airport",
    city: "Raivavae",
    country: "French Polynesia",
    iata: "RVV",
    icao: "NTAV",
    latitude: "-23.87",
    longitude: "-147.67",
    altitude: "25",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Tahiti",
  },
  {
    id: "7457",
    name: "Foshan",
    city: "Foshan",
    country: "China",
    iata: "FUO",
    icao: "\\N",
    latitude: "23.133333",
    longitude: "113.28333",
    altitude: "8",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7458",
    name: "Huizhou",
    city: "Huizhou",
    country: "China",
    iata: "HUZ",
    icao: "\\N",
    latitude: "23.083332",
    longitude: "114.36667",
    altitude: "23",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7459",
    name: "Lleida-Alguaire Airport",
    city: "Lleida",
    country: "Spain",
    iata: "ILD",
    icao: "LEDA",
    latitude: "41.727778",
    longitude: "0.535833",
    altitude: "1148",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7460",
    name: "Aeropuerto Capitan Fuentes Martinez",
    city: "Porvenir",
    country: "Chile",
    iata: "WPR",
    icao: "\\N",
    latitude: "-53.2537",
    longitude: "-70.319228",
    altitude: "104",
    timezone: "-4",
    dst: "U",
    tz: "America/Santiago",
  },
  {
    id: "7461",
    name: "Ouessant Airport",
    city: "Ouessant",
    country: "France",
    iata: "",
    icao: "LFEC",
    latitude: "48.458056",
    longitude: "-5.095556",
    altitude: "25",
    timezone: "1",
    dst: "U",
    tz: "Europe/Paris",
  },
  {
    id: "7462",
    name: "Central Railway Station",
    city: "Montreal",
    country: "Canada",
    iata: "YMY",
    icao: "\\N",
    latitude: "45.499722",
    longitude: "-73.566111",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7463",
    name: "Union Station",
    city: "Toronto",
    country: "Canada",
    iata: "YBZ",
    icao: "\\N",
    latitude: "43.645278",
    longitude: "-79.380556",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7464",
    name: "Bildudalur Airport",
    city: "Bildudalur",
    country: "Iceland",
    iata: "BIU",
    icao: "BIBD",
    latitude: "65.641389",
    longitude: "-23.546111",
    altitude: "26",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "7465",
    name: "Gjogur Airport",
    city: "Gjogur",
    country: "Iceland",
    iata: "GJR",
    icao: "BIGJ",
    latitude: "65.995278",
    longitude: "-21.326944",
    altitude: "98",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "7466",
    name: "Saudarkrokur",
    city: "Saudarkrokur",
    country: "Iceland",
    iata: "SAK",
    icao: "BIKR",
    latitude: "65.731667",
    longitude: "-19.572778",
    altitude: "8",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "7467",
    name: "Selfoss Airport",
    city: "Selfoss",
    country: "Iceland",
    iata: "",
    icao: "BISF",
    latitude: "63.929167",
    longitude: "-21.037778",
    altitude: "45",
    timezone: "0",
    dst: "N",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "7468",
    name: "Inishmaan Aerodrome",
    city: "Inishmaan",
    country: "Ireland",
    iata: "IIA",
    icao: "EIMN",
    latitude: "53.091944",
    longitude: "-9.57",
    altitude: "13",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "7469",
    name: "Taldykorgan Airport",
    city: "Taldykorgan",
    country: "Kazakhstan",
    iata: "TDK",
    icao: "UAAT",
    latitude: "45.016667",
    longitude: "78.366667",
    altitude: "1969",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "7470",
    name: "Olgii Airport",
    city: "Olgii",
    country: "Mongolia",
    iata: "ULG",
    icao: "ZMUL",
    latitude: "48.991667",
    longitude: "89.919722",
    altitude: "5610",
    timezone: "7",
    dst: "U",
    tz: "Asia/Hovd",
  },
  {
    id: "7471",
    name: "Lille",
    city: "Lille",
    country: "France",
    iata: "XDB",
    icao: "\\N",
    latitude: "50.563333",
    longitude: "3.08805",
    altitude: "1",
    timezone: "1",
    dst: "U",
    tz: "Europe/Paris",
  },
  {
    id: "7472",
    name: "Qurghonteppa International Airport",
    city: "Kurgan Tyube",
    country: "Tajikistan",
    iata: "",
    icao: "UTDT",
    latitude: "37.862222",
    longitude: "68.862778",
    altitude: "5000",
    timezone: "5",
    dst: "U",
    tz: "Asia/Dushanbe",
  },
  {
    id: "7473",
    name: "Vologda Airport",
    city: "Vologda",
    country: "Russia",
    iata: "VGD",
    icao: "ULWW",
    latitude: "59.281667",
    longitude: "39.946667",
    altitude: "387",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7474",
    name: "Severo-Evensk Airport",
    city: "Evensk",
    country: "Russia",
    iata: "",
    icao: "UHMW",
    latitude: "61.921667",
    longitude: "159.23",
    altitude: "0",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "7475",
    name: "Olenyok Airport",
    city: "Olenyok",
    country: "Russia",
    iata: "",
    icao: "UERO",
    latitude: "68.514722",
    longitude: "112.48",
    altitude: "847",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "7476",
    name: "Saskylakh Airport",
    city: "Saskylakh",
    country: "Russia",
    iata: "",
    icao: "UERS",
    latitude: "71.927778",
    longitude: "114.08",
    altitude: "500",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "7477",
    name: "Lensk Airport",
    city: "Lensk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "60.719444",
    longitude: "114.931944",
    altitude: "700",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "7478",
    name: "Burevestnik Airport",
    city: "Iturup Island",
    country: "Russia",
    iata: "BVV",
    icao: "\\N",
    latitude: "44.92",
    longitude: "147.621667",
    altitude: "79",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "7479",
    name: "Okha Airport",
    city: "Okha",
    country: "Russia",
    iata: "OHH",
    icao: "\\N",
    latitude: "53.583333",
    longitude: "142.933333",
    altitude: "100",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "7480",
    name: "Leshukonskoye Airport",
    city: "Arkhangelsk",
    country: "Russia",
    iata: "LDG",
    icao: "ULAL",
    latitude: "64.895833",
    longitude: "45.722778",
    altitude: "220",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7481",
    name: "Nizhneangarsk Airport",
    city: "Nizhneangarsk",
    country: "Russia",
    iata: "",
    icao: "UIUN",
    latitude: "55.801667",
    longitude: "109.586667",
    altitude: "1545",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "7482",
    name: "Taksimo Airport",
    city: "Taksimo",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "56.361667",
    longitude: "114.93",
    altitude: "1500",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "7483",
    name: "Vanavara Airport",
    city: "Vanavara",
    country: "Russia",
    iata: "",
    icao: "UNIW",
    latitude: "60.355",
    longitude: "102.31",
    altitude: "892",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "7484",
    name: "Aykhal Airport",
    city: "Aykhal",
    country: "Russia",
    iata: "",
    icao: "UERA",
    latitude: "65.959167",
    longitude: "111.546389",
    altitude: "1499",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "7485",
    name: "Uktus Airport",
    city: "Yekaterinburg",
    country: "Russia",
    iata: "",
    icao: "USSK",
    latitude: "56.701667",
    longitude: "60.79",
    altitude: "643",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "7486",
    name: "Baykit Airport",
    city: "Baykit",
    country: "Russia",
    iata: "",
    icao: "UNIB",
    latitude: "61.676667",
    longitude: "96.355",
    altitude: "853",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "7487",
    name: "Biysk Airport",
    city: "Biysk",
    country: "Russia",
    iata: "",
    icao: "UNBI",
    latitude: "52.466667",
    longitude: "85.35",
    altitude: "620",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "7488",
    name: "Huesca-Pirineos Airport",
    city: "Huesca",
    country: "Spain",
    iata: "HSK",
    icao: "LEHC",
    latitude: "42.080833",
    longitude: "-0.323333",
    altitude: "1768",
    timezone: "1",
    dst: "U",
    tz: "Europe/Madrid",
  },
  {
    id: "7489",
    name: "Ciudad Real Central Airport",
    city: "Ciudad Real",
    country: "Spain",
    iata: "CQM",
    icao: "LERL",
    latitude: "38.856389",
    longitude: "-3.97",
    altitude: "636",
    timezone: "1",
    dst: "U",
    tz: "Europe/Madrid",
  },
  {
    id: "7490",
    name: "Al Najaf International Airport",
    city: "Najaf",
    country: "Iraq",
    iata: "NJF",
    icao: "ORNI",
    latitude: "31.991667",
    longitude: "44.404167",
    altitude: "500",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "7491",
    name: "Hilversum Railway Station",
    city: "Hilversum",
    country: "Netherlands",
    iata: "QYI",
    icao: "\\N",
    latitude: "52.226389",
    longitude: "5.181667",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7492",
    name: "Colonsay Airport",
    city: "Colonsay",
    country: "United Kingdom",
    iata: "CSA",
    icao: "EGEY",
    latitude: "56.0575",
    longitude: "-6.243056",
    altitude: "44",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7493",
    name: "Coll Airport",
    city: "Coll",
    country: "United Kingdom",
    iata: "COL",
    icao: "\\N",
    latitude: "56.633333",
    longitude: "-6.557222",
    altitude: "50",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7494",
    name: "Rock Hill York Co Bryant Airport",
    city: "Rock Hill",
    country: "United States",
    iata: "RKH",
    icao: "KUZA",
    latitude: "34.9878",
    longitude: "-81.0572",
    altitude: "667",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7495",
    name: "Allegheny County Airport",
    city: "Pittsburgh",
    country: "United States",
    iata: "AGC",
    icao: "KAGC",
    latitude: "40.3544",
    longitude: "-79.9302",
    altitude: "1252",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7496",
    name: "Cecil Field",
    city: "Jacksonville",
    country: "United States",
    iata: "NZC",
    icao: "KVQQ",
    latitude: "30.2187",
    longitude: "-81.8767",
    altitude: "81",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7497",
    name: "Fulton County Airport Brown Field",
    city: "Atlanta",
    country: "United States",
    iata: "FTY",
    icao: "KFTY",
    latitude: "33.7791",
    longitude: "-84.5214",
    altitude: "841",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7498",
    name: "Tresco Heliport",
    city: "Tresco",
    country: "United Kingdom",
    iata: "TSO",
    icao: "EGHT",
    latitude: "49.945556",
    longitude: "-6.331389",
    altitude: "20",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7499",
    name: "Tarin Kowt Airport",
    city: "Tarin Kowt",
    country: "Afghanistan",
    iata: "TII",
    icao: "OATN",
    latitude: "32.605278",
    longitude: "65.864167",
    altitude: "3500",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "7500",
    name: "Zaranj Airport",
    city: "Zaranj",
    country: "Afghanistan",
    iata: "ZAJ",
    icao: "OAZJ",
    latitude: "30.969167",
    longitude: "61.866944",
    altitude: "1581",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "7501",
    name: "Chaghcharan Airport",
    city: "Chaghcharan",
    country: "Afghanistan",
    iata: "CCN",
    icao: "OACC",
    latitude: "34.526667",
    longitude: "65.271667",
    altitude: "7383",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "7502",
    name: "Four Corners",
    city: "Four Corners",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "36.998976",
    longitude: "-109.045172",
    altitude: "1000",
    timezone: "-7",
    dst: "U",
    tz: "America/Denver",
  },
  {
    id: "7503",
    name: "Fuyang Airport",
    city: "Fuyang",
    country: "China",
    iata: "FUG",
    icao: "ZSFY",
    latitude: "32.9",
    longitude: "115.816667",
    altitude: "500",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7504",
    name: "Longyan Airport",
    city: "Longyan",
    country: "China",
    iata: "LCX",
    icao: "\\N",
    latitude: "25.674167",
    longitude: "116.746389",
    altitude: "300",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7505",
    name: "Baoshan Airport",
    city: "Baoshan",
    country: "China",
    iata: "BSD",
    icao: "ZPBS",
    latitude: "25.053333",
    longitude: "99.168333",
    altitude: "500",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7506",
    name: "Xingyi Airport",
    city: "Xingyi",
    country: "China",
    iata: "ACX",
    icao: "\\N",
    latitude: "25.0882",
    longitude: "104.9587",
    altitude: "500",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7507",
    name: "Macau Ferry Pier",
    city: "Macau",
    country: "Macau",
    iata: "XZM",
    icao: "\\N",
    latitude: "22.197075",
    longitude: "113.558911",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Macau",
  },
  {
    id: "7508",
    name: "Liping Airport",
    city: "Liping",
    country: "China",
    iata: "HZH",
    icao: "\\N",
    latitude: "26.206",
    longitude: "109.039",
    altitude: "500",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7509",
    name: "Ocean Isle Beach Airport",
    city: "Ocean Isle Beach",
    country: "United States",
    iata: "60J",
    icao: "\\N",
    latitude: "33.9085056",
    longitude: "-78.4366722",
    altitude: "32",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7510",
    name: "Stepanakert",
    city: "Stepanakert",
    country: "Azerbaijan",
    iata: "",
    icao: "UB13",
    latitude: "39.901439",
    longitude: "46.787031",
    altitude: "2001",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "7511",
    name: "Ohio State University Airport",
    city: "Columbus",
    country: "United States",
    iata: "OSU",
    icao: "KOSU",
    latitude: "40.0798",
    longitude: "-83.073",
    altitude: "905",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7922",
    name: "Rio Sidra",
    city: "Rio Sidra",
    country: "Panama",
    iata: "RSI",
    icao: "\\N",
    latitude: "8.966667",
    longitude: "-80.333336",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "7513",
    name: "Addison",
    city: "Addison",
    country: "United States",
    iata: "ADS",
    icao: "KADS",
    latitude: "32.9685594",
    longitude: "-96.8364478",
    altitude: "644",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7514",
    name: "Destin",
    city: "Destin",
    country: "United States",
    iata: "DTS",
    icao: "KDTS",
    latitude: "30.4000611",
    longitude: "-86.4714772",
    altitude: "23",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7515",
    name: "Fort Jefferson",
    city: "Fort Jefferson - Dry Tortugas",
    country: "United States",
    iata: "RBN",
    icao: "\\N",
    latitude: "24.61667",
    longitude: "-82.86667",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7516",
    name: "Chernobayevka Airport",
    city: "Kherson",
    country: "Ukraine",
    iata: "KHE",
    icao: "UKOH",
    latitude: "46.6758",
    longitude: "32.5064",
    altitude: "148",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "7517",
    name: "Ryans Creek Aerodrome",
    city: "Stewart Island",
    country: "New Zealand",
    iata: "SZS",
    icao: "NZRC",
    latitude: "-46.899693",
    longitude: "168.101592",
    altitude: "100",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Auckland",
  },
  {
    id: "7518",
    name: "Assumption Island",
    city: "Assumption Island",
    country: "Seychelles",
    iata: "",
    icao: "FSAS",
    latitude: "-9.7422",
    longitude: "46.5067",
    altitude: "10",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "7519",
    name: "Zhijiang Airport",
    city: "Zhijiang",
    country: "China",
    iata: "HJJ",
    icao: "\\N",
    latitude: "27.441389",
    longitude: "109.699722",
    altitude: "1000",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7520",
    name: "Aldabra",
    city: "Assumption Island",
    country: "Seychelles",
    iata: "",
    icao: "\\N",
    latitude: "-9.74",
    longitude: "46.51",
    altitude: "100",
    timezone: "4",
    dst: "U",
    tz: "Indian/Mahe",
  },
  {
    id: "7521",
    name: "Yarmouth Airport",
    city: "Yarmouth",
    country: "Canada",
    iata: "YQI",
    icao: "CYQI",
    latitude: "43.8269",
    longitude: "-66.0881",
    altitude: "141",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "7522",
    name: "Kinston Regional Jetport",
    city: "Kinston",
    country: "United States",
    iata: "ISO",
    icao: "KISO",
    latitude: "35.331389",
    longitude: "-77.608889",
    altitude: "94",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7523",
    name: "First Flight Airport",
    city: "Kill Devil Hills",
    country: "United States",
    iata: "FFA",
    icao: "KFFA",
    latitude: "36.02",
    longitude: "-75.67",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7524",
    name: "Pebble Island Airstrip",
    city: "Pebble Island Settlement",
    country: "Falkland Islands",
    iata: "",
    icao: "\\N",
    latitude: "-51.31",
    longitude: "-59.61",
    altitude: "8",
    timezone: "-3",
    dst: "S",
    tz: "Atlantic/Stanley",
  },
  {
    id: "7525",
    name: "Sea Lion Island Landing Strip",
    city: "Sea Lion Island",
    country: "Falkland Islands",
    iata: "",
    icao: "\\N",
    latitude: "-52.4282",
    longitude: "-59.0777",
    altitude: "0",
    timezone: "-3",
    dst: "S",
    tz: "Atlantic/Stanley",
  },
  {
    id: "7526",
    name: "Lively Settlement Airstrip",
    city: "Lively Island",
    country: "Falkland Islands",
    iata: "",
    icao: "\\N",
    latitude: "-52.03",
    longitude: "-58.47",
    altitude: "0",
    timezone: "-3",
    dst: "S",
    tz: "Atlantic/Stanley",
  },
  {
    id: "7527",
    name: "Lincang Airport",
    city: "Lincang",
    country: "China",
    iata: "LNJ",
    icao: "ZPLC",
    latitude: "23.738333",
    longitude: "100.025",
    altitude: "1500",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7528",
    name: "Wenshan Airport",
    city: "Wenshan",
    country: "China",
    iata: "WNH",
    icao: "\\N",
    latitude: "23.375833",
    longitude: "104.243056",
    altitude: "1000",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7529",
    name: "Ponta Pelada Airport",
    city: "Manaus",
    country: "Brazil",
    iata: "PLL",
    icao: "\\N",
    latitude: "-3.14604",
    longitude: "-59.9863",
    altitude: "267",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7530",
    name: "Sao Gabriel da Cachoeira Airport",
    city: "Sao Gabriel da Cachoeira",
    country: "Brazil",
    iata: "SJL",
    icao: "\\N",
    latitude: "-0.148056",
    longitude: "-66.9858",
    altitude: "251",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7531",
    name: "Maturaca",
    city: "Maturaca",
    country: "Brazil",
    iata: "",
    icao: "SWMK",
    latitude: "0.628269",
    longitude: "-66.115128",
    altitude: "354",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7532",
    name: "Carajas Airport",
    city: "Parauapebas",
    country: "Brazil",
    iata: "CKS",
    icao: "SBCJ",
    latitude: "-6.11781",
    longitude: "-50.0035",
    altitude: "2064",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7533",
    name: "Centro de Lancamento de Alcantara",
    city: "Alcantara",
    country: "Brazil",
    iata: "",
    icao: "SNCW",
    latitude: "-2.373",
    longitude: "-44.396389",
    altitude: "148",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7534",
    name: "Cachimbo",
    city: "Itaituba",
    country: "Brazil",
    iata: "ITB",
    icao: "\\N",
    latitude: "-4.2446",
    longitude: "-56.00384",
    altitude: "0",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "7535",
    name: "Latur Airport",
    city: "Latur",
    country: "India",
    iata: "LTU",
    icao: "\\N",
    latitude: "18.411944",
    longitude: "76.465",
    altitude: "1584",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Calcutta",
  },
  {
    id: "7536",
    name: "Matak Airport",
    city: "Anambas Islands",
    country: "Indonesia",
    iata: "MWK",
    icao: "WIOM",
    latitude: "3.348119",
    longitude: "106.25805",
    altitude: "10",
    timezone: "7",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7537",
    name: "Mainz Finthen",
    city: "Mainz",
    country: "Germany",
    iata: "QFZ",
    icao: "\\N",
    latitude: "0",
    longitude: "0",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "7538",
    name: "Wuerzburg",
    city: "Wuerzburg",
    country: "Germany",
    iata: "",
    icao: "EDFW",
    latitude: "51.93749",
    longitude: "8.38257",
    altitude: "400",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7539",
    name: "Mainz",
    city: "Mainz",
    country: "Germany",
    iata: "QMZ",
    icao: "\\N",
    latitude: "50.00829",
    longitude: "8.27356",
    altitude: "360",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7540",
    name: "Berlin Gatow",
    city: "Berlin",
    country: "Germany",
    iata: "GWW",
    icao: "\\N",
    latitude: "52.475",
    longitude: "13.139",
    altitude: "160",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7541",
    name: "Rheine Bentlage",
    city: "Rheine",
    country: "Germany",
    iata: "ZPQ",
    icao: "\\N",
    latitude: "52.27656",
    longitude: "7.43843",
    altitude: "120",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7542",
    name: "Sao Jacinto",
    city: "Aveiro",
    country: "Portugal",
    iata: "",
    icao: "LPAV",
    latitude: "40.72222",
    longitude: "-8.816667",
    altitude: "26",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "7543",
    name: "Tana Toraja Airport",
    city: "Toraja",
    country: "Indonesia",
    iata: "TTR",
    icao: "\\N",
    latitude: "-3.416667",
    longitude: "119.916664",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "7544",
    name: "Hopsten Air Base",
    city: "Hopsten",
    country: "Germany",
    iata: "",
    icao: "ETNP",
    latitude: "52.3387",
    longitude: "7.54133",
    altitude: "423",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7545",
    name: "Jose Aponte De La Torre Airport",
    city: "Ceiba",
    country: "Puerto Rico",
    iata: "",
    icao: "TJNR",
    latitude: "18.2453",
    longitude: "-65.6434",
    altitude: "38",
    timezone: "-4",
    dst: "S",
    tz: "America/Puerto_Rico",
  },
  {
    id: "7546",
    name: "Persian Gulf Airport",
    city: "Khalije Fars",
    country: "Iran",
    iata: "PGU",
    icao: "OIBP",
    latitude: "27.379444",
    longitude: "52.7375",
    altitude: "27",
    timezone: "3.5",
    dst: "U",
    tz: "Asia/Tehran",
  },
  {
    id: "7547",
    name: "Yasuj Airport",
    city: "Yasuj",
    country: "Iran",
    iata: "YES",
    icao: "OISY",
    latitude: "30.700556",
    longitude: "51.545",
    altitude: "5939",
    timezone: "3.5",
    dst: "U",
    tz: "Asia/Tehran",
  },
  {
    id: "7548",
    name: "Mosul International Airport",
    city: "Mosul",
    country: "Iraq",
    iata: "OSB",
    icao: "ORBM",
    latitude: "36.305833",
    longitude: "43.1475",
    altitude: "719",
    timezone: "3",
    dst: "U",
    tz: "Asia/Baghdad",
  },
  {
    id: "7549",
    name: "Tajima Airport",
    city: "Toyooka",
    country: "Japan",
    iata: "TJH",
    icao: "RJBT",
    latitude: "35.512778",
    longitude: "134.786944",
    altitude: "578",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "7550",
    name: "Amakusa Airfield",
    city: "Amakusa",
    country: "Japan",
    iata: "AXJ",
    icao: "RJDA",
    latitude: "32.482222",
    longitude: "130.158889",
    altitude: "340",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "7551",
    name: "Kikai Airport",
    city: "Kikai",
    country: "Japan",
    iata: "KKX",
    icao: "RJKI",
    latitude: "28.321389",
    longitude: "129.928056",
    altitude: "15",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "7552",
    name: "Aguni Airport",
    city: "Aguni",
    country: "Japan",
    iata: "AGJ",
    icao: "RORA",
    latitude: "26.592778",
    longitude: "127.240278",
    altitude: "38",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "7553",
    name: "Chongjin Airport",
    city: "Chongjin",
    country: "North Korea",
    iata: "",
    icao: "\\N",
    latitude: "41.801389",
    longitude: "129.855",
    altitude: "500",
    timezone: "9",
    dst: "U",
    tz: "Asia/Pyongyang",
  },
  {
    id: "7554",
    name: "Haeju Airport",
    city: "Haeju",
    country: "North Korea",
    iata: "HAE",
    icao: "\\N",
    latitude: "38.00543",
    longitude: "125.77863",
    altitude: "131",
    timezone: "9",
    dst: "U",
    tz: "Asia/Pyongyang",
  },
  {
    id: "7555",
    name: "Layang Layang Airport",
    city: "Layang Layang Atoll",
    country: "Malaysia",
    iata: "LAC",
    icao: "\\N",
    latitude: "7.372222",
    longitude: "113.841667",
    altitude: "5",
    timezone: "8",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7556",
    name: "Donoi Airport",
    city: "Uliastai",
    country: "Mongolia",
    iata: "",
    icao: "ZMDN",
    latitude: "47.712778",
    longitude: "96.524167",
    altitude: "5724",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "7557",
    name: "Bulgan Airport",
    city: "Bulgan",
    country: "Mongolia",
    iata: "UGA",
    icao: "ZMBN",
    latitude: "48.854167",
    longitude: "103.484167",
    altitude: "3873",
    timezone: "8",
    dst: "U",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "7558",
    name: "Ulaangom Airport",
    city: "Ulaangom",
    country: "Mongolia",
    iata: "ULO",
    icao: "ZMUG",
    latitude: "49.973333",
    longitude: "92.079722",
    altitude: "3500",
    timezone: "7",
    dst: "U",
    tz: "Asia/Hovd",
  },
  {
    id: "7559",
    name: "Borongan Airport",
    city: "Borongan",
    country: "Philippines",
    iata: "BPR",
    icao: "RPVW",
    latitude: "11.674167",
    longitude: "125.478611",
    altitude: "7",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "7560",
    name: "Lubang Community Airport",
    city: "Lubang",
    country: "Philippines",
    iata: "LBX",
    icao: "RPLU",
    latitude: "13.855833",
    longitude: "121.105833",
    altitude: "25",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "7561",
    name: "Bentota Airport",
    city: "Bentota",
    country: "Sri Lanka",
    iata: "BJT",
    icao: "\\N",
    latitude: "6.416667",
    longitude: "79.983333",
    altitude: "100",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "7562",
    name: "Dickwella Airport",
    city: "Dickwella",
    country: "Sri Lanka",
    iata: "DIW",
    icao: "\\N",
    latitude: "5.966667",
    longitude: "80.683333",
    altitude: "100",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Colombo",
  },
  {
    id: "7563",
    name: "Kulob Airport",
    city: "Kulyab",
    country: "Tajikistan",
    iata: "TJU",
    icao: "UTDK",
    latitude: "37.981667",
    longitude: "69.799444",
    altitude: "2293",
    timezone: "5",
    dst: "U",
    tz: "Asia/Dushanbe",
  },
  {
    id: "7564",
    name: "Cimei Airport",
    city: "Cimei",
    country: "Taiwan",
    iata: "CMJ",
    icao: "RCCM",
    latitude: "23.266667",
    longitude: "119.666667",
    altitude: "63",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "7565",
    name: "Dasoguz Airport",
    city: "Dasoguz",
    country: "Turkmenistan",
    iata: "TAZ",
    icao: "UTAT",
    latitude: "41.764722",
    longitude: "59.833056",
    altitude: "500",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "7566",
    name: "Barrow Island Airport",
    city: "Barrow Island",
    country: "Australia",
    iata: "BWB",
    icao: "YBWX",
    latitude: "-20.798",
    longitude: "115.406",
    altitude: "25",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7567",
    name: "Morawa Airport",
    city: "Morawa",
    country: "Australia",
    iata: "MWB",
    icao: "\\N",
    latitude: "-29.211",
    longitude: "116.009",
    altitude: "899",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7568",
    name: "Exmouth Airport",
    city: "Exmouth",
    country: "Australia",
    iata: "EXM",
    icao: "\\N",
    latitude: "-21.933",
    longitude: "114.128",
    altitude: "50",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7569",
    name: "Derby Airport",
    city: "Derby",
    country: "Australia",
    iata: "DRB",
    icao: "YDBY",
    latitude: "-17.39",
    longitude: "123.68",
    altitude: "26",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7570",
    name: "Walgett Airport",
    city: "Walgett",
    country: "Australia",
    iata: "WGE",
    icao: "YWLG",
    latitude: "-30.0318",
    longitude: "148.1222",
    altitude: "439",
    timezone: "10",
    dst: "U",
    tz: "Australia/Sydney",
  },
  {
    id: "7571",
    name: "Bathurst Island Airport",
    city: "Bathurst Island",
    country: "Australia",
    iata: "BRT",
    icao: "YBTI",
    latitude: "-11.769167",
    longitude: "130.619722",
    altitude: "67",
    timezone: "9.5",
    dst: "U",
    tz: "Australia/Darwin",
  },
  {
    id: "7572",
    name: "Dunk Island Airport",
    city: "Dunk Island",
    country: "Australia",
    iata: "DKI",
    icao: "YDKI",
    latitude: "-17.939722",
    longitude: "146.141944",
    altitude: "38",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "7573",
    name: "Lizard Island Airport",
    city: "Lizard Island",
    country: "Australia",
    iata: "LZR",
    icao: "YLZI",
    latitude: "-14.673056",
    longitude: "145.454444",
    altitude: "40",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "7574",
    name: "Hamilton Airport",
    city: "Hamilton",
    country: "Australia",
    iata: "HLT",
    icao: "YHML",
    latitude: "-37.648889",
    longitude: "142.065278",
    altitude: "803",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "7575",
    name: "Halls Creek Airport",
    city: "Halls Creek",
    country: "Australia",
    iata: "HCQ",
    icao: "YHLC",
    latitude: "-18.233889",
    longitude: "127.669722",
    altitude: "1346",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7576",
    name: "Fitzroy Crossing Airport",
    city: "Fitzroy Crossing",
    country: "Australia",
    iata: "FIZ",
    icao: "YFTZ",
    latitude: "-18.178",
    longitude: "125.591",
    altitude: "374",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7577",
    name: "Ravensthorpe Airport",
    city: "Ravensthorpe",
    country: "Australia",
    iata: "RVT",
    icao: "YNRV",
    latitude: "-33.797222",
    longitude: "120.208056",
    altitude: "209",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "7578",
    name: "Wilkins Runway",
    city: "Budd Coast",
    country: "Antarctica",
    iata: "",
    icao: "YWKS",
    latitude: "-66.689444",
    longitude: "111.485833",
    altitude: "2395",
    timezone: "12",
    dst: "U",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "7579",
    name: "Provo Municipal Airport",
    city: "Provo",
    country: "United States",
    iata: "PVU",
    icao: "KPVU",
    latitude: "40.21805555",
    longitude: "-111.72222222",
    altitude: "4497",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7580",
    name: "Steamboat Springs Airport-Bob Adams Field",
    city: "Steamboat Springs",
    country: "United States",
    iata: "SBS",
    icao: "KSBS",
    latitude: "40.51625",
    longitude: "-106.8663056",
    altitude: "6882",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7581",
    name: "Delta Municipal Airport",
    city: "Delta",
    country: "United States",
    iata: "DTA",
    icao: "KDTA",
    latitude: "39.3806386",
    longitude: "-112.5077147",
    altitude: "4759",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7582",
    name: "Richfield Minicipal Airport",
    city: "Richfield",
    country: "United States",
    iata: "RIF",
    icao: "KRIF",
    latitude: "38.7364361",
    longitude: "-112.0989444",
    altitude: "5301",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7583",
    name: "Carbon County Regional-Buck Davis Field",
    city: "Price",
    country: "United States",
    iata: "PUC",
    icao: "KPUC",
    latitude: "39.609722",
    longitude: "-110.75278",
    altitude: "5957",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7584",
    name: "Los Alamos Airport",
    city: "Los Alamos",
    country: "United States",
    iata: "LAM",
    icao: "KLAM",
    latitude: "35.8798019",
    longitude: "-106.2694153",
    altitude: "7171",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7585",
    name: "Borrego Valley Airport",
    city: "Borrego Springs",
    country: "United States",
    iata: "BXS",
    icao: "KBXS",
    latitude: "33.2590278",
    longitude: "-116.3209722",
    altitude: "520",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7586",
    name: "Lake Havasu City Airport",
    city: "Lake Havasu City",
    country: "United States",
    iata: "HII",
    icao: "KHII",
    latitude: "34.5711111",
    longitude: "-114.3582778",
    altitude: "783",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "7587",
    name: "Winslow-Lindbergh Regional Airport",
    city: "Winslow",
    country: "United States",
    iata: "INW",
    icao: "KINW",
    latitude: "35.0219167",
    longitude: "-110.7225278",
    altitude: "4941",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "7588",
    name: "Douglas Municipal Airport",
    city: "Douglas",
    country: "United States",
    iata: "DGL",
    icao: "KDGL",
    latitude: "31.3426028",
    longitude: "-109.5064544",
    altitude: "4173",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "7589",
    name: "Marakei Airport",
    city: "Marakei",
    country: "Kiribati",
    iata: "MZK",
    icao: "NGMK",
    latitude: "2.050278",
    longitude: "173.266667",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7590",
    name: "Abemama Atoll Airport",
    city: "Abemama",
    country: "Kiribati",
    iata: "AEA",
    icao: "NGTB",
    latitude: "0.490833",
    longitude: "173.828611",
    altitude: "8",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7591",
    name: "Aranuka Airport",
    city: "Buariki",
    country: "Kiribati",
    iata: "AAK",
    icao: "NGUK",
    latitude: "0.185278",
    longitude: "173.636389",
    altitude: "6",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7592",
    name: "Kuria Airport",
    city: "Kuria",
    country: "Kiribati",
    iata: "KUC",
    icao: "NGKT",
    latitude: "0.228611",
    longitude: "173.410556",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7593",
    name: "Arorae Island Airport",
    city: "Arorae",
    country: "Kiribati",
    iata: "AIS",
    icao: "NGTR",
    latitude: "-2.633333",
    longitude: "179.816667",
    altitude: "6",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7594",
    name: "Tamana Airport",
    city: "Tamana",
    country: "Kiribati",
    iata: "TMN",
    icao: "NGTM",
    latitude: "-2.5",
    longitude: "175.983333",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7595",
    name: "Beru Island Airport",
    city: "Beru Island",
    country: "Kiribati",
    iata: "BEZ",
    icao: "NGBR",
    latitude: "-1.254722",
    longitude: "176.007222",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7596",
    name: "Nikunau Airport",
    city: "Nikunau",
    country: "Kiribati",
    iata: "NIG",
    icao: "NGNU",
    latitude: "-1.35",
    longitude: "176.45",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7597",
    name: "Butaritari Atoll Airport",
    city: "Butaritari",
    country: "Kiribati",
    iata: "BBG",
    icao: "NGTU",
    latitude: "3.086521",
    longitude: "172.811465",
    altitude: "5",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7598",
    name: "Makin Airport",
    city: "Makin",
    country: "Kiribati",
    iata: "MTK",
    icao: "NGMN",
    latitude: "3.383333",
    longitude: "173",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Tarawa",
  },
  {
    id: "7599",
    name: "Maiana Airport",
    city: "Maiana",
    country: "Kiribati",
    iata: "MNK",
    icao: "NGMA",
    latitude: "0.933333",
    longitude: "173",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7600",
    name: "Nonouti Airport",
    city: "Nonouti",
    country: "Kiribati",
    iata: "NON",
    icao: "NGTO",
    latitude: "-0.616667",
    longitude: "174.366667",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7601",
    name: "Tabiteuea South Airport",
    city: "Tabiteuea",
    country: "Kiribati",
    iata: "TSU",
    icao: "NGTS",
    latitude: "-1.35",
    longitude: "174.8",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7602",
    name: "Bosset Airport",
    city: "Bosset",
    country: "Papua New Guinea",
    iata: "BOT",
    icao: "\\N",
    latitude: "-7.240833",
    longitude: "141.092333",
    altitude: "60",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "7603",
    name: "Ine Airport",
    city: "Ine",
    country: "Marshall Islands",
    iata: "IMI",
    icao: "\\N",
    latitude: "7.016667",
    longitude: "171.483333",
    altitude: "4",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7604",
    name: "Tinak Airport",
    city: "Tinak",
    country: "Marshall Islands",
    iata: "TIC",
    icao: "\\N",
    latitude: "7.133333",
    longitude: "171.916667",
    altitude: "4",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7605",
    name: "Ebon Airport",
    city: "Ebon",
    country: "Marshall Islands",
    iata: "",
    icao: "\\N",
    latitude: "4.598889",
    longitude: "168.753056",
    altitude: "5",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7606",
    name: "Elenak Airport",
    city: "Elenak",
    country: "Marshall Islands",
    iata: "EAL",
    icao: "\\N",
    latitude: "9.083333",
    longitude: "167.333333",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7607",
    name: "Lae Airport",
    city: "Lae",
    country: "Marshall Islands",
    iata: "LML",
    icao: "\\N",
    latitude: "8.921667",
    longitude: "166.265556",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7608",
    name: "Airok Airport",
    city: "Airok",
    country: "Marshall Islands",
    iata: "AIC",
    icao: "\\N",
    latitude: "7.1",
    longitude: "171.233333",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7609",
    name: "Enejit Airport",
    city: "Enejit",
    country: "Marshall Islands",
    iata: "EJT",
    icao: "\\N",
    latitude: "6.040278",
    longitude: "171.984444",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Majuro",
  },
  {
    id: "7610",
    name: "Whitianga Airport",
    city: "Whitianga",
    country: "New Zealand",
    iata: "WTZ",
    icao: "NZWT",
    latitude: "-36.835833",
    longitude: "175.700278",
    altitude: "500",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Auckland",
  },
  {
    id: "7611",
    name: "Takaka Aerodrome",
    city: "Takaka",
    country: "New Zealand",
    iata: "KTF",
    icao: "NZTK",
    latitude: "-40.85",
    longitude: "172.8",
    altitude: "500",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Auckland",
  },
  {
    id: "7612",
    name: "Peleliu Airfield",
    city: "Peleliu",
    country: "Palau",
    iata: "C23",
    icao: "\\N",
    latitude: "6.998333",
    longitude: "134.232778",
    altitude: "9",
    timezone: "9",
    dst: "U",
    tz: "Pacific/Palau",
  },
  {
    id: "7613",
    name: "Angaur Airstrip",
    city: "Angaur",
    country: "Palau",
    iata: "",
    icao: "\\N",
    latitude: "6.906389",
    longitude: "134.145",
    altitude: "20",
    timezone: "9",
    dst: "U",
    tz: "Pacific/Palau",
  },
  {
    id: "7614",
    name: "Asau Airport",
    city: "Savai\\\\'i",
    country: "Samoa",
    iata: "AAU",
    icao: "\\N",
    latitude: "-13.505",
    longitude: "-172.627778",
    altitude: "6",
    timezone: "13",
    dst: "U",
    tz: "Pacific/Apia",
  },
  {
    id: "7615",
    name: "Afutara Airport",
    city: "Afutara",
    country: "Solomon Islands",
    iata: "AFT",
    icao: "AGAF",
    latitude: "-9.183056",
    longitude: "160.949722",
    altitude: "5",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "7616",
    name: "Ulawa Airport",
    city: "Ulawa",
    country: "Solomon Islands",
    iata: "RNA",
    icao: "AGAR",
    latitude: "-9.854722",
    longitude: "161.979167",
    altitude: "5",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "7617",
    name: "Choiseul Bay Airport",
    city: "Choiseul Bay",
    country: "Solomon Islands",
    iata: "CHY",
    icao: "AGGC",
    latitude: "-6.711944",
    longitude: "156.396111",
    altitude: "5",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "7618",
    name: "Santa Ana Airport",
    city: "Santa Ana",
    country: "Solomon Islands",
    iata: "NNB",
    icao: "AGGT",
    latitude: "-10.848056",
    longitude: "162.454167",
    altitude: "6",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "7619",
    name: "Yandina Airport",
    city: "Yandina",
    country: "Solomon Islands",
    iata: "XYA",
    icao: "AGGY",
    latitude: "-9.086111",
    longitude: "159.218889",
    altitude: "6",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "7620",
    name: "Batuna Airport",
    city: "Batuna",
    country: "Solomon Islands",
    iata: "BPF",
    icao: "AGBT",
    latitude: "-8.63",
    longitude: "158",
    altitude: "5",
    timezone: "11",
    dst: "U",
    tz: "Pacific/Guadalcanal",
  },
  {
    id: "7621",
    name: "Bartow Municipal Airport",
    city: "Bartow",
    country: "United States",
    iata: "BOW",
    icao: "KBOW",
    latitude: "27.9434",
    longitude: "-81.7834",
    altitude: "125",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7622",
    name: "Sokerkino",
    city: "Kostroma",
    country: "Russia",
    iata: "KMW",
    icao: "UUBD",
    latitude: "57.7961",
    longitude: "41.0204",
    altitude: "446",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7623",
    name: "Yuryevets",
    city: "Yuryevets",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "57.316667",
    longitude: "43.1",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7624",
    name: "Ozerny",
    city: "Ozerny",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "52.752919",
    longitude: "111.849",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "7625",
    name: "Enkheluk",
    city: "Enkheluk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "52.500967",
    longitude: "107.018852",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "7626",
    name: "Khakusy",
    city: "Khakusy",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.365",
    longitude: "109.812",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "7627",
    name: "Fitiuta Airport",
    city: "Fiti\\\\'uta",
    country: "American Samoa",
    iata: "FTI",
    icao: "NSFQ",
    latitude: "-14.216111",
    longitude: "-169.423611",
    altitude: "110",
    timezone: "-11",
    dst: "U",
    tz: "Pacific/Pago_Pago",
  },
  {
    id: "7628",
    name: "Ofu Airport",
    city: "Ofu",
    country: "American Samoa",
    iata: "OFU",
    icao: "\\N",
    latitude: "-14.184444",
    longitude: "-169.67",
    altitude: "9",
    timezone: "-11",
    dst: "U",
    tz: "Pacific/Pago_Pago",
  },
  {
    id: "7629",
    name: "Livermore Municipal",
    city: "Livermore",
    country: "United States",
    iata: "LVK",
    icao: "KLVK",
    latitude: "37.41362",
    longitude: "-121.49133",
    altitude: "400",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7630",
    name: "MariposaYosemite",
    city: "Mariposa",
    country: "United States",
    iata: "MPI",
    icao: "KMPI",
    latitude: "37.3039",
    longitude: "-120.0222",
    altitude: "2454",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8419",
    name: "Jungseok",
    city: "Seogwipo",
    country: "South Korea",
    iata: "",
    icao: "RKPD",
    latitude: "33.399561",
    longitude: "126.711567",
    altitude: "1171",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "7633",
    name: "Grootfontein",
    city: "Grootfontein",
    country: "Namibia",
    iata: "GFY",
    icao: "FYGF",
    latitude: "-19.602167",
    longitude: "18.122667",
    altitude: "4636",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "7634",
    name: "Rundu",
    city: "Rundu",
    country: "Namibia",
    iata: "NDU",
    icao: "FYRU",
    latitude: "-17.956461",
    longitude: "19.719439",
    altitude: "3627",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "7635",
    name: "Beppu Airport",
    city: "Beppu",
    country: "Japan",
    iata: "BPU",
    icao: "\\N",
    latitude: "33.3",
    longitude: "131.5333",
    altitude: "197",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "7636",
    name: "Heron Island",
    city: "Heron Island",
    country: "Australia",
    iata: "HRN",
    icao: "\\N",
    latitude: "-23.441667",
    longitude: "151.911389",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "7637",
    name: "Lady Elliot Island",
    city: "Lady Elliot Island",
    country: "Australia",
    iata: "LYT",
    icao: "\\N",
    latitude: "-24.113333",
    longitude: "152.715278",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "7638",
    name: "Orpheus Island",
    city: "Orpheus Island",
    country: "Australia",
    iata: "ORS",
    icao: "\\N",
    latitude: "-18.634",
    longitude: "146.5",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "7639",
    name: "Paddington Station",
    city: "London",
    country: "United Kingdom",
    iata: "QQP",
    icao: "\\N",
    latitude: "51.515833",
    longitude: "-0.176111",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7640",
    name: "Liskeard Station",
    city: "Liskeard",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "50.44708",
    longitude: "-4.46753",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7641",
    name: "Port du Bloscon",
    city: "Roscoff",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "48.721816",
    longitude: "-3.96395",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7642",
    name: "Tasiilaq",
    city: "Angmagssalik",
    country: "Greenland",
    iata: "AGM",
    icao: "BGAM",
    latitude: "65.612222",
    longitude: "-37.618333",
    altitude: "24",
    timezone: "-3",
    dst: "U",
    tz: "America/Godthab",
  },
  {
    id: "7643",
    name: "Neets Bay",
    city: "Ketchikan",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "55.778889",
    longitude: "-131.601389",
    altitude: "0",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "7644",
    name: "Fraser Railroad Station",
    city: "Fraser BC",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "59.715517",
    longitude: "-135.046692",
    altitude: "2000",
    timezone: "-8",
    dst: "U",
    tz: "America/Vancouver",
  },
  {
    id: "7645",
    name: "Carcross",
    city: "Carcross YT",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "60.17463",
    longitude: "-134.698088",
    altitude: "2100",
    timezone: "-8",
    dst: "U",
    tz: "America/Vancouver",
  },
  {
    id: "7646",
    name: "Jacqueline Cochran Regional Airport",
    city: "Palm Springs",
    country: "United States",
    iata: "TRM",
    icao: "KTRM",
    latitude: "33.626666",
    longitude: "-116.1596667",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7647",
    name: "Santa Monica Municipal Airport",
    city: "Santa Monica",
    country: "United States",
    iata: "SMO",
    icao: "KSMO",
    latitude: "34.0158333",
    longitude: "-118.4513056",
    altitude: "177",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7648",
    name: "Bermuda Dunes Airport",
    city: "Palm Springs",
    country: "United States",
    iata: "UDD",
    icao: "KUDD",
    latitude: "33.7484375",
    longitude: "-116.2748133",
    altitude: "73",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7649",
    name: "Scottsdale Airport",
    city: "Scottsdale",
    country: "United States",
    iata: "ZSY",
    icao: "KSDL",
    latitude: "33.6228889",
    longitude: "-111.9105278",
    altitude: "1519",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "7650",
    name: "Olympia Regional Airpor",
    city: "Olympia",
    country: "United States",
    iata: "OLM",
    icao: "KOLM",
    latitude: "46.9694044",
    longitude: "-122.9025447",
    altitude: "209",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7651",
    name: "Yolo County Airport",
    city: "Davis-Woodland-Winters",
    country: "United States",
    iata: "DWA",
    icao: "KDWA",
    latitude: "38.5793889",
    longitude: "-121.8569444",
    altitude: "100",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7652",
    name: "Garfield County Regional Airport",
    city: "Rifle",
    country: "United States",
    iata: "RIL",
    icao: "KRIL",
    latitude: "39.5263056",
    longitude: "-107.7269444",
    altitude: "5548",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7653",
    name: "Shively Field Airport",
    city: "SARATOGA",
    country: "United States",
    iata: "SAA",
    icao: "KSAA",
    latitude: "41.4448594",
    longitude: "-106.8235264",
    altitude: "7012",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7654",
    name: "Dekalb-Peachtree Airport",
    city: "Atlanta",
    country: "United States",
    iata: "PDK",
    icao: "KPDK",
    latitude: "33.8756111",
    longitude: "-84.3019722",
    altitude: "1003",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7655",
    name: "Monroe County Airport",
    city: "Bloomington",
    country: "United States",
    iata: "BMG",
    icao: "KBMG",
    latitude: "39.1460208",
    longitude: "-86.6166805",
    altitude: "846",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7656",
    name: "Witham Field Airport",
    city: "Stuart",
    country: "United States",
    iata: "SUA",
    icao: "KSUA",
    latitude: "27.1816996",
    longitude: "-80.221294",
    altitude: "16",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7657",
    name: "Morristown Municipal Airport",
    city: "Morristown",
    country: "United States",
    iata: "MMU",
    icao: "KMMU",
    latitude: "40.79935",
    longitude: "-74.4148747",
    altitude: "187",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7658",
    name: "Napa County Airport",
    city: "Napa",
    country: "United States",
    iata: "APC",
    icao: "KAPC",
    latitude: "38.2131944",
    longitude: "-122.2806944",
    altitude: "35",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7659",
    name: "Brown Field Municipal Airport",
    city: "San Diego",
    country: "United States",
    iata: "SDM",
    icao: "KSDM",
    latitude: "32.5722722",
    longitude: "-116.9801611",
    altitude: "526",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7660",
    name: "Wangen-Lachen",
    city: "Wangen-Lachen",
    country: "Switzerland",
    iata: "",
    icao: "LSPV",
    latitude: "47.204805",
    longitude: "8.866834",
    altitude: "1335",
    timezone: "1",
    dst: "U",
    tz: "Europe/Zurich",
  },
  {
    id: "7661",
    name: "Pahokee Airport",
    city: "Pahokee",
    country: "United States",
    iata: "PHK",
    icao: "\\N",
    latitude: "26.789",
    longitude: "-80.692",
    altitude: "18",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7662",
    name: "Venice Municipal",
    city: "Venice",
    country: "United States",
    iata: "",
    icao: "KVNC",
    latitude: "27.42439",
    longitude: "-82.262364",
    altitude: "18",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7663",
    name: "Pahokee",
    city: "Pahokee",
    country: "United States",
    iata: "",
    icao: "KPHK",
    latitude: "26.471041",
    longitude: "-80.413591",
    altitude: "15",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7664",
    name: "Kineshma",
    city: "Kineshma",
    country: "Russia",
    iata: "KIE",
    icao: "\\N",
    latitude: "57.45000001",
    longitude: "42.15000001",
    altitude: "420",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7665",
    name: "Nezhitino",
    city: "Nezhitino",
    country: "Russia",
    iata: "NEZ",
    icao: "\\N",
    latitude: "57.479444454444",
    longitude: "43.29750001",
    altitude: "400",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7666",
    name: "Glasgow Buchanan Bus Station",
    city: "Glasgow",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "55.8652",
    longitude: "-4.25033",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7667",
    name: "London Victoria Bus Station",
    city: "London",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.494999",
    longitude: "-0.144643",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7668",
    name: "Machu Pichu Airport",
    city: "Machu Pichu",
    country: "Peru",
    iata: "MFT",
    icao: "\\N",
    latitude: "-13.1167",
    longitude: "-72.5667",
    altitude: "9500",
    timezone: "-5",
    dst: "S",
    tz: "America/Lima",
  },
  {
    id: "7669",
    name: "Panama City-NW Florida Bea.",
    city: "Panama City",
    country: "United States",
    iata: "ECP",
    icao: "KECP",
    latitude: "30.3417",
    longitude: "-85.7973",
    altitude: "69",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7670",
    name: "San Bernardino International Airport",
    city: "San Bernardino",
    country: "United States",
    iata: "SBD",
    icao: "KSBD",
    latitude: "34.0953521",
    longitude: "-117.2348722",
    altitude: "1159",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7671",
    name: "Valenca Airport",
    city: "Valenca",
    country: "Brazil",
    iata: "VAL",
    icao: "SNVB",
    latitude: "-13.2965",
    longitude: "-38.9924",
    altitude: "21",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7672",
    name: "Dix Sept Rosado Airport",
    city: "Mossoro",
    country: "Brazil",
    iata: "MVF",
    icao: "SBMW",
    latitude: "-5.20192",
    longitude: "-37.3643",
    altitude: "76",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7673",
    name: "Caruaru Airport",
    city: "Caruaru",
    country: "Brazil",
    iata: "CAU",
    icao: "SNRU",
    latitude: "-8.28239",
    longitude: "-36.0135",
    altitude: "1891",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "7674",
    name: "Wake Island Afld",
    city: "Wake island",
    country: "Wake Island",
    iata: "AWK",
    icao: "PWAK",
    latitude: "19.282067",
    longitude: "166.636444",
    altitude: "14",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Wake",
  },
  {
    id: "7675",
    name: "Aeroclube de Nova Iguacu",
    city: "Nova Iguacu",
    country: "Brazil",
    iata: "QNV",
    icao: "SDNY",
    latitude: "-22.7453",
    longitude: "-43.4603",
    altitude: "164",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "7676",
    name: "Gare du Nord",
    city: "Paris",
    country: "France",
    iata: "XPG",
    icao: "\\N",
    latitude: "48.880931",
    longitude: "2.355323",
    altitude: "423",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7677",
    name: "Gare Montparnasse",
    city: "Paris",
    country: "France",
    iata: "XGB",
    icao: "\\N",
    latitude: "48.84",
    longitude: "2.318611",
    altitude: "423",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7678",
    name: "Saint-Pierre-des-Corps",
    city: "Tours",
    country: "France",
    iata: "XSH",
    icao: "\\N",
    latitude: "47.385626",
    longitude: "0.723347",
    altitude: "159",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7679",
    name: "Darsena Norte",
    city: "Buenos Aires",
    country: "Argentina",
    iata: "",
    icao: "\\N",
    latitude: "-34.5978",
    longitude: "-58.367841",
    altitude: "46",
    timezone: "-3",
    dst: "N",
    tz: "America/Cordoba",
  },
  {
    id: "7680",
    name: "Casa Central",
    city: "Montevideo",
    country: "Uruguay",
    iata: "",
    icao: "\\N",
    latitude: "-34.90278",
    longitude: "-56.213781",
    altitude: "105",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "7681",
    name: "Puerto Franco",
    city: "Colonia del Sacramento",
    country: "Uruguay",
    iata: "",
    icao: "\\N",
    latitude: "-34.4741",
    longitude: "-57.843427",
    altitude: "89",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "7682",
    name: "Tres Cruces",
    city: "Montevideo",
    country: "Uruguay",
    iata: "",
    icao: "\\N",
    latitude: "-34.893891",
    longitude: "-56.166589",
    altitude: "141",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "7683",
    name: "San Carlos Airport",
    city: "San Carlos",
    country: "United States",
    iata: "SQL",
    icao: "KSQL",
    latitude: "37.511944",
    longitude: "-122.249444",
    altitude: "5",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7684",
    name: "Courtelary ",
    city: "Courtelary ",
    country: "Switzerland",
    iata: "",
    icao: "LSZJ",
    latitude: "47.18611",
    longitude: "7.15833",
    altitude: "2250",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7685",
    name: "Koszalin - Zegrze Pomorskie Airport",
    city: "Koszalin",
    country: "Poland",
    iata: "OSZ",
    icao: "EPKO",
    latitude: "54.041",
    longitude: "16.266",
    altitude: "111",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7686",
    name: "Ntswi Island",
    city: "Okavango Delta",
    country: "Botswana",
    iata: "",
    icao: "FBCO",
    latitude: "-19.531109",
    longitude: "23.09092",
    altitude: "3000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "7687",
    name: "Dujiangyan",
    city: "Dujiangyan",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "30.998584",
    longitude: "103.619673",
    altitude: "2385",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7688",
    name: "Maiwa",
    city: "Maiwa",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "33.058044",
    longitude: "102.908775",
    altitude: "11500",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7689",
    name: "Lelystad Airport",
    city: "Lelystad",
    country: "Netherlands",
    iata: "LEY",
    icao: "\\N",
    latitude: "52.4603",
    longitude: "5.52722",
    altitude: "12",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7690",
    name: "Rocky Mount Wilson Regional Airport",
    city: "Rocky Mount",
    country: "United States",
    iata: "RWI",
    icao: "KRWI",
    latitude: "35.8563",
    longitude: "-77.8919",
    altitude: "159",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7691",
    name: "Whittier Airport",
    city: "Whittier",
    country: "United States",
    iata: "",
    icao: "PAWR",
    latitude: "60.7772125",
    longitude: "-148.7215775",
    altitude: "30",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "7692",
    name: "Soldotna Airport",
    city: "Soldotna",
    country: "United States",
    iata: "SXQ",
    icao: "\\N",
    latitude: "60.4749583",
    longitude: "-151.0382389",
    altitude: "113",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "7693",
    name: "Gillespie",
    city: "El Cajon",
    country: "United States",
    iata: "SEE",
    icao: "KSEE",
    latitude: "32.8262222",
    longitude: "-116.9724444",
    altitude: "388",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7694",
    name: "San Clemente Island Nalf",
    city: "San Clemente Island",
    country: "United States",
    iata: "",
    icao: "KNUC",
    latitude: "33.022744",
    longitude: "-118.588489",
    altitude: "184",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7695",
    name: "Cotopaxi International Airport",
    city: "Latacunga",
    country: "Ecuador",
    iata: "LTX",
    icao: "\\N",
    latitude: "-0.5425",
    longitude: "-78.3657",
    altitude: "9205",
    timezone: "-5",
    dst: "S",
    tz: "America/Guayaquil",
  },
  {
    id: "7696",
    name: "London St Pancras",
    city: "London",
    country: "United Kingdom",
    iata: "STP",
    icao: "\\N",
    latitude: "51.53",
    longitude: "-0.125",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7697",
    name: "Amsterdam Centraal",
    city: "Amsterdam",
    country: "Netherlands",
    iata: "ZYA",
    icao: "\\N",
    latitude: "52.378333",
    longitude: "4.9",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7698",
    name: "Mammy Yoko Heliport",
    city: "Freetown",
    country: "Sierra Leone",
    iata: "JMY",
    icao: "\\N",
    latitude: "8.490278",
    longitude: "-13.289722",
    altitude: "0",
    timezone: "0",
    dst: "N",
    tz: "Africa/Freetown",
  },
  {
    id: "7699",
    name: "Shearwater Heliport",
    city: "Victoria Falls",
    country: "Zimbabwe",
    iata: "",
    icao: "\\N",
    latitude: "-17.911443",
    longitude: "25.828167",
    altitude: "3937",
    timezone: "2",
    dst: "U",
    tz: "Africa/Harare",
  },
  {
    id: "7700",
    name: "Phan Rang Airport",
    city: "Phan Rang",
    country: "Vietnam",
    iata: "PHA",
    icao: "VVPR",
    latitude: "11.6335",
    longitude: "108.952",
    altitude: "101",
    timezone: "7",
    dst: "N",
    tz: "Asia/Saigon",
  },
  {
    id: "7701",
    name: "Na-San Airport",
    city: "Son-La",
    country: "Vietnam",
    iata: "SQH",
    icao: "VVNS",
    latitude: "21.217",
    longitude: "104.033",
    altitude: "2133",
    timezone: "7",
    dst: "N",
    tz: "Asia/Saigon",
  },
  {
    id: "7702",
    name: "Truckee-Tahoe Airport",
    city: "Truckee",
    country: "United States",
    iata: "TKF",
    icao: "KTRK",
    latitude: "39.3200422",
    longitude: "-120.1395628",
    altitude: "5900",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7703",
    name: "Frejus Saint Raphael",
    city: "Frejus",
    country: "France",
    iata: "FRJ",
    icao: "LFTU",
    latitude: "43.416667",
    longitude: "6.733333",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7704",
    name: "Geelong Airport",
    city: "Geelong",
    country: "Australia",
    iata: "GEX",
    icao: "YGLG",
    latitude: "-38.225",
    longitude: "144.333",
    altitude: "43",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "7705",
    name: "Detroit Amtrak Station",
    city: "Detroit",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.368097",
    longitude: "-83.072397",
    altitude: "630",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7706",
    name: "Ventura Amtrak",
    city: "Ventura",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "34.27833",
    longitude: "-119.29222",
    altitude: "59",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7707",
    name: "Berlin Hauptbahnhof",
    city: "Berlin",
    country: "Germany",
    iata: "QPP",
    icao: "\\N",
    latitude: "52.52493",
    longitude: "13.36963",
    altitude: "110",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7708",
    name: "Amsterdam Centraal",
    city: "Amsterdam",
    country: "Netherlands",
    iata: "ZYA",
    icao: "\\N",
    latitude: "52.7873",
    longitude: "4.90074",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8169",
    name: "Moultrie Municipal Airport",
    city: "Moultrie",
    country: "United States",
    iata: "MGR",
    icao: "\\N",
    latitude: "31.0849167",
    longitude: "-83.80325",
    altitude: "294",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7710",
    name: "Mezen",
    city: "Mezen",
    country: "Russia",
    iata: "",
    icao: "ULAE",
    latitude: "65.878333",
    longitude: "44.215",
    altitude: "46",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7711",
    name: "Vaskovo",
    city: "Arkhangelsk",
    country: "Russia",
    iata: "",
    icao: "ULAH",
    latitude: "64.441667",
    longitude: "40.421667",
    altitude: "8",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7712",
    name: "Cobb County Airport-Mc Collum Field",
    city: "Atlanta",
    country: "United States",
    iata: "RYY",
    icao: "KRYY",
    latitude: "34.0131569",
    longitude: "-84.5970556",
    altitude: "1041",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7713",
    name: "Oneonta Municipal Airport",
    city: "Oneonta",
    country: "United States",
    iata: "ONH",
    icao: "\\N",
    latitude: "42.524722",
    longitude: "-75.064444",
    altitude: "1763",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7714",
    name: "Tulln ",
    city: "Tulln",
    country: "Austria",
    iata: "",
    icao: "LOXT",
    latitude: "48.318961",
    longitude: "16.114275",
    altitude: "575",
    timezone: "1",
    dst: "U",
    tz: "Europe/Vienna",
  },
  {
    id: "7715",
    name: "Wideawake Field",
    city: "Georgetown Acension Island Santa Helena",
    country: "United Kingdom",
    iata: "ASI",
    icao: "\\N",
    latitude: "-7.969597",
    longitude: "-14.393664",
    altitude: "278",
    timezone: "0",
    dst: "U",
    tz: "Atlantic/St_Helena",
  },
  {
    id: "7716",
    name: "Dell Flight Strip",
    city: "Dell",
    country: "United States",
    iata: "4U9",
    icao: "K4U9",
    latitude: "44.7357483",
    longitude: "-112.7200133",
    altitude: "6007",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7717",
    name: "Mission Field Airport",
    city: "Livingston-Montana",
    country: "United States",
    iata: "LVM",
    icao: "KLVM",
    latitude: "45.6993889",
    longitude: "-110.4483056",
    altitude: "4660",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7718",
    name: "Kota Kinabalu Airport",
    city: "Kota Kinabalu",
    country: "Malaysia",
    iata: "ZWR",
    icao: "\\N",
    latitude: "11.1111",
    longitude: "11.1111",
    altitude: "1",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "7719",
    name: "Valetta Waterfront",
    city: "Valetta",
    country: "Malta",
    iata: "",
    icao: "\\N",
    latitude: "35.889867",
    longitude: "14.508584",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "7720",
    name: "Big Timber Airport",
    city: "Big Timber",
    country: "United States",
    iata: "6S0",
    icao: "K6S0",
    latitude: "45.8063889",
    longitude: "-109.9811111",
    altitude: "4492",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7721",
    name: "Tulip City Airport",
    city: "Holland",
    country: "United States",
    iata: "BIV",
    icao: "KBIV",
    latitude: "42.7427778",
    longitude: "-86.1078333",
    altitude: "698",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7722",
    name: "London Heliport",
    city: "London",
    country: "United Kingdom",
    iata: "",
    icao: "EGLW",
    latitude: "51.47",
    longitude: "-0.177833",
    altitude: "18",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7723",
    name: "San Nicolo Airport",
    city: "Venice",
    country: "Italy",
    iata: "",
    icao: "LIPV",
    latitude: "45.4283",
    longitude: "12.3881",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "7724",
    name: "Tallinn Linnahall Heliport",
    city: "Tallinn",
    country: "Estonia",
    iata: "",
    icao: "EECL",
    latitude: "59.4486",
    longitude: "24.7532",
    altitude: "23",
    timezone: "2",
    dst: "E",
    tz: "Europe/Tallinn",
  },
  {
    id: "7725",
    name: "Hernesaari Heliport",
    city: "Helsinki",
    country: "Finland",
    iata: "HEN",
    icao: "EFHE",
    latitude: "60.1478",
    longitude: "24.9244",
    altitude: "7",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "7726",
    name: "Linkenheim Airport",
    city: "Linkenheim",
    country: "Germany",
    iata: "",
    icao: "EDRI",
    latitude: "49.1417",
    longitude: "8.39472",
    altitude: "325",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7727",
    name: "Monument Valley Airport",
    city: "Monument Valley",
    country: "United States",
    iata: "",
    icao: "UT25",
    latitude: "37.0167",
    longitude: "-110.201",
    altitude: "5192",
    timezone: "-7",
    dst: "U",
    tz: "America/Denver",
  },
  {
    id: "7728",
    name: "Hilversum Airport",
    city: "Hilversum",
    country: "Netherlands",
    iata: "",
    icao: "EHHV",
    latitude: "52.1919",
    longitude: "5.14694",
    altitude: "3",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7729",
    name: "West 30th St. Heliport",
    city: "New York",
    country: "United States",
    iata: "JRA",
    icao: "KJRA",
    latitude: "40.7545",
    longitude: "-74.0071",
    altitude: "7",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7730",
    name: "Texel Airport",
    city: "Texel",
    country: "Netherlands",
    iata: "",
    icao: "EHTX",
    latitude: "53.1153",
    longitude: "4.83361",
    altitude: "2",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7731",
    name: "La Cerdanya",
    city: "Das i Fontanals de Cerdanya",
    country: "Spain",
    iata: "",
    icao: "LECD",
    latitude: "42.3864",
    longitude: "1.8667",
    altitude: "3586",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7732",
    name: "Lakeland Linder Regional Airport",
    city: "Lakeland",
    country: "United States",
    iata: "LAL",
    icao: "KLAL",
    latitude: "27.9889167",
    longitude: "-82.0185556",
    altitude: "142",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7733",
    name: "Valetta Grand Harbour",
    city: "Valetta",
    country: "Malta",
    iata: "",
    icao: "\\N",
    latitude: "14.507392",
    longitude: "35.888695",
    altitude: "0",
    timezone: "3",
    dst: "E",
    tz: "Africa/Khartoum",
  },
  {
    id: "7734",
    name: "Mgarr Seaplane Base",
    city: "Mgarr",
    country: "Malta",
    iata: "",
    icao: "\\N",
    latitude: "36.0245",
    longitude: "14.298359",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "7735",
    name: "Bangkok",
    city: "Bangkok",
    country: "Thailand",
    iata: "",
    icao: "\\N",
    latitude: "13.9126",
    longitude: "100.607",
    altitude: "9",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "7737",
    name: "Jebel Ali Seaplane Base",
    city: "Jebel Ali Golf Resort",
    country: "United Arab Emirates",
    iata: "",
    icao: "\\N",
    latitude: "24.988951",
    longitude: "55.023624",
    altitude: "0",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "7736",
    name: "Soneva Fushi",
    city: "Baa Atoll",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.113033",
    longitude: "73.080288",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "7738",
    name: "Stary Oskol",
    city: "Stary Oskol",
    country: "Russia",
    iata: "",
    icao: "UUOS",
    latitude: "51.33",
    longitude: "37.76833",
    altitude: "791",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7739",
    name: "Savona Cruise Terminal",
    city: "Savona",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "44.309654",
    longitude: "8.486305",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "7740",
    name: "Barcelona Cruise Terminal",
    city: "Barcelona",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "41.358901",
    longitude: "2.178447",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7741",
    name: "Casablanca Harbor",
    city: "Casablanca",
    country: "Morocco",
    iata: "",
    icao: "\\N",
    latitude: "33.604737",
    longitude: "-7.611337",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Africa/Casablanca",
  },
  {
    id: "7742",
    name: "Lanzarote Arrecife Cruise Terminal",
    city: "Arrecife Lanzarote",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "28.967298",
    longitude: "-13.527528",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "7743",
    name: "Tenerife Cruise Terminal",
    city: "Santa Cruz de Tenerife",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "28.470068",
    longitude: "-16.242471",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Canary",
  },
  {
    id: "7744",
    name: "Funchal Cruise Terminal",
    city: "Funchal Madeira",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "32.641868",
    longitude: "-16.911478",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "7745",
    name: "Malaga Cruise Terminal",
    city: "Malaga",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.702989",
    longitude: "-4.41395",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7746",
    name: "Ponta Delgada Cruise Terminal",
    city: "Ponta Delgada Acores",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "37.738409",
    longitude: "-25.662539",
    altitude: "0",
    timezone: "-1",
    dst: "U",
    tz: "Atlantic/Azores",
  },
  {
    id: "7747",
    name: "Vigo Cruise Terminal",
    city: "Vigo",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "42.241537",
    longitude: "-8.728799",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7748",
    name: "Fort Lauderdale Cruise Terminal",
    city: "Fort Lauderdale",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "26.0882",
    longitude: "-80.115373",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7749",
    name: "Southampton Cruise Terminal",
    city: "Southampton",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "50.900976",
    longitude: "-1.413975",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7750",
    name: "Miami Cruise Terminal",
    city: "Miami",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "25.779701",
    longitude: "-80.177279",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7751",
    name: "Nassau Cruise Terminal",
    city: "Nassau",
    country: "Bahamas",
    iata: "",
    icao: "\\N",
    latitude: "25.081158",
    longitude: "-77.341207",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Nassau",
  },
  {
    id: "7752",
    name: "Lisbon Cruise Terminal",
    city: "Lisbon",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "38.712606",
    longitude: "-9.122483",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "7753",
    name: "Cadiz Cruise Terminal",
    city: "Cadiz",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.534821",
    longitude: "-6.290649",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7754",
    name: "Marseille Cruise Terminal",
    city: "Marseille",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "43.343969",
    longitude: "5.333025",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7755",
    name: "Los Angeles San Pedro Cruise Terminal",
    city: "Los Angeles",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "33.747198",
    longitude: "-118.276856",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7756",
    name: "Kailua Kona Harbor",
    city: "Kailua Kona Hawaii",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "19.635393",
    longitude: "-155.998328",
    altitude: "0",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "7757",
    name: "Kauai Cruise Terminal Nawiliwili",
    city: "Nawiliwili Kauai Hawaii",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "21.954549",
    longitude: "-159.355981",
    altitude: "0",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "7758",
    name: "Hilo Cruise Terminal Hawaii",
    city: "Hilo Hawaii",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "19.730967",
    longitude: "-155.054094",
    altitude: "0",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "7759",
    name: "Honolulu Cruise Terminal Oahu",
    city: "Honolulu Oahu",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "21.301185",
    longitude: "-157.865671",
    altitude: "0",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "7760",
    name: "Lahaina Harbor Maui Hawaii",
    city: "Lahaina Maui Hawaii",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "20.876456",
    longitude: "-156.683235",
    altitude: "0",
    timezone: "-10",
    dst: "A",
    tz: "Pacific/Honolulu",
  },
  {
    id: "7761",
    name: "Ensenada Cruise Terminal",
    city: "Ensenada",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "31.855945",
    longitude: "-116.624186",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Tijuana",
  },
  {
    id: "7762",
    name: "Nanaimo Train Station",
    city: "Nanaimo Station British Columbia",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "49.163978",
    longitude: "-123.942502",
    altitude: "92",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7763",
    name: "Victoria Rail Station British Columbia",
    city: "Victoria Station British Columbia",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "48.428339",
    longitude: "-123.370618",
    altitude: "75",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7764",
    name: "Vancouver Cruise Terminal",
    city: "Vancouver BC",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "49.289012",
    longitude: "-123.111463",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7765",
    name: "Seattle Cruise Terminal",
    city: "Seattle WA",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.611241",
    longitude: "-122.350026",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7766",
    name: "Syangboche",
    city: "Syangboche",
    country: "Nepal",
    iata: "SYH",
    icao: "VNSB",
    latitude: "27.811187",
    longitude: "86.712661",
    altitude: "12309",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "7767",
    name: "Idlewild Intl",
    city: "New York",
    country: "United States",
    iata: "IDL",
    icao: "KIDL",
    latitude: "40.639751",
    longitude: "-73.778924",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7768",
    name: "Cheremshanka",
    city: "Krasnoyarsk",
    country: "Russia",
    iata: "",
    icao: "UNKM",
    latitude: "56.179",
    longitude: "92.54265",
    altitude: "1000",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "7769",
    name: "French Valley Airport",
    city: "Murrieta-Temecula",
    country: "United States",
    iata: "RBK",
    icao: "KF70",
    latitude: "33.5741791",
    longitude: "-117.1284732",
    altitude: "1350",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7770",
    name: "Anchorage Main Station",
    city: "Anchorage Alaska",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "61.221749",
    longitude: "-149.890852",
    altitude: "102",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7771",
    name: "Seward Train Station",
    city: "Seward Alaska",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "60.121586",
    longitude: "-149.439983",
    altitude: "22",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "7772",
    name: "Fenosu",
    city: "Oristano",
    country: "Italy",
    iata: "FNU",
    icao: "LIER",
    latitude: "39.895",
    longitude: "8.6383",
    altitude: "36",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "7773",
    name: "White Waltham Airfield",
    city: "Maidenhead",
    country: "United Kingdom",
    iata: "",
    icao: "EGLM",
    latitude: "51.501",
    longitude: "-0.774",
    altitude: "133",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7774",
    name: "Mysore Airport",
    city: "Mysore",
    country: "India",
    iata: "MYQ",
    icao: "VOMY",
    latitude: "12.3072",
    longitude: "76.6497",
    altitude: "2349",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Calcutta",
  },
  {
    id: "7775",
    name: "Erie-Ottawa Regional Airport",
    city: "Port Clinton",
    country: "United States",
    iata: "PCW",
    icao: "KPCW",
    latitude: "41.5162703",
    longitude: "-82.8694868",
    altitude: "590",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7776",
    name: "Dayton-Wright Brothers Airport",
    city: "Dayton",
    country: "United States",
    iata: "MGY",
    icao: "KMGY",
    latitude: "39.5889722",
    longitude: "-84.2248611",
    altitude: "957",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7777",
    name: "Richmond Municipal Airport",
    city: "Richmond",
    country: "United States",
    iata: "RID",
    icao: "KRID",
    latitude: "39.7561006",
    longitude: "-84.8427175",
    altitude: "1140",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7778",
    name: "Findlay Airport",
    city: "Findley",
    country: "United States",
    iata: "FDY",
    icao: "KFDY",
    latitude: "41.0120278",
    longitude: "-83.6686111",
    altitude: "819",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7779",
    name: "Niagara Falls Station",
    city: "Niagara Falls",
    country: "Canada",
    iata: "",
    icao: "NIAG",
    latitude: "43.108802",
    longitude: "-79.06361",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7860",
    name: "Deputatsky",
    city: "Deputatsky",
    country: "Russia",
    iata: "",
    icao: "UEVD",
    latitude: "69.293",
    longitude: "139.5357",
    altitude: "951",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "7780",
    name: "Burlington Airpark",
    city: "Burlington",
    country: "Canada",
    iata: "",
    icao: "CZBA",
    latitude: "43.4425",
    longitude: "-79.850833",
    altitude: "602",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7781",
    name: "Baganara Island",
    city: "Baganara",
    country: "Guyana",
    iata: "",
    icao: "\\N",
    latitude: "6.343791",
    longitude: "-58.591204",
    altitude: "38",
    timezone: "-4",
    dst: "N",
    tz: "America/Guyana",
  },
  {
    id: "7782",
    name: "Penneshaw Airport",
    city: "Penneshaw",
    country: "Australia",
    iata: "PEA",
    icao: "YPSH",
    latitude: "-34.75",
    longitude: "137.933",
    altitude: "0",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "7783",
    name: "Matamanoa Helipad",
    city: "Matamanoa",
    country: "Fiji",
    iata: "",
    icao: "\\N",
    latitude: "-17.638056",
    longitude: "177.066944",
    altitude: "10",
    timezone: "12",
    dst: "U",
    tz: "Pacific/Fiji",
  },
  {
    id: "7784",
    name: "Kaufbeuren BF",
    city: "Kaufbeuren",
    country: "Germany",
    iata: "KFX",
    icao: "KAUF",
    latitude: "47.885",
    longitude: "10.6294",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7785",
    name: "Munich HBF",
    city: "Munich",
    country: "Germany",
    iata: "MUQ",
    icao: "MUNI",
    latitude: "48.1408",
    longitude: "11.555",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7786",
    name: "Nurnberg HBF",
    city: "Nurnberg",
    country: "Germany",
    iata: "NUR",
    icao: "NURN",
    latitude: "49.446",
    longitude: "11.081944",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7787",
    name: "Ebenhofen BF",
    city: "Ebenhofen",
    country: "Germany",
    iata: "EBE",
    icao: "EBEN",
    latitude: "47.824",
    longitude: "10.623",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7788",
    name: "Augsburg HBF",
    city: "Augsburg",
    country: "Germany",
    iata: "AUB",
    icao: "AUGS",
    latitude: "48.3655",
    longitude: "10.886",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7789",
    name: "Biessenhofen BF",
    city: "Biessenhofen",
    country: "Germany",
    iata: "BIE",
    icao: "BIES",
    latitude: "47.851",
    longitude: "10.634",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7790",
    name: "Buchloe BF",
    city: "Buchloe",
    country: "Germany",
    iata: "BUH",
    icao: "BUCH",
    latitude: "48.0411",
    longitude: "10.715",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7791",
    name: "Fussen BF",
    city: "Fussen",
    country: "Germany",
    iata: "FUX",
    icao: "FUSN",
    latitude: "47.585",
    longitude: "10.6866",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7792",
    name: "Kempten HBF",
    city: "Kempten",
    country: "Germany",
    iata: "KEX",
    icao: "KEMP",
    latitude: "47.724",
    longitude: "10.311",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7793",
    name: "Aiome",
    city: "Aiome",
    country: "Papua New Guinea",
    iata: "AIE",
    icao: "\\N",
    latitude: "-5.8",
    longitude: "144.44",
    altitude: "350",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "7794",
    name: "Simbai",
    city: "Simbai",
    country: "Papua New Guinea",
    iata: "SIM",
    icao: "\\N",
    latitude: "-4",
    longitude: "144",
    altitude: "5450",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "7795",
    name: "Ambunti",
    city: "Ambunti",
    country: "Papua New Guinea",
    iata: "AUJ",
    icao: "\\N",
    latitude: "-4.15",
    longitude: "142.51",
    altitude: "160",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "7796",
    name: "Gunns Camp",
    city: "Okavango",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.52666",
    longitude: "23.14944",
    altitude: "0",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "7797",
    name: "Sossusvlei",
    city: "Sossusvlei",
    country: "Namibia",
    iata: "",
    icao: "\\N",
    latitude: "-24.489444",
    longitude: "15.815278",
    altitude: "0",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "7798",
    name: "Marktoberdorf BF",
    city: "Marktoberdorf",
    country: "Germany",
    iata: "OAL",
    icao: "MARK",
    latitude: "47.78",
    longitude: "10.627",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7799",
    name: "Marktoberdorf Schule",
    city: "Marktoberdorf",
    country: "Germany",
    iata: "MOS",
    icao: "MARO",
    latitude: "47.777",
    longitude: "10.623",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7800",
    name: "Essen HBF",
    city: "Essen",
    country: "Germany",
    iata: "ESX",
    icao: "ESSE",
    latitude: "51.451389",
    longitude: "7.0138",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7801",
    name: "Bochum HBF",
    city: "Bochum",
    country: "Germany",
    iata: "BOX",
    icao: "BOCH",
    latitude: "51.478506",
    longitude: "7.2222",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7802",
    name: "Koln HBF",
    city: "Koln",
    country: "Germany",
    iata: "KOX",
    icao: "KOLN",
    latitude: "50.9425",
    longitude: "6.958056",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7803",
    name: "Mannheim HBF",
    city: "Mannheim",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.471",
    longitude: "8.469858",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7804",
    name: "Booker",
    city: "Wycombe",
    country: "United Kingdom",
    iata: "",
    icao: "EGTB",
    latitude: "51.611667",
    longitude: "-0.808056",
    altitude: "520",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7805",
    name: "Bembridge",
    city: "Bembridge",
    country: "United Kingdom",
    iata: "BBP",
    icao: "EGHJ",
    latitude: "50.677778",
    longitude: "-1.109444",
    altitude: "53",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "7806",
    name: "Kings County Municipal Airport",
    city: "Waterville",
    country: "Canada",
    iata: "",
    icao: "CCW3",
    latitude: "45.0519",
    longitude: "-64.6517",
    altitude: "119",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "7807",
    name: "Chojna Air Base",
    city: "Chojna",
    country: "Poland",
    iata: "",
    icao: "\\N",
    latitude: "52.9394",
    longitude: "14.4217",
    altitude: "187",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7808",
    name: "Leuterschach BF",
    city: "Leuterschach",
    country: "Germany",
    iata: "LES",
    icao: "LEUT",
    latitude: "47.75",
    longitude: "10.601",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7809",
    name: "Black Hills Airport-Clyde Ice Field",
    city: "Spearfish-South Dakota",
    country: "United States",
    iata: "SPF",
    icao: "KSPF",
    latitude: "44.4811407",
    longitude: "-103.7860053",
    altitude: "3931",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7810",
    name: "Knokke-Heist Westkapelle Heliport",
    city: "Knokke",
    country: "Belgium",
    iata: "KNO",
    icao: "EBKW",
    latitude: "51.3222",
    longitude: "3.29306",
    altitude: "0",
    timezone: "1",
    dst: "U",
    tz: "Europe/Brussels",
  },
  {
    id: "7811",
    name: "Redcliffe",
    city: "Rothwell",
    country: "Australia",
    iata: "",
    icao: "YRED",
    latitude: "-27.206944",
    longitude: "153.072778",
    altitude: "75",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "7812",
    name: "Gdynia",
    city: "Gdynia",
    country: "Poland",
    iata: "QYD",
    icao: "EPOK",
    latitude: "54.5797",
    longitude: "18.5172",
    altitude: "144",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7813",
    name: "Malbork",
    city: "Malbork",
    country: "Poland",
    iata: "",
    icao: "EPMB",
    latitude: "54.026944",
    longitude: "19.134167",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7814",
    name: "Lask",
    city: "Lask",
    country: "Poland",
    iata: "",
    icao: "EPLK",
    latitude: "51.551667",
    longitude: "19.179058",
    altitude: "633",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7815",
    name: "Miroslawiec",
    city: "Miroslawiec",
    country: "Poland",
    iata: "",
    icao: "EPMI",
    latitude: "53.395072",
    longitude: "16.082814",
    altitude: "459",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7816",
    name: "Krzesiny",
    city: "Poznan",
    country: "Poland",
    iata: "",
    icao: "EPKS",
    latitude: "52.331719",
    longitude: "16.966428",
    altitude: "265",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "7817",
    name: "Olive Branch Muni",
    city: "Olive Branch",
    country: "United States",
    iata: "OLV",
    icao: "KOLV",
    latitude: "34.876944",
    longitude: "-89.783333",
    altitude: "350",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7818",
    name: "Vina Del Mar",
    city: "Vina del Mar",
    country: "Chile",
    iata: "",
    icao: "SCVM",
    latitude: "-32.949611",
    longitude: "-71.478583",
    altitude: "461",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "7819",
    name: "Bangkok Intl closed",
    city: "Bangkok",
    country: "Thailand",
    iata: "",
    icao: "BKKX",
    latitude: "13.91111",
    longitude: "100.60611",
    altitude: "5",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "7820",
    name: "Brampton Airport",
    city: "Brampton",
    country: "Canada",
    iata: "",
    icao: "CNC3",
    latitude: "43.7603",
    longitude: "-79.875",
    altitude: "935",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7821",
    name: "Zonguldak",
    city: "Zonguldak",
    country: "Turkey",
    iata: "ONQ",
    icao: "LTAS",
    latitude: "41.506111",
    longitude: "32.088611",
    altitude: "44",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "7822",
    name: "Rocky Mountain Metropolitan Airport",
    city: "Broomfield-CO",
    country: "United States",
    iata: "BJC",
    icao: "KBJC",
    latitude: "39.90888888",
    longitude: "-105.11722222",
    altitude: "5670",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7823",
    name: "Minot Train Station",
    city: "Minot",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "48.2361",
    longitude: "-101.2987",
    altitude: "0",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7824",
    name: "Havre Train Station",
    city: "Havre",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "48.55457",
    longitude: "-109.67836",
    altitude: "0",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7825",
    name: "Wishram Train Station",
    city: "Wishram",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "45.6576",
    longitude: "-120.9664",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7826",
    name: "McNary Field",
    city: "Salem",
    country: "United States",
    iata: "SLE",
    icao: "KSLE",
    latitude: "44.9095",
    longitude: "-123.003",
    altitude: "214",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7827",
    name: "Tunica Municipal Airport",
    city: "Tunica",
    country: "United States",
    iata: "UTM",
    icao: "KUTA",
    latitude: "34.681",
    longitude: "-90.3467",
    altitude: "194",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7828",
    name: "Batken Airport",
    city: "Batken",
    country: "Kyrgyzstan",
    iata: "",
    icao: "UA30",
    latitude: "40.0427",
    longitude: "70.8381",
    altitude: "3474",
    timezone: "6",
    dst: "E",
    tz: "Asia/Bishkek",
  },
  {
    id: "7829",
    name: "Sun Island",
    city: "Sun Island",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "4.2868",
    longitude: "73.554894",
    altitude: "1",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "7830",
    name: "Kasaba Bay Airport",
    city: "Kasaba Bay",
    country: "Zambia",
    iata: "ZKB",
    icao: "FLKY",
    latitude: "-8.525",
    longitude: "30.663",
    altitude: "2780",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "7831",
    name: "Lindau HBF",
    city: "Lindau",
    country: "Germany",
    iata: "LND",
    icao: "LIND",
    latitude: "47.5489",
    longitude: "9.688",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7832",
    name: "Guardiamarina Zanartu Airport",
    city: "Puerto Williams",
    country: "Chile",
    iata: "WPU",
    icao: "\\N",
    latitude: "-54.9311",
    longitude: "-67.6263",
    altitude: "88",
    timezone: "-4",
    dst: "U",
    tz: "America/Santiago",
  },
  {
    id: "7833",
    name: "Volkel AB",
    city: "Volkel",
    country: "Netherlands",
    iata: "UDE",
    icao: "\\N",
    latitude: "51.656389",
    longitude: "5.708611",
    altitude: "72",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7834",
    name: "Hoogeveen Airport",
    city: "Hoogeveen",
    country: "Netherlands",
    iata: "",
    icao: "EHHO",
    latitude: "52.7308",
    longitude: "6.51611",
    altitude: "40",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7835",
    name: "Teuge Airport",
    city: "Deventer",
    country: "Netherlands",
    iata: "",
    icao: "EHTE",
    latitude: "52.2447",
    longitude: "6.04667",
    altitude: "17",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7836",
    name: "Midden-Zeeland Airport",
    city: "Middelburg",
    country: "Netherlands",
    iata: "",
    icao: "EHMZ",
    latitude: "51.5122",
    longitude: "3.73111",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7837",
    name: "Ameland Airport",
    city: "Ameland",
    country: "Netherlands",
    iata: "",
    icao: "EHAL",
    latitude: "53.4517",
    longitude: "5.67722",
    altitude: "11",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7838",
    name: "Saint-Cyr-l-Ecole Airport",
    city: "Saint-Cyr",
    country: "France",
    iata: "",
    icao: "LFPZ",
    latitude: "48.810278",
    longitude: "2.073332",
    altitude: "373",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7839",
    name: "Lawrence J Timmerman Airport",
    city: "Milwaukee",
    country: "United States",
    iata: "MWC",
    icao: "KMWC",
    latitude: "43.1103889",
    longitude: "-88.0344167",
    altitude: "745",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7840",
    name: "Southern Wisconsin Regional Airport",
    city: "Janesville",
    country: "United States",
    iata: "JVL",
    icao: "KJVL",
    latitude: "42.62025",
    longitude: "-89.0415556",
    altitude: "808",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7841",
    name: "Mantsonyane Airport",
    city: "Mantsonyane",
    country: "Lesotho",
    iata: "",
    icao: "FXMN",
    latitude: "-29.5461",
    longitude: "28.271",
    altitude: "7100",
    timezone: "2",
    dst: "U",
    tz: "Africa/Maseru",
  },
  {
    id: "7842",
    name: "Hatfield",
    city: "Hatfield",
    country: "United Kingdom",
    iata: "HTF",
    icao: "\\N",
    latitude: "51.765",
    longitude: "-0.24833",
    altitude: "254",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "7843",
    name: "Burswood Park Helipad",
    city: "Perth",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-31.952",
    longitude: "115.859",
    altitude: "25",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "7844",
    name: "Toronto Coach Terminal",
    city: "Toronto",
    country: "Canada",
    iata: "",
    icao: "TRTO",
    latitude: "43.655996",
    longitude: "-79.38416",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7845",
    name: "Montreal Central Bus Station",
    city: "Montreal",
    country: "Canada",
    iata: "",
    icao: "MTRL",
    latitude: "45.51527887",
    longitude: "-73.561427593",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7846",
    name: "Arlington Municipal",
    city: "Arlington",
    country: "United States",
    iata: "GKY",
    icao: "KGKY",
    latitude: "32.6638611",
    longitude: "-97.0942778",
    altitude: "628",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7847",
    name: "Gwinnett County Airport-Briscoe Field",
    city: "Lawrenceville",
    country: "United States",
    iata: "LZU",
    icao: "KLZU",
    latitude: "33.9780761",
    longitude: "-83.9623772",
    altitude: "1061",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7848",
    name: "Bowling Green-Warren County Regional Airport",
    city: "Bowling Green",
    country: "United States",
    iata: "BWG",
    icao: "KBWG",
    latitude: "36.9645278",
    longitude: "-86.4196667",
    altitude: "547",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7849",
    name: "Richard Lloyd Jones Jr Airport",
    city: "Tulsa",
    country: "United States",
    iata: "RVS",
    icao: "KRVS",
    latitude: "36.0396111",
    longitude: "-95.9846389",
    altitude: "638",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7850",
    name: "Emeryville Amtrak Station",
    city: "Emeryville",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.8405149",
    longitude: "-122.29134",
    altitude: "23",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7851",
    name: "Bakersfield Amtrak Station",
    city: "Bakersfield",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "35.372159",
    longitude: "-119.008393",
    altitude: "408",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7852",
    name: "Krymsk",
    city: "Novorossiysk",
    country: "Russia",
    iata: "NOI",
    icao: "\\N",
    latitude: "44.4016",
    longitude: "37.7779",
    altitude: "50",
    timezone: "4",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7853",
    name: "Minhad HB",
    city: "Minhad AB",
    country: "United Arab Emirates",
    iata: "NHD",
    icao: "OMDM",
    latitude: "25.02694",
    longitude: "55.36611",
    altitude: "165",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "7854",
    name: "Kirovograd",
    city: "Kirovograd",
    country: "Ukraine",
    iata: "KGO",
    icao: "UKKG",
    latitude: "48.54",
    longitude: "32.29",
    altitude: "510",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "7855",
    name: "Roitzschjora Airport",
    city: "Roitzschjora",
    country: "Germany",
    iata: "",
    icao: "EDAW",
    latitude: "51.5778",
    longitude: "12.4944",
    altitude: "289",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7856",
    name: "Alalamain Intl.",
    city: "Dabaa City",
    country: "Egypt",
    iata: "DBB",
    icao: "HEAL",
    latitude: "30.15",
    longitude: "28.0833",
    altitude: "144",
    timezone: "2",
    dst: "N",
    tz: "Africa/Cairo",
  },
  {
    id: "7857",
    name: "Bryce Canyon",
    city: "Bryce Canyon",
    country: "United States",
    iata: "BCE",
    icao: "KBCE",
    latitude: "37.706444",
    longitude: "-112.145806",
    altitude: "7590",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7858",
    name: "Heidelberg",
    city: "Heidelberg",
    country: "Germany",
    iata: "HDB",
    icao: "EDIU",
    latitude: "49.393333",
    longitude: "8.6525",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7859",
    name: "Burlington-Alamance Regional Airport",
    city: "Burlington",
    country: "United States",
    iata: "BUY",
    icao: "KBUY",
    latitude: "36.0485433",
    longitude: "-79.4748892",
    altitude: "617",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7861",
    name: "Chkalovsky Airport",
    city: "Shchyolkovo",
    country: "Russia",
    iata: "CKL",
    icao: "UUMU",
    latitude: "55.878333",
    longitude: "38.061667",
    altitude: "152",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7862",
    name: "Tengchong Tuofeng Airport",
    city: "Tengchong",
    country: "China",
    iata: "TCZ",
    icao: "ZUTC",
    latitude: "24.938651",
    longitude: "98.483591",
    altitude: "5500",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7863",
    name: "Belbek Sevastopol International Airport",
    city: "Sevastopol",
    country: "Ukraine",
    iata: "UKS",
    icao: "UKFB",
    latitude: "44.691431",
    longitude: "33.57567",
    altitude: "344",
    timezone: "2",
    dst: "U",
    tz: "Europe/Kiev",
  },
  {
    id: "8420",
    name: "Berlin Brandenburg Willy Brandt",
    city: "Berlin",
    country: "Germany",
    iata: "BER",
    icao: "EDDB",
    latitude: "52.366667",
    longitude: "13.503333",
    altitude: "154",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7865",
    name: "Paradise Island Seaplane Base",
    city: "Nassau",
    country: "Bahamas",
    iata: "WZY",
    icao: "\\N",
    latitude: "25.0872",
    longitude: "-77.3239",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "7866",
    name: "Selous Siswandu",
    city: "Selous National Park",
    country: "Tanzania",
    iata: "",
    icao: "\\N",
    latitude: "-7.70515",
    longitude: "38.158644",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "7867",
    name: "De Peel Air Base",
    city: "Deurne",
    country: "Netherlands",
    iata: "",
    icao: "EHDP",
    latitude: "51.5173",
    longitude: "5.85572",
    altitude: "98",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "7868",
    name: "Camp Bastion ",
    city: "Camp Bastion",
    country: "Afghanistan",
    iata: "",
    icao: "OAZI",
    latitude: "31.865556",
    longitude: "64.195278",
    altitude: "2808",
    timezone: "4.5",
    dst: "N",
    tz: "Asia/Kabul",
  },
  {
    id: "7869",
    name: "New Century AirCenter Airport",
    city: "Olathe",
    country: "United States",
    iata: "JCI",
    icao: "KIXD",
    latitude: "38.8309167",
    longitude: "-94.8903056",
    altitude: "1087",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7870",
    name: "Easton-Newnam Field Airport",
    city: "Easton",
    country: "United States",
    iata: "ESN",
    icao: "KESN",
    latitude: "38.8041667",
    longitude: "-76.069",
    altitude: "72",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7871",
    name: "Stafsberg Airport",
    city: "Hamar",
    country: "Norway",
    iata: "HMR",
    icao: "ENHA",
    latitude: "60.8181",
    longitude: "11.068",
    altitude: "713",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "7872",
    name: "Ringebu Airport",
    city: "Frya",
    country: "Norway",
    iata: "",
    icao: "ENRI",
    latitude: "61.5472",
    longitude: "10.0611",
    altitude: "571",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "7873",
    name: "Starmoen",
    city: "Elverum",
    country: "Norway",
    iata: "",
    icao: "ENSM",
    latitude: "60.88",
    longitude: "11.6731",
    altitude: "659",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "7874",
    name: "Ferry County Airport",
    city: "Republic",
    country: "United States",
    iata: "R49",
    icao: "\\N",
    latitude: "48.7182058",
    longitude: "-118.6564714",
    altitude: "2522",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7875",
    name: "Yuba County Airport",
    city: "Yuba City",
    country: "United States",
    iata: "MYV",
    icao: "KMYV",
    latitude: "39.0553",
    longitude: "-121.3411",
    altitude: "62",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7876",
    name: "Basel SBB",
    city: "Basel",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "47.547531",
    longitude: "7.58977",
    altitude: "800",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "7877",
    name: "Stockholm Cruise Port",
    city: "Stockholm",
    country: "Sweden",
    iata: "STO",
    icao: "\\N",
    latitude: "59.3233",
    longitude: "18.081",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "7878",
    name: "Helsingborg Cruise Port",
    city: "Helsingborg",
    country: "Sweden",
    iata: "JHE",
    icao: "\\N",
    latitude: "56.0419",
    longitude: "12.6912",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "7879",
    name: "Phillip Island Cruise Port",
    city: "Phillip Island",
    country: "Australia",
    iata: "",
    icao: "YPID",
    latitude: "-38.4468",
    longitude: "145.2378",
    altitude: "0",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "7880",
    name: "Halliburton Field Airport",
    city: "Duncan",
    country: "United States",
    iata: "DUC",
    icao: "KDUC",
    latitude: "34.4713056",
    longitude: "-97.9598611",
    altitude: "1114",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7881",
    name: "Port Authority Bus Terminal",
    city: "New York",
    country: "United States",
    iata: "",
    icao: "NYPA",
    latitude: "40.75616",
    longitude: "-73.9906",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7882",
    name: "Filitheyo",
    city: "N.Nilandhoo Atoll",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.207801",
    longitude: "73.037308",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "7883",
    name: "Helsinki Cruise Port",
    city: "Helsinki",
    country: "Finland",
    iata: "",
    icao: "HELC",
    latitude: "60.163056",
    longitude: "24.969167",
    altitude: "6",
    timezone: "2",
    dst: "E",
    tz: "Europe/Helsinki",
  },
  {
    id: "7884",
    name: "Chinle Municipal Airport",
    city: "Chinle",
    country: "United States",
    iata: "E91",
    icao: "\\N",
    latitude: "36.1108806",
    longitude: "-109.5754222",
    altitude: "5547",
    timezone: "-7",
    dst: "N",
    tz: "America/Denver",
  },
  {
    id: "7885",
    name: "Garner Field",
    city: "Uvalde",
    country: "United States",
    iata: "UVA",
    icao: "KUVA",
    latitude: "29.215429",
    longitude: "-99.748962",
    altitude: "942",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7886",
    name: "Lewis University Airport",
    city: "Lockport",
    country: "United States",
    iata: "LOT",
    icao: "KLOT",
    latitude: "41.606326",
    longitude: "-88.083003",
    altitude: "680",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7887",
    name: "Frasca Field",
    city: "Urbana",
    country: "United States",
    iata: "C16",
    icao: "\\N",
    latitude: "40.144979",
    longitude: "-88.200197",
    altitude: "735",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7888",
    name: "Buchanan Field Airport",
    city: "Concord",
    country: "United States",
    iata: "CCR",
    icao: "KCCR",
    latitude: "37.9896667",
    longitude: "-122.0568889",
    altitude: "26",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7889",
    name: "Key Largo",
    city: "Ocean Reef Club Airport",
    country: "United States",
    iata: "OCA",
    icao: "07FA",
    latitude: "25.325393",
    longitude: "-80.274775",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7890",
    name: "Denver Union Station",
    city: "Denver",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.753187",
    longitude: "-105.000093",
    altitude: "0",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7891",
    name: "DELETE",
    city: "DELETE",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "-1.1111",
    longitude: "-1.1111",
    altitude: "0",
    timezone: "0",
    dst: "A",
    tz: "\\N",
  },
  {
    id: "7892",
    name: "Polygone",
    city: "Strasbourg Neudorf",
    country: "France",
    iata: "",
    icao: "LFGC",
    latitude: "48.5548",
    longitude: "7.7778",
    altitude: "130",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7893",
    name: "Nannhausen",
    city: "Nannhausen",
    country: "Germany",
    iata: "",
    icao: "EDRN",
    latitude: "50",
    longitude: "7.591667",
    altitude: "1296",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7894",
    name: "Yushu Batang",
    city: "Yushu",
    country: "China",
    iata: "YUS",
    icao: "ZLYS",
    latitude: "32.825",
    longitude: "97.125",
    altitude: "13000",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "7895",
    name: "Playon Chico",
    city: "Playon Chico",
    country: "Panama",
    iata: "PYC",
    icao: "\\N",
    latitude: "9.303333",
    longitude: "-78.236111",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "7896",
    name: "Ustupo",
    city: "Ustupo",
    country: "Panama",
    iata: "UTU",
    icao: "\\N",
    latitude: "9.137778",
    longitude: "-77.933611",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "7897",
    name: "Mamitupo",
    city: "Mamitupo",
    country: "Panama",
    iata: "MPU",
    icao: "\\N",
    latitude: "9.186667",
    longitude: "-77.984167",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "7898",
    name: "Huai An Lianshui Airport",
    city: "Huai An",
    country: "China",
    iata: "HIA",
    icao: "ZSSH",
    latitude: "33.7772",
    longitude: "119.1478",
    altitude: "23",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7899",
    name: "Mureck",
    city: "Mureck",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "46.70778",
    longitude: "15.76941",
    altitude: "764",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "7900",
    name: "Guessing",
    city: "Guessing",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "47.05932",
    longitude: "16.32449",
    altitude: "820",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "7901",
    name: "El Porvenir",
    city: "El Porvenir",
    country: "Panama",
    iata: "PVE",
    icao: "\\N",
    latitude: "9.559167",
    longitude: "-78.971111",
    altitude: "5",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "7902",
    name: "Oshawa Airport",
    city: "Oshawa",
    country: "Canada",
    iata: "YOO",
    icao: "CYOO",
    latitude: "43.9228",
    longitude: "-78.895",
    altitude: "459",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7903",
    name: "Marl-Loemuehle Airport",
    city: "Recklinghausen",
    country: "Germany",
    iata: "",
    icao: "EDLM",
    latitude: "51.6472",
    longitude: "7.16333",
    altitude: "240",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "7904",
    name: "Farila Air Base",
    city: "Farila",
    country: "Sweden",
    iata: "",
    icao: "ESNF",
    latitude: "62.03",
    longitude: "15.752",
    altitude: "660",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "7905",
    name: "Lahr Airport",
    city: "Lahr",
    country: "Germany",
    iata: "LHA",
    icao: "EDTL",
    latitude: "48.3693",
    longitude: "7.82772",
    altitude: "511",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7906",
    name: "Monywa Airport",
    city: "Monywa",
    country: "Burma",
    iata: "",
    icao: "VYMY",
    latitude: "22.233",
    longitude: "95.117",
    altitude: "298",
    timezone: "6.5",
    dst: "N",
    tz: "Asia/Rangoon",
  },
  {
    id: "7907",
    name: "Ohio University Airport",
    city: "Athens",
    country: "United States",
    iata: "",
    icao: "KUNI",
    latitude: "39.2118928",
    longitude: "-82.2292554",
    altitude: "766",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7908",
    name: "Springfield-Beckly Municipal Airport",
    city: "Springfield",
    country: "United States",
    iata: "SGH",
    icao: "KSGH",
    latitude: "39.8402778",
    longitude: "-83.8401667",
    altitude: "1051",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7909",
    name: "Sun Island Airport",
    city: "South Aari Atoll",
    country: "Maldives",
    iata: "MSI",
    icao: "SIAM",
    latitude: "3.295",
    longitude: "72.4814",
    altitude: "2",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "7910",
    name: "Fes Sefrou Airport",
    city: "Fes",
    country: "Morocco",
    iata: "",
    icao: "GMFU",
    latitude: "34.0081",
    longitude: "-4.96556",
    altitude: "1539",
    timezone: "0",
    dst: "U",
    tz: "Africa/Casablanca",
  },
  {
    id: "7911",
    name: "Herrera International Airport",
    city: "Santo Domingo",
    country: "Dominican Republic",
    iata: "HEX",
    icao: "MDHE",
    latitude: "18.475",
    longitude: "-69.975",
    altitude: "22",
    timezone: "-4",
    dst: "U",
    tz: "America/Santo_Domingo",
  },
  {
    id: "7912",
    name: "Cooinda",
    city: "Cooinda",
    country: "Australia",
    iata: "CDA",
    icao: "YCOO",
    latitude: "-12.9033",
    longitude: "132.532",
    altitude: "43",
    timezone: "9.5",
    dst: "U",
    tz: "Australia/Darwin",
  },
  {
    id: "7913",
    name: "Jabiru",
    city: "Jabiru",
    country: "Australia",
    iata: "JAB",
    icao: "YJAB",
    latitude: "-12.6571",
    longitude: "132.893",
    altitude: "52",
    timezone: "9.5",
    dst: "U",
    tz: "Australia/Darwin",
  },
  {
    id: "7914",
    name: "Pitt Island Airport",
    city: "Pitt Island",
    country: "New Zealand",
    iata: "",
    icao: "PITT",
    latitude: "-44.300278",
    longitude: "-176.220556",
    altitude: "12",
    timezone: "12.75",
    dst: "U",
    tz: "Pacific/Chatham",
  },
  {
    id: "7915",
    name: "Plattling Bahnhof",
    city: "Plattling",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.780147",
    longitude: "12.863573",
    altitude: "1050",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7916",
    name: "Osterhofen Bahnhof",
    city: "Osterhofen Niederbayern",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.7",
    longitude: "13.016667",
    altitude: "1043",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7917",
    name: "Passau Hbf",
    city: "Passau",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.574167",
    longitude: "13.450833",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7918",
    name: "Regensburg-Oberhub Airport",
    city: "Regensburg",
    country: "Germany",
    iata: "",
    icao: "EDNR",
    latitude: "49.1419",
    longitude: "12.0819",
    altitude: "1299",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7919",
    name: "Regensburg HBF",
    city: "Regensburg",
    country: "Germany",
    iata: "RGB",
    icao: "REGE",
    latitude: "49.022",
    longitude: "12.1111",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7920",
    name: "Treuchtlingen BF",
    city: "Treuchtlingen",
    country: "Germany",
    iata: "TLG",
    icao: "TREU",
    latitude: "49.04",
    longitude: "11.081944",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7921",
    name: "Rivera Intl.",
    city: "Rivera",
    country: "Uruguay",
    iata: "",
    icao: "\\N",
    latitude: "-31.1127",
    longitude: "55.4611",
    altitude: "200",
    timezone: "-3",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7923",
    name: "Miami Seaplane Base",
    city: "Miami",
    country: "United States",
    iata: "MPB",
    icao: "\\N",
    latitude: "25.7783",
    longitude: "-80.1703",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7924",
    name: "Hastings Airport",
    city: "Freetown",
    country: "Sierra Leone",
    iata: "HGS",
    icao: "GFHA",
    latitude: "8.39713",
    longitude: "-13.1291",
    altitude: "60",
    timezone: "0",
    dst: "N",
    tz: "Africa/Freetown",
  },
  {
    id: "7925",
    name: "Philip Billard Muni",
    city: "Topeka",
    country: "United States",
    iata: "TOP",
    icao: "KTOP",
    latitude: "39.068657",
    longitude: "-95.622482",
    altitude: "881",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7926",
    name: "Grumeti Airstrip",
    city: "Serengeti National Park",
    country: "Tanzania",
    iata: "",
    icao: "\\N",
    latitude: "-2.157488",
    longitude: "34.221232",
    altitude: "5080",
    timezone: "3",
    dst: "N",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "7927",
    name: "Emporia Municipal Airport",
    city: "Emporia",
    country: "United States",
    iata: "EMP",
    icao: "\\N",
    latitude: "38.3321",
    longitude: "-96.1912",
    altitude: "1208",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7928",
    name: "Benson Airstrip",
    city: "Uvalde",
    country: "United States",
    iata: "",
    icao: "2XS8",
    latitude: "29.229405",
    longitude: "-99.823947",
    altitude: "929",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7929",
    name: "Rough River State Park",
    city: "Null",
    country: "United States",
    iata: "",
    icao: "K2I3",
    latitude: "37.609778",
    longitude: "-86.506925",
    altitude: "577",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7930",
    name: "Smyrna Airport",
    city: "Smyrna",
    country: "United States",
    iata: "",
    icao: "KMQY",
    latitude: "36.009",
    longitude: "-86.5201",
    altitude: "543",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7931",
    name: "Franklin County Airport",
    city: "Sewanee",
    country: "United States",
    iata: "",
    icao: "KUOS",
    latitude: "35.2051",
    longitude: "-85.8981",
    altitude: "1953",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7932",
    name: "Gunsa",
    city: "Shiquanhe",
    country: "China",
    iata: "NGQ",
    icao: "ZUAL",
    latitude: "32.10027",
    longitude: "80.052778",
    altitude: "13780",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "7933",
    name: "Magdeburg-Cochstedt",
    city: "Cochstedt",
    country: "Germany",
    iata: "CSO",
    icao: "EDBC",
    latitude: "51.855833",
    longitude: "11.418333",
    altitude: "596",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7934",
    name: "Wurzburg HBF",
    city: "Wurzburg",
    country: "Germany",
    iata: "WZB",
    icao: "WURZ",
    latitude: "49.7999",
    longitude: "9.95555",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7935",
    name: "Collin County Regional Airport at Mc Kinney",
    city: "DALLAS",
    country: "United States",
    iata: "TKI",
    icao: "KTKI",
    latitude: "33.1779444",
    longitude: "-96.5905278",
    altitude: "585",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7936",
    name: "Chicago Executive",
    city: "Chicago-Wheeling",
    country: "United States",
    iata: "PWK",
    icao: "KPWK",
    latitude: "42.1142897",
    longitude: "-87.9015376",
    altitude: "647",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7937",
    name: "Ol Kiombo Airstrip",
    city: "Masai Mara National Park",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.409595",
    longitude: "35.110803",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "7938",
    name: "Kelso Longview",
    city: "Kelso",
    country: "United States",
    iata: "KLS",
    icao: "KKLS",
    latitude: "46.118",
    longitude: "-122.898389",
    altitude: "20",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7939",
    name: "Letiste Benesov",
    city: "Benesov",
    country: "Czech Republic",
    iata: "",
    icao: "LKBE",
    latitude: "49.4427",
    longitude: "14.3841",
    altitude: "1322",
    timezone: "1",
    dst: "U",
    tz: "Europe/Prague",
  },
  {
    id: "7940",
    name: "Put-in-Bay Airport",
    city: "Put-in-Bay",
    country: "United States",
    iata: "3W2",
    icao: "\\N",
    latitude: "41.3521",
    longitude: "-82.497",
    altitude: "595",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7941",
    name: "Bougouni",
    city: "Bougouni",
    country: "Mali",
    iata: "",
    icao: "GABG",
    latitude: "11.45",
    longitude: "-7.517",
    altitude: "300",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "7942",
    name: "Glenwood Springs Train Station",
    city: "Glenwood Springs",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.548",
    longitude: "-107.3233",
    altitude: "0",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7943",
    name: "Grand Junction Train Station",
    city: "Grand Junction",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.0646",
    longitude: "-108.5705",
    altitude: "0",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7944",
    name: "Reno Amtrak Station",
    city: "Reno",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.5287",
    longitude: "-119.8116",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7945",
    name: "Sacramento Amtrak Station",
    city: "Sacramento",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "38.584791",
    longitude: "-121.500517",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7946",
    name: "Tureia Airport",
    city: "Tureia",
    country: "French Polynesia",
    iata: "ZTA",
    icao: "NTGY",
    latitude: "-20.7897",
    longitude: "-138.57",
    altitude: "12",
    timezone: "-10",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7947",
    name: "Ice Runway-McMurdo Sstation",
    city: "Ross Island",
    country: "Antarctica",
    iata: "",
    icao: "NZIR",
    latitude: "-77.8477778",
    longitude: "166.6683333",
    altitude: "1",
    timezone: "12",
    dst: "N",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "7948",
    name: "Keekorok",
    city: "Keekorok",
    country: "Kenya",
    iata: "",
    icao: "HKKE",
    latitude: "-1.586418",
    longitude: "35.259036",
    altitude: "5536",
    timezone: "3",
    dst: "N",
    tz: "Africa/Nairobi",
  },
  {
    id: "7949",
    name: "Ol Kiombo",
    city: "Mara Intrepids",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.409569",
    longitude: "35.110788",
    altitude: "5006",
    timezone: "3",
    dst: "N",
    tz: "Africa/Nairobi",
  },
  {
    id: "7950",
    name: "Ol Kiombo",
    city: "Mara Intrepids",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.409569",
    longitude: "35.110788",
    altitude: "5006",
    timezone: "3",
    dst: "N",
    tz: "Africa/Nairobi",
  },
  {
    id: "7951",
    name: "Kichwa Tembo",
    city: "Kichwa Tembo",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.264132",
    longitude: "35.022719",
    altitude: "5174",
    timezone: "3",
    dst: "N",
    tz: "Africa/Nairobi",
  },
  {
    id: "7952",
    name: "Busan",
    city: "Busan",
    country: "South Korea",
    iata: "",
    icao: "\\N",
    latitude: "35.179444",
    longitude: "129.075556",
    altitude: "0",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "7953",
    name: "Busan",
    city: "Busan",
    country: "South Korea",
    iata: "",
    icao: "\\N",
    latitude: "35.179444",
    longitude: "129.075556",
    altitude: "0",
    timezone: "9",
    dst: "U",
    tz: "Asia/Seoul",
  },
  {
    id: "7954",
    name: "Gare de Marne-la-Vallee",
    city: "Chessy",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "48.869722",
    longitude: "2.782778",
    altitude: "250",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "7955",
    name: "Jefferson County Intl",
    city: "Port Townsend",
    country: "United States",
    iata: "TWD",
    icao: "\\N",
    latitude: "48.0314",
    longitude: "-122.4838",
    altitude: "108",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7956",
    name: "Lynden Airport",
    city: "Lynden",
    country: "United States",
    iata: "38W",
    icao: "\\N",
    latitude: "48.9558961",
    longitude: "-122.4581183",
    altitude: "106",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7957",
    name: "Jefferson County Intl",
    city: "Port Townsend",
    country: "United States",
    iata: "0S9",
    icao: "\\N",
    latitude: "48.0538086",
    longitude: "-122.8106436",
    altitude: "108",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7958",
    name: "Savut",
    city: "Savut",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "1",
    longitude: "1",
    altitude: "1",
    timezone: "1",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "7959",
    name: "Xakan",
    city: "Xakan",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "1",
    longitude: "1",
    altitude: "1",
    timezone: "1",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7960",
    name: "Xakan",
    city: "Xakan",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "1",
    longitude: "1",
    altitude: "1",
    timezone: "1",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7961",
    name: "Xugan",
    city: "Xugan",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "1",
    longitude: "1",
    altitude: "1",
    timezone: "0",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "7962",
    name: "Puerto Obaldia",
    city: "Puerto Obaldia",
    country: "Panama",
    iata: "PUE",
    icao: "MPOA",
    latitude: "8.68333",
    longitude: "-77.5333",
    altitude: "223",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "7963",
    name: "Kerch Intl",
    city: "Kerch",
    country: "Ukraine",
    iata: "KHC",
    icao: "UKFK",
    latitude: "45.372869",
    longitude: "36.402761",
    altitude: "152",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "7964",
    name: "Khao Sok National Park",
    city: "Surat Thani",
    country: "Thailand",
    iata: "",
    icao: "\\N",
    latitude: "8.936667",
    longitude: "98.530278",
    altitude: "1200",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "7965",
    name: "Khao Sok National Park",
    city: "Surat Thani",
    country: "Thailand",
    iata: "",
    icao: "\\N",
    latitude: "8.936667",
    longitude: "98.530278",
    altitude: "1200",
    timezone: "7",
    dst: "U",
    tz: "Asia/Bangkok",
  },
  {
    id: "7966",
    name: "Boston South Station",
    city: "Boston",
    country: "United States",
    iata: "",
    icao: "BOST",
    latitude: "42.35",
    longitude: "-71.0558",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7967",
    name: "Tarifa",
    city: "Tarifa",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.070781",
    longitude: "-5.602764",
    altitude: "20",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "7968",
    name: "Train Station",
    city: "Ottawa",
    country: "Canada",
    iata: "XDS",
    icao: "\\N",
    latitude: "45.4164",
    longitude: "-75.6517",
    altitude: "374",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7969",
    name: "Train Station",
    city: "Belleville",
    country: "Canada",
    iata: "XVV",
    icao: "\\N",
    latitude: "44.1793",
    longitude: "-77.3747",
    altitude: "315",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7970",
    name: "Train Station",
    city: "Edmonton",
    country: "Canada",
    iata: "XZL",
    icao: "\\N",
    latitude: "53.5789",
    longitude: "-113.5307",
    altitude: "2208",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "7971",
    name: "Train Station",
    city: "Richmond",
    country: "United States",
    iata: "ZRD",
    icao: "\\N",
    latitude: "37.5343",
    longitude: "-77.42945",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7972",
    name: "Sentral",
    city: "Kuala Lumpur",
    country: "Malaysia",
    iata: "XKL",
    icao: "\\N",
    latitude: "3.134",
    longitude: "101.686",
    altitude: "126",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "7973",
    name: "Train Station",
    city: "Churchill",
    country: "Canada",
    iata: "XAD",
    icao: "\\N",
    latitude: "58.76775",
    longitude: "-94.17425",
    altitude: "10",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7974",
    name: "Train Station",
    city: "Winnipeg",
    country: "Canada",
    iata: "XEF",
    icao: "\\N",
    latitude: "49.8889",
    longitude: "-97.1342",
    altitude: "751",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "7975",
    name: "Kingston VIA Station",
    city: "Kingston",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "44.2572",
    longitude: "-76.53715",
    altitude: "282",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "7976",
    name: "Ukunda Airport",
    city: "Ukunda",
    country: "Kenya",
    iata: "UKA",
    icao: "HKUK",
    latitude: "-4.29694",
    longitude: "39.5714",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "7977",
    name: "Whitehaven Beach",
    city: "Whitsunday Island",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-20.28866",
    longitude: "149.044966",
    altitude: "0",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "7978",
    name: "Wilmington Airborne Airpark",
    city: "Wilmington",
    country: "United States",
    iata: "ILN",
    icao: "KILN",
    latitude: "39.42792",
    longitude: "-83.792118",
    altitude: "1077",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "7979",
    name: "Marana Regional",
    city: "Tucson",
    country: "United States",
    iata: "AVW",
    icao: "KAVQ",
    latitude: "32.409556",
    longitude: "-111.218388",
    altitude: "2031",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "7980",
    name: "Casa Grande Municipal Airport",
    city: "Casa Grande",
    country: "United States",
    iata: "CGZ",
    icao: "KCGZ",
    latitude: "32.954889",
    longitude: "-111.766832",
    altitude: "1464",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "7981",
    name: "Mobile",
    city: "Mobile",
    country: "United States",
    iata: "",
    icao: "1AZ0",
    latitude: "33.111944",
    longitude: "-112.269166",
    altitude: "1261",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "7982",
    name: "Buckeye Municipal Airport",
    city: "Buckeye",
    country: "United States",
    iata: "BXK",
    icao: "KBXK",
    latitude: "33.420417",
    longitude: "-112.68618",
    altitude: "1033",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "7983",
    name: "Gila Bend Municipal Airport",
    city: "Gila Bend",
    country: "United States",
    iata: "E63",
    icao: "KE63",
    latitude: "32.960169",
    longitude: "-112.673636",
    altitude: "789",
    timezone: "-7",
    dst: "U",
    tz: "America/Phoenix",
  },
  {
    id: "7984",
    name: "McMinn Co",
    city: "Athens",
    country: "United States",
    iata: "MMI",
    icao: "KMMI",
    latitude: "35.39919",
    longitude: "-84.56177",
    altitude: "874",
    timezone: "-5",
    dst: "N",
    tz: "America/New_York",
  },
  {
    id: "7985",
    name: "Sterling Municipal Airport",
    city: "Sterling",
    country: "United States",
    iata: "STK",
    icao: "KSTK",
    latitude: "40.6153136",
    longitude: "-103.2648454",
    altitude: "4040",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7986",
    name: "Rawlins Municipal Airport-Harvey Field",
    city: "Rawlins",
    country: "United States",
    iata: "RWL",
    icao: "KFWL",
    latitude: "41.8055975",
    longitude: "-107.19994",
    altitude: "6813",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "7987",
    name: "Mackenzie Airport",
    city: "Mackenzie British Columbia",
    country: "Canada",
    iata: "YZY",
    icao: "CYZY",
    latitude: "55.29944",
    longitude: "-123.08333",
    altitude: "2264",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "7988",
    name: "JALOU",
    city: "Jalu",
    country: "Libya",
    iata: "",
    icao: "\\N",
    latitude: "29.142222",
    longitude: "21.380556",
    altitude: "0",
    timezone: "2",
    dst: "U",
    tz: "Africa/Tripoli",
  },
  {
    id: "7989",
    name: "JALOU",
    city: "Jalu",
    country: "Libya",
    iata: "",
    icao: "\\N",
    latitude: "29.142222",
    longitude: "21.380556",
    altitude: "0",
    timezone: "2",
    dst: "U",
    tz: "Africa/Tripoli",
  },
  {
    id: "7990",
    name: "Caldwell Essex County Airport",
    city: "Caldwell",
    country: "United States",
    iata: "CDW",
    icao: "KCDW",
    latitude: "40.8752222",
    longitude: "-74.2813611",
    altitude: "172",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7991",
    name: "Lee C Fine Memorial Airport",
    city: "Kaiser Lake Ozark",
    country: "United States",
    iata: "AIZ",
    icao: "KAIZ",
    latitude: "38.096035",
    longitude: "-92.5494875",
    altitude: "869",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "7992",
    name: "Yuryevets",
    city: "Yuryevets",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "57.3106",
    longitude: "43.1003",
    altitude: "269",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "7993",
    name: "Big Bear City",
    city: "Big Bear",
    country: "United States",
    iata: "L35",
    icao: "\\N",
    latitude: "34.2637778",
    longitude: "-116.8560278",
    altitude: "6725",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7994",
    name: "KIEV  INTERNATIONAL AIRPORT",
    city: "KIEV",
    country: "Ukraine",
    iata: "KIP",
    icao: "KIEV",
    latitude: "50.1403",
    longitude: "30.1808",
    altitude: "250",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "7995",
    name: "Los Angeles Union Station",
    city: "Los Angeles",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "34.056111",
    longitude: "-118.234167",
    altitude: "300",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "7996",
    name: "Bamberg BF",
    city: "Bamberg",
    country: "Germany",
    iata: "BAM",
    icao: "BAMB",
    latitude: "49.911",
    longitude: "10.9",
    altitude: "800",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7997",
    name: "Ingolstadt BF",
    city: "Ingolstadt",
    country: "Germany",
    iata: "IGS",
    icao: "INGS",
    latitude: "48.7777",
    longitude: "11.422",
    altitude: "888",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "7998",
    name: "Thomasville Regional Airport",
    city: "Thomasville",
    country: "United States",
    iata: "TVI",
    icao: "KTVI",
    latitude: "30.9017921",
    longitude: "-83.8811285",
    altitude: "264",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "7999",
    name: "Henderson Executive Airport",
    city: "Henderson",
    country: "United States",
    iata: "HSH",
    icao: "KHND",
    latitude: "35.972778",
    longitude: "-115.134444",
    altitude: "1881",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8000",
    name: "Gostomel Antonov",
    city: "Kiev",
    country: "Ukraine",
    iata: "GML",
    icao: "UKKM",
    latitude: "50.603611",
    longitude: "30.191944",
    altitude: "517",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "8001",
    name: "Zuoying Station",
    city: "Kaohsiung",
    country: "Taiwan",
    iata: "",
    icao: "\\N",
    latitude: "22.687389",
    longitude: "120.307481",
    altitude: "31",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "8002",
    name: "Taipei Station",
    city: "Taipei",
    country: "Taiwan",
    iata: "",
    icao: "\\N",
    latitude: "25.047778",
    longitude: "121.517222",
    altitude: "30",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "8003",
    name: "Donghae",
    city: "Donghae",
    country: "South Korea",
    iata: "",
    icao: "\\N",
    latitude: "37.489",
    longitude: "129.124",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Seoul",
  },
  {
    id: "8004",
    name: "Sakaiminato Port",
    city: "Sakaiminato",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "35.539",
    longitude: "133.264",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8005",
    name: "Henry Tift Myers Airport",
    city: "Tifton",
    country: "United States",
    iata: "TMA",
    icao: "KTMA",
    latitude: "31.4289814",
    longitude: "-83.488545",
    altitude: "355",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8006",
    name: "Landshut Ellermuehle",
    city: "Landshut",
    country: "Germany",
    iata: "",
    icao: "EDML",
    latitude: "48.5133333333333",
    longitude: "12.035",
    altitude: "1200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8007",
    name: "Itzehoe-Hungriger Wolf Airport",
    city: "Itzehoe",
    country: "Germany",
    iata: "",
    icao: "EDHF",
    latitude: "53.9944",
    longitude: "9.57861",
    altitude: "89",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8008",
    name: "Savannah Cruise Terminal",
    city: "Savannah",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "32.08558",
    longitude: "-81.097559",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "8009",
    name: "CHARLESTON CRUISE TERMINAL",
    city: "CHARLESTON",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "32.781081",
    longitude: "-79.92364",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "8010",
    name: "NEW YORK CRUISE TERMINAL PIER 92",
    city: "NEW YORK",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.767681",
    longitude: "-73.999107",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "8011",
    name: "Navy Dockyard Hamilton Bermuda",
    city: "HAMILTON",
    country: "Bermuda",
    iata: "",
    icao: "\\N",
    latitude: "32.327037",
    longitude: "-64.830626",
    altitude: "0",
    timezone: "-4",
    dst: "U",
    tz: "Atlantic/Bermuda",
  },
  {
    id: "8012",
    name: "Tokyo Station",
    city: "Tokyo",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "35.672498",
    longitude: "139.753218",
    altitude: "16",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8013",
    name: "Shin-Osaka Station",
    city: "Osaka",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "34.738932",
    longitude: "135.500093",
    altitude: "61",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8014",
    name: "Hiroshima Station",
    city: "Hiroshima",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "34.3973853173792",
    longitude: "132.475978195923",
    altitude: "28",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8015",
    name: "Frankfurt-Main Hauptbahnhof",
    city: "Frankfurt",
    country: "Germany",
    iata: "ZRB",
    icao: "\\N",
    latitude: "50.1070257990375",
    longitude: "8.66276050515751",
    altitude: "372",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8016",
    name: "Amsterdam Amstel Station",
    city: "Amsterdam",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.3466365904832",
    longitude: "4.91781401731873",
    altitude: "21",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8017",
    name: "Florenc Central Bus Station",
    city: "Prague",
    country: "Czech Republic",
    iata: "",
    icao: "\\N",
    latitude: "50.0909636578274",
    longitude: "14.4394929551697",
    altitude: "617",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "8018",
    name: "Wien Sudbahnhof",
    city: "Vienna",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "48.1866480486625",
    longitude: "16.3815008466187",
    altitude: "651",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8019",
    name: "Praha hlavni nadrazi",
    city: "Prague",
    country: "Czech Republic",
    iata: "XYG",
    icao: "\\N",
    latitude: "50.0826892098189",
    longitude: "14.4350297593689",
    altitude: "691",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "8020",
    name: "Wien Westbahnhof",
    city: "Vienna",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "48.1965754250116",
    longitude: "16.3374911611023",
    altitude: "675",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8021",
    name: "Venezia Santa Lucia",
    city: "Venice",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "45.4417738709625",
    longitude: "12.3199978080597",
    altitude: "8",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8022",
    name: "Firenze Santa Maria Novella",
    city: "Florence",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "43.7766651171349",
    longitude: "11.2480175237426",
    altitude: "159",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8023",
    name: "Roma Termini",
    city: "Rome",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "41.9004811137748",
    longitude: "12.5020006853333",
    altitude: "189",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8024",
    name: "St Pancras Railway Station",
    city: "London",
    country: "United Kingdom",
    iata: "QQS",
    icao: "\\N",
    latitude: "51.532519492138",
    longitude: "-0.12630037301642",
    altitude: "80",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8025",
    name: "Chitabe Airstrip",
    city: "Chitabe",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.4687",
    longitude: "23.38271",
    altitude: "3000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "8026",
    name: "Fish River Canyon Lodge Airstrip",
    city: "Fish River Canyon",
    country: "Namibia",
    iata: "",
    icao: "\\N",
    latitude: "-27.659288",
    longitude: "17.837624",
    altitude: "3077",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "8027",
    name: "Sossusvlei Desert Lodge Airstrip",
    city: "Sossusvlei",
    country: "Namibia",
    iata: "",
    icao: "\\N",
    latitude: "-24.802812",
    longitude: "15.891713",
    altitude: "2950",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "8028",
    name: "Ulusaba Airstrip",
    city: "Ulusaba",
    country: "Namibia",
    iata: "ULX",
    icao: "\\N",
    latitude: "-24.782766",
    longitude: "31.353929",
    altitude: "1470",
    timezone: "2",
    dst: "S",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8029",
    name: "RADOM",
    city: "RADOM",
    country: "Poland",
    iata: "QXR",
    icao: "EPRA",
    latitude: "51.231978",
    longitude: "21.124183",
    altitude: "479",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8030",
    name: "Deer Valley Municipal Airport",
    city: "Phoenix ",
    country: "United States",
    iata: "DVT",
    icao: "KDVT",
    latitude: "33.4117",
    longitude: "112.457",
    altitude: "1478",
    timezone: "8",
    dst: "A",
    tz: "Asia/Chongqing",
  },
  {
    id: "8031",
    name: "Calgary Springbank Airport",
    city: "Calgary",
    country: "Canada",
    iata: "YBW",
    icao: "CYBW",
    latitude: "51.1031",
    longitude: "-114.374",
    altitude: "3939",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8032",
    name: "Golden Airport",
    city: "Golden",
    country: "Canada",
    iata: "YGE",
    icao: "CYGE",
    latitude: "51.2992",
    longitude: "-116.982",
    altitude: "2575",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8033",
    name: "Revelstoke Airport",
    city: "Revelstoke",
    country: "Canada",
    iata: "YRV",
    icao: "CYRV",
    latitude: "50.9667",
    longitude: "-118.183",
    altitude: "1459",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8034",
    name: "Republic Airport",
    city: "Farmingdale",
    country: "United States",
    iata: "",
    icao: "KFRG",
    latitude: "40.7288",
    longitude: "-73.4134",
    altitude: "82",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8035",
    name: "Allstedt",
    city: "Allstedt",
    country: "Germany",
    iata: "",
    icao: "EDBT",
    latitude: "51.3806",
    longitude: "11.4467",
    altitude: "932",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8036",
    name: "BWKAM",
    city: "Amberg",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.43",
    longitude: "11.8",
    altitude: "500",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8037",
    name: "Glindbruchkippe",
    city: "Peine",
    country: "Germany",
    iata: "",
    icao: "KIPP",
    latitude: "52.3237",
    longitude: "10.182",
    altitude: "230",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8038",
    name: "General Freire",
    city: "Curico",
    country: "Chile",
    iata: "",
    icao: "SCIC",
    latitude: "-34.9667",
    longitude: "-71.2164",
    altitude: "722",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "8039",
    name: "Peine-Eddesse Airport",
    city: "Peine",
    country: "Germany",
    iata: "",
    icao: "EDVP",
    latitude: "52.4025",
    longitude: "10.2289",
    altitude: "249",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8040",
    name: "Seattle King Street Station",
    city: "Seattle",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.5985",
    longitude: "-122.3299",
    altitude: "7",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8041",
    name: "Tula",
    city: "Tula",
    country: "Russia",
    iata: "TYA",
    icao: "\\N",
    latitude: "54.142208",
    longitude: "37.355619",
    altitude: "590",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8042",
    name: "Hondo Municipal Airport",
    city: "Hondo",
    country: "United States",
    iata: "HDO",
    icao: "KHDO",
    latitude: "29.3591",
    longitude: "-99.1775",
    altitude: "930",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8043",
    name: "Zhongwei Xiangshan Airport",
    city: "Zhongwei",
    country: "China",
    iata: "ZHY",
    icao: "ZLZW",
    latitude: "37.5728",
    longitude: "105.1544",
    altitude: "4305",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8044",
    name: "Milwaukee Airport Station",
    city: "Milwaukee",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.940556",
    longitude: "-87.924722",
    altitude: "730",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8045",
    name: "Springfield IL Amtrak",
    city: "Springfield",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.8023",
    longitude: "-89.6515",
    altitude: "593",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8046",
    name: "St. Louis Amtrak - old",
    city: "St. Louis",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "38.6241",
    longitude: "-90.2056",
    altitude: "450",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8047",
    name: "Camarillo Amtrak",
    city: "Camarillo",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "34.2164",
    longitude: "-119.0335",
    altitude: "140",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8048",
    name: "Seattle Pier 52",
    city: "Seattle",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.6005",
    longitude: "-122.3388",
    altitude: "7",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8049",
    name: "Bremerton Terminal",
    city: "Bremerton",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.5619",
    longitude: "-122.625",
    altitude: "7",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8050",
    name: "McKinley National Park Airport",
    city: "McKinley Park",
    country: "United States",
    iata: "MCL",
    icao: "PAIN",
    latitude: "63.732757",
    longitude: "-148.91129",
    altitude: "1720",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8051",
    name: "Lake Hood Seaplane Base",
    city: "Anchorage",
    country: "United States",
    iata: "LHD",
    icao: "PALH",
    latitude: "61.1866382",
    longitude: "-149.9653918",
    altitude: "71",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8052",
    name: "Prospect Creek Airport",
    city: "Prospect Creek",
    country: "United States",
    iata: "PPC",
    icao: "PAPR",
    latitude: "66.814167",
    longitude: "-150.643611",
    altitude: "1095",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8053",
    name: "Khwai River Lodge",
    city: "Khwai River",
    country: "Botswana",
    iata: "KHW",
    icao: "FBKR",
    latitude: "-19.149166",
    longitude: "23.7875",
    altitude: "3000",
    timezone: "2",
    dst: "N",
    tz: "Africa/Gaborone",
  },
  {
    id: "8054",
    name: "Spremberg-Welzow Airport",
    city: "Welzow",
    country: "Germany",
    iata: "",
    icao: "EDCY",
    latitude: "51.5756",
    longitude: "14.1369",
    altitude: "374",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8055",
    name: "Taichung Airport",
    city: "Taichung",
    country: "Taiwan",
    iata: "TXG",
    icao: "RCLG",
    latitude: "24.1863",
    longitude: "120.654",
    altitude: "369",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "8056",
    name: "Columbia County",
    city: "Hudson NY",
    country: "United States",
    iata: "HCC",
    icao: "\\N",
    latitude: "42.2913",
    longitude: "-73.7103",
    altitude: "198",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8057",
    name: "Sasovo",
    city: "Sasovo",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "54.3539",
    longitude: "41.9739",
    altitude: "365",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8058",
    name: "Hong Kong Macau Ferry Terminal",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.289372",
    longitude: "114.152153",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8059",
    name: "Hong Kong Macau Ferry Terminal",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.289372",
    longitude: "114.152153",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8060",
    name: "Macau Taipa Ferry Terminal",
    city: "Macau",
    country: "Macau",
    iata: "",
    icao: "\\N",
    latitude: "22.1633",
    longitude: "113.57404",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Macau",
  },
  {
    id: "8061",
    name: "Macau Taipa Ferry Terminal",
    city: "Macau",
    country: "Macau",
    iata: "",
    icao: "\\N",
    latitude: "22.1633",
    longitude: "113.57404",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Macau",
  },
  {
    id: "8062",
    name: "Wheeling Ohio County Airport",
    city: "Wheeling",
    country: "United States",
    iata: "HLG",
    icao: "\\N",
    latitude: "40.175",
    longitude: "-80.6463",
    altitude: "1195",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8063",
    name: "Fitzgerald Municipal Airport",
    city: "Fitzgerald",
    country: "United States",
    iata: "FZG",
    icao: "KFZG",
    latitude: "31.6839046",
    longitude: "-83.2709036",
    altitude: "365",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8064",
    name: "Perry-Foley Airport",
    city: "Perry",
    country: "United States",
    iata: "40J",
    icao: "\\N",
    latitude: "30.0692778",
    longitude: "-83.5805833",
    altitude: "44",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8065",
    name: "Cairo-Grady County Airport",
    city: "Cairo",
    country: "United States",
    iata: "70J",
    icao: "\\N",
    latitude: "30.8879767",
    longitude: "-84.1547353",
    altitude: "265",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8066",
    name: "Pacific Station",
    city: "Vancouver",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "49.2739",
    longitude: "-123.0986",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8067",
    name: "Tamar Mepe Airport",
    city: "Mestia",
    country: "Georgia",
    iata: "",
    icao: "\\N",
    latitude: "43.06848",
    longitude: "42.75424",
    altitude: "100",
    timezone: "4",
    dst: "N",
    tz: "Asia/Tbilisi",
  },
  {
    id: "8068",
    name: "Samsun ",
    city: "Samsun",
    country: "Turkey",
    iata: "SSX",
    icao: "\\N",
    latitude: "41.1641",
    longitude: "36.1814",
    altitude: "521",
    timezone: "2",
    dst: "U",
    tz: "Europe/Istanbul",
  },
  {
    id: "8069",
    name: "Ye",
    city: "Ye",
    country: "Burma",
    iata: "XYE",
    icao: "VYYE",
    latitude: "15.25",
    longitude: "97.85",
    altitude: "25",
    timezone: "6.5",
    dst: "U",
    tz: "Asia/Rangoon",
  },
  {
    id: "8070",
    name: "Isla San Felix",
    city: "Isla San Felix",
    country: "Chile",
    iata: "",
    icao: "SCFX",
    latitude: "-26.293864",
    longitude: "-80.096214",
    altitude: "165",
    timezone: "-4",
    dst: "U",
    tz: "America/Santiago",
  },
  {
    id: "8071",
    name: "Kingston Train Station",
    city: "Kingston",
    country: "Canada",
    iata: "XEG",
    icao: "KGST",
    latitude: "44.256944",
    longitude: "-76.536943",
    altitude: "282",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8072",
    name: "Dorval Railway Station",
    city: "Dorval",
    country: "Canada",
    iata: "XAX",
    icao: "\\N",
    latitude: "45.448611",
    longitude: "-73.74111",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8073",
    name: "Brockville Megabus Stop",
    city: "Brockville",
    country: "Canada",
    iata: "",
    icao: "BRKM",
    latitude: "44.6003",
    longitude: "-75.7039",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8074",
    name: "Brockville VIA Station",
    city: "Brockville",
    country: "Canada",
    iata: "",
    icao: "BRKV",
    latitude: "44.5919",
    longitude: "-75.693343",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8075",
    name: "Shaybah airport",
    city: "Shaybah",
    country: "Saudi Arabia",
    iata: "",
    icao: "OESB",
    latitude: "22.5147",
    longitude: "53.9597",
    altitude: "262",
    timezone: "3",
    dst: "N",
    tz: "Asia/Riyadh",
  },
  {
    id: "8076",
    name: "Dubai Al Maktoum",
    city: "Dubai",
    country: "United Arab Emirates",
    iata: "DWC",
    icao: "OMDW",
    latitude: "24.55056",
    longitude: "55.103174",
    altitude: "170",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "8077",
    name: "Aransas County Airport",
    city: "Rockport",
    country: "United States",
    iata: "RKP",
    icao: "KRKP",
    latitude: "28.0862222",
    longitude: "-97.0436944",
    altitude: "24",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8078",
    name: "Bandanaira Airport",
    city: "Bandanaira-Naira Island",
    country: "Indonesia",
    iata: "NDA",
    icao: "\\N",
    latitude: "-4.53333",
    longitude: "129.9",
    altitude: "37",
    timezone: "9",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "8079",
    name: "Megeve Airport",
    city: "Verdun",
    country: "France",
    iata: "MVV",
    icao: "LFHM",
    latitude: "45.8208",
    longitude: "6.65222",
    altitude: "4823",
    timezone: "1",
    dst: "U",
    tz: "Europe/Paris",
  },
  {
    id: "8080",
    name: "Meribel Airport",
    city: "Ajaccio",
    country: "France",
    iata: "MFX",
    icao: "LFKX",
    latitude: "45.4069",
    longitude: "6.58056",
    altitude: "5636",
    timezone: "1",
    dst: "U",
    tz: "Europe/Paris",
  },
  {
    id: "8081",
    name: "Oldbury",
    city: "Oldbury",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "52.55",
    longitude: "-2.0166",
    altitude: "499",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8082",
    name: "Tianyang",
    city: "Baise",
    country: "China",
    iata: "AEB",
    icao: "\\N",
    latitude: "23.72",
    longitude: "106.96",
    altitude: "485",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8083",
    name: "Okaukuejo Airport",
    city: "Okaukuejo",
    country: "Namibia",
    iata: "OKF",
    icao: "FYOO",
    latitude: "-19.1492",
    longitude: "15.9119",
    altitude: "3911",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "8084",
    name: "Mokuti Lodge Airport",
    city: "Mokuti Lodge",
    country: "Namibia",
    iata: "OKU",
    icao: "FYMO",
    latitude: "-18.8128",
    longitude: "17.0594",
    altitude: "3665",
    timezone: "1",
    dst: "S",
    tz: "Africa/Windhoek",
  },
  {
    id: "8085",
    name: "Rotenburg Wuemme Airport",
    city: "Rotenburg Wuemme",
    country: "Germany",
    iata: "",
    icao: "EDXQ",
    latitude: "53.1283",
    longitude: "9.34861",
    altitude: "98",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8086",
    name: "Wipperfuerth-Neye Airport",
    city: "Wipperfuerth",
    country: "Germany",
    iata: "",
    icao: "EDKN",
    latitude: "51.1242",
    longitude: "7.37361",
    altitude: "863",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8087",
    name: "Osnabrueck-Atterheide Airport",
    city: "Osnabrueck",
    country: "Germany",
    iata: "",
    icao: "EDWO",
    latitude: "52.2864",
    longitude: "7.96972",
    altitude: "285",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8088",
    name: "Ballenstedt Airport",
    city: "Ballenstedt",
    country: "Germany",
    iata: "",
    icao: "EDCB",
    latitude: "51.7458",
    longitude: "11.2297",
    altitude: "535",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8089",
    name: "Hartenholm Airport",
    city: "Hasenmoor",
    country: "Germany",
    iata: "",
    icao: "EDHM",
    latitude: "53.915",
    longitude: "10.0356",
    altitude: "108",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8090",
    name: "Ganderkesee Atlas Airfield Airport",
    city: "Ganderkesee",
    country: "Germany",
    iata: "",
    icao: "EDWQ",
    latitude: "53.0361",
    longitude: "8.50556",
    altitude: "95",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8091",
    name: "Nienburg-Holzbalge Airport",
    city: "Nienburg Weser",
    country: "Germany",
    iata: "",
    icao: "EDXI",
    latitude: "52.7097",
    longitude: "9.1625",
    altitude: "82",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8092",
    name: "Damme Airport",
    city: "Damme",
    country: "Germany",
    iata: "",
    icao: "EDWC",
    latitude: "52.4875",
    longitude: "8.18556",
    altitude: "151",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8093",
    name: "Borkenberge Airport",
    city: "Duelmen",
    country: "Germany",
    iata: "",
    icao: "EDLB",
    latitude: "51.78",
    longitude: "7.288",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8094",
    name: "Obermehler-Schlotheim Airport",
    city: "Obermehler",
    country: "Germany",
    iata: "",
    icao: "EDCO",
    latitude: "51.2678",
    longitude: "10.6347",
    altitude: "909",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8095",
    name: "Hodenhagen Airport",
    city: "Hodenhagen",
    country: "Germany",
    iata: "",
    icao: "EDVH",
    latitude: "52.7611",
    longitude: "9.60556",
    altitude: "79",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8096",
    name: "Grube Airport",
    city: "Grube",
    country: "Germany",
    iata: "",
    icao: "EDHB",
    latitude: "54.2444",
    longitude: "11.0247",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8097",
    name: "Toender Airport",
    city: "Toender",
    country: "Denmark",
    iata: "",
    icao: "EKTD",
    latitude: "54.9297",
    longitude: "8.84057",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "8098",
    name: "Celle-Arloh Airport",
    city: "Celle",
    country: "Germany",
    iata: "",
    icao: "EDVC",
    latitude: "52.6872",
    longitude: "10.1114",
    altitude: "207",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8099",
    name: "Uelzen Airport",
    city: "Uelzen",
    country: "Germany",
    iata: "",
    icao: "EDVU",
    latitude: "52.9839",
    longitude: "10.465",
    altitude: "246",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8100",
    name: "Hamm-Lippewiesen Airport",
    city: "Hamm",
    country: "Germany",
    iata: "",
    icao: "EDLH",
    latitude: "51.6897",
    longitude: "7.81611",
    altitude: "190",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8101",
    name: "Luesse Airport",
    city: "Luesse",
    country: "Germany",
    iata: "",
    icao: "EDOJ",
    latitude: "52.1411",
    longitude: "12.6647",
    altitude: "217",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8102",
    name: "Porta Westfalica Airport",
    city: "Bad Oeynhausen",
    country: "Germany",
    iata: "",
    icao: "EDVY",
    latitude: "52.2208",
    longitude: "8.85917",
    altitude: "148",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8103",
    name: "Brilon Hochsauerlandkreis Airport",
    city: "Brilon",
    country: "Germany",
    iata: "",
    icao: "EDKO",
    latitude: "51.4025",
    longitude: "8.64167",
    altitude: "1509",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8104",
    name: "Hameln Pyrmont Airport",
    city: "Bad Pyrmont",
    country: "Germany",
    iata: "",
    icao: "EDVW",
    latitude: "51.9667",
    longitude: "9.29167",
    altitude: "1178",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8105",
    name: "Nordholz Spieka Airport",
    city: "Cuxhaven",
    country: "Germany",
    iata: "",
    icao: "EDXN",
    latitude: "53.7672",
    longitude: "8.64361",
    altitude: "72",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8106",
    name: "Koethen Airport",
    city: "Koethen",
    country: "Germany",
    iata: "",
    icao: "EDCK",
    latitude: "51.7211",
    longitude: "11.9528",
    altitude: "305",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8107",
    name: "St. Michaelisdonn Airport",
    city: "Sankt Michaelisdonn",
    country: "Germany",
    iata: "",
    icao: "EDXM",
    latitude: "53.9781",
    longitude: "9.14472",
    altitude: "125",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8108",
    name: "Salzgitter Druette Airport",
    city: "Salzgitter",
    country: "Germany",
    iata: "",
    icao: "EDVS",
    latitude: "52.1544",
    longitude: "10.4267",
    altitude: "328",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8109",
    name: "Karlshoefen Airport",
    city: "Karlshoefen",
    country: "Germany",
    iata: "",
    icao: "EDWK",
    latitude: "53.3328",
    longitude: "9.02833",
    altitude: "20",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8110",
    name: "Oldenburg Hatten Airport",
    city: "Oldenburg",
    country: "Germany",
    iata: "",
    icao: "EDWH",
    latitude: "53.0689",
    longitude: "8.31361",
    altitude: "26",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8111",
    name: "Rinteln Airport",
    city: "Rinteln",
    country: "Germany",
    iata: "",
    icao: "EDVR",
    latitude: "52.1753",
    longitude: "9.05333",
    altitude: "180",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8112",
    name: "Muenster-Telgte Airport",
    city: "Muenster",
    country: "Germany",
    iata: "",
    icao: "EDLT",
    latitude: "51.9444",
    longitude: "7.77389",
    altitude: "177",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8113",
    name: "St. Peter-Ording Airport",
    city: "Sankt Peter-Ording",
    country: "Germany",
    iata: "PSH",
    icao: "EDXO",
    latitude: "54.3089",
    longitude: "8.68694",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8114",
    name: "Luechow-Rehbeck Airport",
    city: "Luechow",
    country: "Germany",
    iata: "",
    icao: "EDHC",
    latitude: "53.0161",
    longitude: "11.1444",
    altitude: "49",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8115",
    name: "Klietz-Scharlibbe Airport",
    city: "Scharlibbe",
    country: "Germany",
    iata: "",
    icao: "EDCL",
    latitude: "52.7094",
    longitude: "12.0733",
    altitude: "95",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8116",
    name: "Burg Airport",
    city: "Burg",
    country: "Germany",
    iata: "",
    icao: "EDBG",
    latitude: "52.2417",
    longitude: "11.8561",
    altitude: "174",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8117",
    name: "Crisp County Cordele Airport",
    city: "Cordele",
    country: "United States",
    iata: "CKF",
    icao: "KCKF",
    latitude: "31.9888333",
    longitude: "-83.7739167",
    altitude: "310",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8118",
    name: "Ormond Beach municipal Airport",
    city: "Ormond Beach",
    country: "United States",
    iata: "OMN",
    icao: "KOMN",
    latitude: "29.1804",
    longitude: "-81.06497",
    altitude: "28",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8119",
    name: "Bad Neuenahr-Ahrweiler Airport",
    city: "Bad Neuenahr",
    country: "Germany",
    iata: "",
    icao: "EDRA",
    latitude: "50.5578",
    longitude: "7.13639",
    altitude: "673",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8120",
    name: "Bad Duerkheim Airport",
    city: "Bad Duerkheim",
    country: "Germany",
    iata: "",
    icao: "EDRF",
    latitude: "49.4731",
    longitude: "8.19639",
    altitude: "351",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8121",
    name: "Portland Troutdale",
    city: "Troutdale",
    country: "United States",
    iata: "TTD",
    icao: "KTTD",
    latitude: "45.54937",
    longitude: "-122.401253",
    altitude: "39",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8122",
    name: "Portland Hillsboro",
    city: "Hillsboro",
    country: "United States",
    iata: "HIO",
    icao: "KHIO",
    latitude: "45.540394",
    longitude: "-122.949825",
    altitude: "204",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8123",
    name: "One Police Plaza Heliport",
    city: "New York",
    country: "United States",
    iata: "",
    icao: "NK39",
    latitude: "40.7126",
    longitude: "-73.9996",
    altitude: "244",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8124",
    name: "Leverkusen Airport",
    city: "Leverkusen",
    country: "Germany",
    iata: "",
    icao: "EDKL",
    latitude: "51.0153",
    longitude: "7.00556",
    altitude: "157",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8125",
    name: "Suwannee County Airport",
    city: "Live Oak",
    country: "United States",
    iata: "24J",
    icao: "\\N",
    latitude: "30.300125",
    longitude: "-83.0246944",
    altitude: "104",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8126",
    name: "Wershofen Eifel",
    city: "Wershofen",
    country: "Germany",
    iata: "",
    icao: "EDRV",
    latitude: "50.451667",
    longitude: "6.784444",
    altitude: "1560",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8127",
    name: "FOB Salerno",
    city: "Khost",
    country: "Afghanistan",
    iata: "KHT",
    icao: "OAKS",
    latitude: "33.3334",
    longitude: "69.952",
    altitude: "3756",
    timezone: "4.5",
    dst: "N",
    tz: "Asia/Kabul",
  },
  {
    id: "8128",
    name: "TCO",
    city: "Tengiz",
    country: "Kazakhstan",
    iata: "",
    icao: "\\N",
    latitude: "46.303056",
    longitude: "53.4275",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "8129",
    name: "TCO",
    city: "Tengiz",
    country: "Kazakhstan",
    iata: "",
    icao: "\\N",
    latitude: "46.303056",
    longitude: "53.4275",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Asia/Oral",
  },
  {
    id: "8130",
    name: "NAYPYITAW",
    city: "NAYPYITAW",
    country: "Burma",
    iata: "NYT",
    icao: "VYNT",
    latitude: "19.374",
    longitude: "96.121",
    altitude: "294",
    timezone: "6.5",
    dst: "N",
    tz: "Asia/Rangoon",
  },
  {
    id: "8132",
    name: "Maramba Aerodrome",
    city: "Livingstone",
    country: "Zambia",
    iata: "",
    icao: "\\N",
    latitude: "-17.8846",
    longitude: "25.8468",
    altitude: "0",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "8133",
    name: "Bend Municipal Airport",
    city: "Bend",
    country: "United States",
    iata: "",
    icao: "KBDN",
    latitude: "44.0945556",
    longitude: "-121.2002222",
    altitude: "3460",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8134",
    name: "Christmas Valley Airport",
    city: "Christmas Valley",
    country: "United States",
    iata: "",
    icao: "K62S",
    latitude: "43.2365314",
    longitude: "-120.6660967",
    altitude: "4317",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8135",
    name: "Burns Municipal Airport",
    city: "Burns",
    country: "United States",
    iata: "",
    icao: "KBNO",
    latitude: "43.5919167",
    longitude: "-118.95554444",
    altitude: "4159",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8136",
    name: "Prineville Airport",
    city: "Prineville",
    country: "United States",
    iata: "",
    icao: "KS39",
    latitude: "44.2869939",
    longitude: "-120.9038328",
    altitude: "3250",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8137",
    name: "Red Bluff Municipal Airport",
    city: "Red Bluff",
    country: "United States",
    iata: "",
    icao: "KRBL",
    latitude: "40.1506944",
    longitude: "-122.2523056",
    altitude: "352",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8138",
    name: "Gnoss Field Airport",
    city: "Novato",
    country: "United States",
    iata: "",
    icao: "KDVO",
    latitude: "38.1436111",
    longitude: "-122.5561",
    altitude: "2",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8139",
    name: "Lake County Airport",
    city: "Lakeview",
    country: "United States",
    iata: "",
    icao: "KLKV",
    latitude: "42.1611111",
    longitude: "-120.3990833",
    altitude: "4733",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8140",
    name: "Tillamook Airport",
    city: "Tillamook",
    country: "United States",
    iata: "",
    icao: "KTMK",
    latitude: "45.4182419",
    longitude: "-123.8143839",
    altitude: "36",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8141",
    name: "Ontario Municipal Airport",
    city: "Ontario",
    country: "United States",
    iata: "",
    icao: "KONO",
    latitude: "44.0193611",
    longitude: "-117.0130278",
    altitude: "2193",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8142",
    name: "Columbia Gorge Regional - The Dalles Municipal Airport",
    city: "The Dalles",
    country: "United States",
    iata: "",
    icao: "KDLS",
    latitude: "45.6185556",
    longitude: "-121.1673333",
    altitude: "247",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8143",
    name: "Montgomery County Airpark",
    city: "Gaithersburg",
    country: "United States",
    iata: "GAI",
    icao: "KGAI",
    latitude: "39.1006",
    longitude: "-77.09576",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8144",
    name: "Cincinnati Union Terminal",
    city: "Cincinnati",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.109961",
    longitude: "-84.537074",
    altitude: "497",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8145",
    name: "FOB Sharana",
    city: "Sharan",
    country: "Afghanistan",
    iata: "",
    icao: "\\N",
    latitude: "33.12777215",
    longitude: "68.8369847",
    altitude: "7400",
    timezone: "4.5",
    dst: "N",
    tz: "Asia/Kabul",
  },
  {
    id: "8146",
    name: "Sharona",
    city: "Sharona",
    country: "Afghanistan",
    iata: "AZ3",
    icao: "OASA",
    latitude: "33.1277215",
    longitude: "68.8369847",
    altitude: "7400",
    timezone: "4.5",
    dst: "N",
    tz: "Asia/Kabul",
  },
  {
    id: "8147",
    name: "Pembroke Airport",
    city: "Pembroke",
    country: "Canada",
    iata: "YTA",
    icao: "CYTA",
    latitude: "45.864399",
    longitude: "-77.251701",
    altitude: "529",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8148",
    name: "Tsumeb Airport",
    city: "Tsumeb",
    country: "Namibia",
    iata: "TSB",
    icao: "FYTM",
    latitude: "-19.1542",
    longitude: "17.4357",
    altitude: "4353",
    timezone: "1",
    dst: "U",
    tz: "Africa/Windhoek",
  },
  {
    id: "8149",
    name: "Suffield Heliport",
    city: "Suffield",
    country: "Canada",
    iata: "YSD",
    icao: "CYSD",
    latitude: "50.2666701",
    longitude: "-111.182999",
    altitude: "2525",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8150",
    name: "Field 21",
    city: "Wainwright",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "52.830601",
    longitude: "-111.100998",
    altitude: "2260",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8151",
    name: "Field 21",
    city: "Wainwright",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "52.830601",
    longitude: "-111.100998",
    altitude: "2260",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8152",
    name: "Aeroporto Blumenau",
    city: "BLUMENAU",
    country: "Brazil",
    iata: "BNU",
    icao: "SSBL",
    latitude: "-26.834239",
    longitude: "-49.091696",
    altitude: "70",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8153",
    name: "Aeroclub Mures",
    city: "Targu Mures",
    country: "Romania",
    iata: "",
    icao: "LRMS",
    latitude: "46.3201",
    longitude: "24.3157",
    altitude: "1000",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "8154",
    name: "Aeroclub Sibiu",
    city: "Sibiu",
    country: "Romania",
    iata: "",
    icao: "\\N",
    latitude: "45.4649",
    longitude: "24.053",
    altitude: "1451",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "8155",
    name: "Aeroclub Sibiu",
    city: "Sibiu",
    country: "Romania",
    iata: "SIB",
    icao: "\\N",
    latitude: "45.4649",
    longitude: "24.053",
    altitude: "1451",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "8156",
    name: "Bolshoe Gryzlovo",
    city: "Stupino",
    country: "Russia",
    iata: "",
    icao: "UUDG",
    latitude: "54.786667",
    longitude: "37.649167",
    altitude: "797",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8157",
    name: "Aerodrom Cioca",
    city: "Timisoara",
    country: "Romania",
    iata: "",
    icao: "\\N",
    latitude: "46.436",
    longitude: "24.4445",
    altitude: "280",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "8158",
    name: "Aeroclub Cioca",
    city: "Timisoara",
    country: "Romania",
    iata: "CIO",
    icao: "LRT2",
    latitude: "45.471009",
    longitude: "21.111967",
    altitude: "280",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "8159",
    name: "Crocodile Camp Air Strip",
    city: "Tsavo East",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-3.0764",
    longitude: "39.2428",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8160",
    name: "Crocodile Camp Air Strip",
    city: "Tsavo East",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-3.0764",
    longitude: "39.2428",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8161",
    name: "Cleveland Clinic",
    city: "Cleveland",
    country: "United States",
    iata: "",
    icao: "CCLN",
    latitude: "41.50225",
    longitude: "-81.62233",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8162",
    name: "Charlevoix Municipal Airport",
    city: "Charelvoix",
    country: "United States",
    iata: "CVX",
    icao: "KCVX",
    latitude: "45.3047778",
    longitude: "-85.2753333",
    altitude: "669",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8163",
    name: "Quincy Municipal Airport",
    city: "Quincy",
    country: "United States",
    iata: "2J9",
    icao: "\\N",
    latitude: "30.5978708",
    longitude: "-84.557425",
    altitude: "225",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8164",
    name: "Pferdsfeld",
    city: "Pferdsfeld",
    country: "Germany",
    iata: "",
    icao: "ETSP",
    latitude: "49.857778",
    longitude: "7.604167",
    altitude: "492",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8165",
    name: "Mykines Heliport",
    city: "Mykines",
    country: "Faroe Islands",
    iata: "",
    icao: "EKMS",
    latitude: "62.1021",
    longitude: "-7.6459",
    altitude: "112",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Faeroe",
  },
  {
    id: "8166",
    name: "V-A Waterfront",
    city: "Cape Town",
    country: "South Africa",
    iata: "",
    icao: "\\N",
    latitude: "-33.901161",
    longitude: "18.425896",
    altitude: "0",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8167",
    name: "Steenberg Helipad",
    city: "Cape Town",
    country: "South Africa",
    iata: "",
    icao: "\\N",
    latitude: "-34.070582",
    longitude: "18.424067",
    altitude: "50",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8168",
    name: "Steenberg Helipad",
    city: "Cape Town",
    country: "South Africa",
    iata: "",
    icao: "\\N",
    latitude: "-34.070582",
    longitude: "18.424067",
    altitude: "50",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8170",
    name: "Roche Harbor Seaplane Base",
    city: "Roche Harbor",
    country: "United States",
    iata: "RCE",
    icao: "\\N",
    latitude: "48.608056",
    longitude: "-123.159722",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8171",
    name: "Blakely Island Airport",
    city: "Blakely Island",
    country: "United States",
    iata: "BYW",
    icao: "\\N",
    latitude: "48.56025",
    longitude: "-122.80243",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8172",
    name: "Rosario Seaplane Base",
    city: "Rosario",
    country: "United States",
    iata: "RSJ",
    icao: "\\N",
    latitude: "48.645556",
    longitude: "-122.868056",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8173",
    name: "Westsound Seaplane Base",
    city: "Westsound",
    country: "United States",
    iata: "WSX",
    icao: "\\N",
    latitude: "48.617778",
    longitude: "-122.952778",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8174",
    name: "Friday Harbor Seaplane Base",
    city: "Friday Harbor",
    country: "United States",
    iata: "FBS",
    icao: "\\N",
    latitude: "48.537222",
    longitude: "-123.009722",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8175",
    name: "Big Bay Water Aerodrome",
    city: "Big Bay",
    country: "Canada",
    iata: "YRR",
    icao: "\\N",
    latitude: "50.4",
    longitude: "-125.133333",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8176",
    name: "Furnace Creek",
    city: "Death Valley National Park",
    country: "United States",
    iata: "L06",
    icao: "\\N",
    latitude: "36.273",
    longitude: "-116.515",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8177",
    name: "Cornwall Regional Airport",
    city: "Cornwall",
    country: "Canada",
    iata: "YCC",
    icao: "CYCC",
    latitude: "45.092778",
    longitude: "-74.567778",
    altitude: "175",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8178",
    name: "Seppe",
    city: "Bosschenhoofd",
    country: "Netherlands",
    iata: "",
    icao: "EHSE",
    latitude: "51.3317",
    longitude: "4.339",
    altitude: "30",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8179",
    name: "St.Stephan",
    city: "St.Stephan",
    country: "Switzerland",
    iata: "",
    icao: "LSTS",
    latitude: "46.497442",
    longitude: "7.412572",
    altitude: "3304",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8180",
    name: "Zona da Mata Regional Airport",
    city: "Juiz de Fora",
    country: "Brazil",
    iata: "IZA",
    icao: "SDZY",
    latitude: "-21.5130558014",
    longitude: "-43.1730575562",
    altitude: "1348",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8181",
    name: "Aeroclub Ghimbav",
    city: "Brasov",
    country: "Romania",
    iata: "",
    icao: "LRBG",
    latitude: "45.4153",
    longitude: "25.3137",
    altitude: "1743",
    timezone: "2",
    dst: "E",
    tz: "Europe/Bucharest",
  },
  {
    id: "8182",
    name: "Flagler County Airport",
    city: "Flagler",
    country: "United States",
    iata: "XFL",
    icao: "KXFL",
    latitude: "29.2821",
    longitude: "-81.1212",
    altitude: "33",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8183",
    name: "Aeroclub Deva",
    city: "Deva",
    country: "Romania",
    iata: "DVA",
    icao: "\\N",
    latitude: "45.5153",
    longitude: "22.5813",
    altitude: "615",
    timezone: "2",
    dst: "U",
    tz: "Europe/Bucharest",
  },
  {
    id: "8184",
    name: "Aeroclub Cluj",
    city: "Dezmir",
    country: "Romania",
    iata: "DZM",
    icao: "\\N",
    latitude: "46.4643",
    longitude: "23.4258",
    altitude: "1019",
    timezone: "2",
    dst: "U",
    tz: "Europe/Bucharest",
  },
  {
    id: "8185",
    name: "Antarctica",
    city: "Antarctica",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-66",
    longitude: "90",
    altitude: "8000",
    timezone: "12",
    dst: "U",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "8186",
    name: "Antarctica",
    city: "Antarctica",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-66",
    longitude: "90",
    altitude: "8000",
    timezone: "12",
    dst: "N",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "8187",
    name: "Morrisville Stowe State Airport",
    city: "Morrisville",
    country: "United States",
    iata: "MVL",
    icao: "KMVL",
    latitude: "44.535",
    longitude: "-72.614",
    altitude: "732",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8188",
    name: "Dallas Executive Airport",
    city: "Dallas",
    country: "United States",
    iata: "RBD",
    icao: "KRBD",
    latitude: "32.680833",
    longitude: "-96.868333",
    altitude: "201",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8189",
    name: "Como Water AD",
    city: "Como",
    country: "Italy",
    iata: "",
    icao: "LILY",
    latitude: "45.4853",
    longitude: "9.0411",
    altitude: "663",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8190",
    name: "Superficie Cielo Blu",
    city: "Vellezzo Bellini",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "45.283855",
    longitude: "9.111979",
    altitude: "350",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8191",
    name: "Welke Airport",
    city: "Beaver Island",
    country: "United States",
    iata: "6Y8",
    icao: "\\N",
    latitude: "45.721111",
    longitude: "-85.520278",
    altitude: "664",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8192",
    name: "Krainiy",
    city: "Baikonur",
    country: "Kazakhstan",
    iata: "",
    icao: "UAOL",
    latitude: "45.6183",
    longitude: "63.2144",
    altitude: "328",
    timezone: "6",
    dst: "U",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "8193",
    name: "MOW",
    city: "Moscow",
    country: "Russia",
    iata: "MOW",
    icao: "\\N",
    latitude: "55.7557",
    longitude: "37.6176",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8194",
    name: "Westerly State Airport",
    city: "Washington County",
    country: "United States",
    iata: "WST",
    icao: "KWST",
    latitude: "41.349722",
    longitude: "-71.803333",
    altitude: "81",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8195",
    name: "Block Island State Airport",
    city: "Block Island",
    country: "United States",
    iata: "BID",
    icao: "KBID",
    latitude: "41.168056",
    longitude: "-71.577778",
    altitude: "108",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8196",
    name: "Atmautluak Airport",
    city: "Atmautluak",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "60.866667",
    longitude: "-162.273056",
    altitude: "18",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8197",
    name: "Atmautluak Airport",
    city: "Atmautluak",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "60.866667",
    longitude: "-162.273056",
    altitude: "18",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8198",
    name: "Atmautluak Airport",
    city: "Atmautluak",
    country: "United States",
    iata: "369",
    icao: "\\N",
    latitude: "60.866667",
    longitude: "-162.273056",
    altitude: "18",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8199",
    name: "Nightmute Airport",
    city: "Nightmute",
    country: "United States",
    iata: "NME",
    icao: "PAGT",
    latitude: "60.471111",
    longitude: "-164.700833",
    altitude: "4",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8200",
    name: "Toksook Bay Airport",
    city: "Toksook Bay",
    country: "United States",
    iata: "OOK",
    icao: "PAOO",
    latitude: "60.541389",
    longitude: "-165.087222",
    altitude: "59",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8201",
    name: "Tununak Airport",
    city: "Tununak",
    country: "United States",
    iata: "TNK",
    icao: "\\N",
    latitude: "60.575556",
    longitude: "-165.271667",
    altitude: "14",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8202",
    name: "Goodnews Airport",
    city: "Goodnews Bay",
    country: "United States",
    iata: "GNU",
    icao: "\\N",
    latitude: "59.1175",
    longitude: "-161.5775",
    altitude: "15",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8203",
    name: "Newtok Airport",
    city: "Newtok",
    country: "United States",
    iata: "WWT",
    icao: "\\N",
    latitude: "60.939167",
    longitude: "-164.641111",
    altitude: "25",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "8204",
    name: "Achutupo Airport",
    city: "Achutupo",
    country: "Panama",
    iata: "ACU",
    icao: "\\N",
    latitude: "9.2",
    longitude: "-77.98",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "8205",
    name: "Tubuala Airport",
    city: "Tubuala",
    country: "Panama",
    iata: "TUW",
    icao: "\\N",
    latitude: "9.52",
    longitude: "-79.03",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "8206",
    name: "Garachine Airport",
    city: "Garachine",
    country: "Panama",
    iata: "GHE",
    icao: "\\N",
    latitude: "8.06",
    longitude: "-78.36",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "8207",
    name: "Mulatupo Airport",
    city: "Mulatupo",
    country: "Panama",
    iata: "MPP",
    icao: "\\N",
    latitude: "8.95",
    longitude: "-77.75",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Panama",
  },
  {
    id: "8208",
    name: "Ittoqqortoormiit Heliport",
    city: "Ittoqqortoormiit",
    country: "Greenland",
    iata: "OBY",
    icao: "BGSC",
    latitude: "70.485278",
    longitude: "-21.966667",
    altitude: "238",
    timezone: "-1",
    dst: "U",
    tz: "America/Scoresbysund",
  },
  {
    id: "8209",
    name: "Vinnitsa",
    city: "Vinnitsa",
    country: "Ukraine",
    iata: "VIN",
    icao: "UKWW",
    latitude: "49.2433",
    longitude: "28.6063",
    altitude: "900",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "8210",
    name: "Gent Sint-Pieters",
    city: "Gent",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "51.0352",
    longitude: "3.7097",
    altitude: "130",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8211",
    name: "Brugge",
    city: "Bruges",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "51.1972",
    longitude: "3.2172",
    altitude: "120",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8212",
    name: "Brugge",
    city: "Bruges",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "51.1972",
    longitude: "3.2172",
    altitude: "130",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8213",
    name: "Shin-yokohama-eki",
    city: "Yokohama",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "35.5075",
    longitude: "139.6175",
    altitude: "50",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8214",
    name: "Angers St Laud",
    city: "Angers",
    country: "France",
    iata: "QXG",
    icao: "\\N",
    latitude: "47.464714",
    longitude: "-0.556405",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8215",
    name: "Decatur County Industrial Air Park",
    city: "Bainbridge",
    country: "United States",
    iata: "BGE",
    icao: "KBGE",
    latitude: "30.9715981",
    longitude: "-84.6369278",
    altitude: "141",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8216",
    name: "La Romaine Airport",
    city: "La Romaine",
    country: "Canada",
    iata: "",
    icao: "CTT5",
    latitude: "50.257222",
    longitude: "-60.669167",
    altitude: "90",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "8217",
    name: "Kegaska Airport",
    city: "Kegaska",
    country: "Canada",
    iata: "ZKG",
    icao: "CTK6",
    latitude: "50.195833",
    longitude: "-61.265833",
    altitude: "32",
    timezone: "-4",
    dst: "A",
    tz: "America/Blanc-Sablon",
  },
  {
    id: "8218",
    name: "Black Tickle Airport",
    city: "Black Tickle",
    country: "Canada",
    iata: "YBI",
    icao: "CCE4",
    latitude: "53.47",
    longitude: "-55.7875",
    altitude: "57",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "8219",
    name: "Silver Springs Airport",
    city: "Silver Springs",
    country: "United States",
    iata: "SPZ",
    icao: "KSPZ",
    latitude: "39.4030278",
    longitude: "-119.2511944",
    altitude: "4269",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8220",
    name: "Whiteman Airport",
    city: "Los Angeles",
    country: "United States",
    iata: "WHP",
    icao: "KWHP",
    latitude: "34.2593253",
    longitude: "-118.4134331",
    altitude: "1003",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8221",
    name: "Madera Municipal Airport",
    city: "Madera",
    country: "United States",
    iata: "MAE",
    icao: "KMAE",
    latitude: "36.9886111",
    longitude: "-120.1124444",
    altitude: "255",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8222",
    name: "Mountain Home Municipal Airport",
    city: "Mountain Home",
    country: "United States",
    iata: "U76",
    icao: "\\N",
    latitude: "43.1316111",
    longitude: "-115.7305671",
    altitude: "3167",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8223",
    name: "Trail Airport",
    city: "Trail",
    country: "Canada",
    iata: "YZZ",
    icao: "CAD4",
    latitude: "49.055556",
    longitude: "-117.609167",
    altitude: "1427",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8224",
    name: "Victoria Airport Water Aerodrome",
    city: "Patricia Bay",
    country: "Canada",
    iata: "",
    icao: "CAP5",
    latitude: "48.65",
    longitude: "-123.45",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8225",
    name: "Arctic Bay Airport",
    city: "Arctic Bay",
    country: "Canada",
    iata: "YAB",
    icao: "CJX7",
    latitude: "73.006389",
    longitude: "-85.047222",
    altitude: "72",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8226",
    name: "Hope Bay Aerodrome",
    city: "Hope Bay",
    country: "Canada",
    iata: "",
    icao: "CHB3",
    latitude: "68.163889",
    longitude: "-106.614444",
    altitude: "125",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8227",
    name: "Hector Silva Airstrip",
    city: "Belmopan",
    country: "Belize",
    iata: "BCV",
    icao: "\\N",
    latitude: "17.269444",
    longitude: "-88.776111",
    altitude: "50",
    timezone: "-6",
    dst: "U",
    tz: "America/Belize",
  },
  {
    id: "8228",
    name: "Grand-Santi Airport",
    city: "Grand-Santi",
    country: "French Guiana",
    iata: "",
    icao: "SOGS",
    latitude: "4.283333",
    longitude: "-54.381111",
    altitude: "186",
    timezone: "-3",
    dst: "S",
    tz: "America/Cayenne",
  },
  {
    id: "8229",
    name: "Maripasoula Airport",
    city: "Maripasoula",
    country: "French Guiana",
    iata: "MPY",
    icao: "SOOA",
    latitude: "3.6575",
    longitude: "-54.037222",
    altitude: "377",
    timezone: "-3",
    dst: "S",
    tz: "America/Cayenne",
  },
  {
    id: "8230",
    name: "Saint-Laurent-du-Maroni Airport",
    city: "Saint-Laurent-du-Maroni",
    country: "French Guiana",
    iata: "LDX",
    icao: "SOOM",
    latitude: "5.483056",
    longitude: "-54.034444",
    altitude: "17",
    timezone: "-3",
    dst: "S",
    tz: "America/Cayenne",
  },
  {
    id: "8231",
    name: "Cayana Airstrip",
    city: "Cayana",
    country: "Suriname",
    iata: "AAJ",
    icao: "\\N",
    latitude: "3.898611",
    longitude: "-55.577778",
    altitude: "50",
    timezone: "-3",
    dst: "S",
    tz: "America/Paramaribo",
  },
  {
    id: "8232",
    name: "Laduani Airstrip",
    city: "Laduani",
    country: "Suriname",
    iata: "LDO",
    icao: "\\N",
    latitude: "4.3754",
    longitude: "-55.4075",
    altitude: "50",
    timezone: "-3",
    dst: "S",
    tz: "America/Paramaribo",
  },
  {
    id: "8233",
    name: "Kanas Airport",
    city: "Burqin",
    country: "China",
    iata: "KJI",
    icao: "ZWKN",
    latitude: "48.221111",
    longitude: "86.998056",
    altitude: "3900",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8234",
    name: "Capurgana Airport",
    city: "Capurgana",
    country: "Colombia",
    iata: "CPB",
    icao: "SKCA",
    latitude: "8.616667",
    longitude: "-77.333333",
    altitude: "100",
    timezone: "-5",
    dst: "S",
    tz: "America/Bogota",
  },
  {
    id: "8235",
    name: "Sohag International",
    city: "Sohag",
    country: "Egypt",
    iata: "HMB",
    icao: "HEMK",
    latitude: "26.341189",
    longitude: "31.742983",
    altitude: "859",
    timezone: "2",
    dst: "E",
    tz: "Africa/Cairo",
  },
  {
    id: "8236",
    name: "Rivera International Airport",
    city: "Rivera",
    country: "Uruguay",
    iata: "RVY",
    icao: "SURV",
    latitude: "-30.974444",
    longitude: "-55.476111",
    altitude: "712",
    timezone: "-3",
    dst: "S",
    tz: "America/Montevideo",
  },
  {
    id: "8237",
    name: "Patos de Minas Airport",
    city: "Patos de Minas",
    country: "Brazil",
    iata: "POJ",
    icao: "SNPD",
    latitude: "-18.672778",
    longitude: "-46.491111",
    altitude: "851",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8238",
    name: "Bauru-Arealva",
    city: "Bauru",
    country: "Brazil",
    iata: "JTC",
    icao: "SJTC",
    latitude: "-22.157778",
    longitude: "-49.068333",
    altitude: "594",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8239",
    name: "Ourilandia do Norte Airport",
    city: "Ourilandia do Norte",
    country: "Brazil",
    iata: "OIA",
    icao: "SDOW",
    latitude: "-6.763056",
    longitude: "-51.05",
    altitude: "229",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8240",
    name: "Redencao Airport",
    city: "Redencao",
    country: "Brazil",
    iata: "RDC",
    icao: "SNDC",
    latitude: "-8.033333",
    longitude: "-49.98",
    altitude: "669",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8241",
    name: "Sao Felix do Xingu Airport",
    city: "Sao Felix do Xingu",
    country: "Brazil",
    iata: "SXX",
    icao: "SNFX",
    latitude: "-6.641389",
    longitude: "-51.952222",
    altitude: "656",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8242",
    name: "Bonito Airport",
    city: "Bointo",
    country: "Brazil",
    iata: "BYO",
    icao: "SJDB",
    latitude: "-21.247222",
    longitude: "-56.4525",
    altitude: "1180",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "8243",
    name: "Sao Felix do Araguaia Airport",
    city: "Sao Felix do Araguaia",
    country: "Brazil",
    iata: "SXO",
    icao: "SWFX",
    latitude: "-11.6325",
    longitude: "-50.689444",
    altitude: "650",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "8244",
    name: "Carlos Alberto da Costa Neves Airport",
    city: "Cacador",
    country: "Brazil",
    iata: "CFC",
    icao: "SBCD",
    latitude: "-26.788333",
    longitude: "-50.939722",
    altitude: "3376",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8245",
    name: "Carauari Airport",
    city: "Carauari",
    country: "Brazil",
    iata: "CAF",
    icao: "SWCA",
    latitude: "-4.871389",
    longitude: "-66.8975",
    altitude: "354",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8246",
    name: "Porto Urucu",
    city: "Porto Urucu",
    country: "Brazil",
    iata: "",
    icao: "SWUY",
    latitude: "-4.884167",
    longitude: "-65.355556",
    altitude: "210",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8247",
    name: "Amaury Feitosa Tomaz Airport",
    city: "Eirunepe",
    country: "Brazil",
    iata: "ERN",
    icao: "SWEI",
    latitude: "-6.639444",
    longitude: "-69.879722",
    altitude: "412",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8248",
    name: "Concordia Airport",
    city: "Concordia",
    country: "Brazil",
    iata: "CCI",
    icao: "SSCK",
    latitude: "-27.180556",
    longitude: "-52.052778",
    altitude: "2461",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8249",
    name: "Paulo Abdala Airport",
    city: "Francisco Beltrao",
    country: "Brazil",
    iata: "FBE",
    icao: "SSFB",
    latitude: "-26.059167",
    longitude: "-53.063333",
    altitude: "2100",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8250",
    name: "Confresa Airport",
    city: "Confresa",
    country: "Brazil",
    iata: "CFO",
    icao: "SJHG",
    latitude: "-10.633611",
    longitude: "-51.567222",
    altitude: "250",
    timezone: "-4",
    dst: "S",
    tz: "America/Campo_Grande",
  },
  {
    id: "8251",
    name: "Jackson County Airport",
    city: "Jefferson",
    country: "United States",
    iata: "19A",
    icao: "\\N",
    latitude: "34.1758638",
    longitude: "-83.5615972",
    altitude: "951",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "8252",
    name: "Apalachicola Regional Airport",
    city: "Apalachicola",
    country: "United States",
    iata: "AAF",
    icao: "KAAF",
    latitude: "29.7276066",
    longitude: "-85.0274416",
    altitude: "20",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8253",
    name: "Orlando de Carvalho Airport",
    city: "Umuarama",
    country: "Brazil",
    iata: "UMU",
    icao: "SSUM",
    latitude: "-23.798611",
    longitude: "-53.313611",
    altitude: "1558",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8254",
    name: "Diamantina Airport",
    city: "Diamantina",
    country: "Brazil",
    iata: "DTI",
    icao: "SNDT",
    latitude: "-18.231944",
    longitude: "-43.650278",
    altitude: "4446",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8255",
    name: "Fonte Boa Airport",
    city: "Fonte Boa",
    country: "Brazil",
    iata: "FBA",
    icao: "SWOB",
    latitude: "-2.5325",
    longitude: "-66.083333",
    altitude: "207",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8256",
    name: "Senadora Eunice Micheles Airport",
    city: "Sao Paulo de Olivenca",
    country: "Brazil",
    iata: "OLC",
    icao: "SDCG",
    latitude: "-3.465556",
    longitude: "-68.918889",
    altitude: "335",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8257",
    name: "Humaita Airport",
    city: "Humaita",
    country: "Brazil",
    iata: "HUW",
    icao: "SWHT",
    latitude: "-7.532222",
    longitude: "-63.072222",
    altitude: "230",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8258",
    name: "Tapuruquara Airport",
    city: "Santa Isabel do Rio Negro",
    country: "Brazil",
    iata: "IRZ",
    icao: "SWTP",
    latitude: "-0.416944",
    longitude: "-65.033889",
    altitude: "223",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8259",
    name: "Oriximina Airport",
    city: "Oriximina",
    country: "Brazil",
    iata: "ORX",
    icao: "SNOX",
    latitude: "-1.714167",
    longitude: "-55.836111",
    altitude: "262",
    timezone: "-4",
    dst: "S",
    tz: "America/Boa_Vista",
  },
  {
    id: "8260",
    name: "Una-Comandatuba Airport",
    city: "Una",
    country: "Brazil",
    iata: "UNA",
    icao: "SBTC",
    latitude: "-15.355278",
    longitude: "-38.998889",
    altitude: "20",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "8261",
    name: "Algeciras Heliport",
    city: "Algeciras",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.128889",
    longitude: "-5.441111",
    altitude: "98",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "8262",
    name: "Algeciras Heliport",
    city: "Algeciras",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.128889",
    longitude: "-5.441111",
    altitude: "98",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "8263",
    name: "Kai Tak International Airport ",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.3177",
    longitude: "114.202",
    altitude: "30",
    timezone: "8",
    dst: "U",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8264",
    name: "Kai Tak International Airport ",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.3177",
    longitude: "114.202",
    altitude: "30",
    timezone: "8",
    dst: "U",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8265",
    name: "Telfer Airport",
    city: "Telfer",
    country: "Australia",
    iata: "TEF",
    icao: "YTEF",
    latitude: "-21.713057",
    longitude: "122.21222",
    altitude: "970",
    timezone: "8",
    dst: "N",
    tz: "Australia/Perth",
  },
  {
    id: "8266",
    name: "Gazipasa Airport",
    city: "Alanya",
    country: "Turkey",
    iata: "GZP",
    icao: "LTFG",
    latitude: "36.2993",
    longitude: "32.3014",
    altitude: "92",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "8267",
    name: "FOB Shank",
    city: "Shank",
    country: "Afghanistan",
    iata: "",
    icao: "OASH",
    latitude: "33.921369",
    longitude: "69.07813",
    altitude: "6614",
    timezone: "4.5",
    dst: "N",
    tz: "Asia/Kabul",
  },
  {
    id: "8268",
    name: "St. Augustine Airport",
    city: "St. Augustine",
    country: "United States",
    iata: "SGJ",
    icao: "\\N",
    latitude: "29.95925",
    longitude: "-81.3397222",
    altitude: "10",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8269",
    name: "Londolozi",
    city: "Londolozi",
    country: "South Africa",
    iata: "LDZ",
    icao: "\\N",
    latitude: "-24.8333",
    longitude: "31.5",
    altitude: "3510",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8270",
    name: "Singita Sabi Sands",
    city: "Sabi Sands",
    country: "South Africa",
    iata: "",
    icao: "\\N",
    latitude: "-24.84",
    longitude: "31.41",
    altitude: "3500",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8271",
    name: "Singita Sabi Sands",
    city: "Sabi Sands",
    country: "South Africa",
    iata: "",
    icao: "\\N",
    latitude: "-24.84",
    longitude: "31.41",
    altitude: "3500",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8272",
    name: "Singita Sabi Sands",
    city: "Sabi Sands",
    country: "South Africa",
    iata: "INY",
    icao: "\\N",
    latitude: "-24.815",
    longitude: "31.42",
    altitude: "1200",
    timezone: "2",
    dst: "N",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8273",
    name: "Douglas Municipal Airport",
    city: "Douglas",
    country: "United States",
    iata: "DQH",
    icao: "KDQH",
    latitude: "31.4767385",
    longitude: "-82.8605664",
    altitude: "257",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8274",
    name: "St Lucie County International Airport",
    city: "Fort Pierce",
    country: "United States",
    iata: "FRP",
    icao: "KFPR",
    latitude: "27.497472",
    longitude: "-80.372638",
    altitude: "23",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8275",
    name: "Alexandria",
    city: "Alexandria",
    country: "United States",
    iata: "ALX",
    icao: "ALX_",
    latitude: "38.806346",
    longitude: "-77.0621",
    altitude: "1",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8276",
    name: "Taunton Municipal Airport - King Field",
    city: "Taunton",
    country: "United States",
    iata: "TAN",
    icao: "KTAN",
    latitude: "41.8744017",
    longitude: "-71.0166453",
    altitude: "43",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8277",
    name: "Plymouth Municipal Airport",
    city: "Plymouth",
    country: "United States",
    iata: "PYM",
    icao: "KPYM",
    latitude: "41.9090278",
    longitude: "-70.7287778",
    altitude: "148",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8278",
    name: "Quonset State Airport",
    city: "North Kingstown",
    country: "United States",
    iata: "OQU",
    icao: "KOQU",
    latitude: "41.5971389",
    longitude: "-71.4121389",
    altitude: "18",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8279",
    name: "Mansfield Municipal",
    city: "Mansfield",
    country: "United States",
    iata: "1B9",
    icao: "\\N",
    latitude: "42.0001331",
    longitude: "-71.1967714",
    altitude: "122",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8280",
    name: "Norwood Memorial Airport",
    city: "Norwood",
    country: "United States",
    iata: "OWD",
    icao: "KOWD",
    latitude: "42.1905278",
    longitude: "-71.1729444",
    altitude: "49",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8281",
    name: "Barnes Municipal",
    city: "Westfield",
    country: "United States",
    iata: "BAF",
    icao: "KBAF",
    latitude: "42.1579472",
    longitude: "-72.715875",
    altitude: "270",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8282",
    name: "Windham Airport",
    city: "Willimantic",
    country: "United States",
    iata: "IJD",
    icao: "KIJD",
    latitude: "41.7440278",
    longitude: "-72.1802222",
    altitude: "246",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8283",
    name: "Orange County Airport",
    city: "Montgomery",
    country: "United States",
    iata: "MGJ",
    icao: "KMGJ",
    latitude: "41.5099884",
    longitude: "-74.2646444",
    altitude: "364",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8284",
    name: "Capital City Airport",
    city: "Harrisburg",
    country: "United States",
    iata: "CXY",
    icao: "KCXY",
    latitude: "40.2171389",
    longitude: "-76.8513611",
    altitude: "347",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8285",
    name: "Marshfield Municipal Airport",
    city: "Marshfield",
    country: "United States",
    iata: "GHG",
    icao: "KGHG",
    latitude: "42.09825",
    longitude: "-70.6721389",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8286",
    name: "Danbury Municipal Airport",
    city: "Danbury",
    country: "United States",
    iata: "DXR",
    icao: "KDXR",
    latitude: "41.3715353",
    longitude: "-73.4821906",
    altitude: "458",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8287",
    name: "Boire Field Airport",
    city: "Nashua",
    country: "United States",
    iata: "ASH",
    icao: "KASH",
    latitude: "42.78175",
    longitude: "-71.5147778",
    altitude: "199",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8288",
    name: "Lawrence Municipal Airport",
    city: "Lawrence",
    country: "United States",
    iata: "LWM",
    icao: "KLWM",
    latitude: "42.7171944",
    longitude: "-71.1234167",
    altitude: "148",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8289",
    name: "Waterbury-Oxford Airport",
    city: "Oxford",
    country: "United States",
    iata: "OXC",
    icao: "KOXC",
    latitude: "41.4785556",
    longitude: "-73.13525",
    altitude: "726",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8290",
    name: "Fitchburg Municipal Airport",
    city: "Fitchburg",
    country: "United States",
    iata: "FIT",
    icao: "KFIT",
    latitude: "42.5541111",
    longitude: "-71.7589722",
    altitude: "348",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8291",
    name: "Stockmar Airport",
    city: "Villa Rica",
    country: "United States",
    iata: "",
    icao: "20GA",
    latitude: "33.7565556",
    longitude: "-84.8850625",
    altitude: "1110",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8292",
    name: "Cartersville Airport",
    city: "Cartersville",
    country: "United States",
    iata: "VPC",
    icao: "KVPC",
    latitude: "34.1231475",
    longitude: "-84.8487067",
    altitude: "759",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8293",
    name: "Centre-Piedmont-Cherokee County Regional Airport",
    city: "Centre",
    country: "United States",
    iata: "PYP",
    icao: "KPYP",
    latitude: "34.0899167",
    longitude: "-85.6100833",
    altitude: "595",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8294",
    name: "Richard B Russell Airport",
    city: "Rome",
    country: "United States",
    iata: "RMG",
    icao: "KRMG",
    latitude: "34.3507778",
    longitude: "-85.1586667",
    altitude: "664",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8295",
    name: "Northeast Alabama Regional Airport",
    city: "Gadsden",
    country: "United States",
    iata: "GAD",
    icao: "KGAD",
    latitude: "33.9726489",
    longitude: "-86.0890834",
    altitude: "569",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8296",
    name: "Knoxville Downtown Island Airport",
    city: "Knoxville",
    country: "United States",
    iata: "DKX",
    icao: "KDKX",
    latitude: "35.9638333",
    longitude: "-83.8736667",
    altitude: "833",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8297",
    name: "Barrow County Airport",
    city: "Winder",
    country: "United States",
    iata: "WDR",
    icao: "KWDR",
    latitude: "33.9828611",
    longitude: "-83.6674167",
    altitude: "943",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8298",
    name: "Plantation Airpark",
    city: "Sylvania",
    country: "United States",
    iata: "JYL",
    icao: "KJYL",
    latitude: "32.6452778",
    longitude: "-81.5971111",
    altitude: "188",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8299",
    name: "Dalton Municipal Airport",
    city: "Dalton",
    country: "United States",
    iata: "DNN",
    icao: "KDNN",
    latitude: "34.7229444",
    longitude: "-84.87025",
    altitude: "709",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8300",
    name: "West Georgia Regional Airport - O V Gray Field",
    city: "Carrollton",
    country: "United States",
    iata: "CTJ",
    icao: "KCTJ",
    latitude: "33.6316964",
    longitude: "-85.1522641",
    altitude: "1165",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8301",
    name: "Isbell Field Airport",
    city: "Fort Payne",
    country: "United States",
    iata: "4A9",
    icao: "\\N",
    latitude: "34.4736944",
    longitude: "-85.7213889",
    altitude: "877",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8302",
    name: "LaGrange-Callaway Airport",
    city: "LaGrange",
    country: "United States",
    iata: "LGC",
    icao: "KLGC",
    latitude: "33.0088611",
    longitude: "-85.0726111",
    altitude: "694",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8303",
    name: "Baldwin County Airport",
    city: "Milledgeville",
    country: "United States",
    iata: "MLJ",
    icao: "KMLJ",
    latitude: "33.154225",
    longitude: "-83.2414139",
    altitude: "385",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8304",
    name: "Polk County Airport - Cornelius Moore Field",
    city: "Cedartown",
    country: "United States",
    iata: "4A4",
    icao: "\\N",
    latitude: "34.0186944",
    longitude: "-85.1464722",
    altitude: "974",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8305",
    name: "Harris County Airport",
    city: "Pine Mountain",
    country: "United States",
    iata: "PIM",
    icao: "KPIM",
    latitude: "32.8406944",
    longitude: "-84.8824444",
    altitude: "902",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8306",
    name: "Atlanta Regional Airport - Falcon Field",
    city: "Atlanta",
    country: "United States",
    iata: "FFC",
    icao: "KFFC",
    latitude: "33.35725",
    longitude: "-84.5718333",
    altitude: "808",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8307",
    name: "Covington Municipal Airport",
    city: "Covington",
    country: "United States",
    iata: "9A1",
    icao: "\\N",
    latitude: "33.6323083",
    longitude: "-83.8474472",
    altitude: "809",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8308",
    name: "Lee Gilmer Memorial Airport",
    city: "Gainesville",
    country: "United States",
    iata: "GVL",
    icao: "KGVL",
    latitude: "34.272627",
    longitude: "-83.8302233",
    altitude: "1276",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8309",
    name: "Cherokee County Airport",
    city: "Canton",
    country: "United States",
    iata: "",
    icao: "KCNI",
    latitude: "34.3122175",
    longitude: "-84.4221556",
    altitude: "1219",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8310",
    name: "DeFuniak Springs Airport",
    city: "DeFuniak Springs",
    country: "United States",
    iata: "54J",
    icao: "\\N",
    latitude: "30.7311111",
    longitude: "-86.1537778",
    altitude: "289",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8311",
    name: "Barwick Lafayette Airport",
    city: "LaFayette",
    country: "United States",
    iata: "9A5",
    icao: "\\N",
    latitude: "34.6884792",
    longitude: "-85.2903319",
    altitude: "777",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8312",
    name: "Harry Clever Field Airport",
    city: "New Philadelpha",
    country: "United States",
    iata: "PHD",
    icao: "KPHD",
    latitude: "40.4701667",
    longitude: "-81.4199444",
    altitude: "894",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8313",
    name: "Darlington County Jetport",
    city: "Darlington",
    country: "United States",
    iata: "UDG",
    icao: "KUDG",
    latitude: "34.4493845",
    longitude: "-79.8900608",
    altitude: "192",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8314",
    name: "Hilton Head Airport",
    city: "Hilton Head Island",
    country: "United States",
    iata: "HXD",
    icao: "KHXD",
    latitude: "32.2243611",
    longitude: "-80.6974722",
    altitude: "19",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8315",
    name: "Gilmer County Airport",
    city: "Ellijay",
    country: "United States",
    iata: "49A",
    icao: "\\N",
    latitude: "34.6282222",
    longitude: "-84.5265833",
    altitude: "1486",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8316",
    name: "Elizabethton Municipal Airport",
    city: "Elizabethton",
    country: "United States",
    iata: "0A9",
    icao: "\\N",
    latitude: "36.3712222",
    longitude: "-82.1734167",
    altitude: "1593",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8317",
    name: "Moton Field Municipal Airport",
    city: "Tuskegee",
    country: "United States",
    iata: "06A",
    icao: "\\N",
    latitude: "32.4605722",
    longitude: "-85.6800278",
    altitude: "264",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8318",
    name: "Daniel Field Airport",
    city: "Augusta",
    country: "United States",
    iata: "DNL",
    icao: "KDNL",
    latitude: "33.4665028",
    longitude: "-82.0393808",
    altitude: "423",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8319",
    name: "Foothills Regional Airport",
    city: "Morganton",
    country: "United States",
    iata: "MRN",
    icao: "KMRN",
    latitude: "35.8202336",
    longitude: "-81.6115119",
    altitude: "1270",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8320",
    name: "Pike County Airport - Hatcher Field",
    city: "Pikeville",
    country: "United States",
    iata: "PBX",
    icao: "KPBX",
    latitude: "37.5617639",
    longitude: "-82.5663889",
    altitude: "1473",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8321",
    name: "Mallards Landing Airport",
    city: "Locust Grove",
    country: "United States",
    iata: "",
    icao: "GA04",
    latitude: "33.3656703",
    longitude: "-84.1651964",
    altitude: "837",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8322",
    name: "Toccoa RG Letourneau Field Airport",
    city: "Toccoa",
    country: "United States",
    iata: "TOC",
    icao: "KTOC",
    latitude: "34.5928117",
    longitude: "-83.2963717",
    altitude: "996",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8323",
    name: "Shaftesbury-Compton Abbas Aerodrome",
    city: "Shaftesbury",
    country: "United Kingdom",
    iata: "",
    icao: "EGHA",
    latitude: "50.9672",
    longitude: "-2.1536",
    altitude: "811",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "8324",
    name: "SCC4",
    city: "MFO",
    country: "Egypt",
    iata: "",
    icao: "\\N",
    latitude: "30.524819",
    longitude: "34.584025",
    altitude: "2037",
    timezone: "2",
    dst: "U",
    tz: "Asia/Jerusalem",
  },
  {
    id: "8325",
    name: "SCC4",
    city: "MFO",
    country: "Egypt",
    iata: "",
    icao: "\\N",
    latitude: "30.524819",
    longitude: "34.584025",
    altitude: "2037",
    timezone: "2",
    dst: "E",
    tz: "Asia/Jerusalem",
  },
  {
    id: "8326",
    name: "SCC4",
    city: "MFO",
    country: "Egypt",
    iata: "",
    icao: "\\N",
    latitude: "30.524819",
    longitude: "34.584025",
    altitude: "2037",
    timezone: "2",
    dst: "E",
    tz: "Asia/Jerusalem",
  },
  {
    id: "8327",
    name: "SCC4",
    city: "MFO",
    country: "Egypt",
    iata: "",
    icao: "\\N",
    latitude: "30.524819",
    longitude: "34.584025",
    altitude: "2037",
    timezone: "2",
    dst: "E",
    tz: "Asia/Jerusalem",
  },
  {
    id: "8328",
    name: "Poltava",
    city: "Poltava",
    country: "Ukraine",
    iata: "PLV",
    icao: "UKHP",
    latitude: "49.34261",
    longitude: "34.23551",
    altitude: "333",
    timezone: "2",
    dst: "U",
    tz: "Europe/Kiev",
  },
  {
    id: "8329",
    name: "Ferry Port",
    city: "Calais",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "50.967536",
    longitude: "1.849308",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8330",
    name: "Ferry Port",
    city: "Dover",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.126876",
    longitude: "1.339747",
    altitude: "6",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8331",
    name: "Aweil Airport",
    city: "Aweil",
    country: "Sudan",
    iata: "",
    icao: "HSAW",
    latitude: "8.77",
    longitude: "27.3975",
    altitude: "1394",
    timezone: "3",
    dst: "U",
    tz: "Africa/Juba",
  },
  {
    id: "8332",
    name: "Wau Airport",
    city: "Wau",
    country: "Sudan",
    iata: "WUU",
    icao: "HSWW",
    latitude: "7.725",
    longitude: "27.98",
    altitude: "1420",
    timezone: "3",
    dst: "U",
    tz: "Africa/Juba",
  },
  {
    id: "8333",
    name: "Humera Airport",
    city: "Humera",
    country: "Ethiopia",
    iata: "HUE",
    icao: "HAHU",
    latitude: "14.3",
    longitude: "36.616667",
    altitude: "1500",
    timezone: "3",
    dst: "U",
    tz: "Africa/Asmera",
  },
  {
    id: "8334",
    name: "Moyale Airport",
    city: "Moyale",
    country: "Kenya",
    iata: "OYL",
    icao: "HKMY",
    latitude: "3.465",
    longitude: "39.105",
    altitude: "2790",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8335",
    name: "Zagora Airport",
    city: "Zagora",
    country: "Morocco",
    iata: "",
    icao: "GMAZ",
    latitude: "30.330556",
    longitude: "-5.838056",
    altitude: "1500",
    timezone: "0",
    dst: "U",
    tz: "Africa/Casablanca",
  },
  {
    id: "8336",
    name: "Yengema Airport",
    city: "Yengema",
    country: "Sierra Leone",
    iata: "WYE",
    icao: "GFYE",
    latitude: "8.615308",
    longitude: "-11.047192",
    altitude: "1300",
    timezone: "0",
    dst: "U",
    tz: "Africa/Freetown",
  },
  {
    id: "8337",
    name: "Gbangbatok Airport",
    city: "Gbangbatok",
    country: "Sierra Leone",
    iata: "GBK",
    icao: "GFGK",
    latitude: "7.767",
    longitude: "-12.383",
    altitude: "500",
    timezone: "0",
    dst: "U",
    tz: "Africa/Freetown",
  },
  {
    id: "8338",
    name: "Hong Kong China Ferry Terminal",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.299204",
    longitude: "114.166164",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8339",
    name: "Tampa Executive Airport",
    city: "Tampa",
    country: "United States",
    iata: "VDF",
    icao: "\\N",
    latitude: "28.0139772",
    longitude: "-82.3452778",
    altitude: "22",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8340",
    name: "UOTT",
    city: "Turukhansk",
    country: "Russia",
    iata: "",
    icao: "UOTT",
    latitude: "65.46",
    longitude: "87.53",
    altitude: "125",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "8341",
    name: "Podkamennaya Tunguska",
    city: "Bor",
    country: "Russia",
    iata: "",
    icao: "UNIP",
    latitude: "61.34",
    longitude: "89.56",
    altitude: "213",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "8342",
    name: "Fort Worth Alliance Airport",
    city: "Fort Worth",
    country: "United States",
    iata: "AFW",
    icao: "KAFW",
    latitude: "32.987778",
    longitude: "-97.318889",
    altitude: "722",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8343",
    name: "East Troy Municipal Airport",
    city: "East Troy",
    country: "United States",
    iata: "57C",
    icao: "K57C",
    latitude: "42.7971667",
    longitude: "-88.3726111",
    altitude: "860",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8344",
    name: "Kolpashevo Airport",
    city: "Kolpashevo",
    country: "Russia",
    iata: "",
    icao: "UNLL",
    latitude: "58.3333",
    longitude: "82.9333",
    altitude: "243",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "8345",
    name: "Montgomery Field",
    city: "San Diego",
    country: "United States",
    iata: "MYF",
    icao: "NULL",
    latitude: "32.4759",
    longitude: "117.759",
    altitude: "17",
    timezone: "8",
    dst: "A",
    tz: "Asia/Chongqing",
  },
  {
    id: "8346",
    name: "Gimpo International Airpot",
    city: "Seoul",
    country: "South Korea",
    iata: "SEL",
    icao: "\\N",
    latitude: "37.558311",
    longitude: "126.790586",
    altitude: "58",
    timezone: "9",
    dst: "N",
    tz: "Asia/Seoul",
  },
  {
    id: "8347",
    name: "Ali Al Salem Air Base",
    city: "Kuwait",
    country: "Kuwait",
    iata: "",
    icao: "OKAS",
    latitude: "29.346742",
    longitude: "47.520753",
    altitude: "472",
    timezone: "3",
    dst: "A",
    tz: "Asia/Kuwait",
  },
  {
    id: "8348",
    name: "Renmark",
    city: "Renmark",
    country: "Australia",
    iata: "RMK",
    icao: "YREN",
    latitude: "-34.118",
    longitude: "140.404",
    altitude: "115",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "8349",
    name: "Leigh Creek",
    city: "Leigh Creek",
    country: "Australia",
    iata: "",
    icao: "YLEC",
    latitude: "-30.598333",
    longitude: "138.425833",
    altitude: "856",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "8350",
    name: "Warburton",
    city: "Warburton Community",
    country: "Australia",
    iata: "",
    icao: "YWBR",
    latitude: "-26.128333",
    longitude: "126.583333",
    altitude: "1500",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "8351",
    name: "Cunderdin",
    city: "Cunderdin",
    country: "Australia",
    iata: "",
    icao: "YCUN",
    latitude: "-31.622223",
    longitude: "117.216667",
    altitude: "705",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "8352",
    name: "Rottnest Island",
    city: "Rottnest Island",
    country: "Australia",
    iata: "",
    icao: "YRTI",
    latitude: "-32.006667",
    longitude: "115.539722",
    altitude: "12",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "8353",
    name: "Forrest",
    city: "Forrest",
    country: "Australia",
    iata: "",
    icao: "YFRT",
    latitude: "-30.838056",
    longitude: "128.115",
    altitude: "511",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "8354",
    name: "Ballarat",
    city: "Ballarat",
    country: "Australia",
    iata: "",
    icao: "YBLT",
    latitude: "-37.511667",
    longitude: "143.791111",
    altitude: "1433",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "8355",
    name: "Keewaywin",
    city: "Keewaywin",
    country: "Canada",
    iata: "KEW",
    icao: "CPV8",
    latitude: "52.991111",
    longitude: "-92.836389",
    altitude: "988",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8356",
    name: "Marathon",
    city: "Marathon",
    country: "Canada",
    iata: "YSP",
    icao: "CYSP",
    latitude: "48.755278",
    longitude: "-86.344444",
    altitude: "1035",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8357",
    name: "Rene Fontaine",
    city: "Hearst",
    country: "Canada",
    iata: "YHF",
    icao: "CYHF",
    latitude: "49.713889",
    longitude: "-83.686944",
    altitude: "826",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8358",
    name: "Hornepayne",
    city: "Hornepayne",
    country: "Canada",
    iata: "YHN",
    icao: "CYHN",
    latitude: "49.193056",
    longitude: "-84.758889",
    altitude: "1099",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8359",
    name: "Kirkland Lake",
    city: "Kirkland Lake",
    country: "Canada",
    iata: "YKX",
    icao: "CYKX",
    latitude: "48.210278",
    longitude: "-79.981389",
    altitude: "1157",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8360",
    name: "Manitouwadge",
    city: "Manitouwadge",
    country: "Canada",
    iata: "YMG",
    icao: "CYMG",
    latitude: "49.083889",
    longitude: "-85.860556",
    altitude: "1198",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8361",
    name: "Wawa",
    city: "Wawa",
    country: "Canada",
    iata: "YXZ",
    icao: "CYXZ",
    latitude: "47.966944",
    longitude: "-84.786389",
    altitude: "944",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8362",
    name: "Manitoulin East",
    city: "Manitowaning",
    country: "Canada",
    iata: "YEM",
    icao: "CYEM",
    latitude: "45.8425",
    longitude: "-81.8575",
    altitude: "869",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8363",
    name: "Slate Falls",
    city: "Slate Falls",
    country: "Canada",
    iata: "",
    icao: "CKD9",
    latitude: "51.13",
    longitude: "-91.665556",
    altitude: "1355",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8364",
    name: "Collingwood",
    city: "Collingwood",
    country: "Canada",
    iata: "",
    icao: "CNY3",
    latitude: "44.449167",
    longitude: "-80.158333",
    altitude: "730",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8365",
    name: "Brantford",
    city: "Brantford",
    country: "Canada",
    iata: "YFD",
    icao: "CYFD",
    latitude: "43.131389",
    longitude: "-80.3425",
    altitude: "815",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8366",
    name: "Lawrence Municipal",
    city: "Lawrence",
    country: "United States",
    iata: "LWC",
    icao: "KLWC",
    latitude: "39.009167",
    longitude: "-95.2175",
    altitude: "833",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8367",
    name: "Wellington Municipal",
    city: "Wellington",
    country: "United States",
    iata: "EGT",
    icao: "KEGT",
    latitude: "37.39411",
    longitude: "-97.423225",
    altitude: "1277",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8368",
    name: "Isla San Jose",
    city: "Isla San Jose",
    country: "Panama",
    iata: "",
    icao: "\\N",
    latitude: "8.252",
    longitude: "-79.0668",
    altitude: "150",
    timezone: "-5",
    dst: "N",
    tz: "America/Panama",
  },
  {
    id: "8369",
    name: "Griffin-Spalding County Airport",
    city: "Griffin",
    country: "United States",
    iata: "6A2",
    icao: "\\N",
    latitude: "33.2269722",
    longitude: "-84.2749444",
    altitude: "958",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8370",
    name: "Dieu Merci",
    city: "Saint-Elie",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.7828",
    longitude: "-53.2611",
    altitude: "253",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "8371",
    name: "DEGRA",
    city: "REMIRE-MONTJOLY",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.8708",
    longitude: "52.2783",
    altitude: "33",
    timezone: "-3",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "8372",
    name: "Herapel",
    city: "Morsbach",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "49.1606",
    longitude: "6.8649",
    altitude: "840",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8373",
    name: "Degrad des Cannes",
    city: "REMIRE-MONTJOLY",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.8708",
    longitude: "-52.2783",
    altitude: "33",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "8374",
    name: "Elysee",
    city: "Elysee",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.75",
    longitude: "-54.05",
    altitude: "100",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "8375",
    name: "Citron",
    city: "Citron",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.7301",
    longitude: "-53.9516",
    altitude: "100",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "8376",
    name: "Yaou",
    city: "Maripasoula",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "3.7243",
    longitude: "-53.9747",
    altitude: "300",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "8377",
    name: "Helicojyp",
    city: "REMIRE-MONTJOLY",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.8936",
    longitude: "-52.2922",
    altitude: "39",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "8378",
    name: "Nicosia International Airport",
    city: "Nicosia",
    country: "Cyprus",
    iata: "NIC",
    icao: "\\N",
    latitude: "35.15111",
    longitude: "33.27222",
    altitude: "0",
    timezone: "2",
    dst: "E",
    tz: "Asia/Nicosia",
  },
  {
    id: "8379",
    name: "Pompano Beach Airpark",
    city: "Pompano Beach",
    country: "United States",
    iata: "PMP",
    icao: "KPMP",
    latitude: "26.2471389",
    longitude: "-80.1110556",
    altitude: "19",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8380",
    name: "Mallacoota Airport",
    city: "Mallacoota",
    country: "Australia",
    iata: "XMC",
    icao: "YMCO",
    latitude: "-37.598301",
    longitude: "149.720001",
    altitude: "31",
    timezone: "10",
    dst: "U",
    tz: "Australia/Hobart",
  },
  {
    id: "8381",
    name: "Prince Abdul Majeed Airport",
    city: "Al-Ula",
    country: "Saudi Arabia",
    iata: "ULH",
    icao: "OEAO",
    latitude: "26.636718",
    longitude: "37.908018",
    altitude: "2047",
    timezone: "3",
    dst: "N",
    tz: "Asia/Riyadh",
  },
  {
    id: "8382",
    name: "Pogapa Airstrip",
    city: "Pogapa",
    country: "Indonesia",
    iata: "",
    icao: "\\N",
    latitude: "-3.7518",
    longitude: "136.842481",
    altitude: "6060",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "8383",
    name: "Pogapa Airstrip",
    city: "Pogapa",
    country: "Indonesia",
    iata: "",
    icao: "\\N",
    latitude: "-3.7518",
    longitude: "136.842481",
    altitude: "6060",
    timezone: "9",
    dst: "N",
    tz: "Asia/Jayapura",
  },
  {
    id: "8384",
    name: "Greyhound Station",
    city: "Washington DC",
    country: "United States",
    iata: "",
    icao: "DCBS",
    latitude: "38.90339",
    longitude: "-77.00583",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8385",
    name: "Roma Street Railway Station",
    city: "Brisbane",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-27.4666667",
    longitude: "-153.0166667",
    altitude: "100",
    timezone: "10",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "8386",
    name: "Roma Street Railway Station",
    city: "Brisbane",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-27.4666667",
    longitude: "153.0166667",
    altitude: "100",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "8387",
    name: "Rockhampton Railway Station",
    city: "Rockhampton",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-23.378941",
    longitude: "150.512323",
    altitude: "100",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "8388",
    name: "Sydney Terminal Railway Station",
    city: "Sydney",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-33.88373",
    longitude: "151.20592",
    altitude: "100",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "8389",
    name: "Melbourne Southern Cross Railway Station",
    city: "Melbourne",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-37.8181602",
    longitude: "144.9533883",
    altitude: "111",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "8390",
    name: "Nambour Railway Station",
    city: "Nambour",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-26.617353",
    longitude: "152.973785",
    altitude: "400",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "8391",
    name: "Bundaberg Railway Station",
    city: "Bundaberg",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-24.867837",
    longitude: "152.349416",
    altitude: "100",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "8392",
    name: "Hung Hom Railway Station",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.308813",
    longitude: "114.169624",
    altitude: "100",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8393",
    name: "Hong Kong Railway Station",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.2846291082599",
    longitude: "114.158227443695",
    altitude: "100",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "8394",
    name: "Shelby County Airport",
    city: "Alabaster",
    country: "United States",
    iata: "EET",
    icao: "KEET",
    latitude: "33.1777778",
    longitude: "-86.7832222",
    altitude: "586",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8395",
    name: "Yuendumu ",
    city: "Yuendumu ",
    country: "Australia",
    iata: "YUE",
    icao: "YYND",
    latitude: "-22.254167",
    longitude: "131.781944",
    altitude: "2205",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Darwin",
  },
  {
    id: "8396",
    name: "Gare de Strasbourg",
    city: "Strasbourg",
    country: "France",
    iata: "XWG",
    icao: "\\N",
    latitude: "48.585068",
    longitude: "7.734547",
    altitude: "475",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8397",
    name: "Sky Ranch at Carefree",
    city: "Carefree",
    country: "United States",
    iata: "",
    icao: "18AZ",
    latitude: "33.8180947",
    longitude: "-111.8979242",
    altitude: "2568",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "8398",
    name: "St Peter and St Paul Fortress",
    city: "St. Petersburg",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "59.951443",
    longitude: "30.313831",
    altitude: "30",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8399",
    name: "Guangzhou South Railway Station",
    city: "Guangzhou",
    country: "China",
    iata: "GZS",
    icao: "\\N",
    latitude: "22.990081",
    longitude: "113.270631",
    altitude: "1",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8400",
    name: "Oddballs Camp Private Airstrip",
    city: "Okavango Oddballs Camp",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.531281",
    longitude: "23.091847",
    altitude: "3133",
    timezone: "2",
    dst: "N",
    tz: "Africa/Gaborone",
  },
  {
    id: "8401",
    name: "Lombok International Airport",
    city: "Praya",
    country: "Indonesia",
    iata: "LOP",
    icao: "WADL",
    latitude: "-8.7573222",
    longitude: "116.276675",
    altitude: "52",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "8402",
    name: "Marmul",
    city: "Marmul",
    country: "Oman",
    iata: "OMM",
    icao: "OONR",
    latitude: "18.133333",
    longitude: "55.266666",
    altitude: "900",
    timezone: "4",
    dst: "N",
    tz: "Asia/Muscat",
  },
  {
    id: "8403",
    name: "One Hundred Mile House Airport",
    city: "One Hundred Mile House",
    country: "Canada",
    iata: "",
    icao: "CAV3",
    latitude: "51.3833",
    longitude: "-121.1825",
    altitude: "3055",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8404",
    name: "South Cariboo Regional Airport",
    city: "108 Mile Ranch",
    country: "Canada",
    iata: "ZML",
    icao: "CZML",
    latitude: "51.4412",
    longitude: "-121.1958",
    altitude: "3129",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8405",
    name: "Glasgow City Heliport",
    city: "Glasgow",
    country: "United Kingdom",
    iata: "",
    icao: "EGEG",
    latitude: "55.5141",
    longitude: "-4.1749",
    altitude: "10",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8406",
    name: "Yarram",
    city: "Yarram",
    country: "Australia",
    iata: "",
    icao: "YYRM",
    latitude: "-38.56",
    longitude: "146.75",
    altitude: "200",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "8407",
    name: "Hebei Handan Airport",
    city: "Handan",
    country: "China",
    iata: "HDG",
    icao: "ZBHD",
    latitude: "36.524",
    longitude: "114.43",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8408",
    name: "Jade Mountain Helipad",
    city: "Soufriere",
    country: "Saint Lucia",
    iata: "",
    icao: "\\N",
    latitude: "13.868921",
    longitude: "-61.073596",
    altitude: "341",
    timezone: "-4",
    dst: "N",
    tz: "America/St_Lucia",
  },
  {
    id: "8409",
    name: "Indianapolis Metropolitan Airport",
    city: "Indianapolis",
    country: "United States",
    iata: "UMP",
    icao: "KUMP",
    latitude: "39.935278",
    longitude: "-86.045",
    altitude: "811",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8410",
    name: "London-Corbin Airport-MaGee Field",
    city: "London",
    country: "United States",
    iata: "LOZ",
    icao: "KLOZ",
    latitude: "37.0868889",
    longitude: "-84.0773889",
    altitude: "1212",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8411",
    name: "Camden Station",
    city: "Baltimore",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.2837181",
    longitude: "-76.621634",
    altitude: "49",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8412",
    name: "Fredericksburg Amtrak Station",
    city: "Fredericksburg",
    country: "United States",
    iata: "FBG",
    icao: "\\N",
    latitude: "38.298416",
    longitude: "-77.456875",
    altitude: "130",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8413",
    name: "Pamalican Airstrip",
    city: "Cuyo",
    country: "Philippines",
    iata: "",
    icao: "\\N",
    latitude: "11.354499",
    longitude: "120.730991",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Manila",
  },
  {
    id: "8414",
    name: "Warsaw Modlin",
    city: "Warsaw",
    country: "Poland",
    iata: "WMI",
    icao: "EPMO",
    latitude: "52.451111",
    longitude: "20.651667",
    altitude: "341",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8415",
    name: "Buffalo Bus Terminal",
    city: "Buffalo",
    country: "United States",
    iata: "",
    icao: "BBUF",
    latitude: "42.883512",
    longitude: "-78.87205",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8416",
    name: "Twelve Apostles Heliport",
    city: "Princetown",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-38.665833",
    longitude: "143.104444",
    altitude: "165",
    timezone: "10",
    dst: "U",
    tz: "Australia/Hobart",
  },
  {
    id: "8417",
    name: "Jixi Airport",
    city: "Jixi",
    country: "China",
    iata: "JXA",
    icao: "ZYJX",
    latitude: "45.30611",
    longitude: "130.99667",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8418",
    name: "King St Station",
    city: "Seattle",
    country: "United States",
    iata: "",
    icao: "SEAT",
    latitude: "47.5985",
    longitude: "-122.3299",
    altitude: "7",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8422",
    name: "Palatka Amtrak Station",
    city: "Palatka",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "29.649178",
    longitude: "-81.640456",
    altitude: "16",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8423",
    name: "Gimli Industrial Park Airport",
    city: "Gimli",
    country: "Canada",
    iata: "YGM",
    icao: "CYGM",
    latitude: "50.628056",
    longitude: "-97.043333",
    altitude: "753",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8424",
    name: "Matheson Island Airport",
    city: "Matheson Island",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "51.732222",
    longitude: "-96.934444",
    altitude: "725",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8425",
    name: "Matheson Island Airport",
    city: "Matheson Island",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "51.732222",
    longitude: "-96.934444",
    altitude: "725",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8426",
    name: "Matheson Island Airport",
    city: "Matheson Island",
    country: "Canada",
    iata: "",
    icao: "CJT2",
    latitude: "51.732222",
    longitude: "-96.934444",
    altitude: "725",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "8427",
    name: "Tura",
    city: "Tura",
    country: "Russia",
    iata: "",
    icao: "UNIT",
    latitude: "64.33",
    longitude: "100.43",
    altitude: "400",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "8428",
    name: "Beloyarsky",
    city: "Beloyarsky",
    country: "Russia",
    iata: "EYK",
    icao: "USHQ",
    latitude: "63.683056",
    longitude: "66.683056",
    altitude: "25",
    timezone: "6",
    dst: "E",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "8429",
    name: "Ypenburg",
    city: "Ypenburg",
    country: "Netherlands",
    iata: "",
    icao: "EHYB",
    latitude: "52.040376",
    longitude: "4.365771",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8430",
    name: "John H. Batten Airport",
    city: "Racine",
    country: "United States",
    iata: "RAC",
    icao: "KRAC",
    latitude: "42.7605",
    longitude: "-87.8152",
    altitude: "674",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8431",
    name: "Taytay Sandoval",
    city: "Taytay",
    country: "Philippines",
    iata: "RZP",
    icao: "RPSD",
    latitude: "11.05167",
    longitude: "119.5183",
    altitude: "75",
    timezone: "8",
    dst: "U",
    tz: "Asia/Manila",
  },
  {
    id: "8432",
    name: "Gera Leumnitz",
    city: "Gera",
    country: "Germany",
    iata: "",
    icao: "EDAJ",
    latitude: "50.8814",
    longitude: "12.1322",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8433",
    name: "Gera Leumnitz",
    city: "Gera",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.880023",
    longitude: "12.132411",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8434",
    name: "Mira Flores",
    city: "Mira Flores",
    country: "Colombia",
    iata: "",
    icao: "\\N",
    latitude: "1.444549",
    longitude: "-71.949921",
    altitude: "300",
    timezone: "-5",
    dst: "S",
    tz: "America/Bogota",
  },
  {
    id: "8435",
    name: "Kasimovo",
    city: "Saint-Petersburg",
    country: "Russia",
    iata: "",
    icao: "XLLN",
    latitude: "60.200059",
    longitude: "30.334926",
    altitude: "230",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8436",
    name: "Otaru",
    city: "Otaru",
    country: "Japan",
    iata: "QOT",
    icao: "\\N",
    latitude: "43.1894444",
    longitude: "141.0022222",
    altitude: "0",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8437",
    name: "Noboribetsu",
    city: "Noboribetsu",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "42.46867",
    longitude: "141.03833",
    altitude: "361",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8438",
    name: "Terlet",
    city: "Arnhem",
    country: "Netherlands",
    iata: "",
    icao: "EHTL",
    latitude: "52.057222",
    longitude: "5.924444",
    altitude: "276",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8439",
    name: "Schaffen Diest",
    city: "Schaffen",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "51.002846",
    longitude: "5.060649",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8440",
    name: "Blomberg 3GGW",
    city: "Blomberg",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.930401",
    longitude: "9.094285",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8441",
    name: "Buckeburg",
    city: "Buckeburg",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "52.279764",
    longitude: "9.079843",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8442",
    name: "Shigatse Peace Airport",
    city: "Shigatse",
    country: "China",
    iata: "RKZ",
    icao: "ZURK",
    latitude: "29.351667",
    longitude: "89.306944",
    altitude: "12408",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8443",
    name: "Redlands Municipal Airport",
    city: "Redlands",
    country: "United States",
    iata: "REI",
    icao: "KREI",
    latitude: "34.08525",
    longitude: "-117.146388",
    altitude: "1574",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8444",
    name: "Chemehuevi Valley",
    city: "Chemehuevi Valley",
    country: "United States",
    iata: "49X",
    icao: "\\N",
    latitude: "34.528889",
    longitude: "-114.431971",
    altitude: "638",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8445",
    name: "Flabob Airport",
    city: "Riverside",
    country: "United States",
    iata: "RIR",
    icao: "KRIR",
    latitude: "33.988778",
    longitude: "-117.409971",
    altitude: "764",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8446",
    name: "Tacoma Narrows Airport",
    city: "Tacoma",
    country: "United States",
    iata: "TIW",
    icao: "KTIW",
    latitude: "47.267944",
    longitude: "-122.57811",
    altitude: "294",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8447",
    name: "Tampa North Aero Park",
    city: "Tampa",
    country: "United States",
    iata: "X39",
    icao: "\\N",
    latitude: "28.221278",
    longitude: "-82.374555",
    altitude: "68",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8448",
    name: "Athuruga",
    city: "Athuruga",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3",
    longitude: "72",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "8449",
    name: "Athuruga",
    city: "Athuruga",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3",
    longitude: "72",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "8450",
    name: "Athuruga",
    city: "Athuruga",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3",
    longitude: "72",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "8451",
    name: "STROE KAZERNE",
    city: "STROE",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.198138",
    longitude: "5.705802",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8452",
    name: "\\\\'t Harde",
    city: "Oldebroek",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.406503",
    longitude: "5.898492",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8453",
    name: "WERL KAZERNE",
    city: "WERL",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.566907",
    longitude: "7.915326",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8454",
    name: "SZEGED",
    city: "SZEGED",
    country: "Hungary",
    iata: "",
    icao: "\\N",
    latitude: "46.252761",
    longitude: "20.096519",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "8455",
    name: "LAKE WANNSEE",
    city: "BERLIN",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "52.437517",
    longitude: "13.175561",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8456",
    name: "Tenkiller Lake Airpark",
    city: "COOKSON",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "35.705541",
    longitude: "-94.933605",
    altitude: "150",
    timezone: "-6",
    dst: "U",
    tz: "America/Chicago",
  },
  {
    id: "8457",
    name: "HOEVENEN",
    city: "HOEVENEN",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "51.304111",
    longitude: "4.388766",
    altitude: "50",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8458",
    name: "GRAS",
    city: "HARREVELD",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "51.981127",
    longitude: "6.516252",
    altitude: "50",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8459",
    name: "Muenster-Telgte",
    city: "TELGTE",
    country: "Germany",
    iata: "",
    icao: "EDLO",
    latitude: "51.944556",
    longitude: "7.773292",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8460",
    name: "Jack Edwards Airport",
    city: "Gulf Shores",
    country: "United States",
    iata: "JKA",
    icao: "KJKA",
    latitude: "30.2896389",
    longitude: "-87.6717778",
    altitude: "17",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8461",
    name: "General Villamil Airport",
    city: "Isabela",
    country: "Ecuador",
    iata: "",
    icao: "SEII",
    latitude: "-0.942499999",
    longitude: "-90.95305555",
    altitude: "35",
    timezone: "-6",
    dst: "N",
    tz: "Pacific/Galapagos",
  },
  {
    id: "8462",
    name: "Balzers Heliport",
    city: "Balzers",
    country: "Switzerland",
    iata: "",
    icao: "LSXB",
    latitude: "47.076667",
    longitude: "9.5",
    altitude: "1585",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vaduz",
  },
  {
    id: "8463",
    name: "Vieste Heliport",
    city: "Vieste",
    country: "Italy",
    iata: "VIF",
    icao: "\\N",
    latitude: "41.885277",
    longitude: "16.176945",
    altitude: "46",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8464",
    name: "Alpha",
    city: "Cork",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "51.400377",
    longitude: "-7.901464",
    altitude: "100",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8465",
    name: "Gogld",
    city: "Island of Gogland",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "60.011662",
    longitude: "27.008236",
    altitude: "10",
    timezone: "3",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8466",
    name: "HIBER",
    city: "Offshore",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "19.398611",
    longitude: "-92.016111",
    altitude: "100",
    timezone: "-6",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8467",
    name: "Punitz-Guessing",
    city: "Punitz-Guessing",
    country: "Austria",
    iata: "",
    icao: "LOGG",
    latitude: "47.14833",
    longitude: "16.31833",
    altitude: "950",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8468",
    name: "Khmeinitskiy",
    city: "Khmeinitskiy",
    country: "Ukraine",
    iata: "HMJ",
    icao: "UKLH",
    latitude: "49.366",
    longitude: "26.933",
    altitude: "351",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "8469",
    name: "Hiroshima-Nishi",
    city: "Hiroshima",
    country: "Japan",
    iata: "HIW",
    icao: "RJBH",
    latitude: "34.367",
    longitude: "132.408",
    altitude: "9",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "8470",
    name: "Annapolis",
    city: "Annapolis",
    country: "United States",
    iata: "",
    icao: "ANNA",
    latitude: "38.972944",
    longitude: "-76.501158",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8471",
    name: "High River Regional Airport",
    city: "High River",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "50.3333",
    longitude: "-113.833",
    altitude: "3431",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8472",
    name: "Yalata",
    city: "Yalata",
    country: "Australia",
    iata: "",
    icao: "YYTA",
    latitude: "-31.29",
    longitude: "131.51",
    altitude: "100",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "8473",
    name: "Hazleton Municipal",
    city: "Hazleton",
    country: "United States",
    iata: "HZL",
    icao: "KHZL",
    latitude: "40.989167",
    longitude: "-76.0025",
    altitude: "1603",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8474",
    name: "Greater Cumberland Rgnl.",
    city: "Cumberland",
    country: "United States",
    iata: "CBE",
    icao: "KCBE",
    latitude: "39.615278",
    longitude: "-78.760556",
    altitude: "775",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8475",
    name: "Sugar Loaf Shores Airport",
    city: "Key West",
    country: "United States",
    iata: "",
    icao: "7FA1",
    latitude: "24.6487544",
    longitude: "-81.5798083",
    altitude: "4",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8476",
    name: "Wyndham",
    city: "Wyndham",
    country: "Australia",
    iata: "",
    icao: "YWYM",
    latitude: "-15.2857",
    longitude: "128.0722",
    altitude: "100",
    timezone: "8",
    dst: "U",
    tz: "Australia/Perth",
  },
  {
    id: "8477",
    name: "Bob Quinn Lake",
    city: "Bob Quinn Lake",
    country: "Canada",
    iata: "YBO",
    icao: "CBW4",
    latitude: "56.58",
    longitude: "-130.5",
    altitude: "50",
    timezone: "-8",
    dst: "U",
    tz: "America/Vancouver",
  },
  {
    id: "8478",
    name: "Songo Songo",
    city: "Songo Songo Island",
    country: "Tanzania",
    iata: "",
    icao: "\\N",
    latitude: "-8.528056",
    longitude: "39.506944",
    altitude: "1",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "8479",
    name: "Jongomero Camp",
    city: "Ruaha National Park",
    country: "Tanzania",
    iata: "",
    icao: "\\N",
    latitude: "-7.895",
    longitude: "34.580853",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "8480",
    name: "Msembe Airstrip",
    city: "Msembe",
    country: "Tanzania",
    iata: "",
    icao: "\\N",
    latitude: "-7.686111",
    longitude: "35.926944",
    altitude: "0",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "8481",
    name: "Fox Glacier Airstrip",
    city: "Fox Glacier",
    country: "New Zealand",
    iata: "FGL",
    icao: "\\N",
    latitude: "-43.4",
    longitude: "170.033",
    altitude: "475",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "8482",
    name: "Grabtsevo",
    city: "Kaluga",
    country: "Russia",
    iata: "KLF",
    icao: "UUBS",
    latitude: "54.55",
    longitude: "36.367",
    altitude: "600",
    timezone: "4",
    dst: "E",
    tz: "Europe/Moscow",
  },
  {
    id: "8483",
    name: "Reykjahlid",
    city: "Reykjahlid",
    country: "Iceland",
    iata: "",
    icao: "\\N",
    latitude: "65.6",
    longitude: "-17",
    altitude: "100",
    timezone: "0",
    dst: "U",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "8484",
    name: "Central Station",
    city: "Stockholm",
    country: "Sweden",
    iata: "XEV",
    icao: "\\N",
    latitude: "59.33",
    longitude: "18.058056",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "8485",
    name: "Central Station",
    city: "Uppsala",
    country: "Sweden",
    iata: "QYX",
    icao: "\\N",
    latitude: "59.858333",
    longitude: "17.646111",
    altitude: "23",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "8486",
    name: "Centraal",
    city: "Rotterdam",
    country: "Netherlands",
    iata: "QRH",
    icao: "\\N",
    latitude: "51.924444",
    longitude: "4.469444",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8487",
    name: "Holesovice",
    city: "Praha",
    country: "Czech Republic",
    iata: "XYJ",
    icao: "\\N",
    latitude: "50.11",
    longitude: "14.439444",
    altitude: "616",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "8488",
    name: "Hauptbahnhof",
    city: "Bonn",
    country: "Germany",
    iata: "BNJ",
    icao: "\\N",
    latitude: "50.731944",
    longitude: "7.096944",
    altitude: "204",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8489",
    name: "Central",
    city: "Copenhagen",
    country: "Denmark",
    iata: "ZGH",
    icao: "\\N",
    latitude: "55.672778",
    longitude: "12.564444",
    altitude: "16",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "8490",
    name: "Hauptbahnhof",
    city: "Salzburg",
    country: "Austria",
    iata: "ZSB",
    icao: "\\N",
    latitude: "47.813056",
    longitude: "13.046667",
    altitude: "1391",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8491",
    name: "Centraal",
    city: "Antwerp",
    country: "Belgium",
    iata: "ZWE",
    icao: "\\N",
    latitude: "51.217222",
    longitude: "4.421111",
    altitude: "51",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8492",
    name: "Ellisras",
    city: "Lephalale",
    country: "South Africa",
    iata: "ELL",
    icao: "FAEA",
    latitude: "-23.666667",
    longitude: "27.75",
    altitude: "2700",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8493",
    name: "Tri-County Regional Airport",
    city: "Lone Rock",
    country: "United States",
    iata: "LNR",
    icao: "KLNR",
    latitude: "43.211667",
    longitude: "-90.181667",
    altitude: "718",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8494",
    name: "Price County Airport",
    city: "Phillips",
    country: "United States",
    iata: "",
    icao: "KPBH",
    latitude: "45.705",
    longitude: "-90.403056",
    altitude: "1466",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8495",
    name: "Municipal",
    city: "Monroe",
    country: "United States",
    iata: "",
    icao: "KEFT",
    latitude: "42.616389",
    longitude: "-89.591944",
    altitude: "1079",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8496",
    name: "Regional Airport",
    city: "Joliet",
    country: "United States",
    iata: "JOT",
    icao: "KJOT",
    latitude: "41.517778",
    longitude: "-88.175556",
    altitude: "582",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8497",
    name: "Illinois Valley Regional",
    city: "Peru",
    country: "United States",
    iata: "VYS",
    icao: "KVYS",
    latitude: "41.351944",
    longitude: "-89.153056",
    altitude: "654",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8498",
    name: "Dirk Hartog Island",
    city: "Dirk Hartog Island",
    country: "Australia",
    iata: "",
    icao: "YDHD",
    latitude: "-26.00937",
    longitude: "113.160008",
    altitude: "15",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "8499",
    name: "Reynolds Field",
    city: "Jackson",
    country: "United States",
    iata: "JXN",
    icao: "KJXN",
    latitude: "42.260556",
    longitude: "-84.460556",
    altitude: "1001",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8500",
    name: "Flugplatz",
    city: "Furstenwalde",
    country: "Germany",
    iata: "",
    icao: "EDAL",
    latitude: "52.393889",
    longitude: "14.099722",
    altitude: "141",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8501",
    name: "Flugplatz Finow",
    city: "Eberswalde",
    country: "Germany",
    iata: "",
    icao: "EDAV",
    latitude: "52.827222",
    longitude: "13.693611",
    altitude: "121",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8502",
    name: "Joseph A. Hardy Airport",
    city: "Connellsville",
    country: "United States",
    iata: "",
    icao: "KVVS",
    latitude: "39.959167",
    longitude: "-79.657222",
    altitude: "1267",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8503",
    name: "Bedford County",
    city: "Bedford",
    country: "United States",
    iata: "",
    icao: "KHMZ",
    latitude: "40.086111",
    longitude: "-78.513333",
    altitude: "1162",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8504",
    name: "Wings Field",
    city: "Philadelphia",
    country: "United States",
    iata: "BBX",
    icao: "KLOM",
    latitude: "40.1375",
    longitude: "-75.265",
    altitude: "302",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8505",
    name: "County",
    city: "Okeechobee",
    country: "United States",
    iata: "OBE",
    icao: "KOBE",
    latitude: "27.265833",
    longitude: "-80.851111",
    altitude: "34",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8506",
    name: "Regional - Hendricks AAF",
    city: "Sebring",
    country: "United States",
    iata: "SEF",
    icao: "KSEF",
    latitude: "27.456389",
    longitude: "-81.342222",
    altitude: "63",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8507",
    name: "Executive",
    city: "Avon Park",
    country: "United States",
    iata: "AVO",
    icao: "KAVO",
    latitude: "27.591389",
    longitude: "-81.528889",
    altitude: "160",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8508",
    name: "Gilbert Airport",
    city: "Winter Haven",
    country: "United States",
    iata: "GIF",
    icao: "KGIF",
    latitude: "28.062778",
    longitude: "-81.753333",
    altitude: "145",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8509",
    name: "Municipal Airport",
    city: "Zephyrhills",
    country: "United States",
    iata: "ZPH",
    icao: "KZPH",
    latitude: "28.228056",
    longitude: "-82.155833",
    altitude: "90",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8510",
    name: "International Airport",
    city: "Ocala",
    country: "United States",
    iata: "OCF",
    icao: "KOCF",
    latitude: "29.1725",
    longitude: "-82.224167",
    altitude: "89",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8511",
    name: "Jesup-Wayne County Airport",
    city: "Jesup",
    country: "United States",
    iata: "JES",
    icao: "KJES",
    latitude: "31.553889",
    longitude: "-81.8825",
    altitude: "107",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8512",
    name: "Madison GA Municipal Airport",
    city: "Madison",
    country: "United States",
    iata: "52A",
    icao: "K52A",
    latitude: "33.612125",
    longitude: "-83.4604444",
    altitude: "694",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8513",
    name: "Coweta County Airport",
    city: "Newnan",
    country: "United States",
    iata: "CCO",
    icao: "KCCO",
    latitude: "33.3115656",
    longitude: "-84.7697554",
    altitude: "970",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8514",
    name: "McDuffie County Airport",
    city: "Thomson",
    country: "United States",
    iata: "HQU",
    icao: "KHQU",
    latitude: "33.5297315",
    longitude: "-82.5169509",
    altitude: "501",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8515",
    name: "Municipal Airport",
    city: "Aiken",
    country: "United States",
    iata: "AIK",
    icao: "KAIK",
    latitude: "33.6493889",
    longitude: "-81.6850278",
    altitude: "529",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8516",
    name: "Woodward Field",
    city: "Camden",
    country: "United States",
    iata: "CDN",
    icao: "KCDN",
    latitude: "34.2835833",
    longitude: "-80.5648611",
    altitude: "302",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8517",
    name: "Municipal Airport",
    city: "Lumberton",
    country: "United States",
    iata: "LBT",
    icao: "KLBT",
    latitude: "34.6098056",
    longitude: "-79.0595556",
    altitude: "125",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8518",
    name: "Ridgeland Airport",
    city: "Ridgeland",
    country: "United States",
    iata: "3J1",
    icao: "\\N",
    latitude: "32.4934167",
    longitude: "-80.99175",
    altitude: "79",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8519",
    name: "Moore County Airport",
    city: "Pinehurst-Southern Pines",
    country: "United States",
    iata: "SOP",
    icao: "KSOP",
    latitude: "35.2376111",
    longitude: "-79.3887958",
    altitude: "455",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8520",
    name: "Richmond County Airport",
    city: "Rockingham",
    country: "United States",
    iata: "RCZ",
    icao: "KRCZ",
    latitude: "34.8913056",
    longitude: "-79.7596111",
    altitude: "358",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8521",
    name: "Bamberg County Airport",
    city: "Bamberg",
    country: "United States",
    iata: "99N",
    icao: "\\N",
    latitude: "33.3045278",
    longitude: "-81.1084167",
    altitude: "231",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8522",
    name: "Richland Airport",
    city: "Richland Center",
    country: "United States",
    iata: "93C",
    icao: "\\N",
    latitude: "43.2833575",
    longitude: "-90.2982819",
    altitude: "742",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8523",
    name: "Municipal Airport",
    city: "Viroqua",
    country: "United States",
    iata: "Y51",
    icao: "\\N",
    latitude: "43.5793603",
    longitude: "-90.8964742",
    altitude: "1292",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8524",
    name: "Baraboo Wisconsin Dells Airport",
    city: "Baraboo",
    country: "United States",
    iata: "DLL",
    icao: "KDLL",
    latitude: "43.5217843",
    longitude: "-89.7709266",
    altitude: "979",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8525",
    name: "Foster Field",
    city: "Apple River",
    country: "United States",
    iata: "7A4",
    icao: "\\N",
    latitude: "42.4664444",
    longitude: "-90.1693889",
    altitude: "990",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8526",
    name: "Regional Airport",
    city: "Statesville",
    country: "United States",
    iata: "SVH",
    icao: "KSVH",
    latitude: "35.7649958",
    longitude: "-80.9538958",
    altitude: "968",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8527",
    name: "Sylvania Airport",
    city: "Sturtevant",
    country: "United States",
    iata: "C89",
    icao: "\\N",
    latitude: "42.70325",
    longitude: "-87.9589722",
    altitude: "785",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8528",
    name: "Municipal Airport",
    city: "Burlington",
    country: "United States",
    iata: "BUU",
    icao: "KBUU",
    latitude: "42.6907171",
    longitude: "-88.3046825",
    altitude: "780",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8529",
    name: "Stroudsburg-Pocono Airport",
    city: "East Stroudsburg",
    country: "United States",
    iata: "N53",
    icao: "\\N",
    latitude: "41.0358717",
    longitude: "-75.1606789",
    altitude: "480",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8530",
    name: "Spring Hill Airport",
    city: "Sterling",
    country: "United States",
    iata: "70N",
    icao: "\\N",
    latitude: "41.3473569",
    longitude: "-75.4158972",
    altitude: "1729",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8531",
    name: "Randall Airport",
    city: "Middletown",
    country: "United States",
    iata: "06N",
    icao: "\\N",
    latitude: "41.431912",
    longitude: "-74.3915611",
    altitude: "523",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8532",
    name: "William T. Piper Mem.",
    city: "Lock Haven",
    country: "United States",
    iata: "LHV",
    icao: "KLHV",
    latitude: "41.1357778",
    longitude: "-77.4223056",
    altitude: "556",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8533",
    name: "Grove City Airport",
    city: "Grove City",
    country: "United States",
    iata: "29D",
    icao: "\\N",
    latitude: "41.1460278",
    longitude: "-80.16775",
    altitude: "1371",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8534",
    name: "Lansdowne Airport",
    city: "Youngstown",
    country: "United States",
    iata: "04G",
    icao: "\\N",
    latitude: "41.1304722",
    longitude: "-80.6195833",
    altitude: "1044",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8535",
    name: "Wadsworth Municipal",
    city: "Wadsworth",
    country: "United States",
    iata: "3G3",
    icao: "\\N",
    latitude: "41.0031572",
    longitude: "-81.7564401",
    altitude: "974",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8536",
    name: "Ashland County Airport",
    city: "Ashland",
    country: "United States",
    iata: "3G4",
    icao: "\\N",
    latitude: "40.9029722",
    longitude: "-82.2556389",
    altitude: "1206",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8537",
    name: "Pittsburgh-Monroeville Airport",
    city: "Monroeville",
    country: "United States",
    iata: "4G0",
    icao: "\\N",
    latitude: "40.4526389",
    longitude: "-79.7749167",
    altitude: "1187",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8538",
    name: "Zelienople Municipal Airport",
    city: "Zelienople",
    country: "United States",
    iata: "",
    icao: "KPJC",
    latitude: "40.8019722",
    longitude: "-80.1608611",
    altitude: "898",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8539",
    name: "Somerset County Airport",
    city: "Somerset",
    country: "United States",
    iata: "2G9",
    icao: "\\N",
    latitude: "40.0388708",
    longitude: "-79.0149951",
    altitude: "2275",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8540",
    name: "Youngstown Elser Metro Airport",
    city: "Youngstown",
    country: "United States",
    iata: "4G4",
    icao: "\\N",
    latitude: "40.9617953",
    longitude: "-80.6773264",
    altitude: "1070",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8541",
    name: "Braceville Airport",
    city: "Braceville",
    country: "United States",
    iata: "41N",
    icao: "\\N",
    latitude: "41.2111675",
    longitude: "-80.9692572",
    altitude: "900",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8542",
    name: "Lorain County Regional Airport",
    city: "Lorain-Elyria",
    country: "United States",
    iata: "LPR",
    icao: "KLPR",
    latitude: "41.3442778",
    longitude: "-82.1776389",
    altitude: "793",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8543",
    name: "Germack Airport",
    city: "Geneva",
    country: "United States",
    iata: "7D9",
    icao: "\\N",
    latitude: "41.7778322",
    longitude: "-80.9039797",
    altitude: "820",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8544",
    name: "Burke Lakefront Airport",
    city: "Cleveland",
    country: "United States",
    iata: "BKL",
    icao: "KBKL",
    latitude: "41.5175",
    longitude: "-81.683333",
    altitude: "583",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8545",
    name: "Chautauqua County-Dunkirk Airport",
    city: "Dunkirk",
    country: "United States",
    iata: "DKK",
    icao: "KDKK",
    latitude: "42.4933353",
    longitude: "-79.2720417",
    altitude: "693",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8546",
    name: "Hamburg Inc Airport",
    city: "Hamburg",
    country: "United States",
    iata: "4G2",
    icao: "\\N",
    latitude: "42.7008925",
    longitude: "-78.9147569",
    altitude: "751",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8547",
    name: "Trenton-Robbinsville Airport",
    city: "Trenton",
    country: "United States",
    iata: "N87",
    icao: "\\N",
    latitude: "40.2139444",
    longitude: "-74.6017778",
    altitude: "118",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8548",
    name: "South Jersey Regional Airport",
    city: "Mount Holly",
    country: "United States",
    iata: "VAY",
    icao: "KVAY",
    latitude: "39.9428889",
    longitude: "-74.84575",
    altitude: "53",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8549",
    name: "Spitfire Aerodrome",
    city: "Pedricktown",
    country: "United States",
    iata: "7N7",
    icao: "\\N",
    latitude: "39.7355633",
    longitude: "-75.3977211",
    altitude: "40",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8550",
    name: "Linden Airport",
    city: "Linden",
    country: "United States",
    iata: "LDJ",
    icao: "KLDJ",
    latitude: "40.6174472",
    longitude: "-74.2445942",
    altitude: "23",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8551",
    name: "Morgantown Airport",
    city: "Morgantown",
    country: "United States",
    iata: "O03",
    icao: "\\N",
    latitude: "40.1570414",
    longitude: "-75.8704892",
    altitude: "600",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8552",
    name: "Harford County Airport",
    city: "Churchville",
    country: "United States",
    iata: "0W3",
    icao: "\\N",
    latitude: "39.5668378",
    longitude: "-76.2024028",
    altitude: "409",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8553",
    name: "Tri-State Steuben County Airport",
    city: "Angola",
    country: "United States",
    iata: "ANQ",
    icao: "KANQ",
    latitude: "41.6396983",
    longitude: "-85.0834933",
    altitude: "995",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8554",
    name: "Plymouth Municipal Airport",
    city: "Plymouth",
    country: "United States",
    iata: "C65",
    icao: "\\N",
    latitude: "41.3651307",
    longitude: "-86.3002574",
    altitude: "800",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8555",
    name: "Warsaw Municipal Airport",
    city: "Warsaw",
    country: "United States",
    iata: "",
    icao: "KASW",
    latitude: "41.2746944",
    longitude: "-85.8400556",
    altitude: "850",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8556",
    name: "Van Wert County Airport",
    city: "Van Wert",
    country: "United States",
    iata: "VNW",
    icao: "KVNW",
    latitude: "40.8638295",
    longitude: "-84.606358",
    altitude: "787",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8557",
    name: "Port Bucyrus-Crawford County Airport",
    city: "Bucyrus",
    country: "United States",
    iata: "17G",
    icao: "\\N",
    latitude: "40.7815556",
    longitude: "-82.9748056",
    altitude: "1003",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8558",
    name: "Lake Wales Municipal Airport",
    city: "Lake Wales",
    country: "United States",
    iata: "X07",
    icao: "\\N",
    latitude: "27.8938056",
    longitude: "-81.6203889",
    altitude: "127",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8559",
    name: "Brooks Field Airport",
    city: "Marshall",
    country: "United States",
    iata: "RMY",
    icao: "KRMY",
    latitude: "42.2511932",
    longitude: "-84.9554443",
    altitude: "941",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8560",
    name: "Genesee County Airport",
    city: "Batavia",
    country: "United States",
    iata: "GVQ",
    icao: "KGVQ",
    latitude: "43.03175",
    longitude: "-78.1696667",
    altitude: "914",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8561",
    name: "Finger Lakes Regional Airport",
    city: "Seneca Falls",
    country: "United States",
    iata: "0G7",
    icao: "\\N",
    latitude: "42.8835647",
    longitude: "-76.7812318",
    altitude: "492",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8562",
    name: "Stormville Airport",
    city: "Stormville",
    country: "United States",
    iata: "N69",
    icao: "\\N",
    latitude: "41.5769708",
    longitude: "-73.7323514",
    altitude: "358",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8563",
    name: "Robertson Field",
    city: "Plainville",
    country: "United States",
    iata: "4B8",
    icao: "\\N",
    latitude: "41.6893333",
    longitude: "-72.8646944",
    altitude: "202",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8564",
    name: "Williams County Airport",
    city: "Bryan",
    country: "United States",
    iata: "0G6",
    icao: "\\N",
    latitude: "41.4673056",
    longitude: "-84.5067778",
    altitude: "730",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8565",
    name: "Clearwater Air Park",
    city: "Clearwater",
    country: "United States",
    iata: "CLW",
    icao: "KCLW",
    latitude: "27.9764722",
    longitude: "-82.7586667",
    altitude: "70",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8566",
    name: "South Lakeland Airport",
    city: "Lakeland",
    country: "United States",
    iata: "X49",
    icao: "\\N",
    latitude: "27.9333581",
    longitude: "-82.0439739",
    altitude: "110",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8567",
    name: "Scatsta Airport",
    city: "Scatsta",
    country: "United Kingdom",
    iata: "SCS",
    icao: "\\N",
    latitude: "60.433",
    longitude: "-1.3",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "8568",
    name: "North Sea",
    city: "Buchan Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "57.9039",
    longitude: "0.0319",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8569",
    name: "North Sea",
    city: "Buchan Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "57.9039",
    longitude: "0.0319",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8570",
    name: "North Sea",
    city: "Claymore",
    country: "United Kingdom",
    iata: "",
    icao: "CLAA",
    latitude: "58.4494",
    longitude: "-0.2536",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8571",
    name: "North Sea",
    city: "FPSO Anasuria",
    country: "United Kingdom",
    iata: "",
    icao: "ANAS",
    latitude: "57.1524",
    longitude: "0.0483",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8572",
    name: "North Sea",
    city: "BP Bruce",
    country: "United Kingdom",
    iata: "",
    icao: "BRU1",
    latitude: "58.44",
    longitude: "2.33",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8573",
    name: "North Sea",
    city: "Buchan Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "BUCA",
    latitude: "57.9039",
    longitude: "0.0319",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8574",
    name: "North Sea",
    city: "Buzzard",
    country: "United Kingdom",
    iata: "",
    icao: "BUZZ",
    latitude: "56.8",
    longitude: "0.766",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8575",
    name: "North Sea",
    city: "Clyde",
    country: "United Kingdom",
    iata: "",
    icao: "CLY1",
    latitude: "56.45",
    longitude: "2.2833",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8576",
    name: "North Sea",
    city: "Cormorant Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "COA1",
    latitude: "61.2333",
    longitude: "-1.15",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8577",
    name: "North Sea",
    city: "Forties Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "FA08",
    latitude: "57.7167",
    longitude: "-1.0167",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8578",
    name: "North Sea",
    city: "Forties Charlie",
    country: "United Kingdom",
    iata: "",
    icao: "FC08",
    latitude: "57.7167",
    longitude: "-1.0167",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8579",
    name: "North Sea",
    city: "Fulmar",
    country: "United Kingdom",
    iata: "",
    icao: "FUA1",
    latitude: "56.48",
    longitude: "2.13",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8580",
    name: "North Sea",
    city: "Gannet Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "GAA1",
    latitude: "57.3",
    longitude: "1.2",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8581",
    name: "North Sea",
    city: "Montrose Alpha",
    country: "United Kingdom",
    iata: "",
    icao: "MOA1",
    latitude: "57.4506",
    longitude: "1.3883",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8582",
    name: "North Sea",
    city: "Tern",
    country: "United Kingdom",
    iata: "",
    icao: "TEA1",
    latitude: "61.3333",
    longitude: "0.8333",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8583",
    name: "Atlantic Ocean",
    city: "FPSO Xikomba",
    country: "Angola",
    iata: "",
    icao: "XKSO",
    latitude: "-6.0333",
    longitude: "11.0166",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8584",
    name: "Zoo",
    city: "Berlin",
    country: "Germany",
    iata: "QWC",
    icao: "\\N",
    latitude: "52.507222",
    longitude: "13.3325",
    altitude: "120",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8585",
    name: "Frankfurt Oder Hbf",
    city: "Frankfurt Oder",
    country: "Germany",
    iata: "ZFR",
    icao: "\\N",
    latitude: "52.336944",
    longitude: "14.547222",
    altitude: "177",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8586",
    name: "Gare de Lyon",
    city: "Paris",
    country: "France",
    iata: "PLY",
    icao: "\\N",
    latitude: "48.844722",
    longitude: "2.373611",
    altitude: "129",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8587",
    name: "Gare de LEst",
    city: "Paris",
    country: "France",
    iata: "XHP",
    icao: "\\N",
    latitude: "48.876944",
    longitude: "2.359167",
    altitude: "149",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8588",
    name: "All Airports",
    city: "Paris",
    country: "France",
    iata: "PAR",
    icao: "\\N",
    latitude: "48.856389",
    longitude: "2.352222",
    altitude: "107",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8589",
    name: "Ostbahnhof",
    city: "Berlin",
    country: "Germany",
    iata: "BHF",
    icao: "\\N",
    latitude: "52.51",
    longitude: "13.434722",
    altitude: "135",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8590",
    name: "All Airports",
    city: "London",
    country: "United Kingdom",
    iata: "LON",
    icao: "\\N",
    latitude: "51.508056",
    longitude: "-0.127778",
    altitude: "66",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8591",
    name: "All Airports",
    city: "New York",
    country: "United States",
    iata: "NYC",
    icao: "\\N",
    latitude: "40.714167",
    longitude: "-74.005833",
    altitude: "31",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8592",
    name: "All Airports",
    city: "Chicago",
    country: "United States",
    iata: "CHI",
    icao: "\\N",
    latitude: "41.883611",
    longitude: "-87.631667",
    altitude: "596",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8593",
    name: "Meigs Field",
    city: "Chicago",
    country: "United States",
    iata: "CGX",
    icao: "KCGX",
    latitude: "41.860278",
    longitude: "-87.609722",
    altitude: "585",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8594",
    name: "All Airports",
    city: "Tokyo",
    country: "Japan",
    iata: "TYO",
    icao: "\\N",
    latitude: "35.689444",
    longitude: "139.691667",
    altitude: "123",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "8595",
    name: "All Airports",
    city: "Beijing",
    country: "China",
    iata: "BJS",
    icao: "\\N",
    latitude: "39.904167",
    longitude: "116.407222",
    altitude: "171",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8596",
    name: "All Airports",
    city: "Milan",
    country: "Italy",
    iata: "MIL",
    icao: "\\N",
    latitude: "45.463611",
    longitude: "9.188056",
    altitude: "402",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8597",
    name: "All Airports",
    city: "Washington",
    country: "United States",
    iata: "WAS",
    icao: "\\N",
    latitude: "38.889444",
    longitude: "-77.035278",
    altitude: "25",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8598",
    name: "All Airports",
    city: "Montreal",
    country: "Canada",
    iata: "YMQ",
    icao: "\\N",
    latitude: "45.508611",
    longitude: "-73.553889",
    altitude: "53",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8599",
    name: "All Airports",
    city: "Toronto",
    country: "Canada",
    iata: "YTO",
    icao: "\\N",
    latitude: "43.653056",
    longitude: "-79.383056",
    altitude: "302",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8600",
    name: "Longhua Airport",
    city: "Shanghai",
    country: "China",
    iata: "",
    icao: "ZSSL",
    latitude: "31.166944",
    longitude: "121.453611",
    altitude: "14",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8601",
    name: "Pickens County Airport",
    city: "Jasper",
    country: "United States",
    iata: "JZP",
    icao: "KJZP",
    latitude: "34.4534722",
    longitude: "-84.4572222",
    altitude: "1535",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8602",
    name: "Gesundbrunnen",
    city: "Berlin",
    country: "Germany",
    iata: "BGS",
    icao: "\\N",
    latitude: "52.548611",
    longitude: "13.389444",
    altitude: "150",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8603",
    name: "Saarmund Airport",
    city: "Saarmund",
    country: "Germany",
    iata: "",
    icao: "EDCS",
    latitude: "52.3089943",
    longitude: "13.1006727",
    altitude: "160",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8604",
    name: "Grand Strand Airport",
    city: "North Myrtle Beach",
    country: "United States",
    iata: "CRE",
    icao: "\\N",
    latitude: "33.81175",
    longitude: "-78.7239444",
    altitude: "31",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8605",
    name: "Sun Moon Lake Airport",
    city: "Sun Moon Lake",
    country: "Taiwan",
    iata: "SMT",
    icao: "\\N",
    latitude: "23.8833",
    longitude: "120.933",
    altitude: "2405",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "8606",
    name: "Lansing Municipal",
    city: "Lansing",
    country: "United States",
    iata: "IGQ",
    icao: "KIGQ",
    latitude: "41.5349167",
    longitude: "-87.5295278",
    altitude: "620",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8607",
    name: "Bloyer Field",
    city: "Tomah",
    country: "United States",
    iata: "Y72",
    icao: "\\N",
    latitude: "43.9762222",
    longitude: "-90.4806111",
    altitude: "966",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8608",
    name: "Ramona Airport",
    city: "Ramona",
    country: "United States",
    iata: "RNM",
    icao: "KRNM",
    latitude: "33.0391667",
    longitude: "-116.91525",
    altitude: "1395",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8609",
    name: "Dole-Pont Sur Yonne Airport",
    city: "Pont Sur Yonne",
    country: "France",
    iata: "",
    icao: "LFGO",
    latitude: "48.288333",
    longitude: "3.246389",
    altitude: "223",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8610",
    name: "Dole-St Florentin Cheu Airport",
    city: "St Florentin Cheu",
    country: "France",
    iata: "",
    icao: "LFGP",
    latitude: "47.981389",
    longitude: "3.776389",
    altitude: "345",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8611",
    name: "Guiscriff-Saulieu Liernais Airport",
    city: "Saulieu",
    country: "France",
    iata: "",
    icao: "LFEW",
    latitude: "47.238611",
    longitude: "4.263056",
    altitude: "1699",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8612",
    name: "Olten Airport",
    city: "Olten",
    country: "Switzerland",
    iata: "",
    icao: "LSPO",
    latitude: "47.343611",
    longitude: "7.8875",
    altitude: "1370",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8613",
    name: "Buochs Airport",
    city: "Buochs",
    country: "Switzerland",
    iata: "BXO",
    icao: "LSZC",
    latitude: "46.9725",
    longitude: "8.398611",
    altitude: "1464",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8614",
    name: "Ambri Airport",
    city: "Quinto",
    country: "Switzerland",
    iata: "",
    icao: "LSPM",
    latitude: "46.513056",
    longitude: "8.689444",
    altitude: "3214",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8615",
    name: "Lodrino Airport",
    city: "Lodrino",
    country: "Switzerland",
    iata: "",
    icao: "LSML",
    latitude: "46.29499",
    longitude: "8.9916",
    altitude: "850",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8616",
    name: "Roudnice Airport",
    city: "Roudnice nad Lebem",
    country: "Czech Republic",
    iata: "",
    icao: "LKRO",
    latitude: "50.407222",
    longitude: "14.232778",
    altitude: "719",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "8617",
    name: "Usti Nad Labem Airport",
    city: "Usti Nad Labem",
    country: "Czech Republic",
    iata: "",
    icao: "LKUL",
    latitude: "50.698889",
    longitude: "13.970833",
    altitude: "765",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "8618",
    name: "Mauterndorf Airport",
    city: "Mauterndorf",
    country: "Austria",
    iata: "",
    icao: "LOSM",
    latitude: "47.131667",
    longitude: "13.695278",
    altitude: "3629",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8619",
    name: "Notsch Im Gailtal Airport",
    city: "Notsch Im Gailtal",
    country: "Austria",
    iata: "",
    icao: "LOKN",
    latitude: "46.580833",
    longitude: "13.629167",
    altitude: "1810",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8620",
    name: "Forchheim Airport",
    city: "Karlsruhe",
    country: "Germany",
    iata: "",
    icao: "EDTK",
    latitude: "49.097778",
    longitude: "8.453056",
    altitude: "400",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8621",
    name: "Bergstrasse Airport",
    city: "Weinheim",
    country: "Germany",
    iata: "",
    icao: "EDGZ",
    latitude: "49.567222",
    longitude: "8.611389",
    altitude: "319",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8622",
    name: "Creil-Meaux Esbly Airport",
    city: "Meaux",
    country: "France",
    iata: "",
    icao: "LFPE",
    latitude: "48.928611",
    longitude: "2.833056",
    altitude: "210",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8623",
    name: "Belleau Airport",
    city: "Chateau-Thierry",
    country: "France",
    iata: "",
    icao: "LFFH",
    latitude: "49.066944",
    longitude: "3.356111",
    altitude: "719",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8624",
    name: "Branch County Memorial Airport",
    city: "Coldwater",
    country: "United States",
    iata: "OEB",
    icao: "KOEB",
    latitude: "41.9335691",
    longitude: "-85.0522935",
    altitude: "959",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8625",
    name: "Wilkes-Barre Wyoming Valley Airport",
    city: "Wilkes-Barre",
    country: "United States",
    iata: "WBW",
    icao: "KWBW",
    latitude: "41.2973074",
    longitude: "-75.8522405",
    altitude: "543",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8626",
    name: "Lost Nation Municipal Airport",
    city: "Willoughby",
    country: "United States",
    iata: "LNN",
    icao: "KLNN",
    latitude: "41.6840278",
    longitude: "-81.38975",
    altitude: "626",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8627",
    name: "Taoyuan Air Base",
    city: "Taoyuan",
    country: "Taiwan",
    iata: "",
    icao: "RCGM",
    latitude: "25.05660057",
    longitude: "121.2442627",
    altitude: "143",
    timezone: "8",
    dst: "U",
    tz: "Asia/Taipei",
  },
  {
    id: "8628",
    name: "Uummannaq Heliport",
    city: "Uummannaq",
    country: "Greenland",
    iata: "UMD",
    icao: "BGUM",
    latitude: "70.4047",
    longitude: "52.0702",
    altitude: "5",
    timezone: "-4",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "8629",
    name: "Civitavecchia",
    city: "Civitavecchia",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "42.6",
    longitude: "11.48",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8630",
    name: "Bayannur",
    city: "Bayannur",
    country: "China",
    iata: "RLK",
    icao: "\\N",
    latitude: "40.926389",
    longitude: "107.738889",
    altitude: "3389",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8631",
    name: "Capital City Airport",
    city: "Frankfort",
    country: "United States",
    iata: "FFT",
    icao: "KFFT",
    latitude: "38.1819722",
    longitude: "-84.9061389",
    altitude: "812",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8632",
    name: "Lewiston Maine",
    city: "Lewiston",
    country: "United States",
    iata: "LEW",
    icao: "KLEW",
    latitude: "44.0484728",
    longitude: "-70.2835075",
    altitude: "288",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8633",
    name: "Inowroclaw Inowr Airport",
    city: "Inowroclaw",
    country: "Poland",
    iata: "",
    icao: "EPIR",
    latitude: "52.829444",
    longitude: "18.330556",
    altitude: "259",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8634",
    name: "Pruszcz Gdansk Airport",
    city: "Pruszcz Gdansk",
    country: "Poland",
    iata: "",
    icao: "EPPR",
    latitude: "54.248056",
    longitude: "18.671667",
    altitude: "21",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8635",
    name: "Florence",
    city: "Florence",
    country: "United States",
    iata: "6S2",
    icao: "\\N",
    latitude: "43.9828168",
    longitude: "-124.1113687",
    altitude: "51",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8636",
    name: "Martin Campbell Field Airport",
    city: "Copperhead",
    country: "United States",
    iata: "1A3",
    icao: "\\N",
    latitude: "35.0158056",
    longitude: "-84.3468333",
    altitude: "1789",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8637",
    name: "Sudkreuz",
    city: "Berlin",
    country: "Germany",
    iata: "",
    icao: "BPAP",
    latitude: "52.475556",
    longitude: "13.364444",
    altitude: "136",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8638",
    name: "Naval Air Station",
    city: "Glenview",
    country: "United States",
    iata: "NBU",
    icao: "KNBU",
    latitude: "42.090556",
    longitude: "-87.8225",
    altitude: "653",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8639",
    name: "Bloyer Field",
    city: "Tomah",
    country: "United States",
    iata: "",
    icao: "KY72",
    latitude: "43.975278",
    longitude: "-90.483333",
    altitude: "965",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8640",
    name: "Yongning Air Base",
    city: "Beijing",
    country: "China",
    iata: "",
    icao: "CN-0",
    latitude: "40.50310135",
    longitude: "116.1080017",
    altitude: "1677",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8641",
    name: "Marco Islands",
    city: "Marco Island Airport",
    country: "United States",
    iata: "MRK",
    icao: "KMKY",
    latitude: "25.9950278",
    longitude: "-81.6725278",
    altitude: "5",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8642",
    name: "Boipeba",
    city: "Boipeba Island",
    country: "Brazil",
    iata: "",
    icao: "\\N",
    latitude: "-13.565589",
    longitude: "-38.939241",
    altitude: "5",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "8643",
    name: "Boipeba",
    city: "Boipeba Island",
    country: "Brazil",
    iata: "",
    icao: "\\N",
    latitude: "-13.565589",
    longitude: "-38.939241",
    altitude: "5",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "8644",
    name: "Drummond Island Airport",
    city: "Drummond Island",
    country: "United States",
    iata: "DRM",
    icao: "KDRM",
    latitude: "46.0093114",
    longitude: "-83.7439342",
    altitude: "668",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8645",
    name: "Garland Airport",
    city: "Lewiston",
    country: "United States",
    iata: "8M8",
    icao: "\\N",
    latitude: "44.8065278",
    longitude: "-84.2761944",
    altitude: "1218",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8646",
    name: "Gladwin Zettel Memorial Airport",
    city: "Gladwin",
    country: "United States",
    iata: "GDW",
    icao: "KGDW",
    latitude: "43.9705893",
    longitude: "-84.47502",
    altitude: "774",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8647",
    name: "Lowell City Airport",
    city: "Lowell",
    country: "United States",
    iata: "24C",
    icao: "\\N",
    latitude: "42.95392",
    longitude: "-85.3439058",
    altitude: "681",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8648",
    name: "South Haven Area Regional Airport",
    city: "South Haven",
    country: "United States",
    iata: "LWA",
    icao: "KLWA",
    latitude: "42.3511944",
    longitude: "-86.2556389",
    altitude: "666",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8649",
    name: "Schaumburg Regional",
    city: "Schaumburg",
    country: "United States",
    iata: "06C",
    icao: "\\N",
    latitude: "41.9893408",
    longitude: "-88.1012428",
    altitude: "801",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8650",
    name: "Khulna Seaplane Landing Site",
    city: "Khulna",
    country: "Bangladesh",
    iata: "",
    icao: "\\N",
    latitude: "22.464897",
    longitude: "89.351261",
    altitude: "0",
    timezone: "6",
    dst: "N",
    tz: "Asia/Dhaka",
  },
  {
    id: "8651",
    name: "Khulna Seaplane Landing Site",
    city: "Khulna",
    country: "Bangladesh",
    iata: "",
    icao: "\\N",
    latitude: "22.464897",
    longitude: "89.351261",
    altitude: "0",
    timezone: "6",
    dst: "N",
    tz: "Asia/Dhaka",
  },
  {
    id: "8652",
    name: "Khulna Seaplane Landing Site",
    city: "Khulna",
    country: "Bangladesh",
    iata: "",
    icao: "\\N",
    latitude: "22.464897",
    longitude: "89.351261",
    altitude: "0",
    timezone: "6",
    dst: "N",
    tz: "Asia/Dhaka",
  },
  {
    id: "8653",
    name: "Marshfield Municipal Airport",
    city: "Marshfield",
    country: "United States",
    iata: "MFI",
    icao: "KMFI",
    latitude: "44.6368797",
    longitude: "-90.1893267",
    altitude: "1278",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8654",
    name: "Alexander Field South Wood County Airport",
    city: "Wisconsin Rapids",
    country: "United States",
    iata: "ISW",
    icao: "KISW",
    latitude: "44.3606456",
    longitude: "-89.8381412",
    altitude: "1021",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8655",
    name: "Clinton Municipal",
    city: "Clinton",
    country: "United States",
    iata: "CWI",
    icao: "KCWI",
    latitude: "41.83075",
    longitude: "-90.3289722",
    altitude: "708",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8656",
    name: "Wiescheid",
    city: "Langenfeld",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.141663",
    longitude: "6.987305",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8657",
    name: "Wadi Rum",
    city: "Wadi Rum Desert",
    country: "Jordan",
    iata: "",
    icao: "\\N",
    latitude: "29.682087",
    longitude: "35.470734",
    altitude: "1000",
    timezone: "2",
    dst: "U",
    tz: "Asia/Amman",
  },
  {
    id: "8658",
    name: "Beverly Municipal Airport",
    city: "Beverly",
    country: "United States",
    iata: "BVY",
    icao: "KBVY",
    latitude: "42.584141",
    longitude: "-70.9161444",
    altitude: "107",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8659",
    name: "Priob\\\\'e",
    city: "Priob\\\\'e",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "62.5461",
    longitude: "65.6261",
    altitude: "200",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "8660",
    name: "Nagaur Airport",
    city: "Nagaur",
    country: "India",
    iata: "",
    icao: "VI73",
    latitude: "27.20829964",
    longitude: "73.71140289",
    altitude: "3853",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Calcutta",
  },
  {
    id: "8661",
    name: "Ostafyevo International Airport",
    city: "Moscow",
    country: "Russia",
    iata: "",
    icao: "UUMO",
    latitude: "55.511667",
    longitude: "37.507222",
    altitude: "568",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8662",
    name: "Oakdale Airport",
    city: "Oakdale",
    country: "United States",
    iata: "O27",
    icao: "\\N",
    latitude: "37.7563333",
    longitude: "-120.8001944",
    altitude: "237",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8663",
    name: "Trois Rivieres Airport",
    city: "Trois Rivieres",
    country: "Canada",
    iata: "YRQ",
    icao: "CYRQ",
    latitude: "46.351667",
    longitude: "-72.680556",
    altitude: "199",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8664",
    name: "Poplar Bluff Municipal Airport",
    city: "Poplar Bluff",
    country: "United States",
    iata: "POF",
    icao: "KPOF",
    latitude: "36.77394444",
    longitude: "-90.3248611",
    altitude: "331",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8665",
    name: "Somerset Airport",
    city: "Somerville",
    country: "United States",
    iata: "",
    icao: "KSMQ",
    latitude: "40.6259908",
    longitude: "-74.6702433",
    altitude: "105",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8666",
    name: "Eastport Municipal Airport",
    city: "Eastport",
    country: "United States",
    iata: "EPM",
    icao: "KEPM",
    latitude: "44.9101111",
    longitude: "-67.0126944",
    altitude: "45",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8667",
    name: "Keokuk Municipal Airport",
    city: "Keokuk",
    country: "United States",
    iata: "EOK",
    icao: "KEOK",
    latitude: "40.4599078",
    longitude: "-91.4285011",
    altitude: "671",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8668",
    name: "Banks Airport",
    city: "Swans Island",
    country: "United States",
    iata: "ME5",
    icao: "\\N",
    latitude: "44.1653889",
    longitude: "-68.4281667",
    altitude: "100",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8669",
    name: "Perth Scone Airport",
    city: "Perth",
    country: "United Kingdom",
    iata: "PSL",
    icao: "EGPT",
    latitude: "56.439722",
    longitude: "-3.371389",
    altitude: "392",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8670",
    name: "Caernarfon Airport",
    city: "Caernarfon",
    country: "United Kingdom",
    iata: "",
    icao: "EGCK",
    latitude: "53.104167",
    longitude: "-4.340278",
    altitude: "14",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8671",
    name: "Grefrath-Niershorst Airport",
    city: "Grefrath",
    country: "Germany",
    iata: "",
    icao: "EDLF",
    latitude: "51.333889",
    longitude: "6.359444",
    altitude: "105",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8672",
    name: "Offenburg",
    city: "Offenburg",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.4711",
    longitude: "7.9411",
    altitude: "535",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8673",
    name: "Oberwolfach",
    city: "Oberwolfach",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.3167",
    longitude: "8.2167",
    altitude: "1060",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8674",
    name: "Karlsruhe Hbf",
    city: "Karlsruhe",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.0135",
    longitude: "8.4044",
    altitude: "377",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8675",
    name: "Lichtenwalde",
    city: "Lichtenwalde",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.8833",
    longitude: "13.0167",
    altitude: "984",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8676",
    name: "Karlsruhe",
    city: "Karlsruhe",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.0135",
    longitude: "8.4044",
    altitude: "377",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8677",
    name: "Holzhau",
    city: "Holzhau",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.7333334",
    longitude: "13.6",
    altitude: "1969",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8678",
    name: "Porto",
    city: "Porto",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "41.1667",
    longitude: "8.5833",
    altitude: "341",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8679",
    name: "Lisboa-Oriente",
    city: "Lisboa",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "38.424972",
    longitude: "9.82179",
    altitude: "7",
    timezone: "0",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "8680",
    name: "Bad Herrenalb",
    city: "Bad Herrenalb",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.7976817",
    longitude: "8.4361503",
    altitude: "1198",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8681",
    name: "St. Paul Downtown Airport - Holman Field",
    city: "St. Paul",
    country: "United States",
    iata: "",
    icao: "KSTP",
    latitude: "44.9346225",
    longitude: "-93.0603424",
    altitude: "705",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8682",
    name: "Soderhamn Airport",
    city: "Soderhamn",
    country: "Sweden",
    iata: "SOO",
    icao: "ESCL",
    latitude: "61.261667",
    longitude: "17.098056",
    altitude: "94",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "8683",
    name: "Newcastle Airfield",
    city: "Newcastle",
    country: "Ireland",
    iata: "",
    icao: "EINC",
    latitude: "53.073056",
    longitude: "-6.039722",
    altitude: "14",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "8684",
    name: "Saravane Airport",
    city: "Saravane",
    country: "Laos",
    iata: "VNA",
    icao: "VLSV",
    latitude: "15.709444",
    longitude: "106.411667",
    altitude: "612",
    timezone: "7",
    dst: "U",
    tz: "Asia/Vientiane",
  },
  {
    id: "8685",
    name: "Lisboa-Oriente",
    city: "Lisboa",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "38.7",
    longitude: "9.1833",
    altitude: "6",
    timezone: "0",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "8686",
    name: "Lisboa-Oriente",
    city: "Lisboa-Oriente",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "38.7",
    longitude: "-9.1833",
    altitude: "6",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "8687",
    name: "Zurich",
    city: "Zurich",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "47.369",
    longitude: "8.538",
    altitude: "1339",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8688",
    name: "Bagdad Airport",
    city: "Bagdad",
    country: "United States",
    iata: "E51",
    icao: "\\N",
    latitude: "34.5958528",
    longitude: "-113.170195",
    altitude: "4183",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "8689",
    name: "Segeletz Airport",
    city: "Segeletz",
    country: "Germany",
    iata: "",
    icao: "EDAI",
    latitude: "52.826667",
    longitude: "12.541944",
    altitude: "141",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8690",
    name: "Fuentemilanos Airport",
    city: "Segovia",
    country: "Spain",
    iata: "",
    icao: "LEFM",
    latitude: "40.889233",
    longitude: "-4.239478",
    altitude: "3284",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "8691",
    name: "Akeno Aero",
    city: "Akeno",
    country: "Japan",
    iata: "",
    icao: "RJOE",
    latitude: "34.533333",
    longitude: "136.672222",
    altitude: "12",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "8692",
    name: "Ust Kamchatsk Airport",
    city: "Ust Kamchatsk",
    country: "Russia",
    iata: "",
    icao: "UHPK",
    latitude: "56.238556",
    longitude: "162.688851",
    altitude: "200",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "8693",
    name: "Oconomowoc Airport",
    city: "Oconomowoc",
    country: "United States",
    iata: "",
    icao: "0WI8",
    latitude: "43.1388947",
    longitude: "-88.4723206",
    altitude: "885",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8694",
    name: "Kozyrevsk Airport",
    city: "Kozyrevsk",
    country: "Russia",
    iata: "",
    icao: "UHPO",
    latitude: "56.09",
    longitude: "159.876663",
    altitude: "331",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "8695",
    name: "Dikson Airport",
    city: "Dikson",
    country: "Russia",
    iata: "DKS",
    icao: "UODD",
    latitude: "73.517807",
    longitude: "80.379669",
    altitude: "47",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "8696",
    name: "Beverley Airport",
    city: "Mine Site",
    country: "Australia",
    iata: "",
    icao: "YBEE",
    latitude: "-30.19033959",
    longitude: "139.5554942",
    altitude: "381",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "8697",
    name: "Bogande Airport",
    city: "Bogande",
    country: "Canada",
    iata: "XBG",
    icao: "\\N",
    latitude: "48.329498",
    longitude: "-70.995697",
    altitude: "531",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8698",
    name: "Bantry Aerodrome",
    city: "Bantry",
    country: "Ireland",
    iata: "BYT",
    icao: "EIBN",
    latitude: "51.668598",
    longitude: "-9.48417",
    altitude: "7",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "8699",
    name: "Reeroe Airport",
    city: "Caherciveen",
    country: "Ireland",
    iata: "CHE",
    icao: "\\N",
    latitude: "51.933334",
    longitude: "-10.233333",
    altitude: "314",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "8700",
    name: "Aliwal North",
    city: "Aliwal North",
    country: "South Africa",
    iata: "",
    icao: "FAAN",
    latitude: "-30.683333",
    longitude: "26.733333",
    altitude: "4361",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8701",
    name: "Alkantpan Airport",
    city: "Alkantpan",
    country: "South Africa",
    iata: "",
    icao: "FACO",
    latitude: "-29.906389",
    longitude: "22.316667",
    altitude: "3585",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8702",
    name: "Alldays Airport",
    city: "Alldays",
    country: "South Africa",
    iata: "ADY",
    icao: "FAAL",
    latitude: "-22.678889",
    longitude: "29.055278",
    altitude: "2676",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8703",
    name: "Barberton Airport",
    city: "Barberton",
    country: "South Africa",
    iata: "",
    icao: "FABR",
    latitude: "-25.7175",
    longitude: "30.975",
    altitude: "2260",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "8704",
    name: "Ocean Ridge Airport",
    city: "Gualala",
    country: "United States",
    iata: "E55",
    icao: "\\N",
    latitude: "38.8016111",
    longitude: "-123.5306389",
    altitude: "940",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8705",
    name: "Kent State Airport",
    city: "Kent",
    country: "United States",
    iata: "1G3",
    icao: "\\N",
    latitude: "41.1513889",
    longitude: "-81.4151111",
    altitude: "1134",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8706",
    name: "Bulter County Regional Airport",
    city: "Hamilton",
    country: "United States",
    iata: "",
    icao: "KHAO",
    latitude: "39.36375",
    longitude: "-84.5219444",
    altitude: "633",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8707",
    name: "Bungoma Airport",
    city: "Bungoma",
    country: "Kenya",
    iata: "",
    icao: "HKBU",
    latitude: "0.576389",
    longitude: "34.551389",
    altitude: "4752",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8708",
    name: "Bura East",
    city: "Bura",
    country: "Kenya",
    iata: "",
    icao: "HKBR",
    latitude: "-1.185",
    longitude: "39.813889",
    altitude: "295",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8709",
    name: "Busia",
    city: "Busia",
    country: "Kenya",
    iata: "",
    icao: "HKBA",
    latitude: "0.272",
    longitude: "34.748",
    altitude: "3989",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8710",
    name: "Embu",
    city: "Embu",
    country: "Kenya",
    iata: "",
    icao: "HKEM",
    latitude: "-0.568889",
    longitude: "37.492222",
    altitude: "4131",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8711",
    name: "Garba Tula",
    city: "Garba Tula",
    country: "Kenya",
    iata: "",
    icao: "HKGT",
    latitude: "0.3112",
    longitude: "38.3056",
    altitude: "1764",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8712",
    name: "Garissa",
    city: "Garissa",
    country: "Kenya",
    iata: "GAS",
    icao: "HKGA",
    latitude: "-0.468611",
    longitude: "39.649444",
    altitude: "469",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8713",
    name: "Hola",
    city: "Hola",
    country: "Kenya",
    iata: "HOA",
    icao: "HKHO",
    latitude: "-1.52",
    longitude: "40.00389",
    altitude: "220",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8714",
    name: "Homa Bay",
    city: "Homa Bay",
    country: "Kenya",
    iata: "",
    icao: "HKHB",
    latitude: "-0.591668",
    longitude: "34.48",
    altitude: "4231",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8715",
    name: "Isiolo",
    city: "Isiolo",
    country: "Kenya",
    iata: "",
    icao: "HKIS",
    latitude: "0.34361",
    longitude: "37.587778",
    altitude: "3688",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8716",
    name: "Kalokol",
    city: "Kalokol",
    country: "Kenya",
    iata: "KLK",
    icao: "HYFG",
    latitude: "3.49",
    longitude: "35.84",
    altitude: "1296",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8717",
    name: "Kericho",
    city: "Kericho",
    country: "Kenya",
    iata: "KEY",
    icao: "HKKR",
    latitude: "-0.385",
    longitude: "35.245",
    altitude: "6453",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8718",
    name: "Kilaguni",
    city: "Kilaguni",
    country: "Kenya",
    iata: "ILU",
    icao: "HKKL",
    latitude: "-2.9",
    longitude: "38.073889",
    altitude: "2832",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8719",
    name: "Kerio Valley",
    city: "Kimwarer",
    country: "Kenya",
    iata: "KRV",
    icao: "\\N",
    latitude: "0.1912",
    longitude: "35.3954",
    altitude: "7095",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8720",
    name: "Andavadoaka",
    city: "Andavadoaka",
    country: "Madagascar",
    iata: "DVD",
    icao: "\\N",
    latitude: "-22.111111",
    longitude: "43.270556",
    altitude: "27",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "8721",
    name: "Antsirabe",
    city: "Antsirabe",
    country: "Madagascar",
    iata: "ATJ",
    icao: "FMME",
    latitude: "-19.836944",
    longitude: "47.065278",
    altitude: "4913",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "8722",
    name: "Bekily",
    city: "Bekily",
    country: "Madagascar",
    iata: "OVA",
    icao: "FMSL",
    latitude: "-24.236111",
    longitude: "45.305",
    altitude: "1259",
    timezone: "3",
    dst: "U",
    tz: "Indian/Antananarivo",
  },
  {
    id: "8723",
    name: "Ust-Tsylma",
    city: "Ust-Tsylma",
    country: "Russia",
    iata: "",
    icao: "UUYX",
    latitude: "65.434722232222",
    longitude: "52.20000001",
    altitude: "262",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8724",
    name: "Atlantic City Rail Terminal",
    city: "Atlantic City NJ",
    country: "United States",
    iata: "ZRA",
    icao: "\\N",
    latitude: "39.3665",
    longitude: "-74.442",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8725",
    name: "Springfield Amtrak Station",
    city: "Springfield MA",
    country: "United States",
    iata: "ZSF",
    icao: "\\N",
    latitude: "42.106",
    longitude: "-72.593054",
    altitude: "65",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8726",
    name: "Amherst Amtrak Station AMM",
    city: "Amherst MA",
    country: "United States",
    iata: "XZK",
    icao: "\\N",
    latitude: "42.375",
    longitude: "-72.511389",
    altitude: "258",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8727",
    name: "Cape May Ferry Terminal",
    city: "Cape May NJ",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "38.9696286",
    longitude: "-74.960918",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8728",
    name: "Lewes Ferry Terminal",
    city: "Lewes DE",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "38.781655",
    longitude: "-75.119534",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8729",
    name: "Bar Harbor Yarmouth Ferry Terminal",
    city: "Bar Harbor ME",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "44.39917",
    longitude: "-68.225",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8730",
    name: "Yarmouth Ferry Terminal",
    city: "Yarmouth NS",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.833227",
    longitude: "-66.122653",
    altitude: "0",
    timezone: "-4",
    dst: "A",
    tz: "America/Halifax",
  },
  {
    id: "8731",
    name: "Gare de Montreux Railway Station",
    city: "Montreux",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.435833",
    longitude: "6.910278",
    altitude: "1280",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "8732",
    name: "London - Kings Cross",
    city: "London",
    country: "United Kingdom",
    iata: "QQK",
    icao: "\\N",
    latitude: "51.5326",
    longitude: "0.1233",
    altitude: "72",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8733",
    name: "Stevenage Railway Station",
    city: "Stevenage",
    country: "United Kingdom",
    iata: "XVJ",
    icao: "\\N",
    latitude: "51.902",
    longitude: "0.207",
    altitude: "262",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8734",
    name: "Peterborough Railway Station",
    city: "Peterborough",
    country: "United Kingdom",
    iata: "XVH",
    icao: "\\N",
    latitude: "52.5748",
    longitude: "-0.2502",
    altitude: "91",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8735",
    name: "Pomalaa",
    city: "Pomalaa",
    country: "Indonesia",
    iata: "PUM",
    icao: "\\N",
    latitude: "-4.183333",
    longitude: "121.61667",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "8736",
    name: "St. Ignace Ferry Dock",
    city: "St. Ignace MI",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "45.866405",
    longitude: "-84.720254",
    altitude: "587",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8737",
    name: "Mackinac Island Dock",
    city: "Mackinac Island MI",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "45.848801",
    longitude: "-84.615927",
    altitude: "889",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8738",
    name: "YUR'EVETS",
    city: "YUR'EVETS",
    country: "Russia",
    iata: "",
    icao: "UUIC",
    latitude: "57.338582",
    longitude: "43.0949",
    altitude: "413",
    timezone: "4",
    dst: "E",
    tz: "Europe/Moscow",
  },
  {
    id: "8739",
    name: "Whittlesford Parkway Rail Station",
    city: "Whittlesford",
    country: "United Kingdom",
    iata: "WLF",
    icao: "\\N",
    latitude: "52.104",
    longitude: "0.166",
    altitude: "95",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8740",
    name: "Gorno-Altaysk Airport",
    city: "Gorno-Altaysk",
    country: "Russia",
    iata: "RGK",
    icao: "UNBG",
    latitude: "51.966667",
    longitude: "85.833333",
    altitude: "965",
    timezone: "7",
    dst: "U",
    tz: "Asia/Omsk",
  },
  {
    id: "8741",
    name: "Gryzliny - Lansk",
    city: "Gryzliny",
    country: "Poland",
    iata: "",
    icao: "EPGR",
    latitude: "53.3629",
    longitude: "20.204",
    altitude: "520",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8742",
    name: "Fond Du Lac County Airport",
    city: "Fond du Lac",
    country: "United States",
    iata: "FLD",
    icao: "KFLD",
    latitude: "43.7711667",
    longitude: "-88.4884167",
    altitude: "808",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8743",
    name: "Waupaca Municipal Airport",
    city: "Waupaca",
    country: "United States",
    iata: "PCZ",
    icao: "KPCZ",
    latitude: "44.33325",
    longitude: "-89.0197778",
    altitude: "840",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8744",
    name: "Stevens Point Municipal Airport",
    city: "Stevens Point",
    country: "United States",
    iata: "STE",
    icao: "KSTE",
    latitude: "44.5451356",
    longitude: "-89.5302844",
    altitude: "1110",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8745",
    name: "Mys Shmidta Airport",
    city: "Mys Shmidta",
    country: "Russia",
    iata: "",
    icao: "UHMI",
    latitude: "68.868301",
    longitude: "179.373001",
    altitude: "20",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "8746",
    name: "Moma Airport",
    city: "Honuu",
    country: "Russia",
    iata: "",
    icao: "UEMA",
    latitude: "66.450859",
    longitude: "143.261551",
    altitude: "656",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "8747",
    name: "Luce County Airport",
    city: "Newberry",
    country: "United States",
    iata: "ERY",
    icao: "KERY",
    latitude: "46.311199",
    longitude: "-85.457298",
    altitude: "869",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8748",
    name: "Forest Lake Airport",
    city: "Forest Lake",
    country: "United States",
    iata: "25D",
    icao: "\\N",
    latitude: "45.2477456",
    longitude: "-92.9943853",
    altitude: "925",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8749",
    name: "Hannover Messe-Heliport",
    city: "Hannover",
    country: "Germany",
    iata: "ZVM",
    icao: "\\N",
    latitude: "52.329035",
    longitude: "9.822136",
    altitude: "152",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8750",
    name: "Peenemunde Airfield",
    city: "Peenemunde",
    country: "Germany",
    iata: "PEF",
    icao: "EDCP",
    latitude: "54.157778",
    longitude: "13.772778",
    altitude: "7",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8751",
    name: "Goraszka",
    city: "Goraszka",
    country: "Poland",
    iata: "",
    icao: "EPGO",
    latitude: "52.1104",
    longitude: "21.1652",
    altitude: "110",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8752",
    name: "Pangandaran-Java Island-Nusawiru Airport",
    city: "Nusawiru",
    country: "Indonesia",
    iata: "",
    icao: "WI1A",
    latitude: "-7.72039",
    longitude: "108.489998",
    altitude: "16",
    timezone: "7",
    dst: "N",
    tz: "Asia/Jakarta",
  },
  {
    id: "8753",
    name: "Pom Pom Camp",
    city: "Pom Pom",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.35",
    longitude: "22.5",
    altitude: "965",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "8754",
    name: "Moremi Crossing",
    city: "Moremi",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.31",
    longitude: "23.08",
    altitude: "965",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "8755",
    name: "New Delhi Train Station",
    city: "New Delhi",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "28.64197",
    longitude: "77.2206",
    altitude: "708",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "8756",
    name: "Agra Cantonment Railway Station",
    city: "Agra",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "27.1578",
    longitude: "77.98993",
    altitude: "571",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "8757",
    name: "Urumqi Railway Station",
    city: "Urumqi",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "43.7809",
    longitude: "87.585",
    altitude: "2844",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8758",
    name: "Turpan Railway Station",
    city: "Turpan",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "43.151",
    longitude: "88.875",
    altitude: "98",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8759",
    name: "Galion Municipal Airport",
    city: "Galion",
    country: "United States",
    iata: "GQQ",
    icao: "KGQQ",
    latitude: "40.7533889",
    longitude: "-82.7238056",
    altitude: "1224",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8760",
    name: "Musiara Airstrip",
    city: "Musiara",
    country: "Kenya",
    iata: "",
    icao: "HKMZ",
    latitude: "-1.29861",
    longitude: "35.063611",
    altitude: "5200",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8761",
    name: "Tiputini",
    city: "Tiputini",
    country: "Ecuador",
    iata: "TPN",
    icao: "SETI",
    latitude: "-0.766667",
    longitude: "-75.53333",
    altitude: "997",
    timezone: "-5",
    dst: "S",
    tz: "America/Guayaquil",
  },
  {
    id: "8762",
    name: "Shell Mera",
    city: "Pastaza",
    country: "Ecuador",
    iata: "PTZ",
    icao: "SESM",
    latitude: "-2",
    longitude: "-77",
    altitude: "7076",
    timezone: "-5",
    dst: "S",
    tz: "America/Guayaquil",
  },
  {
    id: "8763",
    name: "Clarksville-Montgomery County Regional Airport",
    city: "Clarksville",
    country: "United States",
    iata: "CKV",
    icao: "KCKV",
    latitude: "36.621944",
    longitude: "-87.415",
    altitude: "550",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8764",
    name: "Oban Rail Station",
    city: "Oban",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "56.4124",
    longitude: "-5.4702",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8765",
    name: "Memmingen Rail Station",
    city: "Memmingen",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "47.9878",
    longitude: "10.1811",
    altitude: "2077",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8766",
    name: "Ulm Railway Station",
    city: "Ulm",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "48.4",
    longitude: "9.9833",
    altitude: "1641",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8767",
    name: "Aachen HBF",
    city: "Aachen",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.7667",
    longitude: "6.1",
    altitude: "873",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8768",
    name: "Liege-Guillemins Railway Station",
    city: "Liege",
    country: "Belgium",
    iata: "XHN",
    icao: "\\N",
    latitude: "50.6333",
    longitude: "5.56667",
    altitude: "659",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8769",
    name: "Bruxelles-Central",
    city: "Brussels",
    country: "Belgium",
    iata: "",
    icao: "FBCL",
    latitude: "50.8411",
    longitude: "4.3564",
    altitude: "43",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8770",
    name: "Wyk auf Foehr",
    city: "Wyk",
    country: "Germany",
    iata: "OHR",
    icao: "\\N",
    latitude: "54.411",
    longitude: "8.3145",
    altitude: "24",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8771",
    name: "Lompoc Airport",
    city: "Lompoc",
    country: "United States",
    iata: "LPC",
    icao: "KLPC",
    latitude: "34.6656",
    longitude: "-120.4675",
    altitude: "88",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8772",
    name: "Chester County G O Carlson Airport",
    city: "Coatesville",
    country: "United States",
    iata: "CTH",
    icao: "KMQS",
    latitude: "39.9789",
    longitude: "-75.8654",
    altitude: "660",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8773",
    name: "Bost Airport",
    city: "Lashkar Gah",
    country: "Afghanistan",
    iata: "BST",
    icao: "OABT",
    latitude: "31.558889",
    longitude: "64.364167",
    altitude: "2464",
    timezone: "4.5",
    dst: "U",
    tz: "Asia/Kabul",
  },
  {
    id: "8774",
    name: "Lankaran International Airport",
    city: "Lankaran",
    country: "Azerbaijan",
    iata: "LLK",
    icao: "UBBL",
    latitude: "38.746389",
    longitude: "48.817778",
    altitude: "30",
    timezone: "4",
    dst: "U",
    tz: "Asia/Baku",
  },
  {
    id: "8775",
    name: "Qabala Airport",
    city: "Qabala",
    country: "Azerbaijan",
    iata: "GBB",
    icao: "UBBQ",
    latitude: "40.826667",
    longitude: "47.7125",
    altitude: "100",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "8776",
    name: "Zaqatala International Airport",
    city: "Zaqatala",
    country: "Azerbaijan",
    iata: "ZTU",
    icao: "UBBY",
    latitude: "41.562222",
    longitude: "46.667222",
    altitude: "100",
    timezone: "4",
    dst: "E",
    tz: "Asia/Baku",
  },
  {
    id: "8777",
    name: "Lake Placid Airport",
    city: "Lake Placid",
    country: "United States",
    iata: "LKP",
    icao: "KLKP",
    latitude: "44.264444",
    longitude: "-73.961944",
    altitude: "1747",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8778",
    name: "Long Lake",
    city: "Long Lake",
    country: "United States",
    iata: "NY9",
    icao: "\\N",
    latitude: "43.9750617",
    longitude: "-74.42044",
    altitude: "1629",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8779",
    name: "Tyopliy Klyuch",
    city: "Khandyga",
    country: "Russia",
    iata: "",
    icao: "UEMH",
    latitude: "62.471",
    longitude: "136.505",
    altitude: "932",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "8780",
    name: "Magan",
    city: "Yakutsk",
    country: "Russia",
    iata: "",
    icao: "UEMM",
    latitude: "62.0626",
    longitude: "129.3334",
    altitude: "577",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "8781",
    name: "Zhoubai",
    city: "Qianjiang",
    country: "China",
    iata: "JIQ",
    icao: "\\N",
    latitude: "29.515",
    longitude: "108.83",
    altitude: "2461",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8782",
    name: "Mendeleevo",
    city: "Yuzhno-Kurilsk",
    country: "Russia",
    iata: "DEE",
    icao: "YXCM",
    latitude: "43.5739",
    longitude: "145.4107",
    altitude: "50",
    timezone: "12",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "8783",
    name: "Wishram Amtrak Station",
    city: "Wishram",
    country: "United States",
    iata: "WIH",
    icao: "\\N",
    latitude: "45.6576",
    longitude: "-120.9664",
    altitude: "1",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8784",
    name: "Lima Allen County Airport",
    city: "Lima",
    country: "United States",
    iata: "AOH",
    icao: "KAOH",
    latitude: "40.707478",
    longitude: "-84.0270781",
    altitude: "975",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8785",
    name: "Sondok Airport",
    city: "Hamhung",
    country: "North Korea",
    iata: "DSO",
    icao: "\\N",
    latitude: "39.747333",
    longitude: "127.474611",
    altitude: "0",
    timezone: "9",
    dst: "U",
    tz: "Asia/Pyongyang",
  },
  {
    id: "8786",
    name: "Samjiyon Airport",
    city: "Samjiyon",
    country: "North Korea",
    iata: "YJS",
    icao: "\\N",
    latitude: "41.907167",
    longitude: "128.409889",
    altitude: "0",
    timezone: "9",
    dst: "U",
    tz: "Asia/Pyongyang",
  },
  {
    id: "8787",
    name: "Geiranger",
    city: "Geiranger Fjord",
    country: "Norway",
    iata: "",
    icao: "\\N",
    latitude: "62.474976458",
    longitude: "6.1528587341",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "8788",
    name: "Gangtok Helipad",
    city: "Gangtok",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "27.3521",
    longitude: "88.6051",
    altitude: "1500",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "8789",
    name: "McKinnon Airport",
    city: "Brunswick",
    country: "United States",
    iata: "SSI",
    icao: "KSSI",
    latitude: "31.1519722",
    longitude: "-81.3910556",
    altitude: "19",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8790",
    name: "Beaver Falls",
    city: "Beaver Falls",
    country: "United States",
    iata: "BFP",
    icao: "KBFP",
    latitude: "40.7724722",
    longitude: "-80.3914444",
    altitude: "1253",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8791",
    name: "Seaplane Base",
    city: "Winterhaven",
    country: "United States",
    iata: "F57",
    icao: "\\N",
    latitude: "28.0575",
    longitude: "-81.7628056",
    altitude: "140",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8792",
    name: "Georgetown County Airport",
    city: "Georgetown",
    country: "United States",
    iata: "GGE",
    icao: "KGGE",
    latitude: "33.3114018",
    longitude: "-79.3203139",
    altitude: "40",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8793",
    name: "Hardwick Field Airport",
    city: "Cleveland",
    country: "United States",
    iata: "HDI",
    icao: "KHDI",
    latitude: "35.2199994",
    longitude: "-84.832369",
    altitude: "874",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8794",
    name: "Mark Anton Airport",
    city: "Dayton",
    country: "United States",
    iata: "2A0",
    icao: "\\N",
    latitude: "35.48625",
    longitude: "-84.9310833",
    altitude: "718",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8795",
    name: "Jefferson County Airpark",
    city: "Steubenville",
    country: "United States",
    iata: "2G2",
    icao: "\\N",
    latitude: "40.3602179",
    longitude: "-80.7008742",
    altitude: "1196",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8796",
    name: "Renton",
    city: "Renton",
    country: "United States",
    iata: "RNT",
    icao: "KRNT",
    latitude: "47.4931389",
    longitude: "-122.21575",
    altitude: "32",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8963",
    name: "Bromont Airport",
    city: "Bromont",
    country: "Canada",
    iata: "ZBM",
    icao: "CZBM",
    latitude: "45.290833",
    longitude: "-72.741944",
    altitude: "374",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8798",
    name: "Brackett Field",
    city: "La Verne",
    country: "United States",
    iata: "POC",
    icao: "KPOC",
    latitude: "34.0916667",
    longitude: "-117.7817778",
    altitude: "1014",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8799",
    name: "Jekyll Island Airport",
    city: "Jekyll Island",
    country: "United States",
    iata: "09J",
    icao: "\\N",
    latitude: "31.0744722",
    longitude: "-81.4277778",
    altitude: "11",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8800",
    name: "CedarKey",
    city: "Cedar Key",
    country: "United States",
    iata: "CDK",
    icao: "KCDK",
    latitude: "29.1342222",
    longitude: "-83.0504722",
    altitude: "11",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8801",
    name: "Cross City",
    city: "Cross City",
    country: "United States",
    iata: "CTY",
    icao: "KCTY",
    latitude: "29.6355278",
    longitude: "-83.10475",
    altitude: "42",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8802",
    name: "Clemson",
    city: "Clemson",
    country: "United States",
    iata: "CEU",
    icao: "KCEU",
    latitude: "34.6722222",
    longitude: "-82.8858889",
    altitude: "891",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8803",
    name: "Heber City Municipal Airport",
    city: "Heber",
    country: "United States",
    iata: "36U",
    icao: "\\N",
    latitude: "40.4818056",
    longitude: "-111.4288056",
    altitude: "5637",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8804",
    name: "Beech Factory Airport",
    city: "Wichita",
    country: "United States",
    iata: "BEC",
    icao: "KBEC",
    latitude: "37.6939167",
    longitude: "-97.2149167",
    altitude: "1409",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8805",
    name: "Cherokee County Airport",
    city: "Canton",
    country: "United States",
    iata: "47A",
    icao: "\\N",
    latitude: "34.3122175",
    longitude: "-84.4221556",
    altitude: "1219",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8806",
    name: "Fernandina Beach Municipal Airport",
    city: "Fernandina Beach",
    country: "United States",
    iata: "55J",
    icao: "\\N",
    latitude: "30.6118333",
    longitude: "-81.4611944",
    altitude: "16",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8807",
    name: "Padang Tabing",
    city: "Padang",
    country: "Indonesia",
    iata: "",
    icao: "WIMG",
    latitude: "-0.875",
    longitude: "100.3519",
    altitude: "3",
    timezone: "7",
    dst: "U",
    tz: "Asia/Jakarta",
  },
  {
    id: "8808",
    name: "Tom B. David Field Airport",
    city: "Calhoun",
    country: "United States",
    iata: "",
    icao: "KCZL",
    latitude: "34.45545",
    longitude: "-84.9391622",
    altitude: "651",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8809",
    name: "Habersham County Airport",
    city: "Cornelia",
    country: "United States",
    iata: "",
    icao: "KAJR",
    latitude: "34.4998483",
    longitude: "-83.5566701",
    altitude: "1448",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8810",
    name: "Hamburg Hbf",
    city: "Hamburg",
    country: "Germany",
    iata: "ZMB",
    icao: "\\N",
    latitude: "53.552776",
    longitude: "10.006683",
    altitude: "30",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8811",
    name: "Georgetown Municipal Airport",
    city: "Georgetown",
    country: "United States",
    iata: "GTU",
    icao: "KGTU",
    latitude: "30.678809",
    longitude: "-97.6793837",
    altitude: "790",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8812",
    name: "Old Rhinebeck Airport",
    city: "Rhinebeck",
    country: "United States",
    iata: "",
    icao: "NY94",
    latitude: "41.969833",
    longitude: "-73.864555",
    altitude: "323",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "8813",
    name: "Duxford Aerodrome",
    city: "Duxford",
    country: "United Kingdom",
    iata: "QFO",
    icao: "EGSU",
    latitude: "52.09083",
    longitude: "0.13194",
    altitude: "125",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8814",
    name: "BLABU",
    city: "Blankenburg",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.7946",
    longitude: "11.0183",
    altitude: "551",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8815",
    name: "Sidney Muni Airport",
    city: "Sidney",
    country: "United States",
    iata: "SNY",
    icao: "KSNY",
    latitude: "41.10167",
    longitude: "-102.985",
    altitude: "4313",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8816",
    name: "Manantali Bengassi Airport ",
    city: "Bengassi",
    country: "Mali",
    iata: "",
    icao: "GA46",
    latitude: "13.25561",
    longitude: "-10.50432",
    altitude: "538",
    timezone: "0",
    dst: "N",
    tz: "Africa/Bamako",
  },
  {
    id: "8817",
    name: "Schofields Aerodrome",
    city: "Schofields",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-33.717389",
    longitude: "150.871396",
    altitude: "21",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "8818",
    name: "Luray Caverns Airport",
    city: "Luray",
    country: "United States",
    iata: "",
    icao: "KLUA",
    latitude: "38.666944",
    longitude: "-78.500556",
    altitude: "903",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8819",
    name: "Eagle's Nest Airport",
    city: "Waynesboro",
    country: "United States",
    iata: "W13",
    icao: "\\N",
    latitude: "38.076944",
    longitude: "-78.944167",
    altitude: "1437",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8820",
    name: "Great Keppel Island",
    city: "Great Keppel Island",
    country: "Australia",
    iata: "GKL",
    icao: "YGKL",
    latitude: "-23.186",
    longitude: "150.943",
    altitude: "250",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "8821",
    name: "Roper Bar",
    city: "Roper Bar",
    country: "Australia",
    iata: "RPB",
    icao: "YRRB",
    latitude: "-14.73457",
    longitude: "134.5252",
    altitude: "70",
    timezone: "9.5",
    dst: "U",
    tz: "Australia/Darwin",
  },
  {
    id: "8822",
    name: "Mount Garnet",
    city: "Mount Garnet",
    country: "Australia",
    iata: "",
    icao: "YMRT",
    latitude: "-17.70601",
    longitude: "145.14889",
    altitude: "2159",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "8823",
    name: "Innisfail",
    city: "Innisfail",
    country: "Australia",
    iata: "IFL",
    icao: "YIFL",
    latitude: "-17.55908",
    longitude: "146.01123",
    altitude: "46",
    timezone: "10",
    dst: "U",
    tz: "Australia/Brisbane",
  },
  {
    id: "8824",
    name: "Kalaeloa",
    city: "Kapolei",
    country: "United States",
    iata: "",
    icao: "PHJR",
    latitude: "21.307222",
    longitude: "-158.070278",
    altitude: "30",
    timezone: "-10",
    dst: "U",
    tz: "Pacific/Honolulu",
  },
  {
    id: "8825",
    name: "Bamyan Airport",
    city: "Bamyan",
    country: "Afghanistan",
    iata: "BIN",
    icao: "OABN",
    latitude: "34.816667",
    longitude: "67.816667",
    altitude: "2550",
    timezone: "4.5",
    dst: "N",
    tz: "Asia/Kabul",
  },
  {
    id: "8826",
    name: "Changbaishan Airport",
    city: "Baishan",
    country: "China",
    iata: "NBS",
    icao: "\\N",
    latitude: "42.088056",
    longitude: "127.548889",
    altitude: "2762",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8827",
    name: "SFO Helicopter",
    city: "Sausalito",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.87856",
    longitude: "-122.512742",
    altitude: "13",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8828",
    name: "Lewa Airport",
    city: "Lewa Downs",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "0.1927",
    longitude: "37.4725",
    altitude: "6250",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "8829",
    name: "Huaorani Ecolodge",
    city: "Huaorani",
    country: "Ecuador",
    iata: "",
    icao: "\\N",
    latitude: "-1.0102",
    longitude: "-77.1501",
    altitude: "1000",
    timezone: "-5",
    dst: "U",
    tz: "America/Guayaquil",
  },
  {
    id: "8830",
    name: "Chongjin Airport",
    city: "Chongjin",
    country: "North Korea",
    iata: "RGO",
    icao: "ZZ07",
    latitude: "41.4297",
    longitude: "129.6488",
    altitude: "0",
    timezone: "9",
    dst: "U",
    tz: "Asia/Pyongyang",
  },
  {
    id: "8831",
    name: "Moomba",
    city: "Moomba",
    country: "Australia",
    iata: "MOO",
    icao: "YOOM",
    latitude: "-28.1",
    longitude: "140.2",
    altitude: "143",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "8832",
    name: "Lublin",
    city: "Lublin",
    country: "Poland",
    iata: "LUZ",
    icao: "EPLB",
    latitude: "51.239333",
    longitude: "22.714083",
    altitude: "203",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8834",
    name: "Madison County Executive Airport",
    city: "Huntsville",
    country: "United States",
    iata: "",
    icao: "KMDQ",
    latitude: "34.861",
    longitude: "-86.558",
    altitude: "756",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8835",
    name: "Leesburg Executive Airport",
    city: "Leesburg",
    country: "United States",
    iata: "JYO",
    icao: "KJYO",
    latitude: "39.078",
    longitude: "-77.558",
    altitude: "389",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8836",
    name: "CNC4",
    city: "Guelph",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.563889",
    longitude: "-80.196111",
    altitude: "1100",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8837",
    name: "CNC4",
    city: "Geulph",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.563889",
    longitude: "-80.196111",
    altitude: "1100",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "8839",
    name: "Robinson Crusoe Airport",
    city: "San Juan Bautista",
    country: "Chile",
    iata: "",
    icao: "SCIR",
    latitude: "-33.665001",
    longitude: "-78.929703",
    altitude: "433",
    timezone: "-4",
    dst: "S",
    tz: "America/Santiago",
  },
  {
    id: "8840",
    name: "Maamigili Airport",
    city: "Maamigili",
    country: "Maldives",
    iata: "VAM",
    icao: "VRMV",
    latitude: "3.4702",
    longitude: "72.8344",
    altitude: "6",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "8841",
    name: "Hilton Iru fushi",
    city: "Maldives Hilton Iru fushi",
    country: "Maldives",
    iata: "IRU",
    icao: "IRUF",
    latitude: "5.7435",
    longitude: "73.3249",
    altitude: "6",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "8842",
    name: "Dhigurah Centara Grand Maldives",
    city: "Dhigurah",
    country: "Maldives",
    iata: "DHG",
    icao: "DHGU",
    latitude: "3.5939",
    longitude: "72.8834",
    altitude: "6",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "8843",
    name: "Beijing Railway Station",
    city: "Beijing",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "39.5408",
    longitude: "116.2516",
    altitude: "143",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8844",
    name: "Chengde Railway Station",
    city: "Chengde",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "40.965755",
    longitude: "117.954019",
    altitude: "1083",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8845",
    name: "Yongzhou Lingling Airport",
    city: "Yongzhou",
    country: "China",
    iata: "LLF",
    icao: "\\N",
    latitude: "26.345556",
    longitude: "111.612222",
    altitude: "428",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8846",
    name: "Losinj Airport",
    city: "Mali Losinj",
    country: "Croatia",
    iata: "LSZ",
    icao: "LDLO",
    latitude: "44.3357",
    longitude: "14.2335",
    altitude: "154",
    timezone: "1",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "8847",
    name: "Onslow ",
    city: "Onslow",
    country: "Australia",
    iata: "ONS",
    icao: "YOLW",
    latitude: "-21.667",
    longitude: "115.116",
    altitude: "23",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "8848",
    name: "Theodore",
    city: "Theodore",
    country: "Australia",
    iata: "TDR",
    icao: "YTDR",
    latitude: "-24.986737",
    longitude: "150.093112",
    altitude: "560",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "8849",
    name: "RUDNIKI ",
    city: "RUDNIKI",
    country: "Poland",
    iata: "CZW",
    icao: "EPRU",
    latitude: "50.884722",
    longitude: "19.202222",
    altitude: "262",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8850",
    name: "Williamson-Sodus Airport",
    city: "Williamson",
    country: "United States",
    iata: "SDC",
    icao: "KSDC",
    latitude: "43.2347904",
    longitude: "-77.119444",
    altitude: "424",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8851",
    name: "Clear Lake Metroport",
    city: "Clear Lake City",
    country: "United States",
    iata: "CLC",
    icao: "\\N",
    latitude: "29.5569",
    longitude: "-95.137497",
    altitude: "35",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8852",
    name: "Gilberto Lavaque",
    city: "Cafayate",
    country: "Argentina",
    iata: "CFX",
    icao: "SASC",
    latitude: "-26.06245",
    longitude: "-65.932095",
    altitude: "5523",
    timezone: "-3",
    dst: "S",
    tz: "America/Cordoba",
  },
  {
    id: "8853",
    name: "Woking",
    city: "Fairoaks",
    country: "United Kingdom",
    iata: "",
    icao: "EGTF",
    latitude: "51.348056",
    longitude: "-0.558611",
    altitude: "80",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "8854",
    name: "Boulder Municipal",
    city: "Boulder",
    country: "United States",
    iata: "WBU",
    icao: "KBDU",
    latitude: "40.039444",
    longitude: "-105.225833",
    altitude: "5288",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8855",
    name: "Neustadt-Glewe",
    city: "Neustadt-Glewe",
    country: "Germany",
    iata: "",
    icao: "EDAN",
    latitude: "53.364779",
    longitude: "11.607352",
    altitude: "115",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8856",
    name: "Berchtesgarden BKS",
    city: "Bischofswiesen",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "47.62313",
    longitude: "12.972214",
    altitude: "2297",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8857",
    name: "Hohe Duene",
    city: "Warnemuende",
    country: "Germany",
    iata: "",
    icao: "ETMW",
    latitude: "54.181438",
    longitude: "12.132082",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8858",
    name: "Sannvhe",
    city: "Tangshan",
    country: "China",
    iata: "TVS",
    icao: "ZBSN",
    latitude: "39.717444",
    longitude: "118.002389",
    altitude: "25",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8859",
    name: "GOETSENHOVEN AB",
    city: "GOETSENHOVEN",
    country: "Belgium",
    iata: "",
    icao: "EBTN",
    latitude: "50.7817",
    longitude: "4.95778",
    altitude: "246",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8860",
    name: "Wildenrath AB Closed",
    city: "Wildenrath",
    country: "Germany",
    iata: "",
    icao: "EDUW",
    latitude: "51.113721",
    longitude: "6.210245",
    altitude: "200",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8861",
    name: "Bremgarten Airport",
    city: "Bremgarten",
    country: "Germany",
    iata: "",
    icao: "EDTG",
    latitude: "47.902779",
    longitude: "7.617778",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8862",
    name: "Bitburg AB closed",
    city: "Birburg",
    country: "Germany",
    iata: "",
    icao: "EDRB",
    latitude: "49.945278",
    longitude: "6.565",
    altitude: "1200",
    timezone: "1",
    dst: "U",
    tz: "Europe/Berlin",
  },
  {
    id: "8863",
    name: "Toul AB closed",
    city: "Toul",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "48.779999",
    longitude: "5.98",
    altitude: "936",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8864",
    name: "Palo Alto Airport of Santa Clara County",
    city: "Palo Alto",
    country: "United States",
    iata: "PAO",
    icao: "KPAO",
    latitude: "37.4611111",
    longitude: "-122.1150556",
    altitude: "7",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8865",
    name: "Dubai Cruise Terminal",
    city: "Dubai",
    country: "United Arab Emirates",
    iata: "",
    icao: "\\N",
    latitude: "25.274193",
    longitude: "55.28311",
    altitude: "0",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "8866",
    name: "Ust-Nera Airport",
    city: "Ust-Nera",
    country: "Russia",
    iata: "",
    icao: "UEMT",
    latitude: "64.568056",
    longitude: "143.236111",
    altitude: "3000",
    timezone: "11",
    dst: "U",
    tz: "Asia/Vladivostok",
  },
  {
    id: "8867",
    name: "Vostice",
    city: "Vysoke Myto",
    country: "Czech Republic",
    iata: "",
    icao: "LKVM",
    latitude: "49.5537",
    longitude: "16.1109",
    altitude: "988",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "8868",
    name: "Spa La Sauveniere",
    city: "Spa",
    country: "Belgium",
    iata: "",
    icao: "EBSP",
    latitude: "50.4824981689453",
    longitude: "5.91029977798462",
    altitude: "1581",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8869",
    name: "Mesa Falcon Field",
    city: "Mesa",
    country: "United States",
    iata: "FFZ",
    icao: "KFFZ",
    latitude: "33.4608001708984",
    longitude: "-111.727996826172",
    altitude: "1394",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "8870",
    name: "Coolidge Municipal Airport",
    city: "Cooldige",
    country: "United States",
    iata: "P08",
    icao: "KP08",
    latitude: "32.9359016418457",
    longitude: "-111.427001953125",
    altitude: "1574",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "8871",
    name: "Cottonwood Airport",
    city: "Cottonwood",
    country: "United States",
    iata: "P52",
    icao: "KP52",
    latitude: "34.7299995422363",
    longitude: "-112.035003662109",
    altitude: "3550",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "8872",
    name: "Suarlee Airport",
    city: "Namur",
    country: "Belgium",
    iata: "",
    icao: "EBNM",
    latitude: "50.4879989624023",
    longitude: "4.76891994476318",
    altitude: "594",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8873",
    name: "Hasselt Airport",
    city: "Hasselt",
    country: "Belgium",
    iata: "",
    icao: "EBZH",
    latitude: "50.9700012207031",
    longitude: "5.37507009506226",
    altitude: "141",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "8874",
    name: "Phoenix Regional Airport",
    city: "Phoenix",
    country: "United States",
    iata: "A39",
    icao: "KA39",
    latitude: "32.99169921875",
    longitude: "-111.920997619629",
    altitude: "1300",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "8875",
    name: "Wickenburg Municipal Airport",
    city: "Wickenburg",
    country: "United States",
    iata: "E25",
    icao: "KE25",
    latitude: "33.96889877",
    longitude: "-112.7990036",
    altitude: "2377",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "8876",
    name: "Yangzhou Taizhou Airport",
    city: "Yangzhou",
    country: "China",
    iata: "YTY",
    icao: "ZSYA",
    latitude: "32.5617",
    longitude: "119.715",
    altitude: "7",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8877",
    name: "Oakland Co. Intl",
    city: "Pontiac",
    country: "United States",
    iata: "PTK",
    icao: "KPTK",
    latitude: "42.667",
    longitude: "-83.35",
    altitude: "980",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8878",
    name: "Fuzhou Railway Station",
    city: "Fuzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "26.11351",
    longitude: "119.319998",
    altitude: "39",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8879",
    name: "Xiamen Railway Station",
    city: "Xiamen",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "24.4679",
    longitude: "118.116",
    altitude: "255",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8880",
    name: "Kissidougou",
    city: "Kissidougou",
    country: "Guinea",
    iata: "KSI",
    icao: "GUKU",
    latitude: "9.160556",
    longitude: "-10.124443",
    altitude: "550",
    timezone: "0",
    dst: "N",
    tz: "Africa/Conakry",
  },
  {
    id: "8881",
    name: "Pecs",
    city: "Pecs",
    country: "Hungary",
    iata: "QPJ",
    icao: "\\N",
    latitude: "46.070833",
    longitude: "18.233056",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "8882",
    name: "Neuwied",
    city: "Neuwied",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.432008",
    longitude: "7.472785",
    altitude: "300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8883",
    name: "Castelnuovo di Garfagnana",
    city: "Castelnuovo di Garfagnana",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "44.116464",
    longitude: "10.409954",
    altitude: "1100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8884",
    name: "Portovenere",
    city: "Portovenere",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "44.0519359",
    longitude: "9.8353078",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8885",
    name: "Amsterdam Zuid WTC",
    city: "Amsterdam",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.338841",
    longitude: "4.871471",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8886",
    name: "Budapest Keteli",
    city: "Budapest",
    country: "Hungary",
    iata: "",
    icao: "\\N",
    latitude: "47.500497",
    longitude: "19.085484",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Budapest",
  },
  {
    id: "8887",
    name: "Zagreb Glavni Kolod.",
    city: "Zagreb",
    country: "Croatia",
    iata: "",
    icao: "\\N",
    latitude: "45.804289",
    longitude: "15.979121",
    altitude: "500",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zagreb",
  },
  {
    id: "8888",
    name: "Dillant Hopkins Airport",
    city: "Keene",
    country: "United States",
    iata: "EEN",
    icao: "\\N",
    latitude: "72.270833",
    longitude: "42.898333",
    altitude: "149",
    timezone: "-5",
    dst: "A",
    tz: "\\N",
  },
  {
    id: "8889",
    name: "Tianshui Airport",
    city: "Tianshui",
    country: "China",
    iata: "THQ",
    icao: "ZLTS",
    latitude: "34.333",
    longitude: "105.514",
    altitude: "9186",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8890",
    name: "Kawama Airport",
    city: "Kawama",
    country: "Cuba",
    iata: "",
    icao: "MUKW",
    latitude: "23.123642",
    longitude: "-81.301805",
    altitude: "16",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "8891",
    name: "Yumuri Valley",
    city: "Yumuri Valley",
    country: "Cuba",
    iata: "",
    icao: "\\N",
    latitude: "23.1",
    longitude: "-81.9",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Havana",
  },
  {
    id: "8892",
    name: "Kooddoo",
    city: "Kooddoo",
    country: "Maldives",
    iata: "GKK",
    icao: "VRMO",
    latitude: "0.7308",
    longitude: "73.433",
    altitude: "10",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "8893",
    name: "Glasgow Industrial",
    city: "Glasgow",
    country: "United States",
    iata: "",
    icao: "07MT",
    latitude: "48.4211069",
    longitude: "-106.5277039",
    altitude: "2762",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8894",
    name: "Rochester Airport",
    city: "Rochester",
    country: "United Kingdom",
    iata: "RCS",
    icao: "EGTO",
    latitude: "51.351944",
    longitude: "0.502778",
    altitude: "426",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8895",
    name: "Den Haag Centraal",
    city: "Den Haag",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.081667",
    longitude: "4.329167",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8896",
    name: "Paris Nord",
    city: "Paris",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "48.880931",
    longitude: "2.355323",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "8897",
    name: "Venlo railway station",
    city: "Venlo",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "51.364722",
    longitude: "6.171389",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8898",
    name: "Monchengladbach Central Station",
    city: "Monchengladbach",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "51.196",
    longitude: "6.446",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "8899",
    name: "Utrecht Centraal",
    city: "Utrecht ",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.089167",
    longitude: "5.109722",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "8900",
    name: "Rensselaer Rail Station",
    city: "Albany",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.641389",
    longitude: "-73.741111",
    altitude: "324",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8901",
    name: "Amtrak Station",
    city: "Tacoma",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.242733",
    longitude: "-122.42041",
    altitude: "50",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8902",
    name: "Amtrak Station",
    city: "Orlando",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "28.5259",
    longitude: "-81.3813",
    altitude: "82",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8903",
    name: "Denali Rail",
    city: "Healy",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "63.7306",
    longitude: "-148.913733333333",
    altitude: "1730",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "8904",
    name: "Albian Aerodrome",
    city: "Wood Buffalo",
    country: "Canada",
    iata: "JHL",
    icao: "\\N",
    latitude: "57.223889",
    longitude: "-111.418889",
    altitude: "1048",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "8905",
    name: "Monroe Reqional Airport",
    city: "Charlotte",
    country: "United States",
    iata: "EQY",
    icao: "\\N",
    latitude: "35.01833",
    longitude: "-80.62001",
    altitude: "679",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8906",
    name: "Station Aare",
    city: "Aare",
    country: "Sweden",
    iata: "",
    icao: "\\N",
    latitude: "63.398779",
    longitude: "13.075956",
    altitude: "1240",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "8907",
    name: "Villach Hauptbahnhof",
    city: "Villach",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "46.618333",
    longitude: "13.848333",
    altitude: "1644",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8908",
    name: "Krakow Glowny",
    city: "Krakow",
    country: "Poland",
    iata: "",
    icao: "\\N",
    latitude: "50.065556",
    longitude: "19.947222",
    altitude: "719",
    timezone: "1",
    dst: "E",
    tz: "Europe/Warsaw",
  },
  {
    id: "8909",
    name: "Wien Meidling",
    city: "Vienna",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "48.175",
    longitude: "16.335278",
    altitude: "738",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8910",
    name: "Roma Termini",
    city: "Rome",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "41.900833",
    longitude: "12.501944",
    altitude: "197",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8911",
    name: "Napoli Centrale",
    city: "Naples",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "40.8525",
    longitude: "14.271944",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8912",
    name: "Euston Station",
    city: "London",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.5284",
    longitude: "-0.1331",
    altitude: "89",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8913",
    name: "Kankan",
    city: "Kankan",
    country: "Guinea",
    iata: "KNN",
    icao: "GUXD",
    latitude: "10.448333",
    longitude: "-9.227499",
    altitude: "8694",
    timezone: "0",
    dst: "U",
    tz: "Africa/Conakry",
  },
  {
    id: "8914",
    name: "Termal",
    city: "Rio Hondo",
    country: "Argentina",
    iata: "RHD",
    icao: "SANH",
    latitude: "-27.509946",
    longitude: "-64.936666",
    altitude: "1181",
    timezone: "-3",
    dst: "S",
    tz: "America/Cordoba",
  },
  {
    id: "8915",
    name: "Guangzhou Railway Station",
    city: "Guangzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "23.151343",
    longitude: "113.252073",
    altitude: "19",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8916",
    name: "Shenzhen West Railway Station",
    city: "Shenzhen",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "22.532043",
    longitude: "113.908729",
    altitude: "3",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8917",
    name: "Shenzhen North Railway Station",
    city: "Shenzhen",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "22.607058",
    longitude: "114.027203",
    altitude: "229",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8918",
    name: "Keetmanshoop",
    city: "Keetmanshoop",
    country: "Namibia",
    iata: "KMP",
    icao: "FYKT",
    latitude: "-26.5397",
    longitude: "18.1114",
    altitude: "3506",
    timezone: "1",
    dst: "U",
    tz: "Africa/Windhoek",
  },
  {
    id: "8919",
    name: "Shekou Ferry Terminal",
    city: "Shenzhen",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "22.476555",
    longitude: "113.912855",
    altitude: "2",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8920",
    name: "Zhuhai-Jiuzhou Port",
    city: "Zhuhai",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "22.233333",
    longitude: "113.583333",
    altitude: "2",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8921",
    name: "Kangding Airport",
    city: "Kangding",
    country: "China",
    iata: "KGT",
    icao: "ZUKD",
    latitude: "30.1575",
    longitude: "101.734722",
    altitude: "14042",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8922",
    name: "Train Station",
    city: "Aranyaprathet",
    country: "Thailand",
    iata: "",
    icao: "\\N",
    latitude: "13.4058",
    longitude: "102.311",
    altitude: "150",
    timezone: "7",
    dst: "N",
    tz: "Asia/Bangkok",
  },
  {
    id: "8923",
    name: "Train Station",
    city: "Nha Trang",
    country: "Vietnam",
    iata: "",
    icao: "\\N",
    latitude: "12.15",
    longitude: "109.11",
    altitude: "50",
    timezone: "7",
    dst: "N",
    tz: "Asia/Saigon",
  },
  {
    id: "8924",
    name: "Veliky Ustyug",
    city: "Veliky Ustyug",
    country: "Russia",
    iata: "VUS",
    icao: "ULWU",
    latitude: "60.788333",
    longitude: "46.26",
    altitude: "331",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8925",
    name: "Iowa City Municipal Airport",
    city: "Iowa City",
    country: "United States",
    iata: "IOW",
    icao: "KIOW",
    latitude: "41.639244",
    longitude: "-91.546503",
    altitude: "668",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8926",
    name: "Turpan",
    city: "Turpan",
    country: "China",
    iata: "TLQ",
    icao: "ZWTP",
    latitude: "42.942328",
    longitude: "89.185877",
    altitude: "20",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8927",
    name: "Lorenzo",
    city: "Morro de Sao Paulo",
    country: "Brazil",
    iata: "",
    icao: "SNCL",
    latitude: "-13.389444445",
    longitude: "-38.91",
    altitude: "3",
    timezone: "-3",
    dst: "S",
    tz: "America/Fortaleza",
  },
  {
    id: "8928",
    name: "Windom Municipal Airport",
    city: "Windom",
    country: "United States",
    iata: "MWM",
    icao: "KMWM",
    latitude: "43.9134017",
    longitude: "-95.1094083",
    altitude: "1410",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8929",
    name: "Sasakwa Airstrip",
    city: "Sasakwa",
    country: "Tanzania",
    iata: "",
    icao: "\\N",
    latitude: "-2.0714",
    longitude: "34.5068",
    altitude: "4000",
    timezone: "3",
    dst: "N",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "8930",
    name: "Yabuli",
    city: "Yabuli Town",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "44.4653",
    longitude: "128.27",
    altitude: "1200",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8931",
    name: "Longview Ranch Airport",
    city: "Longview",
    country: "United States",
    iata: "",
    icao: "OG39",
    latitude: "44.6608611",
    longitude: "-119.6526153",
    altitude: "2080",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8932",
    name: "Rothera Research Station",
    city: "Rothera Research Station",
    country: "United Kingdom",
    iata: "",
    icao: "EGAR",
    latitude: "-67.34",
    longitude: "-68.08",
    altitude: "200",
    timezone: "12",
    dst: "U",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "8933",
    name: "Sortavala",
    city: "Sortavala",
    country: "Russia",
    iata: "",
    icao: "ULPW",
    latitude: "61.736099",
    longitude: "30.673599",
    altitude: "14",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8934",
    name: "Valaam",
    city: "Valaam",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "61.37115",
    longitude: "30.88977",
    altitude: "15",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "8935",
    name: "Lee Airport",
    city: "Annapolis",
    country: "United States",
    iata: "ANP",
    icao: "KANP",
    latitude: "38.942778",
    longitude: "-76.568333",
    altitude: "34",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8936",
    name: "Songshan Train Station",
    city: "Taipei",
    country: "Taiwan",
    iata: "",
    icao: "\\N",
    latitude: "25.049214",
    longitude: "121.577961",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "8937",
    name: "Kaohsiung Station",
    city: "Kaohsiung",
    country: "Taiwan",
    iata: "",
    icao: "\\N",
    latitude: "22.638432",
    longitude: "120.301877",
    altitude: "39",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "8938",
    name: "Hualien Station",
    city: "Hualien",
    country: "Taiwan",
    iata: "",
    icao: "\\N",
    latitude: "23.992722",
    longitude: "121.60135",
    altitude: "45",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "8939",
    name: "El Merk",
    city: "El Merk",
    country: "Algeria",
    iata: "",
    icao: "\\N",
    latitude: "30.300039",
    longitude: "8.160833",
    altitude: "0",
    timezone: "1",
    dst: "U",
    tz: "Africa/Algiers",
  },
  {
    id: "8940",
    name: "Budapest Keleti pu.",
    city: "Budapest",
    country: "Hungary",
    iata: "",
    icao: "\\N",
    latitude: "-47.500278",
    longitude: "-160.916111",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "8941",
    name: "Bratislava hl. st.",
    city: "Bratislava",
    country: "Slovakia",
    iata: "",
    icao: "\\N",
    latitude: "-48.158263",
    longitude: "17.105839",
    altitude: "430",
    timezone: "1",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "8942",
    name: "Ndutu",
    city: "Ndutu",
    country: "Tanzania",
    iata: "DUU",
    icao: "HTND",
    latitude: "-3.0243398",
    longitude: "34.98450589999993",
    altitude: "5400",
    timezone: "3",
    dst: "U",
    tz: "Africa/Dar_es_Salaam",
  },
  {
    id: "8943",
    name: "Cuamba",
    city: "Cuamba",
    country: "Mozambique",
    iata: "FXO",
    icao: "FQCB",
    latitude: "-14.8175",
    longitude: "36.528333",
    altitude: "1931",
    timezone: "2",
    dst: "N",
    tz: "Africa/Maputo",
  },
  {
    id: "8944",
    name: "Bodaibo",
    city: "Bodaibo",
    country: "Russia",
    iata: "ODO",
    icao: "UIKB",
    latitude: "57.5137",
    longitude: "114.1348",
    altitude: "940",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "8945",
    name: "Berdoba Airport",
    city: "Berdoba",
    country: "Chad",
    iata: "",
    icao: "\\N",
    latitude: "16.072",
    longitude: "22.8466",
    altitude: "2953",
    timezone: "1",
    dst: "N",
    tz: "Africa/Ndjamena",
  },
  {
    id: "8946",
    name: "Zhytomyr",
    city: "Zhytomyr",
    country: "Ukraine",
    iata: "ZTR",
    icao: "UKKV",
    latitude: "50.270556",
    longitude: "28.738611",
    altitude: "0",
    timezone: "2",
    dst: "E",
    tz: "Europe/Kiev",
  },
  {
    id: "8947",
    name: "Mozyr",
    city: "Mozyr",
    country: "Belarus",
    iata: "",
    icao: "UMGM",
    latitude: "51.981944",
    longitude: "29.165",
    altitude: "0",
    timezone: "3",
    dst: "N",
    tz: "Europe/Minsk",
  },
  {
    id: "8948",
    name: "Paluknys",
    city: "Paluknys",
    country: "Lithuania",
    iata: "",
    icao: "EYVP",
    latitude: "54.483056",
    longitude: "24.989722",
    altitude: "0",
    timezone: "2",
    dst: "E",
    tz: "Europe/Vilnius",
  },
  {
    id: "8949",
    name: "Mattala Rajapaksa Intl.",
    city: "Mattala",
    country: "Sri Lanka",
    iata: "HRI",
    icao: "VCRI",
    latitude: "6.284467",
    longitude: "81.124128",
    altitude: "157",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Colombo",
  },
  {
    id: "8950",
    name: "Pecos Municipal Airport",
    city: "Pecos",
    country: "United States",
    iata: "PEQ",
    icao: "KPEQ",
    latitude: "31.3823889",
    longitude: "-103.5107222",
    altitude: "2613",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8951",
    name: "Hattiesburg Bobby L. Chain Municipal Airport",
    city: "Hattiesburg",
    country: "United States",
    iata: "HBG",
    icao: "KHBG",
    latitude: "31.2649444",
    longitude: "-89.2528889",
    altitude: "151",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8952",
    name: "Botucatu",
    city: "Botucatu",
    country: "Brazil",
    iata: "QCJ",
    icao: "SDBK",
    latitude: "-22.938",
    longitude: "-48.467",
    altitude: "3012",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8953",
    name: "Anapolis Military Airbase",
    city: "Anapolis",
    country: "Brazil",
    iata: "",
    icao: "SBAN",
    latitude: "-16.23",
    longitude: "-48.966",
    altitude: "3731",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8954",
    name: "Sao Carlos TAM",
    city: "Sao Carlos",
    country: "Brazil",
    iata: "QSC",
    icao: "SDSC",
    latitude: "-21.875",
    longitude: "-47.904",
    altitude: "2649",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "8955",
    name: "Byron Airport",
    city: "Byron Bay",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "28.383504",
    longitude: "153.365447",
    altitude: "10",
    timezone: "10",
    dst: "O",
    tz: "\\N",
  },
  {
    id: "8956",
    name: "Grindelwald",
    city: "Grindelwald",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.35106",
    longitude: "7.57408",
    altitude: "6000",
    timezone: "1",
    dst: "U",
    tz: "Europe/Zurich",
  },
  {
    id: "8957",
    name: "Grindelwald",
    city: "Grindelwald",
    country: "Switzerland",
    iata: "",
    icao: "\\N",
    latitude: "46.3506",
    longitude: "7.57408",
    altitude: "6000",
    timezone: "1",
    dst: "U",
    tz: "Europe/Zurich",
  },
  {
    id: "8958",
    name: "Chan Gurney",
    city: "Yankton",
    country: "United States",
    iata: "YKN",
    icao: "KYKN",
    latitude: "42.8711",
    longitude: "-97.3969",
    altitude: "1200",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8959",
    name: "Selfield Airport",
    city: "Selma Alabama",
    country: "United States",
    iata: "SES",
    icao: "KSES",
    latitude: "32.4404",
    longitude: "-86.9522",
    altitude: "131",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "8960",
    name: "Linkwasha Airfield",
    city: "Hwange National Park",
    country: "Zimbabwe",
    iata: "",
    icao: "\\N",
    latitude: "-19.123333",
    longitude: "27.201389",
    altitude: "3543",
    timezone: "2",
    dst: "N",
    tz: "Africa/Harare",
  },
  {
    id: "8961",
    name: "Sir Bani Yas Island",
    city: "Sir Bani Yas Island",
    country: "United Arab Emirates",
    iata: "XSB",
    icao: "\\N",
    latitude: "24.2856083",
    longitude: "52.5783472",
    altitude: "5",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "8962",
    name: "Dalma Airport",
    city: "Dalma Island",
    country: "United Arab Emirates",
    iata: "ZDY",
    icao: "\\N",
    latitude: "24.5033833",
    longitude: "52.3360528",
    altitude: "8",
    timezone: "4",
    dst: "U",
    tz: "Asia/Dubai",
  },
  {
    id: "8964",
    name: "Playa del Carmen Airport",
    city: "Playa del Carmen",
    country: "Mexico",
    iata: "PCM",
    icao: "\\N",
    latitude: "20.6225",
    longitude: "-87.082221",
    altitude: "1",
    timezone: "-6",
    dst: "U",
    tz: "America/Mexico_City",
  },
  {
    id: "8965",
    name: "Ellough",
    city: "Beccles",
    country: "United Kingdom",
    iata: "",
    icao: "EGSM",
    latitude: "52.438333",
    longitude: "1.606944",
    altitude: "80",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8966",
    name: "Kratie Airport",
    city: "Kratie",
    country: "Cambodia",
    iata: "KTI",
    icao: "VDKT",
    latitude: "12.4905",
    longitude: "106.055",
    altitude: "3610",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "8967",
    name: "Caldera Airport",
    city: "Caldera",
    country: "Chile",
    iata: "",
    icao: "SCCL",
    latitude: "-27.078052",
    longitude: "-70.795305",
    altitude: "180",
    timezone: "-4",
    dst: "U",
    tz: "America/Santiago",
  },
  {
    id: "8968",
    name: "San Pedro de Atacama Airport",
    city: "San Pedro de Atacama",
    country: "Chile",
    iata: "",
    icao: "SCPE",
    latitude: "-22.918888",
    longitude: "-68.162777",
    altitude: "7959",
    timezone: "-4",
    dst: "U",
    tz: "America/Santiago",
  },
  {
    id: "8969",
    name: "Copacabana Airport",
    city: "Copacabana",
    country: "Bolivia",
    iata: "",
    icao: "SLCC",
    latitude: "-16.183326",
    longitude: "-69.087501",
    altitude: "12591",
    timezone: "-4",
    dst: "U",
    tz: "America/La_Paz",
  },
  {
    id: "8970",
    name: "Havelock Island Seaport",
    city: "Havelock Island",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "12.042636",
    longitude: "92.982574",
    altitude: "0",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "8971",
    name: "Guyuan",
    city: "Guyuan",
    country: "China",
    iata: "GYU",
    icao: "ZLGY",
    latitude: "36.078611",
    longitude: "106.216667",
    altitude: "5577",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "8972",
    name: "Brawdy RAF Airport",
    city: "Brawdy",
    country: "United Kingdom",
    iata: "",
    icao: "EGDA",
    latitude: "51.880462",
    longitude: "-5.12148",
    altitude: "355",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8973",
    name: "Gaios Bay",
    city: "Paxi",
    country: "Greece",
    iata: "",
    icao: "\\N",
    latitude: "39.195944",
    longitude: "20.195961",
    altitude: "0",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "8974",
    name: "Changhai",
    city: "Changhai",
    country: "China",
    iata: "CNI",
    icao: "ZYCH",
    latitude: "39.266389",
    longitude: "122.666944",
    altitude: "1",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8975",
    name: "Redhill Aerodrome",
    city: "Redhill",
    country: "United Kingdom",
    iata: "KRH",
    icao: "EGKR",
    latitude: "51.213612",
    longitude: "-0.13861",
    altitude: "221",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8976",
    name: "Bahnhof",
    city: "Bad Gastein",
    country: "Austria",
    iata: "",
    icao: "\\N",
    latitude: "47.1",
    longitude: "13.0167",
    altitude: "3287",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "8977",
    name: "Acquafredda Station",
    city: "Maratea",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "40",
    longitude: "15.7167",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8978",
    name: "Victoria Station",
    city: "London",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.4964",
    longitude: "-0.14391",
    altitude: "48",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "8979",
    name: "Jiagedaqi Airport",
    city: "Jiagedaqi District",
    country: "China",
    iata: "JGD",
    icao: "\\N",
    latitude: "50.375",
    longitude: "124.117",
    altitude: "1205",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "8980",
    name: "Chinchilla",
    city: "Chinchilla",
    country: "Australia",
    iata: "CCL",
    icao: "YCCA",
    latitude: "-26.769444",
    longitude: "150.616667",
    altitude: "1030",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "8981",
    name: "Frazier Lake Airpark",
    city: "Hollister",
    country: "United States",
    iata: "1C9",
    icao: "\\N",
    latitude: "54.013333333333335",
    longitude: "-124.76833333333333",
    altitude: "152",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "8982",
    name: "Hayward Executive Airport",
    city: "Hayward",
    country: "United States",
    iata: "HWD",
    icao: "KHWD",
    latitude: "37.65888888888889",
    longitude: "-122.12166666666666",
    altitude: "52",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "8983",
    name: "Motueka",
    city: "Motueka",
    country: "New Zealand",
    iata: "MZP",
    icao: "NZMK",
    latitude: "-41.123299",
    longitude: "172.988998",
    altitude: "39",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Auckland",
  },
  {
    id: "8984",
    name: "Shute Harbour",
    city: "Shute Harbour",
    country: "Australia",
    iata: "JHQ",
    icao: "YSHR",
    latitude: "-20.278299",
    longitude: "148.757004",
    altitude: "12",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "8985",
    name: "Enstone",
    city: "Enstone",
    country: "United Kingdom",
    iata: "",
    icao: "EGTN",
    latitude: "51.928167",
    longitude: "-1.4285",
    altitude: "550",
    timezone: "0",
    dst: "U",
    tz: "Europe/London",
  },
  {
    id: "8986",
    name: "Portoferrario Cruise Terminal",
    city: "Portoferrario",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "42.49",
    longitude: "10.19",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "8987",
    name: "Pittsburgh Amtrak",
    city: "Pittsburgh",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.4406",
    longitude: "-79.9961",
    altitude: "1370",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8988",
    name: "Raton Amtrak",
    city: "Raton",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "36.9033",
    longitude: "-104.4386",
    altitude: "8800",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "8989",
    name: "Ann Arbor Municipal Airport",
    city: "Ann Arbor",
    country: "United States",
    iata: "ARB",
    icao: "KARB",
    latitude: "42.132274",
    longitude: "-83.444418",
    altitude: "839",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "8990",
    name: "Myrdal Station",
    city: "Myrdal",
    country: "Norway",
    iata: "",
    icao: "\\N",
    latitude: "60.4418",
    longitude: "7.0723",
    altitude: "2844",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "8991",
    name: "Flam Station",
    city: "Flam",
    country: "Norway",
    iata: "",
    icao: "\\N",
    latitude: "60.5017",
    longitude: "7.0714",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "8992",
    name: "Leikanger Terminal",
    city: "Leikanger",
    country: "Norway",
    iata: "",
    icao: "\\N",
    latitude: "61.1351",
    longitude: "6.4723",
    altitude: "6",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "8993",
    name: "North Sea",
    city: "Gryphon FPSO",
    country: "United Kingdom",
    iata: "",
    icao: "GRY1",
    latitude: "59.35",
    longitude: "1.57",
    altitude: "0",
    timezone: "0",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "8994",
    name: "Shepparton",
    city: "Shepparton",
    country: "Australia",
    iata: "SHT",
    icao: "YSHT",
    latitude: "-36.428902",
    longitude: "145.393005",
    altitude: "374",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "8995",
    name: "Temora",
    city: "Temora",
    country: "Australia",
    iata: "TEM",
    icao: "YTEM",
    latitude: "-34.4248",
    longitude: "147.5104",
    altitude: "921",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "8996",
    name: "Gayndah",
    city: "Gayndah",
    country: "Australia",
    iata: "GAH",
    icao: "YGAY",
    latitude: "-25.61528",
    longitude: "151.62083",
    altitude: "369",
    timezone: "10",
    dst: "N",
    tz: "Australia/Brisbane",
  },
  {
    id: "8997",
    name: "Popondetta",
    city: "Popondetta",
    country: "Papua New Guinea",
    iata: "EIA",
    icao: "\\N",
    latitude: "-8.19999980927",
    longitude: "147.850006104",
    altitude: "311",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "8998",
    name: "Wilcannia",
    city: "Wilcannia",
    country: "Australia",
    iata: "WIO",
    icao: "YWCA",
    latitude: "-31.5174999237",
    longitude: "143.378997803",
    altitude: "250",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "8999",
    name: "Bollards Lagoon",
    city: "Bollards Lagoon Station",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-28.9832259",
    longitude: "140.852844",
    altitude: "250",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "9000",
    name: "Delamere Range",
    city: "Delamere Range",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-15.7467",
    longitude: "131.919998",
    altitude: "200",
    timezone: "9.5",
    dst: "U",
    tz: "Australia/Darwin",
  },
  {
    id: "9001",
    name: "Ivanhoe",
    city: "Ivanhoe",
    country: "Australia",
    iata: "",
    icao: "YIVO",
    latitude: "-32.883301",
    longitude: "144.309998",
    altitude: "331",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9002",
    name: "Menindee",
    city: "Menindee",
    country: "Australia",
    iata: "",
    icao: "YMED",
    latitude: "-32.22",
    longitude: "142.2418",
    altitude: "164",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9003",
    name: "Naduri",
    city: "Naduri",
    country: "Papua New Guinea",
    iata: "",
    icao: "\\N",
    latitude: "-8.93",
    longitude: "147.73",
    altitude: "900",
    timezone: "10",
    dst: "U",
    tz: "Pacific/Port_Moresby",
  },
  {
    id: "9004",
    name: "Pooncarie",
    city: "Pooncarie",
    country: "Australia",
    iata: "",
    icao: "YPCE",
    latitude: "-33.366699",
    longitude: "142.587977",
    altitude: "184",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9005",
    name: "Wiawera Station",
    city: "Wiawera station",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-32.29515",
    longitude: "140.4145",
    altitude: "180",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "9006",
    name: "Tilpa",
    city: "Tilpa",
    country: "Australia",
    iata: "",
    icao: "YTLP",
    latitude: "-30.556",
    longitude: "144.251",
    altitude: "280",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9007",
    name: "Yarramba Station",
    city: "Yarramba Station",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-31.66136",
    longitude: "140.6277",
    altitude: "180",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "9008",
    name: "Reichenbach",
    city: "Reichenbach im Kandertal",
    country: "Switzerland",
    iata: "",
    icao: "LSGR",
    latitude: "46.61298",
    longitude: "7.67773",
    altitude: "2300",
    timezone: "1",
    dst: "E",
    tz: "Europe/Zurich",
  },
  {
    id: "9009",
    name: "Takayama Station",
    city: "Takayama",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "36.1406",
    longitude: "137.2519",
    altitude: "2200",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "9010",
    name: "Himeji Station",
    city: "Himeji",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "34.49395",
    longitude: "134.412706",
    altitude: "141",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "9011",
    name: "Miyajimaguchi Station",
    city: "Miyajimaguchi",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "34.3122",
    longitude: "132.3022",
    altitude: "6",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "9012",
    name: "Miyajima Port",
    city: "Miyajima",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "34.302043",
    longitude: "132.32213",
    altitude: "0",
    timezone: "9",
    dst: "U",
    tz: "Asia/Tokyo",
  },
  {
    id: "9013",
    name: "Brown Bluff Port",
    city: "Brown Bluff",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-63.32",
    longitude: "-56.54",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9014",
    name: "Devil Island Port",
    city: "Devil Island",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-63.48",
    longitude: "-57.17",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9015",
    name: "Gourdin Island Port",
    city: "Gourdin Island",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-63.12",
    longitude: "-57.18",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9016",
    name: "Cuverville Island Port",
    city: "Cuverville Island",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-64.41",
    longitude: "-62.38",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9017",
    name: "Neko Harbor",
    city: "Neko Harbor",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-64.5",
    longitude: "-62.33",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9018",
    name: "Port Lockroy",
    city: "Port Lockroy",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-64.4931",
    longitude: "-63.294",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9019",
    name: "Walker Bay",
    city: "Walker Bay",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-62.38",
    longitude: "-60.42",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9020",
    name: "Whalers Bay",
    city: "Deception Island",
    country: "Antarctica",
    iata: "",
    icao: "\\N",
    latitude: "-62.5837",
    longitude: "-60.39",
    altitude: "0",
    timezone: "12",
    dst: "S",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9021",
    name: "Labadee Port",
    city: "Labadee",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "19.4711",
    longitude: "-72.1444",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9022",
    name: "Lagos Lagoon",
    city: "Lekki",
    country: "Nigeria",
    iata: "",
    icao: "\\N",
    latitude: "6.465907",
    longitude: "3.532115",
    altitude: "0",
    timezone: "1",
    dst: "N",
    tz: "Africa/Lagos",
  },
  {
    id: "9023",
    name: "Escravos",
    city: "Escravos",
    country: "Nigeria",
    iata: "",
    icao: "\\N",
    latitude: "5.617203",
    longitude: "5.187993",
    altitude: "0",
    timezone: "1",
    dst: "U",
    tz: "Africa/Lagos",
  },
  {
    id: "9024",
    name: "Volosovo",
    city: "Volosovo",
    country: "Russia",
    iata: "",
    icao: "XUMW",
    latitude: "55.0683",
    longitude: "37.4517",
    altitude: "577",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "9025",
    name: "Bijie Feixiong Airport",
    city: "Bijie",
    country: "China",
    iata: "BFJ",
    icao: "\\N",
    latitude: "27.253",
    longitude: "105.426",
    altitude: "5250",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9026",
    name: "Lensk",
    city: "Lensk",
    country: "Russia",
    iata: "ULK",
    icao: "UERL",
    latitude: "60.723",
    longitude: "114.825",
    altitude: "843",
    timezone: "10",
    dst: "U",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9027",
    name: "Fairbanks Train Depot",
    city: "Fairbanks",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "64.5109",
    longitude: "-147.4445",
    altitude: "446",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9028",
    name: "Denali Train Depot",
    city: "Denali",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "63.43083",
    longitude: "-150.31111",
    altitude: "3733",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9029",
    name: "Talkeetna Train Depot",
    city: "Talkeetna",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "62.18934",
    longitude: "-150.06177",
    altitude: "348",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9030",
    name: "Anchorage Rail Depot",
    city: "Anchorage",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "61.1318",
    longitude: "-149.5326",
    altitude: "102",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9031",
    name: "Whittier Port",
    city: "Whittier",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "60.774174",
    longitude: "-148.677649",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9032",
    name: "Qingdao Railway Station",
    city: "Qingdao",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "36.063497",
    longitude: "120.312542",
    altitude: "45",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9033",
    name: "Beijing South Railway Station",
    city: "Beijing",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "39.5157",
    longitude: "116.2235",
    altitude: "144",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9034",
    name: "Shanghai Railway Station",
    city: "Shanghai",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "31.251552",
    longitude: "121.450446",
    altitude: "16",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9035",
    name: "Suzhou Railway Station",
    city: "Suzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "31.195",
    longitude: "120.3623",
    altitude: "9",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9036",
    name: "Biluty",
    city: "Khamar-Daban",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "51.994",
    longitude: "102.099",
    altitude: "3000",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9037",
    name: "Shumak",
    city: "Khamar-Daban",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "51.964",
    longitude: "101.867",
    altitude: "3600",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9038",
    name: "Shumak",
    city: "Khamar-Daban",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "51.964",
    longitude: "101.897",
    altitude: "3300",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9039",
    name: "Kitoi",
    city: "Khamar-Daban",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "52.111",
    longitude: "101.986",
    altitude: "2000",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9040",
    name: "Kitoi",
    city: "Khamar-Daban",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "52.111",
    longitude: "101.986",
    altitude: "2000",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9041",
    name: "Angasolka",
    city: "Baikal",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "51.758",
    longitude: "103.849",
    altitude: "1500",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9042",
    name: "Kavalerovo",
    city: "Kavalerovo",
    country: "Russia",
    iata: "",
    icao: "UHWK",
    latitude: "44.273",
    longitude: "135.029",
    altitude: "660",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "9043",
    name: "Igdir",
    city: "Igdir",
    country: "Turkey",
    iata: "IGD",
    icao: "LTCT",
    latitude: "39.983056",
    longitude: "43.866389",
    altitude: "3100",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9044",
    name: "Sanliurfa GAP",
    city: "Sanliurfa",
    country: "Turkey",
    iata: "GNY",
    icao: "LTCS",
    latitude: "37.45",
    longitude: "38.9",
    altitude: "2700",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9045",
    name: "Zafer",
    city: "Kutahya",
    country: "Turkey",
    iata: "KZR",
    icao: "LTBZ",
    latitude: "39.111389",
    longitude: "30.13",
    altitude: "3327",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9046",
    name: "Barentsburg",
    city: "Barentsburg",
    country: "Svalbard",
    iata: "",
    icao: "\\N",
    latitude: "78.1006",
    longitude: "14.1998",
    altitude: "20",
    timezone: "1",
    dst: "U",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "9047",
    name: "Piramida",
    city: "Piramida",
    country: "Svalbard",
    iata: "",
    icao: "\\N",
    latitude: "78.6528",
    longitude: "16.3392",
    altitude: "20",
    timezone: "1",
    dst: "U",
    tz: "Arctic/Longyearbyen",
  },
  {
    id: "9048",
    name: "Velikiye Luki",
    city: "Velikiye Luki",
    country: "Russia",
    iata: "VLU",
    icao: "ULOL",
    latitude: "56.381667",
    longitude: "30.61",
    altitude: "328",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "9049",
    name: "Boston Back Bay Station",
    city: "Boston",
    country: "United States",
    iata: "ZTY",
    icao: "\\N",
    latitude: "42.3478",
    longitude: "-71.075",
    altitude: "20",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9050",
    name: "Burlington GO Station",
    city: "Burlington",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.3408282",
    longitude: "-79.8093881",
    altitude: "243",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9051",
    name: "Niagra Falls Railway Station",
    city: "Niagra Falls",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.1088",
    longitude: "-79.0634",
    altitude: "521",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9052",
    name: "Niagara Falls Station",
    city: "Niagara Falls",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "43.1135",
    longitude: "-79.0318",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9053",
    name: "Yelahanka AFB",
    city: "Bangalore",
    country: "India",
    iata: "YLK",
    icao: "VOYK",
    latitude: "13.136",
    longitude: "77.607",
    altitude: "2912",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "9054",
    name: "Yeltsovka",
    city: "Novosibirsk",
    country: "Russia",
    iata: "",
    icao: "UNNE",
    latitude: "55.077",
    longitude: "82.997",
    altitude: "617",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "9055",
    name: "Veligandu Resort",
    city: "Veligandu",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "4.1753",
    longitude: "73.0037",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9056",
    name: "Kuramathi",
    city: "Kuramathi",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "4.1525",
    longitude: "73",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9057",
    name: "Olkiombo Airstrip",
    city: "Masai Mara",
    country: "Kenya",
    iata: "",
    icao: "HKOK",
    latitude: "-1.409569",
    longitude: "35.110788",
    altitude: "4997",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "9058",
    name: "Shanghai South Railway Station",
    city: "Shanghai",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "31.154425",
    longitude: "121.42416",
    altitude: "13",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9059",
    name: "Suzhou North Railway Station",
    city: "Suzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "31.423646",
    longitude: "120.639045",
    altitude: "6",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9060",
    name: "Ulithi",
    city: "Ulithi",
    country: "Micronesia",
    iata: "ULI",
    icao: "\\N",
    latitude: "10.016699791",
    longitude: "139.800003052",
    altitude: "10",
    timezone: "10",
    dst: "O",
    tz: "Pacific/Truk",
  },
  {
    id: "9061",
    name: "Mar-Kuel",
    city: "Mar-Kuel",
    country: "Russia",
    iata: "",
    icao: "UHHK",
    latitude: "57.2712",
    longitude: "132.314",
    altitude: "200",
    timezone: "11",
    dst: "N",
    tz: "Asia/Vladivostok",
  },
  {
    id: "9062",
    name: "Kodinsk",
    city: "Kodinsk",
    country: "Russia",
    iata: "",
    icao: "UNKI",
    latitude: "58.285",
    longitude: "99.055",
    altitude: "200",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "9063",
    name: "Nanjing Railway Station",
    city: "Nanjing",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "32.088583",
    longitude: "118.792189",
    altitude: "29",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9064",
    name: "Balkanabat",
    city: "Balkanabat",
    country: "Turkmenistan",
    iata: "BKN",
    icao: "\\N",
    latitude: "39.481389",
    longitude: "54.362778",
    altitude: "7",
    timezone: "5",
    dst: "N",
    tz: "Asia/Ashgabat",
  },
  {
    id: "9065",
    name: "Belmont Airport",
    city: "Lake Macquarie",
    country: "Australia",
    iata: "BEO",
    icao: "YPEC",
    latitude: "-33.066667",
    longitude: "151.648333",
    altitude: "5",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9066",
    name: "Clayton County Tara Field",
    city: "Hampton",
    country: "United States",
    iata: "4A7",
    icao: "K4A7",
    latitude: "33.389099",
    longitude: "-84.332397",
    altitude: "874",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9067",
    name: "Stapleton International Airport",
    city: "Denver",
    country: "United States",
    iata: "",
    icao: "DENX",
    latitude: "39.779255",
    longitude: "-104.88184",
    altitude: "5333",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9068",
    name: "Brampton Island",
    city: "Brampton Island",
    country: "Australia",
    iata: "BMP",
    icao: "YBPI",
    latitude: "-20.804444402073734",
    longitude: "149.2794443842832",
    altitude: "5",
    timezone: "10",
    dst: "O",
    tz: "Australia/Brisbane",
  },
  {
    id: "9069",
    name: "Shanghai Maglev Long Yang Road Station",
    city: "Shanghai",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "31.202854",
    longitude: "121.558335",
    altitude: "16",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "9070",
    name: "Nuernberg Port",
    city: "Nuernberg",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.392222",
    longitude: "11.061944",
    altitude: "990",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9071",
    name: "NAS Alameda",
    city: "Alameda",
    country: "United States",
    iata: "NGZ",
    icao: "KNGZ",
    latitude: "37.7861",
    longitude: "-122.3186",
    altitude: "10",
    timezone: "-8",
    dst: "U",
    tz: "America/Los_Angeles",
  },
  {
    id: "9072",
    name: "Stein",
    city: "Stein",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.406324",
    longitude: "11.003054",
    altitude: "984",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9073",
    name: "Dippenricht Heliport",
    city: "Dippenricht",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "49.253972",
    longitude: "11.363216",
    altitude: "1400",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9074",
    name: "Lagoon Cove water aerodrome",
    city: "Lagoon Cove",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "50.6",
    longitude: "-126.3167",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9075",
    name: "Endelage West",
    city: "Endelage",
    country: "Denmark",
    iata: "",
    icao: "EKEL",
    latitude: "55.75616",
    longitude: "10.250716",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "9076",
    name: "Flugplatz St. Johann in Tirol",
    city: "St. Johann in Tirol",
    country: "Austria",
    iata: "",
    icao: "LOIJ",
    latitude: "47.517222",
    longitude: "12.435833",
    altitude: "2198",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "9077",
    name: "Echo Bay water aerodrome",
    city: "Echo Bay",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "50.45",
    longitude: "-126.29",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9078",
    name: "Kingcome water aerodrome",
    city: "Kingcome",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "50.58",
    longitude: "-128.11",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9079",
    name: "Thalmaessing Waizenhofen",
    city: "Thalmaessing",
    country: "Germany",
    iata: "",
    icao: "EDPW",
    latitude: "49.064444",
    longitude: "11.208056",
    altitude: "1893",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9080",
    name: "Tcentralny",
    city: "Taganrog",
    country: "Russia",
    iata: "",
    icao: "XRRC",
    latitude: "47.246",
    longitude: "38.84",
    altitude: "183",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "9081",
    name: "Buffalo Exchange Street Station",
    city: "Buffalo",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.8783",
    longitude: "-78.8738",
    altitude: "600",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9082",
    name: "Wilmington Amtrak Station",
    city: "Wilmington",
    country: "United States",
    iata: "ZWI",
    icao: "\\N",
    latitude: "39.736667",
    longitude: "-75.551667",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9083",
    name: "Vagaru Island",
    city: "Viceroy Resort",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "6.089305",
    longitude: "73.203857",
    altitude: "5",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "9084",
    name: "Fort McMurray - Mildred Lake Airport",
    city: "Fort McMurray",
    country: "Canada",
    iata: "NML",
    icao: "\\N",
    latitude: "57.055599",
    longitude: "-111.573997",
    altitude: "1046",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "9085",
    name: "Genoa Cruise Terminal",
    city: "Genova",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "44.40725",
    longitude: "8.876301",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "9086",
    name: "Suzhou Industrial Park Railway Station",
    city: "Suzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "31.344444",
    longitude: "120.706667",
    altitude: "7",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9087",
    name: "Elkhart Municipal",
    city: "Elkhart",
    country: "United States",
    iata: "EKI",
    icao: "\\N",
    latitude: "41.719444",
    longitude: "-86.003333",
    altitude: "778",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9088",
    name: "Cochrane",
    city: "Cochrane",
    country: "Canada",
    iata: "YCN",
    icao: "CYCN",
    latitude: "49.106667",
    longitude: "-81.015278",
    altitude: "852",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9089",
    name: "Aeroporto Estadual Arthur Siqueira",
    city: "Braganca Paulista",
    country: "Brazil",
    iata: "BJP",
    icao: "SBBP",
    latitude: "-22.979167",
    longitude: "-46.5375",
    altitude: "3",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "9090",
    name: "Brusselton",
    city: "Brusselton",
    country: "Australia",
    iata: "BQB",
    icao: "YBLN",
    latitude: "-33.687222",
    longitude: "115.400278",
    altitude: "55",
    timezone: "8",
    dst: "O",
    tz: "Australia/Perth",
  },
  {
    id: "9091",
    name: "Srednekolymsk",
    city: "Srednekolymsk",
    country: "Russia",
    iata: "",
    icao: "UESK",
    latitude: "67.2748",
    longitude: "153.4258",
    altitude: "98",
    timezone: "12",
    dst: "N",
    tz: "Asia/Magadan",
  },
  {
    id: "9092",
    name: "Garowe - International",
    city: "Garowe",
    country: "Somalia",
    iata: "GGR",
    icao: "\\N",
    latitude: "8.24",
    longitude: "48.29",
    altitude: "553",
    timezone: "3",
    dst: "N",
    tz: "Africa/Mogadishu",
  },
  {
    id: "9093",
    name: "Salt Lake City Intermodal Hub",
    city: "Salt Lake City",
    country: "United States",
    iata: "",
    icao: "SLCR",
    latitude: "40.762778",
    longitude: "-111.908333",
    altitude: "0",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9094",
    name: "Thorny Bush Game Lodge Airport",
    city: "Hoedspruit",
    country: "South Africa",
    iata: "",
    icao: "\\N",
    latitude: "-24.414722",
    longitude: "31.165001",
    altitude: "1900",
    timezone: "2",
    dst: "U",
    tz: "Africa/Johannesburg",
  },
  {
    id: "9095",
    name: "Inverell",
    city: "Inverell",
    country: "Australia",
    iata: "IVR",
    icao: "YIVL",
    latitude: "-29.888333",
    longitude: "151.144167",
    altitude: "2667",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9096",
    name: "Glen Innes",
    city: "Glen Innes",
    country: "Australia",
    iata: "GLI",
    icao: "YGLI",
    latitude: "-29.675",
    longitude: "151.69",
    altitude: "3433",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9097",
    name: "Hangzhou Railway Station",
    city: "Hangzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "30.246",
    longitude: "120.1784",
    altitude: "39",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9098",
    name: "Sorrento Valley Station",
    city: "San Diego",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "32.903",
    longitude: "-117.225",
    altitude: "150",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9099",
    name: "San Diego Union Station",
    city: "San Diego",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "32.716944",
    longitude: "-117.168611",
    altitude: "50",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9100",
    name: "Petersdorf",
    city: "Ansbach",
    country: "Germany",
    iata: "",
    icao: "EDQF",
    latitude: "49.216",
    longitude: "10.4026",
    altitude: "1370",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9101",
    name: "Venice-Venezia Mestre",
    city: "Venice",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "45.48189",
    longitude: "12.231923",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "9102",
    name: "Immokalee ",
    city: "Immokalee ",
    country: "United States",
    iata: "IMM",
    icao: "KIMM",
    latitude: "26.433889",
    longitude: "-81.401389",
    altitude: "37",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9103",
    name: "Maranggo",
    city: "Sulawesi Tenggara",
    country: "Indonesia",
    iata: "",
    icao: "WA44",
    latitude: "-5.76457",
    longitude: "123.917",
    altitude: "169",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "9104",
    name: "Rancho San Simeon Airport",
    city: "Cambria",
    country: "United States",
    iata: "",
    icao: "66CA",
    latitude: "35.607748",
    longitude: "-121.110192",
    altitude: "320",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9105",
    name: "Port Canaveral",
    city: "Brevard County",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "28.4113919",
    longitude: "-80.6081066",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9106",
    name: "Cococay",
    city: "Ragged Island",
    country: "Bahamas",
    iata: "",
    icao: "\\N",
    latitude: "22.148056",
    longitude: "-75.693333",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Nassau",
  },
  {
    id: "9107",
    name: "Yichun Mingyueshan Airport",
    city: "Yichun",
    country: "China",
    iata: "YIC",
    icao: "ZSYC",
    latitude: "27.8033",
    longitude: "114.3081",
    altitude: "131",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "9108",
    name: "Costa maya port",
    city: "Costa maya",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "18.714",
    longitude: "-87.709",
    altitude: "0",
    timezone: "-6",
    dst: "U",
    tz: "America/Mexico_City",
  },
  {
    id: "9109",
    name: "Costa maya port",
    city: "Costa maya",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "18.714",
    longitude: "-87.709",
    altitude: "0",
    timezone: "-6",
    dst: "U",
    tz: "America/Mexico_City",
  },
  {
    id: "9110",
    name: "Fajardo",
    city: "Fajardo",
    country: "Puerto Rico",
    iata: "",
    icao: "\\N",
    latitude: "18.32",
    longitude: "-65.65",
    altitude: "0",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "9111",
    name: "Billings field",
    city: "Essex",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "42.199",
    longitude: "-82.465",
    altitude: "650",
    timezone: "-5",
    dst: "U",
    tz: "America/Toronto",
  },
  {
    id: "9112",
    name: "Hiberico Offshore Platform",
    city: "Cuidad del Carmen",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "19.398611",
    longitude: "-92.016111",
    altitude: "0",
    timezone: "-6",
    dst: "A",
    tz: "\\N",
  },
  {
    id: "9113",
    name: "Alpha offshore platform",
    city: "Cork",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "51.400377",
    longitude: "-7.901464",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "9114",
    name: "Peterhof Helicopter Landing area",
    city: "Saint-Petersburg",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "59.890529",
    longitude: "29.894609",
    altitude: "0",
    timezone: "4",
    dst: "U",
    tz: "Europe/Moscow",
  },
  {
    id: "9115",
    name: "Gogland Helicopter Landing",
    city: "Gogland Island",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "60.011662",
    longitude: "27.008236",
    altitude: "0",
    timezone: "4",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "9116",
    name: "New Carrollton Rail Station",
    city: "New Carrollton",
    country: "United States",
    iata: "ZRZ",
    icao: "\\N",
    latitude: "38.948",
    longitude: "-76.8719",
    altitude: "39",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9117",
    name: "Ship Channel Cay",
    city: "Ship Channel Cay",
    country: "Bahamas",
    iata: "",
    icao: "\\N",
    latitude: "24.819302",
    longitude: "-76.824331",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Nassau",
  },
  {
    id: "9118",
    name: "Walkersville Train Depot",
    city: "Walkersville",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.48618333333334",
    longitude: "-77.35475",
    altitude: "308",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9119",
    name: "Seattle Pier 69 - Victoria Clipper",
    city: "Seattle",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.613801",
    longitude: "-122.354019",
    altitude: "7",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9120",
    name: "Dinwiddie County Airport",
    city: "Petersburg",
    country: "United States",
    iata: "PTB",
    icao: "KPTB",
    latitude: "37.18375",
    longitude: "-77.507388",
    altitude: "193",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9121",
    name: "Mount Aso helipad",
    city: "Aso",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "32.884308",
    longitude: "131.064638",
    altitude: "1350",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "9122",
    name: "Mount Aso helipad",
    city: "Aso",
    country: "Japan",
    iata: "",
    icao: "\\N",
    latitude: "32.884308",
    longitude: "131.064638",
    altitude: "1350",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "9123",
    name: "Kasongo Lunda",
    city: "Kasongo",
    country: "Congo (Kinshasa)",
    iata: "KGN",
    icao: "FZOK",
    latitude: "-6.583333",
    longitude: "16.816668",
    altitude: "0",
    timezone: "1",
    dst: "U",
    tz: "Africa/Kinshasa",
  },
  {
    id: "9124",
    name: "McMurdo Station Pegasus Field",
    city: "McMurdo Station",
    country: "Antarctica",
    iata: "",
    icao: "NZPG",
    latitude: "-77.963333",
    longitude: "166.524444",
    altitude: "18",
    timezone: "12",
    dst: "Z",
    tz: "Antarctica/South_Pole",
  },
  {
    id: "9125",
    name: "Klatovy",
    city: "Klatovy",
    country: "Czech Republic",
    iata: "",
    icao: "LKKT",
    latitude: "49.418327",
    longitude: "13.321944",
    altitude: "1299",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "9126",
    name: "Sheboygan County Memorial Airport",
    city: "Sheboygan",
    country: "United States",
    iata: "SBM",
    icao: "KSBM",
    latitude: "43.7696",
    longitude: "-87.851402",
    altitude: "755",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9127",
    name: "Dave Forest Airport",
    city: "Cloudbreak",
    country: "Australia",
    iata: "KFE",
    icao: "YFDF",
    latitude: "-22.291945",
    longitude: "119.437225",
    altitude: "1555",
    timezone: "8",
    dst: "N",
    tz: "Australia/Perth",
  },
  {
    id: "9128",
    name: "Ephraim-Gibraltar Airport",
    city: "Ephraim",
    country: "United States",
    iata: "3D2",
    icao: "\\N",
    latitude: "45.1354167",
    longitude: "-87.1879444",
    altitude: "773",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9129",
    name: "Kangel Danda Airport",
    city: "Kangel Danda",
    country: "Nepal",
    iata: "",
    icao: "VNKL",
    latitude: "27.41667",
    longitude: "86.64167",
    altitude: "6880",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "9130",
    name: "Man Maya Airport",
    city: "Khanidanda",
    country: "Nepal",
    iata: "",
    icao: "VNKD",
    latitude: "27.19028",
    longitude: "86.77167",
    altitude: "4435",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "9131",
    name: "Talcha Airport",
    city: "Rara National Park",
    country: "Nepal",
    iata: "",
    icao: "VNT1",
    latitude: "29.43",
    longitude: "81",
    altitude: "0",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "9132",
    name: "Bajura Airport",
    city: "Bajura",
    country: "Nepal",
    iata: "BJU",
    icao: "VNBR",
    latitude: "29.50611",
    longitude: "81.66944",
    altitude: "4606",
    timezone: "5.75",
    dst: "N",
    tz: "Asia/Katmandu",
  },
  {
    id: "9133",
    name: "Walkersville Turnaround",
    city: "Frederick",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.4449",
    longitude: "-77.4012",
    altitude: "302",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9134",
    name: "Airport Chara",
    city: "Chara",
    country: "Russia",
    iata: "",
    icao: "UIAR",
    latitude: "56.912765",
    longitude: "118.271007",
    altitude: "671",
    timezone: "10",
    dst: "N",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9135",
    name: "Tho Xuan Airport",
    city: "Thanh Hoa",
    country: "Vietnam",
    iata: "THD",
    icao: "\\N",
    latitude: "19.90167",
    longitude: "105.46778",
    altitude: "0",
    timezone: "7",
    dst: "N",
    tz: "Asia/Saigon",
  },
  {
    id: "9136",
    name: "Herning",
    city: "Herning",
    country: "Denmark",
    iata: "",
    icao: "EKHG",
    latitude: "56.197224",
    longitude: "9.147222",
    altitude: "136",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "9137",
    name: "Sonderlandeplatz Schleissheim",
    city: "Schleissheim",
    country: "Germany",
    iata: "",
    icao: "EDNX",
    latitude: "48.239167",
    longitude: "11.561389",
    altitude: "1594",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9138",
    name: "Pinal Airpark",
    city: "Marana",
    country: "United States",
    iata: "MZJ",
    icao: "KMZJ",
    latitude: "32.509722",
    longitude: "-111.325278",
    altitude: "1893",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "9139",
    name: "Glendale Municipal Airport",
    city: "Glendale",
    country: "United States",
    iata: "GEU",
    icao: "KGEU",
    latitude: "33.5269167",
    longitude: "-112.2951389",
    altitude: "1071",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "9140",
    name: "Safford Regional Airport",
    city: "Safford",
    country: "United States",
    iata: "SAD",
    icao: "KSAD",
    latitude: "32.8533333",
    longitude: "-109.6350833",
    altitude: "3179",
    timezone: "-7",
    dst: "N",
    tz: "America/Phoenix",
  },
  {
    id: "9141",
    name: "Verden Scharnhorst",
    city: "Verden",
    country: "Germany",
    iata: "",
    icao: "EDWV",
    latitude: "52.965278",
    longitude: "9.282778",
    altitude: "144",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9142",
    name: "Mara North",
    city: "Masai Mara",
    country: "Kenya",
    iata: "",
    icao: "\\N",
    latitude: "-1.142636",
    longitude: "35.139856",
    altitude: "5468",
    timezone: "3",
    dst: "N",
    tz: "Africa/Nairobi",
  },
  {
    id: "9143",
    name: "Fort Lauderdale-Hollywood International Airport Station at Dania Beach",
    city: "Dania Beach",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "26.061933",
    longitude: "-80.16565",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9144",
    name: "Deerfield Beach Station",
    city: "Deerfield Beach",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "26.316944",
    longitude: "-80.122222",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9145",
    name: "Lecheo",
    city: "Korinthos",
    country: "Greece",
    iata: "",
    icao: "\\N",
    latitude: "37.92592",
    longitude: "22.860228",
    altitude: "60",
    timezone: "2",
    dst: "E",
    tz: "Europe/Athens",
  },
  {
    id: "9146",
    name: "Solomon Airport",
    city: "Solomon",
    country: "Australia",
    iata: "SLJ",
    icao: "YSOL",
    latitude: "-22.255",
    longitude: "117.85",
    altitude: "2008",
    timezone: "8",
    dst: "N",
    tz: "Australia/Perth",
  },
  {
    id: "9147",
    name: "Bruck-Nittenau",
    city: "Nittenau",
    country: "Germany",
    iata: "",
    icao: "EDNM",
    latitude: "49.2225",
    longitude: "12.2967",
    altitude: "1161",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9148",
    name: "Kerama Airport",
    city: "Kerama",
    country: "Japan",
    iata: "KJP",
    icao: "ROKR",
    latitude: "26.168333",
    longitude: "127.293333",
    altitude: "156",
    timezone: "9",
    dst: "N",
    tz: "Asia/Tokyo",
  },
  {
    id: "9149",
    name: "Americana",
    city: "Americana",
    country: "Brazil",
    iata: "",
    icao: "SDAI",
    latitude: "-22.7558",
    longitude: "-47.269402",
    altitude: "2085",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "9150",
    name: "Brussels Gare Centrale",
    city: "Brussels",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "50.84548",
    longitude: "4.357174",
    altitude: "43",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "9151",
    name: "Comino Airport",
    city: "Comino",
    country: "Malta",
    iata: "JCO",
    icao: "\\N",
    latitude: "36.016",
    longitude: "14.333",
    altitude: "201",
    timezone: "1",
    dst: "E",
    tz: "Europe/Malta",
  },
  {
    id: "9152",
    name: "Udine stazione",
    city: "Udine",
    country: "Italy",
    iata: "",
    icao: "\\N",
    latitude: "46.04",
    longitude: "13.14",
    altitude: "1",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "9153",
    name: "Bratislava Hlavna Stanica",
    city: "Bratislava",
    country: "Slovakia",
    iata: "",
    icao: "\\N",
    latitude: "48.08",
    longitude: "17.06",
    altitude: "1",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "9154",
    name: "Depati Parbo Airport",
    city: "Sungai Penuh",
    country: "Indonesia",
    iata: "",
    icao: "\\N",
    latitude: "1.881071",
    longitude: "101.442261",
    altitude: "2000",
    timezone: "7",
    dst: "U",
    tz: "Asia/Jakarta",
  },
  {
    id: "9155",
    name: "Kolosovka",
    city: "Kolosovka",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "56.2752",
    longitude: "73.3641",
    altitude: "100",
    timezone: "7",
    dst: "U",
    tz: "Asia/Omsk",
  },
  {
    id: "9156",
    name: "Ekibastuz airport",
    city: "Ekibastuz",
    country: "Kazakhstan",
    iata: "",
    icao: "UASB",
    latitude: "51.5723",
    longitude: "75.2613",
    altitude: "776",
    timezone: "6",
    dst: "N",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "9157",
    name: "Znamenka airport",
    city: "Znamenskoe",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "57.1523",
    longitude: "73.7512",
    altitude: "432",
    timezone: "7",
    dst: "E",
    tz: "Asia/Omsk",
  },
  {
    id: "9158",
    name: "Tevriz airport",
    city: "Tevriz",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "57.5243",
    longitude: "72.4653",
    altitude: "456",
    timezone: "7",
    dst: "U",
    tz: "Asia/Omsk",
  },
  {
    id: "9159",
    name: "Besobe airport",
    city: "Bestobe",
    country: "Kazakhstan",
    iata: "",
    icao: "\\N",
    latitude: "52.4986",
    longitude: "73.1434",
    altitude: "645",
    timezone: "6",
    dst: "N",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "9160",
    name: "Stepnogorsk airport",
    city: "Stepnogorsk",
    country: "Kazakhstan",
    iata: "",
    icao: "\\N",
    latitude: "52.3575",
    longitude: "71.7865",
    altitude: "432",
    timezone: "6",
    dst: "N",
    tz: "Asia/Qyzylorda",
  },
  {
    id: "9161",
    name: "Bekdash airport",
    city: "Karabogaz",
    country: "Turkmenistan",
    iata: "",
    icao: "\\N",
    latitude: "41.5397",
    longitude: "52.5711",
    altitude: "12",
    timezone: "5",
    dst: "U",
    tz: "Asia/Ashgabat",
  },
  {
    id: "9162",
    name: "Adamovka",
    city: "Adamovka",
    country: "Russia",
    iata: "",
    icao: "UWOD",
    latitude: "51.4929",
    longitude: "59.92752",
    altitude: "931",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "9163",
    name: "Kvarkeno",
    city: "Kvarkeno",
    country: "Russia",
    iata: "",
    icao: "UWOH",
    latitude: "52.078333",
    longitude: "59.683333",
    altitude: "305",
    timezone: "6",
    dst: "U",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "9164",
    name: "Sikeston Memorial Municipal",
    city: "Sikeston",
    country: "United States",
    iata: "SIK",
    icao: "KSIK",
    latitude: "36.8988889",
    longitude: "-89.56175",
    altitude: "315",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9165",
    name: "Nynashamn Ferry Port",
    city: "Nynashamn",
    country: "Sweden",
    iata: "NYN",
    icao: "\\N",
    latitude: "58.9",
    longitude: "17.95",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "9166",
    name: "Rodby Port",
    city: "Rodby",
    country: "Denmark",
    iata: "ROD",
    icao: "\\N",
    latitude: "54.65",
    longitude: "11.35",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Copenhagen",
  },
  {
    id: "9167",
    name: "Puttgarden",
    city: "Puttgarden",
    country: "Germany",
    iata: "QUA",
    icao: "\\N",
    latitude: "54.5",
    longitude: "11.2167",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9168",
    name: "Sonevafushi",
    city: "Sonevafushi",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.112336",
    longitude: "73.07805",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9169",
    name: "Royal Island Resort",
    city: "Royal Island Resort",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.162911",
    longitude: "73.053578",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9170",
    name: "Royal Island Resort",
    city: "Royal Island Resort",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.162911",
    longitude: "73.053578",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9171",
    name: "Port of Belfast",
    city: "Belfast",
    country: "United Kingdom",
    iata: "BE2",
    icao: "\\N",
    latitude: "54.6178",
    longitude: "-5.9017",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9172",
    name: "Stranraer Ferry Port",
    city: "Stranraer",
    country: "United Kingdom",
    iata: "SR2",
    icao: "\\N",
    latitude: "54.902",
    longitude: "-5.027",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9173",
    name: "Oceano County Airport",
    city: "Oceano",
    country: "United States",
    iata: "L52",
    icao: "KL52",
    latitude: "35.10147222",
    longitude: "-120.62236111",
    altitude: "14",
    timezone: "-8",
    dst: "U",
    tz: "America/Los_Angeles",
  },
  {
    id: "9174",
    name: "Eupen - Rail",
    city: "Eupen",
    country: "Belgium",
    iata: "",
    icao: "\\N",
    latitude: "50.3743",
    longitude: "6.0201",
    altitude: "1000",
    timezone: "1",
    dst: "E",
    tz: "Europe/Brussels",
  },
  {
    id: "9175",
    name: "Tetiaroa Airport",
    city: "Tetiaroa",
    country: "French Polynesia",
    iata: "TTI",
    icao: "NTTE",
    latitude: "-17.0132999",
    longitude: "-149.5870056",
    altitude: "0",
    timezone: "-10",
    dst: "N",
    tz: "Pacific/Tahiti",
  },
  {
    id: "9176",
    name: "Osnabrueck Hbf",
    city: "Osnabrueck",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "52.272778",
    longitude: "8.061111",
    altitude: "207",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9177",
    name: "Hannover Hbf",
    city: "Hannover",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "52.366667",
    longitude: "9.716667",
    altitude: "180",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9178",
    name: "Floyd Bennett Memorial Airport",
    city: "Queensbury",
    country: "United States",
    iata: "GFL",
    icao: "KGFL",
    latitude: "43.341222",
    longitude: "-73.610305",
    altitude: "328",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9179",
    name: "Saratoga County Airport",
    city: "Ballston Spa",
    country: "United States",
    iata: "5B2",
    icao: "K5B2",
    latitude: "43.050722",
    longitude: "-73.861638",
    altitude: "433",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9180",
    name: "Burrello-Mechanicville Airport",
    city: "Mechanicville",
    country: "United States",
    iata: "K27",
    icao: "\\N",
    latitude: "42.893133",
    longitude: "-73.66845",
    altitude: "195",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9181",
    name: "Tampa Padang",
    city: "Mamuju",
    country: "Indonesia",
    iata: "MJU",
    icao: "WAWJ",
    latitude: "-2.583333",
    longitude: "119.033333",
    altitude: "2",
    timezone: "8",
    dst: "N",
    tz: "Asia/Makassar",
  },
  {
    id: "9182",
    name: "Crystal River",
    city: "Crystal River",
    country: "United States",
    iata: "CGC",
    icao: "KCGC",
    latitude: "28.8676111",
    longitude: "-82.5741111",
    altitude: "9",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9183",
    name: "Martin State",
    city: "Baltimore",
    country: "United States",
    iata: "MTN",
    icao: "KMTN",
    latitude: "39.3256667",
    longitude: "-76.4137778",
    altitude: "22",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9184",
    name: "Lincoln Regional Airport Karl Harder Field",
    city: "Lincoln",
    country: "United States",
    iata: "LHM",
    icao: "KLHM",
    latitude: "38.9091667",
    longitude: "-121.3513333",
    altitude: "121",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9185",
    name: "Fostoria Metropolitan Airport",
    city: "Fostoria",
    country: "United States",
    iata: "FZI",
    icao: "KFZI",
    latitude: "41.1908333",
    longitude: "-83.3930833",
    altitude: "752",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9186",
    name: "Eastern Slopes Regional",
    city: "Fryeburg",
    country: "United States",
    iata: "IZG",
    icao: "KIZG",
    latitude: "43.9911389",
    longitude: "-70.9478889",
    altitude: "455",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9187",
    name: "Coral Creek",
    city: "Placida",
    country: "United States",
    iata: "",
    icao: "FA54",
    latitude: "26.8537417",
    longitude: "-82.2526028",
    altitude: "8",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9188",
    name: "Lakefront",
    city: "New Orleans",
    country: "United States",
    iata: "NEW",
    icao: "KNEW",
    latitude: "30.0424167",
    longitude: "-90.02825",
    altitude: "7",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9189",
    name: "Pappy Boyington",
    city: "Coeur d'Alene",
    country: "United States",
    iata: "COE",
    icao: "KCOE",
    latitude: "47.7743056",
    longitude: "-116.8195833",
    altitude: "2320",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9190",
    name: "Beaumont Municipal",
    city: "Beaumont",
    country: "United States",
    iata: "BMT",
    icao: "KBMT",
    latitude: "30.0702044",
    longitude: "-94.2150967",
    altitude: "32",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9191",
    name: "Vermilion Regional",
    city: "Danville",
    country: "United States",
    iata: "DNV",
    icao: "KDNV",
    latitude: "40.1996944",
    longitude: "-87.5955278",
    altitude: "696",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9192",
    name: "Varberg Railway Station",
    city: "Varberg",
    country: "Sweden",
    iata: "",
    icao: "\\N",
    latitude: "57.107118",
    longitude: "12.2520907",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "9193",
    name: "Coonabarabran",
    city: "Coonabarabran",
    country: "Australia",
    iata: "COJ",
    icao: "YCBB",
    latitude: "-31.337221",
    longitude: "149.27194",
    altitude: "2117",
    timezone: "10",
    dst: "O",
    tz: "Australia/Sydney",
  },
  {
    id: "9194",
    name: "Toronto Union Station",
    city: "Toronto",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.645278",
    longitude: "-79.380556",
    altitude: "249",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9195",
    name: "Windsor Station",
    city: "Windsor",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "42.3254",
    longitude: "-83.0092",
    altitude: "623",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9196",
    name: "Dearborn Amtrak Station",
    city: "Dearborn",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.312222",
    longitude: "-83.198611",
    altitude: "591",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9197",
    name: "Merritt Island Airport",
    city: "Cocoa",
    country: "United States",
    iata: "COI",
    icao: "\\N",
    latitude: "28.3416111",
    longitude: "-80.6854722",
    altitude: "6",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9198",
    name: "Valkaria Municipal",
    city: "Valkaria",
    country: "United States",
    iata: "X59",
    icao: "\\N",
    latitude: "27.9608611",
    longitude: "-80.5583333",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9199",
    name: "Space Coast Reg'l Airport",
    city: "Titusville",
    country: "United States",
    iata: "TIX",
    icao: "\\N",
    latitude: "28.5148",
    longitude: "-80.7992278",
    altitude: "34",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9200",
    name: "Sebastian Municipal",
    city: "Sebastian",
    country: "United States",
    iata: "X26",
    icao: "\\N",
    latitude: "27.81325",
    longitude: "-80.4955833",
    altitude: "21",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9201",
    name: "Terrace Bay",
    city: "Terrace Bay",
    country: "Namibia",
    iata: "TCY",
    icao: "\\N",
    latitude: "-19.9705556",
    longitude: "13.0244444",
    altitude: "0",
    timezone: "1",
    dst: "N",
    tz: "Africa/Windhoek",
  },
  {
    id: "9202",
    name: "Nxabega Airstrip",
    city: "Nxabega",
    country: "Botswana",
    iata: "",
    icao: "FB57",
    latitude: "-19.5147",
    longitude: "22.77665",
    altitude: "3100",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "9203",
    name: "Kelani River-Peliyagoda Waterdrome",
    city: "Colombo",
    country: "Sri Lanka",
    iata: "KEZ",
    icao: "\\N",
    latitude: "6.967463700288899",
    longitude: "79.88197231301456",
    altitude: "28",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Colombo",
  },
  {
    id: "9204",
    name: "Polgolla Reservoir",
    city: "Kandy",
    country: "Sri Lanka",
    iata: "KDZ",
    icao: "\\N",
    latitude: "7.325125009685146",
    longitude: "80.64211571225314",
    altitude: "1472",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Colombo",
  },
  {
    id: "9205",
    name: "Bumi",
    city: "Bumi Hills",
    country: "Zimbabwe",
    iata: "",
    icao: "FVBM",
    latitude: "-16.81685727384918",
    longitude: "28.348887920401467",
    altitude: "1633",
    timezone: "2",
    dst: "N",
    tz: "Africa/Harare",
  },
  {
    id: "9206",
    name: "Priv",
    city: "Lagos",
    country: "Portugal",
    iata: "",
    icao: "\\N",
    latitude: "37.096744",
    longitude: "-8.663535",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/Lisbon",
  },
  {
    id: "9207",
    name: "Warnervale Airport",
    city: "Warnervale Airport",
    country: "Australia",
    iata: "",
    icao: "YWVA",
    latitude: "-33.240833",
    longitude: "151.427778",
    altitude: "25",
    timezone: "10",
    dst: "U",
    tz: "Australia/Sydney",
  },
  {
    id: "9208",
    name: "Boat",
    city: "Hati",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "19.15",
    longitude: "-73",
    altitude: "0",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9209",
    name: "Boat",
    city: "Hati",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "19.1",
    longitude: "-73",
    altitude: "0",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9210",
    name: "Cartitas",
    city: "Hati",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "18.55",
    longitude: "-72.3",
    altitude: "50",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9211",
    name: "Boat",
    city: "Hati",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "19",
    longitude: "-73",
    altitude: "0",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9212",
    name: "Hospital",
    city: "Port Au Prince",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "18.5501",
    longitude: "-72.3001",
    altitude: "50",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9213",
    name: "Clinic",
    city: "Saint Marc",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "19.1001",
    longitude: "-72.7001",
    altitude: "30",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9214",
    name: "Village",
    city: "Dodard",
    country: "Haiti",
    iata: "",
    icao: "\\N",
    latitude: "19.0661",
    longitude: "-72.3001",
    altitude: "2639",
    timezone: "-5",
    dst: "N",
    tz: "America/Port-au-Prince",
  },
  {
    id: "9215",
    name: "Bouarfa International",
    city: "Bouarfa",
    country: "Morocco",
    iata: "",
    icao: "GMFB",
    latitude: "32.518889",
    longitude: "-1.9775",
    altitude: "3564",
    timezone: "0",
    dst: "N",
    tz: "Africa/Casablanca",
  },
  {
    id: "9216",
    name: "Beijing West Railway Station",
    city: "Beijing",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "39.8955463",
    longitude: "116.3201722",
    altitude: "167",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9217",
    name: "Hung Hom Railway Station",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "\\N",
    latitude: "22.303067",
    longitude: "114.18152699999996",
    altitude: "39",
    timezone: "8",
    dst: "N",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "9218",
    name: "NYERI",
    city: "NYERI",
    country: "Kenya",
    iata: "NYE",
    icao: "HKNI",
    latitude: "-0.34",
    longitude: "36.91",
    altitude: "5830",
    timezone: "3",
    dst: "U",
    tz: "Africa/Nairobi",
  },
  {
    id: "9219",
    name: "Angaga Seaplane Dock",
    city: "Alifu Dhaalu Atoll",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.652859",
    longitude: "72.824086",
    altitude: "2",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "9220",
    name: "Madoogali Seaplane Dock",
    city: "Alifu Atoll",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "4.0956",
    longitude: "72.753439",
    altitude: "2",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "9221",
    name: "Effingham Memorial Airport",
    city: "Effingham",
    country: "United States",
    iata: "1H2",
    icao: "KEFH",
    latitude: "39.07",
    longitude: "-88.534",
    altitude: "585",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9222",
    name: "Stoke",
    city: "Stoke-on-Trent",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "53",
    longitude: "2.18333",
    altitude: "500",
    timezone: "0",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "9223",
    name: "Tobermory Dock",
    city: "Tobermory",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "45.2578121",
    longitude: "-81.6637838",
    altitude: "1335",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9224",
    name: "South Baymouth Docks",
    city: "South Baymouth",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "45.5564479",
    longitude: "-82.0071535",
    altitude: "1335",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9225",
    name: "Andrau Airport",
    city: "Houston",
    country: "United States",
    iata: "AAP",
    icao: "KAAP",
    latitude: "29.43",
    longitude: "-95.35",
    altitude: "80",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9226",
    name: "Flying Cloud Airport",
    city: "Eden Prairie",
    country: "United States",
    iata: "FCM",
    icao: "KFCM",
    latitude: "44.4938",
    longitude: "-93.2726",
    altitude: "906",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9227",
    name: "Likoma Island Airport",
    city: "Likoma Island",
    country: "Malawi",
    iata: "LIX",
    icao: "FWLK",
    latitude: "-12.083",
    longitude: "34.733001",
    altitude: "1600",
    timezone: "2",
    dst: "N",
    tz: "Africa/Blantyre",
  },
  {
    id: "9228",
    name: "Johnson County Airport",
    city: "Olathe",
    country: "United States",
    iata: "OJC",
    icao: "KOJC",
    latitude: "38.5051",
    longitude: "-94.4415",
    altitude: "1096",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9229",
    name: "Sigiriya Airport",
    city: "Sigiriya",
    country: "Sri Lanka",
    iata: "GIU",
    icao: "VCCS",
    latitude: "7.57212",
    longitude: "80.43412",
    altitude: "630",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Colombo",
  },
  {
    id: "9230",
    name: "Westbahnhoff",
    city: "Vienna",
    country: "Austria",
    iata: "XWW",
    icao: "\\N",
    latitude: "48.196667",
    longitude: "16.337778",
    altitude: "600",
    timezone: "1",
    dst: "E",
    tz: "Europe/Vienna",
  },
  {
    id: "9231",
    name: "York Mills GO Bus Terminal",
    city: "York Mills",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.745",
    longitude: "-79.406389",
    altitude: "449",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9232",
    name: "Neumuenster",
    city: "Neumuenster",
    country: "Germany",
    iata: "EUM",
    icao: "EDHN",
    latitude: "54.079069",
    longitude: "9.941719",
    altitude: "69",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9233",
    name: "Tak",
    city: "Tak",
    country: "Thailand",
    iata: "TKT",
    icao: "VTPT",
    latitude: "16.89611",
    longitude: "99.25361",
    altitude: "478",
    timezone: "7",
    dst: "N",
    tz: "Asia/Bangkok",
  },
  {
    id: "9234",
    name: "Marshall Aiport",
    city: "Marshall",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "44.4469",
    longitude: "95.7883",
    altitude: "354",
    timezone: "8",
    dst: "A",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "9235",
    name: "Meedhuffushi Seaplane dock",
    city: "Meedhuffushi Island",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "3.003899",
    longitude: "73.000696",
    altitude: "0",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9236",
    name: "Lake Simcoe",
    city: "Barrie-Orillia",
    country: "Canada",
    iata: "YLS",
    icao: "CYLS",
    latitude: "44.487778",
    longitude: "-79.559444",
    altitude: "972",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9237",
    name: "Huronia",
    city: "Midland",
    country: "Canada",
    iata: "YEE",
    icao: "CYEE",
    latitude: "44.684722",
    longitude: "-79.929167",
    altitude: "773",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9238",
    name: "Markham",
    city: "Markham",
    country: "Canada",
    iata: "NU8",
    icao: "CNU8",
    latitude: "43.935278",
    longitude: "-79.263333",
    altitude: "807",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9239",
    name: "Stanhope",
    city: "Haliburton",
    country: "Canada",
    iata: "ND4",
    icao: "CND4",
    latitude: "45.110833",
    longitude: "-78.64",
    altitude: "1066",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9240",
    name: "Lindsay",
    city: "Lindsay",
    country: "Canada",
    iata: "NF4",
    icao: "CNF4",
    latitude: "44.364722",
    longitude: "-78.783889",
    altitude: "895",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9241",
    name: "Niagara District",
    city: "Saint Catherines",
    country: "Canada",
    iata: "YCM",
    icao: "CYSN",
    latitude: "43.191667",
    longitude: "-79.171111",
    altitude: "321",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9242",
    name: "Apopka",
    city: "Orlando",
    country: "United States",
    iata: "X04",
    icao: "\\N",
    latitude: "28.707222",
    longitude: "-81.581667",
    altitude: "143",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9243",
    name: "Edenvale",
    city: "Edenvale",
    country: "Canada",
    iata: "",
    icao: "CNV8",
    latitude: "44.438889",
    longitude: "-79.965278",
    altitude: "718",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9244",
    name: "Orillia",
    city: "Orillia",
    country: "Canada",
    iata: "",
    icao: "CNJ4",
    latitude: "44.683333",
    longitude: "-79.316667",
    altitude: "725",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9245",
    name: "Holland Landing",
    city: "Holland Landing",
    country: "Canada",
    iata: "",
    icao: "CLA4",
    latitude: "44.089444",
    longitude: "-79.495",
    altitude: "855",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9246",
    name: "Kent",
    city: "Chatham",
    country: "Canada",
    iata: "XCM",
    icao: "CNZ3",
    latitude: "42.306111",
    longitude: "-82.081667",
    altitude: "645",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9247",
    name: "Parry Sound",
    city: "Parry Sound",
    country: "Canada",
    iata: "YPD",
    icao: "CNK4",
    latitude: "45.253889",
    longitude: "-79.827778",
    altitude: "830",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9248",
    name: "Saugeen",
    city: "Hanover",
    country: "Canada",
    iata: "",
    icao: "CYHS",
    latitude: "44.158056",
    longitude: "-81.063333",
    altitude: "940",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9249",
    name: "Brandywine Airport",
    city: "West Goshen Township",
    country: "United States",
    iata: "OQN",
    icao: "KOQN",
    latitude: "39.5924",
    longitude: "-75.3455",
    altitude: "466",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9250",
    name: "Batoka",
    city: "Livingston",
    country: "Zambia",
    iata: "",
    icao: "\\N",
    latitude: "-17.53",
    longitude: "25.5",
    altitude: "3235",
    timezone: "2",
    dst: "U",
    tz: "Africa/Lusaka",
  },
  {
    id: "9251",
    name: "Manassas",
    city: "Manassas",
    country: "United States",
    iata: "MNZ",
    icao: "KHEF",
    latitude: "38.721389",
    longitude: "-77.515556",
    altitude: "192",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9252",
    name: "Texas Gulf Coast Regional",
    city: "Angleton",
    country: "United States",
    iata: "",
    icao: "KLBX",
    latitude: "29.1086389",
    longitude: "-95.4620833",
    altitude: "25",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9253",
    name: "Bubovice",
    city: "Bubovice",
    country: "Czech Republic",
    iata: "",
    icao: "LKBU",
    latitude: "49.974422",
    longitude: "14.180801",
    altitude: "1385",
    timezone: "1",
    dst: "E",
    tz: "Europe/Prague",
  },
  {
    id: "9254",
    name: "Shenzhen Railway Station",
    city: "Shenzhen",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "22.5344",
    longitude: "114.1121",
    altitude: "67",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9255",
    name: "Rakkestad Flyplass",
    city: "Rakkestad",
    country: "Norway",
    iata: "",
    icao: "ENRK",
    latitude: "59.3975",
    longitude: "11.3469",
    altitude: "381",
    timezone: "1",
    dst: "E",
    tz: "Europe/Oslo",
  },
  {
    id: "9256",
    name: "Johnstown Amtrak",
    city: "Johnstown",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.3297222",
    longitude: "-78.9222222",
    altitude: "1142",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9257",
    name: "Harvey Field S43",
    city: "Snohomish WA",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "47.904451",
    longitude: "-122.102529",
    altitude: "22",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9258",
    name: "Urgup",
    city: "Urgup",
    country: "Turkey",
    iata: "",
    icao: "\\N",
    latitude: "38.606239",
    longitude: "34.860276",
    altitude: "4000",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9259",
    name: "Dolo Ado",
    city: "Dolo Ado",
    country: "Ethiopia",
    iata: "",
    icao: "\\N",
    latitude: "4.175858",
    longitude: "42.034083",
    altitude: "630",
    timezone: "3",
    dst: "U",
    tz: "Africa/Addis_Ababa",
  },
  {
    id: "9260",
    name: "AYaou",
    city: "Yaou",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "3.724286",
    longitude: "-53.974698",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9261",
    name: "Camop",
    city: "Camopi",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "3.17004",
    longitude: "-52.337801",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9262",
    name: "CApat",
    city: "Croisee d Apatou",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "5.04305",
    longitude: "-54.0425",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9263",
    name: "Citro",
    city: "Citron",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.730072",
    longitude: "-53.95158",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9264",
    name: "DieuM",
    city: "Dieu Merci",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.782964",
    longitude: "-53.260539",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9265",
    name: "Dorli",
    city: "Dorlin",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "3.7353",
    longitude: "-53.5287",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9266",
    name: "Elyse",
    city: "Elysee",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.75",
    longitude: "-54.05",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9267",
    name: "Herap",
    city: "Morsbach",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "49.160592",
    longitude: "6.864892",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "9268",
    name: "OSMSE",
    city: "Saint Elie",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.81444",
    longitude: "-53.28833",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9269",
    name: "Prevo",
    city: "Remire",
    country: "French Guiana",
    iata: "",
    icao: "\\N",
    latitude: "4.89333",
    longitude: "-52.29222",
    altitude: "0",
    timezone: "-3",
    dst: "N",
    tz: "America/Cayenne",
  },
  {
    id: "9270",
    name: "Sisli Belediyesi Evlendirme Dairesi Heliport",
    city: "Istanbul",
    country: "Turkey",
    iata: "",
    icao: "\\N",
    latitude: "41.0410805",
    longitude: "28.9923138",
    altitude: "100",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9271",
    name: "Kadikoy Ispark Heliport",
    city: "Istanbul",
    country: "Turkey",
    iata: "",
    icao: "\\N",
    latitude: "40.989305",
    longitude: "29.018833",
    altitude: "100",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9272",
    name: "Bingol",
    city: "Bingol",
    country: "Turkey",
    iata: "BGG",
    icao: "LTCU",
    latitude: "38.86111",
    longitude: "40.5925",
    altitude: "3490",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9273",
    name: "Uzunyazi",
    city: "Kastamonu",
    country: "Turkey",
    iata: "KFS",
    icao: "LTAL",
    latitude: "41.316944",
    longitude: "33.796111",
    altitude: "3520",
    timezone: "2",
    dst: "E",
    tz: "Europe/Istanbul",
  },
  {
    id: "9274",
    name: "Okawango Lodge",
    city: "Okawango",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.25",
    longitude: "23.09",
    altitude: "3100",
    timezone: "2",
    dst: "N",
    tz: "Africa/Gaborone",
  },
  {
    id: "9275",
    name: "Kai Tak",
    city: "Hong Kong",
    country: "Hong Kong",
    iata: "",
    icao: "HKGX",
    latitude: "22.317883",
    longitude: "114.202108",
    altitude: "50",
    timezone: "8",
    dst: "U",
    tz: "Asia/Hong_Kong",
  },
  {
    id: "9276",
    name: "Elstree",
    city: "Elstree",
    country: "United Kingdom",
    iata: "",
    icao: "EGTR",
    latitude: "51.4807",
    longitude: "-0.00093",
    altitude: "250",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9277",
    name: "Sandtoft Airfield",
    city: "Sandtoft",
    country: "United Kingdom",
    iata: "",
    icao: "EGCF",
    latitude: "53.559444",
    longitude: "-0.858332",
    altitude: "11",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9278",
    name: "Bourne Park",
    city: "Hurtsbourne Tarrant",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.264449",
    longitude: "-1.461975",
    altitude: "550",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9279",
    name: "Hite Airport",
    city: "Hanksville",
    country: "United States",
    iata: "UT3",
    icao: "\\N",
    latitude: "37.8916547",
    longitude: "-110.3840289",
    altitude: "3840",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9280",
    name: "Dieppe Ferry Port",
    city: "Dieppe",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "49.933616",
    longitude: "1.088039",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "9281",
    name: "Newhaven Ferry Port",
    city: "Newhaven",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "50.790385",
    longitude: "0.054551",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9282",
    name: "Ollantaytambo Train Station",
    city: "Ollantaytambo",
    country: "Peru",
    iata: "",
    icao: "\\N",
    latitude: "-13.263155",
    longitude: "-72.270291",
    altitude: "9160",
    timezone: "-5",
    dst: "N",
    tz: "America/Lima",
  },
  {
    id: "9283",
    name: "Aguas Calientes Train Station",
    city: "Aguas Calientes",
    country: "Peru",
    iata: "",
    icao: "\\N",
    latitude: "-13.1556",
    longitude: "-72.5238",
    altitude: "6693",
    timezone: "-5",
    dst: "N",
    tz: "America/Lima",
  },
  {
    id: "9284",
    name: "Poroy Train Station",
    city: "Cusco",
    country: "Peru",
    iata: "",
    icao: "\\N",
    latitude: "-13.4944",
    longitude: "-72.0421",
    altitude: "11710",
    timezone: "-5",
    dst: "N",
    tz: "America/Lima",
  },
  {
    id: "9285",
    name: "Aberdeen Harbour",
    city: "Aberdeen",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "57.13967",
    longitude: "-2.07467",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9286",
    name: "Lerwick Harbour",
    city: "Lerwick",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "60.15",
    longitude: "-1.13333",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9287",
    name: "Torshavn Harbour",
    city: "Torshavn",
    country: "Faroe Islands",
    iata: "",
    icao: "\\N",
    latitude: "62.0057",
    longitude: "-6.7717",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Faeroe",
  },
  {
    id: "9288",
    name: "Seydisfjordur",
    city: "Seydisfjordur",
    country: "Iceland",
    iata: "",
    icao: "\\N",
    latitude: "65.26016",
    longitude: "-14.00905",
    altitude: "0",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "9289",
    name: "Queen Street Station",
    city: "Glasgow",
    country: "United Kingdom",
    iata: "GLQ",
    icao: "\\N",
    latitude: "55.8622",
    longitude: "-4.2512",
    altitude: "50",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9290",
    name: "Torit",
    city: "Torit",
    country: "South Sudan",
    iata: "",
    icao: "HSTR",
    latitude: "4.411111",
    longitude: "32.578889",
    altitude: "2018",
    timezone: "3",
    dst: "N",
    tz: "Africa/Juba",
  },
  {
    id: "9291",
    name: "Falmouth Port",
    city: "Falmouth",
    country: "Jamaica",
    iata: "",
    icao: "\\N",
    latitude: "18.492762",
    longitude: "-77.649675",
    altitude: "0",
    timezone: "-5",
    dst: "N",
    tz: "America/Jamaica",
  },
  {
    id: "9292",
    name: "Cozumel Port",
    city: "Cozumel",
    country: "Mexico",
    iata: "",
    icao: "\\N",
    latitude: "20.510439",
    longitude: "-86.94925",
    altitude: "0",
    timezone: "-6",
    dst: "A",
    tz: "America/Mexico_City",
  },
  {
    id: "9293",
    name: "Philipsburg Port",
    city: "Philipsburg",
    country: "Netherlands Antilles",
    iata: "",
    icao: "\\N",
    latitude: "18.012868",
    longitude: "-63.045242",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Curacao",
  },
  {
    id: "9294",
    name: "Basseterre Port",
    city: "Basseterre",
    country: "Saint Kitts and Nevis",
    iata: "",
    icao: "\\N",
    latitude: "17.290464",
    longitude: "-62.709473",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/St_Kitts",
  },
  {
    id: "9295",
    name: "Charlotte Amalie Port",
    city: "Charlotte Amalie",
    country: "Virgin Islands",
    iata: "",
    icao: "\\N",
    latitude: "18.335431",
    longitude: "-64.926824",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/St_Thomas",
  },
  {
    id: "9296",
    name: "San Juan Port",
    city: "San Juan",
    country: "Puerto Rico",
    iata: "",
    icao: "\\N",
    latitude: "18.458992",
    longitude: "-66.097693",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Puerto_Rico",
  },
  {
    id: "9297",
    name: "Santa Barbara Train Station",
    city: "Santa Barbara",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "34.413611",
    longitude: "-119.691667",
    altitude: "8",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9298",
    name: "Eugene Amtrak Station",
    city: "Eugene",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "44.055062",
    longitude: "-123.092372",
    altitude: "426",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9299",
    name: "Lincolnville GO Station",
    city: "Lincolnville",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.995278",
    longitude: "-79.233333",
    altitude: "873",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9300",
    name: "Mormugao-Goa Port",
    city: "Mormugao",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "15.4",
    longitude: "73.8",
    altitude: "0",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "9301",
    name: "Cochin Port",
    city: "Cochin",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "9.58",
    longitude: "76.14",
    altitude: "0",
    timezone: "5.5",
    dst: "N",
    tz: "Asia/Calcutta",
  },
  {
    id: "9302",
    name: "Penang Cruise Terminal",
    city: "Penang",
    country: "Malaysia",
    iata: "",
    icao: "\\N",
    latitude: "5.418828",
    longitude: "100.345804",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "9303",
    name: "Port Klang-Kuala Lumpur Cruise Terminal",
    city: "Port Klang",
    country: "Malaysia",
    iata: "",
    icao: "\\N",
    latitude: "2.984629",
    longitude: "101.336839",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Kuala_Lumpur",
  },
  {
    id: "9304",
    name: "Singapore Cruise Terminal",
    city: "Singapore",
    country: "Singapore",
    iata: "",
    icao: "\\N",
    latitude: "1.264185",
    longitude: "103.819821",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Singapore",
  },
  {
    id: "9305",
    name: "Shelby County Airport",
    city: "Shelbyville",
    country: "United States",
    iata: "2H0",
    icao: "K2H0",
    latitude: "39.410556",
    longitude: "-88.845556",
    altitude: "550",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9306",
    name: "Illinois Terminal",
    city: "Champaign",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.1155",
    longitude: "-88.2411",
    altitude: "732",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9307",
    name: "Mattoon Amtrak",
    city: "Mattoon",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.4828",
    longitude: "-88.3759",
    altitude: "733",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9308",
    name: "Dawu",
    city: "Lvliang",
    country: "China",
    iata: "LLV",
    icao: "\\N",
    latitude: "37.683333",
    longitude: "111.142778",
    altitude: "3020",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9309",
    name: "Delft Central",
    city: "Delft",
    country: "Netherlands",
    iata: "",
    icao: "\\N",
    latitude: "52.006667",
    longitude: "4.356667",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Amsterdam",
  },
  {
    id: "9310",
    name: "Yading Daocheng",
    city: "Daocheng",
    country: "China",
    iata: "DCY",
    icao: "ZUDC",
    latitude: "29.3231",
    longitude: "100.0533",
    altitude: "14472",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9311",
    name: "Gannan",
    city: "Xiahe city",
    country: "China",
    iata: "GXH",
    icao: "ZLXH",
    latitude: "34.4909",
    longitude: "102.3719",
    altitude: "10466",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9312",
    name: "Komandoo",
    city: "Komandoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.494003",
    longitude: "73.424183",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "9313",
    name: "Komandoo",
    city: "Komandoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.494003",
    longitude: "73.424183",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "9314",
    name: "Meck Island Airstrip",
    city: "Meck Island",
    country: "Marshall Islands",
    iata: "",
    icao: "\\N",
    latitude: "9",
    longitude: "167.726944",
    altitude: "10",
    timezone: "12",
    dst: "Z",
    tz: "Pacific/Majuro",
  },
  {
    id: "9315",
    name: "Sormovo",
    city: "Nizhny Novgorod",
    country: "Russia",
    iata: "",
    icao: "XUDS",
    latitude: "56.1906",
    longitude: "43.4742",
    altitude: "210",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "9316",
    name: "Grand Canyon West Airport",
    city: "Peach Springs",
    country: "United States",
    iata: "1G4",
    icao: "\\N",
    latitude: "35.899904",
    longitude: "-113.815674",
    altitude: "4813",
    timezone: "-7",
    dst: "A",
    tz: "America/Phoenix",
  },
  {
    id: "9317",
    name: "Vangso",
    city: "Vangso",
    country: "Sweden",
    iata: "",
    icao: "ESSZ",
    latitude: "59.13333",
    longitude: "17.25",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "9318",
    name: "Yaroslavsky Station",
    city: "Moscow",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.776",
    longitude: "37.658",
    altitude: "400",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "9319",
    name: "Railway Station",
    city: "Perm",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "58.0203",
    longitude: "56.2525",
    altitude: "558",
    timezone: "6",
    dst: "N",
    tz: "Asia/Yekaterinburg",
  },
  {
    id: "9320",
    name: "Railway Station",
    city: "Novosibirsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.0188",
    longitude: "82.9339",
    altitude: "531",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "9321",
    name: "Railway Station",
    city: "Ulan Bator",
    country: "Mongolia",
    iata: "",
    icao: "\\N",
    latitude: "47.92",
    longitude: "106.92",
    altitude: "4300",
    timezone: "8",
    dst: "N",
    tz: "Asia/Ulaanbaatar",
  },
  {
    id: "9322",
    name: "Main Station",
    city: "Beijing",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "39.9",
    longitude: "116.421",
    altitude: "130",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9323",
    name: "Railway Station",
    city: "Irkutsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "52.3122",
    longitude: "104.2958",
    altitude: "1305",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9324",
    name: "Kuredu ",
    city: "Kuredu",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "5.3244",
    longitude: "73.3756",
    altitude: "10",
    timezone: "5",
    dst: "U",
    tz: "Indian/Maldives",
  },
  {
    id: "9325",
    name: "Heliport NUS",
    city: "Umea",
    country: "Sweden",
    iata: "",
    icao: "\\N",
    latitude: "63.817",
    longitude: "20.2981",
    altitude: "100",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "9326",
    name: "Heliport SU",
    city: "Sundsvall",
    country: "Sweden",
    iata: "",
    icao: "\\N",
    latitude: "62.4077",
    longitude: "17.3024",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Stockholm",
  },
  {
    id: "9327",
    name: "Comiso",
    city: "Comiso",
    country: "Italy",
    iata: "CIY",
    icao: "LICB",
    latitude: "37",
    longitude: "14.6144",
    altitude: "756",
    timezone: "1",
    dst: "E",
    tz: "Europe/Rome",
  },
  {
    id: "9328",
    name: "Leroo La Tau",
    city: "Leroo La Tau",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-20.422617",
    longitude: "24.517433",
    altitude: "1000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "9329",
    name: "Xaxanaka",
    city: "Xaxanaka",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.198083",
    longitude: "23.431383",
    altitude: "1000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "9330",
    name: "Xugana",
    city: "Xugana",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-19.068",
    longitude: "23.10015",
    altitude: "1000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "9331",
    name: "Nxamaseri",
    city: "Nxamaseri",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-18.597283",
    longitude: "21.999267",
    altitude: "1000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "9332",
    name: "Kwando",
    city: "Kwando",
    country: "Botswana",
    iata: "",
    icao: "\\N",
    latitude: "-18.208717",
    longitude: "23.396733",
    altitude: "1000",
    timezone: "2",
    dst: "U",
    tz: "Africa/Gaborone",
  },
  {
    id: "9333",
    name: "Boston North Station",
    city: "Boston",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.366235",
    longitude: "-71.061122",
    altitude: "141",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9334",
    name: "Rockport Station",
    city: "Rockport",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.6558328",
    longitude: "-70.6266667",
    altitude: "77",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9335",
    name: "Salem Station",
    city: "Salem",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.5249995",
    longitude: "-70.8958333",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9336",
    name: "Salem Ferry Dock",
    city: "Salem",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.522421",
    longitude: "-70.881607",
    altitude: "26",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9337",
    name: "Long Wharf",
    city: "Boston",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.36024",
    longitude: "-71.048105",
    altitude: "16",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9338",
    name: "Joliet Union Station",
    city: "Joliet",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.5244",
    longitude: "-88.0795",
    altitude: "532",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9339",
    name: "Laraway Road",
    city: "New Lenox",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.485",
    longitude: "-87.9596",
    altitude: "703",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9340",
    name: "Lasalle Station",
    city: "Chicago",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.875",
    longitude: "-87.632",
    altitude: "592",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9341",
    name: "Waterloo International",
    city: "London",
    country: "United Kingdom",
    iata: "",
    icao: "\\N",
    latitude: "51.5031",
    longitude: "-0.1147",
    altitude: "10",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9342",
    name: "Norfolk Station",
    city: "Norfolk",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "36.843233",
    longitude: "-76.275952",
    altitude: "16",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9343",
    name: "London Railway Station",
    city: "London",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "42.9819",
    longitude: "-81.2464",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9344",
    name: "Gloucester Station",
    city: "Gloucester",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.61666666666667",
    longitude: "-70.66833333333334",
    altitude: "50",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9345",
    name: "Kitchener Bus Terminal",
    city: "Kitchener",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "43.44968",
    longitude: "-80.49222",
    altitude: "1083",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9346",
    name: "Gare du Palais",
    city: "Quebec",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "46.8174",
    longitude: "-71.2139",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/Toronto",
  },
  {
    id: "9347",
    name: "Johnstown Amtrak",
    city: "Johnstown",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.3296",
    longitude: "-78.9219",
    altitude: "1168",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9348",
    name: "Enumclaw Airport",
    city: "Enumclaw",
    country: "United States",
    iata: "",
    icao: "WA77",
    latitude: "47.1956569",
    longitude: "-122.0220561",
    altitude: "738",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9349",
    name: "Rock Airport",
    city: "Tarentum",
    country: "United States",
    iata: "9G1",
    icao: "\\N",
    latitude: "40.6035463",
    longitude: "-79.8261189",
    altitude: "1063",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9350",
    name: "Grand Central Terminal",
    city: "New York",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.752726",
    longitude: "-73.977229",
    altitude: "70",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9351",
    name: "Tremont",
    city: "New York",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.847301",
    longitude: "-73.89955",
    altitude: "200",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9352",
    name: "Plum Island Airport",
    city: "Newburyport",
    country: "United States",
    iata: "2B2",
    icao: "\\N",
    latitude: "42.7953611",
    longitude: "-70.8394444",
    altitude: "11",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9353",
    name: "Brooks Camp",
    city: "Brooks Camp",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "58.556539",
    longitude: "-155.777311",
    altitude: "100",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9354",
    name: "Kulik Lake Airport",
    city: "Kulik Lake",
    country: "United States",
    iata: "LKK",
    icao: "\\N",
    latitude: "58.96591",
    longitude: "-155.108089",
    altitude: "1000",
    timezone: "-9",
    dst: "U",
    tz: "America/Anchorage",
  },
  {
    id: "9355",
    name: "Central Station",
    city: "Glasgow",
    country: "United Kingdom",
    iata: "ZGG",
    icao: "\\N",
    latitude: "55.858",
    longitude: "-4.258",
    altitude: "25",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9356",
    name: "Euston Station",
    city: "London",
    country: "United Kingdom",
    iata: "QQU",
    icao: "\\N",
    latitude: "51.5284",
    longitude: "-0.1331",
    altitude: "89",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9357",
    name: "Waterloo International",
    city: "London",
    country: "United Kingdom",
    iata: "QQW",
    icao: "\\N",
    latitude: "51.5031",
    longitude: "-0.1147",
    altitude: "10",
    timezone: "0",
    dst: "E",
    tz: "Europe/London",
  },
  {
    id: "9358",
    name: "Belorussky Station",
    city: "Moscow",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.7764",
    longitude: "37.5803",
    altitude: "400",
    timezone: "4",
    dst: "N",
    tz: "Europe/Moscow",
  },
  {
    id: "9359",
    name: "Railway Station",
    city: "Omsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "54.9833",
    longitude: "73.3667",
    altitude: "285",
    timezone: "7",
    dst: "N",
    tz: "Asia/Omsk",
  },
  {
    id: "9360",
    name: "Railway Station",
    city: "Krasnoyarsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "56.0167",
    longitude: "93.0667",
    altitude: "446",
    timezone: "8",
    dst: "N",
    tz: "Asia/Krasnoyarsk",
  },
  {
    id: "9361",
    name: "Railway Station",
    city: "Naushki",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "50.3827",
    longitude: "106.1056",
    altitude: "1975",
    timezone: "9",
    dst: "N",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9362",
    name: "Railway Station",
    city: "Erlian",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "43.65",
    longitude: "111.9833",
    altitude: "3159",
    timezone: "8",
    dst: "N",
    tz: "Asia/Chongqing",
  },
  {
    id: "9363",
    name: "Guangzhoudong Railway Station",
    city: "Guangzhou",
    country: "China",
    iata: "",
    icao: "\\N",
    latitude: "23.149554",
    longitude: "113.32479",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "9364",
    name: "Domodedovo",
    city: "Moscow",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.442",
    longitude: "37.763",
    altitude: "207",
    timezone: "4",
    dst: "U",
    tz: "Europe/Moscow",
  },
  {
    id: "9365",
    name: "Levashovo",
    city: "St. Petersburg",
    country: "Russia",
    iata: "",
    icao: "XLLV",
    latitude: "60.08738",
    longitude: "30.19152",
    altitude: "59",
    timezone: "4",
    dst: "E",
    tz: "Europe/Moscow",
  },
  {
    id: "9366",
    name: "Kettle Falls Lodge",
    city: "Minaki",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "50.349812",
    longitude: "-94.583456",
    altitude: "180",
    timezone: "-6",
    dst: "A",
    tz: "America/Winnipeg",
  },
  {
    id: "9367",
    name: "Severobajkalsk Port",
    city: "Severobajkalsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.4209",
    longitude: "109.3225",
    altitude: "500",
    timezone: "9",
    dst: "U",
    tz: "Asia/Irkutsk",
  },
  {
    id: "9368",
    name: "Vanino-Port",
    city: "Vanino",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "49.093",
    longitude: "140.285",
    altitude: "20",
    timezone: "11",
    dst: "U",
    tz: "Asia/Vladivostok",
  },
  {
    id: "9369",
    name: "Holmsk-Port",
    city: "Holmsk",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "47.040278",
    longitude: "142.043056",
    altitude: "29",
    timezone: "11",
    dst: "U",
    tz: "Asia/Vladivostok",
  },
  {
    id: "9370",
    name: "Nogliki",
    city: "Nogliki",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "51.816667",
    longitude: "143.116667",
    altitude: "10",
    timezone: "11",
    dst: "U",
    tz: "Asia/Vladivostok",
  },
  {
    id: "9371",
    name: "Markovo Airport",
    city: "Markovo",
    country: "Russia",
    iata: "KVM",
    icao: "UHMO",
    latitude: "64.665278",
    longitude: "170.414167",
    altitude: "89",
    timezone: "12",
    dst: "E",
    tz: "Asia/Magadan",
  },
  {
    id: "9372",
    name: "Seymchan Airport",
    city: "Seymchan",
    country: "Russia",
    iata: "",
    icao: "UHMS",
    latitude: "62.919167",
    longitude: "152.421667",
    altitude: "679",
    timezone: "12",
    dst: "E",
    tz: "Asia/Magadan",
  },
  {
    id: "9373",
    name: "Zyryanka West Airport",
    city: "Zyryanka",
    country: "Russia",
    iata: "ZKP",
    icao: "UESU",
    latitude: "65.736389",
    longitude: "150.700278",
    altitude: "118",
    timezone: "12",
    dst: "E",
    tz: "Asia/Magadan",
  },
  {
    id: "9374",
    name: "Susuman Airport",
    city: "Susuman",
    country: "Russia",
    iata: "",
    icao: "UHMH",
    latitude: "62.767222",
    longitude: "148.146111",
    altitude: "2129",
    timezone: "12",
    dst: "E",
    tz: "Asia/Magadan",
  },
  {
    id: "9375",
    name: "OYMYAKON",
    city: "OYMYAKON",
    country: "Russia",
    iata: "",
    icao: "UEMY",
    latitude: "63.45",
    longitude: "142.783333",
    altitude: "2431",
    timezone: "11",
    dst: "E",
    tz: "Asia/Vladivostok",
  },
  {
    id: "9376",
    name: "Ust-Maya Airport",
    city: "Ust-Maya",
    country: "Russia",
    iata: "UMS",
    icao: "UEMU",
    latitude: "60.358056",
    longitude: "134.437778",
    altitude: "561",
    timezone: "10",
    dst: "E",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9377",
    name: "Aldan Airport",
    city: "Aldan",
    country: "Russia",
    iata: "ADH",
    icao: "UEEA",
    latitude: "58.603056",
    longitude: "125.407222",
    altitude: "2241",
    timezone: "10",
    dst: "E",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9378",
    name: "Olekminsk Airport",
    city: "Olekminsk",
    country: "Russia",
    iata: "",
    icao: "UEMO",
    latitude: "60.399167",
    longitude: "120.464167",
    altitude: "426",
    timezone: "10",
    dst: "E",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9379",
    name: "Vitim Airport",
    city: "Vitim",
    country: "Russia",
    iata: "",
    icao: "UERT",
    latitude: "59.457778",
    longitude: "112.562778",
    altitude: "610",
    timezone: "10",
    dst: "E",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9380",
    name: "Pellworm",
    city: "Pellworm",
    country: "Germany",
    iata: "",
    icao: "EDHP",
    latitude: "54.536431",
    longitude: "8.67994",
    altitude: "10",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9381",
    name: "Tynda",
    city: "Tynda",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "55.1512",
    longitude: "124.716667",
    altitude: "350",
    timezone: "10",
    dst: "U",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9382",
    name: "Tommot",
    city: "Tommot",
    country: "Russia",
    iata: "",
    icao: "\\N",
    latitude: "58.966667",
    longitude: "126.266667",
    altitude: "280",
    timezone: "10",
    dst: "U",
    tz: "Asia/Yakutsk",
  },
  {
    id: "9383",
    name: "Etretat",
    city: "Etretat",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "49.701",
    longitude: "0.205",
    altitude: "102",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "9384",
    name: "Le Havre",
    city: "Le Havre",
    country: "France",
    iata: "",
    icao: "\\N",
    latitude: "49.4901",
    longitude: "0.1001",
    altitude: "13",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "9385",
    name: "Weimar",
    city: "Weimar",
    country: "Germany",
    iata: "",
    icao: "\\N",
    latitude: "50.983333",
    longitude: "11.316667",
    altitude: "208",
    timezone: "1",
    dst: "E",
    tz: "Europe/Berlin",
  },
  {
    id: "9386",
    name: "Nalati",
    city: "Xinyuan",
    country: "China",
    iata: "NLT",
    icao: "ZWNL",
    latitude: "43.433056",
    longitude: "83.380278",
    altitude: "0",
    timezone: "8",
    dst: "U",
    tz: "Asia/Chongqing",
  },
  {
    id: "9387",
    name: "Port Alsworth Airport",
    city: "Port alsworth",
    country: "United States",
    iata: "PTA",
    icao: "PALJ",
    latitude: "60.208281",
    longitude: "-154.306586",
    altitude: "253",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9388",
    name: "Fontaine Airport",
    city: "Belfort",
    country: "France",
    iata: "BOR",
    icao: "LFSQ",
    latitude: "47.6556015",
    longitude: "7.0108299",
    altitude: "3663",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "9389",
    name: "Pampulha",
    city: "Belo Horizonte",
    country: "Brazil",
    iata: "BHZ",
    icao: "\\N",
    latitude: "-19.8517",
    longitude: "-43.9508",
    altitude: "8708",
    timezone: "-3",
    dst: "S",
    tz: "America/Sao_Paulo",
  },
  {
    id: "9390",
    name: "Fairfield County Airport",
    city: "Winnsboro",
    country: "United States",
    iata: "FDW",
    icao: "KFDW",
    latitude: "34.315472",
    longitude: "-81.108806",
    altitude: "577",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9391",
    name: "Obock",
    city: "Obock",
    country: "Djibouti",
    iata: "OBC",
    icao: "HDOB",
    latitude: "11.968333",
    longitude: "43.278611",
    altitude: "69",
    timezone: "3",
    dst: "N",
    tz: "Africa/Djibouti",
  },
  {
    id: "9392",
    name: "Tadjoura",
    city: "Tadjoura",
    country: "Djibouti",
    iata: "TDJ",
    icao: "HDTJ",
    latitude: "11.783",
    longitude: "42.917",
    altitude: "246",
    timezone: "3",
    dst: "N",
    tz: "Africa/Djibouti",
  },
  {
    id: "9393",
    name: "Santa Cruz des Quiche Airport",
    city: "Santa Cruz des Quiche",
    country: "Guatemala",
    iata: "AQB",
    icao: "MGQC",
    latitude: "15.0122004",
    longitude: "-91.1505966",
    altitude: "6631",
    timezone: "-6",
    dst: "S",
    tz: "America/Guatemala",
  },
  {
    id: "9394",
    name: "Nordfjordur Airport",
    city: "Nordfjordur",
    country: "Iceland",
    iata: "NOR",
    icao: "BINF",
    latitude: "65.131897",
    longitude: "-13.7463999",
    altitude: "3648",
    timezone: "0",
    dst: "E",
    tz: "Atlantic/Reykjavik",
  },
  {
    id: "9395",
    name: "Bursa Airport",
    city: "Bursa",
    country: "Turkey",
    iata: "BTZ",
    icao: "LTBE",
    latitude: "40.2332993",
    longitude: "29.0091991",
    altitude: "772",
    timezone: "2",
    dst: "U",
    tz: "Europe/Istanbul",
  },
  {
    id: "9396",
    name: "Skyhaven Airport",
    city: "Rochester",
    country: "United States",
    iata: "DAW",
    icao: "KDAW",
    latitude: "43.2840556",
    longitude: "-70.9292778",
    altitude: "321",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9397",
    name: "Waris Airport",
    city: "Waris-Papua Island",
    country: "Indonesia",
    iata: "WAR",
    icao: "WAJR",
    latitude: "-3.22243",
    longitude: "140.9790039",
    altitude: "1224",
    timezone: "9",
    dst: "U",
    tz: "Asia/Jayapura",
  },
  {
    id: "9398",
    name: "Port Oceanic Airport",
    city: "Port Oceanic",
    country: "United States",
    iata: "PRL",
    icao: "\\N",
    latitude: "60.2083333",
    longitude: "-147.8194444",
    altitude: "142",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9399",
    name: "Newton City-County Airport",
    city: "Newton",
    country: "United States",
    iata: "EWK",
    icao: "KEWK",
    latitude: "38.0570785",
    longitude: "-97.2752278",
    altitude: "1533",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9400",
    name: "La Ferte Alais Airport",
    city: "La Ferte Alais",
    country: "France",
    iata: "",
    icao: "LFFQ",
    latitude: "48.497799",
    longitude: "2.34333",
    altitude: "453",
    timezone: "1",
    dst: "E",
    tz: "Europe/Paris",
  },
  {
    id: "9401",
    name: "Angguruk airstrip",
    city: "Angguruk",
    country: "Indonesia",
    iata: "",
    icao: "\\N",
    latitude: "-4.2001",
    longitude: "139.4329",
    altitude: "4200",
    timezone: "9",
    dst: "U",
    tz: "Asia/Jayapura",
  },
  {
    id: "9402",
    name: "Bairnsdale Airport",
    city: "Bairnsdale",
    country: "Australia",
    iata: "BSJ",
    icao: "YBNS",
    latitude: "-37.8875",
    longitude: "147.567778",
    altitude: "165",
    timezone: "10",
    dst: "O",
    tz: "Australia/Hobart",
  },
  {
    id: "9403",
    name: "Bolton Field",
    city: "Columbus",
    country: "United States",
    iata: "TZR",
    icao: "KTZR",
    latitude: "39.901111",
    longitude: "-83.136944",
    altitude: "905",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9404",
    name: "Ocean Shores Municipal",
    city: "Ocean Shores",
    country: "United States",
    iata: "W04",
    icao: "KW04",
    latitude: "46.5995",
    longitude: "-124.0854",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9405",
    name: "Packwood",
    city: "Packwood",
    country: "United States",
    iata: "55S",
    icao: "K55S",
    latitude: "46.3625",
    longitude: "-121.4067",
    altitude: "1057",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9406",
    name: "Fort Bridger",
    city: "Fort Bridger",
    country: "United States",
    iata: "FBR",
    icao: "KFBR",
    latitude: "41.236",
    longitude: "-110.2436",
    altitude: "7038",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9407",
    name: "Prosser",
    city: "Prosser",
    country: "United States",
    iata: "S40",
    icao: "KS40",
    latitude: "46.128",
    longitude: "-119.4773",
    altitude: "705",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9408",
    name: "Chehalis-Centralia",
    city: "Chehalis",
    country: "United States",
    iata: "CLS",
    icao: "KCLS",
    latitude: "46.4062",
    longitude: "-122.5897",
    altitude: "177",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9409",
    name: "Desert Aire",
    city: "Mattawa",
    country: "United States",
    iata: "M94",
    icao: "KM94",
    latitude: "46.4124",
    longitude: "-119.5518",
    altitude: "586",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9410",
    name: "Lebanon State",
    city: "Lebanon",
    country: "United States",
    iata: "S30",
    icao: "KS30",
    latitude: "44.3179",
    longitude: "-122.5577",
    altitude: "344",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9411",
    name: "Evanston-Uinta CO Burns Fld",
    city: "Evanston",
    country: "United States",
    iata: "EVW",
    icao: "KEVW",
    latitude: "41.1649",
    longitude: "-111.0208",
    altitude: "7143",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9412",
    name: "Sabetha Municipal",
    city: "Sabetha",
    country: "United States",
    iata: "K83",
    icao: "KK83",
    latitude: "39.5425",
    longitude: "-95.4677",
    altitude: "1330",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9413",
    name: "Mount Pleasant Regional-Faison Field",
    city: "Mount Pleasant",
    country: "United States",
    iata: "LRO",
    icao: "KLRO",
    latitude: "32.5387",
    longitude: "-79.4697",
    altitude: "12",
    timezone: "-5",
    dst: "A",
    tz: "\\N",
  },
  {
    id: "9414",
    name: "Jimmy Carter Regional",
    city: "Americus",
    country: "United States",
    iata: "ACJ",
    icao: "KACJ",
    latitude: "32.0665",
    longitude: "-84.1133",
    altitude: "468",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9415",
    name: "Weedon Field",
    city: "Eufala",
    country: "United States",
    iata: "EUF",
    icao: "KEUF",
    latitude: "31.5708",
    longitude: "-85.0774",
    altitude: "285",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9416",
    name: "Saluda County",
    city: "Saluda",
    country: "United States",
    iata: "6J4",
    icao: "K6J4",
    latitude: "33.5561",
    longitude: "-81.4768",
    altitude: "539",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9417",
    name: "Dare County Regional",
    city: "Manteo",
    country: "United States",
    iata: "MQI",
    icao: "KMQI",
    latitude: "35.5514",
    longitude: "-75.4173",
    altitude: "13",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9418",
    name: "Auburn University Regional",
    city: "Auburn",
    country: "United States",
    iata: "AUO",
    icao: "KAUO",
    latitude: "32.3691",
    longitude: "-85.2604",
    altitude: "777",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9419",
    name: "Tri-Cities",
    city: "Endicott",
    country: "United States",
    iata: "CZG",
    icao: "KCZG",
    latitude: "42.0471",
    longitude: "-76.0578",
    altitude: "833",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9420",
    name: "Isla Culebrita",
    city: "Culebrita",
    country: "Puerto Rico",
    iata: "",
    icao: "\\N",
    latitude: "18.31206",
    longitude: "-65.228405",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "9421",
    name: "Culebrita",
    city: "Isla Culebrita",
    country: "Puerto Rico",
    iata: "",
    icao: "\\N",
    latitude: "18.31206",
    longitude: "-65.228405",
    altitude: "10",
    timezone: "-4",
    dst: "U",
    tz: "America/Puerto_Rico",
  },
  {
    id: "9422",
    name: "Apollo Bay",
    city: "Apollo Bay",
    country: "Australia",
    iata: "",
    icao: "\\N",
    latitude: "-38.758827",
    longitude: "143.676624",
    altitude: "10",
    timezone: "10",
    dst: "U",
    tz: "Australia/Hobart",
  },
  {
    id: "9423",
    name: "Zabrat",
    city: "Baku",
    country: "Azerbaijan",
    iata: "",
    icao: "ZABR",
    latitude: "40.483",
    longitude: "49.967",
    altitude: "0",
    timezone: "4",
    dst: "U",
    tz: "Asia/Baku",
  },
  {
    id: "9424",
    name: "Chirag",
    city: "Caspian Sea",
    country: "Azerbaijan",
    iata: "",
    icao: "CHIR",
    latitude: "40.283",
    longitude: "51.283",
    altitude: "0",
    timezone: "4",
    dst: "U",
    tz: "\\N",
  },
  {
    id: "9425",
    name: "Kendal Glider Port",
    city: "Kendall",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "25.603889",
    longitude: "-80.585556",
    altitude: "10",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "9426",
    name: "Lipa Noi Pier",
    city: "Lipa Noi",
    country: "Thailand",
    iata: "",
    icao: "\\N",
    latitude: "9.481772",
    longitude: "99.926558",
    altitude: "10",
    timezone: "7",
    dst: "N",
    tz: "Asia/Bangkok",
  },
  {
    id: "9427",
    name: "Don Sak Pier",
    city: "Don Sak",
    country: "Thailand",
    iata: "",
    icao: "\\N",
    latitude: "9.321146",
    longitude: "99.735693",
    altitude: "10",
    timezone: "7",
    dst: "N",
    tz: "Asia/Bangkok",
  },
  {
    id: "9428",
    name: "Bessemer",
    city: "Bessemer",
    country: "United States",
    iata: "EKY",
    icao: "KEKY",
    latitude: "33.1876",
    longitude: "-86.5558",
    altitude: "700",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9429",
    name: "Colorado Springs East",
    city: "Ellicott",
    country: "United States",
    iata: "A50",
    icao: "KA50",
    latitude: "38.87",
    longitude: "-104.41",
    altitude: "6145",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9430",
    name: "Olds Didsbury Airport",
    city: "Didsbury",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "51.710833",
    longitude: "-114.106111",
    altitude: "3360",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "9431",
    name: "Sundre Airport",
    city: "Sundre",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "51.774722",
    longitude: "-114.680833",
    altitude: "3663",
    timezone: "-7",
    dst: "A",
    tz: "America/Edmonton",
  },
  {
    id: "9432",
    name: "Buffalo-Depew Station",
    city: "Depew",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "42.9074",
    longitude: "-78.7266",
    altitude: "676",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9433",
    name: "South Bend Station",
    city: "South Bend",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.678",
    longitude: "-86.2876",
    altitude: "722",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9434",
    name: "Carroll Avenue NICTD Station",
    city: "Michigan City",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.7133",
    longitude: "-86.8677",
    altitude: "630",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9435",
    name: "Chicago Millennium Station",
    city: "Chicago",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.8837",
    longitude: "-87.623",
    altitude: "620",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9436",
    name: "St. Louis Gateway Transportation Center",
    city: "St. Louis",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "38.6239",
    longitude: "-90.2039",
    altitude: "476",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9437",
    name: "Kansas City Union Station",
    city: "Kansas City",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "39.0865",
    longitude: "-94.586",
    altitude: "791",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9438",
    name: "Alvarado Transportation Center",
    city: "Albuquerque",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "35.0826",
    longitude: "-106.6474",
    altitude: "4970",
    timezone: "-7",
    dst: "A",
    tz: "America/Denver",
  },
  {
    id: "9439",
    name: "San Francisco 4th and King St. Station",
    city: "San Francisco",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.7763884",
    longitude: "-122.3944444",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9440",
    name: "Oakland Jack London Square Station",
    city: "Oakland",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.7935",
    longitude: "-122.2719",
    altitude: "13",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9441",
    name: "Downtown Mountain View Station",
    city: "Mountain View",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.3943934",
    longitude: "-122.075872",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9442",
    name: "San Mateo Station",
    city: "San Mateo",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.5683328",
    longitude: "-122.3241667",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9443",
    name: "Sunnyvale Station",
    city: "Sunnyvale",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.3786106",
    longitude: "-122.0308333",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9444",
    name: "Millbrae Intermodal Terminal",
    city: "San Mateo",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "37.6002772",
    longitude: "-122.3866667",
    altitude: "15",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9445",
    name: "Cleveland Greyhound Station",
    city: "Cleveland",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "41.5034",
    longitude: "-81.6822",
    altitude: "679",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9446",
    name: "Issyk-Kul International Airport",
    city: "Tamchy",
    country: "Kyrgyzstan",
    iata: "ИКУ",
    icao: "UCFL",
    latitude: "42.3527",
    longitude: "76.4278",
    altitude: "5426",
    timezone: "6",
    dst: "N",
    tz: "Asia/Bishkek",
  },
  {
    id: "9447",
    name: "Crystal Airport",
    city: "Crystal",
    country: "United States",
    iata: "MIC",
    icao: "KMIC",
    latitude: "45.0343",
    longitude: "-93.2114",
    altitude: "869",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9448",
    name: "Clarke CO",
    city: "Quitman",
    country: "United States",
    iata: "23M",
    icao: "K23M",
    latitude: "32.0517",
    longitude: "-88.4434",
    altitude: "320",
    timezone: "-6",
    dst: "A",
    tz: "America/Chicago",
  },
  {
    id: "9449",
    name: "Ellaidhoo",
    city: "Ellaidhoo",
    country: "Maldives",
    iata: "",
    icao: "\\N",
    latitude: "4.005694444444444",
    longitude: "72.9486111111111",
    altitude: "0",
    timezone: "5",
    dst: "N",
    tz: "Indian/Maldives",
  },
  {
    id: "9450",
    name: "W H Barron Field",
    city: "Dublin",
    country: "United States",
    iata: "DBN",
    icao: "KDBN",
    latitude: "32.3388",
    longitude: "-82.591",
    altitude: "311",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9451",
    name: "Port Authority",
    city: "New York",
    country: "United States",
    iata: "",
    icao: "\\N",
    latitude: "40.756667",
    longitude: "-73.991111",
    altitude: "33",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9452",
    name: "Bus Terminal",
    city: "Allentown",
    country: "United States",
    iata: "",
    icao: "ATWN",
    latitude: "40.605604",
    longitude: "-75.462384",
    altitude: "338",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9453",
    name: "Binghamton Bus Terminal",
    city: "Binghamton",
    country: "United States",
    iata: "",
    icao: "BING",
    latitude: "42.101438",
    longitude: "-75.910431",
    altitude: "850",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9454",
    name: "William F. Walsh Regional Transportation Center",
    city: "Syracuse",
    country: "United States",
    iata: "",
    icao: "SYTC",
    latitude: "43.0767",
    longitude: "-76.1691",
    altitude: "380",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9455",
    name: "Union Station",
    city: "Utica",
    country: "United States",
    iata: "UCA",
    icao: "\\N",
    latitude: "43.104167",
    longitude: "-75.223333",
    altitude: "456",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9456",
    name: "Clinton Bus Stop",
    city: "Clinton",
    country: "United States",
    iata: "",
    icao: "CLTN",
    latitude: "43.048889",
    longitude: "-75.380278",
    altitude: "604",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9457",
    name: "Heuston Station",
    city: "Dublin",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "53.3463",
    longitude: "-6.2927",
    altitude: "19",
    timezone: "0",
    dst: "E",
    tz: "Europe/Dublin",
  },
  {
    id: "9458",
    name: "Killarney Station",
    city: "Killarney",
    country: "Ireland",
    iata: "",
    icao: "\\N",
    latitude: "52.5089",
    longitude: "-9.5015",
    altitude: "144",
    timezone: "0",
    dst: "U",
    tz: "Europe/Dublin",
  },
  {
    id: "9459",
    name: "Susquehanna Trailways Terminal",
    city: "Williamsport",
    country: "United States",
    iata: "",
    icao: "WSPT",
    latitude: "41.239395",
    longitude: "-77.000245",
    altitude: "518",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9460",
    name: "Martz Trailways Bus Terminal",
    city: "Wilkes-Barre",
    country: "United States",
    iata: "",
    icao: "WKBR",
    latitude: "41.243958",
    longitude: "-75.882365",
    altitude: "525",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9461",
    name: "Hazelton Bus Station",
    city: "Hazelton",
    country: "United States",
    iata: "",
    icao: "HZLT",
    latitude: "40.954055",
    longitude: "-75.976102",
    altitude: "1689",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9462",
    name: "Lewisburg Bus Stop",
    city: "Lewisburg",
    country: "United States",
    iata: "",
    icao: "LWSB",
    latitude: "40.963889",
    longitude: "-76.888056",
    altitude: "456",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9463",
    name: "Madison NJT Station",
    city: "Madison",
    country: "United States",
    iata: "",
    icao: "MDSN",
    latitude: "40.757028",
    longitude: "-74.415194",
    altitude: "266",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9464",
    name: "Maplewood NJT Station",
    city: "Maplewood",
    country: "United States",
    iata: "",
    icao: "MPLD",
    latitude: "40.731111",
    longitude: "-74.275556",
    altitude: "115",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9465",
    name: "Harrisburg Transportation Center",
    city: "Harrisburg",
    country: "United States",
    iata: "",
    icao: "HBRG",
    latitude: "40.26223",
    longitude: "-76.878709",
    altitude: "320",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9466",
    name: "Metro-North Station",
    city: "Poughkeepsie",
    country: "United States",
    iata: "",
    icao: "PKPS",
    latitude: "41.706516",
    longitude: "-73.937774",
    altitude: "180",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9467",
    name: "Port Everglades",
    city: "Fort Lauderdale",
    country: "United States",
    iata: "",
    icao: "FTLD",
    latitude: "26.087679",
    longitude: "-80.115942",
    altitude: "0",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9468",
    name: "Crown Bay",
    city: "Charlotte Amalie",
    country: "Virgin Islands",
    iata: "",
    icao: "STCB",
    latitude: "18.33482",
    longitude: "-64.952187",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/St_Thomas",
  },
  {
    id: "9469",
    name: "Cruise Ship Dock",
    city: "Roseau",
    country: "Dominica",
    iata: "",
    icao: "RSAU",
    latitude: "15.296416",
    longitude: "-61.38781",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Dominica",
  },
  {
    id: "9470",
    name: "Grenada Port Authority Cruise Ship Terminal",
    city: "St. George's",
    country: "Grenada",
    iata: "",
    icao: "GREN",
    latitude: "12.050773",
    longitude: "-61.754982",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Grenada",
  },
  {
    id: "9471",
    name: "Martinique Cruise Terminal",
    city: "Fort de France",
    country: "Martinique",
    iata: "",
    icao: "MTQE",
    latitude: "14.601432",
    longitude: "-61.073111",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Martinique",
  },
  {
    id: "9472",
    name: "Dr AC Wathey Cruise Pier",
    city: "Philipsburg",
    country: "Netherlands Antilles",
    iata: "",
    icao: "PHBG",
    latitude: "18.011475",
    longitude: "-63.046401",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Curacao",
  },
  {
    id: "9473",
    name: "Half Moon Cay",
    city: "Little San Salvador Island",
    country: "Bahamas",
    iata: "",
    icao: "HMCY",
    latitude: "24.574135",
    longitude: "-75.955868",
    altitude: "0",
    timezone: "-5",
    dst: "U",
    tz: "America/Nassau",
  },
  {
    id: "9474",
    name: "Pukarua Airport",
    city: "Pukarua",
    country: "French Polynesia",
    iata: "PUK",
    icao: "NTGQ",
    latitude: "-18.3166666",
    longitude: "-137.016666",
    altitude: "6",
    timezone: "-10",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "9475",
    name: "Kabale",
    city: "Kabale",
    country: "Uganda",
    iata: "",
    icao: "HUKB",
    latitude: "-1.223333",
    longitude: "29.96",
    altitude: "5850",
    timezone: "3",
    dst: "N",
    tz: "Africa/Kampala",
  },
  {
    id: "9476",
    name: "Cruz Bay Ferry Dock",
    city: "Cruz Bay",
    country: "Virgin Islands",
    iata: "",
    icao: "CBFD",
    latitude: "18.331263",
    longitude: "-64.795408",
    altitude: "0",
    timezone: "-4",
    dst: "A",
    tz: "America/St_Thomas",
  },
  {
    id: "9477",
    name: "Red Hook Bay Ferry Dock",
    city: "Red Hook",
    country: "Virgin Islands",
    iata: "",
    icao: "RHVI",
    latitude: "18.326479",
    longitude: "-64.849361",
    altitude: "0",
    timezone: "-4",
    dst: "A",
    tz: "America/St_Thomas",
  },
  {
    id: "9478",
    name: "Gare Routiere de Fort-de-France",
    city: "Fort-de-France",
    country: "Martinique",
    iata: "",
    icao: "FDFM",
    latitude: "14.602932",
    longitude: "-61.070873",
    altitude: "0",
    timezone: "-4",
    dst: "U",
    tz: "America/Martinique",
  },
  {
    id: "9479",
    name: "Saint Pierre",
    city: "Saint Pierre",
    country: "Martinique",
    iata: "",
    icao: "SPMQ",
    latitude: "14.746061",
    longitude: "-61.176809",
    altitude: "0",
    timezone: "-4",
    dst: "U",
    tz: "America/Martinique",
  },
  {
    id: "9480",
    name: "Philipsburg Bus Stop",
    city: "Philipsburg",
    country: "Netherlands Antilles",
    iata: "",
    icao: "PHSM",
    latitude: "18.0263",
    longitude: "-63.049759",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "America/Curacao",
  },
  {
    id: "9481",
    name: "Marigot Bus Stop",
    city: "Marigot",
    country: "France",
    iata: "",
    icao: "MRGT",
    latitude: "18.066039",
    longitude: "-63.084385",
    altitude: "0",
    timezone: "-4",
    dst: "N",
    tz: "\\N",
  },
  {
    id: "9482",
    name: "Summit NJT Station",
    city: "Summit",
    country: "United States",
    iata: "",
    icao: "SMMT",
    latitude: "40.716556",
    longitude: "-74.35775",
    altitude: "374",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9483",
    name: "Batoka Airfield",
    city: "Dambwa - Livingstone",
    country: "Zambia",
    iata: "",
    icao: "\\N",
    latitude: "-17.88464",
    longitude: "25.84697",
    altitude: "2695",
    timezone: "2",
    dst: "N",
    tz: "Africa/Lusaka",
  },
  {
    id: "9484",
    name: "Santa Justa",
    city: "Sevilla",
    country: "Spain",
    iata: "",
    icao: "SVSJ",
    latitude: "37.392051",
    longitude: "-5.975135",
    altitude: "23",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9485",
    name: "Cordoba Station",
    city: "Cordoba",
    country: "Spain",
    iata: "",
    icao: "CRDB",
    latitude: "37.888573",
    longitude: "-4.789177",
    altitude: "390",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9486",
    name: "Granada Station",
    city: "Granada",
    country: "Spain",
    iata: "",
    icao: "GRND",
    latitude: "37.184055",
    longitude: "-3.60916",
    altitude: "2421",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9487",
    name: "Atocha",
    city: "Madrid",
    country: "Spain",
    iata: "",
    icao: "MDAT",
    latitude: "40.4075",
    longitude: "-3.691667",
    altitude: "2188",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9488",
    name: "Corvallis Muni",
    city: "Corvallis",
    country: "United States",
    iata: "CVO",
    icao: "KCVO",
    latitude: "44.5067",
    longitude: "-123.2915",
    altitude: "250",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9489",
    name: "Helipad of Viraj Group",
    city: "Boisar",
    country: "India",
    iata: "",
    icao: "\\N",
    latitude: "19.779",
    longitude: "72.805",
    altitude: "50",
    timezone: "5.5",
    dst: "U",
    tz: "Asia/Calcutta",
  },
  {
    id: "9490",
    name: "Heydar Aliyev",
    city: "Caspian Sea",
    country: "Azerbaijan",
    iata: "",
    icao: "HEYD",
    latitude: "39.86218",
    longitude: "50.3959",
    altitude: "0",
    timezone: "4",
    dst: "E",
    tz: "\\N",
  },
  {
    id: "9491",
    name: "Phantom Lake",
    city: "Phantom Lake",
    country: "Canada",
    iata: "",
    icao: "\\N",
    latitude: "49.859473",
    longitude: "-123.494509",
    altitude: "3386",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9492",
    name: "Tuzla",
    city: "Tuzla",
    country: "Romania",
    iata: "",
    icao: "LRTZ",
    latitude: "43.9841995",
    longitude: "28.6096992",
    altitude: "78",
    timezone: "2",
    dst: "U",
    tz: "Europe/Bucharest",
  },
  {
    id: "9493",
    name: "Toledo Railway Station",
    city: "Toledo",
    country: "Spain",
    iata: "",
    icao: "TLDO",
    latitude: "39.862363",
    longitude: "-4.011083",
    altitude: "1736",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9494",
    name: "Chamartin Station",
    city: "Madrid",
    country: "Spain",
    iata: "",
    icao: "MADC",
    latitude: "40.472272",
    longitude: "-3.68215",
    altitude: "2188",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9495",
    name: "Abando",
    city: "Bilbao",
    country: "Spain",
    iata: "",
    icao: "BLBO",
    latitude: "43.25947",
    longitude: "-2.929017",
    altitude: "62",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9496",
    name: "Aeroport",
    city: "Barcelona",
    country: "Spain",
    iata: "",
    icao: "ARPT",
    latitude: "41.288436",
    longitude: "2.072409",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9497",
    name: "Passeig de Gracia",
    city: "Barcelona",
    country: "Spain",
    iata: "",
    icao: "PGRC",
    latitude: "41.392186",
    longitude: "2.16482",
    altitude: "39",
    timezone: "1",
    dst: "U",
    tz: "Europe/Madrid",
  },
  {
    id: "9498",
    name: "Sants",
    city: "Barcelona",
    country: "Spain",
    iata: "",
    icao: "BSNT",
    latitude: "41.379359",
    longitude: "2.140474",
    altitude: "39",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9499",
    name: "Railway Station",
    city: "Figueres",
    country: "Spain",
    iata: "",
    icao: "FGRS",
    latitude: "42.265065",
    longitude: "2.968822",
    altitude: "128",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9500",
    name: "Martz Trailways",
    city: "Scranton",
    country: "United States",
    iata: "",
    icao: "SCRT",
    latitude: "41.410253",
    longitude: "-75.670297",
    altitude: "745",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9501",
    name: "New Brunswick Station",
    city: "New Brunswick",
    country: "United States",
    iata: "",
    icao: "NBWK",
    latitude: "40.496432",
    longitude: "-74.446447",
    altitude: "62",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9502",
    name: "Trenton Transit Center",
    city: "Trenton",
    country: "United States",
    iata: "",
    icao: "TRTC",
    latitude: "40.218839",
    longitude: "-74.754279",
    altitude: "49",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9503",
    name: "Holmesburg Jct Station",
    city: "Philadelphia",
    country: "United States",
    iata: "",
    icao: "HOLM",
    latitude: "40.032679",
    longitude: "-75.023718",
    altitude: "39",
    timezone: "-5",
    dst: "U",
    tz: "America/New_York",
  },
  {
    id: "9504",
    name: "White Plains",
    city: "White Plains",
    country: "United States",
    iata: "",
    icao: "WPLN",
    latitude: "41.032549",
    longitude: "-73.775069",
    altitude: "213",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9505",
    name: "Southeast",
    city: "Southeast",
    country: "United States",
    iata: "",
    icao: "STHT",
    latitude: "41.413179",
    longitude: "-73.623551",
    altitude: "338",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9506",
    name: "B Street Cruise Terminal",
    city: "San Diego",
    country: "United States",
    iata: "",
    icao: "SANB",
    latitude: "32.716861",
    longitude: "-117.174296",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9507",
    name: "Terminal Maritima",
    city: "Puerto Vallarta",
    country: "Mexico",
    iata: "",
    icao: "PRTV",
    latitude: "20.657616",
    longitude: "-105.241082",
    altitude: "0",
    timezone: "-6",
    dst: "A",
    tz: "America/Mexico_City",
  },
  {
    id: "9508",
    name: "Bahia San Lucas",
    city: "Cabo San Lucas",
    country: "Mexico",
    iata: "",
    icao: "CABO",
    latitude: "22.880854",
    longitude: "-109.902117",
    altitude: "0",
    timezone: "-7",
    dst: "A",
    tz: "America/Mazatlan",
  },
  {
    id: "9509",
    name: "Ferry Terminal",
    city: "Anacortes",
    country: "United States",
    iata: "",
    icao: "ACRT",
    latitude: "48.50728",
    longitude: "-122.677596",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9510",
    name: "Ferry Dock",
    city: "Friday Harbor",
    country: "United States",
    iata: "",
    icao: "FRID",
    latitude: "48.535673",
    longitude: "-123.014044",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9511",
    name: "Morristown Station",
    city: "Morristown",
    country: "United States",
    iata: "",
    icao: "MRST",
    latitude: "40.796957",
    longitude: "-74.473834",
    altitude: "315",
    timezone: "-5",
    dst: "A",
    tz: "America/New_York",
  },
  {
    id: "9512",
    name: "Port of Seattle",
    city: "Seattle",
    country: "United States",
    iata: "",
    icao: "PSEA",
    latitude: "47.609178",
    longitude: "-122.350605",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9513",
    name: "Ferry Terminal",
    city: "Whittier",
    country: "United States",
    iata: "",
    icao: "WHIT",
    latitude: "60.776566",
    longitude: "-148.683367",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9514",
    name: "Ferry Terminal",
    city: "Valdez",
    country: "United States",
    iata: "",
    icao: "VLDZ",
    latitude: "61.123976",
    longitude: "-146.365309",
    altitude: "0",
    timezone: "-9",
    dst: "A",
    tz: "America/Anchorage",
  },
  {
    id: "9515",
    name: "Gare Routiere",
    city: "Saint-Louis",
    country: "Reunion",
    iata: "",
    icao: "STLS",
    latitude: "-21.289604",
    longitude: "55.407269",
    altitude: "103",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9516",
    name: "Bus Stop",
    city: "La Riviere",
    country: "Reunion",
    iata: "",
    icao: "LRIV",
    latitude: "-21.272574",
    longitude: "55.437706",
    altitude: "190",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9517",
    name: "Bus Stop",
    city: "Cilaos",
    country: "Reunion",
    iata: "",
    icao: "CILS",
    latitude: "-21.135518",
    longitude: "55.472087",
    altitude: "4000",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9518",
    name: "Bus Stop",
    city: "Hell-Bourg",
    country: "Reunion",
    iata: "",
    icao: "HLBG",
    latitude: "-21.06402",
    longitude: "55.518453",
    altitude: "3000",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9519",
    name: "Bus Stop",
    city: "Salazie",
    country: "Reunion",
    iata: "",
    icao: "SLZI",
    latitude: "-21.027485",
    longitude: "55.538955",
    altitude: "3000",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9520",
    name: "Gare",
    city: "St Andre",
    country: "Reunion",
    iata: "",
    icao: "ANDR",
    latitude: "-20.963272",
    longitude: "55.652508",
    altitude: "100",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9521",
    name: "L'Ocean Bus Terminal",
    city: "Saint Denis",
    country: "Reunion",
    iata: "",
    icao: "SDNS",
    latitude: "-20.877683",
    longitude: "55.457393",
    altitude: "0",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9522",
    name: "Gare Routiere",
    city: "Saint Pierre",
    country: "Reunion",
    iata: "",
    icao: "STPR",
    latitude: "-21.33424",
    longitude: "55.471331",
    altitude: "0",
    timezone: "4",
    dst: "E",
    tz: "Indian/Reunion",
  },
  {
    id: "9523",
    name: "Baie Ste Anne",
    city: "Praslin",
    country: "Seychelles",
    iata: "",
    icao: "PLIN",
    latitude: "-4.347119",
    longitude: "55.765688",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Indian/Mahe",
  },
  {
    id: "9524",
    name: "La Passe",
    city: "La Digue",
    country: "Seychelles",
    iata: "",
    icao: "LADG",
    latitude: "-4.347969",
    longitude: "55.829069",
    altitude: "0",
    timezone: "4",
    dst: "N",
    tz: "Indian/Mahe",
  },
  {
    id: "9525",
    name: "Ferry Dock",
    city: "Bainbridge Island",
    country: "United States",
    iata: "",
    icao: "BAIN",
    latitude: "47.622237",
    longitude: "-122.509362",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9526",
    name: "Bus",
    city: "Phnom Penh",
    country: "Cambodia",
    iata: "",
    icao: "PNMP",
    latitude: "11.561716",
    longitude: "104.914276",
    altitude: "0",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "9527",
    name: "Bus",
    city: "Siem Reap",
    country: "Cambodia",
    iata: "",
    icao: "SMRP",
    latitude: "13.361002",
    longitude: "103.859543",
    altitude: "0",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "9528",
    name: "Bus",
    city: "Sihanoukville",
    country: "Cambodia",
    iata: "",
    icao: "SNKV",
    latitude: "10.60722",
    longitude: "103.524886",
    altitude: "0",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "9529",
    name: "Bus",
    city: "Kampot",
    country: "Cambodia",
    iata: "",
    icao: "KMPT",
    latitude: "10.614922",
    longitude: "104.177724",
    altitude: "0",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "9530",
    name: "Bus",
    city: "Kep",
    country: "Cambodia",
    iata: "",
    icao: "KEPC",
    latitude: "10.480174",
    longitude: "104.294228",
    altitude: "0",
    timezone: "7",
    dst: "N",
    tz: "Asia/Phnom_Penh",
  },
  {
    id: "9531",
    name: "Main Station",
    city: "Taipei",
    country: "Taiwan",
    iata: "",
    icao: "TPEI",
    latitude: "25.046176",
    longitude: "121.517532",
    altitude: "0",
    timezone: "8",
    dst: "N",
    tz: "Asia/Taipei",
  },
  {
    id: "9532",
    name: "Prominent Hill",
    city: "Prominent Hill",
    country: "Australia",
    iata: "PXH",
    icao: "YPMH",
    latitude: "-29.716667",
    longitude: "135.521667",
    altitude: "734",
    timezone: "9.5",
    dst: "O",
    tz: "Australia/Adelaide",
  },
  {
    id: "9533",
    name: "Chatsworth Station",
    city: "Chatsworth",
    country: "United States",
    iata: "CWT",
    icao: "\\N",
    latitude: "34.256944",
    longitude: "-118.598889",
    altitude: "978",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9534",
    name: "Algerciras Port",
    city: "Algerciras",
    country: "Spain",
    iata: "",
    icao: "\\N",
    latitude: "36.136",
    longitude: "-5.435",
    altitude: "0",
    timezone: "1",
    dst: "E",
    tz: "Europe/Madrid",
  },
  {
    id: "9535",
    name: "Ganges Water Aerodrome",
    city: "Ganges",
    country: "Canada",
    iata: "YGG",
    icao: "\\N",
    latitude: "48.85",
    longitude: "-123.5",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9536",
    name: "Pender Harbour Water Aerodrome",
    city: "Pender Harbour",
    country: "Canada",
    iata: "YPT",
    icao: "\\N",
    latitude: "49.616667",
    longitude: "-124.016667",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9537",
    name: "Mansons Landing Water Aerodrome",
    city: "Mansons Landing",
    country: "Canada",
    iata: "YMU",
    icao: "\\N",
    latitude: "50.066667",
    longitude: "-124.983333",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9538",
    name: "Port McNeill Airport",
    city: "Port McNeill",
    country: "Canada",
    iata: "YMP",
    icao: "\\N",
    latitude: "50.575556",
    longitude: "-127.028611",
    altitude: "225",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9539",
    name: "Sullivan Bay Water Aerodrome",
    city: "Sullivan Bay",
    country: "Canada",
    iata: "YTG",
    icao: "\\N",
    latitude: "50.883333",
    longitude: "-126.833333",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Vancouver",
  },
  {
    id: "9540",
    name: "Deer Harbor Seaplane",
    city: "Deer Harbor",
    country: "United States",
    iata: "DHB",
    icao: "\\N",
    latitude: "48.618397",
    longitude: "-123.00596",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
  {
    id: "9541",
    name: "San Diego Old Town Transit Center",
    city: "San Diego",
    country: "United States",
    iata: "OLT",
    icao: "\\N",
    latitude: "32.7552",
    longitude: "-117.1995",
    altitude: "0",
    timezone: "-8",
    dst: "A",
    tz: "America/Los_Angeles",
  },
];
